function qm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e
}
var UM = { exports: {} },
  p0 = {},
  NM = { exports: {} },
  be = {}
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dq
function I1() {
  if (Dq) return be
  Dq = 1
  var e = Symbol.for("react.element"),
    A = Symbol.for("react.portal"),
    I = Symbol.for("react.fragment"),
    g = Symbol.for("react.strict_mode"),
    C = Symbol.for("react.profiler"),
    i = Symbol.for("react.provider"),
    B = Symbol.for("react.context"),
    o = Symbol.for("react.forward_ref"),
    r = Symbol.for("react.suspense"),
    s = Symbol.for("react.memo"),
    h = Symbol.for("react.lazy"),
    S = Symbol.iterator
  function d($) {
    return $ === null || typeof $ != "object"
      ? null
      : (($ = (S && $[S]) || $["@@iterator"]), typeof $ == "function" ? $ : null)
  }
  var w = {
      isMounted: function () {
        return !1
      },
      enqueueForceUpdate: function () {},
      enqueueReplaceState: function () {},
      enqueueSetState: function () {},
    },
    M = Object.assign,
    K = {}
  function R($, EA, GA) {
    ;((this.props = $), (this.context = EA), (this.refs = K), (this.updater = GA || w))
  }
  ;((R.prototype.isReactComponent = {}),
    (R.prototype.setState = function ($, EA) {
      if (typeof $ != "object" && typeof $ != "function" && $ != null)
        throw Error(
          "setState(...): takes an object of state variables to update or a function which returns an object of state variables.",
        )
      this.updater.enqueueSetState(this, $, EA, "setState")
    }),
    (R.prototype.forceUpdate = function ($) {
      this.updater.enqueueForceUpdate(this, $, "forceUpdate")
    }))
  function F() {}
  F.prototype = R.prototype
  function L($, EA, GA) {
    ;((this.props = $), (this.context = EA), (this.refs = K), (this.updater = GA || w))
  }
  var Y = (L.prototype = new F())
  ;((Y.constructor = L), M(Y, R.prototype), (Y.isPureReactComponent = !0))
  var H = Array.isArray,
    V = Object.prototype.hasOwnProperty,
    j = { current: null },
    P = { key: !0, ref: !0, __self: !0, __source: !0 }
  function AA($, EA, GA) {
    var DA,
      dA = {},
      kA = null,
      NA = null
    if (EA != null)
      for (DA in (EA.ref !== void 0 && (NA = EA.ref), EA.key !== void 0 && (kA = "" + EA.key), EA))
        V.call(EA, DA) && !P.hasOwnProperty(DA) && (dA[DA] = EA[DA])
    var qA = arguments.length - 2
    if (qA === 1) dA.children = GA
    else if (1 < qA) {
      for (var ZA = Array(qA), sI = 0; sI < qA; sI++) ZA[sI] = arguments[sI + 2]
      dA.children = ZA
    }
    if ($ && $.defaultProps)
      for (DA in ((qA = $.defaultProps), qA)) dA[DA] === void 0 && (dA[DA] = qA[DA])
    return { $$typeof: e, type: $, key: kA, ref: NA, props: dA, _owner: j.current }
  }
  function X($, EA) {
    return { $$typeof: e, type: $.type, key: EA, ref: $.ref, props: $.props, _owner: $._owner }
  }
  function _($) {
    return typeof $ == "object" && $ !== null && $.$$typeof === e
  }
  function eA($) {
    var EA = { "=": "=0", ":": "=2" }
    return (
      "$" +
      $.replace(/[=:]/g, function (GA) {
        return EA[GA]
      })
    )
  }
  var CA = /\/+/g
  function aA($, EA) {
    return typeof $ == "object" && $ !== null && $.key != null ? eA("" + $.key) : EA.toString(36)
  }
  function lA($, EA, GA, DA, dA) {
    var kA = typeof $
    ;(kA === "undefined" || kA === "boolean") && ($ = null)
    var NA = !1
    if ($ === null) NA = !0
    else
      switch (kA) {
        case "string":
        case "number":
          NA = !0
          break
        case "object":
          switch ($.$$typeof) {
            case e:
            case A:
              NA = !0
          }
      }
    if (NA)
      return (
        (NA = $),
        (dA = dA(NA)),
        ($ = DA === "" ? "." + aA(NA, 0) : DA),
        H(dA)
          ? ((GA = ""),
            $ != null && (GA = $.replace(CA, "$&/") + "/"),
            lA(dA, EA, GA, "", function (sI) {
              return sI
            }))
          : dA != null &&
            (_(dA) &&
              (dA = X(
                dA,
                GA +
                  (!dA.key || (NA && NA.key === dA.key)
                    ? ""
                    : ("" + dA.key).replace(CA, "$&/") + "/") +
                  $,
              )),
            EA.push(dA)),
        1
      )
    if (((NA = 0), (DA = DA === "" ? "." : DA + ":"), H($)))
      for (var qA = 0; qA < $.length; qA++) {
        kA = $[qA]
        var ZA = DA + aA(kA, qA)
        NA += lA(kA, EA, GA, ZA, dA)
      }
    else if (((ZA = d($)), typeof ZA == "function"))
      for ($ = ZA.call($), qA = 0; !(kA = $.next()).done; )
        ((kA = kA.value), (ZA = DA + aA(kA, qA++)), (NA += lA(kA, EA, GA, ZA, dA)))
    else if (kA === "object")
      throw (
        (EA = String($)),
        Error(
          "Objects are not valid as a React child (found: " +
            (EA === "[object Object]"
              ? "object with keys {" + Object.keys($).join(", ") + "}"
              : EA) +
            "). If you meant to render a collection of children, use an array instead.",
        )
      )
    return NA
  }
  function JA($, EA, GA) {
    if ($ == null) return $
    var DA = [],
      dA = 0
    return (
      lA($, DA, "", "", function (kA) {
        return EA.call(GA, kA, dA++)
      }),
      DA
    )
  }
  function yA($) {
    if ($._status === -1) {
      var EA = $._result
      ;((EA = EA()),
        EA.then(
          function (GA) {
            ;($._status === 0 || $._status === -1) && (($._status = 1), ($._result = GA))
          },
          function (GA) {
            ;($._status === 0 || $._status === -1) && (($._status = 2), ($._result = GA))
          },
        ),
        $._status === -1 && (($._status = 0), ($._result = EA)))
    }
    if ($._status === 1) return $._result.default
    throw $._result
  }
  var LA = { current: null },
    nA = { transition: null },
    fA = { ReactCurrentDispatcher: LA, ReactCurrentBatchConfig: nA, ReactCurrentOwner: j }
  function sA() {
    throw Error("act(...) is not supported in production builds of React.")
  }
  return (
    (be.Children = {
      map: JA,
      forEach: function ($, EA, GA) {
        JA(
          $,
          function () {
            EA.apply(this, arguments)
          },
          GA,
        )
      },
      count: function ($) {
        var EA = 0
        return (
          JA($, function () {
            EA++
          }),
          EA
        )
      },
      toArray: function ($) {
        return (
          JA($, function (EA) {
            return EA
          }) || []
        )
      },
      only: function ($) {
        if (!_($))
          throw Error("React.Children.only expected to receive a single React element child.")
        return $
      },
    }),
    (be.Component = R),
    (be.Fragment = I),
    (be.Profiler = C),
    (be.PureComponent = L),
    (be.StrictMode = g),
    (be.Suspense = r),
    (be.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fA),
    (be.act = sA),
    (be.cloneElement = function ($, EA, GA) {
      if ($ == null)
        throw Error(
          "React.cloneElement(...): The argument must be a React element, but you passed " +
            $ +
            ".",
        )
      var DA = M({}, $.props),
        dA = $.key,
        kA = $.ref,
        NA = $._owner
      if (EA != null) {
        if (
          (EA.ref !== void 0 && ((kA = EA.ref), (NA = j.current)),
          EA.key !== void 0 && (dA = "" + EA.key),
          $.type && $.type.defaultProps)
        )
          var qA = $.type.defaultProps
        for (ZA in EA)
          V.call(EA, ZA) &&
            !P.hasOwnProperty(ZA) &&
            (DA[ZA] = EA[ZA] === void 0 && qA !== void 0 ? qA[ZA] : EA[ZA])
      }
      var ZA = arguments.length - 2
      if (ZA === 1) DA.children = GA
      else if (1 < ZA) {
        qA = Array(ZA)
        for (var sI = 0; sI < ZA; sI++) qA[sI] = arguments[sI + 2]
        DA.children = qA
      }
      return { $$typeof: e, type: $.type, key: dA, ref: kA, props: DA, _owner: NA }
    }),
    (be.createContext = function ($) {
      return (
        ($ = {
          $$typeof: B,
          _currentValue: $,
          _currentValue2: $,
          _threadCount: 0,
          Provider: null,
          Consumer: null,
          _defaultValue: null,
          _globalName: null,
        }),
        ($.Provider = { $$typeof: i, _context: $ }),
        ($.Consumer = $)
      )
    }),
    (be.createElement = AA),
    (be.createFactory = function ($) {
      var EA = AA.bind(null, $)
      return ((EA.type = $), EA)
    }),
    (be.createRef = function () {
      return { current: null }
    }),
    (be.forwardRef = function ($) {
      return { $$typeof: o, render: $ }
    }),
    (be.isValidElement = _),
    (be.lazy = function ($) {
      return { $$typeof: h, _payload: { _status: -1, _result: $ }, _init: yA }
    }),
    (be.memo = function ($, EA) {
      return { $$typeof: s, type: $, compare: EA === void 0 ? null : EA }
    }),
    (be.startTransition = function ($) {
      var EA = nA.transition
      nA.transition = {}
      try {
        $()
      } finally {
        nA.transition = EA
      }
    }),
    (be.unstable_act = sA),
    (be.useCallback = function ($, EA) {
      return LA.current.useCallback($, EA)
    }),
    (be.useContext = function ($) {
      return LA.current.useContext($)
    }),
    (be.useDebugValue = function () {}),
    (be.useDeferredValue = function ($) {
      return LA.current.useDeferredValue($)
    }),
    (be.useEffect = function ($, EA) {
      return LA.current.useEffect($, EA)
    }),
    (be.useId = function () {
      return LA.current.useId()
    }),
    (be.useImperativeHandle = function ($, EA, GA) {
      return LA.current.useImperativeHandle($, EA, GA)
    }),
    (be.useInsertionEffect = function ($, EA) {
      return LA.current.useInsertionEffect($, EA)
    }),
    (be.useLayoutEffect = function ($, EA) {
      return LA.current.useLayoutEffect($, EA)
    }),
    (be.useMemo = function ($, EA) {
      return LA.current.useMemo($, EA)
    }),
    (be.useReducer = function ($, EA, GA) {
      return LA.current.useReducer($, EA, GA)
    }),
    (be.useRef = function ($) {
      return LA.current.useRef($)
    }),
    (be.useState = function ($) {
      return LA.current.useState($)
    }),
    (be.useSyncExternalStore = function ($, EA, GA) {
      return LA.current.useSyncExternalStore($, EA, GA)
    }),
    (be.useTransition = function () {
      return LA.current.useTransition()
    }),
    (be.version = "18.3.1"),
    be
  )
}
var b0 = { exports: {} }
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
b0.exports
var Sq
function g1() {
  return (
    Sq ||
      ((Sq = 1),
      (function (e, A) {
        process.env.NODE_ENV !== "production" &&
          (function () {
            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" &&
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" &&
              __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error())
            var I = "18.3.1",
              g = Symbol.for("react.element"),
              C = Symbol.for("react.portal"),
              i = Symbol.for("react.fragment"),
              B = Symbol.for("react.strict_mode"),
              o = Symbol.for("react.profiler"),
              r = Symbol.for("react.provider"),
              s = Symbol.for("react.context"),
              h = Symbol.for("react.forward_ref"),
              S = Symbol.for("react.suspense"),
              d = Symbol.for("react.suspense_list"),
              w = Symbol.for("react.memo"),
              M = Symbol.for("react.lazy"),
              K = Symbol.for("react.offscreen"),
              R = Symbol.iterator,
              F = "@@iterator"
            function L(iA) {
              if (iA === null || typeof iA != "object") return null
              var vA = (R && iA[R]) || iA[F]
              return typeof vA == "function" ? vA : null
            }
            var Y = {
                /**
                 * @internal
                 * @type {ReactComponent}
                 */
                current: null,
              },
              H = {
                transition: null,
              },
              V = {
                current: null,
                // Used to reproduce behavior of `batchedUpdates` in legacy mode.
                isBatchingLegacy: !1,
                didScheduleLegacyUpdate: !1,
              },
              j = {
                /**
                 * @internal
                 * @type {ReactComponent}
                 */
                current: null,
              },
              P = {},
              AA = null
            function X(iA) {
              AA = iA
            }
            ;((P.setExtraStackFrame = function (iA) {
              AA = iA
            }),
              (P.getCurrentStack = null),
              (P.getStackAddendum = function () {
                var iA = ""
                AA && (iA += AA)
                var vA = P.getCurrentStack
                return (vA && (iA += vA() || ""), iA)
              }))
            var _ = !1,
              eA = !1,
              CA = !1,
              aA = !1,
              lA = !1,
              JA = {
                ReactCurrentDispatcher: Y,
                ReactCurrentBatchConfig: H,
                ReactCurrentOwner: j,
              }
            ;((JA.ReactDebugCurrentFrame = P), (JA.ReactCurrentActQueue = V))
            function yA(iA) {
              {
                for (
                  var vA = arguments.length, rI = new Array(vA > 1 ? vA - 1 : 0), mI = 1;
                  mI < vA;
                  mI++
                )
                  rI[mI - 1] = arguments[mI]
                nA("warn", iA, rI)
              }
            }
            function LA(iA) {
              {
                for (
                  var vA = arguments.length, rI = new Array(vA > 1 ? vA - 1 : 0), mI = 1;
                  mI < vA;
                  mI++
                )
                  rI[mI - 1] = arguments[mI]
                nA("error", iA, rI)
              }
            }
            function nA(iA, vA, rI) {
              {
                var mI = JA.ReactDebugCurrentFrame,
                  ig = mI.getStackAddendum()
                ig !== "" && ((vA += "%s"), (rI = rI.concat([ig])))
                var AC = rI.map(function (pg) {
                  return String(pg)
                })
                ;(AC.unshift("Warning: " + vA),
                  Function.prototype.apply.call(console[iA], console, AC))
              }
            }
            var fA = {}
            function sA(iA, vA) {
              {
                var rI = iA.constructor,
                  mI = (rI && (rI.displayName || rI.name)) || "ReactClass",
                  ig = mI + "." + vA
                if (fA[ig]) return
                ;(LA(
                  "Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.",
                  vA,
                  mI,
                ),
                  (fA[ig] = !0))
              }
            }
            var $ = {
                /**
                 * Checks whether or not this composite component is mounted.
                 * @param {ReactClass} publicInstance The instance we want to test.
                 * @return {boolean} True if mounted, false otherwise.
                 * @protected
                 * @final
                 */
                isMounted: function (iA) {
                  return !1
                },
                /**
                 * Forces an update. This should only be invoked when it is known with
                 * certainty that we are **not** in a DOM transaction.
                 *
                 * You may want to call this when you know that some deeper aspect of the
                 * component's state has changed but `setState` was not called.
                 *
                 * This will not invoke `shouldComponentUpdate`, but it will invoke
                 * `componentWillUpdate` and `componentDidUpdate`.
                 *
                 * @param {ReactClass} publicInstance The instance that should rerender.
                 * @param {?function} callback Called after component is updated.
                 * @param {?string} callerName name of the calling function in the public API.
                 * @internal
                 */
                enqueueForceUpdate: function (iA, vA, rI) {
                  sA(iA, "forceUpdate")
                },
                /**
                 * Replaces all of the state. Always use this or `setState` to mutate state.
                 * You should treat `this.state` as immutable.
                 *
                 * There is no guarantee that `this.state` will be immediately updated, so
                 * accessing `this.state` after calling this method may return the old value.
                 *
                 * @param {ReactClass} publicInstance The instance that should rerender.
                 * @param {object} completeState Next state.
                 * @param {?function} callback Called after component is updated.
                 * @param {?string} callerName name of the calling function in the public API.
                 * @internal
                 */
                enqueueReplaceState: function (iA, vA, rI, mI) {
                  sA(iA, "replaceState")
                },
                /**
                 * Sets a subset of the state. This only exists because _pendingState is
                 * internal. This provides a merging strategy that is not available to deep
                 * properties which is confusing. TODO: Expose pendingState or don't use it
                 * during the merge.
                 *
                 * @param {ReactClass} publicInstance The instance that should rerender.
                 * @param {object} partialState Next partial state to be merged with state.
                 * @param {?function} callback Called after component is updated.
                 * @param {?string} Name of the calling function in the public API.
                 * @internal
                 */
                enqueueSetState: function (iA, vA, rI, mI) {
                  sA(iA, "setState")
                },
              },
              EA = Object.assign,
              GA = {}
            Object.freeze(GA)
            function DA(iA, vA, rI) {
              ;((this.props = iA), (this.context = vA), (this.refs = GA), (this.updater = rI || $))
            }
            ;((DA.prototype.isReactComponent = {}),
              (DA.prototype.setState = function (iA, vA) {
                if (typeof iA != "object" && typeof iA != "function" && iA != null)
                  throw new Error(
                    "setState(...): takes an object of state variables to update or a function which returns an object of state variables.",
                  )
                this.updater.enqueueSetState(this, iA, vA, "setState")
              }),
              (DA.prototype.forceUpdate = function (iA) {
                this.updater.enqueueForceUpdate(this, iA, "forceUpdate")
              }))
            {
              var dA = {
                  isMounted: [
                    "isMounted",
                    "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks.",
                  ],
                  replaceState: [
                    "replaceState",
                    "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236).",
                  ],
                },
                kA = function (iA, vA) {
                  Object.defineProperty(DA.prototype, iA, {
                    get: function () {
                      yA(
                        "%s(...) is deprecated in plain JavaScript React classes. %s",
                        vA[0],
                        vA[1],
                      )
                    },
                  })
                }
              for (var NA in dA) dA.hasOwnProperty(NA) && kA(NA, dA[NA])
            }
            function qA() {}
            qA.prototype = DA.prototype
            function ZA(iA, vA, rI) {
              ;((this.props = iA), (this.context = vA), (this.refs = GA), (this.updater = rI || $))
            }
            var sI = (ZA.prototype = new qA())
            ;((sI.constructor = ZA), EA(sI, DA.prototype), (sI.isPureReactComponent = !0))
            function cI() {
              var iA = {
                current: null,
              }
              return (Object.seal(iA), iA)
            }
            var YA = Array.isArray
            function eI(iA) {
              return YA(iA)
            }
            function uA(iA) {
              {
                var vA = typeof Symbol == "function" && Symbol.toStringTag,
                  rI = (vA && iA[Symbol.toStringTag]) || iA.constructor.name || "Object"
                return rI
              }
            }
            function hI(iA) {
              try {
                return (II(iA), !1)
              } catch {
                return !0
              }
            }
            function II(iA) {
              return "" + iA
            }
            function pI(iA) {
              if (hI(iA))
                return (
                  LA(
                    "The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.",
                    uA(iA),
                  ),
                  II(iA)
                )
            }
            function AI(iA, vA, rI) {
              var mI = iA.displayName
              if (mI) return mI
              var ig = vA.displayName || vA.name || ""
              return ig !== "" ? rI + "(" + ig + ")" : rI
            }
            function YI(iA) {
              return iA.displayName || "Context"
            }
            function SI(iA) {
              if (iA == null) return null
              if (
                (typeof iA.tag == "number" &&
                  LA(
                    "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.",
                  ),
                typeof iA == "function")
              )
                return iA.displayName || iA.name || null
              if (typeof iA == "string") return iA
              switch (iA) {
                case i:
                  return "Fragment"
                case C:
                  return "Portal"
                case o:
                  return "Profiler"
                case B:
                  return "StrictMode"
                case S:
                  return "Suspense"
                case d:
                  return "SuspenseList"
              }
              if (typeof iA == "object")
                switch (iA.$$typeof) {
                  case s:
                    var vA = iA
                    return YI(vA) + ".Consumer"
                  case r:
                    var rI = iA
                    return YI(rI._context) + ".Provider"
                  case h:
                    return AI(iA, iA.render, "ForwardRef")
                  case w:
                    var mI = iA.displayName || null
                    return mI !== null ? mI : SI(iA.type) || "Memo"
                  case M: {
                    var ig = iA,
                      AC = ig._payload,
                      pg = ig._init
                    try {
                      return SI(pg(AC))
                    } catch {
                      return null
                    }
                  }
                }
              return null
            }
            var QA = Object.prototype.hasOwnProperty,
              tA = {
                key: !0,
                ref: !0,
                __self: !0,
                __source: !0,
              },
              FA,
              WA,
              jA
            jA = {}
            function nI(iA) {
              if (QA.call(iA, "ref")) {
                var vA = Object.getOwnPropertyDescriptor(iA, "ref").get
                if (vA && vA.isReactWarning) return !1
              }
              return iA.ref !== void 0
            }
            function UI(iA) {
              if (QA.call(iA, "key")) {
                var vA = Object.getOwnPropertyDescriptor(iA, "key").get
                if (vA && vA.isReactWarning) return !1
              }
              return iA.key !== void 0
            }
            function GI(iA, vA) {
              var rI = function () {
                FA ||
                  ((FA = !0),
                  LA(
                    "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)",
                    vA,
                  ))
              }
              ;((rI.isReactWarning = !0),
                Object.defineProperty(iA, "key", {
                  get: rI,
                  configurable: !0,
                }))
            }
            function LI(iA, vA) {
              var rI = function () {
                WA ||
                  ((WA = !0),
                  LA(
                    "%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)",
                    vA,
                  ))
              }
              ;((rI.isReactWarning = !0),
                Object.defineProperty(iA, "ref", {
                  get: rI,
                  configurable: !0,
                }))
            }
            function Bg(iA) {
              if (
                typeof iA.ref == "string" &&
                j.current &&
                iA.__self &&
                j.current.stateNode !== iA.__self
              ) {
                var vA = SI(j.current.type)
                jA[vA] ||
                  (LA(
                    'Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref',
                    vA,
                    iA.ref,
                  ),
                  (jA[vA] = !0))
              }
            }
            var MA = function (iA, vA, rI, mI, ig, AC, pg) {
              var tC = {
                // This tag allows us to uniquely identify this as a React Element
                $$typeof: g,
                // Built-in properties that belong on the element
                type: iA,
                key: vA,
                ref: rI,
                props: pg,
                // Record the component responsible for creating this element.
                _owner: AC,
              }
              return (
                (tC._store = {}),
                Object.defineProperty(tC._store, "validated", {
                  configurable: !1,
                  enumerable: !1,
                  writable: !0,
                  value: !1,
                }),
                Object.defineProperty(tC, "_self", {
                  configurable: !1,
                  enumerable: !1,
                  writable: !1,
                  value: mI,
                }),
                Object.defineProperty(tC, "_source", {
                  configurable: !1,
                  enumerable: !1,
                  writable: !1,
                  value: ig,
                }),
                Object.freeze && (Object.freeze(tC.props), Object.freeze(tC)),
                tC
              )
            }
            function OA(iA, vA, rI) {
              var mI,
                ig = {},
                AC = null,
                pg = null,
                tC = null,
                BC = null
              if (vA != null) {
                ;(nI(vA) && ((pg = vA.ref), Bg(vA)),
                  UI(vA) && (pI(vA.key), (AC = "" + vA.key)),
                  (tC = vA.__self === void 0 ? null : vA.__self),
                  (BC = vA.__source === void 0 ? null : vA.__source))
                for (mI in vA) QA.call(vA, mI) && !tA.hasOwnProperty(mI) && (ig[mI] = vA[mI])
              }
              var NC = arguments.length - 2
              if (NC === 1) ig.children = rI
              else if (NC > 1) {
                for (var KC = Array(NC), GC = 0; GC < NC; GC++) KC[GC] = arguments[GC + 2]
                ;(Object.freeze && Object.freeze(KC), (ig.children = KC))
              }
              if (iA && iA.defaultProps) {
                var ie = iA.defaultProps
                for (mI in ie) ig[mI] === void 0 && (ig[mI] = ie[mI])
              }
              if (AC || pg) {
                var we = typeof iA == "function" ? iA.displayName || iA.name || "Unknown" : iA
                ;(AC && GI(ig, we), pg && LI(ig, we))
              }
              return MA(iA, AC, pg, tC, BC, j.current, ig)
            }
            function aI(iA, vA) {
              var rI = MA(iA.type, vA, iA.ref, iA._self, iA._source, iA._owner, iA.props)
              return rI
            }
            function RI(iA, vA, rI) {
              if (iA == null)
                throw new Error(
                  "React.cloneElement(...): The argument must be a React element, but you passed " +
                    iA +
                    ".",
                )
              var mI,
                ig = EA({}, iA.props),
                AC = iA.key,
                pg = iA.ref,
                tC = iA._self,
                BC = iA._source,
                NC = iA._owner
              if (vA != null) {
                ;(nI(vA) && ((pg = vA.ref), (NC = j.current)),
                  UI(vA) && (pI(vA.key), (AC = "" + vA.key)))
                var KC
                iA.type && iA.type.defaultProps && (KC = iA.type.defaultProps)
                for (mI in vA)
                  QA.call(vA, mI) &&
                    !tA.hasOwnProperty(mI) &&
                    (vA[mI] === void 0 && KC !== void 0 ? (ig[mI] = KC[mI]) : (ig[mI] = vA[mI]))
              }
              var GC = arguments.length - 2
              if (GC === 1) ig.children = rI
              else if (GC > 1) {
                for (var ie = Array(GC), we = 0; we < GC; we++) ie[we] = arguments[we + 2]
                ig.children = ie
              }
              return MA(iA.type, AC, pg, tC, BC, NC, ig)
            }
            function VA(iA) {
              return typeof iA == "object" && iA !== null && iA.$$typeof === g
            }
            var ag = ".",
              XI = ":"
            function $I(iA) {
              var vA = /[=:]/g,
                rI = {
                  "=": "=0",
                  ":": "=2",
                },
                mI = iA.replace(vA, function (ig) {
                  return rI[ig]
                })
              return "$" + mI
            }
            var SA = !1,
              NI = /\/+/g
            function HA(iA) {
              return iA.replace(NI, "$&/")
            }
            function iI(iA, vA) {
              return typeof iA == "object" && iA !== null && iA.key != null
                ? (pI(iA.key), $I("" + iA.key))
                : vA.toString(36)
            }
            function zI(iA, vA, rI, mI, ig) {
              var AC = typeof iA
              ;(AC === "undefined" || AC === "boolean") && (iA = null)
              var pg = !1
              if (iA === null) pg = !0
              else
                switch (AC) {
                  case "string":
                  case "number":
                    pg = !0
                    break
                  case "object":
                    switch (iA.$$typeof) {
                      case g:
                      case C:
                        pg = !0
                    }
                }
              if (pg) {
                var tC = iA,
                  BC = ig(tC),
                  NC = mI === "" ? ag + iI(tC, 0) : mI
                if (eI(BC)) {
                  var KC = ""
                  ;(NC != null && (KC = HA(NC) + "/"),
                    zI(BC, vA, KC, "", function (Rl) {
                      return Rl
                    }))
                } else
                  BC != null &&
                    (VA(BC) &&
                      (BC.key && (!tC || tC.key !== BC.key) && pI(BC.key),
                      (BC = aI(
                        BC,
                        // Keep both the (mapped) and old keys if they differ, just as
                        // traverseAllChildren used to do for objects as children
                        rI + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                          (BC.key && (!tC || tC.key !== BC.key)
                            ? // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
                              // eslint-disable-next-line react-internal/safe-string-coercion
                              HA("" + BC.key) + "/"
                            : "") +
                          NC,
                      ))),
                    vA.push(BC))
                return 1
              }
              var GC,
                ie,
                we = 0,
                le = mI === "" ? ag : mI + XI
              if (eI(iA))
                for (var Io = 0; Io < iA.length; Io++)
                  ((GC = iA[Io]), (ie = le + iI(GC, Io)), (we += zI(GC, vA, rI, ie, ig)))
              else {
                var KQ = L(iA)
                if (typeof KQ == "function") {
                  var So = iA
                  KQ === So.entries &&
                    (SA ||
                      yA(
                        "Using Maps as children is not supported. Use an array of keyed ReactElements instead.",
                      ),
                    (SA = !0))
                  for (var xr = KQ.call(So), fo, XE = 0; !(fo = xr.next()).done; )
                    ((GC = fo.value), (ie = le + iI(GC, XE++)), (we += zI(GC, vA, rI, ie, ig)))
                } else if (AC === "object") {
                  var br = String(iA)
                  throw new Error(
                    "Objects are not valid as a React child (found: " +
                      (br === "[object Object]"
                        ? "object with keys {" + Object.keys(iA).join(", ") + "}"
                        : br) +
                      "). If you meant to render a collection of children, use an array instead.",
                  )
                }
              }
              return we
            }
            function qI(iA, vA, rI) {
              if (iA == null) return iA
              var mI = [],
                ig = 0
              return (
                zI(iA, mI, "", "", function (AC) {
                  return vA.call(rI, AC, ig++)
                }),
                mI
              )
            }
            function dg(iA) {
              var vA = 0
              return (
                qI(iA, function () {
                  vA++
                }),
                vA
              )
            }
            function $g(iA, vA, rI) {
              qI(
                iA,
                function () {
                  vA.apply(this, arguments)
                },
                rI,
              )
            }
            function Qg(iA) {
              return (
                qI(iA, function (vA) {
                  return vA
                }) || []
              )
            }
            function Fg(iA) {
              if (!VA(iA))
                throw new Error(
                  "React.Children.only expected to receive a single React element child.",
                )
              return iA
            }
            function jC(iA) {
              var vA = {
                $$typeof: s,
                // As a workaround to support multiple concurrent renderers, we categorize
                // some renderers as primary and others as secondary. We only expect
                // there to be two concurrent renderers at most: React Native (primary) and
                // Fabric (secondary); React DOM (primary) and React ART (secondary).
                // Secondary renderers store their context values on separate fields.
                _currentValue: iA,
                _currentValue2: iA,
                // Used to track how many concurrent renderers this context currently
                // supports within in a single renderer. Such as parallel server rendering.
                _threadCount: 0,
                // These are circular
                Provider: null,
                Consumer: null,
                // Add these to use same hidden class in VM as ServerContext
                _defaultValue: null,
                _globalName: null,
              }
              vA.Provider = {
                $$typeof: r,
                _context: vA,
              }
              var rI = !1,
                mI = !1,
                ig = !1
              {
                var AC = {
                  $$typeof: s,
                  _context: vA,
                }
                ;(Object.defineProperties(AC, {
                  Provider: {
                    get: function () {
                      return (
                        mI ||
                          ((mI = !0),
                          LA(
                            "Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?",
                          )),
                        vA.Provider
                      )
                    },
                    set: function (pg) {
                      vA.Provider = pg
                    },
                  },
                  _currentValue: {
                    get: function () {
                      return vA._currentValue
                    },
                    set: function (pg) {
                      vA._currentValue = pg
                    },
                  },
                  _currentValue2: {
                    get: function () {
                      return vA._currentValue2
                    },
                    set: function (pg) {
                      vA._currentValue2 = pg
                    },
                  },
                  _threadCount: {
                    get: function () {
                      return vA._threadCount
                    },
                    set: function (pg) {
                      vA._threadCount = pg
                    },
                  },
                  Consumer: {
                    get: function () {
                      return (
                        rI ||
                          ((rI = !0),
                          LA(
                            "Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?",
                          )),
                        vA.Consumer
                      )
                    },
                  },
                  displayName: {
                    get: function () {
                      return vA.displayName
                    },
                    set: function (pg) {
                      ig ||
                        (yA(
                          "Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.",
                          pg,
                        ),
                        (ig = !0))
                    },
                  },
                }),
                  (vA.Consumer = AC))
              }
              return ((vA._currentRenderer = null), (vA._currentRenderer2 = null), vA)
            }
            var mC = -1,
              zC = 0,
              Ee = 1,
              ei = 2
            function fe(iA) {
              if (iA._status === mC) {
                var vA = iA._result,
                  rI = vA()
                if (
                  (rI.then(
                    function (AC) {
                      if (iA._status === zC || iA._status === mC) {
                        var pg = iA
                        ;((pg._status = Ee), (pg._result = AC))
                      }
                    },
                    function (AC) {
                      if (iA._status === zC || iA._status === mC) {
                        var pg = iA
                        ;((pg._status = ei), (pg._result = AC))
                      }
                    },
                  ),
                  iA._status === mC)
                ) {
                  var mI = iA
                  ;((mI._status = zC), (mI._result = rI))
                }
              }
              if (iA._status === Ee) {
                var ig = iA._result
                return (
                  ig === void 0 &&
                    LA(
                      `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`,
                      ig,
                    ),
                  "default" in ig ||
                    LA(
                      `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`,
                      ig,
                    ),
                  ig.default
                )
              } else throw iA._result
            }
            function Ei(iA) {
              var vA = {
                  // We use these fields to store the result.
                  _status: mC,
                  _result: iA,
                },
                rI = {
                  $$typeof: M,
                  _payload: vA,
                  _init: fe,
                }
              {
                var mI, ig
                Object.defineProperties(rI, {
                  defaultProps: {
                    configurable: !0,
                    get: function () {
                      return mI
                    },
                    set: function (AC) {
                      ;(LA(
                        "React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.",
                      ),
                        (mI = AC),
                        Object.defineProperty(rI, "defaultProps", {
                          enumerable: !0,
                        }))
                    },
                  },
                  propTypes: {
                    configurable: !0,
                    get: function () {
                      return ig
                    },
                    set: function (AC) {
                      ;(LA(
                        "React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.",
                      ),
                        (ig = AC),
                        Object.defineProperty(rI, "propTypes", {
                          enumerable: !0,
                        }))
                    },
                  },
                })
              }
              return rI
            }
            function vi(iA) {
              ;(iA != null && iA.$$typeof === w
                ? LA(
                    "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).",
                  )
                : typeof iA != "function"
                  ? LA(
                      "forwardRef requires a render function but was given %s.",
                      iA === null ? "null" : typeof iA,
                    )
                  : iA.length !== 0 &&
                    iA.length !== 2 &&
                    LA(
                      "forwardRef render functions accept exactly two parameters: props and ref. %s",
                      iA.length === 1
                        ? "Did you forget to use the ref parameter?"
                        : "Any additional parameter will be undefined.",
                    ),
                iA != null &&
                  (iA.defaultProps != null || iA.propTypes != null) &&
                  LA(
                    "forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?",
                  ))
              var vA = {
                $$typeof: h,
                render: iA,
              }
              {
                var rI
                Object.defineProperty(vA, "displayName", {
                  enumerable: !1,
                  configurable: !0,
                  get: function () {
                    return rI
                  },
                  set: function (mI) {
                    ;((rI = mI), !iA.name && !iA.displayName && (iA.displayName = mI))
                  },
                })
              }
              return vA
            }
            var Li
            Li = Symbol.for("react.module.reference")
            function mA(iA) {
              return !!(
                typeof iA == "string" ||
                typeof iA == "function" ||
                iA === i ||
                iA === o ||
                lA ||
                iA === B ||
                iA === S ||
                iA === d ||
                aA ||
                iA === K ||
                _ ||
                eA ||
                CA ||
                (typeof iA == "object" &&
                  iA !== null &&
                  (iA.$$typeof === M ||
                    iA.$$typeof === w ||
                    iA.$$typeof === r ||
                    iA.$$typeof === s ||
                    iA.$$typeof === h || // This needs to include all possible module reference object
                    // types supported by any Flight configuration anywhere since
                    // we don't know which Flight build this will end up being used
                    // with.
                    iA.$$typeof === Li ||
                    iA.getModuleId !== void 0))
              )
            }
            function TI(iA, vA) {
              mA(iA) ||
                LA(
                  "memo: The first argument must be a component. Instead received: %s",
                  iA === null ? "null" : typeof iA,
                )
              var rI = {
                $$typeof: w,
                type: iA,
                compare: vA === void 0 ? null : vA,
              }
              {
                var mI
                Object.defineProperty(rI, "displayName", {
                  enumerable: !1,
                  configurable: !0,
                  get: function () {
                    return mI
                  },
                  set: function (ig) {
                    ;((mI = ig), !iA.name && !iA.displayName && (iA.displayName = ig))
                  },
                })
              }
              return rI
            }
            function eg() {
              var iA = Y.current
              return (
                iA === null &&
                  LA(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`),
                iA
              )
            }
            function Tg(iA) {
              var vA = eg()
              if (iA._context !== void 0) {
                var rI = iA._context
                rI.Consumer === iA
                  ? LA(
                      "Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?",
                    )
                  : rI.Provider === iA &&
                    LA(
                      "Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?",
                    )
              }
              return vA.useContext(iA)
            }
            function OC(iA) {
              var vA = eg()
              return vA.useState(iA)
            }
            function JC(iA, vA, rI) {
              var mI = eg()
              return mI.useReducer(iA, vA, rI)
            }
            function jg(iA) {
              var vA = eg()
              return vA.useRef(iA)
            }
            function rA(iA, vA) {
              var rI = eg()
              return rI.useEffect(iA, vA)
            }
            function _A(iA, vA) {
              var rI = eg()
              return rI.useInsertionEffect(iA, vA)
            }
            function oI(iA, vA) {
              var rI = eg()
              return rI.useLayoutEffect(iA, vA)
            }
            function QI(iA, vA) {
              var rI = eg()
              return rI.useCallback(iA, vA)
            }
            function PA(iA, vA) {
              var rI = eg()
              return rI.useMemo(iA, vA)
            }
            function gg(iA, vA, rI) {
              var mI = eg()
              return mI.useImperativeHandle(iA, vA, rI)
            }
            function EI(iA, vA) {
              {
                var rI = eg()
                return rI.useDebugValue(iA, vA)
              }
            }
            function hg() {
              var iA = eg()
              return iA.useTransition()
            }
            function yg(iA) {
              var vA = eg()
              return vA.useDeferredValue(iA)
            }
            function rg() {
              var iA = eg()
              return iA.useId()
            }
            function eC(iA, vA, rI) {
              var mI = eg()
              return mI.useSyncExternalStore(iA, vA, rI)
            }
            var Rg = 0,
              pC,
              wC,
              mg,
              UC,
              iC,
              Gg,
              _C
            function vC() {}
            vC.__reactDisabledLog = !0
            function ii() {
              {
                if (Rg === 0) {
                  ;((pC = console.log),
                    (wC = console.info),
                    (mg = console.warn),
                    (UC = console.error),
                    (iC = console.group),
                    (Gg = console.groupCollapsed),
                    (_C = console.groupEnd))
                  var iA = {
                    configurable: !0,
                    enumerable: !0,
                    value: vC,
                    writable: !0,
                  }
                  Object.defineProperties(console, {
                    info: iA,
                    log: iA,
                    warn: iA,
                    error: iA,
                    group: iA,
                    groupCollapsed: iA,
                    groupEnd: iA,
                  })
                }
                Rg++
              }
            }
            function qe() {
              {
                if ((Rg--, Rg === 0)) {
                  var iA = {
                    configurable: !0,
                    enumerable: !0,
                    writable: !0,
                  }
                  Object.defineProperties(console, {
                    log: EA({}, iA, {
                      value: pC,
                    }),
                    info: EA({}, iA, {
                      value: wC,
                    }),
                    warn: EA({}, iA, {
                      value: mg,
                    }),
                    error: EA({}, iA, {
                      value: UC,
                    }),
                    group: EA({}, iA, {
                      value: iC,
                    }),
                    groupCollapsed: EA({}, iA, {
                      value: Gg,
                    }),
                    groupEnd: EA({}, iA, {
                      value: _C,
                    }),
                  })
                }
                Rg < 0 &&
                  LA("disabledDepth fell below zero. This is a bug in React. Please file an issue.")
              }
            }
            var pe = JA.ReactCurrentDispatcher,
              Mi
            function ae(iA, vA, rI) {
              {
                if (Mi === void 0)
                  try {
                    throw Error()
                  } catch (ig) {
                    var mI = ig.stack.trim().match(/\n( *(at )?)/)
                    Mi = (mI && mI[1]) || ""
                  }
                return (
                  `
` +
                  Mi +
                  iA
                )
              }
            }
            var ai = !1,
              fi
            {
              var He = typeof WeakMap == "function" ? WeakMap : Map
              fi = new He()
            }
            function Et(iA, vA) {
              if (!iA || ai) return ""
              {
                var rI = fi.get(iA)
                if (rI !== void 0) return rI
              }
              var mI
              ai = !0
              var ig = Error.prepareStackTrace
              Error.prepareStackTrace = void 0
              var AC
              ;((AC = pe.current), (pe.current = null), ii())
              try {
                if (vA) {
                  var pg = function () {
                    throw Error()
                  }
                  if (
                    (Object.defineProperty(pg.prototype, "props", {
                      set: function () {
                        throw Error()
                      },
                    }),
                    typeof Reflect == "object" && Reflect.construct)
                  ) {
                    try {
                      Reflect.construct(pg, [])
                    } catch (le) {
                      mI = le
                    }
                    Reflect.construct(iA, [], pg)
                  } else {
                    try {
                      pg.call()
                    } catch (le) {
                      mI = le
                    }
                    iA.call(pg.prototype)
                  }
                } else {
                  try {
                    throw Error()
                  } catch (le) {
                    mI = le
                  }
                  iA()
                }
              } catch (le) {
                if (le && mI && typeof le.stack == "string") {
                  for (
                    var tC = le.stack.split(`
`),
                      BC = mI.stack.split(`
`),
                      NC = tC.length - 1,
                      KC = BC.length - 1;
                    NC >= 1 && KC >= 0 && tC[NC] !== BC[KC];
                  )
                    KC--
                  for (; NC >= 1 && KC >= 0; NC--, KC--)
                    if (tC[NC] !== BC[KC]) {
                      if (NC !== 1 || KC !== 1)
                        do
                          if ((NC--, KC--, KC < 0 || tC[NC] !== BC[KC])) {
                            var GC =
                              `
` + tC[NC].replace(" at new ", " at ")
                            return (
                              iA.displayName &&
                                GC.includes("<anonymous>") &&
                                (GC = GC.replace("<anonymous>", iA.displayName)),
                              typeof iA == "function" && fi.set(iA, GC),
                              GC
                            )
                          }
                        while (NC >= 1 && KC >= 0)
                      break
                    }
                }
              } finally {
                ;((ai = !1), (pe.current = AC), qe(), (Error.prepareStackTrace = ig))
              }
              var ie = iA ? iA.displayName || iA.name : "",
                we = ie ? ae(ie) : ""
              return (typeof iA == "function" && fi.set(iA, we), we)
            }
            function Yi(iA, vA, rI) {
              return Et(iA, !1)
            }
            function vn(iA) {
              var vA = iA.prototype
              return !!(vA && vA.isReactComponent)
            }
            function aB(iA, vA, rI) {
              if (iA == null) return ""
              if (typeof iA == "function") return Et(iA, vn(iA))
              if (typeof iA == "string") return ae(iA)
              switch (iA) {
                case S:
                  return ae("Suspense")
                case d:
                  return ae("SuspenseList")
              }
              if (typeof iA == "object")
                switch (iA.$$typeof) {
                  case h:
                    return Yi(iA.render)
                  case w:
                    return aB(iA.type, vA, rI)
                  case M: {
                    var mI = iA,
                      ig = mI._payload,
                      AC = mI._init
                    try {
                      return aB(AC(ig), vA, rI)
                    } catch {}
                  }
                }
              return ""
            }
            var XC = {},
              dB = JA.ReactDebugCurrentFrame
            function zQ(iA) {
              if (iA) {
                var vA = iA._owner,
                  rI = aB(iA.type, iA._source, vA ? vA.type : null)
                dB.setExtraStackFrame(rI)
              } else dB.setExtraStackFrame(null)
            }
            function Wt(iA, vA, rI, mI, ig) {
              {
                var AC = Function.call.bind(QA)
                for (var pg in iA)
                  if (AC(iA, pg)) {
                    var tC = void 0
                    try {
                      if (typeof iA[pg] != "function") {
                        var BC = Error(
                          (mI || "React class") +
                            ": " +
                            rI +
                            " type `" +
                            pg +
                            "` is invalid; it must be a function, usually from the `prop-types` package, but received `" +
                            typeof iA[pg] +
                            "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.",
                        )
                        throw ((BC.name = "Invariant Violation"), BC)
                      }
                      tC = iA[pg](
                        vA,
                        pg,
                        mI,
                        rI,
                        null,
                        "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
                      )
                    } catch (NC) {
                      tC = NC
                    }
                    ;(tC &&
                      !(tC instanceof Error) &&
                      (zQ(ig),
                      LA(
                        "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",
                        mI || "React class",
                        rI,
                        pg,
                        typeof tC,
                      ),
                      zQ(null)),
                      tC instanceof Error &&
                        !(tC.message in XC) &&
                        ((XC[tC.message] = !0),
                        zQ(ig),
                        LA("Failed %s type: %s", rI, tC.message),
                        zQ(null)))
                  }
              }
            }
            function ZC(iA) {
              if (iA) {
                var vA = iA._owner,
                  rI = aB(iA.type, iA._source, vA ? vA.type : null)
                X(rI)
              } else X(null)
            }
            var Ui
            Ui = !1
            function $o() {
              if (j.current) {
                var iA = SI(j.current.type)
                if (iA)
                  return (
                    `

Check the render method of \`` +
                    iA +
                    "`."
                  )
              }
              return ""
            }
            function oC(iA) {
              if (iA !== void 0) {
                var vA = iA.fileName.replace(/^.*[\\\/]/, ""),
                  rI = iA.lineNumber
                return (
                  `

Check your code at ` +
                  vA +
                  ":" +
                  rI +
                  "."
                )
              }
              return ""
            }
            function RQ(iA) {
              return iA != null ? oC(iA.__source) : ""
            }
            var Te = {}
            function hC(iA) {
              var vA = $o()
              if (!vA) {
                var rI = typeof iA == "string" ? iA : iA.displayName || iA.name
                rI &&
                  (vA =
                    `

Check the top-level render call using <` +
                    rI +
                    ">.")
              }
              return vA
            }
            function Vt(iA, vA) {
              if (!(!iA._store || iA._store.validated || iA.key != null)) {
                iA._store.validated = !0
                var rI = hC(vA)
                if (!Te[rI]) {
                  Te[rI] = !0
                  var mI = ""
                  ;(iA &&
                    iA._owner &&
                    iA._owner !== j.current &&
                    (mI = " It was passed a child from " + SI(iA._owner.type) + "."),
                    ZC(iA),
                    LA(
                      'Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.',
                      rI,
                      mI,
                    ),
                    ZC(null))
                }
              }
            }
            function wt(iA, vA) {
              if (typeof iA == "object") {
                if (eI(iA))
                  for (var rI = 0; rI < iA.length; rI++) {
                    var mI = iA[rI]
                    VA(mI) && Vt(mI, vA)
                  }
                else if (VA(iA)) iA._store && (iA._store.validated = !0)
                else if (iA) {
                  var ig = L(iA)
                  if (typeof ig == "function" && ig !== iA.entries)
                    for (var AC = ig.call(iA), pg; !(pg = AC.next()).done; )
                      VA(pg.value) && Vt(pg.value, vA)
                }
              }
            }
            function di(iA) {
              {
                var vA = iA.type
                if (vA == null || typeof vA == "string") return
                var rI
                if (typeof vA == "function") rI = vA.propTypes
                else if (
                  typeof vA == "object" &&
                  (vA.$$typeof === h || // Note: Memo only checks outer props here.
                    // Inner props are checked in the reconciler.
                    vA.$$typeof === w)
                )
                  rI = vA.propTypes
                else return
                if (rI) {
                  var mI = SI(vA)
                  Wt(rI, iA.props, "prop", mI, iA)
                } else if (vA.PropTypes !== void 0 && !Ui) {
                  Ui = !0
                  var ig = SI(vA)
                  LA(
                    "Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?",
                    ig || "Unknown",
                  )
                }
                typeof vA.getDefaultProps == "function" &&
                  !vA.getDefaultProps.isReactClassApproved &&
                  LA(
                    "getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.",
                  )
              }
            }
            function Me(iA) {
              {
                for (var vA = Object.keys(iA.props), rI = 0; rI < vA.length; rI++) {
                  var mI = vA[rI]
                  if (mI !== "children" && mI !== "key") {
                    ;(ZC(iA),
                      LA(
                        "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                        mI,
                      ),
                      ZC(null))
                    break
                  }
                }
                iA.ref !== null &&
                  (ZC(iA), LA("Invalid attribute `ref` supplied to `React.Fragment`."), ZC(null))
              }
            }
            function Ha(iA, vA, rI) {
              var mI = mA(iA)
              if (!mI) {
                var ig = ""
                ;(iA === void 0 ||
                  (typeof iA == "object" && iA !== null && Object.keys(iA).length === 0)) &&
                  (ig +=
                    " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.")
                var AC = RQ(vA)
                AC ? (ig += AC) : (ig += $o())
                var pg
                ;(iA === null
                  ? (pg = "null")
                  : eI(iA)
                    ? (pg = "array")
                    : iA !== void 0 && iA.$$typeof === g
                      ? ((pg = "<" + (SI(iA.type) || "Unknown") + " />"),
                        (ig = " Did you accidentally export a JSX literal instead of a component?"))
                      : (pg = typeof iA),
                  LA(
                    "React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",
                    pg,
                    ig,
                  ))
              }
              var tC = OA.apply(this, arguments)
              if (tC == null) return tC
              if (mI) for (var BC = 2; BC < arguments.length; BC++) wt(arguments[BC], iA)
              return (iA === i ? Me(tC) : di(tC), tC)
            }
            var ee = !1
            function Zi(iA) {
              var vA = Ha.bind(null, iA)
              return (
                (vA.type = iA),
                ee ||
                  ((ee = !0),
                  yA(
                    "React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.",
                  )),
                Object.defineProperty(vA, "type", {
                  enumerable: !1,
                  get: function () {
                    return (
                      yA(
                        "Factory.type is deprecated. Access the class directly before passing it to createFactory.",
                      ),
                      Object.defineProperty(this, "type", {
                        value: iA,
                      }),
                      iA
                    )
                  },
                }),
                vA
              )
            }
            function XQ(iA, vA, rI) {
              for (var mI = RI.apply(this, arguments), ig = 2; ig < arguments.length; ig++)
                wt(arguments[ig], mI.type)
              return (di(mI), mI)
            }
            function rB(iA, vA) {
              var rI = H.transition
              H.transition = {}
              var mI = H.transition
              H.transition._updatedFibers = /* @__PURE__ */ new Set()
              try {
                iA()
              } finally {
                if (((H.transition = rI), rI === null && mI._updatedFibers)) {
                  var ig = mI._updatedFibers.size
                  ;(ig > 10 &&
                    yA(
                      "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.",
                    ),
                    mI._updatedFibers.clear())
                }
              }
            }
            var $Q = !1,
              JQ = null
            function HB(iA) {
              if (JQ === null)
                try {
                  var vA = ("require" + Math.random()).slice(0, 7),
                    rI = e && e[vA]
                  JQ = rI.call(e, "timers").setImmediate
                } catch {
                  JQ = function (ig) {
                    $Q === !1 &&
                      (($Q = !0),
                      typeof MessageChannel > "u" &&
                        LA(
                          "This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.",
                        ))
                    var AC = new MessageChannel()
                    ;((AC.port1.onmessage = ig), AC.port2.postMessage(void 0))
                  }
                }
              return JQ(iA)
            }
            var TB = 0,
              An = !1
            function Gt(iA) {
              {
                var vA = TB
                ;(TB++, V.current === null && (V.current = []))
                var rI = V.isBatchingLegacy,
                  mI
                try {
                  if (((V.isBatchingLegacy = !0), (mI = iA()), !rI && V.didScheduleLegacyUpdate)) {
                    var ig = V.current
                    ig !== null && ((V.didScheduleLegacyUpdate = !1), Ao(ig))
                  }
                } catch (ie) {
                  throw (Ni(vA), ie)
                } finally {
                  V.isBatchingLegacy = rI
                }
                if (mI !== null && typeof mI == "object" && typeof mI.then == "function") {
                  var AC = mI,
                    pg = !1,
                    tC = {
                      then: function (ie, we) {
                        ;((pg = !0),
                          AC.then(
                            function (le) {
                              ;(Ni(vA), TB === 0 ? QQ(le, ie, we) : ie(le))
                            },
                            function (le) {
                              ;(Ni(vA), we(le))
                            },
                          ))
                      },
                    }
                  return (
                    !An &&
                      typeof Promise < "u" &&
                      Promise.resolve()
                        .then(function () {})
                        .then(function () {
                          pg ||
                            ((An = !0),
                            LA(
                              "You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);",
                            ))
                        }),
                    tC
                  )
                } else {
                  var BC = mI
                  if ((Ni(vA), TB === 0)) {
                    var NC = V.current
                    NC !== null && (Ao(NC), (V.current = null))
                    var KC = {
                      then: function (ie, we) {
                        V.current === null ? ((V.current = []), QQ(BC, ie, we)) : ie(BC)
                      },
                    }
                    return KC
                  } else {
                    var GC = {
                      then: function (ie, we) {
                        ie(BC)
                      },
                    }
                    return GC
                  }
                }
              }
            }
            function Ni(iA) {
              ;(iA !== TB - 1 &&
                LA(
                  "You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ",
                ),
                (TB = iA))
            }
            function QQ(iA, vA, rI) {
              {
                var mI = V.current
                if (mI !== null)
                  try {
                    ;(Ao(mI),
                      HB(function () {
                        mI.length === 0 ? ((V.current = null), vA(iA)) : QQ(iA, vA, rI)
                      }))
                  } catch (ig) {
                    rI(ig)
                  }
                else vA(iA)
              }
            }
            var jt = !1
            function Ao(iA) {
              if (!jt) {
                jt = !0
                var vA = 0
                try {
                  for (; vA < iA.length; vA++) {
                    var rI = iA[vA]
                    do rI = rI(!0)
                    while (rI !== null)
                  }
                  iA.length = 0
                } catch (mI) {
                  throw ((iA = iA.slice(vA + 1)), mI)
                } finally {
                  jt = !1
                }
              }
            }
            var In = Ha,
              zt = XQ,
              gn = Zi,
              yB = {
                map: qI,
                forEach: $g,
                count: dg,
                toArray: Qg,
                only: Fg,
              }
            ;((A.Children = yB),
              (A.Component = DA),
              (A.Fragment = i),
              (A.Profiler = o),
              (A.PureComponent = ZA),
              (A.StrictMode = B),
              (A.Suspense = S),
              (A.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = JA),
              (A.act = Gt),
              (A.cloneElement = zt),
              (A.createContext = jC),
              (A.createElement = In),
              (A.createFactory = gn),
              (A.createRef = cI),
              (A.forwardRef = vi),
              (A.isValidElement = VA),
              (A.lazy = Ei),
              (A.memo = TI),
              (A.startTransition = rB),
              (A.unstable_act = Gt),
              (A.useCallback = QI),
              (A.useContext = Tg),
              (A.useDebugValue = EI),
              (A.useDeferredValue = yg),
              (A.useEffect = rA),
              (A.useId = rg),
              (A.useImperativeHandle = gg),
              (A.useInsertionEffect = _A),
              (A.useLayoutEffect = oI),
              (A.useMemo = PA),
              (A.useReducer = JC),
              (A.useRef = jg),
              (A.useState = OC),
              (A.useSyncExternalStore = eC),
              (A.useTransition = hg),
              (A.version = I),
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" &&
                typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" &&
                __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error()))
          })()
      })(b0, b0.exports)),
    b0.exports
  )
}
var fq
function Pf() {
  return (
    fq ||
      ((fq = 1), process.env.NODE_ENV === "production" ? (NM.exports = I1()) : (NM.exports = g1())),
    NM.exports
  )
}
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dq
function C1() {
  if (dq) return p0
  dq = 1
  var e = Pf(),
    A = Symbol.for("react.element"),
    I = Symbol.for("react.fragment"),
    g = Object.prototype.hasOwnProperty,
    C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    i = { key: !0, ref: !0, __self: !0, __source: !0 }
  function B(o, r, s) {
    var h,
      S = {},
      d = null,
      w = null
    ;(s !== void 0 && (d = "" + s),
      r.key !== void 0 && (d = "" + r.key),
      r.ref !== void 0 && (w = r.ref))
    for (h in r) g.call(r, h) && !i.hasOwnProperty(h) && (S[h] = r[h])
    if (o && o.defaultProps) for (h in ((r = o.defaultProps), r)) S[h] === void 0 && (S[h] = r[h])
    return { $$typeof: A, type: o, key: d, ref: w, props: S, _owner: C.current }
  }
  return ((p0.Fragment = I), (p0.jsx = B), (p0.jsxs = B), p0)
}
var w0 = {}
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yq
function e1() {
  return (
    yq ||
      ((yq = 1),
      process.env.NODE_ENV !== "production" &&
        (function () {
          var e = Pf(),
            A = Symbol.for("react.element"),
            I = Symbol.for("react.portal"),
            g = Symbol.for("react.fragment"),
            C = Symbol.for("react.strict_mode"),
            i = Symbol.for("react.profiler"),
            B = Symbol.for("react.provider"),
            o = Symbol.for("react.context"),
            r = Symbol.for("react.forward_ref"),
            s = Symbol.for("react.suspense"),
            h = Symbol.for("react.suspense_list"),
            S = Symbol.for("react.memo"),
            d = Symbol.for("react.lazy"),
            w = Symbol.for("react.offscreen"),
            M = Symbol.iterator,
            K = "@@iterator"
          function R(mA) {
            if (mA === null || typeof mA != "object") return null
            var TI = (M && mA[M]) || mA[K]
            return typeof TI == "function" ? TI : null
          }
          var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
          function L(mA) {
            {
              for (
                var TI = arguments.length, eg = new Array(TI > 1 ? TI - 1 : 0), Tg = 1;
                Tg < TI;
                Tg++
              )
                eg[Tg - 1] = arguments[Tg]
              Y("error", mA, eg)
            }
          }
          function Y(mA, TI, eg) {
            {
              var Tg = F.ReactDebugCurrentFrame,
                OC = Tg.getStackAddendum()
              OC !== "" && ((TI += "%s"), (eg = eg.concat([OC])))
              var JC = eg.map(function (jg) {
                return String(jg)
              })
              ;(JC.unshift("Warning: " + TI),
                Function.prototype.apply.call(console[mA], console, JC))
            }
          }
          var H = !1,
            V = !1,
            j = !1,
            P = !1,
            AA = !1,
            X
          X = Symbol.for("react.module.reference")
          function _(mA) {
            return !!(
              typeof mA == "string" ||
              typeof mA == "function" ||
              mA === g ||
              mA === i ||
              AA ||
              mA === C ||
              mA === s ||
              mA === h ||
              P ||
              mA === w ||
              H ||
              V ||
              j ||
              (typeof mA == "object" &&
                mA !== null &&
                (mA.$$typeof === d ||
                  mA.$$typeof === S ||
                  mA.$$typeof === B ||
                  mA.$$typeof === o ||
                  mA.$$typeof === r || // This needs to include all possible module reference object
                  // types supported by any Flight configuration anywhere since
                  // we don't know which Flight build this will end up being used
                  // with.
                  mA.$$typeof === X ||
                  mA.getModuleId !== void 0))
            )
          }
          function eA(mA, TI, eg) {
            var Tg = mA.displayName
            if (Tg) return Tg
            var OC = TI.displayName || TI.name || ""
            return OC !== "" ? eg + "(" + OC + ")" : eg
          }
          function CA(mA) {
            return mA.displayName || "Context"
          }
          function aA(mA) {
            if (mA == null) return null
            if (
              (typeof mA.tag == "number" &&
                L(
                  "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.",
                ),
              typeof mA == "function")
            )
              return mA.displayName || mA.name || null
            if (typeof mA == "string") return mA
            switch (mA) {
              case g:
                return "Fragment"
              case I:
                return "Portal"
              case i:
                return "Profiler"
              case C:
                return "StrictMode"
              case s:
                return "Suspense"
              case h:
                return "SuspenseList"
            }
            if (typeof mA == "object")
              switch (mA.$$typeof) {
                case o:
                  var TI = mA
                  return CA(TI) + ".Consumer"
                case B:
                  var eg = mA
                  return CA(eg._context) + ".Provider"
                case r:
                  return eA(mA, mA.render, "ForwardRef")
                case S:
                  var Tg = mA.displayName || null
                  return Tg !== null ? Tg : aA(mA.type) || "Memo"
                case d: {
                  var OC = mA,
                    JC = OC._payload,
                    jg = OC._init
                  try {
                    return aA(jg(JC))
                  } catch {
                    return null
                  }
                }
              }
            return null
          }
          var lA = Object.assign,
            JA = 0,
            yA,
            LA,
            nA,
            fA,
            sA,
            $,
            EA
          function GA() {}
          GA.__reactDisabledLog = !0
          function DA() {
            {
              if (JA === 0) {
                ;((yA = console.log),
                  (LA = console.info),
                  (nA = console.warn),
                  (fA = console.error),
                  (sA = console.group),
                  ($ = console.groupCollapsed),
                  (EA = console.groupEnd))
                var mA = {
                  configurable: !0,
                  enumerable: !0,
                  value: GA,
                  writable: !0,
                }
                Object.defineProperties(console, {
                  info: mA,
                  log: mA,
                  warn: mA,
                  error: mA,
                  group: mA,
                  groupCollapsed: mA,
                  groupEnd: mA,
                })
              }
              JA++
            }
          }
          function dA() {
            {
              if ((JA--, JA === 0)) {
                var mA = {
                  configurable: !0,
                  enumerable: !0,
                  writable: !0,
                }
                Object.defineProperties(console, {
                  log: lA({}, mA, {
                    value: yA,
                  }),
                  info: lA({}, mA, {
                    value: LA,
                  }),
                  warn: lA({}, mA, {
                    value: nA,
                  }),
                  error: lA({}, mA, {
                    value: fA,
                  }),
                  group: lA({}, mA, {
                    value: sA,
                  }),
                  groupCollapsed: lA({}, mA, {
                    value: $,
                  }),
                  groupEnd: lA({}, mA, {
                    value: EA,
                  }),
                })
              }
              JA < 0 &&
                L("disabledDepth fell below zero. This is a bug in React. Please file an issue.")
            }
          }
          var kA = F.ReactCurrentDispatcher,
            NA
          function qA(mA, TI, eg) {
            {
              if (NA === void 0)
                try {
                  throw Error()
                } catch (OC) {
                  var Tg = OC.stack.trim().match(/\n( *(at )?)/)
                  NA = (Tg && Tg[1]) || ""
                }
              return (
                `
` +
                NA +
                mA
              )
            }
          }
          var ZA = !1,
            sI
          {
            var cI = typeof WeakMap == "function" ? WeakMap : Map
            sI = new cI()
          }
          function YA(mA, TI) {
            if (!mA || ZA) return ""
            {
              var eg = sI.get(mA)
              if (eg !== void 0) return eg
            }
            var Tg
            ZA = !0
            var OC = Error.prepareStackTrace
            Error.prepareStackTrace = void 0
            var JC
            ;((JC = kA.current), (kA.current = null), DA())
            try {
              if (TI) {
                var jg = function () {
                  throw Error()
                }
                if (
                  (Object.defineProperty(jg.prototype, "props", {
                    set: function () {
                      throw Error()
                    },
                  }),
                  typeof Reflect == "object" && Reflect.construct)
                ) {
                  try {
                    Reflect.construct(jg, [])
                  } catch (hg) {
                    Tg = hg
                  }
                  Reflect.construct(mA, [], jg)
                } else {
                  try {
                    jg.call()
                  } catch (hg) {
                    Tg = hg
                  }
                  mA.call(jg.prototype)
                }
              } else {
                try {
                  throw Error()
                } catch (hg) {
                  Tg = hg
                }
                mA()
              }
            } catch (hg) {
              if (hg && Tg && typeof hg.stack == "string") {
                for (
                  var rA = hg.stack.split(`
`),
                    _A = Tg.stack.split(`
`),
                    oI = rA.length - 1,
                    QI = _A.length - 1;
                  oI >= 1 && QI >= 0 && rA[oI] !== _A[QI];
                )
                  QI--
                for (; oI >= 1 && QI >= 0; oI--, QI--)
                  if (rA[oI] !== _A[QI]) {
                    if (oI !== 1 || QI !== 1)
                      do
                        if ((oI--, QI--, QI < 0 || rA[oI] !== _A[QI])) {
                          var PA =
                            `
` + rA[oI].replace(" at new ", " at ")
                          return (
                            mA.displayName &&
                              PA.includes("<anonymous>") &&
                              (PA = PA.replace("<anonymous>", mA.displayName)),
                            typeof mA == "function" && sI.set(mA, PA),
                            PA
                          )
                        }
                      while (oI >= 1 && QI >= 0)
                    break
                  }
              }
            } finally {
              ;((ZA = !1), (kA.current = JC), dA(), (Error.prepareStackTrace = OC))
            }
            var gg = mA ? mA.displayName || mA.name : "",
              EI = gg ? qA(gg) : ""
            return (typeof mA == "function" && sI.set(mA, EI), EI)
          }
          function eI(mA, TI, eg) {
            return YA(mA, !1)
          }
          function uA(mA) {
            var TI = mA.prototype
            return !!(TI && TI.isReactComponent)
          }
          function hI(mA, TI, eg) {
            if (mA == null) return ""
            if (typeof mA == "function") return YA(mA, uA(mA))
            if (typeof mA == "string") return qA(mA)
            switch (mA) {
              case s:
                return qA("Suspense")
              case h:
                return qA("SuspenseList")
            }
            if (typeof mA == "object")
              switch (mA.$$typeof) {
                case r:
                  return eI(mA.render)
                case S:
                  return hI(mA.type, TI, eg)
                case d: {
                  var Tg = mA,
                    OC = Tg._payload,
                    JC = Tg._init
                  try {
                    return hI(JC(OC), TI, eg)
                  } catch {}
                }
              }
            return ""
          }
          var II = Object.prototype.hasOwnProperty,
            pI = {},
            AI = F.ReactDebugCurrentFrame
          function YI(mA) {
            if (mA) {
              var TI = mA._owner,
                eg = hI(mA.type, mA._source, TI ? TI.type : null)
              AI.setExtraStackFrame(eg)
            } else AI.setExtraStackFrame(null)
          }
          function SI(mA, TI, eg, Tg, OC) {
            {
              var JC = Function.call.bind(II)
              for (var jg in mA)
                if (JC(mA, jg)) {
                  var rA = void 0
                  try {
                    if (typeof mA[jg] != "function") {
                      var _A = Error(
                        (Tg || "React class") +
                          ": " +
                          eg +
                          " type `" +
                          jg +
                          "` is invalid; it must be a function, usually from the `prop-types` package, but received `" +
                          typeof mA[jg] +
                          "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.",
                      )
                      throw ((_A.name = "Invariant Violation"), _A)
                    }
                    rA = mA[jg](
                      TI,
                      jg,
                      Tg,
                      eg,
                      null,
                      "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
                    )
                  } catch (oI) {
                    rA = oI
                  }
                  ;(rA &&
                    !(rA instanceof Error) &&
                    (YI(OC),
                    L(
                      "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",
                      Tg || "React class",
                      eg,
                      jg,
                      typeof rA,
                    ),
                    YI(null)),
                    rA instanceof Error &&
                      !(rA.message in pI) &&
                      ((pI[rA.message] = !0),
                      YI(OC),
                      L("Failed %s type: %s", eg, rA.message),
                      YI(null)))
                }
            }
          }
          var QA = Array.isArray
          function tA(mA) {
            return QA(mA)
          }
          function FA(mA) {
            {
              var TI = typeof Symbol == "function" && Symbol.toStringTag,
                eg = (TI && mA[Symbol.toStringTag]) || mA.constructor.name || "Object"
              return eg
            }
          }
          function WA(mA) {
            try {
              return (jA(mA), !1)
            } catch {
              return !0
            }
          }
          function jA(mA) {
            return "" + mA
          }
          function nI(mA) {
            if (WA(mA))
              return (
                L(
                  "The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.",
                  FA(mA),
                ),
                jA(mA)
              )
          }
          var UI = F.ReactCurrentOwner,
            GI = {
              key: !0,
              ref: !0,
              __self: !0,
              __source: !0,
            },
            LI,
            Bg,
            MA
          MA = {}
          function OA(mA) {
            if (II.call(mA, "ref")) {
              var TI = Object.getOwnPropertyDescriptor(mA, "ref").get
              if (TI && TI.isReactWarning) return !1
            }
            return mA.ref !== void 0
          }
          function aI(mA) {
            if (II.call(mA, "key")) {
              var TI = Object.getOwnPropertyDescriptor(mA, "key").get
              if (TI && TI.isReactWarning) return !1
            }
            return mA.key !== void 0
          }
          function RI(mA, TI) {
            if (typeof mA.ref == "string" && UI.current && TI && UI.current.stateNode !== TI) {
              var eg = aA(UI.current.type)
              MA[eg] ||
                (L(
                  'Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref',
                  aA(UI.current.type),
                  mA.ref,
                ),
                (MA[eg] = !0))
            }
          }
          function VA(mA, TI) {
            {
              var eg = function () {
                LI ||
                  ((LI = !0),
                  L(
                    "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)",
                    TI,
                  ))
              }
              ;((eg.isReactWarning = !0),
                Object.defineProperty(mA, "key", {
                  get: eg,
                  configurable: !0,
                }))
            }
          }
          function ag(mA, TI) {
            {
              var eg = function () {
                Bg ||
                  ((Bg = !0),
                  L(
                    "%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)",
                    TI,
                  ))
              }
              ;((eg.isReactWarning = !0),
                Object.defineProperty(mA, "ref", {
                  get: eg,
                  configurable: !0,
                }))
            }
          }
          var XI = function (mA, TI, eg, Tg, OC, JC, jg) {
            var rA = {
              // This tag allows us to uniquely identify this as a React Element
              $$typeof: A,
              // Built-in properties that belong on the element
              type: mA,
              key: TI,
              ref: eg,
              props: jg,
              // Record the component responsible for creating this element.
              _owner: JC,
            }
            return (
              (rA._store = {}),
              Object.defineProperty(rA._store, "validated", {
                configurable: !1,
                enumerable: !1,
                writable: !0,
                value: !1,
              }),
              Object.defineProperty(rA, "_self", {
                configurable: !1,
                enumerable: !1,
                writable: !1,
                value: Tg,
              }),
              Object.defineProperty(rA, "_source", {
                configurable: !1,
                enumerable: !1,
                writable: !1,
                value: OC,
              }),
              Object.freeze && (Object.freeze(rA.props), Object.freeze(rA)),
              rA
            )
          }
          function $I(mA, TI, eg, Tg, OC) {
            {
              var JC,
                jg = {},
                rA = null,
                _A = null
              ;(eg !== void 0 && (nI(eg), (rA = "" + eg)),
                aI(TI) && (nI(TI.key), (rA = "" + TI.key)),
                OA(TI) && ((_A = TI.ref), RI(TI, OC)))
              for (JC in TI) II.call(TI, JC) && !GI.hasOwnProperty(JC) && (jg[JC] = TI[JC])
              if (mA && mA.defaultProps) {
                var oI = mA.defaultProps
                for (JC in oI) jg[JC] === void 0 && (jg[JC] = oI[JC])
              }
              if (rA || _A) {
                var QI = typeof mA == "function" ? mA.displayName || mA.name || "Unknown" : mA
                ;(rA && VA(jg, QI), _A && ag(jg, QI))
              }
              return XI(mA, rA, _A, OC, Tg, UI.current, jg)
            }
          }
          var SA = F.ReactCurrentOwner,
            NI = F.ReactDebugCurrentFrame
          function HA(mA) {
            if (mA) {
              var TI = mA._owner,
                eg = hI(mA.type, mA._source, TI ? TI.type : null)
              NI.setExtraStackFrame(eg)
            } else NI.setExtraStackFrame(null)
          }
          var iI
          iI = !1
          function zI(mA) {
            return typeof mA == "object" && mA !== null && mA.$$typeof === A
          }
          function qI() {
            {
              if (SA.current) {
                var mA = aA(SA.current.type)
                if (mA)
                  return (
                    `

Check the render method of \`` +
                    mA +
                    "`."
                  )
              }
              return ""
            }
          }
          function dg(mA) {
            return ""
          }
          var $g = {}
          function Qg(mA) {
            {
              var TI = qI()
              if (!TI) {
                var eg = typeof mA == "string" ? mA : mA.displayName || mA.name
                eg &&
                  (TI =
                    `

Check the top-level render call using <` +
                    eg +
                    ">.")
              }
              return TI
            }
          }
          function Fg(mA, TI) {
            {
              if (!mA._store || mA._store.validated || mA.key != null) return
              mA._store.validated = !0
              var eg = Qg(TI)
              if ($g[eg]) return
              $g[eg] = !0
              var Tg = ""
              ;(mA &&
                mA._owner &&
                mA._owner !== SA.current &&
                (Tg = " It was passed a child from " + aA(mA._owner.type) + "."),
                HA(mA),
                L(
                  'Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.',
                  eg,
                  Tg,
                ),
                HA(null))
            }
          }
          function jC(mA, TI) {
            {
              if (typeof mA != "object") return
              if (tA(mA))
                for (var eg = 0; eg < mA.length; eg++) {
                  var Tg = mA[eg]
                  zI(Tg) && Fg(Tg, TI)
                }
              else if (zI(mA)) mA._store && (mA._store.validated = !0)
              else if (mA) {
                var OC = R(mA)
                if (typeof OC == "function" && OC !== mA.entries)
                  for (var JC = OC.call(mA), jg; !(jg = JC.next()).done; )
                    zI(jg.value) && Fg(jg.value, TI)
              }
            }
          }
          function mC(mA) {
            {
              var TI = mA.type
              if (TI == null || typeof TI == "string") return
              var eg
              if (typeof TI == "function") eg = TI.propTypes
              else if (
                typeof TI == "object" &&
                (TI.$$typeof === r || // Note: Memo only checks outer props here.
                  // Inner props are checked in the reconciler.
                  TI.$$typeof === S)
              )
                eg = TI.propTypes
              else return
              if (eg) {
                var Tg = aA(TI)
                SI(eg, mA.props, "prop", Tg, mA)
              } else if (TI.PropTypes !== void 0 && !iI) {
                iI = !0
                var OC = aA(TI)
                L(
                  "Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?",
                  OC || "Unknown",
                )
              }
              typeof TI.getDefaultProps == "function" &&
                !TI.getDefaultProps.isReactClassApproved &&
                L(
                  "getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.",
                )
            }
          }
          function zC(mA) {
            {
              for (var TI = Object.keys(mA.props), eg = 0; eg < TI.length; eg++) {
                var Tg = TI[eg]
                if (Tg !== "children" && Tg !== "key") {
                  ;(HA(mA),
                    L(
                      "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                      Tg,
                    ),
                    HA(null))
                  break
                }
              }
              mA.ref !== null &&
                (HA(mA), L("Invalid attribute `ref` supplied to `React.Fragment`."), HA(null))
            }
          }
          var Ee = {}
          function ei(mA, TI, eg, Tg, OC, JC) {
            {
              var jg = _(mA)
              if (!jg) {
                var rA = ""
                ;(mA === void 0 ||
                  (typeof mA == "object" && mA !== null && Object.keys(mA).length === 0)) &&
                  (rA +=
                    " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.")
                var _A = dg()
                _A ? (rA += _A) : (rA += qI())
                var oI
                ;(mA === null
                  ? (oI = "null")
                  : tA(mA)
                    ? (oI = "array")
                    : mA !== void 0 && mA.$$typeof === A
                      ? ((oI = "<" + (aA(mA.type) || "Unknown") + " />"),
                        (rA = " Did you accidentally export a JSX literal instead of a component?"))
                      : (oI = typeof mA),
                  L(
                    "React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",
                    oI,
                    rA,
                  ))
              }
              var QI = $I(mA, TI, eg, OC, JC)
              if (QI == null) return QI
              if (jg) {
                var PA = TI.children
                if (PA !== void 0)
                  if (Tg)
                    if (tA(PA)) {
                      for (var gg = 0; gg < PA.length; gg++) jC(PA[gg], mA)
                      Object.freeze && Object.freeze(PA)
                    } else
                      L(
                        "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.",
                      )
                  else jC(PA, mA)
              }
              if (II.call(TI, "key")) {
                var EI = aA(mA),
                  hg = Object.keys(TI).filter(function (eC) {
                    return eC !== "key"
                  }),
                  yg =
                    hg.length > 0
                      ? "{key: someKey, " + hg.join(": ..., ") + ": ...}"
                      : "{key: someKey}"
                if (!Ee[EI + yg]) {
                  var rg = hg.length > 0 ? "{" + hg.join(": ..., ") + ": ...}" : "{}"
                  ;(L(
                    `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
                    yg,
                    EI,
                    rg,
                    EI,
                  ),
                    (Ee[EI + yg] = !0))
                }
              }
              return (mA === g ? zC(QI) : mC(QI), QI)
            }
          }
          function fe(mA, TI, eg) {
            return ei(mA, TI, eg, !0)
          }
          function Ei(mA, TI, eg) {
            return ei(mA, TI, eg, !1)
          }
          var vi = Ei,
            Li = fe
          ;((w0.Fragment = g), (w0.jsx = vi), (w0.jsxs = Li))
        })()),
    w0
  )
}
var pq
function i1() {
  return (
    pq ||
      ((pq = 1), process.env.NODE_ENV === "production" ? (UM.exports = C1()) : (UM.exports = e1())),
    UM.exports
  )
}
var qC = i1(),
  My = {},
  FM = { exports: {} },
  Ra = {},
  RM = { exports: {} },
  ZJ = {}
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wq
function t1() {
  return (
    wq ||
      ((wq = 1),
      (function (e) {
        function A(nA, fA) {
          var sA = nA.length
          nA.push(fA)
          A: for (; 0 < sA; ) {
            var $ = (sA - 1) >>> 1,
              EA = nA[$]
            if (0 < C(EA, fA)) ((nA[$] = fA), (nA[sA] = EA), (sA = $))
            else break A
          }
        }
        function I(nA) {
          return nA.length === 0 ? null : nA[0]
        }
        function g(nA) {
          if (nA.length === 0) return null
          var fA = nA[0],
            sA = nA.pop()
          if (sA !== fA) {
            nA[0] = sA
            A: for (var $ = 0, EA = nA.length, GA = EA >>> 1; $ < GA; ) {
              var DA = 2 * ($ + 1) - 1,
                dA = nA[DA],
                kA = DA + 1,
                NA = nA[kA]
              if (0 > C(dA, sA))
                kA < EA && 0 > C(NA, dA)
                  ? ((nA[$] = NA), (nA[kA] = sA), ($ = kA))
                  : ((nA[$] = dA), (nA[DA] = sA), ($ = DA))
              else if (kA < EA && 0 > C(NA, sA)) ((nA[$] = NA), (nA[kA] = sA), ($ = kA))
              else break A
            }
          }
          return fA
        }
        function C(nA, fA) {
          var sA = nA.sortIndex - fA.sortIndex
          return sA !== 0 ? sA : nA.id - fA.id
        }
        if (typeof performance == "object" && typeof performance.now == "function") {
          var i = performance
          e.unstable_now = function () {
            return i.now()
          }
        } else {
          var B = Date,
            o = B.now()
          e.unstable_now = function () {
            return B.now() - o
          }
        }
        var r = [],
          s = [],
          h = 1,
          S = null,
          d = 3,
          w = !1,
          M = !1,
          K = !1,
          R = typeof setTimeout == "function" ? setTimeout : null,
          F = typeof clearTimeout == "function" ? clearTimeout : null,
          L = typeof setImmediate < "u" ? setImmediate : null
        typeof navigator < "u" &&
          navigator.scheduling !== void 0 &&
          navigator.scheduling.isInputPending !== void 0 &&
          navigator.scheduling.isInputPending.bind(navigator.scheduling)
        function Y(nA) {
          for (var fA = I(s); fA !== null; ) {
            if (fA.callback === null) g(s)
            else if (fA.startTime <= nA) (g(s), (fA.sortIndex = fA.expirationTime), A(r, fA))
            else break
            fA = I(s)
          }
        }
        function H(nA) {
          if (((K = !1), Y(nA), !M))
            if (I(r) !== null) ((M = !0), yA(V))
            else {
              var fA = I(s)
              fA !== null && LA(H, fA.startTime - nA)
            }
        }
        function V(nA, fA) {
          ;((M = !1), K && ((K = !1), F(AA), (AA = -1)), (w = !0))
          var sA = d
          try {
            for (Y(fA), S = I(r); S !== null && (!(S.expirationTime > fA) || (nA && !eA())); ) {
              var $ = S.callback
              if (typeof $ == "function") {
                ;((S.callback = null), (d = S.priorityLevel))
                var EA = $(S.expirationTime <= fA)
                ;((fA = e.unstable_now()),
                  typeof EA == "function" ? (S.callback = EA) : S === I(r) && g(r),
                  Y(fA))
              } else g(r)
              S = I(r)
            }
            if (S !== null) var GA = !0
            else {
              var DA = I(s)
              ;(DA !== null && LA(H, DA.startTime - fA), (GA = !1))
            }
            return GA
          } finally {
            ;((S = null), (d = sA), (w = !1))
          }
        }
        var j = !1,
          P = null,
          AA = -1,
          X = 5,
          _ = -1
        function eA() {
          return !(e.unstable_now() - _ < X)
        }
        function CA() {
          if (P !== null) {
            var nA = e.unstable_now()
            _ = nA
            var fA = !0
            try {
              fA = P(!0, nA)
            } finally {
              fA ? aA() : ((j = !1), (P = null))
            }
          } else j = !1
        }
        var aA
        if (typeof L == "function")
          aA = function () {
            L(CA)
          }
        else if (typeof MessageChannel < "u") {
          var lA = new MessageChannel(),
            JA = lA.port2
          ;((lA.port1.onmessage = CA),
            (aA = function () {
              JA.postMessage(null)
            }))
        } else
          aA = function () {
            R(CA, 0)
          }
        function yA(nA) {
          ;((P = nA), j || ((j = !0), aA()))
        }
        function LA(nA, fA) {
          AA = R(function () {
            nA(e.unstable_now())
          }, fA)
        }
        ;((e.unstable_IdlePriority = 5),
          (e.unstable_ImmediatePriority = 1),
          (e.unstable_LowPriority = 4),
          (e.unstable_NormalPriority = 3),
          (e.unstable_Profiling = null),
          (e.unstable_UserBlockingPriority = 2),
          (e.unstable_cancelCallback = function (nA) {
            nA.callback = null
          }),
          (e.unstable_continueExecution = function () {
            M || w || ((M = !0), yA(V))
          }),
          (e.unstable_forceFrameRate = function (nA) {
            0 > nA || 125 < nA
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
                )
              : (X = 0 < nA ? Math.floor(1e3 / nA) : 5)
          }),
          (e.unstable_getCurrentPriorityLevel = function () {
            return d
          }),
          (e.unstable_getFirstCallbackNode = function () {
            return I(r)
          }),
          (e.unstable_next = function (nA) {
            switch (d) {
              case 1:
              case 2:
              case 3:
                var fA = 3
                break
              default:
                fA = d
            }
            var sA = d
            d = fA
            try {
              return nA()
            } finally {
              d = sA
            }
          }),
          (e.unstable_pauseExecution = function () {}),
          (e.unstable_requestPaint = function () {}),
          (e.unstable_runWithPriority = function (nA, fA) {
            switch (nA) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break
              default:
                nA = 3
            }
            var sA = d
            d = nA
            try {
              return fA()
            } finally {
              d = sA
            }
          }),
          (e.unstable_scheduleCallback = function (nA, fA, sA) {
            var $ = e.unstable_now()
            switch (
              (typeof sA == "object" && sA !== null
                ? ((sA = sA.delay), (sA = typeof sA == "number" && 0 < sA ? $ + sA : $))
                : (sA = $),
              nA)
            ) {
              case 1:
                var EA = -1
                break
              case 2:
                EA = 250
                break
              case 5:
                EA = 1073741823
                break
              case 4:
                EA = 1e4
                break
              default:
                EA = 5e3
            }
            return (
              (EA = sA + EA),
              (nA = {
                id: h++,
                callback: fA,
                priorityLevel: nA,
                startTime: sA,
                expirationTime: EA,
                sortIndex: -1,
              }),
              sA > $
                ? ((nA.sortIndex = sA),
                  A(s, nA),
                  I(r) === null &&
                    nA === I(s) &&
                    (K ? (F(AA), (AA = -1)) : (K = !0), LA(H, sA - $)))
                : ((nA.sortIndex = EA), A(r, nA), M || w || ((M = !0), yA(V))),
              nA
            )
          }),
          (e.unstable_shouldYield = eA),
          (e.unstable_wrapCallback = function (nA) {
            var fA = d
            return function () {
              var sA = d
              d = fA
              try {
                return nA.apply(this, arguments)
              } finally {
                d = sA
              }
            }
          }))
      })(ZJ)),
    ZJ
  )
}
var PJ = {}
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gq
function B1() {
  return (
    Gq ||
      ((Gq = 1),
      (function (e) {
        process.env.NODE_ENV !== "production" &&
          (function () {
            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" &&
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" &&
              __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error())
            var A = !1,
              I = !1,
              g = 5
            function C(MA, OA) {
              var aI = MA.length
              ;(MA.push(OA), o(MA, OA, aI))
            }
            function i(MA) {
              return MA.length === 0 ? null : MA[0]
            }
            function B(MA) {
              if (MA.length === 0) return null
              var OA = MA[0],
                aI = MA.pop()
              return (aI !== OA && ((MA[0] = aI), r(MA, aI, 0)), OA)
            }
            function o(MA, OA, aI) {
              for (var RI = aI; RI > 0; ) {
                var VA = (RI - 1) >>> 1,
                  ag = MA[VA]
                if (s(ag, OA) > 0) ((MA[VA] = OA), (MA[RI] = ag), (RI = VA))
                else return
              }
            }
            function r(MA, OA, aI) {
              for (var RI = aI, VA = MA.length, ag = VA >>> 1; RI < ag; ) {
                var XI = (RI + 1) * 2 - 1,
                  $I = MA[XI],
                  SA = XI + 1,
                  NI = MA[SA]
                if (s($I, OA) < 0)
                  SA < VA && s(NI, $I) < 0
                    ? ((MA[RI] = NI), (MA[SA] = OA), (RI = SA))
                    : ((MA[RI] = $I), (MA[XI] = OA), (RI = XI))
                else if (SA < VA && s(NI, OA) < 0) ((MA[RI] = NI), (MA[SA] = OA), (RI = SA))
                else return
              }
            }
            function s(MA, OA) {
              var aI = MA.sortIndex - OA.sortIndex
              return aI !== 0 ? aI : MA.id - OA.id
            }
            var h = 1,
              S = 2,
              d = 3,
              w = 4,
              M = 5
            function K(MA, OA) {}
            var R = typeof performance == "object" && typeof performance.now == "function"
            if (R) {
              var F = performance
              e.unstable_now = function () {
                return F.now()
              }
            } else {
              var L = Date,
                Y = L.now()
              e.unstable_now = function () {
                return L.now() - Y
              }
            }
            var H = 1073741823,
              V = -1,
              j = 250,
              P = 5e3,
              AA = 1e4,
              X = H,
              _ = [],
              eA = [],
              CA = 1,
              aA = null,
              lA = d,
              JA = !1,
              yA = !1,
              LA = !1,
              nA = typeof setTimeout == "function" ? setTimeout : null,
              fA = typeof clearTimeout == "function" ? clearTimeout : null,
              sA = typeof setImmediate < "u" ? setImmediate : null
            typeof navigator < "u" &&
              navigator.scheduling !== void 0 &&
              navigator.scheduling.isInputPending !== void 0 &&
              navigator.scheduling.isInputPending.bind(navigator.scheduling)
            function $(MA) {
              for (var OA = i(eA); OA !== null; ) {
                if (OA.callback === null) B(eA)
                else if (OA.startTime <= MA) (B(eA), (OA.sortIndex = OA.expirationTime), C(_, OA))
                else return
                OA = i(eA)
              }
            }
            function EA(MA) {
              if (((LA = !1), $(MA), !yA))
                if (i(_) !== null) ((yA = !0), nI(GA))
                else {
                  var OA = i(eA)
                  OA !== null && UI(EA, OA.startTime - MA)
                }
            }
            function GA(MA, OA) {
              ;((yA = !1), LA && ((LA = !1), GI()), (JA = !0))
              var aI = lA
              try {
                var RI
                if (!I) return DA(MA, OA)
              } finally {
                ;((aA = null), (lA = aI), (JA = !1))
              }
            }
            function DA(MA, OA) {
              var aI = OA
              for (
                $(aI), aA = i(_);
                aA !== null && !A && !(aA.expirationTime > aI && (!MA || YI()));
              ) {
                var RI = aA.callback
                if (typeof RI == "function") {
                  ;((aA.callback = null), (lA = aA.priorityLevel))
                  var VA = aA.expirationTime <= aI,
                    ag = RI(VA)
                  ;((aI = e.unstable_now()),
                    typeof ag == "function" ? (aA.callback = ag) : aA === i(_) && B(_),
                    $(aI))
                } else B(_)
                aA = i(_)
              }
              if (aA !== null) return !0
              var XI = i(eA)
              return (XI !== null && UI(EA, XI.startTime - aI), !1)
            }
            function dA(MA, OA) {
              switch (MA) {
                case h:
                case S:
                case d:
                case w:
                case M:
                  break
                default:
                  MA = d
              }
              var aI = lA
              lA = MA
              try {
                return OA()
              } finally {
                lA = aI
              }
            }
            function kA(MA) {
              var OA
              switch (lA) {
                case h:
                case S:
                case d:
                  OA = d
                  break
                default:
                  OA = lA
                  break
              }
              var aI = lA
              lA = OA
              try {
                return MA()
              } finally {
                lA = aI
              }
            }
            function NA(MA) {
              var OA = lA
              return function () {
                var aI = lA
                lA = OA
                try {
                  return MA.apply(this, arguments)
                } finally {
                  lA = aI
                }
              }
            }
            function qA(MA, OA, aI) {
              var RI = e.unstable_now(),
                VA
              if (typeof aI == "object" && aI !== null) {
                var ag = aI.delay
                typeof ag == "number" && ag > 0 ? (VA = RI + ag) : (VA = RI)
              } else VA = RI
              var XI
              switch (MA) {
                case h:
                  XI = V
                  break
                case S:
                  XI = j
                  break
                case M:
                  XI = X
                  break
                case w:
                  XI = AA
                  break
                case d:
                default:
                  XI = P
                  break
              }
              var $I = VA + XI,
                SA = {
                  id: CA++,
                  callback: OA,
                  priorityLevel: MA,
                  startTime: VA,
                  expirationTime: $I,
                  sortIndex: -1,
                }
              return (
                VA > RI
                  ? ((SA.sortIndex = VA),
                    C(eA, SA),
                    i(_) === null && SA === i(eA) && (LA ? GI() : (LA = !0), UI(EA, VA - RI)))
                  : ((SA.sortIndex = $I), C(_, SA), !yA && !JA && ((yA = !0), nI(GA))),
                SA
              )
            }
            function ZA() {}
            function sI() {
              !yA && !JA && ((yA = !0), nI(GA))
            }
            function cI() {
              return i(_)
            }
            function YA(MA) {
              MA.callback = null
            }
            function eI() {
              return lA
            }
            var uA = !1,
              hI = null,
              II = -1,
              pI = g,
              AI = -1
            function YI() {
              var MA = e.unstable_now() - AI
              return !(MA < pI)
            }
            function SI() {}
            function QA(MA) {
              if (MA < 0 || MA > 125) {
                console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
                )
                return
              }
              MA > 0 ? (pI = Math.floor(1e3 / MA)) : (pI = g)
            }
            var tA = function () {
                if (hI !== null) {
                  var MA = e.unstable_now()
                  AI = MA
                  var OA = !0,
                    aI = !0
                  try {
                    aI = hI(OA, MA)
                  } finally {
                    aI ? FA() : ((uA = !1), (hI = null))
                  }
                } else uA = !1
              },
              FA
            if (typeof sA == "function")
              FA = function () {
                sA(tA)
              }
            else if (typeof MessageChannel < "u") {
              var WA = new MessageChannel(),
                jA = WA.port2
              ;((WA.port1.onmessage = tA),
                (FA = function () {
                  jA.postMessage(null)
                }))
            } else
              FA = function () {
                nA(tA, 0)
              }
            function nI(MA) {
              ;((hI = MA), uA || ((uA = !0), FA()))
            }
            function UI(MA, OA) {
              II = nA(function () {
                MA(e.unstable_now())
              }, OA)
            }
            function GI() {
              ;(fA(II), (II = -1))
            }
            var LI = SI,
              Bg = null
            ;((e.unstable_IdlePriority = M),
              (e.unstable_ImmediatePriority = h),
              (e.unstable_LowPriority = w),
              (e.unstable_NormalPriority = d),
              (e.unstable_Profiling = Bg),
              (e.unstable_UserBlockingPriority = S),
              (e.unstable_cancelCallback = YA),
              (e.unstable_continueExecution = sI),
              (e.unstable_forceFrameRate = QA),
              (e.unstable_getCurrentPriorityLevel = eI),
              (e.unstable_getFirstCallbackNode = cI),
              (e.unstable_next = kA),
              (e.unstable_pauseExecution = ZA),
              (e.unstable_requestPaint = LI),
              (e.unstable_runWithPriority = dA),
              (e.unstable_scheduleCallback = qA),
              (e.unstable_shouldYield = YI),
              (e.unstable_wrapCallback = NA),
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" &&
                typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" &&
                __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error()))
          })()
      })(PJ)),
    PJ
  )
}
var kq
function zx() {
  return (
    kq ||
      ((kq = 1), process.env.NODE_ENV === "production" ? (RM.exports = t1()) : (RM.exports = B1())),
    RM.exports
  )
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mq
function Q1() {
  if (Mq) return Ra
  Mq = 1
  var e = Pf(),
    A = zx()
  function I(E) {
    for (
      var l = "https://reactjs.org/docs/error-decoder.html?invariant=" + E, p = 1;
      p < arguments.length;
      p++
    )
      l += "&args[]=" + encodeURIComponent(arguments[p])
    return (
      "Minified React error #" +
      E +
      "; visit " +
      l +
      " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
    )
  }
  var g = /* @__PURE__ */ new Set(),
    C = {}
  function i(E, l) {
    ;(B(E, l), B(E + "Capture", l))
  }
  function B(E, l) {
    for (C[E] = l, E = 0; E < l.length; E++) g.add(l[E])
  }
  var o = !(
      typeof window > "u" ||
      typeof window.document > "u" ||
      typeof window.document.createElement > "u"
    ),
    r = Object.prototype.hasOwnProperty,
    s =
      /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    h = {},
    S = {}
  function d(E) {
    return r.call(S, E) ? !0 : r.call(h, E) ? !1 : s.test(E) ? (S[E] = !0) : ((h[E] = !0), !1)
  }
  function w(E, l, p, U) {
    if (p !== null && p.type === 0) return !1
    switch (typeof l) {
      case "function":
      case "symbol":
        return !0
      case "boolean":
        return U
          ? !1
          : p !== null
            ? !p.acceptsBooleans
            : ((E = E.toLowerCase().slice(0, 5)), E !== "data-" && E !== "aria-")
      default:
        return !1
    }
  }
  function M(E, l, p, U) {
    if (l === null || typeof l > "u" || w(E, l, p, U)) return !0
    if (U) return !1
    if (p !== null)
      switch (p.type) {
        case 3:
          return !l
        case 4:
          return l === !1
        case 5:
          return isNaN(l)
        case 6:
          return isNaN(l) || 1 > l
      }
    return !1
  }
  function K(E, l, p, U, q, Z, oA) {
    ;((this.acceptsBooleans = l === 2 || l === 3 || l === 4),
      (this.attributeName = U),
      (this.attributeNamespace = q),
      (this.mustUseProperty = p),
      (this.propertyName = E),
      (this.type = l),
      (this.sanitizeURL = Z),
      (this.removeEmptyString = oA))
  }
  var R = {}
  ;("children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style"
    .split(" ")
    .forEach(function (E) {
      R[E] = new K(E, 0, !1, E, null, !1, !1)
    }),
    [
      ["acceptCharset", "accept-charset"],
      ["className", "class"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
    ].forEach(function (E) {
      var l = E[0]
      R[l] = new K(l, 1, !1, E[1], null, !1, !1)
    }),
    ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (E) {
      R[E] = new K(E, 2, !1, E.toLowerCase(), null, !1, !1)
    }),
    ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(
      function (E) {
        R[E] = new K(E, 2, !1, E, null, !1, !1)
      },
    ),
    "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
      .split(" ")
      .forEach(function (E) {
        R[E] = new K(E, 3, !1, E.toLowerCase(), null, !1, !1)
      }),
    ["checked", "multiple", "muted", "selected"].forEach(function (E) {
      R[E] = new K(E, 3, !0, E, null, !1, !1)
    }),
    ["capture", "download"].forEach(function (E) {
      R[E] = new K(E, 4, !1, E, null, !1, !1)
    }),
    ["cols", "rows", "size", "span"].forEach(function (E) {
      R[E] = new K(E, 6, !1, E, null, !1, !1)
    }),
    ["rowSpan", "start"].forEach(function (E) {
      R[E] = new K(E, 5, !1, E.toLowerCase(), null, !1, !1)
    }))
  var F = /[\-:]([a-z])/g
  function L(E) {
    return E[1].toUpperCase()
  }
  ;("accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
    .split(" ")
    .forEach(function (E) {
      var l = E.replace(F, L)
      R[l] = new K(l, 1, !1, E, null, !1, !1)
    }),
    "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type"
      .split(" ")
      .forEach(function (E) {
        var l = E.replace(F, L)
        R[l] = new K(l, 1, !1, E, "http://www.w3.org/1999/xlink", !1, !1)
      }),
    ["xml:base", "xml:lang", "xml:space"].forEach(function (E) {
      var l = E.replace(F, L)
      R[l] = new K(l, 1, !1, E, "http://www.w3.org/XML/1998/namespace", !1, !1)
    }),
    ["tabIndex", "crossOrigin"].forEach(function (E) {
      R[E] = new K(E, 1, !1, E.toLowerCase(), null, !1, !1)
    }),
    (R.xlinkHref = new K("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1)),
    ["src", "href", "action", "formAction"].forEach(function (E) {
      R[E] = new K(E, 1, !1, E.toLowerCase(), null, !0, !0)
    }))
  function Y(E, l, p, U) {
    var q = R.hasOwnProperty(l) ? R[l] : null
    ;(q !== null
      ? q.type !== 0
      : U || !(2 < l.length) || (l[0] !== "o" && l[0] !== "O") || (l[1] !== "n" && l[1] !== "N")) &&
      (M(l, p, q, U) && (p = null),
      U || q === null
        ? d(l) && (p === null ? E.removeAttribute(l) : E.setAttribute(l, "" + p))
        : q.mustUseProperty
          ? (E[q.propertyName] = p === null ? (q.type === 3 ? !1 : "") : p)
          : ((l = q.attributeName),
            (U = q.attributeNamespace),
            p === null
              ? E.removeAttribute(l)
              : ((q = q.type),
                (p = q === 3 || (q === 4 && p === !0) ? "" : "" + p),
                U ? E.setAttributeNS(U, l, p) : E.setAttribute(l, p))))
  }
  var H = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    V = Symbol.for("react.element"),
    j = Symbol.for("react.portal"),
    P = Symbol.for("react.fragment"),
    AA = Symbol.for("react.strict_mode"),
    X = Symbol.for("react.profiler"),
    _ = Symbol.for("react.provider"),
    eA = Symbol.for("react.context"),
    CA = Symbol.for("react.forward_ref"),
    aA = Symbol.for("react.suspense"),
    lA = Symbol.for("react.suspense_list"),
    JA = Symbol.for("react.memo"),
    yA = Symbol.for("react.lazy"),
    LA = Symbol.for("react.offscreen"),
    nA = Symbol.iterator
  function fA(E) {
    return E === null || typeof E != "object"
      ? null
      : ((E = (nA && E[nA]) || E["@@iterator"]), typeof E == "function" ? E : null)
  }
  var sA = Object.assign,
    $
  function EA(E) {
    if ($ === void 0)
      try {
        throw Error()
      } catch (p) {
        var l = p.stack.trim().match(/\n( *(at )?)/)
        $ = (l && l[1]) || ""
      }
    return (
      `
` +
      $ +
      E
    )
  }
  var GA = !1
  function DA(E, l) {
    if (!E || GA) return ""
    GA = !0
    var p = Error.prepareStackTrace
    Error.prepareStackTrace = void 0
    try {
      if (l)
        if (
          ((l = function () {
            throw Error()
          }),
          Object.defineProperty(l.prototype, "props", {
            set: function () {
              throw Error()
            },
          }),
          typeof Reflect == "object" && Reflect.construct)
        ) {
          try {
            Reflect.construct(l, [])
          } catch (kI) {
            var U = kI
          }
          Reflect.construct(E, [], l)
        } else {
          try {
            l.call()
          } catch (kI) {
            U = kI
          }
          E.call(l.prototype)
        }
      else {
        try {
          throw Error()
        } catch (kI) {
          U = kI
        }
        E()
      }
    } catch (kI) {
      if (kI && U && typeof kI.stack == "string") {
        for (
          var q = kI.stack.split(`
`),
            Z = U.stack.split(`
`),
            oA = q.length - 1,
            KA = Z.length - 1;
          1 <= oA && 0 <= KA && q[oA] !== Z[KA];
        )
          KA--
        for (; 1 <= oA && 0 <= KA; oA--, KA--)
          if (q[oA] !== Z[KA]) {
            if (oA !== 1 || KA !== 1)
              do
                if ((oA--, KA--, 0 > KA || q[oA] !== Z[KA])) {
                  var bA =
                    `
` + q[oA].replace(" at new ", " at ")
                  return (
                    E.displayName &&
                      bA.includes("<anonymous>") &&
                      (bA = bA.replace("<anonymous>", E.displayName)),
                    bA
                  )
                }
              while (1 <= oA && 0 <= KA)
            break
          }
      }
    } finally {
      ;((GA = !1), (Error.prepareStackTrace = p))
    }
    return (E = E ? E.displayName || E.name : "") ? EA(E) : ""
  }
  function dA(E) {
    switch (E.tag) {
      case 5:
        return EA(E.type)
      case 16:
        return EA("Lazy")
      case 13:
        return EA("Suspense")
      case 19:
        return EA("SuspenseList")
      case 0:
      case 2:
      case 15:
        return ((E = DA(E.type, !1)), E)
      case 11:
        return ((E = DA(E.type.render, !1)), E)
      case 1:
        return ((E = DA(E.type, !0)), E)
      default:
        return ""
    }
  }
  function kA(E) {
    if (E == null) return null
    if (typeof E == "function") return E.displayName || E.name || null
    if (typeof E == "string") return E
    switch (E) {
      case P:
        return "Fragment"
      case j:
        return "Portal"
      case X:
        return "Profiler"
      case AA:
        return "StrictMode"
      case aA:
        return "Suspense"
      case lA:
        return "SuspenseList"
    }
    if (typeof E == "object")
      switch (E.$$typeof) {
        case eA:
          return (E.displayName || "Context") + ".Consumer"
        case _:
          return (E._context.displayName || "Context") + ".Provider"
        case CA:
          var l = E.render
          return (
            (E = E.displayName),
            E ||
              ((E = l.displayName || l.name || ""),
              (E = E !== "" ? "ForwardRef(" + E + ")" : "ForwardRef")),
            E
          )
        case JA:
          return ((l = E.displayName || null), l !== null ? l : kA(E.type) || "Memo")
        case yA:
          ;((l = E._payload), (E = E._init))
          try {
            return kA(E(l))
          } catch {}
      }
    return null
  }
  function NA(E) {
    var l = E.type
    switch (E.tag) {
      case 24:
        return "Cache"
      case 9:
        return (l.displayName || "Context") + ".Consumer"
      case 10:
        return (l._context.displayName || "Context") + ".Provider"
      case 18:
        return "DehydratedFragment"
      case 11:
        return (
          (E = l.render),
          (E = E.displayName || E.name || ""),
          l.displayName || (E !== "" ? "ForwardRef(" + E + ")" : "ForwardRef")
        )
      case 7:
        return "Fragment"
      case 5:
        return l
      case 4:
        return "Portal"
      case 3:
        return "Root"
      case 6:
        return "Text"
      case 16:
        return kA(l)
      case 8:
        return l === AA ? "StrictMode" : "Mode"
      case 22:
        return "Offscreen"
      case 12:
        return "Profiler"
      case 21:
        return "Scope"
      case 13:
        return "Suspense"
      case 19:
        return "SuspenseList"
      case 25:
        return "TracingMarker"
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof l == "function") return l.displayName || l.name || null
        if (typeof l == "string") return l
    }
    return null
  }
  function qA(E) {
    switch (typeof E) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return E
      case "object":
        return E
      default:
        return ""
    }
  }
  function ZA(E) {
    var l = E.type
    return (E = E.nodeName) && E.toLowerCase() === "input" && (l === "checkbox" || l === "radio")
  }
  function sI(E) {
    var l = ZA(E) ? "checked" : "value",
      p = Object.getOwnPropertyDescriptor(E.constructor.prototype, l),
      U = "" + E[l]
    if (
      !E.hasOwnProperty(l) &&
      typeof p < "u" &&
      typeof p.get == "function" &&
      typeof p.set == "function"
    ) {
      var q = p.get,
        Z = p.set
      return (
        Object.defineProperty(E, l, {
          configurable: !0,
          get: function () {
            return q.call(this)
          },
          set: function (oA) {
            ;((U = "" + oA), Z.call(this, oA))
          },
        }),
        Object.defineProperty(E, l, { enumerable: p.enumerable }),
        {
          getValue: function () {
            return U
          },
          setValue: function (oA) {
            U = "" + oA
          },
          stopTracking: function () {
            ;((E._valueTracker = null), delete E[l])
          },
        }
      )
    }
  }
  function cI(E) {
    E._valueTracker || (E._valueTracker = sI(E))
  }
  function YA(E) {
    if (!E) return !1
    var l = E._valueTracker
    if (!l) return !0
    var p = l.getValue(),
      U = ""
    return (
      E && (U = ZA(E) ? (E.checked ? "true" : "false") : E.value),
      (E = U),
      E !== p ? (l.setValue(E), !0) : !1
    )
  }
  function eI(E) {
    if (((E = E || (typeof document < "u" ? document : void 0)), typeof E > "u")) return null
    try {
      return E.activeElement || E.body
    } catch {
      return E.body
    }
  }
  function uA(E, l) {
    var p = l.checked
    return sA({}, l, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: p ?? E._wrapperState.initialChecked,
    })
  }
  function hI(E, l) {
    var p = l.defaultValue == null ? "" : l.defaultValue,
      U = l.checked != null ? l.checked : l.defaultChecked
    ;((p = qA(l.value != null ? l.value : p)),
      (E._wrapperState = {
        initialChecked: U,
        initialValue: p,
        controlled:
          l.type === "checkbox" || l.type === "radio" ? l.checked != null : l.value != null,
      }))
  }
  function II(E, l) {
    ;((l = l.checked), l != null && Y(E, "checked", l, !1))
  }
  function pI(E, l) {
    II(E, l)
    var p = qA(l.value),
      U = l.type
    if (p != null)
      U === "number"
        ? ((p === 0 && E.value === "") || E.value != p) && (E.value = "" + p)
        : E.value !== "" + p && (E.value = "" + p)
    else if (U === "submit" || U === "reset") {
      E.removeAttribute("value")
      return
    }
    ;(l.hasOwnProperty("value")
      ? YI(E, l.type, p)
      : l.hasOwnProperty("defaultValue") && YI(E, l.type, qA(l.defaultValue)),
      l.checked == null && l.defaultChecked != null && (E.defaultChecked = !!l.defaultChecked))
  }
  function AI(E, l, p) {
    if (l.hasOwnProperty("value") || l.hasOwnProperty("defaultValue")) {
      var U = l.type
      if (!((U !== "submit" && U !== "reset") || (l.value !== void 0 && l.value !== null))) return
      ;((l = "" + E._wrapperState.initialValue),
        p || l === E.value || (E.value = l),
        (E.defaultValue = l))
    }
    ;((p = E.name),
      p !== "" && (E.name = ""),
      (E.defaultChecked = !!E._wrapperState.initialChecked),
      p !== "" && (E.name = p))
  }
  function YI(E, l, p) {
    ;(l !== "number" || eI(E.ownerDocument) !== E) &&
      (p == null
        ? (E.defaultValue = "" + E._wrapperState.initialValue)
        : E.defaultValue !== "" + p && (E.defaultValue = "" + p))
  }
  var SI = Array.isArray
  function QA(E, l, p, U) {
    if (((E = E.options), l)) {
      l = {}
      for (var q = 0; q < p.length; q++) l["$" + p[q]] = !0
      for (p = 0; p < E.length; p++)
        ((q = l.hasOwnProperty("$" + E[p].value)),
          E[p].selected !== q && (E[p].selected = q),
          q && U && (E[p].defaultSelected = !0))
    } else {
      for (p = "" + qA(p), l = null, q = 0; q < E.length; q++) {
        if (E[q].value === p) {
          ;((E[q].selected = !0), U && (E[q].defaultSelected = !0))
          return
        }
        l !== null || E[q].disabled || (l = E[q])
      }
      l !== null && (l.selected = !0)
    }
  }
  function tA(E, l) {
    if (l.dangerouslySetInnerHTML != null) throw Error(I(91))
    return sA({}, l, {
      value: void 0,
      defaultValue: void 0,
      children: "" + E._wrapperState.initialValue,
    })
  }
  function FA(E, l) {
    var p = l.value
    if (p == null) {
      if (((p = l.children), (l = l.defaultValue), p != null)) {
        if (l != null) throw Error(I(92))
        if (SI(p)) {
          if (1 < p.length) throw Error(I(93))
          p = p[0]
        }
        l = p
      }
      ;(l == null && (l = ""), (p = l))
    }
    E._wrapperState = { initialValue: qA(p) }
  }
  function WA(E, l) {
    var p = qA(l.value),
      U = qA(l.defaultValue)
    ;(p != null &&
      ((p = "" + p),
      p !== E.value && (E.value = p),
      l.defaultValue == null && E.defaultValue !== p && (E.defaultValue = p)),
      U != null && (E.defaultValue = "" + U))
  }
  function jA(E) {
    var l = E.textContent
    l === E._wrapperState.initialValue && l !== "" && l !== null && (E.value = l)
  }
  function nI(E) {
    switch (E) {
      case "svg":
        return "http://www.w3.org/2000/svg"
      case "math":
        return "http://www.w3.org/1998/Math/MathML"
      default:
        return "http://www.w3.org/1999/xhtml"
    }
  }
  function UI(E, l) {
    return E == null || E === "http://www.w3.org/1999/xhtml"
      ? nI(l)
      : E === "http://www.w3.org/2000/svg" && l === "foreignObject"
        ? "http://www.w3.org/1999/xhtml"
        : E
  }
  var GI,
    LI = (function (E) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction
        ? function (l, p, U, q) {
            MSApp.execUnsafeLocalFunction(function () {
              return E(l, p, U, q)
            })
          }
        : E
    })(function (E, l) {
      if (E.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in E) E.innerHTML = l
      else {
        for (
          GI = GI || document.createElement("div"),
            GI.innerHTML = "<svg>" + l.valueOf().toString() + "</svg>",
            l = GI.firstChild;
          E.firstChild;
        )
          E.removeChild(E.firstChild)
        for (; l.firstChild; ) E.appendChild(l.firstChild)
      }
    })
  function Bg(E, l) {
    if (l) {
      var p = E.firstChild
      if (p && p === E.lastChild && p.nodeType === 3) {
        p.nodeValue = l
        return
      }
    }
    E.textContent = l
  }
  var MA = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0,
    },
    OA = ["Webkit", "ms", "Moz", "O"]
  Object.keys(MA).forEach(function (E) {
    OA.forEach(function (l) {
      ;((l = l + E.charAt(0).toUpperCase() + E.substring(1)), (MA[l] = MA[E]))
    })
  })
  function aI(E, l, p) {
    return l == null || typeof l == "boolean" || l === ""
      ? ""
      : p || typeof l != "number" || l === 0 || (MA.hasOwnProperty(E) && MA[E])
        ? ("" + l).trim()
        : l + "px"
  }
  function RI(E, l) {
    E = E.style
    for (var p in l)
      if (l.hasOwnProperty(p)) {
        var U = p.indexOf("--") === 0,
          q = aI(p, l[p], U)
        ;(p === "float" && (p = "cssFloat"), U ? E.setProperty(p, q) : (E[p] = q))
      }
  }
  var VA = sA(
    { menuitem: !0 },
    {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0,
    },
  )
  function ag(E, l) {
    if (l) {
      if (VA[E] && (l.children != null || l.dangerouslySetInnerHTML != null)) throw Error(I(137, E))
      if (l.dangerouslySetInnerHTML != null) {
        if (l.children != null) throw Error(I(60))
        if (
          typeof l.dangerouslySetInnerHTML != "object" ||
          !("__html" in l.dangerouslySetInnerHTML)
        )
          throw Error(I(61))
      }
      if (l.style != null && typeof l.style != "object") throw Error(I(62))
    }
  }
  function XI(E, l) {
    if (E.indexOf("-") === -1) return typeof l.is == "string"
    switch (E) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1
      default:
        return !0
    }
  }
  var $I = null
  function SA(E) {
    return (
      (E = E.target || E.srcElement || window),
      E.correspondingUseElement && (E = E.correspondingUseElement),
      E.nodeType === 3 ? E.parentNode : E
    )
  }
  var NI = null,
    HA = null,
    iI = null
  function zI(E) {
    if ((E = lQ(E))) {
      if (typeof NI != "function") throw Error(I(280))
      var l = E.stateNode
      l && ((l = nC(l)), NI(E.stateNode, E.type, l))
    }
  }
  function qI(E) {
    HA ? (iI ? iI.push(E) : (iI = [E])) : (HA = E)
  }
  function dg() {
    if (HA) {
      var E = HA,
        l = iI
      if (((iI = HA = null), zI(E), l)) for (E = 0; E < l.length; E++) zI(l[E])
    }
  }
  function $g(E, l) {
    return E(l)
  }
  function Qg() {}
  var Fg = !1
  function jC(E, l, p) {
    if (Fg) return E(l, p)
    Fg = !0
    try {
      return $g(E, l, p)
    } finally {
      ;((Fg = !1), (HA !== null || iI !== null) && (Qg(), dg()))
    }
  }
  function mC(E, l) {
    var p = E.stateNode
    if (p === null) return null
    var U = nC(p)
    if (U === null) return null
    p = U[l]
    A: switch (l) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        ;((U = !U.disabled) ||
          ((E = E.type),
          (U = !(E === "button" || E === "input" || E === "select" || E === "textarea"))),
          (E = !U))
        break A
      default:
        E = !1
    }
    if (E) return null
    if (p && typeof p != "function") throw Error(I(231, l, typeof p))
    return p
  }
  var zC = !1
  if (o)
    try {
      var Ee = {}
      ;(Object.defineProperty(Ee, "passive", {
        get: function () {
          zC = !0
        },
      }),
        window.addEventListener("test", Ee, Ee),
        window.removeEventListener("test", Ee, Ee))
    } catch {
      zC = !1
    }
  function ei(E, l, p, U, q, Z, oA, KA, bA) {
    var kI = Array.prototype.slice.call(arguments, 3)
    try {
      l.apply(p, kI)
    } catch (tg) {
      this.onError(tg)
    }
  }
  var fe = !1,
    Ei = null,
    vi = !1,
    Li = null,
    mA = {
      onError: function (E) {
        ;((fe = !0), (Ei = E))
      },
    }
  function TI(E, l, p, U, q, Z, oA, KA, bA) {
    ;((fe = !1), (Ei = null), ei.apply(mA, arguments))
  }
  function eg(E, l, p, U, q, Z, oA, KA, bA) {
    if ((TI.apply(this, arguments), fe)) {
      if (fe) {
        var kI = Ei
        ;((fe = !1), (Ei = null))
      } else throw Error(I(198))
      vi || ((vi = !0), (Li = kI))
    }
  }
  function Tg(E) {
    var l = E,
      p = E
    if (E.alternate) for (; l.return; ) l = l.return
    else {
      E = l
      do ((l = E), l.flags & 4098 && (p = l.return), (E = l.return))
      while (E)
    }
    return l.tag === 3 ? p : null
  }
  function OC(E) {
    if (E.tag === 13) {
      var l = E.memoizedState
      if ((l === null && ((E = E.alternate), E !== null && (l = E.memoizedState)), l !== null))
        return l.dehydrated
    }
    return null
  }
  function JC(E) {
    if (Tg(E) !== E) throw Error(I(188))
  }
  function jg(E) {
    var l = E.alternate
    if (!l) {
      if (((l = Tg(E)), l === null)) throw Error(I(188))
      return l !== E ? null : E
    }
    for (var p = E, U = l; ; ) {
      var q = p.return
      if (q === null) break
      var Z = q.alternate
      if (Z === null) {
        if (((U = q.return), U !== null)) {
          p = U
          continue
        }
        break
      }
      if (q.child === Z.child) {
        for (Z = q.child; Z; ) {
          if (Z === p) return (JC(q), E)
          if (Z === U) return (JC(q), l)
          Z = Z.sibling
        }
        throw Error(I(188))
      }
      if (p.return !== U.return) ((p = q), (U = Z))
      else {
        for (var oA = !1, KA = q.child; KA; ) {
          if (KA === p) {
            ;((oA = !0), (p = q), (U = Z))
            break
          }
          if (KA === U) {
            ;((oA = !0), (U = q), (p = Z))
            break
          }
          KA = KA.sibling
        }
        if (!oA) {
          for (KA = Z.child; KA; ) {
            if (KA === p) {
              ;((oA = !0), (p = Z), (U = q))
              break
            }
            if (KA === U) {
              ;((oA = !0), (U = Z), (p = q))
              break
            }
            KA = KA.sibling
          }
          if (!oA) throw Error(I(189))
        }
      }
      if (p.alternate !== U) throw Error(I(190))
    }
    if (p.tag !== 3) throw Error(I(188))
    return p.stateNode.current === p ? E : l
  }
  function rA(E) {
    return ((E = jg(E)), E !== null ? _A(E) : null)
  }
  function _A(E) {
    if (E.tag === 5 || E.tag === 6) return E
    for (E = E.child; E !== null; ) {
      var l = _A(E)
      if (l !== null) return l
      E = E.sibling
    }
    return null
  }
  var oI = A.unstable_scheduleCallback,
    QI = A.unstable_cancelCallback,
    PA = A.unstable_shouldYield,
    gg = A.unstable_requestPaint,
    EI = A.unstable_now,
    hg = A.unstable_getCurrentPriorityLevel,
    yg = A.unstable_ImmediatePriority,
    rg = A.unstable_UserBlockingPriority,
    eC = A.unstable_NormalPriority,
    Rg = A.unstable_LowPriority,
    pC = A.unstable_IdlePriority,
    wC = null,
    mg = null
  function UC(E) {
    if (mg && typeof mg.onCommitFiberRoot == "function")
      try {
        mg.onCommitFiberRoot(wC, E, void 0, (E.current.flags & 128) === 128)
      } catch {}
  }
  var iC = Math.clz32 ? Math.clz32 : vC,
    Gg = Math.log,
    _C = Math.LN2
  function vC(E) {
    return ((E >>>= 0), E === 0 ? 32 : (31 - ((Gg(E) / _C) | 0)) | 0)
  }
  var ii = 64,
    qe = 4194304
  function pe(E) {
    switch (E & -E) {
      case 1:
        return 1
      case 2:
        return 2
      case 4:
        return 4
      case 8:
        return 8
      case 16:
        return 16
      case 32:
        return 32
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return E & 4194240
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return E & 130023424
      case 134217728:
        return 134217728
      case 268435456:
        return 268435456
      case 536870912:
        return 536870912
      case 1073741824:
        return 1073741824
      default:
        return E
    }
  }
  function Mi(E, l) {
    var p = E.pendingLanes
    if (p === 0) return 0
    var U = 0,
      q = E.suspendedLanes,
      Z = E.pingedLanes,
      oA = p & 268435455
    if (oA !== 0) {
      var KA = oA & ~q
      KA !== 0 ? (U = pe(KA)) : ((Z &= oA), Z !== 0 && (U = pe(Z)))
    } else ((oA = p & ~q), oA !== 0 ? (U = pe(oA)) : Z !== 0 && (U = pe(Z)))
    if (U === 0) return 0
    if (
      l !== 0 &&
      l !== U &&
      !(l & q) &&
      ((q = U & -U), (Z = l & -l), q >= Z || (q === 16 && (Z & 4194240) !== 0))
    )
      return l
    if ((U & 4 && (U |= p & 16), (l = E.entangledLanes), l !== 0))
      for (E = E.entanglements, l &= U; 0 < l; )
        ((p = 31 - iC(l)), (q = 1 << p), (U |= E[p]), (l &= ~q))
    return U
  }
  function ae(E, l) {
    switch (E) {
      case 1:
      case 2:
      case 4:
        return l + 250
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l + 5e3
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1
      default:
        return -1
    }
  }
  function ai(E, l) {
    for (
      var p = E.suspendedLanes, U = E.pingedLanes, q = E.expirationTimes, Z = E.pendingLanes;
      0 < Z;
    ) {
      var oA = 31 - iC(Z),
        KA = 1 << oA,
        bA = q[oA]
      ;(bA === -1
        ? (!(KA & p) || KA & U) && (q[oA] = ae(KA, l))
        : bA <= l && (E.expiredLanes |= KA),
        (Z &= ~KA))
    }
  }
  function fi(E) {
    return ((E = E.pendingLanes & -1073741825), E !== 0 ? E : E & 1073741824 ? 1073741824 : 0)
  }
  function He() {
    var E = ii
    return ((ii <<= 1), !(ii & 4194240) && (ii = 64), E)
  }
  function Et(E) {
    for (var l = [], p = 0; 31 > p; p++) l.push(E)
    return l
  }
  function Yi(E, l, p) {
    ;((E.pendingLanes |= l),
      l !== 536870912 && ((E.suspendedLanes = 0), (E.pingedLanes = 0)),
      (E = E.eventTimes),
      (l = 31 - iC(l)),
      (E[l] = p))
  }
  function vn(E, l) {
    var p = E.pendingLanes & ~l
    ;((E.pendingLanes = l),
      (E.suspendedLanes = 0),
      (E.pingedLanes = 0),
      (E.expiredLanes &= l),
      (E.mutableReadLanes &= l),
      (E.entangledLanes &= l),
      (l = E.entanglements))
    var U = E.eventTimes
    for (E = E.expirationTimes; 0 < p; ) {
      var q = 31 - iC(p),
        Z = 1 << q
      ;((l[q] = 0), (U[q] = -1), (E[q] = -1), (p &= ~Z))
    }
  }
  function aB(E, l) {
    var p = (E.entangledLanes |= l)
    for (E = E.entanglements; p; ) {
      var U = 31 - iC(p),
        q = 1 << U
      ;((q & l) | (E[U] & l) && (E[U] |= l), (p &= ~q))
    }
  }
  var XC = 0
  function dB(E) {
    return ((E &= -E), 1 < E ? (4 < E ? (E & 268435455 ? 16 : 536870912) : 4) : 1)
  }
  var zQ,
    Wt,
    ZC,
    Ui,
    $o,
    oC = !1,
    RQ = [],
    Te = null,
    hC = null,
    Vt = null,
    wt = /* @__PURE__ */ new Map(),
    di = /* @__PURE__ */ new Map(),
    Me = [],
    Ha =
      "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(
        " ",
      )
  function ee(E, l) {
    switch (E) {
      case "focusin":
      case "focusout":
        Te = null
        break
      case "dragenter":
      case "dragleave":
        hC = null
        break
      case "mouseover":
      case "mouseout":
        Vt = null
        break
      case "pointerover":
      case "pointerout":
        wt.delete(l.pointerId)
        break
      case "gotpointercapture":
      case "lostpointercapture":
        di.delete(l.pointerId)
    }
  }
  function Zi(E, l, p, U, q, Z) {
    return E === null || E.nativeEvent !== Z
      ? ((E = {
          blockedOn: l,
          domEventName: p,
          eventSystemFlags: U,
          nativeEvent: Z,
          targetContainers: [q],
        }),
        l !== null && ((l = lQ(l)), l !== null && Wt(l)),
        E)
      : ((E.eventSystemFlags |= U),
        (l = E.targetContainers),
        q !== null && l.indexOf(q) === -1 && l.push(q),
        E)
  }
  function XQ(E, l, p, U, q) {
    switch (l) {
      case "focusin":
        return ((Te = Zi(Te, E, l, p, U, q)), !0)
      case "dragenter":
        return ((hC = Zi(hC, E, l, p, U, q)), !0)
      case "mouseover":
        return ((Vt = Zi(Vt, E, l, p, U, q)), !0)
      case "pointerover":
        var Z = q.pointerId
        return (wt.set(Z, Zi(wt.get(Z) || null, E, l, p, U, q)), !0)
      case "gotpointercapture":
        return ((Z = q.pointerId), di.set(Z, Zi(di.get(Z) || null, E, l, p, U, q)), !0)
    }
    return !1
  }
  function rB(E) {
    var l = wB(E.target)
    if (l !== null) {
      var p = Tg(l)
      if (p !== null) {
        if (((l = p.tag), l === 13)) {
          if (((l = OC(p)), l !== null)) {
            ;((E.blockedOn = l),
              $o(E.priority, function () {
                ZC(p)
              }))
            return
          }
        } else if (l === 3 && p.stateNode.current.memoizedState.isDehydrated) {
          E.blockedOn = p.tag === 3 ? p.stateNode.containerInfo : null
          return
        }
      }
    }
    E.blockedOn = null
  }
  function $Q(E) {
    if (E.blockedOn !== null) return !1
    for (var l = E.targetContainers; 0 < l.length; ) {
      var p = zt(E.domEventName, E.eventSystemFlags, l[0], E.nativeEvent)
      if (p === null) {
        p = E.nativeEvent
        var U = new p.constructor(p.type, p)
        ;(($I = U), p.target.dispatchEvent(U), ($I = null))
      } else return ((l = lQ(p)), l !== null && Wt(l), (E.blockedOn = p), !1)
      l.shift()
    }
    return !0
  }
  function JQ(E, l, p) {
    $Q(E) && p.delete(l)
  }
  function HB() {
    ;((oC = !1),
      Te !== null && $Q(Te) && (Te = null),
      hC !== null && $Q(hC) && (hC = null),
      Vt !== null && $Q(Vt) && (Vt = null),
      wt.forEach(JQ),
      di.forEach(JQ))
  }
  function TB(E, l) {
    E.blockedOn === l &&
      ((E.blockedOn = null),
      oC || ((oC = !0), A.unstable_scheduleCallback(A.unstable_NormalPriority, HB)))
  }
  function An(E) {
    function l(q) {
      return TB(q, E)
    }
    if (0 < RQ.length) {
      TB(RQ[0], E)
      for (var p = 1; p < RQ.length; p++) {
        var U = RQ[p]
        U.blockedOn === E && (U.blockedOn = null)
      }
    }
    for (
      Te !== null && TB(Te, E),
        hC !== null && TB(hC, E),
        Vt !== null && TB(Vt, E),
        wt.forEach(l),
        di.forEach(l),
        p = 0;
      p < Me.length;
      p++
    )
      ((U = Me[p]), U.blockedOn === E && (U.blockedOn = null))
    for (; 0 < Me.length && ((p = Me[0]), p.blockedOn === null); )
      (rB(p), p.blockedOn === null && Me.shift())
  }
  var Gt = H.ReactCurrentBatchConfig,
    Ni = !0
  function QQ(E, l, p, U) {
    var q = XC,
      Z = Gt.transition
    Gt.transition = null
    try {
      ;((XC = 1), Ao(E, l, p, U))
    } finally {
      ;((XC = q), (Gt.transition = Z))
    }
  }
  function jt(E, l, p, U) {
    var q = XC,
      Z = Gt.transition
    Gt.transition = null
    try {
      ;((XC = 4), Ao(E, l, p, U))
    } finally {
      ;((XC = q), (Gt.transition = Z))
    }
  }
  function Ao(E, l, p, U) {
    if (Ni) {
      var q = zt(E, l, p, U)
      if (q === null) (io(E, l, U, In, p), ee(E, U))
      else if (XQ(q, E, l, p, U)) U.stopPropagation()
      else if ((ee(E, U), l & 4 && -1 < Ha.indexOf(E))) {
        for (; q !== null; ) {
          var Z = lQ(q)
          if (
            (Z !== null && zQ(Z), (Z = zt(E, l, p, U)), Z === null && io(E, l, U, In, p), Z === q)
          )
            break
          q = Z
        }
        q !== null && U.stopPropagation()
      } else io(E, l, U, null, p)
    }
  }
  var In = null
  function zt(E, l, p, U) {
    if (((In = null), (E = SA(U)), (E = wB(E)), E !== null))
      if (((l = Tg(E)), l === null)) E = null
      else if (((p = l.tag), p === 13)) {
        if (((E = OC(l)), E !== null)) return E
        E = null
      } else if (p === 3) {
        if (l.stateNode.current.memoizedState.isDehydrated)
          return l.tag === 3 ? l.stateNode.containerInfo : null
        E = null
      } else l !== E && (E = null)
    return ((In = E), null)
  }
  function gn(E) {
    switch (E) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4
      case "message":
        switch (hg()) {
          case yg:
            return 1
          case rg:
            return 4
          case eC:
          case Rg:
            return 16
          case pC:
            return 536870912
          default:
            return 16
        }
      default:
        return 16
    }
  }
  var yB = null,
    iA = null,
    vA = null
  function rI() {
    if (vA) return vA
    var E,
      l = iA,
      p = l.length,
      U,
      q = "value" in yB ? yB.value : yB.textContent,
      Z = q.length
    for (E = 0; E < p && l[E] === q[E]; E++);
    var oA = p - E
    for (U = 1; U <= oA && l[p - U] === q[Z - U]; U++);
    return (vA = q.slice(E, 1 < U ? 1 - U : void 0))
  }
  function mI(E) {
    var l = E.keyCode
    return (
      "charCode" in E ? ((E = E.charCode), E === 0 && l === 13 && (E = 13)) : (E = l),
      E === 10 && (E = 13),
      32 <= E || E === 13 ? E : 0
    )
  }
  function ig() {
    return !0
  }
  function AC() {
    return !1
  }
  function pg(E) {
    function l(p, U, q, Z, oA) {
      ;((this._reactName = p),
        (this._targetInst = q),
        (this.type = U),
        (this.nativeEvent = Z),
        (this.target = oA),
        (this.currentTarget = null))
      for (var KA in E) E.hasOwnProperty(KA) && ((p = E[KA]), (this[KA] = p ? p(Z) : Z[KA]))
      return (
        (this.isDefaultPrevented = (
          Z.defaultPrevented != null ? Z.defaultPrevented : Z.returnValue === !1
        )
          ? ig
          : AC),
        (this.isPropagationStopped = AC),
        this
      )
    }
    return (
      sA(l.prototype, {
        preventDefault: function () {
          this.defaultPrevented = !0
          var p = this.nativeEvent
          p &&
            (p.preventDefault
              ? p.preventDefault()
              : typeof p.returnValue != "unknown" && (p.returnValue = !1),
            (this.isDefaultPrevented = ig))
        },
        stopPropagation: function () {
          var p = this.nativeEvent
          p &&
            (p.stopPropagation
              ? p.stopPropagation()
              : typeof p.cancelBubble != "unknown" && (p.cancelBubble = !0),
            (this.isPropagationStopped = ig))
        },
        persist: function () {},
        isPersistent: ig,
      }),
      l
    )
  }
  var tC = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function (E) {
        return E.timeStamp || Date.now()
      },
      defaultPrevented: 0,
      isTrusted: 0,
    },
    BC = pg(tC),
    NC = sA({}, tC, { view: 0, detail: 0 }),
    KC = pg(NC),
    GC,
    ie,
    we,
    le = sA({}, NC, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: $E,
      button: 0,
      buttons: 0,
      relatedTarget: function (E) {
        return E.relatedTarget === void 0
          ? E.fromElement === E.srcElement
            ? E.toElement
            : E.fromElement
          : E.relatedTarget
      },
      movementX: function (E) {
        return "movementX" in E
          ? E.movementX
          : (E !== we &&
              (we && E.type === "mousemove"
                ? ((GC = E.screenX - we.screenX), (ie = E.screenY - we.screenY))
                : (ie = GC = 0),
              (we = E)),
            GC)
      },
      movementY: function (E) {
        return "movementY" in E ? E.movementY : ie
      },
    }),
    Io = pg(le),
    KQ = sA({}, le, { dataTransfer: 0 }),
    So = pg(KQ),
    xr = sA({}, NC, { relatedTarget: 0 }),
    fo = pg(xr),
    XE = sA({}, tC, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
    br = pg(XE),
    Rl = sA({}, tC, {
      clipboardData: function (E) {
        return "clipboardData" in E ? E.clipboardData : window.clipboardData
      },
    }),
    Jl = pg(Rl),
    Kl = sA({}, tC, { data: 0 }),
    ml = pg(Kl),
    vl = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified",
    },
    Pc = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta",
    },
    Ll = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" }
  function Ta(E) {
    var l = this.nativeEvent
    return l.getModifierState ? l.getModifierState(E) : (E = Ll[E]) ? !!l[E] : !1
  }
  function $E() {
    return Ta
  }
  var yo = sA({}, NC, {
      key: function (E) {
        if (E.key) {
          var l = vl[E.key] || E.key
          if (l !== "Unidentified") return l
        }
        return E.type === "keypress"
          ? ((E = mI(E)), E === 13 ? "Enter" : String.fromCharCode(E))
          : E.type === "keydown" || E.type === "keyup"
            ? Pc[E.keyCode] || "Unidentified"
            : ""
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: $E,
      charCode: function (E) {
        return E.type === "keypress" ? mI(E) : 0
      },
      keyCode: function (E) {
        return E.type === "keydown" || E.type === "keyup" ? E.keyCode : 0
      },
      which: function (E) {
        return E.type === "keypress"
          ? mI(E)
          : E.type === "keydown" || E.type === "keyup"
            ? E.keyCode
            : 0
      },
    }),
    Yl = pg(yo),
    mQ = sA({}, le, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0,
    }),
    oQ = pg(mQ),
    fE = sA({}, NC, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: $E,
    }),
    dE = pg(fE),
    po = sA({}, tC, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
    Aa = pg(po),
    nQ = sA({}, le, {
      deltaX: function (E) {
        return "deltaX" in E ? E.deltaX : "wheelDeltaX" in E ? -E.wheelDeltaX : 0
      },
      deltaY: function (E) {
        return "deltaY" in E
          ? E.deltaY
          : "wheelDeltaY" in E
            ? -E.wheelDeltaY
            : "wheelDelta" in E
              ? -E.wheelDelta
              : 0
      },
      deltaZ: 0,
      deltaMode: 0,
    }),
    Cn = pg(nQ),
    at = [9, 13, 27, 32],
    Xi = o && "CompositionEvent" in window,
    $i = null
  o && "documentMode" in document && ($i = document.documentMode)
  var ri = o && "TextEvent" in window && !$i,
    xa = o && (!Xi || ($i && 8 < $i && 11 >= $i)),
    pB = " ",
    ql = !1
  function Hl(E, l) {
    switch (E) {
      case "keyup":
        return at.indexOf(l.keyCode) !== -1
      case "keydown":
        return l.keyCode !== 229
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0
      default:
        return !1
    }
  }
  function ba(E) {
    return ((E = E.detail), typeof E == "object" && "data" in E ? E.data : null)
  }
  var yE = !1
  function Wc(E, l) {
    switch (E) {
      case "compositionend":
        return ba(l)
      case "keypress":
        return l.which !== 32 ? null : ((ql = !0), pB)
      case "textInput":
        return ((E = l.data), E === pB && ql ? null : E)
      default:
        return null
    }
  }
  function Fs(E, l) {
    if (yE)
      return E === "compositionend" || (!Xi && Hl(E, l))
        ? ((E = rI()), (vA = iA = yB = null), (yE = !1), E)
        : null
    switch (E) {
      case "paste":
        return null
      case "keypress":
        if (!(l.ctrlKey || l.altKey || l.metaKey) || (l.ctrlKey && l.altKey)) {
          if (l.char && 1 < l.char.length) return l.char
          if (l.which) return String.fromCharCode(l.which)
        }
        return null
      case "compositionend":
        return xa && l.locale !== "ko" ? null : l.data
      default:
        return null
    }
  }
  var Oa = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
  }
  function Or(E) {
    var l = E && E.nodeName && E.nodeName.toLowerCase()
    return l === "input" ? !!Oa[E.type] : l === "textarea"
  }
  function Ia(E, l, p, U) {
    ;(qI(U),
      (l = Tn(l, "onChange")),
      0 < l.length &&
        ((p = new BC("onChange", "change", null, p, U)), E.push({ event: p, listeners: l })))
  }
  var EQ = null,
    pE = null
  function Ln(E) {
    Cg(E, 0)
  }
  function en(E) {
    var l = Re(E)
    if (YA(l)) return E
  }
  function Rs(E, l) {
    if (E === "change") return l
  }
  var _a = !1
  if (o) {
    var xB
    if (o) {
      var Za = "oninput" in document
      if (!Za) {
        var wE = document.createElement("div")
        ;(wE.setAttribute("oninput", "return;"), (Za = typeof wE.oninput == "function"))
      }
      xB = Za
    } else xB = !1
    _a = xB && (!document.documentMode || 9 < document.documentMode)
  }
  function wo() {
    EQ && (EQ.detachEvent("onpropertychange", Js), (pE = EQ = null))
  }
  function Js(E) {
    if (E.propertyName === "value" && en(pE)) {
      var l = []
      ;(Ia(l, pE, E, SA(E)), jC(Ln, l))
    }
  }
  function Pa(E, l, p) {
    E === "focusin"
      ? (wo(), (EQ = l), (pE = p), EQ.attachEvent("onpropertychange", Js))
      : E === "focusout" && wo()
  }
  function Ks(E) {
    if (E === "selectionchange" || E === "keyup" || E === "keydown") return en(pE)
  }
  function go(E, l) {
    if (E === "click") return en(l)
  }
  function Fi(E, l) {
    if (E === "input" || E === "change") return en(l)
  }
  function Wa(E, l) {
    return (E === l && (E !== 0 || 1 / E === 1 / l)) || (E !== E && l !== l)
  }
  var rt = typeof Object.is == "function" ? Object.is : Wa
  function vQ(E, l) {
    if (rt(E, l)) return !0
    if (typeof E != "object" || E === null || typeof l != "object" || l === null) return !1
    var p = Object.keys(E),
      U = Object.keys(l)
    if (p.length !== U.length) return !1
    for (U = 0; U < p.length; U++) {
      var q = p[U]
      if (!r.call(l, q) || !rt(E[q], l[q])) return !1
    }
    return !0
  }
  function vt(E) {
    for (; E && E.firstChild; ) E = E.firstChild
    return E
  }
  function ti(E, l) {
    var p = vt(E)
    E = 0
    for (var U; p; ) {
      if (p.nodeType === 3) {
        if (((U = E + p.textContent.length), E <= l && U >= l)) return { node: p, offset: l - E }
        E = U
      }
      A: {
        for (; p; ) {
          if (p.nextSibling) {
            p = p.nextSibling
            break A
          }
          p = p.parentNode
        }
        p = void 0
      }
      p = vt(p)
    }
  }
  function GE(E, l) {
    return E && l
      ? E === l
        ? !0
        : E && E.nodeType === 3
          ? !1
          : l && l.nodeType === 3
            ? GE(E, l.parentNode)
            : "contains" in E
              ? E.contains(l)
              : E.compareDocumentPosition
                ? !!(E.compareDocumentPosition(l) & 16)
                : !1
      : !1
  }
  function he() {
    for (var E = window, l = eI(); l instanceof E.HTMLIFrameElement; ) {
      try {
        var p = typeof l.contentWindow.location.href == "string"
      } catch {
        p = !1
      }
      if (p) E = l.contentWindow
      else break
      l = eI(E.document)
    }
    return l
  }
  function xe(E) {
    var l = E && E.nodeName && E.nodeName.toLowerCase()
    return (
      l &&
      ((l === "input" &&
        (E.type === "text" ||
          E.type === "search" ||
          E.type === "tel" ||
          E.type === "url" ||
          E.type === "password")) ||
        l === "textarea" ||
        E.contentEditable === "true")
    )
  }
  function $e(E) {
    var l = he(),
      p = E.focusedElem,
      U = E.selectionRange
    if (l !== p && p && p.ownerDocument && GE(p.ownerDocument.documentElement, p)) {
      if (U !== null && xe(p)) {
        if (((l = U.start), (E = U.end), E === void 0 && (E = l), "selectionStart" in p))
          ((p.selectionStart = l), (p.selectionEnd = Math.min(E, p.value.length)))
        else if (
          ((E = ((l = p.ownerDocument || document) && l.defaultView) || window), E.getSelection)
        ) {
          E = E.getSelection()
          var q = p.textContent.length,
            Z = Math.min(U.start, q)
          ;((U = U.end === void 0 ? Z : Math.min(U.end, q)),
            !E.extend && Z > U && ((q = U), (U = Z), (Z = q)),
            (q = ti(p, Z)))
          var oA = ti(p, U)
          q &&
            oA &&
            (E.rangeCount !== 1 ||
              E.anchorNode !== q.node ||
              E.anchorOffset !== q.offset ||
              E.focusNode !== oA.node ||
              E.focusOffset !== oA.offset) &&
            ((l = l.createRange()),
            l.setStart(q.node, q.offset),
            E.removeAllRanges(),
            Z > U
              ? (E.addRange(l), E.extend(oA.node, oA.offset))
              : (l.setEnd(oA.node, oA.offset), E.addRange(l)))
        }
      }
      for (l = [], E = p; (E = E.parentNode); )
        E.nodeType === 1 && l.push({ element: E, left: E.scrollLeft, top: E.scrollTop })
      for (typeof p.focus == "function" && p.focus(), p = 0; p < l.length; p++)
        ((E = l[p]), (E.element.scrollLeft = E.left), (E.element.scrollTop = E.top))
    }
  }
  var Va = o && "documentMode" in document && 11 >= document.documentMode,
    Lt = null,
    ga = null,
    Yn = null,
    kt = !1
  function Co(E, l, p) {
    var U = p.window === p ? p.document : p.nodeType === 9 ? p : p.ownerDocument
    kt ||
      Lt == null ||
      Lt !== eI(U) ||
      ((U = Lt),
      "selectionStart" in U && xe(U)
        ? (U = { start: U.selectionStart, end: U.selectionEnd })
        : ((U = ((U.ownerDocument && U.ownerDocument.defaultView) || window).getSelection()),
          (U = {
            anchorNode: U.anchorNode,
            anchorOffset: U.anchorOffset,
            focusNode: U.focusNode,
            focusOffset: U.focusOffset,
          })),
      (Yn && vQ(Yn, U)) ||
        ((Yn = U),
        (U = Tn(ga, "onSelect")),
        0 < U.length &&
          ((l = new BC("onSelect", "select", null, l, p)),
          E.push({ event: l, listeners: U }),
          (l.target = Lt))))
  }
  function kE(E, l) {
    var p = {}
    return (
      (p[E.toLowerCase()] = l.toLowerCase()),
      (p["Webkit" + E] = "webkit" + l),
      (p["Moz" + E] = "moz" + l),
      p
    )
  }
  var tn = {
      animationend: kE("Animation", "AnimationEnd"),
      animationiteration: kE("Animation", "AnimationIteration"),
      animationstart: kE("Animation", "AnimationStart"),
      transitionend: kE("Transition", "TransitionEnd"),
    },
    Go = {},
    eo = {}
  o &&
    ((eo = document.createElement("div").style),
    "AnimationEvent" in window ||
      (delete tn.animationend.animation,
      delete tn.animationiteration.animation,
      delete tn.animationstart.animation),
    "TransitionEvent" in window || delete tn.transitionend.transition)
  function yi(E) {
    if (Go[E]) return Go[E]
    if (!tn[E]) return E
    var l = tn[E],
      p
    for (p in l) if (l.hasOwnProperty(p) && p in eo) return (Go[E] = l[p])
    return E
  }
  var ja = yi("animationend"),
    ms = yi("animationiteration"),
    Ca = yi("animationstart"),
    Tl = yi("transitionend"),
    FC = /* @__PURE__ */ new Map(),
    Ai =
      "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
        " ",
      )
  function Ae(E, l) {
    ;(FC.set(E, l), i(l, [E]))
  }
  for (var qi = 0; qi < Ai.length; qi++) {
    var sB = Ai[qi],
      _r = sB.toLowerCase(),
      Zr = sB[0].toUpperCase() + sB.slice(1)
    Ae(_r, "on" + Zr)
  }
  ;(Ae(ja, "onAnimationEnd"),
    Ae(ms, "onAnimationIteration"),
    Ae(Ca, "onAnimationStart"),
    Ae("dblclick", "onDoubleClick"),
    Ae("focusin", "onFocus"),
    Ae("focusout", "onBlur"),
    Ae(Tl, "onTransitionEnd"),
    B("onMouseEnter", ["mouseout", "mouseover"]),
    B("onMouseLeave", ["mouseout", "mouseover"]),
    B("onPointerEnter", ["pointerout", "pointerover"]),
    B("onPointerLeave", ["pointerout", "pointerover"]),
    i("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")),
    i(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " ",
      ),
    ),
    i("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]),
    i("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")),
    i(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" "),
    ),
    i(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" "),
    ))
  var ea =
      "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
        " ",
      ),
    xl = new Set("cancel close invalid load scroll toggle".split(" ").concat(ea))
  function Pr(E, l, p) {
    var U = E.type || "unknown-event"
    ;((E.currentTarget = p), eg(U, l, void 0, E), (E.currentTarget = null))
  }
  function Cg(E, l) {
    l = (l & 4) !== 0
    for (var p = 0; p < E.length; p++) {
      var U = E[p],
        q = U.event
      U = U.listeners
      A: {
        var Z = void 0
        if (l)
          for (var oA = U.length - 1; 0 <= oA; oA--) {
            var KA = U[oA],
              bA = KA.instance,
              kI = KA.currentTarget
            if (((KA = KA.listener), bA !== Z && q.isPropagationStopped())) break A
            ;(Pr(q, KA, kI), (Z = bA))
          }
        else
          for (oA = 0; oA < U.length; oA++) {
            if (
              ((KA = U[oA]),
              (bA = KA.instance),
              (kI = KA.currentTarget),
              (KA = KA.listener),
              bA !== Z && q.isPropagationStopped())
            )
              break A
            ;(Pr(q, KA, kI), (Z = bA))
          }
      }
    }
    if (vi) throw ((E = Li), (vi = !1), (Li = null), E)
  }
  function TC(E, l) {
    var p = l[ta]
    p === void 0 && (p = l[ta] = /* @__PURE__ */ new Set())
    var U = E + "__bubble"
    p.has(U) || (qn(l, E, 2, !1), p.add(U))
  }
  function PC(E, l, p) {
    var U = 0
    ;(l && (U |= 4), qn(p, E, U, l))
  }
  var aQ = "_reactListening" + Math.random().toString(36).slice(2)
  function LQ(E) {
    if (!E[aQ]) {
      ;((E[aQ] = !0),
        g.forEach(function (p) {
          p !== "selectionchange" && (xl.has(p) || PC(p, !1, E), PC(p, !0, E))
        }))
      var l = E.nodeType === 9 ? E : E.ownerDocument
      l === null || l[aQ] || ((l[aQ] = !0), PC("selectionchange", !1, l))
    }
  }
  function qn(E, l, p, U) {
    switch (gn(l)) {
      case 1:
        var q = QQ
        break
      case 4:
        q = jt
        break
      default:
        q = Ao
    }
    ;((p = q.bind(null, l, p, E)),
      (q = void 0),
      !zC || (l !== "touchstart" && l !== "touchmove" && l !== "wheel") || (q = !0),
      U
        ? q !== void 0
          ? E.addEventListener(l, p, { capture: !0, passive: q })
          : E.addEventListener(l, p, !0)
        : q !== void 0
          ? E.addEventListener(l, p, { passive: q })
          : E.addEventListener(l, p, !1))
  }
  function io(E, l, p, U, q) {
    var Z = U
    if (!(l & 1) && !(l & 2) && U !== null)
      A: for (;;) {
        if (U === null) return
        var oA = U.tag
        if (oA === 3 || oA === 4) {
          var KA = U.stateNode.containerInfo
          if (KA === q || (KA.nodeType === 8 && KA.parentNode === q)) break
          if (oA === 4)
            for (oA = U.return; oA !== null; ) {
              var bA = oA.tag
              if (
                (bA === 3 || bA === 4) &&
                ((bA = oA.stateNode.containerInfo),
                bA === q || (bA.nodeType === 8 && bA.parentNode === q))
              )
                return
              oA = oA.return
            }
          for (; KA !== null; ) {
            if (((oA = wB(KA)), oA === null)) return
            if (((bA = oA.tag), bA === 5 || bA === 6)) {
              U = Z = oA
              continue A
            }
            KA = KA.parentNode
          }
        }
        U = U.return
      }
    jC(function () {
      var kI = Z,
        tg = SA(p),
        Eg = []
      A: {
        var Ig = FC.get(E)
        if (Ig !== void 0) {
          var Ug = BC,
            Wg = E
          switch (E) {
            case "keypress":
              if (mI(p) === 0) break A
            case "keydown":
            case "keyup":
              Ug = Yl
              break
            case "focusin":
              ;((Wg = "focus"), (Ug = fo))
              break
            case "focusout":
              ;((Wg = "blur"), (Ug = fo))
              break
            case "beforeblur":
            case "afterblur":
              Ug = fo
              break
            case "click":
              if (p.button === 2) break A
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Ug = Io
              break
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Ug = So
              break
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Ug = dE
              break
            case ja:
            case ms:
            case Ca:
              Ug = br
              break
            case Tl:
              Ug = Aa
              break
            case "scroll":
              Ug = KC
              break
            case "wheel":
              Ug = Cn
              break
            case "copy":
            case "cut":
            case "paste":
              Ug = Jl
              break
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Ug = oQ
          }
          var Xg = (l & 4) !== 0,
            Ft = !Xg && E === "scroll",
            lI = Xg ? (Ig !== null ? Ig + "Capture" : null) : Ig
          Xg = []
          for (var XA = kI, wI; XA !== null; ) {
            wI = XA
            var Dg = wI.stateNode
            if (
              (wI.tag === 5 &&
                Dg !== null &&
                ((wI = Dg),
                lI !== null && ((Dg = mC(XA, lI)), Dg != null && Xg.push(Hn(XA, Dg, wI)))),
              Ft)
            )
              break
            XA = XA.return
          }
          0 < Xg.length &&
            ((Ig = new Ug(Ig, Wg, null, p, tg)), Eg.push({ event: Ig, listeners: Xg }))
        }
      }
      if (!(l & 7)) {
        A: {
          if (
            ((Ig = E === "mouseover" || E === "pointerover"),
            (Ug = E === "mouseout" || E === "pointerout"),
            Ig && p !== $I && (Wg = p.relatedTarget || p.fromElement) && (wB(Wg) || Wg[sQ]))
          )
            break A
          if (
            (Ug || Ig) &&
            ((Ig =
              tg.window === tg
                ? tg
                : (Ig = tg.ownerDocument)
                  ? Ig.defaultView || Ig.parentWindow
                  : window),
            Ug
              ? ((Wg = p.relatedTarget || p.toElement),
                (Ug = kI),
                (Wg = Wg ? wB(Wg) : null),
                Wg !== null &&
                  ((Ft = Tg(Wg)), Wg !== Ft || (Wg.tag !== 5 && Wg.tag !== 6)) &&
                  (Wg = null))
              : ((Ug = null), (Wg = kI)),
            Ug !== Wg)
          ) {
            if (
              ((Xg = Io),
              (Dg = "onMouseLeave"),
              (lI = "onMouseEnter"),
              (XA = "mouse"),
              (E === "pointerout" || E === "pointerover") &&
                ((Xg = oQ), (Dg = "onPointerLeave"), (lI = "onPointerEnter"), (XA = "pointer")),
              (Ft = Ug == null ? Ig : Re(Ug)),
              (wI = Wg == null ? Ig : Re(Wg)),
              (Ig = new Xg(Dg, XA + "leave", Ug, p, tg)),
              (Ig.target = Ft),
              (Ig.relatedTarget = wI),
              (Dg = null),
              wB(tg) === kI &&
                ((Xg = new Xg(lI, XA + "enter", Wg, p, tg)),
                (Xg.target = wI),
                (Xg.relatedTarget = Ft),
                (Dg = Xg)),
              (Ft = Dg),
              Ug && Wg)
            )
              I: {
                for (Xg = Ug, lI = Wg, XA = 0, wI = Xg; wI; wI = ko(wI)) XA++
                for (wI = 0, Dg = lI; Dg; Dg = ko(Dg)) wI++
                for (; 0 < XA - wI; ) ((Xg = ko(Xg)), XA--)
                for (; 0 < wI - XA; ) ((lI = ko(lI)), wI--)
                for (; XA--; ) {
                  if (Xg === lI || (lI !== null && Xg === lI.alternate)) break I
                  ;((Xg = ko(Xg)), (lI = ko(lI)))
                }
                Xg = null
              }
            else Xg = null
            ;(Ug !== null && vs(Eg, Ig, Ug, Xg, !1),
              Wg !== null && Ft !== null && vs(Eg, Ft, Wg, Xg, !0))
          }
        }
        A: {
          if (
            ((Ig = kI ? Re(kI) : window),
            (Ug = Ig.nodeName && Ig.nodeName.toLowerCase()),
            Ug === "select" || (Ug === "input" && Ig.type === "file"))
          )
            var gC = Rs
          else if (Or(Ig))
            if (_a) gC = Fi
            else {
              gC = Ks
              var lC = Pa
            }
          else
            (Ug = Ig.nodeName) &&
              Ug.toLowerCase() === "input" &&
              (Ig.type === "checkbox" || Ig.type === "radio") &&
              (gC = go)
          if (gC && (gC = gC(E, kI))) {
            Ia(Eg, gC, p, tg)
            break A
          }
          ;(lC && lC(E, Ig, kI),
            E === "focusout" &&
              (lC = Ig._wrapperState) &&
              lC.controlled &&
              Ig.type === "number" &&
              YI(Ig, "number", Ig.value))
        }
        switch (((lC = kI ? Re(kI) : window), E)) {
          case "focusin":
            ;(Or(lC) || lC.contentEditable === "true") && ((Lt = lC), (ga = kI), (Yn = null))
            break
          case "focusout":
            Yn = ga = Lt = null
            break
          case "mousedown":
            kt = !0
            break
          case "contextmenu":
          case "mouseup":
          case "dragend":
            ;((kt = !1), Co(Eg, p, tg))
            break
          case "selectionchange":
            if (Va) break
          case "keydown":
          case "keyup":
            Co(Eg, p, tg)
        }
        var Vg
        if (Xi)
          A: {
            switch (E) {
              case "compositionstart":
                var dC = "onCompositionStart"
                break A
              case "compositionend":
                dC = "onCompositionEnd"
                break A
              case "compositionupdate":
                dC = "onCompositionUpdate"
                break A
            }
            dC = void 0
          }
        else
          yE
            ? Hl(E, p) && (dC = "onCompositionEnd")
            : E === "keydown" && p.keyCode === 229 && (dC = "onCompositionStart")
        ;(dC &&
          (xa &&
            p.locale !== "ko" &&
            (yE || dC !== "onCompositionStart"
              ? dC === "onCompositionEnd" && yE && (Vg = rI())
              : ((yB = tg), (iA = "value" in yB ? yB.value : yB.textContent), (yE = !0))),
          (lC = Tn(kI, dC)),
          0 < lC.length &&
            ((dC = new ml(dC, E, null, p, tg)),
            Eg.push({ event: dC, listeners: lC }),
            Vg ? (dC.data = Vg) : ((Vg = ba(p)), Vg !== null && (dC.data = Vg)))),
          (Vg = ri ? Wc(E, p) : Fs(E, p)) &&
            ((kI = Tn(kI, "onBeforeInput")),
            0 < kI.length &&
              ((tg = new ml("onBeforeInput", "beforeinput", null, p, tg)),
              Eg.push({ event: tg, listeners: kI }),
              (tg.data = Vg))))
      }
      Cg(Eg, l)
    })
  }
  function Hn(E, l, p) {
    return { instance: E, listener: l, currentTarget: p }
  }
  function Tn(E, l) {
    for (var p = l + "Capture", U = []; E !== null; ) {
      var q = E,
        Z = q.stateNode
      ;(q.tag === 5 &&
        Z !== null &&
        ((q = Z),
        (Z = mC(E, p)),
        Z != null && U.unshift(Hn(E, Z, q)),
        (Z = mC(E, l)),
        Z != null && U.push(Hn(E, Z, q))),
        (E = E.return))
    }
    return U
  }
  function ko(E) {
    if (E === null) return null
    do E = E.return
    while (E && E.tag !== 5)
    return E || null
  }
  function vs(E, l, p, U, q) {
    for (var Z = l._reactName, oA = []; p !== null && p !== U; ) {
      var KA = p,
        bA = KA.alternate,
        kI = KA.stateNode
      if (bA !== null && bA === U) break
      ;(KA.tag === 5 &&
        kI !== null &&
        ((KA = kI),
        q
          ? ((bA = mC(p, Z)), bA != null && oA.unshift(Hn(p, bA, KA)))
          : q || ((bA = mC(p, Z)), bA != null && oA.push(Hn(p, bA, KA)))),
        (p = p.return))
    }
    oA.length !== 0 && E.push({ event: l, listeners: oA })
  }
  var Ls = /\r\n?/g,
    bl = /\u0000|\uFFFD/g
  function Wr(E) {
    return (typeof E == "string" ? E : "" + E)
      .replace(
        Ls,
        `
`,
      )
      .replace(bl, "")
  }
  function za(E, l, p) {
    if (((l = Wr(l)), Wr(E) !== l && p)) throw Error(I(425))
  }
  function Xa() {}
  var ia = null,
    ME = null
  function $a(E, l) {
    return (
      E === "textarea" ||
      E === "noscript" ||
      typeof l.children == "string" ||
      typeof l.children == "number" ||
      (typeof l.dangerouslySetInnerHTML == "object" &&
        l.dangerouslySetInnerHTML !== null &&
        l.dangerouslySetInnerHTML.__html != null)
    )
  }
  var UE = typeof setTimeout == "function" ? setTimeout : void 0,
    Vr = typeof clearTimeout == "function" ? clearTimeout : void 0,
    Ar = typeof Promise == "function" ? Promise : void 0,
    Ys =
      typeof queueMicrotask == "function"
        ? queueMicrotask
        : typeof Ar < "u"
          ? function (E) {
              return Ar.resolve(null).then(E).catch(Ol)
            }
          : UE
  function Ol(E) {
    setTimeout(function () {
      throw E
    })
  }
  function Bn(E, l) {
    var p = l,
      U = 0
    do {
      var q = p.nextSibling
      if ((E.removeChild(p), q && q.nodeType === 8))
        if (((p = q.data), p === "/$")) {
          if (U === 0) {
            ;(E.removeChild(q), An(l))
            return
          }
          U--
        } else (p !== "$" && p !== "$?" && p !== "$!") || U++
      p = q
    } while (p)
    An(l)
  }
  function rQ(E) {
    for (; E != null; E = E.nextSibling) {
      var l = E.nodeType
      if (l === 1 || l === 3) break
      if (l === 8) {
        if (((l = E.data), l === "$" || l === "$!" || l === "$?")) break
        if (l === "/$") return null
      }
    }
    return E
  }
  function Qn(E) {
    E = E.previousSibling
    for (var l = 0; E; ) {
      if (E.nodeType === 8) {
        var p = E.data
        if (p === "$" || p === "$!" || p === "$?") {
          if (l === 0) return E
          l--
        } else p === "/$" && l++
      }
      E = E.previousSibling
    }
    return null
  }
  var on = Math.random().toString(36).slice(2),
    Mt = "__reactFiber$" + on,
    xn = "__reactProps$" + on,
    sQ = "__reactContainer$" + on,
    ta = "__reactEvents$" + on,
    Ba = "__reactListeners$" + on,
    Ir = "__reactHandles$" + on
  function wB(E) {
    var l = E[Mt]
    if (l) return l
    for (var p = E.parentNode; p; ) {
      if ((l = p[sQ] || p[Mt])) {
        if (((p = l.alternate), l.child !== null || (p !== null && p.child !== null)))
          for (E = Qn(E); E !== null; ) {
            if ((p = E[Mt])) return p
            E = Qn(E)
          }
        return l
      }
      ;((E = p), (p = E.parentNode))
    }
    return null
  }
  function lQ(E) {
    return (
      (E = E[Mt] || E[sQ]),
      !E || (E.tag !== 5 && E.tag !== 6 && E.tag !== 13 && E.tag !== 3) ? null : E
    )
  }
  function Re(E) {
    if (E.tag === 5 || E.tag === 6) return E.stateNode
    throw Error(I(33))
  }
  function nC(E) {
    return E[xn] || null
  }
  var Je = [],
    te = -1
  function IC(E) {
    return { current: E }
  }
  function de(E) {
    0 > te || ((E.current = Je[te]), (Je[te] = null), te--)
  }
  function Ue(E, l) {
    ;(te++, (Je[te] = E.current), (E.current = l))
  }
  var nn = {},
    kC = IC(nn),
    At = IC(!1),
    bB = nn
  function cQ(E, l) {
    var p = E.type.contextTypes
    if (!p) return nn
    var U = E.stateNode
    if (U && U.__reactInternalMemoizedUnmaskedChildContext === l)
      return U.__reactInternalMemoizedMaskedChildContext
    var q = {},
      Z
    for (Z in p) q[Z] = l[Z]
    return (
      U &&
        ((E = E.stateNode),
        (E.__reactInternalMemoizedUnmaskedChildContext = l),
        (E.__reactInternalMemoizedMaskedChildContext = q)),
      q
    )
  }
  function Ri(E) {
    return ((E = E.childContextTypes), E != null)
  }
  function hQ() {
    ;(de(At), de(kC))
  }
  function bn(E, l, p) {
    if (kC.current !== nn) throw Error(I(168))
    ;(Ue(kC, l), Ue(At, p))
  }
  function Qa(E, l, p) {
    var U = E.stateNode
    if (((l = l.childContextTypes), typeof U.getChildContext != "function")) return p
    U = U.getChildContext()
    for (var q in U) if (!(q in l)) throw Error(I(108, NA(E) || "Unknown", q))
    return sA({}, p, U)
  }
  function On(E) {
    return (
      (E = ((E = E.stateNode) && E.__reactInternalMemoizedMergedChildContext) || nn),
      (bB = kC.current),
      Ue(kC, E),
      Ue(At, At.current),
      !0
    )
  }
  function Vc(E, l, p) {
    var U = E.stateNode
    if (!U) throw Error(I(169))
    ;(p
      ? ((E = Qa(E, l, bB)),
        (U.__reactInternalMemoizedMergedChildContext = E),
        de(At),
        de(kC),
        Ue(kC, E))
      : de(At),
      Ue(At, p))
  }
  var OB = null,
    Xt = !1,
    jr = !1
  function Mo(E) {
    OB === null ? (OB = [E]) : OB.push(E)
  }
  function oa(E) {
    ;((Xt = !0), Mo(E))
  }
  function st() {
    if (!jr && OB !== null) {
      jr = !0
      var E = 0,
        l = XC
      try {
        var p = OB
        for (XC = 1; E < p.length; E++) {
          var U = p[E]
          do U = U(!0)
          while (U !== null)
        }
        ;((OB = null), (Xt = !1))
      } catch (q) {
        throw (OB !== null && (OB = OB.slice(E + 1)), oI(yg, st), q)
      } finally {
        ;((XC = l), (jr = !1))
      }
    }
    return null
  }
  var En = [],
    Ne = 0,
    Uo = null,
    LC = 0,
    Yt = [],
    It = 0,
    an = null,
    lg = 1,
    YQ = ""
  function $t(E, l) {
    ;((En[Ne++] = LC), (En[Ne++] = Uo), (Uo = E), (LC = l))
  }
  function _l(E, l, p) {
    ;((Yt[It++] = lg), (Yt[It++] = YQ), (Yt[It++] = an), (an = E))
    var U = lg
    E = YQ
    var q = 32 - iC(U) - 1
    ;((U &= ~(1 << q)), (p += 1))
    var Z = 32 - iC(l) + q
    if (30 < Z) {
      var oA = q - (q % 5)
      ;((Z = (U & ((1 << oA) - 1)).toString(32)),
        (U >>= oA),
        (q -= oA),
        (lg = (1 << (32 - iC(l) + q)) | (p << q) | U),
        (YQ = Z + E))
    } else ((lg = (1 << Z) | (p << q) | U), (YQ = E))
  }
  function qs(E) {
    E.return !== null && ($t(E, 1), _l(E, 1, 0))
  }
  function NE(E) {
    for (; E === Uo; ) ((Uo = En[--Ne]), (En[Ne] = null), (LC = En[--Ne]), (En[Ne] = null))
    for (; E === an; )
      ((an = Yt[--It]),
        (Yt[It] = null),
        (YQ = Yt[--It]),
        (Yt[It] = null),
        (lg = Yt[--It]),
        (Yt[It] = null))
  }
  var AB = null,
    _B = null,
    pi = !1,
    qQ = null
  function to(E, l) {
    var p = Yo(5, null, null, 0)
    ;((p.elementType = "DELETED"),
      (p.stateNode = l),
      (p.return = E),
      (l = E.deletions),
      l === null ? ((E.deletions = [p]), (E.flags |= 16)) : l.push(p))
  }
  function gr(E, l) {
    switch (E.tag) {
      case 5:
        var p = E.type
        return (
          (l = l.nodeType !== 1 || p.toLowerCase() !== l.nodeName.toLowerCase() ? null : l),
          l !== null ? ((E.stateNode = l), (AB = E), (_B = rQ(l.firstChild)), !0) : !1
        )
      case 6:
        return (
          (l = E.pendingProps === "" || l.nodeType !== 3 ? null : l),
          l !== null ? ((E.stateNode = l), (AB = E), (_B = null), !0) : !1
        )
      case 13:
        return (
          (l = l.nodeType !== 8 ? null : l),
          l !== null
            ? ((p = an !== null ? { id: lg, overflow: YQ } : null),
              (E.memoizedState = { dehydrated: l, treeContext: p, retryLane: 1073741824 }),
              (p = Yo(18, null, null, 0)),
              (p.stateNode = l),
              (p.return = E),
              (E.child = p),
              (AB = E),
              (_B = null),
              !0)
            : !1
        )
      default:
        return !1
    }
  }
  function FE(E) {
    return (E.mode & 1) !== 0 && (E.flags & 128) === 0
  }
  function Cr(E) {
    if (pi) {
      var l = _B
      if (l) {
        var p = l
        if (!gr(E, l)) {
          if (FE(E)) throw Error(I(418))
          l = rQ(p.nextSibling)
          var U = AB
          l && gr(E, l) ? to(U, p) : ((E.flags = (E.flags & -4097) | 2), (pi = !1), (AB = E))
        }
      } else {
        if (FE(E)) throw Error(I(418))
        ;((E.flags = (E.flags & -4097) | 2), (pi = !1), (AB = E))
      }
    }
  }
  function na(E) {
    for (E = E.return; E !== null && E.tag !== 5 && E.tag !== 3 && E.tag !== 13; ) E = E.return
    AB = E
  }
  function ZB(E) {
    if (E !== AB) return !1
    if (!pi) return (na(E), (pi = !0), !1)
    var l
    if (
      ((l = E.tag !== 3) &&
        !(l = E.tag !== 5) &&
        ((l = E.type), (l = l !== "head" && l !== "body" && !$a(E.type, E.memoizedProps))),
      l && (l = _B))
    ) {
      if (FE(E)) throw (qt(), Error(I(418)))
      for (; l; ) (to(E, l), (l = rQ(l.nextSibling)))
    }
    if ((na(E), E.tag === 13)) {
      if (((E = E.memoizedState), (E = E !== null ? E.dehydrated : null), !E)) throw Error(I(317))
      A: {
        for (E = E.nextSibling, l = 0; E; ) {
          if (E.nodeType === 8) {
            var p = E.data
            if (p === "/$") {
              if (l === 0) {
                _B = rQ(E.nextSibling)
                break A
              }
              l--
            } else (p !== "$" && p !== "$!" && p !== "$?") || l++
          }
          E = E.nextSibling
        }
        _B = null
      }
    } else _B = AB ? rQ(E.stateNode.nextSibling) : null
    return !0
  }
  function qt() {
    for (var E = _B; E; ) E = rQ(E.nextSibling)
  }
  function Hi() {
    ;((_B = AB = null), (pi = !1))
  }
  function zr(E) {
    qQ === null ? (qQ = [E]) : qQ.push(E)
  }
  var Zl = H.ReactCurrentBatchConfig
  function Ea(E, l, p) {
    if (((E = p.ref), E !== null && typeof E != "function" && typeof E != "object")) {
      if (p._owner) {
        if (((p = p._owner), p)) {
          if (p.tag !== 1) throw Error(I(309))
          var U = p.stateNode
        }
        if (!U) throw Error(I(147, E))
        var q = U,
          Z = "" + E
        return l !== null && l.ref !== null && typeof l.ref == "function" && l.ref._stringRef === Z
          ? l.ref
          : ((l = function (oA) {
              var KA = q.refs
              oA === null ? delete KA[Z] : (KA[Z] = oA)
            }),
            (l._stringRef = Z),
            l)
      }
      if (typeof E != "string") throw Error(I(284))
      if (!p._owner) throw Error(I(290, E))
    }
    return E
  }
  function No(E, l) {
    throw (
      (E = Object.prototype.toString.call(l)),
      Error(
        I(31, E === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : E),
      )
    )
  }
  function Pl(E) {
    var l = E._init
    return l(E._payload)
  }
  function Hs(E) {
    function l(lI, XA) {
      if (E) {
        var wI = lI.deletions
        wI === null ? ((lI.deletions = [XA]), (lI.flags |= 16)) : wI.push(XA)
      }
    }
    function p(lI, XA) {
      if (!E) return null
      for (; XA !== null; ) (l(lI, XA), (XA = XA.sibling))
      return null
    }
    function U(lI, XA) {
      for (lI = /* @__PURE__ */ new Map(); XA !== null; )
        (XA.key !== null ? lI.set(XA.key, XA) : lI.set(XA.index, XA), (XA = XA.sibling))
      return lI
    }
    function q(lI, XA) {
      return ((lI = os(lI, XA)), (lI.index = 0), (lI.sibling = null), lI)
    }
    function Z(lI, XA, wI) {
      return (
        (lI.index = wI),
        E
          ? ((wI = lI.alternate),
            wI !== null
              ? ((wI = wI.index), wI < XA ? ((lI.flags |= 2), XA) : wI)
              : ((lI.flags |= 2), XA))
          : ((lI.flags |= 1048576), XA)
      )
    }
    function oA(lI) {
      return (E && lI.alternate === null && (lI.flags |= 2), lI)
    }
    function KA(lI, XA, wI, Dg) {
      return XA === null || XA.tag !== 6
        ? ((XA = Il(wI, lI.mode, Dg)), (XA.return = lI), XA)
        : ((XA = q(XA, wI)), (XA.return = lI), XA)
    }
    function bA(lI, XA, wI, Dg) {
      var gC = wI.type
      return gC === P
        ? tg(lI, XA, wI.props.children, Dg, wI.key)
        : XA !== null &&
            (XA.elementType === gC ||
              (typeof gC == "object" && gC !== null && gC.$$typeof === yA && Pl(gC) === XA.type))
          ? ((Dg = q(XA, wI.props)), (Dg.ref = Ea(lI, XA, wI)), (Dg.return = lI), Dg)
          : ((Dg = TE(wI.type, wI.key, wI.props, null, lI.mode, Dg)),
            (Dg.ref = Ea(lI, XA, wI)),
            (Dg.return = lI),
            Dg)
    }
    function kI(lI, XA, wI, Dg) {
      return XA === null ||
        XA.tag !== 4 ||
        XA.stateNode.containerInfo !== wI.containerInfo ||
        XA.stateNode.implementation !== wI.implementation
        ? ((XA = qo(wI, lI.mode, Dg)), (XA.return = lI), XA)
        : ((XA = q(XA, wI.children || [])), (XA.return = lI), XA)
    }
    function tg(lI, XA, wI, Dg, gC) {
      return XA === null || XA.tag !== 7
        ? ((XA = IE(wI, lI.mode, Dg, gC)), (XA.return = lI), XA)
        : ((XA = q(XA, wI)), (XA.return = lI), XA)
    }
    function Eg(lI, XA, wI) {
      if ((typeof XA == "string" && XA !== "") || typeof XA == "number")
        return ((XA = Il("" + XA, lI.mode, wI)), (XA.return = lI), XA)
      if (typeof XA == "object" && XA !== null) {
        switch (XA.$$typeof) {
          case V:
            return (
              (wI = TE(XA.type, XA.key, XA.props, null, lI.mode, wI)),
              (wI.ref = Ea(lI, null, XA)),
              (wI.return = lI),
              wI
            )
          case j:
            return ((XA = qo(XA, lI.mode, wI)), (XA.return = lI), XA)
          case yA:
            var Dg = XA._init
            return Eg(lI, Dg(XA._payload), wI)
        }
        if (SI(XA) || fA(XA)) return ((XA = IE(XA, lI.mode, wI, null)), (XA.return = lI), XA)
        No(lI, XA)
      }
      return null
    }
    function Ig(lI, XA, wI, Dg) {
      var gC = XA !== null ? XA.key : null
      if ((typeof wI == "string" && wI !== "") || typeof wI == "number")
        return gC !== null ? null : KA(lI, XA, "" + wI, Dg)
      if (typeof wI == "object" && wI !== null) {
        switch (wI.$$typeof) {
          case V:
            return wI.key === gC ? bA(lI, XA, wI, Dg) : null
          case j:
            return wI.key === gC ? kI(lI, XA, wI, Dg) : null
          case yA:
            return ((gC = wI._init), Ig(lI, XA, gC(wI._payload), Dg))
        }
        if (SI(wI) || fA(wI)) return gC !== null ? null : tg(lI, XA, wI, Dg, null)
        No(lI, wI)
      }
      return null
    }
    function Ug(lI, XA, wI, Dg, gC) {
      if ((typeof Dg == "string" && Dg !== "") || typeof Dg == "number")
        return ((lI = lI.get(wI) || null), KA(XA, lI, "" + Dg, gC))
      if (typeof Dg == "object" && Dg !== null) {
        switch (Dg.$$typeof) {
          case V:
            return ((lI = lI.get(Dg.key === null ? wI : Dg.key) || null), bA(XA, lI, Dg, gC))
          case j:
            return ((lI = lI.get(Dg.key === null ? wI : Dg.key) || null), kI(XA, lI, Dg, gC))
          case yA:
            var lC = Dg._init
            return Ug(lI, XA, wI, lC(Dg._payload), gC)
        }
        if (SI(Dg) || fA(Dg)) return ((lI = lI.get(wI) || null), tg(XA, lI, Dg, gC, null))
        No(XA, Dg)
      }
      return null
    }
    function Wg(lI, XA, wI, Dg) {
      for (
        var gC = null, lC = null, Vg = XA, dC = (XA = 0), hB = null;
        Vg !== null && dC < wI.length;
        dC++
      ) {
        Vg.index > dC ? ((hB = Vg), (Vg = null)) : (hB = Vg.sibling)
        var _e = Ig(lI, Vg, wI[dC], Dg)
        if (_e === null) {
          Vg === null && (Vg = hB)
          break
        }
        ;(E && Vg && _e.alternate === null && l(lI, Vg),
          (XA = Z(_e, XA, dC)),
          lC === null ? (gC = _e) : (lC.sibling = _e),
          (lC = _e),
          (Vg = hB))
      }
      if (dC === wI.length) return (p(lI, Vg), pi && $t(lI, dC), gC)
      if (Vg === null) {
        for (; dC < wI.length; dC++)
          ((Vg = Eg(lI, wI[dC], Dg)),
            Vg !== null &&
              ((XA = Z(Vg, XA, dC)), lC === null ? (gC = Vg) : (lC.sibling = Vg), (lC = Vg)))
        return (pi && $t(lI, dC), gC)
      }
      for (Vg = U(lI, Vg); dC < wI.length; dC++)
        ((hB = Ug(Vg, lI, dC, wI[dC], Dg)),
          hB !== null &&
            (E && hB.alternate !== null && Vg.delete(hB.key === null ? dC : hB.key),
            (XA = Z(hB, XA, dC)),
            lC === null ? (gC = hB) : (lC.sibling = hB),
            (lC = hB)))
      return (
        E &&
          Vg.forEach(function (da) {
            return l(lI, da)
          }),
        pi && $t(lI, dC),
        gC
      )
    }
    function Xg(lI, XA, wI, Dg) {
      var gC = fA(wI)
      if (typeof gC != "function") throw Error(I(150))
      if (((wI = gC.call(wI)), wI == null)) throw Error(I(151))
      for (
        var lC = (gC = null), Vg = XA, dC = (XA = 0), hB = null, _e = wI.next();
        Vg !== null && !_e.done;
        dC++, _e = wI.next()
      ) {
        Vg.index > dC ? ((hB = Vg), (Vg = null)) : (hB = Vg.sibling)
        var da = Ig(lI, Vg, _e.value, Dg)
        if (da === null) {
          Vg === null && (Vg = hB)
          break
        }
        ;(E && Vg && da.alternate === null && l(lI, Vg),
          (XA = Z(da, XA, dC)),
          lC === null ? (gC = da) : (lC.sibling = da),
          (lC = da),
          (Vg = hB))
      }
      if (_e.done) return (p(lI, Vg), pi && $t(lI, dC), gC)
      if (Vg === null) {
        for (; !_e.done; dC++, _e = wI.next())
          ((_e = Eg(lI, _e.value, Dg)),
            _e !== null &&
              ((XA = Z(_e, XA, dC)), lC === null ? (gC = _e) : (lC.sibling = _e), (lC = _e)))
        return (pi && $t(lI, dC), gC)
      }
      for (Vg = U(lI, Vg); !_e.done; dC++, _e = wI.next())
        ((_e = Ug(Vg, lI, dC, _e.value, Dg)),
          _e !== null &&
            (E && _e.alternate !== null && Vg.delete(_e.key === null ? dC : _e.key),
            (XA = Z(_e, XA, dC)),
            lC === null ? (gC = _e) : (lC.sibling = _e),
            (lC = _e)))
      return (
        E &&
          Vg.forEach(function (lh) {
            return l(lI, lh)
          }),
        pi && $t(lI, dC),
        gC
      )
    }
    function Ft(lI, XA, wI, Dg) {
      if (
        (typeof wI == "object" &&
          wI !== null &&
          wI.type === P &&
          wI.key === null &&
          (wI = wI.props.children),
        typeof wI == "object" && wI !== null)
      ) {
        switch (wI.$$typeof) {
          case V:
            A: {
              for (var gC = wI.key, lC = XA; lC !== null; ) {
                if (lC.key === gC) {
                  if (((gC = wI.type), gC === P)) {
                    if (lC.tag === 7) {
                      ;(p(lI, lC.sibling),
                        (XA = q(lC, wI.props.children)),
                        (XA.return = lI),
                        (lI = XA))
                      break A
                    }
                  } else if (
                    lC.elementType === gC ||
                    (typeof gC == "object" &&
                      gC !== null &&
                      gC.$$typeof === yA &&
                      Pl(gC) === lC.type)
                  ) {
                    ;(p(lI, lC.sibling),
                      (XA = q(lC, wI.props)),
                      (XA.ref = Ea(lI, lC, wI)),
                      (XA.return = lI),
                      (lI = XA))
                    break A
                  }
                  p(lI, lC)
                  break
                } else l(lI, lC)
                lC = lC.sibling
              }
              wI.type === P
                ? ((XA = IE(wI.props.children, lI.mode, Dg, wI.key)), (XA.return = lI), (lI = XA))
                : ((Dg = TE(wI.type, wI.key, wI.props, null, lI.mode, Dg)),
                  (Dg.ref = Ea(lI, XA, wI)),
                  (Dg.return = lI),
                  (lI = Dg))
            }
            return oA(lI)
          case j:
            A: {
              for (lC = wI.key; XA !== null; ) {
                if (XA.key === lC)
                  if (
                    XA.tag === 4 &&
                    XA.stateNode.containerInfo === wI.containerInfo &&
                    XA.stateNode.implementation === wI.implementation
                  ) {
                    ;(p(lI, XA.sibling),
                      (XA = q(XA, wI.children || [])),
                      (XA.return = lI),
                      (lI = XA))
                    break A
                  } else {
                    p(lI, XA)
                    break
                  }
                else l(lI, XA)
                XA = XA.sibling
              }
              ;((XA = qo(wI, lI.mode, Dg)), (XA.return = lI), (lI = XA))
            }
            return oA(lI)
          case yA:
            return ((lC = wI._init), Ft(lI, XA, lC(wI._payload), Dg))
        }
        if (SI(wI)) return Wg(lI, XA, wI, Dg)
        if (fA(wI)) return Xg(lI, XA, wI, Dg)
        No(lI, wI)
      }
      return (typeof wI == "string" && wI !== "") || typeof wI == "number"
        ? ((wI = "" + wI),
          XA !== null && XA.tag === 6
            ? (p(lI, XA.sibling), (XA = q(XA, wI)), (XA.return = lI), (lI = XA))
            : (p(lI, XA), (XA = Il(wI, lI.mode, Dg)), (XA.return = lI), (lI = XA)),
          oA(lI))
        : p(lI, XA)
    }
    return Ft
  }
  var er = Hs(!0),
    Ts = Hs(!1),
    Bi = IC(null),
    Ti = null,
    fg = null,
    Ht = null
  function lB() {
    Ht = fg = Ti = null
  }
  function xs(E) {
    var l = Bi.current
    ;(de(Bi), (E._currentValue = l))
  }
  function bs(E, l, p) {
    for (; E !== null; ) {
      var U = E.alternate
      if (
        ((E.childLanes & l) !== l
          ? ((E.childLanes |= l), U !== null && (U.childLanes |= l))
          : U !== null && (U.childLanes & l) !== l && (U.childLanes |= l),
        E === p)
      )
        break
      E = E.return
    }
  }
  function Bo(E, l) {
    ;((Ti = E),
      (Ht = fg = null),
      (E = E.dependencies),
      E !== null && E.firstContext !== null && (E.lanes & l && (Be = !0), (E.firstContext = null)))
  }
  function si(E) {
    var l = E._currentValue
    if (Ht !== E)
      if (((E = { context: E, memoizedValue: l, next: null }), fg === null)) {
        if (Ti === null) throw Error(I(308))
        ;((fg = E), (Ti.dependencies = { lanes: 0, firstContext: E }))
      } else fg = fg.next = E
    return l
  }
  var wg = null
  function Qi(E) {
    wg === null ? (wg = [E]) : wg.push(E)
  }
  function uQ(E, l, p, U) {
    var q = l.interleaved
    return (
      q === null ? ((p.next = p), Qi(l)) : ((p.next = q.next), (q.next = p)),
      (l.interleaved = p),
      rn(E, U)
    )
  }
  function rn(E, l) {
    E.lanes |= l
    var p = E.alternate
    for (p !== null && (p.lanes |= l), p = E, E = E.return; E !== null; )
      ((E.childLanes |= l),
        (p = E.alternate),
        p !== null && (p.childLanes |= l),
        (p = E),
        (E = E.return))
    return p.tag === 3 ? p.stateNode : null
  }
  var li = !1
  function $C(E) {
    E.updateQueue = {
      baseState: E.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, interleaved: null, lanes: 0 },
      effects: null,
    }
  }
  function xi(E, l) {
    ;((E = E.updateQueue),
      l.updateQueue === E &&
        (l.updateQueue = {
          baseState: E.baseState,
          firstBaseUpdate: E.firstBaseUpdate,
          lastBaseUpdate: E.lastBaseUpdate,
          shared: E.shared,
          effects: E.effects,
        }))
  }
  function Ke(E, l) {
    return { eventTime: E, lane: l, tag: 0, payload: null, callback: null, next: null }
  }
  function Ie(E, l, p) {
    var U = E.updateQueue
    if (U === null) return null
    if (((U = U.shared), fC & 2)) {
      var q = U.pending
      return (
        q === null ? (l.next = l) : ((l.next = q.next), (q.next = l)),
        (U.pending = l),
        rn(E, p)
      )
    }
    return (
      (q = U.interleaved),
      q === null ? ((l.next = l), Qi(U)) : ((l.next = q.next), (q.next = l)),
      (U.interleaved = l),
      rn(E, p)
    )
  }
  function PB(E, l, p) {
    if (((l = l.updateQueue), l !== null && ((l = l.shared), (p & 4194240) !== 0))) {
      var U = l.lanes
      ;((U &= E.pendingLanes), (p |= U), (l.lanes = p), aB(E, p))
    }
  }
  function ir(E, l) {
    var p = E.updateQueue,
      U = E.alternate
    if (U !== null && ((U = U.updateQueue), p === U)) {
      var q = null,
        Z = null
      if (((p = p.firstBaseUpdate), p !== null)) {
        do {
          var oA = {
            eventTime: p.eventTime,
            lane: p.lane,
            tag: p.tag,
            payload: p.payload,
            callback: p.callback,
            next: null,
          }
          ;(Z === null ? (q = Z = oA) : (Z = Z.next = oA), (p = p.next))
        } while (p !== null)
        Z === null ? (q = Z = l) : (Z = Z.next = l)
      } else q = Z = l
      ;((p = {
        baseState: U.baseState,
        firstBaseUpdate: q,
        lastBaseUpdate: Z,
        shared: U.shared,
        effects: U.effects,
      }),
        (E.updateQueue = p))
      return
    }
    ;((E = p.lastBaseUpdate),
      E === null ? (p.firstBaseUpdate = l) : (E.next = l),
      (p.lastBaseUpdate = l))
  }
  function lt(E, l, p, U) {
    var q = E.updateQueue
    li = !1
    var Z = q.firstBaseUpdate,
      oA = q.lastBaseUpdate,
      KA = q.shared.pending
    if (KA !== null) {
      q.shared.pending = null
      var bA = KA,
        kI = bA.next
      ;((bA.next = null), oA === null ? (Z = kI) : (oA.next = kI), (oA = bA))
      var tg = E.alternate
      tg !== null &&
        ((tg = tg.updateQueue),
        (KA = tg.lastBaseUpdate),
        KA !== oA &&
          (KA === null ? (tg.firstBaseUpdate = kI) : (KA.next = kI), (tg.lastBaseUpdate = bA)))
    }
    if (Z !== null) {
      var Eg = q.baseState
      ;((oA = 0), (tg = kI = bA = null), (KA = Z))
      do {
        var Ig = KA.lane,
          Ug = KA.eventTime
        if ((U & Ig) === Ig) {
          tg !== null &&
            (tg = tg.next =
              {
                eventTime: Ug,
                lane: 0,
                tag: KA.tag,
                payload: KA.payload,
                callback: KA.callback,
                next: null,
              })
          A: {
            var Wg = E,
              Xg = KA
            switch (((Ig = l), (Ug = p), Xg.tag)) {
              case 1:
                if (((Wg = Xg.payload), typeof Wg == "function")) {
                  Eg = Wg.call(Ug, Eg, Ig)
                  break A
                }
                Eg = Wg
                break A
              case 3:
                Wg.flags = (Wg.flags & -65537) | 128
              case 0:
                if (
                  ((Wg = Xg.payload),
                  (Ig = typeof Wg == "function" ? Wg.call(Ug, Eg, Ig) : Wg),
                  Ig == null)
                )
                  break A
                Eg = sA({}, Eg, Ig)
                break A
              case 2:
                li = !0
            }
          }
          KA.callback !== null &&
            KA.lane !== 0 &&
            ((E.flags |= 64), (Ig = q.effects), Ig === null ? (q.effects = [KA]) : Ig.push(KA))
        } else
          ((Ug = {
            eventTime: Ug,
            lane: Ig,
            tag: KA.tag,
            payload: KA.payload,
            callback: KA.callback,
            next: null,
          }),
            tg === null ? ((kI = tg = Ug), (bA = Eg)) : (tg = tg.next = Ug),
            (oA |= Ig))
        if (((KA = KA.next), KA === null)) {
          if (((KA = q.shared.pending), KA === null)) break
          ;((Ig = KA),
            (KA = Ig.next),
            (Ig.next = null),
            (q.lastBaseUpdate = Ig),
            (q.shared.pending = null))
        }
      } while (!0)
      if (
        (tg === null && (bA = Eg),
        (q.baseState = bA),
        (q.firstBaseUpdate = kI),
        (q.lastBaseUpdate = tg),
        (l = q.shared.interleaved),
        l !== null)
      ) {
        q = l
        do ((oA |= q.lane), (q = q.next))
        while (q !== l)
      } else Z === null && (q.shared.lanes = 0)
      ;((zs |= oA), (E.lanes = oA), (E.memoizedState = Eg))
    }
  }
  function tr(E, l, p) {
    if (((E = l.effects), (l.effects = null), E !== null))
      for (l = 0; l < E.length; l++) {
        var U = E[l],
          q = U.callback
        if (q !== null) {
          if (((U.callback = null), (U = p), typeof q != "function")) throw Error(I(191, q))
          q.call(U)
        }
      }
  }
  var HQ = {},
    IB = IC(HQ),
    aa = IC(HQ),
    RE = IC(HQ)
  function Tt(E) {
    if (E === HQ) throw Error(I(174))
    return E
  }
  function Os(E, l) {
    switch ((Ue(RE, l), Ue(aa, E), Ue(IB, HQ), (E = l.nodeType), E)) {
      case 9:
      case 11:
        l = (l = l.documentElement) ? l.namespaceURI : UI(null, "")
        break
      default:
        ;((E = E === 8 ? l.parentNode : l),
          (l = E.namespaceURI || null),
          (E = E.tagName),
          (l = UI(l, E)))
    }
    ;(de(IB), Ue(IB, l))
  }
  function ra() {
    ;(de(IB), de(aa), de(RE))
  }
  function Br(E) {
    Tt(RE.current)
    var l = Tt(IB.current),
      p = UI(l, E.type)
    l !== p && (Ue(aa, E), Ue(IB, p))
  }
  function Qr(E) {
    aa.current === E && (de(IB), de(aa))
  }
  var wi = IC(0)
  function sn(E) {
    for (var l = E; l !== null; ) {
      if (l.tag === 13) {
        var p = l.memoizedState
        if (p !== null && ((p = p.dehydrated), p === null || p.data === "$?" || p.data === "$!"))
          return l
      } else if (l.tag === 19 && l.memoizedProps.revealOrder !== void 0) {
        if (l.flags & 128) return l
      } else if (l.child !== null) {
        ;((l.child.return = l), (l = l.child))
        continue
      }
      if (l === E) break
      for (; l.sibling === null; ) {
        if (l.return === null || l.return === E) return null
        l = l.return
      }
      ;((l.sibling.return = l.return), (l = l.sibling))
    }
    return null
  }
  var or = []
  function _n() {
    for (var E = 0; E < or.length; E++) or[E]._workInProgressVersionPrimary = null
    or.length = 0
  }
  var nr = H.ReactCurrentDispatcher,
    JE = H.ReactCurrentBatchConfig,
    zg = 0,
    Pg = null,
    uC = null,
    rC = null,
    xt = !1,
    GB = !1,
    Zn = 0,
    TQ = 0
  function ci() {
    throw Error(I(321))
  }
  function DQ(E, l) {
    if (l === null) return !1
    for (var p = 0; p < l.length && p < E.length; p++) if (!rt(E[p], l[p])) return !1
    return !0
  }
  function Ag(E, l, p, U, q, Z) {
    if (
      ((zg = Z),
      (Pg = l),
      (l.memoizedState = null),
      (l.updateQueue = null),
      (l.lanes = 0),
      (nr.current = E === null || E.memoizedState === null ? lu : ue),
      (E = p(U, q)),
      GB)
    ) {
      Z = 0
      do {
        if (((GB = !1), (Zn = 0), 25 <= Z)) throw Error(I(301))
        ;((Z += 1), (rC = uC = null), (l.updateQueue = null), (nr.current = ha), (E = p(U, q)))
      } while (GB)
    }
    if (
      ((nr.current = VB),
      (l = uC !== null && uC.next !== null),
      (zg = 0),
      (rC = uC = Pg = null),
      (xt = !1),
      l)
    )
      throw Error(I(300))
    return E
  }
  function ct() {
    var E = Zn !== 0
    return ((Zn = 0), E)
  }
  function bg() {
    var E = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null }
    return (rC === null ? (Pg.memoizedState = rC = E) : (rC = rC.next = E), rC)
  }
  function cB() {
    if (uC === null) {
      var E = Pg.alternate
      E = E !== null ? E.memoizedState : null
    } else E = uC.next
    var l = rC === null ? Pg.memoizedState : rC.next
    if (l !== null) ((rC = l), (uC = E))
    else {
      if (E === null) throw Error(I(310))
      ;((uC = E),
        (E = {
          memoizedState: uC.memoizedState,
          baseState: uC.baseState,
          baseQueue: uC.baseQueue,
          queue: uC.queue,
          next: null,
        }),
        rC === null ? (Pg.memoizedState = rC = E) : (rC = rC.next = E))
    }
    return rC
  }
  function SQ(E, l) {
    return typeof l == "function" ? l(E) : l
  }
  function bt(E) {
    var l = cB(),
      p = l.queue
    if (p === null) throw Error(I(311))
    p.lastRenderedReducer = E
    var U = uC,
      q = U.baseQueue,
      Z = p.pending
    if (Z !== null) {
      if (q !== null) {
        var oA = q.next
        ;((q.next = Z.next), (Z.next = oA))
      }
      ;((U.baseQueue = q = Z), (p.pending = null))
    }
    if (q !== null) {
      ;((Z = q.next), (U = U.baseState))
      var KA = (oA = null),
        bA = null,
        kI = Z
      do {
        var tg = kI.lane
        if ((zg & tg) === tg)
          (bA !== null &&
            (bA = bA.next =
              {
                lane: 0,
                action: kI.action,
                hasEagerState: kI.hasEagerState,
                eagerState: kI.eagerState,
                next: null,
              }),
            (U = kI.hasEagerState ? kI.eagerState : E(U, kI.action)))
        else {
          var Eg = {
            lane: tg,
            action: kI.action,
            hasEagerState: kI.hasEagerState,
            eagerState: kI.eagerState,
            next: null,
          }
          ;(bA === null ? ((KA = bA = Eg), (oA = U)) : (bA = bA.next = Eg),
            (Pg.lanes |= tg),
            (zs |= tg))
        }
        kI = kI.next
      } while (kI !== null && kI !== Z)
      ;(bA === null ? (oA = U) : (bA.next = KA),
        rt(U, l.memoizedState) || (Be = !0),
        (l.memoizedState = U),
        (l.baseState = oA),
        (l.baseQueue = bA),
        (p.lastRenderedState = U))
    }
    if (((E = p.interleaved), E !== null)) {
      q = E
      do ((Z = q.lane), (Pg.lanes |= Z), (zs |= Z), (q = q.next))
      while (q !== E)
    } else q === null && (p.lanes = 0)
    return [l.memoizedState, p.dispatch]
  }
  function gB(E) {
    var l = cB(),
      p = l.queue
    if (p === null) throw Error(I(311))
    p.lastRenderedReducer = E
    var U = p.dispatch,
      q = p.pending,
      Z = l.memoizedState
    if (q !== null) {
      p.pending = null
      var oA = (q = q.next)
      do ((Z = E(Z, oA.action)), (oA = oA.next))
      while (oA !== q)
      ;(rt(Z, l.memoizedState) || (Be = !0),
        (l.memoizedState = Z),
        l.baseQueue === null && (l.baseState = Z),
        (p.lastRenderedState = Z))
    }
    return [Z, U]
  }
  function Er() {}
  function sa(E, l) {
    var p = Pg,
      U = cB(),
      q = l(),
      Z = !rt(U.memoizedState, q)
    if (
      (Z && ((U.memoizedState = q), (Be = !0)),
      (U = U.queue),
      xQ(Wl.bind(null, p, U, E), [E]),
      U.getSnapshot !== l || Z || (rC !== null && rC.memoizedState.tag & 1))
    ) {
      if (((p.flags |= 2048), kB(9, Pn.bind(null, p, U, q, l), void 0, null), Oe === null))
        throw Error(I(349))
      zg & 30 || la(p, l, q)
    }
    return q
  }
  function la(E, l, p) {
    ;((E.flags |= 16384),
      (E = { getSnapshot: l, value: p }),
      (l = Pg.updateQueue),
      l === null
        ? ((l = { lastEffect: null, stores: null }), (Pg.updateQueue = l), (l.stores = [E]))
        : ((p = l.stores), p === null ? (l.stores = [E]) : p.push(E)))
  }
  function Pn(E, l, p, U) {
    ;((l.value = p), (l.getSnapshot = U), _s(l) && Xr(E))
  }
  function Wl(E, l, p) {
    return p(function () {
      _s(l) && Xr(E)
    })
  }
  function _s(E) {
    var l = E.getSnapshot
    E = E.value
    try {
      var p = l()
      return !rt(E, p)
    } catch {
      return !0
    }
  }
  function Xr(E) {
    var l = rn(E, 1)
    l !== null && et(l, E, 1, -1)
  }
  function WB(E) {
    var l = bg()
    return (
      typeof E == "function" && (E = E()),
      (l.memoizedState = l.baseState = E),
      (E = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: SQ,
        lastRenderedState: E,
      }),
      (l.queue = E),
      (E = E.dispatch = Ro.bind(null, Pg, E)),
      [l.memoizedState, E]
    )
  }
  function kB(E, l, p, U) {
    return (
      (E = { tag: E, create: l, destroy: p, deps: U, next: null }),
      (l = Pg.updateQueue),
      l === null
        ? ((l = { lastEffect: null, stores: null }),
          (Pg.updateQueue = l),
          (l.lastEffect = E.next = E))
        : ((p = l.lastEffect),
          p === null
            ? (l.lastEffect = E.next = E)
            : ((U = p.next), (p.next = E), (E.next = U), (l.lastEffect = E))),
      E
    )
  }
  function Vl() {
    return cB().memoizedState
  }
  function Fo(E, l, p, U) {
    var q = bg()
    ;((Pg.flags |= E), (q.memoizedState = kB(1 | l, p, void 0, U === void 0 ? null : U)))
  }
  function ht(E, l, p, U) {
    var q = cB()
    U = U === void 0 ? null : U
    var Z = void 0
    if (uC !== null) {
      var oA = uC.memoizedState
      if (((Z = oA.destroy), U !== null && DQ(U, oA.deps))) {
        q.memoizedState = kB(l, p, Z, U)
        return
      }
    }
    ;((Pg.flags |= E), (q.memoizedState = kB(1 | l, p, Z, U)))
  }
  function Fe(E, l) {
    return Fo(8390656, 8, E, l)
  }
  function xQ(E, l) {
    return ht(2048, 8, E, l)
  }
  function fQ(E, l) {
    return ht(4, 2, E, l)
  }
  function jl(E, l) {
    return ht(4, 4, E, l)
  }
  function Wn(E, l) {
    if (typeof l == "function")
      return (
        (E = E()),
        l(E),
        function () {
          l(null)
        }
      )
    if (l != null)
      return (
        (E = E()),
        (l.current = E),
        function () {
          l.current = null
        }
      )
  }
  function KE(E, l, p) {
    return ((p = p != null ? p.concat([E]) : null), ht(4, 4, Wn.bind(null, l, E), p))
  }
  function ln() {}
  function cn(E, l) {
    var p = cB()
    l = l === void 0 ? null : l
    var U = p.memoizedState
    return U !== null && l !== null && DQ(l, U[1]) ? U[0] : ((p.memoizedState = [E, l]), E)
  }
  function CB(E, l) {
    var p = cB()
    l = l === void 0 ? null : l
    var U = p.memoizedState
    return U !== null && l !== null && DQ(l, U[1])
      ? U[0]
      : ((E = E()), (p.memoizedState = [E, l]), E)
  }
  function Vn(E, l, p) {
    return zg & 21
      ? (rt(p, l) || ((p = He()), (Pg.lanes |= p), (zs |= p), (E.baseState = !0)), l)
      : (E.baseState && ((E.baseState = !1), (Be = !0)), (E.memoizedState = p))
  }
  function ar(E, l) {
    var p = XC
    ;((XC = p !== 0 && 4 > p ? p : 4), E(!0))
    var U = JE.transition
    JE.transition = {}
    try {
      ;(E(!1), l())
    } finally {
      ;((XC = p), (JE.transition = U))
    }
  }
  function MB() {
    return cB().memoizedState
  }
  function ca(E, l, p) {
    var U = St(E)
    if (((p = { lane: U, action: p, hasEagerState: !1, eagerState: null, next: null }), rr(E)))
      mE(l, p)
    else if (((p = uQ(E, l, p, U)), p !== null)) {
      var q = FB()
      ;(et(p, E, U, q), Jo(p, l, U))
    }
  }
  function Ro(E, l, p) {
    var U = St(E),
      q = { lane: U, action: p, hasEagerState: !1, eagerState: null, next: null }
    if (rr(E)) mE(l, q)
    else {
      var Z = E.alternate
      if (
        E.lanes === 0 &&
        (Z === null || Z.lanes === 0) &&
        ((Z = l.lastRenderedReducer), Z !== null)
      )
        try {
          var oA = l.lastRenderedState,
            KA = Z(oA, p)
          if (((q.hasEagerState = !0), (q.eagerState = KA), rt(KA, oA))) {
            var bA = l.interleaved
            ;(bA === null ? ((q.next = q), Qi(l)) : ((q.next = bA.next), (bA.next = q)),
              (l.interleaved = q))
            return
          }
        } catch {
        } finally {
        }
      ;((p = uQ(E, l, q, U)), p !== null && ((q = FB()), et(p, E, U, q), Jo(p, l, U)))
    }
  }
  function rr(E) {
    var l = E.alternate
    return E === Pg || (l !== null && l === Pg)
  }
  function mE(E, l) {
    GB = xt = !0
    var p = E.pending
    ;(p === null ? (l.next = l) : ((l.next = p.next), (p.next = l)), (E.pending = l))
  }
  function Jo(E, l, p) {
    if (p & 4194240) {
      var U = l.lanes
      ;((U &= E.pendingLanes), (p |= U), (l.lanes = p), aB(E, p))
    }
  }
  var VB = {
      readContext: si,
      useCallback: ci,
      useContext: ci,
      useEffect: ci,
      useImperativeHandle: ci,
      useInsertionEffect: ci,
      useLayoutEffect: ci,
      useMemo: ci,
      useReducer: ci,
      useRef: ci,
      useState: ci,
      useDebugValue: ci,
      useDeferredValue: ci,
      useTransition: ci,
      useMutableSource: ci,
      useSyncExternalStore: ci,
      useId: ci,
      unstable_isNewReconciler: !1,
    },
    lu = {
      readContext: si,
      useCallback: function (E, l) {
        return ((bg().memoizedState = [E, l === void 0 ? null : l]), E)
      },
      useContext: si,
      useEffect: Fe,
      useImperativeHandle: function (E, l, p) {
        return ((p = p != null ? p.concat([E]) : null), Fo(4194308, 4, Wn.bind(null, l, E), p))
      },
      useLayoutEffect: function (E, l) {
        return Fo(4194308, 4, E, l)
      },
      useInsertionEffect: function (E, l) {
        return Fo(4, 2, E, l)
      },
      useMemo: function (E, l) {
        var p = bg()
        return ((l = l === void 0 ? null : l), (E = E()), (p.memoizedState = [E, l]), E)
      },
      useReducer: function (E, l, p) {
        var U = bg()
        return (
          (l = p !== void 0 ? p(l) : l),
          (U.memoizedState = U.baseState = l),
          (E = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: E,
            lastRenderedState: l,
          }),
          (U.queue = E),
          (E = E.dispatch = ca.bind(null, Pg, E)),
          [U.memoizedState, E]
        )
      },
      useRef: function (E) {
        var l = bg()
        return ((E = { current: E }), (l.memoizedState = E))
      },
      useState: WB,
      useDebugValue: ln,
      useDeferredValue: function (E) {
        return (bg().memoizedState = E)
      },
      useTransition: function () {
        var E = WB(!1),
          l = E[0]
        return ((E = ar.bind(null, E[1])), (bg().memoizedState = E), [l, E])
      },
      useMutableSource: function () {},
      useSyncExternalStore: function (E, l, p) {
        var U = Pg,
          q = bg()
        if (pi) {
          if (p === void 0) throw Error(I(407))
          p = p()
        } else {
          if (((p = l()), Oe === null)) throw Error(I(349))
          zg & 30 || la(U, l, p)
        }
        q.memoizedState = p
        var Z = { value: p, getSnapshot: l }
        return (
          (q.queue = Z),
          Fe(Wl.bind(null, U, Z, E), [E]),
          (U.flags |= 2048),
          kB(9, Pn.bind(null, U, Z, p, l), void 0, null),
          p
        )
      },
      useId: function () {
        var E = bg(),
          l = Oe.identifierPrefix
        if (pi) {
          var p = YQ,
            U = lg
          ;((p = (U & ~(1 << (32 - iC(U) - 1))).toString(32) + p),
            (l = ":" + l + "R" + p),
            (p = Zn++),
            0 < p && (l += "H" + p.toString(32)),
            (l += ":"))
        } else ((p = TQ++), (l = ":" + l + "r" + p.toString(32) + ":"))
        return (E.memoizedState = l)
      },
      unstable_isNewReconciler: !1,
    },
    ue = {
      readContext: si,
      useCallback: cn,
      useContext: si,
      useEffect: xQ,
      useImperativeHandle: KE,
      useInsertionEffect: fQ,
      useLayoutEffect: jl,
      useMemo: CB,
      useReducer: bt,
      useRef: Vl,
      useState: function () {
        return bt(SQ)
      },
      useDebugValue: ln,
      useDeferredValue: function (E) {
        var l = cB()
        return Vn(l, uC.memoizedState, E)
      },
      useTransition: function () {
        var E = bt(SQ)[0],
          l = cB().memoizedState
        return [E, l]
      },
      useMutableSource: Er,
      useSyncExternalStore: sa,
      useId: MB,
      unstable_isNewReconciler: !1,
    },
    ha = {
      readContext: si,
      useCallback: cn,
      useContext: si,
      useEffect: xQ,
      useImperativeHandle: KE,
      useInsertionEffect: fQ,
      useLayoutEffect: jl,
      useMemo: CB,
      useReducer: gB,
      useRef: Vl,
      useState: function () {
        return gB(SQ)
      },
      useDebugValue: ln,
      useDeferredValue: function (E) {
        var l = cB()
        return uC === null ? (l.memoizedState = E) : Vn(l, uC.memoizedState, E)
      },
      useTransition: function () {
        var E = gB(SQ)[0],
          l = cB().memoizedState
        return [E, l]
      },
      useMutableSource: Er,
      useSyncExternalStore: sa,
      useId: MB,
      unstable_isNewReconciler: !1,
    }
  function eB(E, l) {
    if (E && E.defaultProps) {
      ;((l = sA({}, l)), (E = E.defaultProps))
      for (var p in E) l[p] === void 0 && (l[p] = E[p])
      return l
    }
    return l
  }
  function Ko(E, l, p, U) {
    ;((l = E.memoizedState),
      (p = p(U, l)),
      (p = p == null ? l : sA({}, l, p)),
      (E.memoizedState = p),
      E.lanes === 0 && (E.updateQueue.baseState = p))
  }
  var mo = {
    isMounted: function (E) {
      return (E = E._reactInternals) ? Tg(E) === E : !1
    },
    enqueueSetState: function (E, l, p) {
      E = E._reactInternals
      var U = FB(),
        q = St(E),
        Z = Ke(U, q)
      ;((Z.payload = l),
        p != null && (Z.callback = p),
        (l = Ie(E, Z, q)),
        l !== null && (et(l, E, q, U), PB(l, E, q)))
    },
    enqueueReplaceState: function (E, l, p) {
      E = E._reactInternals
      var U = FB(),
        q = St(E),
        Z = Ke(U, q)
      ;((Z.tag = 1),
        (Z.payload = l),
        p != null && (Z.callback = p),
        (l = Ie(E, Z, q)),
        l !== null && (et(l, E, q, U), PB(l, E, q)))
    },
    enqueueForceUpdate: function (E, l) {
      E = E._reactInternals
      var p = FB(),
        U = St(E),
        q = Ke(p, U)
      ;((q.tag = 2),
        l != null && (q.callback = l),
        (l = Ie(E, q, U)),
        l !== null && (et(l, E, U, p), PB(l, E, U)))
    },
  }
  function zl(E, l, p, U, q, Z, oA) {
    return (
      (E = E.stateNode),
      typeof E.shouldComponentUpdate == "function"
        ? E.shouldComponentUpdate(U, Z, oA)
        : l.prototype && l.prototype.isPureReactComponent
          ? !vQ(p, U) || !vQ(q, Z)
          : !0
    )
  }
  function u(E, l, p) {
    var U = !1,
      q = nn,
      Z = l.contextType
    return (
      typeof Z == "object" && Z !== null
        ? (Z = si(Z))
        : ((q = Ri(l) ? bB : kC.current),
          (U = l.contextTypes),
          (Z = (U = U != null) ? cQ(E, q) : nn)),
      (l = new l(p, Z)),
      (E.memoizedState = l.state !== null && l.state !== void 0 ? l.state : null),
      (l.updater = mo),
      (E.stateNode = l),
      (l._reactInternals = E),
      U &&
        ((E = E.stateNode),
        (E.__reactInternalMemoizedUnmaskedChildContext = q),
        (E.__reactInternalMemoizedMaskedChildContext = Z)),
      l
    )
  }
  function D(E, l, p, U) {
    ;((E = l.state),
      typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps(p, U),
      typeof l.UNSAFE_componentWillReceiveProps == "function" &&
        l.UNSAFE_componentWillReceiveProps(p, U),
      l.state !== E && mo.enqueueReplaceState(l, l.state, null))
  }
  function N(E, l, p, U) {
    var q = E.stateNode
    ;((q.props = p), (q.state = E.memoizedState), (q.refs = {}), $C(E))
    var Z = l.contextType
    ;(typeof Z == "object" && Z !== null
      ? (q.context = si(Z))
      : ((Z = Ri(l) ? bB : kC.current), (q.context = cQ(E, Z))),
      (q.state = E.memoizedState),
      (Z = l.getDerivedStateFromProps),
      typeof Z == "function" && (Ko(E, l, Z, p), (q.state = E.memoizedState)),
      typeof l.getDerivedStateFromProps == "function" ||
        typeof q.getSnapshotBeforeUpdate == "function" ||
        (typeof q.UNSAFE_componentWillMount != "function" &&
          typeof q.componentWillMount != "function") ||
        ((l = q.state),
        typeof q.componentWillMount == "function" && q.componentWillMount(),
        typeof q.UNSAFE_componentWillMount == "function" && q.UNSAFE_componentWillMount(),
        l !== q.state && mo.enqueueReplaceState(q, q.state, null),
        lt(E, p, q, U),
        (q.state = E.memoizedState)),
      typeof q.componentDidMount == "function" && (E.flags |= 4194308))
  }
  function v(E, l) {
    try {
      var p = "",
        U = l
      do ((p += dA(U)), (U = U.return))
      while (U)
      var q = p
    } catch (Z) {
      q =
        `
Error generating stack: ` +
        Z.message +
        `
` +
        Z.stack
    }
    return { value: E, source: l, stack: q, digest: null }
  }
  function O(E, l, p) {
    return { value: E, source: null, stack: p ?? null, digest: l ?? null }
  }
  function IA(E, l) {
    try {
      console.error(l.value)
    } catch (p) {
      setTimeout(function () {
        throw p
      })
    }
  }
  var UA = typeof WeakMap == "function" ? WeakMap : Map
  function CI(E, l, p) {
    ;((p = Ke(-1, p)), (p.tag = 3), (p.payload = { element: null }))
    var U = l.value
    return (
      (p.callback = function () {
        ;(Cc || ((Cc = !0), (bD = U)), IA(E, l))
      }),
      p
    )
  }
  function HI(E, l, p) {
    ;((p = Ke(-1, p)), (p.tag = 3))
    var U = E.type.getDerivedStateFromError
    if (typeof U == "function") {
      var q = l.value
      ;((p.payload = function () {
        return U(q)
      }),
        (p.callback = function () {
          IA(E, l)
        }))
    }
    var Z = E.stateNode
    return (
      Z !== null &&
        typeof Z.componentDidCatch == "function" &&
        (p.callback = function () {
          ;(IA(E, l),
            typeof U != "function" &&
              (zn === null ? (zn = /* @__PURE__ */ new Set([this])) : zn.add(this)))
          var oA = l.stack
          this.componentDidCatch(l.value, { componentStack: oA !== null ? oA : "" })
        }),
      p
    )
  }
  function ng(E, l, p) {
    var U = E.pingCache
    if (U === null) {
      U = E.pingCache = new UA()
      var q = /* @__PURE__ */ new Set()
      U.set(l, q)
    } else ((q = U.get(l)), q === void 0 && ((q = /* @__PURE__ */ new Set()), U.set(l, q)))
    q.has(p) || (q.add(p), (E = Id.bind(null, E, l, p)), l.then(E, E))
  }
  function Sg(E) {
    do {
      var l
      if (
        ((l = E.tag === 13) &&
          ((l = E.memoizedState), (l = l !== null ? l.dehydrated !== null : !0)),
        l)
      )
        return E
      E = E.return
    } while (E !== null)
    return null
  }
  function DC(E, l, p, U, q) {
    return E.mode & 1
      ? ((E.flags |= 65536), (E.lanes = q), E)
      : (E === l
          ? (E.flags |= 65536)
          : ((E.flags |= 128),
            (p.flags |= 131072),
            (p.flags &= -52805),
            p.tag === 1 &&
              (p.alternate === null ? (p.tag = 17) : ((l = Ke(-1, 1)), (l.tag = 2), Ie(p, l, 1))),
            (p.lanes |= 1)),
        E)
  }
  var sC = H.ReactCurrentOwner,
    Be = !1
  function kg(E, l, p, U) {
    l.child = E === null ? Ts(l, null, p, U) : er(l, E.child, p, U)
  }
  function ut(E, l, p, U, q) {
    p = p.render
    var Z = l.ref
    return (
      Bo(l, q),
      (U = Ag(E, l, p, U, Z, q)),
      (p = ct()),
      E !== null && !Be
        ? ((l.updateQueue = E.updateQueue), (l.flags &= -2053), (E.lanes &= ~q), Ut(E, l, q))
        : (pi && p && qs(l), (l.flags |= 1), kg(E, l, U, q), l.child)
    )
  }
  function Dt(E, l, p, U, q) {
    if (E === null) {
      var Z = p.type
      return typeof Z == "function" &&
        !Qs(Z) &&
        Z.defaultProps === void 0 &&
        p.compare === null &&
        p.defaultProps === void 0
        ? ((l.tag = 15), (l.type = Z), yI(E, l, Z, U, q))
        : ((E = TE(p.type, null, U, l, l.mode, q)), (E.ref = l.ref), (E.return = l), (l.child = E))
    }
    if (((Z = E.child), !(E.lanes & q))) {
      var oA = Z.memoizedProps
      if (((p = p.compare), (p = p !== null ? p : vQ), p(oA, U) && E.ref === l.ref))
        return Ut(E, l, q)
    }
    return ((l.flags |= 1), (E = os(Z, U)), (E.ref = l.ref), (E.return = l), (l.child = E))
  }
  function yI(E, l, p, U, q) {
    if (E !== null) {
      var Z = E.memoizedProps
      if (vQ(Z, U) && E.ref === l.ref)
        if (((Be = !1), (l.pendingProps = U = Z), (E.lanes & q) !== 0))
          E.flags & 131072 && (Be = !0)
        else return ((l.lanes = E.lanes), Ut(E, l, q))
    }
    return WI(E, l, p, U, q)
  }
  function zA(E, l, p) {
    var U = l.pendingProps,
      q = U.children,
      Z = E !== null ? E.memoizedState : null
    if (U.mode === "hidden")
      if (!(l.mode & 1))
        ((l.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
          Ue(gc, tB),
          (tB |= p))
      else {
        if (!(p & 1073741824))
          return (
            (E = Z !== null ? Z.baseLanes | p : p),
            (l.lanes = l.childLanes = 1073741824),
            (l.memoizedState = { baseLanes: E, cachePool: null, transitions: null }),
            (l.updateQueue = null),
            Ue(gc, tB),
            (tB |= E),
            null
          )
        ;((l.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
          (U = Z !== null ? Z.baseLanes : p),
          Ue(gc, tB),
          (tB |= U))
      }
    else
      (Z !== null ? ((U = Z.baseLanes | p), (l.memoizedState = null)) : (U = p),
        Ue(gc, tB),
        (tB |= U))
    return (kg(E, l, q, p), l.child)
  }
  function JI(E, l) {
    var p = l.ref
    ;((E === null && p !== null) || (E !== null && E.ref !== p)) &&
      ((l.flags |= 512), (l.flags |= 2097152))
  }
  function WI(E, l, p, U, q) {
    var Z = Ri(p) ? bB : kC.current
    return (
      (Z = cQ(l, Z)),
      Bo(l, q),
      (p = Ag(E, l, p, U, Z, q)),
      (U = ct()),
      E !== null && !Be
        ? ((l.updateQueue = E.updateQueue), (l.flags &= -2053), (E.lanes &= ~q), Ut(E, l, q))
        : (pi && U && qs(l), (l.flags |= 1), kg(E, l, p, q), l.child)
    )
  }
  function Zg(E, l, p, U, q) {
    if (Ri(p)) {
      var Z = !0
      On(l)
    } else Z = !1
    if ((Bo(l, q), l.stateNode === null)) (Xl(E, l), u(l, p, U), N(l, p, U, q), (U = !0))
    else if (E === null) {
      var oA = l.stateNode,
        KA = l.memoizedProps
      oA.props = KA
      var bA = oA.context,
        kI = p.contextType
      typeof kI == "object" && kI !== null
        ? (kI = si(kI))
        : ((kI = Ri(p) ? bB : kC.current), (kI = cQ(l, kI)))
      var tg = p.getDerivedStateFromProps,
        Eg = typeof tg == "function" || typeof oA.getSnapshotBeforeUpdate == "function"
      ;(Eg ||
        (typeof oA.UNSAFE_componentWillReceiveProps != "function" &&
          typeof oA.componentWillReceiveProps != "function") ||
        ((KA !== U || bA !== kI) && D(l, oA, U, kI)),
        (li = !1))
      var Ig = l.memoizedState
      ;((oA.state = Ig),
        lt(l, U, oA, q),
        (bA = l.memoizedState),
        KA !== U || Ig !== bA || At.current || li
          ? (typeof tg == "function" && (Ko(l, p, tg, U), (bA = l.memoizedState)),
            (KA = li || zl(l, p, KA, U, Ig, bA, kI))
              ? (Eg ||
                  (typeof oA.UNSAFE_componentWillMount != "function" &&
                    typeof oA.componentWillMount != "function") ||
                  (typeof oA.componentWillMount == "function" && oA.componentWillMount(),
                  typeof oA.UNSAFE_componentWillMount == "function" &&
                    oA.UNSAFE_componentWillMount()),
                typeof oA.componentDidMount == "function" && (l.flags |= 4194308))
              : (typeof oA.componentDidMount == "function" && (l.flags |= 4194308),
                (l.memoizedProps = U),
                (l.memoizedState = bA)),
            (oA.props = U),
            (oA.state = bA),
            (oA.context = kI),
            (U = KA))
          : (typeof oA.componentDidMount == "function" && (l.flags |= 4194308), (U = !1)))
    } else {
      ;((oA = l.stateNode),
        xi(E, l),
        (KA = l.memoizedProps),
        (kI = l.type === l.elementType ? KA : eB(l.type, KA)),
        (oA.props = kI),
        (Eg = l.pendingProps),
        (Ig = oA.context),
        (bA = p.contextType),
        typeof bA == "object" && bA !== null
          ? (bA = si(bA))
          : ((bA = Ri(p) ? bB : kC.current), (bA = cQ(l, bA))))
      var Ug = p.getDerivedStateFromProps
      ;((tg = typeof Ug == "function" || typeof oA.getSnapshotBeforeUpdate == "function") ||
        (typeof oA.UNSAFE_componentWillReceiveProps != "function" &&
          typeof oA.componentWillReceiveProps != "function") ||
        ((KA !== Eg || Ig !== bA) && D(l, oA, U, bA)),
        (li = !1),
        (Ig = l.memoizedState),
        (oA.state = Ig),
        lt(l, U, oA, q))
      var Wg = l.memoizedState
      KA !== Eg || Ig !== Wg || At.current || li
        ? (typeof Ug == "function" && (Ko(l, p, Ug, U), (Wg = l.memoizedState)),
          (kI = li || zl(l, p, kI, U, Ig, Wg, bA) || !1)
            ? (tg ||
                (typeof oA.UNSAFE_componentWillUpdate != "function" &&
                  typeof oA.componentWillUpdate != "function") ||
                (typeof oA.componentWillUpdate == "function" && oA.componentWillUpdate(U, Wg, bA),
                typeof oA.UNSAFE_componentWillUpdate == "function" &&
                  oA.UNSAFE_componentWillUpdate(U, Wg, bA)),
              typeof oA.componentDidUpdate == "function" && (l.flags |= 4),
              typeof oA.getSnapshotBeforeUpdate == "function" && (l.flags |= 1024))
            : (typeof oA.componentDidUpdate != "function" ||
                (KA === E.memoizedProps && Ig === E.memoizedState) ||
                (l.flags |= 4),
              typeof oA.getSnapshotBeforeUpdate != "function" ||
                (KA === E.memoizedProps && Ig === E.memoizedState) ||
                (l.flags |= 1024),
              (l.memoizedProps = U),
              (l.memoizedState = Wg)),
          (oA.props = U),
          (oA.state = Wg),
          (oA.context = bA),
          (U = kI))
        : (typeof oA.componentDidUpdate != "function" ||
            (KA === E.memoizedProps && Ig === E.memoizedState) ||
            (l.flags |= 4),
          typeof oA.getSnapshotBeforeUpdate != "function" ||
            (KA === E.memoizedProps && Ig === E.memoizedState) ||
            (l.flags |= 1024),
          (U = !1))
    }
    return WC(E, l, p, U, Z, q)
  }
  function WC(E, l, p, U, q, Z) {
    JI(E, l)
    var oA = (l.flags & 128) !== 0
    if (!U && !oA) return (q && Vc(l, p, !1), Ut(E, l, Z))
    ;((U = l.stateNode), (sC.current = l))
    var KA = oA && typeof p.getDerivedStateFromError != "function" ? null : U.render()
    return (
      (l.flags |= 1),
      E !== null && oA
        ? ((l.child = er(l, E.child, null, Z)), (l.child = er(l, null, KA, Z)))
        : kg(E, l, KA, Z),
      (l.memoizedState = U.state),
      q && Vc(l, p, !0),
      l.child
    )
  }
  function SC(E) {
    var l = E.stateNode
    ;(l.pendingContext
      ? bn(E, l.pendingContext, l.pendingContext !== l.context)
      : l.context && bn(E, l.context, !1),
      Os(E, l.containerInfo))
  }
  function Qe(E, l, p, U, q) {
    return (Hi(), zr(q), (l.flags |= 256), kg(E, l, p, U), l.child)
  }
  var bi = { dehydrated: null, treeContext: null, retryLane: 0 }
  function oe(E) {
    return { baseLanes: E, cachePool: null, transitions: null }
  }
  function vE(E, l, p) {
    var U = l.pendingProps,
      q = wi.current,
      Z = !1,
      oA = (l.flags & 128) !== 0,
      KA
    if (
      ((KA = oA) || (KA = E !== null && E.memoizedState === null ? !1 : (q & 2) !== 0),
      KA ? ((Z = !0), (l.flags &= -129)) : (E === null || E.memoizedState !== null) && (q |= 1),
      Ue(wi, q & 1),
      E === null)
    )
      return (
        Cr(l),
        (E = l.memoizedState),
        E !== null && ((E = E.dehydrated), E !== null)
          ? (l.mode & 1
              ? E.data === "$!"
                ? (l.lanes = 8)
                : (l.lanes = 1073741824)
              : (l.lanes = 1),
            null)
          : ((oA = U.children),
            (E = U.fallback),
            Z
              ? ((U = l.mode),
                (Z = l.child),
                (oA = { mode: "hidden", children: oA }),
                !(U & 1) && Z !== null
                  ? ((Z.childLanes = 0), (Z.pendingProps = oA))
                  : (Z = Gu(oA, U, 0, null)),
                (E = IE(E, U, p, null)),
                (Z.return = l),
                (E.return = l),
                (Z.sibling = E),
                (l.child = Z),
                (l.child.memoizedState = oe(p)),
                (l.memoizedState = bi),
                E)
              : sr(l, oA))
      )
    if (((q = E.memoizedState), q !== null && ((KA = q.dehydrated), KA !== null)))
      return hu(E, l, oA, U, KA, q, p)
    if (Z) {
      ;((Z = U.fallback), (oA = l.mode), (q = E.child), (KA = q.sibling))
      var bA = { mode: "hidden", children: U.children }
      return (
        !(oA & 1) && l.child !== q
          ? ((U = l.child), (U.childLanes = 0), (U.pendingProps = bA), (l.deletions = null))
          : ((U = os(q, bA)), (U.subtreeFlags = q.subtreeFlags & 14680064)),
        KA !== null ? (Z = os(KA, Z)) : ((Z = IE(Z, oA, p, null)), (Z.flags |= 2)),
        (Z.return = l),
        (U.return = l),
        (U.sibling = Z),
        (l.child = U),
        (U = Z),
        (Z = l.child),
        (oA = E.child.memoizedState),
        (oA =
          oA === null
            ? oe(p)
            : { baseLanes: oA.baseLanes | p, cachePool: null, transitions: oA.transitions }),
        (Z.memoizedState = oA),
        (Z.childLanes = E.childLanes & ~p),
        (l.memoizedState = bi),
        U
      )
    }
    return (
      (Z = E.child),
      (E = Z.sibling),
      (U = os(Z, { mode: "visible", children: U.children })),
      !(l.mode & 1) && (U.lanes = p),
      (U.return = l),
      (U.sibling = null),
      E !== null &&
        ((p = l.deletions), p === null ? ((l.deletions = [E]), (l.flags |= 16)) : p.push(E)),
      (l.child = U),
      (l.memoizedState = null),
      U
    )
  }
  function sr(E, l) {
    return (
      (l = Gu({ mode: "visible", children: l }, E.mode, 0, null)),
      (l.return = E),
      (E.child = l)
    )
  }
  function cu(E, l, p, U) {
    return (
      U !== null && zr(U),
      er(l, E.child, null, p),
      (E = sr(l, l.pendingProps.children)),
      (E.flags |= 2),
      (l.memoizedState = null),
      E
    )
  }
  function hu(E, l, p, U, q, Z, oA) {
    if (p)
      return l.flags & 256
        ? ((l.flags &= -257), (U = O(Error(I(422)))), cu(E, l, oA, U))
        : l.memoizedState !== null
          ? ((l.child = E.child), (l.flags |= 128), null)
          : ((Z = U.fallback),
            (q = l.mode),
            (U = Gu({ mode: "visible", children: U.children }, q, 0, null)),
            (Z = IE(Z, q, oA, null)),
            (Z.flags |= 2),
            (U.return = l),
            (Z.return = l),
            (U.sibling = Z),
            (l.child = U),
            l.mode & 1 && er(l, E.child, null, oA),
            (l.child.memoizedState = oe(oA)),
            (l.memoizedState = bi),
            Z)
    if (!(l.mode & 1)) return cu(E, l, oA, null)
    if (q.data === "$!") {
      if (((U = q.nextSibling && q.nextSibling.dataset), U)) var KA = U.dgst
      return ((U = KA), (Z = Error(I(419))), (U = O(Z, U, void 0)), cu(E, l, oA, U))
    }
    if (((KA = (oA & E.childLanes) !== 0), Be || KA)) {
      if (((U = Oe), U !== null)) {
        switch (oA & -oA) {
          case 4:
            q = 2
            break
          case 16:
            q = 8
            break
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            q = 32
            break
          case 536870912:
            q = 268435456
            break
          default:
            q = 0
        }
        ;((q = q & (U.suspendedLanes | oA) ? 0 : q),
          q !== 0 && q !== Z.retryLane && ((Z.retryLane = q), rn(E, q), et(U, E, q, -1)))
      }
      return (Bh(), (U = O(Error(I(421)))), cu(E, l, oA, U))
    }
    return q.data === "$?"
      ? ((l.flags |= 128), (l.child = E.child), (l = ZD.bind(null, E)), (q._reactRetry = l), null)
      : ((E = Z.treeContext),
        (_B = rQ(q.nextSibling)),
        (AB = l),
        (pi = !0),
        (qQ = null),
        E !== null &&
          ((Yt[It++] = lg),
          (Yt[It++] = YQ),
          (Yt[It++] = an),
          (lg = E.id),
          (YQ = E.overflow),
          (an = l)),
        (l = sr(l, U.children)),
        (l.flags |= 4096),
        l)
  }
  function jc(E, l, p) {
    E.lanes |= l
    var U = E.alternate
    ;(U !== null && (U.lanes |= l), bs(E.return, l, p))
  }
  function zc(E, l, p, U, q) {
    var Z = E.memoizedState
    Z === null
      ? (E.memoizedState = {
          isBackwards: l,
          rendering: null,
          renderingStartTime: 0,
          last: U,
          tail: p,
          tailMode: q,
        })
      : ((Z.isBackwards = l),
        (Z.rendering = null),
        (Z.renderingStartTime = 0),
        (Z.last = U),
        (Z.tail = p),
        (Z.tailMode = q))
  }
  function Xc(E, l, p) {
    var U = l.pendingProps,
      q = U.revealOrder,
      Z = U.tail
    if ((kg(E, l, U.children, p), (U = wi.current), U & 2)) ((U = (U & 1) | 2), (l.flags |= 128))
    else {
      if (E !== null && E.flags & 128)
        A: for (E = l.child; E !== null; ) {
          if (E.tag === 13) E.memoizedState !== null && jc(E, p, l)
          else if (E.tag === 19) jc(E, p, l)
          else if (E.child !== null) {
            ;((E.child.return = E), (E = E.child))
            continue
          }
          if (E === l) break A
          for (; E.sibling === null; ) {
            if (E.return === null || E.return === l) break A
            E = E.return
          }
          ;((E.sibling.return = E.return), (E = E.sibling))
        }
      U &= 1
    }
    if ((Ue(wi, U), !(l.mode & 1))) l.memoizedState = null
    else
      switch (q) {
        case "forwards":
          for (p = l.child, q = null; p !== null; )
            ((E = p.alternate), E !== null && sn(E) === null && (q = p), (p = p.sibling))
          ;((p = q),
            p === null ? ((q = l.child), (l.child = null)) : ((q = p.sibling), (p.sibling = null)),
            zc(l, !1, q, p, Z))
          break
        case "backwards":
          for (p = null, q = l.child, l.child = null; q !== null; ) {
            if (((E = q.alternate), E !== null && sn(E) === null)) {
              l.child = q
              break
            }
            ;((E = q.sibling), (q.sibling = p), (p = q), (q = E))
          }
          zc(l, !0, p, null, Z)
          break
        case "together":
          zc(l, !1, null, null, void 0)
          break
        default:
          l.memoizedState = null
      }
    return l.child
  }
  function Xl(E, l) {
    !(l.mode & 1) && E !== null && ((E.alternate = null), (l.alternate = null), (l.flags |= 2))
  }
  function Ut(E, l, p) {
    if ((E !== null && (l.dependencies = E.dependencies), (zs |= l.lanes), !(p & l.childLanes)))
      return null
    if (E !== null && l.child !== E.child) throw Error(I(153))
    if (l.child !== null) {
      for (E = l.child, p = os(E, E.pendingProps), l.child = p, p.return = l; E.sibling !== null; )
        ((E = E.sibling), (p = p.sibling = os(E, E.pendingProps)), (p.return = l))
      p.sibling = null
    }
    return l.child
  }
  function LE(E, l, p) {
    switch (l.tag) {
      case 3:
        ;(SC(l), Hi())
        break
      case 5:
        Br(l)
        break
      case 1:
        Ri(l.type) && On(l)
        break
      case 4:
        Os(l, l.stateNode.containerInfo)
        break
      case 10:
        var U = l.type._context,
          q = l.memoizedProps.value
        ;(Ue(Bi, U._currentValue), (U._currentValue = q))
        break
      case 13:
        if (((U = l.memoizedState), U !== null))
          return U.dehydrated !== null
            ? (Ue(wi, wi.current & 1), (l.flags |= 128), null)
            : p & l.child.childLanes
              ? vE(E, l, p)
              : (Ue(wi, wi.current & 1), (E = Ut(E, l, p)), E !== null ? E.sibling : null)
        Ue(wi, wi.current & 1)
        break
      case 19:
        if (((U = (p & l.childLanes) !== 0), E.flags & 128)) {
          if (U) return Xc(E, l, p)
          l.flags |= 128
        }
        if (
          ((q = l.memoizedState),
          q !== null && ((q.rendering = null), (q.tail = null), (q.lastEffect = null)),
          Ue(wi, wi.current),
          U)
        )
          break
        return null
      case 22:
      case 23:
        return ((l.lanes = 0), zA(E, l, p))
    }
    return Ut(E, l, p)
  }
  var jn, $r, As, hn
  ;((jn = function (E, l) {
    for (var p = l.child; p !== null; ) {
      if (p.tag === 5 || p.tag === 6) E.appendChild(p.stateNode)
      else if (p.tag !== 4 && p.child !== null) {
        ;((p.child.return = p), (p = p.child))
        continue
      }
      if (p === l) break
      for (; p.sibling === null; ) {
        if (p.return === null || p.return === l) return
        p = p.return
      }
      ;((p.sibling.return = p.return), (p = p.sibling))
    }
  }),
    ($r = function () {}),
    (As = function (E, l, p, U) {
      var q = E.memoizedProps
      if (q !== U) {
        ;((E = l.stateNode), Tt(IB.current))
        var Z = null
        switch (p) {
          case "input":
            ;((q = uA(E, q)), (U = uA(E, U)), (Z = []))
            break
          case "select":
            ;((q = sA({}, q, { value: void 0 })), (U = sA({}, U, { value: void 0 })), (Z = []))
            break
          case "textarea":
            ;((q = tA(E, q)), (U = tA(E, U)), (Z = []))
            break
          default:
            typeof q.onClick != "function" && typeof U.onClick == "function" && (E.onclick = Xa)
        }
        ag(p, U)
        var oA
        p = null
        for (kI in q)
          if (!U.hasOwnProperty(kI) && q.hasOwnProperty(kI) && q[kI] != null)
            if (kI === "style") {
              var KA = q[kI]
              for (oA in KA) KA.hasOwnProperty(oA) && (p || (p = {}), (p[oA] = ""))
            } else
              kI !== "dangerouslySetInnerHTML" &&
                kI !== "children" &&
                kI !== "suppressContentEditableWarning" &&
                kI !== "suppressHydrationWarning" &&
                kI !== "autoFocus" &&
                (C.hasOwnProperty(kI) ? Z || (Z = []) : (Z = Z || []).push(kI, null))
        for (kI in U) {
          var bA = U[kI]
          if (((KA = q?.[kI]), U.hasOwnProperty(kI) && bA !== KA && (bA != null || KA != null)))
            if (kI === "style")
              if (KA) {
                for (oA in KA)
                  !KA.hasOwnProperty(oA) ||
                    (bA && bA.hasOwnProperty(oA)) ||
                    (p || (p = {}), (p[oA] = ""))
                for (oA in bA)
                  bA.hasOwnProperty(oA) && KA[oA] !== bA[oA] && (p || (p = {}), (p[oA] = bA[oA]))
              } else (p || (Z || (Z = []), Z.push(kI, p)), (p = bA))
            else
              kI === "dangerouslySetInnerHTML"
                ? ((bA = bA ? bA.__html : void 0),
                  (KA = KA ? KA.__html : void 0),
                  bA != null && KA !== bA && (Z = Z || []).push(kI, bA))
                : kI === "children"
                  ? (typeof bA != "string" && typeof bA != "number") ||
                    (Z = Z || []).push(kI, "" + bA)
                  : kI !== "suppressContentEditableWarning" &&
                    kI !== "suppressHydrationWarning" &&
                    (C.hasOwnProperty(kI)
                      ? (bA != null && kI === "onScroll" && TC("scroll", E),
                        Z || KA === bA || (Z = []))
                      : (Z = Z || []).push(kI, bA))
        }
        p && (Z = Z || []).push("style", p)
        var kI = Z
        ;(l.updateQueue = kI) && (l.flags |= 4)
      }
    }),
    (hn = function (E, l, p, U) {
      p !== U && (l.flags |= 4)
    }))
  function gt(E, l) {
    if (!pi)
      switch (E.tailMode) {
        case "hidden":
          l = E.tail
          for (var p = null; l !== null; ) (l.alternate !== null && (p = l), (l = l.sibling))
          p === null ? (E.tail = null) : (p.sibling = null)
          break
        case "collapsed":
          p = E.tail
          for (var U = null; p !== null; ) (p.alternate !== null && (U = p), (p = p.sibling))
          U === null
            ? l || E.tail === null
              ? (E.tail = null)
              : (E.tail.sibling = null)
            : (U.sibling = null)
      }
  }
  function jB(E) {
    var l = E.alternate !== null && E.alternate.child === E.child,
      p = 0,
      U = 0
    if (l)
      for (var q = E.child; q !== null; )
        ((p |= q.lanes | q.childLanes),
          (U |= q.subtreeFlags & 14680064),
          (U |= q.flags & 14680064),
          (q.return = E),
          (q = q.sibling))
    else
      for (q = E.child; q !== null; )
        ((p |= q.lanes | q.childLanes),
          (U |= q.subtreeFlags),
          (U |= q.flags),
          (q.return = E),
          (q = q.sibling))
    return ((E.subtreeFlags |= U), (E.childLanes = p), l)
  }
  function qD(E, l, p) {
    var U = l.pendingProps
    switch ((NE(l), l.tag)) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return (jB(l), null)
      case 1:
        return (Ri(l.type) && hQ(), jB(l), null)
      case 3:
        return (
          (U = l.stateNode),
          ra(),
          de(At),
          de(kC),
          _n(),
          U.pendingContext && ((U.context = U.pendingContext), (U.pendingContext = null)),
          (E === null || E.child === null) &&
            (ZB(l)
              ? (l.flags |= 4)
              : E === null ||
                (E.memoizedState.isDehydrated && !(l.flags & 256)) ||
                ((l.flags |= 1024), qQ !== null && (eh(qQ), (qQ = null)))),
          $r(E, l),
          jB(l),
          null
        )
      case 5:
        Qr(l)
        var q = Tt(RE.current)
        if (((p = l.type), E !== null && l.stateNode != null))
          (As(E, l, p, U, q), E.ref !== l.ref && ((l.flags |= 512), (l.flags |= 2097152)))
        else {
          if (!U) {
            if (l.stateNode === null) throw Error(I(166))
            return (jB(l), null)
          }
          if (((E = Tt(IB.current)), ZB(l))) {
            ;((U = l.stateNode), (p = l.type))
            var Z = l.memoizedProps
            switch (((U[Mt] = l), (U[xn] = Z), (E = (l.mode & 1) !== 0), p)) {
              case "dialog":
                ;(TC("cancel", U), TC("close", U))
                break
              case "iframe":
              case "object":
              case "embed":
                TC("load", U)
                break
              case "video":
              case "audio":
                for (q = 0; q < ea.length; q++) TC(ea[q], U)
                break
              case "source":
                TC("error", U)
                break
              case "img":
              case "image":
              case "link":
                ;(TC("error", U), TC("load", U))
                break
              case "details":
                TC("toggle", U)
                break
              case "input":
                ;(hI(U, Z), TC("invalid", U))
                break
              case "select":
                ;((U._wrapperState = { wasMultiple: !!Z.multiple }), TC("invalid", U))
                break
              case "textarea":
                ;(FA(U, Z), TC("invalid", U))
            }
            ;(ag(p, Z), (q = null))
            for (var oA in Z)
              if (Z.hasOwnProperty(oA)) {
                var KA = Z[oA]
                oA === "children"
                  ? typeof KA == "string"
                    ? U.textContent !== KA &&
                      (Z.suppressHydrationWarning !== !0 && za(U.textContent, KA, E),
                      (q = ["children", KA]))
                    : typeof KA == "number" &&
                      U.textContent !== "" + KA &&
                      (Z.suppressHydrationWarning !== !0 && za(U.textContent, KA, E),
                      (q = ["children", "" + KA]))
                  : C.hasOwnProperty(oA) && KA != null && oA === "onScroll" && TC("scroll", U)
              }
            switch (p) {
              case "input":
                ;(cI(U), AI(U, Z, !0))
                break
              case "textarea":
                ;(cI(U), jA(U))
                break
              case "select":
              case "option":
                break
              default:
                typeof Z.onClick == "function" && (U.onclick = Xa)
            }
            ;((U = q), (l.updateQueue = U), U !== null && (l.flags |= 4))
          } else {
            ;((oA = q.nodeType === 9 ? q : q.ownerDocument),
              E === "http://www.w3.org/1999/xhtml" && (E = nI(p)),
              E === "http://www.w3.org/1999/xhtml"
                ? p === "script"
                  ? ((E = oA.createElement("div")),
                    (E.innerHTML = "<script><\/script>"),
                    (E = E.removeChild(E.firstChild)))
                  : typeof U.is == "string"
                    ? (E = oA.createElement(p, { is: U.is }))
                    : ((E = oA.createElement(p)),
                      p === "select" &&
                        ((oA = E), U.multiple ? (oA.multiple = !0) : U.size && (oA.size = U.size)))
                : (E = oA.createElementNS(E, p)),
              (E[Mt] = l),
              (E[xn] = U),
              jn(E, l, !1, !1),
              (l.stateNode = E))
            A: {
              switch (((oA = XI(p, U)), p)) {
                case "dialog":
                  ;(TC("cancel", E), TC("close", E), (q = U))
                  break
                case "iframe":
                case "object":
                case "embed":
                  ;(TC("load", E), (q = U))
                  break
                case "video":
                case "audio":
                  for (q = 0; q < ea.length; q++) TC(ea[q], E)
                  q = U
                  break
                case "source":
                  ;(TC("error", E), (q = U))
                  break
                case "img":
                case "image":
                case "link":
                  ;(TC("error", E), TC("load", E), (q = U))
                  break
                case "details":
                  ;(TC("toggle", E), (q = U))
                  break
                case "input":
                  ;(hI(E, U), (q = uA(E, U)), TC("invalid", E))
                  break
                case "option":
                  q = U
                  break
                case "select":
                  ;((E._wrapperState = { wasMultiple: !!U.multiple }),
                    (q = sA({}, U, { value: void 0 })),
                    TC("invalid", E))
                  break
                case "textarea":
                  ;(FA(E, U), (q = tA(E, U)), TC("invalid", E))
                  break
                default:
                  q = U
              }
              ;(ag(p, q), (KA = q))
              for (Z in KA)
                if (KA.hasOwnProperty(Z)) {
                  var bA = KA[Z]
                  Z === "style"
                    ? RI(E, bA)
                    : Z === "dangerouslySetInnerHTML"
                      ? ((bA = bA ? bA.__html : void 0), bA != null && LI(E, bA))
                      : Z === "children"
                        ? typeof bA == "string"
                          ? (p !== "textarea" || bA !== "") && Bg(E, bA)
                          : typeof bA == "number" && Bg(E, "" + bA)
                        : Z !== "suppressContentEditableWarning" &&
                          Z !== "suppressHydrationWarning" &&
                          Z !== "autoFocus" &&
                          (C.hasOwnProperty(Z)
                            ? bA != null && Z === "onScroll" && TC("scroll", E)
                            : bA != null && Y(E, Z, bA, oA))
                }
              switch (p) {
                case "input":
                  ;(cI(E), AI(E, U, !1))
                  break
                case "textarea":
                  ;(cI(E), jA(E))
                  break
                case "option":
                  U.value != null && E.setAttribute("value", "" + qA(U.value))
                  break
                case "select":
                  ;((E.multiple = !!U.multiple),
                    (Z = U.value),
                    Z != null
                      ? QA(E, !!U.multiple, Z, !1)
                      : U.defaultValue != null && QA(E, !!U.multiple, U.defaultValue, !0))
                  break
                default:
                  typeof q.onClick == "function" && (E.onclick = Xa)
              }
              switch (p) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  U = !!U.autoFocus
                  break A
                case "img":
                  U = !0
                  break A
                default:
                  U = !1
              }
            }
            U && (l.flags |= 4)
          }
          l.ref !== null && ((l.flags |= 512), (l.flags |= 2097152))
        }
        return (jB(l), null)
      case 6:
        if (E && l.stateNode != null) hn(E, l, E.memoizedProps, U)
        else {
          if (typeof U != "string" && l.stateNode === null) throw Error(I(166))
          if (((p = Tt(RE.current)), Tt(IB.current), ZB(l))) {
            if (
              ((U = l.stateNode),
              (p = l.memoizedProps),
              (U[Mt] = l),
              (Z = U.nodeValue !== p) && ((E = AB), E !== null))
            )
              switch (E.tag) {
                case 3:
                  za(U.nodeValue, p, (E.mode & 1) !== 0)
                  break
                case 5:
                  E.memoizedProps.suppressHydrationWarning !== !0 &&
                    za(U.nodeValue, p, (E.mode & 1) !== 0)
              }
            Z && (l.flags |= 4)
          } else
            ((U = (p.nodeType === 9 ? p : p.ownerDocument).createTextNode(U)),
              (U[Mt] = l),
              (l.stateNode = U))
        }
        return (jB(l), null)
      case 13:
        if (
          (de(wi),
          (U = l.memoizedState),
          E === null || (E.memoizedState !== null && E.memoizedState.dehydrated !== null))
        ) {
          if (pi && _B !== null && l.mode & 1 && !(l.flags & 128))
            (qt(), Hi(), (l.flags |= 98560), (Z = !1))
          else if (((Z = ZB(l)), U !== null && U.dehydrated !== null)) {
            if (E === null) {
              if (!Z) throw Error(I(318))
              if (((Z = l.memoizedState), (Z = Z !== null ? Z.dehydrated : null), !Z))
                throw Error(I(317))
              Z[Mt] = l
            } else (Hi(), !(l.flags & 128) && (l.memoizedState = null), (l.flags |= 4))
            ;(jB(l), (Z = !1))
          } else (qQ !== null && (eh(qQ), (qQ = null)), (Z = !0))
          if (!Z) return l.flags & 65536 ? l : null
        }
        return l.flags & 128
          ? ((l.lanes = p), l)
          : ((U = U !== null),
            U !== (E !== null && E.memoizedState !== null) &&
              U &&
              ((l.child.flags |= 8192),
              l.mode & 1 && (E === null || wi.current & 1 ? NB === 0 && (NB = 3) : Bh())),
            l.updateQueue !== null && (l.flags |= 4),
            jB(l),
            null)
      case 4:
        return (ra(), $r(E, l), E === null && LQ(l.stateNode.containerInfo), jB(l), null)
      case 10:
        return (xs(l.type._context), jB(l), null)
      case 17:
        return (Ri(l.type) && hQ(), jB(l), null)
      case 19:
        if ((de(wi), (Z = l.memoizedState), Z === null)) return (jB(l), null)
        if (((U = (l.flags & 128) !== 0), (oA = Z.rendering), oA === null))
          if (U) gt(Z, !1)
          else {
            if (NB !== 0 || (E !== null && E.flags & 128))
              for (E = l.child; E !== null; ) {
                if (((oA = sn(E)), oA !== null)) {
                  for (
                    l.flags |= 128,
                      gt(Z, !1),
                      U = oA.updateQueue,
                      U !== null && ((l.updateQueue = U), (l.flags |= 4)),
                      l.subtreeFlags = 0,
                      U = p,
                      p = l.child;
                    p !== null;
                  )
                    ((Z = p),
                      (E = U),
                      (Z.flags &= 14680066),
                      (oA = Z.alternate),
                      oA === null
                        ? ((Z.childLanes = 0),
                          (Z.lanes = E),
                          (Z.child = null),
                          (Z.subtreeFlags = 0),
                          (Z.memoizedProps = null),
                          (Z.memoizedState = null),
                          (Z.updateQueue = null),
                          (Z.dependencies = null),
                          (Z.stateNode = null))
                        : ((Z.childLanes = oA.childLanes),
                          (Z.lanes = oA.lanes),
                          (Z.child = oA.child),
                          (Z.subtreeFlags = 0),
                          (Z.deletions = null),
                          (Z.memoizedProps = oA.memoizedProps),
                          (Z.memoizedState = oA.memoizedState),
                          (Z.updateQueue = oA.updateQueue),
                          (Z.type = oA.type),
                          (E = oA.dependencies),
                          (Z.dependencies =
                            E === null ? null : { lanes: E.lanes, firstContext: E.firstContext })),
                      (p = p.sibling))
                  return (Ue(wi, (wi.current & 1) | 2), l.child)
                }
                E = E.sibling
              }
            Z.tail !== null &&
              EI() > es &&
              ((l.flags |= 128), (U = !0), gt(Z, !1), (l.lanes = 4194304))
          }
        else {
          if (!U)
            if (((E = sn(oA)), E !== null)) {
              if (
                ((l.flags |= 128),
                (U = !0),
                (p = E.updateQueue),
                p !== null && ((l.updateQueue = p), (l.flags |= 4)),
                gt(Z, !0),
                Z.tail === null && Z.tailMode === "hidden" && !oA.alternate && !pi)
              )
                return (jB(l), null)
            } else
              2 * EI() - Z.renderingStartTime > es &&
                p !== 1073741824 &&
                ((l.flags |= 128), (U = !0), gt(Z, !1), (l.lanes = 4194304))
          Z.isBackwards
            ? ((oA.sibling = l.child), (l.child = oA))
            : ((p = Z.last), p !== null ? (p.sibling = oA) : (l.child = oA), (Z.last = oA))
        }
        return Z.tail !== null
          ? ((l = Z.tail),
            (Z.rendering = l),
            (Z.tail = l.sibling),
            (Z.renderingStartTime = EI()),
            (l.sibling = null),
            (p = wi.current),
            Ue(wi, U ? (p & 1) | 2 : p & 1),
            l)
          : (jB(l), null)
      case 22:
      case 23:
        return (
          th(),
          (U = l.memoizedState !== null),
          E !== null && (E.memoizedState !== null) !== U && (l.flags |= 8192),
          U && l.mode & 1
            ? tB & 1073741824 && (jB(l), l.subtreeFlags & 6 && (l.flags |= 8192))
            : jB(l),
          null
        )
      case 24:
        return null
      case 25:
        return null
    }
    throw Error(I(156, l.tag))
  }
  function HD(E, l) {
    switch ((NE(l), l.tag)) {
      case 1:
        return (
          Ri(l.type) && hQ(),
          (E = l.flags),
          E & 65536 ? ((l.flags = (E & -65537) | 128), l) : null
        )
      case 3:
        return (
          ra(),
          de(At),
          de(kC),
          _n(),
          (E = l.flags),
          E & 65536 && !(E & 128) ? ((l.flags = (E & -65537) | 128), l) : null
        )
      case 5:
        return (Qr(l), null)
      case 13:
        if ((de(wi), (E = l.memoizedState), E !== null && E.dehydrated !== null)) {
          if (l.alternate === null) throw Error(I(340))
          Hi()
        }
        return ((E = l.flags), E & 65536 ? ((l.flags = (E & -65537) | 128), l) : null)
      case 19:
        return (de(wi), null)
      case 4:
        return (ra(), null)
      case 10:
        return (xs(l.type._context), null)
      case 22:
      case 23:
        return (th(), null)
      case 24:
        return null
      default:
        return null
    }
  }
  var Zs = !1,
    UB = !1,
    $l = typeof WeakSet == "function" ? WeakSet : Set,
    xg = null
  function Ac(E, l) {
    var p = E.ref
    if (p !== null)
      if (typeof p == "function")
        try {
          p(null)
        } catch (U) {
          Pi(E, l, U)
        }
      else p.current = null
  }
  function uu(E, l, p) {
    try {
      p()
    } catch (U) {
      Pi(E, l, U)
    }
  }
  var $c = !1
  function Jp(E, l) {
    if (((ia = Ni), (E = he()), xe(E))) {
      if ("selectionStart" in E) var p = { start: E.selectionStart, end: E.selectionEnd }
      else
        A: {
          p = ((p = E.ownerDocument) && p.defaultView) || window
          var U = p.getSelection && p.getSelection()
          if (U && U.rangeCount !== 0) {
            p = U.anchorNode
            var q = U.anchorOffset,
              Z = U.focusNode
            U = U.focusOffset
            try {
              ;(p.nodeType, Z.nodeType)
            } catch {
              p = null
              break A
            }
            var oA = 0,
              KA = -1,
              bA = -1,
              kI = 0,
              tg = 0,
              Eg = E,
              Ig = null
            I: for (;;) {
              for (
                var Ug;
                Eg !== p || (q !== 0 && Eg.nodeType !== 3) || (KA = oA + q),
                  Eg !== Z || (U !== 0 && Eg.nodeType !== 3) || (bA = oA + U),
                  Eg.nodeType === 3 && (oA += Eg.nodeValue.length),
                  (Ug = Eg.firstChild) !== null;
              )
                ((Ig = Eg), (Eg = Ug))
              for (;;) {
                if (Eg === E) break I
                if (
                  (Ig === p && ++kI === q && (KA = oA),
                  Ig === Z && ++tg === U && (bA = oA),
                  (Ug = Eg.nextSibling) !== null)
                )
                  break
                ;((Eg = Ig), (Ig = Eg.parentNode))
              }
              Eg = Ug
            }
            p = KA === -1 || bA === -1 ? null : { start: KA, end: bA }
          } else p = null
        }
      p = p || { start: 0, end: 0 }
    } else p = null
    for (ME = { focusedElem: E, selectionRange: p }, Ni = !1, xg = l; xg !== null; )
      if (((l = xg), (E = l.child), (l.subtreeFlags & 1028) !== 0 && E !== null))
        ((E.return = l), (xg = E))
      else
        for (; xg !== null; ) {
          l = xg
          try {
            var Wg = l.alternate
            if (l.flags & 1024)
              switch (l.tag) {
                case 0:
                case 11:
                case 15:
                  break
                case 1:
                  if (Wg !== null) {
                    var Xg = Wg.memoizedProps,
                      Ft = Wg.memoizedState,
                      lI = l.stateNode,
                      XA = lI.getSnapshotBeforeUpdate(
                        l.elementType === l.type ? Xg : eB(l.type, Xg),
                        Ft,
                      )
                    lI.__reactInternalSnapshotBeforeUpdate = XA
                  }
                  break
                case 3:
                  var wI = l.stateNode.containerInfo
                  wI.nodeType === 1
                    ? (wI.textContent = "")
                    : wI.nodeType === 9 && wI.documentElement && wI.removeChild(wI.documentElement)
                  break
                case 5:
                case 6:
                case 4:
                case 17:
                  break
                default:
                  throw Error(I(163))
              }
          } catch (Dg) {
            Pi(l, l.return, Dg)
          }
          if (((E = l.sibling), E !== null)) {
            ;((E.return = l.return), (xg = E))
            break
          }
          xg = l.return
        }
    return ((Wg = $c), ($c = !1), Wg)
  }
  function Ps(E, l, p) {
    var U = l.updateQueue
    if (((U = U !== null ? U.lastEffect : null), U !== null)) {
      var q = (U = U.next)
      do {
        if ((q.tag & E) === E) {
          var Z = q.destroy
          ;((q.destroy = void 0), Z !== void 0 && uu(l, p, Z))
        }
        q = q.next
      } while (q !== U)
    }
  }
  function Ic(E, l) {
    if (((l = l.updateQueue), (l = l !== null ? l.lastEffect : null), l !== null)) {
      var p = (l = l.next)
      do {
        if ((p.tag & E) === E) {
          var U = p.create
          p.destroy = U()
        }
        p = p.next
      } while (p !== l)
    }
  }
  function Du(E) {
    var l = E.ref
    if (l !== null) {
      var p = E.stateNode
      switch (E.tag) {
        case 5:
          E = p
          break
        default:
          E = p
      }
      typeof l == "function" ? l(E) : (l.current = E)
    }
  }
  function $f(E) {
    var l = E.alternate
    ;(l !== null && ((E.alternate = null), $f(l)),
      (E.child = null),
      (E.deletions = null),
      (E.sibling = null),
      E.tag === 5 &&
        ((l = E.stateNode),
        l !== null && (delete l[Mt], delete l[xn], delete l[ta], delete l[Ba], delete l[Ir])),
      (E.stateNode = null),
      (E.return = null),
      (E.dependencies = null),
      (E.memoizedProps = null),
      (E.memoizedState = null),
      (E.pendingProps = null),
      (E.stateNode = null),
      (E.updateQueue = null))
  }
  function Is(E) {
    return E.tag === 5 || E.tag === 3 || E.tag === 4
  }
  function Ws(E) {
    A: for (;;) {
      for (; E.sibling === null; ) {
        if (E.return === null || Is(E.return)) return null
        E = E.return
      }
      for (
        E.sibling.return = E.return, E = E.sibling;
        E.tag !== 5 && E.tag !== 6 && E.tag !== 18;
      ) {
        if (E.flags & 2 || E.child === null || E.tag === 4) continue A
        ;((E.child.return = E), (E = E.child))
      }
      if (!(E.flags & 2)) return E.stateNode
    }
  }
  function gs(E, l, p) {
    var U = E.tag
    if (U === 5 || U === 6)
      ((E = E.stateNode),
        l
          ? p.nodeType === 8
            ? p.parentNode.insertBefore(E, l)
            : p.insertBefore(E, l)
          : (p.nodeType === 8
              ? ((l = p.parentNode), l.insertBefore(E, p))
              : ((l = p), l.appendChild(E)),
            (p = p._reactRootContainer),
            p != null || l.onclick !== null || (l.onclick = Xa)))
    else if (U !== 4 && ((E = E.child), E !== null))
      for (gs(E, l, p), E = E.sibling; E !== null; ) (gs(E, l, p), (E = E.sibling))
  }
  function lr(E, l, p) {
    var U = E.tag
    if (U === 5 || U === 6) ((E = E.stateNode), l ? p.insertBefore(E, l) : p.appendChild(E))
    else if (U !== 4 && ((E = E.child), E !== null))
      for (lr(E, l, p), E = E.sibling; E !== null; ) (lr(E, l, p), (E = E.sibling))
  }
  var me = null,
    Gi = !1
  function iB(E, l, p) {
    for (p = p.child; p !== null; ) (vo(E, l, p), (p = p.sibling))
  }
  function vo(E, l, p) {
    if (mg && typeof mg.onCommitFiberUnmount == "function")
      try {
        mg.onCommitFiberUnmount(wC, p)
      } catch {}
    switch (p.tag) {
      case 5:
        UB || Ac(p, l)
      case 6:
        var U = me,
          q = Gi
        ;((me = null),
          iB(E, l, p),
          (me = U),
          (Gi = q),
          me !== null &&
            (Gi
              ? ((E = me),
                (p = p.stateNode),
                E.nodeType === 8 ? E.parentNode.removeChild(p) : E.removeChild(p))
              : me.removeChild(p.stateNode)))
        break
      case 18:
        me !== null &&
          (Gi
            ? ((E = me),
              (p = p.stateNode),
              E.nodeType === 8 ? Bn(E.parentNode, p) : E.nodeType === 1 && Bn(E, p),
              An(E))
            : Bn(me, p.stateNode))
        break
      case 4:
        ;((U = me),
          (q = Gi),
          (me = p.stateNode.containerInfo),
          (Gi = !0),
          iB(E, l, p),
          (me = U),
          (Gi = q))
        break
      case 0:
      case 11:
      case 14:
      case 15:
        if (!UB && ((U = p.updateQueue), U !== null && ((U = U.lastEffect), U !== null))) {
          q = U = U.next
          do {
            var Z = q,
              oA = Z.destroy
            ;((Z = Z.tag), oA !== void 0 && (Z & 2 || Z & 4) && uu(p, l, oA), (q = q.next))
          } while (q !== U)
        }
        iB(E, l, p)
        break
      case 1:
        if (!UB && (Ac(p, l), (U = p.stateNode), typeof U.componentWillUnmount == "function"))
          try {
            ;((U.props = p.memoizedProps), (U.state = p.memoizedState), U.componentWillUnmount())
          } catch (KA) {
            Pi(p, l, KA)
          }
        iB(E, l, p)
        break
      case 21:
        iB(E, l, p)
        break
      case 22:
        p.mode & 1
          ? ((UB = (U = UB) || p.memoizedState !== null), iB(E, l, p), (UB = U))
          : iB(E, l, p)
        break
      default:
        iB(E, l, p)
    }
  }
  function Lo(E) {
    var l = E.updateQueue
    if (l !== null) {
      E.updateQueue = null
      var p = E.stateNode
      ;(p === null && (p = E.stateNode = new $l()),
        l.forEach(function (U) {
          var q = gd.bind(null, E, U)
          p.has(U) || (p.add(U), U.then(q, q))
        }))
    }
  }
  function zB(E, l) {
    var p = l.deletions
    if (p !== null)
      for (var U = 0; U < p.length; U++) {
        var q = p[U]
        try {
          var Z = E,
            oA = l,
            KA = oA
          A: for (; KA !== null; ) {
            switch (KA.tag) {
              case 5:
                ;((me = KA.stateNode), (Gi = !1))
                break A
              case 3:
                ;((me = KA.stateNode.containerInfo), (Gi = !0))
                break A
              case 4:
                ;((me = KA.stateNode.containerInfo), (Gi = !0))
                break A
            }
            KA = KA.return
          }
          if (me === null) throw Error(I(160))
          ;(vo(Z, oA, q), (me = null), (Gi = !1))
          var bA = q.alternate
          ;(bA !== null && (bA.return = null), (q.return = null))
        } catch (kI) {
          Pi(q, l, kI)
        }
      }
    if (l.subtreeFlags & 12854) for (l = l.child; l !== null; ) (Ad(l, E), (l = l.sibling))
  }
  function Ad(E, l) {
    var p = E.alternate,
      U = E.flags
    switch (E.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if ((zB(l, E), ua(E), U & 4)) {
          try {
            ;(Ps(3, E, E.return), Ic(3, E))
          } catch (Xg) {
            Pi(E, E.return, Xg)
          }
          try {
            Ps(5, E, E.return)
          } catch (Xg) {
            Pi(E, E.return, Xg)
          }
        }
        break
      case 1:
        ;(zB(l, E), ua(E), U & 512 && p !== null && Ac(p, p.return))
        break
      case 5:
        if ((zB(l, E), ua(E), U & 512 && p !== null && Ac(p, p.return), E.flags & 32)) {
          var q = E.stateNode
          try {
            Bg(q, "")
          } catch (Xg) {
            Pi(E, E.return, Xg)
          }
        }
        if (U & 4 && ((q = E.stateNode), q != null)) {
          var Z = E.memoizedProps,
            oA = p !== null ? p.memoizedProps : Z,
            KA = E.type,
            bA = E.updateQueue
          if (((E.updateQueue = null), bA !== null))
            try {
              ;(KA === "input" && Z.type === "radio" && Z.name != null && II(q, Z), XI(KA, oA))
              var kI = XI(KA, Z)
              for (oA = 0; oA < bA.length; oA += 2) {
                var tg = bA[oA],
                  Eg = bA[oA + 1]
                tg === "style"
                  ? RI(q, Eg)
                  : tg === "dangerouslySetInnerHTML"
                    ? LI(q, Eg)
                    : tg === "children"
                      ? Bg(q, Eg)
                      : Y(q, tg, Eg, kI)
              }
              switch (KA) {
                case "input":
                  pI(q, Z)
                  break
                case "textarea":
                  WA(q, Z)
                  break
                case "select":
                  var Ig = q._wrapperState.wasMultiple
                  q._wrapperState.wasMultiple = !!Z.multiple
                  var Ug = Z.value
                  Ug != null
                    ? QA(q, !!Z.multiple, Ug, !1)
                    : Ig !== !!Z.multiple &&
                      (Z.defaultValue != null
                        ? QA(q, !!Z.multiple, Z.defaultValue, !0)
                        : QA(q, !!Z.multiple, Z.multiple ? [] : "", !1))
              }
              q[xn] = Z
            } catch (Xg) {
              Pi(E, E.return, Xg)
            }
        }
        break
      case 6:
        if ((zB(l, E), ua(E), U & 4)) {
          if (E.stateNode === null) throw Error(I(162))
          ;((q = E.stateNode), (Z = E.memoizedProps))
          try {
            q.nodeValue = Z
          } catch (Xg) {
            Pi(E, E.return, Xg)
          }
        }
        break
      case 3:
        if ((zB(l, E), ua(E), U & 4 && p !== null && p.memoizedState.isDehydrated))
          try {
            An(l.containerInfo)
          } catch (Xg) {
            Pi(E, E.return, Xg)
          }
        break
      case 4:
        ;(zB(l, E), ua(E))
        break
      case 13:
        ;(zB(l, E),
          ua(E),
          (q = E.child),
          q.flags & 8192 &&
            ((Z = q.memoizedState !== null),
            (q.stateNode.isHidden = Z),
            !Z || (q.alternate !== null && q.alternate.memoizedState !== null) || (gh = EI())),
          U & 4 && Lo(E))
        break
      case 22:
        if (
          ((tg = p !== null && p.memoizedState !== null),
          E.mode & 1 ? ((UB = (kI = UB) || tg), zB(l, E), (UB = kI)) : zB(l, E),
          ua(E),
          U & 8192)
        ) {
          if (((kI = E.memoizedState !== null), (E.stateNode.isHidden = kI) && !tg && E.mode & 1))
            for (xg = E, tg = E.child; tg !== null; ) {
              for (Eg = xg = tg; xg !== null; ) {
                switch (((Ig = xg), (Ug = Ig.child), Ig.tag)) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    Ps(4, Ig, Ig.return)
                    break
                  case 1:
                    Ac(Ig, Ig.return)
                    var Wg = Ig.stateNode
                    if (typeof Wg.componentWillUnmount == "function") {
                      ;((U = Ig), (p = Ig.return))
                      try {
                        ;((l = U),
                          (Wg.props = l.memoizedProps),
                          (Wg.state = l.memoizedState),
                          Wg.componentWillUnmount())
                      } catch (Xg) {
                        Pi(U, p, Xg)
                      }
                    }
                    break
                  case 5:
                    Ac(Ig, Ig.return)
                    break
                  case 22:
                    if (Ig.memoizedState !== null) {
                      Ah(Eg)
                      continue
                    }
                }
                Ug !== null ? ((Ug.return = Ig), (xg = Ug)) : Ah(Eg)
              }
              tg = tg.sibling
            }
          A: for (tg = null, Eg = E; ; ) {
            if (Eg.tag === 5) {
              if (tg === null) {
                tg = Eg
                try {
                  ;((q = Eg.stateNode),
                    kI
                      ? ((Z = q.style),
                        typeof Z.setProperty == "function"
                          ? Z.setProperty("display", "none", "important")
                          : (Z.display = "none"))
                      : ((KA = Eg.stateNode),
                        (bA = Eg.memoizedProps.style),
                        (oA = bA != null && bA.hasOwnProperty("display") ? bA.display : null),
                        (KA.style.display = aI("display", oA))))
                } catch (Xg) {
                  Pi(E, E.return, Xg)
                }
              }
            } else if (Eg.tag === 6) {
              if (tg === null)
                try {
                  Eg.stateNode.nodeValue = kI ? "" : Eg.memoizedProps
                } catch (Xg) {
                  Pi(E, E.return, Xg)
                }
            } else if (
              ((Eg.tag !== 22 && Eg.tag !== 23) || Eg.memoizedState === null || Eg === E) &&
              Eg.child !== null
            ) {
              ;((Eg.child.return = Eg), (Eg = Eg.child))
              continue
            }
            if (Eg === E) break A
            for (; Eg.sibling === null; ) {
              if (Eg.return === null || Eg.return === E) break A
              ;(tg === Eg && (tg = null), (Eg = Eg.return))
            }
            ;(tg === Eg && (tg = null), (Eg.sibling.return = Eg.return), (Eg = Eg.sibling))
          }
        }
        break
      case 19:
        ;(zB(l, E), ua(E), U & 4 && Lo(E))
        break
      case 21:
        break
      default:
        ;(zB(l, E), ua(E))
    }
  }
  function ua(E) {
    var l = E.flags
    if (l & 2) {
      try {
        A: {
          for (var p = E.return; p !== null; ) {
            if (Is(p)) {
              var U = p
              break A
            }
            p = p.return
          }
          throw Error(I(160))
        }
        switch (U.tag) {
          case 5:
            var q = U.stateNode
            U.flags & 32 && (Bg(q, ""), (U.flags &= -33))
            var Z = Ws(E)
            lr(E, Z, q)
            break
          case 3:
          case 4:
            var oA = U.stateNode.containerInfo,
              KA = Ws(E)
            gs(E, KA, oA)
            break
          default:
            throw Error(I(161))
        }
      } catch (bA) {
        Pi(E, E.return, bA)
      }
      E.flags &= -3
    }
    l & 4096 && (E.flags &= -4097)
  }
  function Vs(E, l, p) {
    ;((xg = E), Su(E))
  }
  function Su(E, l, p) {
    for (var U = (E.mode & 1) !== 0; xg !== null; ) {
      var q = xg,
        Z = q.child
      if (q.tag === 22 && U) {
        var oA = q.memoizedState !== null || Zs
        if (!oA) {
          var KA = q.alternate,
            bA = (KA !== null && KA.memoizedState !== null) || UB
          KA = Zs
          var kI = UB
          if (((Zs = oA), (UB = bA) && !kI))
            for (xg = q; xg !== null; )
              ((oA = xg),
                (bA = oA.child),
                oA.tag === 22 && oA.memoizedState !== null
                  ? TD(q)
                  : bA !== null
                    ? ((bA.return = oA), (xg = bA))
                    : TD(q))
          for (; Z !== null; ) ((xg = Z), Su(Z), (Z = Z.sibling))
          ;((xg = q), (Zs = KA), (UB = kI))
        }
        Cs(E)
      } else q.subtreeFlags & 8772 && Z !== null ? ((Z.return = q), (xg = Z)) : Cs(E)
    }
  }
  function Cs(E) {
    for (; xg !== null; ) {
      var l = xg
      if (l.flags & 8772) {
        var p = l.alternate
        try {
          if (l.flags & 8772)
            switch (l.tag) {
              case 0:
              case 11:
              case 15:
                UB || Ic(5, l)
                break
              case 1:
                var U = l.stateNode
                if (l.flags & 4 && !UB)
                  if (p === null) U.componentDidMount()
                  else {
                    var q = l.elementType === l.type ? p.memoizedProps : eB(l.type, p.memoizedProps)
                    U.componentDidUpdate(q, p.memoizedState, U.__reactInternalSnapshotBeforeUpdate)
                  }
                var Z = l.updateQueue
                Z !== null && tr(l, Z, U)
                break
              case 3:
                var oA = l.updateQueue
                if (oA !== null) {
                  if (((p = null), l.child !== null))
                    switch (l.child.tag) {
                      case 5:
                        p = l.child.stateNode
                        break
                      case 1:
                        p = l.child.stateNode
                    }
                  tr(l, oA, p)
                }
                break
              case 5:
                var KA = l.stateNode
                if (p === null && l.flags & 4) {
                  p = KA
                  var bA = l.memoizedProps
                  switch (l.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      bA.autoFocus && p.focus()
                      break
                    case "img":
                      bA.src && (p.src = bA.src)
                  }
                }
                break
              case 6:
                break
              case 4:
                break
              case 12:
                break
              case 13:
                if (l.memoizedState === null) {
                  var kI = l.alternate
                  if (kI !== null) {
                    var tg = kI.memoizedState
                    if (tg !== null) {
                      var Eg = tg.dehydrated
                      Eg !== null && An(Eg)
                    }
                  }
                }
                break
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break
              default:
                throw Error(I(163))
            }
          UB || (l.flags & 512 && Du(l))
        } catch (Ig) {
          Pi(l, l.return, Ig)
        }
      }
      if (l === E) {
        xg = null
        break
      }
      if (((p = l.sibling), p !== null)) {
        ;((p.return = l.return), (xg = p))
        break
      }
      xg = l.return
    }
  }
  function Ah(E) {
    for (; xg !== null; ) {
      var l = xg
      if (l === E) {
        xg = null
        break
      }
      var p = l.sibling
      if (p !== null) {
        ;((p.return = l.return), (xg = p))
        break
      }
      xg = l.return
    }
  }
  function TD(E) {
    for (; xg !== null; ) {
      var l = xg
      try {
        switch (l.tag) {
          case 0:
          case 11:
          case 15:
            var p = l.return
            try {
              Ic(4, l)
            } catch (bA) {
              Pi(l, p, bA)
            }
            break
          case 1:
            var U = l.stateNode
            if (typeof U.componentDidMount == "function") {
              var q = l.return
              try {
                U.componentDidMount()
              } catch (bA) {
                Pi(l, q, bA)
              }
            }
            var Z = l.return
            try {
              Du(l)
            } catch (bA) {
              Pi(l, Z, bA)
            }
            break
          case 5:
            var oA = l.return
            try {
              Du(l)
            } catch (bA) {
              Pi(l, oA, bA)
            }
        }
      } catch (bA) {
        Pi(l, l.return, bA)
      }
      if (l === E) {
        xg = null
        break
      }
      var KA = l.sibling
      if (KA !== null) {
        ;((KA.return = l.return), (xg = KA))
        break
      }
      xg = l.return
    }
  }
  var xD = Math.ceil,
    js = H.ReactCurrentDispatcher,
    fu = H.ReactCurrentOwner,
    XB = H.ReactCurrentBatchConfig,
    fC = 0,
    Oe = null,
    ve = null,
    Ct = 0,
    tB = 0,
    gc = IC(0),
    NB = 0,
    Ih = null,
    zs = 0,
    Xs = 0,
    du = 0,
    Da = null,
    dQ = null,
    gh = 0,
    es = 1 / 0,
    YE = null,
    Cc = !1,
    bD = null,
    zn = null,
    ec = !1,
    Xn = null,
    Ch = 0,
    cr = 0,
    yu = null,
    ic = -1,
    $n = 0
  function FB() {
    return fC & 6 ? EI() : ic !== -1 ? ic : (ic = EI())
  }
  function St(E) {
    return E.mode & 1
      ? fC & 2 && Ct !== 0
        ? Ct & -Ct
        : Zl.transition !== null
          ? ($n === 0 && ($n = He()), $n)
          : ((E = XC), E !== 0 || ((E = window.event), (E = E === void 0 ? 16 : gn(E.type))), E)
      : 1
  }
  function et(E, l, p, U) {
    if (50 < cr) throw ((cr = 0), (yu = null), Error(I(185)))
    ;(Yi(E, p, U),
      (!(fC & 2) || E !== Oe) &&
        (E === Oe && (!(fC & 2) && (Xs |= p), NB === 4 && qE(E, Ct)),
        BB(E, U),
        p === 1 && fC === 0 && !(l.mode & 1) && ((es = EI() + 500), Xt && st())))
  }
  function BB(E, l) {
    var p = E.callbackNode
    ai(E, l)
    var U = Mi(E, E === Oe ? Ct : 0)
    if (U === 0) (p !== null && QI(p), (E.callbackNode = null), (E.callbackPriority = 0))
    else if (((l = U & -U), E.callbackPriority !== l)) {
      if ((p != null && QI(p), l === 1))
        (E.tag === 0 ? oa(Sa.bind(null, E)) : Mo(Sa.bind(null, E)),
          Ys(function () {
            !(fC & 6) && st()
          }),
          (p = null))
      else {
        switch (dB(U)) {
          case 1:
            p = yg
            break
          case 4:
            p = rg
            break
          case 16:
            p = eC
            break
          case 536870912:
            p = pC
            break
          default:
            p = eC
        }
        p = oc(p, tc.bind(null, E))
      }
      ;((E.callbackPriority = l), (E.callbackNode = p))
    }
  }
  function tc(E, l) {
    if (((ic = -1), ($n = 0), fC & 6)) throw Error(I(327))
    var p = E.callbackNode
    if (Bs() && E.callbackNode !== p) return null
    var U = Mi(E, E === Oe ? Ct : 0)
    if (U === 0) return null
    if (U & 30 || U & E.expiredLanes || l) l = pu(E, U)
    else {
      l = U
      var q = fC
      fC |= 2
      var Z = OD()
      ;(Oe !== E || Ct !== l) && ((YE = null), (es = EI() + 500), is(E, l))
      do
        try {
          ts()
          break
        } catch (KA) {
          $s(E, KA)
        }
      while (!0)
      ;(lB(), (js.current = Z), (fC = q), ve !== null ? (l = 0) : ((Oe = null), (Ct = 0), (l = NB)))
    }
    if (l !== 0) {
      if ((l === 2 && ((q = fi(E)), q !== 0 && ((U = q), (l = hr(E, q)))), l === 1))
        throw ((p = Ih), is(E, 0), qE(E, U), BB(E, EI()), p)
      if (l === 6) qE(E, U)
      else {
        if (
          ((q = E.current.alternate),
          !(U & 30) &&
            !ih(q) &&
            ((l = pu(E, U)),
            l === 2 && ((Z = fi(E)), Z !== 0 && ((U = Z), (l = hr(E, Z)))),
            l === 1))
        )
          throw ((p = Ih), is(E, 0), qE(E, U), BB(E, EI()), p)
        switch (((E.finishedWork = q), (E.finishedLanes = U), l)) {
          case 0:
          case 1:
            throw Error(I(345))
          case 2:
            HE(E, dQ, YE)
            break
          case 3:
            if ((qE(E, U), (U & 130023424) === U && ((l = gh + 500 - EI()), 10 < l))) {
              if (Mi(E, 0) !== 0) break
              if (((q = E.suspendedLanes), (q & U) !== U)) {
                ;(FB(), (E.pingedLanes |= E.suspendedLanes & q))
                break
              }
              E.timeoutHandle = UE(HE.bind(null, E, dQ, YE), l)
              break
            }
            HE(E, dQ, YE)
            break
          case 4:
            if ((qE(E, U), (U & 4194240) === U)) break
            for (l = E.eventTimes, q = -1; 0 < U; ) {
              var oA = 31 - iC(U)
              ;((Z = 1 << oA), (oA = l[oA]), oA > q && (q = oA), (U &= ~Z))
            }
            if (
              ((U = q),
              (U = EI() - U),
              (U =
                (120 > U
                  ? 120
                  : 480 > U
                    ? 480
                    : 1080 > U
                      ? 1080
                      : 1920 > U
                        ? 1920
                        : 3e3 > U
                          ? 3e3
                          : 4320 > U
                            ? 4320
                            : 1960 * xD(U / 1960)) - U),
              10 < U)
            ) {
              E.timeoutHandle = UE(HE.bind(null, E, dQ, YE), U)
              break
            }
            HE(E, dQ, YE)
            break
          case 5:
            HE(E, dQ, YE)
            break
          default:
            throw Error(I(329))
        }
      }
    }
    return (BB(E, EI()), E.callbackNode === p ? tc.bind(null, E) : null)
  }
  function hr(E, l) {
    var p = Da
    return (
      E.current.memoizedState.isDehydrated && (is(E, l).flags |= 256),
      (E = pu(E, l)),
      E !== 2 && ((l = dQ), (dQ = p), l !== null && eh(l)),
      E
    )
  }
  function eh(E) {
    dQ === null ? (dQ = E) : dQ.push.apply(dQ, E)
  }
  function ih(E) {
    for (var l = E; ; ) {
      if (l.flags & 16384) {
        var p = l.updateQueue
        if (p !== null && ((p = p.stores), p !== null))
          for (var U = 0; U < p.length; U++) {
            var q = p[U],
              Z = q.getSnapshot
            q = q.value
            try {
              if (!rt(Z(), q)) return !1
            } catch {
              return !1
            }
          }
      }
      if (((p = l.child), l.subtreeFlags & 16384 && p !== null)) ((p.return = l), (l = p))
      else {
        if (l === E) break
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === E) return !0
          l = l.return
        }
        ;((l.sibling.return = l.return), (l = l.sibling))
      }
    }
    return !0
  }
  function qE(E, l) {
    for (
      l &= ~du, l &= ~Xs, E.suspendedLanes |= l, E.pingedLanes &= ~l, E = E.expirationTimes;
      0 < l;
    ) {
      var p = 31 - iC(l),
        U = 1 << p
      ;((E[p] = -1), (l &= ~U))
    }
  }
  function Sa(E) {
    if (fC & 6) throw Error(I(327))
    Bs()
    var l = Mi(E, 0)
    if (!(l & 1)) return (BB(E, EI()), null)
    var p = pu(E, l)
    if (E.tag !== 0 && p === 2) {
      var U = fi(E)
      U !== 0 && ((l = U), (p = hr(E, U)))
    }
    if (p === 1) throw ((p = Ih), is(E, 0), qE(E, l), BB(E, EI()), p)
    if (p === 6) throw Error(I(345))
    return (
      (E.finishedWork = E.current.alternate),
      (E.finishedLanes = l),
      HE(E, dQ, YE),
      BB(E, EI()),
      null
    )
  }
  function Bc(E, l) {
    var p = fC
    fC |= 1
    try {
      return E(l)
    } finally {
      ;((fC = p), fC === 0 && ((es = EI() + 500), Xt && st()))
    }
  }
  function un(E) {
    Xn !== null && Xn.tag === 0 && !(fC & 6) && Bs()
    var l = fC
    fC |= 1
    var p = XB.transition,
      U = XC
    try {
      if (((XB.transition = null), (XC = 1), E)) return E()
    } finally {
      ;((XC = U), (XB.transition = p), (fC = l), !(fC & 6) && st())
    }
  }
  function th() {
    ;((tB = gc.current), de(gc))
  }
  function is(E, l) {
    ;((E.finishedWork = null), (E.finishedLanes = 0))
    var p = E.timeoutHandle
    if ((p !== -1 && ((E.timeoutHandle = -1), Vr(p)), ve !== null))
      for (p = ve.return; p !== null; ) {
        var U = p
        switch ((NE(U), U.tag)) {
          case 1:
            ;((U = U.type.childContextTypes), U != null && hQ())
            break
          case 3:
            ;(ra(), de(At), de(kC), _n())
            break
          case 5:
            Qr(U)
            break
          case 4:
            ra()
            break
          case 13:
            de(wi)
            break
          case 19:
            de(wi)
            break
          case 10:
            xs(U.type._context)
            break
          case 22:
          case 23:
            th()
        }
        p = p.return
      }
    if (
      ((Oe = E),
      (ve = E = os(E.current, null)),
      (Ct = tB = l),
      (NB = 0),
      (Ih = null),
      (du = Xs = zs = 0),
      (dQ = Da = null),
      wg !== null)
    ) {
      for (l = 0; l < wg.length; l++)
        if (((p = wg[l]), (U = p.interleaved), U !== null)) {
          p.interleaved = null
          var q = U.next,
            Z = p.pending
          if (Z !== null) {
            var oA = Z.next
            ;((Z.next = q), (U.next = oA))
          }
          p.pending = U
        }
      wg = null
    }
    return E
  }
  function $s(E, l) {
    do {
      var p = ve
      try {
        if ((lB(), (nr.current = VB), xt)) {
          for (var U = Pg.memoizedState; U !== null; ) {
            var q = U.queue
            ;(q !== null && (q.pending = null), (U = U.next))
          }
          xt = !1
        }
        if (
          ((zg = 0),
          (rC = uC = Pg = null),
          (GB = !1),
          (Zn = 0),
          (fu.current = null),
          p === null || p.return === null)
        ) {
          ;((NB = 1), (Ih = l), (ve = null))
          break
        }
        A: {
          var Z = E,
            oA = p.return,
            KA = p,
            bA = l
          if (
            ((l = Ct),
            (KA.flags |= 32768),
            bA !== null && typeof bA == "object" && typeof bA.then == "function")
          ) {
            var kI = bA,
              tg = KA,
              Eg = tg.tag
            if (!(tg.mode & 1) && (Eg === 0 || Eg === 11 || Eg === 15)) {
              var Ig = tg.alternate
              Ig
                ? ((tg.updateQueue = Ig.updateQueue),
                  (tg.memoizedState = Ig.memoizedState),
                  (tg.lanes = Ig.lanes))
                : ((tg.updateQueue = null), (tg.memoizedState = null))
            }
            var Ug = Sg(oA)
            if (Ug !== null) {
              ;((Ug.flags &= -257),
                DC(Ug, oA, KA, Z, l),
                Ug.mode & 1 && ng(Z, kI, l),
                (l = Ug),
                (bA = kI))
              var Wg = l.updateQueue
              if (Wg === null) {
                var Xg = /* @__PURE__ */ new Set()
                ;(Xg.add(bA), (l.updateQueue = Xg))
              } else Wg.add(bA)
              break A
            } else {
              if (!(l & 1)) {
                ;(ng(Z, kI, l), Bh())
                break A
              }
              bA = Error(I(426))
            }
          } else if (pi && KA.mode & 1) {
            var Ft = Sg(oA)
            if (Ft !== null) {
              ;(!(Ft.flags & 65536) && (Ft.flags |= 256), DC(Ft, oA, KA, Z, l), zr(v(bA, KA)))
              break A
            }
          }
          ;((Z = bA = v(bA, KA)),
            NB !== 4 && (NB = 2),
            Da === null ? (Da = [Z]) : Da.push(Z),
            (Z = oA))
          do {
            switch (Z.tag) {
              case 3:
                ;((Z.flags |= 65536), (l &= -l), (Z.lanes |= l))
                var lI = CI(Z, bA, l)
                ir(Z, lI)
                break A
              case 1:
                KA = bA
                var XA = Z.type,
                  wI = Z.stateNode
                if (
                  !(Z.flags & 128) &&
                  (typeof XA.getDerivedStateFromError == "function" ||
                    (wI !== null &&
                      typeof wI.componentDidCatch == "function" &&
                      (zn === null || !zn.has(wI))))
                ) {
                  ;((Z.flags |= 65536), (l &= -l), (Z.lanes |= l))
                  var Dg = HI(Z, KA, l)
                  ir(Z, Dg)
                  break A
                }
            }
            Z = Z.return
          } while (Z !== null)
        }
        oh(p)
      } catch (gC) {
        ;((l = gC), ve === p && p !== null && (ve = p = p.return))
        continue
      }
      break
    } while (!0)
  }
  function OD() {
    var E = js.current
    return ((js.current = VB), E === null ? VB : E)
  }
  function Bh() {
    ;((NB === 0 || NB === 3 || NB === 2) && (NB = 4),
      Oe === null || (!(zs & 268435455) && !(Xs & 268435455)) || qE(Oe, Ct))
  }
  function pu(E, l) {
    var p = fC
    fC |= 2
    var U = OD()
    ;(Oe !== E || Ct !== l) && ((YE = null), is(E, l))
    do
      try {
        Qh()
        break
      } catch (q) {
        $s(E, q)
      }
    while (!0)
    if ((lB(), (fC = p), (js.current = U), ve !== null)) throw Error(I(261))
    return ((Oe = null), (Ct = 0), NB)
  }
  function Qh() {
    for (; ve !== null; ) Qc(ve)
  }
  function ts() {
    for (; ve !== null && !PA(); ) Qc(ve)
  }
  function Qc(E) {
    var l = PD(E.alternate, E, tB)
    ;((E.memoizedProps = E.pendingProps), l === null ? oh(E) : (ve = l), (fu.current = null))
  }
  function oh(E) {
    var l = E
    do {
      var p = l.alternate
      if (((E = l.return), l.flags & 32768)) {
        if (((p = HD(p, l)), p !== null)) {
          ;((p.flags &= 32767), (ve = p))
          return
        }
        if (E !== null) ((E.flags |= 32768), (E.subtreeFlags = 0), (E.deletions = null))
        else {
          ;((NB = 6), (ve = null))
          return
        }
      } else if (((p = qD(p, l, tB)), p !== null)) {
        ve = p
        return
      }
      if (((l = l.sibling), l !== null)) {
        ve = l
        return
      }
      ve = l = E
    } while (l !== null)
    NB === 0 && (NB = 5)
  }
  function HE(E, l, p) {
    var U = XC,
      q = XB.transition
    try {
      ;((XB.transition = null), (XC = 1), _D(E, l, p, U))
    } finally {
      ;((XB.transition = q), (XC = U))
    }
    return null
  }
  function _D(E, l, p, U) {
    do Bs()
    while (Xn !== null)
    if (fC & 6) throw Error(I(327))
    p = E.finishedWork
    var q = E.finishedLanes
    if (p === null) return null
    if (((E.finishedWork = null), (E.finishedLanes = 0), p === E.current)) throw Error(I(177))
    ;((E.callbackNode = null), (E.callbackPriority = 0))
    var Z = p.lanes | p.childLanes
    if (
      (vn(E, Z),
      E === Oe && ((ve = Oe = null), (Ct = 0)),
      (!(p.subtreeFlags & 2064) && !(p.flags & 2064)) ||
        ec ||
        ((ec = !0),
        oc(eC, function () {
          return (Bs(), null)
        })),
      (Z = (p.flags & 15990) !== 0),
      p.subtreeFlags & 15990 || Z)
    ) {
      ;((Z = XB.transition), (XB.transition = null))
      var oA = XC
      XC = 1
      var KA = fC
      ;((fC |= 4),
        (fu.current = null),
        Jp(E, p),
        Ad(p, E),
        $e(ME),
        (Ni = !!ia),
        (ME = ia = null),
        (E.current = p),
        Vs(p),
        gg(),
        (fC = KA),
        (XC = oA),
        (XB.transition = Z))
    } else E.current = p
    if (
      (ec && ((ec = !1), (Xn = E), (Ch = q)),
      (Z = E.pendingLanes),
      Z === 0 && (zn = null),
      UC(p.stateNode),
      BB(E, EI()),
      l !== null)
    )
      for (U = E.onRecoverableError, p = 0; p < l.length; p++)
        ((q = l[p]), U(q.value, { componentStack: q.stack, digest: q.digest }))
    if (Cc) throw ((Cc = !1), (E = bD), (bD = null), E)
    return (
      Ch & 1 && E.tag !== 0 && Bs(),
      (Z = E.pendingLanes),
      Z & 1 ? (E === yu ? cr++ : ((cr = 0), (yu = E))) : (cr = 0),
      st(),
      null
    )
  }
  function Bs() {
    if (Xn !== null) {
      var E = dB(Ch),
        l = XB.transition,
        p = XC
      try {
        if (((XB.transition = null), (XC = 16 > E ? 16 : E), Xn === null)) var U = !1
        else {
          if (((E = Xn), (Xn = null), (Ch = 0), fC & 6)) throw Error(I(331))
          var q = fC
          for (fC |= 4, xg = E.current; xg !== null; ) {
            var Z = xg,
              oA = Z.child
            if (xg.flags & 16) {
              var KA = Z.deletions
              if (KA !== null) {
                for (var bA = 0; bA < KA.length; bA++) {
                  var kI = KA[bA]
                  for (xg = kI; xg !== null; ) {
                    var tg = xg
                    switch (tg.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Ps(8, tg, Z)
                    }
                    var Eg = tg.child
                    if (Eg !== null) ((Eg.return = tg), (xg = Eg))
                    else
                      for (; xg !== null; ) {
                        tg = xg
                        var Ig = tg.sibling,
                          Ug = tg.return
                        if (($f(tg), tg === kI)) {
                          xg = null
                          break
                        }
                        if (Ig !== null) {
                          ;((Ig.return = Ug), (xg = Ig))
                          break
                        }
                        xg = Ug
                      }
                  }
                }
                var Wg = Z.alternate
                if (Wg !== null) {
                  var Xg = Wg.child
                  if (Xg !== null) {
                    Wg.child = null
                    do {
                      var Ft = Xg.sibling
                      ;((Xg.sibling = null), (Xg = Ft))
                    } while (Xg !== null)
                  }
                }
                xg = Z
              }
            }
            if (Z.subtreeFlags & 2064 && oA !== null) ((oA.return = Z), (xg = oA))
            else
              A: for (; xg !== null; ) {
                if (((Z = xg), Z.flags & 2048))
                  switch (Z.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Ps(9, Z, Z.return)
                  }
                var lI = Z.sibling
                if (lI !== null) {
                  ;((lI.return = Z.return), (xg = lI))
                  break A
                }
                xg = Z.return
              }
          }
          var XA = E.current
          for (xg = XA; xg !== null; ) {
            oA = xg
            var wI = oA.child
            if (oA.subtreeFlags & 2064 && wI !== null) ((wI.return = oA), (xg = wI))
            else
              A: for (oA = XA; xg !== null; ) {
                if (((KA = xg), KA.flags & 2048))
                  try {
                    switch (KA.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Ic(9, KA)
                    }
                  } catch (gC) {
                    Pi(KA, KA.return, gC)
                  }
                if (KA === oA) {
                  xg = null
                  break A
                }
                var Dg = KA.sibling
                if (Dg !== null) {
                  ;((Dg.return = KA.return), (xg = Dg))
                  break A
                }
                xg = KA.return
              }
          }
          if (((fC = q), st(), mg && typeof mg.onPostCommitFiberRoot == "function"))
            try {
              mg.onPostCommitFiberRoot(wC, E)
            } catch {}
          U = !0
        }
        return U
      } finally {
        ;((XC = p), (XB.transition = l))
      }
    }
    return !1
  }
  function Al(E, l, p) {
    ;((l = v(p, l)),
      (l = CI(E, l, 1)),
      (E = Ie(E, l, 1)),
      (l = FB()),
      E !== null && (Yi(E, 1, l), BB(E, l)))
  }
  function Pi(E, l, p) {
    if (E.tag === 3) Al(E, E, p)
    else
      for (; l !== null; ) {
        if (l.tag === 3) {
          Al(l, E, p)
          break
        } else if (l.tag === 1) {
          var U = l.stateNode
          if (
            typeof l.type.getDerivedStateFromError == "function" ||
            (typeof U.componentDidCatch == "function" && (zn === null || !zn.has(U)))
          ) {
            ;((E = v(p, E)),
              (E = HI(l, E, 1)),
              (l = Ie(l, E, 1)),
              (E = FB()),
              l !== null && (Yi(l, 1, E), BB(l, E)))
            break
          }
        }
        l = l.return
      }
  }
  function Id(E, l, p) {
    var U = E.pingCache
    ;(U !== null && U.delete(l),
      (l = FB()),
      (E.pingedLanes |= E.suspendedLanes & p),
      Oe === E &&
        (Ct & p) === p &&
        (NB === 4 || (NB === 3 && (Ct & 130023424) === Ct && 500 > EI() - gh)
          ? is(E, 0)
          : (du |= p)),
      BB(E, l))
  }
  function wu(E, l) {
    l === 0 && (E.mode & 1 ? ((l = qe), (qe <<= 1), !(qe & 130023424) && (qe = 4194304)) : (l = 1))
    var p = FB()
    ;((E = rn(E, l)), E !== null && (Yi(E, l, p), BB(E, p)))
  }
  function ZD(E) {
    var l = E.memoizedState,
      p = 0
    ;(l !== null && (p = l.retryLane), wu(E, p))
  }
  function gd(E, l) {
    var p = 0
    switch (E.tag) {
      case 13:
        var U = E.stateNode,
          q = E.memoizedState
        q !== null && (p = q.retryLane)
        break
      case 19:
        U = E.stateNode
        break
      default:
        throw Error(I(314))
    }
    ;(U !== null && U.delete(l), wu(E, p))
  }
  var PD
  PD = function (E, l, p) {
    if (E !== null)
      if (E.memoizedProps !== l.pendingProps || At.current) Be = !0
      else {
        if (!(E.lanes & p) && !(l.flags & 128)) return ((Be = !1), LE(E, l, p))
        Be = !!(E.flags & 131072)
      }
    else ((Be = !1), pi && l.flags & 1048576 && _l(l, LC, l.index))
    switch (((l.lanes = 0), l.tag)) {
      case 2:
        var U = l.type
        ;(Xl(E, l), (E = l.pendingProps))
        var q = cQ(l, kC.current)
        ;(Bo(l, p), (q = Ag(null, l, U, E, q, p)))
        var Z = ct()
        return (
          (l.flags |= 1),
          typeof q == "object" &&
          q !== null &&
          typeof q.render == "function" &&
          q.$$typeof === void 0
            ? ((l.tag = 1),
              (l.memoizedState = null),
              (l.updateQueue = null),
              Ri(U) ? ((Z = !0), On(l)) : (Z = !1),
              (l.memoizedState = q.state !== null && q.state !== void 0 ? q.state : null),
              $C(l),
              (q.updater = mo),
              (l.stateNode = q),
              (q._reactInternals = l),
              N(l, U, E, p),
              (l = WC(null, l, U, !0, Z, p)))
            : ((l.tag = 0), pi && Z && qs(l), kg(null, l, q, p), (l = l.child)),
          l
        )
      case 16:
        U = l.elementType
        A: {
          switch (
            (Xl(E, l),
            (E = l.pendingProps),
            (q = U._init),
            (U = q(U._payload)),
            (l.type = U),
            (q = l.tag = WD(U)),
            (E = eB(U, E)),
            q)
          ) {
            case 0:
              l = WI(null, l, U, E, p)
              break A
            case 1:
              l = Zg(null, l, U, E, p)
              break A
            case 11:
              l = ut(null, l, U, E, p)
              break A
            case 14:
              l = Dt(null, l, U, eB(U.type, E), p)
              break A
          }
          throw Error(I(306, U, ""))
        }
        return l
      case 0:
        return (
          (U = l.type),
          (q = l.pendingProps),
          (q = l.elementType === U ? q : eB(U, q)),
          WI(E, l, U, q, p)
        )
      case 1:
        return (
          (U = l.type),
          (q = l.pendingProps),
          (q = l.elementType === U ? q : eB(U, q)),
          Zg(E, l, U, q, p)
        )
      case 3:
        A: {
          if ((SC(l), E === null)) throw Error(I(387))
          ;((U = l.pendingProps),
            (Z = l.memoizedState),
            (q = Z.element),
            xi(E, l),
            lt(l, U, null, p))
          var oA = l.memoizedState
          if (((U = oA.element), Z.isDehydrated))
            if (
              ((Z = {
                element: U,
                isDehydrated: !1,
                cache: oA.cache,
                pendingSuspenseBoundaries: oA.pendingSuspenseBoundaries,
                transitions: oA.transitions,
              }),
              (l.updateQueue.baseState = Z),
              (l.memoizedState = Z),
              l.flags & 256)
            ) {
              ;((q = v(Error(I(423)), l)), (l = Qe(E, l, U, p, q)))
              break A
            } else if (U !== q) {
              ;((q = v(Error(I(424)), l)), (l = Qe(E, l, U, p, q)))
              break A
            } else
              for (
                _B = rQ(l.stateNode.containerInfo.firstChild),
                  AB = l,
                  pi = !0,
                  qQ = null,
                  p = Ts(l, null, U, p),
                  l.child = p;
                p;
              )
                ((p.flags = (p.flags & -3) | 4096), (p = p.sibling))
          else {
            if ((Hi(), U === q)) {
              l = Ut(E, l, p)
              break A
            }
            kg(E, l, U, p)
          }
          l = l.child
        }
        return l
      case 5:
        return (
          Br(l),
          E === null && Cr(l),
          (U = l.type),
          (q = l.pendingProps),
          (Z = E !== null ? E.memoizedProps : null),
          (oA = q.children),
          $a(U, q) ? (oA = null) : Z !== null && $a(U, Z) && (l.flags |= 32),
          JI(E, l),
          kg(E, l, oA, p),
          l.child
        )
      case 6:
        return (E === null && Cr(l), null)
      case 13:
        return vE(E, l, p)
      case 4:
        return (
          Os(l, l.stateNode.containerInfo),
          (U = l.pendingProps),
          E === null ? (l.child = er(l, null, U, p)) : kg(E, l, U, p),
          l.child
        )
      case 11:
        return (
          (U = l.type),
          (q = l.pendingProps),
          (q = l.elementType === U ? q : eB(U, q)),
          ut(E, l, U, q, p)
        )
      case 7:
        return (kg(E, l, l.pendingProps, p), l.child)
      case 8:
        return (kg(E, l, l.pendingProps.children, p), l.child)
      case 12:
        return (kg(E, l, l.pendingProps.children, p), l.child)
      case 10:
        A: {
          if (
            ((U = l.type._context),
            (q = l.pendingProps),
            (Z = l.memoizedProps),
            (oA = q.value),
            Ue(Bi, U._currentValue),
            (U._currentValue = oA),
            Z !== null)
          )
            if (rt(Z.value, oA)) {
              if (Z.children === q.children && !At.current) {
                l = Ut(E, l, p)
                break A
              }
            } else
              for (Z = l.child, Z !== null && (Z.return = l); Z !== null; ) {
                var KA = Z.dependencies
                if (KA !== null) {
                  oA = Z.child
                  for (var bA = KA.firstContext; bA !== null; ) {
                    if (bA.context === U) {
                      if (Z.tag === 1) {
                        ;((bA = Ke(-1, p & -p)), (bA.tag = 2))
                        var kI = Z.updateQueue
                        if (kI !== null) {
                          kI = kI.shared
                          var tg = kI.pending
                          ;(tg === null ? (bA.next = bA) : ((bA.next = tg.next), (tg.next = bA)),
                            (kI.pending = bA))
                        }
                      }
                      ;((Z.lanes |= p),
                        (bA = Z.alternate),
                        bA !== null && (bA.lanes |= p),
                        bs(Z.return, p, l),
                        (KA.lanes |= p))
                      break
                    }
                    bA = bA.next
                  }
                } else if (Z.tag === 10) oA = Z.type === l.type ? null : Z.child
                else if (Z.tag === 18) {
                  if (((oA = Z.return), oA === null)) throw Error(I(341))
                  ;((oA.lanes |= p),
                    (KA = oA.alternate),
                    KA !== null && (KA.lanes |= p),
                    bs(oA, p, l),
                    (oA = Z.sibling))
                } else oA = Z.child
                if (oA !== null) oA.return = Z
                else
                  for (oA = Z; oA !== null; ) {
                    if (oA === l) {
                      oA = null
                      break
                    }
                    if (((Z = oA.sibling), Z !== null)) {
                      ;((Z.return = oA.return), (oA = Z))
                      break
                    }
                    oA = oA.return
                  }
                Z = oA
              }
          ;(kg(E, l, q.children, p), (l = l.child))
        }
        return l
      case 9:
        return (
          (q = l.type),
          (U = l.pendingProps.children),
          Bo(l, p),
          (q = si(q)),
          (U = U(q)),
          (l.flags |= 1),
          kg(E, l, U, p),
          l.child
        )
      case 14:
        return ((U = l.type), (q = eB(U, l.pendingProps)), (q = eB(U.type, q)), Dt(E, l, U, q, p))
      case 15:
        return yI(E, l, l.type, l.pendingProps, p)
      case 17:
        return (
          (U = l.type),
          (q = l.pendingProps),
          (q = l.elementType === U ? q : eB(U, q)),
          Xl(E, l),
          (l.tag = 1),
          Ri(U) ? ((E = !0), On(l)) : (E = !1),
          Bo(l, p),
          u(l, U, q),
          N(l, U, q, p),
          WC(null, l, U, !0, E, p)
        )
      case 19:
        return Xc(E, l, p)
      case 22:
        return zA(E, l, p)
    }
    throw Error(I(156, l.tag))
  }
  function oc(E, l) {
    return oI(E, l)
  }
  function AE(E, l, p, U) {
    ;((this.tag = E),
      (this.key = p),
      (this.sibling =
        this.child =
        this.return =
        this.stateNode =
        this.type =
        this.elementType =
          null),
      (this.index = 0),
      (this.ref = null),
      (this.pendingProps = l),
      (this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null),
      (this.mode = U),
      (this.subtreeFlags = this.flags = 0),
      (this.deletions = null),
      (this.childLanes = this.lanes = 0),
      (this.alternate = null))
  }
  function Yo(E, l, p, U) {
    return new AE(E, l, p, U)
  }
  function Qs(E) {
    return ((E = E.prototype), !(!E || !E.isReactComponent))
  }
  function WD(E) {
    if (typeof E == "function") return Qs(E) ? 1 : 0
    if (E != null) {
      if (((E = E.$$typeof), E === CA)) return 11
      if (E === JA) return 14
    }
    return 2
  }
  function os(E, l) {
    var p = E.alternate
    return (
      p === null
        ? ((p = Yo(E.tag, l, E.key, E.mode)),
          (p.elementType = E.elementType),
          (p.type = E.type),
          (p.stateNode = E.stateNode),
          (p.alternate = E),
          (E.alternate = p))
        : ((p.pendingProps = l),
          (p.type = E.type),
          (p.flags = 0),
          (p.subtreeFlags = 0),
          (p.deletions = null)),
      (p.flags = E.flags & 14680064),
      (p.childLanes = E.childLanes),
      (p.lanes = E.lanes),
      (p.child = E.child),
      (p.memoizedProps = E.memoizedProps),
      (p.memoizedState = E.memoizedState),
      (p.updateQueue = E.updateQueue),
      (l = E.dependencies),
      (p.dependencies = l === null ? null : { lanes: l.lanes, firstContext: l.firstContext }),
      (p.sibling = E.sibling),
      (p.index = E.index),
      (p.ref = E.ref),
      p
    )
  }
  function TE(E, l, p, U, q, Z) {
    var oA = 2
    if (((U = E), typeof E == "function")) Qs(E) && (oA = 1)
    else if (typeof E == "string") oA = 5
    else
      A: switch (E) {
        case P:
          return IE(p.children, q, Z, l)
        case AA:
          ;((oA = 8), (q |= 8))
          break
        case X:
          return ((E = Yo(12, p, l, q | 2)), (E.elementType = X), (E.lanes = Z), E)
        case aA:
          return ((E = Yo(13, p, l, q)), (E.elementType = aA), (E.lanes = Z), E)
        case lA:
          return ((E = Yo(19, p, l, q)), (E.elementType = lA), (E.lanes = Z), E)
        case LA:
          return Gu(p, q, Z, l)
        default:
          if (typeof E == "object" && E !== null)
            switch (E.$$typeof) {
              case _:
                oA = 10
                break A
              case eA:
                oA = 9
                break A
              case CA:
                oA = 11
                break A
              case JA:
                oA = 14
                break A
              case yA:
                ;((oA = 16), (U = null))
                break A
            }
          throw Error(I(130, E == null ? E : typeof E, ""))
      }
    return ((l = Yo(oA, p, l, q)), (l.elementType = E), (l.type = U), (l.lanes = Z), l)
  }
  function IE(E, l, p, U) {
    return ((E = Yo(7, E, U, l)), (E.lanes = p), E)
  }
  function Gu(E, l, p, U) {
    return (
      (E = Yo(22, E, U, l)),
      (E.elementType = LA),
      (E.lanes = p),
      (E.stateNode = { isHidden: !1 }),
      E
    )
  }
  function Il(E, l, p) {
    return ((E = Yo(6, E, null, l)), (E.lanes = p), E)
  }
  function qo(E, l, p) {
    return (
      (l = Yo(4, E.children !== null ? E.children : [], E.key, l)),
      (l.lanes = p),
      (l.stateNode = {
        containerInfo: E.containerInfo,
        pendingChildren: null,
        implementation: E.implementation,
      }),
      l
    )
  }
  function Oi(E, l, p, U, q) {
    ;((this.tag = l),
      (this.containerInfo = E),
      (this.finishedWork = this.pingCache = this.current = this.pendingChildren = null),
      (this.timeoutHandle = -1),
      (this.callbackNode = this.pendingContext = this.context = null),
      (this.callbackPriority = 0),
      (this.eventTimes = Et(0)),
      (this.expirationTimes = Et(-1)),
      (this.entangledLanes =
        this.finishedLanes =
        this.mutableReadLanes =
        this.expiredLanes =
        this.pingedLanes =
        this.suspendedLanes =
        this.pendingLanes =
          0),
      (this.entanglements = Et(0)),
      (this.identifierPrefix = U),
      (this.onRecoverableError = q),
      (this.mutableSourceEagerHydrationData = null))
  }
  function fa(E, l, p, U, q, Z, oA, KA, bA) {
    return (
      (E = new Oi(E, l, p, KA, bA)),
      l === 1 ? ((l = 1), Z === !0 && (l |= 8)) : (l = 0),
      (Z = Yo(3, null, null, l)),
      (E.current = Z),
      (Z.stateNode = E),
      (Z.memoizedState = {
        element: U,
        isDehydrated: p,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null,
      }),
      $C(Z),
      E
    )
  }
  function Ot(E, l, p) {
    var U = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null
    return {
      $$typeof: j,
      key: U == null ? null : "" + U,
      children: E,
      containerInfo: l,
      implementation: p,
    }
  }
  function RB(E) {
    if (!E) return nn
    E = E._reactInternals
    A: {
      if (Tg(E) !== E || E.tag !== 1) throw Error(I(170))
      var l = E
      do {
        switch (l.tag) {
          case 3:
            l = l.stateNode.context
            break A
          case 1:
            if (Ri(l.type)) {
              l = l.stateNode.__reactInternalMemoizedMergedChildContext
              break A
            }
        }
        l = l.return
      } while (l !== null)
      throw Error(I(171))
    }
    if (E.tag === 1) {
      var p = E.type
      if (Ri(p)) return Qa(E, p, l)
    }
    return l
  }
  function nh(E, l, p, U, q, Z, oA, KA, bA) {
    return (
      (E = fa(p, U, !0, E, q, Z, oA, KA, bA)),
      (E.context = RB(null)),
      (p = E.current),
      (U = FB()),
      (q = St(p)),
      (Z = Ke(U, q)),
      (Z.callback = l ?? null),
      Ie(p, Z, q),
      (E.current.lanes = q),
      Yi(E, q, U),
      BB(E, U),
      E
    )
  }
  function nc(E, l, p, U) {
    var q = l.current,
      Z = FB(),
      oA = St(q)
    return (
      (p = RB(p)),
      l.context === null ? (l.context = p) : (l.pendingContext = p),
      (l = Ke(Z, oA)),
      (l.payload = { element: E }),
      (U = U === void 0 ? null : U),
      U !== null && (l.callback = U),
      (E = Ie(q, l, oA)),
      E !== null && (et(E, q, oA, Z), PB(E, q, oA)),
      oA
    )
  }
  function Eh(E) {
    if (((E = E.current), !E.child)) return null
    switch (E.child.tag) {
      case 5:
        return E.child.stateNode
      default:
        return E.child.stateNode
    }
  }
  function Kg(E, l) {
    if (((E = E.memoizedState), E !== null && E.dehydrated !== null)) {
      var p = E.retryLane
      E.retryLane = p !== 0 && p < l ? p : l
    }
  }
  function bQ(E, l) {
    ;(Kg(E, l), (E = E.alternate) && Kg(E, l))
  }
  function VD() {
    return null
  }
  var ns =
    typeof reportError == "function"
      ? reportError
      : function (E) {
          console.error(E)
        }
  function ur(E) {
    this._internalRoot = E
  }
  ;((Ii.prototype.render = ur.prototype.render =
    function (E) {
      var l = this._internalRoot
      if (l === null) throw Error(I(409))
      nc(E, l, null, null)
    }),
    (Ii.prototype.unmount = ur.prototype.unmount =
      function () {
        var E = this._internalRoot
        if (E !== null) {
          this._internalRoot = null
          var l = E.containerInfo
          ;(un(function () {
            nc(null, E, null, null)
          }),
            (l[sQ] = null))
        }
      }))
  function Ii(E) {
    this._internalRoot = E
  }
  Ii.prototype.unstable_scheduleHydration = function (E) {
    if (E) {
      var l = Ui()
      E = { blockedOn: null, target: E, priority: l }
      for (var p = 0; p < Me.length && l !== 0 && l < Me[p].priority; p++);
      ;(Me.splice(p, 0, E), p === 0 && rB(E))
    }
  }
  function Nt(E) {
    return !(!E || (E.nodeType !== 1 && E.nodeType !== 9 && E.nodeType !== 11))
  }
  function _t(E) {
    return !(
      !E ||
      (E.nodeType !== 1 &&
        E.nodeType !== 9 &&
        E.nodeType !== 11 &&
        (E.nodeType !== 8 || E.nodeValue !== " react-mount-point-unstable "))
    )
  }
  function ah() {}
  function rh(E, l, p, U, q) {
    if (q) {
      if (typeof U == "function") {
        var Z = U
        U = function () {
          var kI = Eh(oA)
          Z.call(kI)
        }
      }
      var oA = nh(l, U, E, 0, null, !1, !1, "", ah)
      return (
        (E._reactRootContainer = oA),
        (E[sQ] = oA.current),
        LQ(E.nodeType === 8 ? E.parentNode : E),
        un(),
        oA
      )
    }
    for (; (q = E.lastChild); ) E.removeChild(q)
    if (typeof U == "function") {
      var KA = U
      U = function () {
        var kI = Eh(bA)
        KA.call(kI)
      }
    }
    var bA = fa(E, 0, !1, null, null, !1, !1, "", ah)
    return (
      (E._reactRootContainer = bA),
      (E[sQ] = bA.current),
      LQ(E.nodeType === 8 ? E.parentNode : E),
      un(function () {
        nc(l, bA, p, U)
      }),
      bA
    )
  }
  function Es(E, l, p, U, q) {
    var Z = p._reactRootContainer
    if (Z) {
      var oA = Z
      if (typeof q == "function") {
        var KA = q
        q = function () {
          var bA = Eh(oA)
          KA.call(bA)
        }
      }
      nc(l, oA, E, q)
    } else oA = rh(p, l, E, q, U)
    return Eh(oA)
  }
  ;((zQ = function (E) {
    switch (E.tag) {
      case 3:
        var l = E.stateNode
        if (l.current.memoizedState.isDehydrated) {
          var p = pe(l.pendingLanes)
          p !== 0 && (aB(l, p | 1), BB(l, EI()), !(fC & 6) && ((es = EI() + 500), st()))
        }
        break
      case 13:
        ;(un(function () {
          var U = rn(E, 1)
          if (U !== null) {
            var q = FB()
            et(U, E, 1, q)
          }
        }),
          bQ(E, 1))
    }
  }),
    (Wt = function (E) {
      if (E.tag === 13) {
        var l = rn(E, 134217728)
        if (l !== null) {
          var p = FB()
          et(l, E, 134217728, p)
        }
        bQ(E, 134217728)
      }
    }),
    (ZC = function (E) {
      if (E.tag === 13) {
        var l = St(E),
          p = rn(E, l)
        if (p !== null) {
          var U = FB()
          et(p, E, l, U)
        }
        bQ(E, l)
      }
    }),
    (Ui = function () {
      return XC
    }),
    ($o = function (E, l) {
      var p = XC
      try {
        return ((XC = E), l())
      } finally {
        XC = p
      }
    }),
    (NI = function (E, l, p) {
      switch (l) {
        case "input":
          if ((pI(E, p), (l = p.name), p.type === "radio" && l != null)) {
            for (p = E; p.parentNode; ) p = p.parentNode
            for (
              p = p.querySelectorAll("input[name=" + JSON.stringify("" + l) + '][type="radio"]'),
                l = 0;
              l < p.length;
              l++
            ) {
              var U = p[l]
              if (U !== E && U.form === E.form) {
                var q = nC(U)
                if (!q) throw Error(I(90))
                ;(YA(U), pI(U, q))
              }
            }
          }
          break
        case "textarea":
          WA(E, p)
          break
        case "select":
          ;((l = p.value), l != null && QA(E, !!p.multiple, l, !1))
      }
    }),
    ($g = Bc),
    (Qg = un))
  var Kp = { usingClientEntryPoint: !1, Events: [lQ, Re, nC, qI, dg, Bc] },
    sh = {
      findFiberByHostInstance: wB,
      bundleType: 0,
      version: "18.3.1",
      rendererPackageName: "react-dom",
    },
    VI = {
      bundleType: sh.bundleType,
      version: sh.version,
      rendererPackageName: sh.rendererPackageName,
      rendererConfig: sh.rendererConfig,
      overrideHookState: null,
      overrideHookStateDeletePath: null,
      overrideHookStateRenamePath: null,
      overrideProps: null,
      overridePropsDeletePath: null,
      overridePropsRenamePath: null,
      setErrorHandler: null,
      setSuspenseHandler: null,
      scheduleUpdate: null,
      currentDispatcherRef: H.ReactCurrentDispatcher,
      findHostInstanceByFiber: function (E) {
        return ((E = rA(E)), E === null ? null : E.stateNode)
      },
      findFiberByHostInstance: sh.findFiberByHostInstance || VD,
      findHostInstancesForRefresh: null,
      scheduleRefresh: null,
      scheduleRoot: null,
      setRefreshHandler: null,
      getCurrentFiber: null,
      reconcilerVersion: "18.3.1-next-f1338f8080-20240426",
    }
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Qo = __REACT_DEVTOOLS_GLOBAL_HOOK__
    if (!Qo.isDisabled && Qo.supportsFiber)
      try {
        ;((wC = Qo.inject(VI)), (mg = Qo))
      } catch {}
  }
  return (
    (Ra.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Kp),
    (Ra.createPortal = function (E, l) {
      var p = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null
      if (!Nt(l)) throw Error(I(200))
      return Ot(E, l, null, p)
    }),
    (Ra.createRoot = function (E, l) {
      if (!Nt(E)) throw Error(I(299))
      var p = !1,
        U = "",
        q = ns
      return (
        l != null &&
          (l.unstable_strictMode === !0 && (p = !0),
          l.identifierPrefix !== void 0 && (U = l.identifierPrefix),
          l.onRecoverableError !== void 0 && (q = l.onRecoverableError)),
        (l = fa(E, 1, !1, null, null, p, !1, U, q)),
        (E[sQ] = l.current),
        LQ(E.nodeType === 8 ? E.parentNode : E),
        new ur(l)
      )
    }),
    (Ra.findDOMNode = function (E) {
      if (E == null) return null
      if (E.nodeType === 1) return E
      var l = E._reactInternals
      if (l === void 0)
        throw typeof E.render == "function"
          ? Error(I(188))
          : ((E = Object.keys(E).join(",")), Error(I(268, E)))
      return ((E = rA(l)), (E = E === null ? null : E.stateNode), E)
    }),
    (Ra.flushSync = function (E) {
      return un(E)
    }),
    (Ra.hydrate = function (E, l, p) {
      if (!_t(l)) throw Error(I(200))
      return Es(null, E, l, !0, p)
    }),
    (Ra.hydrateRoot = function (E, l, p) {
      if (!Nt(E)) throw Error(I(405))
      var U = (p != null && p.hydratedSources) || null,
        q = !1,
        Z = "",
        oA = ns
      if (
        (p != null &&
          (p.unstable_strictMode === !0 && (q = !0),
          p.identifierPrefix !== void 0 && (Z = p.identifierPrefix),
          p.onRecoverableError !== void 0 && (oA = p.onRecoverableError)),
        (l = nh(l, null, E, 1, p ?? null, q, !1, Z, oA)),
        (E[sQ] = l.current),
        LQ(E),
        U)
      )
        for (E = 0; E < U.length; E++)
          ((p = U[E]),
            (q = p._getVersion),
            (q = q(p._source)),
            l.mutableSourceEagerHydrationData == null
              ? (l.mutableSourceEagerHydrationData = [p, q])
              : l.mutableSourceEagerHydrationData.push(p, q))
      return new Ii(l)
    }),
    (Ra.render = function (E, l, p) {
      if (!_t(l)) throw Error(I(200))
      return Es(null, E, l, !1, p)
    }),
    (Ra.unmountComponentAtNode = function (E) {
      if (!_t(E)) throw Error(I(40))
      return E._reactRootContainer
        ? (un(function () {
            Es(null, null, E, !1, function () {
              ;((E._reactRootContainer = null), (E[sQ] = null))
            })
          }),
          !0)
        : !1
    }),
    (Ra.unstable_batchedUpdates = Bc),
    (Ra.unstable_renderSubtreeIntoContainer = function (E, l, p, U) {
      if (!_t(p)) throw Error(I(200))
      if (E == null || E._reactInternals === void 0) throw Error(I(38))
      return Es(E, l, p, !1, U)
    }),
    (Ra.version = "18.3.1-next-f1338f8080-20240426"),
    Ra
  )
}
var Ja = {}
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Uq
function o1() {
  return (
    Uq ||
      ((Uq = 1),
      process.env.NODE_ENV !== "production" &&
        (function () {
          typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" &&
            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" &&
            __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error())
          var e = Pf(),
            A = zx(),
            I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
            g = !1
          function C(t) {
            g = t
          }
          function i(t) {
            if (!g) {
              for (var Q = arguments.length, c = new Array(Q > 1 ? Q - 1 : 0), f = 1; f < Q; f++)
                c[f - 1] = arguments[f]
              o("warn", t, c)
            }
          }
          function B(t) {
            if (!g) {
              for (var Q = arguments.length, c = new Array(Q > 1 ? Q - 1 : 0), f = 1; f < Q; f++)
                c[f - 1] = arguments[f]
              o("error", t, c)
            }
          }
          function o(t, Q, c) {
            {
              var f = I.ReactDebugCurrentFrame,
                G = f.getStackAddendum()
              G !== "" && ((Q += "%s"), (c = c.concat([G])))
              var m = c.map(function (x) {
                return String(x)
              })
              ;(m.unshift("Warning: " + Q), Function.prototype.apply.call(console[t], console, m))
            }
          }
          var r = 0,
            s = 1,
            h = 2,
            S = 3,
            d = 4,
            w = 5,
            M = 6,
            K = 7,
            R = 8,
            F = 9,
            L = 10,
            Y = 11,
            H = 12,
            V = 13,
            j = 14,
            P = 15,
            AA = 16,
            X = 17,
            _ = 18,
            eA = 19,
            CA = 21,
            aA = 22,
            lA = 23,
            JA = 24,
            yA = 25,
            LA = !0,
            nA = !1,
            fA = !1,
            sA = !1,
            $ = !1,
            EA = !0,
            GA = !1,
            DA = !0,
            dA = !0,
            kA = !0,
            NA = !0,
            qA = /* @__PURE__ */ new Set(),
            ZA = {},
            sI = {}
          function cI(t, Q) {
            ;(YA(t, Q), YA(t + "Capture", Q))
          }
          function YA(t, Q) {
            ;(ZA[t] &&
              B(
                "EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",
                t,
              ),
              (ZA[t] = Q))
            {
              var c = t.toLowerCase()
              ;((sI[c] = t), t === "onDoubleClick" && (sI.ondblclick = t))
            }
            for (var f = 0; f < Q.length; f++) qA.add(Q[f])
          }
          var eI =
              typeof window < "u" &&
              typeof window.document < "u" &&
              typeof window.document.createElement < "u",
            uA = Object.prototype.hasOwnProperty
          function hI(t) {
            {
              var Q = typeof Symbol == "function" && Symbol.toStringTag,
                c = (Q && t[Symbol.toStringTag]) || t.constructor.name || "Object"
              return c
            }
          }
          function II(t) {
            try {
              return (pI(t), !1)
            } catch {
              return !0
            }
          }
          function pI(t) {
            return "" + t
          }
          function AI(t, Q) {
            if (II(t))
              return (
                B(
                  "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.",
                  Q,
                  hI(t),
                ),
                pI(t)
              )
          }
          function YI(t) {
            if (II(t))
              return (
                B(
                  "The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.",
                  hI(t),
                ),
                pI(t)
              )
          }
          function SI(t, Q) {
            if (II(t))
              return (
                B(
                  "The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.",
                  Q,
                  hI(t),
                ),
                pI(t)
              )
          }
          function QA(t, Q) {
            if (II(t))
              return (
                B(
                  "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.",
                  Q,
                  hI(t),
                ),
                pI(t)
              )
          }
          function tA(t) {
            if (II(t))
              return (
                B(
                  "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.",
                  hI(t),
                ),
                pI(t)
              )
          }
          function FA(t) {
            if (II(t))
              return (
                B(
                  "Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.",
                  hI(t),
                ),
                pI(t)
              )
          }
          var WA = 0,
            jA = 1,
            nI = 2,
            UI = 3,
            GI = 4,
            LI = 5,
            Bg = 6,
            MA =
              ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",
            OA = MA + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
            aI = new RegExp("^[" + MA + "][" + OA + "]*$"),
            RI = {},
            VA = {}
          function ag(t) {
            return uA.call(VA, t)
              ? !0
              : uA.call(RI, t)
                ? !1
                : aI.test(t)
                  ? ((VA[t] = !0), !0)
                  : ((RI[t] = !0), B("Invalid attribute name: `%s`", t), !1)
          }
          function XI(t, Q, c) {
            return Q !== null
              ? Q.type === WA
              : c
                ? !1
                : t.length > 2 && (t[0] === "o" || t[0] === "O") && (t[1] === "n" || t[1] === "N")
          }
          function $I(t, Q, c, f) {
            if (c !== null && c.type === WA) return !1
            switch (typeof Q) {
              case "function":
              // $FlowIssue symbol is perfectly valid here
              case "symbol":
                return !0
              case "boolean": {
                if (f) return !1
                if (c !== null) return !c.acceptsBooleans
                var G = t.toLowerCase().slice(0, 5)
                return G !== "data-" && G !== "aria-"
              }
              default:
                return !1
            }
          }
          function SA(t, Q, c, f) {
            if (Q === null || typeof Q > "u" || $I(t, Q, c, f)) return !0
            if (f) return !1
            if (c !== null)
              switch (c.type) {
                case UI:
                  return !Q
                case GI:
                  return Q === !1
                case LI:
                  return isNaN(Q)
                case Bg:
                  return isNaN(Q) || Q < 1
              }
            return !1
          }
          function NI(t) {
            return iI.hasOwnProperty(t) ? iI[t] : null
          }
          function HA(t, Q, c, f, G, m, x) {
            ;((this.acceptsBooleans = Q === nI || Q === UI || Q === GI),
              (this.attributeName = f),
              (this.attributeNamespace = G),
              (this.mustUseProperty = c),
              (this.propertyName = t),
              (this.type = Q),
              (this.sanitizeURL = m),
              (this.removeEmptyString = x))
          }
          var iI = {},
            zI = [
              "children",
              "dangerouslySetInnerHTML",
              // TODO: This prevents the assignment of defaultValue to regular
              // elements (not just inputs). Now that ReactDOMInput assigns to the
              // defaultValue property -- do we need this?
              "defaultValue",
              "defaultChecked",
              "innerHTML",
              "suppressContentEditableWarning",
              "suppressHydrationWarning",
              "style",
            ]
          ;(zI.forEach(function (t) {
            iI[t] = new HA(
              t,
              WA,
              !1,
              // mustUseProperty
              t,
              // attributeName
              null,
              // attributeNamespace
              !1,
              // sanitizeURL
              !1,
            )
          }),
            [
              ["acceptCharset", "accept-charset"],
              ["className", "class"],
              ["htmlFor", "for"],
              ["httpEquiv", "http-equiv"],
            ].forEach(function (t) {
              var Q = t[0],
                c = t[1]
              iI[Q] = new HA(
                Q,
                jA,
                !1,
                // mustUseProperty
                c,
                // attributeName
                null,
                // attributeNamespace
                !1,
                // sanitizeURL
                !1,
              )
            }),
            ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (t) {
              iI[t] = new HA(
                t,
                nI,
                !1,
                // mustUseProperty
                t.toLowerCase(),
                // attributeName
                null,
                // attributeNamespace
                !1,
                // sanitizeURL
                !1,
              )
            }),
            ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(
              function (t) {
                iI[t] = new HA(
                  t,
                  nI,
                  !1,
                  // mustUseProperty
                  t,
                  // attributeName
                  null,
                  // attributeNamespace
                  !1,
                  // sanitizeURL
                  !1,
                )
              },
            ),
            [
              "allowFullScreen",
              "async",
              // Note: there is a special case that prevents it from being written to the DOM
              // on the client side because the browsers are inconsistent. Instead we call focus().
              "autoFocus",
              "autoPlay",
              "controls",
              "default",
              "defer",
              "disabled",
              "disablePictureInPicture",
              "disableRemotePlayback",
              "formNoValidate",
              "hidden",
              "loop",
              "noModule",
              "noValidate",
              "open",
              "playsInline",
              "readOnly",
              "required",
              "reversed",
              "scoped",
              "seamless",
              // Microdata
              "itemScope",
            ].forEach(function (t) {
              iI[t] = new HA(
                t,
                UI,
                !1,
                // mustUseProperty
                t.toLowerCase(),
                // attributeName
                null,
                // attributeNamespace
                !1,
                // sanitizeURL
                !1,
              )
            }),
            [
              "checked",
              // Note: `option.selected` is not updated if `select.multiple` is
              // disabled with `removeAttribute`. We have special logic for handling this.
              "multiple",
              "muted",
              "selected",
              // NOTE: if you add a camelCased prop to this list,
              // you'll need to set attributeName to name.toLowerCase()
              // instead in the assignment below.
            ].forEach(function (t) {
              iI[t] = new HA(
                t,
                UI,
                !0,
                // mustUseProperty
                t,
                // attributeName
                null,
                // attributeNamespace
                !1,
                // sanitizeURL
                !1,
              )
            }),
            [
              "capture",
              "download",
              // NOTE: if you add a camelCased prop to this list,
              // you'll need to set attributeName to name.toLowerCase()
              // instead in the assignment below.
            ].forEach(function (t) {
              iI[t] = new HA(
                t,
                GI,
                !1,
                // mustUseProperty
                t,
                // attributeName
                null,
                // attributeNamespace
                !1,
                // sanitizeURL
                !1,
              )
            }),
            [
              "cols",
              "rows",
              "size",
              "span",
              // NOTE: if you add a camelCased prop to this list,
              // you'll need to set attributeName to name.toLowerCase()
              // instead in the assignment below.
            ].forEach(function (t) {
              iI[t] = new HA(
                t,
                Bg,
                !1,
                // mustUseProperty
                t,
                // attributeName
                null,
                // attributeNamespace
                !1,
                // sanitizeURL
                !1,
              )
            }),
            ["rowSpan", "start"].forEach(function (t) {
              iI[t] = new HA(
                t,
                LI,
                !1,
                // mustUseProperty
                t.toLowerCase(),
                // attributeName
                null,
                // attributeNamespace
                !1,
                // sanitizeURL
                !1,
              )
            }))
          var qI = /[\-\:]([a-z])/g,
            dg = function (t) {
              return t[1].toUpperCase()
            }
          ;([
            "accent-height",
            "alignment-baseline",
            "arabic-form",
            "baseline-shift",
            "cap-height",
            "clip-path",
            "clip-rule",
            "color-interpolation",
            "color-interpolation-filters",
            "color-profile",
            "color-rendering",
            "dominant-baseline",
            "enable-background",
            "fill-opacity",
            "fill-rule",
            "flood-color",
            "flood-opacity",
            "font-family",
            "font-size",
            "font-size-adjust",
            "font-stretch",
            "font-style",
            "font-variant",
            "font-weight",
            "glyph-name",
            "glyph-orientation-horizontal",
            "glyph-orientation-vertical",
            "horiz-adv-x",
            "horiz-origin-x",
            "image-rendering",
            "letter-spacing",
            "lighting-color",
            "marker-end",
            "marker-mid",
            "marker-start",
            "overline-position",
            "overline-thickness",
            "paint-order",
            "panose-1",
            "pointer-events",
            "rendering-intent",
            "shape-rendering",
            "stop-color",
            "stop-opacity",
            "strikethrough-position",
            "strikethrough-thickness",
            "stroke-dasharray",
            "stroke-dashoffset",
            "stroke-linecap",
            "stroke-linejoin",
            "stroke-miterlimit",
            "stroke-opacity",
            "stroke-width",
            "text-anchor",
            "text-decoration",
            "text-rendering",
            "underline-position",
            "underline-thickness",
            "unicode-bidi",
            "unicode-range",
            "units-per-em",
            "v-alphabetic",
            "v-hanging",
            "v-ideographic",
            "v-mathematical",
            "vector-effect",
            "vert-adv-y",
            "vert-origin-x",
            "vert-origin-y",
            "word-spacing",
            "writing-mode",
            "xmlns:xlink",
            "x-height",
            // NOTE: if you add a camelCased prop to this list,
            // you'll need to set attributeName to name.toLowerCase()
            // instead in the assignment below.
          ].forEach(function (t) {
            var Q = t.replace(qI, dg)
            iI[Q] = new HA(
              Q,
              jA,
              !1,
              // mustUseProperty
              t,
              null,
              // attributeNamespace
              !1,
              // sanitizeURL
              !1,
            )
          }),
            [
              "xlink:actuate",
              "xlink:arcrole",
              "xlink:role",
              "xlink:show",
              "xlink:title",
              "xlink:type",
              // NOTE: if you add a camelCased prop to this list,
              // you'll need to set attributeName to name.toLowerCase()
              // instead in the assignment below.
            ].forEach(function (t) {
              var Q = t.replace(qI, dg)
              iI[Q] = new HA(
                Q,
                jA,
                !1,
                // mustUseProperty
                t,
                "http://www.w3.org/1999/xlink",
                !1,
                // sanitizeURL
                !1,
              )
            }),
            [
              "xml:base",
              "xml:lang",
              "xml:space",
              // NOTE: if you add a camelCased prop to this list,
              // you'll need to set attributeName to name.toLowerCase()
              // instead in the assignment below.
            ].forEach(function (t) {
              var Q = t.replace(qI, dg)
              iI[Q] = new HA(
                Q,
                jA,
                !1,
                // mustUseProperty
                t,
                "http://www.w3.org/XML/1998/namespace",
                !1,
                // sanitizeURL
                !1,
              )
            }),
            ["tabIndex", "crossOrigin"].forEach(function (t) {
              iI[t] = new HA(
                t,
                jA,
                !1,
                // mustUseProperty
                t.toLowerCase(),
                // attributeName
                null,
                // attributeNamespace
                !1,
                // sanitizeURL
                !1,
              )
            }))
          var $g = "xlinkHref"
          ;((iI[$g] = new HA(
            "xlinkHref",
            jA,
            !1,
            // mustUseProperty
            "xlink:href",
            "http://www.w3.org/1999/xlink",
            !0,
            // sanitizeURL
            !1,
          )),
            ["src", "href", "action", "formAction"].forEach(function (t) {
              iI[t] = new HA(
                t,
                jA,
                !1,
                // mustUseProperty
                t.toLowerCase(),
                // attributeName
                null,
                // attributeNamespace
                !0,
                // sanitizeURL
                !0,
              )
            }))
          var Qg =
              /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i,
            Fg = !1
          function jC(t) {
            !Fg &&
              Qg.test(t) &&
              ((Fg = !0),
              B(
                "A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.",
                JSON.stringify(t),
              ))
          }
          function mC(t, Q, c, f) {
            if (f.mustUseProperty) {
              var G = f.propertyName
              return t[G]
            } else {
              ;(AI(c, Q), f.sanitizeURL && jC("" + c))
              var m = f.attributeName,
                x = null
              if (f.type === GI) {
                if (t.hasAttribute(m)) {
                  var z = t.getAttribute(m)
                  return z === "" ? !0 : SA(Q, c, f, !1) ? z : z === "" + c ? c : z
                }
              } else if (t.hasAttribute(m)) {
                if (SA(Q, c, f, !1)) return t.getAttribute(m)
                if (f.type === UI) return c
                x = t.getAttribute(m)
              }
              return SA(Q, c, f, !1) ? (x === null ? c : x) : x === "" + c ? c : x
            }
          }
          function zC(t, Q, c, f) {
            {
              if (!ag(Q)) return
              if (!t.hasAttribute(Q)) return c === void 0 ? void 0 : null
              var G = t.getAttribute(Q)
              return (AI(c, Q), G === "" + c ? c : G)
            }
          }
          function Ee(t, Q, c, f) {
            var G = NI(Q)
            if (!XI(Q, G, f)) {
              if ((SA(Q, c, G, f) && (c = null), f || G === null)) {
                if (ag(Q)) {
                  var m = Q
                  c === null ? t.removeAttribute(m) : (AI(c, Q), t.setAttribute(m, "" + c))
                }
                return
              }
              var x = G.mustUseProperty
              if (x) {
                var z = G.propertyName
                if (c === null) {
                  var gA = G.type
                  t[z] = gA === UI ? !1 : ""
                } else t[z] = c
                return
              }
              var hA = G.attributeName,
                pA = G.attributeNamespace
              if (c === null) t.removeAttribute(hA)
              else {
                var gI = G.type,
                  $A
                ;(gI === UI || (gI === GI && c === !0)
                  ? ($A = "")
                  : (AI(c, hA), ($A = "" + c), G.sanitizeURL && jC($A.toString())),
                  pA ? t.setAttributeNS(pA, hA, $A) : t.setAttribute(hA, $A))
              }
            }
          }
          var ei = Symbol.for("react.element"),
            fe = Symbol.for("react.portal"),
            Ei = Symbol.for("react.fragment"),
            vi = Symbol.for("react.strict_mode"),
            Li = Symbol.for("react.profiler"),
            mA = Symbol.for("react.provider"),
            TI = Symbol.for("react.context"),
            eg = Symbol.for("react.forward_ref"),
            Tg = Symbol.for("react.suspense"),
            OC = Symbol.for("react.suspense_list"),
            JC = Symbol.for("react.memo"),
            jg = Symbol.for("react.lazy"),
            rA = Symbol.for("react.scope"),
            _A = Symbol.for("react.debug_trace_mode"),
            oI = Symbol.for("react.offscreen"),
            QI = Symbol.for("react.legacy_hidden"),
            PA = Symbol.for("react.cache"),
            gg = Symbol.for("react.tracing_marker"),
            EI = Symbol.iterator,
            hg = "@@iterator"
          function yg(t) {
            if (t === null || typeof t != "object") return null
            var Q = (EI && t[EI]) || t[hg]
            return typeof Q == "function" ? Q : null
          }
          var rg = Object.assign,
            eC = 0,
            Rg,
            pC,
            wC,
            mg,
            UC,
            iC,
            Gg
          function _C() {}
          _C.__reactDisabledLog = !0
          function vC() {
            {
              if (eC === 0) {
                ;((Rg = console.log),
                  (pC = console.info),
                  (wC = console.warn),
                  (mg = console.error),
                  (UC = console.group),
                  (iC = console.groupCollapsed),
                  (Gg = console.groupEnd))
                var t = {
                  configurable: !0,
                  enumerable: !0,
                  value: _C,
                  writable: !0,
                }
                Object.defineProperties(console, {
                  info: t,
                  log: t,
                  warn: t,
                  error: t,
                  group: t,
                  groupCollapsed: t,
                  groupEnd: t,
                })
              }
              eC++
            }
          }
          function ii() {
            {
              if ((eC--, eC === 0)) {
                var t = {
                  configurable: !0,
                  enumerable: !0,
                  writable: !0,
                }
                Object.defineProperties(console, {
                  log: rg({}, t, {
                    value: Rg,
                  }),
                  info: rg({}, t, {
                    value: pC,
                  }),
                  warn: rg({}, t, {
                    value: wC,
                  }),
                  error: rg({}, t, {
                    value: mg,
                  }),
                  group: rg({}, t, {
                    value: UC,
                  }),
                  groupCollapsed: rg({}, t, {
                    value: iC,
                  }),
                  groupEnd: rg({}, t, {
                    value: Gg,
                  }),
                })
              }
              eC < 0 &&
                B("disabledDepth fell below zero. This is a bug in React. Please file an issue.")
            }
          }
          var qe = I.ReactCurrentDispatcher,
            pe
          function Mi(t, Q, c) {
            {
              if (pe === void 0)
                try {
                  throw Error()
                } catch (G) {
                  var f = G.stack.trim().match(/\n( *(at )?)/)
                  pe = (f && f[1]) || ""
                }
              return (
                `
` +
                pe +
                t
              )
            }
          }
          var ae = !1,
            ai
          {
            var fi = typeof WeakMap == "function" ? WeakMap : Map
            ai = new fi()
          }
          function He(t, Q) {
            if (!t || ae) return ""
            {
              var c = ai.get(t)
              if (c !== void 0) return c
            }
            var f
            ae = !0
            var G = Error.prepareStackTrace
            Error.prepareStackTrace = void 0
            var m
            ;((m = qe.current), (qe.current = null), vC())
            try {
              if (Q) {
                var x = function () {
                  throw Error()
                }
                if (
                  (Object.defineProperty(x.prototype, "props", {
                    set: function () {
                      throw Error()
                    },
                  }),
                  typeof Reflect == "object" && Reflect.construct)
                ) {
                  try {
                    Reflect.construct(x, [])
                  } catch (KI) {
                    f = KI
                  }
                  Reflect.construct(t, [], x)
                } else {
                  try {
                    x.call()
                  } catch (KI) {
                    f = KI
                  }
                  t.call(x.prototype)
                }
              } else {
                try {
                  throw Error()
                } catch (KI) {
                  f = KI
                }
                t()
              }
            } catch (KI) {
              if (KI && f && typeof KI.stack == "string") {
                for (
                  var z = KI.stack.split(`
`),
                    gA = f.stack.split(`
`),
                    hA = z.length - 1,
                    pA = gA.length - 1;
                  hA >= 1 && pA >= 0 && z[hA] !== gA[pA];
                )
                  pA--
                for (; hA >= 1 && pA >= 0; hA--, pA--)
                  if (z[hA] !== gA[pA]) {
                    if (hA !== 1 || pA !== 1)
                      do
                        if ((hA--, pA--, pA < 0 || z[hA] !== gA[pA])) {
                          var gI =
                            `
` + z[hA].replace(" at new ", " at ")
                          return (
                            t.displayName &&
                              gI.includes("<anonymous>") &&
                              (gI = gI.replace("<anonymous>", t.displayName)),
                            typeof t == "function" && ai.set(t, gI),
                            gI
                          )
                        }
                      while (hA >= 1 && pA >= 0)
                    break
                  }
              }
            } finally {
              ;((ae = !1), (qe.current = m), ii(), (Error.prepareStackTrace = G))
            }
            var $A = t ? t.displayName || t.name : "",
              FI = $A ? Mi($A) : ""
            return (typeof t == "function" && ai.set(t, FI), FI)
          }
          function Et(t, Q, c) {
            return He(t, !0)
          }
          function Yi(t, Q, c) {
            return He(t, !1)
          }
          function vn(t) {
            var Q = t.prototype
            return !!(Q && Q.isReactComponent)
          }
          function aB(t, Q, c) {
            if (t == null) return ""
            if (typeof t == "function") return He(t, vn(t))
            if (typeof t == "string") return Mi(t)
            switch (t) {
              case Tg:
                return Mi("Suspense")
              case OC:
                return Mi("SuspenseList")
            }
            if (typeof t == "object")
              switch (t.$$typeof) {
                case eg:
                  return Yi(t.render)
                case JC:
                  return aB(t.type, Q, c)
                case jg: {
                  var f = t,
                    G = f._payload,
                    m = f._init
                  try {
                    return aB(m(G), Q, c)
                  } catch {}
                }
              }
            return ""
          }
          function XC(t) {
            switch ((t._debugOwner && t._debugOwner.type, t._debugSource, t.tag)) {
              case w:
                return Mi(t.type)
              case AA:
                return Mi("Lazy")
              case V:
                return Mi("Suspense")
              case eA:
                return Mi("SuspenseList")
              case r:
              case h:
              case P:
                return Yi(t.type)
              case Y:
                return Yi(t.type.render)
              case s:
                return Et(t.type)
              default:
                return ""
            }
          }
          function dB(t) {
            try {
              var Q = "",
                c = t
              do ((Q += XC(c)), (c = c.return))
              while (c)
              return Q
            } catch (f) {
              return (
                `
Error generating stack: ` +
                f.message +
                `
` +
                f.stack
              )
            }
          }
          function zQ(t, Q, c) {
            var f = t.displayName
            if (f) return f
            var G = Q.displayName || Q.name || ""
            return G !== "" ? c + "(" + G + ")" : c
          }
          function Wt(t) {
            return t.displayName || "Context"
          }
          function ZC(t) {
            if (t == null) return null
            if (
              (typeof t.tag == "number" &&
                B(
                  "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.",
                ),
              typeof t == "function")
            )
              return t.displayName || t.name || null
            if (typeof t == "string") return t
            switch (t) {
              case Ei:
                return "Fragment"
              case fe:
                return "Portal"
              case Li:
                return "Profiler"
              case vi:
                return "StrictMode"
              case Tg:
                return "Suspense"
              case OC:
                return "SuspenseList"
            }
            if (typeof t == "object")
              switch (t.$$typeof) {
                case TI:
                  var Q = t
                  return Wt(Q) + ".Consumer"
                case mA:
                  var c = t
                  return Wt(c._context) + ".Provider"
                case eg:
                  return zQ(t, t.render, "ForwardRef")
                case JC:
                  var f = t.displayName || null
                  return f !== null ? f : ZC(t.type) || "Memo"
                case jg: {
                  var G = t,
                    m = G._payload,
                    x = G._init
                  try {
                    return ZC(x(m))
                  } catch {
                    return null
                  }
                }
              }
            return null
          }
          function Ui(t, Q, c) {
            var f = Q.displayName || Q.name || ""
            return t.displayName || (f !== "" ? c + "(" + f + ")" : c)
          }
          function $o(t) {
            return t.displayName || "Context"
          }
          function oC(t) {
            var Q = t.tag,
              c = t.type
            switch (Q) {
              case JA:
                return "Cache"
              case F:
                var f = c
                return $o(f) + ".Consumer"
              case L:
                var G = c
                return $o(G._context) + ".Provider"
              case _:
                return "DehydratedFragment"
              case Y:
                return Ui(c, c.render, "ForwardRef")
              case K:
                return "Fragment"
              case w:
                return c
              case d:
                return "Portal"
              case S:
                return "Root"
              case M:
                return "Text"
              case AA:
                return ZC(c)
              case R:
                return c === vi ? "StrictMode" : "Mode"
              case aA:
                return "Offscreen"
              case H:
                return "Profiler"
              case CA:
                return "Scope"
              case V:
                return "Suspense"
              case eA:
                return "SuspenseList"
              case yA:
                return "TracingMarker"
              // The display name for this tags come from the user-provided type:
              case s:
              case r:
              case X:
              case h:
              case j:
              case P:
                if (typeof c == "function") return c.displayName || c.name || null
                if (typeof c == "string") return c
                break
            }
            return null
          }
          var RQ = I.ReactDebugCurrentFrame,
            Te = null,
            hC = !1
          function Vt() {
            {
              if (Te === null) return null
              var t = Te._debugOwner
              if (t !== null && typeof t < "u") return oC(t)
            }
            return null
          }
          function wt() {
            return Te === null ? "" : dB(Te)
          }
          function di() {
            ;((RQ.getCurrentStack = null), (Te = null), (hC = !1))
          }
          function Me(t) {
            ;((RQ.getCurrentStack = t === null ? null : wt), (Te = t), (hC = !1))
          }
          function Ha() {
            return Te
          }
          function ee(t) {
            hC = t
          }
          function Zi(t) {
            return "" + t
          }
          function XQ(t) {
            switch (typeof t) {
              case "boolean":
              case "number":
              case "string":
              case "undefined":
                return t
              case "object":
                return (FA(t), t)
              default:
                return ""
            }
          }
          var rB = {
            button: !0,
            checkbox: !0,
            image: !0,
            hidden: !0,
            radio: !0,
            reset: !0,
            submit: !0,
          }
          function $Q(t, Q) {
            ;(rB[Q.type] ||
              Q.onChange ||
              Q.onInput ||
              Q.readOnly ||
              Q.disabled ||
              Q.value == null ||
              B(
                "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.",
              ),
              Q.onChange ||
                Q.readOnly ||
                Q.disabled ||
                Q.checked == null ||
                B(
                  "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.",
                ))
          }
          function JQ(t) {
            var Q = t.type,
              c = t.nodeName
            return c && c.toLowerCase() === "input" && (Q === "checkbox" || Q === "radio")
          }
          function HB(t) {
            return t._valueTracker
          }
          function TB(t) {
            t._valueTracker = null
          }
          function An(t) {
            var Q = ""
            return (t && (JQ(t) ? (Q = t.checked ? "true" : "false") : (Q = t.value)), Q)
          }
          function Gt(t) {
            var Q = JQ(t) ? "checked" : "value",
              c = Object.getOwnPropertyDescriptor(t.constructor.prototype, Q)
            FA(t[Q])
            var f = "" + t[Q]
            if (
              !(
                t.hasOwnProperty(Q) ||
                typeof c > "u" ||
                typeof c.get != "function" ||
                typeof c.set != "function"
              )
            ) {
              var G = c.get,
                m = c.set
              ;(Object.defineProperty(t, Q, {
                configurable: !0,
                get: function () {
                  return G.call(this)
                },
                set: function (z) {
                  ;(FA(z), (f = "" + z), m.call(this, z))
                },
              }),
                Object.defineProperty(t, Q, {
                  enumerable: c.enumerable,
                }))
              var x = {
                getValue: function () {
                  return f
                },
                setValue: function (z) {
                  ;(FA(z), (f = "" + z))
                },
                stopTracking: function () {
                  ;(TB(t), delete t[Q])
                },
              }
              return x
            }
          }
          function Ni(t) {
            HB(t) || (t._valueTracker = Gt(t))
          }
          function QQ(t) {
            if (!t) return !1
            var Q = HB(t)
            if (!Q) return !0
            var c = Q.getValue(),
              f = An(t)
            return f !== c ? (Q.setValue(f), !0) : !1
          }
          function jt(t) {
            if (((t = t || (typeof document < "u" ? document : void 0)), typeof t > "u"))
              return null
            try {
              return t.activeElement || t.body
            } catch {
              return t.body
            }
          }
          var Ao = !1,
            In = !1,
            zt = !1,
            gn = !1
          function yB(t) {
            var Q = t.type === "checkbox" || t.type === "radio"
            return Q ? t.checked != null : t.value != null
          }
          function iA(t, Q) {
            var c = t,
              f = Q.checked,
              G = rg({}, Q, {
                defaultChecked: void 0,
                defaultValue: void 0,
                value: void 0,
                checked: f ?? c._wrapperState.initialChecked,
              })
            return G
          }
          function vA(t, Q) {
            ;($Q("input", Q),
              Q.checked !== void 0 &&
                Q.defaultChecked !== void 0 &&
                !In &&
                (B(
                  "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components",
                  Vt() || "A component",
                  Q.type,
                ),
                (In = !0)),
              Q.value !== void 0 &&
                Q.defaultValue !== void 0 &&
                !Ao &&
                (B(
                  "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components",
                  Vt() || "A component",
                  Q.type,
                ),
                (Ao = !0)))
            var c = t,
              f = Q.defaultValue == null ? "" : Q.defaultValue
            c._wrapperState = {
              initialChecked: Q.checked != null ? Q.checked : Q.defaultChecked,
              initialValue: XQ(Q.value != null ? Q.value : f),
              controlled: yB(Q),
            }
          }
          function rI(t, Q) {
            var c = t,
              f = Q.checked
            f != null && Ee(c, "checked", f, !1)
          }
          function mI(t, Q) {
            var c = t
            {
              var f = yB(Q)
              ;(!c._wrapperState.controlled &&
                f &&
                !gn &&
                (B(
                  "A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components",
                ),
                (gn = !0)),
                c._wrapperState.controlled &&
                  !f &&
                  !zt &&
                  (B(
                    "A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components",
                  ),
                  (zt = !0)))
            }
            rI(t, Q)
            var G = XQ(Q.value),
              m = Q.type
            if (G != null)
              m === "number"
                ? ((G === 0 && c.value === "") || // We explicitly want to coerce to number here if possible.
                    // eslint-disable-next-line
                    c.value != G) &&
                  (c.value = Zi(G))
                : c.value !== Zi(G) && (c.value = Zi(G))
            else if (m === "submit" || m === "reset") {
              c.removeAttribute("value")
              return
            }
            ;(Q.hasOwnProperty("value")
              ? tC(c, Q.type, G)
              : Q.hasOwnProperty("defaultValue") && tC(c, Q.type, XQ(Q.defaultValue)),
              Q.checked == null &&
                Q.defaultChecked != null &&
                (c.defaultChecked = !!Q.defaultChecked))
          }
          function ig(t, Q, c) {
            var f = t
            if (Q.hasOwnProperty("value") || Q.hasOwnProperty("defaultValue")) {
              var G = Q.type,
                m = G === "submit" || G === "reset"
              if (m && (Q.value === void 0 || Q.value === null)) return
              var x = Zi(f._wrapperState.initialValue)
              ;(c || (x !== f.value && (f.value = x)), (f.defaultValue = x))
            }
            var z = f.name
            ;(z !== "" && (f.name = ""),
              (f.defaultChecked = !f.defaultChecked),
              (f.defaultChecked = !!f._wrapperState.initialChecked),
              z !== "" && (f.name = z))
          }
          function AC(t, Q) {
            var c = t
            ;(mI(c, Q), pg(c, Q))
          }
          function pg(t, Q) {
            var c = Q.name
            if (Q.type === "radio" && c != null) {
              for (var f = t; f.parentNode; ) f = f.parentNode
              AI(c, "name")
              for (
                var G = f.querySelectorAll(
                    "input[name=" + JSON.stringify("" + c) + '][type="radio"]',
                  ),
                  m = 0;
                m < G.length;
                m++
              ) {
                var x = G[m]
                if (!(x === t || x.form !== t.form)) {
                  var z = pa(x)
                  if (!z)
                    throw new Error(
                      "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.",
                    )
                  ;(QQ(x), mI(x, z))
                }
              }
            }
          }
          function tC(t, Q, c) {
            // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
            ;(Q !== "number" || jt(t.ownerDocument) !== t) &&
              (c == null
                ? (t.defaultValue = Zi(t._wrapperState.initialValue))
                : t.defaultValue !== Zi(c) && (t.defaultValue = Zi(c)))
          }
          var BC = !1,
            NC = !1,
            KC = !1
          function GC(t, Q) {
            ;(Q.value == null &&
              (typeof Q.children == "object" && Q.children !== null
                ? e.Children.forEach(Q.children, function (c) {
                    c != null &&
                      (typeof c == "string" ||
                        typeof c == "number" ||
                        NC ||
                        ((NC = !0),
                        B(
                          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.",
                        )))
                  })
                : Q.dangerouslySetInnerHTML != null &&
                  (KC ||
                    ((KC = !0),
                    B(
                      "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.",
                    )))),
              Q.selected != null &&
                !BC &&
                (B(
                  "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.",
                ),
                (BC = !0)))
          }
          function ie(t, Q) {
            Q.value != null && t.setAttribute("value", Zi(XQ(Q.value)))
          }
          var we = Array.isArray
          function le(t) {
            return we(t)
          }
          var Io
          Io = !1
          function KQ() {
            var t = Vt()
            return t
              ? `

Check the render method of \`` +
                  t +
                  "`."
              : ""
          }
          var So = ["value", "defaultValue"]
          function xr(t) {
            {
              $Q("select", t)
              for (var Q = 0; Q < So.length; Q++) {
                var c = So[Q]
                if (t[c] != null) {
                  var f = le(t[c])
                  t.multiple && !f
                    ? B(
                        "The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",
                        c,
                        KQ(),
                      )
                    : !t.multiple &&
                      f &&
                      B(
                        "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",
                        c,
                        KQ(),
                      )
                }
              }
            }
          }
          function fo(t, Q, c, f) {
            var G = t.options
            if (Q) {
              for (var m = c, x = {}, z = 0; z < m.length; z++) x["$" + m[z]] = !0
              for (var gA = 0; gA < G.length; gA++) {
                var hA = x.hasOwnProperty("$" + G[gA].value)
                ;(G[gA].selected !== hA && (G[gA].selected = hA),
                  hA && f && (G[gA].defaultSelected = !0))
              }
            } else {
              for (var pA = Zi(XQ(c)), gI = null, $A = 0; $A < G.length; $A++) {
                if (G[$A].value === pA) {
                  ;((G[$A].selected = !0), f && (G[$A].defaultSelected = !0))
                  return
                }
                gI === null && !G[$A].disabled && (gI = G[$A])
              }
              gI !== null && (gI.selected = !0)
            }
          }
          function XE(t, Q) {
            return rg({}, Q, {
              value: void 0,
            })
          }
          function br(t, Q) {
            var c = t
            ;(xr(Q),
              (c._wrapperState = {
                wasMultiple: !!Q.multiple,
              }),
              Q.value !== void 0 &&
                Q.defaultValue !== void 0 &&
                !Io &&
                (B(
                  "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components",
                ),
                (Io = !0)))
          }
          function Rl(t, Q) {
            var c = t
            c.multiple = !!Q.multiple
            var f = Q.value
            f != null
              ? fo(c, !!Q.multiple, f, !1)
              : Q.defaultValue != null && fo(c, !!Q.multiple, Q.defaultValue, !0)
          }
          function Jl(t, Q) {
            var c = t,
              f = c._wrapperState.wasMultiple
            c._wrapperState.wasMultiple = !!Q.multiple
            var G = Q.value
            G != null
              ? fo(c, !!Q.multiple, G, !1)
              : f !== !!Q.multiple &&
                (Q.defaultValue != null
                  ? fo(c, !!Q.multiple, Q.defaultValue, !0)
                  : fo(c, !!Q.multiple, Q.multiple ? [] : "", !1))
          }
          function Kl(t, Q) {
            var c = t,
              f = Q.value
            f != null && fo(c, !!Q.multiple, f, !1)
          }
          var ml = !1
          function vl(t, Q) {
            var c = t
            if (Q.dangerouslySetInnerHTML != null)
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.")
            var f = rg({}, Q, {
              value: void 0,
              defaultValue: void 0,
              children: Zi(c._wrapperState.initialValue),
            })
            return f
          }
          function Pc(t, Q) {
            var c = t
            ;($Q("textarea", Q),
              Q.value !== void 0 &&
                Q.defaultValue !== void 0 &&
                !ml &&
                (B(
                  "%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components",
                  Vt() || "A component",
                ),
                (ml = !0)))
            var f = Q.value
            if (f == null) {
              var G = Q.children,
                m = Q.defaultValue
              if (G != null) {
                B(
                  "Use the `defaultValue` or `value` props instead of setting children on <textarea>.",
                )
                {
                  if (m != null)
                    throw new Error(
                      "If you supply `defaultValue` on a <textarea>, do not pass children.",
                    )
                  if (le(G)) {
                    if (G.length > 1) throw new Error("<textarea> can only have at most one child.")
                    G = G[0]
                  }
                  m = G
                }
              }
              ;(m == null && (m = ""), (f = m))
            }
            c._wrapperState = {
              initialValue: XQ(f),
            }
          }
          function Ll(t, Q) {
            var c = t,
              f = XQ(Q.value),
              G = XQ(Q.defaultValue)
            if (f != null) {
              var m = Zi(f)
              ;(m !== c.value && (c.value = m),
                Q.defaultValue == null && c.defaultValue !== m && (c.defaultValue = m))
            }
            G != null && (c.defaultValue = Zi(G))
          }
          function Ta(t, Q) {
            var c = t,
              f = c.textContent
            f === c._wrapperState.initialValue && f !== "" && f !== null && (c.value = f)
          }
          function $E(t, Q) {
            Ll(t, Q)
          }
          var yo = "http://www.w3.org/1999/xhtml",
            Yl = "http://www.w3.org/1998/Math/MathML",
            mQ = "http://www.w3.org/2000/svg"
          function oQ(t) {
            switch (t) {
              case "svg":
                return mQ
              case "math":
                return Yl
              default:
                return yo
            }
          }
          function fE(t, Q) {
            return t == null || t === yo ? oQ(Q) : t === mQ && Q === "foreignObject" ? yo : t
          }
          var dE = function (t) {
              return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction
                ? function (Q, c, f, G) {
                    MSApp.execUnsafeLocalFunction(function () {
                      return t(Q, c, f, G)
                    })
                  }
                : t
            },
            po,
            Aa = dE(function (t, Q) {
              if (t.namespaceURI === mQ && !("innerHTML" in t)) {
                ;((po = po || document.createElement("div")),
                  (po.innerHTML = "<svg>" + Q.valueOf().toString() + "</svg>"))
                for (var c = po.firstChild; t.firstChild; ) t.removeChild(t.firstChild)
                for (; c.firstChild; ) t.appendChild(c.firstChild)
                return
              }
              t.innerHTML = Q
            }),
            nQ = 1,
            Cn = 3,
            at = 8,
            Xi = 9,
            $i = 11,
            ri = function (t, Q) {
              if (Q) {
                var c = t.firstChild
                if (c && c === t.lastChild && c.nodeType === Cn) {
                  c.nodeValue = Q
                  return
                }
              }
              t.textContent = Q
            },
            xa = {
              animation: [
                "animationDelay",
                "animationDirection",
                "animationDuration",
                "animationFillMode",
                "animationIterationCount",
                "animationName",
                "animationPlayState",
                "animationTimingFunction",
              ],
              background: [
                "backgroundAttachment",
                "backgroundClip",
                "backgroundColor",
                "backgroundImage",
                "backgroundOrigin",
                "backgroundPositionX",
                "backgroundPositionY",
                "backgroundRepeat",
                "backgroundSize",
              ],
              backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
              border: [
                "borderBottomColor",
                "borderBottomStyle",
                "borderBottomWidth",
                "borderImageOutset",
                "borderImageRepeat",
                "borderImageSlice",
                "borderImageSource",
                "borderImageWidth",
                "borderLeftColor",
                "borderLeftStyle",
                "borderLeftWidth",
                "borderRightColor",
                "borderRightStyle",
                "borderRightWidth",
                "borderTopColor",
                "borderTopStyle",
                "borderTopWidth",
              ],
              borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
              borderBlockStart: [
                "borderBlockStartColor",
                "borderBlockStartStyle",
                "borderBlockStartWidth",
              ],
              borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
              borderColor: [
                "borderBottomColor",
                "borderLeftColor",
                "borderRightColor",
                "borderTopColor",
              ],
              borderImage: [
                "borderImageOutset",
                "borderImageRepeat",
                "borderImageSlice",
                "borderImageSource",
                "borderImageWidth",
              ],
              borderInlineEnd: [
                "borderInlineEndColor",
                "borderInlineEndStyle",
                "borderInlineEndWidth",
              ],
              borderInlineStart: [
                "borderInlineStartColor",
                "borderInlineStartStyle",
                "borderInlineStartWidth",
              ],
              borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
              borderRadius: [
                "borderBottomLeftRadius",
                "borderBottomRightRadius",
                "borderTopLeftRadius",
                "borderTopRightRadius",
              ],
              borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
              borderStyle: [
                "borderBottomStyle",
                "borderLeftStyle",
                "borderRightStyle",
                "borderTopStyle",
              ],
              borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
              borderWidth: [
                "borderBottomWidth",
                "borderLeftWidth",
                "borderRightWidth",
                "borderTopWidth",
              ],
              columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
              columns: ["columnCount", "columnWidth"],
              flex: ["flexBasis", "flexGrow", "flexShrink"],
              flexFlow: ["flexDirection", "flexWrap"],
              font: [
                "fontFamily",
                "fontFeatureSettings",
                "fontKerning",
                "fontLanguageOverride",
                "fontSize",
                "fontSizeAdjust",
                "fontStretch",
                "fontStyle",
                "fontVariant",
                "fontVariantAlternates",
                "fontVariantCaps",
                "fontVariantEastAsian",
                "fontVariantLigatures",
                "fontVariantNumeric",
                "fontVariantPosition",
                "fontWeight",
                "lineHeight",
              ],
              fontVariant: [
                "fontVariantAlternates",
                "fontVariantCaps",
                "fontVariantEastAsian",
                "fontVariantLigatures",
                "fontVariantNumeric",
                "fontVariantPosition",
              ],
              gap: ["columnGap", "rowGap"],
              grid: [
                "gridAutoColumns",
                "gridAutoFlow",
                "gridAutoRows",
                "gridTemplateAreas",
                "gridTemplateColumns",
                "gridTemplateRows",
              ],
              gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
              gridColumn: ["gridColumnEnd", "gridColumnStart"],
              gridColumnGap: ["columnGap"],
              gridGap: ["columnGap", "rowGap"],
              gridRow: ["gridRowEnd", "gridRowStart"],
              gridRowGap: ["rowGap"],
              gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
              listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
              margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
              marker: ["markerEnd", "markerMid", "markerStart"],
              mask: [
                "maskClip",
                "maskComposite",
                "maskImage",
                "maskMode",
                "maskOrigin",
                "maskPositionX",
                "maskPositionY",
                "maskRepeat",
                "maskSize",
              ],
              maskPosition: ["maskPositionX", "maskPositionY"],
              outline: ["outlineColor", "outlineStyle", "outlineWidth"],
              overflow: ["overflowX", "overflowY"],
              padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
              placeContent: ["alignContent", "justifyContent"],
              placeItems: ["alignItems", "justifyItems"],
              placeSelf: ["alignSelf", "justifySelf"],
              textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
              textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
              transition: [
                "transitionDelay",
                "transitionDuration",
                "transitionProperty",
                "transitionTimingFunction",
              ],
              wordWrap: ["overflowWrap"],
            },
            pB = {
              animationIterationCount: !0,
              aspectRatio: !0,
              borderImageOutset: !0,
              borderImageSlice: !0,
              borderImageWidth: !0,
              boxFlex: !0,
              boxFlexGroup: !0,
              boxOrdinalGroup: !0,
              columnCount: !0,
              columns: !0,
              flex: !0,
              flexGrow: !0,
              flexPositive: !0,
              flexShrink: !0,
              flexNegative: !0,
              flexOrder: !0,
              gridArea: !0,
              gridRow: !0,
              gridRowEnd: !0,
              gridRowSpan: !0,
              gridRowStart: !0,
              gridColumn: !0,
              gridColumnEnd: !0,
              gridColumnSpan: !0,
              gridColumnStart: !0,
              fontWeight: !0,
              lineClamp: !0,
              lineHeight: !0,
              opacity: !0,
              order: !0,
              orphans: !0,
              tabSize: !0,
              widows: !0,
              zIndex: !0,
              zoom: !0,
              // SVG-related properties
              fillOpacity: !0,
              floodOpacity: !0,
              stopOpacity: !0,
              strokeDasharray: !0,
              strokeDashoffset: !0,
              strokeMiterlimit: !0,
              strokeOpacity: !0,
              strokeWidth: !0,
            }
          function ql(t, Q) {
            return t + Q.charAt(0).toUpperCase() + Q.substring(1)
          }
          var Hl = ["Webkit", "ms", "Moz", "O"]
          Object.keys(pB).forEach(function (t) {
            Hl.forEach(function (Q) {
              pB[ql(Q, t)] = pB[t]
            })
          })
          function ba(t, Q, c) {
            var f = Q == null || typeof Q == "boolean" || Q === ""
            return f
              ? ""
              : !c && typeof Q == "number" && Q !== 0 && !(pB.hasOwnProperty(t) && pB[t])
                ? Q + "px"
                : (QA(Q, t), ("" + Q).trim())
          }
          var yE = /([A-Z])/g,
            Wc = /^ms-/
          function Fs(t) {
            return t.replace(yE, "-$1").toLowerCase().replace(Wc, "-ms-")
          }
          var Oa = function () {}
          {
            var Or = /^(?:webkit|moz|o)[A-Z]/,
              Ia = /^-ms-/,
              EQ = /-(.)/g,
              pE = /;\s*$/,
              Ln = {},
              en = {},
              Rs = !1,
              _a = !1,
              xB = function (t) {
                return t.replace(EQ, function (Q, c) {
                  return c.toUpperCase()
                })
              },
              Za = function (t) {
                ;(Ln.hasOwnProperty(t) && Ln[t]) ||
                  ((Ln[t] = !0),
                  B(
                    "Unsupported style property %s. Did you mean %s?",
                    t,
                    // As Andi Smith suggests
                    // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
                    // is converted to lowercase `ms`.
                    xB(t.replace(Ia, "ms-")),
                  ))
              },
              wE = function (t) {
                ;(Ln.hasOwnProperty(t) && Ln[t]) ||
                  ((Ln[t] = !0),
                  B(
                    "Unsupported vendor-prefixed style property %s. Did you mean %s?",
                    t,
                    t.charAt(0).toUpperCase() + t.slice(1),
                  ))
              },
              wo = function (t, Q) {
                ;(en.hasOwnProperty(Q) && en[Q]) ||
                  ((en[Q] = !0),
                  B(
                    `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
                    t,
                    Q.replace(pE, ""),
                  ))
              },
              Js = function (t, Q) {
                Rs ||
                  ((Rs = !0), B("`NaN` is an invalid value for the `%s` css style property.", t))
              },
              Pa = function (t, Q) {
                _a ||
                  ((_a = !0),
                  B("`Infinity` is an invalid value for the `%s` css style property.", t))
              }
            Oa = function (t, Q) {
              ;(t.indexOf("-") > -1 ? Za(t) : Or.test(t) ? wE(t) : pE.test(Q) && wo(t, Q),
                typeof Q == "number" && (isNaN(Q) ? Js(t, Q) : isFinite(Q) || Pa(t, Q)))
            }
          }
          var Ks = Oa
          function go(t) {
            {
              var Q = "",
                c = ""
              for (var f in t)
                if (t.hasOwnProperty(f)) {
                  var G = t[f]
                  if (G != null) {
                    var m = f.indexOf("--") === 0
                    ;((Q += c + (m ? f : Fs(f)) + ":"), (Q += ba(f, G, m)), (c = ";"))
                  }
                }
              return Q || null
            }
          }
          function Fi(t, Q) {
            var c = t.style
            for (var f in Q)
              if (Q.hasOwnProperty(f)) {
                var G = f.indexOf("--") === 0
                G || Ks(f, Q[f])
                var m = ba(f, Q[f], G)
                ;(f === "float" && (f = "cssFloat"), G ? c.setProperty(f, m) : (c[f] = m))
              }
          }
          function Wa(t) {
            return t == null || typeof t == "boolean" || t === ""
          }
          function rt(t) {
            var Q = {}
            for (var c in t) for (var f = xa[c] || [c], G = 0; G < f.length; G++) Q[f[G]] = c
            return Q
          }
          function vQ(t, Q) {
            {
              if (!Q) return
              var c = rt(t),
                f = rt(Q),
                G = {}
              for (var m in c) {
                var x = c[m],
                  z = f[m]
                if (z && x !== z) {
                  var gA = x + "," + z
                  if (G[gA]) continue
                  ;((G[gA] = !0),
                    B(
                      "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                      Wa(t[x]) ? "Removing" : "Updating",
                      x,
                      z,
                    ))
                }
              }
            }
          }
          var vt = {
              area: !0,
              base: !0,
              br: !0,
              col: !0,
              embed: !0,
              hr: !0,
              img: !0,
              input: !0,
              keygen: !0,
              link: !0,
              meta: !0,
              param: !0,
              source: !0,
              track: !0,
              wbr: !0,
              // NOTE: menuitem's close tag should be omitted, but that causes problems.
            },
            ti = rg(
              {
                menuitem: !0,
              },
              vt,
            ),
            GE = "__html"
          function he(t, Q) {
            if (Q) {
              if (ti[t] && (Q.children != null || Q.dangerouslySetInnerHTML != null))
                throw new Error(
                  t +
                    " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.",
                )
              if (Q.dangerouslySetInnerHTML != null) {
                if (Q.children != null)
                  throw new Error(
                    "Can only set one of `children` or `props.dangerouslySetInnerHTML`.",
                  )
                if (
                  typeof Q.dangerouslySetInnerHTML != "object" ||
                  !(GE in Q.dangerouslySetInnerHTML)
                )
                  throw new Error(
                    "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.",
                  )
              }
              if (
                (!Q.suppressContentEditableWarning &&
                  Q.contentEditable &&
                  Q.children != null &&
                  B(
                    "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.",
                  ),
                Q.style != null && typeof Q.style != "object")
              )
                throw new Error(
                  "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.",
                )
            }
          }
          function xe(t, Q) {
            if (t.indexOf("-") === -1) return typeof Q.is == "string"
            switch (t) {
              // These are reserved SVG and MathML elements.
              // We don't mind this list too much because we expect it to never grow.
              // The alternative is to track the namespace in a few places which is convoluted.
              // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
              case "annotation-xml":
              case "color-profile":
              case "font-face":
              case "font-face-src":
              case "font-face-uri":
              case "font-face-format":
              case "font-face-name":
              case "missing-glyph":
                return !1
              default:
                return !0
            }
          }
          var $e = {
              // HTML
              accept: "accept",
              acceptcharset: "acceptCharset",
              "accept-charset": "acceptCharset",
              accesskey: "accessKey",
              action: "action",
              allowfullscreen: "allowFullScreen",
              alt: "alt",
              as: "as",
              async: "async",
              autocapitalize: "autoCapitalize",
              autocomplete: "autoComplete",
              autocorrect: "autoCorrect",
              autofocus: "autoFocus",
              autoplay: "autoPlay",
              autosave: "autoSave",
              capture: "capture",
              cellpadding: "cellPadding",
              cellspacing: "cellSpacing",
              challenge: "challenge",
              charset: "charSet",
              checked: "checked",
              children: "children",
              cite: "cite",
              class: "className",
              classid: "classID",
              classname: "className",
              cols: "cols",
              colspan: "colSpan",
              content: "content",
              contenteditable: "contentEditable",
              contextmenu: "contextMenu",
              controls: "controls",
              controlslist: "controlsList",
              coords: "coords",
              crossorigin: "crossOrigin",
              dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
              data: "data",
              datetime: "dateTime",
              default: "default",
              defaultchecked: "defaultChecked",
              defaultvalue: "defaultValue",
              defer: "defer",
              dir: "dir",
              disabled: "disabled",
              disablepictureinpicture: "disablePictureInPicture",
              disableremoteplayback: "disableRemotePlayback",
              download: "download",
              draggable: "draggable",
              enctype: "encType",
              enterkeyhint: "enterKeyHint",
              for: "htmlFor",
              form: "form",
              formmethod: "formMethod",
              formaction: "formAction",
              formenctype: "formEncType",
              formnovalidate: "formNoValidate",
              formtarget: "formTarget",
              frameborder: "frameBorder",
              headers: "headers",
              height: "height",
              hidden: "hidden",
              high: "high",
              href: "href",
              hreflang: "hrefLang",
              htmlfor: "htmlFor",
              httpequiv: "httpEquiv",
              "http-equiv": "httpEquiv",
              icon: "icon",
              id: "id",
              imagesizes: "imageSizes",
              imagesrcset: "imageSrcSet",
              innerhtml: "innerHTML",
              inputmode: "inputMode",
              integrity: "integrity",
              is: "is",
              itemid: "itemID",
              itemprop: "itemProp",
              itemref: "itemRef",
              itemscope: "itemScope",
              itemtype: "itemType",
              keyparams: "keyParams",
              keytype: "keyType",
              kind: "kind",
              label: "label",
              lang: "lang",
              list: "list",
              loop: "loop",
              low: "low",
              manifest: "manifest",
              marginwidth: "marginWidth",
              marginheight: "marginHeight",
              max: "max",
              maxlength: "maxLength",
              media: "media",
              mediagroup: "mediaGroup",
              method: "method",
              min: "min",
              minlength: "minLength",
              multiple: "multiple",
              muted: "muted",
              name: "name",
              nomodule: "noModule",
              nonce: "nonce",
              novalidate: "noValidate",
              open: "open",
              optimum: "optimum",
              pattern: "pattern",
              placeholder: "placeholder",
              playsinline: "playsInline",
              poster: "poster",
              preload: "preload",
              profile: "profile",
              radiogroup: "radioGroup",
              readonly: "readOnly",
              referrerpolicy: "referrerPolicy",
              rel: "rel",
              required: "required",
              reversed: "reversed",
              role: "role",
              rows: "rows",
              rowspan: "rowSpan",
              sandbox: "sandbox",
              scope: "scope",
              scoped: "scoped",
              scrolling: "scrolling",
              seamless: "seamless",
              selected: "selected",
              shape: "shape",
              size: "size",
              sizes: "sizes",
              span: "span",
              spellcheck: "spellCheck",
              src: "src",
              srcdoc: "srcDoc",
              srclang: "srcLang",
              srcset: "srcSet",
              start: "start",
              step: "step",
              style: "style",
              summary: "summary",
              tabindex: "tabIndex",
              target: "target",
              title: "title",
              type: "type",
              usemap: "useMap",
              value: "value",
              width: "width",
              wmode: "wmode",
              wrap: "wrap",
              // SVG
              about: "about",
              accentheight: "accentHeight",
              "accent-height": "accentHeight",
              accumulate: "accumulate",
              additive: "additive",
              alignmentbaseline: "alignmentBaseline",
              "alignment-baseline": "alignmentBaseline",
              allowreorder: "allowReorder",
              alphabetic: "alphabetic",
              amplitude: "amplitude",
              arabicform: "arabicForm",
              "arabic-form": "arabicForm",
              ascent: "ascent",
              attributename: "attributeName",
              attributetype: "attributeType",
              autoreverse: "autoReverse",
              azimuth: "azimuth",
              basefrequency: "baseFrequency",
              baselineshift: "baselineShift",
              "baseline-shift": "baselineShift",
              baseprofile: "baseProfile",
              bbox: "bbox",
              begin: "begin",
              bias: "bias",
              by: "by",
              calcmode: "calcMode",
              capheight: "capHeight",
              "cap-height": "capHeight",
              clip: "clip",
              clippath: "clipPath",
              "clip-path": "clipPath",
              clippathunits: "clipPathUnits",
              cliprule: "clipRule",
              "clip-rule": "clipRule",
              color: "color",
              colorinterpolation: "colorInterpolation",
              "color-interpolation": "colorInterpolation",
              colorinterpolationfilters: "colorInterpolationFilters",
              "color-interpolation-filters": "colorInterpolationFilters",
              colorprofile: "colorProfile",
              "color-profile": "colorProfile",
              colorrendering: "colorRendering",
              "color-rendering": "colorRendering",
              contentscripttype: "contentScriptType",
              contentstyletype: "contentStyleType",
              cursor: "cursor",
              cx: "cx",
              cy: "cy",
              d: "d",
              datatype: "datatype",
              decelerate: "decelerate",
              descent: "descent",
              diffuseconstant: "diffuseConstant",
              direction: "direction",
              display: "display",
              divisor: "divisor",
              dominantbaseline: "dominantBaseline",
              "dominant-baseline": "dominantBaseline",
              dur: "dur",
              dx: "dx",
              dy: "dy",
              edgemode: "edgeMode",
              elevation: "elevation",
              enablebackground: "enableBackground",
              "enable-background": "enableBackground",
              end: "end",
              exponent: "exponent",
              externalresourcesrequired: "externalResourcesRequired",
              fill: "fill",
              fillopacity: "fillOpacity",
              "fill-opacity": "fillOpacity",
              fillrule: "fillRule",
              "fill-rule": "fillRule",
              filter: "filter",
              filterres: "filterRes",
              filterunits: "filterUnits",
              floodopacity: "floodOpacity",
              "flood-opacity": "floodOpacity",
              floodcolor: "floodColor",
              "flood-color": "floodColor",
              focusable: "focusable",
              fontfamily: "fontFamily",
              "font-family": "fontFamily",
              fontsize: "fontSize",
              "font-size": "fontSize",
              fontsizeadjust: "fontSizeAdjust",
              "font-size-adjust": "fontSizeAdjust",
              fontstretch: "fontStretch",
              "font-stretch": "fontStretch",
              fontstyle: "fontStyle",
              "font-style": "fontStyle",
              fontvariant: "fontVariant",
              "font-variant": "fontVariant",
              fontweight: "fontWeight",
              "font-weight": "fontWeight",
              format: "format",
              from: "from",
              fx: "fx",
              fy: "fy",
              g1: "g1",
              g2: "g2",
              glyphname: "glyphName",
              "glyph-name": "glyphName",
              glyphorientationhorizontal: "glyphOrientationHorizontal",
              "glyph-orientation-horizontal": "glyphOrientationHorizontal",
              glyphorientationvertical: "glyphOrientationVertical",
              "glyph-orientation-vertical": "glyphOrientationVertical",
              glyphref: "glyphRef",
              gradienttransform: "gradientTransform",
              gradientunits: "gradientUnits",
              hanging: "hanging",
              horizadvx: "horizAdvX",
              "horiz-adv-x": "horizAdvX",
              horizoriginx: "horizOriginX",
              "horiz-origin-x": "horizOriginX",
              ideographic: "ideographic",
              imagerendering: "imageRendering",
              "image-rendering": "imageRendering",
              in2: "in2",
              in: "in",
              inlist: "inlist",
              intercept: "intercept",
              k1: "k1",
              k2: "k2",
              k3: "k3",
              k4: "k4",
              k: "k",
              kernelmatrix: "kernelMatrix",
              kernelunitlength: "kernelUnitLength",
              kerning: "kerning",
              keypoints: "keyPoints",
              keysplines: "keySplines",
              keytimes: "keyTimes",
              lengthadjust: "lengthAdjust",
              letterspacing: "letterSpacing",
              "letter-spacing": "letterSpacing",
              lightingcolor: "lightingColor",
              "lighting-color": "lightingColor",
              limitingconeangle: "limitingConeAngle",
              local: "local",
              markerend: "markerEnd",
              "marker-end": "markerEnd",
              markerheight: "markerHeight",
              markermid: "markerMid",
              "marker-mid": "markerMid",
              markerstart: "markerStart",
              "marker-start": "markerStart",
              markerunits: "markerUnits",
              markerwidth: "markerWidth",
              mask: "mask",
              maskcontentunits: "maskContentUnits",
              maskunits: "maskUnits",
              mathematical: "mathematical",
              mode: "mode",
              numoctaves: "numOctaves",
              offset: "offset",
              opacity: "opacity",
              operator: "operator",
              order: "order",
              orient: "orient",
              orientation: "orientation",
              origin: "origin",
              overflow: "overflow",
              overlineposition: "overlinePosition",
              "overline-position": "overlinePosition",
              overlinethickness: "overlineThickness",
              "overline-thickness": "overlineThickness",
              paintorder: "paintOrder",
              "paint-order": "paintOrder",
              panose1: "panose1",
              "panose-1": "panose1",
              pathlength: "pathLength",
              patterncontentunits: "patternContentUnits",
              patterntransform: "patternTransform",
              patternunits: "patternUnits",
              pointerevents: "pointerEvents",
              "pointer-events": "pointerEvents",
              points: "points",
              pointsatx: "pointsAtX",
              pointsaty: "pointsAtY",
              pointsatz: "pointsAtZ",
              prefix: "prefix",
              preservealpha: "preserveAlpha",
              preserveaspectratio: "preserveAspectRatio",
              primitiveunits: "primitiveUnits",
              property: "property",
              r: "r",
              radius: "radius",
              refx: "refX",
              refy: "refY",
              renderingintent: "renderingIntent",
              "rendering-intent": "renderingIntent",
              repeatcount: "repeatCount",
              repeatdur: "repeatDur",
              requiredextensions: "requiredExtensions",
              requiredfeatures: "requiredFeatures",
              resource: "resource",
              restart: "restart",
              result: "result",
              results: "results",
              rotate: "rotate",
              rx: "rx",
              ry: "ry",
              scale: "scale",
              security: "security",
              seed: "seed",
              shaperendering: "shapeRendering",
              "shape-rendering": "shapeRendering",
              slope: "slope",
              spacing: "spacing",
              specularconstant: "specularConstant",
              specularexponent: "specularExponent",
              speed: "speed",
              spreadmethod: "spreadMethod",
              startoffset: "startOffset",
              stddeviation: "stdDeviation",
              stemh: "stemh",
              stemv: "stemv",
              stitchtiles: "stitchTiles",
              stopcolor: "stopColor",
              "stop-color": "stopColor",
              stopopacity: "stopOpacity",
              "stop-opacity": "stopOpacity",
              strikethroughposition: "strikethroughPosition",
              "strikethrough-position": "strikethroughPosition",
              strikethroughthickness: "strikethroughThickness",
              "strikethrough-thickness": "strikethroughThickness",
              string: "string",
              stroke: "stroke",
              strokedasharray: "strokeDasharray",
              "stroke-dasharray": "strokeDasharray",
              strokedashoffset: "strokeDashoffset",
              "stroke-dashoffset": "strokeDashoffset",
              strokelinecap: "strokeLinecap",
              "stroke-linecap": "strokeLinecap",
              strokelinejoin: "strokeLinejoin",
              "stroke-linejoin": "strokeLinejoin",
              strokemiterlimit: "strokeMiterlimit",
              "stroke-miterlimit": "strokeMiterlimit",
              strokewidth: "strokeWidth",
              "stroke-width": "strokeWidth",
              strokeopacity: "strokeOpacity",
              "stroke-opacity": "strokeOpacity",
              suppresscontenteditablewarning: "suppressContentEditableWarning",
              suppresshydrationwarning: "suppressHydrationWarning",
              surfacescale: "surfaceScale",
              systemlanguage: "systemLanguage",
              tablevalues: "tableValues",
              targetx: "targetX",
              targety: "targetY",
              textanchor: "textAnchor",
              "text-anchor": "textAnchor",
              textdecoration: "textDecoration",
              "text-decoration": "textDecoration",
              textlength: "textLength",
              textrendering: "textRendering",
              "text-rendering": "textRendering",
              to: "to",
              transform: "transform",
              typeof: "typeof",
              u1: "u1",
              u2: "u2",
              underlineposition: "underlinePosition",
              "underline-position": "underlinePosition",
              underlinethickness: "underlineThickness",
              "underline-thickness": "underlineThickness",
              unicode: "unicode",
              unicodebidi: "unicodeBidi",
              "unicode-bidi": "unicodeBidi",
              unicoderange: "unicodeRange",
              "unicode-range": "unicodeRange",
              unitsperem: "unitsPerEm",
              "units-per-em": "unitsPerEm",
              unselectable: "unselectable",
              valphabetic: "vAlphabetic",
              "v-alphabetic": "vAlphabetic",
              values: "values",
              vectoreffect: "vectorEffect",
              "vector-effect": "vectorEffect",
              version: "version",
              vertadvy: "vertAdvY",
              "vert-adv-y": "vertAdvY",
              vertoriginx: "vertOriginX",
              "vert-origin-x": "vertOriginX",
              vertoriginy: "vertOriginY",
              "vert-origin-y": "vertOriginY",
              vhanging: "vHanging",
              "v-hanging": "vHanging",
              videographic: "vIdeographic",
              "v-ideographic": "vIdeographic",
              viewbox: "viewBox",
              viewtarget: "viewTarget",
              visibility: "visibility",
              vmathematical: "vMathematical",
              "v-mathematical": "vMathematical",
              vocab: "vocab",
              widths: "widths",
              wordspacing: "wordSpacing",
              "word-spacing": "wordSpacing",
              writingmode: "writingMode",
              "writing-mode": "writingMode",
              x1: "x1",
              x2: "x2",
              x: "x",
              xchannelselector: "xChannelSelector",
              xheight: "xHeight",
              "x-height": "xHeight",
              xlinkactuate: "xlinkActuate",
              "xlink:actuate": "xlinkActuate",
              xlinkarcrole: "xlinkArcrole",
              "xlink:arcrole": "xlinkArcrole",
              xlinkhref: "xlinkHref",
              "xlink:href": "xlinkHref",
              xlinkrole: "xlinkRole",
              "xlink:role": "xlinkRole",
              xlinkshow: "xlinkShow",
              "xlink:show": "xlinkShow",
              xlinktitle: "xlinkTitle",
              "xlink:title": "xlinkTitle",
              xlinktype: "xlinkType",
              "xlink:type": "xlinkType",
              xmlbase: "xmlBase",
              "xml:base": "xmlBase",
              xmllang: "xmlLang",
              "xml:lang": "xmlLang",
              xmlns: "xmlns",
              "xml:space": "xmlSpace",
              xmlnsxlink: "xmlnsXlink",
              "xmlns:xlink": "xmlnsXlink",
              xmlspace: "xmlSpace",
              y1: "y1",
              y2: "y2",
              y: "y",
              ychannelselector: "yChannelSelector",
              z: "z",
              zoomandpan: "zoomAndPan",
            },
            Va = {
              "aria-current": 0,
              // state
              "aria-description": 0,
              "aria-details": 0,
              "aria-disabled": 0,
              // state
              "aria-hidden": 0,
              // state
              "aria-invalid": 0,
              // state
              "aria-keyshortcuts": 0,
              "aria-label": 0,
              "aria-roledescription": 0,
              // Widget Attributes
              "aria-autocomplete": 0,
              "aria-checked": 0,
              "aria-expanded": 0,
              "aria-haspopup": 0,
              "aria-level": 0,
              "aria-modal": 0,
              "aria-multiline": 0,
              "aria-multiselectable": 0,
              "aria-orientation": 0,
              "aria-placeholder": 0,
              "aria-pressed": 0,
              "aria-readonly": 0,
              "aria-required": 0,
              "aria-selected": 0,
              "aria-sort": 0,
              "aria-valuemax": 0,
              "aria-valuemin": 0,
              "aria-valuenow": 0,
              "aria-valuetext": 0,
              // Live Region Attributes
              "aria-atomic": 0,
              "aria-busy": 0,
              "aria-live": 0,
              "aria-relevant": 0,
              // Drag-and-Drop Attributes
              "aria-dropeffect": 0,
              "aria-grabbed": 0,
              // Relationship Attributes
              "aria-activedescendant": 0,
              "aria-colcount": 0,
              "aria-colindex": 0,
              "aria-colspan": 0,
              "aria-controls": 0,
              "aria-describedby": 0,
              "aria-errormessage": 0,
              "aria-flowto": 0,
              "aria-labelledby": 0,
              "aria-owns": 0,
              "aria-posinset": 0,
              "aria-rowcount": 0,
              "aria-rowindex": 0,
              "aria-rowspan": 0,
              "aria-setsize": 0,
            },
            Lt = {},
            ga = new RegExp("^(aria)-[" + OA + "]*$"),
            Yn = new RegExp("^(aria)[A-Z][" + OA + "]*$")
          function kt(t, Q) {
            {
              if (uA.call(Lt, Q) && Lt[Q]) return !0
              if (Yn.test(Q)) {
                var c = "aria-" + Q.slice(4).toLowerCase(),
                  f = Va.hasOwnProperty(c) ? c : null
                if (f == null)
                  return (
                    B(
                      "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
                      Q,
                    ),
                    (Lt[Q] = !0),
                    !0
                  )
                if (Q !== f)
                  return (
                    B("Invalid ARIA attribute `%s`. Did you mean `%s`?", Q, f),
                    (Lt[Q] = !0),
                    !0
                  )
              }
              if (ga.test(Q)) {
                var G = Q.toLowerCase(),
                  m = Va.hasOwnProperty(G) ? G : null
                if (m == null) return ((Lt[Q] = !0), !1)
                if (Q !== m)
                  return (
                    B("Unknown ARIA attribute `%s`. Did you mean `%s`?", Q, m),
                    (Lt[Q] = !0),
                    !0
                  )
              }
            }
            return !0
          }
          function Co(t, Q) {
            {
              var c = []
              for (var f in Q) {
                var G = kt(t, f)
                G || c.push(f)
              }
              var m = c
                .map(function (x) {
                  return "`" + x + "`"
                })
                .join(", ")
              c.length === 1
                ? B(
                    "Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props",
                    m,
                    t,
                  )
                : c.length > 1 &&
                  B(
                    "Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props",
                    m,
                    t,
                  )
            }
          }
          function kE(t, Q) {
            xe(t, Q) || Co(t, Q)
          }
          var tn = !1
          function Go(t, Q) {
            {
              if (t !== "input" && t !== "textarea" && t !== "select") return
              Q != null &&
                Q.value === null &&
                !tn &&
                ((tn = !0),
                t === "select" && Q.multiple
                  ? B(
                      "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
                      t,
                    )
                  : B(
                      "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
                      t,
                    ))
            }
          }
          var eo = function () {}
          {
            var yi = {},
              ja = /^on./,
              ms = /^on[^A-Z]/,
              Ca = new RegExp("^(aria)-[" + OA + "]*$"),
              Tl = new RegExp("^(aria)[A-Z][" + OA + "]*$")
            eo = function (t, Q, c, f) {
              if (uA.call(yi, Q) && yi[Q]) return !0
              var G = Q.toLowerCase()
              if (G === "onfocusin" || G === "onfocusout")
                return (
                  B(
                    "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.",
                  ),
                  (yi[Q] = !0),
                  !0
                )
              if (f != null) {
                var m = f.registrationNameDependencies,
                  x = f.possibleRegistrationNames
                if (m.hasOwnProperty(Q)) return !0
                var z = x.hasOwnProperty(G) ? x[G] : null
                if (z != null)
                  return (
                    B("Invalid event handler property `%s`. Did you mean `%s`?", Q, z),
                    (yi[Q] = !0),
                    !0
                  )
                if (ja.test(Q))
                  return (
                    B("Unknown event handler property `%s`. It will be ignored.", Q),
                    (yi[Q] = !0),
                    !0
                  )
              } else if (ja.test(Q))
                return (
                  ms.test(Q) &&
                    B(
                      "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
                      Q,
                    ),
                  (yi[Q] = !0),
                  !0
                )
              if (Ca.test(Q) || Tl.test(Q)) return !0
              if (G === "innerhtml")
                return (
                  B(
                    "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.",
                  ),
                  (yi[Q] = !0),
                  !0
                )
              if (G === "aria")
                return (
                  B(
                    "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.",
                  ),
                  (yi[Q] = !0),
                  !0
                )
              if (G === "is" && c !== null && c !== void 0 && typeof c != "string")
                return (
                  B(
                    "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
                    typeof c,
                  ),
                  (yi[Q] = !0),
                  !0
                )
              if (typeof c == "number" && isNaN(c))
                return (
                  B(
                    "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
                    Q,
                  ),
                  (yi[Q] = !0),
                  !0
                )
              var gA = NI(Q),
                hA = gA !== null && gA.type === WA
              if ($e.hasOwnProperty(G)) {
                var pA = $e[G]
                if (pA !== Q)
                  return (
                    B("Invalid DOM property `%s`. Did you mean `%s`?", Q, pA),
                    (yi[Q] = !0),
                    !0
                  )
              } else if (!hA && Q !== G)
                return (
                  B(
                    "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
                    Q,
                    G,
                  ),
                  (yi[Q] = !0),
                  !0
                )
              return typeof c == "boolean" && $I(Q, c, gA, !1)
                ? (c
                    ? B(
                        'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                        c,
                        Q,
                        Q,
                        c,
                        Q,
                      )
                    : B(
                        'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                        c,
                        Q,
                        Q,
                        c,
                        Q,
                        Q,
                        Q,
                      ),
                  (yi[Q] = !0),
                  !0)
                : hA
                  ? !0
                  : $I(Q, c, gA, !1)
                    ? ((yi[Q] = !0), !1)
                    : ((c === "false" || c === "true") &&
                        gA !== null &&
                        gA.type === UI &&
                        (B(
                          "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
                          c,
                          Q,
                          c === "false"
                            ? "The browser will interpret it as a truthy value."
                            : 'Although this works, it will not work as expected if you pass the string "false".',
                          Q,
                          c,
                        ),
                        (yi[Q] = !0)),
                      !0)
            }
          }
          var FC = function (t, Q, c) {
            {
              var f = []
              for (var G in Q) {
                var m = eo(t, G, Q[G], c)
                m || f.push(G)
              }
              var x = f
                .map(function (z) {
                  return "`" + z + "`"
                })
                .join(", ")
              f.length === 1
                ? B(
                    "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ",
                    x,
                    t,
                  )
                : f.length > 1 &&
                  B(
                    "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ",
                    x,
                    t,
                  )
            }
          }
          function Ai(t, Q, c) {
            xe(t, Q) || FC(t, Q, c)
          }
          var Ae = 1,
            qi = 2,
            sB = 4,
            _r = Ae | qi | sB,
            Zr = null
          function ea(t) {
            ;(Zr !== null &&
              B(
                "Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.",
              ),
              (Zr = t))
          }
          function xl() {
            ;(Zr === null &&
              B(
                "Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.",
              ),
              (Zr = null))
          }
          function Pr(t) {
            return t === Zr
          }
          function Cg(t) {
            var Q = t.target || t.srcElement || window
            return (
              Q.correspondingUseElement && (Q = Q.correspondingUseElement),
              Q.nodeType === Cn ? Q.parentNode : Q
            )
          }
          var TC = null,
            PC = null,
            aQ = null
          function LQ(t) {
            var Q = cc(t)
            if (Q) {
              if (typeof TC != "function")
                throw new Error(
                  "setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.",
                )
              var c = Q.stateNode
              if (c) {
                var f = pa(c)
                TC(Q.stateNode, Q.type, f)
              }
            }
          }
          function qn(t) {
            TC = t
          }
          function io(t) {
            PC ? (aQ ? aQ.push(t) : (aQ = [t])) : (PC = t)
          }
          function Hn() {
            return PC !== null || aQ !== null
          }
          function Tn() {
            if (PC) {
              var t = PC,
                Q = aQ
              if (((PC = null), (aQ = null), LQ(t), Q)) for (var c = 0; c < Q.length; c++) LQ(Q[c])
            }
          }
          var ko = function (t, Q) {
              return t(Q)
            },
            vs = function () {},
            Ls = !1
          function bl() {
            var t = Hn()
            t && (vs(), Tn())
          }
          function Wr(t, Q, c) {
            if (Ls) return t(Q, c)
            Ls = !0
            try {
              return ko(t, Q, c)
            } finally {
              ;((Ls = !1), bl())
            }
          }
          function za(t, Q, c) {
            ;((ko = t), (vs = c))
          }
          function Xa(t) {
            return t === "button" || t === "input" || t === "select" || t === "textarea"
          }
          function ia(t, Q, c) {
            switch (t) {
              case "onClick":
              case "onClickCapture":
              case "onDoubleClick":
              case "onDoubleClickCapture":
              case "onMouseDown":
              case "onMouseDownCapture":
              case "onMouseMove":
              case "onMouseMoveCapture":
              case "onMouseUp":
              case "onMouseUpCapture":
              case "onMouseEnter":
                return !!(c.disabled && Xa(Q))
              default:
                return !1
            }
          }
          function ME(t, Q) {
            var c = t.stateNode
            if (c === null) return null
            var f = pa(c)
            if (f === null) return null
            var G = f[Q]
            if (ia(Q, t.type, f)) return null
            if (G && typeof G != "function")
              throw new Error(
                "Expected `" +
                  Q +
                  "` listener to be a function, instead got a value of `" +
                  typeof G +
                  "` type.",
              )
            return G
          }
          var $a = !1
          if (eI)
            try {
              var UE = {}
              ;(Object.defineProperty(UE, "passive", {
                get: function () {
                  $a = !0
                },
              }),
                window.addEventListener("test", UE, UE),
                window.removeEventListener("test", UE, UE))
            } catch {
              $a = !1
            }
          function Vr(t, Q, c, f, G, m, x, z, gA) {
            var hA = Array.prototype.slice.call(arguments, 3)
            try {
              Q.apply(c, hA)
            } catch (pA) {
              this.onError(pA)
            }
          }
          var Ar = Vr
          if (
            typeof window < "u" &&
            typeof window.dispatchEvent == "function" &&
            typeof document < "u" &&
            typeof document.createEvent == "function"
          ) {
            var Ys = document.createElement("react")
            Ar = function (Q, c, f, G, m, x, z, gA, hA) {
              if (typeof document > "u" || document === null)
                throw new Error(
                  "The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.",
                )
              var pA = document.createEvent("Event"),
                gI = !1,
                $A = !0,
                FI = window.event,
                KI = Object.getOwnPropertyDescriptor(window, "event")
              function OI() {
                ;(Ys.removeEventListener(_I, yC, !1),
                  typeof window.event < "u" &&
                    window.hasOwnProperty("event") &&
                    (window.event = FI))
              }
              var Lg = Array.prototype.slice.call(arguments, 3)
              function yC() {
                ;((gI = !0), OI(), c.apply(f, Lg), ($A = !1))
              }
              var EC,
                We = !1,
                Le = !1
              function fI(dI) {
                if (
                  ((EC = dI.error),
                  (We = !0),
                  EC === null && dI.colno === 0 && dI.lineno === 0 && (Le = !0),
                  dI.defaultPrevented && EC != null && typeof EC == "object")
                )
                  try {
                    EC._suppressLogging = !0
                  } catch {}
              }
              var _I = "react-" + (Q || "invokeguardedcallback")
              if (
                (window.addEventListener("error", fI),
                Ys.addEventListener(_I, yC, !1),
                pA.initEvent(_I, !1, !1),
                Ys.dispatchEvent(pA),
                KI && Object.defineProperty(window, "event", KI),
                gI &&
                  $A &&
                  (We
                    ? Le &&
                      (EC = new Error(
                        "A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.",
                      ))
                    : (EC = new Error(
                        `An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`,
                      )),
                  this.onError(EC)),
                window.removeEventListener("error", fI),
                !gI)
              )
                return (OI(), Vr.apply(this, arguments))
            }
          }
          var Ol = Ar,
            Bn = !1,
            rQ = null,
            Qn = !1,
            on = null,
            Mt = {
              onError: function (t) {
                ;((Bn = !0), (rQ = t))
              },
            }
          function xn(t, Q, c, f, G, m, x, z, gA) {
            ;((Bn = !1), (rQ = null), Ol.apply(Mt, arguments))
          }
          function sQ(t, Q, c, f, G, m, x, z, gA) {
            if ((xn.apply(this, arguments), Bn)) {
              var hA = Ir()
              Qn || ((Qn = !0), (on = hA))
            }
          }
          function ta() {
            if (Qn) {
              var t = on
              throw ((Qn = !1), (on = null), t)
            }
          }
          function Ba() {
            return Bn
          }
          function Ir() {
            if (Bn) {
              var t = rQ
              return ((Bn = !1), (rQ = null), t)
            } else
              throw new Error(
                "clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.",
              )
          }
          function wB(t) {
            return t._reactInternals
          }
          function lQ(t) {
            return t._reactInternals !== void 0
          }
          function Re(t, Q) {
            t._reactInternals = Q
          }
          var nC =
              /*                      */
              0,
            Je =
              /*                */
              1,
            te =
              /*                    */
              2,
            IC =
              /*                       */
              4,
            de =
              /*                */
              16,
            Ue =
              /*                 */
              32,
            nn =
              /*                     */
              64,
            kC =
              /*                   */
              128,
            At =
              /*            */
              256,
            bB =
              /*                          */
              512,
            cQ =
              /*                     */
              1024,
            Ri =
              /*                      */
              2048,
            hQ =
              /*                    */
              4096,
            bn =
              /*                   */
              8192,
            Qa =
              /*             */
              16384,
            On = Ri | IC | nn | bB | cQ | Qa,
            Vc =
              /*               */
              32767,
            OB =
              /*                   */
              32768,
            Xt =
              /*                */
              65536,
            jr =
              /* */
              131072,
            Mo =
              /*                       */
              1048576,
            oa =
              /*                    */
              2097152,
            st =
              /*                 */
              4194304,
            En =
              /*                */
              8388608,
            Ne =
              /*               */
              16777216,
            Uo =
              /*              */
              33554432,
            LC =
              // TODO: Remove Update flag from before mutation phase by re-landing Visibility
              // flag logic (see #20043)
              IC | cQ | 0,
            Yt = te | IC | de | Ue | bB | hQ | bn,
            It = IC | nn | bB | bn,
            an = Ri | de,
            lg = st | En | oa,
            YQ = I.ReactCurrentOwner
          function $t(t) {
            var Q = t,
              c = t
            if (t.alternate) for (; Q.return; ) Q = Q.return
            else {
              var f = Q
              do ((Q = f), (Q.flags & (te | hQ)) !== nC && (c = Q.return), (f = Q.return))
              while (f)
            }
            return Q.tag === S ? c : null
          }
          function _l(t) {
            if (t.tag === V) {
              var Q = t.memoizedState
              if (Q === null) {
                var c = t.alternate
                c !== null && (Q = c.memoizedState)
              }
              if (Q !== null) return Q.dehydrated
            }
            return null
          }
          function qs(t) {
            return t.tag === S ? t.stateNode.containerInfo : null
          }
          function NE(t) {
            return $t(t) === t
          }
          function AB(t) {
            {
              var Q = YQ.current
              if (Q !== null && Q.tag === s) {
                var c = Q,
                  f = c.stateNode
                ;(f._warnedAboutRefsInRender ||
                  B(
                    "%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.",
                    oC(c) || "A component",
                  ),
                  (f._warnedAboutRefsInRender = !0))
              }
            }
            var G = wB(t)
            return G ? $t(G) === G : !1
          }
          function _B(t) {
            if ($t(t) !== t) throw new Error("Unable to find node on an unmounted component.")
          }
          function pi(t) {
            var Q = t.alternate
            if (!Q) {
              var c = $t(t)
              if (c === null) throw new Error("Unable to find node on an unmounted component.")
              return c !== t ? null : t
            }
            for (var f = t, G = Q; ; ) {
              var m = f.return
              if (m === null) break
              var x = m.alternate
              if (x === null) {
                var z = m.return
                if (z !== null) {
                  f = G = z
                  continue
                }
                break
              }
              if (m.child === x.child) {
                for (var gA = m.child; gA; ) {
                  if (gA === f) return (_B(m), t)
                  if (gA === G) return (_B(m), Q)
                  gA = gA.sibling
                }
                throw new Error("Unable to find node on an unmounted component.")
              }
              if (f.return !== G.return) ((f = m), (G = x))
              else {
                for (var hA = !1, pA = m.child; pA; ) {
                  if (pA === f) {
                    ;((hA = !0), (f = m), (G = x))
                    break
                  }
                  if (pA === G) {
                    ;((hA = !0), (G = m), (f = x))
                    break
                  }
                  pA = pA.sibling
                }
                if (!hA) {
                  for (pA = x.child; pA; ) {
                    if (pA === f) {
                      ;((hA = !0), (f = x), (G = m))
                      break
                    }
                    if (pA === G) {
                      ;((hA = !0), (G = x), (f = m))
                      break
                    }
                    pA = pA.sibling
                  }
                  if (!hA)
                    throw new Error(
                      "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.",
                    )
                }
              }
              if (f.alternate !== G)
                throw new Error(
                  "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.",
                )
            }
            if (f.tag !== S) throw new Error("Unable to find node on an unmounted component.")
            return f.stateNode.current === f ? t : Q
          }
          function qQ(t) {
            var Q = pi(t)
            return Q !== null ? to(Q) : null
          }
          function to(t) {
            if (t.tag === w || t.tag === M) return t
            for (var Q = t.child; Q !== null; ) {
              var c = to(Q)
              if (c !== null) return c
              Q = Q.sibling
            }
            return null
          }
          function gr(t) {
            var Q = pi(t)
            return Q !== null ? FE(Q) : null
          }
          function FE(t) {
            if (t.tag === w || t.tag === M) return t
            for (var Q = t.child; Q !== null; ) {
              if (Q.tag !== d) {
                var c = FE(Q)
                if (c !== null) return c
              }
              Q = Q.sibling
            }
            return null
          }
          var Cr = A.unstable_scheduleCallback,
            na = A.unstable_cancelCallback,
            ZB = A.unstable_shouldYield,
            qt = A.unstable_requestPaint,
            Hi = A.unstable_now,
            zr = A.unstable_getCurrentPriorityLevel,
            Zl = A.unstable_ImmediatePriority,
            Ea = A.unstable_UserBlockingPriority,
            No = A.unstable_NormalPriority,
            Pl = A.unstable_LowPriority,
            Hs = A.unstable_IdlePriority,
            er = A.unstable_yieldValue,
            Ts = A.unstable_setDisableYieldValue,
            Bi = null,
            Ti = null,
            fg = null,
            Ht = !1,
            lB = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u"
          function xs(t) {
            if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1
            var Q = __REACT_DEVTOOLS_GLOBAL_HOOK__
            if (Q.isDisabled) return !0
            if (!Q.supportsFiber)
              return (
                B(
                  "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools",
                ),
                !0
              )
            try {
              ;(dA &&
                (t = rg({}, t, {
                  getLaneLabelMap: rn,
                  injectProfilingHooks: uQ,
                })),
                (Bi = Q.inject(t)),
                (Ti = Q))
            } catch (c) {
              B("React instrumentation encountered an error: %s.", c)
            }
            return !!Q.checkDCE
          }
          function bs(t, Q) {
            if (Ti && typeof Ti.onScheduleFiberRoot == "function")
              try {
                Ti.onScheduleFiberRoot(Bi, t, Q)
              } catch (c) {
                Ht || ((Ht = !0), B("React instrumentation encountered an error: %s", c))
              }
          }
          function Bo(t, Q) {
            if (Ti && typeof Ti.onCommitFiberRoot == "function")
              try {
                var c = (t.current.flags & kC) === kC
                if (kA) {
                  var f
                  switch (Q) {
                    case Ut:
                      f = Zl
                      break
                    case LE:
                      f = Ea
                      break
                    case jn:
                      f = No
                      break
                    case $r:
                      f = Hs
                      break
                    default:
                      f = No
                      break
                  }
                  Ti.onCommitFiberRoot(Bi, t, f, c)
                }
              } catch (G) {
                Ht || ((Ht = !0), B("React instrumentation encountered an error: %s", G))
              }
          }
          function si(t) {
            if (Ti && typeof Ti.onPostCommitFiberRoot == "function")
              try {
                Ti.onPostCommitFiberRoot(Bi, t)
              } catch (Q) {
                Ht || ((Ht = !0), B("React instrumentation encountered an error: %s", Q))
              }
          }
          function wg(t) {
            if (Ti && typeof Ti.onCommitFiberUnmount == "function")
              try {
                Ti.onCommitFiberUnmount(Bi, t)
              } catch (Q) {
                Ht || ((Ht = !0), B("React instrumentation encountered an error: %s", Q))
              }
          }
          function Qi(t) {
            if (
              (typeof er == "function" && (Ts(t), C(t)),
              Ti && typeof Ti.setStrictMode == "function")
            )
              try {
                Ti.setStrictMode(Bi, t)
              } catch (Q) {
                Ht || ((Ht = !0), B("React instrumentation encountered an error: %s", Q))
              }
          }
          function uQ(t) {
            fg = t
          }
          function rn() {
            {
              for (var t = /* @__PURE__ */ new Map(), Q = 1, c = 0; c < DQ; c++) {
                var f = lu(Q)
                ;(t.set(Q, f), (Q *= 2))
              }
              return t
            }
          }
          function li(t) {
            fg !== null && typeof fg.markCommitStarted == "function" && fg.markCommitStarted(t)
          }
          function $C() {
            fg !== null && typeof fg.markCommitStopped == "function" && fg.markCommitStopped()
          }
          function xi(t) {
            fg !== null &&
              typeof fg.markComponentRenderStarted == "function" &&
              fg.markComponentRenderStarted(t)
          }
          function Ke() {
            fg !== null &&
              typeof fg.markComponentRenderStopped == "function" &&
              fg.markComponentRenderStopped()
          }
          function Ie(t) {
            fg !== null &&
              typeof fg.markComponentPassiveEffectMountStarted == "function" &&
              fg.markComponentPassiveEffectMountStarted(t)
          }
          function PB() {
            fg !== null &&
              typeof fg.markComponentPassiveEffectMountStopped == "function" &&
              fg.markComponentPassiveEffectMountStopped()
          }
          function ir(t) {
            fg !== null &&
              typeof fg.markComponentPassiveEffectUnmountStarted == "function" &&
              fg.markComponentPassiveEffectUnmountStarted(t)
          }
          function lt() {
            fg !== null &&
              typeof fg.markComponentPassiveEffectUnmountStopped == "function" &&
              fg.markComponentPassiveEffectUnmountStopped()
          }
          function tr(t) {
            fg !== null &&
              typeof fg.markComponentLayoutEffectMountStarted == "function" &&
              fg.markComponentLayoutEffectMountStarted(t)
          }
          function HQ() {
            fg !== null &&
              typeof fg.markComponentLayoutEffectMountStopped == "function" &&
              fg.markComponentLayoutEffectMountStopped()
          }
          function IB(t) {
            fg !== null &&
              typeof fg.markComponentLayoutEffectUnmountStarted == "function" &&
              fg.markComponentLayoutEffectUnmountStarted(t)
          }
          function aa() {
            fg !== null &&
              typeof fg.markComponentLayoutEffectUnmountStopped == "function" &&
              fg.markComponentLayoutEffectUnmountStopped()
          }
          function RE(t, Q, c) {
            fg !== null &&
              typeof fg.markComponentErrored == "function" &&
              fg.markComponentErrored(t, Q, c)
          }
          function Tt(t, Q, c) {
            fg !== null &&
              typeof fg.markComponentSuspended == "function" &&
              fg.markComponentSuspended(t, Q, c)
          }
          function Os(t) {
            fg !== null &&
              typeof fg.markLayoutEffectsStarted == "function" &&
              fg.markLayoutEffectsStarted(t)
          }
          function ra() {
            fg !== null &&
              typeof fg.markLayoutEffectsStopped == "function" &&
              fg.markLayoutEffectsStopped()
          }
          function Br(t) {
            fg !== null &&
              typeof fg.markPassiveEffectsStarted == "function" &&
              fg.markPassiveEffectsStarted(t)
          }
          function Qr() {
            fg !== null &&
              typeof fg.markPassiveEffectsStopped == "function" &&
              fg.markPassiveEffectsStopped()
          }
          function wi(t) {
            fg !== null && typeof fg.markRenderStarted == "function" && fg.markRenderStarted(t)
          }
          function sn() {
            fg !== null && typeof fg.markRenderYielded == "function" && fg.markRenderYielded()
          }
          function or() {
            fg !== null && typeof fg.markRenderStopped == "function" && fg.markRenderStopped()
          }
          function _n(t) {
            fg !== null && typeof fg.markRenderScheduled == "function" && fg.markRenderScheduled(t)
          }
          function nr(t, Q) {
            fg !== null &&
              typeof fg.markForceUpdateScheduled == "function" &&
              fg.markForceUpdateScheduled(t, Q)
          }
          function JE(t, Q) {
            fg !== null &&
              typeof fg.markStateUpdateScheduled == "function" &&
              fg.markStateUpdateScheduled(t, Q)
          }
          var zg =
              /*                         */
              0,
            Pg =
              /*                 */
              1,
            uC =
              /*                    */
              2,
            rC =
              /*               */
              8,
            xt =
              /*              */
              16,
            GB = Math.clz32 ? Math.clz32 : ci,
            Zn = Math.log,
            TQ = Math.LN2
          function ci(t) {
            var Q = t >>> 0
            return Q === 0 ? 32 : (31 - ((Zn(Q) / TQ) | 0)) | 0
          }
          var DQ = 31,
            Ag =
              /*                        */
              0,
            ct =
              /*                          */
              0,
            bg =
              /*                        */
              1,
            cB =
              /*    */
              2,
            SQ =
              /*             */
              4,
            bt =
              /*            */
              8,
            gB =
              /*                     */
              16,
            Er =
              /*                */
              32,
            sa =
              /*                       */
              4194240,
            la =
              /*                        */
              64,
            Pn =
              /*                        */
              128,
            Wl =
              /*                        */
              256,
            _s =
              /*                        */
              512,
            Xr =
              /*                        */
              1024,
            WB =
              /*                        */
              2048,
            kB =
              /*                        */
              4096,
            Vl =
              /*                        */
              8192,
            Fo =
              /*                        */
              16384,
            ht =
              /*                       */
              32768,
            Fe =
              /*                       */
              65536,
            xQ =
              /*                       */
              131072,
            fQ =
              /*                       */
              262144,
            jl =
              /*                       */
              524288,
            Wn =
              /*                       */
              1048576,
            KE =
              /*                       */
              2097152,
            ln =
              /*                            */
              130023424,
            cn =
              /*                             */
              4194304,
            CB =
              /*                             */
              8388608,
            Vn =
              /*                             */
              16777216,
            ar =
              /*                             */
              33554432,
            MB =
              /*                             */
              67108864,
            ca = cn,
            Ro =
              /*          */
              134217728,
            rr =
              /*                          */
              268435455,
            mE =
              /*               */
              268435456,
            Jo =
              /*                        */
              536870912,
            VB =
              /*                   */
              1073741824
          function lu(t) {
            {
              if (t & bg) return "Sync"
              if (t & cB) return "InputContinuousHydration"
              if (t & SQ) return "InputContinuous"
              if (t & bt) return "DefaultHydration"
              if (t & gB) return "Default"
              if (t & Er) return "TransitionHydration"
              if (t & sa) return "Transition"
              if (t & ln) return "Retry"
              if (t & Ro) return "SelectiveHydration"
              if (t & mE) return "IdleHydration"
              if (t & Jo) return "Idle"
              if (t & VB) return "Offscreen"
            }
          }
          var ue = -1,
            ha = la,
            eB = cn
          function Ko(t) {
            switch (kg(t)) {
              case bg:
                return bg
              case cB:
                return cB
              case SQ:
                return SQ
              case bt:
                return bt
              case gB:
                return gB
              case Er:
                return Er
              case la:
              case Pn:
              case Wl:
              case _s:
              case Xr:
              case WB:
              case kB:
              case Vl:
              case Fo:
              case ht:
              case Fe:
              case xQ:
              case fQ:
              case jl:
              case Wn:
              case KE:
                return t & sa
              case cn:
              case CB:
              case Vn:
              case ar:
              case MB:
                return t & ln
              case Ro:
                return Ro
              case mE:
                return mE
              case Jo:
                return Jo
              case VB:
                return VB
              default:
                return (B("Should have found matching lanes. This is a bug in React."), t)
            }
          }
          function mo(t, Q) {
            var c = t.pendingLanes
            if (c === Ag) return Ag
            var f = Ag,
              G = t.suspendedLanes,
              m = t.pingedLanes,
              x = c & rr
            if (x !== Ag) {
              var z = x & ~G
              if (z !== Ag) f = Ko(z)
              else {
                var gA = x & m
                gA !== Ag && (f = Ko(gA))
              }
            } else {
              var hA = c & ~G
              hA !== Ag ? (f = Ko(hA)) : m !== Ag && (f = Ko(m))
            }
            if (f === Ag) return Ag
            if (
              Q !== Ag &&
              Q !== f && // If we already suspended with a delay, then interrupting is fine. Don't
              // bother waiting until the root is complete.
              (Q & G) === Ag
            ) {
              var pA = kg(f),
                gI = kg(Q)
              if (
                // Tests whether the next lane is equal or lower priority than the wip
                // one. This works because the bits decrease in priority as you go left.
                pA >= gI || // Default priority updates should not interrupt transition updates. The
                // only difference between default updates and transition updates is that
                // default updates do not support refresh transitions.
                (pA === gB && (gI & sa) !== Ag)
              )
                return Q
            }
            ;(f & SQ) !== Ag && (f |= c & gB)
            var $A = t.entangledLanes
            if ($A !== Ag)
              for (var FI = t.entanglements, KI = f & $A; KI > 0; ) {
                var OI = Dt(KI),
                  Lg = 1 << OI
                ;((f |= FI[OI]), (KI &= ~Lg))
              }
            return f
          }
          function zl(t, Q) {
            for (var c = t.eventTimes, f = ue; Q > 0; ) {
              var G = Dt(Q),
                m = 1 << G,
                x = c[G]
              ;(x > f && (f = x), (Q &= ~m))
            }
            return f
          }
          function u(t, Q) {
            switch (t) {
              case bg:
              case cB:
              case SQ:
                return Q + 250
              case bt:
              case gB:
              case Er:
              case la:
              case Pn:
              case Wl:
              case _s:
              case Xr:
              case WB:
              case kB:
              case Vl:
              case Fo:
              case ht:
              case Fe:
              case xQ:
              case fQ:
              case jl:
              case Wn:
              case KE:
                return Q + 5e3
              case cn:
              case CB:
              case Vn:
              case ar:
              case MB:
                return ue
              case Ro:
              case mE:
              case Jo:
              case VB:
                return ue
              default:
                return (B("Should have found matching lanes. This is a bug in React."), ue)
            }
          }
          function D(t, Q) {
            for (
              var c = t.pendingLanes,
                f = t.suspendedLanes,
                G = t.pingedLanes,
                m = t.expirationTimes,
                x = c;
              x > 0;
            ) {
              var z = Dt(x),
                gA = 1 << z,
                hA = m[z]
              ;(hA === ue
                ? ((gA & f) === Ag || (gA & G) !== Ag) && (m[z] = u(gA, Q))
                : hA <= Q && (t.expiredLanes |= gA),
                (x &= ~gA))
            }
          }
          function N(t) {
            return Ko(t.pendingLanes)
          }
          function v(t) {
            var Q = t.pendingLanes & ~VB
            return Q !== Ag ? Q : Q & VB ? VB : Ag
          }
          function O(t) {
            return (t & bg) !== Ag
          }
          function IA(t) {
            return (t & rr) !== Ag
          }
          function UA(t) {
            return (t & ln) === t
          }
          function CI(t) {
            var Q = bg | SQ | gB
            return (t & Q) === Ag
          }
          function HI(t) {
            return (t & sa) === t
          }
          function ng(t, Q) {
            var c = cB | SQ | bt | gB
            return (Q & c) !== Ag
          }
          function Sg(t, Q) {
            return (Q & t.expiredLanes) !== Ag
          }
          function DC(t) {
            return (t & sa) !== Ag
          }
          function sC() {
            var t = ha
            return ((ha <<= 1), (ha & sa) === Ag && (ha = la), t)
          }
          function Be() {
            var t = eB
            return ((eB <<= 1), (eB & ln) === Ag && (eB = cn), t)
          }
          function kg(t) {
            return t & -t
          }
          function ut(t) {
            return kg(t)
          }
          function Dt(t) {
            return 31 - GB(t)
          }
          function yI(t) {
            return Dt(t)
          }
          function zA(t, Q) {
            return (t & Q) !== Ag
          }
          function JI(t, Q) {
            return (t & Q) === Q
          }
          function WI(t, Q) {
            return t | Q
          }
          function Zg(t, Q) {
            return t & ~Q
          }
          function WC(t, Q) {
            return t & Q
          }
          function SC(t) {
            return t
          }
          function Qe(t, Q) {
            return t !== ct && t < Q ? t : Q
          }
          function bi(t) {
            for (var Q = [], c = 0; c < DQ; c++) Q.push(t)
            return Q
          }
          function oe(t, Q, c) {
            ;((t.pendingLanes |= Q), Q !== Jo && ((t.suspendedLanes = Ag), (t.pingedLanes = Ag)))
            var f = t.eventTimes,
              G = yI(Q)
            f[G] = c
          }
          function vE(t, Q) {
            ;((t.suspendedLanes |= Q), (t.pingedLanes &= ~Q))
            for (var c = t.expirationTimes, f = Q; f > 0; ) {
              var G = Dt(f),
                m = 1 << G
              ;((c[G] = ue), (f &= ~m))
            }
          }
          function sr(t, Q, c) {
            t.pingedLanes |= t.suspendedLanes & Q
          }
          function cu(t, Q) {
            var c = t.pendingLanes & ~Q
            ;((t.pendingLanes = Q),
              (t.suspendedLanes = Ag),
              (t.pingedLanes = Ag),
              (t.expiredLanes &= Q),
              (t.mutableReadLanes &= Q),
              (t.entangledLanes &= Q))
            for (var f = t.entanglements, G = t.eventTimes, m = t.expirationTimes, x = c; x > 0; ) {
              var z = Dt(x),
                gA = 1 << z
              ;((f[z] = Ag), (G[z] = ue), (m[z] = ue), (x &= ~gA))
            }
          }
          function hu(t, Q) {
            for (var c = (t.entangledLanes |= Q), f = t.entanglements, G = c; G; ) {
              var m = Dt(G),
                x = 1 << m
              // Is this one of the newly entangled lanes?
              ;((x & Q) | // Is this lane transitively entangled with the newly entangled lanes?
                (f[m] & Q) && (f[m] |= Q),
                (G &= ~x))
            }
          }
          function jc(t, Q) {
            var c = kg(Q),
              f
            switch (c) {
              case SQ:
                f = cB
                break
              case gB:
                f = bt
                break
              case la:
              case Pn:
              case Wl:
              case _s:
              case Xr:
              case WB:
              case kB:
              case Vl:
              case Fo:
              case ht:
              case Fe:
              case xQ:
              case fQ:
              case jl:
              case Wn:
              case KE:
              case cn:
              case CB:
              case Vn:
              case ar:
              case MB:
                f = Er
                break
              case Jo:
                f = mE
                break
              default:
                f = ct
                break
            }
            return (f & (t.suspendedLanes | Q)) !== ct ? ct : f
          }
          function zc(t, Q, c) {
            if (lB)
              for (var f = t.pendingUpdatersLaneMap; c > 0; ) {
                var G = yI(c),
                  m = 1 << G,
                  x = f[G]
                ;(x.add(Q), (c &= ~m))
              }
          }
          function Xc(t, Q) {
            if (lB)
              for (var c = t.pendingUpdatersLaneMap, f = t.memoizedUpdaters; Q > 0; ) {
                var G = yI(Q),
                  m = 1 << G,
                  x = c[G]
                ;(x.size > 0 &&
                  (x.forEach(function (z) {
                    var gA = z.alternate
                    ;(gA === null || !f.has(gA)) && f.add(z)
                  }),
                  x.clear()),
                  (Q &= ~m))
              }
          }
          function Xl(t, Q) {
            return null
          }
          var Ut = bg,
            LE = SQ,
            jn = gB,
            $r = Jo,
            As = ct
          function hn() {
            return As
          }
          function gt(t) {
            As = t
          }
          function jB(t, Q) {
            var c = As
            try {
              return ((As = t), Q())
            } finally {
              As = c
            }
          }
          function qD(t, Q) {
            return t !== 0 && t < Q ? t : Q
          }
          function HD(t, Q) {
            return t > Q ? t : Q
          }
          function Zs(t, Q) {
            return t !== 0 && t < Q
          }
          function UB(t) {
            var Q = kg(t)
            return Zs(Ut, Q) ? (Zs(LE, Q) ? (IA(Q) ? jn : $r) : LE) : Ut
          }
          function $l(t) {
            var Q = t.current.memoizedState
            return Q.isDehydrated
          }
          var xg
          function Ac(t) {
            xg = t
          }
          function uu(t) {
            xg(t)
          }
          var $c
          function Jp(t) {
            $c = t
          }
          var Ps
          function Ic(t) {
            Ps = t
          }
          var Du
          function $f(t) {
            Du = t
          }
          var Is
          function Ws(t) {
            Is = t
          }
          var gs = !1,
            lr = [],
            me = null,
            Gi = null,
            iB = null,
            vo = /* @__PURE__ */ new Map(),
            Lo = /* @__PURE__ */ new Map(),
            zB = [],
            Ad = [
              "mousedown",
              "mouseup",
              "touchcancel",
              "touchend",
              "touchstart",
              "auxclick",
              "dblclick",
              "pointercancel",
              "pointerdown",
              "pointerup",
              "dragend",
              "dragstart",
              "drop",
              "compositionend",
              "compositionstart",
              "keydown",
              "keypress",
              "keyup",
              "input",
              "textInput",
              // Intentionally camelCase
              "copy",
              "cut",
              "paste",
              "click",
              "change",
              "contextmenu",
              "reset",
              "submit",
            ]
          function ua(t) {
            return Ad.indexOf(t) > -1
          }
          function Vs(t, Q, c, f, G) {
            return {
              blockedOn: t,
              domEventName: Q,
              eventSystemFlags: c,
              nativeEvent: G,
              targetContainers: [f],
            }
          }
          function Su(t, Q) {
            switch (t) {
              case "focusin":
              case "focusout":
                me = null
                break
              case "dragenter":
              case "dragleave":
                Gi = null
                break
              case "mouseover":
              case "mouseout":
                iB = null
                break
              case "pointerover":
              case "pointerout": {
                var c = Q.pointerId
                vo.delete(c)
                break
              }
              case "gotpointercapture":
              case "lostpointercapture": {
                var f = Q.pointerId
                Lo.delete(f)
                break
              }
            }
          }
          function Cs(t, Q, c, f, G, m) {
            if (t === null || t.nativeEvent !== m) {
              var x = Vs(Q, c, f, G, m)
              if (Q !== null) {
                var z = cc(Q)
                z !== null && $c(z)
              }
              return x
            }
            t.eventSystemFlags |= f
            var gA = t.targetContainers
            return (G !== null && gA.indexOf(G) === -1 && gA.push(G), t)
          }
          function Ah(t, Q, c, f, G) {
            switch (Q) {
              case "focusin": {
                var m = G
                return ((me = Cs(me, t, Q, c, f, m)), !0)
              }
              case "dragenter": {
                var x = G
                return ((Gi = Cs(Gi, t, Q, c, f, x)), !0)
              }
              case "mouseover": {
                var z = G
                return ((iB = Cs(iB, t, Q, c, f, z)), !0)
              }
              case "pointerover": {
                var gA = G,
                  hA = gA.pointerId
                return (vo.set(hA, Cs(vo.get(hA) || null, t, Q, c, f, gA)), !0)
              }
              case "gotpointercapture": {
                var pA = G,
                  gI = pA.pointerId
                return (Lo.set(gI, Cs(Lo.get(gI) || null, t, Q, c, f, pA)), !0)
              }
            }
            return !1
          }
          function TD(t) {
            var Q = yh(t.target)
            if (Q !== null) {
              var c = $t(Q)
              if (c !== null) {
                var f = c.tag
                if (f === V) {
                  var G = _l(c)
                  if (G !== null) {
                    ;((t.blockedOn = G),
                      Is(t.priority, function () {
                        Ps(c)
                      }))
                    return
                  }
                } else if (f === S) {
                  var m = c.stateNode
                  if ($l(m)) {
                    t.blockedOn = qs(c)
                    return
                  }
                }
              }
            }
            t.blockedOn = null
          }
          function xD(t) {
            for (
              var Q = Du(),
                c = {
                  blockedOn: null,
                  target: t,
                  priority: Q,
                },
                f = 0;
              f < zB.length && Zs(Q, zB[f].priority);
              f++
            );
            ;(zB.splice(f, 0, c), f === 0 && TD(c))
          }
          function js(t) {
            if (t.blockedOn !== null) return !1
            for (var Q = t.targetContainers; Q.length > 0; ) {
              var c = Q[0],
                f = dQ(t.domEventName, t.eventSystemFlags, c, t.nativeEvent)
              if (f === null) {
                var G = t.nativeEvent,
                  m = new G.constructor(G.type, G)
                ;(ea(m), G.target.dispatchEvent(m), xl())
              } else {
                var x = cc(f)
                return (x !== null && $c(x), (t.blockedOn = f), !1)
              }
              Q.shift()
            }
            return !0
          }
          function fu(t, Q, c) {
            js(t) && c.delete(Q)
          }
          function XB() {
            ;((gs = !1),
              me !== null && js(me) && (me = null),
              Gi !== null && js(Gi) && (Gi = null),
              iB !== null && js(iB) && (iB = null),
              vo.forEach(fu),
              Lo.forEach(fu))
          }
          function fC(t, Q) {
            t.blockedOn === Q &&
              ((t.blockedOn = null),
              gs || ((gs = !0), A.unstable_scheduleCallback(A.unstable_NormalPriority, XB)))
          }
          function Oe(t) {
            if (lr.length > 0) {
              fC(lr[0], t)
              for (var Q = 1; Q < lr.length; Q++) {
                var c = lr[Q]
                c.blockedOn === t && (c.blockedOn = null)
              }
            }
            ;(me !== null && fC(me, t), Gi !== null && fC(Gi, t), iB !== null && fC(iB, t))
            var f = function (z) {
              return fC(z, t)
            }
            ;(vo.forEach(f), Lo.forEach(f))
            for (var G = 0; G < zB.length; G++) {
              var m = zB[G]
              m.blockedOn === t && (m.blockedOn = null)
            }
            for (; zB.length > 0; ) {
              var x = zB[0]
              if (x.blockedOn !== null) break
              ;(TD(x), x.blockedOn === null && zB.shift())
            }
          }
          var ve = I.ReactCurrentBatchConfig,
            Ct = !0
          function tB(t) {
            Ct = !!t
          }
          function gc() {
            return Ct
          }
          function NB(t, Q, c) {
            var f = gh(Q),
              G
            switch (f) {
              case Ut:
                G = Ih
                break
              case LE:
                G = zs
                break
              case jn:
              default:
                G = Xs
                break
            }
            return G.bind(null, Q, c, t)
          }
          function Ih(t, Q, c, f) {
            var G = hn(),
              m = ve.transition
            ve.transition = null
            try {
              ;(gt(Ut), Xs(t, Q, c, f))
            } finally {
              ;(gt(G), (ve.transition = m))
            }
          }
          function zs(t, Q, c, f) {
            var G = hn(),
              m = ve.transition
            ve.transition = null
            try {
              ;(gt(LE), Xs(t, Q, c, f))
            } finally {
              ;(gt(G), (ve.transition = m))
            }
          }
          function Xs(t, Q, c, f) {
            Ct && du(t, Q, c, f)
          }
          function du(t, Q, c, f) {
            var G = dQ(t, Q, c, f)
            if (G === null) {
              ;(YC(t, Q, f, Da, c), Su(t, f))
              return
            }
            if (Ah(G, t, Q, c, f)) {
              f.stopPropagation()
              return
            }
            if ((Su(t, f), Q & sB && ua(t))) {
              for (; G !== null; ) {
                var m = cc(G)
                m !== null && uu(m)
                var x = dQ(t, Q, c, f)
                if ((x === null && YC(t, Q, f, Da, c), x === G)) break
                G = x
              }
              G !== null && f.stopPropagation()
              return
            }
            YC(t, Q, f, null, c)
          }
          var Da = null
          function dQ(t, Q, c, f) {
            Da = null
            var G = Cg(f),
              m = yh(G)
            if (m !== null) {
              var x = $t(m)
              if (x === null) m = null
              else {
                var z = x.tag
                if (z === V) {
                  var gA = _l(x)
                  if (gA !== null) return gA
                  m = null
                } else if (z === S) {
                  var hA = x.stateNode
                  if ($l(hA)) return qs(x)
                  m = null
                } else x !== m && (m = null)
              }
            }
            return ((Da = m), null)
          }
          function gh(t) {
            switch (t) {
              // Used by SimpleEventPlugin:
              case "cancel":
              case "click":
              case "close":
              case "contextmenu":
              case "copy":
              case "cut":
              case "auxclick":
              case "dblclick":
              case "dragend":
              case "dragstart":
              case "drop":
              case "focusin":
              case "focusout":
              case "input":
              case "invalid":
              case "keydown":
              case "keypress":
              case "keyup":
              case "mousedown":
              case "mouseup":
              case "paste":
              case "pause":
              case "play":
              case "pointercancel":
              case "pointerdown":
              case "pointerup":
              case "ratechange":
              case "reset":
              case "resize":
              case "seeked":
              case "submit":
              case "touchcancel":
              case "touchend":
              case "touchstart":
              case "volumechange":
              // Used by polyfills:
              // eslint-disable-next-line no-fallthrough
              case "change":
              case "selectionchange":
              case "textInput":
              case "compositionstart":
              case "compositionend":
              case "compositionupdate":
              // Only enableCreateEventHandleAPI:
              // eslint-disable-next-line no-fallthrough
              case "beforeblur":
              case "afterblur":
              // Not used by React but could be by user code:
              // eslint-disable-next-line no-fallthrough
              case "beforeinput":
              case "blur":
              case "fullscreenchange":
              case "focus":
              case "hashchange":
              case "popstate":
              case "select":
              case "selectstart":
                return Ut
              case "drag":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "mousemove":
              case "mouseout":
              case "mouseover":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "scroll":
              case "toggle":
              case "touchmove":
              case "wheel":
              // Not used by React but could be by user code:
              // eslint-disable-next-line no-fallthrough
              case "mouseenter":
              case "mouseleave":
              case "pointerenter":
              case "pointerleave":
                return LE
              case "message": {
                var Q = zr()
                switch (Q) {
                  case Zl:
                    return Ut
                  case Ea:
                    return LE
                  case No:
                  case Pl:
                    return jn
                  case Hs:
                    return $r
                  default:
                    return jn
                }
              }
              default:
                return jn
            }
          }
          function es(t, Q, c) {
            return (t.addEventListener(Q, c, !1), c)
          }
          function YE(t, Q, c) {
            return (t.addEventListener(Q, c, !0), c)
          }
          function Cc(t, Q, c, f) {
            return (
              t.addEventListener(Q, c, {
                capture: !0,
                passive: f,
              }),
              c
            )
          }
          function bD(t, Q, c, f) {
            return (
              t.addEventListener(Q, c, {
                passive: f,
              }),
              c
            )
          }
          var zn = null,
            ec = null,
            Xn = null
          function Ch(t) {
            return ((zn = t), (ec = ic()), !0)
          }
          function cr() {
            ;((zn = null), (ec = null), (Xn = null))
          }
          function yu() {
            if (Xn) return Xn
            var t,
              Q = ec,
              c = Q.length,
              f,
              G = ic(),
              m = G.length
            for (t = 0; t < c && Q[t] === G[t]; t++);
            var x = c - t
            for (f = 1; f <= x && Q[c - f] === G[m - f]; f++);
            var z = f > 1 ? 1 - f : void 0
            return ((Xn = G.slice(t, z)), Xn)
          }
          function ic() {
            return "value" in zn ? zn.value : zn.textContent
          }
          function $n(t) {
            var Q,
              c = t.keyCode
            return (
              "charCode" in t ? ((Q = t.charCode), Q === 0 && c === 13 && (Q = 13)) : (Q = c),
              Q === 10 && (Q = 13),
              Q >= 32 || Q === 13 ? Q : 0
            )
          }
          function FB() {
            return !0
          }
          function St() {
            return !1
          }
          function et(t) {
            function Q(c, f, G, m, x) {
              ;((this._reactName = c),
                (this._targetInst = G),
                (this.type = f),
                (this.nativeEvent = m),
                (this.target = x),
                (this.currentTarget = null))
              for (var z in t)
                if (t.hasOwnProperty(z)) {
                  var gA = t[z]
                  gA ? (this[z] = gA(m)) : (this[z] = m[z])
                }
              var hA = m.defaultPrevented != null ? m.defaultPrevented : m.returnValue === !1
              return (
                hA ? (this.isDefaultPrevented = FB) : (this.isDefaultPrevented = St),
                (this.isPropagationStopped = St),
                this
              )
            }
            return (
              rg(Q.prototype, {
                preventDefault: function () {
                  this.defaultPrevented = !0
                  var c = this.nativeEvent
                  c &&
                    (c.preventDefault
                      ? c.preventDefault()
                      : typeof c.returnValue != "unknown" && (c.returnValue = !1),
                    (this.isDefaultPrevented = FB))
                },
                stopPropagation: function () {
                  var c = this.nativeEvent
                  c &&
                    (c.stopPropagation
                      ? c.stopPropagation()
                      : typeof c.cancelBubble != "unknown" && (c.cancelBubble = !0),
                    (this.isPropagationStopped = FB))
                },
                /**
                 * We release all dispatched `SyntheticEvent`s after each event loop, adding
                 * them back into the pool. This allows a way to hold onto a reference that
                 * won't be added back into the pool.
                 */
                persist: function () {},
                /**
                 * Checks if this event should be released back into the pool.
                 *
                 * @return {boolean} True if this should not be released, false otherwise.
                 */
                isPersistent: FB,
              }),
              Q
            )
          }
          var BB = {
              eventPhase: 0,
              bubbles: 0,
              cancelable: 0,
              timeStamp: function (t) {
                return t.timeStamp || Date.now()
              },
              defaultPrevented: 0,
              isTrusted: 0,
            },
            tc = et(BB),
            hr = rg({}, BB, {
              view: 0,
              detail: 0,
            }),
            eh = et(hr),
            ih,
            qE,
            Sa
          function Bc(t) {
            t !== Sa &&
              (Sa && t.type === "mousemove"
                ? ((ih = t.screenX - Sa.screenX), (qE = t.screenY - Sa.screenY))
                : ((ih = 0), (qE = 0)),
              (Sa = t))
          }
          var un = rg({}, hr, {
              screenX: 0,
              screenY: 0,
              clientX: 0,
              clientY: 0,
              pageX: 0,
              pageY: 0,
              ctrlKey: 0,
              shiftKey: 0,
              altKey: 0,
              metaKey: 0,
              getModifierState: ZD,
              button: 0,
              buttons: 0,
              relatedTarget: function (t) {
                return t.relatedTarget === void 0
                  ? t.fromElement === t.srcElement
                    ? t.toElement
                    : t.fromElement
                  : t.relatedTarget
              },
              movementX: function (t) {
                return "movementX" in t ? t.movementX : (Bc(t), ih)
              },
              movementY: function (t) {
                return "movementY" in t ? t.movementY : qE
              },
            }),
            th = et(un),
            is = rg({}, un, {
              dataTransfer: 0,
            }),
            $s = et(is),
            OD = rg({}, hr, {
              relatedTarget: 0,
            }),
            Bh = et(OD),
            pu = rg({}, BB, {
              animationName: 0,
              elapsedTime: 0,
              pseudoElement: 0,
            }),
            Qh = et(pu),
            ts = rg({}, BB, {
              clipboardData: function (t) {
                return "clipboardData" in t ? t.clipboardData : window.clipboardData
              },
            }),
            Qc = et(ts),
            oh = rg({}, BB, {
              data: 0,
            }),
            HE = et(oh),
            _D = HE,
            Bs = {
              Esc: "Escape",
              Spacebar: " ",
              Left: "ArrowLeft",
              Up: "ArrowUp",
              Right: "ArrowRight",
              Down: "ArrowDown",
              Del: "Delete",
              Win: "OS",
              Menu: "ContextMenu",
              Apps: "ContextMenu",
              Scroll: "ScrollLock",
              MozPrintableKey: "Unidentified",
            },
            Al = {
              8: "Backspace",
              9: "Tab",
              12: "Clear",
              13: "Enter",
              16: "Shift",
              17: "Control",
              18: "Alt",
              19: "Pause",
              20: "CapsLock",
              27: "Escape",
              32: " ",
              33: "PageUp",
              34: "PageDown",
              35: "End",
              36: "Home",
              37: "ArrowLeft",
              38: "ArrowUp",
              39: "ArrowRight",
              40: "ArrowDown",
              45: "Insert",
              46: "Delete",
              112: "F1",
              113: "F2",
              114: "F3",
              115: "F4",
              116: "F5",
              117: "F6",
              118: "F7",
              119: "F8",
              120: "F9",
              121: "F10",
              122: "F11",
              123: "F12",
              144: "NumLock",
              145: "ScrollLock",
              224: "Meta",
            }
          function Pi(t) {
            if (t.key) {
              var Q = Bs[t.key] || t.key
              if (Q !== "Unidentified") return Q
            }
            if (t.type === "keypress") {
              var c = $n(t)
              return c === 13 ? "Enter" : String.fromCharCode(c)
            }
            return t.type === "keydown" || t.type === "keyup" ? Al[t.keyCode] || "Unidentified" : ""
          }
          var Id = {
            Alt: "altKey",
            Control: "ctrlKey",
            Meta: "metaKey",
            Shift: "shiftKey",
          }
          function wu(t) {
            var Q = this,
              c = Q.nativeEvent
            if (c.getModifierState) return c.getModifierState(t)
            var f = Id[t]
            return f ? !!c[f] : !1
          }
          function ZD(t) {
            return wu
          }
          var gd = rg({}, hr, {
              key: Pi,
              code: 0,
              location: 0,
              ctrlKey: 0,
              shiftKey: 0,
              altKey: 0,
              metaKey: 0,
              repeat: 0,
              locale: 0,
              getModifierState: ZD,
              // Legacy Interface
              charCode: function (t) {
                return t.type === "keypress" ? $n(t) : 0
              },
              keyCode: function (t) {
                return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0
              },
              which: function (t) {
                return t.type === "keypress"
                  ? $n(t)
                  : t.type === "keydown" || t.type === "keyup"
                    ? t.keyCode
                    : 0
              },
            }),
            PD = et(gd),
            oc = rg({}, un, {
              pointerId: 0,
              width: 0,
              height: 0,
              pressure: 0,
              tangentialPressure: 0,
              tiltX: 0,
              tiltY: 0,
              twist: 0,
              pointerType: 0,
              isPrimary: 0,
            }),
            AE = et(oc),
            Yo = rg({}, hr, {
              touches: 0,
              targetTouches: 0,
              changedTouches: 0,
              altKey: 0,
              metaKey: 0,
              ctrlKey: 0,
              shiftKey: 0,
              getModifierState: ZD,
            }),
            Qs = et(Yo),
            WD = rg({}, BB, {
              propertyName: 0,
              elapsedTime: 0,
              pseudoElement: 0,
            }),
            os = et(WD),
            TE = rg({}, un, {
              deltaX: function (t) {
                return "deltaX" in t
                  ? t.deltaX
                  : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
                    "wheelDeltaX" in t
                    ? -t.wheelDeltaX
                    : 0
              },
              deltaY: function (t) {
                return "deltaY" in t
                  ? t.deltaY
                  : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
                    "wheelDeltaY" in t
                    ? -t.wheelDeltaY
                    : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
                      "wheelDelta" in t
                      ? -t.wheelDelta
                      : 0
              },
              deltaZ: 0,
              // Browsers without "deltaMode" is reporting in raw wheel delta where one
              // notch on the scroll is always +/- 120, roughly equivalent to pixels.
              // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
              // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
              deltaMode: 0,
            }),
            IE = et(TE),
            Gu = [9, 13, 27, 32],
            Il = 229,
            qo = eI && "CompositionEvent" in window,
            Oi = null
          eI && "documentMode" in document && (Oi = document.documentMode)
          var fa = eI && "TextEvent" in window && !Oi,
            Ot = eI && (!qo || (Oi && Oi > 8 && Oi <= 11)),
            RB = 32,
            nh = String.fromCharCode(RB)
          function nc() {
            ;(cI("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]),
              cI("onCompositionEnd", [
                "compositionend",
                "focusout",
                "keydown",
                "keypress",
                "keyup",
                "mousedown",
              ]),
              cI("onCompositionStart", [
                "compositionstart",
                "focusout",
                "keydown",
                "keypress",
                "keyup",
                "mousedown",
              ]),
              cI("onCompositionUpdate", [
                "compositionupdate",
                "focusout",
                "keydown",
                "keypress",
                "keyup",
                "mousedown",
              ]))
          }
          var Eh = !1
          function Kg(t) {
            return (
              (t.ctrlKey || t.altKey || t.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
              !(t.ctrlKey && t.altKey)
            )
          }
          function bQ(t) {
            switch (t) {
              case "compositionstart":
                return "onCompositionStart"
              case "compositionend":
                return "onCompositionEnd"
              case "compositionupdate":
                return "onCompositionUpdate"
            }
          }
          function VD(t, Q) {
            return t === "keydown" && Q.keyCode === Il
          }
          function ns(t, Q) {
            switch (t) {
              case "keyup":
                return Gu.indexOf(Q.keyCode) !== -1
              case "keydown":
                return Q.keyCode !== Il
              case "keypress":
              case "mousedown":
              case "focusout":
                return !0
              default:
                return !1
            }
          }
          function ur(t) {
            var Q = t.detail
            return typeof Q == "object" && "data" in Q ? Q.data : null
          }
          function Ii(t) {
            return t.locale === "ko"
          }
          var Nt = !1
          function _t(t, Q, c, f, G) {
            var m, x
            if (
              (qo
                ? (m = bQ(Q))
                : Nt
                  ? ns(Q, f) && (m = "onCompositionEnd")
                  : VD(Q, f) && (m = "onCompositionStart"),
              !m)
            )
              return null
            Ot &&
              !Ii(f) &&
              (!Nt && m === "onCompositionStart"
                ? (Nt = Ch(G))
                : m === "onCompositionEnd" && Nt && (x = yu()))
            var z = Dh(c, m)
            if (z.length > 0) {
              var gA = new HE(m, Q, null, f, G)
              if (
                (t.push({
                  event: gA,
                  listeners: z,
                }),
                x)
              )
                gA.data = x
              else {
                var hA = ur(f)
                hA !== null && (gA.data = hA)
              }
            }
          }
          function ah(t, Q) {
            switch (t) {
              case "compositionend":
                return ur(Q)
              case "keypress":
                var c = Q.which
                return c !== RB ? null : ((Eh = !0), nh)
              case "textInput":
                var f = Q.data
                return f === nh && Eh ? null : f
              default:
                return null
            }
          }
          function rh(t, Q) {
            if (Nt) {
              if (t === "compositionend" || (!qo && ns(t, Q))) {
                var c = yu()
                return (cr(), (Nt = !1), c)
              }
              return null
            }
            switch (t) {
              case "paste":
                return null
              case "keypress":
                if (!Kg(Q)) {
                  if (Q.char && Q.char.length > 1) return Q.char
                  if (Q.which) return String.fromCharCode(Q.which)
                }
                return null
              case "compositionend":
                return Ot && !Ii(Q) ? null : Q.data
              default:
                return null
            }
          }
          function Es(t, Q, c, f, G) {
            var m
            if ((fa ? (m = ah(Q, f)) : (m = rh(Q, f)), !m)) return null
            var x = Dh(c, "onBeforeInput")
            if (x.length > 0) {
              var z = new _D("onBeforeInput", "beforeinput", null, f, G)
              ;(t.push({
                event: z,
                listeners: x,
              }),
                (z.data = m))
            }
          }
          function Kp(t, Q, c, f, G, m, x) {
            ;(_t(t, Q, c, f, G), Es(t, Q, c, f, G))
          }
          var sh = {
            color: !0,
            date: !0,
            datetime: !0,
            "datetime-local": !0,
            email: !0,
            month: !0,
            number: !0,
            password: !0,
            range: !0,
            search: !0,
            tel: !0,
            text: !0,
            time: !0,
            url: !0,
            week: !0,
          }
          function VI(t) {
            var Q = t && t.nodeName && t.nodeName.toLowerCase()
            return Q === "input" ? !!sh[t.type] : Q === "textarea"
          }
          /**
           * Checks if an event is supported in the current execution environment.
           *
           * NOTE: This will not work correctly for non-generic events such as `change`,
           * `reset`, `load`, `error`, and `select`.
           *
           * Borrows from Modernizr.
           *
           * @param {string} eventNameSuffix Event name, e.g. "click".
           * @return {boolean} True if the event is supported.
           * @internal
           * @license Modernizr 3.0.0pre (Custom Build) | MIT
           */
          function Qo(t) {
            if (!eI) return !1
            var Q = "on" + t,
              c = Q in document
            if (!c) {
              var f = document.createElement("div")
              ;(f.setAttribute(Q, "return;"), (c = typeof f[Q] == "function"))
            }
            return c
          }
          function E() {
            cI("onChange", [
              "change",
              "click",
              "focusin",
              "focusout",
              "input",
              "keydown",
              "keyup",
              "selectionchange",
            ])
          }
          function l(t, Q, c, f) {
            io(f)
            var G = Dh(Q, "onChange")
            if (G.length > 0) {
              var m = new tc("onChange", "change", null, c, f)
              t.push({
                event: m,
                listeners: G,
              })
            }
          }
          var p = null,
            U = null
          function q(t) {
            var Q = t.nodeName && t.nodeName.toLowerCase()
            return Q === "select" || (Q === "input" && t.type === "file")
          }
          function Z(t) {
            var Q = []
            ;(l(Q, U, t, Cg(t)), Wr(oA, Q))
          }
          function oA(t) {
            xp(t, 0)
          }
          function KA(t) {
            var Q = pQ(t)
            if (QQ(Q)) return t
          }
          function bA(t, Q) {
            if (t === "change") return Q
          }
          var kI = !1
          eI && (kI = Qo("input") && (!document.documentMode || document.documentMode > 9))
          function tg(t, Q) {
            ;((p = t), (U = Q), p.attachEvent("onpropertychange", Ig))
          }
          function Eg() {
            p && (p.detachEvent("onpropertychange", Ig), (p = null), (U = null))
          }
          function Ig(t) {
            t.propertyName === "value" && KA(U) && Z(t)
          }
          function Ug(t, Q, c) {
            t === "focusin" ? (Eg(), tg(Q, c)) : t === "focusout" && Eg()
          }
          function Wg(t, Q) {
            if (t === "selectionchange" || t === "keyup" || t === "keydown") return KA(U)
          }
          function Xg(t) {
            var Q = t.nodeName
            return Q && Q.toLowerCase() === "input" && (t.type === "checkbox" || t.type === "radio")
          }
          function Ft(t, Q) {
            if (t === "click") return KA(Q)
          }
          function lI(t, Q) {
            if (t === "input" || t === "change") return KA(Q)
          }
          function XA(t) {
            var Q = t._wrapperState
            !Q || !Q.controlled || t.type !== "number" || tC(t, "number", t.value)
          }
          function wI(t, Q, c, f, G, m, x) {
            var z = c ? pQ(c) : window,
              gA,
              hA
            if (
              (q(z)
                ? (gA = bA)
                : VI(z)
                  ? kI
                    ? (gA = lI)
                    : ((gA = Wg), (hA = Ug))
                  : Xg(z) && (gA = Ft),
              gA)
            ) {
              var pA = gA(Q, c)
              if (pA) {
                l(t, pA, f, G)
                return
              }
            }
            ;(hA && hA(Q, z, c), Q === "focusout" && XA(z))
          }
          function Dg() {
            ;(YA("onMouseEnter", ["mouseout", "mouseover"]),
              YA("onMouseLeave", ["mouseout", "mouseover"]),
              YA("onPointerEnter", ["pointerout", "pointerover"]),
              YA("onPointerLeave", ["pointerout", "pointerover"]))
          }
          function gC(t, Q, c, f, G, m, x) {
            var z = Q === "mouseover" || Q === "pointerover",
              gA = Q === "mouseout" || Q === "pointerout"
            if (z && !Pr(f)) {
              var hA = f.relatedTarget || f.fromElement
              if (hA && (yh(hA) || sS(hA))) return
            }
            if (!(!gA && !z)) {
              var pA
              if (G.window === G) pA = G
              else {
                var gI = G.ownerDocument
                gI ? (pA = gI.defaultView || gI.parentWindow) : (pA = window)
              }
              var $A, FI
              if (gA) {
                var KI = f.relatedTarget || f.toElement
                if ((($A = c), (FI = KI ? yh(KI) : null), FI !== null)) {
                  var OI = $t(FI)
                  ;(FI !== OI || (FI.tag !== w && FI.tag !== M)) && (FI = null)
                }
              } else (($A = null), (FI = c))
              if ($A !== FI) {
                var Lg = th,
                  yC = "onMouseLeave",
                  EC = "onMouseEnter",
                  We = "mouse"
                ;(Q === "pointerout" || Q === "pointerover") &&
                  ((Lg = AE), (yC = "onPointerLeave"), (EC = "onPointerEnter"), (We = "pointer"))
                var Le = $A == null ? pA : pQ($A),
                  fI = FI == null ? pA : pQ(FI),
                  _I = new Lg(yC, We + "leave", $A, f, G)
                ;((_I.target = Le), (_I.relatedTarget = fI))
                var dI = null,
                  sg = yh(G)
                if (sg === c) {
                  var _g = new Lg(EC, We + "enter", FI, f, G)
                  ;((_g.target = fI), (_g.relatedTarget = Le), (dI = _g))
                }
                Sd(t, _I, dI, $A, FI)
              }
            }
          }
          function lC(t, Q) {
            return (t === Q && (t !== 0 || 1 / t === 1 / Q)) || (t !== t && Q !== Q)
          }
          var Vg = typeof Object.is == "function" ? Object.is : lC
          function dC(t, Q) {
            if (Vg(t, Q)) return !0
            if (typeof t != "object" || t === null || typeof Q != "object" || Q === null) return !1
            var c = Object.keys(t),
              f = Object.keys(Q)
            if (c.length !== f.length) return !1
            for (var G = 0; G < c.length; G++) {
              var m = c[G]
              if (!uA.call(Q, m) || !Vg(t[m], Q[m])) return !1
            }
            return !0
          }
          function hB(t) {
            for (; t && t.firstChild; ) t = t.firstChild
            return t
          }
          function _e(t) {
            for (; t; ) {
              if (t.nextSibling) return t.nextSibling
              t = t.parentNode
            }
          }
          function da(t, Q) {
            for (var c = hB(t), f = 0, G = 0; c; ) {
              if (c.nodeType === Cn) {
                if (((G = f + c.textContent.length), f <= Q && G >= Q))
                  return {
                    node: c,
                    offset: Q - f,
                  }
                f = G
              }
              c = hB(_e(c))
            }
          }
          function lh(t) {
            var Q = t.ownerDocument,
              c = (Q && Q.defaultView) || window,
              f = c.getSelection && c.getSelection()
            if (!f || f.rangeCount === 0) return null
            var G = f.anchorNode,
              m = f.anchorOffset,
              x = f.focusNode,
              z = f.focusOffset
            try {
              ;(G.nodeType, x.nodeType)
            } catch {
              return null
            }
            return Cd(t, G, m, x, z)
          }
          function Cd(t, Q, c, f, G) {
            var m = 0,
              x = -1,
              z = -1,
              gA = 0,
              hA = 0,
              pA = t,
              gI = null
            A: for (;;) {
              for (
                var $A = null;
                pA === Q && (c === 0 || pA.nodeType === Cn) && (x = m + c),
                  pA === f && (G === 0 || pA.nodeType === Cn) && (z = m + G),
                  pA.nodeType === Cn && (m += pA.nodeValue.length),
                  ($A = pA.firstChild) !== null;
              )
                ((gI = pA), (pA = $A))
              for (;;) {
                if (pA === t) break A
                if (
                  (gI === Q && ++gA === c && (x = m),
                  gI === f && ++hA === G && (z = m),
                  ($A = pA.nextSibling) !== null)
                )
                  break
                ;((pA = gI), (gI = pA.parentNode))
              }
              pA = $A
            }
            return x === -1 || z === -1
              ? null
              : {
                  start: x,
                  end: z,
                }
          }
          function ed(t, Q) {
            var c = t.ownerDocument || document,
              f = (c && c.defaultView) || window
            if (f.getSelection) {
              var G = f.getSelection(),
                m = t.textContent.length,
                x = Math.min(Q.start, m),
                z = Q.end === void 0 ? x : Math.min(Q.end, m)
              if (!G.extend && x > z) {
                var gA = z
                ;((z = x), (x = gA))
              }
              var hA = da(t, x),
                pA = da(t, z)
              if (hA && pA) {
                if (
                  G.rangeCount === 1 &&
                  G.anchorNode === hA.node &&
                  G.anchorOffset === hA.offset &&
                  G.focusNode === pA.node &&
                  G.focusOffset === pA.offset
                )
                  return
                var gI = c.createRange()
                ;(gI.setStart(hA.node, hA.offset),
                  G.removeAllRanges(),
                  x > z
                    ? (G.addRange(gI), G.extend(pA.node, pA.offset))
                    : (gI.setEnd(pA.node, pA.offset), G.addRange(gI)))
              }
            }
          }
          function ku(t) {
            return t && t.nodeType === Cn
          }
          function id(t, Q) {
            return !t || !Q
              ? !1
              : t === Q
                ? !0
                : ku(t)
                  ? !1
                  : ku(Q)
                    ? id(t, Q.parentNode)
                    : "contains" in t
                      ? t.contains(Q)
                      : t.compareDocumentPosition
                        ? !!(t.compareDocumentPosition(Q) & 16)
                        : !1
          }
          function td(t) {
            return t && t.ownerDocument && id(t.ownerDocument.documentElement, t)
          }
          function jD(t) {
            try {
              return typeof t.contentWindow.location.href == "string"
            } catch {
              return !1
            }
          }
          function zD() {
            for (var t = window, Q = jt(); Q instanceof t.HTMLIFrameElement; ) {
              if (jD(Q)) t = Q.contentWindow
              else return Q
              Q = jt(t.document)
            }
            return Q
          }
          function ch(t) {
            var Q = t && t.nodeName && t.nodeName.toLowerCase()
            return (
              Q &&
              ((Q === "input" &&
                (t.type === "text" ||
                  t.type === "search" ||
                  t.type === "tel" ||
                  t.type === "url" ||
                  t.type === "password")) ||
                Q === "textarea" ||
                t.contentEditable === "true")
            )
          }
          function hh() {
            var t = zD()
            return {
              focusedElem: t,
              selectionRange: ch(t) ? Bd(t) : null,
            }
          }
          function mp(t) {
            var Q = zD(),
              c = t.focusedElem,
              f = t.selectionRange
            if (Q !== c && td(c)) {
              f !== null && ch(c) && vp(c, f)
              for (var G = [], m = c; (m = m.parentNode); )
                m.nodeType === nQ &&
                  G.push({
                    element: m,
                    left: m.scrollLeft,
                    top: m.scrollTop,
                  })
              typeof c.focus == "function" && c.focus()
              for (var x = 0; x < G.length; x++) {
                var z = G[x]
                ;((z.element.scrollLeft = z.left), (z.element.scrollTop = z.top))
              }
            }
          }
          function Bd(t) {
            var Q
            return (
              "selectionStart" in t
                ? (Q = {
                    start: t.selectionStart,
                    end: t.selectionEnd,
                  })
                : (Q = lh(t)),
              Q || {
                start: 0,
                end: 0,
              }
            )
          }
          function vp(t, Q) {
            var c = Q.start,
              f = Q.end
            ;(f === void 0 && (f = c),
              "selectionStart" in t
                ? ((t.selectionStart = c), (t.selectionEnd = Math.min(f, t.value.length)))
                : ed(t, Q))
          }
          var Qd = eI && "documentMode" in document && document.documentMode <= 11
          function _G() {
            cI("onSelect", [
              "focusout",
              "contextmenu",
              "dragend",
              "focusin",
              "keydown",
              "keyup",
              "mousedown",
              "mouseup",
              "selectionchange",
            ])
          }
          var Ec = null,
            Mu = null,
            XD = null,
            Uu = !1
          function Lp(t) {
            if ("selectionStart" in t && ch(t))
              return {
                start: t.selectionStart,
                end: t.selectionEnd,
              }
            var Q = (t.ownerDocument && t.ownerDocument.defaultView) || window,
              c = Q.getSelection()
            return {
              anchorNode: c.anchorNode,
              anchorOffset: c.anchorOffset,
              focusNode: c.focusNode,
              focusOffset: c.focusOffset,
            }
          }
          function od(t) {
            return t.window === t ? t.document : t.nodeType === Xi ? t : t.ownerDocument
          }
          function nd(t, Q, c) {
            var f = od(c)
            if (!(Uu || Ec == null || Ec !== jt(f))) {
              var G = Lp(Ec)
              if (!XD || !dC(XD, G)) {
                XD = G
                var m = Dh(Mu, "onSelect")
                if (m.length > 0) {
                  var x = new tc("onSelect", "select", null, Q, c)
                  ;(t.push({
                    event: x,
                    listeners: m,
                  }),
                    (x.target = Ec))
                }
              }
            }
          }
          function Ed(t, Q, c, f, G, m, x) {
            var z = c ? pQ(c) : window
            switch (Q) {
              // Track the input node that has focus.
              case "focusin":
                ;(VI(z) || z.contentEditable === "true") && ((Ec = z), (Mu = c), (XD = null))
                break
              case "focusout":
                ;((Ec = null), (Mu = null), (XD = null))
                break
              // Don't fire the event while the user is dragging. This matches the
              // semantics of the native select event.
              case "mousedown":
                Uu = !0
                break
              case "contextmenu":
              case "mouseup":
              case "dragend":
                ;((Uu = !1), nd(t, f, G))
                break
              // Chrome and IE fire non-standard event when selection is changed (and
              // sometimes when it hasn't). IE's event fires out of order with respect
              // to key and input events on deletion, so we discard it.
              //
              // Firefox doesn't support selectionchange, so check selection status
              // after each key entry. The selection changes after keydown and before
              // keyup, but we check on keydown as well in the case of holding down a
              // key, when multiple keydown events are fired but only one keyup is.
              // This is also our approach for IE handling, for the reason above.
              case "selectionchange":
                if (Qd) break
              // falls through
              case "keydown":
              case "keyup":
                nd(t, f, G)
            }
          }
          function Nu(t, Q) {
            var c = {}
            return (
              (c[t.toLowerCase()] = Q.toLowerCase()),
              (c["Webkit" + t] = "webkit" + Q),
              (c["Moz" + t] = "moz" + Q),
              c
            )
          }
          var uh = {
              animationend: Nu("Animation", "AnimationEnd"),
              animationiteration: Nu("Animation", "AnimationIteration"),
              animationstart: Nu("Animation", "AnimationStart"),
              transitionend: Nu("Transition", "TransitionEnd"),
            },
            ad = {},
            ZG = {}
          eI &&
            ((ZG = document.createElement("div").style),
            "AnimationEvent" in window ||
              (delete uh.animationend.animation,
              delete uh.animationiteration.animation,
              delete uh.animationstart.animation),
            "TransitionEvent" in window || delete uh.transitionend.transition)
          function Fu(t) {
            if (ad[t]) return ad[t]
            if (!uh[t]) return t
            var Q = uh[t]
            for (var c in Q) if (Q.hasOwnProperty(c) && c in ZG) return (ad[t] = Q[c])
            return t
          }
          var Yp = Fu("animationend"),
            qp = Fu("animationiteration"),
            Hp = Fu("animationstart"),
            PG = Fu("transitionend"),
            rd = /* @__PURE__ */ new Map(),
            $D = [
              "abort",
              "auxClick",
              "cancel",
              "canPlay",
              "canPlayThrough",
              "click",
              "close",
              "contextMenu",
              "copy",
              "cut",
              "drag",
              "dragEnd",
              "dragEnter",
              "dragExit",
              "dragLeave",
              "dragOver",
              "dragStart",
              "drop",
              "durationChange",
              "emptied",
              "encrypted",
              "ended",
              "error",
              "gotPointerCapture",
              "input",
              "invalid",
              "keyDown",
              "keyPress",
              "keyUp",
              "load",
              "loadedData",
              "loadedMetadata",
              "loadStart",
              "lostPointerCapture",
              "mouseDown",
              "mouseMove",
              "mouseOut",
              "mouseOver",
              "mouseUp",
              "paste",
              "pause",
              "play",
              "playing",
              "pointerCancel",
              "pointerDown",
              "pointerMove",
              "pointerOut",
              "pointerOver",
              "pointerUp",
              "progress",
              "rateChange",
              "reset",
              "resize",
              "seeked",
              "seeking",
              "stalled",
              "submit",
              "suspend",
              "timeUpdate",
              "touchCancel",
              "touchEnd",
              "touchStart",
              "volumeChange",
              "scroll",
              "toggle",
              "touchMove",
              "waiting",
              "wheel",
            ]
          function ac(t, Q) {
            ;(rd.set(t, Q), cI(Q, [t]))
          }
          function zF() {
            for (var t = 0; t < $D.length; t++) {
              var Q = $D[t],
                c = Q.toLowerCase(),
                f = Q[0].toUpperCase() + Q.slice(1)
              ac(c, "on" + f)
            }
            ;(ac(Yp, "onAnimationEnd"),
              ac(qp, "onAnimationIteration"),
              ac(Hp, "onAnimationStart"),
              ac("dblclick", "onDoubleClick"),
              ac("focusin", "onFocus"),
              ac("focusout", "onBlur"),
              ac(PG, "onTransitionEnd"))
          }
          function WG(t, Q, c, f, G, m, x) {
            var z = rd.get(Q)
            if (z !== void 0) {
              var gA = tc,
                hA = Q
              switch (Q) {
                case "keypress":
                  if ($n(f) === 0) return
                /* falls through */
                case "keydown":
                case "keyup":
                  gA = PD
                  break
                case "focusin":
                  ;((hA = "focus"), (gA = Bh))
                  break
                case "focusout":
                  ;((hA = "blur"), (gA = Bh))
                  break
                case "beforeblur":
                case "afterblur":
                  gA = Bh
                  break
                case "click":
                  if (f.button === 2) return
                /* falls through */
                case "auxclick":
                case "dblclick":
                case "mousedown":
                case "mousemove":
                case "mouseup":
                // TODO: Disabled elements should not respond to mouse events
                /* falls through */
                case "mouseout":
                case "mouseover":
                case "contextmenu":
                  gA = th
                  break
                case "drag":
                case "dragend":
                case "dragenter":
                case "dragexit":
                case "dragleave":
                case "dragover":
                case "dragstart":
                case "drop":
                  gA = $s
                  break
                case "touchcancel":
                case "touchend":
                case "touchmove":
                case "touchstart":
                  gA = Qs
                  break
                case Yp:
                case qp:
                case Hp:
                  gA = Qh
                  break
                case PG:
                  gA = os
                  break
                case "scroll":
                  gA = eh
                  break
                case "wheel":
                  gA = IE
                  break
                case "copy":
                case "cut":
                case "paste":
                  gA = Qc
                  break
                case "gotpointercapture":
                case "lostpointercapture":
                case "pointercancel":
                case "pointerdown":
                case "pointermove":
                case "pointerout":
                case "pointerover":
                case "pointerup":
                  gA = AE
                  break
              }
              var pA = (m & sB) !== 0
              {
                var gI =
                    !pA && // TODO: ideally, we'd eventually add all events from
                    // nonDelegatedEvents list in DOMPluginEventSystem.
                    // Then we can remove this special list.
                    // This is a breaking change that can wait until React 18.
                    Q === "scroll",
                  $A = zG(c, z, f.type, pA, gI)
                if ($A.length > 0) {
                  var FI = new gA(z, hA, null, f, G)
                  t.push({
                    event: FI,
                    listeners: $A,
                  })
                }
              }
            }
          }
          ;(zF(), Dg(), E(), _G(), nc())
          function VG(t, Q, c, f, G, m, x) {
            WG(t, Q, c, f, G, m)
            var z = (m & _r) === 0
            z && (gC(t, Q, c, f, G), wI(t, Q, c, f, G), Ed(t, Q, c, f, G), Kp(t, Q, c, f, G))
          }
          var Ru = [
              "abort",
              "canplay",
              "canplaythrough",
              "durationchange",
              "emptied",
              "encrypted",
              "ended",
              "error",
              "loadeddata",
              "loadedmetadata",
              "loadstart",
              "pause",
              "play",
              "playing",
              "progress",
              "ratechange",
              "resize",
              "seeked",
              "seeking",
              "stalled",
              "suspend",
              "timeupdate",
              "volumechange",
              "waiting",
            ],
            sd = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Ru))
          function Tp(t, Q, c) {
            var f = t.type || "unknown-event"
            ;((t.currentTarget = c), sQ(f, Q, void 0, t), (t.currentTarget = null))
          }
          function ld(t, Q, c) {
            var f
            if (c)
              for (var G = Q.length - 1; G >= 0; G--) {
                var m = Q[G],
                  x = m.instance,
                  z = m.currentTarget,
                  gA = m.listener
                if (x !== f && t.isPropagationStopped()) return
                ;(Tp(t, gA, z), (f = x))
              }
            else
              for (var hA = 0; hA < Q.length; hA++) {
                var pA = Q[hA],
                  gI = pA.instance,
                  $A = pA.currentTarget,
                  FI = pA.listener
                if (gI !== f && t.isPropagationStopped()) return
                ;(Tp(t, FI, $A), (f = gI))
              }
          }
          function xp(t, Q) {
            for (var c = (Q & sB) !== 0, f = 0; f < t.length; f++) {
              var G = t[f],
                m = G.event,
                x = G.listeners
              ld(m, x, c)
            }
            ta()
          }
          function jG(t, Q, c, f, G) {
            var m = Cg(c),
              x = []
            ;(VG(x, t, f, c, m, Q), xp(x, Q))
          }
          function ft(t, Q) {
            sd.has(t) ||
              B(
                'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
                t,
              )
            var c = !1,
              f = wR(Q),
              G = XG(t)
            f.has(G) || (AS(Q, t, qi, c), f.add(G))
          }
          function cd(t, Q, c) {
            sd.has(t) &&
              !Q &&
              B(
                'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
                t,
              )
            var f = 0
            ;(Q && (f |= sB), AS(c, t, f, Q))
          }
          var xE = "_reactListening" + Math.random().toString(36).slice(2)
          function Dn(t) {
            if (!t[xE]) {
              ;((t[xE] = !0),
                qA.forEach(function (c) {
                  c !== "selectionchange" && (sd.has(c) || cd(c, !1, t), cd(c, !0, t))
                }))
              var Q = t.nodeType === Xi ? t : t.ownerDocument
              Q !== null && (Q[xE] || ((Q[xE] = !0), cd("selectionchange", !1, Q)))
            }
          }
          function AS(t, Q, c, f, G) {
            var m = NB(t, Q, c),
              x = void 0
            ;($a && (Q === "touchstart" || Q === "touchmove" || Q === "wheel") && (x = !0),
              (t = t),
              f
                ? x !== void 0
                  ? Cc(t, Q, m, x)
                  : YE(t, Q, m)
                : x !== void 0
                  ? bD(t, Q, m, x)
                  : es(t, Q, m))
          }
          function hd(t, Q) {
            return t === Q || (t.nodeType === at && t.parentNode === Q)
          }
          function YC(t, Q, c, f, G) {
            var m = f
            if (!(Q & Ae) && !(Q & qi)) {
              var x = G
              if (f !== null) {
                var z = f
                A: for (;;) {
                  if (z === null) return
                  var gA = z.tag
                  if (gA === S || gA === d) {
                    var hA = z.stateNode.containerInfo
                    if (hd(hA, x)) break
                    if (gA === d)
                      for (var pA = z.return; pA !== null; ) {
                        var gI = pA.tag
                        if (gI === S || gI === d) {
                          var $A = pA.stateNode.containerInfo
                          if (hd($A, x)) return
                        }
                        pA = pA.return
                      }
                    for (; hA !== null; ) {
                      var FI = yh(hA)
                      if (FI === null) return
                      var KI = FI.tag
                      if (KI === w || KI === M) {
                        z = m = FI
                        continue A
                      }
                      hA = hA.parentNode
                    }
                  }
                  z = z.return
                }
              }
            }
            Wr(function () {
              return jG(t, Q, c, m)
            })
          }
          function ya(t, Q, c) {
            return {
              instance: t,
              listener: Q,
              currentTarget: c,
            }
          }
          function zG(t, Q, c, f, G, m) {
            for (
              var x = Q !== null ? Q + "Capture" : null, z = f ? x : Q, gA = [], hA = t, pA = null;
              hA !== null;
            ) {
              var gI = hA,
                $A = gI.stateNode,
                FI = gI.tag
              if (FI === w && $A !== null && ((pA = $A), z !== null)) {
                var KI = ME(hA, z)
                KI != null && gA.push(ya(hA, KI, pA))
              }
              if (G) break
              hA = hA.return
            }
            return gA
          }
          function Dh(t, Q) {
            for (var c = Q + "Capture", f = [], G = t; G !== null; ) {
              var m = G,
                x = m.stateNode,
                z = m.tag
              if (z === w && x !== null) {
                var gA = x,
                  hA = ME(G, c)
                hA != null && f.unshift(ya(G, hA, gA))
                var pA = ME(G, Q)
                pA != null && f.push(ya(G, pA, gA))
              }
              G = G.return
            }
            return f
          }
          function as(t) {
            if (t === null) return null
            do t = t.return
            while (t && t.tag !== w)
            return t || null
          }
          function ud(t, Q) {
            for (var c = t, f = Q, G = 0, m = c; m; m = as(m)) G++
            for (var x = 0, z = f; z; z = as(z)) x++
            for (; G - x > 0; ) ((c = as(c)), G--)
            for (; x - G > 0; ) ((f = as(f)), x--)
            for (var gA = G; gA--; ) {
              if (c === f || (f !== null && c === f.alternate)) return c
              ;((c = as(c)), (f = as(f)))
            }
            return null
          }
          function Dd(t, Q, c, f, G) {
            for (var m = Q._reactName, x = [], z = c; z !== null && z !== f; ) {
              var gA = z,
                hA = gA.alternate,
                pA = gA.stateNode,
                gI = gA.tag
              if (hA !== null && hA === f) break
              if (gI === w && pA !== null) {
                var $A = pA
                if (G) {
                  var FI = ME(z, m)
                  FI != null && x.unshift(ya(z, FI, $A))
                } else if (!G) {
                  var KI = ME(z, m)
                  KI != null && x.push(ya(z, KI, $A))
                }
              }
              z = z.return
            }
            x.length !== 0 &&
              t.push({
                event: Q,
                listeners: x,
              })
          }
          function Sd(t, Q, c, f, G) {
            var m = f && G ? ud(f, G) : null
            ;(f !== null && Dd(t, Q, f, m, !1), G !== null && c !== null && Dd(t, c, G, m, !0))
          }
          function XG(t, Q) {
            return t + "__bubble"
          }
          var gE = !1,
            IS = "dangerouslySetInnerHTML",
            fd = "suppressContentEditableWarning",
            gl = "suppressHydrationWarning",
            bp = "autoFocus",
            Cl = "children",
            rc = "style",
            Sh = "__html",
            CE,
            Ju,
            Ho,
            dd,
            Ku,
            gS,
            $G
          ;((CE = {
            // There are working polyfills for <dialog>. Let people use it.
            dialog: !0,
            // Electron ships a custom <webview> tag to display external web content in
            // an isolated frame and process.
            // This tag is not present in non Electron environments such as JSDom which
            // is often used for testing purposes.
            // @see https://electronjs.org/docs/api/webview-tag
            webview: !0,
          }),
            (Ju = function (t, Q) {
              ;(kE(t, Q),
                Go(t, Q),
                Ai(t, Q, {
                  registrationNameDependencies: ZA,
                  possibleRegistrationNames: sI,
                }))
            }),
            (gS = eI && !document.documentMode),
            (Ho = function (t, Q, c) {
              if (!gE) {
                var f = CS(c),
                  G = CS(Q)
                G !== f &&
                  ((gE = !0),
                  B(
                    "Prop `%s` did not match. Server: %s Client: %s",
                    t,
                    JSON.stringify(G),
                    JSON.stringify(f),
                  ))
              }
            }),
            (dd = function (t) {
              if (!gE) {
                gE = !0
                var Q = []
                ;(t.forEach(function (c) {
                  Q.push(c)
                }),
                  B("Extra attributes from the server: %s", Q))
              }
            }),
            (Ku = function (t, Q) {
              Q === !1
                ? B(
                    "Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",
                    t,
                    t,
                    t,
                  )
                : B(
                    "Expected `%s` listener to be a function, instead got a value of `%s` type.",
                    t,
                    typeof Q,
                  )
            }),
            ($G = function (t, Q) {
              var c =
                t.namespaceURI === yo
                  ? t.ownerDocument.createElement(t.tagName)
                  : t.ownerDocument.createElementNS(t.namespaceURI, t.tagName)
              return ((c.innerHTML = Q), c.innerHTML)
            }))
          var Op = /\r\n?/g,
            XF = /\u0000|\uFFFD/g
          function CS(t) {
            tA(t)
            var Q = typeof t == "string" ? t : "" + t
            return Q.replace(
              Op,
              `
`,
            ).replace(XF, "")
          }
          function mu(t, Q, c, f) {
            var G = CS(Q),
              m = CS(t)
            if (
              m !== G &&
              (f &&
                (gE ||
                  ((gE = !0), B('Text content did not match. Server: "%s" Client: "%s"', m, G))),
              c && LA)
            )
              throw new Error("Text content does not match server-rendered HTML.")
          }
          function _p(t) {
            return t.nodeType === Xi ? t : t.ownerDocument
          }
          function $F() {}
          function yd(t) {
            t.onclick = $F
          }
          function Ak(t, Q, c, f, G) {
            for (var m in f)
              if (f.hasOwnProperty(m)) {
                var x = f[m]
                if (m === rc) (x && Object.freeze(x), Fi(Q, x))
                else if (m === IS) {
                  var z = x ? x[Sh] : void 0
                  z != null && Aa(Q, z)
                } else if (m === Cl)
                  if (typeof x == "string") {
                    var gA = t !== "textarea" || x !== ""
                    gA && ri(Q, x)
                  } else typeof x == "number" && ri(Q, "" + x)
                else
                  m === fd ||
                    m === gl ||
                    m === bp ||
                    (ZA.hasOwnProperty(m)
                      ? x != null &&
                        (typeof x != "function" && Ku(m, x), m === "onScroll" && ft("scroll", Q))
                      : x != null && Ee(Q, m, x, G))
              }
          }
          function Ik(t, Q, c, f) {
            for (var G = 0; G < Q.length; G += 2) {
              var m = Q[G],
                x = Q[G + 1]
              m === rc ? Fi(t, x) : m === IS ? Aa(t, x) : m === Cl ? ri(t, x) : Ee(t, m, x, f)
            }
          }
          function AR(t, Q, c, f) {
            var G,
              m = _p(c),
              x,
              z = f
            if ((z === yo && (z = oQ(t)), z === yo)) {
              if (
                ((G = xe(t, Q)),
                !G &&
                  t !== t.toLowerCase() &&
                  B(
                    "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
                    t,
                  ),
                t === "script")
              ) {
                var gA = m.createElement("div")
                gA.innerHTML = "<script><\/script>"
                var hA = gA.firstChild
                x = gA.removeChild(hA)
              } else if (typeof Q.is == "string")
                x = m.createElement(t, {
                  is: Q.is,
                })
              else if (((x = m.createElement(t)), t === "select")) {
                var pA = x
                Q.multiple ? (pA.multiple = !0) : Q.size && (pA.size = Q.size)
              }
            } else x = m.createElementNS(z, t)
            return (
              z === yo &&
                !G &&
                Object.prototype.toString.call(x) === "[object HTMLUnknownElement]" &&
                !uA.call(CE, t) &&
                ((CE[t] = !0),
                B(
                  "The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",
                  t,
                )),
              x
            )
          }
          function IR(t, Q) {
            return _p(Q).createTextNode(t)
          }
          function rs(t, Q, c, f) {
            var G = xe(Q, c)
            Ju(Q, c)
            var m
            switch (Q) {
              case "dialog":
                ;(ft("cancel", t), ft("close", t), (m = c))
                break
              case "iframe":
              case "object":
              case "embed":
                ;(ft("load", t), (m = c))
                break
              case "video":
              case "audio":
                for (var x = 0; x < Ru.length; x++) ft(Ru[x], t)
                m = c
                break
              case "source":
                ;(ft("error", t), (m = c))
                break
              case "img":
              case "image":
              case "link":
                ;(ft("error", t), ft("load", t), (m = c))
                break
              case "details":
                ;(ft("toggle", t), (m = c))
                break
              case "input":
                ;(vA(t, c), (m = iA(t, c)), ft("invalid", t))
                break
              case "option":
                ;(GC(t, c), (m = c))
                break
              case "select":
                ;(br(t, c), (m = XE(t, c)), ft("invalid", t))
                break
              case "textarea":
                ;(Pc(t, c), (m = vl(t, c)), ft("invalid", t))
                break
              default:
                m = c
            }
            switch ((he(Q, m), Ak(Q, t, f, m, G), Q)) {
              case "input":
                ;(Ni(t), ig(t, c, !1))
                break
              case "textarea":
                ;(Ni(t), Ta(t))
                break
              case "option":
                ie(t, c)
                break
              case "select":
                Rl(t, c)
                break
              default:
                typeof m.onClick == "function" && yd(t)
                break
            }
          }
          function gk(t, Q, c, f, G) {
            Ju(Q, f)
            var m = null,
              x,
              z
            switch (Q) {
              case "input":
                ;((x = iA(t, c)), (z = iA(t, f)), (m = []))
                break
              case "select":
                ;((x = XE(t, c)), (z = XE(t, f)), (m = []))
                break
              case "textarea":
                ;((x = vl(t, c)), (z = vl(t, f)), (m = []))
                break
              default:
                ;((x = c),
                  (z = f),
                  typeof x.onClick != "function" && typeof z.onClick == "function" && yd(t))
                break
            }
            he(Q, z)
            var gA,
              hA,
              pA = null
            for (gA in x)
              if (!(z.hasOwnProperty(gA) || !x.hasOwnProperty(gA) || x[gA] == null))
                if (gA === rc) {
                  var gI = x[gA]
                  for (hA in gI) gI.hasOwnProperty(hA) && (pA || (pA = {}), (pA[hA] = ""))
                } else
                  gA === IS ||
                    gA === Cl ||
                    gA === fd ||
                    gA === gl ||
                    gA === bp ||
                    (ZA.hasOwnProperty(gA) ? m || (m = []) : (m = m || []).push(gA, null))
            for (gA in z) {
              var $A = z[gA],
                FI = x?.[gA]
              if (!(!z.hasOwnProperty(gA) || $A === FI || ($A == null && FI == null)))
                if (gA === rc)
                  if (($A && Object.freeze($A), FI)) {
                    for (hA in FI)
                      FI.hasOwnProperty(hA) &&
                        (!$A || !$A.hasOwnProperty(hA)) &&
                        (pA || (pA = {}), (pA[hA] = ""))
                    for (hA in $A)
                      $A.hasOwnProperty(hA) &&
                        FI[hA] !== $A[hA] &&
                        (pA || (pA = {}), (pA[hA] = $A[hA]))
                  } else (pA || (m || (m = []), m.push(gA, pA)), (pA = $A))
                else if (gA === IS) {
                  var KI = $A ? $A[Sh] : void 0,
                    OI = FI ? FI[Sh] : void 0
                  KI != null && OI !== KI && (m = m || []).push(gA, KI)
                } else
                  gA === Cl
                    ? (typeof $A == "string" || typeof $A == "number") &&
                      (m = m || []).push(gA, "" + $A)
                    : gA === fd ||
                      gA === gl ||
                      (ZA.hasOwnProperty(gA)
                        ? ($A != null &&
                            (typeof $A != "function" && Ku(gA, $A),
                            gA === "onScroll" && ft("scroll", t)),
                          !m && FI !== $A && (m = []))
                        : (m = m || []).push(gA, $A))
            }
            return (pA && (vQ(pA, z[rc]), (m = m || []).push(rc, pA)), m)
          }
          function Ck(t, Q, c, f, G) {
            c === "input" && G.type === "radio" && G.name != null && rI(t, G)
            var m = xe(c, f),
              x = xe(c, G)
            switch ((Ik(t, Q, m, x), c)) {
              case "input":
                mI(t, G)
                break
              case "textarea":
                Ll(t, G)
                break
              case "select":
                Jl(t, G)
                break
            }
          }
          function eS(t) {
            {
              var Q = t.toLowerCase()
              return ($e.hasOwnProperty(Q) && $e[Q]) || null
            }
          }
          function iS(t, Q, c, f, G, m, x) {
            var z, gA
            switch (((z = xe(Q, c)), Ju(Q, c), Q)) {
              case "dialog":
                ;(ft("cancel", t), ft("close", t))
                break
              case "iframe":
              case "object":
              case "embed":
                ft("load", t)
                break
              case "video":
              case "audio":
                for (var hA = 0; hA < Ru.length; hA++) ft(Ru[hA], t)
                break
              case "source":
                ft("error", t)
                break
              case "img":
              case "image":
              case "link":
                ;(ft("error", t), ft("load", t))
                break
              case "details":
                ft("toggle", t)
                break
              case "input":
                ;(vA(t, c), ft("invalid", t))
                break
              case "option":
                GC(t, c)
                break
              case "select":
                ;(br(t, c), ft("invalid", t))
                break
              case "textarea":
                ;(Pc(t, c), ft("invalid", t))
                break
            }
            he(Q, c)
            {
              gA = /* @__PURE__ */ new Set()
              for (var pA = t.attributes, gI = 0; gI < pA.length; gI++) {
                var $A = pA[gI].name.toLowerCase()
                switch ($A) {
                  // Controlled attributes are not validated
                  // TODO: Only ignore them on controlled tags.
                  case "value":
                    break
                  case "checked":
                    break
                  case "selected":
                    break
                  default:
                    gA.add(pA[gI].name)
                }
              }
            }
            var FI = null
            for (var KI in c)
              if (c.hasOwnProperty(KI)) {
                var OI = c[KI]
                if (KI === Cl)
                  typeof OI == "string"
                    ? t.textContent !== OI &&
                      (c[gl] !== !0 && mu(t.textContent, OI, m, x), (FI = [Cl, OI]))
                    : typeof OI == "number" &&
                      t.textContent !== "" + OI &&
                      (c[gl] !== !0 && mu(t.textContent, OI, m, x), (FI = [Cl, "" + OI]))
                else if (ZA.hasOwnProperty(KI))
                  OI != null &&
                    (typeof OI != "function" && Ku(KI, OI), KI === "onScroll" && ft("scroll", t))
                else if (
                  x && // Convince Flow we've calculated it (it's DEV-only in this method.)
                  typeof z == "boolean"
                ) {
                  var Lg = void 0,
                    yC = z && GA ? null : NI(KI)
                  if (c[gl] !== !0) {
                    if (
                      !(
                        KI === fd ||
                        KI === gl || // Controlled attributes are not validated
                        // TODO: Only ignore them on controlled tags.
                        KI === "value" ||
                        KI === "checked" ||
                        KI === "selected"
                      )
                    ) {
                      if (KI === IS) {
                        var EC = t.innerHTML,
                          We = OI ? OI[Sh] : void 0
                        if (We != null) {
                          var Le = $G(t, We)
                          Le !== EC && Ho(KI, EC, Le)
                        }
                      } else if (KI === rc) {
                        if ((gA.delete(KI), gS)) {
                          var fI = go(OI)
                          ;((Lg = t.getAttribute("style")), fI !== Lg && Ho(KI, Lg, fI))
                        }
                      } else if (z && !GA)
                        (gA.delete(KI.toLowerCase()),
                          (Lg = zC(t, KI, OI)),
                          OI !== Lg && Ho(KI, Lg, OI))
                      else if (!XI(KI, yC, z) && !SA(KI, OI, yC, z)) {
                        var _I = !1
                        if (yC !== null) (gA.delete(yC.attributeName), (Lg = mC(t, KI, OI, yC)))
                        else {
                          var dI = f
                          if ((dI === yo && (dI = oQ(Q)), dI === yo)) gA.delete(KI.toLowerCase())
                          else {
                            var sg = eS(KI)
                            ;(sg !== null && sg !== KI && ((_I = !0), gA.delete(sg)), gA.delete(KI))
                          }
                          Lg = zC(t, KI, OI)
                        }
                        var _g = GA
                        !_g && OI !== Lg && !_I && Ho(KI, Lg, OI)
                      }
                    }
                  }
                }
              }
            switch (
              (x && // $FlowFixMe - Should be inferred as not undefined.
                gA.size > 0 &&
                c[gl] !== !0 &&
                dd(gA),
              Q)
            ) {
              case "input":
                ;(Ni(t), ig(t, c, !0))
                break
              case "textarea":
                ;(Ni(t), Ta(t))
                break
              case "select":
              case "option":
                break
              default:
                typeof c.onClick == "function" && yd(t)
                break
            }
            return FI
          }
          function pd(t, Q, c) {
            var f = t.nodeValue !== Q
            return f
          }
          function vu(t, Q) {
            {
              if (gE) return
              ;((gE = !0),
                B(
                  "Did not expect server HTML to contain a <%s> in <%s>.",
                  Q.nodeName.toLowerCase(),
                  t.nodeName.toLowerCase(),
                ))
            }
          }
          function wd(t, Q) {
            {
              if (gE) return
              ;((gE = !0),
                B(
                  'Did not expect server HTML to contain the text node "%s" in <%s>.',
                  Q.nodeValue,
                  t.nodeName.toLowerCase(),
                ))
            }
          }
          function fh(t, Q, c) {
            {
              if (gE) return
              ;((gE = !0),
                B(
                  "Expected server HTML to contain a matching <%s> in <%s>.",
                  Q,
                  t.nodeName.toLowerCase(),
                ))
            }
          }
          function yQ(t, Q) {
            {
              if (Q === "" || gE) return
              ;((gE = !0),
                B(
                  'Expected server HTML to contain a matching text node for "%s" in <%s>.',
                  Q,
                  t.nodeName.toLowerCase(),
                ))
            }
          }
          function ek(t, Q, c) {
            switch (Q) {
              case "input":
                AC(t, c)
                return
              case "textarea":
                $E(t, c)
                return
              case "select":
                Kl(t, c)
                return
            }
          }
          var el = function () {},
            Sn = function () {}
          {
            var Zp = [
                "address",
                "applet",
                "area",
                "article",
                "aside",
                "base",
                "basefont",
                "bgsound",
                "blockquote",
                "body",
                "br",
                "button",
                "caption",
                "center",
                "col",
                "colgroup",
                "dd",
                "details",
                "dir",
                "div",
                "dl",
                "dt",
                "embed",
                "fieldset",
                "figcaption",
                "figure",
                "footer",
                "form",
                "frame",
                "frameset",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "head",
                "header",
                "hgroup",
                "hr",
                "html",
                "iframe",
                "img",
                "input",
                "isindex",
                "li",
                "link",
                "listing",
                "main",
                "marquee",
                "menu",
                "menuitem",
                "meta",
                "nav",
                "noembed",
                "noframes",
                "noscript",
                "object",
                "ol",
                "p",
                "param",
                "plaintext",
                "pre",
                "script",
                "section",
                "select",
                "source",
                "style",
                "summary",
                "table",
                "tbody",
                "td",
                "template",
                "textarea",
                "tfoot",
                "th",
                "thead",
                "title",
                "tr",
                "track",
                "ul",
                "wbr",
                "xmp",
              ],
              Lu = [
                "applet",
                "caption",
                "html",
                "table",
                "td",
                "th",
                "marquee",
                "object",
                "template",
                // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
                // TODO: Distinguish by namespace here -- for <title>, including it here
                // errs on the side of fewer warnings
                "foreignObject",
                "desc",
                "title",
              ],
              Pp = Lu.concat(["button"]),
              Wp = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"],
              Gd = {
                current: null,
                formTag: null,
                aTagInScope: null,
                buttonTagInScope: null,
                nobrTagInScope: null,
                pTagInButtonScope: null,
                listItemTagAutoclosing: null,
                dlItemTagAutoclosing: null,
              }
            Sn = function (t, Q) {
              var c = rg({}, t || Gd),
                f = {
                  tag: Q,
                }
              return (
                Lu.indexOf(Q) !== -1 &&
                  ((c.aTagInScope = null), (c.buttonTagInScope = null), (c.nobrTagInScope = null)),
                Pp.indexOf(Q) !== -1 && (c.pTagInButtonScope = null),
                Zp.indexOf(Q) !== -1 &&
                  Q !== "address" &&
                  Q !== "div" &&
                  Q !== "p" &&
                  ((c.listItemTagAutoclosing = null), (c.dlItemTagAutoclosing = null)),
                (c.current = f),
                Q === "form" && (c.formTag = f),
                Q === "a" && (c.aTagInScope = f),
                Q === "button" && (c.buttonTagInScope = f),
                Q === "nobr" && (c.nobrTagInScope = f),
                Q === "p" && (c.pTagInButtonScope = f),
                Q === "li" && (c.listItemTagAutoclosing = f),
                (Q === "dd" || Q === "dt") && (c.dlItemTagAutoclosing = f),
                c
              )
            }
            var dh = function (t, Q) {
                switch (Q) {
                  // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
                  case "select":
                    return t === "option" || t === "optgroup" || t === "#text"
                  case "optgroup":
                    return t === "option" || t === "#text"
                  // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
                  // but
                  case "option":
                    return t === "#text"
                  // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
                  // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
                  // No special behavior since these rules fall back to "in body" mode for
                  // all except special table nodes which cause bad parsing behavior anyway.
                  // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
                  case "tr":
                    return (
                      t === "th" ||
                      t === "td" ||
                      t === "style" ||
                      t === "script" ||
                      t === "template"
                    )
                  // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
                  case "tbody":
                  case "thead":
                  case "tfoot":
                    return t === "tr" || t === "style" || t === "script" || t === "template"
                  // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
                  case "colgroup":
                    return t === "col" || t === "template"
                  // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
                  case "table":
                    return (
                      t === "caption" ||
                      t === "colgroup" ||
                      t === "tbody" ||
                      t === "tfoot" ||
                      t === "thead" ||
                      t === "style" ||
                      t === "script" ||
                      t === "template"
                    )
                  // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
                  case "head":
                    return (
                      t === "base" ||
                      t === "basefont" ||
                      t === "bgsound" ||
                      t === "link" ||
                      t === "meta" ||
                      t === "title" ||
                      t === "noscript" ||
                      t === "noframes" ||
                      t === "style" ||
                      t === "script" ||
                      t === "template"
                    )
                  // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
                  case "html":
                    return t === "head" || t === "body" || t === "frameset"
                  case "frameset":
                    return t === "frame"
                  case "#document":
                    return t === "html"
                }
                switch (t) {
                  case "h1":
                  case "h2":
                  case "h3":
                  case "h4":
                  case "h5":
                  case "h6":
                    return (
                      Q !== "h1" &&
                      Q !== "h2" &&
                      Q !== "h3" &&
                      Q !== "h4" &&
                      Q !== "h5" &&
                      Q !== "h6"
                    )
                  case "rp":
                  case "rt":
                    return Wp.indexOf(Q) === -1
                  case "body":
                  case "caption":
                  case "col":
                  case "colgroup":
                  case "frameset":
                  case "frame":
                  case "head":
                  case "html":
                  case "tbody":
                  case "td":
                  case "tfoot":
                  case "th":
                  case "thead":
                  case "tr":
                    return Q == null
                }
                return !0
              },
              Vp = function (t, Q) {
                switch (t) {
                  case "address":
                  case "article":
                  case "aside":
                  case "blockquote":
                  case "center":
                  case "details":
                  case "dialog":
                  case "dir":
                  case "div":
                  case "dl":
                  case "fieldset":
                  case "figcaption":
                  case "figure":
                  case "footer":
                  case "header":
                  case "hgroup":
                  case "main":
                  case "menu":
                  case "nav":
                  case "ol":
                  case "p":
                  case "section":
                  case "summary":
                  case "ul":
                  case "pre":
                  case "listing":
                  case "table":
                  case "hr":
                  case "xmp":
                  case "h1":
                  case "h2":
                  case "h3":
                  case "h4":
                  case "h5":
                  case "h6":
                    return Q.pTagInButtonScope
                  case "form":
                    return Q.formTag || Q.pTagInButtonScope
                  case "li":
                    return Q.listItemTagAutoclosing
                  case "dd":
                  case "dt":
                    return Q.dlItemTagAutoclosing
                  case "button":
                    return Q.buttonTagInScope
                  case "a":
                    return Q.aTagInScope
                  case "nobr":
                    return Q.nobrTagInScope
                }
                return null
              },
              tS = {}
            el = function (t, Q, c) {
              c = c || Gd
              var f = c.current,
                G = f && f.tag
              Q != null &&
                (t != null &&
                  B("validateDOMNesting: when childText is passed, childTag should be null"),
                (t = "#text"))
              var m = dh(t, G) ? null : f,
                x = m ? null : Vp(t, c),
                z = m || x
              if (z) {
                var gA = z.tag,
                  hA = !!m + "|" + t + "|" + gA
                if (!tS[hA]) {
                  tS[hA] = !0
                  var pA = t,
                    gI = ""
                  if (
                    (t === "#text"
                      ? /\S/.test(Q)
                        ? (pA = "Text nodes")
                        : ((pA = "Whitespace text nodes"),
                          (gI =
                            " Make sure you don't have any extra whitespace between tags on each line of your source code."))
                      : (pA = "<" + t + ">"),
                    m)
                  ) {
                    var $A = ""
                    ;(gA === "table" &&
                      t === "tr" &&
                      ($A +=
                        " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."),
                      B(
                        "validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s",
                        pA,
                        gA,
                        gI,
                        $A,
                      ))
                  } else
                    B("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", pA, gA)
                }
              }
            }
          }
          var OQ = "suppressHydrationWarning",
            kd = "$",
            BS = "/$",
            Yu = "$?",
            qu = "$!",
            ik = "style",
            jp = null,
            zp = null
          function gR(t) {
            var Q,
              c,
              f = t.nodeType
            switch (f) {
              case Xi:
              case $i: {
                Q = f === Xi ? "#document" : "#fragment"
                var G = t.documentElement
                c = G ? G.namespaceURI : fE(null, "")
                break
              }
              default: {
                var m = f === at ? t.parentNode : t,
                  x = m.namespaceURI || null
                ;((Q = m.tagName), (c = fE(x, Q)))
                break
              }
            }
            {
              var z = Q.toLowerCase(),
                gA = Sn(null, z)
              return {
                namespace: c,
                ancestorInfo: gA,
              }
            }
          }
          function tk(t, Q, c) {
            {
              var f = t,
                G = fE(f.namespace, Q),
                m = Sn(f.ancestorInfo, Q)
              return {
                namespace: G,
                ancestorInfo: m,
              }
            }
          }
          function Bk(t) {
            return t
          }
          function Qk(t) {
            ;((jp = gc()), (zp = hh()))
            var Q = null
            return (tB(!1), Q)
          }
          function Xp(t) {
            ;(mp(zp), tB(jp), (jp = null), (zp = null))
          }
          function ok(t, Q, c, f, G) {
            var m
            {
              var x = f
              if (
                (el(t, null, x.ancestorInfo),
                typeof Q.children == "string" || typeof Q.children == "number")
              ) {
                var z = "" + Q.children,
                  gA = Sn(x.ancestorInfo, t)
                el(null, z, gA)
              }
              m = x.namespace
            }
            var hA = AR(t, Q, c, m)
            return (lc(G, hA), Ew(hA, Q), hA)
          }
          function CR(t, Q) {
            t.appendChild(Q)
          }
          function nk(t, Q, c, f, G) {
            switch ((rs(t, Q, c, f), Q)) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                return !!c.autoFocus
              case "img":
                return !0
              default:
                return !1
            }
          }
          function eR(t, Q, c, f, G, m) {
            {
              var x = m
              if (
                typeof f.children != typeof c.children &&
                (typeof f.children == "string" || typeof f.children == "number")
              ) {
                var z = "" + f.children,
                  gA = Sn(x.ancestorInfo, Q)
                el(null, z, gA)
              }
            }
            return gk(t, Q, c, f)
          }
          function $p(t, Q) {
            return (
              t === "textarea" ||
              t === "noscript" ||
              typeof Q.children == "string" ||
              typeof Q.children == "number" ||
              (typeof Q.dangerouslySetInnerHTML == "object" &&
                Q.dangerouslySetInnerHTML !== null &&
                Q.dangerouslySetInnerHTML.__html != null)
            )
          }
          function iR(t, Q, c, f) {
            {
              var G = c
              el(null, t, G.ancestorInfo)
            }
            var m = IR(t, Q)
            return (lc(f, m), m)
          }
          function tR() {
            var t = window.event
            return t === void 0 ? jn : gh(t.type)
          }
          var Aw = typeof setTimeout == "function" ? setTimeout : void 0,
            Iw = typeof clearTimeout == "function" ? clearTimeout : void 0,
            Hu = -1,
            QS = typeof Promise == "function" ? Promise : void 0,
            Ek =
              typeof queueMicrotask == "function"
                ? queueMicrotask
                : typeof QS < "u"
                  ? function (t) {
                      return QS.resolve(null).then(t).catch(BR)
                    }
                  : Aw
          function BR(t) {
            setTimeout(function () {
              throw t
            })
          }
          function ak(t, Q, c, f) {
            switch (Q) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                c.autoFocus && t.focus()
                return
              case "img": {
                c.src && (t.src = c.src)
                return
              }
            }
          }
          function rk(t, Q, c, f, G, m) {
            ;(Ck(t, Q, c, f, G), Ew(t, G))
          }
          function Md(t) {
            ri(t, "")
          }
          function QR(t, Q, c) {
            t.nodeValue = c
          }
          function gw(t, Q) {
            t.appendChild(Q)
          }
          function sk(t, Q) {
            var c
            t.nodeType === at
              ? ((c = t.parentNode), c.insertBefore(Q, t))
              : ((c = t), c.appendChild(Q))
            var f = t._reactRootContainer
            f == null && c.onclick === null && yd(c)
          }
          function lk(t, Q, c) {
            t.insertBefore(Q, c)
          }
          function ck(t, Q, c) {
            t.nodeType === at ? t.parentNode.insertBefore(Q, c) : t.insertBefore(Q, c)
          }
          function Ud(t, Q) {
            t.removeChild(Q)
          }
          function oR(t, Q) {
            t.nodeType === at ? t.parentNode.removeChild(Q) : t.removeChild(Q)
          }
          function Cw(t, Q) {
            var c = Q,
              f = 0
            do {
              var G = c.nextSibling
              if ((t.removeChild(c), G && G.nodeType === at)) {
                var m = G.data
                if (m === BS)
                  if (f === 0) {
                    ;(t.removeChild(G), Oe(Q))
                    return
                  } else f--
                else (m === kd || m === Yu || m === qu) && f++
              }
              c = G
            } while (c)
            Oe(Q)
          }
          function nR(t, Q) {
            ;(t.nodeType === at ? Cw(t.parentNode, Q) : t.nodeType === nQ && Cw(t, Q), Oe(t))
          }
          function hk(t) {
            t = t
            var Q = t.style
            typeof Q.setProperty == "function"
              ? Q.setProperty("display", "none", "important")
              : (Q.display = "none")
          }
          function ER(t) {
            t.nodeValue = ""
          }
          function aR(t, Q) {
            t = t
            var c = Q[ik],
              f = c != null && c.hasOwnProperty("display") ? c.display : null
            t.style.display = ba("display", f)
          }
          function rR(t, Q) {
            t.nodeValue = Q
          }
          function sR(t) {
            t.nodeType === nQ
              ? (t.textContent = "")
              : t.nodeType === Xi && t.documentElement && t.removeChild(t.documentElement)
          }
          function uk(t, Q, c) {
            return t.nodeType !== nQ || Q.toLowerCase() !== t.nodeName.toLowerCase() ? null : t
          }
          function lR(t, Q) {
            return Q === "" || t.nodeType !== Cn ? null : t
          }
          function ew(t) {
            return t.nodeType !== at ? null : t
          }
          function iw(t) {
            return t.data === Yu
          }
          function tw(t) {
            return t.data === qu
          }
          function Dk(t) {
            var Q = t.nextSibling && t.nextSibling.dataset,
              c,
              f,
              G
            return (
              Q && ((c = Q.dgst), (f = Q.msg), (G = Q.stck)),
              {
                message: f,
                digest: c,
                stack: G,
              }
            )
          }
          function cR(t, Q) {
            t._reactRetry = Q
          }
          function oS(t) {
            for (; t != null; t = t.nextSibling) {
              var Q = t.nodeType
              if (Q === nQ || Q === Cn) break
              if (Q === at) {
                var c = t.data
                if (c === kd || c === qu || c === Yu) break
                if (c === BS) return null
              }
            }
            return t
          }
          function nS(t) {
            return oS(t.nextSibling)
          }
          function Nd(t) {
            return oS(t.firstChild)
          }
          function il(t) {
            return oS(t.firstChild)
          }
          function hR(t) {
            return oS(t.nextSibling)
          }
          function Bw(t, Q, c, f, G, m, x) {
            ;(lc(m, t), Ew(t, c))
            var z
            {
              var gA = G
              z = gA.namespace
            }
            var hA = (m.mode & Pg) !== zg
            return iS(t, Q, c, z, f, hA, x)
          }
          function uR(t, Q, c, f) {
            return (lc(c, t), c.mode & Pg, pd(t, Q))
          }
          function Sk(t, Q) {
            lc(Q, t)
          }
          function DR(t) {
            for (var Q = t.nextSibling, c = 0; Q; ) {
              if (Q.nodeType === at) {
                var f = Q.data
                if (f === BS) {
                  if (c === 0) return nS(Q)
                  c--
                } else (f === kd || f === qu || f === Yu) && c++
              }
              Q = Q.nextSibling
            }
            return null
          }
          function Qw(t) {
            for (var Q = t.previousSibling, c = 0; Q; ) {
              if (Q.nodeType === at) {
                var f = Q.data
                if (f === kd || f === qu || f === Yu) {
                  if (c === 0) return Q
                  c--
                } else f === BS && c++
              }
              Q = Q.previousSibling
            }
            return null
          }
          function fk(t) {
            Oe(t)
          }
          function dk(t) {
            Oe(t)
          }
          function ow(t) {
            return t !== "head" && t !== "body"
          }
          function SR(t, Q, c, f) {
            var G = !0
            mu(Q.nodeValue, c, f, G)
          }
          function ES(t, Q, c, f, G, m) {
            if (Q[OQ] !== !0) {
              var x = !0
              mu(f.nodeValue, G, m, x)
            }
          }
          function Fd(t, Q) {
            Q.nodeType === nQ ? vu(t, Q) : Q.nodeType === at || wd(t, Q)
          }
          function fR(t, Q) {
            {
              var c = t.parentNode
              c !== null && (Q.nodeType === nQ ? vu(c, Q) : Q.nodeType === at || wd(c, Q))
            }
          }
          function yk(t, Q, c, f, G) {
            ;(G || Q[OQ] !== !0) && (f.nodeType === nQ ? vu(c, f) : f.nodeType === at || wd(c, f))
          }
          function dR(t, Q, c) {
            fh(t, Q)
          }
          function pk(t, Q) {
            yQ(t, Q)
          }
          function wk(t, Q, c) {
            {
              var f = t.parentNode
              f !== null && fh(f, Q)
            }
          }
          function Rd(t, Q) {
            {
              var c = t.parentNode
              c !== null && yQ(c, Q)
            }
          }
          function sc(t, Q, c, f, G, m) {
            ;(m || Q[OQ] !== !0) && fh(c, f)
          }
          function yR(t, Q, c, f, G) {
            ;(G || Q[OQ] !== !0) && yQ(c, f)
          }
          function vg(t) {
            B(
              "An error occurred during hydration. The server HTML was replaced with client content in <%s>.",
              t.nodeName.toLowerCase(),
            )
          }
          function Tu(t) {
            Dn(t)
          }
          var Dr = Math.random().toString(36).slice(2),
            uB = "__reactFiber$" + Dr,
            nw = "__reactProps$" + Dr,
            xu = "__reactContainer$" + Dr,
            aS = "__reactEvents$" + Dr,
            pR = "__reactListeners$" + Dr,
            Gk = "__reactHandles$" + Dr
          function Jd(t) {
            ;(delete t[uB], delete t[nw], delete t[aS], delete t[pR], delete t[Gk])
          }
          function lc(t, Q) {
            Q[uB] = t
          }
          function rS(t, Q) {
            Q[xu] = t
          }
          function kk(t) {
            t[xu] = null
          }
          function sS(t) {
            return !!t[xu]
          }
          function yh(t) {
            var Q = t[uB]
            if (Q) return Q
            for (var c = t.parentNode; c; ) {
              if (((Q = c[xu] || c[uB]), Q)) {
                var f = Q.alternate
                if (Q.child !== null || (f !== null && f.child !== null))
                  for (var G = Qw(t); G !== null; ) {
                    var m = G[uB]
                    if (m) return m
                    G = Qw(G)
                  }
                return Q
              }
              ;((t = c), (c = t.parentNode))
            }
            return null
          }
          function cc(t) {
            var Q = t[uB] || t[xu]
            return Q && (Q.tag === w || Q.tag === M || Q.tag === V || Q.tag === S) ? Q : null
          }
          function pQ(t) {
            if (t.tag === w || t.tag === M) return t.stateNode
            throw new Error("getNodeFromInstance: Invalid argument.")
          }
          function pa(t) {
            return t[nw] || null
          }
          function Ew(t, Q) {
            t[nw] = Q
          }
          function wR(t) {
            var Q = t[aS]
            return (Q === void 0 && (Q = t[aS] = /* @__PURE__ */ new Set()), Q)
          }
          var Mk = {},
            Uk = I.ReactDebugCurrentFrame
          function lS(t) {
            if (t) {
              var Q = t._owner,
                c = aB(t.type, t._source, Q ? Q.type : null)
              Uk.setExtraStackFrame(c)
            } else Uk.setExtraStackFrame(null)
          }
          function Sr(t, Q, c, f, G) {
            {
              var m = Function.call.bind(uA)
              for (var x in t)
                if (m(t, x)) {
                  var z = void 0
                  try {
                    if (typeof t[x] != "function") {
                      var gA = Error(
                        (f || "React class") +
                          ": " +
                          c +
                          " type `" +
                          x +
                          "` is invalid; it must be a function, usually from the `prop-types` package, but received `" +
                          typeof t[x] +
                          "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.",
                      )
                      throw ((gA.name = "Invariant Violation"), gA)
                    }
                    z = t[x](Q, x, f, c, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED")
                  } catch (hA) {
                    z = hA
                  }
                  ;(z &&
                    !(z instanceof Error) &&
                    (lS(G),
                    B(
                      "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",
                      f || "React class",
                      c,
                      x,
                      typeof z,
                    ),
                    lS(null)),
                    z instanceof Error &&
                      !(z.message in Mk) &&
                      ((Mk[z.message] = !0),
                      lS(G),
                      B("Failed %s type: %s", c, z.message),
                      lS(null)))
                }
            }
          }
          var Kd = [],
            cS
          cS = []
          var tl = -1
          function Bl(t) {
            return {
              current: t,
            }
          }
          function To(t, Q) {
            if (tl < 0) {
              B("Unexpected pop.")
              return
            }
            ;(Q !== cS[tl] && B("Unexpected Fiber popped."),
              (t.current = Kd[tl]),
              (Kd[tl] = null),
              (cS[tl] = null),
              tl--)
          }
          function xo(t, Q, c) {
            ;(tl++, (Kd[tl] = t.current), (cS[tl] = c), (t.current = Q))
          }
          var aw
          aw = {}
          var eE = {}
          Object.freeze(eE)
          var ss = Bl(eE),
            fr = Bl(!1),
            hS = eE
          function hc(t, Q, c) {
            return c && dr(Q) ? hS : ss.current
          }
          function rw(t, Q, c) {
            {
              var f = t.stateNode
              ;((f.__reactInternalMemoizedUnmaskedChildContext = Q),
                (f.__reactInternalMemoizedMaskedChildContext = c))
            }
          }
          function bu(t, Q) {
            {
              var c = t.type,
                f = c.contextTypes
              if (!f) return eE
              var G = t.stateNode
              if (G && G.__reactInternalMemoizedUnmaskedChildContext === Q)
                return G.__reactInternalMemoizedMaskedChildContext
              var m = {}
              for (var x in f) m[x] = Q[x]
              {
                var z = oC(t) || "Unknown"
                Sr(f, m, "context", z)
              }
              return (G && rw(t, Q, m), m)
            }
          }
          function Ou() {
            return fr.current
          }
          function dr(t) {
            {
              var Q = t.childContextTypes
              return Q != null
            }
          }
          function md(t) {
            ;(To(fr, t), To(ss, t))
          }
          function _u(t) {
            ;(To(fr, t), To(ss, t))
          }
          function Nk(t, Q, c) {
            {
              if (ss.current !== eE)
                throw new Error(
                  "Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.",
                )
              ;(xo(ss, Q, t), xo(fr, c, t))
            }
          }
          function Fk(t, Q, c) {
            {
              var f = t.stateNode,
                G = Q.childContextTypes
              if (typeof f.getChildContext != "function") {
                {
                  var m = oC(t) || "Unknown"
                  aw[m] ||
                    ((aw[m] = !0),
                    B(
                      "%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.",
                      m,
                      m,
                    ))
                }
                return c
              }
              var x = f.getChildContext()
              for (var z in x)
                if (!(z in G))
                  throw new Error(
                    (oC(t) || "Unknown") +
                      '.getChildContext(): key "' +
                      z +
                      '" is not defined in childContextTypes.',
                  )
              {
                var gA = oC(t) || "Unknown"
                Sr(G, x, "child context", gA)
              }
              return rg({}, c, x)
            }
          }
          function vd(t) {
            {
              var Q = t.stateNode,
                c = (Q && Q.__reactInternalMemoizedMergedChildContext) || eE
              return ((hS = ss.current), xo(ss, c, t), xo(fr, fr.current, t), !0)
            }
          }
          function Rk(t, Q, c) {
            {
              var f = t.stateNode
              if (!f)
                throw new Error(
                  "Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.",
                )
              if (c) {
                var G = Fk(t, Q, hS)
                ;((f.__reactInternalMemoizedMergedChildContext = G),
                  To(fr, t),
                  To(ss, t),
                  xo(ss, G, t),
                  xo(fr, c, t))
              } else (To(fr, t), xo(fr, c, t))
            }
          }
          function GR(t) {
            {
              if (!NE(t) || t.tag !== s)
                throw new Error(
                  "Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.",
                )
              var Q = t
              do {
                switch (Q.tag) {
                  case S:
                    return Q.stateNode.context
                  case s: {
                    var c = Q.type
                    if (dr(c)) return Q.stateNode.__reactInternalMemoizedMergedChildContext
                    break
                  }
                }
                Q = Q.return
              } while (Q !== null)
              throw new Error(
                "Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.",
              )
            }
          }
          var uc = 0,
            uS = 1,
            yr = null,
            sw = !1,
            Ld = !1
          function Jk(t) {
            yr === null ? (yr = [t]) : yr.push(t)
          }
          function Kk(t) {
            ;((sw = !0), Jk(t))
          }
          function mk() {
            sw && Dc()
          }
          function Dc() {
            if (!Ld && yr !== null) {
              Ld = !0
              var t = 0,
                Q = hn()
              try {
                var c = !0,
                  f = yr
                for (gt(Ut); t < f.length; t++) {
                  var G = f[t]
                  do G = G(c)
                  while (G !== null)
                }
                ;((yr = null), (sw = !1))
              } catch (m) {
                throw (yr !== null && (yr = yr.slice(t + 1)), Cr(Zl, Dc), m)
              } finally {
                ;(gt(Q), (Ld = !1))
              }
            }
            return null
          }
          var Zu = [],
            Pu = 0,
            Yd = null,
            qd = 0,
            wa = [],
            Ga = 0,
            ph = null,
            Ql = 1,
            ol = ""
          function vk(t) {
            return (pr(), (t.flags & Mo) !== nC)
          }
          function ka(t) {
            return (pr(), qd)
          }
          function kR() {
            var t = ol,
              Q = Ql,
              c = Q & ~Hd(Q)
            return c.toString(32) + t
          }
          function wh(t, Q) {
            ;(pr(), (Zu[Pu++] = qd), (Zu[Pu++] = Yd), (Yd = t), (qd = Q))
          }
          function Lk(t, Q, c) {
            ;(pr(), (wa[Ga++] = Ql), (wa[Ga++] = ol), (wa[Ga++] = ph), (ph = t))
            var f = Ql,
              G = ol,
              m = Gh(f) - 1,
              x = f & ~(1 << m),
              z = c + 1,
              gA = Gh(Q) + m
            if (gA > 30) {
              var hA = m - (m % 5),
                pA = (1 << hA) - 1,
                gI = (x & pA).toString(32),
                $A = x >> hA,
                FI = m - hA,
                KI = Gh(Q) + FI,
                OI = z << FI,
                Lg = OI | $A,
                yC = gI + G
              ;((Ql = (1 << KI) | Lg), (ol = yC))
            } else {
              var EC = z << m,
                We = EC | x,
                Le = G
              ;((Ql = (1 << gA) | We), (ol = Le))
            }
          }
          function lw(t) {
            pr()
            var Q = t.return
            if (Q !== null) {
              var c = 1,
                f = 0
              ;(wh(t, c), Lk(t, c, f))
            }
          }
          function Gh(t) {
            return 32 - GB(t)
          }
          function Hd(t) {
            return 1 << (Gh(t) - 1)
          }
          function Wu(t) {
            for (; t === Yd; ) ((Yd = Zu[--Pu]), (Zu[Pu] = null), (qd = Zu[--Pu]), (Zu[Pu] = null))
            for (; t === ph; )
              ((ph = wa[--Ga]),
                (wa[Ga] = null),
                (ol = wa[--Ga]),
                (wa[Ga] = null),
                (Ql = wa[--Ga]),
                (wa[Ga] = null))
          }
          function Td() {
            return (
              pr(),
              ph !== null
                ? {
                    id: Ql,
                    overflow: ol,
                  }
                : null
            )
          }
          function xd(t, Q) {
            ;(pr(),
              (wa[Ga++] = Ql),
              (wa[Ga++] = ol),
              (wa[Ga++] = ph),
              (Ql = Q.id),
              (ol = Q.overflow),
              (ph = t))
          }
          function pr() {
            it() || B("Expected to be hydrating. This is a bug in React. Please file an issue.")
          }
          var oo = null,
            Ma = null,
            wr = !1,
            kh = !1,
            Sc = null
          function cw() {
            wr && B("We should not be hydrating here. This is a bug in React. Please file a bug.")
          }
          function bd() {
            kh = !0
          }
          function hw() {
            return kh
          }
          function Yk(t) {
            var Q = t.stateNode.containerInfo
            return ((Ma = il(Q)), (oo = t), (wr = !0), (Sc = null), (kh = !1), !0)
          }
          function MR(t, Q, c) {
            return (
              (Ma = hR(Q)),
              (oo = t),
              (wr = !0),
              (Sc = null),
              (kh = !1),
              c !== null && xd(t, c),
              !0
            )
          }
          function DS(t, Q) {
            switch (t.tag) {
              case S: {
                Fd(t.stateNode.containerInfo, Q)
                break
              }
              case w: {
                var c = (t.mode & Pg) !== zg
                yk(
                  t.type,
                  t.memoizedProps,
                  t.stateNode,
                  Q,
                  // TODO: Delete this argument when we remove the legacy root API.
                  c,
                )
                break
              }
              case V: {
                var f = t.memoizedState
                f.dehydrated !== null && fR(f.dehydrated, Q)
                break
              }
            }
          }
          function qk(t, Q) {
            DS(t, Q)
            var c = d3()
            ;((c.stateNode = Q), (c.return = t))
            var f = t.deletions
            f === null ? ((t.deletions = [c]), (t.flags |= de)) : f.push(c)
          }
          function uw(t, Q) {
            {
              if (kh) return
              switch (t.tag) {
                case S: {
                  var c = t.stateNode.containerInfo
                  switch (Q.tag) {
                    case w:
                      var f = Q.type
                      ;(Q.pendingProps, dR(c, f))
                      break
                    case M:
                      var G = Q.pendingProps
                      pk(c, G)
                      break
                  }
                  break
                }
                case w: {
                  var m = t.type,
                    x = t.memoizedProps,
                    z = t.stateNode
                  switch (Q.tag) {
                    case w: {
                      var gA = Q.type,
                        hA = Q.pendingProps,
                        pA = (t.mode & Pg) !== zg
                      sc(
                        m,
                        x,
                        z,
                        gA,
                        hA,
                        // TODO: Delete this argument when we remove the legacy root API.
                        pA,
                      )
                      break
                    }
                    case M: {
                      var gI = Q.pendingProps,
                        $A = (t.mode & Pg) !== zg
                      yR(
                        m,
                        x,
                        z,
                        gI,
                        // TODO: Delete this argument when we remove the legacy root API.
                        $A,
                      )
                      break
                    }
                  }
                  break
                }
                case V: {
                  var FI = t.memoizedState,
                    KI = FI.dehydrated
                  if (KI !== null)
                    switch (Q.tag) {
                      case w:
                        var OI = Q.type
                        ;(Q.pendingProps, wk(KI, OI))
                        break
                      case M:
                        var Lg = Q.pendingProps
                        Rd(KI, Lg)
                        break
                    }
                  break
                }
                default:
                  return
              }
            }
          }
          function Hk(t, Q) {
            ;((Q.flags = (Q.flags & ~hQ) | te), uw(t, Q))
          }
          function SS(t, Q) {
            switch (t.tag) {
              case w: {
                var c = t.type
                t.pendingProps
                var f = uk(Q, c)
                return f !== null ? ((t.stateNode = f), (oo = t), (Ma = Nd(f)), !0) : !1
              }
              case M: {
                var G = t.pendingProps,
                  m = lR(Q, G)
                return m !== null ? ((t.stateNode = m), (oo = t), (Ma = null), !0) : !1
              }
              case V: {
                var x = ew(Q)
                if (x !== null) {
                  var z = {
                    dehydrated: x,
                    treeContext: Td(),
                    retryLane: VB,
                  }
                  t.memoizedState = z
                  var gA = y3(x)
                  return ((gA.return = t), (t.child = gA), (oo = t), (Ma = null), !0)
                }
                return !1
              }
              default:
                return !1
            }
          }
          function Dw(t) {
            return (t.mode & Pg) !== zg && (t.flags & kC) === nC
          }
          function Sw(t) {
            throw new Error(
              "Hydration failed because the initial UI does not match what was rendered on the server.",
            )
          }
          function fw(t) {
            if (wr) {
              var Q = Ma
              if (!Q) {
                ;(Dw(t) && (uw(oo, t), Sw()), Hk(oo, t), (wr = !1), (oo = t))
                return
              }
              var c = Q
              if (!SS(t, Q)) {
                ;(Dw(t) && (uw(oo, t), Sw()), (Q = nS(c)))
                var f = oo
                if (!Q || !SS(t, Q)) {
                  ;(Hk(oo, t), (wr = !1), (oo = t))
                  return
                }
                qk(f, c)
              }
            }
          }
          function UR(t, Q, c) {
            var f = t.stateNode,
              G = !kh,
              m = Bw(f, t.type, t.memoizedProps, Q, c, t, G)
            return ((t.updateQueue = m), m !== null)
          }
          function Tk(t) {
            var Q = t.stateNode,
              c = t.memoizedProps,
              f = uR(Q, c, t)
            if (f) {
              var G = oo
              if (G !== null)
                switch (G.tag) {
                  case S: {
                    var m = G.stateNode.containerInfo,
                      x = (G.mode & Pg) !== zg
                    SR(
                      m,
                      Q,
                      c,
                      // TODO: Delete this argument when we remove the legacy root API.
                      x,
                    )
                    break
                  }
                  case w: {
                    var z = G.type,
                      gA = G.memoizedProps,
                      hA = G.stateNode,
                      pA = (G.mode & Pg) !== zg
                    ES(
                      z,
                      gA,
                      hA,
                      Q,
                      c,
                      // TODO: Delete this argument when we remove the legacy root API.
                      pA,
                    )
                    break
                  }
                }
            }
            return f
          }
          function NR(t) {
            var Q = t.memoizedState,
              c = Q !== null ? Q.dehydrated : null
            if (!c)
              throw new Error(
                "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.",
              )
            Sk(c, t)
          }
          function dw(t) {
            var Q = t.memoizedState,
              c = Q !== null ? Q.dehydrated : null
            if (!c)
              throw new Error(
                "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.",
              )
            return DR(c)
          }
          function Od(t) {
            for (var Q = t.return; Q !== null && Q.tag !== w && Q.tag !== S && Q.tag !== V; )
              Q = Q.return
            oo = Q
          }
          function dt(t) {
            if (t !== oo) return !1
            if (!wr) return (Od(t), (wr = !0), !1)
            if (t.tag !== S && (t.tag !== w || (ow(t.type) && !$p(t.type, t.memoizedProps)))) {
              var Q = Ma
              if (Q)
                if (Dw(t)) (JB(t), Sw())
                else for (; Q; ) (qk(t, Q), (Q = nS(Q)))
            }
            return (Od(t), t.tag === V ? (Ma = dw(t)) : (Ma = oo ? nS(t.stateNode) : null), !0)
          }
          function Gr() {
            return wr && Ma !== null
          }
          function JB(t) {
            for (var Q = Ma; Q; ) (DS(t, Q), (Q = nS(Q)))
          }
          function fc() {
            ;((oo = null), (Ma = null), (wr = !1), (kh = !1))
          }
          function no() {
            Sc !== null && (dY(Sc), (Sc = null))
          }
          function it() {
            return wr
          }
          function kr(t) {
            Sc === null ? (Sc = [t]) : Sc.push(t)
          }
          var fS = I.ReactCurrentBatchConfig,
            Mh = null
          function _d() {
            return fS.transition
          }
          var fn = {
            recordUnsafeLifecycleWarnings: function (t, Q) {},
            flushPendingUnsafeLifecycleWarnings: function () {},
            recordLegacyContextWarning: function (t, Q) {},
            flushLegacyContextWarning: function () {},
            discardPendingWarnings: function () {},
          }
          {
            var xk = function (t) {
                for (var Q = null, c = t; c !== null; ) (c.mode & rC && (Q = c), (c = c.return))
                return Q
              },
              nl = function (t) {
                var Q = []
                return (
                  t.forEach(function (c) {
                    Q.push(c)
                  }),
                  Q.sort().join(", ")
                )
              },
              ge = [],
              $B = [],
              tt = [],
              QB = [],
              iE = [],
              Uh = [],
              Rt = /* @__PURE__ */ new Set()
            ;((fn.recordUnsafeLifecycleWarnings = function (t, Q) {
              Rt.has(t.type) ||
                (typeof Q.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
                  Q.componentWillMount.__suppressDeprecationWarning !== !0 &&
                  ge.push(t),
                t.mode & rC && typeof Q.UNSAFE_componentWillMount == "function" && $B.push(t),
                typeof Q.componentWillReceiveProps == "function" &&
                  Q.componentWillReceiveProps.__suppressDeprecationWarning !== !0 &&
                  tt.push(t),
                t.mode & rC &&
                  typeof Q.UNSAFE_componentWillReceiveProps == "function" &&
                  QB.push(t),
                typeof Q.componentWillUpdate == "function" &&
                  Q.componentWillUpdate.__suppressDeprecationWarning !== !0 &&
                  iE.push(t),
                t.mode & rC && typeof Q.UNSAFE_componentWillUpdate == "function" && Uh.push(t))
            }),
              (fn.flushPendingUnsafeLifecycleWarnings = function () {
                var t = /* @__PURE__ */ new Set()
                ge.length > 0 &&
                  (ge.forEach(function ($A) {
                    ;(t.add(oC($A) || "Component"), Rt.add($A.type))
                  }),
                  (ge = []))
                var Q = /* @__PURE__ */ new Set()
                $B.length > 0 &&
                  ($B.forEach(function ($A) {
                    ;(Q.add(oC($A) || "Component"), Rt.add($A.type))
                  }),
                  ($B = []))
                var c = /* @__PURE__ */ new Set()
                tt.length > 0 &&
                  (tt.forEach(function ($A) {
                    ;(c.add(oC($A) || "Component"), Rt.add($A.type))
                  }),
                  (tt = []))
                var f = /* @__PURE__ */ new Set()
                QB.length > 0 &&
                  (QB.forEach(function ($A) {
                    ;(f.add(oC($A) || "Component"), Rt.add($A.type))
                  }),
                  (QB = []))
                var G = /* @__PURE__ */ new Set()
                iE.length > 0 &&
                  (iE.forEach(function ($A) {
                    ;(G.add(oC($A) || "Component"), Rt.add($A.type))
                  }),
                  (iE = []))
                var m = /* @__PURE__ */ new Set()
                if (
                  (Uh.length > 0 &&
                    (Uh.forEach(function ($A) {
                      ;(m.add(oC($A) || "Component"), Rt.add($A.type))
                    }),
                    (Uh = [])),
                  Q.size > 0)
                ) {
                  var x = nl(Q)
                  B(
                    `Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`,
                    x,
                  )
                }
                if (f.size > 0) {
                  var z = nl(f)
                  B(
                    `Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`,
                    z,
                  )
                }
                if (m.size > 0) {
                  var gA = nl(m)
                  B(
                    `Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`,
                    gA,
                  )
                }
                if (t.size > 0) {
                  var hA = nl(t)
                  i(
                    `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
                    hA,
                  )
                }
                if (c.size > 0) {
                  var pA = nl(c)
                  i(
                    `componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
                    pA,
                  )
                }
                if (G.size > 0) {
                  var gI = nl(G)
                  i(
                    `componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
                    gI,
                  )
                }
              }))
            var dc = /* @__PURE__ */ new Map(),
              dS = /* @__PURE__ */ new Set()
            ;((fn.recordLegacyContextWarning = function (t, Q) {
              var c = xk(t)
              if (c === null) {
                B(
                  "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.",
                )
                return
              }
              if (!dS.has(t.type)) {
                var f = dc.get(c)
                ;(t.type.contextTypes != null ||
                  t.type.childContextTypes != null ||
                  (Q !== null && typeof Q.getChildContext == "function")) &&
                  (f === void 0 && ((f = []), dc.set(c, f)), f.push(t))
              }
            }),
              (fn.flushLegacyContextWarning = function () {
                dc.forEach(function (t, Q) {
                  if (t.length !== 0) {
                    var c = t[0],
                      f = /* @__PURE__ */ new Set()
                    t.forEach(function (m) {
                      ;(f.add(oC(m) || "Component"), dS.add(m.type))
                    })
                    var G = nl(f)
                    try {
                      ;(Me(c),
                        B(
                          `Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`,
                          G,
                        ))
                    } finally {
                      di()
                    }
                  }
                })
              }),
              (fn.discardPendingWarnings = function () {
                ;((ge = []),
                  ($B = []),
                  (tt = []),
                  (QB = []),
                  (iE = []),
                  (Uh = []),
                  (dc = /* @__PURE__ */ new Map()))
              }))
          }
          var Nh,
            Vu,
            Fh,
            bo,
            yS,
            yw = function (t, Q) {}
          ;((Nh = !1),
            (Vu = !1),
            (Fh = {}),
            (bo = {}),
            (yS = {}),
            (yw = function (t, Q) {
              if (
                !(t === null || typeof t != "object") &&
                !(!t._store || t._store.validated || t.key != null)
              ) {
                if (typeof t._store != "object")
                  throw new Error(
                    "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.",
                  )
                t._store.validated = !0
                var c = oC(Q) || "Component"
                bo[c] ||
                  ((bo[c] = !0),
                  B(
                    'Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.',
                  ))
              }
            }))
          function bk(t) {
            return t.prototype && t.prototype.isReactComponent
          }
          function pS(t, Q, c) {
            var f = c.ref
            if (f !== null && typeof f != "function" && typeof f != "object") {
              if (
                (t.mode & rC || DA) && // We warn in ReactElement.js if owner and self are equal for string refs
                // because these cannot be automatically converted to an arrow function
                // using a codemod. Therefore, we don't have to warn about string refs again.
                !(c._owner && c._self && c._owner.stateNode !== c._self) && // Will already throw with "Function components cannot have string refs"
                !(c._owner && c._owner.tag !== s) && // Will already warn with "Function components cannot be given refs"
                !(typeof c.type == "function" && !bk(c.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
                c._owner
              ) {
                var G = oC(t) || "Component"
                Fh[G] ||
                  (B(
                    'Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref',
                    G,
                    f,
                  ),
                  (Fh[G] = !0))
              }
              if (c._owner) {
                var m = c._owner,
                  x
                if (m) {
                  var z = m
                  if (z.tag !== s)
                    throw new Error(
                      "Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref",
                    )
                  x = z.stateNode
                }
                if (!x)
                  throw new Error(
                    "Missing owner for string ref " +
                      f +
                      ". This error is likely caused by a bug in React. Please file an issue.",
                  )
                var gA = x
                SI(f, "ref")
                var hA = "" + f
                if (
                  Q !== null &&
                  Q.ref !== null &&
                  typeof Q.ref == "function" &&
                  Q.ref._stringRef === hA
                )
                  return Q.ref
                var pA = function (gI) {
                  var $A = gA.refs
                  gI === null ? delete $A[hA] : ($A[hA] = gI)
                }
                return ((pA._stringRef = hA), pA)
              } else {
                if (typeof f != "string")
                  throw new Error(
                    "Expected ref to be a function, a string, an object returned by React.createRef(), or null.",
                  )
                if (!c._owner)
                  throw new Error(
                    "Element ref was specified as a string (" +
                      f +
                      `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`,
                  )
              }
            }
            return f
          }
          function El(t, Q) {
            var c = Object.prototype.toString.call(Q)
            throw new Error(
              "Objects are not valid as a React child (found: " +
                (c === "[object Object]"
                  ? "object with keys {" + Object.keys(Q).join(", ") + "}"
                  : c) +
                "). If you meant to render a collection of children, use an array instead.",
            )
          }
          function wS(t) {
            {
              var Q = oC(t) || "Component"
              if (yS[Q]) return
              ;((yS[Q] = !0),
                B(
                  "Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.",
                ))
            }
          }
          function GS(t) {
            var Q = t._payload,
              c = t._init
            return c(Q)
          }
          function Zd(t) {
            function Q(fI, _I) {
              if (t) {
                var dI = fI.deletions
                dI === null ? ((fI.deletions = [_I]), (fI.flags |= de)) : dI.push(_I)
              }
            }
            function c(fI, _I) {
              if (!t) return null
              for (var dI = _I; dI !== null; ) (Q(fI, dI), (dI = dI.sibling))
              return null
            }
            function f(fI, _I) {
              for (var dI = /* @__PURE__ */ new Map(), sg = _I; sg !== null; )
                (sg.key !== null ? dI.set(sg.key, sg) : dI.set(sg.index, sg), (sg = sg.sibling))
              return dI
            }
            function G(fI, _I) {
              var dI = Cf(fI, _I)
              return ((dI.index = 0), (dI.sibling = null), dI)
            }
            function m(fI, _I, dI) {
              if (((fI.index = dI), !t)) return ((fI.flags |= Mo), _I)
              var sg = fI.alternate
              if (sg !== null) {
                var _g = sg.index
                return _g < _I ? ((fI.flags |= te), _I) : _g
              } else return ((fI.flags |= te), _I)
            }
            function x(fI) {
              return (t && fI.alternate === null && (fI.flags |= te), fI)
            }
            function z(fI, _I, dI, sg) {
              if (_I === null || _I.tag !== M) {
                var _g = vJ(dI, fI.mode, sg)
                return ((_g.return = fI), _g)
              } else {
                var Hg = G(_I, dI)
                return ((Hg.return = fI), Hg)
              }
            }
            function gA(fI, _I, dI, sg) {
              var _g = dI.type
              if (_g === Ei) return pA(fI, _I, dI.props.children, sg, dI.key)
              if (
                _I !== null &&
                (_I.elementType === _g || // Keep this check inline so it only runs on the false path:
                  YY(_I, dI) || // Lazy types should reconcile their resolved type.
                  // We need to do this after the Hot Reloading check above,
                  // because hot reloading has different semantics than prod because
                  // it doesn't resuspend. So we can't let the call below suspend.
                  (typeof _g == "object" &&
                    _g !== null &&
                    _g.$$typeof === jg &&
                    GS(_g) === _I.type))
              ) {
                var Hg = G(_I, dI.props)
                return (
                  (Hg.ref = pS(fI, _I, dI)),
                  (Hg.return = fI),
                  (Hg._debugSource = dI._source),
                  (Hg._debugOwner = dI._owner),
                  Hg
                )
              }
              var xC = mJ(dI, fI.mode, sg)
              return ((xC.ref = pS(fI, _I, dI)), (xC.return = fI), xC)
            }
            function hA(fI, _I, dI, sg) {
              if (
                _I === null ||
                _I.tag !== d ||
                _I.stateNode.containerInfo !== dI.containerInfo ||
                _I.stateNode.implementation !== dI.implementation
              ) {
                var _g = LJ(dI, fI.mode, sg)
                return ((_g.return = fI), _g)
              } else {
                var Hg = G(_I, dI.children || [])
                return ((Hg.return = fI), Hg)
              }
            }
            function pA(fI, _I, dI, sg, _g) {
              if (_I === null || _I.tag !== K) {
                var Hg = QD(dI, fI.mode, sg, _g)
                return ((Hg.return = fI), Hg)
              } else {
                var xC = G(_I, dI)
                return ((xC.return = fI), xC)
              }
            }
            function gI(fI, _I, dI) {
              if ((typeof _I == "string" && _I !== "") || typeof _I == "number") {
                var sg = vJ("" + _I, fI.mode, dI)
                return ((sg.return = fI), sg)
              }
              if (typeof _I == "object" && _I !== null) {
                switch (_I.$$typeof) {
                  case ei: {
                    var _g = mJ(_I, fI.mode, dI)
                    return ((_g.ref = pS(fI, null, _I)), (_g.return = fI), _g)
                  }
                  case fe: {
                    var Hg = LJ(_I, fI.mode, dI)
                    return ((Hg.return = fI), Hg)
                  }
                  case jg: {
                    var xC = _I._payload,
                      Ce = _I._init
                    return gI(fI, Ce(xC), dI)
                  }
                }
                if (le(_I) || yg(_I)) {
                  var Wi = QD(_I, fI.mode, dI, null)
                  return ((Wi.return = fI), Wi)
                }
                El(fI, _I)
              }
              return (typeof _I == "function" && wS(fI), null)
            }
            function $A(fI, _I, dI, sg) {
              var _g = _I !== null ? _I.key : null
              if ((typeof dI == "string" && dI !== "") || typeof dI == "number")
                return _g !== null ? null : z(fI, _I, "" + dI, sg)
              if (typeof dI == "object" && dI !== null) {
                switch (dI.$$typeof) {
                  case ei:
                    return dI.key === _g ? gA(fI, _I, dI, sg) : null
                  case fe:
                    return dI.key === _g ? hA(fI, _I, dI, sg) : null
                  case jg: {
                    var Hg = dI._payload,
                      xC = dI._init
                    return $A(fI, _I, xC(Hg), sg)
                  }
                }
                if (le(dI) || yg(dI)) return _g !== null ? null : pA(fI, _I, dI, sg, null)
                El(fI, dI)
              }
              return (typeof dI == "function" && wS(fI), null)
            }
            function FI(fI, _I, dI, sg, _g) {
              if ((typeof sg == "string" && sg !== "") || typeof sg == "number") {
                var Hg = fI.get(dI) || null
                return z(_I, Hg, "" + sg, _g)
              }
              if (typeof sg == "object" && sg !== null) {
                switch (sg.$$typeof) {
                  case ei: {
                    var xC = fI.get(sg.key === null ? dI : sg.key) || null
                    return gA(_I, xC, sg, _g)
                  }
                  case fe: {
                    var Ce = fI.get(sg.key === null ? dI : sg.key) || null
                    return hA(_I, Ce, sg, _g)
                  }
                  case jg:
                    var Wi = sg._payload,
                      hi = sg._init
                    return FI(fI, _I, dI, hi(Wi), _g)
                }
                if (le(sg) || yg(sg)) {
                  var MQ = fI.get(dI) || null
                  return pA(_I, MQ, sg, _g, null)
                }
                El(_I, sg)
              }
              return (typeof sg == "function" && wS(_I), null)
            }
            function KI(fI, _I, dI) {
              {
                if (typeof fI != "object" || fI === null) return _I
                switch (fI.$$typeof) {
                  case ei:
                  case fe:
                    yw(fI, dI)
                    var sg = fI.key
                    if (typeof sg != "string") break
                    if (_I === null) {
                      ;((_I = /* @__PURE__ */ new Set()), _I.add(sg))
                      break
                    }
                    if (!_I.has(sg)) {
                      _I.add(sg)
                      break
                    }
                    B(
                      "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",
                      sg,
                    )
                    break
                  case jg:
                    var _g = fI._payload,
                      Hg = fI._init
                    KI(Hg(_g), _I, dI)
                    break
                }
              }
              return _I
            }
            function OI(fI, _I, dI, sg) {
              for (var _g = null, Hg = 0; Hg < dI.length; Hg++) {
                var xC = dI[Hg]
                _g = KI(xC, _g, fI)
              }
              for (
                var Ce = null, Wi = null, hi = _I, MQ = 0, ui = 0, IQ = null;
                hi !== null && ui < dI.length;
                ui++
              ) {
                hi.index > ui ? ((IQ = hi), (hi = null)) : (IQ = hi.sibling)
                var QE = $A(fI, hi, dI[ui], sg)
                if (QE === null) {
                  hi === null && (hi = IQ)
                  break
                }
                ;(t && hi && QE.alternate === null && Q(fI, hi),
                  (MQ = m(QE, MQ, ui)),
                  Wi === null ? (Ce = QE) : (Wi.sibling = QE),
                  (Wi = QE),
                  (hi = IQ))
              }
              if (ui === dI.length) {
                if ((c(fI, hi), it())) {
                  var Rn = ui
                  wh(fI, Rn)
                }
                return Ce
              }
              if (hi === null) {
                for (; ui < dI.length; ui++) {
                  var Fr = gI(fI, dI[ui], sg)
                  Fr !== null &&
                    ((MQ = m(Fr, MQ, ui)), Wi === null ? (Ce = Fr) : (Wi.sibling = Fr), (Wi = Fr))
                }
                if (it()) {
                  var PE = ui
                  wh(fI, PE)
                }
                return Ce
              }
              for (var WE = f(fI, hi); ui < dI.length; ui++) {
                var oE = FI(WE, fI, ui, dI[ui], sg)
                oE !== null &&
                  (t && oE.alternate !== null && WE.delete(oE.key === null ? ui : oE.key),
                  (MQ = m(oE, MQ, ui)),
                  Wi === null ? (Ce = oE) : (Wi.sibling = oE),
                  (Wi = oE))
              }
              if (
                (t &&
                  WE.forEach(function (ky) {
                    return Q(fI, ky)
                  }),
                it())
              ) {
                var Zh = ui
                wh(fI, Zh)
              }
              return Ce
            }
            function Lg(fI, _I, dI, sg) {
              var _g = yg(dI)
              if (typeof _g != "function")
                throw new Error(
                  "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.",
                )
              {
                ;(typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
                  dI[Symbol.toStringTag] === "Generator" &&
                  (Vu ||
                    B(
                      "Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.",
                    ),
                  (Vu = !0)),
                  dI.entries === _g &&
                    (Nh ||
                      B(
                        "Using Maps as children is not supported. Use an array of keyed ReactElements instead.",
                      ),
                    (Nh = !0)))
                var Hg = _g.call(dI)
                if (Hg)
                  for (var xC = null, Ce = Hg.next(); !Ce.done; Ce = Hg.next()) {
                    var Wi = Ce.value
                    xC = KI(Wi, xC, fI)
                  }
              }
              var hi = _g.call(dI)
              if (hi == null) throw new Error("An iterable object provided no iterator.")
              for (
                var MQ = null, ui = null, IQ = _I, QE = 0, Rn = 0, Fr = null, PE = hi.next();
                IQ !== null && !PE.done;
                Rn++, PE = hi.next()
              ) {
                IQ.index > Rn ? ((Fr = IQ), (IQ = null)) : (Fr = IQ.sibling)
                var WE = $A(fI, IQ, PE.value, sg)
                if (WE === null) {
                  IQ === null && (IQ = Fr)
                  break
                }
                ;(t && IQ && WE.alternate === null && Q(fI, IQ),
                  (QE = m(WE, QE, Rn)),
                  ui === null ? (MQ = WE) : (ui.sibling = WE),
                  (ui = WE),
                  (IQ = Fr))
              }
              if (PE.done) {
                if ((c(fI, IQ), it())) {
                  var oE = Rn
                  wh(fI, oE)
                }
                return MQ
              }
              if (IQ === null) {
                for (; !PE.done; Rn++, PE = hi.next()) {
                  var Zh = gI(fI, PE.value, sg)
                  Zh !== null &&
                    ((QE = m(Zh, QE, Rn)), ui === null ? (MQ = Zh) : (ui.sibling = Zh), (ui = Zh))
                }
                if (it()) {
                  var ky = Rn
                  wh(fI, ky)
                }
                return MQ
              }
              for (var y0 = f(fI, IQ); !PE.done; Rn++, PE = hi.next()) {
                var qc = FI(y0, fI, Rn, PE.value, sg)
                qc !== null &&
                  (t && qc.alternate !== null && y0.delete(qc.key === null ? Rn : qc.key),
                  (QE = m(qc, QE, Rn)),
                  ui === null ? (MQ = qc) : (ui.sibling = qc),
                  (ui = qc))
              }
              if (
                (t &&
                  y0.forEach(function (A1) {
                    return Q(fI, A1)
                  }),
                it())
              ) {
                var $3 = Rn
                wh(fI, $3)
              }
              return MQ
            }
            function yC(fI, _I, dI, sg) {
              if (_I !== null && _I.tag === M) {
                c(fI, _I.sibling)
                var _g = G(_I, dI)
                return ((_g.return = fI), _g)
              }
              c(fI, _I)
              var Hg = vJ(dI, fI.mode, sg)
              return ((Hg.return = fI), Hg)
            }
            function EC(fI, _I, dI, sg) {
              for (var _g = dI.key, Hg = _I; Hg !== null; ) {
                if (Hg.key === _g) {
                  var xC = dI.type
                  if (xC === Ei) {
                    if (Hg.tag === K) {
                      c(fI, Hg.sibling)
                      var Ce = G(Hg, dI.props.children)
                      return (
                        (Ce.return = fI),
                        (Ce._debugSource = dI._source),
                        (Ce._debugOwner = dI._owner),
                        Ce
                      )
                    }
                  } else if (
                    Hg.elementType === xC || // Keep this check inline so it only runs on the false path:
                    YY(Hg, dI) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    (typeof xC == "object" &&
                      xC !== null &&
                      xC.$$typeof === jg &&
                      GS(xC) === Hg.type)
                  ) {
                    c(fI, Hg.sibling)
                    var Wi = G(Hg, dI.props)
                    return (
                      (Wi.ref = pS(fI, Hg, dI)),
                      (Wi.return = fI),
                      (Wi._debugSource = dI._source),
                      (Wi._debugOwner = dI._owner),
                      Wi
                    )
                  }
                  c(fI, Hg)
                  break
                } else Q(fI, Hg)
                Hg = Hg.sibling
              }
              if (dI.type === Ei) {
                var hi = QD(dI.props.children, fI.mode, sg, dI.key)
                return ((hi.return = fI), hi)
              } else {
                var MQ = mJ(dI, fI.mode, sg)
                return ((MQ.ref = pS(fI, _I, dI)), (MQ.return = fI), MQ)
              }
            }
            function We(fI, _I, dI, sg) {
              for (var _g = dI.key, Hg = _I; Hg !== null; ) {
                if (Hg.key === _g)
                  if (
                    Hg.tag === d &&
                    Hg.stateNode.containerInfo === dI.containerInfo &&
                    Hg.stateNode.implementation === dI.implementation
                  ) {
                    c(fI, Hg.sibling)
                    var xC = G(Hg, dI.children || [])
                    return ((xC.return = fI), xC)
                  } else {
                    c(fI, Hg)
                    break
                  }
                else Q(fI, Hg)
                Hg = Hg.sibling
              }
              var Ce = LJ(dI, fI.mode, sg)
              return ((Ce.return = fI), Ce)
            }
            function Le(fI, _I, dI, sg) {
              var _g = typeof dI == "object" && dI !== null && dI.type === Ei && dI.key === null
              if ((_g && (dI = dI.props.children), typeof dI == "object" && dI !== null)) {
                switch (dI.$$typeof) {
                  case ei:
                    return x(EC(fI, _I, dI, sg))
                  case fe:
                    return x(We(fI, _I, dI, sg))
                  case jg:
                    var Hg = dI._payload,
                      xC = dI._init
                    return Le(fI, _I, xC(Hg), sg)
                }
                if (le(dI)) return OI(fI, _I, dI, sg)
                if (yg(dI)) return Lg(fI, _I, dI, sg)
                El(fI, dI)
              }
              return (typeof dI == "string" && dI !== "") || typeof dI == "number"
                ? x(yC(fI, _I, "" + dI, sg))
                : (typeof dI == "function" && wS(fI), c(fI, _I))
            }
            return Le
          }
          var Mr = Zd(!0),
            yc = Zd(!1)
          function al(t, Q) {
            if (t !== null && Q.child !== t.child)
              throw new Error("Resuming work not yet implemented.")
            if (Q.child !== null) {
              var c = Q.child,
                f = Cf(c, c.pendingProps)
              for (Q.child = f, f.return = Q; c.sibling !== null; )
                ((c = c.sibling), (f = f.sibling = Cf(c, c.pendingProps)), (f.return = Q))
              f.sibling = null
            }
          }
          function kS(t, Q) {
            for (var c = t.child; c !== null; ) (h3(c, Q), (c = c.sibling))
          }
          var MS = Bl(null),
            pw
          pw = {}
          var pc = null,
            wc = null,
            ww = null,
            Rh = !1
          function Gc() {
            ;((pc = null), (wc = null), (ww = null), (Rh = !1))
          }
          function US() {
            Rh = !0
          }
          function NS() {
            Rh = !1
          }
          function Oo(t, Q, c) {
            ;(xo(MS, Q._currentValue, t),
              (Q._currentValue = c),
              Q._currentRenderer !== void 0 &&
                Q._currentRenderer !== null &&
                Q._currentRenderer !== pw &&
                B(
                  "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.",
                ),
              (Q._currentRenderer = pw))
          }
          function ls(t, Q) {
            var c = MS.current
            ;(To(MS, Q), (t._currentValue = c))
          }
          function Gw(t, Q, c) {
            for (var f = t; f !== null; ) {
              var G = f.alternate
              if (
                (JI(f.childLanes, Q)
                  ? G !== null && !JI(G.childLanes, Q) && (G.childLanes = WI(G.childLanes, Q))
                  : ((f.childLanes = WI(f.childLanes, Q)),
                    G !== null && (G.childLanes = WI(G.childLanes, Q))),
                f === c)
              )
                break
              f = f.return
            }
            f !== c &&
              B(
                "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.",
              )
          }
          function wQ(t, Q, c) {
            FR(t, Q, c)
          }
          function FR(t, Q, c) {
            var f = t.child
            for (f !== null && (f.return = t); f !== null; ) {
              var G = void 0,
                m = f.dependencies
              if (m !== null) {
                G = f.child
                for (var x = m.firstContext; x !== null; ) {
                  if (x.context === Q) {
                    if (f.tag === s) {
                      var z = ut(c),
                        gA = cs(ue, z)
                      gA.tag = Vd
                      var hA = f.updateQueue
                      if (hA !== null) {
                        var pA = hA.shared,
                          gI = pA.pending
                        ;(gI === null ? (gA.next = gA) : ((gA.next = gI.next), (gI.next = gA)),
                          (pA.pending = gA))
                      }
                    }
                    f.lanes = WI(f.lanes, c)
                    var $A = f.alternate
                    ;($A !== null && ($A.lanes = WI($A.lanes, c)),
                      Gw(f.return, c, t),
                      (m.lanes = WI(m.lanes, c)))
                    break
                  }
                  x = x.next
                }
              } else if (f.tag === L) G = f.type === t.type ? null : f.child
              else if (f.tag === _) {
                var FI = f.return
                if (FI === null)
                  throw new Error(
                    "We just came from a parent so we must have had a parent. This is a bug in React.",
                  )
                FI.lanes = WI(FI.lanes, c)
                var KI = FI.alternate
                ;(KI !== null && (KI.lanes = WI(KI.lanes, c)), Gw(FI, c, t), (G = f.sibling))
              } else G = f.child
              if (G !== null) G.return = f
              else
                for (G = f; G !== null; ) {
                  if (G === t) {
                    G = null
                    break
                  }
                  var OI = G.sibling
                  if (OI !== null) {
                    ;((OI.return = G.return), (G = OI))
                    break
                  }
                  G = G.return
                }
              f = G
            }
          }
          function rl(t, Q) {
            ;((pc = t), (wc = null), (ww = null))
            var c = t.dependencies
            if (c !== null) {
              var f = c.firstContext
              f !== null && (zA(c.lanes, Q) && t0(), (c.firstContext = null))
            }
          }
          function KB(t) {
            Rh &&
              B(
                "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().",
              )
            var Q = t._currentValue
            if (ww !== t) {
              var c = {
                context: t,
                memoizedValue: Q,
                next: null,
              }
              if (wc === null) {
                if (pc === null)
                  throw new Error(
                    "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().",
                  )
                ;((wc = c),
                  (pc.dependencies = {
                    lanes: Ag,
                    firstContext: c,
                  }))
              } else wc = wc.next = c
            }
            return Q
          }
          var AQ = null
          function Pd(t) {
            AQ === null ? (AQ = [t]) : AQ.push(t)
          }
          function kw() {
            if (AQ !== null) {
              for (var t = 0; t < AQ.length; t++) {
                var Q = AQ[t],
                  c = Q.interleaved
                if (c !== null) {
                  Q.interleaved = null
                  var f = c.next,
                    G = Q.pending
                  if (G !== null) {
                    var m = G.next
                    ;((G.next = f), (c.next = m))
                  }
                  Q.pending = c
                }
              }
              AQ = null
            }
          }
          function Mw(t, Q, c, f) {
            var G = Q.interleaved
            return (
              G === null ? ((c.next = c), Pd(Q)) : ((c.next = G.next), (G.next = c)),
              (Q.interleaved = c),
              Wd(t, f)
            )
          }
          function RR(t, Q, c, f) {
            var G = Q.interleaved
            ;(G === null ? ((c.next = c), Pd(Q)) : ((c.next = G.next), (G.next = c)),
              (Q.interleaved = c))
          }
          function JR(t, Q, c, f) {
            var G = Q.interleaved
            return (
              G === null ? ((c.next = c), Pd(Q)) : ((c.next = G.next), (G.next = c)),
              (Q.interleaved = c),
              Wd(t, f)
            )
          }
          function mB(t, Q) {
            return Wd(t, Q)
          }
          var Ok = Wd
          function Wd(t, Q) {
            t.lanes = WI(t.lanes, Q)
            var c = t.alternate
            ;(c !== null && (c.lanes = WI(c.lanes, Q)),
              c === null && (t.flags & (te | hQ)) !== nC && KY(t))
            for (var f = t, G = t.return; G !== null; )
              ((G.childLanes = WI(G.childLanes, Q)),
                (c = G.alternate),
                c !== null
                  ? (c.childLanes = WI(c.childLanes, Q))
                  : (G.flags & (te | hQ)) !== nC && KY(t),
                (f = G),
                (G = G.return))
            if (f.tag === S) {
              var m = f.stateNode
              return m
            } else return null
          }
          var _k = 0,
            Zk = 1,
            Vd = 2,
            ju = 3,
            jd = !1,
            Uw,
            Jh
          ;((Uw = !1), (Jh = null))
          function FS(t) {
            var Q = {
              baseState: t.memoizedState,
              firstBaseUpdate: null,
              lastBaseUpdate: null,
              shared: {
                pending: null,
                interleaved: null,
                lanes: Ag,
              },
              effects: null,
            }
            t.updateQueue = Q
          }
          function kc(t, Q) {
            var c = Q.updateQueue,
              f = t.updateQueue
            if (c === f) {
              var G = {
                baseState: f.baseState,
                firstBaseUpdate: f.firstBaseUpdate,
                lastBaseUpdate: f.lastBaseUpdate,
                shared: f.shared,
                effects: f.effects,
              }
              Q.updateQueue = G
            }
          }
          function cs(t, Q) {
            var c = {
              eventTime: t,
              lane: Q,
              tag: _k,
              payload: null,
              callback: null,
              next: null,
            }
            return c
          }
          function sl(t, Q, c) {
            var f = t.updateQueue
            if (f === null) return null
            var G = f.shared
            if (
              (Jh === G &&
                !Uw &&
                (B(
                  "An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.",
                ),
                (Uw = !0)),
              K4())
            ) {
              var m = G.pending
              return (
                m === null ? (Q.next = Q) : ((Q.next = m.next), (m.next = Q)),
                (G.pending = Q),
                Ok(t, c)
              )
            } else return JR(t, G, Q, c)
          }
          function RS(t, Q, c) {
            var f = Q.updateQueue
            if (f !== null) {
              var G = f.shared
              if (DC(c)) {
                var m = G.lanes
                m = WC(m, t.pendingLanes)
                var x = WI(m, c)
                ;((G.lanes = x), hu(t, x))
              }
            }
          }
          function Nw(t, Q) {
            var c = t.updateQueue,
              f = t.alternate
            if (f !== null) {
              var G = f.updateQueue
              if (c === G) {
                var m = null,
                  x = null,
                  z = c.firstBaseUpdate
                if (z !== null) {
                  var gA = z
                  do {
                    var hA = {
                      eventTime: gA.eventTime,
                      lane: gA.lane,
                      tag: gA.tag,
                      payload: gA.payload,
                      callback: gA.callback,
                      next: null,
                    }
                    ;(x === null ? (m = x = hA) : ((x.next = hA), (x = hA)), (gA = gA.next))
                  } while (gA !== null)
                  x === null ? (m = x = Q) : ((x.next = Q), (x = Q))
                } else m = x = Q
                ;((c = {
                  baseState: G.baseState,
                  firstBaseUpdate: m,
                  lastBaseUpdate: x,
                  shared: G.shared,
                  effects: G.effects,
                }),
                  (t.updateQueue = c))
                return
              }
            }
            var pA = c.lastBaseUpdate
            ;(pA === null ? (c.firstBaseUpdate = Q) : (pA.next = Q), (c.lastBaseUpdate = Q))
          }
          function zd(t, Q, c, f, G, m) {
            switch (c.tag) {
              case Zk: {
                var x = c.payload
                if (typeof x == "function") {
                  US()
                  var z = x.call(m, f, G)
                  {
                    if (t.mode & rC) {
                      Qi(!0)
                      try {
                        x.call(m, f, G)
                      } finally {
                        Qi(!1)
                      }
                    }
                    NS()
                  }
                  return z
                }
                return x
              }
              case ju:
                t.flags = (t.flags & ~Xt) | kC
              // Intentional fallthrough
              case _k: {
                var gA = c.payload,
                  hA
                if (typeof gA == "function") {
                  ;(US(), (hA = gA.call(m, f, G)))
                  {
                    if (t.mode & rC) {
                      Qi(!0)
                      try {
                        gA.call(m, f, G)
                      } finally {
                        Qi(!1)
                      }
                    }
                    NS()
                  }
                } else hA = gA
                return hA == null ? f : rg({}, f, hA)
              }
              case Vd:
                return ((jd = !0), f)
            }
            return f
          }
          function Xd(t, Q, c, f) {
            var G = t.updateQueue
            ;((jd = !1), (Jh = G.shared))
            var m = G.firstBaseUpdate,
              x = G.lastBaseUpdate,
              z = G.shared.pending
            if (z !== null) {
              G.shared.pending = null
              var gA = z,
                hA = gA.next
              ;((gA.next = null), x === null ? (m = hA) : (x.next = hA), (x = gA))
              var pA = t.alternate
              if (pA !== null) {
                var gI = pA.updateQueue,
                  $A = gI.lastBaseUpdate
                $A !== x &&
                  ($A === null ? (gI.firstBaseUpdate = hA) : ($A.next = hA),
                  (gI.lastBaseUpdate = gA))
              }
            }
            if (m !== null) {
              var FI = G.baseState,
                KI = Ag,
                OI = null,
                Lg = null,
                yC = null,
                EC = m
              do {
                var We = EC.lane,
                  Le = EC.eventTime
                if (JI(f, We)) {
                  if (yC !== null) {
                    var _I = {
                      eventTime: Le,
                      // This update is going to be committed so we never want uncommit
                      // it. Using NoLane works because 0 is a subset of all bitmasks, so
                      // this will never be skipped by the check above.
                      lane: ct,
                      tag: EC.tag,
                      payload: EC.payload,
                      callback: EC.callback,
                      next: null,
                    }
                    yC = yC.next = _I
                  }
                  FI = zd(t, G, EC, FI, Q, c)
                  var dI = EC.callback
                  if (
                    dI !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    EC.lane !== ct
                  ) {
                    t.flags |= nn
                    var sg = G.effects
                    sg === null ? (G.effects = [EC]) : sg.push(EC)
                  }
                } else {
                  var fI = {
                    eventTime: Le,
                    lane: We,
                    tag: EC.tag,
                    payload: EC.payload,
                    callback: EC.callback,
                    next: null,
                  }
                  ;(yC === null ? ((Lg = yC = fI), (OI = FI)) : (yC = yC.next = fI),
                    (KI = WI(KI, We)))
                }
                if (((EC = EC.next), EC === null)) {
                  if (((z = G.shared.pending), z === null)) break
                  var _g = z,
                    Hg = _g.next
                  ;((_g.next = null), (EC = Hg), (G.lastBaseUpdate = _g), (G.shared.pending = null))
                }
              } while (!0)
              ;(yC === null && (OI = FI),
                (G.baseState = OI),
                (G.firstBaseUpdate = Lg),
                (G.lastBaseUpdate = yC))
              var xC = G.shared.interleaved
              if (xC !== null) {
                var Ce = xC
                do ((KI = WI(KI, Ce.lane)), (Ce = Ce.next))
                while (Ce !== xC)
              } else m === null && (G.shared.lanes = Ag)
              ;(u0(KI), (t.lanes = KI), (t.memoizedState = FI))
            }
            Jh = null
          }
          function Fw(t, Q) {
            if (typeof t != "function")
              throw new Error(
                "Invalid argument passed as callback. Expected a function. Instead " +
                  ("received: " + t),
              )
            t.call(Q)
          }
          function Pk() {
            jd = !1
          }
          function $d() {
            return jd
          }
          function JS(t, Q, c) {
            var f = Q.effects
            if (((Q.effects = null), f !== null))
              for (var G = 0; G < f.length; G++) {
                var m = f[G],
                  x = m.callback
                x !== null && ((m.callback = null), Fw(x, c))
              }
          }
          var KS = {},
            Mc = Bl(KS),
            mS = Bl(KS),
            vS = Bl(KS)
          function LS(t) {
            if (t === KS)
              throw new Error(
                "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.",
              )
            return t
          }
          function Uc() {
            var t = LS(vS.current)
            return t
          }
          function Rw(t, Q) {
            ;(xo(vS, Q, t), xo(mS, t, t), xo(Mc, KS, t))
            var c = gR(Q)
            ;(To(Mc, t), xo(Mc, c, t))
          }
          function dn(t) {
            ;(To(Mc, t), To(mS, t), To(vS, t))
          }
          function Jw() {
            var t = LS(Mc.current)
            return t
          }
          function Wk(t) {
            LS(vS.current)
            var Q = LS(Mc.current),
              c = tk(Q, t.type)
            Q !== c && (xo(mS, t, t), xo(Mc, c, t))
          }
          function Ay(t) {
            mS.current === t && (To(Mc, t), To(mS, t))
          }
          var KR = 0,
            Vk = 1,
            jk = 1,
            zu = 2,
            Bt = Bl(KR)
          function Kw(t, Q) {
            return (t & Q) !== 0
          }
          function Kh(t) {
            return t & Vk
          }
          function mw(t, Q) {
            return (t & Vk) | Q
          }
          function mR(t, Q) {
            return t | Q
          }
          function Nc(t, Q) {
            xo(Bt, Q, t)
          }
          function Xu(t) {
            To(Bt, t)
          }
          function vR(t, Q) {
            var c = t.memoizedState
            return c !== null ? c.dehydrated !== null : (t.memoizedProps, !0)
          }
          function YS(t) {
            for (var Q = t; Q !== null; ) {
              if (Q.tag === V) {
                var c = Q.memoizedState
                if (c !== null) {
                  var f = c.dehydrated
                  if (f === null || iw(f) || tw(f)) return Q
                }
              } else if (
                Q.tag === eA && // revealOrder undefined can't be trusted because it don't
                // keep track of whether it suspended or not.
                Q.memoizedProps.revealOrder !== void 0
              ) {
                var G = (Q.flags & kC) !== nC
                if (G) return Q
              } else if (Q.child !== null) {
                ;((Q.child.return = Q), (Q = Q.child))
                continue
              }
              if (Q === t) return null
              for (; Q.sibling === null; ) {
                if (Q.return === null || Q.return === t) return null
                Q = Q.return
              }
              ;((Q.sibling.return = Q.return), (Q = Q.sibling))
            }
            return null
          }
          var Eo =
              /*   */
              0,
            DB =
              /* */
              1,
            Ur =
              /*  */
              2,
            vB =
              /*    */
              4,
            ao =
              /*   */
              8,
            Iy = []
          function qS() {
            for (var t = 0; t < Iy.length; t++) {
              var Q = Iy[t]
              Q._workInProgressVersionPrimary = null
            }
            Iy.length = 0
          }
          function LR(t, Q) {
            var c = Q._getVersion,
              f = c(Q._source)
            t.mutableSourceEagerHydrationData == null
              ? (t.mutableSourceEagerHydrationData = [Q, f])
              : t.mutableSourceEagerHydrationData.push(Q, f)
          }
          var Jg = I.ReactCurrentDispatcher,
            mh = I.ReactCurrentBatchConfig,
            $u,
            vh
          $u = /* @__PURE__ */ new Set()
          var Fc = Ag,
            Ji = null,
            GQ = null,
            Ki = null,
            ll = !1,
            HS = !1,
            hs = 0,
            vw = 0,
            Lw = 25,
            jI = null,
            bE = null,
            Rc = -1,
            Yw = !1
          function gi() {
            {
              var t = jI
              bE === null ? (bE = [t]) : bE.push(t)
            }
          }
          function Ng() {
            {
              var t = jI
              bE !== null && (Rc++, bE[Rc] !== t && YR(t))
            }
          }
          function Jc(t) {
            t != null &&
              !le(t) &&
              B(
                "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
                jI,
                typeof t,
              )
          }
          function YR(t) {
            {
              var Q = oC(Ji)
              if (!$u.has(Q) && ($u.add(Q), bE !== null)) {
                for (var c = "", f = 30, G = 0; G <= Rc; G++) {
                  for (var m = bE[G], x = G === Rc ? t : m, z = G + 1 + ". " + m; z.length < f; )
                    z += " "
                  ;((z +=
                    x +
                    `
`),
                    (c += z))
                }
                B(
                  `React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`,
                  Q,
                  c,
                )
              }
            }
          }
          function _o() {
            throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`)
          }
          function TS(t, Q) {
            if (Yw) return !1
            if (Q === null)
              return (
                B(
                  "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
                  jI,
                ),
                !1
              )
            t.length !== Q.length &&
              B(
                `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
                jI,
                "[" + Q.join(", ") + "]",
                "[" + t.join(", ") + "]",
              )
            for (var c = 0; c < Q.length && c < t.length; c++) if (!Vg(t[c], Q[c])) return !1
            return !0
          }
          function Lh(t, Q, c, f, G, m) {
            ;((Fc = m),
              (Ji = Q),
              (bE = t !== null ? t._debugHookTypes : null),
              (Rc = -1),
              (Yw = t !== null && t.type !== Q.type),
              (Q.memoizedState = null),
              (Q.updateQueue = null),
              (Q.lanes = Ag),
              t !== null && t.memoizedState !== null
                ? (Jg.current = n)
                : bE !== null
                  ? (Jg.current = tM)
                  : (Jg.current = iM))
            var x = c(f, G)
            if (HS) {
              var z = 0
              do {
                if (((HS = !1), (hs = 0), z >= Lw))
                  throw new Error(
                    "Too many re-renders. React limits the number of renders to prevent an infinite loop.",
                  )
                ;((z += 1),
                  (Yw = !1),
                  (GQ = null),
                  (Ki = null),
                  (Q.updateQueue = null),
                  (Rc = -1),
                  (Jg.current = a),
                  (x = c(f, G)))
              } while (HS)
            }
            ;((Jg.current = uy), (Q._debugHookTypes = bE))
            var gA = GQ !== null && GQ.next !== null
            if (
              ((Fc = Ag),
              (Ji = null),
              (GQ = null),
              (Ki = null),
              (jI = null),
              (bE = null),
              (Rc = -1),
              t !== null &&
                (t.flags & lg) !== (Q.flags & lg) && // Disable this warning in legacy mode, because legacy Suspense is weird
                // and creates false positives. To make this work in legacy mode, we'd
                // need to mark fibers that commit in an incomplete state, somehow. For
                // now I'll disable the warning that most of the bugs that would trigger
                // it are either exclusive to concurrent mode or exist in both.
                (t.mode & Pg) !== zg &&
                B(
                  "Internal React error: Expected static flag was missing. Please notify the React team.",
                ),
              (ll = !1),
              gA)
            )
              throw new Error(
                "Rendered fewer hooks than expected. This may be caused by an accidental early return statement.",
              )
            return x
          }
          function AD() {
            var t = hs !== 0
            return ((hs = 0), t)
          }
          function tE(t, Q, c) {
            ;((Q.updateQueue = t.updateQueue),
              (Q.mode & xt) !== zg ? (Q.flags &= ~(Uo | Ne | Ri | IC)) : (Q.flags &= ~(Ri | IC)),
              (t.lanes = Zg(t.lanes, c)))
          }
          function gy() {
            if (((Jg.current = uy), ll)) {
              for (var t = Ji.memoizedState; t !== null; ) {
                var Q = t.queue
                ;(Q !== null && (Q.pending = null), (t = t.next))
              }
              ll = !1
            }
            ;((Fc = Ag),
              (Ji = null),
              (GQ = null),
              (Ki = null),
              (bE = null),
              (Rc = -1),
              (jI = null),
              (Xw = !1),
              (HS = !1),
              (hs = 0))
          }
          function us() {
            var t = {
              memoizedState: null,
              baseState: null,
              baseQueue: null,
              queue: null,
              next: null,
            }
            return (Ki === null ? (Ji.memoizedState = Ki = t) : (Ki = Ki.next = t), Ki)
          }
          function Ua() {
            var t
            if (GQ === null) {
              var Q = Ji.alternate
              Q !== null ? (t = Q.memoizedState) : (t = null)
            } else t = GQ.next
            var c
            if ((Ki === null ? (c = Ji.memoizedState) : (c = Ki.next), c !== null))
              ((Ki = c), (c = Ki.next), (GQ = t))
            else {
              if (t === null)
                throw new Error("Rendered more hooks than during the previous render.")
              GQ = t
              var f = {
                memoizedState: GQ.memoizedState,
                baseState: GQ.baseState,
                baseQueue: GQ.baseQueue,
                queue: GQ.queue,
                next: null,
              }
              Ki === null ? (Ji.memoizedState = Ki = f) : (Ki = Ki.next = f)
            }
            return Ki
          }
          function Kc() {
            return {
              lastEffect: null,
              stores: null,
            }
          }
          function qw(t, Q) {
            return typeof Q == "function" ? Q(t) : Q
          }
          function Hw(t, Q, c) {
            var f = us(),
              G
            ;(c !== void 0 ? (G = c(Q)) : (G = Q), (f.memoizedState = f.baseState = G))
            var m = {
              pending: null,
              interleaved: null,
              lanes: Ag,
              dispatch: null,
              lastRenderedReducer: t,
              lastRenderedState: G,
            }
            f.queue = m
            var x = (m.dispatch = gM.bind(null, Ji, m))
            return [f.memoizedState, x]
          }
          function xS(t, Q, c) {
            var f = Ua(),
              G = f.queue
            if (G === null)
              throw new Error(
                "Should have a queue. This is likely a bug in React. Please file an issue.",
              )
            G.lastRenderedReducer = t
            var m = GQ,
              x = m.baseQueue,
              z = G.pending
            if (z !== null) {
              if (x !== null) {
                var gA = x.next,
                  hA = z.next
                ;((x.next = hA), (z.next = gA))
              }
              ;(m.baseQueue !== x &&
                B(
                  "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.",
                ),
                (m.baseQueue = x = z),
                (G.pending = null))
            }
            if (x !== null) {
              var pA = x.next,
                gI = m.baseState,
                $A = null,
                FI = null,
                KI = null,
                OI = pA
              do {
                var Lg = OI.lane
                if (JI(Fc, Lg)) {
                  if (KI !== null) {
                    var EC = {
                      // This update is going to be committed so we never want uncommit
                      // it. Using NoLane works because 0 is a subset of all bitmasks, so
                      // this will never be skipped by the check above.
                      lane: ct,
                      action: OI.action,
                      hasEagerState: OI.hasEagerState,
                      eagerState: OI.eagerState,
                      next: null,
                    }
                    KI = KI.next = EC
                  }
                  if (OI.hasEagerState) gI = OI.eagerState
                  else {
                    var We = OI.action
                    gI = t(gI, We)
                  }
                } else {
                  var yC = {
                    lane: Lg,
                    action: OI.action,
                    hasEagerState: OI.hasEagerState,
                    eagerState: OI.eagerState,
                    next: null,
                  }
                  ;(KI === null ? ((FI = KI = yC), ($A = gI)) : (KI = KI.next = yC),
                    (Ji.lanes = WI(Ji.lanes, Lg)),
                    u0(Lg))
                }
                OI = OI.next
              } while (OI !== null && OI !== pA)
              ;(KI === null ? ($A = gI) : (KI.next = FI),
                Vg(gI, f.memoizedState) || t0(),
                (f.memoizedState = gI),
                (f.baseState = $A),
                (f.baseQueue = KI),
                (G.lastRenderedState = gI))
            }
            var Le = G.interleaved
            if (Le !== null) {
              var fI = Le
              do {
                var _I = fI.lane
                ;((Ji.lanes = WI(Ji.lanes, _I)), u0(_I), (fI = fI.next))
              } while (fI !== Le)
            } else x === null && (G.lanes = Ag)
            var dI = G.dispatch
            return [f.memoizedState, dI]
          }
          function bS(t, Q, c) {
            var f = Ua(),
              G = f.queue
            if (G === null)
              throw new Error(
                "Should have a queue. This is likely a bug in React. Please file an issue.",
              )
            G.lastRenderedReducer = t
            var m = G.dispatch,
              x = G.pending,
              z = f.memoizedState
            if (x !== null) {
              G.pending = null
              var gA = x.next,
                hA = gA
              do {
                var pA = hA.action
                ;((z = t(z, pA)), (hA = hA.next))
              } while (hA !== gA)
              ;(Vg(z, f.memoizedState) || t0(),
                (f.memoizedState = z),
                f.baseQueue === null && (f.baseState = z),
                (G.lastRenderedState = z))
            }
            return [z, m]
          }
          function Yh(t, Q, c) {}
          function GL(t, Q, c) {}
          function Tw(t, Q, c) {
            var f = Ji,
              G = us(),
              m,
              x = it()
            if (x) {
              if (c === void 0)
                throw new Error(
                  "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.",
                )
              ;((m = c()),
                vh ||
                  (m !== c() &&
                    (B(
                      "The result of getServerSnapshot should be cached to avoid an infinite loop",
                    ),
                    (vh = !0))))
            } else {
              if (((m = Q()), !vh)) {
                var z = Q()
                Vg(m, z) ||
                  (B("The result of getSnapshot should be cached to avoid an infinite loop"),
                  (vh = !0))
              }
              var gA = SM()
              if (gA === null)
                throw new Error(
                  "Expected a work-in-progress root. This is a bug in React. Please file an issue.",
                )
              ng(gA, Fc) || xw(f, Q, m)
            }
            G.memoizedState = m
            var hA = {
              value: m,
              getSnapshot: Q,
            }
            return (
              (G.queue = hA),
              By(zk.bind(null, f, hA, t), [t]),
              (f.flags |= Ri),
              _S(DB | ao, ey.bind(null, f, hA, m, Q), void 0, null),
              m
            )
          }
          function Cy(t, Q, c) {
            var f = Ji,
              G = Ua(),
              m = Q()
            if (!vh) {
              var x = Q()
              Vg(m, x) ||
                (B("The result of getSnapshot should be cached to avoid an infinite loop"),
                (vh = !0))
            }
            var z = G.memoizedState,
              gA = !Vg(z, m)
            gA && ((G.memoizedState = m), t0())
            var hA = G.queue
            if (
              (PS(zk.bind(null, f, hA, t), [t]),
              hA.getSnapshot !== Q ||
                gA || // Check if the susbcribe function changed. We can save some memory by
                // checking whether we scheduled a subscription effect above.
                (Ki !== null && Ki.memoizedState.tag & DB))
            ) {
              ;((f.flags |= Ri), _S(DB | ao, ey.bind(null, f, hA, m, Q), void 0, null))
              var pA = SM()
              if (pA === null)
                throw new Error(
                  "Expected a work-in-progress root. This is a bug in React. Please file an issue.",
                )
              ng(pA, Fc) || xw(f, Q, m)
            }
            return m
          }
          function xw(t, Q, c) {
            t.flags |= Qa
            var f = {
                getSnapshot: Q,
                value: c,
              },
              G = Ji.updateQueue
            if (G === null) ((G = Kc()), (Ji.updateQueue = G), (G.stores = [f]))
            else {
              var m = G.stores
              m === null ? (G.stores = [f]) : m.push(f)
            }
          }
          function ey(t, Q, c, f) {
            ;((Q.value = c), (Q.getSnapshot = f), Xk(Q) && iy(t))
          }
          function zk(t, Q, c) {
            var f = function () {
              Xk(Q) && iy(t)
            }
            return c(f)
          }
          function Xk(t) {
            var Q = t.getSnapshot,
              c = t.value
            try {
              var f = Q()
              return !Vg(c, f)
            } catch {
              return !0
            }
          }
          function iy(t) {
            var Q = mB(t, bg)
            Q !== null && co(Q, t, bg, ue)
          }
          function OS(t) {
            var Q = us()
            ;(typeof t == "function" && (t = t()), (Q.memoizedState = Q.baseState = t))
            var c = {
              pending: null,
              interleaved: null,
              lanes: Ag,
              dispatch: null,
              lastRenderedReducer: qw,
              lastRenderedState: t,
            }
            Q.queue = c
            var f = (c.dispatch = CM.bind(null, Ji, c))
            return [Q.memoizedState, f]
          }
          function bw(t) {
            return xS(qw)
          }
          function ty(t) {
            return bS(qw)
          }
          function _S(t, Q, c, f) {
            var G = {
                tag: t,
                create: Q,
                destroy: c,
                deps: f,
                // Circular
                next: null,
              },
              m = Ji.updateQueue
            if (m === null) ((m = Kc()), (Ji.updateQueue = m), (m.lastEffect = G.next = G))
            else {
              var x = m.lastEffect
              if (x === null) m.lastEffect = G.next = G
              else {
                var z = x.next
                ;((x.next = G), (G.next = z), (m.lastEffect = G))
              }
            }
            return G
          }
          function Ow(t) {
            var Q = us()
            {
              var c = {
                current: t,
              }
              return ((Q.memoizedState = c), c)
            }
          }
          function ID(t) {
            var Q = Ua()
            return Q.memoizedState
          }
          function qh(t, Q, c, f) {
            var G = us(),
              m = f === void 0 ? null : f
            ;((Ji.flags |= t), (G.memoizedState = _S(DB | Q, c, void 0, m)))
          }
          function ZS(t, Q, c, f) {
            var G = Ua(),
              m = f === void 0 ? null : f,
              x = void 0
            if (GQ !== null) {
              var z = GQ.memoizedState
              if (((x = z.destroy), m !== null)) {
                var gA = z.deps
                if (TS(m, gA)) {
                  G.memoizedState = _S(Q, c, x, m)
                  return
                }
              }
            }
            ;((Ji.flags |= t), (G.memoizedState = _S(DB | Q, c, x, m)))
          }
          function By(t, Q) {
            return (Ji.mode & xt) !== zg ? qh(Uo | Ri | En, ao, t, Q) : qh(Ri | En, ao, t, Q)
          }
          function PS(t, Q) {
            return ZS(Ri, ao, t, Q)
          }
          function _w(t, Q) {
            return qh(IC, Ur, t, Q)
          }
          function Qy(t, Q) {
            return ZS(IC, Ur, t, Q)
          }
          function oy(t, Q) {
            var c = IC
            return ((c |= st), (Ji.mode & xt) !== zg && (c |= Ne), qh(c, vB, t, Q))
          }
          function ny(t, Q) {
            return ZS(IC, vB, t, Q)
          }
          function $k(t, Q) {
            if (typeof Q == "function") {
              var c = Q,
                f = t()
              return (
                c(f),
                function () {
                  c(null)
                }
              )
            } else if (Q != null) {
              var G = Q
              G.hasOwnProperty("current") ||
                B(
                  "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
                  "an object with keys {" + Object.keys(G).join(", ") + "}",
                )
              var m = t()
              return (
                (G.current = m),
                function () {
                  G.current = null
                }
              )
            }
          }
          function Ey(t, Q, c) {
            typeof Q != "function" &&
              B(
                "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
                Q !== null ? typeof Q : "null",
              )
            var f = c != null ? c.concat([t]) : null,
              G = IC
            return (
              (G |= st),
              (Ji.mode & xt) !== zg && (G |= Ne),
              qh(G, vB, $k.bind(null, Q, t), f)
            )
          }
          function gD(t, Q, c) {
            typeof Q != "function" &&
              B(
                "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
                Q !== null ? typeof Q : "null",
              )
            var f = c != null ? c.concat([t]) : null
            return ZS(IC, vB, $k.bind(null, Q, t), f)
          }
          function qR(t, Q) {}
          var ay = qR
          function Zw(t, Q) {
            var c = us(),
              f = Q === void 0 ? null : Q
            return ((c.memoizedState = [t, f]), t)
          }
          function WS(t, Q) {
            var c = Ua(),
              f = Q === void 0 ? null : Q,
              G = c.memoizedState
            if (G !== null && f !== null) {
              var m = G[1]
              if (TS(f, m)) return G[0]
            }
            return ((c.memoizedState = [t, f]), t)
          }
          function ry(t, Q) {
            var c = us(),
              f = Q === void 0 ? null : Q,
              G = t()
            return ((c.memoizedState = [G, f]), G)
          }
          function VS(t, Q) {
            var c = Ua(),
              f = Q === void 0 ? null : Q,
              G = c.memoizedState
            if (G !== null && f !== null) {
              var m = G[1]
              if (TS(f, m)) return G[0]
            }
            var x = t()
            return ((c.memoizedState = [x, f]), x)
          }
          function sy(t) {
            var Q = us()
            return ((Q.memoizedState = t), t)
          }
          function Pw(t) {
            var Q = Ua(),
              c = GQ,
              f = c.memoizedState
            return Vw(Q, f, t)
          }
          function Ww(t) {
            var Q = Ua()
            if (GQ === null) return ((Q.memoizedState = t), t)
            var c = GQ.memoizedState
            return Vw(Q, c, t)
          }
          function Vw(t, Q, c) {
            var f = !CI(Fc)
            if (f) {
              if (!Vg(c, Q)) {
                var G = sC()
                ;((Ji.lanes = WI(Ji.lanes, G)), u0(G), (t.baseState = !0))
              }
              return Q
            } else return (t.baseState && ((t.baseState = !1), t0()), (t.memoizedState = c), c)
          }
          function AM(t, Q, c) {
            var f = hn()
            ;(gt(qD(f, LE)), t(!0))
            var G = mh.transition
            mh.transition = {}
            var m = mh.transition
            mh.transition._updatedFibers = /* @__PURE__ */ new Set()
            try {
              ;(t(!1), Q())
            } finally {
              if ((gt(f), (mh.transition = G), G === null && m._updatedFibers)) {
                var x = m._updatedFibers.size
                ;(x > 10 &&
                  i(
                    "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.",
                  ),
                  m._updatedFibers.clear())
              }
            }
          }
          function ly() {
            var t = OS(!1),
              Q = t[0],
              c = t[1],
              f = AM.bind(null, c),
              G = us()
            return ((G.memoizedState = f), [Q, f])
          }
          function jw() {
            var t = bw(),
              Q = t[0],
              c = Ua(),
              f = c.memoizedState
            return [Q, f]
          }
          function zw() {
            var t = ty(),
              Q = t[0],
              c = Ua(),
              f = c.memoizedState
            return [Q, f]
          }
          var Xw = !1
          function IM() {
            return Xw
          }
          function cy() {
            var t = us(),
              Q = SM(),
              c = Q.identifierPrefix,
              f
            if (it()) {
              var G = kR()
              f = ":" + c + "R" + G
              var m = hs++
              ;(m > 0 && (f += "H" + m.toString(32)), (f += ":"))
            } else {
              var x = vw++
              f = ":" + c + "r" + x.toString(32) + ":"
            }
            return ((t.memoizedState = f), f)
          }
          function jS() {
            var t = Ua(),
              Q = t.memoizedState
            return Q
          }
          function gM(t, Q, c) {
            typeof arguments[3] == "function" &&
              B(
                "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().",
              )
            var f = tD(t),
              G = {
                lane: f,
                action: c,
                hasEagerState: !1,
                eagerState: null,
                next: null,
              }
            if ($w(t)) A0(Q, G)
            else {
              var m = Mw(t, Q, G, f)
              if (m !== null) {
                var x = ZE()
                ;(co(m, t, f, x), hy(m, Q, f))
              }
            }
            eM(t, f)
          }
          function CM(t, Q, c) {
            typeof arguments[3] == "function" &&
              B(
                "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().",
              )
            var f = tD(t),
              G = {
                lane: f,
                action: c,
                hasEagerState: !1,
                eagerState: null,
                next: null,
              }
            if ($w(t)) A0(Q, G)
            else {
              var m = t.alternate
              if (t.lanes === Ag && (m === null || m.lanes === Ag)) {
                var x = Q.lastRenderedReducer
                if (x !== null) {
                  var z
                  ;((z = Jg.current), (Jg.current = k))
                  try {
                    var gA = Q.lastRenderedState,
                      hA = x(gA, c)
                    if (((G.hasEagerState = !0), (G.eagerState = hA), Vg(hA, gA))) {
                      RR(t, Q, G, f)
                      return
                    }
                  } catch {
                  } finally {
                    Jg.current = z
                  }
                }
              }
              var pA = Mw(t, Q, G, f)
              if (pA !== null) {
                var gI = ZE()
                ;(co(pA, t, f, gI), hy(pA, Q, f))
              }
            }
            eM(t, f)
          }
          function $w(t) {
            var Q = t.alternate
            return t === Ji || (Q !== null && Q === Ji)
          }
          function A0(t, Q) {
            HS = ll = !0
            var c = t.pending
            ;(c === null ? (Q.next = Q) : ((Q.next = c.next), (c.next = Q)), (t.pending = Q))
          }
          function hy(t, Q, c) {
            if (DC(c)) {
              var f = Q.lanes
              f = WC(f, t.pendingLanes)
              var G = WI(f, c)
              ;((Q.lanes = G), hu(t, G))
            }
          }
          function eM(t, Q, c) {
            JE(t, Q)
          }
          var uy = {
              readContext: KB,
              useCallback: _o,
              useContext: _o,
              useEffect: _o,
              useImperativeHandle: _o,
              useInsertionEffect: _o,
              useLayoutEffect: _o,
              useMemo: _o,
              useReducer: _o,
              useRef: _o,
              useState: _o,
              useDebugValue: _o,
              useDeferredValue: _o,
              useTransition: _o,
              useMutableSource: _o,
              useSyncExternalStore: _o,
              useId: _o,
              unstable_isNewReconciler: nA,
            },
            iM = null,
            tM = null,
            n = null,
            a = null,
            y = null,
            k = null,
            J = null
          {
            var T = function () {
                B(
                  "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().",
                )
              },
              W = function () {
                B(
                  "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks",
                )
              }
            ;((iM = {
              readContext: function (t) {
                return KB(t)
              },
              useCallback: function (t, Q) {
                return ((jI = "useCallback"), gi(), Jc(Q), Zw(t, Q))
              },
              useContext: function (t) {
                return ((jI = "useContext"), gi(), KB(t))
              },
              useEffect: function (t, Q) {
                return ((jI = "useEffect"), gi(), Jc(Q), By(t, Q))
              },
              useImperativeHandle: function (t, Q, c) {
                return ((jI = "useImperativeHandle"), gi(), Jc(c), Ey(t, Q, c))
              },
              useInsertionEffect: function (t, Q) {
                return ((jI = "useInsertionEffect"), gi(), Jc(Q), _w(t, Q))
              },
              useLayoutEffect: function (t, Q) {
                return ((jI = "useLayoutEffect"), gi(), Jc(Q), oy(t, Q))
              },
              useMemo: function (t, Q) {
                ;((jI = "useMemo"), gi(), Jc(Q))
                var c = Jg.current
                Jg.current = y
                try {
                  return ry(t, Q)
                } finally {
                  Jg.current = c
                }
              },
              useReducer: function (t, Q, c) {
                ;((jI = "useReducer"), gi())
                var f = Jg.current
                Jg.current = y
                try {
                  return Hw(t, Q, c)
                } finally {
                  Jg.current = f
                }
              },
              useRef: function (t) {
                return ((jI = "useRef"), gi(), Ow(t))
              },
              useState: function (t) {
                ;((jI = "useState"), gi())
                var Q = Jg.current
                Jg.current = y
                try {
                  return OS(t)
                } finally {
                  Jg.current = Q
                }
              },
              useDebugValue: function (t, Q) {
                return ((jI = "useDebugValue"), gi(), void 0)
              },
              useDeferredValue: function (t) {
                return ((jI = "useDeferredValue"), gi(), sy(t))
              },
              useTransition: function () {
                return ((jI = "useTransition"), gi(), ly())
              },
              useMutableSource: function (t, Q, c) {
                return ((jI = "useMutableSource"), gi(), void 0)
              },
              useSyncExternalStore: function (t, Q, c) {
                return ((jI = "useSyncExternalStore"), gi(), Tw(t, Q, c))
              },
              useId: function () {
                return ((jI = "useId"), gi(), cy())
              },
              unstable_isNewReconciler: nA,
            }),
              (tM = {
                readContext: function (t) {
                  return KB(t)
                },
                useCallback: function (t, Q) {
                  return ((jI = "useCallback"), Ng(), Zw(t, Q))
                },
                useContext: function (t) {
                  return ((jI = "useContext"), Ng(), KB(t))
                },
                useEffect: function (t, Q) {
                  return ((jI = "useEffect"), Ng(), By(t, Q))
                },
                useImperativeHandle: function (t, Q, c) {
                  return ((jI = "useImperativeHandle"), Ng(), Ey(t, Q, c))
                },
                useInsertionEffect: function (t, Q) {
                  return ((jI = "useInsertionEffect"), Ng(), _w(t, Q))
                },
                useLayoutEffect: function (t, Q) {
                  return ((jI = "useLayoutEffect"), Ng(), oy(t, Q))
                },
                useMemo: function (t, Q) {
                  ;((jI = "useMemo"), Ng())
                  var c = Jg.current
                  Jg.current = y
                  try {
                    return ry(t, Q)
                  } finally {
                    Jg.current = c
                  }
                },
                useReducer: function (t, Q, c) {
                  ;((jI = "useReducer"), Ng())
                  var f = Jg.current
                  Jg.current = y
                  try {
                    return Hw(t, Q, c)
                  } finally {
                    Jg.current = f
                  }
                },
                useRef: function (t) {
                  return ((jI = "useRef"), Ng(), Ow(t))
                },
                useState: function (t) {
                  ;((jI = "useState"), Ng())
                  var Q = Jg.current
                  Jg.current = y
                  try {
                    return OS(t)
                  } finally {
                    Jg.current = Q
                  }
                },
                useDebugValue: function (t, Q) {
                  return ((jI = "useDebugValue"), Ng(), void 0)
                },
                useDeferredValue: function (t) {
                  return ((jI = "useDeferredValue"), Ng(), sy(t))
                },
                useTransition: function () {
                  return ((jI = "useTransition"), Ng(), ly())
                },
                useMutableSource: function (t, Q, c) {
                  return ((jI = "useMutableSource"), Ng(), void 0)
                },
                useSyncExternalStore: function (t, Q, c) {
                  return ((jI = "useSyncExternalStore"), Ng(), Tw(t, Q, c))
                },
                useId: function () {
                  return ((jI = "useId"), Ng(), cy())
                },
                unstable_isNewReconciler: nA,
              }),
              (n = {
                readContext: function (t) {
                  return KB(t)
                },
                useCallback: function (t, Q) {
                  return ((jI = "useCallback"), Ng(), WS(t, Q))
                },
                useContext: function (t) {
                  return ((jI = "useContext"), Ng(), KB(t))
                },
                useEffect: function (t, Q) {
                  return ((jI = "useEffect"), Ng(), PS(t, Q))
                },
                useImperativeHandle: function (t, Q, c) {
                  return ((jI = "useImperativeHandle"), Ng(), gD(t, Q, c))
                },
                useInsertionEffect: function (t, Q) {
                  return ((jI = "useInsertionEffect"), Ng(), Qy(t, Q))
                },
                useLayoutEffect: function (t, Q) {
                  return ((jI = "useLayoutEffect"), Ng(), ny(t, Q))
                },
                useMemo: function (t, Q) {
                  ;((jI = "useMemo"), Ng())
                  var c = Jg.current
                  Jg.current = k
                  try {
                    return VS(t, Q)
                  } finally {
                    Jg.current = c
                  }
                },
                useReducer: function (t, Q, c) {
                  ;((jI = "useReducer"), Ng())
                  var f = Jg.current
                  Jg.current = k
                  try {
                    return xS(t, Q, c)
                  } finally {
                    Jg.current = f
                  }
                },
                useRef: function (t) {
                  return ((jI = "useRef"), Ng(), ID())
                },
                useState: function (t) {
                  ;((jI = "useState"), Ng())
                  var Q = Jg.current
                  Jg.current = k
                  try {
                    return bw(t)
                  } finally {
                    Jg.current = Q
                  }
                },
                useDebugValue: function (t, Q) {
                  return ((jI = "useDebugValue"), Ng(), ay())
                },
                useDeferredValue: function (t) {
                  return ((jI = "useDeferredValue"), Ng(), Pw(t))
                },
                useTransition: function () {
                  return ((jI = "useTransition"), Ng(), jw())
                },
                useMutableSource: function (t, Q, c) {
                  return ((jI = "useMutableSource"), Ng(), void 0)
                },
                useSyncExternalStore: function (t, Q, c) {
                  return ((jI = "useSyncExternalStore"), Ng(), Cy(t, Q))
                },
                useId: function () {
                  return ((jI = "useId"), Ng(), jS())
                },
                unstable_isNewReconciler: nA,
              }),
              (a = {
                readContext: function (t) {
                  return KB(t)
                },
                useCallback: function (t, Q) {
                  return ((jI = "useCallback"), Ng(), WS(t, Q))
                },
                useContext: function (t) {
                  return ((jI = "useContext"), Ng(), KB(t))
                },
                useEffect: function (t, Q) {
                  return ((jI = "useEffect"), Ng(), PS(t, Q))
                },
                useImperativeHandle: function (t, Q, c) {
                  return ((jI = "useImperativeHandle"), Ng(), gD(t, Q, c))
                },
                useInsertionEffect: function (t, Q) {
                  return ((jI = "useInsertionEffect"), Ng(), Qy(t, Q))
                },
                useLayoutEffect: function (t, Q) {
                  return ((jI = "useLayoutEffect"), Ng(), ny(t, Q))
                },
                useMemo: function (t, Q) {
                  ;((jI = "useMemo"), Ng())
                  var c = Jg.current
                  Jg.current = J
                  try {
                    return VS(t, Q)
                  } finally {
                    Jg.current = c
                  }
                },
                useReducer: function (t, Q, c) {
                  ;((jI = "useReducer"), Ng())
                  var f = Jg.current
                  Jg.current = J
                  try {
                    return bS(t, Q, c)
                  } finally {
                    Jg.current = f
                  }
                },
                useRef: function (t) {
                  return ((jI = "useRef"), Ng(), ID())
                },
                useState: function (t) {
                  ;((jI = "useState"), Ng())
                  var Q = Jg.current
                  Jg.current = J
                  try {
                    return ty(t)
                  } finally {
                    Jg.current = Q
                  }
                },
                useDebugValue: function (t, Q) {
                  return ((jI = "useDebugValue"), Ng(), ay())
                },
                useDeferredValue: function (t) {
                  return ((jI = "useDeferredValue"), Ng(), Ww(t))
                },
                useTransition: function () {
                  return ((jI = "useTransition"), Ng(), zw())
                },
                useMutableSource: function (t, Q, c) {
                  return ((jI = "useMutableSource"), Ng(), void 0)
                },
                useSyncExternalStore: function (t, Q, c) {
                  return ((jI = "useSyncExternalStore"), Ng(), Cy(t, Q))
                },
                useId: function () {
                  return ((jI = "useId"), Ng(), jS())
                },
                unstable_isNewReconciler: nA,
              }),
              (y = {
                readContext: function (t) {
                  return (T(), KB(t))
                },
                useCallback: function (t, Q) {
                  return ((jI = "useCallback"), W(), gi(), Zw(t, Q))
                },
                useContext: function (t) {
                  return ((jI = "useContext"), W(), gi(), KB(t))
                },
                useEffect: function (t, Q) {
                  return ((jI = "useEffect"), W(), gi(), By(t, Q))
                },
                useImperativeHandle: function (t, Q, c) {
                  return ((jI = "useImperativeHandle"), W(), gi(), Ey(t, Q, c))
                },
                useInsertionEffect: function (t, Q) {
                  return ((jI = "useInsertionEffect"), W(), gi(), _w(t, Q))
                },
                useLayoutEffect: function (t, Q) {
                  return ((jI = "useLayoutEffect"), W(), gi(), oy(t, Q))
                },
                useMemo: function (t, Q) {
                  ;((jI = "useMemo"), W(), gi())
                  var c = Jg.current
                  Jg.current = y
                  try {
                    return ry(t, Q)
                  } finally {
                    Jg.current = c
                  }
                },
                useReducer: function (t, Q, c) {
                  ;((jI = "useReducer"), W(), gi())
                  var f = Jg.current
                  Jg.current = y
                  try {
                    return Hw(t, Q, c)
                  } finally {
                    Jg.current = f
                  }
                },
                useRef: function (t) {
                  return ((jI = "useRef"), W(), gi(), Ow(t))
                },
                useState: function (t) {
                  ;((jI = "useState"), W(), gi())
                  var Q = Jg.current
                  Jg.current = y
                  try {
                    return OS(t)
                  } finally {
                    Jg.current = Q
                  }
                },
                useDebugValue: function (t, Q) {
                  return ((jI = "useDebugValue"), W(), gi(), void 0)
                },
                useDeferredValue: function (t) {
                  return ((jI = "useDeferredValue"), W(), gi(), sy(t))
                },
                useTransition: function () {
                  return ((jI = "useTransition"), W(), gi(), ly())
                },
                useMutableSource: function (t, Q, c) {
                  return ((jI = "useMutableSource"), W(), gi(), void 0)
                },
                useSyncExternalStore: function (t, Q, c) {
                  return ((jI = "useSyncExternalStore"), W(), gi(), Tw(t, Q, c))
                },
                useId: function () {
                  return ((jI = "useId"), W(), gi(), cy())
                },
                unstable_isNewReconciler: nA,
              }),
              (k = {
                readContext: function (t) {
                  return (T(), KB(t))
                },
                useCallback: function (t, Q) {
                  return ((jI = "useCallback"), W(), Ng(), WS(t, Q))
                },
                useContext: function (t) {
                  return ((jI = "useContext"), W(), Ng(), KB(t))
                },
                useEffect: function (t, Q) {
                  return ((jI = "useEffect"), W(), Ng(), PS(t, Q))
                },
                useImperativeHandle: function (t, Q, c) {
                  return ((jI = "useImperativeHandle"), W(), Ng(), gD(t, Q, c))
                },
                useInsertionEffect: function (t, Q) {
                  return ((jI = "useInsertionEffect"), W(), Ng(), Qy(t, Q))
                },
                useLayoutEffect: function (t, Q) {
                  return ((jI = "useLayoutEffect"), W(), Ng(), ny(t, Q))
                },
                useMemo: function (t, Q) {
                  ;((jI = "useMemo"), W(), Ng())
                  var c = Jg.current
                  Jg.current = k
                  try {
                    return VS(t, Q)
                  } finally {
                    Jg.current = c
                  }
                },
                useReducer: function (t, Q, c) {
                  ;((jI = "useReducer"), W(), Ng())
                  var f = Jg.current
                  Jg.current = k
                  try {
                    return xS(t, Q, c)
                  } finally {
                    Jg.current = f
                  }
                },
                useRef: function (t) {
                  return ((jI = "useRef"), W(), Ng(), ID())
                },
                useState: function (t) {
                  ;((jI = "useState"), W(), Ng())
                  var Q = Jg.current
                  Jg.current = k
                  try {
                    return bw(t)
                  } finally {
                    Jg.current = Q
                  }
                },
                useDebugValue: function (t, Q) {
                  return ((jI = "useDebugValue"), W(), Ng(), ay())
                },
                useDeferredValue: function (t) {
                  return ((jI = "useDeferredValue"), W(), Ng(), Pw(t))
                },
                useTransition: function () {
                  return ((jI = "useTransition"), W(), Ng(), jw())
                },
                useMutableSource: function (t, Q, c) {
                  return ((jI = "useMutableSource"), W(), Ng(), void 0)
                },
                useSyncExternalStore: function (t, Q, c) {
                  return ((jI = "useSyncExternalStore"), W(), Ng(), Cy(t, Q))
                },
                useId: function () {
                  return ((jI = "useId"), W(), Ng(), jS())
                },
                unstable_isNewReconciler: nA,
              }),
              (J = {
                readContext: function (t) {
                  return (T(), KB(t))
                },
                useCallback: function (t, Q) {
                  return ((jI = "useCallback"), W(), Ng(), WS(t, Q))
                },
                useContext: function (t) {
                  return ((jI = "useContext"), W(), Ng(), KB(t))
                },
                useEffect: function (t, Q) {
                  return ((jI = "useEffect"), W(), Ng(), PS(t, Q))
                },
                useImperativeHandle: function (t, Q, c) {
                  return ((jI = "useImperativeHandle"), W(), Ng(), gD(t, Q, c))
                },
                useInsertionEffect: function (t, Q) {
                  return ((jI = "useInsertionEffect"), W(), Ng(), Qy(t, Q))
                },
                useLayoutEffect: function (t, Q) {
                  return ((jI = "useLayoutEffect"), W(), Ng(), ny(t, Q))
                },
                useMemo: function (t, Q) {
                  ;((jI = "useMemo"), W(), Ng())
                  var c = Jg.current
                  Jg.current = k
                  try {
                    return VS(t, Q)
                  } finally {
                    Jg.current = c
                  }
                },
                useReducer: function (t, Q, c) {
                  ;((jI = "useReducer"), W(), Ng())
                  var f = Jg.current
                  Jg.current = k
                  try {
                    return bS(t, Q, c)
                  } finally {
                    Jg.current = f
                  }
                },
                useRef: function (t) {
                  return ((jI = "useRef"), W(), Ng(), ID())
                },
                useState: function (t) {
                  ;((jI = "useState"), W(), Ng())
                  var Q = Jg.current
                  Jg.current = k
                  try {
                    return ty(t)
                  } finally {
                    Jg.current = Q
                  }
                },
                useDebugValue: function (t, Q) {
                  return ((jI = "useDebugValue"), W(), Ng(), ay())
                },
                useDeferredValue: function (t) {
                  return ((jI = "useDeferredValue"), W(), Ng(), Ww(t))
                },
                useTransition: function () {
                  return ((jI = "useTransition"), W(), Ng(), zw())
                },
                useMutableSource: function (t, Q, c) {
                  return ((jI = "useMutableSource"), W(), Ng(), void 0)
                },
                useSyncExternalStore: function (t, Q, c) {
                  return ((jI = "useSyncExternalStore"), W(), Ng(), Cy(t, Q))
                },
                useId: function () {
                  return ((jI = "useId"), W(), Ng(), jS())
                },
                unstable_isNewReconciler: nA,
              }))
          }
          var BA = A.unstable_now,
            cA = 0,
            RA = -1,
            TA = -1,
            DI = -1,
            vI = !1,
            bI = !1
          function og() {
            return vI
          }
          function cg() {
            bI = !0
          }
          function cC() {
            ;((vI = !1), (bI = !1))
          }
          function re() {
            ;((vI = bI), (bI = !1))
          }
          function MC() {
            return cA
          }
          function yt() {
            cA = BA()
          }
          function Qt(t) {
            ;((TA = BA()), t.actualStartTime < 0 && (t.actualStartTime = BA()))
          }
          function MI(t) {
            TA = -1
          }
          function PI(t, Q) {
            if (TA >= 0) {
              var c = BA() - TA
              ;((t.actualDuration += c), Q && (t.selfBaseDuration = c), (TA = -1))
            }
          }
          function uI(t) {
            if (RA >= 0) {
              var Q = BA() - RA
              RA = -1
              for (var c = t.return; c !== null; ) {
                switch (c.tag) {
                  case S:
                    var f = c.stateNode
                    f.effectDuration += Q
                    return
                  case H:
                    var G = c.stateNode
                    G.effectDuration += Q
                    return
                }
                c = c.return
              }
            }
          }
          function ug(t) {
            if (DI >= 0) {
              var Q = BA() - DI
              DI = -1
              for (var c = t.return; c !== null; ) {
                switch (c.tag) {
                  case S:
                    var f = c.stateNode
                    f !== null && (f.passiveEffectDuration += Q)
                    return
                  case H:
                    var G = c.stateNode
                    G !== null && (G.passiveEffectDuration += Q)
                    return
                }
                c = c.return
              }
            }
          }
          function Og() {
            RA = BA()
          }
          function qg() {
            DI = BA()
          }
          function Ge(t) {
            for (var Q = t.child; Q; ) ((t.actualDuration += Q.actualDuration), (Q = Q.sibling))
          }
          function De(t, Q) {
            if (t && t.defaultProps) {
              var c = rg({}, Q),
                f = t.defaultProps
              for (var G in f) c[G] === void 0 && (c[G] = f[G])
              return c
            }
            return Q
          }
          var _i = {},
            oi,
            Jt,
            Ze,
            Se,
            oB,
            Zt,
            yn,
            kQ,
            pn,
            wn,
            BE
          {
            ;((oi = /* @__PURE__ */ new Set()),
              (Jt = /* @__PURE__ */ new Set()),
              (Ze = /* @__PURE__ */ new Set()),
              (Se = /* @__PURE__ */ new Set()),
              (kQ = /* @__PURE__ */ new Set()),
              (oB = /* @__PURE__ */ new Set()),
              (pn = /* @__PURE__ */ new Set()),
              (wn = /* @__PURE__ */ new Set()),
              (BE = /* @__PURE__ */ new Set()))
            var Hh = /* @__PURE__ */ new Set()
            ;((yn = function (t, Q) {
              if (!(t === null || typeof t == "function")) {
                var c = Q + "_" + t
                Hh.has(c) ||
                  (Hh.add(c),
                  B(
                    "%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.",
                    Q,
                    t,
                  ))
              }
            }),
              (Zt = function (t, Q) {
                if (Q === void 0) {
                  var c = ZC(t) || "Component"
                  oB.has(c) ||
                    (oB.add(c),
                    B(
                      "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
                      c,
                    ))
                }
              }),
              Object.defineProperty(_i, "_processChildContext", {
                enumerable: !1,
                value: function () {
                  throw new Error(
                    "_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).",
                  )
                },
              }),
              Object.freeze(_i))
          }
          function mc(t, Q, c, f) {
            var G = t.memoizedState,
              m = c(f, G)
            {
              if (t.mode & rC) {
                Qi(!0)
                try {
                  m = c(f, G)
                } finally {
                  Qi(!1)
                }
              }
              Zt(Q, m)
            }
            var x = m == null ? G : rg({}, G, m)
            if (((t.memoizedState = x), t.lanes === Ag)) {
              var z = t.updateQueue
              z.baseState = x
            }
          }
          var Gn = {
            isMounted: AB,
            enqueueSetState: function (t, Q, c) {
              var f = wB(t),
                G = ZE(),
                m = tD(f),
                x = cs(G, m)
              ;((x.payload = Q), c != null && (yn(c, "setState"), (x.callback = c)))
              var z = sl(f, x, m)
              ;(z !== null && (co(z, f, m, G), RS(z, f, m)), JE(f, m))
            },
            enqueueReplaceState: function (t, Q, c) {
              var f = wB(t),
                G = ZE(),
                m = tD(f),
                x = cs(G, m)
              ;((x.tag = Zk),
                (x.payload = Q),
                c != null && (yn(c, "replaceState"), (x.callback = c)))
              var z = sl(f, x, m)
              ;(z !== null && (co(z, f, m, G), RS(z, f, m)), JE(f, m))
            },
            enqueueForceUpdate: function (t, Q) {
              var c = wB(t),
                f = ZE(),
                G = tD(c),
                m = cs(f, G)
              ;((m.tag = Vd), Q != null && (yn(Q, "forceUpdate"), (m.callback = Q)))
              var x = sl(c, m, G)
              ;(x !== null && (co(x, c, G, f), RS(x, c, G)), nr(c, G))
            },
          }
          function vc(t, Q, c, f, G, m, x) {
            var z = t.stateNode
            if (typeof z.shouldComponentUpdate == "function") {
              var gA = z.shouldComponentUpdate(f, m, x)
              {
                if (t.mode & rC) {
                  Qi(!0)
                  try {
                    gA = z.shouldComponentUpdate(f, m, x)
                  } finally {
                    Qi(!1)
                  }
                }
                gA === void 0 &&
                  B(
                    "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
                    ZC(Q) || "Component",
                  )
              }
              return gA
            }
            return Q.prototype && Q.prototype.isPureReactComponent ? !dC(c, f) || !dC(G, m) : !0
          }
          function I0(t, Q, c) {
            var f = t.stateNode
            {
              var G = ZC(Q) || "Component",
                m = f.render
              ;(m ||
                (Q.prototype && typeof Q.prototype.render == "function"
                  ? B(
                      "%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?",
                      G,
                    )
                  : B(
                      "%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.",
                      G,
                    )),
                f.getInitialState &&
                  !f.getInitialState.isReactClassApproved &&
                  !f.state &&
                  B(
                    "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
                    G,
                  ),
                f.getDefaultProps &&
                  !f.getDefaultProps.isReactClassApproved &&
                  B(
                    "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
                    G,
                  ),
                f.propTypes &&
                  B(
                    "propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.",
                    G,
                  ),
                f.contextType &&
                  B(
                    "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
                    G,
                  ),
                Q.childContextTypes &&
                  !BE.has(Q) && // Strict Mode has its own warning for legacy context, so we can skip
                  // this one.
                  (t.mode & rC) === zg &&
                  (BE.add(Q),
                  B(
                    `%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`,
                    G,
                  )),
                Q.contextTypes &&
                  !BE.has(Q) && // Strict Mode has its own warning for legacy context, so we can skip
                  // this one.
                  (t.mode & rC) === zg &&
                  (BE.add(Q),
                  B(
                    `%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`,
                    G,
                  )),
                f.contextTypes &&
                  B(
                    "contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.",
                    G,
                  ),
                Q.contextType &&
                  Q.contextTypes &&
                  !pn.has(Q) &&
                  (pn.add(Q),
                  B(
                    "%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.",
                    G,
                  )),
                typeof f.componentShouldUpdate == "function" &&
                  B(
                    "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
                    G,
                  ),
                Q.prototype &&
                  Q.prototype.isPureReactComponent &&
                  typeof f.shouldComponentUpdate < "u" &&
                  B(
                    "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
                    ZC(Q) || "A pure component",
                  ),
                typeof f.componentDidUnmount == "function" &&
                  B(
                    "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
                    G,
                  ),
                typeof f.componentDidReceiveProps == "function" &&
                  B(
                    "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
                    G,
                  ),
                typeof f.componentWillRecieveProps == "function" &&
                  B(
                    "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
                    G,
                  ),
                typeof f.UNSAFE_componentWillRecieveProps == "function" &&
                  B(
                    "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
                    G,
                  ))
              var x = f.props !== c
              ;(f.props !== void 0 &&
                x &&
                B(
                  "%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
                  G,
                  G,
                ),
                f.defaultProps &&
                  B(
                    "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
                    G,
                    G,
                  ),
                typeof f.getSnapshotBeforeUpdate == "function" &&
                  typeof f.componentDidUpdate != "function" &&
                  !Ze.has(Q) &&
                  (Ze.add(Q),
                  B(
                    "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
                    ZC(Q),
                  )),
                typeof f.getDerivedStateFromProps == "function" &&
                  B(
                    "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
                    G,
                  ),
                typeof f.getDerivedStateFromError == "function" &&
                  B(
                    "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
                    G,
                  ),
                typeof Q.getSnapshotBeforeUpdate == "function" &&
                  B(
                    "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
                    G,
                  ))
              var z = f.state
              ;(z &&
                (typeof z != "object" || le(z)) &&
                B("%s.state: must be set to an object or null", G),
                typeof f.getChildContext == "function" &&
                  typeof Q.childContextTypes != "object" &&
                  B(
                    "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
                    G,
                  ))
            }
          }
          function g0(t, Q) {
            ;((Q.updater = Gn), (t.stateNode = Q), Re(Q, t), (Q._reactInternalInstance = _i))
          }
          function BM(t, Q, c) {
            var f = !1,
              G = eE,
              m = eE,
              x = Q.contextType
            if ("contextType" in Q) {
              var z =
                // Allow null for conditional declaration
                x === null || (x !== void 0 && x.$$typeof === TI && x._context === void 0)
              if (!z && !wn.has(Q)) {
                wn.add(Q)
                var gA = ""
                ;(x === void 0
                  ? (gA =
                      " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.")
                  : typeof x != "object"
                    ? (gA = " However, it is set to a " + typeof x + ".")
                    : x.$$typeof === mA
                      ? (gA = " Did you accidentally pass the Context.Provider instead?")
                      : x._context !== void 0
                        ? (gA = " Did you accidentally pass the Context.Consumer instead?")
                        : (gA =
                            " However, it is set to an object with keys {" +
                            Object.keys(x).join(", ") +
                            "}."),
                  B(
                    "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
                    ZC(Q) || "Component",
                    gA,
                  ))
              }
            }
            if (typeof x == "object" && x !== null) m = KB(x)
            else {
              G = hc(t, Q, !0)
              var hA = Q.contextTypes
              ;((f = hA != null), (m = f ? bu(t, G) : eE))
            }
            var pA = new Q(c, m)
            if (t.mode & rC) {
              Qi(!0)
              try {
                pA = new Q(c, m)
              } finally {
                Qi(!1)
              }
            }
            var gI = (t.memoizedState = pA.state !== null && pA.state !== void 0 ? pA.state : null)
            g0(t, pA)
            {
              if (typeof Q.getDerivedStateFromProps == "function" && gI === null) {
                var $A = ZC(Q) || "Component"
                Jt.has($A) ||
                  (Jt.add($A),
                  B(
                    "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
                    $A,
                    pA.state === null ? "null" : "undefined",
                    $A,
                  ))
              }
              if (
                typeof Q.getDerivedStateFromProps == "function" ||
                typeof pA.getSnapshotBeforeUpdate == "function"
              ) {
                var FI = null,
                  KI = null,
                  OI = null
                if (
                  (typeof pA.componentWillMount == "function" &&
                  pA.componentWillMount.__suppressDeprecationWarning !== !0
                    ? (FI = "componentWillMount")
                    : typeof pA.UNSAFE_componentWillMount == "function" &&
                      (FI = "UNSAFE_componentWillMount"),
                  typeof pA.componentWillReceiveProps == "function" &&
                  pA.componentWillReceiveProps.__suppressDeprecationWarning !== !0
                    ? (KI = "componentWillReceiveProps")
                    : typeof pA.UNSAFE_componentWillReceiveProps == "function" &&
                      (KI = "UNSAFE_componentWillReceiveProps"),
                  typeof pA.componentWillUpdate == "function" &&
                  pA.componentWillUpdate.__suppressDeprecationWarning !== !0
                    ? (OI = "componentWillUpdate")
                    : typeof pA.UNSAFE_componentWillUpdate == "function" &&
                      (OI = "UNSAFE_componentWillUpdate"),
                  FI !== null || KI !== null || OI !== null)
                ) {
                  var Lg = ZC(Q) || "Component",
                    yC =
                      typeof Q.getDerivedStateFromProps == "function"
                        ? "getDerivedStateFromProps()"
                        : "getSnapshotBeforeUpdate()"
                  Se.has(Lg) ||
                    (Se.add(Lg),
                    B(
                      `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`,
                      Lg,
                      yC,
                      FI !== null
                        ? `
  ` + FI
                        : "",
                      KI !== null
                        ? `
  ` + KI
                        : "",
                      OI !== null
                        ? `
  ` + OI
                        : "",
                    ))
                }
              }
            }
            return (f && rw(t, G, m), pA)
          }
          function HR(t, Q) {
            var c = Q.state
            ;(typeof Q.componentWillMount == "function" && Q.componentWillMount(),
              typeof Q.UNSAFE_componentWillMount == "function" && Q.UNSAFE_componentWillMount(),
              c !== Q.state &&
                (B(
                  "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
                  oC(t) || "Component",
                ),
                Gn.enqueueReplaceState(Q, Q.state, null)))
          }
          function kL(t, Q, c, f) {
            var G = Q.state
            if (
              (typeof Q.componentWillReceiveProps == "function" &&
                Q.componentWillReceiveProps(c, f),
              typeof Q.UNSAFE_componentWillReceiveProps == "function" &&
                Q.UNSAFE_componentWillReceiveProps(c, f),
              Q.state !== G)
            ) {
              {
                var m = oC(t) || "Component"
                oi.has(m) ||
                  (oi.add(m),
                  B(
                    "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
                    m,
                  ))
              }
              Gn.enqueueReplaceState(Q, Q.state, null)
            }
          }
          function TR(t, Q, c, f) {
            I0(t, Q, c)
            var G = t.stateNode
            ;((G.props = c), (G.state = t.memoizedState), (G.refs = {}), FS(t))
            var m = Q.contextType
            if (typeof m == "object" && m !== null) G.context = KB(m)
            else {
              var x = hc(t, Q, !0)
              G.context = bu(t, x)
            }
            {
              if (G.state === c) {
                var z = ZC(Q) || "Component"
                kQ.has(z) ||
                  (kQ.add(z),
                  B(
                    "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
                    z,
                  ))
              }
              ;(t.mode & rC && fn.recordLegacyContextWarning(t, G),
                fn.recordUnsafeLifecycleWarnings(t, G))
            }
            G.state = t.memoizedState
            var gA = Q.getDerivedStateFromProps
            if (
              (typeof gA == "function" && (mc(t, Q, gA, c), (G.state = t.memoizedState)),
              typeof Q.getDerivedStateFromProps != "function" &&
                typeof G.getSnapshotBeforeUpdate != "function" &&
                (typeof G.UNSAFE_componentWillMount == "function" ||
                  typeof G.componentWillMount == "function") &&
                (HR(t, G), Xd(t, c, G, f), (G.state = t.memoizedState)),
              typeof G.componentDidMount == "function")
            ) {
              var hA = IC
              ;((hA |= st), (t.mode & xt) !== zg && (hA |= Ne), (t.flags |= hA))
            }
          }
          function g_(t, Q, c, f) {
            var G = t.stateNode,
              m = t.memoizedProps
            G.props = m
            var x = G.context,
              z = Q.contextType,
              gA = eE
            if (typeof z == "object" && z !== null) gA = KB(z)
            else {
              var hA = hc(t, Q, !0)
              gA = bu(t, hA)
            }
            var pA = Q.getDerivedStateFromProps,
              gI = typeof pA == "function" || typeof G.getSnapshotBeforeUpdate == "function"
            ;(!gI &&
              (typeof G.UNSAFE_componentWillReceiveProps == "function" ||
                typeof G.componentWillReceiveProps == "function") &&
              (m !== c || x !== gA) &&
              kL(t, G, c, gA),
              Pk())
            var $A = t.memoizedState,
              FI = (G.state = $A)
            if ((Xd(t, c, G, f), (FI = t.memoizedState), m === c && $A === FI && !Ou() && !$d())) {
              if (typeof G.componentDidMount == "function") {
                var KI = IC
                ;((KI |= st), (t.mode & xt) !== zg && (KI |= Ne), (t.flags |= KI))
              }
              return !1
            }
            typeof pA == "function" && (mc(t, Q, pA, c), (FI = t.memoizedState))
            var OI = $d() || vc(t, Q, m, c, $A, FI, gA)
            if (OI) {
              if (
                (!gI &&
                  (typeof G.UNSAFE_componentWillMount == "function" ||
                    typeof G.componentWillMount == "function") &&
                  (typeof G.componentWillMount == "function" && G.componentWillMount(),
                  typeof G.UNSAFE_componentWillMount == "function" &&
                    G.UNSAFE_componentWillMount()),
                typeof G.componentDidMount == "function")
              ) {
                var Lg = IC
                ;((Lg |= st), (t.mode & xt) !== zg && (Lg |= Ne), (t.flags |= Lg))
              }
            } else {
              if (typeof G.componentDidMount == "function") {
                var yC = IC
                ;((yC |= st), (t.mode & xt) !== zg && (yC |= Ne), (t.flags |= yC))
              }
              ;((t.memoizedProps = c), (t.memoizedState = FI))
            }
            return ((G.props = c), (G.state = FI), (G.context = gA), OI)
          }
          function C_(t, Q, c, f, G) {
            var m = Q.stateNode
            kc(t, Q)
            var x = Q.memoizedProps,
              z = Q.type === Q.elementType ? x : De(Q.type, x)
            m.props = z
            var gA = Q.pendingProps,
              hA = m.context,
              pA = c.contextType,
              gI = eE
            if (typeof pA == "object" && pA !== null) gI = KB(pA)
            else {
              var $A = hc(Q, c, !0)
              gI = bu(Q, $A)
            }
            var FI = c.getDerivedStateFromProps,
              KI = typeof FI == "function" || typeof m.getSnapshotBeforeUpdate == "function"
            ;(!KI &&
              (typeof m.UNSAFE_componentWillReceiveProps == "function" ||
                typeof m.componentWillReceiveProps == "function") &&
              (x !== gA || hA !== gI) &&
              kL(Q, m, f, gI),
              Pk())
            var OI = Q.memoizedState,
              Lg = (m.state = OI)
            if (
              (Xd(Q, f, m, G),
              (Lg = Q.memoizedState),
              x === gA && OI === Lg && !Ou() && !$d() && !fA)
            )
              return (
                typeof m.componentDidUpdate == "function" &&
                  (x !== t.memoizedProps || OI !== t.memoizedState) &&
                  (Q.flags |= IC),
                typeof m.getSnapshotBeforeUpdate == "function" &&
                  (x !== t.memoizedProps || OI !== t.memoizedState) &&
                  (Q.flags |= cQ),
                !1
              )
            typeof FI == "function" && (mc(Q, c, FI, f), (Lg = Q.memoizedState))
            var yC =
              $d() ||
              vc(Q, c, z, f, OI, Lg, gI) || // TODO: In some cases, we'll end up checking if context has changed twice,
              // both before and after `shouldComponentUpdate` has been called. Not ideal,
              // but I'm loath to refactor this function. This only happens for memoized
              // components so it's not that common.
              fA
            return (
              yC
                ? (!KI &&
                    (typeof m.UNSAFE_componentWillUpdate == "function" ||
                      typeof m.componentWillUpdate == "function") &&
                    (typeof m.componentWillUpdate == "function" && m.componentWillUpdate(f, Lg, gI),
                    typeof m.UNSAFE_componentWillUpdate == "function" &&
                      m.UNSAFE_componentWillUpdate(f, Lg, gI)),
                  typeof m.componentDidUpdate == "function" && (Q.flags |= IC),
                  typeof m.getSnapshotBeforeUpdate == "function" && (Q.flags |= cQ))
                : (typeof m.componentDidUpdate == "function" &&
                    (x !== t.memoizedProps || OI !== t.memoizedState) &&
                    (Q.flags |= IC),
                  typeof m.getSnapshotBeforeUpdate == "function" &&
                    (x !== t.memoizedProps || OI !== t.memoizedState) &&
                    (Q.flags |= cQ),
                  (Q.memoizedProps = f),
                  (Q.memoizedState = Lg)),
              (m.props = f),
              (m.state = Lg),
              (m.context = gI),
              yC
            )
          }
          function zS(t, Q) {
            return {
              value: t,
              source: Q,
              stack: dB(Q),
              digest: null,
            }
          }
          function xR(t, Q, c) {
            return {
              value: t,
              source: null,
              stack: c ?? null,
              digest: Q ?? null,
            }
          }
          function e_(t, Q) {
            return !0
          }
          function bR(t, Q) {
            try {
              var c = e_(t, Q)
              if (c === !1) return
              var f = Q.value,
                G = Q.source,
                m = Q.stack,
                x = m !== null ? m : ""
              if (f != null && f._suppressLogging) {
                if (t.tag === s) return
                console.error(f)
              }
              var z = G ? oC(G) : null,
                gA = z
                  ? "The above error occurred in the <" + z + "> component:"
                  : "The above error occurred in one of your React components:",
                hA
              if (t.tag === S)
                hA = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`
              else {
                var pA = oC(t) || "Anonymous"
                hA =
                  "React will try to recreate this component tree from scratch " +
                  ("using the error boundary you provided, " + pA + ".")
              }
              var gI =
                gA +
                `
` +
                x +
                `

` +
                ("" + hA)
              console.error(gI)
            } catch ($A) {
              setTimeout(function () {
                throw $A
              })
            }
          }
          var i_ = typeof WeakMap == "function" ? WeakMap : Map
          function ML(t, Q, c) {
            var f = cs(ue, c)
            ;((f.tag = ju),
              (f.payload = {
                element: null,
              }))
            var G = Q.value
            return (
              (f.callback = function () {
                ;(z4(G), bR(t, Q))
              }),
              f
            )
          }
          function OR(t, Q, c) {
            var f = cs(ue, c)
            f.tag = ju
            var G = t.type.getDerivedStateFromError
            if (typeof G == "function") {
              var m = Q.value
              ;((f.payload = function () {
                return G(m)
              }),
                (f.callback = function () {
                  ;(qY(t), bR(t, Q))
                }))
            }
            var x = t.stateNode
            return (
              x !== null &&
                typeof x.componentDidCatch == "function" &&
                (f.callback = function () {
                  ;(qY(t), bR(t, Q), typeof G != "function" && V4(this))
                  var gA = Q.value,
                    hA = Q.stack
                  ;(this.componentDidCatch(gA, {
                    componentStack: hA !== null ? hA : "",
                  }),
                    typeof G != "function" &&
                      (zA(t.lanes, bg) ||
                        B(
                          "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
                          oC(t) || "Unknown",
                        )))
                }),
              f
            )
          }
          function UL(t, Q, c) {
            var f = t.pingCache,
              G
            if (
              (f === null
                ? ((f = t.pingCache = new i_()), (G = /* @__PURE__ */ new Set()), f.set(Q, G))
                : ((G = f.get(Q)), G === void 0 && ((G = /* @__PURE__ */ new Set()), f.set(Q, G))),
              !G.has(c))
            ) {
              G.add(c)
              var m = X4.bind(null, t, Q, c)
              ;(lB && D0(t, c), Q.then(m, m))
            }
          }
          function t_(t, Q, c, f) {
            var G = t.updateQueue
            if (G === null) {
              var m = /* @__PURE__ */ new Set()
              ;(m.add(c), (t.updateQueue = m))
            } else G.add(c)
          }
          function B_(t, Q) {
            var c = t.tag
            if ((t.mode & Pg) === zg && (c === r || c === Y || c === P)) {
              var f = t.alternate
              f
                ? ((t.updateQueue = f.updateQueue),
                  (t.memoizedState = f.memoizedState),
                  (t.lanes = f.lanes))
                : ((t.updateQueue = null), (t.memoizedState = null))
            }
          }
          function NL(t) {
            var Q = t
            do {
              if (Q.tag === V && vR(Q)) return Q
              Q = Q.return
            } while (Q !== null)
            return null
          }
          function FL(t, Q, c, f, G) {
            if ((t.mode & Pg) === zg) {
              if (t === Q) t.flags |= Xt
              else {
                if (((t.flags |= kC), (c.flags |= jr), (c.flags &= ~(On | OB)), c.tag === s)) {
                  var m = c.alternate
                  if (m === null) c.tag = X
                  else {
                    var x = cs(ue, bg)
                    ;((x.tag = Vd), sl(c, x, bg))
                  }
                }
                c.lanes = WI(c.lanes, bg)
              }
              return t
            }
            return ((t.flags |= Xt), (t.lanes = G), t)
          }
          function Q_(t, Q, c, f, G) {
            if (
              ((c.flags |= OB),
              lB && D0(t, G),
              f !== null && typeof f == "object" && typeof f.then == "function")
            ) {
              var m = f
              ;(B_(c), it() && c.mode & Pg && bd())
              var x = NL(Q)
              if (x !== null) {
                ;((x.flags &= ~At), FL(x, Q, c, t, G), x.mode & Pg && UL(t, m, G), t_(x, t, m))
                return
              } else {
                if (!O(G)) {
                  ;(UL(t, m, G), yJ())
                  return
                }
                var z = new Error(
                  "A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.",
                )
                f = z
              }
            } else if (it() && c.mode & Pg) {
              bd()
              var gA = NL(Q)
              if (gA !== null) {
                ;((gA.flags & Xt) === nC && (gA.flags |= At), FL(gA, Q, c, t, G), kr(zS(f, c)))
                return
              }
            }
            ;((f = zS(f, c)), T4(f))
            var hA = Q
            do {
              switch (hA.tag) {
                case S: {
                  var pA = f
                  hA.flags |= Xt
                  var gI = ut(G)
                  hA.lanes = WI(hA.lanes, gI)
                  var $A = ML(hA, pA, gI)
                  Nw(hA, $A)
                  return
                }
                case s:
                  var FI = f,
                    KI = hA.type,
                    OI = hA.stateNode
                  if (
                    (hA.flags & kC) === nC &&
                    (typeof KI.getDerivedStateFromError == "function" ||
                      (OI !== null && typeof OI.componentDidCatch == "function" && !NY(OI)))
                  ) {
                    hA.flags |= Xt
                    var Lg = ut(G)
                    hA.lanes = WI(hA.lanes, Lg)
                    var yC = OR(hA, FI, Lg)
                    Nw(hA, yC)
                    return
                  }
                  break
              }
              hA = hA.return
            } while (hA !== null)
          }
          function o_() {
            return null
          }
          var C0 = I.ReactCurrentOwner,
            cl = !1,
            _R,
            e0,
            ZR,
            PR,
            WR,
            XS,
            VR,
            QM,
            i0
          ;((_R = {}),
            (e0 = {}),
            (ZR = {}),
            (PR = {}),
            (WR = {}),
            (XS = !1),
            (VR = {}),
            (QM = {}),
            (i0 = {}))
          function OE(t, Q, c, f) {
            t === null ? (Q.child = yc(Q, null, c, f)) : (Q.child = Mr(Q, t.child, c, f))
          }
          function n_(t, Q, c, f) {
            ;((Q.child = Mr(Q, t.child, null, f)), (Q.child = Mr(Q, null, c, f)))
          }
          function RL(t, Q, c, f, G) {
            if (Q.type !== Q.elementType) {
              var m = c.propTypes
              m &&
                Sr(
                  m,
                  f,
                  // Resolved props
                  "prop",
                  ZC(c),
                )
            }
            var x = c.render,
              z = Q.ref,
              gA,
              hA
            ;(rl(Q, G), xi(Q))
            {
              if (
                ((C0.current = Q), ee(!0), (gA = Lh(t, Q, x, f, z, G)), (hA = AD()), Q.mode & rC)
              ) {
                Qi(!0)
                try {
                  ;((gA = Lh(t, Q, x, f, z, G)), (hA = AD()))
                } finally {
                  Qi(!1)
                }
              }
              ee(!1)
            }
            return (
              Ke(),
              t !== null && !cl
                ? (tE(t, Q, G), Th(t, Q, G))
                : (it() && hA && lw(Q), (Q.flags |= Je), OE(t, Q, gA, G), Q.child)
            )
          }
          function JL(t, Q, c, f, G) {
            if (t === null) {
              var m = c.type
              if (
                l3(m) &&
                c.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
                c.defaultProps === void 0
              ) {
                var x = m
                return ((x = Gy(m)), (Q.tag = P), (Q.type = x), XR(Q, m), KL(t, Q, x, f, G))
              }
              {
                var z = m.propTypes
                if (
                  (z &&
                    Sr(
                      z,
                      f,
                      // Resolved props
                      "prop",
                      ZC(m),
                    ),
                  c.defaultProps !== void 0)
                ) {
                  var gA = ZC(m) || "Unknown"
                  i0[gA] ||
                    (B(
                      "%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.",
                      gA,
                    ),
                    (i0[gA] = !0))
                }
              }
              var hA = KJ(c.type, null, f, Q, Q.mode, G)
              return ((hA.ref = Q.ref), (hA.return = Q), (Q.child = hA), hA)
            }
            {
              var pA = c.type,
                gI = pA.propTypes
              gI &&
                Sr(
                  gI,
                  f,
                  // Resolved props
                  "prop",
                  ZC(pA),
                )
            }
            var $A = t.child,
              FI = eJ(t, G)
            if (!FI) {
              var KI = $A.memoizedProps,
                OI = c.compare
              if (((OI = OI !== null ? OI : dC), OI(KI, f) && t.ref === Q.ref)) return Th(t, Q, G)
            }
            Q.flags |= Je
            var Lg = Cf($A, f)
            return ((Lg.ref = Q.ref), (Lg.return = Q), (Q.child = Lg), Lg)
          }
          function KL(t, Q, c, f, G) {
            if (Q.type !== Q.elementType) {
              var m = Q.elementType
              if (m.$$typeof === jg) {
                var x = m,
                  z = x._payload,
                  gA = x._init
                try {
                  m = gA(z)
                } catch {
                  m = null
                }
                var hA = m && m.propTypes
                hA &&
                  Sr(
                    hA,
                    f,
                    // Resolved (SimpleMemoComponent has no defaultProps)
                    "prop",
                    ZC(m),
                  )
              }
            }
            if (t !== null) {
              var pA = t.memoizedProps
              if (
                dC(pA, f) &&
                t.ref === Q.ref && // Prevent bailout if the implementation changed due to hot reload.
                Q.type === t.type
              )
                if (((cl = !1), (Q.pendingProps = f = pA), eJ(t, G)))
                  (t.flags & jr) !== nC && (cl = !0)
                else return ((Q.lanes = t.lanes), Th(t, Q, G))
            }
            return jR(t, Q, c, f, G)
          }
          function mL(t, Q, c) {
            var f = Q.pendingProps,
              G = f.children,
              m = t !== null ? t.memoizedState : null
            if (f.mode === "hidden" || sA)
              if ((Q.mode & Pg) === zg) {
                var x = {
                  baseLanes: Ag,
                  cachePool: null,
                  transitions: null,
                }
                ;((Q.memoizedState = x), fM(Q, c))
              } else if (zA(c, VB)) {
                var gI = {
                  baseLanes: Ag,
                  cachePool: null,
                  transitions: null,
                }
                Q.memoizedState = gI
                var $A = m !== null ? m.baseLanes : c
                fM(Q, $A)
              } else {
                var z = null,
                  gA
                if (m !== null) {
                  var hA = m.baseLanes
                  gA = WI(hA, c)
                } else gA = c
                Q.lanes = Q.childLanes = VB
                var pA = {
                  baseLanes: gA,
                  cachePool: z,
                  transitions: null,
                }
                return ((Q.memoizedState = pA), (Q.updateQueue = null), fM(Q, gA), null)
              }
            else {
              var FI
              ;(m !== null ? ((FI = WI(m.baseLanes, c)), (Q.memoizedState = null)) : (FI = c),
                fM(Q, FI))
            }
            return (OE(t, Q, G, c), Q.child)
          }
          function E_(t, Q, c) {
            var f = Q.pendingProps
            return (OE(t, Q, f, c), Q.child)
          }
          function a_(t, Q, c) {
            var f = Q.pendingProps.children
            return (OE(t, Q, f, c), Q.child)
          }
          function r_(t, Q, c) {
            {
              Q.flags |= IC
              {
                var f = Q.stateNode
                ;((f.effectDuration = 0), (f.passiveEffectDuration = 0))
              }
            }
            var G = Q.pendingProps,
              m = G.children
            return (OE(t, Q, m, c), Q.child)
          }
          function vL(t, Q) {
            var c = Q.ref
            ;((t === null && c !== null) || (t !== null && t.ref !== c)) &&
              ((Q.flags |= bB), (Q.flags |= oa))
          }
          function jR(t, Q, c, f, G) {
            if (Q.type !== Q.elementType) {
              var m = c.propTypes
              m &&
                Sr(
                  m,
                  f,
                  // Resolved props
                  "prop",
                  ZC(c),
                )
            }
            var x
            {
              var z = hc(Q, c, !0)
              x = bu(Q, z)
            }
            var gA, hA
            ;(rl(Q, G), xi(Q))
            {
              if (
                ((C0.current = Q), ee(!0), (gA = Lh(t, Q, c, f, x, G)), (hA = AD()), Q.mode & rC)
              ) {
                Qi(!0)
                try {
                  ;((gA = Lh(t, Q, c, f, x, G)), (hA = AD()))
                } finally {
                  Qi(!1)
                }
              }
              ee(!1)
            }
            return (
              Ke(),
              t !== null && !cl
                ? (tE(t, Q, G), Th(t, Q, G))
                : (it() && hA && lw(Q), (Q.flags |= Je), OE(t, Q, gA, G), Q.child)
            )
          }
          function LL(t, Q, c, f, G) {
            {
              switch (N3(Q)) {
                case !1: {
                  var m = Q.stateNode,
                    x = Q.type,
                    z = new x(Q.memoizedProps, m.context),
                    gA = z.state
                  m.updater.enqueueSetState(m, gA, null)
                  break
                }
                case !0: {
                  ;((Q.flags |= kC), (Q.flags |= Xt))
                  var hA = new Error("Simulated error coming from DevTools"),
                    pA = ut(G)
                  Q.lanes = WI(Q.lanes, pA)
                  var gI = OR(Q, zS(hA, Q), pA)
                  Nw(Q, gI)
                  break
                }
              }
              if (Q.type !== Q.elementType) {
                var $A = c.propTypes
                $A &&
                  Sr(
                    $A,
                    f,
                    // Resolved props
                    "prop",
                    ZC(c),
                  )
              }
            }
            var FI
            ;(dr(c) ? ((FI = !0), vd(Q)) : (FI = !1), rl(Q, G))
            var KI = Q.stateNode,
              OI
            KI === null
              ? (nM(t, Q), BM(Q, c, f), TR(Q, c, f, G), (OI = !0))
              : t === null
                ? (OI = g_(Q, c, f, G))
                : (OI = C_(t, Q, c, f, G))
            var Lg = zR(t, Q, c, OI, FI, G)
            {
              var yC = Q.stateNode
              OI &&
                yC.props !== f &&
                (XS ||
                  B(
                    "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
                    oC(Q) || "a component",
                  ),
                (XS = !0))
            }
            return Lg
          }
          function zR(t, Q, c, f, G, m) {
            vL(t, Q)
            var x = (Q.flags & kC) !== nC
            if (!f && !x) return (G && Rk(Q, c, !1), Th(t, Q, m))
            var z = Q.stateNode
            C0.current = Q
            var gA
            if (x && typeof c.getDerivedStateFromError != "function") ((gA = null), MI())
            else {
              xi(Q)
              {
                if ((ee(!0), (gA = z.render()), Q.mode & rC)) {
                  Qi(!0)
                  try {
                    z.render()
                  } finally {
                    Qi(!1)
                  }
                }
                ee(!1)
              }
              Ke()
            }
            return (
              (Q.flags |= Je),
              t !== null && x ? n_(t, Q, gA, m) : OE(t, Q, gA, m),
              (Q.memoizedState = z.state),
              G && Rk(Q, c, !0),
              Q.child
            )
          }
          function YL(t) {
            var Q = t.stateNode
            ;(Q.pendingContext
              ? Nk(t, Q.pendingContext, Q.pendingContext !== Q.context)
              : Q.context && Nk(t, Q.context, !1),
              Rw(t, Q.containerInfo))
          }
          function s_(t, Q, c) {
            if ((YL(Q), t === null))
              throw new Error("Should have a current fiber. This is a bug in React.")
            var f = Q.pendingProps,
              G = Q.memoizedState,
              m = G.element
            ;(kc(t, Q), Xd(Q, f, null, c))
            var x = Q.memoizedState
            Q.stateNode
            var z = x.element
            if (G.isDehydrated) {
              var gA = {
                  element: z,
                  isDehydrated: !1,
                  cache: x.cache,
                  pendingSuspenseBoundaries: x.pendingSuspenseBoundaries,
                  transitions: x.transitions,
                },
                hA = Q.updateQueue
              if (((hA.baseState = gA), (Q.memoizedState = gA), Q.flags & At)) {
                var pA = zS(
                  new Error(
                    "There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.",
                  ),
                  Q,
                )
                return qL(t, Q, z, c, pA)
              } else if (z !== m) {
                var gI = zS(
                  new Error(
                    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.",
                  ),
                  Q,
                )
                return qL(t, Q, z, c, gI)
              } else {
                Yk(Q)
                var $A = yc(Q, null, z, c)
                Q.child = $A
                for (var FI = $A; FI; ) ((FI.flags = (FI.flags & ~te) | hQ), (FI = FI.sibling))
              }
            } else {
              if ((fc(), z === m)) return Th(t, Q, c)
              OE(t, Q, z, c)
            }
            return Q.child
          }
          function qL(t, Q, c, f, G) {
            return (fc(), kr(G), (Q.flags |= At), OE(t, Q, c, f), Q.child)
          }
          function l_(t, Q, c) {
            ;(Wk(Q), t === null && fw(Q))
            var f = Q.type,
              G = Q.pendingProps,
              m = t !== null ? t.memoizedProps : null,
              x = G.children,
              z = $p(f, G)
            return (
              z ? (x = null) : m !== null && $p(f, m) && (Q.flags |= Ue),
              vL(t, Q),
              OE(t, Q, x, c),
              Q.child
            )
          }
          function c_(t, Q) {
            return (t === null && fw(Q), null)
          }
          function h_(t, Q, c, f) {
            nM(t, Q)
            var G = Q.pendingProps,
              m = c,
              x = m._payload,
              z = m._init,
              gA = z(x)
            Q.type = gA
            var hA = (Q.tag = c3(gA)),
              pA = De(gA, G),
              gI
            switch (hA) {
              case r:
                return (XR(Q, gA), (Q.type = gA = Gy(gA)), (gI = jR(null, Q, gA, pA, f)), gI)
              case s:
                return ((Q.type = gA = MJ(gA)), (gI = LL(null, Q, gA, pA, f)), gI)
              case Y:
                return ((Q.type = gA = UJ(gA)), (gI = RL(null, Q, gA, pA, f)), gI)
              case j: {
                if (Q.type !== Q.elementType) {
                  var $A = gA.propTypes
                  $A &&
                    Sr(
                      $A,
                      pA,
                      // Resolved for outer only
                      "prop",
                      ZC(gA),
                    )
                }
                return (
                  (gI = JL(
                    null,
                    Q,
                    gA,
                    De(gA.type, pA),
                    // The inner type can have defaults too
                    f,
                  )),
                  gI
                )
              }
            }
            var FI = ""
            throw (
              gA !== null &&
                typeof gA == "object" &&
                gA.$$typeof === jg &&
                (FI = " Did you wrap a component in React.lazy() more than once?"),
              new Error(
                "Element type is invalid. Received a promise that resolves to: " +
                  gA +
                  ". " +
                  ("Lazy element type must resolve to a class or function." + FI),
              )
            )
          }
          function u_(t, Q, c, f, G) {
            ;(nM(t, Q), (Q.tag = s))
            var m
            return (
              dr(c) ? ((m = !0), vd(Q)) : (m = !1),
              rl(Q, G),
              BM(Q, c, f),
              TR(Q, c, f, G),
              zR(null, Q, c, !0, m, G)
            )
          }
          function D_(t, Q, c, f) {
            nM(t, Q)
            var G = Q.pendingProps,
              m
            {
              var x = hc(Q, c, !1)
              m = bu(Q, x)
            }
            rl(Q, f)
            var z, gA
            xi(Q)
            {
              if (c.prototype && typeof c.prototype.render == "function") {
                var hA = ZC(c) || "Unknown"
                _R[hA] ||
                  (B(
                    "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
                    hA,
                    hA,
                  ),
                  (_R[hA] = !0))
              }
              ;(Q.mode & rC && fn.recordLegacyContextWarning(Q, null),
                ee(!0),
                (C0.current = Q),
                (z = Lh(null, Q, c, G, m, f)),
                (gA = AD()),
                ee(!1))
            }
            if (
              (Ke(),
              (Q.flags |= Je),
              typeof z == "object" &&
                z !== null &&
                typeof z.render == "function" &&
                z.$$typeof === void 0)
            ) {
              var pA = ZC(c) || "Unknown"
              e0[pA] ||
                (B(
                  "The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.",
                  pA,
                  pA,
                  pA,
                ),
                (e0[pA] = !0))
            }
            if (
              // Run these checks in production only if the flag is off.
              // Eventually we'll delete this branch altogether.
              typeof z == "object" &&
              z !== null &&
              typeof z.render == "function" &&
              z.$$typeof === void 0
            ) {
              {
                var gI = ZC(c) || "Unknown"
                e0[gI] ||
                  (B(
                    "The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.",
                    gI,
                    gI,
                    gI,
                  ),
                  (e0[gI] = !0))
              }
              ;((Q.tag = s), (Q.memoizedState = null), (Q.updateQueue = null))
              var $A = !1
              return (
                dr(c) ? (($A = !0), vd(Q)) : ($A = !1),
                (Q.memoizedState = z.state !== null && z.state !== void 0 ? z.state : null),
                FS(Q),
                g0(Q, z),
                TR(Q, c, G, f),
                zR(null, Q, c, !0, $A, f)
              )
            } else {
              if (((Q.tag = r), Q.mode & rC)) {
                Qi(!0)
                try {
                  ;((z = Lh(null, Q, c, G, m, f)), (gA = AD()))
                } finally {
                  Qi(!1)
                }
              }
              return (it() && gA && lw(Q), OE(null, Q, z, f), XR(Q, c), Q.child)
            }
          }
          function XR(t, Q) {
            {
              if (
                (Q &&
                  Q.childContextTypes &&
                  B(
                    "%s(...): childContextTypes cannot be defined on a function component.",
                    Q.displayName || Q.name || "Component",
                  ),
                t.ref !== null)
              ) {
                var c = "",
                  f = Vt()
                f &&
                  (c +=
                    `

Check the render method of \`` +
                    f +
                    "`.")
                var G = f || "",
                  m = t._debugSource
                ;(m && (G = m.fileName + ":" + m.lineNumber),
                  WR[G] ||
                    ((WR[G] = !0),
                    B(
                      "Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s",
                      c,
                    )))
              }
              if (Q.defaultProps !== void 0) {
                var x = ZC(Q) || "Unknown"
                i0[x] ||
                  (B(
                    "%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.",
                    x,
                  ),
                  (i0[x] = !0))
              }
              if (typeof Q.getDerivedStateFromProps == "function") {
                var z = ZC(Q) || "Unknown"
                PR[z] ||
                  (B("%s: Function components do not support getDerivedStateFromProps.", z),
                  (PR[z] = !0))
              }
              if (typeof Q.contextType == "object" && Q.contextType !== null) {
                var gA = ZC(Q) || "Unknown"
                ZR[gA] ||
                  (B("%s: Function components do not support contextType.", gA), (ZR[gA] = !0))
              }
            }
          }
          var $R = {
            dehydrated: null,
            treeContext: null,
            retryLane: ct,
          }
          function AJ(t) {
            return {
              baseLanes: t,
              cachePool: o_(),
              transitions: null,
            }
          }
          function S_(t, Q) {
            var c = null
            return {
              baseLanes: WI(t.baseLanes, Q),
              cachePool: c,
              transitions: t.transitions,
            }
          }
          function f_(t, Q, c, f) {
            if (Q !== null) {
              var G = Q.memoizedState
              if (G === null) return !1
            }
            return Kw(t, zu)
          }
          function d_(t, Q) {
            return Zg(t.childLanes, Q)
          }
          function HL(t, Q, c) {
            var f = Q.pendingProps
            F3(Q) && (Q.flags |= kC)
            var G = Bt.current,
              m = !1,
              x = (Q.flags & kC) !== nC
            if (
              (x || f_(G, t)
                ? ((m = !0), (Q.flags &= ~kC))
                : (t === null || t.memoizedState !== null) && (G = mR(G, jk)),
              (G = Kh(G)),
              Nc(Q, G),
              t === null)
            ) {
              fw(Q)
              var z = Q.memoizedState
              if (z !== null) {
                var gA = z.dehydrated
                if (gA !== null) return k_(Q, gA)
              }
              var hA = f.children,
                pA = f.fallback
              if (m) {
                var gI = y_(Q, hA, pA, c),
                  $A = Q.child
                return (($A.memoizedState = AJ(c)), (Q.memoizedState = $R), gI)
              } else return IJ(Q, hA)
            } else {
              var FI = t.memoizedState
              if (FI !== null) {
                var KI = FI.dehydrated
                if (KI !== null) return M_(t, Q, x, f, KI, FI, c)
              }
              if (m) {
                var OI = f.fallback,
                  Lg = f.children,
                  yC = w_(t, Q, Lg, OI, c),
                  EC = Q.child,
                  We = t.child.memoizedState
                return (
                  (EC.memoizedState = We === null ? AJ(c) : S_(We, c)),
                  (EC.childLanes = d_(t, c)),
                  (Q.memoizedState = $R),
                  yC
                )
              } else {
                var Le = f.children,
                  fI = p_(t, Q, Le, c)
                return ((Q.memoizedState = null), fI)
              }
            }
          }
          function IJ(t, Q, c) {
            var f = t.mode,
              G = {
                mode: "visible",
                children: Q,
              },
              m = gJ(G, f)
            return ((m.return = t), (t.child = m), m)
          }
          function y_(t, Q, c, f) {
            var G = t.mode,
              m = t.child,
              x = {
                mode: "hidden",
                children: Q,
              },
              z,
              gA
            return (
              (G & Pg) === zg && m !== null
                ? ((z = m),
                  (z.childLanes = Ag),
                  (z.pendingProps = x),
                  t.mode & uC &&
                    ((z.actualDuration = 0),
                    (z.actualStartTime = -1),
                    (z.selfBaseDuration = 0),
                    (z.treeBaseDuration = 0)),
                  (gA = QD(c, G, f, null)))
                : ((z = gJ(x, G)), (gA = QD(c, G, f, null))),
              (z.return = t),
              (gA.return = t),
              (z.sibling = gA),
              (t.child = z),
              gA
            )
          }
          function gJ(t, Q, c) {
            return TY(t, Q, Ag, null)
          }
          function TL(t, Q) {
            return Cf(t, Q)
          }
          function p_(t, Q, c, f) {
            var G = t.child,
              m = G.sibling,
              x = TL(G, {
                mode: "visible",
                children: c,
              })
            if (
              ((Q.mode & Pg) === zg && (x.lanes = f),
              (x.return = Q),
              (x.sibling = null),
              m !== null)
            ) {
              var z = Q.deletions
              z === null ? ((Q.deletions = [m]), (Q.flags |= de)) : z.push(m)
            }
            return ((Q.child = x), x)
          }
          function w_(t, Q, c, f, G) {
            var m = Q.mode,
              x = t.child,
              z = x.sibling,
              gA = {
                mode: "hidden",
                children: c,
              },
              hA
            if (
              // In legacy mode, we commit the primary tree as if it successfully
              // completed, even though it's in an inconsistent state.
              (m & Pg) === zg && // Make sure we're on the second pass, i.e. the primary child fragment was
              // already cloned. In legacy mode, the only case where this isn't true is
              // when DevTools forces us to display a fallback; we skip the first render
              // pass entirely and go straight to rendering the fallback. (In Concurrent
              // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
              // only codepath.)
              Q.child !== x
            ) {
              var pA = Q.child
              ;((hA = pA),
                (hA.childLanes = Ag),
                (hA.pendingProps = gA),
                Q.mode & uC &&
                  ((hA.actualDuration = 0),
                  (hA.actualStartTime = -1),
                  (hA.selfBaseDuration = x.selfBaseDuration),
                  (hA.treeBaseDuration = x.treeBaseDuration)),
                (Q.deletions = null))
            } else ((hA = TL(x, gA)), (hA.subtreeFlags = x.subtreeFlags & lg))
            var gI
            return (
              z !== null ? (gI = Cf(z, f)) : ((gI = QD(f, m, G, null)), (gI.flags |= te)),
              (gI.return = Q),
              (hA.return = Q),
              (hA.sibling = gI),
              (Q.child = hA),
              gI
            )
          }
          function oM(t, Q, c, f) {
            ;(f !== null && kr(f), Mr(Q, t.child, null, c))
            var G = Q.pendingProps,
              m = G.children,
              x = IJ(Q, m)
            return ((x.flags |= te), (Q.memoizedState = null), x)
          }
          function G_(t, Q, c, f, G) {
            var m = Q.mode,
              x = {
                mode: "visible",
                children: c,
              },
              z = gJ(x, m),
              gA = QD(f, m, G, null)
            return (
              (gA.flags |= te),
              (z.return = Q),
              (gA.return = Q),
              (z.sibling = gA),
              (Q.child = z),
              (Q.mode & Pg) !== zg && Mr(Q, t.child, null, G),
              gA
            )
          }
          function k_(t, Q, c) {
            return (
              (t.mode & Pg) === zg
                ? (B(
                    "Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.",
                  ),
                  (t.lanes = bg))
                : tw(Q)
                  ? (t.lanes = bt)
                  : (t.lanes = VB),
              null
            )
          }
          function M_(t, Q, c, f, G, m, x) {
            if (c)
              if (Q.flags & At) {
                Q.flags &= ~At
                var fI = xR(
                  new Error(
                    "There was an error while hydrating this Suspense boundary. Switched to client rendering.",
                  ),
                )
                return oM(t, Q, x, fI)
              } else {
                if (Q.memoizedState !== null) return ((Q.child = t.child), (Q.flags |= kC), null)
                var _I = f.children,
                  dI = f.fallback,
                  sg = G_(t, Q, _I, dI, x),
                  _g = Q.child
                return ((_g.memoizedState = AJ(x)), (Q.memoizedState = $R), sg)
              }
            else {
              if ((cw(), (Q.mode & Pg) === zg))
                return oM(
                  t,
                  Q,
                  x,
                  // TODO: When we delete legacy mode, we should make this error argument
                  // required — every concurrent mode path that causes hydration to
                  // de-opt to client rendering should have an error message.
                  null,
                )
              if (tw(G)) {
                var z, gA, hA
                {
                  var pA = Dk(G)
                  ;((z = pA.digest), (gA = pA.message), (hA = pA.stack))
                }
                var gI
                gA
                  ? (gI = new Error(gA))
                  : (gI = new Error(
                      "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.",
                    ))
                var $A = xR(gI, z, hA)
                return oM(t, Q, x, $A)
              }
              var FI = zA(x, t.childLanes)
              if (cl || FI) {
                var KI = SM()
                if (KI !== null) {
                  var OI = jc(KI, x)
                  if (OI !== ct && OI !== m.retryLane) {
                    m.retryLane = OI
                    var Lg = ue
                    ;(mB(t, OI), co(KI, t, OI, Lg))
                  }
                }
                yJ()
                var yC = xR(
                  new Error(
                    "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.",
                  ),
                )
                return oM(t, Q, x, yC)
              } else if (iw(G)) {
                ;((Q.flags |= kC), (Q.child = t.child))
                var EC = $4.bind(null, t)
                return (cR(G, EC), null)
              } else {
                MR(Q, G, m.treeContext)
                var We = f.children,
                  Le = IJ(Q, We)
                return ((Le.flags |= hQ), Le)
              }
            }
          }
          function xL(t, Q, c) {
            t.lanes = WI(t.lanes, Q)
            var f = t.alternate
            ;(f !== null && (f.lanes = WI(f.lanes, Q)), Gw(t.return, Q, c))
          }
          function U_(t, Q, c) {
            for (var f = Q; f !== null; ) {
              if (f.tag === V) {
                var G = f.memoizedState
                G !== null && xL(f, c, t)
              } else if (f.tag === eA) xL(f, c, t)
              else if (f.child !== null) {
                ;((f.child.return = f), (f = f.child))
                continue
              }
              if (f === t) return
              for (; f.sibling === null; ) {
                if (f.return === null || f.return === t) return
                f = f.return
              }
              ;((f.sibling.return = f.return), (f = f.sibling))
            }
          }
          function N_(t) {
            for (var Q = t, c = null; Q !== null; ) {
              var f = Q.alternate
              ;(f !== null && YS(f) === null && (c = Q), (Q = Q.sibling))
            }
            return c
          }
          function F_(t) {
            if (t !== void 0 && t !== "forwards" && t !== "backwards" && t !== "together" && !VR[t])
              if (((VR[t] = !0), typeof t == "string"))
                switch (t.toLowerCase()) {
                  case "together":
                  case "forwards":
                  case "backwards": {
                    B(
                      '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                      t,
                      t.toLowerCase(),
                    )
                    break
                  }
                  case "forward":
                  case "backward": {
                    B(
                      '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                      t,
                      t.toLowerCase(),
                    )
                    break
                  }
                  default:
                    B(
                      '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
                      t,
                    )
                    break
                }
              else
                B(
                  '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
                  t,
                )
          }
          function R_(t, Q) {
            t !== void 0 &&
              !QM[t] &&
              (t !== "collapsed" && t !== "hidden"
                ? ((QM[t] = !0),
                  B(
                    '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?',
                    t,
                  ))
                : Q !== "forwards" &&
                  Q !== "backwards" &&
                  ((QM[t] = !0),
                  B(
                    '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
                    t,
                  )))
          }
          function bL(t, Q) {
            {
              var c = le(t),
                f = !c && typeof yg(t) == "function"
              if (c || f) {
                var G = c ? "array" : "iterable"
                return (
                  B(
                    "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
                    G,
                    Q,
                    G,
                  ),
                  !1
                )
              }
            }
            return !0
          }
          function J_(t, Q) {
            if ((Q === "forwards" || Q === "backwards") && t !== void 0 && t !== null && t !== !1)
              if (le(t)) {
                for (var c = 0; c < t.length; c++) if (!bL(t[c], c)) return
              } else {
                var f = yg(t)
                if (typeof f == "function") {
                  var G = f.call(t)
                  if (G)
                    for (var m = G.next(), x = 0; !m.done; m = G.next()) {
                      if (!bL(m.value, x)) return
                      x++
                    }
                } else
                  B(
                    'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
                    Q,
                  )
              }
          }
          function CJ(t, Q, c, f, G) {
            var m = t.memoizedState
            m === null
              ? (t.memoizedState = {
                  isBackwards: Q,
                  rendering: null,
                  renderingStartTime: 0,
                  last: f,
                  tail: c,
                  tailMode: G,
                })
              : ((m.isBackwards = Q),
                (m.rendering = null),
                (m.renderingStartTime = 0),
                (m.last = f),
                (m.tail = c),
                (m.tailMode = G))
          }
          function OL(t, Q, c) {
            var f = Q.pendingProps,
              G = f.revealOrder,
              m = f.tail,
              x = f.children
            ;(F_(G), R_(m, G), J_(x, G), OE(t, Q, x, c))
            var z = Bt.current,
              gA = Kw(z, zu)
            if (gA) ((z = mw(z, zu)), (Q.flags |= kC))
            else {
              var hA = t !== null && (t.flags & kC) !== nC
              ;(hA && U_(Q, Q.child, c), (z = Kh(z)))
            }
            if ((Nc(Q, z), (Q.mode & Pg) === zg)) Q.memoizedState = null
            else
              switch (G) {
                case "forwards": {
                  var pA = N_(Q.child),
                    gI
                  ;(pA === null
                    ? ((gI = Q.child), (Q.child = null))
                    : ((gI = pA.sibling), (pA.sibling = null)),
                    CJ(
                      Q,
                      !1,
                      // isBackwards
                      gI,
                      pA,
                      m,
                    ))
                  break
                }
                case "backwards": {
                  var $A = null,
                    FI = Q.child
                  for (Q.child = null; FI !== null; ) {
                    var KI = FI.alternate
                    if (KI !== null && YS(KI) === null) {
                      Q.child = FI
                      break
                    }
                    var OI = FI.sibling
                    ;((FI.sibling = $A), ($A = FI), (FI = OI))
                  }
                  CJ(
                    Q,
                    !0,
                    // isBackwards
                    $A,
                    null,
                    // last
                    m,
                  )
                  break
                }
                case "together": {
                  CJ(
                    Q,
                    !1,
                    // isBackwards
                    null,
                    // tail
                    null,
                    // last
                    void 0,
                  )
                  break
                }
                default:
                  Q.memoizedState = null
              }
            return Q.child
          }
          function K_(t, Q, c) {
            Rw(Q, Q.stateNode.containerInfo)
            var f = Q.pendingProps
            return (t === null ? (Q.child = Mr(Q, null, f, c)) : OE(t, Q, f, c), Q.child)
          }
          var _L = !1
          function m_(t, Q, c) {
            var f = Q.type,
              G = f._context,
              m = Q.pendingProps,
              x = Q.memoizedProps,
              z = m.value
            {
              "value" in m ||
                _L ||
                ((_L = !0),
                B(
                  "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?",
                ))
              var gA = Q.type.propTypes
              gA && Sr(gA, m, "prop", "Context.Provider")
            }
            if ((Oo(Q, G, z), x !== null)) {
              var hA = x.value
              if (Vg(hA, z)) {
                if (x.children === m.children && !Ou()) return Th(t, Q, c)
              } else wQ(Q, G, c)
            }
            var pA = m.children
            return (OE(t, Q, pA, c), Q.child)
          }
          var ZL = !1
          function v_(t, Q, c) {
            var f = Q.type
            f._context === void 0
              ? f !== f.Consumer &&
                (ZL ||
                  ((ZL = !0),
                  B(
                    "Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?",
                  )))
              : (f = f._context)
            var G = Q.pendingProps,
              m = G.children
            ;(typeof m != "function" &&
              B(
                "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.",
              ),
              rl(Q, c))
            var x = KB(f)
            xi(Q)
            var z
            return (
              (C0.current = Q),
              ee(!0),
              (z = m(x)),
              ee(!1),
              Ke(),
              (Q.flags |= Je),
              OE(t, Q, z, c),
              Q.child
            )
          }
          function t0() {
            cl = !0
          }
          function nM(t, Q) {
            ;(Q.mode & Pg) === zg &&
              t !== null &&
              ((t.alternate = null), (Q.alternate = null), (Q.flags |= te))
          }
          function Th(t, Q, c) {
            return (
              t !== null && (Q.dependencies = t.dependencies),
              MI(),
              u0(Q.lanes),
              zA(c, Q.childLanes) ? (al(t, Q), Q.child) : null
            )
          }
          function L_(t, Q, c) {
            {
              var f = Q.return
              if (f === null) throw new Error("Cannot swap the root fiber.")
              if (
                ((t.alternate = null),
                (Q.alternate = null),
                (c.index = Q.index),
                (c.sibling = Q.sibling),
                (c.return = Q.return),
                (c.ref = Q.ref),
                Q === f.child)
              )
                f.child = c
              else {
                var G = f.child
                if (G === null) throw new Error("Expected parent to have a child.")
                for (; G.sibling !== Q; )
                  if (((G = G.sibling), G === null))
                    throw new Error("Expected to find the previous sibling.")
                G.sibling = c
              }
              var m = f.deletions
              return (
                m === null ? ((f.deletions = [t]), (f.flags |= de)) : m.push(t),
                (c.flags |= te),
                c
              )
            }
          }
          function eJ(t, Q) {
            var c = t.lanes
            return !!zA(c, Q)
          }
          function Y_(t, Q, c) {
            switch (Q.tag) {
              case S:
                ;(YL(Q), Q.stateNode, fc())
                break
              case w:
                Wk(Q)
                break
              case s: {
                var f = Q.type
                dr(f) && vd(Q)
                break
              }
              case d:
                Rw(Q, Q.stateNode.containerInfo)
                break
              case L: {
                var G = Q.memoizedProps.value,
                  m = Q.type._context
                Oo(Q, m, G)
                break
              }
              case H:
                {
                  var x = zA(c, Q.childLanes)
                  x && (Q.flags |= IC)
                  {
                    var z = Q.stateNode
                    ;((z.effectDuration = 0), (z.passiveEffectDuration = 0))
                  }
                }
                break
              case V: {
                var gA = Q.memoizedState
                if (gA !== null) {
                  if (gA.dehydrated !== null) return (Nc(Q, Kh(Bt.current)), (Q.flags |= kC), null)
                  var hA = Q.child,
                    pA = hA.childLanes
                  if (zA(c, pA)) return HL(t, Q, c)
                  Nc(Q, Kh(Bt.current))
                  var gI = Th(t, Q, c)
                  return gI !== null ? gI.sibling : null
                } else Nc(Q, Kh(Bt.current))
                break
              }
              case eA: {
                var $A = (t.flags & kC) !== nC,
                  FI = zA(c, Q.childLanes)
                if ($A) {
                  if (FI) return OL(t, Q, c)
                  Q.flags |= kC
                }
                var KI = Q.memoizedState
                if (
                  (KI !== null && ((KI.rendering = null), (KI.tail = null), (KI.lastEffect = null)),
                  Nc(Q, Bt.current),
                  FI)
                )
                  break
                return null
              }
              case aA:
              case lA:
                return ((Q.lanes = Ag), mL(t, Q, c))
            }
            return Th(t, Q, c)
          }
          function PL(t, Q, c) {
            if (Q._debugNeedsRemount && t !== null)
              return L_(
                t,
                Q,
                KJ(Q.type, Q.key, Q.pendingProps, Q._debugOwner || null, Q.mode, Q.lanes),
              )
            if (t !== null) {
              var f = t.memoizedProps,
                G = Q.pendingProps
              if (
                f !== G ||
                Ou() || // Force a re-render if the implementation changed due to hot reload:
                Q.type !== t.type
              )
                cl = !0
              else {
                var m = eJ(t, c)
                if (
                  !m && // If this is the second pass of an error or suspense boundary, there
                  // may not be work scheduled on `current`, so we check for this flag.
                  (Q.flags & kC) === nC
                )
                  return ((cl = !1), Y_(t, Q, c))
                ;(t.flags & jr) !== nC ? (cl = !0) : (cl = !1)
              }
            } else if (((cl = !1), it() && vk(Q))) {
              var x = Q.index,
                z = ka()
              Lk(Q, z, x)
            }
            switch (((Q.lanes = Ag), Q.tag)) {
              case h:
                return D_(t, Q, Q.type, c)
              case AA: {
                var gA = Q.elementType
                return h_(t, Q, gA, c)
              }
              case r: {
                var hA = Q.type,
                  pA = Q.pendingProps,
                  gI = Q.elementType === hA ? pA : De(hA, pA)
                return jR(t, Q, hA, gI, c)
              }
              case s: {
                var $A = Q.type,
                  FI = Q.pendingProps,
                  KI = Q.elementType === $A ? FI : De($A, FI)
                return LL(t, Q, $A, KI, c)
              }
              case S:
                return s_(t, Q, c)
              case w:
                return l_(t, Q, c)
              case M:
                return c_(t, Q)
              case V:
                return HL(t, Q, c)
              case d:
                return K_(t, Q, c)
              case Y: {
                var OI = Q.type,
                  Lg = Q.pendingProps,
                  yC = Q.elementType === OI ? Lg : De(OI, Lg)
                return RL(t, Q, OI, yC, c)
              }
              case K:
                return E_(t, Q, c)
              case R:
                return a_(t, Q, c)
              case H:
                return r_(t, Q, c)
              case L:
                return m_(t, Q, c)
              case F:
                return v_(t, Q, c)
              case j: {
                var EC = Q.type,
                  We = Q.pendingProps,
                  Le = De(EC, We)
                if (Q.type !== Q.elementType) {
                  var fI = EC.propTypes
                  fI &&
                    Sr(
                      fI,
                      Le,
                      // Resolved for outer only
                      "prop",
                      ZC(EC),
                    )
                }
                return ((Le = De(EC.type, Le)), JL(t, Q, EC, Le, c))
              }
              case P:
                return KL(t, Q, Q.type, Q.pendingProps, c)
              case X: {
                var _I = Q.type,
                  dI = Q.pendingProps,
                  sg = Q.elementType === _I ? dI : De(_I, dI)
                return u_(t, Q, _I, sg, c)
              }
              case eA:
                return OL(t, Q, c)
              case CA:
                break
              case aA:
                return mL(t, Q, c)
            }
            throw new Error(
              "Unknown unit of work tag (" +
                Q.tag +
                "). This error is likely caused by a bug in React. Please file an issue.",
            )
          }
          function Dy(t) {
            t.flags |= IC
          }
          function WL(t) {
            ;((t.flags |= bB), (t.flags |= oa))
          }
          var VL, iJ, jL, zL
          ;((VL = function (t, Q, c, f) {
            for (var G = Q.child; G !== null; ) {
              if (G.tag === w || G.tag === M) CR(t, G.stateNode)
              else if (G.tag !== d) {
                if (G.child !== null) {
                  ;((G.child.return = G), (G = G.child))
                  continue
                }
              }
              if (G === Q) return
              for (; G.sibling === null; ) {
                if (G.return === null || G.return === Q) return
                G = G.return
              }
              ;((G.sibling.return = G.return), (G = G.sibling))
            }
          }),
            (iJ = function (t, Q) {}),
            (jL = function (t, Q, c, f, G) {
              var m = t.memoizedProps
              if (m !== f) {
                var x = Q.stateNode,
                  z = Jw(),
                  gA = eR(x, c, m, f, G, z)
                ;((Q.updateQueue = gA), gA && Dy(Q))
              }
            }),
            (zL = function (t, Q, c, f) {
              c !== f && Dy(Q)
            }))
          function B0(t, Q) {
            if (!it())
              switch (t.tailMode) {
                case "hidden": {
                  for (var c = t.tail, f = null; c !== null; )
                    (c.alternate !== null && (f = c), (c = c.sibling))
                  f === null ? (t.tail = null) : (f.sibling = null)
                  break
                }
                case "collapsed": {
                  for (var G = t.tail, m = null; G !== null; )
                    (G.alternate !== null && (m = G), (G = G.sibling))
                  m === null
                    ? !Q && t.tail !== null
                      ? (t.tail.sibling = null)
                      : (t.tail = null)
                    : (m.sibling = null)
                  break
                }
              }
          }
          function kn(t) {
            var Q = t.alternate !== null && t.alternate.child === t.child,
              c = Ag,
              f = nC
            if (Q) {
              if ((t.mode & uC) !== zg) {
                for (var gA = t.selfBaseDuration, hA = t.child; hA !== null; )
                  ((c = WI(c, WI(hA.lanes, hA.childLanes))),
                    (f |= hA.subtreeFlags & lg),
                    (f |= hA.flags & lg),
                    (gA += hA.treeBaseDuration),
                    (hA = hA.sibling))
                t.treeBaseDuration = gA
              } else
                for (var pA = t.child; pA !== null; )
                  ((c = WI(c, WI(pA.lanes, pA.childLanes))),
                    (f |= pA.subtreeFlags & lg),
                    (f |= pA.flags & lg),
                    (pA.return = t),
                    (pA = pA.sibling))
              t.subtreeFlags |= f
            } else {
              if ((t.mode & uC) !== zg) {
                for (var G = t.actualDuration, m = t.selfBaseDuration, x = t.child; x !== null; )
                  ((c = WI(c, WI(x.lanes, x.childLanes))),
                    (f |= x.subtreeFlags),
                    (f |= x.flags),
                    (G += x.actualDuration),
                    (m += x.treeBaseDuration),
                    (x = x.sibling))
                ;((t.actualDuration = G), (t.treeBaseDuration = m))
              } else
                for (var z = t.child; z !== null; )
                  ((c = WI(c, WI(z.lanes, z.childLanes))),
                    (f |= z.subtreeFlags),
                    (f |= z.flags),
                    (z.return = t),
                    (z = z.sibling))
              t.subtreeFlags |= f
            }
            return ((t.childLanes = c), Q)
          }
          function q_(t, Q, c) {
            if (Gr() && (Q.mode & Pg) !== zg && (Q.flags & kC) === nC)
              return (JB(Q), fc(), (Q.flags |= At | OB | Xt), !1)
            var f = dt(Q)
            if (c !== null && c.dehydrated !== null)
              if (t === null) {
                if (!f)
                  throw new Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.",
                  )
                if ((NR(Q), kn(Q), (Q.mode & uC) !== zg)) {
                  var G = c !== null
                  if (G) {
                    var m = Q.child
                    m !== null && (Q.treeBaseDuration -= m.treeBaseDuration)
                  }
                }
                return !1
              } else {
                if (
                  (fc(),
                  (Q.flags & kC) === nC && (Q.memoizedState = null),
                  (Q.flags |= IC),
                  kn(Q),
                  (Q.mode & uC) !== zg)
                ) {
                  var x = c !== null
                  if (x) {
                    var z = Q.child
                    z !== null && (Q.treeBaseDuration -= z.treeBaseDuration)
                  }
                }
                return !1
              }
            else return (no(), !0)
          }
          function XL(t, Q, c) {
            var f = Q.pendingProps
            switch ((Wu(Q), Q.tag)) {
              case h:
              case AA:
              case P:
              case r:
              case Y:
              case K:
              case R:
              case H:
              case F:
              case j:
                return (kn(Q), null)
              case s: {
                var G = Q.type
                return (dr(G) && md(Q), kn(Q), null)
              }
              case S: {
                var m = Q.stateNode
                if (
                  (dn(Q),
                  _u(Q),
                  qS(),
                  m.pendingContext && ((m.context = m.pendingContext), (m.pendingContext = null)),
                  t === null || t.child === null)
                ) {
                  var x = dt(Q)
                  if (x) Dy(Q)
                  else if (t !== null) {
                    var z = t.memoizedState
                    // Check if this is a client root
                    ;(!z.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                      (Q.flags & At) !== nC) &&
                      ((Q.flags |= cQ), no())
                  }
                }
                return (iJ(t, Q), kn(Q), null)
              }
              case w: {
                Ay(Q)
                var gA = Uc(),
                  hA = Q.type
                if (t !== null && Q.stateNode != null)
                  (jL(t, Q, hA, f, gA), t.ref !== Q.ref && WL(Q))
                else {
                  if (!f) {
                    if (Q.stateNode === null)
                      throw new Error(
                        "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.",
                      )
                    return (kn(Q), null)
                  }
                  var pA = Jw(),
                    gI = dt(Q)
                  if (gI) UR(Q, gA, pA) && Dy(Q)
                  else {
                    var $A = ok(hA, f, gA, pA, Q)
                    ;(VL($A, Q, !1, !1), (Q.stateNode = $A), nk($A, hA, f, gA) && Dy(Q))
                  }
                  Q.ref !== null && WL(Q)
                }
                return (kn(Q), null)
              }
              case M: {
                var FI = f
                if (t && Q.stateNode != null) {
                  var KI = t.memoizedProps
                  zL(t, Q, KI, FI)
                } else {
                  if (typeof FI != "string" && Q.stateNode === null)
                    throw new Error(
                      "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.",
                    )
                  var OI = Uc(),
                    Lg = Jw(),
                    yC = dt(Q)
                  yC ? Tk(Q) && Dy(Q) : (Q.stateNode = iR(FI, OI, Lg, Q))
                }
                return (kn(Q), null)
              }
              case V: {
                Xu(Q)
                var EC = Q.memoizedState
                if (
                  t === null ||
                  (t.memoizedState !== null && t.memoizedState.dehydrated !== null)
                ) {
                  var We = q_(t, Q, EC)
                  if (!We) return Q.flags & Xt ? Q : null
                }
                if ((Q.flags & kC) !== nC) return ((Q.lanes = c), (Q.mode & uC) !== zg && Ge(Q), Q)
                var Le = EC !== null,
                  fI = t !== null && t.memoizedState !== null
                if (Le !== fI && Le) {
                  var _I = Q.child
                  if (((_I.flags |= bn), (Q.mode & Pg) !== zg)) {
                    var dI = t === null && (Q.memoizedProps.unstable_avoidThisFallback !== !0 || !$)
                    dI || Kw(Bt.current, jk) ? H4() : yJ()
                  }
                }
                var sg = Q.updateQueue
                if ((sg !== null && (Q.flags |= IC), kn(Q), (Q.mode & uC) !== zg && Le)) {
                  var _g = Q.child
                  _g !== null && (Q.treeBaseDuration -= _g.treeBaseDuration)
                }
                return null
              }
              case d:
                return (dn(Q), iJ(t, Q), t === null && Tu(Q.stateNode.containerInfo), kn(Q), null)
              case L:
                var Hg = Q.type._context
                return (ls(Hg, Q), kn(Q), null)
              case X: {
                var xC = Q.type
                return (dr(xC) && md(Q), kn(Q), null)
              }
              case eA: {
                Xu(Q)
                var Ce = Q.memoizedState
                if (Ce === null) return (kn(Q), null)
                var Wi = (Q.flags & kC) !== nC,
                  hi = Ce.rendering
                if (hi === null)
                  if (Wi) B0(Ce, !1)
                  else {
                    var MQ = x4() && (t === null || (t.flags & kC) === nC)
                    if (!MQ)
                      for (var ui = Q.child; ui !== null; ) {
                        var IQ = YS(ui)
                        if (IQ !== null) {
                          ;((Wi = !0), (Q.flags |= kC), B0(Ce, !1))
                          var QE = IQ.updateQueue
                          return (
                            QE !== null && ((Q.updateQueue = QE), (Q.flags |= IC)),
                            (Q.subtreeFlags = nC),
                            kS(Q, c),
                            Nc(Q, mw(Bt.current, zu)),
                            Q.child
                          )
                        }
                        ui = ui.sibling
                      }
                    Ce.tail !== null &&
                      Hi() > DY() &&
                      ((Q.flags |= kC), (Wi = !0), B0(Ce, !1), (Q.lanes = ca))
                  }
                else {
                  if (!Wi) {
                    var Rn = YS(hi)
                    if (Rn !== null) {
                      ;((Q.flags |= kC), (Wi = !0))
                      var Fr = Rn.updateQueue
                      if (
                        (Fr !== null && ((Q.updateQueue = Fr), (Q.flags |= IC)),
                        B0(Ce, !0),
                        Ce.tail === null && Ce.tailMode === "hidden" && !hi.alternate && !it())
                      )
                        return (kn(Q), null)
                    } // The time it took to render last row is greater than the remaining
                    else
                      // time we have to render. So rendering one more row would likely
                      // exceed it.
                      Hi() * 2 - Ce.renderingStartTime > DY() &&
                        c !== VB &&
                        ((Q.flags |= kC), (Wi = !0), B0(Ce, !1), (Q.lanes = ca))
                  }
                  if (Ce.isBackwards) ((hi.sibling = Q.child), (Q.child = hi))
                  else {
                    var PE = Ce.last
                    ;(PE !== null ? (PE.sibling = hi) : (Q.child = hi), (Ce.last = hi))
                  }
                }
                if (Ce.tail !== null) {
                  var WE = Ce.tail
                  ;((Ce.rendering = WE),
                    (Ce.tail = WE.sibling),
                    (Ce.renderingStartTime = Hi()),
                    (WE.sibling = null))
                  var oE = Bt.current
                  return (Wi ? (oE = mw(oE, zu)) : (oE = Kh(oE)), Nc(Q, oE), WE)
                }
                return (kn(Q), null)
              }
              case CA:
                break
              case aA:
              case lA: {
                dJ(Q)
                var Zh = Q.memoizedState,
                  ky = Zh !== null
                if (t !== null) {
                  var y0 = t.memoizedState,
                    qc = y0 !== null
                  qc !== ky && // LegacyHidden doesn't do any hiding — it only pre-renders.
                    !sA &&
                    (Q.flags |= bn)
                }
                return (
                  !ky || (Q.mode & Pg) === zg
                    ? kn(Q)
                    : zA(Yc, VB) && (kn(Q), Q.subtreeFlags & (te | IC) && (Q.flags |= bn)),
                  null
                )
              }
              case JA:
                return null
              case yA:
                return null
            }
            throw new Error(
              "Unknown unit of work tag (" +
                Q.tag +
                "). This error is likely caused by a bug in React. Please file an issue.",
            )
          }
          function H_(t, Q, c) {
            switch ((Wu(Q), Q.tag)) {
              case s: {
                var f = Q.type
                dr(f) && md(Q)
                var G = Q.flags
                return G & Xt
                  ? ((Q.flags = (G & ~Xt) | kC), (Q.mode & uC) !== zg && Ge(Q), Q)
                  : null
              }
              case S: {
                ;(Q.stateNode, dn(Q), _u(Q), qS())
                var m = Q.flags
                return (m & Xt) !== nC && (m & kC) === nC ? ((Q.flags = (m & ~Xt) | kC), Q) : null
              }
              case w:
                return (Ay(Q), null)
              case V: {
                Xu(Q)
                var x = Q.memoizedState
                if (x !== null && x.dehydrated !== null) {
                  if (Q.alternate === null)
                    throw new Error(
                      "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.",
                    )
                  fc()
                }
                var z = Q.flags
                return z & Xt
                  ? ((Q.flags = (z & ~Xt) | kC), (Q.mode & uC) !== zg && Ge(Q), Q)
                  : null
              }
              case eA:
                return (Xu(Q), null)
              case d:
                return (dn(Q), null)
              case L:
                var gA = Q.type._context
                return (ls(gA, Q), null)
              case aA:
              case lA:
                return (dJ(Q), null)
              case JA:
                return null
              default:
                return null
            }
          }
          function $L(t, Q, c) {
            switch ((Wu(Q), Q.tag)) {
              case s: {
                var f = Q.type.childContextTypes
                f != null && md(Q)
                break
              }
              case S: {
                ;(Q.stateNode, dn(Q), _u(Q), qS())
                break
              }
              case w: {
                Ay(Q)
                break
              }
              case d:
                dn(Q)
                break
              case V:
                Xu(Q)
                break
              case eA:
                Xu(Q)
                break
              case L:
                var G = Q.type._context
                ls(G, Q)
                break
              case aA:
              case lA:
                dJ(Q)
                break
            }
          }
          var AY = null
          AY = /* @__PURE__ */ new Set()
          var EM = !1,
            Mn = !1,
            T_ = typeof WeakSet == "function" ? WeakSet : Set,
            CC = null,
            Sy = null,
            fy = null
          function x_(t) {
            ;(xn(null, function () {
              throw t
            }),
              Ir())
          }
          var b_ = function (t, Q) {
            if (((Q.props = t.memoizedProps), (Q.state = t.memoizedState), t.mode & uC))
              try {
                ;(Og(), Q.componentWillUnmount())
              } finally {
                uI(t)
              }
            else Q.componentWillUnmount()
          }
          function IY(t, Q) {
            try {
              CD(vB, t)
            } catch (c) {
              Kt(t, Q, c)
            }
          }
          function tJ(t, Q, c) {
            try {
              b_(t, c)
            } catch (f) {
              Kt(t, Q, f)
            }
          }
          function O_(t, Q, c) {
            try {
              c.componentDidMount()
            } catch (f) {
              Kt(t, Q, f)
            }
          }
          function gY(t, Q) {
            try {
              eY(t)
            } catch (c) {
              Kt(t, Q, c)
            }
          }
          function dy(t, Q) {
            var c = t.ref
            if (c !== null)
              if (typeof c == "function") {
                var f
                try {
                  if (kA && NA && t.mode & uC)
                    try {
                      ;(Og(), (f = c(null)))
                    } finally {
                      uI(t)
                    }
                  else f = c(null)
                } catch (G) {
                  Kt(t, Q, G)
                }
                typeof f == "function" &&
                  B(
                    "Unexpected return value from a callback ref in %s. A callback ref should not return a function.",
                    oC(t),
                  )
              } else c.current = null
          }
          function aM(t, Q, c) {
            try {
              c()
            } catch (f) {
              Kt(t, Q, f)
            }
          }
          var CY = !1
          function __(t, Q) {
            ;(Qk(t.containerInfo), (CC = Q), Z_())
            var c = CY
            return ((CY = !1), c)
          }
          function Z_() {
            for (; CC !== null; ) {
              var t = CC,
                Q = t.child
              ;(t.subtreeFlags & LC) !== nC && Q !== null ? ((Q.return = t), (CC = Q)) : P_()
            }
          }
          function P_() {
            for (; CC !== null; ) {
              var t = CC
              Me(t)
              try {
                W_(t)
              } catch (c) {
                Kt(t, t.return, c)
              }
              di()
              var Q = t.sibling
              if (Q !== null) {
                ;((Q.return = t.return), (CC = Q))
                return
              }
              CC = t.return
            }
          }
          function W_(t) {
            var Q = t.alternate,
              c = t.flags
            if ((c & cQ) !== nC) {
              switch ((Me(t), t.tag)) {
                case r:
                case Y:
                case P:
                  break
                case s: {
                  if (Q !== null) {
                    var f = Q.memoizedProps,
                      G = Q.memoizedState,
                      m = t.stateNode
                    t.type === t.elementType &&
                      !XS &&
                      (m.props !== t.memoizedProps &&
                        B(
                          "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                          oC(t) || "instance",
                        ),
                      m.state !== t.memoizedState &&
                        B(
                          "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                          oC(t) || "instance",
                        ))
                    var x = m.getSnapshotBeforeUpdate(
                      t.elementType === t.type ? f : De(t.type, f),
                      G,
                    )
                    {
                      var z = AY
                      x === void 0 &&
                        !z.has(t.type) &&
                        (z.add(t.type),
                        B(
                          "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
                          oC(t),
                        ))
                    }
                    m.__reactInternalSnapshotBeforeUpdate = x
                  }
                  break
                }
                case S: {
                  {
                    var gA = t.stateNode
                    sR(gA.containerInfo)
                  }
                  break
                }
                case w:
                case M:
                case d:
                case X:
                  break
                default:
                  throw new Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.",
                  )
              }
              di()
            }
          }
          function hl(t, Q, c) {
            var f = Q.updateQueue,
              G = f !== null ? f.lastEffect : null
            if (G !== null) {
              var m = G.next,
                x = m
              do {
                if ((x.tag & t) === t) {
                  var z = x.destroy
                  ;((x.destroy = void 0),
                    z !== void 0 &&
                      ((t & ao) !== Eo ? ir(Q) : (t & vB) !== Eo && IB(Q),
                      (t & Ur) !== Eo && S0(!0),
                      aM(Q, c, z),
                      (t & Ur) !== Eo && S0(!1),
                      (t & ao) !== Eo ? lt() : (t & vB) !== Eo && aa()))
                }
                x = x.next
              } while (x !== m)
            }
          }
          function CD(t, Q) {
            var c = Q.updateQueue,
              f = c !== null ? c.lastEffect : null
            if (f !== null) {
              var G = f.next,
                m = G
              do {
                if ((m.tag & t) === t) {
                  ;(t & ao) !== Eo ? Ie(Q) : (t & vB) !== Eo && tr(Q)
                  var x = m.create
                  ;((t & Ur) !== Eo && S0(!0),
                    (m.destroy = x()),
                    (t & Ur) !== Eo && S0(!1),
                    (t & ao) !== Eo ? PB() : (t & vB) !== Eo && HQ())
                  {
                    var z = m.destroy
                    if (z !== void 0 && typeof z != "function") {
                      var gA = void 0
                      ;(m.tag & vB) !== nC
                        ? (gA = "useLayoutEffect")
                        : (m.tag & Ur) !== nC
                          ? (gA = "useInsertionEffect")
                          : (gA = "useEffect")
                      var hA = void 0
                      ;(z === null
                        ? (hA =
                            " You returned null. If your effect does not require clean up, return undefined (or nothing).")
                        : typeof z.then == "function"
                          ? (hA =
                              `

It looks like you wrote ` +
                              gA +
                              `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` +
                              gA +
                              `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching`)
                          : (hA = " You returned: " + z),
                        B(
                          "%s must not return anything besides a function, which is used for clean-up.%s",
                          gA,
                          hA,
                        ))
                    }
                  }
                }
                m = m.next
              } while (m !== G)
            }
          }
          function V_(t, Q) {
            if ((Q.flags & IC) !== nC)
              switch (Q.tag) {
                case H: {
                  var c = Q.stateNode.passiveEffectDuration,
                    f = Q.memoizedProps,
                    G = f.id,
                    m = f.onPostCommit,
                    x = MC(),
                    z = Q.alternate === null ? "mount" : "update"
                  ;(og() && (z = "nested-update"), typeof m == "function" && m(G, z, c, x))
                  var gA = Q.return
                  A: for (; gA !== null; ) {
                    switch (gA.tag) {
                      case S:
                        var hA = gA.stateNode
                        hA.passiveEffectDuration += c
                        break A
                      case H:
                        var pA = gA.stateNode
                        pA.passiveEffectDuration += c
                        break A
                    }
                    gA = gA.return
                  }
                  break
                }
              }
          }
          function j_(t, Q, c, f) {
            if ((c.flags & It) !== nC)
              switch (c.tag) {
                case r:
                case Y:
                case P: {
                  if (!Mn)
                    if (c.mode & uC)
                      try {
                        ;(Og(), CD(vB | DB, c))
                      } finally {
                        uI(c)
                      }
                    else CD(vB | DB, c)
                  break
                }
                case s: {
                  var G = c.stateNode
                  if (c.flags & IC && !Mn)
                    if (Q === null)
                      if (
                        (c.type === c.elementType &&
                          !XS &&
                          (G.props !== c.memoizedProps &&
                            B(
                              "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                              oC(c) || "instance",
                            ),
                          G.state !== c.memoizedState &&
                            B(
                              "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                              oC(c) || "instance",
                            )),
                        c.mode & uC)
                      )
                        try {
                          ;(Og(), G.componentDidMount())
                        } finally {
                          uI(c)
                        }
                      else G.componentDidMount()
                    else {
                      var m =
                          c.elementType === c.type ? Q.memoizedProps : De(c.type, Q.memoizedProps),
                        x = Q.memoizedState
                      if (
                        (c.type === c.elementType &&
                          !XS &&
                          (G.props !== c.memoizedProps &&
                            B(
                              "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                              oC(c) || "instance",
                            ),
                          G.state !== c.memoizedState &&
                            B(
                              "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                              oC(c) || "instance",
                            )),
                        c.mode & uC)
                      )
                        try {
                          ;(Og(), G.componentDidUpdate(m, x, G.__reactInternalSnapshotBeforeUpdate))
                        } finally {
                          uI(c)
                        }
                      else G.componentDidUpdate(m, x, G.__reactInternalSnapshotBeforeUpdate)
                    }
                  var z = c.updateQueue
                  z !== null &&
                    (c.type === c.elementType &&
                      !XS &&
                      (G.props !== c.memoizedProps &&
                        B(
                          "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                          oC(c) || "instance",
                        ),
                      G.state !== c.memoizedState &&
                        B(
                          "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                          oC(c) || "instance",
                        )),
                    JS(c, z, G))
                  break
                }
                case S: {
                  var gA = c.updateQueue
                  if (gA !== null) {
                    var hA = null
                    if (c.child !== null)
                      switch (c.child.tag) {
                        case w:
                          hA = c.child.stateNode
                          break
                        case s:
                          hA = c.child.stateNode
                          break
                      }
                    JS(c, gA, hA)
                  }
                  break
                }
                case w: {
                  var pA = c.stateNode
                  if (Q === null && c.flags & IC) {
                    var gI = c.type,
                      $A = c.memoizedProps
                    ak(pA, gI, $A)
                  }
                  break
                }
                case M:
                  break
                case d:
                  break
                case H: {
                  {
                    var FI = c.memoizedProps,
                      KI = FI.onCommit,
                      OI = FI.onRender,
                      Lg = c.stateNode.effectDuration,
                      yC = MC(),
                      EC = Q === null ? "mount" : "update"
                    ;(og() && (EC = "nested-update"),
                      typeof OI == "function" &&
                        OI(
                          c.memoizedProps.id,
                          EC,
                          c.actualDuration,
                          c.treeBaseDuration,
                          c.actualStartTime,
                          yC,
                        ))
                    {
                      ;(typeof KI == "function" && KI(c.memoizedProps.id, EC, Lg, yC), P4(c))
                      var We = c.return
                      A: for (; We !== null; ) {
                        switch (We.tag) {
                          case S:
                            var Le = We.stateNode
                            Le.effectDuration += Lg
                            break A
                          case H:
                            var fI = We.stateNode
                            fI.effectDuration += Lg
                            break A
                        }
                        We = We.return
                      }
                    }
                  }
                  break
                }
                case V: {
                  e4(t, c)
                  break
                }
                case eA:
                case X:
                case CA:
                case aA:
                case lA:
                case yA:
                  break
                default:
                  throw new Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.",
                  )
              }
            Mn || (c.flags & bB && eY(c))
          }
          function z_(t) {
            switch (t.tag) {
              case r:
              case Y:
              case P: {
                if (t.mode & uC)
                  try {
                    ;(Og(), IY(t, t.return))
                  } finally {
                    uI(t)
                  }
                else IY(t, t.return)
                break
              }
              case s: {
                var Q = t.stateNode
                ;(typeof Q.componentDidMount == "function" && O_(t, t.return, Q), gY(t, t.return))
                break
              }
              case w: {
                gY(t, t.return)
                break
              }
            }
          }
          function X_(t, Q) {
            for (var c = null, f = t; ; ) {
              if (f.tag === w) {
                if (c === null) {
                  c = f
                  try {
                    var G = f.stateNode
                    Q ? hk(G) : aR(f.stateNode, f.memoizedProps)
                  } catch (x) {
                    Kt(t, t.return, x)
                  }
                }
              } else if (f.tag === M) {
                if (c === null)
                  try {
                    var m = f.stateNode
                    Q ? ER(m) : rR(m, f.memoizedProps)
                  } catch (x) {
                    Kt(t, t.return, x)
                  }
              } else if (!((f.tag === aA || f.tag === lA) && f.memoizedState !== null && f !== t)) {
                if (f.child !== null) {
                  ;((f.child.return = f), (f = f.child))
                  continue
                }
              }
              if (f === t) return
              for (; f.sibling === null; ) {
                if (f.return === null || f.return === t) return
                ;(c === f && (c = null), (f = f.return))
              }
              ;(c === f && (c = null), (f.sibling.return = f.return), (f = f.sibling))
            }
          }
          function eY(t) {
            var Q = t.ref
            if (Q !== null) {
              var c = t.stateNode,
                f
              switch (t.tag) {
                case w:
                  f = c
                  break
                default:
                  f = c
              }
              if (typeof Q == "function") {
                var G
                if (t.mode & uC)
                  try {
                    ;(Og(), (G = Q(f)))
                  } finally {
                    uI(t)
                  }
                else G = Q(f)
                typeof G == "function" &&
                  B(
                    "Unexpected return value from a callback ref in %s. A callback ref should not return a function.",
                    oC(t),
                  )
              } else
                (Q.hasOwnProperty("current") ||
                  B(
                    "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
                    oC(t),
                  ),
                  (Q.current = f))
            }
          }
          function $_(t) {
            var Q = t.alternate
            ;(Q !== null && (Q.return = null), (t.return = null))
          }
          function iY(t) {
            var Q = t.alternate
            Q !== null && ((t.alternate = null), iY(Q))
            {
              if (((t.child = null), (t.deletions = null), (t.sibling = null), t.tag === w)) {
                var c = t.stateNode
                c !== null && Jd(c)
              }
              ;((t.stateNode = null),
                (t._debugOwner = null),
                (t.return = null),
                (t.dependencies = null),
                (t.memoizedProps = null),
                (t.memoizedState = null),
                (t.pendingProps = null),
                (t.stateNode = null),
                (t.updateQueue = null))
            }
          }
          function A4(t) {
            for (var Q = t.return; Q !== null; ) {
              if (tY(Q)) return Q
              Q = Q.return
            }
            throw new Error(
              "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.",
            )
          }
          function tY(t) {
            return t.tag === w || t.tag === S || t.tag === d
          }
          function BY(t) {
            var Q = t
            A: for (;;) {
              for (; Q.sibling === null; ) {
                if (Q.return === null || tY(Q.return)) return null
                Q = Q.return
              }
              for (
                Q.sibling.return = Q.return, Q = Q.sibling;
                Q.tag !== w && Q.tag !== M && Q.tag !== _;
              ) {
                if (Q.flags & te || Q.child === null || Q.tag === d) continue A
                ;((Q.child.return = Q), (Q = Q.child))
              }
              if (!(Q.flags & te)) return Q.stateNode
            }
          }
          function I4(t) {
            var Q = A4(t)
            switch (Q.tag) {
              case w: {
                var c = Q.stateNode
                Q.flags & Ue && (Md(c), (Q.flags &= ~Ue))
                var f = BY(t)
                QJ(t, f, c)
                break
              }
              case S:
              case d: {
                var G = Q.stateNode.containerInfo,
                  m = BY(t)
                BJ(t, m, G)
                break
              }
              // eslint-disable-next-line-no-fallthrough
              default:
                throw new Error(
                  "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.",
                )
            }
          }
          function BJ(t, Q, c) {
            var f = t.tag,
              G = f === w || f === M
            if (G) {
              var m = t.stateNode
              Q ? ck(c, m, Q) : sk(c, m)
            } else if (f !== d) {
              var x = t.child
              if (x !== null) {
                BJ(x, Q, c)
                for (var z = x.sibling; z !== null; ) (BJ(z, Q, c), (z = z.sibling))
              }
            }
          }
          function QJ(t, Q, c) {
            var f = t.tag,
              G = f === w || f === M
            if (G) {
              var m = t.stateNode
              Q ? lk(c, m, Q) : gw(c, m)
            } else if (f !== d) {
              var x = t.child
              if (x !== null) {
                QJ(x, Q, c)
                for (var z = x.sibling; z !== null; ) (QJ(z, Q, c), (z = z.sibling))
              }
            }
          }
          var Un = null,
            ul = !1
          function g4(t, Q, c) {
            {
              var f = Q
              A: for (; f !== null; ) {
                switch (f.tag) {
                  case w: {
                    ;((Un = f.stateNode), (ul = !1))
                    break A
                  }
                  case S: {
                    ;((Un = f.stateNode.containerInfo), (ul = !0))
                    break A
                  }
                  case d: {
                    ;((Un = f.stateNode.containerInfo), (ul = !0))
                    break A
                  }
                }
                f = f.return
              }
              if (Un === null)
                throw new Error(
                  "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.",
                )
              ;(QY(t, Q, c), (Un = null), (ul = !1))
            }
            $_(c)
          }
          function eD(t, Q, c) {
            for (var f = c.child; f !== null; ) (QY(t, Q, f), (f = f.sibling))
          }
          function QY(t, Q, c) {
            switch ((wg(c), c.tag)) {
              case w:
                Mn || dy(c, Q)
              // eslint-disable-next-line-no-fallthrough
              case M: {
                {
                  var f = Un,
                    G = ul
                  ;((Un = null),
                    eD(t, Q, c),
                    (Un = f),
                    (ul = G),
                    Un !== null && (ul ? oR(Un, c.stateNode) : Ud(Un, c.stateNode)))
                }
                return
              }
              case _: {
                Un !== null && (ul ? nR(Un, c.stateNode) : Cw(Un, c.stateNode))
                return
              }
              case d: {
                {
                  var m = Un,
                    x = ul
                  ;((Un = c.stateNode.containerInfo), (ul = !0), eD(t, Q, c), (Un = m), (ul = x))
                }
                return
              }
              case r:
              case Y:
              case j:
              case P: {
                if (!Mn) {
                  var z = c.updateQueue
                  if (z !== null) {
                    var gA = z.lastEffect
                    if (gA !== null) {
                      var hA = gA.next,
                        pA = hA
                      do {
                        var gI = pA,
                          $A = gI.destroy,
                          FI = gI.tag
                        ;($A !== void 0 &&
                          ((FI & Ur) !== Eo
                            ? aM(c, Q, $A)
                            : (FI & vB) !== Eo &&
                              (IB(c),
                              c.mode & uC ? (Og(), aM(c, Q, $A), uI(c)) : aM(c, Q, $A),
                              aa())),
                          (pA = pA.next))
                      } while (pA !== hA)
                    }
                  }
                }
                eD(t, Q, c)
                return
              }
              case s: {
                if (!Mn) {
                  dy(c, Q)
                  var KI = c.stateNode
                  typeof KI.componentWillUnmount == "function" && tJ(c, Q, KI)
                }
                eD(t, Q, c)
                return
              }
              case CA: {
                eD(t, Q, c)
                return
              }
              case aA: {
                if (
                  // TODO: Remove this dead flag
                  c.mode & Pg
                ) {
                  var OI = Mn
                  ;((Mn = OI || c.memoizedState !== null), eD(t, Q, c), (Mn = OI))
                } else eD(t, Q, c)
                break
              }
              default: {
                eD(t, Q, c)
                return
              }
            }
          }
          function C4(t) {
            t.memoizedState
          }
          function e4(t, Q) {
            var c = Q.memoizedState
            if (c === null) {
              var f = Q.alternate
              if (f !== null) {
                var G = f.memoizedState
                if (G !== null) {
                  var m = G.dehydrated
                  m !== null && dk(m)
                }
              }
            }
          }
          function oY(t) {
            var Q = t.updateQueue
            if (Q !== null) {
              t.updateQueue = null
              var c = t.stateNode
              ;(c === null && (c = t.stateNode = new T_()),
                Q.forEach(function (f) {
                  var G = A3.bind(null, t, f)
                  if (!c.has(f)) {
                    if ((c.add(f), lB))
                      if (Sy !== null && fy !== null) D0(fy, Sy)
                      else
                        throw Error(
                          "Expected finished root and lanes to be set. This is a bug in React.",
                        )
                    f.then(G, G)
                  }
                }))
            }
          }
          function i4(t, Q, c) {
            ;((Sy = c), (fy = t), Me(Q), nY(Q, t), Me(Q), (Sy = null), (fy = null))
          }
          function Dl(t, Q, c) {
            var f = Q.deletions
            if (f !== null)
              for (var G = 0; G < f.length; G++) {
                var m = f[G]
                try {
                  g4(t, Q, m)
                } catch (gA) {
                  Kt(m, Q, gA)
                }
              }
            var x = Ha()
            if (Q.subtreeFlags & Yt)
              for (var z = Q.child; z !== null; ) (Me(z), nY(z, t), (z = z.sibling))
            Me(x)
          }
          function nY(t, Q, c) {
            var f = t.alternate,
              G = t.flags
            switch (t.tag) {
              case r:
              case Y:
              case j:
              case P: {
                if ((Dl(Q, t), Lc(t), G & IC)) {
                  try {
                    ;(hl(Ur | DB, t, t.return), CD(Ur | DB, t))
                  } catch (xC) {
                    Kt(t, t.return, xC)
                  }
                  if (t.mode & uC) {
                    try {
                      ;(Og(), hl(vB | DB, t, t.return))
                    } catch (xC) {
                      Kt(t, t.return, xC)
                    }
                    uI(t)
                  } else
                    try {
                      hl(vB | DB, t, t.return)
                    } catch (xC) {
                      Kt(t, t.return, xC)
                    }
                }
                return
              }
              case s: {
                ;(Dl(Q, t), Lc(t), G & bB && f !== null && dy(f, f.return))
                return
              }
              case w: {
                ;(Dl(Q, t), Lc(t), G & bB && f !== null && dy(f, f.return))
                {
                  if (t.flags & Ue) {
                    var m = t.stateNode
                    try {
                      Md(m)
                    } catch (xC) {
                      Kt(t, t.return, xC)
                    }
                  }
                  if (G & IC) {
                    var x = t.stateNode
                    if (x != null) {
                      var z = t.memoizedProps,
                        gA = f !== null ? f.memoizedProps : z,
                        hA = t.type,
                        pA = t.updateQueue
                      if (((t.updateQueue = null), pA !== null))
                        try {
                          rk(x, pA, hA, gA, z, t)
                        } catch (xC) {
                          Kt(t, t.return, xC)
                        }
                    }
                  }
                }
                return
              }
              case M: {
                if ((Dl(Q, t), Lc(t), G & IC)) {
                  if (t.stateNode === null)
                    throw new Error(
                      "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.",
                    )
                  var gI = t.stateNode,
                    $A = t.memoizedProps,
                    FI = f !== null ? f.memoizedProps : $A
                  try {
                    QR(gI, FI, $A)
                  } catch (xC) {
                    Kt(t, t.return, xC)
                  }
                }
                return
              }
              case S: {
                if ((Dl(Q, t), Lc(t), G & IC && f !== null)) {
                  var KI = f.memoizedState
                  if (KI.isDehydrated)
                    try {
                      fk(Q.containerInfo)
                    } catch (xC) {
                      Kt(t, t.return, xC)
                    }
                }
                return
              }
              case d: {
                ;(Dl(Q, t), Lc(t))
                return
              }
              case V: {
                ;(Dl(Q, t), Lc(t))
                var OI = t.child
                if (OI.flags & bn) {
                  var Lg = OI.stateNode,
                    yC = OI.memoizedState,
                    EC = yC !== null
                  if (((Lg.isHidden = EC), EC)) {
                    var We = OI.alternate !== null && OI.alternate.memoizedState !== null
                    We || q4()
                  }
                }
                if (G & IC) {
                  try {
                    C4(t)
                  } catch (xC) {
                    Kt(t, t.return, xC)
                  }
                  oY(t)
                }
                return
              }
              case aA: {
                var Le = f !== null && f.memoizedState !== null
                if (
                  // TODO: Remove this dead flag
                  t.mode & Pg
                ) {
                  var fI = Mn
                  ;((Mn = fI || Le), Dl(Q, t), (Mn = fI))
                } else Dl(Q, t)
                if ((Lc(t), G & bn)) {
                  var _I = t.stateNode,
                    dI = t.memoizedState,
                    sg = dI !== null,
                    _g = t
                  if (((_I.isHidden = sg), sg && !Le && (_g.mode & Pg) !== zg)) {
                    CC = _g
                    for (var Hg = _g.child; Hg !== null; ) ((CC = Hg), B4(Hg), (Hg = Hg.sibling))
                  }
                  X_(_g, sg)
                }
                return
              }
              case eA: {
                ;(Dl(Q, t), Lc(t), G & IC && oY(t))
                return
              }
              case CA:
                return
              default: {
                ;(Dl(Q, t), Lc(t))
                return
              }
            }
          }
          function Lc(t) {
            var Q = t.flags
            if (Q & te) {
              try {
                I4(t)
              } catch (c) {
                Kt(t, t.return, c)
              }
              t.flags &= ~te
            }
            Q & hQ && (t.flags &= ~hQ)
          }
          function t4(t, Q, c) {
            ;((Sy = c), (fy = Q), (CC = t), EY(t, Q, c), (Sy = null), (fy = null))
          }
          function EY(t, Q, c) {
            for (var f = (t.mode & Pg) !== zg; CC !== null; ) {
              var G = CC,
                m = G.child
              if (G.tag === aA && f) {
                var x = G.memoizedState !== null,
                  z = x || EM
                if (z) {
                  oJ(t, Q, c)
                  continue
                } else {
                  var gA = G.alternate,
                    hA = gA !== null && gA.memoizedState !== null,
                    pA = hA || Mn,
                    gI = EM,
                    $A = Mn
                  ;((EM = z), (Mn = pA), Mn && !$A && ((CC = G), Q4(G)))
                  for (var FI = m; FI !== null; )
                    ((CC = FI),
                      EY(
                        FI,
                        // New root; bubble back up to here and stop.
                        Q,
                        c,
                      ),
                      (FI = FI.sibling))
                  ;((CC = G), (EM = gI), (Mn = $A), oJ(t, Q, c))
                  continue
                }
              }
              ;(G.subtreeFlags & It) !== nC && m !== null ? ((m.return = G), (CC = m)) : oJ(t, Q, c)
            }
          }
          function oJ(t, Q, c) {
            for (; CC !== null; ) {
              var f = CC
              if ((f.flags & It) !== nC) {
                var G = f.alternate
                Me(f)
                try {
                  j_(Q, G, f, c)
                } catch (x) {
                  Kt(f, f.return, x)
                }
                di()
              }
              if (f === t) {
                CC = null
                return
              }
              var m = f.sibling
              if (m !== null) {
                ;((m.return = f.return), (CC = m))
                return
              }
              CC = f.return
            }
          }
          function B4(t) {
            for (; CC !== null; ) {
              var Q = CC,
                c = Q.child
              switch (Q.tag) {
                case r:
                case Y:
                case j:
                case P: {
                  if (Q.mode & uC)
                    try {
                      ;(Og(), hl(vB, Q, Q.return))
                    } finally {
                      uI(Q)
                    }
                  else hl(vB, Q, Q.return)
                  break
                }
                case s: {
                  dy(Q, Q.return)
                  var f = Q.stateNode
                  typeof f.componentWillUnmount == "function" && tJ(Q, Q.return, f)
                  break
                }
                case w: {
                  dy(Q, Q.return)
                  break
                }
                case aA: {
                  var G = Q.memoizedState !== null
                  if (G) {
                    aY(t)
                    continue
                  }
                  break
                }
              }
              c !== null ? ((c.return = Q), (CC = c)) : aY(t)
            }
          }
          function aY(t) {
            for (; CC !== null; ) {
              var Q = CC
              if (Q === t) {
                CC = null
                return
              }
              var c = Q.sibling
              if (c !== null) {
                ;((c.return = Q.return), (CC = c))
                return
              }
              CC = Q.return
            }
          }
          function Q4(t) {
            for (; CC !== null; ) {
              var Q = CC,
                c = Q.child
              if (Q.tag === aA) {
                var f = Q.memoizedState !== null
                if (f) {
                  rY(t)
                  continue
                }
              }
              c !== null ? ((c.return = Q), (CC = c)) : rY(t)
            }
          }
          function rY(t) {
            for (; CC !== null; ) {
              var Q = CC
              Me(Q)
              try {
                z_(Q)
              } catch (f) {
                Kt(Q, Q.return, f)
              }
              if ((di(), Q === t)) {
                CC = null
                return
              }
              var c = Q.sibling
              if (c !== null) {
                ;((c.return = Q.return), (CC = c))
                return
              }
              CC = Q.return
            }
          }
          function o4(t, Q, c, f) {
            ;((CC = Q), n4(Q, t, c, f))
          }
          function n4(t, Q, c, f) {
            for (; CC !== null; ) {
              var G = CC,
                m = G.child
              ;(G.subtreeFlags & an) !== nC && m !== null
                ? ((m.return = G), (CC = m))
                : E4(t, Q, c, f)
            }
          }
          function E4(t, Q, c, f) {
            for (; CC !== null; ) {
              var G = CC
              if ((G.flags & Ri) !== nC) {
                Me(G)
                try {
                  a4(Q, G, c, f)
                } catch (x) {
                  Kt(G, G.return, x)
                }
                di()
              }
              if (G === t) {
                CC = null
                return
              }
              var m = G.sibling
              if (m !== null) {
                ;((m.return = G.return), (CC = m))
                return
              }
              CC = G.return
            }
          }
          function a4(t, Q, c, f) {
            switch (Q.tag) {
              case r:
              case Y:
              case P: {
                if (Q.mode & uC) {
                  qg()
                  try {
                    CD(ao | DB, Q)
                  } finally {
                    ug(Q)
                  }
                } else CD(ao | DB, Q)
                break
              }
            }
          }
          function r4(t) {
            ;((CC = t), s4())
          }
          function s4() {
            for (; CC !== null; ) {
              var t = CC,
                Q = t.child
              if ((CC.flags & de) !== nC) {
                var c = t.deletions
                if (c !== null) {
                  for (var f = 0; f < c.length; f++) {
                    var G = c[f]
                    ;((CC = G), h4(G, t))
                  }
                  {
                    var m = t.alternate
                    if (m !== null) {
                      var x = m.child
                      if (x !== null) {
                        m.child = null
                        do {
                          var z = x.sibling
                          ;((x.sibling = null), (x = z))
                        } while (x !== null)
                      }
                    }
                  }
                  CC = t
                }
              }
              ;(t.subtreeFlags & an) !== nC && Q !== null ? ((Q.return = t), (CC = Q)) : l4()
            }
          }
          function l4() {
            for (; CC !== null; ) {
              var t = CC
              ;(t.flags & Ri) !== nC && (Me(t), c4(t), di())
              var Q = t.sibling
              if (Q !== null) {
                ;((Q.return = t.return), (CC = Q))
                return
              }
              CC = t.return
            }
          }
          function c4(t) {
            switch (t.tag) {
              case r:
              case Y:
              case P: {
                t.mode & uC ? (qg(), hl(ao | DB, t, t.return), ug(t)) : hl(ao | DB, t, t.return)
                break
              }
            }
          }
          function h4(t, Q) {
            for (; CC !== null; ) {
              var c = CC
              ;(Me(c), D4(c, Q), di())
              var f = c.child
              f !== null ? ((f.return = c), (CC = f)) : u4(t)
            }
          }
          function u4(t) {
            for (; CC !== null; ) {
              var Q = CC,
                c = Q.sibling,
                f = Q.return
              if ((iY(Q), Q === t)) {
                CC = null
                return
              }
              if (c !== null) {
                ;((c.return = f), (CC = c))
                return
              }
              CC = f
            }
          }
          function D4(t, Q) {
            switch (t.tag) {
              case r:
              case Y:
              case P: {
                t.mode & uC ? (qg(), hl(ao, t, Q), ug(t)) : hl(ao, t, Q)
                break
              }
            }
          }
          function S4(t) {
            switch (t.tag) {
              case r:
              case Y:
              case P: {
                try {
                  CD(vB | DB, t)
                } catch (c) {
                  Kt(t, t.return, c)
                }
                break
              }
              case s: {
                var Q = t.stateNode
                try {
                  Q.componentDidMount()
                } catch (c) {
                  Kt(t, t.return, c)
                }
                break
              }
            }
          }
          function f4(t) {
            switch (t.tag) {
              case r:
              case Y:
              case P: {
                try {
                  CD(ao | DB, t)
                } catch (Q) {
                  Kt(t, t.return, Q)
                }
                break
              }
            }
          }
          function d4(t) {
            switch (t.tag) {
              case r:
              case Y:
              case P: {
                try {
                  hl(vB | DB, t, t.return)
                } catch (c) {
                  Kt(t, t.return, c)
                }
                break
              }
              case s: {
                var Q = t.stateNode
                typeof Q.componentWillUnmount == "function" && tJ(t, t.return, Q)
                break
              }
            }
          }
          function y4(t) {
            switch (t.tag) {
              case r:
              case Y:
              case P:
                try {
                  hl(ao | DB, t, t.return)
                } catch (Q) {
                  Kt(t, t.return, Q)
                }
            }
          }
          if (typeof Symbol == "function" && Symbol.for) {
            var Q0 = Symbol.for
            ;(Q0("selector.component"),
              Q0("selector.has_pseudo_class"),
              Q0("selector.role"),
              Q0("selector.test_id"),
              Q0("selector.text"))
          }
          var p4 = []
          function w4() {
            p4.forEach(function (t) {
              return t()
            })
          }
          var G4 = I.ReactCurrentActQueue
          function k4(t) {
            {
              var Q =
                  // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
                  typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0,
                c = typeof jest < "u"
              return c && Q !== !1
            }
          }
          function sY() {
            {
              var t =
                // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
                typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
              return (
                !t &&
                  G4.current !== null &&
                  B("The current testing environment is not configured to support act(...)"),
                t
              )
            }
          }
          var M4 = Math.ceil,
            nJ = I.ReactCurrentDispatcher,
            EJ = I.ReactCurrentOwner,
            Nn = I.ReactCurrentBatchConfig,
            Sl = I.ReactCurrentActQueue,
            ro =
              /*             */
              0,
            lY =
              /*               */
              1,
            Fn =
              /*                */
              2,
            Ds =
              /*                */
              4,
            xh = 0,
            o0 = 1,
            $S = 2,
            rM = 3,
            n0 = 4,
            cY = 5,
            aJ = 6,
            Pe = ro,
            _E = null,
            LB = null,
            so = Ag,
            Yc = Ag,
            rJ = Bl(Ag),
            lo = xh,
            E0 = null,
            sM = Ag,
            a0 = Ag,
            lM = Ag,
            r0 = null,
            Na = null,
            sJ = 0,
            hY = 500,
            uY = 1 / 0,
            U4 = 500,
            bh = null
          function s0() {
            uY = Hi() + U4
          }
          function DY() {
            return uY
          }
          var cM = !1,
            lJ = null,
            yy = null,
            Af = !1,
            iD = null,
            l0 = Ag,
            cJ = [],
            hJ = null,
            N4 = 50,
            c0 = 0,
            uJ = null,
            DJ = !1,
            hM = !1,
            F4 = 50,
            py = 0,
            uM = null,
            h0 = ue,
            DM = Ag,
            SY = !1
          function SM() {
            return _E
          }
          function ZE() {
            return (Pe & (Fn | Ds)) !== ro ? Hi() : (h0 !== ue || (h0 = Hi()), h0)
          }
          function tD(t) {
            var Q = t.mode
            if ((Q & Pg) === zg) return bg
            if ((Pe & Fn) !== ro && so !== Ag) return ut(so)
            var c = _d() !== Mh
            if (c) {
              if (Nn.transition !== null) {
                var f = Nn.transition
                ;(f._updatedFibers || (f._updatedFibers = /* @__PURE__ */ new Set()),
                  f._updatedFibers.add(t))
              }
              return (DM === ct && (DM = sC()), DM)
            }
            var G = hn()
            if (G !== ct) return G
            var m = tR()
            return m
          }
          function R4(t) {
            var Q = t.mode
            return (Q & Pg) === zg ? bg : Be()
          }
          function co(t, Q, c, f) {
            ;(g3(),
              SY && B("useInsertionEffect must not schedule updates."),
              DJ && (hM = !0),
              oe(t, c, f),
              (Pe & Fn) !== Ag && t === _E
                ? i3(Q)
                : (lB && zc(t, Q, c),
                  t3(Q),
                  t === _E && ((Pe & Fn) === ro && (a0 = WI(a0, c)), lo === n0 && BD(t, so)),
                  Fa(t, f),
                  c === bg &&
                    Pe === ro &&
                    (Q.mode & Pg) === zg && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
                    !Sl.isBatchingLegacy &&
                    (s0(), mk())))
          }
          function J4(t, Q, c) {
            var f = t.current
            ;((f.lanes = Q), oe(t, Q, c), Fa(t, c))
          }
          function K4(t) {
            return (
              // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
              // decided not to enable it.
              (Pe & Fn) !== ro
            )
          }
          function Fa(t, Q) {
            var c = t.callbackNode
            D(t, Q)
            var f = mo(t, t === _E ? so : Ag)
            if (f === Ag) {
              ;(c !== null && vY(c), (t.callbackNode = null), (t.callbackPriority = ct))
              return
            }
            var G = kg(f),
              m = t.callbackPriority
            if (
              m === G && // Special case related to `act`. If the currently scheduled task is a
              // Scheduler task, rather than an `act` task, cancel it and re-scheduled
              // on the `act` queue.
              !(Sl.current !== null && c !== GJ)
            ) {
              c == null &&
                m !== bg &&
                B(
                  "Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.",
                )
              return
            }
            c != null && vY(c)
            var x
            if (G === bg)
              (t.tag === uc
                ? (Sl.isBatchingLegacy !== null && (Sl.didScheduleLegacyUpdate = !0),
                  Kk(yY.bind(null, t)))
                : Jk(yY.bind(null, t)),
                Sl.current !== null
                  ? Sl.current.push(Dc)
                  : Ek(function () {
                      ;(Pe & (Fn | Ds)) === ro && Dc()
                    }),
                (x = null))
            else {
              var z
              switch (UB(f)) {
                case Ut:
                  z = Zl
                  break
                case LE:
                  z = Ea
                  break
                case jn:
                  z = No
                  break
                case $r:
                  z = Hs
                  break
                default:
                  z = No
                  break
              }
              x = kJ(z, fY.bind(null, t))
            }
            ;((t.callbackPriority = G), (t.callbackNode = x))
          }
          function fY(t, Q) {
            if ((cC(), (h0 = ue), (DM = Ag), (Pe & (Fn | Ds)) !== ro))
              throw new Error("Should not already be working.")
            var c = t.callbackNode,
              f = _h()
            if (f && t.callbackNode !== c) return null
            var G = mo(t, t === _E ? so : Ag)
            if (G === Ag) return null
            var m = !ng(t, G) && !Sg(t, G) && !Q,
              x = m ? O4(t, G) : dM(t, G)
            if (x !== xh) {
              if (x === $S) {
                var z = v(t)
                z !== Ag && ((G = z), (x = SJ(t, z)))
              }
              if (x === o0) {
                var gA = E0
                throw (If(t, Ag), BD(t, G), Fa(t, Hi()), gA)
              }
              if (x === aJ) BD(t, G)
              else {
                var hA = !ng(t, G),
                  pA = t.current.alternate
                if (hA && !v4(pA)) {
                  if (((x = dM(t, G)), x === $S)) {
                    var gI = v(t)
                    gI !== Ag && ((G = gI), (x = SJ(t, gI)))
                  }
                  if (x === o0) {
                    var $A = E0
                    throw (If(t, Ag), BD(t, G), Fa(t, Hi()), $A)
                  }
                }
                ;((t.finishedWork = pA), (t.finishedLanes = G), m4(t, x, G))
              }
            }
            return (Fa(t, Hi()), t.callbackNode === c ? fY.bind(null, t) : null)
          }
          function SJ(t, Q) {
            var c = r0
            if ($l(t)) {
              var f = If(t, Q)
              ;((f.flags |= At), vg(t.containerInfo))
            }
            var G = dM(t, Q)
            if (G !== $S) {
              var m = Na
              ;((Na = c), m !== null && dY(m))
            }
            return G
          }
          function dY(t) {
            Na === null ? (Na = t) : Na.push.apply(Na, t)
          }
          function m4(t, Q, c) {
            switch (Q) {
              case xh:
              case o0:
                throw new Error("Root did not complete. This is a bug in React.")
              // Flow knows about invariant, so it complains if I add a break
              // statement, but eslint doesn't know about invariant, so it complains
              // if I do. eslint-disable-next-line no-fallthrough
              case $S: {
                gf(t, Na, bh)
                break
              }
              case rM: {
                if (
                  (BD(t, c),
                  UA(c) && // do not delay if we're inside an act() scope
                    !LY())
                ) {
                  var f = sJ + hY - Hi()
                  if (f > 10) {
                    var G = mo(t, Ag)
                    if (G !== Ag) break
                    var m = t.suspendedLanes
                    if (!JI(m, c)) {
                      ;(ZE(), sr(t, m))
                      break
                    }
                    t.timeoutHandle = Aw(gf.bind(null, t, Na, bh), f)
                    break
                  }
                }
                gf(t, Na, bh)
                break
              }
              case n0: {
                if ((BD(t, c), HI(c))) break
                if (!LY()) {
                  var x = zl(t, c),
                    z = x,
                    gA = Hi() - z,
                    hA = I3(gA) - gA
                  if (hA > 10) {
                    t.timeoutHandle = Aw(gf.bind(null, t, Na, bh), hA)
                    break
                  }
                }
                gf(t, Na, bh)
                break
              }
              case cY: {
                gf(t, Na, bh)
                break
              }
              default:
                throw new Error("Unknown root exit status.")
            }
          }
          function v4(t) {
            for (var Q = t; ; ) {
              if (Q.flags & Qa) {
                var c = Q.updateQueue
                if (c !== null) {
                  var f = c.stores
                  if (f !== null)
                    for (var G = 0; G < f.length; G++) {
                      var m = f[G],
                        x = m.getSnapshot,
                        z = m.value
                      try {
                        if (!Vg(x(), z)) return !1
                      } catch {
                        return !1
                      }
                    }
                }
              }
              var gA = Q.child
              if (Q.subtreeFlags & Qa && gA !== null) {
                ;((gA.return = Q), (Q = gA))
                continue
              }
              if (Q === t) return !0
              for (; Q.sibling === null; ) {
                if (Q.return === null || Q.return === t) return !0
                Q = Q.return
              }
              ;((Q.sibling.return = Q.return), (Q = Q.sibling))
            }
            return !0
          }
          function BD(t, Q) {
            ;((Q = Zg(Q, lM)), (Q = Zg(Q, a0)), vE(t, Q))
          }
          function yY(t) {
            if ((re(), (Pe & (Fn | Ds)) !== ro)) throw new Error("Should not already be working.")
            _h()
            var Q = mo(t, Ag)
            if (!zA(Q, bg)) return (Fa(t, Hi()), null)
            var c = dM(t, Q)
            if (t.tag !== uc && c === $S) {
              var f = v(t)
              f !== Ag && ((Q = f), (c = SJ(t, f)))
            }
            if (c === o0) {
              var G = E0
              throw (If(t, Ag), BD(t, Q), Fa(t, Hi()), G)
            }
            if (c === aJ) throw new Error("Root did not complete. This is a bug in React.")
            var m = t.current.alternate
            return ((t.finishedWork = m), (t.finishedLanes = Q), gf(t, Na, bh), Fa(t, Hi()), null)
          }
          function L4(t, Q) {
            Q !== Ag && (hu(t, WI(Q, bg)), Fa(t, Hi()), (Pe & (Fn | Ds)) === ro && (s0(), Dc()))
          }
          function fJ(t, Q) {
            var c = Pe
            Pe |= lY
            try {
              return t(Q)
            } finally {
              ;((Pe = c),
                Pe === ro && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
                  !Sl.isBatchingLegacy &&
                  (s0(), mk()))
            }
          }
          function Y4(t, Q, c, f, G) {
            var m = hn(),
              x = Nn.transition
            try {
              return ((Nn.transition = null), gt(Ut), t(Q, c, f, G))
            } finally {
              ;(gt(m), (Nn.transition = x), Pe === ro && s0())
            }
          }
          function Oh(t) {
            iD !== null && iD.tag === uc && (Pe & (Fn | Ds)) === ro && _h()
            var Q = Pe
            Pe |= lY
            var c = Nn.transition,
              f = hn()
            try {
              return ((Nn.transition = null), gt(Ut), t ? t() : void 0)
            } finally {
              ;(gt(f), (Nn.transition = c), (Pe = Q), (Pe & (Fn | Ds)) === ro && Dc())
            }
          }
          function pY() {
            return (Pe & (Fn | Ds)) !== ro
          }
          function fM(t, Q) {
            ;(xo(rJ, Yc, t), (Yc = WI(Yc, Q)))
          }
          function dJ(t) {
            ;((Yc = rJ.current), To(rJ, t))
          }
          function If(t, Q) {
            ;((t.finishedWork = null), (t.finishedLanes = Ag))
            var c = t.timeoutHandle
            if ((c !== Hu && ((t.timeoutHandle = Hu), Iw(c)), LB !== null))
              for (var f = LB.return; f !== null; ) {
                var G = f.alternate
                ;($L(G, f), (f = f.return))
              }
            _E = t
            var m = Cf(t.current, null)
            return (
              (LB = m),
              (so = Yc = Q),
              (lo = xh),
              (E0 = null),
              (sM = Ag),
              (a0 = Ag),
              (lM = Ag),
              (r0 = null),
              (Na = null),
              kw(),
              fn.discardPendingWarnings(),
              m
            )
          }
          function wY(t, Q) {
            do {
              var c = LB
              try {
                if ((Gc(), gy(), di(), (EJ.current = null), c === null || c.return === null)) {
                  ;((lo = o0), (E0 = Q), (LB = null))
                  return
                }
                if ((kA && c.mode & uC && PI(c, !0), dA))
                  if ((Ke(), Q !== null && typeof Q == "object" && typeof Q.then == "function")) {
                    var f = Q
                    Tt(c, f, so)
                  } else RE(c, Q, so)
                ;(Q_(t, c.return, c, Q, so), UY(c))
              } catch (G) {
                ;((Q = G), LB === c && c !== null ? ((c = c.return), (LB = c)) : (c = LB))
                continue
              }
              return
            } while (!0)
          }
          function GY() {
            var t = nJ.current
            return ((nJ.current = uy), t === null ? uy : t)
          }
          function kY(t) {
            nJ.current = t
          }
          function q4() {
            sJ = Hi()
          }
          function u0(t) {
            sM = WI(t, sM)
          }
          function H4() {
            lo === xh && (lo = rM)
          }
          function yJ() {
            ;((lo === xh || lo === rM || lo === $S) && (lo = n0),
              _E !== null && (IA(sM) || IA(a0)) && BD(_E, so))
          }
          function T4(t) {
            ;(lo !== n0 && (lo = $S), r0 === null ? (r0 = [t]) : r0.push(t))
          }
          function x4() {
            return lo === xh
          }
          function dM(t, Q) {
            var c = Pe
            Pe |= Fn
            var f = GY()
            if (_E !== t || so !== Q) {
              if (lB) {
                var G = t.memoizedUpdaters
                ;(G.size > 0 && (D0(t, so), G.clear()), Xc(t, Q))
              }
              ;((bh = Xl()), If(t, Q))
            }
            wi(Q)
            do
              try {
                b4()
                break
              } catch (m) {
                wY(t, m)
              }
            while (!0)
            if ((Gc(), (Pe = c), kY(f), LB !== null))
              throw new Error(
                "Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.",
              )
            return (or(), (_E = null), (so = Ag), lo)
          }
          function b4() {
            for (; LB !== null; ) MY(LB)
          }
          function O4(t, Q) {
            var c = Pe
            Pe |= Fn
            var f = GY()
            if (_E !== t || so !== Q) {
              if (lB) {
                var G = t.memoizedUpdaters
                ;(G.size > 0 && (D0(t, so), G.clear()), Xc(t, Q))
              }
              ;((bh = Xl()), s0(), If(t, Q))
            }
            wi(Q)
            do
              try {
                _4()
                break
              } catch (m) {
                wY(t, m)
              }
            while (!0)
            return (
              Gc(),
              kY(f),
              (Pe = c),
              LB !== null ? (sn(), xh) : (or(), (_E = null), (so = Ag), lo)
            )
          }
          function _4() {
            for (; LB !== null && !ZB(); ) MY(LB)
          }
          function MY(t) {
            var Q = t.alternate
            Me(t)
            var c
            ;((t.mode & uC) !== zg ? (Qt(t), (c = pJ(Q, t, Yc)), PI(t, !0)) : (c = pJ(Q, t, Yc)),
              di(),
              (t.memoizedProps = t.pendingProps),
              c === null ? UY(t) : (LB = c),
              (EJ.current = null))
          }
          function UY(t) {
            var Q = t
            do {
              var c = Q.alternate,
                f = Q.return
              if ((Q.flags & OB) === nC) {
                Me(Q)
                var G = void 0
                if (
                  ((Q.mode & uC) === zg
                    ? (G = XL(c, Q, Yc))
                    : (Qt(Q), (G = XL(c, Q, Yc)), PI(Q, !1)),
                  di(),
                  G !== null)
                ) {
                  LB = G
                  return
                }
              } else {
                var m = H_(c, Q)
                if (m !== null) {
                  ;((m.flags &= Vc), (LB = m))
                  return
                }
                if ((Q.mode & uC) !== zg) {
                  PI(Q, !1)
                  for (var x = Q.actualDuration, z = Q.child; z !== null; )
                    ((x += z.actualDuration), (z = z.sibling))
                  Q.actualDuration = x
                }
                if (f !== null) ((f.flags |= OB), (f.subtreeFlags = nC), (f.deletions = null))
                else {
                  ;((lo = aJ), (LB = null))
                  return
                }
              }
              var gA = Q.sibling
              if (gA !== null) {
                LB = gA
                return
              }
              ;((Q = f), (LB = Q))
            } while (Q !== null)
            lo === xh && (lo = cY)
          }
          function gf(t, Q, c) {
            var f = hn(),
              G = Nn.transition
            try {
              ;((Nn.transition = null), gt(Ut), Z4(t, Q, c, f))
            } finally {
              ;((Nn.transition = G), gt(f))
            }
            return null
          }
          function Z4(t, Q, c, f) {
            do _h()
            while (iD !== null)
            if ((C3(), (Pe & (Fn | Ds)) !== ro)) throw new Error("Should not already be working.")
            var G = t.finishedWork,
              m = t.finishedLanes
            if ((li(m), G === null)) return ($C(), null)
            if (
              (m === Ag &&
                B(
                  "root.finishedLanes should not be empty during a commit. This is a bug in React.",
                ),
              (t.finishedWork = null),
              (t.finishedLanes = Ag),
              G === t.current)
            )
              throw new Error(
                "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.",
              )
            ;((t.callbackNode = null), (t.callbackPriority = ct))
            var x = WI(G.lanes, G.childLanes)
            ;(cu(t, x),
              t === _E && ((_E = null), (LB = null), (so = Ag)),
              ((G.subtreeFlags & an) !== nC || (G.flags & an) !== nC) &&
                (Af ||
                  ((Af = !0),
                  (hJ = c),
                  kJ(No, function () {
                    return (_h(), null)
                  }))))
            var z = (G.subtreeFlags & (LC | Yt | It | an)) !== nC,
              gA = (G.flags & (LC | Yt | It | an)) !== nC
            if (z || gA) {
              var hA = Nn.transition
              Nn.transition = null
              var pA = hn()
              gt(Ut)
              var gI = Pe
              ;((Pe |= Ds),
                (EJ.current = null),
                __(t, G),
                yt(),
                i4(t, G, m),
                Xp(t.containerInfo),
                (t.current = G),
                Os(m),
                t4(G, t, m),
                ra(),
                qt(),
                (Pe = gI),
                gt(pA),
                (Nn.transition = hA))
            } else ((t.current = G), yt())
            var $A = Af
            if (
              (Af ? ((Af = !1), (iD = t), (l0 = m)) : ((py = 0), (uM = null)),
              (x = t.pendingLanes),
              x === Ag && (yy = null),
              $A || JY(t.current, !1),
              Bo(G.stateNode, f),
              lB && t.memoizedUpdaters.clear(),
              w4(),
              Fa(t, Hi()),
              Q !== null)
            )
              for (var FI = t.onRecoverableError, KI = 0; KI < Q.length; KI++) {
                var OI = Q[KI],
                  Lg = OI.stack,
                  yC = OI.digest
                FI(OI.value, {
                  componentStack: Lg,
                  digest: yC,
                })
              }
            if (cM) {
              cM = !1
              var EC = lJ
              throw ((lJ = null), EC)
            }
            return (
              zA(l0, bg) && t.tag !== uc && _h(),
              (x = t.pendingLanes),
              zA(x, bg) ? (cg(), t === uJ ? c0++ : ((c0 = 0), (uJ = t))) : (c0 = 0),
              Dc(),
              $C(),
              null
            )
          }
          function _h() {
            if (iD !== null) {
              var t = UB(l0),
                Q = HD(jn, t),
                c = Nn.transition,
                f = hn()
              try {
                return ((Nn.transition = null), gt(Q), W4())
              } finally {
                ;(gt(f), (Nn.transition = c))
              }
            }
            return !1
          }
          function P4(t) {
            ;(cJ.push(t),
              Af ||
                ((Af = !0),
                kJ(No, function () {
                  return (_h(), null)
                })))
          }
          function W4() {
            if (iD === null) return !1
            var t = hJ
            hJ = null
            var Q = iD,
              c = l0
            if (((iD = null), (l0 = Ag), (Pe & (Fn | Ds)) !== ro))
              throw new Error("Cannot flush passive effects while already rendering.")
            ;((DJ = !0), (hM = !1), Br(c))
            var f = Pe
            ;((Pe |= Ds), r4(Q.current), o4(Q, Q.current, c, t))
            {
              var G = cJ
              cJ = []
              for (var m = 0; m < G.length; m++) {
                var x = G[m]
                V_(Q, x)
              }
            }
            ;(Qr(),
              JY(Q.current, !0),
              (Pe = f),
              Dc(),
              hM ? (Q === uM ? py++ : ((py = 0), (uM = Q))) : (py = 0),
              (DJ = !1),
              (hM = !1),
              si(Q))
            {
              var z = Q.current.stateNode
              ;((z.effectDuration = 0), (z.passiveEffectDuration = 0))
            }
            return !0
          }
          function NY(t) {
            return yy !== null && yy.has(t)
          }
          function V4(t) {
            yy === null ? (yy = /* @__PURE__ */ new Set([t])) : yy.add(t)
          }
          function j4(t) {
            cM || ((cM = !0), (lJ = t))
          }
          var z4 = j4
          function FY(t, Q, c) {
            var f = zS(c, Q),
              G = ML(t, f, bg),
              m = sl(t, G, bg),
              x = ZE()
            m !== null && (oe(m, bg, x), Fa(m, x))
          }
          function Kt(t, Q, c) {
            if ((x_(c), S0(!1), t.tag === S)) {
              FY(t, t, c)
              return
            }
            var f = null
            for (f = Q; f !== null; ) {
              if (f.tag === S) {
                FY(f, t, c)
                return
              } else if (f.tag === s) {
                var G = f.type,
                  m = f.stateNode
                if (
                  typeof G.getDerivedStateFromError == "function" ||
                  (typeof m.componentDidCatch == "function" && !NY(m))
                ) {
                  var x = zS(c, t),
                    z = OR(f, x, bg),
                    gA = sl(f, z, bg),
                    hA = ZE()
                  gA !== null && (oe(gA, bg, hA), Fa(gA, hA))
                  return
                }
              }
              f = f.return
            }
            B(
              `Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`,
              c,
            )
          }
          function X4(t, Q, c) {
            var f = t.pingCache
            f !== null && f.delete(Q)
            var G = ZE()
            ;(sr(t, c),
              B3(t),
              _E === t &&
                JI(so, c) &&
                (lo === n0 || (lo === rM && UA(so) && Hi() - sJ < hY)
                  ? If(t, Ag)
                  : (lM = WI(lM, c))),
              Fa(t, G))
          }
          function RY(t, Q) {
            Q === ct && (Q = R4(t))
            var c = ZE(),
              f = mB(t, Q)
            f !== null && (oe(f, Q, c), Fa(f, c))
          }
          function $4(t) {
            var Q = t.memoizedState,
              c = ct
            ;(Q !== null && (c = Q.retryLane), RY(t, c))
          }
          function A3(t, Q) {
            var c = ct,
              f
            switch (t.tag) {
              case V:
                f = t.stateNode
                var G = t.memoizedState
                G !== null && (c = G.retryLane)
                break
              case eA:
                f = t.stateNode
                break
              default:
                throw new Error(
                  "Pinged unknown suspense boundary type. This is probably a bug in React.",
                )
            }
            ;(f !== null && f.delete(Q), RY(t, c))
          }
          function I3(t) {
            return t < 120
              ? 120
              : t < 480
                ? 480
                : t < 1080
                  ? 1080
                  : t < 1920
                    ? 1920
                    : t < 3e3
                      ? 3e3
                      : t < 4320
                        ? 4320
                        : M4(t / 1960) * 1960
          }
          function g3() {
            if (c0 > N4)
              throw (
                (c0 = 0),
                (uJ = null),
                new Error(
                  "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.",
                )
              )
            py > F4 &&
              ((py = 0),
              (uM = null),
              B(
                "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.",
              ))
          }
          function C3() {
            ;(fn.flushLegacyContextWarning(), fn.flushPendingUnsafeLifecycleWarnings())
          }
          function JY(t, Q) {
            ;(Me(t), yM(t, Ne, d4), Q && yM(t, Uo, y4), yM(t, Ne, S4), Q && yM(t, Uo, f4), di())
          }
          function yM(t, Q, c) {
            for (var f = t, G = null; f !== null; ) {
              var m = f.subtreeFlags & Q
              f !== G && f.child !== null && m !== nC
                ? (f = f.child)
                : ((f.flags & Q) !== nC && c(f),
                  f.sibling !== null ? (f = f.sibling) : (f = G = f.return))
            }
          }
          var pM = null
          function KY(t) {
            {
              if ((Pe & Fn) !== ro || !(t.mode & Pg)) return
              var Q = t.tag
              if (Q !== h && Q !== S && Q !== s && Q !== r && Q !== Y && Q !== j && Q !== P) return
              var c = oC(t) || "ReactComponent"
              if (pM !== null) {
                if (pM.has(c)) return
                pM.add(c)
              } else pM = /* @__PURE__ */ new Set([c])
              var f = Te
              try {
                ;(Me(t),
                  B(
                    "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.",
                  ))
              } finally {
                f ? Me(t) : di()
              }
            }
          }
          var pJ
          {
            var e3 = null
            pJ = function (t, Q, c) {
              var f = xY(e3, Q)
              try {
                return PL(t, Q, c)
              } catch (m) {
                if (hw() || (m !== null && typeof m == "object" && typeof m.then == "function"))
                  throw m
                if (
                  (Gc(),
                  gy(),
                  $L(t, Q),
                  xY(Q, f),
                  Q.mode & uC && Qt(Q),
                  xn(null, PL, null, t, Q, c),
                  Ba())
                ) {
                  var G = Ir()
                  typeof G == "object" &&
                    G !== null &&
                    G._suppressLogging &&
                    typeof m == "object" &&
                    m !== null &&
                    !m._suppressLogging &&
                    (m._suppressLogging = !0)
                }
                throw m
              }
            }
          }
          var mY = !1,
            wJ
          wJ = /* @__PURE__ */ new Set()
          function i3(t) {
            if (hC && !IM())
              switch (t.tag) {
                case r:
                case Y:
                case P: {
                  var Q = (LB && oC(LB)) || "Unknown",
                    c = Q
                  if (!wJ.has(c)) {
                    wJ.add(c)
                    var f = oC(t) || "Unknown"
                    B(
                      "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render",
                      f,
                      Q,
                      Q,
                    )
                  }
                  break
                }
                case s: {
                  mY ||
                    (B(
                      "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.",
                    ),
                    (mY = !0))
                  break
                }
              }
          }
          function D0(t, Q) {
            if (lB) {
              var c = t.memoizedUpdaters
              c.forEach(function (f) {
                zc(t, f, Q)
              })
            }
          }
          var GJ = {}
          function kJ(t, Q) {
            {
              var c = Sl.current
              return c !== null ? (c.push(Q), GJ) : Cr(t, Q)
            }
          }
          function vY(t) {
            if (t !== GJ) return na(t)
          }
          function LY() {
            return Sl.current !== null
          }
          function t3(t) {
            {
              if (t.mode & Pg) {
                if (!sY()) return
              } else if (!k4() || Pe !== ro || (t.tag !== r && t.tag !== Y && t.tag !== P)) return
              if (Sl.current === null) {
                var Q = Te
                try {
                  ;(Me(t),
                    B(
                      `An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`,
                      oC(t),
                    ))
                } finally {
                  Q ? Me(t) : di()
                }
              }
            }
          }
          function B3(t) {
            t.tag !== uc &&
              sY() &&
              Sl.current === null &&
              B(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`)
          }
          function S0(t) {
            SY = t
          }
          var Ss = null,
            wy = null,
            Q3 = function (t) {
              Ss = t
            }
          function Gy(t) {
            {
              if (Ss === null) return t
              var Q = Ss(t)
              return Q === void 0 ? t : Q.current
            }
          }
          function MJ(t) {
            return Gy(t)
          }
          function UJ(t) {
            {
              if (Ss === null) return t
              var Q = Ss(t)
              if (Q === void 0) {
                if (t != null && typeof t.render == "function") {
                  var c = Gy(t.render)
                  if (t.render !== c) {
                    var f = {
                      $$typeof: eg,
                      render: c,
                    }
                    return (t.displayName !== void 0 && (f.displayName = t.displayName), f)
                  }
                }
                return t
              }
              return Q.current
            }
          }
          function YY(t, Q) {
            {
              if (Ss === null) return !1
              var c = t.elementType,
                f = Q.type,
                G = !1,
                m = typeof f == "object" && f !== null ? f.$$typeof : null
              switch (t.tag) {
                case s: {
                  typeof f == "function" && (G = !0)
                  break
                }
                case r: {
                  ;(typeof f == "function" || m === jg) && (G = !0)
                  break
                }
                case Y: {
                  ;(m === eg || m === jg) && (G = !0)
                  break
                }
                case j:
                case P: {
                  ;(m === JC || m === jg) && (G = !0)
                  break
                }
                default:
                  return !1
              }
              if (G) {
                var x = Ss(c)
                if (x !== void 0 && x === Ss(f)) return !0
              }
              return !1
            }
          }
          function qY(t) {
            {
              if (Ss === null || typeof WeakSet != "function") return
              ;(wy === null && (wy = /* @__PURE__ */ new WeakSet()), wy.add(t))
            }
          }
          var o3 = function (t, Q) {
              {
                if (Ss === null) return
                var c = Q.staleFamilies,
                  f = Q.updatedFamilies
                ;(_h(),
                  Oh(function () {
                    NJ(t.current, f, c)
                  }))
              }
            },
            n3 = function (t, Q) {
              {
                if (t.context !== eE) return
                ;(_h(),
                  Oh(function () {
                    f0(Q, t, null, null)
                  }))
              }
            }
          function NJ(t, Q, c) {
            {
              var f = t.alternate,
                G = t.child,
                m = t.sibling,
                x = t.tag,
                z = t.type,
                gA = null
              switch (x) {
                case r:
                case P:
                case s:
                  gA = z
                  break
                case Y:
                  gA = z.render
                  break
              }
              if (Ss === null)
                throw new Error("Expected resolveFamily to be set during hot reload.")
              var hA = !1,
                pA = !1
              if (gA !== null) {
                var gI = Ss(gA)
                gI !== void 0 &&
                  (c.has(gI) ? (pA = !0) : Q.has(gI) && (x === s ? (pA = !0) : (hA = !0)))
              }
              if (
                (wy !== null && (wy.has(t) || (f !== null && wy.has(f))) && (pA = !0),
                pA && (t._debugNeedsRemount = !0),
                pA || hA)
              ) {
                var $A = mB(t, bg)
                $A !== null && co($A, t, bg, ue)
              }
              ;(G !== null && !pA && NJ(G, Q, c), m !== null && NJ(m, Q, c))
            }
          }
          var E3 = function (t, Q) {
            {
              var c = /* @__PURE__ */ new Set(),
                f = new Set(
                  Q.map(function (G) {
                    return G.current
                  }),
                )
              return (FJ(t.current, f, c), c)
            }
          }
          function FJ(t, Q, c) {
            {
              var f = t.child,
                G = t.sibling,
                m = t.tag,
                x = t.type,
                z = null
              switch (m) {
                case r:
                case P:
                case s:
                  z = x
                  break
                case Y:
                  z = x.render
                  break
              }
              var gA = !1
              ;(z !== null && Q.has(z) && (gA = !0),
                gA ? a3(t, c) : f !== null && FJ(f, Q, c),
                G !== null && FJ(G, Q, c))
            }
          }
          function a3(t, Q) {
            {
              var c = r3(t, Q)
              if (c) return
              for (var f = t; ; ) {
                switch (f.tag) {
                  case w:
                    Q.add(f.stateNode)
                    return
                  case d:
                    Q.add(f.stateNode.containerInfo)
                    return
                  case S:
                    Q.add(f.stateNode.containerInfo)
                    return
                }
                if (f.return === null) throw new Error("Expected to reach root first.")
                f = f.return
              }
            }
          }
          function r3(t, Q) {
            for (var c = t, f = !1; ; ) {
              if (c.tag === w) ((f = !0), Q.add(c.stateNode))
              else if (c.child !== null) {
                ;((c.child.return = c), (c = c.child))
                continue
              }
              if (c === t) return f
              for (; c.sibling === null; ) {
                if (c.return === null || c.return === t) return f
                c = c.return
              }
              ;((c.sibling.return = c.return), (c = c.sibling))
            }
            return !1
          }
          var RJ
          {
            RJ = !1
            try {
              var HY = Object.preventExtensions({})
            } catch {
              RJ = !0
            }
          }
          function s3(t, Q, c, f) {
            ;((this.tag = t),
              (this.key = c),
              (this.elementType = null),
              (this.type = null),
              (this.stateNode = null),
              (this.return = null),
              (this.child = null),
              (this.sibling = null),
              (this.index = 0),
              (this.ref = null),
              (this.pendingProps = Q),
              (this.memoizedProps = null),
              (this.updateQueue = null),
              (this.memoizedState = null),
              (this.dependencies = null),
              (this.mode = f),
              (this.flags = nC),
              (this.subtreeFlags = nC),
              (this.deletions = null),
              (this.lanes = Ag),
              (this.childLanes = Ag),
              (this.alternate = null),
              (this.actualDuration = Number.NaN),
              (this.actualStartTime = Number.NaN),
              (this.selfBaseDuration = Number.NaN),
              (this.treeBaseDuration = Number.NaN),
              (this.actualDuration = 0),
              (this.actualStartTime = -1),
              (this.selfBaseDuration = 0),
              (this.treeBaseDuration = 0),
              (this._debugSource = null),
              (this._debugOwner = null),
              (this._debugNeedsRemount = !1),
              (this._debugHookTypes = null),
              !RJ &&
                typeof Object.preventExtensions == "function" &&
                Object.preventExtensions(this))
          }
          var Nr = function (t, Q, c, f) {
            return new s3(t, Q, c, f)
          }
          function JJ(t) {
            var Q = t.prototype
            return !!(Q && Q.isReactComponent)
          }
          function l3(t) {
            return typeof t == "function" && !JJ(t) && t.defaultProps === void 0
          }
          function c3(t) {
            if (typeof t == "function") return JJ(t) ? s : r
            if (t != null) {
              var Q = t.$$typeof
              if (Q === eg) return Y
              if (Q === JC) return j
            }
            return h
          }
          function Cf(t, Q) {
            var c = t.alternate
            ;(c === null
              ? ((c = Nr(t.tag, Q, t.key, t.mode)),
                (c.elementType = t.elementType),
                (c.type = t.type),
                (c.stateNode = t.stateNode),
                (c._debugSource = t._debugSource),
                (c._debugOwner = t._debugOwner),
                (c._debugHookTypes = t._debugHookTypes),
                (c.alternate = t),
                (t.alternate = c))
              : ((c.pendingProps = Q),
                (c.type = t.type),
                (c.flags = nC),
                (c.subtreeFlags = nC),
                (c.deletions = null),
                (c.actualDuration = 0),
                (c.actualStartTime = -1)),
              (c.flags = t.flags & lg),
              (c.childLanes = t.childLanes),
              (c.lanes = t.lanes),
              (c.child = t.child),
              (c.memoizedProps = t.memoizedProps),
              (c.memoizedState = t.memoizedState),
              (c.updateQueue = t.updateQueue))
            var f = t.dependencies
            switch (
              ((c.dependencies =
                f === null
                  ? null
                  : {
                      lanes: f.lanes,
                      firstContext: f.firstContext,
                    }),
              (c.sibling = t.sibling),
              (c.index = t.index),
              (c.ref = t.ref),
              (c.selfBaseDuration = t.selfBaseDuration),
              (c.treeBaseDuration = t.treeBaseDuration),
              (c._debugNeedsRemount = t._debugNeedsRemount),
              c.tag)
            ) {
              case h:
              case r:
              case P:
                c.type = Gy(t.type)
                break
              case s:
                c.type = MJ(t.type)
                break
              case Y:
                c.type = UJ(t.type)
                break
            }
            return c
          }
          function h3(t, Q) {
            t.flags &= lg | te
            var c = t.alternate
            if (c === null)
              ((t.childLanes = Ag),
                (t.lanes = Q),
                (t.child = null),
                (t.subtreeFlags = nC),
                (t.memoizedProps = null),
                (t.memoizedState = null),
                (t.updateQueue = null),
                (t.dependencies = null),
                (t.stateNode = null),
                (t.selfBaseDuration = 0),
                (t.treeBaseDuration = 0))
            else {
              ;((t.childLanes = c.childLanes),
                (t.lanes = c.lanes),
                (t.child = c.child),
                (t.subtreeFlags = nC),
                (t.deletions = null),
                (t.memoizedProps = c.memoizedProps),
                (t.memoizedState = c.memoizedState),
                (t.updateQueue = c.updateQueue),
                (t.type = c.type))
              var f = c.dependencies
              ;((t.dependencies =
                f === null
                  ? null
                  : {
                      lanes: f.lanes,
                      firstContext: f.firstContext,
                    }),
                (t.selfBaseDuration = c.selfBaseDuration),
                (t.treeBaseDuration = c.treeBaseDuration))
            }
            return t
          }
          function u3(t, Q, c) {
            var f
            return (
              t === uS ? ((f = Pg), Q === !0 && ((f |= rC), (f |= xt))) : (f = zg),
              lB && (f |= uC),
              Nr(S, null, null, f)
            )
          }
          function KJ(t, Q, c, f, G, m) {
            var x = h,
              z = t
            if (typeof t == "function") JJ(t) ? ((x = s), (z = MJ(z))) : (z = Gy(z))
            else if (typeof t == "string") x = w
            else
              A: switch (t) {
                case Ei:
                  return QD(c.children, G, m, Q)
                case vi:
                  ;((x = R), (G |= rC), (G & Pg) !== zg && (G |= xt))
                  break
                case Li:
                  return D3(c, G, m, Q)
                case Tg:
                  return S3(c, G, m, Q)
                case OC:
                  return f3(c, G, m, Q)
                case oI:
                  return TY(c, G, m, Q)
                case QI:
                // eslint-disable-next-line no-fallthrough
                case rA:
                // eslint-disable-next-line no-fallthrough
                case PA:
                // eslint-disable-next-line no-fallthrough
                case gg:
                // eslint-disable-next-line no-fallthrough
                case _A:
                // eslint-disable-next-line no-fallthrough
                default: {
                  if (typeof t == "object" && t !== null)
                    switch (t.$$typeof) {
                      case mA:
                        x = L
                        break A
                      case TI:
                        x = F
                        break A
                      case eg:
                        ;((x = Y), (z = UJ(z)))
                        break A
                      case JC:
                        x = j
                        break A
                      case jg:
                        ;((x = AA), (z = null))
                        break A
                    }
                  var gA = ""
                  {
                    ;(t === void 0 ||
                      (typeof t == "object" && t !== null && Object.keys(t).length === 0)) &&
                      (gA +=
                        " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.")
                    var hA = f ? oC(f) : null
                    hA &&
                      (gA +=
                        `

Check the render method of \`` +
                        hA +
                        "`.")
                  }
                  throw new Error(
                    "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " +
                      ("but got: " + (t == null ? t : typeof t) + "." + gA),
                  )
                }
              }
            var pA = Nr(x, c, Q, G)
            return ((pA.elementType = t), (pA.type = z), (pA.lanes = m), (pA._debugOwner = f), pA)
          }
          function mJ(t, Q, c) {
            var f = null
            f = t._owner
            var G = t.type,
              m = t.key,
              x = t.props,
              z = KJ(G, m, x, f, Q, c)
            return ((z._debugSource = t._source), (z._debugOwner = t._owner), z)
          }
          function QD(t, Q, c, f) {
            var G = Nr(K, t, f, Q)
            return ((G.lanes = c), G)
          }
          function D3(t, Q, c, f) {
            typeof t.id != "string" &&
              B(
                'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
                typeof t.id,
              )
            var G = Nr(H, t, f, Q | uC)
            return (
              (G.elementType = Li),
              (G.lanes = c),
              (G.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0,
              }),
              G
            )
          }
          function S3(t, Q, c, f) {
            var G = Nr(V, t, f, Q)
            return ((G.elementType = Tg), (G.lanes = c), G)
          }
          function f3(t, Q, c, f) {
            var G = Nr(eA, t, f, Q)
            return ((G.elementType = OC), (G.lanes = c), G)
          }
          function TY(t, Q, c, f) {
            var G = Nr(aA, t, f, Q)
            ;((G.elementType = oI), (G.lanes = c))
            var m = {
              isHidden: !1,
            }
            return ((G.stateNode = m), G)
          }
          function vJ(t, Q, c) {
            var f = Nr(M, t, null, Q)
            return ((f.lanes = c), f)
          }
          function d3() {
            var t = Nr(w, null, null, zg)
            return ((t.elementType = "DELETED"), t)
          }
          function y3(t) {
            var Q = Nr(_, null, null, zg)
            return ((Q.stateNode = t), Q)
          }
          function LJ(t, Q, c) {
            var f = t.children !== null ? t.children : [],
              G = Nr(d, f, t.key, Q)
            return (
              (G.lanes = c),
              (G.stateNode = {
                containerInfo: t.containerInfo,
                pendingChildren: null,
                // Used by persistent updates
                implementation: t.implementation,
              }),
              G
            )
          }
          function xY(t, Q) {
            return (
              t === null && (t = Nr(h, null, null, zg)),
              (t.tag = Q.tag),
              (t.key = Q.key),
              (t.elementType = Q.elementType),
              (t.type = Q.type),
              (t.stateNode = Q.stateNode),
              (t.return = Q.return),
              (t.child = Q.child),
              (t.sibling = Q.sibling),
              (t.index = Q.index),
              (t.ref = Q.ref),
              (t.pendingProps = Q.pendingProps),
              (t.memoizedProps = Q.memoizedProps),
              (t.updateQueue = Q.updateQueue),
              (t.memoizedState = Q.memoizedState),
              (t.dependencies = Q.dependencies),
              (t.mode = Q.mode),
              (t.flags = Q.flags),
              (t.subtreeFlags = Q.subtreeFlags),
              (t.deletions = Q.deletions),
              (t.lanes = Q.lanes),
              (t.childLanes = Q.childLanes),
              (t.alternate = Q.alternate),
              (t.actualDuration = Q.actualDuration),
              (t.actualStartTime = Q.actualStartTime),
              (t.selfBaseDuration = Q.selfBaseDuration),
              (t.treeBaseDuration = Q.treeBaseDuration),
              (t._debugSource = Q._debugSource),
              (t._debugOwner = Q._debugOwner),
              (t._debugNeedsRemount = Q._debugNeedsRemount),
              (t._debugHookTypes = Q._debugHookTypes),
              t
            )
          }
          function p3(t, Q, c, f, G) {
            ;((this.tag = Q),
              (this.containerInfo = t),
              (this.pendingChildren = null),
              (this.current = null),
              (this.pingCache = null),
              (this.finishedWork = null),
              (this.timeoutHandle = Hu),
              (this.context = null),
              (this.pendingContext = null),
              (this.callbackNode = null),
              (this.callbackPriority = ct),
              (this.eventTimes = bi(Ag)),
              (this.expirationTimes = bi(ue)),
              (this.pendingLanes = Ag),
              (this.suspendedLanes = Ag),
              (this.pingedLanes = Ag),
              (this.expiredLanes = Ag),
              (this.mutableReadLanes = Ag),
              (this.finishedLanes = Ag),
              (this.entangledLanes = Ag),
              (this.entanglements = bi(Ag)),
              (this.identifierPrefix = f),
              (this.onRecoverableError = G),
              (this.mutableSourceEagerHydrationData = null),
              (this.effectDuration = 0),
              (this.passiveEffectDuration = 0))
            {
              this.memoizedUpdaters = /* @__PURE__ */ new Set()
              for (var m = (this.pendingUpdatersLaneMap = []), x = 0; x < DQ; x++)
                m.push(/* @__PURE__ */ new Set())
            }
            switch (Q) {
              case uS:
                this._debugRootType = c ? "hydrateRoot()" : "createRoot()"
                break
              case uc:
                this._debugRootType = c ? "hydrate()" : "render()"
                break
            }
          }
          function bY(t, Q, c, f, G, m, x, z, gA, hA) {
            var pA = new p3(t, Q, c, z, gA),
              gI = u3(Q, m)
            ;((pA.current = gI), (gI.stateNode = pA))
            {
              var $A = {
                element: f,
                isDehydrated: c,
                cache: null,
                // not enabled yet
                transitions: null,
                pendingSuspenseBoundaries: null,
              }
              gI.memoizedState = $A
            }
            return (FS(gI), pA)
          }
          var YJ = "18.3.1"
          function w3(t, Q, c) {
            var f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null
            return (
              YI(f),
              {
                // This tag allow us to uniquely identify this as a React Portal
                $$typeof: fe,
                key: f == null ? null : "" + f,
                children: t,
                containerInfo: Q,
                implementation: c,
              }
            )
          }
          var qJ, HJ
          ;((qJ = !1), (HJ = {}))
          function OY(t) {
            if (!t) return eE
            var Q = wB(t),
              c = GR(Q)
            if (Q.tag === s) {
              var f = Q.type
              if (dr(f)) return Fk(Q, f, c)
            }
            return c
          }
          function G3(t, Q) {
            {
              var c = wB(t)
              if (c === void 0) {
                if (typeof t.render == "function")
                  throw new Error("Unable to find node on an unmounted component.")
                var f = Object.keys(t).join(",")
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + f)
              }
              var G = qQ(c)
              if (G === null) return null
              if (G.mode & rC) {
                var m = oC(c) || "Component"
                if (!HJ[m]) {
                  HJ[m] = !0
                  var x = Te
                  try {
                    ;(Me(G),
                      c.mode & rC
                        ? B(
                            "%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node",
                            Q,
                            Q,
                            m,
                          )
                        : B(
                            "%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node",
                            Q,
                            Q,
                            m,
                          ))
                  } finally {
                    x ? Me(x) : di()
                  }
                }
              }
              return G.stateNode
            }
          }
          function _Y(t, Q, c, f, G, m, x, z) {
            var gA = !1,
              hA = null
            return bY(t, Q, gA, hA, c, f, G, m, x)
          }
          function ZY(t, Q, c, f, G, m, x, z, gA, hA) {
            var pA = !0,
              gI = bY(c, f, pA, t, G, m, x, z, gA)
            gI.context = OY(null)
            var $A = gI.current,
              FI = ZE(),
              KI = tD($A),
              OI = cs(FI, KI)
            return ((OI.callback = Q ?? null), sl($A, OI, KI), J4(gI, KI, FI), gI)
          }
          function f0(t, Q, c, f) {
            bs(Q, t)
            var G = Q.current,
              m = ZE(),
              x = tD(G)
            _n(x)
            var z = OY(c)
            ;(Q.context === null ? (Q.context = z) : (Q.pendingContext = z),
              hC &&
                Te !== null &&
                !qJ &&
                ((qJ = !0),
                B(
                  `Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`,
                  oC(Te) || "Unknown",
                )))
            var gA = cs(m, x)
            ;((gA.payload = {
              element: t,
            }),
              (f = f === void 0 ? null : f),
              f !== null &&
                (typeof f != "function" &&
                  B(
                    "render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.",
                    f,
                  ),
                (gA.callback = f)))
            var hA = sl(G, gA, x)
            return (hA !== null && (co(hA, G, x, m), RS(hA, G, x)), x)
          }
          function wM(t) {
            var Q = t.current
            if (!Q.child) return null
            switch (Q.child.tag) {
              case w:
                return Q.child.stateNode
              default:
                return Q.child.stateNode
            }
          }
          function k3(t) {
            switch (t.tag) {
              case S: {
                var Q = t.stateNode
                if ($l(Q)) {
                  var c = N(Q)
                  L4(Q, c)
                }
                break
              }
              case V: {
                Oh(function () {
                  var G = mB(t, bg)
                  if (G !== null) {
                    var m = ZE()
                    co(G, t, bg, m)
                  }
                })
                var f = bg
                TJ(t, f)
                break
              }
            }
          }
          function PY(t, Q) {
            var c = t.memoizedState
            c !== null && c.dehydrated !== null && (c.retryLane = Qe(c.retryLane, Q))
          }
          function TJ(t, Q) {
            PY(t, Q)
            var c = t.alternate
            c && PY(c, Q)
          }
          function M3(t) {
            if (t.tag === V) {
              var Q = Ro,
                c = mB(t, Q)
              if (c !== null) {
                var f = ZE()
                co(c, t, Q, f)
              }
              TJ(t, Q)
            }
          }
          function U3(t) {
            if (t.tag === V) {
              var Q = tD(t),
                c = mB(t, Q)
              if (c !== null) {
                var f = ZE()
                co(c, t, Q, f)
              }
              TJ(t, Q)
            }
          }
          function WY(t) {
            var Q = gr(t)
            return Q === null ? null : Q.stateNode
          }
          var VY = function (t) {
            return null
          }
          function N3(t) {
            return VY(t)
          }
          var jY = function (t) {
            return !1
          }
          function F3(t) {
            return jY(t)
          }
          var zY = null,
            XY = null,
            $Y = null,
            Aq = null,
            Iq = null,
            gq = null,
            Cq = null,
            eq = null,
            iq = null
          {
            var tq = function (t, Q, c) {
                var f = Q[c],
                  G = le(t) ? t.slice() : rg({}, t)
                return c + 1 === Q.length
                  ? (le(G) ? G.splice(f, 1) : delete G[f], G)
                  : ((G[f] = tq(t[f], Q, c + 1)), G)
              },
              Bq = function (t, Q) {
                return tq(t, Q, 0)
              },
              Qq = function (t, Q, c, f) {
                var G = Q[f],
                  m = le(t) ? t.slice() : rg({}, t)
                if (f + 1 === Q.length) {
                  var x = c[f]
                  ;((m[x] = m[G]), le(m) ? m.splice(G, 1) : delete m[G])
                } else
                  m[G] = Qq(
                    // $FlowFixMe number or string is fine here
                    t[G],
                    Q,
                    c,
                    f + 1,
                  )
                return m
              },
              oq = function (t, Q, c) {
                if (Q.length !== c.length) {
                  i("copyWithRename() expects paths of the same length")
                  return
                } else
                  for (var f = 0; f < c.length - 1; f++)
                    if (Q[f] !== c[f]) {
                      i("copyWithRename() expects paths to be the same except for the deepest key")
                      return
                    }
                return Qq(t, Q, c, 0)
              },
              nq = function (t, Q, c, f) {
                if (c >= Q.length) return f
                var G = Q[c],
                  m = le(t) ? t.slice() : rg({}, t)
                return ((m[G] = nq(t[G], Q, c + 1, f)), m)
              },
              Eq = function (t, Q, c) {
                return nq(t, Q, 0, c)
              },
              xJ = function (t, Q) {
                for (var c = t.memoizedState; c !== null && Q > 0; ) ((c = c.next), Q--)
                return c
              }
            ;((zY = function (t, Q, c, f) {
              var G = xJ(t, Q)
              if (G !== null) {
                var m = Eq(G.memoizedState, c, f)
                ;((G.memoizedState = m),
                  (G.baseState = m),
                  (t.memoizedProps = rg({}, t.memoizedProps)))
                var x = mB(t, bg)
                x !== null && co(x, t, bg, ue)
              }
            }),
              (XY = function (t, Q, c) {
                var f = xJ(t, Q)
                if (f !== null) {
                  var G = Bq(f.memoizedState, c)
                  ;((f.memoizedState = G),
                    (f.baseState = G),
                    (t.memoizedProps = rg({}, t.memoizedProps)))
                  var m = mB(t, bg)
                  m !== null && co(m, t, bg, ue)
                }
              }),
              ($Y = function (t, Q, c, f) {
                var G = xJ(t, Q)
                if (G !== null) {
                  var m = oq(G.memoizedState, c, f)
                  ;((G.memoizedState = m),
                    (G.baseState = m),
                    (t.memoizedProps = rg({}, t.memoizedProps)))
                  var x = mB(t, bg)
                  x !== null && co(x, t, bg, ue)
                }
              }),
              (Aq = function (t, Q, c) {
                ;((t.pendingProps = Eq(t.memoizedProps, Q, c)),
                  t.alternate && (t.alternate.pendingProps = t.pendingProps))
                var f = mB(t, bg)
                f !== null && co(f, t, bg, ue)
              }),
              (Iq = function (t, Q) {
                ;((t.pendingProps = Bq(t.memoizedProps, Q)),
                  t.alternate && (t.alternate.pendingProps = t.pendingProps))
                var c = mB(t, bg)
                c !== null && co(c, t, bg, ue)
              }),
              (gq = function (t, Q, c) {
                ;((t.pendingProps = oq(t.memoizedProps, Q, c)),
                  t.alternate && (t.alternate.pendingProps = t.pendingProps))
                var f = mB(t, bg)
                f !== null && co(f, t, bg, ue)
              }),
              (Cq = function (t) {
                var Q = mB(t, bg)
                Q !== null && co(Q, t, bg, ue)
              }),
              (eq = function (t) {
                VY = t
              }),
              (iq = function (t) {
                jY = t
              }))
          }
          function R3(t) {
            var Q = qQ(t)
            return Q === null ? null : Q.stateNode
          }
          function J3(t) {
            return null
          }
          function K3() {
            return Te
          }
          function m3(t) {
            var Q = t.findFiberByHostInstance,
              c = I.ReactCurrentDispatcher
            return xs({
              bundleType: t.bundleType,
              version: t.version,
              rendererPackageName: t.rendererPackageName,
              rendererConfig: t.rendererConfig,
              overrideHookState: zY,
              overrideHookStateDeletePath: XY,
              overrideHookStateRenamePath: $Y,
              overrideProps: Aq,
              overridePropsDeletePath: Iq,
              overridePropsRenamePath: gq,
              setErrorHandler: eq,
              setSuspenseHandler: iq,
              scheduleUpdate: Cq,
              currentDispatcherRef: c,
              findHostInstanceByFiber: R3,
              findFiberByHostInstance: Q || J3,
              // React Refresh
              findHostInstancesForRefresh: E3,
              scheduleRefresh: o3,
              scheduleRoot: n3,
              setRefreshHandler: Q3,
              // Enables DevTools to append owner stacks to error messages in DEV mode.
              getCurrentFiber: K3,
              // Enables DevTools to detect reconciler version rather than renderer version
              // which may not match for third party renderers.
              reconcilerVersion: YJ,
            })
          }
          var aq =
            typeof reportError == "function"
              ? // In modern browsers, reportError will dispatch an error event,
                // emulating an uncaught JavaScript error.
                reportError
              : function (t) {
                  console.error(t)
                }
          function bJ(t) {
            this._internalRoot = t
          }
          ;((GM.prototype.render = bJ.prototype.render =
            function (t) {
              var Q = this._internalRoot
              if (Q === null) throw new Error("Cannot update an unmounted root.")
              {
                typeof arguments[1] == "function"
                  ? B(
                      "render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().",
                    )
                  : kM(arguments[1])
                    ? B(
                        "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.",
                      )
                    : typeof arguments[1] < "u" &&
                      B(
                        "You passed a second argument to root.render(...) but it only accepts one argument.",
                      )
                var c = Q.containerInfo
                if (c.nodeType !== at) {
                  var f = WY(Q.current)
                  f &&
                    f.parentNode !== c &&
                    B(
                      "render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.",
                    )
                }
              }
              f0(t, Q, null, null)
            }),
            (GM.prototype.unmount = bJ.prototype.unmount =
              function () {
                typeof arguments[0] == "function" &&
                  B(
                    "unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().",
                  )
                var t = this._internalRoot
                if (t !== null) {
                  this._internalRoot = null
                  var Q = t.containerInfo
                  ;(pY() &&
                    B(
                      "Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.",
                    ),
                    Oh(function () {
                      f0(null, t, null, null)
                    }),
                    kk(Q))
                }
              }))
          function v3(t, Q) {
            if (!kM(t)) throw new Error("createRoot(...): Target container is not a DOM element.")
            rq(t)
            var c = !1,
              f = !1,
              G = "",
              m = aq
            Q != null &&
              (Q.hydrate
                ? i(
                    "hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.",
                  )
                : typeof Q == "object" &&
                  Q !== null &&
                  Q.$$typeof === ei &&
                  B(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`),
              Q.unstable_strictMode === !0 && (c = !0),
              Q.identifierPrefix !== void 0 && (G = Q.identifierPrefix),
              Q.onRecoverableError !== void 0 && (m = Q.onRecoverableError),
              Q.transitionCallbacks !== void 0 && Q.transitionCallbacks)
            var x = _Y(t, uS, null, c, f, G, m)
            rS(x.current, t)
            var z = t.nodeType === at ? t.parentNode : t
            return (Dn(z), new bJ(x))
          }
          function GM(t) {
            this._internalRoot = t
          }
          function L3(t) {
            t && xD(t)
          }
          GM.prototype.unstable_scheduleHydration = L3
          function Y3(t, Q, c) {
            if (!kM(t)) throw new Error("hydrateRoot(...): Target container is not a DOM element.")
            ;(rq(t),
              Q === void 0 &&
                B(
                  "Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)",
                ))
            var f = c ?? null,
              G = (c != null && c.hydratedSources) || null,
              m = !1,
              x = !1,
              z = "",
              gA = aq
            c != null &&
              (c.unstable_strictMode === !0 && (m = !0),
              c.identifierPrefix !== void 0 && (z = c.identifierPrefix),
              c.onRecoverableError !== void 0 && (gA = c.onRecoverableError))
            var hA = ZY(Q, null, t, uS, f, m, x, z, gA)
            if ((rS(hA.current, t), Dn(t), G))
              for (var pA = 0; pA < G.length; pA++) {
                var gI = G[pA]
                LR(hA, gI)
              }
            return new GM(hA)
          }
          function kM(t) {
            return !!(t && (t.nodeType === nQ || t.nodeType === Xi || t.nodeType === $i || !EA))
          }
          function d0(t) {
            return !!(
              t &&
              (t.nodeType === nQ ||
                t.nodeType === Xi ||
                t.nodeType === $i ||
                (t.nodeType === at && t.nodeValue === " react-mount-point-unstable "))
            )
          }
          function rq(t) {
            ;(t.nodeType === nQ &&
              t.tagName &&
              t.tagName.toUpperCase() === "BODY" &&
              B(
                "createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.",
              ),
              sS(t) &&
                (t._reactRootContainer
                  ? B(
                      "You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.",
                    )
                  : B(
                      "You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.",
                    )))
          }
          var q3 = I.ReactCurrentOwner,
            sq
          sq = function (t) {
            if (t._reactRootContainer && t.nodeType !== at) {
              var Q = WY(t._reactRootContainer.current)
              Q &&
                Q.parentNode !== t &&
                B(
                  "render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.",
                )
            }
            var c = !!t._reactRootContainer,
              f = OJ(t),
              G = !!(f && cc(f))
            ;(G &&
              !c &&
              B(
                "render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.",
              ),
              t.nodeType === nQ &&
                t.tagName &&
                t.tagName.toUpperCase() === "BODY" &&
                B(
                  "render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.",
                ))
          }
          function OJ(t) {
            return t ? (t.nodeType === Xi ? t.documentElement : t.firstChild) : null
          }
          function lq() {}
          function H3(t, Q, c, f, G) {
            if (G) {
              if (typeof f == "function") {
                var m = f
                f = function () {
                  var $A = wM(x)
                  m.call($A)
                }
              }
              var x = ZY(
                Q,
                f,
                t,
                uc,
                null,
                // hydrationCallbacks
                !1,
                // isStrictMode
                !1,
                // concurrentUpdatesByDefaultOverride,
                "",
                // identifierPrefix
                lq,
              )
              ;((t._reactRootContainer = x), rS(x.current, t))
              var z = t.nodeType === at ? t.parentNode : t
              return (Dn(z), Oh(), x)
            } else {
              for (var gA; (gA = t.lastChild); ) t.removeChild(gA)
              if (typeof f == "function") {
                var hA = f
                f = function () {
                  var $A = wM(pA)
                  hA.call($A)
                }
              }
              var pA = _Y(
                t,
                uc,
                null,
                // hydrationCallbacks
                !1,
                // isStrictMode
                !1,
                // concurrentUpdatesByDefaultOverride,
                "",
                // identifierPrefix
                lq,
              )
              ;((t._reactRootContainer = pA), rS(pA.current, t))
              var gI = t.nodeType === at ? t.parentNode : t
              return (
                Dn(gI),
                Oh(function () {
                  f0(Q, pA, c, f)
                }),
                pA
              )
            }
          }
          function T3(t, Q) {
            t !== null &&
              typeof t != "function" &&
              B(
                "%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.",
                Q,
                t,
              )
          }
          function MM(t, Q, c, f, G) {
            ;(sq(c), T3(G === void 0 ? null : G, "render"))
            var m = c._reactRootContainer,
              x
            if (!m) x = H3(c, Q, t, G, f)
            else {
              if (((x = m), typeof G == "function")) {
                var z = G
                G = function () {
                  var gA = wM(x)
                  z.call(gA)
                }
              }
              f0(Q, x, t, G)
            }
            return wM(x)
          }
          var cq = !1
          function x3(t) {
            {
              cq ||
                ((cq = !0),
                B(
                  "findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node",
                ))
              var Q = q3.current
              if (Q !== null && Q.stateNode !== null) {
                var c = Q.stateNode._warnedAboutRefsInRender
                ;(c ||
                  B(
                    "%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.",
                    ZC(Q.type) || "A component",
                  ),
                  (Q.stateNode._warnedAboutRefsInRender = !0))
              }
            }
            return t == null ? null : t.nodeType === nQ ? t : G3(t, "findDOMNode")
          }
          function b3(t, Q, c) {
            if (
              (B(
                "ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot",
              ),
              !d0(Q))
            )
              throw new Error("Target container is not a DOM element.")
            {
              var f = sS(Q) && Q._reactRootContainer === void 0
              f &&
                B(
                  "You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?",
                )
            }
            return MM(null, t, Q, !0, c)
          }
          function O3(t, Q, c) {
            if (
              (B(
                "ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot",
              ),
              !d0(Q))
            )
              throw new Error("Target container is not a DOM element.")
            {
              var f = sS(Q) && Q._reactRootContainer === void 0
              f &&
                B(
                  "You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?",
                )
            }
            return MM(null, t, Q, !1, c)
          }
          function _3(t, Q, c, f) {
            if (
              (B(
                "ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot",
              ),
              !d0(c))
            )
              throw new Error("Target container is not a DOM element.")
            if (t == null || !lQ(t))
              throw new Error("parentComponent must be a valid React Component")
            return MM(t, Q, c, !1, f)
          }
          var hq = !1
          function Z3(t) {
            if (
              (hq ||
                ((hq = !0),
                B(
                  "unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot",
                )),
              !d0(t))
            )
              throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.")
            {
              var Q = sS(t) && t._reactRootContainer === void 0
              Q &&
                B(
                  "You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?",
                )
            }
            if (t._reactRootContainer) {
              {
                var c = OJ(t),
                  f = c && !cc(c)
                f &&
                  B(
                    "unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.",
                  )
              }
              return (
                Oh(function () {
                  MM(null, null, t, !1, function () {
                    ;((t._reactRootContainer = null), kk(t))
                  })
                }),
                !0
              )
            } else {
              {
                var G = OJ(t),
                  m = !!(G && cc(G)),
                  x = t.nodeType === nQ && d0(t.parentNode) && !!t.parentNode._reactRootContainer
                m &&
                  B(
                    "unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s",
                    x
                      ? "You may have accidentally passed in a React root node instead of its container."
                      : "Instead, have the parent component update its state and rerender in order to remove this component.",
                  )
              }
              return !1
            }
          }
          ;(Ac(k3),
            Jp(M3),
            Ic(U3),
            $f(hn),
            Ws(jB),
            (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
              Map.prototype == null ||
              typeof Map.prototype.forEach != "function" ||
              typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
              Set.prototype == null ||
              typeof Set.prototype.clear != "function" ||
              typeof Set.prototype.forEach != "function") &&
              B(
                "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills",
              ),
            qn(ek),
            za(fJ, Y4, Oh))
          function P3(t, Q) {
            var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null
            if (!kM(Q)) throw new Error("Target container is not a DOM element.")
            return w3(t, Q, null, c)
          }
          function W3(t, Q, c, f) {
            return _3(t, Q, c, f)
          }
          var _J = {
            usingClientEntryPoint: !1,
            // Keep in sync with ReactTestUtils.js.
            // This is an array for better minification.
            Events: [cc, pQ, pa, io, Tn, fJ],
          }
          function V3(t, Q) {
            return (
              _J.usingClientEntryPoint ||
                B(
                  'You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".',
                ),
              v3(t, Q)
            )
          }
          function j3(t, Q, c) {
            return (
              _J.usingClientEntryPoint ||
                B(
                  'You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".',
                ),
              Y3(t, Q, c)
            )
          }
          function z3(t) {
            return (
              pY() &&
                B(
                  "flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.",
                ),
              Oh(t)
            )
          }
          var X3 = m3({
            findFiberByHostInstance: yh,
            bundleType: 1,
            version: YJ,
            rendererPackageName: "react-dom",
          })
          if (
            !X3 &&
            eI &&
            window.top === window.self &&
            ((navigator.userAgent.indexOf("Chrome") > -1 &&
              navigator.userAgent.indexOf("Edge") === -1) ||
              navigator.userAgent.indexOf("Firefox") > -1)
          ) {
            var uq = window.location.protocol
            ;/^(https?|file):$/.test(uq) &&
              console.info(
                "%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" +
                  (uq === "file:"
                    ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq`
                    : ""),
                "font-weight:bold",
              )
          }
          ;((Ja.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = _J),
            (Ja.createPortal = P3),
            (Ja.createRoot = V3),
            (Ja.findDOMNode = x3),
            (Ja.flushSync = z3),
            (Ja.hydrate = b3),
            (Ja.hydrateRoot = j3),
            (Ja.render = O3),
            (Ja.unmountComponentAtNode = Z3),
            (Ja.unstable_batchedUpdates = fJ),
            (Ja.unstable_renderSubtreeIntoContainer = W3),
            (Ja.version = YJ),
            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" &&
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" &&
              __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error()))
        })()),
    Ja
  )
}
var Nq
function n1() {
  if (Nq) return FM.exports
  Nq = 1
  function e() {
    if (
      !(
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
      )
    ) {
      if (process.env.NODE_ENV !== "production") throw new Error("^_^")
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e)
      } catch (A) {
        console.error(A)
      }
    }
  }
  return (
    process.env.NODE_ENV === "production" ? (e(), (FM.exports = Q1())) : (FM.exports = o1()),
    FM.exports
  )
}
var Fq
function E1() {
  if (Fq) return My
  Fq = 1
  var e = n1()
  if (process.env.NODE_ENV === "production")
    ((My.createRoot = e.createRoot), (My.hydrateRoot = e.hydrateRoot))
  else {
    var A = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
    ;((My.createRoot = function (I, g) {
      A.usingClientEntryPoint = !0
      try {
        return e.createRoot(I, g)
      } finally {
        A.usingClientEntryPoint = !1
      }
    }),
      (My.hydrateRoot = function (I, g, C) {
        A.usingClientEntryPoint = !0
        try {
          return e.hydrateRoot(I, g, C)
        } finally {
          A.usingClientEntryPoint = !1
        }
      }))
  }
  return My
}
var a1 = E1()
/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const Wf = "170",
  r1 = { LEFT: 0, MIDDLE: 1, RIGHT: 2, ROTATE: 0, DOLLY: 1, PAN: 2 },
  s1 = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 },
  Xx = 0,
  am = 1,
  $x = 2,
  l1 = 3,
  A2 = 0,
  xN = 1,
  X0 = 2,
  pl = 3,
  Us = 0,
  WQ = 1,
  rE = 2,
  hE = 0,
  Ff = 1,
  rm = 2,
  sm = 3,
  lm = 4,
  I2 = 5,
  yD = 100,
  g2 = 101,
  C2 = 102,
  e2 = 103,
  i2 = 104,
  t2 = 200,
  B2 = 201,
  Q2 = 202,
  o2 = 203,
  HU = 204,
  TU = 205,
  n2 = 206,
  E2 = 207,
  a2 = 208,
  r2 = 209,
  s2 = 210,
  l2 = 211,
  c2 = 212,
  h2 = 213,
  u2 = 214,
  xU = 0,
  bU = 1,
  OU = 2,
  Lf = 3,
  _U = 4,
  ZU = 5,
  PU = 6,
  WU = 7,
  MG = 0,
  D2 = 1,
  S2 = 2,
  Ms = 0,
  f2 = 1,
  d2 = 2,
  y2 = 3,
  Hm = 4,
  p2 = 5,
  w2 = 6,
  G2 = 7,
  cm = "attached",
  k2 = "detached",
  bN = 300,
  Bu = 301,
  kD = 302,
  nG = 303,
  EG = 304,
  Sp = 306,
  MD = 1e3,
  vr = 1001,
  Qp = 1002,
  iQ = 1003,
  ON = 1004,
  c1 = 1004,
  pf = 1005,
  h1 = 1005,
  nt = 1006,
  ep = 1007,
  u1 = 1007,
  ks = 1008,
  D1 = 1008,
  Xo = 1009,
  Tm = 1010,
  xm = 1011,
  op = 1012,
  _N = 1013,
  Zc = 1014,
  sE = 1015,
  KD = 1016,
  ZN = 1017,
  PN = 1018,
  UD = 1020,
  bm = 35902,
  Om = 1021,
  _m = 1022,
  lE = 1023,
  Zm = 1024,
  Pm = 1025,
  Rf = 1026,
  ND = 1027,
  WN = 1028,
  UG = 1029,
  Wm = 1030,
  VN = 1031,
  S1 = 1032,
  jN = 1033,
  $0 = 33776,
  AG = 33777,
  IG = 33778,
  gG = 33779,
  VU = 35840,
  jU = 35841,
  zU = 35842,
  XU = 35843,
  $U = 36196,
  AN = 37492,
  IN = 37496,
  gN = 37808,
  CN = 37809,
  eN = 37810,
  iN = 37811,
  tN = 37812,
  BN = 37813,
  QN = 37814,
  oN = 37815,
  nN = 37816,
  EN = 37817,
  aN = 37818,
  rN = 37819,
  sN = 37820,
  lN = 37821,
  CG = 36492,
  cN = 36494,
  hN = 36495,
  Vm = 36283,
  uN = 36284,
  DN = 36285,
  SN = 36286,
  M2 = 2200,
  U2 = 2201,
  N2 = 2202,
  np = 2300,
  Ep = 2301,
  mU = 2302,
  wf = 2400,
  Gf = 2401,
  aG = 2402,
  zN = 2500,
  jm = 2501,
  F2 = 0,
  zm = 1,
  fN = 2,
  mD = 3200,
  Xm = 3201,
  f1 = 3202,
  d1 = 3203,
  vD = 0,
  R2 = 1,
  kl = "",
  zi = "srgb",
  ru = "srgb-linear",
  NG = "linear",
  ot = "srgb",
  y1 = 0,
  ff = 7680,
  p1 = 7681,
  w1 = 7682,
  G1 = 7683,
  k1 = 34055,
  M1 = 34056,
  U1 = 5386,
  N1 = 512,
  F1 = 513,
  R1 = 514,
  J1 = 515,
  K1 = 516,
  m1 = 517,
  v1 = 518,
  hm = 519,
  J2 = 512,
  K2 = 513,
  m2 = 514,
  $m = 515,
  v2 = 516,
  L2 = 517,
  Y2 = 518,
  q2 = 519,
  rG = 35044,
  H2 = 35048,
  L1 = 35040,
  Y1 = 35045,
  q1 = 35049,
  H1 = 35041,
  T1 = 35046,
  x1 = 35050,
  b1 = 35042,
  O1 = "100",
  um = "300 es",
  bc = 2e3,
  sG = 2001
class qr {
  addEventListener(A, I) {
    this._listeners === void 0 && (this._listeners = {})
    const g = this._listeners
    ;(g[A] === void 0 && (g[A] = []), g[A].indexOf(I) === -1 && g[A].push(I))
  }
  hasEventListener(A, I) {
    if (this._listeners === void 0) return !1
    const g = this._listeners
    return g[A] !== void 0 && g[A].indexOf(I) !== -1
  }
  removeEventListener(A, I) {
    if (this._listeners === void 0) return
    const C = this._listeners[A]
    if (C !== void 0) {
      const i = C.indexOf(I)
      i !== -1 && C.splice(i, 1)
    }
  }
  dispatchEvent(A) {
    if (this._listeners === void 0) return
    const g = this._listeners[A.type]
    if (g !== void 0) {
      A.target = this
      const C = g.slice(0)
      for (let i = 0, B = C.length; i < B; i++) C[i].call(this, A)
      A.target = null
    }
  }
}
const nE = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "0a",
  "0b",
  "0c",
  "0d",
  "0e",
  "0f",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "1a",
  "1b",
  "1c",
  "1d",
  "1e",
  "1f",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "2a",
  "2b",
  "2c",
  "2d",
  "2e",
  "2f",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "3a",
  "3b",
  "3c",
  "3d",
  "3e",
  "3f",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "4a",
  "4b",
  "4c",
  "4d",
  "4e",
  "4f",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
  "5a",
  "5b",
  "5c",
  "5d",
  "5e",
  "5f",
  "60",
  "61",
  "62",
  "63",
  "64",
  "65",
  "66",
  "67",
  "68",
  "69",
  "6a",
  "6b",
  "6c",
  "6d",
  "6e",
  "6f",
  "70",
  "71",
  "72",
  "73",
  "74",
  "75",
  "76",
  "77",
  "78",
  "79",
  "7a",
  "7b",
  "7c",
  "7d",
  "7e",
  "7f",
  "80",
  "81",
  "82",
  "83",
  "84",
  "85",
  "86",
  "87",
  "88",
  "89",
  "8a",
  "8b",
  "8c",
  "8d",
  "8e",
  "8f",
  "90",
  "91",
  "92",
  "93",
  "94",
  "95",
  "96",
  "97",
  "98",
  "99",
  "9a",
  "9b",
  "9c",
  "9d",
  "9e",
  "9f",
  "a0",
  "a1",
  "a2",
  "a3",
  "a4",
  "a5",
  "a6",
  "a7",
  "a8",
  "a9",
  "aa",
  "ab",
  "ac",
  "ad",
  "ae",
  "af",
  "b0",
  "b1",
  "b2",
  "b3",
  "b4",
  "b5",
  "b6",
  "b7",
  "b8",
  "b9",
  "ba",
  "bb",
  "bc",
  "bd",
  "be",
  "bf",
  "c0",
  "c1",
  "c2",
  "c3",
  "c4",
  "c5",
  "c6",
  "c7",
  "c8",
  "c9",
  "ca",
  "cb",
  "cc",
  "cd",
  "ce",
  "cf",
  "d0",
  "d1",
  "d2",
  "d3",
  "d4",
  "d5",
  "d6",
  "d7",
  "d8",
  "d9",
  "da",
  "db",
  "dc",
  "dd",
  "de",
  "df",
  "e0",
  "e1",
  "e2",
  "e3",
  "e4",
  "e5",
  "e6",
  "e7",
  "e8",
  "e9",
  "ea",
  "eb",
  "ec",
  "ed",
  "ee",
  "ef",
  "f0",
  "f1",
  "f2",
  "f3",
  "f4",
  "f5",
  "f6",
  "f7",
  "f8",
  "f9",
  "fa",
  "fb",
  "fc",
  "fd",
  "fe",
  "ff",
]
let Rq = 1234567
const Jf = Math.PI / 180,
  ap = 180 / Math.PI
function Lr() {
  const e = (Math.random() * 4294967295) | 0,
    A = (Math.random() * 4294967295) | 0,
    I = (Math.random() * 4294967295) | 0,
    g = (Math.random() * 4294967295) | 0
  return (
    nE[e & 255] +
    nE[(e >> 8) & 255] +
    nE[(e >> 16) & 255] +
    nE[(e >> 24) & 255] +
    "-" +
    nE[A & 255] +
    nE[(A >> 8) & 255] +
    "-" +
    nE[((A >> 16) & 15) | 64] +
    nE[(A >> 24) & 255] +
    "-" +
    nE[(I & 63) | 128] +
    nE[(I >> 8) & 255] +
    "-" +
    nE[(I >> 16) & 255] +
    nE[(I >> 24) & 255] +
    nE[g & 255] +
    nE[(g >> 8) & 255] +
    nE[(g >> 16) & 255] +
    nE[(g >> 24) & 255]
  ).toLowerCase()
}
function eQ(e, A, I) {
  return Math.max(A, Math.min(I, e))
}
function Av(e, A) {
  return ((e % A) + A) % A
}
function _1(e, A, I, g, C) {
  return g + ((e - A) * (C - g)) / (I - A)
}
function Z1(e, A, I) {
  return e !== A ? (I - e) / (A - e) : 0
}
function eG(e, A, I) {
  return (1 - I) * e + I * A
}
function P1(e, A, I, g) {
  return eG(e, A, 1 - Math.exp(-I * g))
}
function W1(e, A = 1) {
  return A - Math.abs(Av(e, A * 2) - A)
}
function V1(e, A, I) {
  return e <= A ? 0 : e >= I ? 1 : ((e = (e - A) / (I - A)), e * e * (3 - 2 * e))
}
function j1(e, A, I) {
  return e <= A ? 0 : e >= I ? 1 : ((e = (e - A) / (I - A)), e * e * e * (e * (e * 6 - 15) + 10))
}
function z1(e, A) {
  return e + Math.floor(Math.random() * (A - e + 1))
}
function X1(e, A) {
  return e + Math.random() * (A - e)
}
function $1(e) {
  return e * (0.5 - Math.random())
}
function AZ(e) {
  e !== void 0 && (Rq = e)
  let A = (Rq += 1831565813)
  return (
    (A = Math.imul(A ^ (A >>> 15), A | 1)),
    (A ^= A + Math.imul(A ^ (A >>> 7), A | 61)),
    ((A ^ (A >>> 14)) >>> 0) / 4294967296
  )
}
function IZ(e) {
  return e * Jf
}
function gZ(e) {
  return e * ap
}
function CZ(e) {
  return (e & (e - 1)) === 0 && e !== 0
}
function eZ(e) {
  return Math.pow(2, Math.ceil(Math.log(e) / Math.LN2))
}
function iZ(e) {
  return Math.pow(2, Math.floor(Math.log(e) / Math.LN2))
}
function tZ(e, A, I, g, C) {
  const i = Math.cos,
    B = Math.sin,
    o = i(I / 2),
    r = B(I / 2),
    s = i((A + g) / 2),
    h = B((A + g) / 2),
    S = i((A - g) / 2),
    d = B((A - g) / 2),
    w = i((g - A) / 2),
    M = B((g - A) / 2)
  switch (C) {
    case "XYX":
      e.set(o * h, r * S, r * d, o * s)
      break
    case "YZY":
      e.set(r * d, o * h, r * S, o * s)
      break
    case "ZXZ":
      e.set(r * S, r * d, o * h, o * s)
      break
    case "XZX":
      e.set(o * h, r * M, r * w, o * s)
      break
    case "YXY":
      e.set(r * w, o * h, r * M, o * s)
      break
    case "ZYZ":
      e.set(r * M, r * w, o * h, o * s)
      break
    default:
      console.warn(
        "THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + C,
      )
  }
}
function zE(e, A) {
  switch (A.constructor) {
    case Float32Array:
      return e
    case Uint32Array:
      return e / 4294967295
    case Uint16Array:
      return e / 65535
    case Uint8Array:
      return e / 255
    case Int32Array:
      return Math.max(e / 2147483647, -1)
    case Int16Array:
      return Math.max(e / 32767, -1)
    case Int8Array:
      return Math.max(e / 127, -1)
    default:
      throw new Error("Invalid component type.")
  }
}
function ye(e, A) {
  switch (A.constructor) {
    case Float32Array:
      return e
    case Uint32Array:
      return Math.round(e * 4294967295)
    case Uint16Array:
      return Math.round(e * 65535)
    case Uint8Array:
      return Math.round(e * 255)
    case Int32Array:
      return Math.round(e * 2147483647)
    case Int16Array:
      return Math.round(e * 32767)
    case Int8Array:
      return Math.round(e * 127)
    default:
      throw new Error("Invalid component type.")
  }
}
const XN = {
  DEG2RAD: Jf,
  RAD2DEG: ap,
  generateUUID: Lr,
  clamp: eQ,
  euclideanModulo: Av,
  mapLinear: _1,
  inverseLerp: Z1,
  lerp: eG,
  damp: P1,
  pingpong: W1,
  smoothstep: V1,
  smootherstep: j1,
  randInt: z1,
  randFloat: X1,
  randFloatSpread: $1,
  seededRandom: AZ,
  degToRad: IZ,
  radToDeg: gZ,
  isPowerOfTwo: CZ,
  ceilPowerOfTwo: eZ,
  floorPowerOfTwo: iZ,
  setQuaternionFromProperEuler: tZ,
  normalize: ye,
  denormalize: zE,
}
class ZI {
  constructor(A = 0, I = 0) {
    ;((ZI.prototype.isVector2 = !0), (this.x = A), (this.y = I))
  }
  get width() {
    return this.x
  }
  set width(A) {
    this.x = A
  }
  get height() {
    return this.y
  }
  set height(A) {
    this.y = A
  }
  set(A, I) {
    return ((this.x = A), (this.y = I), this)
  }
  setScalar(A) {
    return ((this.x = A), (this.y = A), this)
  }
  setX(A) {
    return ((this.x = A), this)
  }
  setY(A) {
    return ((this.y = A), this)
  }
  setComponent(A, I) {
    switch (A) {
      case 0:
        this.x = I
        break
      case 1:
        this.y = I
        break
      default:
        throw new Error("index is out of range: " + A)
    }
    return this
  }
  getComponent(A) {
    switch (A) {
      case 0:
        return this.x
      case 1:
        return this.y
      default:
        throw new Error("index is out of range: " + A)
    }
  }
  clone() {
    return new this.constructor(this.x, this.y)
  }
  copy(A) {
    return ((this.x = A.x), (this.y = A.y), this)
  }
  add(A) {
    return ((this.x += A.x), (this.y += A.y), this)
  }
  addScalar(A) {
    return ((this.x += A), (this.y += A), this)
  }
  addVectors(A, I) {
    return ((this.x = A.x + I.x), (this.y = A.y + I.y), this)
  }
  addScaledVector(A, I) {
    return ((this.x += A.x * I), (this.y += A.y * I), this)
  }
  sub(A) {
    return ((this.x -= A.x), (this.y -= A.y), this)
  }
  subScalar(A) {
    return ((this.x -= A), (this.y -= A), this)
  }
  subVectors(A, I) {
    return ((this.x = A.x - I.x), (this.y = A.y - I.y), this)
  }
  multiply(A) {
    return ((this.x *= A.x), (this.y *= A.y), this)
  }
  multiplyScalar(A) {
    return ((this.x *= A), (this.y *= A), this)
  }
  divide(A) {
    return ((this.x /= A.x), (this.y /= A.y), this)
  }
  divideScalar(A) {
    return this.multiplyScalar(1 / A)
  }
  applyMatrix3(A) {
    const I = this.x,
      g = this.y,
      C = A.elements
    return ((this.x = C[0] * I + C[3] * g + C[6]), (this.y = C[1] * I + C[4] * g + C[7]), this)
  }
  min(A) {
    return ((this.x = Math.min(this.x, A.x)), (this.y = Math.min(this.y, A.y)), this)
  }
  max(A) {
    return ((this.x = Math.max(this.x, A.x)), (this.y = Math.max(this.y, A.y)), this)
  }
  clamp(A, I) {
    return (
      (this.x = Math.max(A.x, Math.min(I.x, this.x))),
      (this.y = Math.max(A.y, Math.min(I.y, this.y))),
      this
    )
  }
  clampScalar(A, I) {
    return (
      (this.x = Math.max(A, Math.min(I, this.x))),
      (this.y = Math.max(A, Math.min(I, this.y))),
      this
    )
  }
  clampLength(A, I) {
    const g = this.length()
    return this.divideScalar(g || 1).multiplyScalar(Math.max(A, Math.min(I, g)))
  }
  floor() {
    return ((this.x = Math.floor(this.x)), (this.y = Math.floor(this.y)), this)
  }
  ceil() {
    return ((this.x = Math.ceil(this.x)), (this.y = Math.ceil(this.y)), this)
  }
  round() {
    return ((this.x = Math.round(this.x)), (this.y = Math.round(this.y)), this)
  }
  roundToZero() {
    return ((this.x = Math.trunc(this.x)), (this.y = Math.trunc(this.y)), this)
  }
  negate() {
    return ((this.x = -this.x), (this.y = -this.y), this)
  }
  dot(A) {
    return this.x * A.x + this.y * A.y
  }
  cross(A) {
    return this.x * A.y - this.y * A.x
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y)
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y)
  }
  normalize() {
    return this.divideScalar(this.length() || 1)
  }
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI
  }
  angleTo(A) {
    const I = Math.sqrt(this.lengthSq() * A.lengthSq())
    if (I === 0) return Math.PI / 2
    const g = this.dot(A) / I
    return Math.acos(eQ(g, -1, 1))
  }
  distanceTo(A) {
    return Math.sqrt(this.distanceToSquared(A))
  }
  distanceToSquared(A) {
    const I = this.x - A.x,
      g = this.y - A.y
    return I * I + g * g
  }
  manhattanDistanceTo(A) {
    return Math.abs(this.x - A.x) + Math.abs(this.y - A.y)
  }
  setLength(A) {
    return this.normalize().multiplyScalar(A)
  }
  lerp(A, I) {
    return ((this.x += (A.x - this.x) * I), (this.y += (A.y - this.y) * I), this)
  }
  lerpVectors(A, I, g) {
    return ((this.x = A.x + (I.x - A.x) * g), (this.y = A.y + (I.y - A.y) * g), this)
  }
  equals(A) {
    return A.x === this.x && A.y === this.y
  }
  fromArray(A, I = 0) {
    return ((this.x = A[I]), (this.y = A[I + 1]), this)
  }
  toArray(A = [], I = 0) {
    return ((A[I] = this.x), (A[I + 1] = this.y), A)
  }
  fromBufferAttribute(A, I) {
    return ((this.x = A.getX(I)), (this.y = A.getY(I)), this)
  }
  rotateAround(A, I) {
    const g = Math.cos(I),
      C = Math.sin(I),
      i = this.x - A.x,
      B = this.y - A.y
    return ((this.x = i * g - B * C + A.x), (this.y = i * C + B * g + A.y), this)
  }
  random() {
    return ((this.x = Math.random()), (this.y = Math.random()), this)
  }
  *[Symbol.iterator]() {
    ;(yield this.x, yield this.y)
  }
}
class ce {
  constructor(A, I, g, C, i, B, o, r, s) {
    ;((ce.prototype.isMatrix3 = !0),
      (this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1]),
      A !== void 0 && this.set(A, I, g, C, i, B, o, r, s))
  }
  set(A, I, g, C, i, B, o, r, s) {
    const h = this.elements
    return (
      (h[0] = A),
      (h[1] = C),
      (h[2] = o),
      (h[3] = I),
      (h[4] = i),
      (h[5] = r),
      (h[6] = g),
      (h[7] = B),
      (h[8] = s),
      this
    )
  }
  identity() {
    return (this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this)
  }
  copy(A) {
    const I = this.elements,
      g = A.elements
    return (
      (I[0] = g[0]),
      (I[1] = g[1]),
      (I[2] = g[2]),
      (I[3] = g[3]),
      (I[4] = g[4]),
      (I[5] = g[5]),
      (I[6] = g[6]),
      (I[7] = g[7]),
      (I[8] = g[8]),
      this
    )
  }
  extractBasis(A, I, g) {
    return (
      A.setFromMatrix3Column(this, 0),
      I.setFromMatrix3Column(this, 1),
      g.setFromMatrix3Column(this, 2),
      this
    )
  }
  setFromMatrix4(A) {
    const I = A.elements
    return (this.set(I[0], I[4], I[8], I[1], I[5], I[9], I[2], I[6], I[10]), this)
  }
  multiply(A) {
    return this.multiplyMatrices(this, A)
  }
  premultiply(A) {
    return this.multiplyMatrices(A, this)
  }
  multiplyMatrices(A, I) {
    const g = A.elements,
      C = I.elements,
      i = this.elements,
      B = g[0],
      o = g[3],
      r = g[6],
      s = g[1],
      h = g[4],
      S = g[7],
      d = g[2],
      w = g[5],
      M = g[8],
      K = C[0],
      R = C[3],
      F = C[6],
      L = C[1],
      Y = C[4],
      H = C[7],
      V = C[2],
      j = C[5],
      P = C[8]
    return (
      (i[0] = B * K + o * L + r * V),
      (i[3] = B * R + o * Y + r * j),
      (i[6] = B * F + o * H + r * P),
      (i[1] = s * K + h * L + S * V),
      (i[4] = s * R + h * Y + S * j),
      (i[7] = s * F + h * H + S * P),
      (i[2] = d * K + w * L + M * V),
      (i[5] = d * R + w * Y + M * j),
      (i[8] = d * F + w * H + M * P),
      this
    )
  }
  multiplyScalar(A) {
    const I = this.elements
    return (
      (I[0] *= A),
      (I[3] *= A),
      (I[6] *= A),
      (I[1] *= A),
      (I[4] *= A),
      (I[7] *= A),
      (I[2] *= A),
      (I[5] *= A),
      (I[8] *= A),
      this
    )
  }
  determinant() {
    const A = this.elements,
      I = A[0],
      g = A[1],
      C = A[2],
      i = A[3],
      B = A[4],
      o = A[5],
      r = A[6],
      s = A[7],
      h = A[8]
    return I * B * h - I * o * s - g * i * h + g * o * r + C * i * s - C * B * r
  }
  invert() {
    const A = this.elements,
      I = A[0],
      g = A[1],
      C = A[2],
      i = A[3],
      B = A[4],
      o = A[5],
      r = A[6],
      s = A[7],
      h = A[8],
      S = h * B - o * s,
      d = o * r - h * i,
      w = s * i - B * r,
      M = I * S + g * d + C * w
    if (M === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0)
    const K = 1 / M
    return (
      (A[0] = S * K),
      (A[1] = (C * s - h * g) * K),
      (A[2] = (o * g - C * B) * K),
      (A[3] = d * K),
      (A[4] = (h * I - C * r) * K),
      (A[5] = (C * i - o * I) * K),
      (A[6] = w * K),
      (A[7] = (g * r - s * I) * K),
      (A[8] = (B * I - g * i) * K),
      this
    )
  }
  transpose() {
    let A
    const I = this.elements
    return (
      (A = I[1]),
      (I[1] = I[3]),
      (I[3] = A),
      (A = I[2]),
      (I[2] = I[6]),
      (I[6] = A),
      (A = I[5]),
      (I[5] = I[7]),
      (I[7] = A),
      this
    )
  }
  getNormalMatrix(A) {
    return this.setFromMatrix4(A).invert().transpose()
  }
  transposeIntoArray(A) {
    const I = this.elements
    return (
      (A[0] = I[0]),
      (A[1] = I[3]),
      (A[2] = I[6]),
      (A[3] = I[1]),
      (A[4] = I[4]),
      (A[5] = I[7]),
      (A[6] = I[2]),
      (A[7] = I[5]),
      (A[8] = I[8]),
      this
    )
  }
  setUvTransform(A, I, g, C, i, B, o) {
    const r = Math.cos(i),
      s = Math.sin(i)
    return (
      this.set(
        g * r,
        g * s,
        -g * (r * B + s * o) + B + A,
        -C * s,
        C * r,
        -C * (-s * B + r * o) + o + I,
        0,
        0,
        1,
      ),
      this
    )
  }
  //
  scale(A, I) {
    return (this.premultiply(WJ.makeScale(A, I)), this)
  }
  rotate(A) {
    return (this.premultiply(WJ.makeRotation(-A)), this)
  }
  translate(A, I) {
    return (this.premultiply(WJ.makeTranslation(A, I)), this)
  }
  // for 2D Transforms
  makeTranslation(A, I) {
    return (
      A.isVector2 ? this.set(1, 0, A.x, 0, 1, A.y, 0, 0, 1) : this.set(1, 0, A, 0, 1, I, 0, 0, 1),
      this
    )
  }
  makeRotation(A) {
    const I = Math.cos(A),
      g = Math.sin(A)
    return (this.set(I, -g, 0, g, I, 0, 0, 0, 1), this)
  }
  makeScale(A, I) {
    return (this.set(A, 0, 0, 0, I, 0, 0, 0, 1), this)
  }
  //
  equals(A) {
    const I = this.elements,
      g = A.elements
    for (let C = 0; C < 9; C++) if (I[C] !== g[C]) return !1
    return !0
  }
  fromArray(A, I = 0) {
    for (let g = 0; g < 9; g++) this.elements[g] = A[g + I]
    return this
  }
  toArray(A = [], I = 0) {
    const g = this.elements
    return (
      (A[I] = g[0]),
      (A[I + 1] = g[1]),
      (A[I + 2] = g[2]),
      (A[I + 3] = g[3]),
      (A[I + 4] = g[4]),
      (A[I + 5] = g[5]),
      (A[I + 6] = g[6]),
      (A[I + 7] = g[7]),
      (A[I + 8] = g[8]),
      A
    )
  }
  clone() {
    return new this.constructor().fromArray(this.elements)
  }
}
const WJ = /* @__PURE__ */ new ce()
function T2(e) {
  for (let A = e.length - 1; A >= 0; --A) if (e[A] >= 65535) return !0
  return !1
}
const BZ = {
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
}
function Ap(e, A) {
  return new BZ[e](A)
}
function lG(e) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", e)
}
function x2() {
  const e = lG("canvas")
  return ((e.style.display = "block"), e)
}
const Jq = {}
function O0(e) {
  e in Jq || ((Jq[e] = !0), console.warn(e))
}
function QZ(e, A, I) {
  return new Promise(function (g, C) {
    function i() {
      switch (e.clientWaitSync(A, e.SYNC_FLUSH_COMMANDS_BIT, 0)) {
        case e.WAIT_FAILED:
          C()
          break
        case e.TIMEOUT_EXPIRED:
          setTimeout(i, I)
          break
        default:
          g()
      }
    }
    setTimeout(i, I)
  })
}
function oZ(e) {
  const A = e.elements
  ;((A[2] = 0.5 * A[2] + 0.5 * A[3]),
    (A[6] = 0.5 * A[6] + 0.5 * A[7]),
    (A[10] = 0.5 * A[10] + 0.5 * A[11]),
    (A[14] = 0.5 * A[14] + 0.5 * A[15]))
}
function nZ(e) {
  const A = e.elements
  A[11] === -1 ? ((A[10] = -A[10] - 1), (A[14] = -A[14])) : ((A[10] = -A[10]), (A[14] = -A[14] + 1))
}
const ni = {
  enabled: !0,
  workingColorSpace: ru,
  /**
   * Implementations of supported color spaces.
   *
   * Required:
   *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
   *	- whitePoint: reference white [ x y ]
   *	- transfer: transfer function (pre-defined)
   *	- toXYZ: Matrix3 RGB to XYZ transform
   *	- fromXYZ: Matrix3 XYZ to RGB transform
   *	- luminanceCoefficients: RGB luminance coefficients
   *
   * Optional:
   *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
   *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
   *
   * Reference:
   * - https://www.russellcottrell.com/photo/matrixCalculator.htm
   */
  spaces: {},
  convert: function (e, A, I) {
    return (
      this.enabled === !1 ||
        A === I ||
        !A ||
        !I ||
        (this.spaces[A].transfer === ot && ((e.r = eu(e.r)), (e.g = eu(e.g)), (e.b = eu(e.b))),
        this.spaces[A].primaries !== this.spaces[I].primaries &&
          (e.applyMatrix3(this.spaces[A].toXYZ), e.applyMatrix3(this.spaces[I].fromXYZ)),
        this.spaces[I].transfer === ot && ((e.r = ip(e.r)), (e.g = ip(e.g)), (e.b = ip(e.b)))),
      e
    )
  },
  fromWorkingColorSpace: function (e, A) {
    return this.convert(e, this.workingColorSpace, A)
  },
  toWorkingColorSpace: function (e, A) {
    return this.convert(e, A, this.workingColorSpace)
  },
  getPrimaries: function (e) {
    return this.spaces[e].primaries
  },
  getTransfer: function (e) {
    return e === kl ? NG : this.spaces[e].transfer
  },
  getLuminanceCoefficients: function (e, A = this.workingColorSpace) {
    return e.fromArray(this.spaces[A].luminanceCoefficients)
  },
  define: function (e) {
    Object.assign(this.spaces, e)
  },
  // Internal APIs
  _getMatrix: function (e, A, I) {
    return e.copy(this.spaces[A].toXYZ).multiply(this.spaces[I].fromXYZ)
  },
  _getDrawingBufferColorSpace: function (e) {
    return this.spaces[e].outputColorSpaceConfig.drawingBufferColorSpace
  },
  _getUnpackColorSpace: function (e = this.workingColorSpace) {
    return this.spaces[e].workingColorSpaceConfig.unpackColorSpace
  },
}
function eu(e) {
  return e < 0.04045 ? e * 0.0773993808 : Math.pow(e * 0.9478672986 + 0.0521327014, 2.4)
}
function ip(e) {
  return e < 31308e-7 ? e * 12.92 : 1.055 * Math.pow(e, 0.41666) - 0.055
}
const Kq = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06],
  mq = [0.2126, 0.7152, 0.0722],
  vq = [0.3127, 0.329],
  Lq = /* @__PURE__ */ new ce().set(
    0.4123908,
    0.3575843,
    0.1804808,
    0.212639,
    0.7151687,
    0.0721923,
    0.0193308,
    0.1191948,
    0.9505322,
  ),
  Yq = /* @__PURE__ */ new ce().set(
    3.2409699,
    -1.5373832,
    -0.4986108,
    -0.9692436,
    1.8759675,
    0.0415551,
    0.0556301,
    -0.203977,
    1.0569715,
  )
ni.define({
  [ru]: {
    primaries: Kq,
    whitePoint: vq,
    transfer: NG,
    toXYZ: Lq,
    fromXYZ: Yq,
    luminanceCoefficients: mq,
    workingColorSpaceConfig: { unpackColorSpace: zi },
    outputColorSpaceConfig: { drawingBufferColorSpace: zi },
  },
  [zi]: {
    primaries: Kq,
    whitePoint: vq,
    transfer: ot,
    toXYZ: Lq,
    fromXYZ: Yq,
    luminanceCoefficients: mq,
    outputColorSpaceConfig: { drawingBufferColorSpace: zi },
  },
})
let Uy
class b2 {
  static getDataURL(A) {
    if (/^data:/i.test(A.src) || typeof HTMLCanvasElement > "u") return A.src
    let I
    if (A instanceof HTMLCanvasElement) I = A
    else {
      ;(Uy === void 0 && (Uy = lG("canvas")), (Uy.width = A.width), (Uy.height = A.height))
      const g = Uy.getContext("2d")
      ;(A instanceof ImageData ? g.putImageData(A, 0, 0) : g.drawImage(A, 0, 0, A.width, A.height),
        (I = Uy))
    }
    return I.width > 2048 || I.height > 2048
      ? (console.warn(
          "THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons",
          A,
        ),
        I.toDataURL("image/jpeg", 0.6))
      : I.toDataURL("image/png")
  }
  static sRGBToLinear(A) {
    if (
      (typeof HTMLImageElement < "u" && A instanceof HTMLImageElement) ||
      (typeof HTMLCanvasElement < "u" && A instanceof HTMLCanvasElement) ||
      (typeof ImageBitmap < "u" && A instanceof ImageBitmap)
    ) {
      const I = lG("canvas")
      ;((I.width = A.width), (I.height = A.height))
      const g = I.getContext("2d")
      g.drawImage(A, 0, 0, A.width, A.height)
      const C = g.getImageData(0, 0, A.width, A.height),
        i = C.data
      for (let B = 0; B < i.length; B++) i[B] = eu(i[B] / 255) * 255
      return (g.putImageData(C, 0, 0), I)
    } else if (A.data) {
      const I = A.data.slice(0)
      for (let g = 0; g < I.length; g++)
        I instanceof Uint8Array || I instanceof Uint8ClampedArray
          ? (I[g] = Math.floor(eu(I[g] / 255) * 255))
          : (I[g] = eu(I[g]))
      return {
        data: I,
        width: A.width,
        height: A.height,
      }
    } else
      return (
        console.warn(
          "THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.",
        ),
        A
      )
  }
}
let EZ = 0
class kf {
  constructor(A = null) {
    ;((this.isSource = !0),
      Object.defineProperty(this, "id", { value: EZ++ }),
      (this.uuid = Lr()),
      (this.data = A),
      (this.dataReady = !0),
      (this.version = 0))
  }
  set needsUpdate(A) {
    A === !0 && this.version++
  }
  toJSON(A) {
    const I = A === void 0 || typeof A == "string"
    if (!I && A.images[this.uuid] !== void 0) return A.images[this.uuid]
    const g = {
        uuid: this.uuid,
        url: "",
      },
      C = this.data
    if (C !== null) {
      let i
      if (Array.isArray(C)) {
        i = []
        for (let B = 0, o = C.length; B < o; B++)
          C[B].isDataTexture ? i.push(VJ(C[B].image)) : i.push(VJ(C[B]))
      } else i = VJ(C)
      g.url = i
    }
    return (I || (A.images[this.uuid] = g), g)
  }
}
function VJ(e) {
  return (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement) ||
    (typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement) ||
    (typeof ImageBitmap < "u" && e instanceof ImageBitmap)
    ? b2.getDataURL(e)
    : e.data
      ? {
          data: Array.from(e.data),
          width: e.width,
          height: e.height,
          type: e.data.constructor.name,
        }
      : (console.warn("THREE.Texture: Unable to serialize Texture."), {})
}
let aZ = 0
class pt extends qr {
  constructor(
    A = pt.DEFAULT_IMAGE,
    I = pt.DEFAULT_MAPPING,
    g = vr,
    C = vr,
    i = nt,
    B = ks,
    o = lE,
    r = Xo,
    s = pt.DEFAULT_ANISOTROPY,
    h = kl,
  ) {
    ;(super(),
      (this.isTexture = !0),
      Object.defineProperty(this, "id", { value: aZ++ }),
      (this.uuid = Lr()),
      (this.name = ""),
      (this.source = new kf(A)),
      (this.mipmaps = []),
      (this.mapping = I),
      (this.channel = 0),
      (this.wrapS = g),
      (this.wrapT = C),
      (this.magFilter = i),
      (this.minFilter = B),
      (this.anisotropy = s),
      (this.format = o),
      (this.internalFormat = null),
      (this.type = r),
      (this.offset = new ZI(0, 0)),
      (this.repeat = new ZI(1, 1)),
      (this.center = new ZI(0, 0)),
      (this.rotation = 0),
      (this.matrixAutoUpdate = !0),
      (this.matrix = new ce()),
      (this.generateMipmaps = !0),
      (this.premultiplyAlpha = !1),
      (this.flipY = !0),
      (this.unpackAlignment = 4),
      (this.colorSpace = h),
      (this.userData = {}),
      (this.version = 0),
      (this.onUpdate = null),
      (this.isRenderTargetTexture = !1),
      (this.pmremVersion = 0))
  }
  get image() {
    return this.source.data
  }
  set image(A = null) {
    this.source.data = A
  }
  updateMatrix() {
    this.matrix.setUvTransform(
      this.offset.x,
      this.offset.y,
      this.repeat.x,
      this.repeat.y,
      this.rotation,
      this.center.x,
      this.center.y,
    )
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(A) {
    return (
      (this.name = A.name),
      (this.source = A.source),
      (this.mipmaps = A.mipmaps.slice(0)),
      (this.mapping = A.mapping),
      (this.channel = A.channel),
      (this.wrapS = A.wrapS),
      (this.wrapT = A.wrapT),
      (this.magFilter = A.magFilter),
      (this.minFilter = A.minFilter),
      (this.anisotropy = A.anisotropy),
      (this.format = A.format),
      (this.internalFormat = A.internalFormat),
      (this.type = A.type),
      this.offset.copy(A.offset),
      this.repeat.copy(A.repeat),
      this.center.copy(A.center),
      (this.rotation = A.rotation),
      (this.matrixAutoUpdate = A.matrixAutoUpdate),
      this.matrix.copy(A.matrix),
      (this.generateMipmaps = A.generateMipmaps),
      (this.premultiplyAlpha = A.premultiplyAlpha),
      (this.flipY = A.flipY),
      (this.unpackAlignment = A.unpackAlignment),
      (this.colorSpace = A.colorSpace),
      (this.userData = JSON.parse(JSON.stringify(A.userData))),
      (this.needsUpdate = !0),
      this
    )
  }
  toJSON(A) {
    const I = A === void 0 || typeof A == "string"
    if (!I && A.textures[this.uuid] !== void 0) return A.textures[this.uuid]
    const g = {
      metadata: {
        version: 4.6,
        type: "Texture",
        generator: "Texture.toJSON",
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(A).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment,
    }
    return (
      Object.keys(this.userData).length > 0 && (g.userData = this.userData),
      I || (A.textures[this.uuid] = g),
      g
    )
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" })
  }
  transformUv(A) {
    if (this.mapping !== bN) return A
    if ((A.applyMatrix3(this.matrix), A.x < 0 || A.x > 1))
      switch (this.wrapS) {
        case MD:
          A.x = A.x - Math.floor(A.x)
          break
        case vr:
          A.x = A.x < 0 ? 0 : 1
          break
        case Qp:
          Math.abs(Math.floor(A.x) % 2) === 1
            ? (A.x = Math.ceil(A.x) - A.x)
            : (A.x = A.x - Math.floor(A.x))
          break
      }
    if (A.y < 0 || A.y > 1)
      switch (this.wrapT) {
        case MD:
          A.y = A.y - Math.floor(A.y)
          break
        case vr:
          A.y = A.y < 0 ? 0 : 1
          break
        case Qp:
          Math.abs(Math.floor(A.y) % 2) === 1
            ? (A.y = Math.ceil(A.y) - A.y)
            : (A.y = A.y - Math.floor(A.y))
          break
      }
    return (this.flipY && (A.y = 1 - A.y), A)
  }
  set needsUpdate(A) {
    A === !0 && (this.version++, (this.source.needsUpdate = !0))
  }
  set needsPMREMUpdate(A) {
    A === !0 && this.pmremVersion++
  }
}
pt.DEFAULT_IMAGE = null
pt.DEFAULT_MAPPING = bN
pt.DEFAULT_ANISOTROPY = 1
class Xe {
  constructor(A = 0, I = 0, g = 0, C = 1) {
    ;((Xe.prototype.isVector4 = !0), (this.x = A), (this.y = I), (this.z = g), (this.w = C))
  }
  get width() {
    return this.z
  }
  set width(A) {
    this.z = A
  }
  get height() {
    return this.w
  }
  set height(A) {
    this.w = A
  }
  set(A, I, g, C) {
    return ((this.x = A), (this.y = I), (this.z = g), (this.w = C), this)
  }
  setScalar(A) {
    return ((this.x = A), (this.y = A), (this.z = A), (this.w = A), this)
  }
  setX(A) {
    return ((this.x = A), this)
  }
  setY(A) {
    return ((this.y = A), this)
  }
  setZ(A) {
    return ((this.z = A), this)
  }
  setW(A) {
    return ((this.w = A), this)
  }
  setComponent(A, I) {
    switch (A) {
      case 0:
        this.x = I
        break
      case 1:
        this.y = I
        break
      case 2:
        this.z = I
        break
      case 3:
        this.w = I
        break
      default:
        throw new Error("index is out of range: " + A)
    }
    return this
  }
  getComponent(A) {
    switch (A) {
      case 0:
        return this.x
      case 1:
        return this.y
      case 2:
        return this.z
      case 3:
        return this.w
      default:
        throw new Error("index is out of range: " + A)
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w)
  }
  copy(A) {
    return (
      (this.x = A.x),
      (this.y = A.y),
      (this.z = A.z),
      (this.w = A.w !== void 0 ? A.w : 1),
      this
    )
  }
  add(A) {
    return ((this.x += A.x), (this.y += A.y), (this.z += A.z), (this.w += A.w), this)
  }
  addScalar(A) {
    return ((this.x += A), (this.y += A), (this.z += A), (this.w += A), this)
  }
  addVectors(A, I) {
    return (
      (this.x = A.x + I.x),
      (this.y = A.y + I.y),
      (this.z = A.z + I.z),
      (this.w = A.w + I.w),
      this
    )
  }
  addScaledVector(A, I) {
    return (
      (this.x += A.x * I),
      (this.y += A.y * I),
      (this.z += A.z * I),
      (this.w += A.w * I),
      this
    )
  }
  sub(A) {
    return ((this.x -= A.x), (this.y -= A.y), (this.z -= A.z), (this.w -= A.w), this)
  }
  subScalar(A) {
    return ((this.x -= A), (this.y -= A), (this.z -= A), (this.w -= A), this)
  }
  subVectors(A, I) {
    return (
      (this.x = A.x - I.x),
      (this.y = A.y - I.y),
      (this.z = A.z - I.z),
      (this.w = A.w - I.w),
      this
    )
  }
  multiply(A) {
    return ((this.x *= A.x), (this.y *= A.y), (this.z *= A.z), (this.w *= A.w), this)
  }
  multiplyScalar(A) {
    return ((this.x *= A), (this.y *= A), (this.z *= A), (this.w *= A), this)
  }
  applyMatrix4(A) {
    const I = this.x,
      g = this.y,
      C = this.z,
      i = this.w,
      B = A.elements
    return (
      (this.x = B[0] * I + B[4] * g + B[8] * C + B[12] * i),
      (this.y = B[1] * I + B[5] * g + B[9] * C + B[13] * i),
      (this.z = B[2] * I + B[6] * g + B[10] * C + B[14] * i),
      (this.w = B[3] * I + B[7] * g + B[11] * C + B[15] * i),
      this
    )
  }
  divide(A) {
    return ((this.x /= A.x), (this.y /= A.y), (this.z /= A.z), (this.w /= A.w), this)
  }
  divideScalar(A) {
    return this.multiplyScalar(1 / A)
  }
  setAxisAngleFromQuaternion(A) {
    this.w = 2 * Math.acos(A.w)
    const I = Math.sqrt(1 - A.w * A.w)
    return (
      I < 1e-4
        ? ((this.x = 1), (this.y = 0), (this.z = 0))
        : ((this.x = A.x / I), (this.y = A.y / I), (this.z = A.z / I)),
      this
    )
  }
  setAxisAngleFromRotationMatrix(A) {
    let I, g, C, i
    const r = A.elements,
      s = r[0],
      h = r[4],
      S = r[8],
      d = r[1],
      w = r[5],
      M = r[9],
      K = r[2],
      R = r[6],
      F = r[10]
    if (Math.abs(h - d) < 0.01 && Math.abs(S - K) < 0.01 && Math.abs(M - R) < 0.01) {
      if (
        Math.abs(h + d) < 0.1 &&
        Math.abs(S + K) < 0.1 &&
        Math.abs(M + R) < 0.1 &&
        Math.abs(s + w + F - 3) < 0.1
      )
        return (this.set(1, 0, 0, 0), this)
      I = Math.PI
      const Y = (s + 1) / 2,
        H = (w + 1) / 2,
        V = (F + 1) / 2,
        j = (h + d) / 4,
        P = (S + K) / 4,
        AA = (M + R) / 4
      return (
        Y > H && Y > V
          ? Y < 0.01
            ? ((g = 0), (C = 0.707106781), (i = 0.707106781))
            : ((g = Math.sqrt(Y)), (C = j / g), (i = P / g))
          : H > V
            ? H < 0.01
              ? ((g = 0.707106781), (C = 0), (i = 0.707106781))
              : ((C = Math.sqrt(H)), (g = j / C), (i = AA / C))
            : V < 0.01
              ? ((g = 0.707106781), (C = 0.707106781), (i = 0))
              : ((i = Math.sqrt(V)), (g = P / i), (C = AA / i)),
        this.set(g, C, i, I),
        this
      )
    }
    let L = Math.sqrt((R - M) * (R - M) + (S - K) * (S - K) + (d - h) * (d - h))
    return (
      Math.abs(L) < 1e-3 && (L = 1),
      (this.x = (R - M) / L),
      (this.y = (S - K) / L),
      (this.z = (d - h) / L),
      (this.w = Math.acos((s + w + F - 1) / 2)),
      this
    )
  }
  setFromMatrixPosition(A) {
    const I = A.elements
    return ((this.x = I[12]), (this.y = I[13]), (this.z = I[14]), (this.w = I[15]), this)
  }
  min(A) {
    return (
      (this.x = Math.min(this.x, A.x)),
      (this.y = Math.min(this.y, A.y)),
      (this.z = Math.min(this.z, A.z)),
      (this.w = Math.min(this.w, A.w)),
      this
    )
  }
  max(A) {
    return (
      (this.x = Math.max(this.x, A.x)),
      (this.y = Math.max(this.y, A.y)),
      (this.z = Math.max(this.z, A.z)),
      (this.w = Math.max(this.w, A.w)),
      this
    )
  }
  clamp(A, I) {
    return (
      (this.x = Math.max(A.x, Math.min(I.x, this.x))),
      (this.y = Math.max(A.y, Math.min(I.y, this.y))),
      (this.z = Math.max(A.z, Math.min(I.z, this.z))),
      (this.w = Math.max(A.w, Math.min(I.w, this.w))),
      this
    )
  }
  clampScalar(A, I) {
    return (
      (this.x = Math.max(A, Math.min(I, this.x))),
      (this.y = Math.max(A, Math.min(I, this.y))),
      (this.z = Math.max(A, Math.min(I, this.z))),
      (this.w = Math.max(A, Math.min(I, this.w))),
      this
    )
  }
  clampLength(A, I) {
    const g = this.length()
    return this.divideScalar(g || 1).multiplyScalar(Math.max(A, Math.min(I, g)))
  }
  floor() {
    return (
      (this.x = Math.floor(this.x)),
      (this.y = Math.floor(this.y)),
      (this.z = Math.floor(this.z)),
      (this.w = Math.floor(this.w)),
      this
    )
  }
  ceil() {
    return (
      (this.x = Math.ceil(this.x)),
      (this.y = Math.ceil(this.y)),
      (this.z = Math.ceil(this.z)),
      (this.w = Math.ceil(this.w)),
      this
    )
  }
  round() {
    return (
      (this.x = Math.round(this.x)),
      (this.y = Math.round(this.y)),
      (this.z = Math.round(this.z)),
      (this.w = Math.round(this.w)),
      this
    )
  }
  roundToZero() {
    return (
      (this.x = Math.trunc(this.x)),
      (this.y = Math.trunc(this.y)),
      (this.z = Math.trunc(this.z)),
      (this.w = Math.trunc(this.w)),
      this
    )
  }
  negate() {
    return ((this.x = -this.x), (this.y = -this.y), (this.z = -this.z), (this.w = -this.w), this)
  }
  dot(A) {
    return this.x * A.x + this.y * A.y + this.z * A.z + this.w * A.w
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w)
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w)
  }
  normalize() {
    return this.divideScalar(this.length() || 1)
  }
  setLength(A) {
    return this.normalize().multiplyScalar(A)
  }
  lerp(A, I) {
    return (
      (this.x += (A.x - this.x) * I),
      (this.y += (A.y - this.y) * I),
      (this.z += (A.z - this.z) * I),
      (this.w += (A.w - this.w) * I),
      this
    )
  }
  lerpVectors(A, I, g) {
    return (
      (this.x = A.x + (I.x - A.x) * g),
      (this.y = A.y + (I.y - A.y) * g),
      (this.z = A.z + (I.z - A.z) * g),
      (this.w = A.w + (I.w - A.w) * g),
      this
    )
  }
  equals(A) {
    return A.x === this.x && A.y === this.y && A.z === this.z && A.w === this.w
  }
  fromArray(A, I = 0) {
    return ((this.x = A[I]), (this.y = A[I + 1]), (this.z = A[I + 2]), (this.w = A[I + 3]), this)
  }
  toArray(A = [], I = 0) {
    return ((A[I] = this.x), (A[I + 1] = this.y), (A[I + 2] = this.z), (A[I + 3] = this.w), A)
  }
  fromBufferAttribute(A, I) {
    return (
      (this.x = A.getX(I)),
      (this.y = A.getY(I)),
      (this.z = A.getZ(I)),
      (this.w = A.getW(I)),
      this
    )
  }
  random() {
    return (
      (this.x = Math.random()),
      (this.y = Math.random()),
      (this.z = Math.random()),
      (this.w = Math.random()),
      this
    )
  }
  *[Symbol.iterator]() {
    ;(yield this.x, yield this.y, yield this.z, yield this.w)
  }
}
class O2 extends qr {
  constructor(A = 1, I = 1, g = {}) {
    ;(super(),
      (this.isRenderTarget = !0),
      (this.width = A),
      (this.height = I),
      (this.depth = 1),
      (this.scissor = new Xe(0, 0, A, I)),
      (this.scissorTest = !1),
      (this.viewport = new Xe(0, 0, A, I)))
    const C = { width: A, height: I, depth: 1 }
    g = Object.assign(
      {
        generateMipmaps: !1,
        internalFormat: null,
        minFilter: nt,
        depthBuffer: !0,
        stencilBuffer: !1,
        resolveDepthBuffer: !0,
        resolveStencilBuffer: !0,
        depthTexture: null,
        samples: 0,
        count: 1,
      },
      g,
    )
    const i = new pt(
      C,
      g.mapping,
      g.wrapS,
      g.wrapT,
      g.magFilter,
      g.minFilter,
      g.format,
      g.type,
      g.anisotropy,
      g.colorSpace,
    )
    ;((i.flipY = !1),
      (i.generateMipmaps = g.generateMipmaps),
      (i.internalFormat = g.internalFormat),
      (this.textures = []))
    const B = g.count
    for (let o = 0; o < B; o++)
      ((this.textures[o] = i.clone()), (this.textures[o].isRenderTargetTexture = !0))
    ;((this.depthBuffer = g.depthBuffer),
      (this.stencilBuffer = g.stencilBuffer),
      (this.resolveDepthBuffer = g.resolveDepthBuffer),
      (this.resolveStencilBuffer = g.resolveStencilBuffer),
      (this.depthTexture = g.depthTexture),
      (this.samples = g.samples))
  }
  get texture() {
    return this.textures[0]
  }
  set texture(A) {
    this.textures[0] = A
  }
  setSize(A, I, g = 1) {
    if (this.width !== A || this.height !== I || this.depth !== g) {
      ;((this.width = A), (this.height = I), (this.depth = g))
      for (let C = 0, i = this.textures.length; C < i; C++)
        ((this.textures[C].image.width = A),
          (this.textures[C].image.height = I),
          (this.textures[C].image.depth = g))
      this.dispose()
    }
    ;(this.viewport.set(0, 0, A, I), this.scissor.set(0, 0, A, I))
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(A) {
    ;((this.width = A.width),
      (this.height = A.height),
      (this.depth = A.depth),
      this.scissor.copy(A.scissor),
      (this.scissorTest = A.scissorTest),
      this.viewport.copy(A.viewport),
      (this.textures.length = 0))
    for (let g = 0, C = A.textures.length; g < C; g++)
      ((this.textures[g] = A.textures[g].clone()), (this.textures[g].isRenderTargetTexture = !0))
    const I = Object.assign({}, A.texture.image)
    return (
      (this.texture.source = new kf(I)),
      (this.depthBuffer = A.depthBuffer),
      (this.stencilBuffer = A.stencilBuffer),
      (this.resolveDepthBuffer = A.resolveDepthBuffer),
      (this.resolveStencilBuffer = A.resolveStencilBuffer),
      A.depthTexture !== null && (this.depthTexture = A.depthTexture.clone()),
      (this.samples = A.samples),
      this
    )
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" })
  }
}
class BQ extends O2 {
  constructor(A = 1, I = 1, g = {}) {
    ;(super(A, I, g), (this.isWebGLRenderTarget = !0))
  }
}
class $N extends pt {
  constructor(A = null, I = 1, g = 1, C = 1) {
    ;(super(null),
      (this.isDataArrayTexture = !0),
      (this.image = { data: A, width: I, height: g, depth: C }),
      (this.magFilter = iQ),
      (this.minFilter = iQ),
      (this.wrapR = vr),
      (this.generateMipmaps = !1),
      (this.flipY = !1),
      (this.unpackAlignment = 1),
      (this.layerUpdates = /* @__PURE__ */ new Set()))
  }
  addLayerUpdate(A) {
    this.layerUpdates.add(A)
  }
  clearLayerUpdates() {
    this.layerUpdates.clear()
  }
}
class rZ extends BQ {
  constructor(A = 1, I = 1, g = 1, C = {}) {
    ;(super(A, I, C),
      (this.isWebGLArrayRenderTarget = !0),
      (this.depth = g),
      (this.texture = new $N(null, A, I, g)),
      (this.texture.isRenderTargetTexture = !0))
  }
}
class Iv extends pt {
  constructor(A = null, I = 1, g = 1, C = 1) {
    ;(super(null),
      (this.isData3DTexture = !0),
      (this.image = { data: A, width: I, height: g, depth: C }),
      (this.magFilter = iQ),
      (this.minFilter = iQ),
      (this.wrapR = vr),
      (this.generateMipmaps = !1),
      (this.flipY = !1),
      (this.unpackAlignment = 1))
  }
}
class sZ extends BQ {
  constructor(A = 1, I = 1, g = 1, C = {}) {
    ;(super(A, I, C),
      (this.isWebGL3DRenderTarget = !0),
      (this.depth = g),
      (this.texture = new Iv(null, A, I, g)),
      (this.texture.isRenderTargetTexture = !0))
  }
}
class ho {
  constructor(A = 0, I = 0, g = 0, C = 1) {
    ;((this.isQuaternion = !0), (this._x = A), (this._y = I), (this._z = g), (this._w = C))
  }
  static slerpFlat(A, I, g, C, i, B, o) {
    let r = g[C + 0],
      s = g[C + 1],
      h = g[C + 2],
      S = g[C + 3]
    const d = i[B + 0],
      w = i[B + 1],
      M = i[B + 2],
      K = i[B + 3]
    if (o === 0) {
      ;((A[I + 0] = r), (A[I + 1] = s), (A[I + 2] = h), (A[I + 3] = S))
      return
    }
    if (o === 1) {
      ;((A[I + 0] = d), (A[I + 1] = w), (A[I + 2] = M), (A[I + 3] = K))
      return
    }
    if (S !== K || r !== d || s !== w || h !== M) {
      let R = 1 - o
      const F = r * d + s * w + h * M + S * K,
        L = F >= 0 ? 1 : -1,
        Y = 1 - F * F
      if (Y > Number.EPSILON) {
        const V = Math.sqrt(Y),
          j = Math.atan2(V, F * L)
        ;((R = Math.sin(R * j) / V), (o = Math.sin(o * j) / V))
      }
      const H = o * L
      if (
        ((r = r * R + d * H),
        (s = s * R + w * H),
        (h = h * R + M * H),
        (S = S * R + K * H),
        R === 1 - o)
      ) {
        const V = 1 / Math.sqrt(r * r + s * s + h * h + S * S)
        ;((r *= V), (s *= V), (h *= V), (S *= V))
      }
    }
    ;((A[I] = r), (A[I + 1] = s), (A[I + 2] = h), (A[I + 3] = S))
  }
  static multiplyQuaternionsFlat(A, I, g, C, i, B) {
    const o = g[C],
      r = g[C + 1],
      s = g[C + 2],
      h = g[C + 3],
      S = i[B],
      d = i[B + 1],
      w = i[B + 2],
      M = i[B + 3]
    return (
      (A[I] = o * M + h * S + r * w - s * d),
      (A[I + 1] = r * M + h * d + s * S - o * w),
      (A[I + 2] = s * M + h * w + o * d - r * S),
      (A[I + 3] = h * M - o * S - r * d - s * w),
      A
    )
  }
  get x() {
    return this._x
  }
  set x(A) {
    ;((this._x = A), this._onChangeCallback())
  }
  get y() {
    return this._y
  }
  set y(A) {
    ;((this._y = A), this._onChangeCallback())
  }
  get z() {
    return this._z
  }
  set z(A) {
    ;((this._z = A), this._onChangeCallback())
  }
  get w() {
    return this._w
  }
  set w(A) {
    ;((this._w = A), this._onChangeCallback())
  }
  set(A, I, g, C) {
    return (
      (this._x = A),
      (this._y = I),
      (this._z = g),
      (this._w = C),
      this._onChangeCallback(),
      this
    )
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w)
  }
  copy(A) {
    return (
      (this._x = A.x),
      (this._y = A.y),
      (this._z = A.z),
      (this._w = A.w),
      this._onChangeCallback(),
      this
    )
  }
  setFromEuler(A, I = !0) {
    const g = A._x,
      C = A._y,
      i = A._z,
      B = A._order,
      o = Math.cos,
      r = Math.sin,
      s = o(g / 2),
      h = o(C / 2),
      S = o(i / 2),
      d = r(g / 2),
      w = r(C / 2),
      M = r(i / 2)
    switch (B) {
      case "XYZ":
        ;((this._x = d * h * S + s * w * M),
          (this._y = s * w * S - d * h * M),
          (this._z = s * h * M + d * w * S),
          (this._w = s * h * S - d * w * M))
        break
      case "YXZ":
        ;((this._x = d * h * S + s * w * M),
          (this._y = s * w * S - d * h * M),
          (this._z = s * h * M - d * w * S),
          (this._w = s * h * S + d * w * M))
        break
      case "ZXY":
        ;((this._x = d * h * S - s * w * M),
          (this._y = s * w * S + d * h * M),
          (this._z = s * h * M + d * w * S),
          (this._w = s * h * S - d * w * M))
        break
      case "ZYX":
        ;((this._x = d * h * S - s * w * M),
          (this._y = s * w * S + d * h * M),
          (this._z = s * h * M - d * w * S),
          (this._w = s * h * S + d * w * M))
        break
      case "YZX":
        ;((this._x = d * h * S + s * w * M),
          (this._y = s * w * S + d * h * M),
          (this._z = s * h * M - d * w * S),
          (this._w = s * h * S - d * w * M))
        break
      case "XZY":
        ;((this._x = d * h * S - s * w * M),
          (this._y = s * w * S - d * h * M),
          (this._z = s * h * M + d * w * S),
          (this._w = s * h * S + d * w * M))
        break
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + B)
    }
    return (I === !0 && this._onChangeCallback(), this)
  }
  setFromAxisAngle(A, I) {
    const g = I / 2,
      C = Math.sin(g)
    return (
      (this._x = A.x * C),
      (this._y = A.y * C),
      (this._z = A.z * C),
      (this._w = Math.cos(g)),
      this._onChangeCallback(),
      this
    )
  }
  setFromRotationMatrix(A) {
    const I = A.elements,
      g = I[0],
      C = I[4],
      i = I[8],
      B = I[1],
      o = I[5],
      r = I[9],
      s = I[2],
      h = I[6],
      S = I[10],
      d = g + o + S
    if (d > 0) {
      const w = 0.5 / Math.sqrt(d + 1)
      ;((this._w = 0.25 / w),
        (this._x = (h - r) * w),
        (this._y = (i - s) * w),
        (this._z = (B - C) * w))
    } else if (g > o && g > S) {
      const w = 2 * Math.sqrt(1 + g - o - S)
      ;((this._w = (h - r) / w),
        (this._x = 0.25 * w),
        (this._y = (C + B) / w),
        (this._z = (i + s) / w))
    } else if (o > S) {
      const w = 2 * Math.sqrt(1 + o - g - S)
      ;((this._w = (i - s) / w),
        (this._x = (C + B) / w),
        (this._y = 0.25 * w),
        (this._z = (r + h) / w))
    } else {
      const w = 2 * Math.sqrt(1 + S - g - o)
      ;((this._w = (B - C) / w),
        (this._x = (i + s) / w),
        (this._y = (r + h) / w),
        (this._z = 0.25 * w))
    }
    return (this._onChangeCallback(), this)
  }
  setFromUnitVectors(A, I) {
    let g = A.dot(I) + 1
    return (
      g < Number.EPSILON
        ? ((g = 0),
          Math.abs(A.x) > Math.abs(A.z)
            ? ((this._x = -A.y), (this._y = A.x), (this._z = 0), (this._w = g))
            : ((this._x = 0), (this._y = -A.z), (this._z = A.y), (this._w = g)))
        : ((this._x = A.y * I.z - A.z * I.y),
          (this._y = A.z * I.x - A.x * I.z),
          (this._z = A.x * I.y - A.y * I.x),
          (this._w = g)),
      this.normalize()
    )
  }
  angleTo(A) {
    return 2 * Math.acos(Math.abs(eQ(this.dot(A), -1, 1)))
  }
  rotateTowards(A, I) {
    const g = this.angleTo(A)
    if (g === 0) return this
    const C = Math.min(1, I / g)
    return (this.slerp(A, C), this)
  }
  identity() {
    return this.set(0, 0, 0, 1)
  }
  invert() {
    return this.conjugate()
  }
  conjugate() {
    return ((this._x *= -1), (this._y *= -1), (this._z *= -1), this._onChangeCallback(), this)
  }
  dot(A) {
    return this._x * A._x + this._y * A._y + this._z * A._z + this._w * A._w
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w)
  }
  normalize() {
    let A = this.length()
    return (
      A === 0
        ? ((this._x = 0), (this._y = 0), (this._z = 0), (this._w = 1))
        : ((A = 1 / A),
          (this._x = this._x * A),
          (this._y = this._y * A),
          (this._z = this._z * A),
          (this._w = this._w * A)),
      this._onChangeCallback(),
      this
    )
  }
  multiply(A) {
    return this.multiplyQuaternions(this, A)
  }
  premultiply(A) {
    return this.multiplyQuaternions(A, this)
  }
  multiplyQuaternions(A, I) {
    const g = A._x,
      C = A._y,
      i = A._z,
      B = A._w,
      o = I._x,
      r = I._y,
      s = I._z,
      h = I._w
    return (
      (this._x = g * h + B * o + C * s - i * r),
      (this._y = C * h + B * r + i * o - g * s),
      (this._z = i * h + B * s + g * r - C * o),
      (this._w = B * h - g * o - C * r - i * s),
      this._onChangeCallback(),
      this
    )
  }
  slerp(A, I) {
    if (I === 0) return this
    if (I === 1) return this.copy(A)
    const g = this._x,
      C = this._y,
      i = this._z,
      B = this._w
    let o = B * A._w + g * A._x + C * A._y + i * A._z
    if (
      (o < 0
        ? ((this._w = -A._w), (this._x = -A._x), (this._y = -A._y), (this._z = -A._z), (o = -o))
        : this.copy(A),
      o >= 1)
    )
      return ((this._w = B), (this._x = g), (this._y = C), (this._z = i), this)
    const r = 1 - o * o
    if (r <= Number.EPSILON) {
      const w = 1 - I
      return (
        (this._w = w * B + I * this._w),
        (this._x = w * g + I * this._x),
        (this._y = w * C + I * this._y),
        (this._z = w * i + I * this._z),
        this.normalize(),
        this
      )
    }
    const s = Math.sqrt(r),
      h = Math.atan2(s, o),
      S = Math.sin((1 - I) * h) / s,
      d = Math.sin(I * h) / s
    return (
      (this._w = B * S + this._w * d),
      (this._x = g * S + this._x * d),
      (this._y = C * S + this._y * d),
      (this._z = i * S + this._z * d),
      this._onChangeCallback(),
      this
    )
  }
  slerpQuaternions(A, I, g) {
    return this.copy(A).slerp(I, g)
  }
  random() {
    const A = 2 * Math.PI * Math.random(),
      I = 2 * Math.PI * Math.random(),
      g = Math.random(),
      C = Math.sqrt(1 - g),
      i = Math.sqrt(g)
    return this.set(C * Math.sin(A), C * Math.cos(A), i * Math.sin(I), i * Math.cos(I))
  }
  equals(A) {
    return A._x === this._x && A._y === this._y && A._z === this._z && A._w === this._w
  }
  fromArray(A, I = 0) {
    return (
      (this._x = A[I]),
      (this._y = A[I + 1]),
      (this._z = A[I + 2]),
      (this._w = A[I + 3]),
      this._onChangeCallback(),
      this
    )
  }
  toArray(A = [], I = 0) {
    return ((A[I] = this._x), (A[I + 1] = this._y), (A[I + 2] = this._z), (A[I + 3] = this._w), A)
  }
  fromBufferAttribute(A, I) {
    return (
      (this._x = A.getX(I)),
      (this._y = A.getY(I)),
      (this._z = A.getZ(I)),
      (this._w = A.getW(I)),
      this._onChangeCallback(),
      this
    )
  }
  toJSON() {
    return this.toArray()
  }
  _onChange(A) {
    return ((this._onChangeCallback = A), this)
  }
  _onChangeCallback() {}
  *[Symbol.iterator]() {
    ;(yield this._x, yield this._y, yield this._z, yield this._w)
  }
}
class wA {
  constructor(A = 0, I = 0, g = 0) {
    ;((wA.prototype.isVector3 = !0), (this.x = A), (this.y = I), (this.z = g))
  }
  set(A, I, g) {
    return (g === void 0 && (g = this.z), (this.x = A), (this.y = I), (this.z = g), this)
  }
  setScalar(A) {
    return ((this.x = A), (this.y = A), (this.z = A), this)
  }
  setX(A) {
    return ((this.x = A), this)
  }
  setY(A) {
    return ((this.y = A), this)
  }
  setZ(A) {
    return ((this.z = A), this)
  }
  setComponent(A, I) {
    switch (A) {
      case 0:
        this.x = I
        break
      case 1:
        this.y = I
        break
      case 2:
        this.z = I
        break
      default:
        throw new Error("index is out of range: " + A)
    }
    return this
  }
  getComponent(A) {
    switch (A) {
      case 0:
        return this.x
      case 1:
        return this.y
      case 2:
        return this.z
      default:
        throw new Error("index is out of range: " + A)
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z)
  }
  copy(A) {
    return ((this.x = A.x), (this.y = A.y), (this.z = A.z), this)
  }
  add(A) {
    return ((this.x += A.x), (this.y += A.y), (this.z += A.z), this)
  }
  addScalar(A) {
    return ((this.x += A), (this.y += A), (this.z += A), this)
  }
  addVectors(A, I) {
    return ((this.x = A.x + I.x), (this.y = A.y + I.y), (this.z = A.z + I.z), this)
  }
  addScaledVector(A, I) {
    return ((this.x += A.x * I), (this.y += A.y * I), (this.z += A.z * I), this)
  }
  sub(A) {
    return ((this.x -= A.x), (this.y -= A.y), (this.z -= A.z), this)
  }
  subScalar(A) {
    return ((this.x -= A), (this.y -= A), (this.z -= A), this)
  }
  subVectors(A, I) {
    return ((this.x = A.x - I.x), (this.y = A.y - I.y), (this.z = A.z - I.z), this)
  }
  multiply(A) {
    return ((this.x *= A.x), (this.y *= A.y), (this.z *= A.z), this)
  }
  multiplyScalar(A) {
    return ((this.x *= A), (this.y *= A), (this.z *= A), this)
  }
  multiplyVectors(A, I) {
    return ((this.x = A.x * I.x), (this.y = A.y * I.y), (this.z = A.z * I.z), this)
  }
  applyEuler(A) {
    return this.applyQuaternion(qq.setFromEuler(A))
  }
  applyAxisAngle(A, I) {
    return this.applyQuaternion(qq.setFromAxisAngle(A, I))
  }
  applyMatrix3(A) {
    const I = this.x,
      g = this.y,
      C = this.z,
      i = A.elements
    return (
      (this.x = i[0] * I + i[3] * g + i[6] * C),
      (this.y = i[1] * I + i[4] * g + i[7] * C),
      (this.z = i[2] * I + i[5] * g + i[8] * C),
      this
    )
  }
  applyNormalMatrix(A) {
    return this.applyMatrix3(A).normalize()
  }
  applyMatrix4(A) {
    const I = this.x,
      g = this.y,
      C = this.z,
      i = A.elements,
      B = 1 / (i[3] * I + i[7] * g + i[11] * C + i[15])
    return (
      (this.x = (i[0] * I + i[4] * g + i[8] * C + i[12]) * B),
      (this.y = (i[1] * I + i[5] * g + i[9] * C + i[13]) * B),
      (this.z = (i[2] * I + i[6] * g + i[10] * C + i[14]) * B),
      this
    )
  }
  applyQuaternion(A) {
    const I = this.x,
      g = this.y,
      C = this.z,
      i = A.x,
      B = A.y,
      o = A.z,
      r = A.w,
      s = 2 * (B * C - o * g),
      h = 2 * (o * I - i * C),
      S = 2 * (i * g - B * I)
    return (
      (this.x = I + r * s + B * S - o * h),
      (this.y = g + r * h + o * s - i * S),
      (this.z = C + r * S + i * h - B * s),
      this
    )
  }
  project(A) {
    return this.applyMatrix4(A.matrixWorldInverse).applyMatrix4(A.projectionMatrix)
  }
  unproject(A) {
    return this.applyMatrix4(A.projectionMatrixInverse).applyMatrix4(A.matrixWorld)
  }
  transformDirection(A) {
    const I = this.x,
      g = this.y,
      C = this.z,
      i = A.elements
    return (
      (this.x = i[0] * I + i[4] * g + i[8] * C),
      (this.y = i[1] * I + i[5] * g + i[9] * C),
      (this.z = i[2] * I + i[6] * g + i[10] * C),
      this.normalize()
    )
  }
  divide(A) {
    return ((this.x /= A.x), (this.y /= A.y), (this.z /= A.z), this)
  }
  divideScalar(A) {
    return this.multiplyScalar(1 / A)
  }
  min(A) {
    return (
      (this.x = Math.min(this.x, A.x)),
      (this.y = Math.min(this.y, A.y)),
      (this.z = Math.min(this.z, A.z)),
      this
    )
  }
  max(A) {
    return (
      (this.x = Math.max(this.x, A.x)),
      (this.y = Math.max(this.y, A.y)),
      (this.z = Math.max(this.z, A.z)),
      this
    )
  }
  clamp(A, I) {
    return (
      (this.x = Math.max(A.x, Math.min(I.x, this.x))),
      (this.y = Math.max(A.y, Math.min(I.y, this.y))),
      (this.z = Math.max(A.z, Math.min(I.z, this.z))),
      this
    )
  }
  clampScalar(A, I) {
    return (
      (this.x = Math.max(A, Math.min(I, this.x))),
      (this.y = Math.max(A, Math.min(I, this.y))),
      (this.z = Math.max(A, Math.min(I, this.z))),
      this
    )
  }
  clampLength(A, I) {
    const g = this.length()
    return this.divideScalar(g || 1).multiplyScalar(Math.max(A, Math.min(I, g)))
  }
  floor() {
    return (
      (this.x = Math.floor(this.x)),
      (this.y = Math.floor(this.y)),
      (this.z = Math.floor(this.z)),
      this
    )
  }
  ceil() {
    return (
      (this.x = Math.ceil(this.x)),
      (this.y = Math.ceil(this.y)),
      (this.z = Math.ceil(this.z)),
      this
    )
  }
  round() {
    return (
      (this.x = Math.round(this.x)),
      (this.y = Math.round(this.y)),
      (this.z = Math.round(this.z)),
      this
    )
  }
  roundToZero() {
    return (
      (this.x = Math.trunc(this.x)),
      (this.y = Math.trunc(this.y)),
      (this.z = Math.trunc(this.z)),
      this
    )
  }
  negate() {
    return ((this.x = -this.x), (this.y = -this.y), (this.z = -this.z), this)
  }
  dot(A) {
    return this.x * A.x + this.y * A.y + this.z * A.z
  }
  // TODO lengthSquared?
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z)
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z)
  }
  normalize() {
    return this.divideScalar(this.length() || 1)
  }
  setLength(A) {
    return this.normalize().multiplyScalar(A)
  }
  lerp(A, I) {
    return (
      (this.x += (A.x - this.x) * I),
      (this.y += (A.y - this.y) * I),
      (this.z += (A.z - this.z) * I),
      this
    )
  }
  lerpVectors(A, I, g) {
    return (
      (this.x = A.x + (I.x - A.x) * g),
      (this.y = A.y + (I.y - A.y) * g),
      (this.z = A.z + (I.z - A.z) * g),
      this
    )
  }
  cross(A) {
    return this.crossVectors(this, A)
  }
  crossVectors(A, I) {
    const g = A.x,
      C = A.y,
      i = A.z,
      B = I.x,
      o = I.y,
      r = I.z
    return ((this.x = C * r - i * o), (this.y = i * B - g * r), (this.z = g * o - C * B), this)
  }
  projectOnVector(A) {
    const I = A.lengthSq()
    if (I === 0) return this.set(0, 0, 0)
    const g = A.dot(this) / I
    return this.copy(A).multiplyScalar(g)
  }
  projectOnPlane(A) {
    return (jJ.copy(this).projectOnVector(A), this.sub(jJ))
  }
  reflect(A) {
    return this.sub(jJ.copy(A).multiplyScalar(2 * this.dot(A)))
  }
  angleTo(A) {
    const I = Math.sqrt(this.lengthSq() * A.lengthSq())
    if (I === 0) return Math.PI / 2
    const g = this.dot(A) / I
    return Math.acos(eQ(g, -1, 1))
  }
  distanceTo(A) {
    return Math.sqrt(this.distanceToSquared(A))
  }
  distanceToSquared(A) {
    const I = this.x - A.x,
      g = this.y - A.y,
      C = this.z - A.z
    return I * I + g * g + C * C
  }
  manhattanDistanceTo(A) {
    return Math.abs(this.x - A.x) + Math.abs(this.y - A.y) + Math.abs(this.z - A.z)
  }
  setFromSpherical(A) {
    return this.setFromSphericalCoords(A.radius, A.phi, A.theta)
  }
  setFromSphericalCoords(A, I, g) {
    const C = Math.sin(I) * A
    return (
      (this.x = C * Math.sin(g)),
      (this.y = Math.cos(I) * A),
      (this.z = C * Math.cos(g)),
      this
    )
  }
  setFromCylindrical(A) {
    return this.setFromCylindricalCoords(A.radius, A.theta, A.y)
  }
  setFromCylindricalCoords(A, I, g) {
    return ((this.x = A * Math.sin(I)), (this.y = g), (this.z = A * Math.cos(I)), this)
  }
  setFromMatrixPosition(A) {
    const I = A.elements
    return ((this.x = I[12]), (this.y = I[13]), (this.z = I[14]), this)
  }
  setFromMatrixScale(A) {
    const I = this.setFromMatrixColumn(A, 0).length(),
      g = this.setFromMatrixColumn(A, 1).length(),
      C = this.setFromMatrixColumn(A, 2).length()
    return ((this.x = I), (this.y = g), (this.z = C), this)
  }
  setFromMatrixColumn(A, I) {
    return this.fromArray(A.elements, I * 4)
  }
  setFromMatrix3Column(A, I) {
    return this.fromArray(A.elements, I * 3)
  }
  setFromEuler(A) {
    return ((this.x = A._x), (this.y = A._y), (this.z = A._z), this)
  }
  setFromColor(A) {
    return ((this.x = A.r), (this.y = A.g), (this.z = A.b), this)
  }
  equals(A) {
    return A.x === this.x && A.y === this.y && A.z === this.z
  }
  fromArray(A, I = 0) {
    return ((this.x = A[I]), (this.y = A[I + 1]), (this.z = A[I + 2]), this)
  }
  toArray(A = [], I = 0) {
    return ((A[I] = this.x), (A[I + 1] = this.y), (A[I + 2] = this.z), A)
  }
  fromBufferAttribute(A, I) {
    return ((this.x = A.getX(I)), (this.y = A.getY(I)), (this.z = A.getZ(I)), this)
  }
  random() {
    return ((this.x = Math.random()), (this.y = Math.random()), (this.z = Math.random()), this)
  }
  randomDirection() {
    const A = Math.random() * Math.PI * 2,
      I = Math.random() * 2 - 1,
      g = Math.sqrt(1 - I * I)
    return ((this.x = g * Math.cos(A)), (this.y = I), (this.z = g * Math.sin(A)), this)
  }
  *[Symbol.iterator]() {
    ;(yield this.x, yield this.y, yield this.z)
  }
}
const jJ = /* @__PURE__ */ new wA(),
  qq = /* @__PURE__ */ new ho()
class Vo {
  constructor(A = new wA(1 / 0, 1 / 0, 1 / 0), I = new wA(-1 / 0, -1 / 0, -1 / 0)) {
    ;((this.isBox3 = !0), (this.min = A), (this.max = I))
  }
  set(A, I) {
    return (this.min.copy(A), this.max.copy(I), this)
  }
  setFromArray(A) {
    this.makeEmpty()
    for (let I = 0, g = A.length; I < g; I += 3) this.expandByPoint(fl.fromArray(A, I))
    return this
  }
  setFromBufferAttribute(A) {
    this.makeEmpty()
    for (let I = 0, g = A.count; I < g; I++) this.expandByPoint(fl.fromBufferAttribute(A, I))
    return this
  }
  setFromPoints(A) {
    this.makeEmpty()
    for (let I = 0, g = A.length; I < g; I++) this.expandByPoint(A[I])
    return this
  }
  setFromCenterAndSize(A, I) {
    const g = fl.copy(I).multiplyScalar(0.5)
    return (this.min.copy(A).sub(g), this.max.copy(A).add(g), this)
  }
  setFromObject(A, I = !1) {
    return (this.makeEmpty(), this.expandByObject(A, I))
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(A) {
    return (this.min.copy(A.min), this.max.copy(A.max), this)
  }
  makeEmpty() {
    return (
      (this.min.x = this.min.y = this.min.z = 1 / 0),
      (this.max.x = this.max.y = this.max.z = -1 / 0),
      this
    )
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z
  }
  getCenter(A) {
    return this.isEmpty() ? A.set(0, 0, 0) : A.addVectors(this.min, this.max).multiplyScalar(0.5)
  }
  getSize(A) {
    return this.isEmpty() ? A.set(0, 0, 0) : A.subVectors(this.max, this.min)
  }
  expandByPoint(A) {
    return (this.min.min(A), this.max.max(A), this)
  }
  expandByVector(A) {
    return (this.min.sub(A), this.max.add(A), this)
  }
  expandByScalar(A) {
    return (this.min.addScalar(-A), this.max.addScalar(A), this)
  }
  expandByObject(A, I = !1) {
    A.updateWorldMatrix(!1, !1)
    const g = A.geometry
    if (g !== void 0) {
      const i = g.getAttribute("position")
      if (I === !0 && i !== void 0 && A.isInstancedMesh !== !0)
        for (let B = 0, o = i.count; B < o; B++)
          (A.isMesh === !0 ? A.getVertexPosition(B, fl) : fl.fromBufferAttribute(i, B),
            fl.applyMatrix4(A.matrixWorld),
            this.expandByPoint(fl))
      else
        (A.boundingBox !== void 0
          ? (A.boundingBox === null && A.computeBoundingBox(), JM.copy(A.boundingBox))
          : (g.boundingBox === null && g.computeBoundingBox(), JM.copy(g.boundingBox)),
          JM.applyMatrix4(A.matrixWorld),
          this.union(JM))
    }
    const C = A.children
    for (let i = 0, B = C.length; i < B; i++) this.expandByObject(C[i], I)
    return this
  }
  containsPoint(A) {
    return (
      A.x >= this.min.x &&
      A.x <= this.max.x &&
      A.y >= this.min.y &&
      A.y <= this.max.y &&
      A.z >= this.min.z &&
      A.z <= this.max.z
    )
  }
  containsBox(A) {
    return (
      this.min.x <= A.min.x &&
      A.max.x <= this.max.x &&
      this.min.y <= A.min.y &&
      A.max.y <= this.max.y &&
      this.min.z <= A.min.z &&
      A.max.z <= this.max.z
    )
  }
  getParameter(A, I) {
    return I.set(
      (A.x - this.min.x) / (this.max.x - this.min.x),
      (A.y - this.min.y) / (this.max.y - this.min.y),
      (A.z - this.min.z) / (this.max.z - this.min.z),
    )
  }
  intersectsBox(A) {
    return (
      A.max.x >= this.min.x &&
      A.min.x <= this.max.x &&
      A.max.y >= this.min.y &&
      A.min.y <= this.max.y &&
      A.max.z >= this.min.z &&
      A.min.z <= this.max.z
    )
  }
  intersectsSphere(A) {
    return (this.clampPoint(A.center, fl), fl.distanceToSquared(A.center) <= A.radius * A.radius)
  }
  intersectsPlane(A) {
    let I, g
    return (
      A.normal.x > 0
        ? ((I = A.normal.x * this.min.x), (g = A.normal.x * this.max.x))
        : ((I = A.normal.x * this.max.x), (g = A.normal.x * this.min.x)),
      A.normal.y > 0
        ? ((I += A.normal.y * this.min.y), (g += A.normal.y * this.max.y))
        : ((I += A.normal.y * this.max.y), (g += A.normal.y * this.min.y)),
      A.normal.z > 0
        ? ((I += A.normal.z * this.min.z), (g += A.normal.z * this.max.z))
        : ((I += A.normal.z * this.max.z), (g += A.normal.z * this.min.z)),
      I <= -A.constant && g >= -A.constant
    )
  }
  intersectsTriangle(A) {
    if (this.isEmpty()) return !1
    ;(this.getCenter(G0),
      KM.subVectors(this.max, G0),
      Ny.subVectors(A.a, G0),
      Fy.subVectors(A.b, G0),
      Ry.subVectors(A.c, G0),
      oD.subVectors(Fy, Ny),
      nD.subVectors(Ry, Fy),
      ef.subVectors(Ny, Ry))
    let I = [
      0,
      -oD.z,
      oD.y,
      0,
      -nD.z,
      nD.y,
      0,
      -ef.z,
      ef.y,
      oD.z,
      0,
      -oD.x,
      nD.z,
      0,
      -nD.x,
      ef.z,
      0,
      -ef.x,
      -oD.y,
      oD.x,
      0,
      -nD.y,
      nD.x,
      0,
      -ef.y,
      ef.x,
      0,
    ]
    return !zJ(I, Ny, Fy, Ry, KM) || ((I = [1, 0, 0, 0, 1, 0, 0, 0, 1]), !zJ(I, Ny, Fy, Ry, KM))
      ? !1
      : (mM.crossVectors(oD, nD), (I = [mM.x, mM.y, mM.z]), zJ(I, Ny, Fy, Ry, KM))
  }
  clampPoint(A, I) {
    return I.copy(A).clamp(this.min, this.max)
  }
  distanceToPoint(A) {
    return this.clampPoint(A, fl).distanceTo(A)
  }
  getBoundingSphere(A) {
    return (
      this.isEmpty()
        ? A.makeEmpty()
        : (this.getCenter(A.center), (A.radius = this.getSize(fl).length() * 0.5)),
      A
    )
  }
  intersect(A) {
    return (this.min.max(A.min), this.max.min(A.max), this.isEmpty() && this.makeEmpty(), this)
  }
  union(A) {
    return (this.min.min(A.min), this.max.max(A.max), this)
  }
  applyMatrix4(A) {
    return this.isEmpty()
      ? this
      : (Ph[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(A),
        Ph[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(A),
        Ph[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(A),
        Ph[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(A),
        Ph[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(A),
        Ph[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(A),
        Ph[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(A),
        Ph[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(A),
        this.setFromPoints(Ph),
        this)
  }
  translate(A) {
    return (this.min.add(A), this.max.add(A), this)
  }
  equals(A) {
    return A.min.equals(this.min) && A.max.equals(this.max)
  }
}
const Ph = [
    /* @__PURE__ */ new wA(),
    /* @__PURE__ */ new wA(),
    /* @__PURE__ */ new wA(),
    /* @__PURE__ */ new wA(),
    /* @__PURE__ */ new wA(),
    /* @__PURE__ */ new wA(),
    /* @__PURE__ */ new wA(),
    /* @__PURE__ */ new wA(),
  ],
  fl = /* @__PURE__ */ new wA(),
  JM = /* @__PURE__ */ new Vo(),
  Ny = /* @__PURE__ */ new wA(),
  Fy = /* @__PURE__ */ new wA(),
  Ry = /* @__PURE__ */ new wA(),
  oD = /* @__PURE__ */ new wA(),
  nD = /* @__PURE__ */ new wA(),
  ef = /* @__PURE__ */ new wA(),
  G0 = /* @__PURE__ */ new wA(),
  KM = /* @__PURE__ */ new wA(),
  mM = /* @__PURE__ */ new wA(),
  tf = /* @__PURE__ */ new wA()
function zJ(e, A, I, g, C) {
  for (let i = 0, B = e.length - 3; i <= B; i += 3) {
    tf.fromArray(e, i)
    const o = C.x * Math.abs(tf.x) + C.y * Math.abs(tf.y) + C.z * Math.abs(tf.z),
      r = A.dot(tf),
      s = I.dot(tf),
      h = g.dot(tf)
    if (Math.max(-Math.max(r, s, h), Math.min(r, s, h)) > o) return !1
  }
  return !0
}
const lZ = /* @__PURE__ */ new Vo(),
  k0 = /* @__PURE__ */ new wA(),
  XJ = /* @__PURE__ */ new wA()
class jo {
  constructor(A = new wA(), I = -1) {
    ;((this.isSphere = !0), (this.center = A), (this.radius = I))
  }
  set(A, I) {
    return (this.center.copy(A), (this.radius = I), this)
  }
  setFromPoints(A, I) {
    const g = this.center
    I !== void 0 ? g.copy(I) : lZ.setFromPoints(A).getCenter(g)
    let C = 0
    for (let i = 0, B = A.length; i < B; i++) C = Math.max(C, g.distanceToSquared(A[i]))
    return ((this.radius = Math.sqrt(C)), this)
  }
  copy(A) {
    return (this.center.copy(A.center), (this.radius = A.radius), this)
  }
  isEmpty() {
    return this.radius < 0
  }
  makeEmpty() {
    return (this.center.set(0, 0, 0), (this.radius = -1), this)
  }
  containsPoint(A) {
    return A.distanceToSquared(this.center) <= this.radius * this.radius
  }
  distanceToPoint(A) {
    return A.distanceTo(this.center) - this.radius
  }
  intersectsSphere(A) {
    const I = this.radius + A.radius
    return A.center.distanceToSquared(this.center) <= I * I
  }
  intersectsBox(A) {
    return A.intersectsSphere(this)
  }
  intersectsPlane(A) {
    return Math.abs(A.distanceToPoint(this.center)) <= this.radius
  }
  clampPoint(A, I) {
    const g = this.center.distanceToSquared(A)
    return (
      I.copy(A),
      g > this.radius * this.radius &&
        (I.sub(this.center).normalize(), I.multiplyScalar(this.radius).add(this.center)),
      I
    )
  }
  getBoundingBox(A) {
    return this.isEmpty()
      ? (A.makeEmpty(), A)
      : (A.set(this.center, this.center), A.expandByScalar(this.radius), A)
  }
  applyMatrix4(A) {
    return (this.center.applyMatrix4(A), (this.radius = this.radius * A.getMaxScaleOnAxis()), this)
  }
  translate(A) {
    return (this.center.add(A), this)
  }
  expandByPoint(A) {
    if (this.isEmpty()) return (this.center.copy(A), (this.radius = 0), this)
    k0.subVectors(A, this.center)
    const I = k0.lengthSq()
    if (I > this.radius * this.radius) {
      const g = Math.sqrt(I),
        C = (g - this.radius) * 0.5
      ;(this.center.addScaledVector(k0, C / g), (this.radius += C))
    }
    return this
  }
  union(A) {
    return A.isEmpty()
      ? this
      : this.isEmpty()
        ? (this.copy(A), this)
        : (this.center.equals(A.center) === !0
            ? (this.radius = Math.max(this.radius, A.radius))
            : (XJ.subVectors(A.center, this.center).setLength(A.radius),
              this.expandByPoint(k0.copy(A.center).add(XJ)),
              this.expandByPoint(k0.copy(A.center).sub(XJ))),
          this)
  }
  equals(A) {
    return A.center.equals(this.center) && A.radius === this.radius
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
const Wh = /* @__PURE__ */ new wA(),
  $J = /* @__PURE__ */ new wA(),
  vM = /* @__PURE__ */ new wA(),
  ED = /* @__PURE__ */ new wA(),
  AK = /* @__PURE__ */ new wA(),
  LM = /* @__PURE__ */ new wA(),
  IK = /* @__PURE__ */ new wA()
class fp {
  constructor(A = new wA(), I = new wA(0, 0, -1)) {
    ;((this.origin = A), (this.direction = I))
  }
  set(A, I) {
    return (this.origin.copy(A), this.direction.copy(I), this)
  }
  copy(A) {
    return (this.origin.copy(A.origin), this.direction.copy(A.direction), this)
  }
  at(A, I) {
    return I.copy(this.origin).addScaledVector(this.direction, A)
  }
  lookAt(A) {
    return (this.direction.copy(A).sub(this.origin).normalize(), this)
  }
  recast(A) {
    return (this.origin.copy(this.at(A, Wh)), this)
  }
  closestPointToPoint(A, I) {
    I.subVectors(A, this.origin)
    const g = I.dot(this.direction)
    return g < 0 ? I.copy(this.origin) : I.copy(this.origin).addScaledVector(this.direction, g)
  }
  distanceToPoint(A) {
    return Math.sqrt(this.distanceSqToPoint(A))
  }
  distanceSqToPoint(A) {
    const I = Wh.subVectors(A, this.origin).dot(this.direction)
    return I < 0
      ? this.origin.distanceToSquared(A)
      : (Wh.copy(this.origin).addScaledVector(this.direction, I), Wh.distanceToSquared(A))
  }
  distanceSqToSegment(A, I, g, C) {
    ;($J.copy(A).add(I).multiplyScalar(0.5),
      vM.copy(I).sub(A).normalize(),
      ED.copy(this.origin).sub($J))
    const i = A.distanceTo(I) * 0.5,
      B = -this.direction.dot(vM),
      o = ED.dot(this.direction),
      r = -ED.dot(vM),
      s = ED.lengthSq(),
      h = Math.abs(1 - B * B)
    let S, d, w, M
    if (h > 0)
      if (((S = B * r - o), (d = B * o - r), (M = i * h), S >= 0))
        if (d >= -M)
          if (d <= M) {
            const K = 1 / h
            ;((S *= K), (d *= K), (w = S * (S + B * d + 2 * o) + d * (B * S + d + 2 * r) + s))
          } else ((d = i), (S = Math.max(0, -(B * d + o))), (w = -S * S + d * (d + 2 * r) + s))
        else ((d = -i), (S = Math.max(0, -(B * d + o))), (w = -S * S + d * (d + 2 * r) + s))
      else
        d <= -M
          ? ((S = Math.max(0, -(-B * i + o))),
            (d = S > 0 ? -i : Math.min(Math.max(-i, -r), i)),
            (w = -S * S + d * (d + 2 * r) + s))
          : d <= M
            ? ((S = 0), (d = Math.min(Math.max(-i, -r), i)), (w = d * (d + 2 * r) + s))
            : ((S = Math.max(0, -(B * i + o))),
              (d = S > 0 ? i : Math.min(Math.max(-i, -r), i)),
              (w = -S * S + d * (d + 2 * r) + s))
    else ((d = B > 0 ? -i : i), (S = Math.max(0, -(B * d + o))), (w = -S * S + d * (d + 2 * r) + s))
    return (
      g && g.copy(this.origin).addScaledVector(this.direction, S),
      C && C.copy($J).addScaledVector(vM, d),
      w
    )
  }
  intersectSphere(A, I) {
    Wh.subVectors(A.center, this.origin)
    const g = Wh.dot(this.direction),
      C = Wh.dot(Wh) - g * g,
      i = A.radius * A.radius
    if (C > i) return null
    const B = Math.sqrt(i - C),
      o = g - B,
      r = g + B
    return r < 0 ? null : o < 0 ? this.at(r, I) : this.at(o, I)
  }
  intersectsSphere(A) {
    return this.distanceSqToPoint(A.center) <= A.radius * A.radius
  }
  distanceToPlane(A) {
    const I = A.normal.dot(this.direction)
    if (I === 0) return A.distanceToPoint(this.origin) === 0 ? 0 : null
    const g = -(this.origin.dot(A.normal) + A.constant) / I
    return g >= 0 ? g : null
  }
  intersectPlane(A, I) {
    const g = this.distanceToPlane(A)
    return g === null ? null : this.at(g, I)
  }
  intersectsPlane(A) {
    const I = A.distanceToPoint(this.origin)
    return I === 0 || A.normal.dot(this.direction) * I < 0
  }
  intersectBox(A, I) {
    let g, C, i, B, o, r
    const s = 1 / this.direction.x,
      h = 1 / this.direction.y,
      S = 1 / this.direction.z,
      d = this.origin
    return (
      s >= 0
        ? ((g = (A.min.x - d.x) * s), (C = (A.max.x - d.x) * s))
        : ((g = (A.max.x - d.x) * s), (C = (A.min.x - d.x) * s)),
      h >= 0
        ? ((i = (A.min.y - d.y) * h), (B = (A.max.y - d.y) * h))
        : ((i = (A.max.y - d.y) * h), (B = (A.min.y - d.y) * h)),
      g > B ||
      i > C ||
      ((i > g || isNaN(g)) && (g = i),
      (B < C || isNaN(C)) && (C = B),
      S >= 0
        ? ((o = (A.min.z - d.z) * S), (r = (A.max.z - d.z) * S))
        : ((o = (A.max.z - d.z) * S), (r = (A.min.z - d.z) * S)),
      g > r || o > C) ||
      ((o > g || g !== g) && (g = o), (r < C || C !== C) && (C = r), C < 0)
        ? null
        : this.at(g >= 0 ? g : C, I)
    )
  }
  intersectsBox(A) {
    return this.intersectBox(A, Wh) !== null
  }
  intersectTriangle(A, I, g, C, i) {
    ;(AK.subVectors(I, A), LM.subVectors(g, A), IK.crossVectors(AK, LM))
    let B = this.direction.dot(IK),
      o
    if (B > 0) {
      if (C) return null
      o = 1
    } else if (B < 0) ((o = -1), (B = -B))
    else return null
    ED.subVectors(this.origin, A)
    const r = o * this.direction.dot(LM.crossVectors(ED, LM))
    if (r < 0) return null
    const s = o * this.direction.dot(AK.cross(ED))
    if (s < 0 || r + s > B) return null
    const h = -o * ED.dot(IK)
    return h < 0 ? null : this.at(h / B, i)
  }
  applyMatrix4(A) {
    return (this.origin.applyMatrix4(A), this.direction.transformDirection(A), this)
  }
  equals(A) {
    return A.origin.equals(this.origin) && A.direction.equals(this.direction)
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
class RC {
  constructor(A, I, g, C, i, B, o, r, s, h, S, d, w, M, K, R) {
    ;((RC.prototype.isMatrix4 = !0),
      (this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
      A !== void 0 && this.set(A, I, g, C, i, B, o, r, s, h, S, d, w, M, K, R))
  }
  set(A, I, g, C, i, B, o, r, s, h, S, d, w, M, K, R) {
    const F = this.elements
    return (
      (F[0] = A),
      (F[4] = I),
      (F[8] = g),
      (F[12] = C),
      (F[1] = i),
      (F[5] = B),
      (F[9] = o),
      (F[13] = r),
      (F[2] = s),
      (F[6] = h),
      (F[10] = S),
      (F[14] = d),
      (F[3] = w),
      (F[7] = M),
      (F[11] = K),
      (F[15] = R),
      this
    )
  }
  identity() {
    return (this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this)
  }
  clone() {
    return new RC().fromArray(this.elements)
  }
  copy(A) {
    const I = this.elements,
      g = A.elements
    return (
      (I[0] = g[0]),
      (I[1] = g[1]),
      (I[2] = g[2]),
      (I[3] = g[3]),
      (I[4] = g[4]),
      (I[5] = g[5]),
      (I[6] = g[6]),
      (I[7] = g[7]),
      (I[8] = g[8]),
      (I[9] = g[9]),
      (I[10] = g[10]),
      (I[11] = g[11]),
      (I[12] = g[12]),
      (I[13] = g[13]),
      (I[14] = g[14]),
      (I[15] = g[15]),
      this
    )
  }
  copyPosition(A) {
    const I = this.elements,
      g = A.elements
    return ((I[12] = g[12]), (I[13] = g[13]), (I[14] = g[14]), this)
  }
  setFromMatrix3(A) {
    const I = A.elements
    return (
      this.set(I[0], I[3], I[6], 0, I[1], I[4], I[7], 0, I[2], I[5], I[8], 0, 0, 0, 0, 1),
      this
    )
  }
  extractBasis(A, I, g) {
    return (
      A.setFromMatrixColumn(this, 0),
      I.setFromMatrixColumn(this, 1),
      g.setFromMatrixColumn(this, 2),
      this
    )
  }
  makeBasis(A, I, g) {
    return (this.set(A.x, I.x, g.x, 0, A.y, I.y, g.y, 0, A.z, I.z, g.z, 0, 0, 0, 0, 1), this)
  }
  extractRotation(A) {
    const I = this.elements,
      g = A.elements,
      C = 1 / Jy.setFromMatrixColumn(A, 0).length(),
      i = 1 / Jy.setFromMatrixColumn(A, 1).length(),
      B = 1 / Jy.setFromMatrixColumn(A, 2).length()
    return (
      (I[0] = g[0] * C),
      (I[1] = g[1] * C),
      (I[2] = g[2] * C),
      (I[3] = 0),
      (I[4] = g[4] * i),
      (I[5] = g[5] * i),
      (I[6] = g[6] * i),
      (I[7] = 0),
      (I[8] = g[8] * B),
      (I[9] = g[9] * B),
      (I[10] = g[10] * B),
      (I[11] = 0),
      (I[12] = 0),
      (I[13] = 0),
      (I[14] = 0),
      (I[15] = 1),
      this
    )
  }
  makeRotationFromEuler(A) {
    const I = this.elements,
      g = A.x,
      C = A.y,
      i = A.z,
      B = Math.cos(g),
      o = Math.sin(g),
      r = Math.cos(C),
      s = Math.sin(C),
      h = Math.cos(i),
      S = Math.sin(i)
    if (A.order === "XYZ") {
      const d = B * h,
        w = B * S,
        M = o * h,
        K = o * S
      ;((I[0] = r * h),
        (I[4] = -r * S),
        (I[8] = s),
        (I[1] = w + M * s),
        (I[5] = d - K * s),
        (I[9] = -o * r),
        (I[2] = K - d * s),
        (I[6] = M + w * s),
        (I[10] = B * r))
    } else if (A.order === "YXZ") {
      const d = r * h,
        w = r * S,
        M = s * h,
        K = s * S
      ;((I[0] = d + K * o),
        (I[4] = M * o - w),
        (I[8] = B * s),
        (I[1] = B * S),
        (I[5] = B * h),
        (I[9] = -o),
        (I[2] = w * o - M),
        (I[6] = K + d * o),
        (I[10] = B * r))
    } else if (A.order === "ZXY") {
      const d = r * h,
        w = r * S,
        M = s * h,
        K = s * S
      ;((I[0] = d - K * o),
        (I[4] = -B * S),
        (I[8] = M + w * o),
        (I[1] = w + M * o),
        (I[5] = B * h),
        (I[9] = K - d * o),
        (I[2] = -B * s),
        (I[6] = o),
        (I[10] = B * r))
    } else if (A.order === "ZYX") {
      const d = B * h,
        w = B * S,
        M = o * h,
        K = o * S
      ;((I[0] = r * h),
        (I[4] = M * s - w),
        (I[8] = d * s + K),
        (I[1] = r * S),
        (I[5] = K * s + d),
        (I[9] = w * s - M),
        (I[2] = -s),
        (I[6] = o * r),
        (I[10] = B * r))
    } else if (A.order === "YZX") {
      const d = B * r,
        w = B * s,
        M = o * r,
        K = o * s
      ;((I[0] = r * h),
        (I[4] = K - d * S),
        (I[8] = M * S + w),
        (I[1] = S),
        (I[5] = B * h),
        (I[9] = -o * h),
        (I[2] = -s * h),
        (I[6] = w * S + M),
        (I[10] = d - K * S))
    } else if (A.order === "XZY") {
      const d = B * r,
        w = B * s,
        M = o * r,
        K = o * s
      ;((I[0] = r * h),
        (I[4] = -S),
        (I[8] = s * h),
        (I[1] = d * S + K),
        (I[5] = B * h),
        (I[9] = w * S - M),
        (I[2] = M * S - w),
        (I[6] = o * h),
        (I[10] = K * S + d))
    }
    return (
      (I[3] = 0),
      (I[7] = 0),
      (I[11] = 0),
      (I[12] = 0),
      (I[13] = 0),
      (I[14] = 0),
      (I[15] = 1),
      this
    )
  }
  makeRotationFromQuaternion(A) {
    return this.compose(cZ, A, hZ)
  }
  lookAt(A, I, g) {
    const C = this.elements
    return (
      Rr.subVectors(A, I),
      Rr.lengthSq() === 0 && (Rr.z = 1),
      Rr.normalize(),
      aD.crossVectors(g, Rr),
      aD.lengthSq() === 0 &&
        (Math.abs(g.z) === 1 ? (Rr.x += 1e-4) : (Rr.z += 1e-4),
        Rr.normalize(),
        aD.crossVectors(g, Rr)),
      aD.normalize(),
      YM.crossVectors(Rr, aD),
      (C[0] = aD.x),
      (C[4] = YM.x),
      (C[8] = Rr.x),
      (C[1] = aD.y),
      (C[5] = YM.y),
      (C[9] = Rr.y),
      (C[2] = aD.z),
      (C[6] = YM.z),
      (C[10] = Rr.z),
      this
    )
  }
  multiply(A) {
    return this.multiplyMatrices(this, A)
  }
  premultiply(A) {
    return this.multiplyMatrices(A, this)
  }
  multiplyMatrices(A, I) {
    const g = A.elements,
      C = I.elements,
      i = this.elements,
      B = g[0],
      o = g[4],
      r = g[8],
      s = g[12],
      h = g[1],
      S = g[5],
      d = g[9],
      w = g[13],
      M = g[2],
      K = g[6],
      R = g[10],
      F = g[14],
      L = g[3],
      Y = g[7],
      H = g[11],
      V = g[15],
      j = C[0],
      P = C[4],
      AA = C[8],
      X = C[12],
      _ = C[1],
      eA = C[5],
      CA = C[9],
      aA = C[13],
      lA = C[2],
      JA = C[6],
      yA = C[10],
      LA = C[14],
      nA = C[3],
      fA = C[7],
      sA = C[11],
      $ = C[15]
    return (
      (i[0] = B * j + o * _ + r * lA + s * nA),
      (i[4] = B * P + o * eA + r * JA + s * fA),
      (i[8] = B * AA + o * CA + r * yA + s * sA),
      (i[12] = B * X + o * aA + r * LA + s * $),
      (i[1] = h * j + S * _ + d * lA + w * nA),
      (i[5] = h * P + S * eA + d * JA + w * fA),
      (i[9] = h * AA + S * CA + d * yA + w * sA),
      (i[13] = h * X + S * aA + d * LA + w * $),
      (i[2] = M * j + K * _ + R * lA + F * nA),
      (i[6] = M * P + K * eA + R * JA + F * fA),
      (i[10] = M * AA + K * CA + R * yA + F * sA),
      (i[14] = M * X + K * aA + R * LA + F * $),
      (i[3] = L * j + Y * _ + H * lA + V * nA),
      (i[7] = L * P + Y * eA + H * JA + V * fA),
      (i[11] = L * AA + Y * CA + H * yA + V * sA),
      (i[15] = L * X + Y * aA + H * LA + V * $),
      this
    )
  }
  multiplyScalar(A) {
    const I = this.elements
    return (
      (I[0] *= A),
      (I[4] *= A),
      (I[8] *= A),
      (I[12] *= A),
      (I[1] *= A),
      (I[5] *= A),
      (I[9] *= A),
      (I[13] *= A),
      (I[2] *= A),
      (I[6] *= A),
      (I[10] *= A),
      (I[14] *= A),
      (I[3] *= A),
      (I[7] *= A),
      (I[11] *= A),
      (I[15] *= A),
      this
    )
  }
  determinant() {
    const A = this.elements,
      I = A[0],
      g = A[4],
      C = A[8],
      i = A[12],
      B = A[1],
      o = A[5],
      r = A[9],
      s = A[13],
      h = A[2],
      S = A[6],
      d = A[10],
      w = A[14],
      M = A[3],
      K = A[7],
      R = A[11],
      F = A[15]
    return (
      M * (+i * r * S - C * s * S - i * o * d + g * s * d + C * o * w - g * r * w) +
      K * (+I * r * w - I * s * d + i * B * d - C * B * w + C * s * h - i * r * h) +
      R * (+I * s * S - I * o * w - i * B * S + g * B * w + i * o * h - g * s * h) +
      F * (-C * o * h - I * r * S + I * o * d + C * B * S - g * B * d + g * r * h)
    )
  }
  transpose() {
    const A = this.elements
    let I
    return (
      (I = A[1]),
      (A[1] = A[4]),
      (A[4] = I),
      (I = A[2]),
      (A[2] = A[8]),
      (A[8] = I),
      (I = A[6]),
      (A[6] = A[9]),
      (A[9] = I),
      (I = A[3]),
      (A[3] = A[12]),
      (A[12] = I),
      (I = A[7]),
      (A[7] = A[13]),
      (A[13] = I),
      (I = A[11]),
      (A[11] = A[14]),
      (A[14] = I),
      this
    )
  }
  setPosition(A, I, g) {
    const C = this.elements
    return (
      A.isVector3
        ? ((C[12] = A.x), (C[13] = A.y), (C[14] = A.z))
        : ((C[12] = A), (C[13] = I), (C[14] = g)),
      this
    )
  }
  invert() {
    const A = this.elements,
      I = A[0],
      g = A[1],
      C = A[2],
      i = A[3],
      B = A[4],
      o = A[5],
      r = A[6],
      s = A[7],
      h = A[8],
      S = A[9],
      d = A[10],
      w = A[11],
      M = A[12],
      K = A[13],
      R = A[14],
      F = A[15],
      L = S * R * s - K * d * s + K * r * w - o * R * w - S * r * F + o * d * F,
      Y = M * d * s - h * R * s - M * r * w + B * R * w + h * r * F - B * d * F,
      H = h * K * s - M * S * s + M * o * w - B * K * w - h * o * F + B * S * F,
      V = M * S * r - h * K * r - M * o * d + B * K * d + h * o * R - B * S * R,
      j = I * L + g * Y + C * H + i * V
    if (j === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)
    const P = 1 / j
    return (
      (A[0] = L * P),
      (A[1] = (K * d * i - S * R * i - K * C * w + g * R * w + S * C * F - g * d * F) * P),
      (A[2] = (o * R * i - K * r * i + K * C * s - g * R * s - o * C * F + g * r * F) * P),
      (A[3] = (S * r * i - o * d * i - S * C * s + g * d * s + o * C * w - g * r * w) * P),
      (A[4] = Y * P),
      (A[5] = (h * R * i - M * d * i + M * C * w - I * R * w - h * C * F + I * d * F) * P),
      (A[6] = (M * r * i - B * R * i - M * C * s + I * R * s + B * C * F - I * r * F) * P),
      (A[7] = (B * d * i - h * r * i + h * C * s - I * d * s - B * C * w + I * r * w) * P),
      (A[8] = H * P),
      (A[9] = (M * S * i - h * K * i - M * g * w + I * K * w + h * g * F - I * S * F) * P),
      (A[10] = (B * K * i - M * o * i + M * g * s - I * K * s - B * g * F + I * o * F) * P),
      (A[11] = (h * o * i - B * S * i - h * g * s + I * S * s + B * g * w - I * o * w) * P),
      (A[12] = V * P),
      (A[13] = (h * K * C - M * S * C + M * g * d - I * K * d - h * g * R + I * S * R) * P),
      (A[14] = (M * o * C - B * K * C - M * g * r + I * K * r + B * g * R - I * o * R) * P),
      (A[15] = (B * S * C - h * o * C + h * g * r - I * S * r - B * g * d + I * o * d) * P),
      this
    )
  }
  scale(A) {
    const I = this.elements,
      g = A.x,
      C = A.y,
      i = A.z
    return (
      (I[0] *= g),
      (I[4] *= C),
      (I[8] *= i),
      (I[1] *= g),
      (I[5] *= C),
      (I[9] *= i),
      (I[2] *= g),
      (I[6] *= C),
      (I[10] *= i),
      (I[3] *= g),
      (I[7] *= C),
      (I[11] *= i),
      this
    )
  }
  getMaxScaleOnAxis() {
    const A = this.elements,
      I = A[0] * A[0] + A[1] * A[1] + A[2] * A[2],
      g = A[4] * A[4] + A[5] * A[5] + A[6] * A[6],
      C = A[8] * A[8] + A[9] * A[9] + A[10] * A[10]
    return Math.sqrt(Math.max(I, g, C))
  }
  makeTranslation(A, I, g) {
    return (
      A.isVector3
        ? this.set(1, 0, 0, A.x, 0, 1, 0, A.y, 0, 0, 1, A.z, 0, 0, 0, 1)
        : this.set(1, 0, 0, A, 0, 1, 0, I, 0, 0, 1, g, 0, 0, 0, 1),
      this
    )
  }
  makeRotationX(A) {
    const I = Math.cos(A),
      g = Math.sin(A)
    return (this.set(1, 0, 0, 0, 0, I, -g, 0, 0, g, I, 0, 0, 0, 0, 1), this)
  }
  makeRotationY(A) {
    const I = Math.cos(A),
      g = Math.sin(A)
    return (this.set(I, 0, g, 0, 0, 1, 0, 0, -g, 0, I, 0, 0, 0, 0, 1), this)
  }
  makeRotationZ(A) {
    const I = Math.cos(A),
      g = Math.sin(A)
    return (this.set(I, -g, 0, 0, g, I, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this)
  }
  makeRotationAxis(A, I) {
    const g = Math.cos(I),
      C = Math.sin(I),
      i = 1 - g,
      B = A.x,
      o = A.y,
      r = A.z,
      s = i * B,
      h = i * o
    return (
      this.set(
        s * B + g,
        s * o - C * r,
        s * r + C * o,
        0,
        s * o + C * r,
        h * o + g,
        h * r - C * B,
        0,
        s * r - C * o,
        h * r + C * B,
        i * r * r + g,
        0,
        0,
        0,
        0,
        1,
      ),
      this
    )
  }
  makeScale(A, I, g) {
    return (this.set(A, 0, 0, 0, 0, I, 0, 0, 0, 0, g, 0, 0, 0, 0, 1), this)
  }
  makeShear(A, I, g, C, i, B) {
    return (this.set(1, g, i, 0, A, 1, B, 0, I, C, 1, 0, 0, 0, 0, 1), this)
  }
  compose(A, I, g) {
    const C = this.elements,
      i = I._x,
      B = I._y,
      o = I._z,
      r = I._w,
      s = i + i,
      h = B + B,
      S = o + o,
      d = i * s,
      w = i * h,
      M = i * S,
      K = B * h,
      R = B * S,
      F = o * S,
      L = r * s,
      Y = r * h,
      H = r * S,
      V = g.x,
      j = g.y,
      P = g.z
    return (
      (C[0] = (1 - (K + F)) * V),
      (C[1] = (w + H) * V),
      (C[2] = (M - Y) * V),
      (C[3] = 0),
      (C[4] = (w - H) * j),
      (C[5] = (1 - (d + F)) * j),
      (C[6] = (R + L) * j),
      (C[7] = 0),
      (C[8] = (M + Y) * P),
      (C[9] = (R - L) * P),
      (C[10] = (1 - (d + K)) * P),
      (C[11] = 0),
      (C[12] = A.x),
      (C[13] = A.y),
      (C[14] = A.z),
      (C[15] = 1),
      this
    )
  }
  decompose(A, I, g) {
    const C = this.elements
    let i = Jy.set(C[0], C[1], C[2]).length()
    const B = Jy.set(C[4], C[5], C[6]).length(),
      o = Jy.set(C[8], C[9], C[10]).length()
    ;(this.determinant() < 0 && (i = -i),
      (A.x = C[12]),
      (A.y = C[13]),
      (A.z = C[14]),
      dl.copy(this))
    const s = 1 / i,
      h = 1 / B,
      S = 1 / o
    return (
      (dl.elements[0] *= s),
      (dl.elements[1] *= s),
      (dl.elements[2] *= s),
      (dl.elements[4] *= h),
      (dl.elements[5] *= h),
      (dl.elements[6] *= h),
      (dl.elements[8] *= S),
      (dl.elements[9] *= S),
      (dl.elements[10] *= S),
      I.setFromRotationMatrix(dl),
      (g.x = i),
      (g.y = B),
      (g.z = o),
      this
    )
  }
  makePerspective(A, I, g, C, i, B, o = bc) {
    const r = this.elements,
      s = (2 * i) / (I - A),
      h = (2 * i) / (g - C),
      S = (I + A) / (I - A),
      d = (g + C) / (g - C)
    let w, M
    if (o === bc) ((w = -(B + i) / (B - i)), (M = (-2 * B * i) / (B - i)))
    else if (o === sG) ((w = -B / (B - i)), (M = (-B * i) / (B - i)))
    else throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + o)
    return (
      (r[0] = s),
      (r[4] = 0),
      (r[8] = S),
      (r[12] = 0),
      (r[1] = 0),
      (r[5] = h),
      (r[9] = d),
      (r[13] = 0),
      (r[2] = 0),
      (r[6] = 0),
      (r[10] = w),
      (r[14] = M),
      (r[3] = 0),
      (r[7] = 0),
      (r[11] = -1),
      (r[15] = 0),
      this
    )
  }
  makeOrthographic(A, I, g, C, i, B, o = bc) {
    const r = this.elements,
      s = 1 / (I - A),
      h = 1 / (g - C),
      S = 1 / (B - i),
      d = (I + A) * s,
      w = (g + C) * h
    let M, K
    if (o === bc) ((M = (B + i) * S), (K = -2 * S))
    else if (o === sG) ((M = i * S), (K = -1 * S))
    else throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + o)
    return (
      (r[0] = 2 * s),
      (r[4] = 0),
      (r[8] = 0),
      (r[12] = -d),
      (r[1] = 0),
      (r[5] = 2 * h),
      (r[9] = 0),
      (r[13] = -w),
      (r[2] = 0),
      (r[6] = 0),
      (r[10] = K),
      (r[14] = -M),
      (r[3] = 0),
      (r[7] = 0),
      (r[11] = 0),
      (r[15] = 1),
      this
    )
  }
  equals(A) {
    const I = this.elements,
      g = A.elements
    for (let C = 0; C < 16; C++) if (I[C] !== g[C]) return !1
    return !0
  }
  fromArray(A, I = 0) {
    for (let g = 0; g < 16; g++) this.elements[g] = A[g + I]
    return this
  }
  toArray(A = [], I = 0) {
    const g = this.elements
    return (
      (A[I] = g[0]),
      (A[I + 1] = g[1]),
      (A[I + 2] = g[2]),
      (A[I + 3] = g[3]),
      (A[I + 4] = g[4]),
      (A[I + 5] = g[5]),
      (A[I + 6] = g[6]),
      (A[I + 7] = g[7]),
      (A[I + 8] = g[8]),
      (A[I + 9] = g[9]),
      (A[I + 10] = g[10]),
      (A[I + 11] = g[11]),
      (A[I + 12] = g[12]),
      (A[I + 13] = g[13]),
      (A[I + 14] = g[14]),
      (A[I + 15] = g[15]),
      A
    )
  }
}
const Jy = /* @__PURE__ */ new wA(),
  dl = /* @__PURE__ */ new RC(),
  cZ = /* @__PURE__ */ new wA(0, 0, 0),
  hZ = /* @__PURE__ */ new wA(1, 1, 1),
  aD = /* @__PURE__ */ new wA(),
  YM = /* @__PURE__ */ new wA(),
  Rr = /* @__PURE__ */ new wA(),
  Hq = /* @__PURE__ */ new RC(),
  Tq = /* @__PURE__ */ new ho()
class uE {
  constructor(A = 0, I = 0, g = 0, C = uE.DEFAULT_ORDER) {
    ;((this.isEuler = !0), (this._x = A), (this._y = I), (this._z = g), (this._order = C))
  }
  get x() {
    return this._x
  }
  set x(A) {
    ;((this._x = A), this._onChangeCallback())
  }
  get y() {
    return this._y
  }
  set y(A) {
    ;((this._y = A), this._onChangeCallback())
  }
  get z() {
    return this._z
  }
  set z(A) {
    ;((this._z = A), this._onChangeCallback())
  }
  get order() {
    return this._order
  }
  set order(A) {
    ;((this._order = A), this._onChangeCallback())
  }
  set(A, I, g, C = this._order) {
    return (
      (this._x = A),
      (this._y = I),
      (this._z = g),
      (this._order = C),
      this._onChangeCallback(),
      this
    )
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order)
  }
  copy(A) {
    return (
      (this._x = A._x),
      (this._y = A._y),
      (this._z = A._z),
      (this._order = A._order),
      this._onChangeCallback(),
      this
    )
  }
  setFromRotationMatrix(A, I = this._order, g = !0) {
    const C = A.elements,
      i = C[0],
      B = C[4],
      o = C[8],
      r = C[1],
      s = C[5],
      h = C[9],
      S = C[2],
      d = C[6],
      w = C[10]
    switch (I) {
      case "XYZ":
        ;((this._y = Math.asin(eQ(o, -1, 1))),
          Math.abs(o) < 0.9999999
            ? ((this._x = Math.atan2(-h, w)), (this._z = Math.atan2(-B, i)))
            : ((this._x = Math.atan2(d, s)), (this._z = 0)))
        break
      case "YXZ":
        ;((this._x = Math.asin(-eQ(h, -1, 1))),
          Math.abs(h) < 0.9999999
            ? ((this._y = Math.atan2(o, w)), (this._z = Math.atan2(r, s)))
            : ((this._y = Math.atan2(-S, i)), (this._z = 0)))
        break
      case "ZXY":
        ;((this._x = Math.asin(eQ(d, -1, 1))),
          Math.abs(d) < 0.9999999
            ? ((this._y = Math.atan2(-S, w)), (this._z = Math.atan2(-B, s)))
            : ((this._y = 0), (this._z = Math.atan2(r, i))))
        break
      case "ZYX":
        ;((this._y = Math.asin(-eQ(S, -1, 1))),
          Math.abs(S) < 0.9999999
            ? ((this._x = Math.atan2(d, w)), (this._z = Math.atan2(r, i)))
            : ((this._x = 0), (this._z = Math.atan2(-B, s))))
        break
      case "YZX":
        ;((this._z = Math.asin(eQ(r, -1, 1))),
          Math.abs(r) < 0.9999999
            ? ((this._x = Math.atan2(-h, s)), (this._y = Math.atan2(-S, i)))
            : ((this._x = 0), (this._y = Math.atan2(o, w))))
        break
      case "XZY":
        ;((this._z = Math.asin(-eQ(B, -1, 1))),
          Math.abs(B) < 0.9999999
            ? ((this._x = Math.atan2(d, s)), (this._y = Math.atan2(o, i)))
            : ((this._x = Math.atan2(-h, w)), (this._y = 0)))
        break
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + I)
    }
    return ((this._order = I), g === !0 && this._onChangeCallback(), this)
  }
  setFromQuaternion(A, I, g) {
    return (Hq.makeRotationFromQuaternion(A), this.setFromRotationMatrix(Hq, I, g))
  }
  setFromVector3(A, I = this._order) {
    return this.set(A.x, A.y, A.z, I)
  }
  reorder(A) {
    return (Tq.setFromEuler(this), this.setFromQuaternion(Tq, A))
  }
  equals(A) {
    return A._x === this._x && A._y === this._y && A._z === this._z && A._order === this._order
  }
  fromArray(A) {
    return (
      (this._x = A[0]),
      (this._y = A[1]),
      (this._z = A[2]),
      A[3] !== void 0 && (this._order = A[3]),
      this._onChangeCallback(),
      this
    )
  }
  toArray(A = [], I = 0) {
    return (
      (A[I] = this._x),
      (A[I + 1] = this._y),
      (A[I + 2] = this._z),
      (A[I + 3] = this._order),
      A
    )
  }
  _onChange(A) {
    return ((this._onChangeCallback = A), this)
  }
  _onChangeCallback() {}
  *[Symbol.iterator]() {
    ;(yield this._x, yield this._y, yield this._z, yield this._order)
  }
}
uE.DEFAULT_ORDER = "XYZ"
class Kf {
  constructor() {
    this.mask = 1
  }
  set(A) {
    this.mask = ((1 << A) | 0) >>> 0
  }
  enable(A) {
    this.mask |= (1 << A) | 0
  }
  enableAll() {
    this.mask = -1
  }
  toggle(A) {
    this.mask ^= (1 << A) | 0
  }
  disable(A) {
    this.mask &= ~((1 << A) | 0)
  }
  disableAll() {
    this.mask = 0
  }
  test(A) {
    return (this.mask & A.mask) !== 0
  }
  isEnabled(A) {
    return (this.mask & ((1 << A) | 0)) !== 0
  }
}
let uZ = 0
const xq = /* @__PURE__ */ new wA(),
  Ky = /* @__PURE__ */ new ho(),
  Vh = /* @__PURE__ */ new RC(),
  qM = /* @__PURE__ */ new wA(),
  M0 = /* @__PURE__ */ new wA(),
  DZ = /* @__PURE__ */ new wA(),
  SZ = /* @__PURE__ */ new ho(),
  bq = /* @__PURE__ */ new wA(1, 0, 0),
  Oq = /* @__PURE__ */ new wA(0, 1, 0),
  _q = /* @__PURE__ */ new wA(0, 0, 1),
  Zq = { type: "added" },
  fZ = { type: "removed" },
  my = { type: "childadded", child: null },
  gK = { type: "childremoved", child: null }
class Ci extends qr {
  constructor() {
    ;(super(),
      (this.isObject3D = !0),
      Object.defineProperty(this, "id", { value: uZ++ }),
      (this.uuid = Lr()),
      (this.name = ""),
      (this.type = "Object3D"),
      (this.parent = null),
      (this.children = []),
      (this.up = Ci.DEFAULT_UP.clone()))
    const A = new wA(),
      I = new uE(),
      g = new ho(),
      C = new wA(1, 1, 1)
    function i() {
      g.setFromEuler(I, !1)
    }
    function B() {
      I.setFromQuaternion(g, void 0, !1)
    }
    ;(I._onChange(i),
      g._onChange(B),
      Object.defineProperties(this, {
        position: {
          configurable: !0,
          enumerable: !0,
          value: A,
        },
        rotation: {
          configurable: !0,
          enumerable: !0,
          value: I,
        },
        quaternion: {
          configurable: !0,
          enumerable: !0,
          value: g,
        },
        scale: {
          configurable: !0,
          enumerable: !0,
          value: C,
        },
        modelViewMatrix: {
          value: new RC(),
        },
        normalMatrix: {
          value: new ce(),
        },
      }),
      (this.matrix = new RC()),
      (this.matrixWorld = new RC()),
      (this.matrixAutoUpdate = Ci.DEFAULT_MATRIX_AUTO_UPDATE),
      (this.matrixWorldAutoUpdate = Ci.DEFAULT_MATRIX_WORLD_AUTO_UPDATE),
      (this.matrixWorldNeedsUpdate = !1),
      (this.layers = new Kf()),
      (this.visible = !0),
      (this.castShadow = !1),
      (this.receiveShadow = !1),
      (this.frustumCulled = !0),
      (this.renderOrder = 0),
      (this.animations = []),
      (this.userData = {}))
  }
  onBeforeShadow() {}
  onAfterShadow() {}
  onBeforeRender() {}
  onAfterRender() {}
  applyMatrix4(A) {
    ;(this.matrixAutoUpdate && this.updateMatrix(),
      this.matrix.premultiply(A),
      this.matrix.decompose(this.position, this.quaternion, this.scale))
  }
  applyQuaternion(A) {
    return (this.quaternion.premultiply(A), this)
  }
  setRotationFromAxisAngle(A, I) {
    this.quaternion.setFromAxisAngle(A, I)
  }
  setRotationFromEuler(A) {
    this.quaternion.setFromEuler(A, !0)
  }
  setRotationFromMatrix(A) {
    this.quaternion.setFromRotationMatrix(A)
  }
  setRotationFromQuaternion(A) {
    this.quaternion.copy(A)
  }
  rotateOnAxis(A, I) {
    return (Ky.setFromAxisAngle(A, I), this.quaternion.multiply(Ky), this)
  }
  rotateOnWorldAxis(A, I) {
    return (Ky.setFromAxisAngle(A, I), this.quaternion.premultiply(Ky), this)
  }
  rotateX(A) {
    return this.rotateOnAxis(bq, A)
  }
  rotateY(A) {
    return this.rotateOnAxis(Oq, A)
  }
  rotateZ(A) {
    return this.rotateOnAxis(_q, A)
  }
  translateOnAxis(A, I) {
    return (
      xq.copy(A).applyQuaternion(this.quaternion),
      this.position.add(xq.multiplyScalar(I)),
      this
    )
  }
  translateX(A) {
    return this.translateOnAxis(bq, A)
  }
  translateY(A) {
    return this.translateOnAxis(Oq, A)
  }
  translateZ(A) {
    return this.translateOnAxis(_q, A)
  }
  localToWorld(A) {
    return (this.updateWorldMatrix(!0, !1), A.applyMatrix4(this.matrixWorld))
  }
  worldToLocal(A) {
    return (this.updateWorldMatrix(!0, !1), A.applyMatrix4(Vh.copy(this.matrixWorld).invert()))
  }
  lookAt(A, I, g) {
    A.isVector3 ? qM.copy(A) : qM.set(A, I, g)
    const C = this.parent
    ;(this.updateWorldMatrix(!0, !1),
      M0.setFromMatrixPosition(this.matrixWorld),
      this.isCamera || this.isLight ? Vh.lookAt(M0, qM, this.up) : Vh.lookAt(qM, M0, this.up),
      this.quaternion.setFromRotationMatrix(Vh),
      C &&
        (Vh.extractRotation(C.matrixWorld),
        Ky.setFromRotationMatrix(Vh),
        this.quaternion.premultiply(Ky.invert())))
  }
  add(A) {
    if (arguments.length > 1) {
      for (let I = 0; I < arguments.length; I++) this.add(arguments[I])
      return this
    }
    return A === this
      ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", A), this)
      : (A && A.isObject3D
          ? (A.removeFromParent(),
            (A.parent = this),
            this.children.push(A),
            A.dispatchEvent(Zq),
            (my.child = A),
            this.dispatchEvent(my),
            (my.child = null))
          : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", A),
        this)
  }
  remove(A) {
    if (arguments.length > 1) {
      for (let g = 0; g < arguments.length; g++) this.remove(arguments[g])
      return this
    }
    const I = this.children.indexOf(A)
    return (
      I !== -1 &&
        ((A.parent = null),
        this.children.splice(I, 1),
        A.dispatchEvent(fZ),
        (gK.child = A),
        this.dispatchEvent(gK),
        (gK.child = null)),
      this
    )
  }
  removeFromParent() {
    const A = this.parent
    return (A !== null && A.remove(this), this)
  }
  clear() {
    return this.remove(...this.children)
  }
  attach(A) {
    return (
      this.updateWorldMatrix(!0, !1),
      Vh.copy(this.matrixWorld).invert(),
      A.parent !== null && (A.parent.updateWorldMatrix(!0, !1), Vh.multiply(A.parent.matrixWorld)),
      A.applyMatrix4(Vh),
      A.removeFromParent(),
      (A.parent = this),
      this.children.push(A),
      A.updateWorldMatrix(!1, !0),
      A.dispatchEvent(Zq),
      (my.child = A),
      this.dispatchEvent(my),
      (my.child = null),
      this
    )
  }
  getObjectById(A) {
    return this.getObjectByProperty("id", A)
  }
  getObjectByName(A) {
    return this.getObjectByProperty("name", A)
  }
  getObjectByProperty(A, I) {
    if (this[A] === I) return this
    for (let g = 0, C = this.children.length; g < C; g++) {
      const B = this.children[g].getObjectByProperty(A, I)
      if (B !== void 0) return B
    }
  }
  getObjectsByProperty(A, I, g = []) {
    this[A] === I && g.push(this)
    const C = this.children
    for (let i = 0, B = C.length; i < B; i++) C[i].getObjectsByProperty(A, I, g)
    return g
  }
  getWorldPosition(A) {
    return (this.updateWorldMatrix(!0, !1), A.setFromMatrixPosition(this.matrixWorld))
  }
  getWorldQuaternion(A) {
    return (this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(M0, A, DZ), A)
  }
  getWorldScale(A) {
    return (this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(M0, SZ, A), A)
  }
  getWorldDirection(A) {
    this.updateWorldMatrix(!0, !1)
    const I = this.matrixWorld.elements
    return A.set(I[8], I[9], I[10]).normalize()
  }
  raycast() {}
  traverse(A) {
    A(this)
    const I = this.children
    for (let g = 0, C = I.length; g < C; g++) I[g].traverse(A)
  }
  traverseVisible(A) {
    if (this.visible === !1) return
    A(this)
    const I = this.children
    for (let g = 0, C = I.length; g < C; g++) I[g].traverseVisible(A)
  }
  traverseAncestors(A) {
    const I = this.parent
    I !== null && (A(I), I.traverseAncestors(A))
  }
  updateMatrix() {
    ;(this.matrix.compose(this.position, this.quaternion, this.scale),
      (this.matrixWorldNeedsUpdate = !0))
  }
  updateMatrixWorld(A) {
    ;(this.matrixAutoUpdate && this.updateMatrix(),
      (this.matrixWorldNeedsUpdate || A) &&
        (this.matrixWorldAutoUpdate === !0 &&
          (this.parent === null
            ? this.matrixWorld.copy(this.matrix)
            : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)),
        (this.matrixWorldNeedsUpdate = !1),
        (A = !0)))
    const I = this.children
    for (let g = 0, C = I.length; g < C; g++) I[g].updateMatrixWorld(A)
  }
  updateWorldMatrix(A, I) {
    const g = this.parent
    if (
      (A === !0 && g !== null && g.updateWorldMatrix(!0, !1),
      this.matrixAutoUpdate && this.updateMatrix(),
      this.matrixWorldAutoUpdate === !0 &&
        (this.parent === null
          ? this.matrixWorld.copy(this.matrix)
          : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)),
      I === !0)
    ) {
      const C = this.children
      for (let i = 0, B = C.length; i < B; i++) C[i].updateWorldMatrix(!1, !0)
    }
  }
  toJSON(A) {
    const I = A === void 0 || typeof A == "string",
      g = {}
    I &&
      ((A = {
        geometries: {},
        materials: {},
        textures: {},
        images: {},
        shapes: {},
        skeletons: {},
        animations: {},
        nodes: {},
      }),
      (g.metadata = {
        version: 4.6,
        type: "Object",
        generator: "Object3D.toJSON",
      }))
    const C = {}
    ;((C.uuid = this.uuid),
      (C.type = this.type),
      this.name !== "" && (C.name = this.name),
      this.castShadow === !0 && (C.castShadow = !0),
      this.receiveShadow === !0 && (C.receiveShadow = !0),
      this.visible === !1 && (C.visible = !1),
      this.frustumCulled === !1 && (C.frustumCulled = !1),
      this.renderOrder !== 0 && (C.renderOrder = this.renderOrder),
      Object.keys(this.userData).length > 0 && (C.userData = this.userData),
      (C.layers = this.layers.mask),
      (C.matrix = this.matrix.toArray()),
      (C.up = this.up.toArray()),
      this.matrixAutoUpdate === !1 && (C.matrixAutoUpdate = !1),
      this.isInstancedMesh &&
        ((C.type = "InstancedMesh"),
        (C.count = this.count),
        (C.instanceMatrix = this.instanceMatrix.toJSON()),
        this.instanceColor !== null && (C.instanceColor = this.instanceColor.toJSON())),
      this.isBatchedMesh &&
        ((C.type = "BatchedMesh"),
        (C.perObjectFrustumCulled = this.perObjectFrustumCulled),
        (C.sortObjects = this.sortObjects),
        (C.drawRanges = this._drawRanges),
        (C.reservedRanges = this._reservedRanges),
        (C.visibility = this._visibility),
        (C.active = this._active),
        (C.bounds = this._bounds.map((o) => ({
          boxInitialized: o.boxInitialized,
          boxMin: o.box.min.toArray(),
          boxMax: o.box.max.toArray(),
          sphereInitialized: o.sphereInitialized,
          sphereRadius: o.sphere.radius,
          sphereCenter: o.sphere.center.toArray(),
        }))),
        (C.maxInstanceCount = this._maxInstanceCount),
        (C.maxVertexCount = this._maxVertexCount),
        (C.maxIndexCount = this._maxIndexCount),
        (C.geometryInitialized = this._geometryInitialized),
        (C.geometryCount = this._geometryCount),
        (C.matricesTexture = this._matricesTexture.toJSON(A)),
        this._colorsTexture !== null && (C.colorsTexture = this._colorsTexture.toJSON(A)),
        this.boundingSphere !== null &&
          (C.boundingSphere = {
            center: C.boundingSphere.center.toArray(),
            radius: C.boundingSphere.radius,
          }),
        this.boundingBox !== null &&
          (C.boundingBox = {
            min: C.boundingBox.min.toArray(),
            max: C.boundingBox.max.toArray(),
          })))
    function i(o, r) {
      return (o[r.uuid] === void 0 && (o[r.uuid] = r.toJSON(A)), r.uuid)
    }
    if (this.isScene)
      (this.background &&
        (this.background.isColor
          ? (C.background = this.background.toJSON())
          : this.background.isTexture && (C.background = this.background.toJSON(A).uuid)),
        this.environment &&
          this.environment.isTexture &&
          this.environment.isRenderTargetTexture !== !0 &&
          (C.environment = this.environment.toJSON(A).uuid))
    else if (this.isMesh || this.isLine || this.isPoints) {
      C.geometry = i(A.geometries, this.geometry)
      const o = this.geometry.parameters
      if (o !== void 0 && o.shapes !== void 0) {
        const r = o.shapes
        if (Array.isArray(r))
          for (let s = 0, h = r.length; s < h; s++) {
            const S = r[s]
            i(A.shapes, S)
          }
        else i(A.shapes, r)
      }
    }
    if (
      (this.isSkinnedMesh &&
        ((C.bindMode = this.bindMode),
        (C.bindMatrix = this.bindMatrix.toArray()),
        this.skeleton !== void 0 &&
          (i(A.skeletons, this.skeleton), (C.skeleton = this.skeleton.uuid))),
      this.material !== void 0)
    )
      if (Array.isArray(this.material)) {
        const o = []
        for (let r = 0, s = this.material.length; r < s; r++)
          o.push(i(A.materials, this.material[r]))
        C.material = o
      } else C.material = i(A.materials, this.material)
    if (this.children.length > 0) {
      C.children = []
      for (let o = 0; o < this.children.length; o++)
        C.children.push(this.children[o].toJSON(A).object)
    }
    if (this.animations.length > 0) {
      C.animations = []
      for (let o = 0; o < this.animations.length; o++) {
        const r = this.animations[o]
        C.animations.push(i(A.animations, r))
      }
    }
    if (I) {
      const o = B(A.geometries),
        r = B(A.materials),
        s = B(A.textures),
        h = B(A.images),
        S = B(A.shapes),
        d = B(A.skeletons),
        w = B(A.animations),
        M = B(A.nodes)
      ;(o.length > 0 && (g.geometries = o),
        r.length > 0 && (g.materials = r),
        s.length > 0 && (g.textures = s),
        h.length > 0 && (g.images = h),
        S.length > 0 && (g.shapes = S),
        d.length > 0 && (g.skeletons = d),
        w.length > 0 && (g.animations = w),
        M.length > 0 && (g.nodes = M))
    }
    return ((g.object = C), g)
    function B(o) {
      const r = []
      for (const s in o) {
        const h = o[s]
        ;(delete h.metadata, r.push(h))
      }
      return r
    }
  }
  clone(A) {
    return new this.constructor().copy(this, A)
  }
  copy(A, I = !0) {
    if (
      ((this.name = A.name),
      this.up.copy(A.up),
      this.position.copy(A.position),
      (this.rotation.order = A.rotation.order),
      this.quaternion.copy(A.quaternion),
      this.scale.copy(A.scale),
      this.matrix.copy(A.matrix),
      this.matrixWorld.copy(A.matrixWorld),
      (this.matrixAutoUpdate = A.matrixAutoUpdate),
      (this.matrixWorldAutoUpdate = A.matrixWorldAutoUpdate),
      (this.matrixWorldNeedsUpdate = A.matrixWorldNeedsUpdate),
      (this.layers.mask = A.layers.mask),
      (this.visible = A.visible),
      (this.castShadow = A.castShadow),
      (this.receiveShadow = A.receiveShadow),
      (this.frustumCulled = A.frustumCulled),
      (this.renderOrder = A.renderOrder),
      (this.animations = A.animations.slice()),
      (this.userData = JSON.parse(JSON.stringify(A.userData))),
      I === !0)
    )
      for (let g = 0; g < A.children.length; g++) {
        const C = A.children[g]
        this.add(C.clone())
      }
    return this
  }
}
Ci.DEFAULT_UP = /* @__PURE__ */ new wA(0, 1, 0)
Ci.DEFAULT_MATRIX_AUTO_UPDATE = !0
Ci.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0
const yl = /* @__PURE__ */ new wA(),
  jh = /* @__PURE__ */ new wA(),
  CK = /* @__PURE__ */ new wA(),
  zh = /* @__PURE__ */ new wA(),
  vy = /* @__PURE__ */ new wA(),
  Ly = /* @__PURE__ */ new wA(),
  Pq = /* @__PURE__ */ new wA(),
  eK = /* @__PURE__ */ new wA(),
  iK = /* @__PURE__ */ new wA(),
  tK = /* @__PURE__ */ new wA(),
  BK = /* @__PURE__ */ new Xe(),
  QK = /* @__PURE__ */ new Xe(),
  oK = /* @__PURE__ */ new Xe()
class va {
  constructor(A = new wA(), I = new wA(), g = new wA()) {
    ;((this.a = A), (this.b = I), (this.c = g))
  }
  static getNormal(A, I, g, C) {
    ;(C.subVectors(g, I), yl.subVectors(A, I), C.cross(yl))
    const i = C.lengthSq()
    return i > 0 ? C.multiplyScalar(1 / Math.sqrt(i)) : C.set(0, 0, 0)
  }
  // static/instance method to calculate barycentric coordinates
  // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
  static getBarycoord(A, I, g, C, i) {
    ;(yl.subVectors(C, I), jh.subVectors(g, I), CK.subVectors(A, I))
    const B = yl.dot(yl),
      o = yl.dot(jh),
      r = yl.dot(CK),
      s = jh.dot(jh),
      h = jh.dot(CK),
      S = B * s - o * o
    if (S === 0) return (i.set(0, 0, 0), null)
    const d = 1 / S,
      w = (s * r - o * h) * d,
      M = (B * h - o * r) * d
    return i.set(1 - w - M, M, w)
  }
  static containsPoint(A, I, g, C) {
    return this.getBarycoord(A, I, g, C, zh) === null
      ? !1
      : zh.x >= 0 && zh.y >= 0 && zh.x + zh.y <= 1
  }
  static getInterpolation(A, I, g, C, i, B, o, r) {
    return this.getBarycoord(A, I, g, C, zh) === null
      ? ((r.x = 0), (r.y = 0), "z" in r && (r.z = 0), "w" in r && (r.w = 0), null)
      : (r.setScalar(0),
        r.addScaledVector(i, zh.x),
        r.addScaledVector(B, zh.y),
        r.addScaledVector(o, zh.z),
        r)
  }
  static getInterpolatedAttribute(A, I, g, C, i, B) {
    return (
      BK.setScalar(0),
      QK.setScalar(0),
      oK.setScalar(0),
      BK.fromBufferAttribute(A, I),
      QK.fromBufferAttribute(A, g),
      oK.fromBufferAttribute(A, C),
      B.setScalar(0),
      B.addScaledVector(BK, i.x),
      B.addScaledVector(QK, i.y),
      B.addScaledVector(oK, i.z),
      B
    )
  }
  static isFrontFacing(A, I, g, C) {
    return (yl.subVectors(g, I), jh.subVectors(A, I), yl.cross(jh).dot(C) < 0)
  }
  set(A, I, g) {
    return (this.a.copy(A), this.b.copy(I), this.c.copy(g), this)
  }
  setFromPointsAndIndices(A, I, g, C) {
    return (this.a.copy(A[I]), this.b.copy(A[g]), this.c.copy(A[C]), this)
  }
  setFromAttributeAndIndices(A, I, g, C) {
    return (
      this.a.fromBufferAttribute(A, I),
      this.b.fromBufferAttribute(A, g),
      this.c.fromBufferAttribute(A, C),
      this
    )
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(A) {
    return (this.a.copy(A.a), this.b.copy(A.b), this.c.copy(A.c), this)
  }
  getArea() {
    return (
      yl.subVectors(this.c, this.b),
      jh.subVectors(this.a, this.b),
      yl.cross(jh).length() * 0.5
    )
  }
  getMidpoint(A) {
    return A.addVectors(this.a, this.b)
      .add(this.c)
      .multiplyScalar(1 / 3)
  }
  getNormal(A) {
    return va.getNormal(this.a, this.b, this.c, A)
  }
  getPlane(A) {
    return A.setFromCoplanarPoints(this.a, this.b, this.c)
  }
  getBarycoord(A, I) {
    return va.getBarycoord(A, this.a, this.b, this.c, I)
  }
  getInterpolation(A, I, g, C, i) {
    return va.getInterpolation(A, this.a, this.b, this.c, I, g, C, i)
  }
  containsPoint(A) {
    return va.containsPoint(A, this.a, this.b, this.c)
  }
  isFrontFacing(A) {
    return va.isFrontFacing(this.a, this.b, this.c, A)
  }
  intersectsBox(A) {
    return A.intersectsTriangle(this)
  }
  closestPointToPoint(A, I) {
    const g = this.a,
      C = this.b,
      i = this.c
    let B, o
    ;(vy.subVectors(C, g), Ly.subVectors(i, g), eK.subVectors(A, g))
    const r = vy.dot(eK),
      s = Ly.dot(eK)
    if (r <= 0 && s <= 0) return I.copy(g)
    iK.subVectors(A, C)
    const h = vy.dot(iK),
      S = Ly.dot(iK)
    if (h >= 0 && S <= h) return I.copy(C)
    const d = r * S - h * s
    if (d <= 0 && r >= 0 && h <= 0) return ((B = r / (r - h)), I.copy(g).addScaledVector(vy, B))
    tK.subVectors(A, i)
    const w = vy.dot(tK),
      M = Ly.dot(tK)
    if (M >= 0 && w <= M) return I.copy(i)
    const K = w * s - r * M
    if (K <= 0 && s >= 0 && M <= 0) return ((o = s / (s - M)), I.copy(g).addScaledVector(Ly, o))
    const R = h * M - w * S
    if (R <= 0 && S - h >= 0 && w - M >= 0)
      return (
        Pq.subVectors(i, C),
        (o = (S - h) / (S - h + (w - M))),
        I.copy(C).addScaledVector(Pq, o)
      )
    const F = 1 / (R + K + d)
    return ((B = K * F), (o = d * F), I.copy(g).addScaledVector(vy, B).addScaledVector(Ly, o))
  }
  equals(A) {
    return A.a.equals(this.a) && A.b.equals(this.b) && A.c.equals(this.c)
  }
}
const _2 = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074,
  },
  rD = { h: 0, s: 0, l: 0 },
  HM = { h: 0, s: 0, l: 0 }
function nK(e, A, I) {
  return (
    I < 0 && (I += 1),
    I > 1 && (I -= 1),
    I < 1 / 6 ? e + (A - e) * 6 * I : I < 1 / 2 ? A : I < 2 / 3 ? e + (A - e) * 6 * (2 / 3 - I) : e
  )
}
class Mg {
  constructor(A, I, g) {
    return ((this.isColor = !0), (this.r = 1), (this.g = 1), (this.b = 1), this.set(A, I, g))
  }
  set(A, I, g) {
    if (I === void 0 && g === void 0) {
      const C = A
      C && C.isColor
        ? this.copy(C)
        : typeof C == "number"
          ? this.setHex(C)
          : typeof C == "string" && this.setStyle(C)
    } else this.setRGB(A, I, g)
    return this
  }
  setScalar(A) {
    return ((this.r = A), (this.g = A), (this.b = A), this)
  }
  setHex(A, I = zi) {
    return (
      (A = Math.floor(A)),
      (this.r = ((A >> 16) & 255) / 255),
      (this.g = ((A >> 8) & 255) / 255),
      (this.b = (A & 255) / 255),
      ni.toWorkingColorSpace(this, I),
      this
    )
  }
  setRGB(A, I, g, C = ni.workingColorSpace) {
    return ((this.r = A), (this.g = I), (this.b = g), ni.toWorkingColorSpace(this, C), this)
  }
  setHSL(A, I, g, C = ni.workingColorSpace) {
    if (((A = Av(A, 1)), (I = eQ(I, 0, 1)), (g = eQ(g, 0, 1)), I === 0))
      this.r = this.g = this.b = g
    else {
      const i = g <= 0.5 ? g * (1 + I) : g + I - g * I,
        B = 2 * g - i
      ;((this.r = nK(B, i, A + 1 / 3)), (this.g = nK(B, i, A)), (this.b = nK(B, i, A - 1 / 3)))
    }
    return (ni.toWorkingColorSpace(this, C), this)
  }
  setStyle(A, I = zi) {
    function g(i) {
      i !== void 0 &&
        parseFloat(i) < 1 &&
        console.warn("THREE.Color: Alpha component of " + A + " will be ignored.")
    }
    let C
    if ((C = /^(\w+)\(([^\)]*)\)/.exec(A))) {
      let i
      const B = C[1],
        o = C[2]
      switch (B) {
        case "rgb":
        case "rgba":
          if ((i = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)))
            return (
              g(i[4]),
              this.setRGB(
                Math.min(255, parseInt(i[1], 10)) / 255,
                Math.min(255, parseInt(i[2], 10)) / 255,
                Math.min(255, parseInt(i[3], 10)) / 255,
                I,
              )
            )
          if ((i = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)))
            return (
              g(i[4]),
              this.setRGB(
                Math.min(100, parseInt(i[1], 10)) / 100,
                Math.min(100, parseInt(i[2], 10)) / 100,
                Math.min(100, parseInt(i[3], 10)) / 100,
                I,
              )
            )
          break
        case "hsl":
        case "hsla":
          if (
            (i =
              /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
                o,
              ))
          )
            return (
              g(i[4]),
              this.setHSL(parseFloat(i[1]) / 360, parseFloat(i[2]) / 100, parseFloat(i[3]) / 100, I)
            )
          break
        default:
          console.warn("THREE.Color: Unknown color model " + A)
      }
    } else if ((C = /^\#([A-Fa-f\d]+)$/.exec(A))) {
      const i = C[1],
        B = i.length
      if (B === 3)
        return this.setRGB(
          parseInt(i.charAt(0), 16) / 15,
          parseInt(i.charAt(1), 16) / 15,
          parseInt(i.charAt(2), 16) / 15,
          I,
        )
      if (B === 6) return this.setHex(parseInt(i, 16), I)
      console.warn("THREE.Color: Invalid hex color " + A)
    } else if (A && A.length > 0) return this.setColorName(A, I)
    return this
  }
  setColorName(A, I = zi) {
    const g = _2[A.toLowerCase()]
    return (
      g !== void 0 ? this.setHex(g, I) : console.warn("THREE.Color: Unknown color " + A),
      this
    )
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b)
  }
  copy(A) {
    return ((this.r = A.r), (this.g = A.g), (this.b = A.b), this)
  }
  copySRGBToLinear(A) {
    return ((this.r = eu(A.r)), (this.g = eu(A.g)), (this.b = eu(A.b)), this)
  }
  copyLinearToSRGB(A) {
    return ((this.r = ip(A.r)), (this.g = ip(A.g)), (this.b = ip(A.b)), this)
  }
  convertSRGBToLinear() {
    return (this.copySRGBToLinear(this), this)
  }
  convertLinearToSRGB() {
    return (this.copyLinearToSRGB(this), this)
  }
  getHex(A = zi) {
    return (
      ni.fromWorkingColorSpace(EE.copy(this), A),
      Math.round(eQ(EE.r * 255, 0, 255)) * 65536 +
        Math.round(eQ(EE.g * 255, 0, 255)) * 256 +
        Math.round(eQ(EE.b * 255, 0, 255))
    )
  }
  getHexString(A = zi) {
    return ("000000" + this.getHex(A).toString(16)).slice(-6)
  }
  getHSL(A, I = ni.workingColorSpace) {
    ni.fromWorkingColorSpace(EE.copy(this), I)
    const g = EE.r,
      C = EE.g,
      i = EE.b,
      B = Math.max(g, C, i),
      o = Math.min(g, C, i)
    let r, s
    const h = (o + B) / 2
    if (o === B) ((r = 0), (s = 0))
    else {
      const S = B - o
      switch (((s = h <= 0.5 ? S / (B + o) : S / (2 - B - o)), B)) {
        case g:
          r = (C - i) / S + (C < i ? 6 : 0)
          break
        case C:
          r = (i - g) / S + 2
          break
        case i:
          r = (g - C) / S + 4
          break
      }
      r /= 6
    }
    return ((A.h = r), (A.s = s), (A.l = h), A)
  }
  getRGB(A, I = ni.workingColorSpace) {
    return (ni.fromWorkingColorSpace(EE.copy(this), I), (A.r = EE.r), (A.g = EE.g), (A.b = EE.b), A)
  }
  getStyle(A = zi) {
    ni.fromWorkingColorSpace(EE.copy(this), A)
    const I = EE.r,
      g = EE.g,
      C = EE.b
    return A !== zi
      ? `color(${A} ${I.toFixed(3)} ${g.toFixed(3)} ${C.toFixed(3)})`
      : `rgb(${Math.round(I * 255)},${Math.round(g * 255)},${Math.round(C * 255)})`
  }
  offsetHSL(A, I, g) {
    return (this.getHSL(rD), this.setHSL(rD.h + A, rD.s + I, rD.l + g))
  }
  add(A) {
    return ((this.r += A.r), (this.g += A.g), (this.b += A.b), this)
  }
  addColors(A, I) {
    return ((this.r = A.r + I.r), (this.g = A.g + I.g), (this.b = A.b + I.b), this)
  }
  addScalar(A) {
    return ((this.r += A), (this.g += A), (this.b += A), this)
  }
  sub(A) {
    return (
      (this.r = Math.max(0, this.r - A.r)),
      (this.g = Math.max(0, this.g - A.g)),
      (this.b = Math.max(0, this.b - A.b)),
      this
    )
  }
  multiply(A) {
    return ((this.r *= A.r), (this.g *= A.g), (this.b *= A.b), this)
  }
  multiplyScalar(A) {
    return ((this.r *= A), (this.g *= A), (this.b *= A), this)
  }
  lerp(A, I) {
    return (
      (this.r += (A.r - this.r) * I),
      (this.g += (A.g - this.g) * I),
      (this.b += (A.b - this.b) * I),
      this
    )
  }
  lerpColors(A, I, g) {
    return (
      (this.r = A.r + (I.r - A.r) * g),
      (this.g = A.g + (I.g - A.g) * g),
      (this.b = A.b + (I.b - A.b) * g),
      this
    )
  }
  lerpHSL(A, I) {
    ;(this.getHSL(rD), A.getHSL(HM))
    const g = eG(rD.h, HM.h, I),
      C = eG(rD.s, HM.s, I),
      i = eG(rD.l, HM.l, I)
    return (this.setHSL(g, C, i), this)
  }
  setFromVector3(A) {
    return ((this.r = A.x), (this.g = A.y), (this.b = A.z), this)
  }
  applyMatrix3(A) {
    const I = this.r,
      g = this.g,
      C = this.b,
      i = A.elements
    return (
      (this.r = i[0] * I + i[3] * g + i[6] * C),
      (this.g = i[1] * I + i[4] * g + i[7] * C),
      (this.b = i[2] * I + i[5] * g + i[8] * C),
      this
    )
  }
  equals(A) {
    return A.r === this.r && A.g === this.g && A.b === this.b
  }
  fromArray(A, I = 0) {
    return ((this.r = A[I]), (this.g = A[I + 1]), (this.b = A[I + 2]), this)
  }
  toArray(A = [], I = 0) {
    return ((A[I] = this.r), (A[I + 1] = this.g), (A[I + 2] = this.b), A)
  }
  fromBufferAttribute(A, I) {
    return ((this.r = A.getX(I)), (this.g = A.getY(I)), (this.b = A.getZ(I)), this)
  }
  toJSON() {
    return this.getHex()
  }
  *[Symbol.iterator]() {
    ;(yield this.r, yield this.g, yield this.b)
  }
}
const EE = /* @__PURE__ */ new Mg()
Mg.NAMES = _2
let dZ = 0
class tQ extends qr {
  static get type() {
    return "Material"
  }
  get type() {
    return this.constructor.type
  }
  set type(A) {}
  constructor() {
    ;(super(),
      (this.isMaterial = !0),
      Object.defineProperty(this, "id", { value: dZ++ }),
      (this.uuid = Lr()),
      (this.name = ""),
      (this.blending = Ff),
      (this.side = Us),
      (this.vertexColors = !1),
      (this.opacity = 1),
      (this.transparent = !1),
      (this.alphaHash = !1),
      (this.blendSrc = HU),
      (this.blendDst = TU),
      (this.blendEquation = yD),
      (this.blendSrcAlpha = null),
      (this.blendDstAlpha = null),
      (this.blendEquationAlpha = null),
      (this.blendColor = new Mg(0, 0, 0)),
      (this.blendAlpha = 0),
      (this.depthFunc = Lf),
      (this.depthTest = !0),
      (this.depthWrite = !0),
      (this.stencilWriteMask = 255),
      (this.stencilFunc = hm),
      (this.stencilRef = 0),
      (this.stencilFuncMask = 255),
      (this.stencilFail = ff),
      (this.stencilZFail = ff),
      (this.stencilZPass = ff),
      (this.stencilWrite = !1),
      (this.clippingPlanes = null),
      (this.clipIntersection = !1),
      (this.clipShadows = !1),
      (this.shadowSide = null),
      (this.colorWrite = !0),
      (this.precision = null),
      (this.polygonOffset = !1),
      (this.polygonOffsetFactor = 0),
      (this.polygonOffsetUnits = 0),
      (this.dithering = !1),
      (this.alphaToCoverage = !1),
      (this.premultipliedAlpha = !1),
      (this.forceSinglePass = !1),
      (this.visible = !0),
      (this.toneMapped = !0),
      (this.userData = {}),
      (this.version = 0),
      (this._alphaTest = 0))
  }
  get alphaTest() {
    return this._alphaTest
  }
  set alphaTest(A) {
    ;(this._alphaTest > 0 != A > 0 && this.version++, (this._alphaTest = A))
  }
  // onBeforeRender and onBeforeCompile only supported in WebGLRenderer
  onBeforeRender() {}
  onBeforeCompile() {}
  customProgramCacheKey() {
    return this.onBeforeCompile.toString()
  }
  setValues(A) {
    if (A !== void 0)
      for (const I in A) {
        const g = A[I]
        if (g === void 0) {
          console.warn(`THREE.Material: parameter '${I}' has value of undefined.`)
          continue
        }
        const C = this[I]
        if (C === void 0) {
          console.warn(`THREE.Material: '${I}' is not a property of THREE.${this.type}.`)
          continue
        }
        C && C.isColor ? C.set(g) : C && C.isVector3 && g && g.isVector3 ? C.copy(g) : (this[I] = g)
      }
  }
  toJSON(A) {
    const I = A === void 0 || typeof A == "string"
    I &&
      (A = {
        textures: {},
        images: {},
      })
    const g = {
      metadata: {
        version: 4.6,
        type: "Material",
        generator: "Material.toJSON",
      },
    }
    ;((g.uuid = this.uuid),
      (g.type = this.type),
      this.name !== "" && (g.name = this.name),
      this.color && this.color.isColor && (g.color = this.color.getHex()),
      this.roughness !== void 0 && (g.roughness = this.roughness),
      this.metalness !== void 0 && (g.metalness = this.metalness),
      this.sheen !== void 0 && (g.sheen = this.sheen),
      this.sheenColor && this.sheenColor.isColor && (g.sheenColor = this.sheenColor.getHex()),
      this.sheenRoughness !== void 0 && (g.sheenRoughness = this.sheenRoughness),
      this.emissive && this.emissive.isColor && (g.emissive = this.emissive.getHex()),
      this.emissiveIntensity !== void 0 &&
        this.emissiveIntensity !== 1 &&
        (g.emissiveIntensity = this.emissiveIntensity),
      this.specular && this.specular.isColor && (g.specular = this.specular.getHex()),
      this.specularIntensity !== void 0 && (g.specularIntensity = this.specularIntensity),
      this.specularColor &&
        this.specularColor.isColor &&
        (g.specularColor = this.specularColor.getHex()),
      this.shininess !== void 0 && (g.shininess = this.shininess),
      this.clearcoat !== void 0 && (g.clearcoat = this.clearcoat),
      this.clearcoatRoughness !== void 0 && (g.clearcoatRoughness = this.clearcoatRoughness),
      this.clearcoatMap &&
        this.clearcoatMap.isTexture &&
        (g.clearcoatMap = this.clearcoatMap.toJSON(A).uuid),
      this.clearcoatRoughnessMap &&
        this.clearcoatRoughnessMap.isTexture &&
        (g.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(A).uuid),
      this.clearcoatNormalMap &&
        this.clearcoatNormalMap.isTexture &&
        ((g.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(A).uuid),
        (g.clearcoatNormalScale = this.clearcoatNormalScale.toArray())),
      this.dispersion !== void 0 && (g.dispersion = this.dispersion),
      this.iridescence !== void 0 && (g.iridescence = this.iridescence),
      this.iridescenceIOR !== void 0 && (g.iridescenceIOR = this.iridescenceIOR),
      this.iridescenceThicknessRange !== void 0 &&
        (g.iridescenceThicknessRange = this.iridescenceThicknessRange),
      this.iridescenceMap &&
        this.iridescenceMap.isTexture &&
        (g.iridescenceMap = this.iridescenceMap.toJSON(A).uuid),
      this.iridescenceThicknessMap &&
        this.iridescenceThicknessMap.isTexture &&
        (g.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(A).uuid),
      this.anisotropy !== void 0 && (g.anisotropy = this.anisotropy),
      this.anisotropyRotation !== void 0 && (g.anisotropyRotation = this.anisotropyRotation),
      this.anisotropyMap &&
        this.anisotropyMap.isTexture &&
        (g.anisotropyMap = this.anisotropyMap.toJSON(A).uuid),
      this.map && this.map.isTexture && (g.map = this.map.toJSON(A).uuid),
      this.matcap && this.matcap.isTexture && (g.matcap = this.matcap.toJSON(A).uuid),
      this.alphaMap && this.alphaMap.isTexture && (g.alphaMap = this.alphaMap.toJSON(A).uuid),
      this.lightMap &&
        this.lightMap.isTexture &&
        ((g.lightMap = this.lightMap.toJSON(A).uuid),
        (g.lightMapIntensity = this.lightMapIntensity)),
      this.aoMap &&
        this.aoMap.isTexture &&
        ((g.aoMap = this.aoMap.toJSON(A).uuid), (g.aoMapIntensity = this.aoMapIntensity)),
      this.bumpMap &&
        this.bumpMap.isTexture &&
        ((g.bumpMap = this.bumpMap.toJSON(A).uuid), (g.bumpScale = this.bumpScale)),
      this.normalMap &&
        this.normalMap.isTexture &&
        ((g.normalMap = this.normalMap.toJSON(A).uuid),
        (g.normalMapType = this.normalMapType),
        (g.normalScale = this.normalScale.toArray())),
      this.displacementMap &&
        this.displacementMap.isTexture &&
        ((g.displacementMap = this.displacementMap.toJSON(A).uuid),
        (g.displacementScale = this.displacementScale),
        (g.displacementBias = this.displacementBias)),
      this.roughnessMap &&
        this.roughnessMap.isTexture &&
        (g.roughnessMap = this.roughnessMap.toJSON(A).uuid),
      this.metalnessMap &&
        this.metalnessMap.isTexture &&
        (g.metalnessMap = this.metalnessMap.toJSON(A).uuid),
      this.emissiveMap &&
        this.emissiveMap.isTexture &&
        (g.emissiveMap = this.emissiveMap.toJSON(A).uuid),
      this.specularMap &&
        this.specularMap.isTexture &&
        (g.specularMap = this.specularMap.toJSON(A).uuid),
      this.specularIntensityMap &&
        this.specularIntensityMap.isTexture &&
        (g.specularIntensityMap = this.specularIntensityMap.toJSON(A).uuid),
      this.specularColorMap &&
        this.specularColorMap.isTexture &&
        (g.specularColorMap = this.specularColorMap.toJSON(A).uuid),
      this.envMap &&
        this.envMap.isTexture &&
        ((g.envMap = this.envMap.toJSON(A).uuid),
        this.combine !== void 0 && (g.combine = this.combine)),
      this.envMapRotation !== void 0 && (g.envMapRotation = this.envMapRotation.toArray()),
      this.envMapIntensity !== void 0 && (g.envMapIntensity = this.envMapIntensity),
      this.reflectivity !== void 0 && (g.reflectivity = this.reflectivity),
      this.refractionRatio !== void 0 && (g.refractionRatio = this.refractionRatio),
      this.gradientMap &&
        this.gradientMap.isTexture &&
        (g.gradientMap = this.gradientMap.toJSON(A).uuid),
      this.transmission !== void 0 && (g.transmission = this.transmission),
      this.transmissionMap &&
        this.transmissionMap.isTexture &&
        (g.transmissionMap = this.transmissionMap.toJSON(A).uuid),
      this.thickness !== void 0 && (g.thickness = this.thickness),
      this.thicknessMap &&
        this.thicknessMap.isTexture &&
        (g.thicknessMap = this.thicknessMap.toJSON(A).uuid),
      this.attenuationDistance !== void 0 &&
        this.attenuationDistance !== 1 / 0 &&
        (g.attenuationDistance = this.attenuationDistance),
      this.attenuationColor !== void 0 && (g.attenuationColor = this.attenuationColor.getHex()),
      this.size !== void 0 && (g.size = this.size),
      this.shadowSide !== null && (g.shadowSide = this.shadowSide),
      this.sizeAttenuation !== void 0 && (g.sizeAttenuation = this.sizeAttenuation),
      this.blending !== Ff && (g.blending = this.blending),
      this.side !== Us && (g.side = this.side),
      this.vertexColors === !0 && (g.vertexColors = !0),
      this.opacity < 1 && (g.opacity = this.opacity),
      this.transparent === !0 && (g.transparent = !0),
      this.blendSrc !== HU && (g.blendSrc = this.blendSrc),
      this.blendDst !== TU && (g.blendDst = this.blendDst),
      this.blendEquation !== yD && (g.blendEquation = this.blendEquation),
      this.blendSrcAlpha !== null && (g.blendSrcAlpha = this.blendSrcAlpha),
      this.blendDstAlpha !== null && (g.blendDstAlpha = this.blendDstAlpha),
      this.blendEquationAlpha !== null && (g.blendEquationAlpha = this.blendEquationAlpha),
      this.blendColor && this.blendColor.isColor && (g.blendColor = this.blendColor.getHex()),
      this.blendAlpha !== 0 && (g.blendAlpha = this.blendAlpha),
      this.depthFunc !== Lf && (g.depthFunc = this.depthFunc),
      this.depthTest === !1 && (g.depthTest = this.depthTest),
      this.depthWrite === !1 && (g.depthWrite = this.depthWrite),
      this.colorWrite === !1 && (g.colorWrite = this.colorWrite),
      this.stencilWriteMask !== 255 && (g.stencilWriteMask = this.stencilWriteMask),
      this.stencilFunc !== hm && (g.stencilFunc = this.stencilFunc),
      this.stencilRef !== 0 && (g.stencilRef = this.stencilRef),
      this.stencilFuncMask !== 255 && (g.stencilFuncMask = this.stencilFuncMask),
      this.stencilFail !== ff && (g.stencilFail = this.stencilFail),
      this.stencilZFail !== ff && (g.stencilZFail = this.stencilZFail),
      this.stencilZPass !== ff && (g.stencilZPass = this.stencilZPass),
      this.stencilWrite === !0 && (g.stencilWrite = this.stencilWrite),
      this.rotation !== void 0 && this.rotation !== 0 && (g.rotation = this.rotation),
      this.polygonOffset === !0 && (g.polygonOffset = !0),
      this.polygonOffsetFactor !== 0 && (g.polygonOffsetFactor = this.polygonOffsetFactor),
      this.polygonOffsetUnits !== 0 && (g.polygonOffsetUnits = this.polygonOffsetUnits),
      this.linewidth !== void 0 && this.linewidth !== 1 && (g.linewidth = this.linewidth),
      this.dashSize !== void 0 && (g.dashSize = this.dashSize),
      this.gapSize !== void 0 && (g.gapSize = this.gapSize),
      this.scale !== void 0 && (g.scale = this.scale),
      this.dithering === !0 && (g.dithering = !0),
      this.alphaTest > 0 && (g.alphaTest = this.alphaTest),
      this.alphaHash === !0 && (g.alphaHash = !0),
      this.alphaToCoverage === !0 && (g.alphaToCoverage = !0),
      this.premultipliedAlpha === !0 && (g.premultipliedAlpha = !0),
      this.forceSinglePass === !0 && (g.forceSinglePass = !0),
      this.wireframe === !0 && (g.wireframe = !0),
      this.wireframeLinewidth > 1 && (g.wireframeLinewidth = this.wireframeLinewidth),
      this.wireframeLinecap !== "round" && (g.wireframeLinecap = this.wireframeLinecap),
      this.wireframeLinejoin !== "round" && (g.wireframeLinejoin = this.wireframeLinejoin),
      this.flatShading === !0 && (g.flatShading = !0),
      this.visible === !1 && (g.visible = !1),
      this.toneMapped === !1 && (g.toneMapped = !1),
      this.fog === !1 && (g.fog = !1),
      Object.keys(this.userData).length > 0 && (g.userData = this.userData))
    function C(i) {
      const B = []
      for (const o in i) {
        const r = i[o]
        ;(delete r.metadata, B.push(r))
      }
      return B
    }
    if (I) {
      const i = C(A.textures),
        B = C(A.images)
      ;(i.length > 0 && (g.textures = i), B.length > 0 && (g.images = B))
    }
    return g
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(A) {
    ;((this.name = A.name),
      (this.blending = A.blending),
      (this.side = A.side),
      (this.vertexColors = A.vertexColors),
      (this.opacity = A.opacity),
      (this.transparent = A.transparent),
      (this.blendSrc = A.blendSrc),
      (this.blendDst = A.blendDst),
      (this.blendEquation = A.blendEquation),
      (this.blendSrcAlpha = A.blendSrcAlpha),
      (this.blendDstAlpha = A.blendDstAlpha),
      (this.blendEquationAlpha = A.blendEquationAlpha),
      this.blendColor.copy(A.blendColor),
      (this.blendAlpha = A.blendAlpha),
      (this.depthFunc = A.depthFunc),
      (this.depthTest = A.depthTest),
      (this.depthWrite = A.depthWrite),
      (this.stencilWriteMask = A.stencilWriteMask),
      (this.stencilFunc = A.stencilFunc),
      (this.stencilRef = A.stencilRef),
      (this.stencilFuncMask = A.stencilFuncMask),
      (this.stencilFail = A.stencilFail),
      (this.stencilZFail = A.stencilZFail),
      (this.stencilZPass = A.stencilZPass),
      (this.stencilWrite = A.stencilWrite))
    const I = A.clippingPlanes
    let g = null
    if (I !== null) {
      const C = I.length
      g = new Array(C)
      for (let i = 0; i !== C; ++i) g[i] = I[i].clone()
    }
    return (
      (this.clippingPlanes = g),
      (this.clipIntersection = A.clipIntersection),
      (this.clipShadows = A.clipShadows),
      (this.shadowSide = A.shadowSide),
      (this.colorWrite = A.colorWrite),
      (this.precision = A.precision),
      (this.polygonOffset = A.polygonOffset),
      (this.polygonOffsetFactor = A.polygonOffsetFactor),
      (this.polygonOffsetUnits = A.polygonOffsetUnits),
      (this.dithering = A.dithering),
      (this.alphaTest = A.alphaTest),
      (this.alphaHash = A.alphaHash),
      (this.alphaToCoverage = A.alphaToCoverage),
      (this.premultipliedAlpha = A.premultipliedAlpha),
      (this.forceSinglePass = A.forceSinglePass),
      (this.visible = A.visible),
      (this.toneMapped = A.toneMapped),
      (this.userData = JSON.parse(JSON.stringify(A.userData))),
      this
    )
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" })
  }
  set needsUpdate(A) {
    A === !0 && this.version++
  }
  onBuild() {
    console.warn("Material: onBuild() has been removed.")
  }
}
class La extends tQ {
  static get type() {
    return "MeshBasicMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isMeshBasicMaterial = !0),
      (this.color = new Mg(16777215)),
      (this.map = null),
      (this.lightMap = null),
      (this.lightMapIntensity = 1),
      (this.aoMap = null),
      (this.aoMapIntensity = 1),
      (this.specularMap = null),
      (this.alphaMap = null),
      (this.envMap = null),
      (this.envMapRotation = new uE()),
      (this.combine = MG),
      (this.reflectivity = 1),
      (this.refractionRatio = 0.98),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.wireframeLinecap = "round"),
      (this.wireframeLinejoin = "round"),
      (this.fog = !0),
      this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      this.color.copy(A.color),
      (this.map = A.map),
      (this.lightMap = A.lightMap),
      (this.lightMapIntensity = A.lightMapIntensity),
      (this.aoMap = A.aoMap),
      (this.aoMapIntensity = A.aoMapIntensity),
      (this.specularMap = A.specularMap),
      (this.alphaMap = A.alphaMap),
      (this.envMap = A.envMap),
      this.envMapRotation.copy(A.envMapRotation),
      (this.combine = A.combine),
      (this.reflectivity = A.reflectivity),
      (this.refractionRatio = A.refractionRatio),
      (this.wireframe = A.wireframe),
      (this.wireframeLinewidth = A.wireframeLinewidth),
      (this.wireframeLinecap = A.wireframeLinecap),
      (this.wireframeLinejoin = A.wireframeLinejoin),
      (this.fog = A.fog),
      this
    )
  }
}
const Au = /* @__PURE__ */ yZ()
function yZ() {
  const e = new ArrayBuffer(4),
    A = new Float32Array(e),
    I = new Uint32Array(e),
    g = new Uint32Array(512),
    C = new Uint32Array(512)
  for (let r = 0; r < 256; ++r) {
    const s = r - 127
    s < -27
      ? ((g[r] = 0), (g[r | 256] = 32768), (C[r] = 24), (C[r | 256] = 24))
      : s < -14
        ? ((g[r] = 1024 >> (-s - 14)),
          (g[r | 256] = (1024 >> (-s - 14)) | 32768),
          (C[r] = -s - 1),
          (C[r | 256] = -s - 1))
        : s <= 15
          ? ((g[r] = (s + 15) << 10),
            (g[r | 256] = ((s + 15) << 10) | 32768),
            (C[r] = 13),
            (C[r | 256] = 13))
          : s < 128
            ? ((g[r] = 31744), (g[r | 256] = 64512), (C[r] = 24), (C[r | 256] = 24))
            : ((g[r] = 31744), (g[r | 256] = 64512), (C[r] = 13), (C[r | 256] = 13))
  }
  const i = new Uint32Array(2048),
    B = new Uint32Array(64),
    o = new Uint32Array(64)
  for (let r = 1; r < 1024; ++r) {
    let s = r << 13,
      h = 0
    for (; !(s & 8388608); ) ((s <<= 1), (h -= 8388608))
    ;((s &= -8388609), (h += 947912704), (i[r] = s | h))
  }
  for (let r = 1024; r < 2048; ++r) i[r] = 939524096 + ((r - 1024) << 13)
  for (let r = 1; r < 31; ++r) B[r] = r << 23
  ;((B[31] = 1199570944), (B[32] = 2147483648))
  for (let r = 33; r < 63; ++r) B[r] = 2147483648 + ((r - 32) << 23)
  B[63] = 3347054592
  for (let r = 1; r < 64; ++r) r !== 32 && (o[r] = 1024)
  return {
    floatView: A,
    uint32View: I,
    baseTable: g,
    shiftTable: C,
    mantissaTable: i,
    exponentTable: B,
    offsetTable: o,
  }
}
function ma(e) {
  ;(Math.abs(e) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."),
    (e = eQ(e, -65504, 65504)),
    (Au.floatView[0] = e))
  const A = Au.uint32View[0],
    I = (A >> 23) & 511
  return Au.baseTable[I] + ((A & 8388607) >> Au.shiftTable[I])
}
function _0(e) {
  const A = e >> 10
  return (
    (Au.uint32View[0] = Au.mantissaTable[Au.offsetTable[A] + (e & 1023)] + Au.exponentTable[A]),
    Au.floatView[0]
  )
}
const pZ = {
    toHalfFloat: ma,
    fromHalfFloat: _0,
  },
  _Q = /* @__PURE__ */ new wA(),
  TM = /* @__PURE__ */ new ZI()
class Ye {
  constructor(A, I, g = !1) {
    if (Array.isArray(A))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.")
    ;((this.isBufferAttribute = !0),
      (this.name = ""),
      (this.array = A),
      (this.itemSize = I),
      (this.count = A !== void 0 ? A.length / I : 0),
      (this.normalized = g),
      (this.usage = rG),
      (this.updateRanges = []),
      (this.gpuType = sE),
      (this.version = 0))
  }
  onUploadCallback() {}
  set needsUpdate(A) {
    A === !0 && this.version++
  }
  setUsage(A) {
    return ((this.usage = A), this)
  }
  addUpdateRange(A, I) {
    this.updateRanges.push({ start: A, count: I })
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0
  }
  copy(A) {
    return (
      (this.name = A.name),
      (this.array = new A.array.constructor(A.array)),
      (this.itemSize = A.itemSize),
      (this.count = A.count),
      (this.normalized = A.normalized),
      (this.usage = A.usage),
      (this.gpuType = A.gpuType),
      this
    )
  }
  copyAt(A, I, g) {
    ;((A *= this.itemSize), (g *= I.itemSize))
    for (let C = 0, i = this.itemSize; C < i; C++) this.array[A + C] = I.array[g + C]
    return this
  }
  copyArray(A) {
    return (this.array.set(A), this)
  }
  applyMatrix3(A) {
    if (this.itemSize === 2)
      for (let I = 0, g = this.count; I < g; I++)
        (TM.fromBufferAttribute(this, I), TM.applyMatrix3(A), this.setXY(I, TM.x, TM.y))
    else if (this.itemSize === 3)
      for (let I = 0, g = this.count; I < g; I++)
        (_Q.fromBufferAttribute(this, I), _Q.applyMatrix3(A), this.setXYZ(I, _Q.x, _Q.y, _Q.z))
    return this
  }
  applyMatrix4(A) {
    for (let I = 0, g = this.count; I < g; I++)
      (_Q.fromBufferAttribute(this, I), _Q.applyMatrix4(A), this.setXYZ(I, _Q.x, _Q.y, _Q.z))
    return this
  }
  applyNormalMatrix(A) {
    for (let I = 0, g = this.count; I < g; I++)
      (_Q.fromBufferAttribute(this, I), _Q.applyNormalMatrix(A), this.setXYZ(I, _Q.x, _Q.y, _Q.z))
    return this
  }
  transformDirection(A) {
    for (let I = 0, g = this.count; I < g; I++)
      (_Q.fromBufferAttribute(this, I), _Q.transformDirection(A), this.setXYZ(I, _Q.x, _Q.y, _Q.z))
    return this
  }
  set(A, I = 0) {
    return (this.array.set(A, I), this)
  }
  getComponent(A, I) {
    let g = this.array[A * this.itemSize + I]
    return (this.normalized && (g = zE(g, this.array)), g)
  }
  setComponent(A, I, g) {
    return (
      this.normalized && (g = ye(g, this.array)),
      (this.array[A * this.itemSize + I] = g),
      this
    )
  }
  getX(A) {
    let I = this.array[A * this.itemSize]
    return (this.normalized && (I = zE(I, this.array)), I)
  }
  setX(A, I) {
    return (this.normalized && (I = ye(I, this.array)), (this.array[A * this.itemSize] = I), this)
  }
  getY(A) {
    let I = this.array[A * this.itemSize + 1]
    return (this.normalized && (I = zE(I, this.array)), I)
  }
  setY(A, I) {
    return (
      this.normalized && (I = ye(I, this.array)),
      (this.array[A * this.itemSize + 1] = I),
      this
    )
  }
  getZ(A) {
    let I = this.array[A * this.itemSize + 2]
    return (this.normalized && (I = zE(I, this.array)), I)
  }
  setZ(A, I) {
    return (
      this.normalized && (I = ye(I, this.array)),
      (this.array[A * this.itemSize + 2] = I),
      this
    )
  }
  getW(A) {
    let I = this.array[A * this.itemSize + 3]
    return (this.normalized && (I = zE(I, this.array)), I)
  }
  setW(A, I) {
    return (
      this.normalized && (I = ye(I, this.array)),
      (this.array[A * this.itemSize + 3] = I),
      this
    )
  }
  setXY(A, I, g) {
    return (
      (A *= this.itemSize),
      this.normalized && ((I = ye(I, this.array)), (g = ye(g, this.array))),
      (this.array[A + 0] = I),
      (this.array[A + 1] = g),
      this
    )
  }
  setXYZ(A, I, g, C) {
    return (
      (A *= this.itemSize),
      this.normalized &&
        ((I = ye(I, this.array)), (g = ye(g, this.array)), (C = ye(C, this.array))),
      (this.array[A + 0] = I),
      (this.array[A + 1] = g),
      (this.array[A + 2] = C),
      this
    )
  }
  setXYZW(A, I, g, C, i) {
    return (
      (A *= this.itemSize),
      this.normalized &&
        ((I = ye(I, this.array)),
        (g = ye(g, this.array)),
        (C = ye(C, this.array)),
        (i = ye(i, this.array))),
      (this.array[A + 0] = I),
      (this.array[A + 1] = g),
      (this.array[A + 2] = C),
      (this.array[A + 3] = i),
      this
    )
  }
  onUpload(A) {
    return ((this.onUploadCallback = A), this)
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this)
  }
  toJSON() {
    const A = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized,
    }
    return (
      this.name !== "" && (A.name = this.name),
      this.usage !== rG && (A.usage = this.usage),
      A
    )
  }
}
class wZ extends Ye {
  constructor(A, I, g) {
    super(new Int8Array(A), I, g)
  }
}
class GZ extends Ye {
  constructor(A, I, g) {
    super(new Uint8Array(A), I, g)
  }
}
class kZ extends Ye {
  constructor(A, I, g) {
    super(new Uint8ClampedArray(A), I, g)
  }
}
class MZ extends Ye {
  constructor(A, I, g) {
    super(new Int16Array(A), I, g)
  }
}
class gv extends Ye {
  constructor(A, I, g) {
    super(new Uint16Array(A), I, g)
  }
}
class UZ extends Ye {
  constructor(A, I, g) {
    super(new Int32Array(A), I, g)
  }
}
class Cv extends Ye {
  constructor(A, I, g) {
    super(new Uint32Array(A), I, g)
  }
}
class NZ extends Ye {
  constructor(A, I, g) {
    ;(super(new Uint16Array(A), I, g), (this.isFloat16BufferAttribute = !0))
  }
  getX(A) {
    let I = _0(this.array[A * this.itemSize])
    return (this.normalized && (I = zE(I, this.array)), I)
  }
  setX(A, I) {
    return (
      this.normalized && (I = ye(I, this.array)),
      (this.array[A * this.itemSize] = ma(I)),
      this
    )
  }
  getY(A) {
    let I = _0(this.array[A * this.itemSize + 1])
    return (this.normalized && (I = zE(I, this.array)), I)
  }
  setY(A, I) {
    return (
      this.normalized && (I = ye(I, this.array)),
      (this.array[A * this.itemSize + 1] = ma(I)),
      this
    )
  }
  getZ(A) {
    let I = _0(this.array[A * this.itemSize + 2])
    return (this.normalized && (I = zE(I, this.array)), I)
  }
  setZ(A, I) {
    return (
      this.normalized && (I = ye(I, this.array)),
      (this.array[A * this.itemSize + 2] = ma(I)),
      this
    )
  }
  getW(A) {
    let I = _0(this.array[A * this.itemSize + 3])
    return (this.normalized && (I = zE(I, this.array)), I)
  }
  setW(A, I) {
    return (
      this.normalized && (I = ye(I, this.array)),
      (this.array[A * this.itemSize + 3] = ma(I)),
      this
    )
  }
  setXY(A, I, g) {
    return (
      (A *= this.itemSize),
      this.normalized && ((I = ye(I, this.array)), (g = ye(g, this.array))),
      (this.array[A + 0] = ma(I)),
      (this.array[A + 1] = ma(g)),
      this
    )
  }
  setXYZ(A, I, g, C) {
    return (
      (A *= this.itemSize),
      this.normalized &&
        ((I = ye(I, this.array)), (g = ye(g, this.array)), (C = ye(C, this.array))),
      (this.array[A + 0] = ma(I)),
      (this.array[A + 1] = ma(g)),
      (this.array[A + 2] = ma(C)),
      this
    )
  }
  setXYZW(A, I, g, C, i) {
    return (
      (A *= this.itemSize),
      this.normalized &&
        ((I = ye(I, this.array)),
        (g = ye(g, this.array)),
        (C = ye(C, this.array)),
        (i = ye(i, this.array))),
      (this.array[A + 0] = ma(I)),
      (this.array[A + 1] = ma(g)),
      (this.array[A + 2] = ma(C)),
      (this.array[A + 3] = ma(i)),
      this
    )
  }
}
class aC extends Ye {
  constructor(A, I, g) {
    super(new Float32Array(A), I, g)
  }
}
let FZ = 0
const fs = /* @__PURE__ */ new RC(),
  EK = /* @__PURE__ */ new Ci(),
  Yy = /* @__PURE__ */ new wA(),
  Jr = /* @__PURE__ */ new Vo(),
  U0 = /* @__PURE__ */ new Vo(),
  Zo = /* @__PURE__ */ new wA()
class se extends qr {
  constructor() {
    ;(super(),
      (this.isBufferGeometry = !0),
      Object.defineProperty(this, "id", { value: FZ++ }),
      (this.uuid = Lr()),
      (this.name = ""),
      (this.type = "BufferGeometry"),
      (this.index = null),
      (this.indirect = null),
      (this.attributes = {}),
      (this.morphAttributes = {}),
      (this.morphTargetsRelative = !1),
      (this.groups = []),
      (this.boundingBox = null),
      (this.boundingSphere = null),
      (this.drawRange = { start: 0, count: 1 / 0 }),
      (this.userData = {}))
  }
  getIndex() {
    return this.index
  }
  setIndex(A) {
    return (Array.isArray(A) ? (this.index = new (T2(A) ? Cv : gv)(A, 1)) : (this.index = A), this)
  }
  setIndirect(A) {
    return ((this.indirect = A), this)
  }
  getIndirect() {
    return this.indirect
  }
  getAttribute(A) {
    return this.attributes[A]
  }
  setAttribute(A, I) {
    return ((this.attributes[A] = I), this)
  }
  deleteAttribute(A) {
    return (delete this.attributes[A], this)
  }
  hasAttribute(A) {
    return this.attributes[A] !== void 0
  }
  addGroup(A, I, g = 0) {
    this.groups.push({
      start: A,
      count: I,
      materialIndex: g,
    })
  }
  clearGroups() {
    this.groups = []
  }
  setDrawRange(A, I) {
    ;((this.drawRange.start = A), (this.drawRange.count = I))
  }
  applyMatrix4(A) {
    const I = this.attributes.position
    I !== void 0 && (I.applyMatrix4(A), (I.needsUpdate = !0))
    const g = this.attributes.normal
    if (g !== void 0) {
      const i = new ce().getNormalMatrix(A)
      ;(g.applyNormalMatrix(i), (g.needsUpdate = !0))
    }
    const C = this.attributes.tangent
    return (
      C !== void 0 && (C.transformDirection(A), (C.needsUpdate = !0)),
      this.boundingBox !== null && this.computeBoundingBox(),
      this.boundingSphere !== null && this.computeBoundingSphere(),
      this
    )
  }
  applyQuaternion(A) {
    return (fs.makeRotationFromQuaternion(A), this.applyMatrix4(fs), this)
  }
  rotateX(A) {
    return (fs.makeRotationX(A), this.applyMatrix4(fs), this)
  }
  rotateY(A) {
    return (fs.makeRotationY(A), this.applyMatrix4(fs), this)
  }
  rotateZ(A) {
    return (fs.makeRotationZ(A), this.applyMatrix4(fs), this)
  }
  translate(A, I, g) {
    return (fs.makeTranslation(A, I, g), this.applyMatrix4(fs), this)
  }
  scale(A, I, g) {
    return (fs.makeScale(A, I, g), this.applyMatrix4(fs), this)
  }
  lookAt(A) {
    return (EK.lookAt(A), EK.updateMatrix(), this.applyMatrix4(EK.matrix), this)
  }
  center() {
    return (
      this.computeBoundingBox(),
      this.boundingBox.getCenter(Yy).negate(),
      this.translate(Yy.x, Yy.y, Yy.z),
      this
    )
  }
  setFromPoints(A) {
    const I = this.getAttribute("position")
    if (I === void 0) {
      const g = []
      for (let C = 0, i = A.length; C < i; C++) {
        const B = A[C]
        g.push(B.x, B.y, B.z || 0)
      }
      this.setAttribute("position", new aC(g, 3))
    } else {
      for (let g = 0, C = I.count; g < C; g++) {
        const i = A[g]
        I.setXYZ(g, i.x, i.y, i.z || 0)
      }
      ;(A.length > I.count &&
        console.warn(
          "THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.",
        ),
        (I.needsUpdate = !0))
    }
    return this
  }
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new Vo())
    const A = this.attributes.position,
      I = this.morphAttributes.position
    if (A && A.isGLBufferAttribute) {
      ;(console.error(
        "THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.",
        this,
      ),
        this.boundingBox.set(new wA(-1 / 0, -1 / 0, -1 / 0), new wA(1 / 0, 1 / 0, 1 / 0)))
      return
    }
    if (A !== void 0) {
      if ((this.boundingBox.setFromBufferAttribute(A), I))
        for (let g = 0, C = I.length; g < C; g++) {
          const i = I[g]
          ;(Jr.setFromBufferAttribute(i),
            this.morphTargetsRelative
              ? (Zo.addVectors(this.boundingBox.min, Jr.min),
                this.boundingBox.expandByPoint(Zo),
                Zo.addVectors(this.boundingBox.max, Jr.max),
                this.boundingBox.expandByPoint(Zo))
              : (this.boundingBox.expandByPoint(Jr.min), this.boundingBox.expandByPoint(Jr.max)))
        }
    } else this.boundingBox.makeEmpty()
    ;(isNaN(this.boundingBox.min.x) ||
      isNaN(this.boundingBox.min.y) ||
      isNaN(this.boundingBox.min.z)) &&
      console.error(
        'THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.',
        this,
      )
  }
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new jo())
    const A = this.attributes.position,
      I = this.morphAttributes.position
    if (A && A.isGLBufferAttribute) {
      ;(console.error(
        "THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.",
        this,
      ),
        this.boundingSphere.set(new wA(), 1 / 0))
      return
    }
    if (A) {
      const g = this.boundingSphere.center
      if ((Jr.setFromBufferAttribute(A), I))
        for (let i = 0, B = I.length; i < B; i++) {
          const o = I[i]
          ;(U0.setFromBufferAttribute(o),
            this.morphTargetsRelative
              ? (Zo.addVectors(Jr.min, U0.min),
                Jr.expandByPoint(Zo),
                Zo.addVectors(Jr.max, U0.max),
                Jr.expandByPoint(Zo))
              : (Jr.expandByPoint(U0.min), Jr.expandByPoint(U0.max)))
        }
      Jr.getCenter(g)
      let C = 0
      for (let i = 0, B = A.count; i < B; i++)
        (Zo.fromBufferAttribute(A, i), (C = Math.max(C, g.distanceToSquared(Zo))))
      if (I)
        for (let i = 0, B = I.length; i < B; i++) {
          const o = I[i],
            r = this.morphTargetsRelative
          for (let s = 0, h = o.count; s < h; s++)
            (Zo.fromBufferAttribute(o, s),
              r && (Yy.fromBufferAttribute(A, s), Zo.add(Yy)),
              (C = Math.max(C, g.distanceToSquared(Zo))))
        }
      ;((this.boundingSphere.radius = Math.sqrt(C)),
        isNaN(this.boundingSphere.radius) &&
          console.error(
            'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.',
            this,
          ))
    }
  }
  computeTangents() {
    const A = this.index,
      I = this.attributes
    if (A === null || I.position === void 0 || I.normal === void 0 || I.uv === void 0) {
      console.error(
        "THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)",
      )
      return
    }
    const g = I.position,
      C = I.normal,
      i = I.uv
    this.hasAttribute("tangent") === !1 &&
      this.setAttribute("tangent", new Ye(new Float32Array(4 * g.count), 4))
    const B = this.getAttribute("tangent"),
      o = [],
      r = []
    for (let AA = 0; AA < g.count; AA++) ((o[AA] = new wA()), (r[AA] = new wA()))
    const s = new wA(),
      h = new wA(),
      S = new wA(),
      d = new ZI(),
      w = new ZI(),
      M = new ZI(),
      K = new wA(),
      R = new wA()
    function F(AA, X, _) {
      ;(s.fromBufferAttribute(g, AA),
        h.fromBufferAttribute(g, X),
        S.fromBufferAttribute(g, _),
        d.fromBufferAttribute(i, AA),
        w.fromBufferAttribute(i, X),
        M.fromBufferAttribute(i, _),
        h.sub(s),
        S.sub(s),
        w.sub(d),
        M.sub(d))
      const eA = 1 / (w.x * M.y - M.x * w.y)
      isFinite(eA) &&
        (K.copy(h).multiplyScalar(M.y).addScaledVector(S, -w.y).multiplyScalar(eA),
        R.copy(S).multiplyScalar(w.x).addScaledVector(h, -M.x).multiplyScalar(eA),
        o[AA].add(K),
        o[X].add(K),
        o[_].add(K),
        r[AA].add(R),
        r[X].add(R),
        r[_].add(R))
    }
    let L = this.groups
    L.length === 0 &&
      (L = [
        {
          start: 0,
          count: A.count,
        },
      ])
    for (let AA = 0, X = L.length; AA < X; ++AA) {
      const _ = L[AA],
        eA = _.start,
        CA = _.count
      for (let aA = eA, lA = eA + CA; aA < lA; aA += 3)
        F(A.getX(aA + 0), A.getX(aA + 1), A.getX(aA + 2))
    }
    const Y = new wA(),
      H = new wA(),
      V = new wA(),
      j = new wA()
    function P(AA) {
      ;(V.fromBufferAttribute(C, AA), j.copy(V))
      const X = o[AA]
      ;(Y.copy(X), Y.sub(V.multiplyScalar(V.dot(X))).normalize(), H.crossVectors(j, X))
      const eA = H.dot(r[AA]) < 0 ? -1 : 1
      B.setXYZW(AA, Y.x, Y.y, Y.z, eA)
    }
    for (let AA = 0, X = L.length; AA < X; ++AA) {
      const _ = L[AA],
        eA = _.start,
        CA = _.count
      for (let aA = eA, lA = eA + CA; aA < lA; aA += 3)
        (P(A.getX(aA + 0)), P(A.getX(aA + 1)), P(A.getX(aA + 2)))
    }
  }
  computeVertexNormals() {
    const A = this.index,
      I = this.getAttribute("position")
    if (I !== void 0) {
      let g = this.getAttribute("normal")
      if (g === void 0)
        ((g = new Ye(new Float32Array(I.count * 3), 3)), this.setAttribute("normal", g))
      else for (let d = 0, w = g.count; d < w; d++) g.setXYZ(d, 0, 0, 0)
      const C = new wA(),
        i = new wA(),
        B = new wA(),
        o = new wA(),
        r = new wA(),
        s = new wA(),
        h = new wA(),
        S = new wA()
      if (A)
        for (let d = 0, w = A.count; d < w; d += 3) {
          const M = A.getX(d + 0),
            K = A.getX(d + 1),
            R = A.getX(d + 2)
          ;(C.fromBufferAttribute(I, M),
            i.fromBufferAttribute(I, K),
            B.fromBufferAttribute(I, R),
            h.subVectors(B, i),
            S.subVectors(C, i),
            h.cross(S),
            o.fromBufferAttribute(g, M),
            r.fromBufferAttribute(g, K),
            s.fromBufferAttribute(g, R),
            o.add(h),
            r.add(h),
            s.add(h),
            g.setXYZ(M, o.x, o.y, o.z),
            g.setXYZ(K, r.x, r.y, r.z),
            g.setXYZ(R, s.x, s.y, s.z))
        }
      else
        for (let d = 0, w = I.count; d < w; d += 3)
          (C.fromBufferAttribute(I, d + 0),
            i.fromBufferAttribute(I, d + 1),
            B.fromBufferAttribute(I, d + 2),
            h.subVectors(B, i),
            S.subVectors(C, i),
            h.cross(S),
            g.setXYZ(d + 0, h.x, h.y, h.z),
            g.setXYZ(d + 1, h.x, h.y, h.z),
            g.setXYZ(d + 2, h.x, h.y, h.z))
      ;(this.normalizeNormals(), (g.needsUpdate = !0))
    }
  }
  normalizeNormals() {
    const A = this.attributes.normal
    for (let I = 0, g = A.count; I < g; I++)
      (Zo.fromBufferAttribute(A, I), Zo.normalize(), A.setXYZ(I, Zo.x, Zo.y, Zo.z))
  }
  toNonIndexed() {
    function A(o, r) {
      const s = o.array,
        h = o.itemSize,
        S = o.normalized,
        d = new s.constructor(r.length * h)
      let w = 0,
        M = 0
      for (let K = 0, R = r.length; K < R; K++) {
        o.isInterleavedBufferAttribute ? (w = r[K] * o.data.stride + o.offset) : (w = r[K] * h)
        for (let F = 0; F < h; F++) d[M++] = s[w++]
      }
      return new Ye(d, h, S)
    }
    if (this.index === null)
      return (
        console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."),
        this
      )
    const I = new se(),
      g = this.index.array,
      C = this.attributes
    for (const o in C) {
      const r = C[o],
        s = A(r, g)
      I.setAttribute(o, s)
    }
    const i = this.morphAttributes
    for (const o in i) {
      const r = [],
        s = i[o]
      for (let h = 0, S = s.length; h < S; h++) {
        const d = s[h],
          w = A(d, g)
        r.push(w)
      }
      I.morphAttributes[o] = r
    }
    I.morphTargetsRelative = this.morphTargetsRelative
    const B = this.groups
    for (let o = 0, r = B.length; o < r; o++) {
      const s = B[o]
      I.addGroup(s.start, s.count, s.materialIndex)
    }
    return I
  }
  toJSON() {
    const A = {
      metadata: {
        version: 4.6,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON",
      },
    }
    if (
      ((A.uuid = this.uuid),
      (A.type = this.type),
      this.name !== "" && (A.name = this.name),
      Object.keys(this.userData).length > 0 && (A.userData = this.userData),
      this.parameters !== void 0)
    ) {
      const r = this.parameters
      for (const s in r) r[s] !== void 0 && (A[s] = r[s])
      return A
    }
    A.data = { attributes: {} }
    const I = this.index
    I !== null &&
      (A.data.index = {
        type: I.array.constructor.name,
        array: Array.prototype.slice.call(I.array),
      })
    const g = this.attributes
    for (const r in g) {
      const s = g[r]
      A.data.attributes[r] = s.toJSON(A.data)
    }
    const C = {}
    let i = !1
    for (const r in this.morphAttributes) {
      const s = this.morphAttributes[r],
        h = []
      for (let S = 0, d = s.length; S < d; S++) {
        const w = s[S]
        h.push(w.toJSON(A.data))
      }
      h.length > 0 && ((C[r] = h), (i = !0))
    }
    i && ((A.data.morphAttributes = C), (A.data.morphTargetsRelative = this.morphTargetsRelative))
    const B = this.groups
    B.length > 0 && (A.data.groups = JSON.parse(JSON.stringify(B)))
    const o = this.boundingSphere
    return (
      o !== null &&
        (A.data.boundingSphere = {
          center: o.center.toArray(),
          radius: o.radius,
        }),
      A
    )
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(A) {
    ;((this.index = null),
      (this.attributes = {}),
      (this.morphAttributes = {}),
      (this.groups = []),
      (this.boundingBox = null),
      (this.boundingSphere = null))
    const I = {}
    this.name = A.name
    const g = A.index
    g !== null && this.setIndex(g.clone(I))
    const C = A.attributes
    for (const s in C) {
      const h = C[s]
      this.setAttribute(s, h.clone(I))
    }
    const i = A.morphAttributes
    for (const s in i) {
      const h = [],
        S = i[s]
      for (let d = 0, w = S.length; d < w; d++) h.push(S[d].clone(I))
      this.morphAttributes[s] = h
    }
    this.morphTargetsRelative = A.morphTargetsRelative
    const B = A.groups
    for (let s = 0, h = B.length; s < h; s++) {
      const S = B[s]
      this.addGroup(S.start, S.count, S.materialIndex)
    }
    const o = A.boundingBox
    o !== null && (this.boundingBox = o.clone())
    const r = A.boundingSphere
    return (
      r !== null && (this.boundingSphere = r.clone()),
      (this.drawRange.start = A.drawRange.start),
      (this.drawRange.count = A.drawRange.count),
      (this.userData = A.userData),
      this
    )
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" })
  }
}
const Wq = /* @__PURE__ */ new RC(),
  Bf = /* @__PURE__ */ new fp(),
  xM = /* @__PURE__ */ new jo(),
  Vq = /* @__PURE__ */ new wA(),
  bM = /* @__PURE__ */ new wA(),
  OM = /* @__PURE__ */ new wA(),
  _M = /* @__PURE__ */ new wA(),
  aK = /* @__PURE__ */ new wA(),
  ZM = /* @__PURE__ */ new wA(),
  jq = /* @__PURE__ */ new wA(),
  PM = /* @__PURE__ */ new wA()
class EB extends Ci {
  constructor(A = new se(), I = new La()) {
    ;(super(),
      (this.isMesh = !0),
      (this.type = "Mesh"),
      (this.geometry = A),
      (this.material = I),
      this.updateMorphTargets())
  }
  copy(A, I) {
    return (
      super.copy(A, I),
      A.morphTargetInfluences !== void 0 &&
        (this.morphTargetInfluences = A.morphTargetInfluences.slice()),
      A.morphTargetDictionary !== void 0 &&
        (this.morphTargetDictionary = Object.assign({}, A.morphTargetDictionary)),
      (this.material = Array.isArray(A.material) ? A.material.slice() : A.material),
      (this.geometry = A.geometry),
      this
    )
  }
  updateMorphTargets() {
    const I = this.geometry.morphAttributes,
      g = Object.keys(I)
    if (g.length > 0) {
      const C = I[g[0]]
      if (C !== void 0) {
        ;((this.morphTargetInfluences = []), (this.morphTargetDictionary = {}))
        for (let i = 0, B = C.length; i < B; i++) {
          const o = C[i].name || String(i)
          ;(this.morphTargetInfluences.push(0), (this.morphTargetDictionary[o] = i))
        }
      }
    }
  }
  getVertexPosition(A, I) {
    const g = this.geometry,
      C = g.attributes.position,
      i = g.morphAttributes.position,
      B = g.morphTargetsRelative
    I.fromBufferAttribute(C, A)
    const o = this.morphTargetInfluences
    if (i && o) {
      ZM.set(0, 0, 0)
      for (let r = 0, s = i.length; r < s; r++) {
        const h = o[r],
          S = i[r]
        h !== 0 &&
          (aK.fromBufferAttribute(S, A),
          B ? ZM.addScaledVector(aK, h) : ZM.addScaledVector(aK.sub(I), h))
      }
      I.add(ZM)
    }
    return I
  }
  raycast(A, I) {
    const g = this.geometry,
      C = this.material,
      i = this.matrixWorld
    C !== void 0 &&
      (g.boundingSphere === null && g.computeBoundingSphere(),
      xM.copy(g.boundingSphere),
      xM.applyMatrix4(i),
      Bf.copy(A.ray).recast(A.near),
      !(
        xM.containsPoint(Bf.origin) === !1 &&
        (Bf.intersectSphere(xM, Vq) === null ||
          Bf.origin.distanceToSquared(Vq) > (A.far - A.near) ** 2)
      ) &&
        (Wq.copy(i).invert(),
        Bf.copy(A.ray).applyMatrix4(Wq),
        !(g.boundingBox !== null && Bf.intersectsBox(g.boundingBox) === !1) &&
          this._computeIntersections(A, I, Bf)))
  }
  _computeIntersections(A, I, g) {
    let C
    const i = this.geometry,
      B = this.material,
      o = i.index,
      r = i.attributes.position,
      s = i.attributes.uv,
      h = i.attributes.uv1,
      S = i.attributes.normal,
      d = i.groups,
      w = i.drawRange
    if (o !== null)
      if (Array.isArray(B))
        for (let M = 0, K = d.length; M < K; M++) {
          const R = d[M],
            F = B[R.materialIndex],
            L = Math.max(R.start, w.start),
            Y = Math.min(o.count, Math.min(R.start + R.count, w.start + w.count))
          for (let H = L, V = Y; H < V; H += 3) {
            const j = o.getX(H),
              P = o.getX(H + 1),
              AA = o.getX(H + 2)
            ;((C = WM(this, F, A, g, s, h, S, j, P, AA)),
              C &&
                ((C.faceIndex = Math.floor(H / 3)),
                (C.face.materialIndex = R.materialIndex),
                I.push(C)))
          }
        }
      else {
        const M = Math.max(0, w.start),
          K = Math.min(o.count, w.start + w.count)
        for (let R = M, F = K; R < F; R += 3) {
          const L = o.getX(R),
            Y = o.getX(R + 1),
            H = o.getX(R + 2)
          ;((C = WM(this, B, A, g, s, h, S, L, Y, H)),
            C && ((C.faceIndex = Math.floor(R / 3)), I.push(C)))
        }
      }
    else if (r !== void 0)
      if (Array.isArray(B))
        for (let M = 0, K = d.length; M < K; M++) {
          const R = d[M],
            F = B[R.materialIndex],
            L = Math.max(R.start, w.start),
            Y = Math.min(r.count, Math.min(R.start + R.count, w.start + w.count))
          for (let H = L, V = Y; H < V; H += 3) {
            const j = H,
              P = H + 1,
              AA = H + 2
            ;((C = WM(this, F, A, g, s, h, S, j, P, AA)),
              C &&
                ((C.faceIndex = Math.floor(H / 3)),
                (C.face.materialIndex = R.materialIndex),
                I.push(C)))
          }
        }
      else {
        const M = Math.max(0, w.start),
          K = Math.min(r.count, w.start + w.count)
        for (let R = M, F = K; R < F; R += 3) {
          const L = R,
            Y = R + 1,
            H = R + 2
          ;((C = WM(this, B, A, g, s, h, S, L, Y, H)),
            C && ((C.faceIndex = Math.floor(R / 3)), I.push(C)))
        }
      }
  }
}
function RZ(e, A, I, g, C, i, B, o) {
  let r
  if (
    (A.side === WQ
      ? (r = g.intersectTriangle(B, i, C, !0, o))
      : (r = g.intersectTriangle(C, i, B, A.side === Us, o)),
    r === null)
  )
    return null
  ;(PM.copy(o), PM.applyMatrix4(e.matrixWorld))
  const s = I.ray.origin.distanceTo(PM)
  return s < I.near || s > I.far
    ? null
    : {
        distance: s,
        point: PM.clone(),
        object: e,
      }
}
function WM(e, A, I, g, C, i, B, o, r, s) {
  ;(e.getVertexPosition(o, bM), e.getVertexPosition(r, OM), e.getVertexPosition(s, _M))
  const h = RZ(e, A, I, g, bM, OM, _M, jq)
  if (h) {
    const S = new wA()
    ;(va.getBarycoord(jq, bM, OM, _M, S),
      C && (h.uv = va.getInterpolatedAttribute(C, o, r, s, S, new ZI())),
      i && (h.uv1 = va.getInterpolatedAttribute(i, o, r, s, S, new ZI())),
      B &&
        ((h.normal = va.getInterpolatedAttribute(B, o, r, s, S, new wA())),
        h.normal.dot(g.direction) > 0 && h.normal.multiplyScalar(-1)))
    const d = {
      a: o,
      b: r,
      c: s,
      normal: new wA(),
      materialIndex: 0,
    }
    ;(va.getNormal(bM, OM, _M, d.normal), (h.face = d), (h.barycoord = S))
  }
  return h
}
class Vf extends se {
  constructor(A = 1, I = 1, g = 1, C = 1, i = 1, B = 1) {
    ;(super(),
      (this.type = "BoxGeometry"),
      (this.parameters = {
        width: A,
        height: I,
        depth: g,
        widthSegments: C,
        heightSegments: i,
        depthSegments: B,
      }))
    const o = this
    ;((C = Math.floor(C)), (i = Math.floor(i)), (B = Math.floor(B)))
    const r = [],
      s = [],
      h = [],
      S = []
    let d = 0,
      w = 0
    ;(M("z", "y", "x", -1, -1, g, I, A, B, i, 0),
      M("z", "y", "x", 1, -1, g, I, -A, B, i, 1),
      M("x", "z", "y", 1, 1, A, g, I, C, B, 2),
      M("x", "z", "y", 1, -1, A, g, -I, C, B, 3),
      M("x", "y", "z", 1, -1, A, I, g, C, i, 4),
      M("x", "y", "z", -1, -1, A, I, -g, C, i, 5),
      this.setIndex(r),
      this.setAttribute("position", new aC(s, 3)),
      this.setAttribute("normal", new aC(h, 3)),
      this.setAttribute("uv", new aC(S, 2)))
    function M(K, R, F, L, Y, H, V, j, P, AA, X) {
      const _ = H / P,
        eA = V / AA,
        CA = H / 2,
        aA = V / 2,
        lA = j / 2,
        JA = P + 1,
        yA = AA + 1
      let LA = 0,
        nA = 0
      const fA = new wA()
      for (let sA = 0; sA < yA; sA++) {
        const $ = sA * eA - aA
        for (let EA = 0; EA < JA; EA++) {
          const GA = EA * _ - CA
          ;((fA[K] = GA * L),
            (fA[R] = $ * Y),
            (fA[F] = lA),
            s.push(fA.x, fA.y, fA.z),
            (fA[K] = 0),
            (fA[R] = 0),
            (fA[F] = j > 0 ? 1 : -1),
            h.push(fA.x, fA.y, fA.z),
            S.push(EA / P),
            S.push(1 - sA / AA),
            (LA += 1))
        }
      }
      for (let sA = 0; sA < AA; sA++)
        for (let $ = 0; $ < P; $++) {
          const EA = d + $ + JA * sA,
            GA = d + $ + JA * (sA + 1),
            DA = d + ($ + 1) + JA * (sA + 1),
            dA = d + ($ + 1) + JA * sA
          ;(r.push(EA, GA, dA), r.push(GA, DA, dA), (nA += 6))
        }
      ;(o.addGroup(w, nA, X), (w += nA), (d += LA))
    }
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
  static fromJSON(A) {
    return new Vf(A.width, A.height, A.depth, A.widthSegments, A.heightSegments, A.depthSegments)
  }
}
function rp(e) {
  const A = {}
  for (const I in e) {
    A[I] = {}
    for (const g in e[I]) {
      const C = e[I][g]
      C &&
      (C.isColor ||
        C.isMatrix3 ||
        C.isMatrix4 ||
        C.isVector2 ||
        C.isVector3 ||
        C.isVector4 ||
        C.isTexture ||
        C.isQuaternion)
        ? C.isRenderTargetTexture
          ? (console.warn(
              "UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().",
            ),
            (A[I][g] = null))
          : (A[I][g] = C.clone())
        : Array.isArray(C)
          ? (A[I][g] = C.slice())
          : (A[I][g] = C)
    }
  }
  return A
}
function jE(e) {
  const A = {}
  for (let I = 0; I < e.length; I++) {
    const g = rp(e[I])
    for (const C in g) A[C] = g[C]
  }
  return A
}
function JZ(e) {
  const A = []
  for (let I = 0; I < e.length; I++) A.push(e[I].clone())
  return A
}
function Z2(e) {
  const A = e.getRenderTarget()
  return A === null
    ? e.outputColorSpace
    : A.isXRRenderTarget === !0
      ? A.texture.colorSpace
      : ni.workingColorSpace
}
const AF = { clone: rp, merge: jE }
var KZ = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`,
  mZ = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`
class VQ extends tQ {
  static get type() {
    return "ShaderMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isShaderMaterial = !0),
      (this.defines = {}),
      (this.uniforms = {}),
      (this.uniformsGroups = []),
      (this.vertexShader = KZ),
      (this.fragmentShader = mZ),
      (this.linewidth = 1),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.fog = !1),
      (this.lights = !1),
      (this.clipping = !1),
      (this.forceSinglePass = !0),
      (this.extensions = {
        clipCullDistance: !1,
        // set to use vertex shader clipping
        multiDraw: !1,
        // set to use vertex shader multi_draw / enable gl_DrawID
      }),
      (this.defaultAttributeValues = {
        color: [1, 1, 1],
        uv: [0, 0],
        uv1: [0, 0],
      }),
      (this.index0AttributeName = void 0),
      (this.uniformsNeedUpdate = !1),
      (this.glslVersion = null),
      A !== void 0 && this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      (this.fragmentShader = A.fragmentShader),
      (this.vertexShader = A.vertexShader),
      (this.uniforms = rp(A.uniforms)),
      (this.uniformsGroups = JZ(A.uniformsGroups)),
      (this.defines = Object.assign({}, A.defines)),
      (this.wireframe = A.wireframe),
      (this.wireframeLinewidth = A.wireframeLinewidth),
      (this.fog = A.fog),
      (this.lights = A.lights),
      (this.clipping = A.clipping),
      (this.extensions = Object.assign({}, A.extensions)),
      (this.glslVersion = A.glslVersion),
      this
    )
  }
  toJSON(A) {
    const I = super.toJSON(A)
    ;((I.glslVersion = this.glslVersion), (I.uniforms = {}))
    for (const C in this.uniforms) {
      const B = this.uniforms[C].value
      B && B.isTexture
        ? (I.uniforms[C] = {
            type: "t",
            value: B.toJSON(A).uuid,
          })
        : B && B.isColor
          ? (I.uniforms[C] = {
              type: "c",
              value: B.getHex(),
            })
          : B && B.isVector2
            ? (I.uniforms[C] = {
                type: "v2",
                value: B.toArray(),
              })
            : B && B.isVector3
              ? (I.uniforms[C] = {
                  type: "v3",
                  value: B.toArray(),
                })
              : B && B.isVector4
                ? (I.uniforms[C] = {
                    type: "v4",
                    value: B.toArray(),
                  })
                : B && B.isMatrix3
                  ? (I.uniforms[C] = {
                      type: "m3",
                      value: B.toArray(),
                    })
                  : B && B.isMatrix4
                    ? (I.uniforms[C] = {
                        type: "m4",
                        value: B.toArray(),
                      })
                    : (I.uniforms[C] = {
                        value: B,
                      })
    }
    ;(Object.keys(this.defines).length > 0 && (I.defines = this.defines),
      (I.vertexShader = this.vertexShader),
      (I.fragmentShader = this.fragmentShader),
      (I.lights = this.lights),
      (I.clipping = this.clipping))
    const g = {}
    for (const C in this.extensions) this.extensions[C] === !0 && (g[C] = !0)
    return (Object.keys(g).length > 0 && (I.extensions = g), I)
  }
}
class dp extends Ci {
  constructor() {
    ;(super(),
      (this.isCamera = !0),
      (this.type = "Camera"),
      (this.matrixWorldInverse = new RC()),
      (this.projectionMatrix = new RC()),
      (this.projectionMatrixInverse = new RC()),
      (this.coordinateSystem = bc))
  }
  copy(A, I) {
    return (
      super.copy(A, I),
      this.matrixWorldInverse.copy(A.matrixWorldInverse),
      this.projectionMatrix.copy(A.projectionMatrix),
      this.projectionMatrixInverse.copy(A.projectionMatrixInverse),
      (this.coordinateSystem = A.coordinateSystem),
      this
    )
  }
  getWorldDirection(A) {
    return super.getWorldDirection(A).negate()
  }
  updateMatrixWorld(A) {
    ;(super.updateMatrixWorld(A), this.matrixWorldInverse.copy(this.matrixWorld).invert())
  }
  updateWorldMatrix(A, I) {
    ;(super.updateWorldMatrix(A, I), this.matrixWorldInverse.copy(this.matrixWorld).invert())
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
const sD = /* @__PURE__ */ new wA(),
  zq = /* @__PURE__ */ new ZI(),
  Xq = /* @__PURE__ */ new ZI()
class PQ extends dp {
  constructor(A = 50, I = 1, g = 0.1, C = 2e3) {
    ;(super(),
      (this.isPerspectiveCamera = !0),
      (this.type = "PerspectiveCamera"),
      (this.fov = A),
      (this.zoom = 1),
      (this.near = g),
      (this.far = C),
      (this.focus = 10),
      (this.aspect = I),
      (this.view = null),
      (this.filmGauge = 35),
      (this.filmOffset = 0),
      this.updateProjectionMatrix())
  }
  copy(A, I) {
    return (
      super.copy(A, I),
      (this.fov = A.fov),
      (this.zoom = A.zoom),
      (this.near = A.near),
      (this.far = A.far),
      (this.focus = A.focus),
      (this.aspect = A.aspect),
      (this.view = A.view === null ? null : Object.assign({}, A.view)),
      (this.filmGauge = A.filmGauge),
      (this.filmOffset = A.filmOffset),
      this
    )
  }
  /**
   * Sets the FOV by focal length in respect to the current .filmGauge.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(A) {
    const I = (0.5 * this.getFilmHeight()) / A
    ;((this.fov = ap * 2 * Math.atan(I)), this.updateProjectionMatrix())
  }
  /**
   * Calculates the focal length from the current .fov and .filmGauge.
   */
  getFocalLength() {
    const A = Math.tan(Jf * 0.5 * this.fov)
    return (0.5 * this.getFilmHeight()) / A
  }
  getEffectiveFOV() {
    return ap * 2 * Math.atan(Math.tan(Jf * 0.5 * this.fov) / this.zoom)
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1)
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1)
  }
  /**
   * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
   * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
   */
  getViewBounds(A, I, g) {
    ;(sD.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse),
      I.set(sD.x, sD.y).multiplyScalar(-A / sD.z),
      sD.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse),
      g.set(sD.x, sD.y).multiplyScalar(-A / sD.z))
  }
  /**
   * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
   * Copies the result into the target Vector2, where x is width and y is height.
   */
  getViewSize(A, I) {
    return (this.getViewBounds(A, zq, Xq), I.subVectors(Xq, zq))
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *
   * then for each monitor you would call it like this
   *
   *   const w = 1920;
   *   const h = 1080;
   *   const fullWidth = w * 3;
   *   const fullHeight = h * 2;
   *
   *   --A--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   *   --B--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   *   --C--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   *   --D--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   *   --E--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   *   --F--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   *
   *   Note there is no reason monitors have to be the same size or in a grid.
   */
  setViewOffset(A, I, g, C, i, B) {
    ;((this.aspect = A / I),
      this.view === null &&
        (this.view = {
          enabled: !0,
          fullWidth: 1,
          fullHeight: 1,
          offsetX: 0,
          offsetY: 0,
          width: 1,
          height: 1,
        }),
      (this.view.enabled = !0),
      (this.view.fullWidth = A),
      (this.view.fullHeight = I),
      (this.view.offsetX = g),
      (this.view.offsetY = C),
      (this.view.width = i),
      (this.view.height = B),
      this.updateProjectionMatrix())
  }
  clearViewOffset() {
    ;(this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix())
  }
  updateProjectionMatrix() {
    const A = this.near
    let I = (A * Math.tan(Jf * 0.5 * this.fov)) / this.zoom,
      g = 2 * I,
      C = this.aspect * g,
      i = -0.5 * C
    const B = this.view
    if (this.view !== null && this.view.enabled) {
      const r = B.fullWidth,
        s = B.fullHeight
      ;((i += (B.offsetX * C) / r),
        (I -= (B.offsetY * g) / s),
        (C *= B.width / r),
        (g *= B.height / s))
    }
    const o = this.filmOffset
    ;(o !== 0 && (i += (A * o) / this.getFilmWidth()),
      this.projectionMatrix.makePerspective(i, i + C, I, I - g, A, this.far, this.coordinateSystem),
      this.projectionMatrixInverse.copy(this.projectionMatrix).invert())
  }
  toJSON(A) {
    const I = super.toJSON(A)
    return (
      (I.object.fov = this.fov),
      (I.object.zoom = this.zoom),
      (I.object.near = this.near),
      (I.object.far = this.far),
      (I.object.focus = this.focus),
      (I.object.aspect = this.aspect),
      this.view !== null && (I.object.view = Object.assign({}, this.view)),
      (I.object.filmGauge = this.filmGauge),
      (I.object.filmOffset = this.filmOffset),
      I
    )
  }
}
const qy = -90,
  Hy = 1
class P2 extends Ci {
  constructor(A, I, g) {
    ;(super(),
      (this.type = "CubeCamera"),
      (this.renderTarget = g),
      (this.coordinateSystem = null),
      (this.activeMipmapLevel = 0))
    const C = new PQ(qy, Hy, A, I)
    ;((C.layers = this.layers), this.add(C))
    const i = new PQ(qy, Hy, A, I)
    ;((i.layers = this.layers), this.add(i))
    const B = new PQ(qy, Hy, A, I)
    ;((B.layers = this.layers), this.add(B))
    const o = new PQ(qy, Hy, A, I)
    ;((o.layers = this.layers), this.add(o))
    const r = new PQ(qy, Hy, A, I)
    ;((r.layers = this.layers), this.add(r))
    const s = new PQ(qy, Hy, A, I)
    ;((s.layers = this.layers), this.add(s))
  }
  updateCoordinateSystem() {
    const A = this.coordinateSystem,
      I = this.children.concat(),
      [g, C, i, B, o, r] = I
    for (const s of I) this.remove(s)
    if (A === bc)
      (g.up.set(0, 1, 0),
        g.lookAt(1, 0, 0),
        C.up.set(0, 1, 0),
        C.lookAt(-1, 0, 0),
        i.up.set(0, 0, -1),
        i.lookAt(0, 1, 0),
        B.up.set(0, 0, 1),
        B.lookAt(0, -1, 0),
        o.up.set(0, 1, 0),
        o.lookAt(0, 0, 1),
        r.up.set(0, 1, 0),
        r.lookAt(0, 0, -1))
    else if (A === sG)
      (g.up.set(0, -1, 0),
        g.lookAt(-1, 0, 0),
        C.up.set(0, -1, 0),
        C.lookAt(1, 0, 0),
        i.up.set(0, 0, 1),
        i.lookAt(0, 1, 0),
        B.up.set(0, 0, -1),
        B.lookAt(0, -1, 0),
        o.up.set(0, -1, 0),
        o.lookAt(0, 0, 1),
        r.up.set(0, -1, 0),
        r.lookAt(0, 0, -1))
    else
      throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + A)
    for (const s of I) (this.add(s), s.updateMatrixWorld())
  }
  update(A, I) {
    this.parent === null && this.updateMatrixWorld()
    const { renderTarget: g, activeMipmapLevel: C } = this
    this.coordinateSystem !== A.coordinateSystem &&
      ((this.coordinateSystem = A.coordinateSystem), this.updateCoordinateSystem())
    const [i, B, o, r, s, h] = this.children,
      S = A.getRenderTarget(),
      d = A.getActiveCubeFace(),
      w = A.getActiveMipmapLevel(),
      M = A.xr.enabled
    A.xr.enabled = !1
    const K = g.texture.generateMipmaps
    ;((g.texture.generateMipmaps = !1),
      A.setRenderTarget(g, 0, C),
      A.render(I, i),
      A.setRenderTarget(g, 1, C),
      A.render(I, B),
      A.setRenderTarget(g, 2, C),
      A.render(I, o),
      A.setRenderTarget(g, 3, C),
      A.render(I, r),
      A.setRenderTarget(g, 4, C),
      A.render(I, s),
      (g.texture.generateMipmaps = K),
      A.setRenderTarget(g, 5, C),
      A.render(I, h),
      A.setRenderTarget(S, d, w),
      (A.xr.enabled = M),
      (g.texture.needsPMREMUpdate = !0))
  }
}
class FG extends pt {
  constructor(A, I, g, C, i, B, o, r, s, h) {
    ;((A = A !== void 0 ? A : []),
      (I = I !== void 0 ? I : Bu),
      super(A, I, g, C, i, B, o, r, s, h),
      (this.isCubeTexture = !0),
      (this.flipY = !1))
  }
  get images() {
    return this.image
  }
  set images(A) {
    this.image = A
  }
}
class W2 extends BQ {
  constructor(A = 1, I = {}) {
    ;(super(A, A, I), (this.isWebGLCubeRenderTarget = !0))
    const g = { width: A, height: A, depth: 1 },
      C = [g, g, g, g, g, g]
    ;((this.texture = new FG(
      C,
      I.mapping,
      I.wrapS,
      I.wrapT,
      I.magFilter,
      I.minFilter,
      I.format,
      I.type,
      I.anisotropy,
      I.colorSpace,
    )),
      (this.texture.isRenderTargetTexture = !0),
      (this.texture.generateMipmaps = I.generateMipmaps !== void 0 ? I.generateMipmaps : !1),
      (this.texture.minFilter = I.minFilter !== void 0 ? I.minFilter : nt))
  }
  fromEquirectangularTexture(A, I) {
    ;((this.texture.type = I.type),
      (this.texture.colorSpace = I.colorSpace),
      (this.texture.generateMipmaps = I.generateMipmaps),
      (this.texture.minFilter = I.minFilter),
      (this.texture.magFilter = I.magFilter))
    const g = {
        uniforms: {
          tEquirect: { value: null },
        },
        vertexShader:
          /* glsl */
          `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
        fragmentShader:
          /* glsl */
          `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`,
      },
      C = new Vf(5, 5, 5),
      i = new VQ({
        name: "CubemapFromEquirect",
        uniforms: rp(g.uniforms),
        vertexShader: g.vertexShader,
        fragmentShader: g.fragmentShader,
        side: WQ,
        blending: hE,
      })
    i.uniforms.tEquirect.value = I
    const B = new EB(C, i),
      o = I.minFilter
    return (
      I.minFilter === ks && (I.minFilter = nt),
      new P2(1, 10, this).update(A, B),
      (I.minFilter = o),
      B.geometry.dispose(),
      B.material.dispose(),
      this
    )
  }
  clear(A, I, g, C) {
    const i = A.getRenderTarget()
    for (let B = 0; B < 6; B++) (A.setRenderTarget(this, B), A.clear(I, g, C))
    A.setRenderTarget(i)
  }
}
const rK = /* @__PURE__ */ new wA(),
  vZ = /* @__PURE__ */ new wA(),
  LZ = /* @__PURE__ */ new ce()
class fD {
  constructor(A = new wA(1, 0, 0), I = 0) {
    ;((this.isPlane = !0), (this.normal = A), (this.constant = I))
  }
  set(A, I) {
    return (this.normal.copy(A), (this.constant = I), this)
  }
  setComponents(A, I, g, C) {
    return (this.normal.set(A, I, g), (this.constant = C), this)
  }
  setFromNormalAndCoplanarPoint(A, I) {
    return (this.normal.copy(A), (this.constant = -I.dot(this.normal)), this)
  }
  setFromCoplanarPoints(A, I, g) {
    const C = rK.subVectors(g, I).cross(vZ.subVectors(A, I)).normalize()
    return (this.setFromNormalAndCoplanarPoint(C, A), this)
  }
  copy(A) {
    return (this.normal.copy(A.normal), (this.constant = A.constant), this)
  }
  normalize() {
    const A = 1 / this.normal.length()
    return (this.normal.multiplyScalar(A), (this.constant *= A), this)
  }
  negate() {
    return ((this.constant *= -1), this.normal.negate(), this)
  }
  distanceToPoint(A) {
    return this.normal.dot(A) + this.constant
  }
  distanceToSphere(A) {
    return this.distanceToPoint(A.center) - A.radius
  }
  projectPoint(A, I) {
    return I.copy(A).addScaledVector(this.normal, -this.distanceToPoint(A))
  }
  intersectLine(A, I) {
    const g = A.delta(rK),
      C = this.normal.dot(g)
    if (C === 0) return this.distanceToPoint(A.start) === 0 ? I.copy(A.start) : null
    const i = -(A.start.dot(this.normal) + this.constant) / C
    return i < 0 || i > 1 ? null : I.copy(A.start).addScaledVector(g, i)
  }
  intersectsLine(A) {
    const I = this.distanceToPoint(A.start),
      g = this.distanceToPoint(A.end)
    return (I < 0 && g > 0) || (g < 0 && I > 0)
  }
  intersectsBox(A) {
    return A.intersectsPlane(this)
  }
  intersectsSphere(A) {
    return A.intersectsPlane(this)
  }
  coplanarPoint(A) {
    return A.copy(this.normal).multiplyScalar(-this.constant)
  }
  applyMatrix4(A, I) {
    const g = I || LZ.getNormalMatrix(A),
      C = this.coplanarPoint(rK).applyMatrix4(A),
      i = this.normal.applyMatrix3(g).normalize()
    return ((this.constant = -C.dot(i)), this)
  }
  translate(A) {
    return ((this.constant -= A.dot(this.normal)), this)
  }
  equals(A) {
    return A.normal.equals(this.normal) && A.constant === this.constant
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
const Qf = /* @__PURE__ */ new jo(),
  VM = /* @__PURE__ */ new wA()
class RG {
  constructor(A = new fD(), I = new fD(), g = new fD(), C = new fD(), i = new fD(), B = new fD()) {
    this.planes = [A, I, g, C, i, B]
  }
  set(A, I, g, C, i, B) {
    const o = this.planes
    return (
      o[0].copy(A),
      o[1].copy(I),
      o[2].copy(g),
      o[3].copy(C),
      o[4].copy(i),
      o[5].copy(B),
      this
    )
  }
  copy(A) {
    const I = this.planes
    for (let g = 0; g < 6; g++) I[g].copy(A.planes[g])
    return this
  }
  setFromProjectionMatrix(A, I = bc) {
    const g = this.planes,
      C = A.elements,
      i = C[0],
      B = C[1],
      o = C[2],
      r = C[3],
      s = C[4],
      h = C[5],
      S = C[6],
      d = C[7],
      w = C[8],
      M = C[9],
      K = C[10],
      R = C[11],
      F = C[12],
      L = C[13],
      Y = C[14],
      H = C[15]
    if (
      (g[0].setComponents(r - i, d - s, R - w, H - F).normalize(),
      g[1].setComponents(r + i, d + s, R + w, H + F).normalize(),
      g[2].setComponents(r + B, d + h, R + M, H + L).normalize(),
      g[3].setComponents(r - B, d - h, R - M, H - L).normalize(),
      g[4].setComponents(r - o, d - S, R - K, H - Y).normalize(),
      I === bc)
    )
      g[5].setComponents(r + o, d + S, R + K, H + Y).normalize()
    else if (I === sG) g[5].setComponents(o, S, K, Y).normalize()
    else throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + I)
    return this
  }
  intersectsObject(A) {
    if (A.boundingSphere !== void 0)
      (A.boundingSphere === null && A.computeBoundingSphere(),
        Qf.copy(A.boundingSphere).applyMatrix4(A.matrixWorld))
    else {
      const I = A.geometry
      ;(I.boundingSphere === null && I.computeBoundingSphere(),
        Qf.copy(I.boundingSphere).applyMatrix4(A.matrixWorld))
    }
    return this.intersectsSphere(Qf)
  }
  intersectsSprite(A) {
    return (
      Qf.center.set(0, 0, 0),
      (Qf.radius = 0.7071067811865476),
      Qf.applyMatrix4(A.matrixWorld),
      this.intersectsSphere(Qf)
    )
  }
  intersectsSphere(A) {
    const I = this.planes,
      g = A.center,
      C = -A.radius
    for (let i = 0; i < 6; i++) if (I[i].distanceToPoint(g) < C) return !1
    return !0
  }
  intersectsBox(A) {
    const I = this.planes
    for (let g = 0; g < 6; g++) {
      const C = I[g]
      if (
        ((VM.x = C.normal.x > 0 ? A.max.x : A.min.x),
        (VM.y = C.normal.y > 0 ? A.max.y : A.min.y),
        (VM.z = C.normal.z > 0 ? A.max.z : A.min.z),
        C.distanceToPoint(VM) < 0)
      )
        return !1
    }
    return !0
  }
  containsPoint(A) {
    const I = this.planes
    for (let g = 0; g < 6; g++) if (I[g].distanceToPoint(A) < 0) return !1
    return !0
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
function V2() {
  let e = null,
    A = !1,
    I = null,
    g = null
  function C(i, B) {
    ;(I(i, B), (g = e.requestAnimationFrame(C)))
  }
  return {
    start: function () {
      A !== !0 && I !== null && ((g = e.requestAnimationFrame(C)), (A = !0))
    },
    stop: function () {
      ;(e.cancelAnimationFrame(g), (A = !1))
    },
    setAnimationLoop: function (i) {
      I = i
    },
    setContext: function (i) {
      e = i
    },
  }
}
function YZ(e) {
  const A = /* @__PURE__ */ new WeakMap()
  function I(o, r) {
    const s = o.array,
      h = o.usage,
      S = s.byteLength,
      d = e.createBuffer()
    ;(e.bindBuffer(r, d), e.bufferData(r, s, h), o.onUploadCallback())
    let w
    if (s instanceof Float32Array) w = e.FLOAT
    else if (s instanceof Uint16Array)
      o.isFloat16BufferAttribute ? (w = e.HALF_FLOAT) : (w = e.UNSIGNED_SHORT)
    else if (s instanceof Int16Array) w = e.SHORT
    else if (s instanceof Uint32Array) w = e.UNSIGNED_INT
    else if (s instanceof Int32Array) w = e.INT
    else if (s instanceof Int8Array) w = e.BYTE
    else if (s instanceof Uint8Array) w = e.UNSIGNED_BYTE
    else if (s instanceof Uint8ClampedArray) w = e.UNSIGNED_BYTE
    else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + s)
    return {
      buffer: d,
      type: w,
      bytesPerElement: s.BYTES_PER_ELEMENT,
      version: o.version,
      size: S,
    }
  }
  function g(o, r, s) {
    const h = r.array,
      S = r.updateRanges
    if ((e.bindBuffer(s, o), S.length === 0)) e.bufferSubData(s, 0, h)
    else {
      S.sort((w, M) => w.start - M.start)
      let d = 0
      for (let w = 1; w < S.length; w++) {
        const M = S[d],
          K = S[w]
        K.start <= M.start + M.count + 1
          ? (M.count = Math.max(M.count, K.start + K.count - M.start))
          : (++d, (S[d] = K))
      }
      S.length = d + 1
      for (let w = 0, M = S.length; w < M; w++) {
        const K = S[w]
        e.bufferSubData(s, K.start * h.BYTES_PER_ELEMENT, h, K.start, K.count)
      }
      r.clearUpdateRanges()
    }
    r.onUploadCallback()
  }
  function C(o) {
    return (o.isInterleavedBufferAttribute && (o = o.data), A.get(o))
  }
  function i(o) {
    o.isInterleavedBufferAttribute && (o = o.data)
    const r = A.get(o)
    r && (e.deleteBuffer(r.buffer), A.delete(o))
  }
  function B(o, r) {
    if ((o.isInterleavedBufferAttribute && (o = o.data), o.isGLBufferAttribute)) {
      const h = A.get(o)
      ;(!h || h.version < o.version) &&
        A.set(o, {
          buffer: o.buffer,
          type: o.type,
          bytesPerElement: o.elementSize,
          version: o.version,
        })
      return
    }
    const s = A.get(o)
    if (s === void 0) A.set(o, I(o, r))
    else if (s.version < o.version) {
      if (s.size !== o.array.byteLength)
        throw new Error(
          "THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.",
        )
      ;(g(s.buffer, o, r), (s.version = o.version))
    }
  }
  return {
    get: C,
    remove: i,
    update: B,
  }
}
class su extends se {
  constructor(A = 1, I = 1, g = 1, C = 1) {
    ;(super(),
      (this.type = "PlaneGeometry"),
      (this.parameters = {
        width: A,
        height: I,
        widthSegments: g,
        heightSegments: C,
      }))
    const i = A / 2,
      B = I / 2,
      o = Math.floor(g),
      r = Math.floor(C),
      s = o + 1,
      h = r + 1,
      S = A / o,
      d = I / r,
      w = [],
      M = [],
      K = [],
      R = []
    for (let F = 0; F < h; F++) {
      const L = F * d - B
      for (let Y = 0; Y < s; Y++) {
        const H = Y * S - i
        ;(M.push(H, -L, 0), K.push(0, 0, 1), R.push(Y / o), R.push(1 - F / r))
      }
    }
    for (let F = 0; F < r; F++)
      for (let L = 0; L < o; L++) {
        const Y = L + s * F,
          H = L + s * (F + 1),
          V = L + 1 + s * (F + 1),
          j = L + 1 + s * F
        ;(w.push(Y, H, j), w.push(H, V, j))
      }
    ;(this.setIndex(w),
      this.setAttribute("position", new aC(M, 3)),
      this.setAttribute("normal", new aC(K, 3)),
      this.setAttribute("uv", new aC(R, 2)))
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
  static fromJSON(A) {
    return new su(A.width, A.height, A.widthSegments, A.heightSegments)
  }
}
var qZ = `#ifdef USE_ALPHAHASH
	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;
#endif`,
  HZ = `#ifdef USE_ALPHAHASH
	const float ALPHA_HASH_SCALE = 0.05;
	float hash2D( vec2 value ) {
		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );
	}
	float hash3D( vec3 value ) {
		return hash2D( vec2( hash2D( value.xy ), value.z ) );
	}
	float getAlphaHashThreshold( vec3 position ) {
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);
		float lerpFactor = fract( log2( pixScale ) );
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;
		return clamp( threshold , 1.0e-6, 1.0 );
	}
#endif`,
  TZ = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;
#endif`,
  xZ = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`,
  bZ = `#ifdef USE_ALPHATEST
	#ifdef ALPHA_TO_COVERAGE
	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );
	if ( diffuseColor.a == 0.0 ) discard;
	#else
	if ( diffuseColor.a < alphaTest ) discard;
	#endif
#endif`,
  OZ = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`,
  _Z = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_CLEARCOAT ) 
		clearcoatSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_SHEEN ) 
		sheenSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`,
  ZZ = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`,
  PZ = `#ifdef USE_BATCHING
	#if ! defined( GL_ANGLE_multi_draw )
	#define gl_DrawID _gl_DrawID
	uniform int _gl_DrawID;
	#endif
	uniform highp sampler2D batchingTexture;
	uniform highp usampler2D batchingIdTexture;
	mat4 getBatchingMatrix( const in float i ) {
		int size = textureSize( batchingTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
	float getIndirectIndex( const in int i ) {
		int size = textureSize( batchingIdTexture, 0 ).x;
		int x = i % size;
		int y = i / size;
		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );
	}
#endif
#ifdef USE_BATCHING_COLOR
	uniform sampler2D batchingColorTexture;
	vec3 getBatchingColor( const in float i ) {
		int size = textureSize( batchingColorTexture, 0 ).x;
		int j = int( i );
		int x = j % size;
		int y = j / size;
		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;
	}
#endif`,
  WZ = `#ifdef USE_BATCHING
	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );
#endif`,
  VZ = `vec3 transformed = vec3( position );
#ifdef USE_ALPHAHASH
	vPosition = vec3( position );
#endif`,
  jZ = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`,
  zZ = `float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
} // validated`,
  XZ = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`,
  $Z = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );
		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );
		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`,
  AP = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#ifdef ALPHA_TO_COVERAGE
		float distanceToPlane, distanceGradient;
		float clipOpacity = 1.0;
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
			distanceGradient = fwidth( distanceToPlane ) / 2.0;
			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			if ( clipOpacity == 0.0 ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			float unionClipOpacity = 1.0;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
				distanceGradient = fwidth( distanceToPlane ) / 2.0;
				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			}
			#pragma unroll_loop_end
			clipOpacity *= 1.0 - unionClipOpacity;
		#endif
		diffuseColor.a *= clipOpacity;
		if ( diffuseColor.a == 0.0 ) discard;
	#else
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			bool clipped = true;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
			}
			#pragma unroll_loop_end
			if ( clipped ) discard;
		#endif
	#endif
#endif`,
  IP = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`,
  gP = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`,
  CP = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`,
  eP = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`,
  iP = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`,
  tP = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	varying vec3 vColor;
#endif`,
  BP = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif
#ifdef USE_BATCHING_COLOR
	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );
	vColor.xyz *= batchingColor.xyz;
#endif`,
  QP = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
#ifdef USE_ALPHAHASH
	varying vec3 vPosition;
#endif
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}
vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
} // validated`,
  oP = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`,
  nP = `vec3 transformedNormal = objectNormal;
#ifdef USE_TANGENT
	vec3 transformedTangent = objectTangent;
#endif
#ifdef USE_BATCHING
	mat3 bm = mat3( batchingMatrix );
	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );
	transformedNormal = bm * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = bm * transformedTangent;
	#endif
#endif
#ifdef USE_INSTANCING
	mat3 im = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );
	transformedNormal = im * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = im * transformedTangent;
	#endif
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`,
  EP = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`,
  aP = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );
#endif`,
  rP = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );
	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE
		emissiveColor = sRGBTransferEOTF( emissiveColor );
	#endif
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`,
  sP = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`,
  lP = "gl_FragColor = linearToOutputTexel( gl_FragColor );",
  cP = `vec4 LinearTransferOETF( in vec4 value ) {
	return value;
}
vec4 sRGBTransferEOTF( in vec4 value ) {
	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );
}
vec4 sRGBTransferOETF( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`,
  hP = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`,
  uP = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	uniform mat3 envMapRotation;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`,
  DP = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`,
  SP = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`,
  fP = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`,
  dP = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`,
  yP = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`,
  pP = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`,
  wP = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`,
  GP = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`,
  kP = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`,
  MP = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`,
  UP = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`,
  NP = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
#if defined( USE_LIGHT_PROBES )
	uniform vec3 lightProbe[ 9 ];
#endif
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
	if ( cutoffDistance > 0.0 ) {
		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
	}
	return distanceFalloff;
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`,
  FP = `#ifdef USE_ENVMAP
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	#ifdef USE_ANISOTROPY
		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
				return getIBLRadiance( viewDir, bentNormal, roughness );
			#else
				return vec3( 0.0 );
			#endif
		}
	#endif
#endif`,
  RP = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`,
  JP = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`,
  KP = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`,
  mP = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`,
  vP = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef USE_SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULAR_COLORMAP
			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;
		#endif
		#ifdef USE_SPECULAR_INTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_DISPERSION
	material.dispersion = dispersion;
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEEN_COLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEEN_ROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;
	#endif
#endif
#ifdef USE_ANISOTROPY
	#ifdef USE_ANISOTROPYMAP
		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;
	#else
		vec2 anisotropyV = anisotropyVector;
	#endif
	material.anisotropy = length( anisotropyV );
	if( material.anisotropy == 0.0 ) {
		anisotropyV = vec2( 1.0, 0.0 );
	} else {
		anisotropyV /= material.anisotropy;
		material.anisotropy = saturate( material.anisotropy );
	}
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );
	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;
#endif`,
  LP = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	float dispersion;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif
};
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
#ifdef USE_ANISOTROPY
	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {
		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		float v = 0.5 / ( gv + gl );
		return saturate(v);
	}
	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {
		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;
		return RECIPROCAL_PI * a2 * pow2 ( w2 );
	}
#endif
#ifdef USE_CLEARCOAT
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {
		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = F_Schlick( f0, f90, dotVH );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 f0 = material.specularColor;
	float f90 = material.specularF90;
	float roughness = material.roughness;
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	#ifdef USE_IRIDESCENCE
		F = mix( F, material.iridescenceFresnel, material.iridescence );
	#endif
	#ifdef USE_ANISOTROPY
		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );
		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );
		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );
	#else
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
	#endif
	return F * ( V * D );
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );
	#endif
	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`,
  YP = `
vec3 geometryPosition = - vViewPosition;
vec3 geometryNormal = normal;
vec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
vec3 geometryClearcoatNormal = vec3( 0.0 );
#ifdef USE_CLEARCOAT
	geometryClearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometryViewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometryPosition, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometryPosition, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	#if defined( USE_LIGHT_PROBES )
		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );
	#endif
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`,
  qP = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometryNormal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	#ifdef USE_ANISOTROPY
		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );
	#else
		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );
	#endif
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`,
  HP = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif`,
  TP = `#if defined( USE_LOGDEPTHBUF )
	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`,
  xP = `#if defined( USE_LOGDEPTHBUF )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`,
  bP = `#ifdef USE_LOGDEPTHBUF
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`,
  OP = `#ifdef USE_LOGDEPTHBUF
	vFragDepth = 1.0 + gl_Position.w;
	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
#endif`,
  _P = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vMapUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`,
  ZP = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`,
  PP = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	#if defined( USE_POINTS_UV )
		vec2 uv = vUv;
	#else
		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
	#endif
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`,
  WP = `#if defined( USE_POINTS_UV )
	varying vec2 vUv;
#else
	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
		uniform mat3 uvTransform;
	#endif
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`,
  VP = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );
	metalnessFactor *= texelMetalness.b;
#endif`,
  jP = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`,
  zP = `#ifdef USE_INSTANCING_MORPH
	float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;
	}
#endif`,
  XP = `#if defined( USE_MORPHCOLORS )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`,
  $P = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
	}
#endif`,
  A8 = `#ifdef USE_MORPHTARGETS
	#ifndef USE_INSTANCING_MORPH
		uniform float morphTargetBaseInfluence;
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	#endif
	uniform sampler2DArray morphTargetsTexture;
	uniform ivec2 morphTargetsTextureSize;
	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
		int y = texelIndex / morphTargetsTextureSize.x;
		int x = texelIndex - y * morphTargetsTextureSize.x;
		ivec3 morphUV = ivec3( x, y, morphTargetIndex );
		return texelFetch( morphTargetsTexture, morphUV, 0 );
	}
#endif`,
  I8 = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
	}
#endif`,
  g8 = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal *= faceDirection;
	#endif
#endif
#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )
	#ifdef USE_TANGENT
		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;
	#endif
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	#ifdef USE_TANGENT
		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;
	#endif
#endif
vec3 nonPerturbedNormal = normal;`,
  C8 = `#ifdef USE_NORMALMAP_OBJECTSPACE
	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( USE_NORMALMAP_TANGENTSPACE )
	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	normal = normalize( tbn * mapN );
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`,
  e8 = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`,
  i8 = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`,
  t8 = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`,
  B8 = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef USE_NORMALMAP_OBJECTSPACE
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )
	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );
		return mat3( T * scale, B * scale, N );
	}
#endif`,
  Q8 = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = nonPerturbedNormal;
#endif`,
  o8 = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	clearcoatNormal = normalize( tbn2 * clearcoatMapN );
#endif`,
  n8 = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif`,
  E8 = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`,
  a8 = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`,
  r8 = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;
const float Inv255 = 1. / 255.;
const vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );
const vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );
const vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );
const vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );
vec4 packDepthToRGBA( const in float v ) {
	if( v <= 0.0 )
		return vec4( 0., 0., 0., 0. );
	if( v >= 1.0 )
		return vec4( 1., 1., 1., 1. );
	float vuf;
	float af = modf( v * PackFactors.a, vuf );
	float bf = modf( vuf * ShiftRight8, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );
}
vec3 packDepthToRGB( const in float v ) {
	if( v <= 0.0 )
		return vec3( 0., 0., 0. );
	if( v >= 1.0 )
		return vec3( 1., 1., 1. );
	float vuf;
	float bf = modf( v * PackFactors.b, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec3( vuf * Inv255, gf * PackUpscale, bf );
}
vec2 packDepthToRG( const in float v ) {
	if( v <= 0.0 )
		return vec2( 0., 0. );
	if( v >= 1.0 )
		return vec2( 1., 1. );
	float vuf;
	float gf = modf( v * 256., vuf );
	return vec2( vuf * Inv255, gf );
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors4 );
}
float unpackRGBToDepth( const in vec3 v ) {
	return dot( v, UnpackFactors3 );
}
float unpackRGToDepth( const in vec2 v ) {
	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;
}
vec4 pack2HalfToRGBA( const in vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( const in vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return depth * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * depth - far );
}`,
  s8 = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`,
  l8 = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_BATCHING
	mvPosition = batchingMatrix * mvPosition;
#endif
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`,
  c8 = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`,
  h8 = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`,
  u8 = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );
	roughnessFactor *= texelRoughness.g;
#endif`,
  D8 = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`,
  S8 = `#if NUM_SPOT_LIGHT_COORDS > 0
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		float hard_shadow = step( compare , distribution.x );
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		
		float lightToPositionLength = length( lightToPosition );
		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {
			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;
			vec3 bd3D = normalize( lightToPosition );
			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
				shadow = (
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
				) * ( 1.0 / 9.0 );
			#else
				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
			#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
#endif`,
  f8 = `#if NUM_SPOT_LIGHT_COORDS > 0
	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`,
  d8 = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`,
  y8 = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`,
  p8 = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`,
  w8 = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	mat4 getBoneMatrix( const in float i ) {
		int size = textureSize( boneTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
#endif`,
  G8 = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`,
  k8 = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`,
  M8 = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`,
  U8 = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`,
  N8 = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`,
  F8 = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return saturate( toneMappingExposure * color );
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 CineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
const mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(
	vec3( 1.6605, - 0.1246, - 0.0182 ),
	vec3( - 0.5876, 1.1329, - 0.1006 ),
	vec3( - 0.0728, - 0.0083, 1.1187 )
);
const mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(
	vec3( 0.6274, 0.0691, 0.0164 ),
	vec3( 0.3293, 0.9195, 0.0880 ),
	vec3( 0.0433, 0.0113, 0.8956 )
);
vec3 agxDefaultContrastApprox( vec3 x ) {
	vec3 x2 = x * x;
	vec3 x4 = x2 * x2;
	return + 15.5 * x4 * x2
		- 40.14 * x4 * x
		+ 31.96 * x4
		- 6.868 * x2 * x
		+ 0.4298 * x2
		+ 0.1191 * x
		- 0.00232;
}
vec3 AgXToneMapping( vec3 color ) {
	const mat3 AgXInsetMatrix = mat3(
		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),
		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),
		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )
	);
	const mat3 AgXOutsetMatrix = mat3(
		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),
		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),
		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )
	);
	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;
	color *= toneMappingExposure;
	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;
	color = AgXInsetMatrix * color;
	color = max( color, 1e-10 );	color = log2( color );
	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );
	color = clamp( color, 0.0, 1.0 );
	color = agxDefaultContrastApprox( color );
	color = AgXOutsetMatrix * color;
	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );
	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;
	color = clamp( color, 0.0, 1.0 );
	return color;
}
vec3 NeutralToneMapping( vec3 color ) {
	const float StartCompression = 0.8 - 0.04;
	const float Desaturation = 0.15;
	color *= toneMappingExposure;
	float x = min( color.r, min( color.g, color.b ) );
	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;
	color -= offset;
	float peak = max( color.r, max( color.g, color.b ) );
	if ( peak < StartCompression ) return color;
	float d = 1. - StartCompression;
	float newPeak = 1. - d * d / ( peak + d - StartCompression );
	color *= newPeak / peak;
	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );
	return mix( color, vec3( newPeak ), g );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`,
  R8 = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );
#endif`,
  J8 = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	float w0( float a ) {
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
	}
	float w1( float a ) {
		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
	}
	float w2( float a ){
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
	}
	float w3( float a ) {
		return ( 1.0 / 6.0 ) * ( a * a * a );
	}
	float g0( float a ) {
		return w0( a ) + w1( a );
	}
	float g1( float a ) {
		return w2( a ) + w3( a );
	}
	float h0( float a ) {
		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
	}
	float h1( float a ) {
		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
	}
	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
		uv = uv * texelSize.zw + 0.5;
		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );
		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );
		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
	}
	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );
	}
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );
	}
	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return vec3( 1.0 );
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec4 transmittedLight;
		vec3 transmittance;
		#ifdef USE_DISPERSION
			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;
			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );
			for ( int i = 0; i < 3; i ++ ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;
		
				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;
		
				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );
				transmittedLight[ i ] = transmissionSample[ i ];
				transmittedLight.a += transmissionSample.a;
				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];
			}
			transmittedLight.a /= 3.0;
		
		#else
		
			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
			vec3 refractedRayExit = position + transmissionRay;
			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
			vec2 refractionCoords = ndcPos.xy / ndcPos.w;
			refractionCoords += 1.0;
			refractionCoords /= 2.0;
			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		
		#endif
		vec3 attenuatedColor = transmittance * transmittedLight.rgb;
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;
		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );
	}
#endif`,
  K8 = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_SPECULARMAP
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`,
  m8 = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	uniform mat3 mapTransform;
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_DISPLACEMENTMAP
	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SPECULARMAP
	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`,
  v8 = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	vUv = vec3( uv, 1 ).xy;
#endif
#ifdef USE_MAP
	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ALPHAMAP
	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_LIGHTMAP
	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_AOMAP
	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_BUMPMAP
	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_NORMALMAP
	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_DISPLACEMENTMAP
	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_EMISSIVEMAP
	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_METALNESSMAP
	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ROUGHNESSMAP
	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ANISOTROPYMAP
	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOATMAP
	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCEMAP
	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_COLORMAP
	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULARMAP
	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_COLORMAP
	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_TRANSMISSIONMAP
	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_THICKNESSMAP
	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;
#endif`,
  L8 = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_BATCHING
		worldPosition = batchingMatrix * worldPosition;
	#endif
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`
const Y8 = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`,
  q8 = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
  H8 = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`,
  T8 = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
uniform mat3 backgroundRotation;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
  x8 = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`,
  b8 = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
  O8 = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`,
  _8 = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <logdepthbuf_fragment>
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#elif DEPTH_PACKING == 3202
		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );
	#elif DEPTH_PACKING == 3203
		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );
	#endif
}`,
  Z8 = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`,
  P8 = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`,
  W8 = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`,
  V8 = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
  j8 = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`,
  z8 = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`,
  X8 = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`,
  $8 = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  AW = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
  IW = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  gW = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`,
  CW = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  eW = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	vViewPosition = - mvPosition.xyz;
#endif
}`,
  iW = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`,
  tW = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
  BW = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  QW = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`,
  oW = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif
	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_DISPERSION
	uniform float dispersion;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;
	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;
	#endif
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  nW = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
  EW = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  aW = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#ifdef USE_POINTS_UV
	varying vec2 vUv;
	uniform mat3 uvTransform;
#endif
void main() {
	#ifdef USE_POINTS_UV
		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	#endif
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`,
  rW = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`,
  sW = `#include <common>
#include <batching_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
  lW = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	#include <logdepthbuf_fragment>
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`,
  cW = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix[ 3 ];
	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`,
  hW = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`,
  ne = {
    alphahash_fragment: qZ,
    alphahash_pars_fragment: HZ,
    alphamap_fragment: TZ,
    alphamap_pars_fragment: xZ,
    alphatest_fragment: bZ,
    alphatest_pars_fragment: OZ,
    aomap_fragment: _Z,
    aomap_pars_fragment: ZZ,
    batching_pars_vertex: PZ,
    batching_vertex: WZ,
    begin_vertex: VZ,
    beginnormal_vertex: jZ,
    bsdfs: zZ,
    iridescence_fragment: XZ,
    bumpmap_pars_fragment: $Z,
    clipping_planes_fragment: AP,
    clipping_planes_pars_fragment: IP,
    clipping_planes_pars_vertex: gP,
    clipping_planes_vertex: CP,
    color_fragment: eP,
    color_pars_fragment: iP,
    color_pars_vertex: tP,
    color_vertex: BP,
    common: QP,
    cube_uv_reflection_fragment: oP,
    defaultnormal_vertex: nP,
    displacementmap_pars_vertex: EP,
    displacementmap_vertex: aP,
    emissivemap_fragment: rP,
    emissivemap_pars_fragment: sP,
    colorspace_fragment: lP,
    colorspace_pars_fragment: cP,
    envmap_fragment: hP,
    envmap_common_pars_fragment: uP,
    envmap_pars_fragment: DP,
    envmap_pars_vertex: SP,
    envmap_physical_pars_fragment: FP,
    envmap_vertex: fP,
    fog_vertex: dP,
    fog_pars_vertex: yP,
    fog_fragment: pP,
    fog_pars_fragment: wP,
    gradientmap_pars_fragment: GP,
    lightmap_pars_fragment: kP,
    lights_lambert_fragment: MP,
    lights_lambert_pars_fragment: UP,
    lights_pars_begin: NP,
    lights_toon_fragment: RP,
    lights_toon_pars_fragment: JP,
    lights_phong_fragment: KP,
    lights_phong_pars_fragment: mP,
    lights_physical_fragment: vP,
    lights_physical_pars_fragment: LP,
    lights_fragment_begin: YP,
    lights_fragment_maps: qP,
    lights_fragment_end: HP,
    logdepthbuf_fragment: TP,
    logdepthbuf_pars_fragment: xP,
    logdepthbuf_pars_vertex: bP,
    logdepthbuf_vertex: OP,
    map_fragment: _P,
    map_pars_fragment: ZP,
    map_particle_fragment: PP,
    map_particle_pars_fragment: WP,
    metalnessmap_fragment: VP,
    metalnessmap_pars_fragment: jP,
    morphinstance_vertex: zP,
    morphcolor_vertex: XP,
    morphnormal_vertex: $P,
    morphtarget_pars_vertex: A8,
    morphtarget_vertex: I8,
    normal_fragment_begin: g8,
    normal_fragment_maps: C8,
    normal_pars_fragment: e8,
    normal_pars_vertex: i8,
    normal_vertex: t8,
    normalmap_pars_fragment: B8,
    clearcoat_normal_fragment_begin: Q8,
    clearcoat_normal_fragment_maps: o8,
    clearcoat_pars_fragment: n8,
    iridescence_pars_fragment: E8,
    opaque_fragment: a8,
    packing: r8,
    premultiplied_alpha_fragment: s8,
    project_vertex: l8,
    dithering_fragment: c8,
    dithering_pars_fragment: h8,
    roughnessmap_fragment: u8,
    roughnessmap_pars_fragment: D8,
    shadowmap_pars_fragment: S8,
    shadowmap_pars_vertex: f8,
    shadowmap_vertex: d8,
    shadowmask_pars_fragment: y8,
    skinbase_vertex: p8,
    skinning_pars_vertex: w8,
    skinning_vertex: G8,
    skinnormal_vertex: k8,
    specularmap_fragment: M8,
    specularmap_pars_fragment: U8,
    tonemapping_fragment: N8,
    tonemapping_pars_fragment: F8,
    transmission_fragment: R8,
    transmission_pars_fragment: J8,
    uv_pars_fragment: K8,
    uv_pars_vertex: m8,
    uv_vertex: v8,
    worldpos_vertex: L8,
    background_vert: Y8,
    background_frag: q8,
    backgroundCube_vert: H8,
    backgroundCube_frag: T8,
    cube_vert: x8,
    cube_frag: b8,
    depth_vert: O8,
    depth_frag: _8,
    distanceRGBA_vert: Z8,
    distanceRGBA_frag: P8,
    equirect_vert: W8,
    equirect_frag: V8,
    linedashed_vert: j8,
    linedashed_frag: z8,
    meshbasic_vert: X8,
    meshbasic_frag: $8,
    meshlambert_vert: AW,
    meshlambert_frag: IW,
    meshmatcap_vert: gW,
    meshmatcap_frag: CW,
    meshnormal_vert: eW,
    meshnormal_frag: iW,
    meshphong_vert: tW,
    meshphong_frag: BW,
    meshphysical_vert: QW,
    meshphysical_frag: oW,
    meshtoon_vert: nW,
    meshtoon_frag: EW,
    points_vert: aW,
    points_frag: rW,
    shadow_vert: sW,
    shadow_frag: lW,
    sprite_vert: cW,
    sprite_frag: hW,
  },
  Yg = {
    common: {
      diffuse: { value: /* @__PURE__ */ new Mg(16777215) },
      opacity: { value: 1 },
      map: { value: null },
      mapTransform: { value: /* @__PURE__ */ new ce() },
      alphaMap: { value: null },
      alphaMapTransform: { value: /* @__PURE__ */ new ce() },
      alphaTest: { value: 0 },
    },
    specularmap: {
      specularMap: { value: null },
      specularMapTransform: { value: /* @__PURE__ */ new ce() },
    },
    envmap: {
      envMap: { value: null },
      envMapRotation: { value: /* @__PURE__ */ new ce() },
      flipEnvMap: { value: -1 },
      reflectivity: { value: 1 },
      // basic, lambert, phong
      ior: { value: 1.5 },
      // physical
      refractionRatio: { value: 0.98 },
      // basic, lambert, phong
    },
    aomap: {
      aoMap: { value: null },
      aoMapIntensity: { value: 1 },
      aoMapTransform: { value: /* @__PURE__ */ new ce() },
    },
    lightmap: {
      lightMap: { value: null },
      lightMapIntensity: { value: 1 },
      lightMapTransform: { value: /* @__PURE__ */ new ce() },
    },
    bumpmap: {
      bumpMap: { value: null },
      bumpMapTransform: { value: /* @__PURE__ */ new ce() },
      bumpScale: { value: 1 },
    },
    normalmap: {
      normalMap: { value: null },
      normalMapTransform: { value: /* @__PURE__ */ new ce() },
      normalScale: { value: /* @__PURE__ */ new ZI(1, 1) },
    },
    displacementmap: {
      displacementMap: { value: null },
      displacementMapTransform: { value: /* @__PURE__ */ new ce() },
      displacementScale: { value: 1 },
      displacementBias: { value: 0 },
    },
    emissivemap: {
      emissiveMap: { value: null },
      emissiveMapTransform: { value: /* @__PURE__ */ new ce() },
    },
    metalnessmap: {
      metalnessMap: { value: null },
      metalnessMapTransform: { value: /* @__PURE__ */ new ce() },
    },
    roughnessmap: {
      roughnessMap: { value: null },
      roughnessMapTransform: { value: /* @__PURE__ */ new ce() },
    },
    gradientmap: {
      gradientMap: { value: null },
    },
    fog: {
      fogDensity: { value: 25e-5 },
      fogNear: { value: 1 },
      fogFar: { value: 2e3 },
      fogColor: { value: /* @__PURE__ */ new Mg(16777215) },
    },
    lights: {
      ambientLightColor: { value: [] },
      lightProbe: { value: [] },
      directionalLights: {
        value: [],
        properties: {
          direction: {},
          color: {},
        },
      },
      directionalLightShadows: {
        value: [],
        properties: {
          shadowIntensity: 1,
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {},
        },
      },
      directionalShadowMap: { value: [] },
      directionalShadowMatrix: { value: [] },
      spotLights: {
        value: [],
        properties: {
          color: {},
          position: {},
          direction: {},
          distance: {},
          coneCos: {},
          penumbraCos: {},
          decay: {},
        },
      },
      spotLightShadows: {
        value: [],
        properties: {
          shadowIntensity: 1,
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {},
        },
      },
      spotLightMap: { value: [] },
      spotShadowMap: { value: [] },
      spotLightMatrix: { value: [] },
      pointLights: {
        value: [],
        properties: {
          color: {},
          position: {},
          decay: {},
          distance: {},
        },
      },
      pointLightShadows: {
        value: [],
        properties: {
          shadowIntensity: 1,
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {},
          shadowCameraNear: {},
          shadowCameraFar: {},
        },
      },
      pointShadowMap: { value: [] },
      pointShadowMatrix: { value: [] },
      hemisphereLights: {
        value: [],
        properties: {
          direction: {},
          skyColor: {},
          groundColor: {},
        },
      },
      // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
      rectAreaLights: {
        value: [],
        properties: {
          color: {},
          position: {},
          width: {},
          height: {},
        },
      },
      ltc_1: { value: null },
      ltc_2: { value: null },
    },
    points: {
      diffuse: { value: /* @__PURE__ */ new Mg(16777215) },
      opacity: { value: 1 },
      size: { value: 1 },
      scale: { value: 1 },
      map: { value: null },
      alphaMap: { value: null },
      alphaMapTransform: { value: /* @__PURE__ */ new ce() },
      alphaTest: { value: 0 },
      uvTransform: { value: /* @__PURE__ */ new ce() },
    },
    sprite: {
      diffuse: { value: /* @__PURE__ */ new Mg(16777215) },
      opacity: { value: 1 },
      center: { value: /* @__PURE__ */ new ZI(0.5, 0.5) },
      rotation: { value: 0 },
      map: { value: null },
      mapTransform: { value: /* @__PURE__ */ new ce() },
      alphaMap: { value: null },
      alphaMapTransform: { value: /* @__PURE__ */ new ce() },
      alphaTest: { value: 0 },
    },
  },
  Gl = {
    basic: {
      uniforms: /* @__PURE__ */ jE([
        Yg.common,
        Yg.specularmap,
        Yg.envmap,
        Yg.aomap,
        Yg.lightmap,
        Yg.fog,
      ]),
      vertexShader: ne.meshbasic_vert,
      fragmentShader: ne.meshbasic_frag,
    },
    lambert: {
      uniforms: /* @__PURE__ */ jE([
        Yg.common,
        Yg.specularmap,
        Yg.envmap,
        Yg.aomap,
        Yg.lightmap,
        Yg.emissivemap,
        Yg.bumpmap,
        Yg.normalmap,
        Yg.displacementmap,
        Yg.fog,
        Yg.lights,
        {
          emissive: { value: /* @__PURE__ */ new Mg(0) },
        },
      ]),
      vertexShader: ne.meshlambert_vert,
      fragmentShader: ne.meshlambert_frag,
    },
    phong: {
      uniforms: /* @__PURE__ */ jE([
        Yg.common,
        Yg.specularmap,
        Yg.envmap,
        Yg.aomap,
        Yg.lightmap,
        Yg.emissivemap,
        Yg.bumpmap,
        Yg.normalmap,
        Yg.displacementmap,
        Yg.fog,
        Yg.lights,
        {
          emissive: { value: /* @__PURE__ */ new Mg(0) },
          specular: { value: /* @__PURE__ */ new Mg(1118481) },
          shininess: { value: 30 },
        },
      ]),
      vertexShader: ne.meshphong_vert,
      fragmentShader: ne.meshphong_frag,
    },
    standard: {
      uniforms: /* @__PURE__ */ jE([
        Yg.common,
        Yg.envmap,
        Yg.aomap,
        Yg.lightmap,
        Yg.emissivemap,
        Yg.bumpmap,
        Yg.normalmap,
        Yg.displacementmap,
        Yg.roughnessmap,
        Yg.metalnessmap,
        Yg.fog,
        Yg.lights,
        {
          emissive: { value: /* @__PURE__ */ new Mg(0) },
          roughness: { value: 1 },
          metalness: { value: 0 },
          envMapIntensity: { value: 1 },
        },
      ]),
      vertexShader: ne.meshphysical_vert,
      fragmentShader: ne.meshphysical_frag,
    },
    toon: {
      uniforms: /* @__PURE__ */ jE([
        Yg.common,
        Yg.aomap,
        Yg.lightmap,
        Yg.emissivemap,
        Yg.bumpmap,
        Yg.normalmap,
        Yg.displacementmap,
        Yg.gradientmap,
        Yg.fog,
        Yg.lights,
        {
          emissive: { value: /* @__PURE__ */ new Mg(0) },
        },
      ]),
      vertexShader: ne.meshtoon_vert,
      fragmentShader: ne.meshtoon_frag,
    },
    matcap: {
      uniforms: /* @__PURE__ */ jE([
        Yg.common,
        Yg.bumpmap,
        Yg.normalmap,
        Yg.displacementmap,
        Yg.fog,
        {
          matcap: { value: null },
        },
      ]),
      vertexShader: ne.meshmatcap_vert,
      fragmentShader: ne.meshmatcap_frag,
    },
    points: {
      uniforms: /* @__PURE__ */ jE([Yg.points, Yg.fog]),
      vertexShader: ne.points_vert,
      fragmentShader: ne.points_frag,
    },
    dashed: {
      uniforms: /* @__PURE__ */ jE([
        Yg.common,
        Yg.fog,
        {
          scale: { value: 1 },
          dashSize: { value: 1 },
          totalSize: { value: 2 },
        },
      ]),
      vertexShader: ne.linedashed_vert,
      fragmentShader: ne.linedashed_frag,
    },
    depth: {
      uniforms: /* @__PURE__ */ jE([Yg.common, Yg.displacementmap]),
      vertexShader: ne.depth_vert,
      fragmentShader: ne.depth_frag,
    },
    normal: {
      uniforms: /* @__PURE__ */ jE([
        Yg.common,
        Yg.bumpmap,
        Yg.normalmap,
        Yg.displacementmap,
        {
          opacity: { value: 1 },
        },
      ]),
      vertexShader: ne.meshnormal_vert,
      fragmentShader: ne.meshnormal_frag,
    },
    sprite: {
      uniforms: /* @__PURE__ */ jE([Yg.sprite, Yg.fog]),
      vertexShader: ne.sprite_vert,
      fragmentShader: ne.sprite_frag,
    },
    background: {
      uniforms: {
        uvTransform: { value: /* @__PURE__ */ new ce() },
        t2D: { value: null },
        backgroundIntensity: { value: 1 },
      },
      vertexShader: ne.background_vert,
      fragmentShader: ne.background_frag,
    },
    backgroundCube: {
      uniforms: {
        envMap: { value: null },
        flipEnvMap: { value: -1 },
        backgroundBlurriness: { value: 0 },
        backgroundIntensity: { value: 1 },
        backgroundRotation: { value: /* @__PURE__ */ new ce() },
      },
      vertexShader: ne.backgroundCube_vert,
      fragmentShader: ne.backgroundCube_frag,
    },
    cube: {
      uniforms: {
        tCube: { value: null },
        tFlip: { value: -1 },
        opacity: { value: 1 },
      },
      vertexShader: ne.cube_vert,
      fragmentShader: ne.cube_frag,
    },
    equirect: {
      uniforms: {
        tEquirect: { value: null },
      },
      vertexShader: ne.equirect_vert,
      fragmentShader: ne.equirect_frag,
    },
    distanceRGBA: {
      uniforms: /* @__PURE__ */ jE([
        Yg.common,
        Yg.displacementmap,
        {
          referencePosition: { value: /* @__PURE__ */ new wA() },
          nearDistance: { value: 1 },
          farDistance: { value: 1e3 },
        },
      ]),
      vertexShader: ne.distanceRGBA_vert,
      fragmentShader: ne.distanceRGBA_frag,
    },
    shadow: {
      uniforms: /* @__PURE__ */ jE([
        Yg.lights,
        Yg.fog,
        {
          color: { value: /* @__PURE__ */ new Mg(0) },
          opacity: { value: 1 },
        },
      ]),
      vertexShader: ne.shadow_vert,
      fragmentShader: ne.shadow_frag,
    },
  }
Gl.physical = {
  uniforms: /* @__PURE__ */ jE([
    Gl.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatMapTransform: { value: /* @__PURE__ */ new ce() },
      clearcoatNormalMap: { value: null },
      clearcoatNormalMapTransform: { value: /* @__PURE__ */ new ce() },
      clearcoatNormalScale: { value: /* @__PURE__ */ new ZI(1, 1) },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatRoughnessMapTransform: { value: /* @__PURE__ */ new ce() },
      dispersion: { value: 0 },
      iridescence: { value: 0 },
      iridescenceMap: { value: null },
      iridescenceMapTransform: { value: /* @__PURE__ */ new ce() },
      iridescenceIOR: { value: 1.3 },
      iridescenceThicknessMinimum: { value: 100 },
      iridescenceThicknessMaximum: { value: 400 },
      iridescenceThicknessMap: { value: null },
      iridescenceThicknessMapTransform: { value: /* @__PURE__ */ new ce() },
      sheen: { value: 0 },
      sheenColor: { value: /* @__PURE__ */ new Mg(0) },
      sheenColorMap: { value: null },
      sheenColorMapTransform: { value: /* @__PURE__ */ new ce() },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      sheenRoughnessMapTransform: { value: /* @__PURE__ */ new ce() },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionMapTransform: { value: /* @__PURE__ */ new ce() },
      transmissionSamplerSize: { value: /* @__PURE__ */ new ZI() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      thicknessMapTransform: { value: /* @__PURE__ */ new ce() },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: /* @__PURE__ */ new Mg(0) },
      specularColor: { value: /* @__PURE__ */ new Mg(1, 1, 1) },
      specularColorMap: { value: null },
      specularColorMapTransform: { value: /* @__PURE__ */ new ce() },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularIntensityMapTransform: { value: /* @__PURE__ */ new ce() },
      anisotropyVector: { value: /* @__PURE__ */ new ZI() },
      anisotropyMap: { value: null },
      anisotropyMapTransform: { value: /* @__PURE__ */ new ce() },
    },
  ]),
  vertexShader: ne.meshphysical_vert,
  fragmentShader: ne.meshphysical_frag,
}
const jM = { r: 0, b: 0, g: 0 },
  of = /* @__PURE__ */ new uE(),
  uW = /* @__PURE__ */ new RC()
function DW(e, A, I, g, C, i, B) {
  const o = new Mg(0)
  let r = i === !0 ? 0 : 1,
    s,
    h,
    S = null,
    d = 0,
    w = null
  function M(L) {
    let Y = L.isScene === !0 ? L.background : null
    return (Y && Y.isTexture && (Y = (L.backgroundBlurriness > 0 ? I : A).get(Y)), Y)
  }
  function K(L) {
    let Y = !1
    const H = M(L)
    H === null ? F(o, r) : H && H.isColor && (F(H, 1), (Y = !0))
    const V = e.xr.getEnvironmentBlendMode()
    ;(V === "additive"
      ? g.buffers.color.setClear(0, 0, 0, 1, B)
      : V === "alpha-blend" && g.buffers.color.setClear(0, 0, 0, 0, B),
      (e.autoClear || Y) &&
        (g.buffers.depth.setTest(!0),
        g.buffers.depth.setMask(!0),
        g.buffers.color.setMask(!0),
        e.clear(e.autoClearColor, e.autoClearDepth, e.autoClearStencil)))
  }
  function R(L, Y) {
    const H = M(Y)
    H && (H.isCubeTexture || H.mapping === Sp)
      ? (h === void 0 &&
          ((h = new EB(
            new Vf(1, 1, 1),
            new VQ({
              name: "BackgroundCubeMaterial",
              uniforms: rp(Gl.backgroundCube.uniforms),
              vertexShader: Gl.backgroundCube.vertexShader,
              fragmentShader: Gl.backgroundCube.fragmentShader,
              side: WQ,
              depthTest: !1,
              depthWrite: !1,
              fog: !1,
            }),
          )),
          h.geometry.deleteAttribute("normal"),
          h.geometry.deleteAttribute("uv"),
          (h.onBeforeRender = function (V, j, P) {
            this.matrixWorld.copyPosition(P.matrixWorld)
          }),
          Object.defineProperty(h.material, "envMap", {
            get: function () {
              return this.uniforms.envMap.value
            },
          }),
          C.update(h)),
        of.copy(Y.backgroundRotation),
        (of.x *= -1),
        (of.y *= -1),
        (of.z *= -1),
        H.isCubeTexture && H.isRenderTargetTexture === !1 && ((of.y *= -1), (of.z *= -1)),
        (h.material.uniforms.envMap.value = H),
        (h.material.uniforms.flipEnvMap.value =
          H.isCubeTexture && H.isRenderTargetTexture === !1 ? -1 : 1),
        (h.material.uniforms.backgroundBlurriness.value = Y.backgroundBlurriness),
        (h.material.uniforms.backgroundIntensity.value = Y.backgroundIntensity),
        h.material.uniforms.backgroundRotation.value.setFromMatrix4(uW.makeRotationFromEuler(of)),
        (h.material.toneMapped = ni.getTransfer(H.colorSpace) !== ot),
        (S !== H || d !== H.version || w !== e.toneMapping) &&
          ((h.material.needsUpdate = !0), (S = H), (d = H.version), (w = e.toneMapping)),
        h.layers.enableAll(),
        L.unshift(h, h.geometry, h.material, 0, 0, null))
      : H &&
        H.isTexture &&
        (s === void 0 &&
          ((s = new EB(
            new su(2, 2),
            new VQ({
              name: "BackgroundMaterial",
              uniforms: rp(Gl.background.uniforms),
              vertexShader: Gl.background.vertexShader,
              fragmentShader: Gl.background.fragmentShader,
              side: Us,
              depthTest: !1,
              depthWrite: !1,
              fog: !1,
            }),
          )),
          s.geometry.deleteAttribute("normal"),
          Object.defineProperty(s.material, "map", {
            get: function () {
              return this.uniforms.t2D.value
            },
          }),
          C.update(s)),
        (s.material.uniforms.t2D.value = H),
        (s.material.uniforms.backgroundIntensity.value = Y.backgroundIntensity),
        (s.material.toneMapped = ni.getTransfer(H.colorSpace) !== ot),
        H.matrixAutoUpdate === !0 && H.updateMatrix(),
        s.material.uniforms.uvTransform.value.copy(H.matrix),
        (S !== H || d !== H.version || w !== e.toneMapping) &&
          ((s.material.needsUpdate = !0), (S = H), (d = H.version), (w = e.toneMapping)),
        s.layers.enableAll(),
        L.unshift(s, s.geometry, s.material, 0, 0, null))
  }
  function F(L, Y) {
    ;(L.getRGB(jM, Z2(e)), g.buffers.color.setClear(jM.r, jM.g, jM.b, Y, B))
  }
  return {
    getClearColor: function () {
      return o
    },
    setClearColor: function (L, Y = 1) {
      ;(o.set(L), (r = Y), F(o, r))
    },
    getClearAlpha: function () {
      return r
    },
    setClearAlpha: function (L) {
      ;((r = L), F(o, r))
    },
    render: K,
    addToRenderList: R,
  }
}
function SW(e, A) {
  const I = e.getParameter(e.MAX_VERTEX_ATTRIBS),
    g = {},
    C = d(null)
  let i = C,
    B = !1
  function o(_, eA, CA, aA, lA) {
    let JA = !1
    const yA = S(aA, CA, eA)
    ;(i !== yA && ((i = yA), s(i.object)),
      (JA = w(_, aA, CA, lA)),
      JA && M(_, aA, CA, lA),
      lA !== null && A.update(lA, e.ELEMENT_ARRAY_BUFFER),
      (JA || B) &&
        ((B = !1),
        H(_, eA, CA, aA),
        lA !== null && e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, A.get(lA).buffer)))
  }
  function r() {
    return e.createVertexArray()
  }
  function s(_) {
    return e.bindVertexArray(_)
  }
  function h(_) {
    return e.deleteVertexArray(_)
  }
  function S(_, eA, CA) {
    const aA = CA.wireframe === !0
    let lA = g[_.id]
    lA === void 0 && ((lA = {}), (g[_.id] = lA))
    let JA = lA[eA.id]
    JA === void 0 && ((JA = {}), (lA[eA.id] = JA))
    let yA = JA[aA]
    return (yA === void 0 && ((yA = d(r())), (JA[aA] = yA)), yA)
  }
  function d(_) {
    const eA = [],
      CA = [],
      aA = []
    for (let lA = 0; lA < I; lA++) ((eA[lA] = 0), (CA[lA] = 0), (aA[lA] = 0))
    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: eA,
      enabledAttributes: CA,
      attributeDivisors: aA,
      object: _,
      attributes: {},
      index: null,
    }
  }
  function w(_, eA, CA, aA) {
    const lA = i.attributes,
      JA = eA.attributes
    let yA = 0
    const LA = CA.getAttributes()
    for (const nA in LA)
      if (LA[nA].location >= 0) {
        const sA = lA[nA]
        let $ = JA[nA]
        if (
          ($ === void 0 &&
            (nA === "instanceMatrix" && _.instanceMatrix && ($ = _.instanceMatrix),
            nA === "instanceColor" && _.instanceColor && ($ = _.instanceColor)),
          sA === void 0 || sA.attribute !== $ || ($ && sA.data !== $.data))
        )
          return !0
        yA++
      }
    return i.attributesNum !== yA || i.index !== aA
  }
  function M(_, eA, CA, aA) {
    const lA = {},
      JA = eA.attributes
    let yA = 0
    const LA = CA.getAttributes()
    for (const nA in LA)
      if (LA[nA].location >= 0) {
        let sA = JA[nA]
        sA === void 0 &&
          (nA === "instanceMatrix" && _.instanceMatrix && (sA = _.instanceMatrix),
          nA === "instanceColor" && _.instanceColor && (sA = _.instanceColor))
        const $ = {}
        ;(($.attribute = sA), sA && sA.data && ($.data = sA.data), (lA[nA] = $), yA++)
      }
    ;((i.attributes = lA), (i.attributesNum = yA), (i.index = aA))
  }
  function K() {
    const _ = i.newAttributes
    for (let eA = 0, CA = _.length; eA < CA; eA++) _[eA] = 0
  }
  function R(_) {
    F(_, 0)
  }
  function F(_, eA) {
    const CA = i.newAttributes,
      aA = i.enabledAttributes,
      lA = i.attributeDivisors
    ;((CA[_] = 1),
      aA[_] === 0 && (e.enableVertexAttribArray(_), (aA[_] = 1)),
      lA[_] !== eA && (e.vertexAttribDivisor(_, eA), (lA[_] = eA)))
  }
  function L() {
    const _ = i.newAttributes,
      eA = i.enabledAttributes
    for (let CA = 0, aA = eA.length; CA < aA; CA++)
      eA[CA] !== _[CA] && (e.disableVertexAttribArray(CA), (eA[CA] = 0))
  }
  function Y(_, eA, CA, aA, lA, JA, yA) {
    yA === !0
      ? e.vertexAttribIPointer(_, eA, CA, lA, JA)
      : e.vertexAttribPointer(_, eA, CA, aA, lA, JA)
  }
  function H(_, eA, CA, aA) {
    K()
    const lA = aA.attributes,
      JA = CA.getAttributes(),
      yA = eA.defaultAttributeValues
    for (const LA in JA) {
      const nA = JA[LA]
      if (nA.location >= 0) {
        let fA = lA[LA]
        if (
          (fA === void 0 &&
            (LA === "instanceMatrix" && _.instanceMatrix && (fA = _.instanceMatrix),
            LA === "instanceColor" && _.instanceColor && (fA = _.instanceColor)),
          fA !== void 0)
        ) {
          const sA = fA.normalized,
            $ = fA.itemSize,
            EA = A.get(fA)
          if (EA === void 0) continue
          const GA = EA.buffer,
            DA = EA.type,
            dA = EA.bytesPerElement,
            kA = DA === e.INT || DA === e.UNSIGNED_INT || fA.gpuType === _N
          if (fA.isInterleavedBufferAttribute) {
            const NA = fA.data,
              qA = NA.stride,
              ZA = fA.offset
            if (NA.isInstancedInterleavedBuffer) {
              for (let sI = 0; sI < nA.locationSize; sI++) F(nA.location + sI, NA.meshPerAttribute)
              _.isInstancedMesh !== !0 &&
                aA._maxInstanceCount === void 0 &&
                (aA._maxInstanceCount = NA.meshPerAttribute * NA.count)
            } else for (let sI = 0; sI < nA.locationSize; sI++) R(nA.location + sI)
            e.bindBuffer(e.ARRAY_BUFFER, GA)
            for (let sI = 0; sI < nA.locationSize; sI++)
              Y(
                nA.location + sI,
                $ / nA.locationSize,
                DA,
                sA,
                qA * dA,
                (ZA + ($ / nA.locationSize) * sI) * dA,
                kA,
              )
          } else {
            if (fA.isInstancedBufferAttribute) {
              for (let NA = 0; NA < nA.locationSize; NA++) F(nA.location + NA, fA.meshPerAttribute)
              _.isInstancedMesh !== !0 &&
                aA._maxInstanceCount === void 0 &&
                (aA._maxInstanceCount = fA.meshPerAttribute * fA.count)
            } else for (let NA = 0; NA < nA.locationSize; NA++) R(nA.location + NA)
            e.bindBuffer(e.ARRAY_BUFFER, GA)
            for (let NA = 0; NA < nA.locationSize; NA++)
              Y(
                nA.location + NA,
                $ / nA.locationSize,
                DA,
                sA,
                $ * dA,
                ($ / nA.locationSize) * NA * dA,
                kA,
              )
          }
        } else if (yA !== void 0) {
          const sA = yA[LA]
          if (sA !== void 0)
            switch (sA.length) {
              case 2:
                e.vertexAttrib2fv(nA.location, sA)
                break
              case 3:
                e.vertexAttrib3fv(nA.location, sA)
                break
              case 4:
                e.vertexAttrib4fv(nA.location, sA)
                break
              default:
                e.vertexAttrib1fv(nA.location, sA)
            }
        }
      }
    }
    L()
  }
  function V() {
    AA()
    for (const _ in g) {
      const eA = g[_]
      for (const CA in eA) {
        const aA = eA[CA]
        for (const lA in aA) (h(aA[lA].object), delete aA[lA])
        delete eA[CA]
      }
      delete g[_]
    }
  }
  function j(_) {
    if (g[_.id] === void 0) return
    const eA = g[_.id]
    for (const CA in eA) {
      const aA = eA[CA]
      for (const lA in aA) (h(aA[lA].object), delete aA[lA])
      delete eA[CA]
    }
    delete g[_.id]
  }
  function P(_) {
    for (const eA in g) {
      const CA = g[eA]
      if (CA[_.id] === void 0) continue
      const aA = CA[_.id]
      for (const lA in aA) (h(aA[lA].object), delete aA[lA])
      delete CA[_.id]
    }
  }
  function AA() {
    ;(X(), (B = !0), i !== C && ((i = C), s(i.object)))
  }
  function X() {
    ;((C.geometry = null), (C.program = null), (C.wireframe = !1))
  }
  return {
    setup: o,
    reset: AA,
    resetDefaultState: X,
    dispose: V,
    releaseStatesOfGeometry: j,
    releaseStatesOfProgram: P,
    initAttributes: K,
    enableAttribute: R,
    disableUnusedAttributes: L,
  }
}
function fW(e, A, I) {
  let g
  function C(s) {
    g = s
  }
  function i(s, h) {
    ;(e.drawArrays(g, s, h), I.update(h, g, 1))
  }
  function B(s, h, S) {
    S !== 0 && (e.drawArraysInstanced(g, s, h, S), I.update(h, g, S))
  }
  function o(s, h, S) {
    if (S === 0) return
    A.get("WEBGL_multi_draw").multiDrawArraysWEBGL(g, s, 0, h, 0, S)
    let w = 0
    for (let M = 0; M < S; M++) w += h[M]
    I.update(w, g, 1)
  }
  function r(s, h, S, d) {
    if (S === 0) return
    const w = A.get("WEBGL_multi_draw")
    if (w === null) for (let M = 0; M < s.length; M++) B(s[M], h[M], d[M])
    else {
      w.multiDrawArraysInstancedWEBGL(g, s, 0, h, 0, d, 0, S)
      let M = 0
      for (let K = 0; K < S; K++) M += h[K] * d[K]
      I.update(M, g, 1)
    }
  }
  ;((this.setMode = C),
    (this.render = i),
    (this.renderInstances = B),
    (this.renderMultiDraw = o),
    (this.renderMultiDrawInstances = r))
}
function dW(e, A, I, g) {
  let C
  function i() {
    if (C !== void 0) return C
    if (A.has("EXT_texture_filter_anisotropic") === !0) {
      const P = A.get("EXT_texture_filter_anisotropic")
      C = e.getParameter(P.MAX_TEXTURE_MAX_ANISOTROPY_EXT)
    } else C = 0
    return C
  }
  function B(P) {
    return !(P !== lE && g.convert(P) !== e.getParameter(e.IMPLEMENTATION_COLOR_READ_FORMAT))
  }
  function o(P) {
    const AA = P === KD && (A.has("EXT_color_buffer_half_float") || A.has("EXT_color_buffer_float"))
    return !(
      P !== Xo &&
      g.convert(P) !== e.getParameter(e.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
      P !== sE &&
      !AA
    )
  }
  function r(P) {
    if (P === "highp") {
      if (
        e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_FLOAT).precision > 0 &&
        e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT).precision > 0
      )
        return "highp"
      P = "mediump"
    }
    return P === "mediump" &&
      e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_FLOAT).precision > 0 &&
      e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_FLOAT).precision > 0
      ? "mediump"
      : "lowp"
  }
  let s = I.precision !== void 0 ? I.precision : "highp"
  const h = r(s)
  h !== s &&
    (console.warn("THREE.WebGLRenderer:", s, "not supported, using", h, "instead."), (s = h))
  const S = I.logarithmicDepthBuffer === !0,
    d = I.reverseDepthBuffer === !0 && A.has("EXT_clip_control"),
    w = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS),
    M = e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
    K = e.getParameter(e.MAX_TEXTURE_SIZE),
    R = e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE),
    F = e.getParameter(e.MAX_VERTEX_ATTRIBS),
    L = e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS),
    Y = e.getParameter(e.MAX_VARYING_VECTORS),
    H = e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS),
    V = M > 0,
    j = e.getParameter(e.MAX_SAMPLES)
  return {
    isWebGL2: !0,
    // keeping this for backwards compatibility
    getMaxAnisotropy: i,
    getMaxPrecision: r,
    textureFormatReadable: B,
    textureTypeReadable: o,
    precision: s,
    logarithmicDepthBuffer: S,
    reverseDepthBuffer: d,
    maxTextures: w,
    maxVertexTextures: M,
    maxTextureSize: K,
    maxCubemapSize: R,
    maxAttributes: F,
    maxVertexUniforms: L,
    maxVaryings: Y,
    maxFragmentUniforms: H,
    vertexTextures: V,
    maxSamples: j,
  }
}
function yW(e) {
  const A = this
  let I = null,
    g = 0,
    C = !1,
    i = !1
  const B = new fD(),
    o = new ce(),
    r = { value: null, needsUpdate: !1 }
  ;((this.uniform = r),
    (this.numPlanes = 0),
    (this.numIntersection = 0),
    (this.init = function (S, d) {
      const w =
        S.length !== 0 ||
        d || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        g !== 0 ||
        C
      return ((C = d), (g = S.length), w)
    }),
    (this.beginShadows = function () {
      ;((i = !0), h(null))
    }),
    (this.endShadows = function () {
      i = !1
    }),
    (this.setGlobalState = function (S, d) {
      I = h(S, d, 0)
    }),
    (this.setState = function (S, d, w) {
      const M = S.clippingPlanes,
        K = S.clipIntersection,
        R = S.clipShadows,
        F = e.get(S)
      if (!C || M === null || M.length === 0 || (i && !R)) i ? h(null) : s()
      else {
        const L = i ? 0 : g,
          Y = L * 4
        let H = F.clippingState || null
        ;((r.value = H), (H = h(M, d, Y, w)))
        for (let V = 0; V !== Y; ++V) H[V] = I[V]
        ;((F.clippingState = H),
          (this.numIntersection = K ? this.numPlanes : 0),
          (this.numPlanes += L))
      }
    }))
  function s() {
    ;(r.value !== I && ((r.value = I), (r.needsUpdate = g > 0)),
      (A.numPlanes = g),
      (A.numIntersection = 0))
  }
  function h(S, d, w, M) {
    const K = S !== null ? S.length : 0
    let R = null
    if (K !== 0) {
      if (((R = r.value), M !== !0 || R === null)) {
        const F = w + K * 4,
          L = d.matrixWorldInverse
        ;(o.getNormalMatrix(L), (R === null || R.length < F) && (R = new Float32Array(F)))
        for (let Y = 0, H = w; Y !== K; ++Y, H += 4)
          (B.copy(S[Y]).applyMatrix4(L, o), B.normal.toArray(R, H), (R[H + 3] = B.constant))
      }
      ;((r.value = R), (r.needsUpdate = !0))
    }
    return ((A.numPlanes = K), (A.numIntersection = 0), R)
  }
}
function pW(e) {
  let A = /* @__PURE__ */ new WeakMap()
  function I(B, o) {
    return (o === nG ? (B.mapping = Bu) : o === EG && (B.mapping = kD), B)
  }
  function g(B) {
    if (B && B.isTexture) {
      const o = B.mapping
      if (o === nG || o === EG)
        if (A.has(B)) {
          const r = A.get(B).texture
          return I(r, B.mapping)
        } else {
          const r = B.image
          if (r && r.height > 0) {
            const s = new W2(r.height)
            return (
              s.fromEquirectangularTexture(e, B),
              A.set(B, s),
              B.addEventListener("dispose", C),
              I(s.texture, B.mapping)
            )
          } else return null
        }
    }
    return B
  }
  function C(B) {
    const o = B.target
    o.removeEventListener("dispose", C)
    const r = A.get(o)
    r !== void 0 && (A.delete(o), r.dispose())
  }
  function i() {
    A = /* @__PURE__ */ new WeakMap()
  }
  return {
    get: g,
    dispose: i,
  }
}
class yp extends dp {
  constructor(A = -1, I = 1, g = 1, C = -1, i = 0.1, B = 2e3) {
    ;(super(),
      (this.isOrthographicCamera = !0),
      (this.type = "OrthographicCamera"),
      (this.zoom = 1),
      (this.view = null),
      (this.left = A),
      (this.right = I),
      (this.top = g),
      (this.bottom = C),
      (this.near = i),
      (this.far = B),
      this.updateProjectionMatrix())
  }
  copy(A, I) {
    return (
      super.copy(A, I),
      (this.left = A.left),
      (this.right = A.right),
      (this.top = A.top),
      (this.bottom = A.bottom),
      (this.near = A.near),
      (this.far = A.far),
      (this.zoom = A.zoom),
      (this.view = A.view === null ? null : Object.assign({}, A.view)),
      this
    )
  }
  setViewOffset(A, I, g, C, i, B) {
    ;(this.view === null &&
      (this.view = {
        enabled: !0,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1,
      }),
      (this.view.enabled = !0),
      (this.view.fullWidth = A),
      (this.view.fullHeight = I),
      (this.view.offsetX = g),
      (this.view.offsetY = C),
      (this.view.width = i),
      (this.view.height = B),
      this.updateProjectionMatrix())
  }
  clearViewOffset() {
    ;(this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix())
  }
  updateProjectionMatrix() {
    const A = (this.right - this.left) / (2 * this.zoom),
      I = (this.top - this.bottom) / (2 * this.zoom),
      g = (this.right + this.left) / 2,
      C = (this.top + this.bottom) / 2
    let i = g - A,
      B = g + A,
      o = C + I,
      r = C - I
    if (this.view !== null && this.view.enabled) {
      const s = (this.right - this.left) / this.view.fullWidth / this.zoom,
        h = (this.top - this.bottom) / this.view.fullHeight / this.zoom
      ;((i += s * this.view.offsetX),
        (B = i + s * this.view.width),
        (o -= h * this.view.offsetY),
        (r = o - h * this.view.height))
    }
    ;(this.projectionMatrix.makeOrthographic(
      i,
      B,
      o,
      r,
      this.near,
      this.far,
      this.coordinateSystem,
    ),
      this.projectionMatrixInverse.copy(this.projectionMatrix).invert())
  }
  toJSON(A) {
    const I = super.toJSON(A)
    return (
      (I.object.zoom = this.zoom),
      (I.object.left = this.left),
      (I.object.right = this.right),
      (I.object.top = this.top),
      (I.object.bottom = this.bottom),
      (I.object.near = this.near),
      (I.object.far = this.far),
      this.view !== null && (I.object.view = Object.assign({}, this.view)),
      I
    )
  }
}
const Ip = 4,
  $q = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582],
  yf = 20,
  sK = /* @__PURE__ */ new yp(),
  AH = /* @__PURE__ */ new Mg()
let lK = null,
  cK = 0,
  hK = 0,
  uK = !1
const df = (1 + Math.sqrt(5)) / 2,
  Ty = 1 / df,
  IH = [
    /* @__PURE__ */ new wA(-df, Ty, 0),
    /* @__PURE__ */ new wA(df, Ty, 0),
    /* @__PURE__ */ new wA(-Ty, 0, df),
    /* @__PURE__ */ new wA(Ty, 0, df),
    /* @__PURE__ */ new wA(0, df, -Ty),
    /* @__PURE__ */ new wA(0, df, Ty),
    /* @__PURE__ */ new wA(-1, 1, -1),
    /* @__PURE__ */ new wA(1, 1, -1),
    /* @__PURE__ */ new wA(-1, 1, 1),
    /* @__PURE__ */ new wA(1, 1, 1),
  ]
class Dm {
  constructor(A) {
    ;((this._renderer = A),
      (this._pingPongRenderTarget = null),
      (this._lodMax = 0),
      (this._cubeSize = 0),
      (this._lodPlanes = []),
      (this._sizeLods = []),
      (this._sigmas = []),
      (this._blurMaterial = null),
      (this._cubemapMaterial = null),
      (this._equirectMaterial = null),
      this._compileMaterial(this._blurMaterial))
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety (the cubeCamera
   * is placed at the origin).
   */
  fromScene(A, I = 0, g = 0.1, C = 100) {
    ;((lK = this._renderer.getRenderTarget()),
      (cK = this._renderer.getActiveCubeFace()),
      (hK = this._renderer.getActiveMipmapLevel()),
      (uK = this._renderer.xr.enabled),
      (this._renderer.xr.enabled = !1),
      this._setSize(256))
    const i = this._allocateTargets()
    return (
      (i.depthBuffer = !0),
      this._sceneToCubeUV(A, g, C, i),
      I > 0 && this._blur(i, 0, 0, I),
      this._applyPMREM(i),
      this._cleanup(i),
      i
    )
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   * The smallest supported equirectangular image size is 64 x 32.
   */
  fromEquirectangular(A, I = null) {
    return this._fromTexture(A, I)
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   * The smallest supported cube size is 16 x 16.
   */
  fromCubemap(A, I = null) {
    return this._fromTexture(A, I)
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileCubemapShader() {
    this._cubemapMaterial === null &&
      ((this._cubemapMaterial = eH()), this._compileMaterial(this._cubemapMaterial))
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileEquirectangularShader() {
    this._equirectMaterial === null &&
      ((this._equirectMaterial = CH()), this._compileMaterial(this._equirectMaterial))
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    ;(this._dispose(),
      this._cubemapMaterial !== null && this._cubemapMaterial.dispose(),
      this._equirectMaterial !== null && this._equirectMaterial.dispose())
  }
  // private interface
  _setSize(A) {
    ;((this._lodMax = Math.floor(Math.log2(A))), (this._cubeSize = Math.pow(2, this._lodMax)))
  }
  _dispose() {
    ;(this._blurMaterial !== null && this._blurMaterial.dispose(),
      this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose())
    for (let A = 0; A < this._lodPlanes.length; A++) this._lodPlanes[A].dispose()
  }
  _cleanup(A) {
    ;(this._renderer.setRenderTarget(lK, cK, hK),
      (this._renderer.xr.enabled = uK),
      (A.scissorTest = !1),
      zM(A, 0, 0, A.width, A.height))
  }
  _fromTexture(A, I) {
    ;(A.mapping === Bu || A.mapping === kD
      ? this._setSize(A.image.length === 0 ? 16 : A.image[0].width || A.image[0].image.width)
      : this._setSize(A.image.width / 4),
      (lK = this._renderer.getRenderTarget()),
      (cK = this._renderer.getActiveCubeFace()),
      (hK = this._renderer.getActiveMipmapLevel()),
      (uK = this._renderer.xr.enabled),
      (this._renderer.xr.enabled = !1))
    const g = I || this._allocateTargets()
    return (this._textureToCubeUV(A, g), this._applyPMREM(g), this._cleanup(g), g)
  }
  _allocateTargets() {
    const A = 3 * Math.max(this._cubeSize, 112),
      I = 4 * this._cubeSize,
      g = {
        magFilter: nt,
        minFilter: nt,
        generateMipmaps: !1,
        type: KD,
        format: lE,
        colorSpace: ru,
        depthBuffer: !1,
      },
      C = gH(A, I, g)
    if (
      this._pingPongRenderTarget === null ||
      this._pingPongRenderTarget.width !== A ||
      this._pingPongRenderTarget.height !== I
    ) {
      ;(this._pingPongRenderTarget !== null && this._dispose(),
        (this._pingPongRenderTarget = gH(A, I, g)))
      const { _lodMax: i } = this
      ;(({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = wW(i)),
        (this._blurMaterial = GW(i, A, I)))
    }
    return C
  }
  _compileMaterial(A) {
    const I = new EB(this._lodPlanes[0], A)
    this._renderer.compile(I, sK)
  }
  _sceneToCubeUV(A, I, g, C) {
    const o = new PQ(90, 1, I, g),
      r = [1, -1, 1, 1, 1, 1],
      s = [1, 1, 1, -1, -1, -1],
      h = this._renderer,
      S = h.autoClear,
      d = h.toneMapping
    ;(h.getClearColor(AH), (h.toneMapping = Ms), (h.autoClear = !1))
    const w = new La({
        name: "PMREM.Background",
        side: WQ,
        depthWrite: !1,
        depthTest: !1,
      }),
      M = new EB(new Vf(), w)
    let K = !1
    const R = A.background
    R
      ? R.isColor && (w.color.copy(R), (A.background = null), (K = !0))
      : (w.color.copy(AH), (K = !0))
    for (let F = 0; F < 6; F++) {
      const L = F % 3
      L === 0
        ? (o.up.set(0, r[F], 0), o.lookAt(s[F], 0, 0))
        : L === 1
          ? (o.up.set(0, 0, r[F]), o.lookAt(0, s[F], 0))
          : (o.up.set(0, r[F], 0), o.lookAt(0, 0, s[F]))
      const Y = this._cubeSize
      ;(zM(C, L * Y, F > 2 ? Y : 0, Y, Y),
        h.setRenderTarget(C),
        K && h.render(M, o),
        h.render(A, o))
    }
    ;(M.geometry.dispose(),
      M.material.dispose(),
      (h.toneMapping = d),
      (h.autoClear = S),
      (A.background = R))
  }
  _textureToCubeUV(A, I) {
    const g = this._renderer,
      C = A.mapping === Bu || A.mapping === kD
    C
      ? (this._cubemapMaterial === null && (this._cubemapMaterial = eH()),
        (this._cubemapMaterial.uniforms.flipEnvMap.value = A.isRenderTargetTexture === !1 ? -1 : 1))
      : this._equirectMaterial === null && (this._equirectMaterial = CH())
    const i = C ? this._cubemapMaterial : this._equirectMaterial,
      B = new EB(this._lodPlanes[0], i),
      o = i.uniforms
    o.envMap.value = A
    const r = this._cubeSize
    ;(zM(I, 0, 0, 3 * r, 2 * r), g.setRenderTarget(I), g.render(B, sK))
  }
  _applyPMREM(A) {
    const I = this._renderer,
      g = I.autoClear
    I.autoClear = !1
    const C = this._lodPlanes.length
    for (let i = 1; i < C; i++) {
      const B = Math.sqrt(
          this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1],
        ),
        o = IH[(C - i - 1) % IH.length]
      this._blur(A, i - 1, i, B, o)
    }
    I.autoClear = g
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   */
  _blur(A, I, g, C, i) {
    const B = this._pingPongRenderTarget
    ;(this._halfBlur(A, B, I, g, C, "latitudinal", i),
      this._halfBlur(B, A, g, g, C, "longitudinal", i))
  }
  _halfBlur(A, I, g, C, i, B, o) {
    const r = this._renderer,
      s = this._blurMaterial
    B !== "latitudinal" &&
      B !== "longitudinal" &&
      console.error("blur direction must be either latitudinal or longitudinal!")
    const h = 3,
      S = new EB(this._lodPlanes[C], s),
      d = s.uniforms,
      w = this._sizeLods[g] - 1,
      M = isFinite(i) ? Math.PI / (2 * w) : (2 * Math.PI) / (2 * yf - 1),
      K = i / M,
      R = isFinite(i) ? 1 + Math.floor(h * K) : yf
    R > yf &&
      console.warn(
        `sigmaRadians, ${i}, is too large and will clip, as it requested ${R} samples when the maximum is set to ${yf}`,
      )
    const F = []
    let L = 0
    for (let P = 0; P < yf; ++P) {
      const AA = P / K,
        X = Math.exp((-AA * AA) / 2)
      ;(F.push(X), P === 0 ? (L += X) : P < R && (L += 2 * X))
    }
    for (let P = 0; P < F.length; P++) F[P] = F[P] / L
    ;((d.envMap.value = A.texture),
      (d.samples.value = R),
      (d.weights.value = F),
      (d.latitudinal.value = B === "latitudinal"),
      o && (d.poleAxis.value = o))
    const { _lodMax: Y } = this
    ;((d.dTheta.value = M), (d.mipInt.value = Y - g))
    const H = this._sizeLods[C],
      V = 3 * H * (C > Y - Ip ? C - Y + Ip : 0),
      j = 4 * (this._cubeSize - H)
    ;(zM(I, V, j, 3 * H, 2 * H), r.setRenderTarget(I), r.render(S, sK))
  }
}
function wW(e) {
  const A = [],
    I = [],
    g = []
  let C = e
  const i = e - Ip + 1 + $q.length
  for (let B = 0; B < i; B++) {
    const o = Math.pow(2, C)
    I.push(o)
    let r = 1 / o
    ;(B > e - Ip ? (r = $q[B - e + Ip - 1]) : B === 0 && (r = 0), g.push(r))
    const s = 1 / (o - 2),
      h = -s,
      S = 1 + s,
      d = [h, h, S, h, S, S, h, h, S, S, h, S],
      w = 6,
      M = 6,
      K = 3,
      R = 2,
      F = 1,
      L = new Float32Array(K * M * w),
      Y = new Float32Array(R * M * w),
      H = new Float32Array(F * M * w)
    for (let j = 0; j < w; j++) {
      const P = ((j % 3) * 2) / 3 - 1,
        AA = j > 2 ? 0 : -1,
        X = [
          P,
          AA,
          0,
          P + 2 / 3,
          AA,
          0,
          P + 2 / 3,
          AA + 1,
          0,
          P,
          AA,
          0,
          P + 2 / 3,
          AA + 1,
          0,
          P,
          AA + 1,
          0,
        ]
      ;(L.set(X, K * M * j), Y.set(d, R * M * j))
      const _ = [j, j, j, j, j, j]
      H.set(_, F * M * j)
    }
    const V = new se()
    ;(V.setAttribute("position", new Ye(L, K)),
      V.setAttribute("uv", new Ye(Y, R)),
      V.setAttribute("faceIndex", new Ye(H, F)),
      A.push(V),
      C > Ip && C--)
  }
  return { lodPlanes: A, sizeLods: I, sigmas: g }
}
function gH(e, A, I) {
  const g = new BQ(e, A, I)
  return ((g.texture.mapping = Sp), (g.texture.name = "PMREM.cubeUv"), (g.scissorTest = !0), g)
}
function zM(e, A, I, g, C) {
  ;(e.viewport.set(A, I, g, C), e.scissor.set(A, I, g, C))
}
function GW(e, A, I) {
  const g = new Float32Array(yf),
    C = new wA(0, 1, 0)
  return new VQ({
    name: "SphericalGaussianBlur",
    defines: {
      n: yf,
      CUBEUV_TEXEL_WIDTH: 1 / A,
      CUBEUV_TEXEL_HEIGHT: 1 / I,
      CUBEUV_MAX_MIP: `${e}.0`,
    },
    uniforms: {
      envMap: { value: null },
      samples: { value: 1 },
      weights: { value: g },
      latitudinal: { value: !1 },
      dTheta: { value: 0 },
      mipInt: { value: 0 },
      poleAxis: { value: C },
    },
    vertexShader: ev(),
    fragmentShader:
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
    blending: hE,
    depthTest: !1,
    depthWrite: !1,
  })
}
function CH() {
  return new VQ({
    name: "EquirectangularToCubeUV",
    uniforms: {
      envMap: { value: null },
    },
    vertexShader: ev(),
    fragmentShader:
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
    blending: hE,
    depthTest: !1,
    depthWrite: !1,
  })
}
function eH() {
  return new VQ({
    name: "CubemapToCubeUV",
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 },
    },
    vertexShader: ev(),
    fragmentShader:
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
    blending: hE,
    depthTest: !1,
    depthWrite: !1,
  })
}
function ev() {
  return (
    /* glsl */
    `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
  )
}
function kW(e) {
  let A = /* @__PURE__ */ new WeakMap(),
    I = null
  function g(o) {
    if (o && o.isTexture) {
      const r = o.mapping,
        s = r === nG || r === EG,
        h = r === Bu || r === kD
      if (s || h) {
        let S = A.get(o)
        const d = S !== void 0 ? S.texture.pmremVersion : 0
        if (o.isRenderTargetTexture && o.pmremVersion !== d)
          return (
            I === null && (I = new Dm(e)),
            (S = s ? I.fromEquirectangular(o, S) : I.fromCubemap(o, S)),
            (S.texture.pmremVersion = o.pmremVersion),
            A.set(o, S),
            S.texture
          )
        if (S !== void 0) return S.texture
        {
          const w = o.image
          return (s && w && w.height > 0) || (h && w && C(w))
            ? (I === null && (I = new Dm(e)),
              (S = s ? I.fromEquirectangular(o) : I.fromCubemap(o)),
              (S.texture.pmremVersion = o.pmremVersion),
              A.set(o, S),
              o.addEventListener("dispose", i),
              S.texture)
            : null
        }
      }
    }
    return o
  }
  function C(o) {
    let r = 0
    const s = 6
    for (let h = 0; h < s; h++) o[h] !== void 0 && r++
    return r === s
  }
  function i(o) {
    const r = o.target
    r.removeEventListener("dispose", i)
    const s = A.get(r)
    s !== void 0 && (A.delete(r), s.dispose())
  }
  function B() {
    ;((A = /* @__PURE__ */ new WeakMap()), I !== null && (I.dispose(), (I = null)))
  }
  return {
    get: g,
    dispose: B,
  }
}
function MW(e) {
  const A = {}
  function I(g) {
    if (A[g] !== void 0) return A[g]
    let C
    switch (g) {
      case "WEBGL_depth_texture":
        C =
          e.getExtension("WEBGL_depth_texture") ||
          e.getExtension("MOZ_WEBGL_depth_texture") ||
          e.getExtension("WEBKIT_WEBGL_depth_texture")
        break
      case "EXT_texture_filter_anisotropic":
        C =
          e.getExtension("EXT_texture_filter_anisotropic") ||
          e.getExtension("MOZ_EXT_texture_filter_anisotropic") ||
          e.getExtension("WEBKIT_EXT_texture_filter_anisotropic")
        break
      case "WEBGL_compressed_texture_s3tc":
        C =
          e.getExtension("WEBGL_compressed_texture_s3tc") ||
          e.getExtension("MOZ_WEBGL_compressed_texture_s3tc") ||
          e.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc")
        break
      case "WEBGL_compressed_texture_pvrtc":
        C =
          e.getExtension("WEBGL_compressed_texture_pvrtc") ||
          e.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc")
        break
      default:
        C = e.getExtension(g)
    }
    return ((A[g] = C), C)
  }
  return {
    has: function (g) {
      return I(g) !== null
    },
    init: function () {
      ;(I("EXT_color_buffer_float"),
        I("WEBGL_clip_cull_distance"),
        I("OES_texture_float_linear"),
        I("EXT_color_buffer_half_float"),
        I("WEBGL_multisampled_render_to_texture"),
        I("WEBGL_render_shared_exponent"))
    },
    get: function (g) {
      const C = I(g)
      return (C === null && O0("THREE.WebGLRenderer: " + g + " extension not supported."), C)
    },
  }
}
function UW(e, A, I, g) {
  const C = {},
    i = /* @__PURE__ */ new WeakMap()
  function B(S) {
    const d = S.target
    d.index !== null && A.remove(d.index)
    for (const M in d.attributes) A.remove(d.attributes[M])
    for (const M in d.morphAttributes) {
      const K = d.morphAttributes[M]
      for (let R = 0, F = K.length; R < F; R++) A.remove(K[R])
    }
    ;(d.removeEventListener("dispose", B), delete C[d.id])
    const w = i.get(d)
    ;(w && (A.remove(w), i.delete(d)),
      g.releaseStatesOfGeometry(d),
      d.isInstancedBufferGeometry === !0 && delete d._maxInstanceCount,
      I.memory.geometries--)
  }
  function o(S, d) {
    return (
      C[d.id] === !0 || (d.addEventListener("dispose", B), (C[d.id] = !0), I.memory.geometries++),
      d
    )
  }
  function r(S) {
    const d = S.attributes
    for (const M in d) A.update(d[M], e.ARRAY_BUFFER)
    const w = S.morphAttributes
    for (const M in w) {
      const K = w[M]
      for (let R = 0, F = K.length; R < F; R++) A.update(K[R], e.ARRAY_BUFFER)
    }
  }
  function s(S) {
    const d = [],
      w = S.index,
      M = S.attributes.position
    let K = 0
    if (w !== null) {
      const L = w.array
      K = w.version
      for (let Y = 0, H = L.length; Y < H; Y += 3) {
        const V = L[Y + 0],
          j = L[Y + 1],
          P = L[Y + 2]
        d.push(V, j, j, P, P, V)
      }
    } else if (M !== void 0) {
      const L = M.array
      K = M.version
      for (let Y = 0, H = L.length / 3 - 1; Y < H; Y += 3) {
        const V = Y + 0,
          j = Y + 1,
          P = Y + 2
        d.push(V, j, j, P, P, V)
      }
    } else return
    const R = new (T2(d) ? Cv : gv)(d, 1)
    R.version = K
    const F = i.get(S)
    ;(F && A.remove(F), i.set(S, R))
  }
  function h(S) {
    const d = i.get(S)
    if (d) {
      const w = S.index
      w !== null && d.version < w.version && s(S)
    } else s(S)
    return i.get(S)
  }
  return {
    get: o,
    update: r,
    getWireframeAttribute: h,
  }
}
function NW(e, A, I) {
  let g
  function C(d) {
    g = d
  }
  let i, B
  function o(d) {
    ;((i = d.type), (B = d.bytesPerElement))
  }
  function r(d, w) {
    ;(e.drawElements(g, w, i, d * B), I.update(w, g, 1))
  }
  function s(d, w, M) {
    M !== 0 && (e.drawElementsInstanced(g, w, i, d * B, M), I.update(w, g, M))
  }
  function h(d, w, M) {
    if (M === 0) return
    A.get("WEBGL_multi_draw").multiDrawElementsWEBGL(g, w, 0, i, d, 0, M)
    let R = 0
    for (let F = 0; F < M; F++) R += w[F]
    I.update(R, g, 1)
  }
  function S(d, w, M, K) {
    if (M === 0) return
    const R = A.get("WEBGL_multi_draw")
    if (R === null) for (let F = 0; F < d.length; F++) s(d[F] / B, w[F], K[F])
    else {
      R.multiDrawElementsInstancedWEBGL(g, w, 0, i, d, 0, K, 0, M)
      let F = 0
      for (let L = 0; L < M; L++) F += w[L] * K[L]
      I.update(F, g, 1)
    }
  }
  ;((this.setMode = C),
    (this.setIndex = o),
    (this.render = r),
    (this.renderInstances = s),
    (this.renderMultiDraw = h),
    (this.renderMultiDrawInstances = S))
}
function FW(e) {
  const A = {
      geometries: 0,
      textures: 0,
    },
    I = {
      frame: 0,
      calls: 0,
      triangles: 0,
      points: 0,
      lines: 0,
    }
  function g(i, B, o) {
    switch ((I.calls++, B)) {
      case e.TRIANGLES:
        I.triangles += o * (i / 3)
        break
      case e.LINES:
        I.lines += o * (i / 2)
        break
      case e.LINE_STRIP:
        I.lines += o * (i - 1)
        break
      case e.LINE_LOOP:
        I.lines += o * i
        break
      case e.POINTS:
        I.points += o * i
        break
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", B)
        break
    }
  }
  function C() {
    ;((I.calls = 0), (I.triangles = 0), (I.points = 0), (I.lines = 0))
  }
  return {
    memory: A,
    render: I,
    programs: null,
    autoReset: !0,
    reset: C,
    update: g,
  }
}
function RW(e, A, I) {
  const g = /* @__PURE__ */ new WeakMap(),
    C = new Xe()
  function i(B, o, r) {
    const s = B.morphTargetInfluences,
      h = o.morphAttributes.position || o.morphAttributes.normal || o.morphAttributes.color,
      S = h !== void 0 ? h.length : 0
    let d = g.get(o)
    if (d === void 0 || d.count !== S) {
      let X = function () {
        ;(P.dispose(), g.delete(o), o.removeEventListener("dispose", X))
      }
      d !== void 0 && d.texture.dispose()
      const w = o.morphAttributes.position !== void 0,
        M = o.morphAttributes.normal !== void 0,
        K = o.morphAttributes.color !== void 0,
        R = o.morphAttributes.position || [],
        F = o.morphAttributes.normal || [],
        L = o.morphAttributes.color || []
      let Y = 0
      ;(w === !0 && (Y = 1), M === !0 && (Y = 2), K === !0 && (Y = 3))
      let H = o.attributes.position.count * Y,
        V = 1
      H > A.maxTextureSize && ((V = Math.ceil(H / A.maxTextureSize)), (H = A.maxTextureSize))
      const j = new Float32Array(H * V * 4 * S),
        P = new $N(j, H, V, S)
      ;((P.type = sE), (P.needsUpdate = !0))
      const AA = Y * 4
      for (let _ = 0; _ < S; _++) {
        const eA = R[_],
          CA = F[_],
          aA = L[_],
          lA = H * V * 4 * _
        for (let JA = 0; JA < eA.count; JA++) {
          const yA = JA * AA
          ;(w === !0 &&
            (C.fromBufferAttribute(eA, JA),
            (j[lA + yA + 0] = C.x),
            (j[lA + yA + 1] = C.y),
            (j[lA + yA + 2] = C.z),
            (j[lA + yA + 3] = 0)),
            M === !0 &&
              (C.fromBufferAttribute(CA, JA),
              (j[lA + yA + 4] = C.x),
              (j[lA + yA + 5] = C.y),
              (j[lA + yA + 6] = C.z),
              (j[lA + yA + 7] = 0)),
            K === !0 &&
              (C.fromBufferAttribute(aA, JA),
              (j[lA + yA + 8] = C.x),
              (j[lA + yA + 9] = C.y),
              (j[lA + yA + 10] = C.z),
              (j[lA + yA + 11] = aA.itemSize === 4 ? C.w : 1)))
        }
      }
      ;((d = {
        count: S,
        texture: P,
        size: new ZI(H, V),
      }),
        g.set(o, d),
        o.addEventListener("dispose", X))
    }
    if (B.isInstancedMesh === !0 && B.morphTexture !== null)
      r.getUniforms().setValue(e, "morphTexture", B.morphTexture, I)
    else {
      let w = 0
      for (let K = 0; K < s.length; K++) w += s[K]
      const M = o.morphTargetsRelative ? 1 : 1 - w
      ;(r.getUniforms().setValue(e, "morphTargetBaseInfluence", M),
        r.getUniforms().setValue(e, "morphTargetInfluences", s))
    }
    ;(r.getUniforms().setValue(e, "morphTargetsTexture", d.texture, I),
      r.getUniforms().setValue(e, "morphTargetsTextureSize", d.size))
  }
  return {
    update: i,
  }
}
function JW(e, A, I, g) {
  let C = /* @__PURE__ */ new WeakMap()
  function i(r) {
    const s = g.render.frame,
      h = r.geometry,
      S = A.get(r, h)
    if (
      (C.get(S) !== s && (A.update(S), C.set(S, s)),
      r.isInstancedMesh &&
        (r.hasEventListener("dispose", o) === !1 && r.addEventListener("dispose", o),
        C.get(r) !== s &&
          (I.update(r.instanceMatrix, e.ARRAY_BUFFER),
          r.instanceColor !== null && I.update(r.instanceColor, e.ARRAY_BUFFER),
          C.set(r, s))),
      r.isSkinnedMesh)
    ) {
      const d = r.skeleton
      C.get(d) !== s && (d.update(), C.set(d, s))
    }
    return S
  }
  function B() {
    C = /* @__PURE__ */ new WeakMap()
  }
  function o(r) {
    const s = r.target
    ;(s.removeEventListener("dispose", o),
      I.remove(s.instanceMatrix),
      s.instanceColor !== null && I.remove(s.instanceColor))
  }
  return {
    update: i,
    dispose: B,
  }
}
class JG extends pt {
  constructor(A, I, g, C, i, B, o, r, s, h = Rf) {
    if (h !== Rf && h !== ND)
      throw new Error(
        "DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat",
      )
    ;(g === void 0 && h === Rf && (g = Zc),
      g === void 0 && h === ND && (g = UD),
      super(null, C, i, B, o, r, h, g, s),
      (this.isDepthTexture = !0),
      (this.image = { width: A, height: I }),
      (this.magFilter = o !== void 0 ? o : iQ),
      (this.minFilter = r !== void 0 ? r : iQ),
      (this.flipY = !1),
      (this.generateMipmaps = !1),
      (this.compareFunction = null))
  }
  copy(A) {
    return (super.copy(A), (this.compareFunction = A.compareFunction), this)
  }
  toJSON(A) {
    const I = super.toJSON(A)
    return (this.compareFunction !== null && (I.compareFunction = this.compareFunction), I)
  }
}
const j2 = /* @__PURE__ */ new pt(),
  iH = /* @__PURE__ */ new JG(1, 1),
  z2 = /* @__PURE__ */ new $N(),
  X2 = /* @__PURE__ */ new Iv(),
  $2 = /* @__PURE__ */ new FG(),
  tH = [],
  BH = [],
  QH = new Float32Array(16),
  oH = new Float32Array(9),
  nH = new Float32Array(4)
function pp(e, A, I) {
  const g = e[0]
  if (g <= 0 || g > 0) return e
  const C = A * I
  let i = tH[C]
  if ((i === void 0 && ((i = new Float32Array(C)), (tH[C] = i)), A !== 0)) {
    g.toArray(i, 0)
    for (let B = 1, o = 0; B !== A; ++B) ((o += I), e[B].toArray(i, o))
  }
  return i
}
function uo(e, A) {
  if (e.length !== A.length) return !1
  for (let I = 0, g = e.length; I < g; I++) if (e[I] !== A[I]) return !1
  return !0
}
function Do(e, A) {
  for (let I = 0, g = A.length; I < g; I++) e[I] = A[I]
}
function IF(e, A) {
  let I = BH[A]
  I === void 0 && ((I = new Int32Array(A)), (BH[A] = I))
  for (let g = 0; g !== A; ++g) I[g] = e.allocateTextureUnit()
  return I
}
function KW(e, A) {
  const I = this.cache
  I[0] !== A && (e.uniform1f(this.addr, A), (I[0] = A))
}
function mW(e, A) {
  const I = this.cache
  if (A.x !== void 0)
    (I[0] !== A.x || I[1] !== A.y) && (e.uniform2f(this.addr, A.x, A.y), (I[0] = A.x), (I[1] = A.y))
  else {
    if (uo(I, A)) return
    ;(e.uniform2fv(this.addr, A), Do(I, A))
  }
}
function vW(e, A) {
  const I = this.cache
  if (A.x !== void 0)
    (I[0] !== A.x || I[1] !== A.y || I[2] !== A.z) &&
      (e.uniform3f(this.addr, A.x, A.y, A.z), (I[0] = A.x), (I[1] = A.y), (I[2] = A.z))
  else if (A.r !== void 0)
    (I[0] !== A.r || I[1] !== A.g || I[2] !== A.b) &&
      (e.uniform3f(this.addr, A.r, A.g, A.b), (I[0] = A.r), (I[1] = A.g), (I[2] = A.b))
  else {
    if (uo(I, A)) return
    ;(e.uniform3fv(this.addr, A), Do(I, A))
  }
}
function LW(e, A) {
  const I = this.cache
  if (A.x !== void 0)
    (I[0] !== A.x || I[1] !== A.y || I[2] !== A.z || I[3] !== A.w) &&
      (e.uniform4f(this.addr, A.x, A.y, A.z, A.w),
      (I[0] = A.x),
      (I[1] = A.y),
      (I[2] = A.z),
      (I[3] = A.w))
  else {
    if (uo(I, A)) return
    ;(e.uniform4fv(this.addr, A), Do(I, A))
  }
}
function YW(e, A) {
  const I = this.cache,
    g = A.elements
  if (g === void 0) {
    if (uo(I, A)) return
    ;(e.uniformMatrix2fv(this.addr, !1, A), Do(I, A))
  } else {
    if (uo(I, g)) return
    ;(nH.set(g), e.uniformMatrix2fv(this.addr, !1, nH), Do(I, g))
  }
}
function qW(e, A) {
  const I = this.cache,
    g = A.elements
  if (g === void 0) {
    if (uo(I, A)) return
    ;(e.uniformMatrix3fv(this.addr, !1, A), Do(I, A))
  } else {
    if (uo(I, g)) return
    ;(oH.set(g), e.uniformMatrix3fv(this.addr, !1, oH), Do(I, g))
  }
}
function HW(e, A) {
  const I = this.cache,
    g = A.elements
  if (g === void 0) {
    if (uo(I, A)) return
    ;(e.uniformMatrix4fv(this.addr, !1, A), Do(I, A))
  } else {
    if (uo(I, g)) return
    ;(QH.set(g), e.uniformMatrix4fv(this.addr, !1, QH), Do(I, g))
  }
}
function TW(e, A) {
  const I = this.cache
  I[0] !== A && (e.uniform1i(this.addr, A), (I[0] = A))
}
function xW(e, A) {
  const I = this.cache
  if (A.x !== void 0)
    (I[0] !== A.x || I[1] !== A.y) && (e.uniform2i(this.addr, A.x, A.y), (I[0] = A.x), (I[1] = A.y))
  else {
    if (uo(I, A)) return
    ;(e.uniform2iv(this.addr, A), Do(I, A))
  }
}
function bW(e, A) {
  const I = this.cache
  if (A.x !== void 0)
    (I[0] !== A.x || I[1] !== A.y || I[2] !== A.z) &&
      (e.uniform3i(this.addr, A.x, A.y, A.z), (I[0] = A.x), (I[1] = A.y), (I[2] = A.z))
  else {
    if (uo(I, A)) return
    ;(e.uniform3iv(this.addr, A), Do(I, A))
  }
}
function OW(e, A) {
  const I = this.cache
  if (A.x !== void 0)
    (I[0] !== A.x || I[1] !== A.y || I[2] !== A.z || I[3] !== A.w) &&
      (e.uniform4i(this.addr, A.x, A.y, A.z, A.w),
      (I[0] = A.x),
      (I[1] = A.y),
      (I[2] = A.z),
      (I[3] = A.w))
  else {
    if (uo(I, A)) return
    ;(e.uniform4iv(this.addr, A), Do(I, A))
  }
}
function _W(e, A) {
  const I = this.cache
  I[0] !== A && (e.uniform1ui(this.addr, A), (I[0] = A))
}
function ZW(e, A) {
  const I = this.cache
  if (A.x !== void 0)
    (I[0] !== A.x || I[1] !== A.y) &&
      (e.uniform2ui(this.addr, A.x, A.y), (I[0] = A.x), (I[1] = A.y))
  else {
    if (uo(I, A)) return
    ;(e.uniform2uiv(this.addr, A), Do(I, A))
  }
}
function PW(e, A) {
  const I = this.cache
  if (A.x !== void 0)
    (I[0] !== A.x || I[1] !== A.y || I[2] !== A.z) &&
      (e.uniform3ui(this.addr, A.x, A.y, A.z), (I[0] = A.x), (I[1] = A.y), (I[2] = A.z))
  else {
    if (uo(I, A)) return
    ;(e.uniform3uiv(this.addr, A), Do(I, A))
  }
}
function WW(e, A) {
  const I = this.cache
  if (A.x !== void 0)
    (I[0] !== A.x || I[1] !== A.y || I[2] !== A.z || I[3] !== A.w) &&
      (e.uniform4ui(this.addr, A.x, A.y, A.z, A.w),
      (I[0] = A.x),
      (I[1] = A.y),
      (I[2] = A.z),
      (I[3] = A.w))
  else {
    if (uo(I, A)) return
    ;(e.uniform4uiv(this.addr, A), Do(I, A))
  }
}
function VW(e, A, I) {
  const g = this.cache,
    C = I.allocateTextureUnit()
  g[0] !== C && (e.uniform1i(this.addr, C), (g[0] = C))
  let i
  ;(this.type === e.SAMPLER_2D_SHADOW ? ((iH.compareFunction = $m), (i = iH)) : (i = j2),
    I.setTexture2D(A || i, C))
}
function jW(e, A, I) {
  const g = this.cache,
    C = I.allocateTextureUnit()
  ;(g[0] !== C && (e.uniform1i(this.addr, C), (g[0] = C)), I.setTexture3D(A || X2, C))
}
function zW(e, A, I) {
  const g = this.cache,
    C = I.allocateTextureUnit()
  ;(g[0] !== C && (e.uniform1i(this.addr, C), (g[0] = C)), I.setTextureCube(A || $2, C))
}
function XW(e, A, I) {
  const g = this.cache,
    C = I.allocateTextureUnit()
  ;(g[0] !== C && (e.uniform1i(this.addr, C), (g[0] = C)), I.setTexture2DArray(A || z2, C))
}
function $W(e) {
  switch (e) {
    case 5126:
      return KW
    // FLOAT
    case 35664:
      return mW
    // _VEC2
    case 35665:
      return vW
    // _VEC3
    case 35666:
      return LW
    // _VEC4
    case 35674:
      return YW
    // _MAT2
    case 35675:
      return qW
    // _MAT3
    case 35676:
      return HW
    // _MAT4
    case 5124:
    case 35670:
      return TW
    // INT, BOOL
    case 35667:
    case 35671:
      return xW
    // _VEC2
    case 35668:
    case 35672:
      return bW
    // _VEC3
    case 35669:
    case 35673:
      return OW
    // _VEC4
    case 5125:
      return _W
    // UINT
    case 36294:
      return ZW
    // _VEC2
    case 36295:
      return PW
    // _VEC3
    case 36296:
      return WW
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return VW
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return jW
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return zW
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return XW
  }
}
function AV(e, A) {
  e.uniform1fv(this.addr, A)
}
function IV(e, A) {
  const I = pp(A, this.size, 2)
  e.uniform2fv(this.addr, I)
}
function gV(e, A) {
  const I = pp(A, this.size, 3)
  e.uniform3fv(this.addr, I)
}
function CV(e, A) {
  const I = pp(A, this.size, 4)
  e.uniform4fv(this.addr, I)
}
function eV(e, A) {
  const I = pp(A, this.size, 4)
  e.uniformMatrix2fv(this.addr, !1, I)
}
function iV(e, A) {
  const I = pp(A, this.size, 9)
  e.uniformMatrix3fv(this.addr, !1, I)
}
function tV(e, A) {
  const I = pp(A, this.size, 16)
  e.uniformMatrix4fv(this.addr, !1, I)
}
function BV(e, A) {
  e.uniform1iv(this.addr, A)
}
function QV(e, A) {
  e.uniform2iv(this.addr, A)
}
function oV(e, A) {
  e.uniform3iv(this.addr, A)
}
function nV(e, A) {
  e.uniform4iv(this.addr, A)
}
function EV(e, A) {
  e.uniform1uiv(this.addr, A)
}
function aV(e, A) {
  e.uniform2uiv(this.addr, A)
}
function rV(e, A) {
  e.uniform3uiv(this.addr, A)
}
function sV(e, A) {
  e.uniform4uiv(this.addr, A)
}
function lV(e, A, I) {
  const g = this.cache,
    C = A.length,
    i = IF(I, C)
  uo(g, i) || (e.uniform1iv(this.addr, i), Do(g, i))
  for (let B = 0; B !== C; ++B) I.setTexture2D(A[B] || j2, i[B])
}
function cV(e, A, I) {
  const g = this.cache,
    C = A.length,
    i = IF(I, C)
  uo(g, i) || (e.uniform1iv(this.addr, i), Do(g, i))
  for (let B = 0; B !== C; ++B) I.setTexture3D(A[B] || X2, i[B])
}
function hV(e, A, I) {
  const g = this.cache,
    C = A.length,
    i = IF(I, C)
  uo(g, i) || (e.uniform1iv(this.addr, i), Do(g, i))
  for (let B = 0; B !== C; ++B) I.setTextureCube(A[B] || $2, i[B])
}
function uV(e, A, I) {
  const g = this.cache,
    C = A.length,
    i = IF(I, C)
  uo(g, i) || (e.uniform1iv(this.addr, i), Do(g, i))
  for (let B = 0; B !== C; ++B) I.setTexture2DArray(A[B] || z2, i[B])
}
function DV(e) {
  switch (e) {
    case 5126:
      return AV
    // FLOAT
    case 35664:
      return IV
    // _VEC2
    case 35665:
      return gV
    // _VEC3
    case 35666:
      return CV
    // _VEC4
    case 35674:
      return eV
    // _MAT2
    case 35675:
      return iV
    // _MAT3
    case 35676:
      return tV
    // _MAT4
    case 5124:
    case 35670:
      return BV
    // INT, BOOL
    case 35667:
    case 35671:
      return QV
    // _VEC2
    case 35668:
    case 35672:
      return oV
    // _VEC3
    case 35669:
    case 35673:
      return nV
    // _VEC4
    case 5125:
      return EV
    // UINT
    case 36294:
      return aV
    // _VEC2
    case 36295:
      return rV
    // _VEC3
    case 36296:
      return sV
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return lV
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return cV
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return hV
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return uV
  }
}
class SV {
  constructor(A, I, g) {
    ;((this.id = A),
      (this.addr = g),
      (this.cache = []),
      (this.type = I.type),
      (this.setValue = $W(I.type)))
  }
}
class fV {
  constructor(A, I, g) {
    ;((this.id = A),
      (this.addr = g),
      (this.cache = []),
      (this.type = I.type),
      (this.size = I.size),
      (this.setValue = DV(I.type)))
  }
}
class dV {
  constructor(A) {
    ;((this.id = A), (this.seq = []), (this.map = {}))
  }
  setValue(A, I, g) {
    const C = this.seq
    for (let i = 0, B = C.length; i !== B; ++i) {
      const o = C[i]
      o.setValue(A, I[o.id], g)
    }
  }
}
const DK = /(\w+)(\])?(\[|\.)?/g
function EH(e, A) {
  ;(e.seq.push(A), (e.map[A.id] = A))
}
function yV(e, A, I) {
  const g = e.name,
    C = g.length
  for (DK.lastIndex = 0; ; ) {
    const i = DK.exec(g),
      B = DK.lastIndex
    let o = i[1]
    const r = i[2] === "]",
      s = i[3]
    if ((r && (o = o | 0), s === void 0 || (s === "[" && B + 2 === C))) {
      EH(I, s === void 0 ? new SV(o, e, A) : new fV(o, e, A))
      break
    } else {
      let S = I.map[o]
      ;(S === void 0 && ((S = new dV(o)), EH(I, S)), (I = S))
    }
  }
}
class vU {
  constructor(A, I) {
    ;((this.seq = []), (this.map = {}))
    const g = A.getProgramParameter(I, A.ACTIVE_UNIFORMS)
    for (let C = 0; C < g; ++C) {
      const i = A.getActiveUniform(I, C),
        B = A.getUniformLocation(I, i.name)
      yV(i, B, this)
    }
  }
  setValue(A, I, g, C) {
    const i = this.map[I]
    i !== void 0 && i.setValue(A, g, C)
  }
  setOptional(A, I, g) {
    const C = I[g]
    C !== void 0 && this.setValue(A, g, C)
  }
  static upload(A, I, g, C) {
    for (let i = 0, B = I.length; i !== B; ++i) {
      const o = I[i],
        r = g[o.id]
      r.needsUpdate !== !1 && o.setValue(A, r.value, C)
    }
  }
  static seqWithValue(A, I) {
    const g = []
    for (let C = 0, i = A.length; C !== i; ++C) {
      const B = A[C]
      B.id in I && g.push(B)
    }
    return g
  }
}
function aH(e, A, I) {
  const g = e.createShader(A)
  return (e.shaderSource(g, I), e.compileShader(g), g)
}
const pV = 37297
let wV = 0
function GV(e, A) {
  const I = e.split(`
`),
    g = [],
    C = Math.max(A - 6, 0),
    i = Math.min(A + 6, I.length)
  for (let B = C; B < i; B++) {
    const o = B + 1
    g.push(`${o === A ? ">" : " "} ${o}: ${I[B]}`)
  }
  return g.join(`
`)
}
const rH = /* @__PURE__ */ new ce()
function kV(e) {
  ni._getMatrix(rH, ni.workingColorSpace, e)
  const A = `mat3( ${rH.elements.map((I) => I.toFixed(4))} )`
  switch (ni.getTransfer(e)) {
    case NG:
      return [A, "LinearTransferOETF"]
    case ot:
      return [A, "sRGBTransferOETF"]
    default:
      return (
        console.warn("THREE.WebGLProgram: Unsupported color space: ", e),
        [A, "LinearTransferOETF"]
      )
  }
}
function sH(e, A, I) {
  const g = e.getShaderParameter(A, e.COMPILE_STATUS),
    C = e.getShaderInfoLog(A).trim()
  if (g && C === "") return ""
  const i = /ERROR: 0:(\d+)/.exec(C)
  if (i) {
    const B = parseInt(i[1])
    return (
      I.toUpperCase() +
      `

` +
      C +
      `

` +
      GV(e.getShaderSource(A), B)
    )
  } else return C
}
function MV(e, A) {
  const I = kV(A)
  return [
    `vec4 ${e}( vec4 value ) {`,
    `	return ${I[1]}( vec4( value.rgb * ${I[0]}, value.a ) );`,
    "}",
  ].join(`
`)
}
function UV(e, A) {
  let I
  switch (A) {
    case f2:
      I = "Linear"
      break
    case d2:
      I = "Reinhard"
      break
    case y2:
      I = "Cineon"
      break
    case Hm:
      I = "ACESFilmic"
      break
    case w2:
      I = "AgX"
      break
    case G2:
      I = "Neutral"
      break
    case p2:
      I = "Custom"
      break
    default:
      ;(console.warn("THREE.WebGLProgram: Unsupported toneMapping:", A), (I = "Linear"))
  }
  return "vec3 " + e + "( vec3 color ) { return " + I + "ToneMapping( color ); }"
}
const XM = /* @__PURE__ */ new wA()
function NV() {
  ni.getLuminanceCoefficients(XM)
  const e = XM.x.toFixed(4),
    A = XM.y.toFixed(4),
    I = XM.z.toFixed(4)
  return [
    "float luminance( const in vec3 rgb ) {",
    `	const vec3 weights = vec3( ${e}, ${A}, ${I} );`,
    "	return dot( weights, rgb );",
    "}",
  ].join(`
`)
}
function FV(e) {
  return [
    e.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
    e.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : "",
  ].filter(Z0).join(`
`)
}
function RV(e) {
  const A = []
  for (const I in e) {
    const g = e[I]
    g !== !1 && A.push("#define " + I + " " + g)
  }
  return A.join(`
`)
}
function JV(e, A) {
  const I = {},
    g = e.getProgramParameter(A, e.ACTIVE_ATTRIBUTES)
  for (let C = 0; C < g; C++) {
    const i = e.getActiveAttrib(A, C),
      B = i.name
    let o = 1
    ;(i.type === e.FLOAT_MAT2 && (o = 2),
      i.type === e.FLOAT_MAT3 && (o = 3),
      i.type === e.FLOAT_MAT4 && (o = 4),
      (I[B] = {
        type: i.type,
        location: e.getAttribLocation(A, B),
        locationSize: o,
      }))
  }
  return I
}
function Z0(e) {
  return e !== ""
}
function lH(e, A) {
  const I = A.numSpotLightShadows + A.numSpotLightMaps - A.numSpotLightShadowsWithMaps
  return e
    .replace(/NUM_DIR_LIGHTS/g, A.numDirLights)
    .replace(/NUM_SPOT_LIGHTS/g, A.numSpotLights)
    .replace(/NUM_SPOT_LIGHT_MAPS/g, A.numSpotLightMaps)
    .replace(/NUM_SPOT_LIGHT_COORDS/g, I)
    .replace(/NUM_RECT_AREA_LIGHTS/g, A.numRectAreaLights)
    .replace(/NUM_POINT_LIGHTS/g, A.numPointLights)
    .replace(/NUM_HEMI_LIGHTS/g, A.numHemiLights)
    .replace(/NUM_DIR_LIGHT_SHADOWS/g, A.numDirLightShadows)
    .replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, A.numSpotLightShadowsWithMaps)
    .replace(/NUM_SPOT_LIGHT_SHADOWS/g, A.numSpotLightShadows)
    .replace(/NUM_POINT_LIGHT_SHADOWS/g, A.numPointLightShadows)
}
function cH(e, A) {
  return e
    .replace(/NUM_CLIPPING_PLANES/g, A.numClippingPlanes)
    .replace(/UNION_CLIPPING_PLANES/g, A.numClippingPlanes - A.numClipIntersection)
}
const KV = /^[ \t]*#include +<([\w\d./]+)>/gm
function Sm(e) {
  return e.replace(KV, vV)
}
const mV = /* @__PURE__ */ new Map()
function vV(e, A) {
  let I = ne[A]
  if (I === void 0) {
    const g = mV.get(A)
    if (g !== void 0)
      ((I = ne[g]),
        console.warn(
          'THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.',
          A,
          g,
        ))
    else throw new Error("Can not resolve #include <" + A + ">")
  }
  return Sm(I)
}
const LV =
  /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g
function hH(e) {
  return e.replace(LV, YV)
}
function YV(e, A, I, g) {
  let C = ""
  for (let i = parseInt(A); i < parseInt(I); i++)
    C += g.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i)
  return C
}
function uH(e) {
  let A = `precision ${e.precision} float;
	precision ${e.precision} int;
	precision ${e.precision} sampler2D;
	precision ${e.precision} samplerCube;
	precision ${e.precision} sampler3D;
	precision ${e.precision} sampler2DArray;
	precision ${e.precision} sampler2DShadow;
	precision ${e.precision} samplerCubeShadow;
	precision ${e.precision} sampler2DArrayShadow;
	precision ${e.precision} isampler2D;
	precision ${e.precision} isampler3D;
	precision ${e.precision} isamplerCube;
	precision ${e.precision} isampler2DArray;
	precision ${e.precision} usampler2D;
	precision ${e.precision} usampler3D;
	precision ${e.precision} usamplerCube;
	precision ${e.precision} usampler2DArray;
	`
  return (
    e.precision === "highp"
      ? (A += `
#define HIGH_PRECISION`)
      : e.precision === "mediump"
        ? (A += `
#define MEDIUM_PRECISION`)
        : e.precision === "lowp" &&
          (A += `
#define LOW_PRECISION`),
    A
  )
}
function qV(e) {
  let A = "SHADOWMAP_TYPE_BASIC"
  return (
    e.shadowMapType === xN
      ? (A = "SHADOWMAP_TYPE_PCF")
      : e.shadowMapType === X0
        ? (A = "SHADOWMAP_TYPE_PCF_SOFT")
        : e.shadowMapType === pl && (A = "SHADOWMAP_TYPE_VSM"),
    A
  )
}
function HV(e) {
  let A = "ENVMAP_TYPE_CUBE"
  if (e.envMap)
    switch (e.envMapMode) {
      case Bu:
      case kD:
        A = "ENVMAP_TYPE_CUBE"
        break
      case Sp:
        A = "ENVMAP_TYPE_CUBE_UV"
        break
    }
  return A
}
function TV(e) {
  let A = "ENVMAP_MODE_REFLECTION"
  if (e.envMap)
    switch (e.envMapMode) {
      case kD:
        A = "ENVMAP_MODE_REFRACTION"
        break
    }
  return A
}
function xV(e) {
  let A = "ENVMAP_BLENDING_NONE"
  if (e.envMap)
    switch (e.combine) {
      case MG:
        A = "ENVMAP_BLENDING_MULTIPLY"
        break
      case D2:
        A = "ENVMAP_BLENDING_MIX"
        break
      case S2:
        A = "ENVMAP_BLENDING_ADD"
        break
    }
  return A
}
function bV(e) {
  const A = e.envMapCubeUVHeight
  if (A === null) return null
  const I = Math.log2(A) - 2,
    g = 1 / A
  return { texelWidth: 1 / (3 * Math.max(Math.pow(2, I), 7 * 16)), texelHeight: g, maxMip: I }
}
function OV(e, A, I, g) {
  const C = e.getContext(),
    i = I.defines
  let B = I.vertexShader,
    o = I.fragmentShader
  const r = qV(I),
    s = HV(I),
    h = TV(I),
    S = xV(I),
    d = bV(I),
    w = FV(I),
    M = RV(i),
    K = C.createProgram()
  let R,
    F,
    L = I.glslVersion
      ? "#version " +
        I.glslVersion +
        `
`
      : ""
  ;(I.isRawShaderMaterial
    ? ((R = [
        "#define SHADER_TYPE " + I.shaderType,
        "#define SHADER_NAME " + I.shaderName,
        M,
      ].filter(Z0).join(`
`)),
      R.length > 0 &&
        (R += `
`),
      (F = ["#define SHADER_TYPE " + I.shaderType, "#define SHADER_NAME " + I.shaderName, M].filter(
        Z0,
      ).join(`
`)),
      F.length > 0 &&
        (F += `
`))
    : ((R = [
        uH(I),
        "#define SHADER_TYPE " + I.shaderType,
        "#define SHADER_NAME " + I.shaderName,
        M,
        I.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
        I.batching ? "#define USE_BATCHING" : "",
        I.batchingColor ? "#define USE_BATCHING_COLOR" : "",
        I.instancing ? "#define USE_INSTANCING" : "",
        I.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
        I.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
        I.useFog && I.fog ? "#define USE_FOG" : "",
        I.useFog && I.fogExp2 ? "#define FOG_EXP2" : "",
        I.map ? "#define USE_MAP" : "",
        I.envMap ? "#define USE_ENVMAP" : "",
        I.envMap ? "#define " + h : "",
        I.lightMap ? "#define USE_LIGHTMAP" : "",
        I.aoMap ? "#define USE_AOMAP" : "",
        I.bumpMap ? "#define USE_BUMPMAP" : "",
        I.normalMap ? "#define USE_NORMALMAP" : "",
        I.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        I.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        I.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
        I.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        I.anisotropy ? "#define USE_ANISOTROPY" : "",
        I.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        I.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        I.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        I.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        I.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        I.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        I.specularMap ? "#define USE_SPECULARMAP" : "",
        I.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        I.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        I.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        I.metalnessMap ? "#define USE_METALNESSMAP" : "",
        I.alphaMap ? "#define USE_ALPHAMAP" : "",
        I.alphaHash ? "#define USE_ALPHAHASH" : "",
        I.transmission ? "#define USE_TRANSMISSION" : "",
        I.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        I.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        I.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        I.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        //
        I.mapUv ? "#define MAP_UV " + I.mapUv : "",
        I.alphaMapUv ? "#define ALPHAMAP_UV " + I.alphaMapUv : "",
        I.lightMapUv ? "#define LIGHTMAP_UV " + I.lightMapUv : "",
        I.aoMapUv ? "#define AOMAP_UV " + I.aoMapUv : "",
        I.emissiveMapUv ? "#define EMISSIVEMAP_UV " + I.emissiveMapUv : "",
        I.bumpMapUv ? "#define BUMPMAP_UV " + I.bumpMapUv : "",
        I.normalMapUv ? "#define NORMALMAP_UV " + I.normalMapUv : "",
        I.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + I.displacementMapUv : "",
        I.metalnessMapUv ? "#define METALNESSMAP_UV " + I.metalnessMapUv : "",
        I.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + I.roughnessMapUv : "",
        I.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + I.anisotropyMapUv : "",
        I.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + I.clearcoatMapUv : "",
        I.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + I.clearcoatNormalMapUv : "",
        I.clearcoatRoughnessMapUv
          ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + I.clearcoatRoughnessMapUv
          : "",
        I.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + I.iridescenceMapUv : "",
        I.iridescenceThicknessMapUv
          ? "#define IRIDESCENCE_THICKNESSMAP_UV " + I.iridescenceThicknessMapUv
          : "",
        I.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + I.sheenColorMapUv : "",
        I.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + I.sheenRoughnessMapUv : "",
        I.specularMapUv ? "#define SPECULARMAP_UV " + I.specularMapUv : "",
        I.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + I.specularColorMapUv : "",
        I.specularIntensityMapUv
          ? "#define SPECULAR_INTENSITYMAP_UV " + I.specularIntensityMapUv
          : "",
        I.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + I.transmissionMapUv : "",
        I.thicknessMapUv ? "#define THICKNESSMAP_UV " + I.thicknessMapUv : "",
        //
        I.vertexTangents && I.flatShading === !1 ? "#define USE_TANGENT" : "",
        I.vertexColors ? "#define USE_COLOR" : "",
        I.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        I.vertexUv1s ? "#define USE_UV1" : "",
        I.vertexUv2s ? "#define USE_UV2" : "",
        I.vertexUv3s ? "#define USE_UV3" : "",
        I.pointsUvs ? "#define USE_POINTS_UV" : "",
        I.flatShading ? "#define FLAT_SHADED" : "",
        I.skinning ? "#define USE_SKINNING" : "",
        I.morphTargets ? "#define USE_MORPHTARGETS" : "",
        I.morphNormals && I.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
        I.morphColors ? "#define USE_MORPHCOLORS" : "",
        I.morphTargetsCount > 0
          ? "#define MORPHTARGETS_TEXTURE_STRIDE " + I.morphTextureStride
          : "",
        I.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + I.morphTargetsCount : "",
        I.doubleSided ? "#define DOUBLE_SIDED" : "",
        I.flipSided ? "#define FLIP_SIDED" : "",
        I.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        I.shadowMapEnabled ? "#define " + r : "",
        I.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
        I.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        I.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        I.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
        "uniform mat4 modelMatrix;",
        "uniform mat4 modelViewMatrix;",
        "uniform mat4 projectionMatrix;",
        "uniform mat4 viewMatrix;",
        "uniform mat3 normalMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        "#ifdef USE_INSTANCING",
        "	attribute mat4 instanceMatrix;",
        "#endif",
        "#ifdef USE_INSTANCING_COLOR",
        "	attribute vec3 instanceColor;",
        "#endif",
        "#ifdef USE_INSTANCING_MORPH",
        "	uniform sampler2D morphTexture;",
        "#endif",
        "attribute vec3 position;",
        "attribute vec3 normal;",
        "attribute vec2 uv;",
        "#ifdef USE_UV1",
        "	attribute vec2 uv1;",
        "#endif",
        "#ifdef USE_UV2",
        "	attribute vec2 uv2;",
        "#endif",
        "#ifdef USE_UV3",
        "	attribute vec2 uv3;",
        "#endif",
        "#ifdef USE_TANGENT",
        "	attribute vec4 tangent;",
        "#endif",
        "#if defined( USE_COLOR_ALPHA )",
        "	attribute vec4 color;",
        "#elif defined( USE_COLOR )",
        "	attribute vec3 color;",
        "#endif",
        "#ifdef USE_SKINNING",
        "	attribute vec4 skinIndex;",
        "	attribute vec4 skinWeight;",
        "#endif",
        `
`,
      ].filter(Z0).join(`
`)),
      (F = [
        uH(I),
        "#define SHADER_TYPE " + I.shaderType,
        "#define SHADER_NAME " + I.shaderName,
        M,
        I.useFog && I.fog ? "#define USE_FOG" : "",
        I.useFog && I.fogExp2 ? "#define FOG_EXP2" : "",
        I.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
        I.map ? "#define USE_MAP" : "",
        I.matcap ? "#define USE_MATCAP" : "",
        I.envMap ? "#define USE_ENVMAP" : "",
        I.envMap ? "#define " + s : "",
        I.envMap ? "#define " + h : "",
        I.envMap ? "#define " + S : "",
        d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
        d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
        d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
        I.lightMap ? "#define USE_LIGHTMAP" : "",
        I.aoMap ? "#define USE_AOMAP" : "",
        I.bumpMap ? "#define USE_BUMPMAP" : "",
        I.normalMap ? "#define USE_NORMALMAP" : "",
        I.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        I.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        I.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        I.anisotropy ? "#define USE_ANISOTROPY" : "",
        I.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        I.clearcoat ? "#define USE_CLEARCOAT" : "",
        I.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        I.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        I.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        I.dispersion ? "#define USE_DISPERSION" : "",
        I.iridescence ? "#define USE_IRIDESCENCE" : "",
        I.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        I.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        I.specularMap ? "#define USE_SPECULARMAP" : "",
        I.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        I.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        I.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        I.metalnessMap ? "#define USE_METALNESSMAP" : "",
        I.alphaMap ? "#define USE_ALPHAMAP" : "",
        I.alphaTest ? "#define USE_ALPHATEST" : "",
        I.alphaHash ? "#define USE_ALPHAHASH" : "",
        I.sheen ? "#define USE_SHEEN" : "",
        I.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        I.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        I.transmission ? "#define USE_TRANSMISSION" : "",
        I.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        I.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        I.vertexTangents && I.flatShading === !1 ? "#define USE_TANGENT" : "",
        I.vertexColors || I.instancingColor || I.batchingColor ? "#define USE_COLOR" : "",
        I.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        I.vertexUv1s ? "#define USE_UV1" : "",
        I.vertexUv2s ? "#define USE_UV2" : "",
        I.vertexUv3s ? "#define USE_UV3" : "",
        I.pointsUvs ? "#define USE_POINTS_UV" : "",
        I.gradientMap ? "#define USE_GRADIENTMAP" : "",
        I.flatShading ? "#define FLAT_SHADED" : "",
        I.doubleSided ? "#define DOUBLE_SIDED" : "",
        I.flipSided ? "#define FLIP_SIDED" : "",
        I.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        I.shadowMapEnabled ? "#define " + r : "",
        I.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
        I.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        I.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
        I.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
        I.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        I.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
        "uniform mat4 viewMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        I.toneMapping !== Ms ? "#define TONE_MAPPING" : "",
        I.toneMapping !== Ms ? ne.tonemapping_pars_fragment : "",
        // this code is required here because it is used by the toneMapping() function defined below
        I.toneMapping !== Ms ? UV("toneMapping", I.toneMapping) : "",
        I.dithering ? "#define DITHERING" : "",
        I.opaque ? "#define OPAQUE" : "",
        ne.colorspace_pars_fragment,
        // this code is required here because it is used by the various encoding/decoding function defined below
        MV("linearToOutputTexel", I.outputColorSpace),
        NV(),
        I.useDepthPacking ? "#define DEPTH_PACKING " + I.depthPacking : "",
        `
`,
      ].filter(Z0).join(`
`))),
    (B = Sm(B)),
    (B = lH(B, I)),
    (B = cH(B, I)),
    (o = Sm(o)),
    (o = lH(o, I)),
    (o = cH(o, I)),
    (B = hH(B)),
    (o = hH(o)),
    I.isRawShaderMaterial !== !0 &&
      ((L = `#version 300 es
`),
      (R =
        [w, "#define attribute in", "#define varying out", "#define texture2D texture"].join(`
`) +
        `
` +
        R),
      (F =
        [
          "#define varying in",
          I.glslVersion === um ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
          I.glslVersion === um ? "" : "#define gl_FragColor pc_fragColor",
          "#define gl_FragDepthEXT gl_FragDepth",
          "#define texture2D texture",
          "#define textureCube texture",
          "#define texture2DProj textureProj",
          "#define texture2DLodEXT textureLod",
          "#define texture2DProjLodEXT textureProjLod",
          "#define textureCubeLodEXT textureLod",
          "#define texture2DGradEXT textureGrad",
          "#define texture2DProjGradEXT textureProjGrad",
          "#define textureCubeGradEXT textureGrad",
        ].join(`
`) +
        `
` +
        F)))
  const Y = L + R + B,
    H = L + F + o,
    V = aH(C, C.VERTEX_SHADER, Y),
    j = aH(C, C.FRAGMENT_SHADER, H)
  ;(C.attachShader(K, V),
    C.attachShader(K, j),
    I.index0AttributeName !== void 0
      ? C.bindAttribLocation(K, 0, I.index0AttributeName)
      : I.morphTargets === !0 && C.bindAttribLocation(K, 0, "position"),
    C.linkProgram(K))
  function P(eA) {
    if (e.debug.checkShaderErrors) {
      const CA = C.getProgramInfoLog(K).trim(),
        aA = C.getShaderInfoLog(V).trim(),
        lA = C.getShaderInfoLog(j).trim()
      let JA = !0,
        yA = !0
      if (C.getProgramParameter(K, C.LINK_STATUS) === !1)
        if (((JA = !1), typeof e.debug.onShaderError == "function"))
          e.debug.onShaderError(C, K, V, j)
        else {
          const LA = sH(C, V, "vertex"),
            nA = sH(C, j, "fragment")
          console.error(
            "THREE.WebGLProgram: Shader Error " +
              C.getError() +
              " - VALIDATE_STATUS " +
              C.getProgramParameter(K, C.VALIDATE_STATUS) +
              `

Material Name: ` +
              eA.name +
              `
Material Type: ` +
              eA.type +
              `

Program Info Log: ` +
              CA +
              `
` +
              LA +
              `
` +
              nA,
          )
        }
      else
        CA !== ""
          ? console.warn("THREE.WebGLProgram: Program Info Log:", CA)
          : (aA === "" || lA === "") && (yA = !1)
      yA &&
        (eA.diagnostics = {
          runnable: JA,
          programLog: CA,
          vertexShader: {
            log: aA,
            prefix: R,
          },
          fragmentShader: {
            log: lA,
            prefix: F,
          },
        })
    }
    ;(C.deleteShader(V), C.deleteShader(j), (AA = new vU(C, K)), (X = JV(C, K)))
  }
  let AA
  this.getUniforms = function () {
    return (AA === void 0 && P(this), AA)
  }
  let X
  this.getAttributes = function () {
    return (X === void 0 && P(this), X)
  }
  let _ = I.rendererExtensionParallelShaderCompile === !1
  return (
    (this.isReady = function () {
      return (_ === !1 && (_ = C.getProgramParameter(K, pV)), _)
    }),
    (this.destroy = function () {
      ;(g.releaseStatesOfProgram(this), C.deleteProgram(K), (this.program = void 0))
    }),
    (this.type = I.shaderType),
    (this.name = I.shaderName),
    (this.id = wV++),
    (this.cacheKey = A),
    (this.usedTimes = 1),
    (this.program = K),
    (this.vertexShader = V),
    (this.fragmentShader = j),
    this
  )
}
let _V = 0
class ZV {
  constructor() {
    ;((this.shaderCache = /* @__PURE__ */ new Map()),
      (this.materialCache = /* @__PURE__ */ new Map()))
  }
  update(A) {
    const I = A.vertexShader,
      g = A.fragmentShader,
      C = this._getShaderStage(I),
      i = this._getShaderStage(g),
      B = this._getShaderCacheForMaterial(A)
    return (
      B.has(C) === !1 && (B.add(C), C.usedTimes++),
      B.has(i) === !1 && (B.add(i), i.usedTimes++),
      this
    )
  }
  remove(A) {
    const I = this.materialCache.get(A)
    for (const g of I) (g.usedTimes--, g.usedTimes === 0 && this.shaderCache.delete(g.code))
    return (this.materialCache.delete(A), this)
  }
  getVertexShaderID(A) {
    return this._getShaderStage(A.vertexShader).id
  }
  getFragmentShaderID(A) {
    return this._getShaderStage(A.fragmentShader).id
  }
  dispose() {
    ;(this.shaderCache.clear(), this.materialCache.clear())
  }
  _getShaderCacheForMaterial(A) {
    const I = this.materialCache
    let g = I.get(A)
    return (g === void 0 && ((g = /* @__PURE__ */ new Set()), I.set(A, g)), g)
  }
  _getShaderStage(A) {
    const I = this.shaderCache
    let g = I.get(A)
    return (g === void 0 && ((g = new PV(A)), I.set(A, g)), g)
  }
}
class PV {
  constructor(A) {
    ;((this.id = _V++), (this.code = A), (this.usedTimes = 0))
  }
}
function WV(e, A, I, g, C, i, B) {
  const o = new Kf(),
    r = new ZV(),
    s = /* @__PURE__ */ new Set(),
    h = [],
    S = C.logarithmicDepthBuffer,
    d = C.vertexTextures
  let w = C.precision
  const M = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite",
  }
  function K(X) {
    return (s.add(X), X === 0 ? "uv" : `uv${X}`)
  }
  function R(X, _, eA, CA, aA) {
    const lA = CA.fog,
      JA = aA.geometry,
      yA = X.isMeshStandardMaterial ? CA.environment : null,
      LA = (X.isMeshStandardMaterial ? I : A).get(X.envMap || yA),
      nA = LA && LA.mapping === Sp ? LA.image.height : null,
      fA = M[X.type]
    X.precision !== null &&
      ((w = C.getMaxPrecision(X.precision)),
      w !== X.precision &&
        console.warn(
          "THREE.WebGLProgram.getParameters:",
          X.precision,
          "not supported, using",
          w,
          "instead.",
        ))
    const sA = JA.morphAttributes.position || JA.morphAttributes.normal || JA.morphAttributes.color,
      $ = sA !== void 0 ? sA.length : 0
    let EA = 0
    ;(JA.morphAttributes.position !== void 0 && (EA = 1),
      JA.morphAttributes.normal !== void 0 && (EA = 2),
      JA.morphAttributes.color !== void 0 && (EA = 3))
    let GA, DA, dA, kA
    if (fA) {
      const Fg = Gl[fA]
      ;((GA = Fg.vertexShader), (DA = Fg.fragmentShader))
    } else
      ((GA = X.vertexShader),
        (DA = X.fragmentShader),
        r.update(X),
        (dA = r.getVertexShaderID(X)),
        (kA = r.getFragmentShaderID(X)))
    const NA = e.getRenderTarget(),
      qA = e.state.buffers.depth.getReversed(),
      ZA = aA.isInstancedMesh === !0,
      sI = aA.isBatchedMesh === !0,
      cI = !!X.map,
      YA = !!X.matcap,
      eI = !!LA,
      uA = !!X.aoMap,
      hI = !!X.lightMap,
      II = !!X.bumpMap,
      pI = !!X.normalMap,
      AI = !!X.displacementMap,
      YI = !!X.emissiveMap,
      SI = !!X.metalnessMap,
      QA = !!X.roughnessMap,
      tA = X.anisotropy > 0,
      FA = X.clearcoat > 0,
      WA = X.dispersion > 0,
      jA = X.iridescence > 0,
      nI = X.sheen > 0,
      UI = X.transmission > 0,
      GI = tA && !!X.anisotropyMap,
      LI = FA && !!X.clearcoatMap,
      Bg = FA && !!X.clearcoatNormalMap,
      MA = FA && !!X.clearcoatRoughnessMap,
      OA = jA && !!X.iridescenceMap,
      aI = jA && !!X.iridescenceThicknessMap,
      RI = nI && !!X.sheenColorMap,
      VA = nI && !!X.sheenRoughnessMap,
      ag = !!X.specularMap,
      XI = !!X.specularColorMap,
      $I = !!X.specularIntensityMap,
      SA = UI && !!X.transmissionMap,
      NI = UI && !!X.thicknessMap,
      HA = !!X.gradientMap,
      iI = !!X.alphaMap,
      zI = X.alphaTest > 0,
      qI = !!X.alphaHash,
      dg = !!X.extensions
    let $g = Ms
    X.toneMapped && (NA === null || NA.isXRRenderTarget === !0) && ($g = e.toneMapping)
    const Qg = {
      shaderID: fA,
      shaderType: X.type,
      shaderName: X.name,
      vertexShader: GA,
      fragmentShader: DA,
      defines: X.defines,
      customVertexShaderID: dA,
      customFragmentShaderID: kA,
      isRawShaderMaterial: X.isRawShaderMaterial === !0,
      glslVersion: X.glslVersion,
      precision: w,
      batching: sI,
      batchingColor: sI && aA._colorsTexture !== null,
      instancing: ZA,
      instancingColor: ZA && aA.instanceColor !== null,
      instancingMorph: ZA && aA.morphTexture !== null,
      supportsVertexTextures: d,
      outputColorSpace:
        NA === null ? e.outputColorSpace : NA.isXRRenderTarget === !0 ? NA.texture.colorSpace : ru,
      alphaToCoverage: !!X.alphaToCoverage,
      map: cI,
      matcap: YA,
      envMap: eI,
      envMapMode: eI && LA.mapping,
      envMapCubeUVHeight: nA,
      aoMap: uA,
      lightMap: hI,
      bumpMap: II,
      normalMap: pI,
      displacementMap: d && AI,
      emissiveMap: YI,
      normalMapObjectSpace: pI && X.normalMapType === R2,
      normalMapTangentSpace: pI && X.normalMapType === vD,
      metalnessMap: SI,
      roughnessMap: QA,
      anisotropy: tA,
      anisotropyMap: GI,
      clearcoat: FA,
      clearcoatMap: LI,
      clearcoatNormalMap: Bg,
      clearcoatRoughnessMap: MA,
      dispersion: WA,
      iridescence: jA,
      iridescenceMap: OA,
      iridescenceThicknessMap: aI,
      sheen: nI,
      sheenColorMap: RI,
      sheenRoughnessMap: VA,
      specularMap: ag,
      specularColorMap: XI,
      specularIntensityMap: $I,
      transmission: UI,
      transmissionMap: SA,
      thicknessMap: NI,
      gradientMap: HA,
      opaque: X.transparent === !1 && X.blending === Ff && X.alphaToCoverage === !1,
      alphaMap: iI,
      alphaTest: zI,
      alphaHash: qI,
      combine: X.combine,
      //
      mapUv: cI && K(X.map.channel),
      aoMapUv: uA && K(X.aoMap.channel),
      lightMapUv: hI && K(X.lightMap.channel),
      bumpMapUv: II && K(X.bumpMap.channel),
      normalMapUv: pI && K(X.normalMap.channel),
      displacementMapUv: AI && K(X.displacementMap.channel),
      emissiveMapUv: YI && K(X.emissiveMap.channel),
      metalnessMapUv: SI && K(X.metalnessMap.channel),
      roughnessMapUv: QA && K(X.roughnessMap.channel),
      anisotropyMapUv: GI && K(X.anisotropyMap.channel),
      clearcoatMapUv: LI && K(X.clearcoatMap.channel),
      clearcoatNormalMapUv: Bg && K(X.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: MA && K(X.clearcoatRoughnessMap.channel),
      iridescenceMapUv: OA && K(X.iridescenceMap.channel),
      iridescenceThicknessMapUv: aI && K(X.iridescenceThicknessMap.channel),
      sheenColorMapUv: RI && K(X.sheenColorMap.channel),
      sheenRoughnessMapUv: VA && K(X.sheenRoughnessMap.channel),
      specularMapUv: ag && K(X.specularMap.channel),
      specularColorMapUv: XI && K(X.specularColorMap.channel),
      specularIntensityMapUv: $I && K(X.specularIntensityMap.channel),
      transmissionMapUv: SA && K(X.transmissionMap.channel),
      thicknessMapUv: NI && K(X.thicknessMap.channel),
      alphaMapUv: iI && K(X.alphaMap.channel),
      //
      vertexTangents: !!JA.attributes.tangent && (pI || tA),
      vertexColors: X.vertexColors,
      vertexAlphas:
        X.vertexColors === !0 && !!JA.attributes.color && JA.attributes.color.itemSize === 4,
      pointsUvs: aA.isPoints === !0 && !!JA.attributes.uv && (cI || iI),
      fog: !!lA,
      useFog: X.fog === !0,
      fogExp2: !!lA && lA.isFogExp2,
      flatShading: X.flatShading === !0,
      sizeAttenuation: X.sizeAttenuation === !0,
      logarithmicDepthBuffer: S,
      reverseDepthBuffer: qA,
      skinning: aA.isSkinnedMesh === !0,
      morphTargets: JA.morphAttributes.position !== void 0,
      morphNormals: JA.morphAttributes.normal !== void 0,
      morphColors: JA.morphAttributes.color !== void 0,
      morphTargetsCount: $,
      morphTextureStride: EA,
      numDirLights: _.directional.length,
      numPointLights: _.point.length,
      numSpotLights: _.spot.length,
      numSpotLightMaps: _.spotLightMap.length,
      numRectAreaLights: _.rectArea.length,
      numHemiLights: _.hemi.length,
      numDirLightShadows: _.directionalShadowMap.length,
      numPointLightShadows: _.pointShadowMap.length,
      numSpotLightShadows: _.spotShadowMap.length,
      numSpotLightShadowsWithMaps: _.numSpotLightShadowsWithMaps,
      numLightProbes: _.numLightProbes,
      numClippingPlanes: B.numPlanes,
      numClipIntersection: B.numIntersection,
      dithering: X.dithering,
      shadowMapEnabled: e.shadowMap.enabled && eA.length > 0,
      shadowMapType: e.shadowMap.type,
      toneMapping: $g,
      decodeVideoTexture:
        cI && X.map.isVideoTexture === !0 && ni.getTransfer(X.map.colorSpace) === ot,
      decodeVideoTextureEmissive:
        YI &&
        X.emissiveMap.isVideoTexture === !0 &&
        ni.getTransfer(X.emissiveMap.colorSpace) === ot,
      premultipliedAlpha: X.premultipliedAlpha,
      doubleSided: X.side === rE,
      flipSided: X.side === WQ,
      useDepthPacking: X.depthPacking >= 0,
      depthPacking: X.depthPacking || 0,
      index0AttributeName: X.index0AttributeName,
      extensionClipCullDistance:
        dg && X.extensions.clipCullDistance === !0 && g.has("WEBGL_clip_cull_distance"),
      extensionMultiDraw:
        ((dg && X.extensions.multiDraw === !0) || sI) && g.has("WEBGL_multi_draw"),
      rendererExtensionParallelShaderCompile: g.has("KHR_parallel_shader_compile"),
      customProgramCacheKey: X.customProgramCacheKey(),
    }
    return (
      (Qg.vertexUv1s = s.has(1)),
      (Qg.vertexUv2s = s.has(2)),
      (Qg.vertexUv3s = s.has(3)),
      s.clear(),
      Qg
    )
  }
  function F(X) {
    const _ = []
    if (
      (X.shaderID
        ? _.push(X.shaderID)
        : (_.push(X.customVertexShaderID), _.push(X.customFragmentShaderID)),
      X.defines !== void 0)
    )
      for (const eA in X.defines) (_.push(eA), _.push(X.defines[eA]))
    return (
      X.isRawShaderMaterial === !1 && (L(_, X), Y(_, X), _.push(e.outputColorSpace)),
      _.push(X.customProgramCacheKey),
      _.join()
    )
  }
  function L(X, _) {
    ;(X.push(_.precision),
      X.push(_.outputColorSpace),
      X.push(_.envMapMode),
      X.push(_.envMapCubeUVHeight),
      X.push(_.mapUv),
      X.push(_.alphaMapUv),
      X.push(_.lightMapUv),
      X.push(_.aoMapUv),
      X.push(_.bumpMapUv),
      X.push(_.normalMapUv),
      X.push(_.displacementMapUv),
      X.push(_.emissiveMapUv),
      X.push(_.metalnessMapUv),
      X.push(_.roughnessMapUv),
      X.push(_.anisotropyMapUv),
      X.push(_.clearcoatMapUv),
      X.push(_.clearcoatNormalMapUv),
      X.push(_.clearcoatRoughnessMapUv),
      X.push(_.iridescenceMapUv),
      X.push(_.iridescenceThicknessMapUv),
      X.push(_.sheenColorMapUv),
      X.push(_.sheenRoughnessMapUv),
      X.push(_.specularMapUv),
      X.push(_.specularColorMapUv),
      X.push(_.specularIntensityMapUv),
      X.push(_.transmissionMapUv),
      X.push(_.thicknessMapUv),
      X.push(_.combine),
      X.push(_.fogExp2),
      X.push(_.sizeAttenuation),
      X.push(_.morphTargetsCount),
      X.push(_.morphAttributeCount),
      X.push(_.numDirLights),
      X.push(_.numPointLights),
      X.push(_.numSpotLights),
      X.push(_.numSpotLightMaps),
      X.push(_.numHemiLights),
      X.push(_.numRectAreaLights),
      X.push(_.numDirLightShadows),
      X.push(_.numPointLightShadows),
      X.push(_.numSpotLightShadows),
      X.push(_.numSpotLightShadowsWithMaps),
      X.push(_.numLightProbes),
      X.push(_.shadowMapType),
      X.push(_.toneMapping),
      X.push(_.numClippingPlanes),
      X.push(_.numClipIntersection),
      X.push(_.depthPacking))
  }
  function Y(X, _) {
    ;(o.disableAll(),
      _.supportsVertexTextures && o.enable(0),
      _.instancing && o.enable(1),
      _.instancingColor && o.enable(2),
      _.instancingMorph && o.enable(3),
      _.matcap && o.enable(4),
      _.envMap && o.enable(5),
      _.normalMapObjectSpace && o.enable(6),
      _.normalMapTangentSpace && o.enable(7),
      _.clearcoat && o.enable(8),
      _.iridescence && o.enable(9),
      _.alphaTest && o.enable(10),
      _.vertexColors && o.enable(11),
      _.vertexAlphas && o.enable(12),
      _.vertexUv1s && o.enable(13),
      _.vertexUv2s && o.enable(14),
      _.vertexUv3s && o.enable(15),
      _.vertexTangents && o.enable(16),
      _.anisotropy && o.enable(17),
      _.alphaHash && o.enable(18),
      _.batching && o.enable(19),
      _.dispersion && o.enable(20),
      _.batchingColor && o.enable(21),
      X.push(o.mask),
      o.disableAll(),
      _.fog && o.enable(0),
      _.useFog && o.enable(1),
      _.flatShading && o.enable(2),
      _.logarithmicDepthBuffer && o.enable(3),
      _.reverseDepthBuffer && o.enable(4),
      _.skinning && o.enable(5),
      _.morphTargets && o.enable(6),
      _.morphNormals && o.enable(7),
      _.morphColors && o.enable(8),
      _.premultipliedAlpha && o.enable(9),
      _.shadowMapEnabled && o.enable(10),
      _.doubleSided && o.enable(11),
      _.flipSided && o.enable(12),
      _.useDepthPacking && o.enable(13),
      _.dithering && o.enable(14),
      _.transmission && o.enable(15),
      _.sheen && o.enable(16),
      _.opaque && o.enable(17),
      _.pointsUvs && o.enable(18),
      _.decodeVideoTexture && o.enable(19),
      _.decodeVideoTextureEmissive && o.enable(20),
      _.alphaToCoverage && o.enable(21),
      X.push(o.mask))
  }
  function H(X) {
    const _ = M[X.type]
    let eA
    if (_) {
      const CA = Gl[_]
      eA = AF.clone(CA.uniforms)
    } else eA = X.uniforms
    return eA
  }
  function V(X, _) {
    let eA
    for (let CA = 0, aA = h.length; CA < aA; CA++) {
      const lA = h[CA]
      if (lA.cacheKey === _) {
        ;((eA = lA), ++eA.usedTimes)
        break
      }
    }
    return (eA === void 0 && ((eA = new OV(e, _, X, i)), h.push(eA)), eA)
  }
  function j(X) {
    if (--X.usedTimes === 0) {
      const _ = h.indexOf(X)
      ;((h[_] = h[h.length - 1]), h.pop(), X.destroy())
    }
  }
  function P(X) {
    r.remove(X)
  }
  function AA() {
    r.dispose()
  }
  return {
    getParameters: R,
    getProgramCacheKey: F,
    getUniforms: H,
    acquireProgram: V,
    releaseProgram: j,
    releaseShaderCache: P,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs: h,
    dispose: AA,
  }
}
function VV() {
  let e = /* @__PURE__ */ new WeakMap()
  function A(B) {
    return e.has(B)
  }
  function I(B) {
    let o = e.get(B)
    return (o === void 0 && ((o = {}), e.set(B, o)), o)
  }
  function g(B) {
    e.delete(B)
  }
  function C(B, o, r) {
    e.get(B)[o] = r
  }
  function i() {
    e = /* @__PURE__ */ new WeakMap()
  }
  return {
    has: A,
    get: I,
    remove: g,
    update: C,
    dispose: i,
  }
}
function jV(e, A) {
  return e.groupOrder !== A.groupOrder
    ? e.groupOrder - A.groupOrder
    : e.renderOrder !== A.renderOrder
      ? e.renderOrder - A.renderOrder
      : e.material.id !== A.material.id
        ? e.material.id - A.material.id
        : e.z !== A.z
          ? e.z - A.z
          : e.id - A.id
}
function DH(e, A) {
  return e.groupOrder !== A.groupOrder
    ? e.groupOrder - A.groupOrder
    : e.renderOrder !== A.renderOrder
      ? e.renderOrder - A.renderOrder
      : e.z !== A.z
        ? A.z - e.z
        : e.id - A.id
}
function SH() {
  const e = []
  let A = 0
  const I = [],
    g = [],
    C = []
  function i() {
    ;((A = 0), (I.length = 0), (g.length = 0), (C.length = 0))
  }
  function B(S, d, w, M, K, R) {
    let F = e[A]
    return (
      F === void 0
        ? ((F = {
            id: S.id,
            object: S,
            geometry: d,
            material: w,
            groupOrder: M,
            renderOrder: S.renderOrder,
            z: K,
            group: R,
          }),
          (e[A] = F))
        : ((F.id = S.id),
          (F.object = S),
          (F.geometry = d),
          (F.material = w),
          (F.groupOrder = M),
          (F.renderOrder = S.renderOrder),
          (F.z = K),
          (F.group = R)),
      A++,
      F
    )
  }
  function o(S, d, w, M, K, R) {
    const F = B(S, d, w, M, K, R)
    w.transmission > 0 ? g.push(F) : w.transparent === !0 ? C.push(F) : I.push(F)
  }
  function r(S, d, w, M, K, R) {
    const F = B(S, d, w, M, K, R)
    w.transmission > 0 ? g.unshift(F) : w.transparent === !0 ? C.unshift(F) : I.unshift(F)
  }
  function s(S, d) {
    ;(I.length > 1 && I.sort(S || jV),
      g.length > 1 && g.sort(d || DH),
      C.length > 1 && C.sort(d || DH))
  }
  function h() {
    for (let S = A, d = e.length; S < d; S++) {
      const w = e[S]
      if (w.id === null) break
      ;((w.id = null),
        (w.object = null),
        (w.geometry = null),
        (w.material = null),
        (w.group = null))
    }
  }
  return {
    opaque: I,
    transmissive: g,
    transparent: C,
    init: i,
    push: o,
    unshift: r,
    finish: h,
    sort: s,
  }
}
function zV() {
  let e = /* @__PURE__ */ new WeakMap()
  function A(g, C) {
    const i = e.get(g)
    let B
    return (
      i === void 0
        ? ((B = new SH()), e.set(g, [B]))
        : C >= i.length
          ? ((B = new SH()), i.push(B))
          : (B = i[C]),
      B
    )
  }
  function I() {
    e = /* @__PURE__ */ new WeakMap()
  }
  return {
    get: A,
    dispose: I,
  }
}
function XV() {
  const e = {}
  return {
    get: function (A) {
      if (e[A.id] !== void 0) return e[A.id]
      let I
      switch (A.type) {
        case "DirectionalLight":
          I = {
            direction: new wA(),
            color: new Mg(),
          }
          break
        case "SpotLight":
          I = {
            position: new wA(),
            direction: new wA(),
            color: new Mg(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0,
          }
          break
        case "PointLight":
          I = {
            position: new wA(),
            color: new Mg(),
            distance: 0,
            decay: 0,
          }
          break
        case "HemisphereLight":
          I = {
            direction: new wA(),
            skyColor: new Mg(),
            groundColor: new Mg(),
          }
          break
        case "RectAreaLight":
          I = {
            color: new Mg(),
            position: new wA(),
            halfWidth: new wA(),
            halfHeight: new wA(),
          }
          break
      }
      return ((e[A.id] = I), I)
    },
  }
}
function $V() {
  const e = {}
  return {
    get: function (A) {
      if (e[A.id] !== void 0) return e[A.id]
      let I
      switch (A.type) {
        case "DirectionalLight":
          I = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new ZI(),
          }
          break
        case "SpotLight":
          I = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new ZI(),
          }
          break
        case "PointLight":
          I = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new ZI(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3,
          }
          break
      }
      return ((e[A.id] = I), I)
    },
  }
}
let A5 = 0
function I5(e, A) {
  return (A.castShadow ? 2 : 0) - (e.castShadow ? 2 : 0) + (A.map ? 1 : 0) - (e.map ? 1 : 0)
}
function g5(e) {
  const A = new XV(),
    I = $V(),
    g = {
      version: 0,
      hash: {
        directionalLength: -1,
        pointLength: -1,
        spotLength: -1,
        rectAreaLength: -1,
        hemiLength: -1,
        numDirectionalShadows: -1,
        numPointShadows: -1,
        numSpotShadows: -1,
        numSpotMaps: -1,
        numLightProbes: -1,
      },
      ambient: [0, 0, 0],
      probe: [],
      directional: [],
      directionalShadow: [],
      directionalShadowMap: [],
      directionalShadowMatrix: [],
      spot: [],
      spotLightMap: [],
      spotShadow: [],
      spotShadowMap: [],
      spotLightMatrix: [],
      rectArea: [],
      rectAreaLTC1: null,
      rectAreaLTC2: null,
      point: [],
      pointShadow: [],
      pointShadowMap: [],
      pointShadowMatrix: [],
      hemi: [],
      numSpotLightShadowsWithMaps: 0,
      numLightProbes: 0,
    }
  for (let s = 0; s < 9; s++) g.probe.push(new wA())
  const C = new wA(),
    i = new RC(),
    B = new RC()
  function o(s) {
    let h = 0,
      S = 0,
      d = 0
    for (let X = 0; X < 9; X++) g.probe[X].set(0, 0, 0)
    let w = 0,
      M = 0,
      K = 0,
      R = 0,
      F = 0,
      L = 0,
      Y = 0,
      H = 0,
      V = 0,
      j = 0,
      P = 0
    s.sort(I5)
    for (let X = 0, _ = s.length; X < _; X++) {
      const eA = s[X],
        CA = eA.color,
        aA = eA.intensity,
        lA = eA.distance,
        JA = eA.shadow && eA.shadow.map ? eA.shadow.map.texture : null
      if (eA.isAmbientLight) ((h += CA.r * aA), (S += CA.g * aA), (d += CA.b * aA))
      else if (eA.isLightProbe) {
        for (let yA = 0; yA < 9; yA++) g.probe[yA].addScaledVector(eA.sh.coefficients[yA], aA)
        P++
      } else if (eA.isDirectionalLight) {
        const yA = A.get(eA)
        if ((yA.color.copy(eA.color).multiplyScalar(eA.intensity), eA.castShadow)) {
          const LA = eA.shadow,
            nA = I.get(eA)
          ;((nA.shadowIntensity = LA.intensity),
            (nA.shadowBias = LA.bias),
            (nA.shadowNormalBias = LA.normalBias),
            (nA.shadowRadius = LA.radius),
            (nA.shadowMapSize = LA.mapSize),
            (g.directionalShadow[w] = nA),
            (g.directionalShadowMap[w] = JA),
            (g.directionalShadowMatrix[w] = eA.shadow.matrix),
            L++)
        }
        ;((g.directional[w] = yA), w++)
      } else if (eA.isSpotLight) {
        const yA = A.get(eA)
        ;(yA.position.setFromMatrixPosition(eA.matrixWorld),
          yA.color.copy(CA).multiplyScalar(aA),
          (yA.distance = lA),
          (yA.coneCos = Math.cos(eA.angle)),
          (yA.penumbraCos = Math.cos(eA.angle * (1 - eA.penumbra))),
          (yA.decay = eA.decay),
          (g.spot[K] = yA))
        const LA = eA.shadow
        if (
          (eA.map &&
            ((g.spotLightMap[V] = eA.map), V++, LA.updateMatrices(eA), eA.castShadow && j++),
          (g.spotLightMatrix[K] = LA.matrix),
          eA.castShadow)
        ) {
          const nA = I.get(eA)
          ;((nA.shadowIntensity = LA.intensity),
            (nA.shadowBias = LA.bias),
            (nA.shadowNormalBias = LA.normalBias),
            (nA.shadowRadius = LA.radius),
            (nA.shadowMapSize = LA.mapSize),
            (g.spotShadow[K] = nA),
            (g.spotShadowMap[K] = JA),
            H++)
        }
        K++
      } else if (eA.isRectAreaLight) {
        const yA = A.get(eA)
        ;(yA.color.copy(CA).multiplyScalar(aA),
          yA.halfWidth.set(eA.width * 0.5, 0, 0),
          yA.halfHeight.set(0, eA.height * 0.5, 0),
          (g.rectArea[R] = yA),
          R++)
      } else if (eA.isPointLight) {
        const yA = A.get(eA)
        if (
          (yA.color.copy(eA.color).multiplyScalar(eA.intensity),
          (yA.distance = eA.distance),
          (yA.decay = eA.decay),
          eA.castShadow)
        ) {
          const LA = eA.shadow,
            nA = I.get(eA)
          ;((nA.shadowIntensity = LA.intensity),
            (nA.shadowBias = LA.bias),
            (nA.shadowNormalBias = LA.normalBias),
            (nA.shadowRadius = LA.radius),
            (nA.shadowMapSize = LA.mapSize),
            (nA.shadowCameraNear = LA.camera.near),
            (nA.shadowCameraFar = LA.camera.far),
            (g.pointShadow[M] = nA),
            (g.pointShadowMap[M] = JA),
            (g.pointShadowMatrix[M] = eA.shadow.matrix),
            Y++)
        }
        ;((g.point[M] = yA), M++)
      } else if (eA.isHemisphereLight) {
        const yA = A.get(eA)
        ;(yA.skyColor.copy(eA.color).multiplyScalar(aA),
          yA.groundColor.copy(eA.groundColor).multiplyScalar(aA),
          (g.hemi[F] = yA),
          F++)
      }
    }
    ;(R > 0 &&
      (e.has("OES_texture_float_linear") === !0
        ? ((g.rectAreaLTC1 = Yg.LTC_FLOAT_1), (g.rectAreaLTC2 = Yg.LTC_FLOAT_2))
        : ((g.rectAreaLTC1 = Yg.LTC_HALF_1), (g.rectAreaLTC2 = Yg.LTC_HALF_2))),
      (g.ambient[0] = h),
      (g.ambient[1] = S),
      (g.ambient[2] = d))
    const AA = g.hash
    ;(AA.directionalLength !== w ||
      AA.pointLength !== M ||
      AA.spotLength !== K ||
      AA.rectAreaLength !== R ||
      AA.hemiLength !== F ||
      AA.numDirectionalShadows !== L ||
      AA.numPointShadows !== Y ||
      AA.numSpotShadows !== H ||
      AA.numSpotMaps !== V ||
      AA.numLightProbes !== P) &&
      ((g.directional.length = w),
      (g.spot.length = K),
      (g.rectArea.length = R),
      (g.point.length = M),
      (g.hemi.length = F),
      (g.directionalShadow.length = L),
      (g.directionalShadowMap.length = L),
      (g.pointShadow.length = Y),
      (g.pointShadowMap.length = Y),
      (g.spotShadow.length = H),
      (g.spotShadowMap.length = H),
      (g.directionalShadowMatrix.length = L),
      (g.pointShadowMatrix.length = Y),
      (g.spotLightMatrix.length = H + V - j),
      (g.spotLightMap.length = V),
      (g.numSpotLightShadowsWithMaps = j),
      (g.numLightProbes = P),
      (AA.directionalLength = w),
      (AA.pointLength = M),
      (AA.spotLength = K),
      (AA.rectAreaLength = R),
      (AA.hemiLength = F),
      (AA.numDirectionalShadows = L),
      (AA.numPointShadows = Y),
      (AA.numSpotShadows = H),
      (AA.numSpotMaps = V),
      (AA.numLightProbes = P),
      (g.version = A5++))
  }
  function r(s, h) {
    let S = 0,
      d = 0,
      w = 0,
      M = 0,
      K = 0
    const R = h.matrixWorldInverse
    for (let F = 0, L = s.length; F < L; F++) {
      const Y = s[F]
      if (Y.isDirectionalLight) {
        const H = g.directional[S]
        ;(H.direction.setFromMatrixPosition(Y.matrixWorld),
          C.setFromMatrixPosition(Y.target.matrixWorld),
          H.direction.sub(C),
          H.direction.transformDirection(R),
          S++)
      } else if (Y.isSpotLight) {
        const H = g.spot[w]
        ;(H.position.setFromMatrixPosition(Y.matrixWorld),
          H.position.applyMatrix4(R),
          H.direction.setFromMatrixPosition(Y.matrixWorld),
          C.setFromMatrixPosition(Y.target.matrixWorld),
          H.direction.sub(C),
          H.direction.transformDirection(R),
          w++)
      } else if (Y.isRectAreaLight) {
        const H = g.rectArea[M]
        ;(H.position.setFromMatrixPosition(Y.matrixWorld),
          H.position.applyMatrix4(R),
          B.identity(),
          i.copy(Y.matrixWorld),
          i.premultiply(R),
          B.extractRotation(i),
          H.halfWidth.set(Y.width * 0.5, 0, 0),
          H.halfHeight.set(0, Y.height * 0.5, 0),
          H.halfWidth.applyMatrix4(B),
          H.halfHeight.applyMatrix4(B),
          M++)
      } else if (Y.isPointLight) {
        const H = g.point[d]
        ;(H.position.setFromMatrixPosition(Y.matrixWorld), H.position.applyMatrix4(R), d++)
      } else if (Y.isHemisphereLight) {
        const H = g.hemi[K]
        ;(H.direction.setFromMatrixPosition(Y.matrixWorld), H.direction.transformDirection(R), K++)
      }
    }
  }
  return {
    setup: o,
    setupView: r,
    state: g,
  }
}
function fH(e) {
  const A = new g5(e),
    I = [],
    g = []
  function C(h) {
    ;((s.camera = h), (I.length = 0), (g.length = 0))
  }
  function i(h) {
    I.push(h)
  }
  function B(h) {
    g.push(h)
  }
  function o() {
    A.setup(I)
  }
  function r(h) {
    A.setupView(I, h)
  }
  const s = {
    lightsArray: I,
    shadowsArray: g,
    camera: null,
    lights: A,
    transmissionRenderTarget: {},
  }
  return {
    init: C,
    state: s,
    setupLights: o,
    setupLightsView: r,
    pushLight: i,
    pushShadow: B,
  }
}
function C5(e) {
  let A = /* @__PURE__ */ new WeakMap()
  function I(C, i = 0) {
    const B = A.get(C)
    let o
    return (
      B === void 0
        ? ((o = new fH(e)), A.set(C, [o]))
        : i >= B.length
          ? ((o = new fH(e)), B.push(o))
          : (o = B[i]),
      o
    )
  }
  function g() {
    A = /* @__PURE__ */ new WeakMap()
  }
  return {
    get: I,
    dispose: g,
  }
}
class gF extends tQ {
  static get type() {
    return "MeshDepthMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isMeshDepthMaterial = !0),
      (this.depthPacking = mD),
      (this.map = null),
      (this.alphaMap = null),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      (this.depthPacking = A.depthPacking),
      (this.map = A.map),
      (this.alphaMap = A.alphaMap),
      (this.displacementMap = A.displacementMap),
      (this.displacementScale = A.displacementScale),
      (this.displacementBias = A.displacementBias),
      (this.wireframe = A.wireframe),
      (this.wireframeLinewidth = A.wireframeLinewidth),
      this
    )
  }
}
class CF extends tQ {
  static get type() {
    return "MeshDistanceMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isMeshDistanceMaterial = !0),
      (this.map = null),
      (this.alphaMap = null),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      (this.map = A.map),
      (this.alphaMap = A.alphaMap),
      (this.displacementMap = A.displacementMap),
      (this.displacementScale = A.displacementScale),
      (this.displacementBias = A.displacementBias),
      this
    )
  }
}
const e5 = `void main() {
	gl_Position = vec4( position, 1.0 );
}`,
  i5 = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`
function t5(e, A, I) {
  let g = new RG()
  const C = new ZI(),
    i = new ZI(),
    B = new Xe(),
    o = new gF({ depthPacking: Xm }),
    r = new CF(),
    s = {},
    h = I.maxTextureSize,
    S = { [Us]: WQ, [WQ]: Us, [rE]: rE },
    d = new VQ({
      defines: {
        VSM_SAMPLES: 8,
      },
      uniforms: {
        shadow_pass: { value: null },
        resolution: { value: new ZI() },
        radius: { value: 4 },
      },
      vertexShader: e5,
      fragmentShader: i5,
    }),
    w = d.clone()
  w.defines.HORIZONTAL_PASS = 1
  const M = new se()
  M.setAttribute("position", new Ye(new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]), 3))
  const K = new EB(M, d),
    R = this
  ;((this.enabled = !1), (this.autoUpdate = !0), (this.needsUpdate = !1), (this.type = xN))
  let F = this.type
  this.render = function (j, P, AA) {
    if (R.enabled === !1 || (R.autoUpdate === !1 && R.needsUpdate === !1) || j.length === 0) return
    const X = e.getRenderTarget(),
      _ = e.getActiveCubeFace(),
      eA = e.getActiveMipmapLevel(),
      CA = e.state
    ;(CA.setBlending(hE),
      CA.buffers.color.setClear(1, 1, 1, 1),
      CA.buffers.depth.setTest(!0),
      CA.setScissorTest(!1))
    const aA = F !== pl && this.type === pl,
      lA = F === pl && this.type !== pl
    for (let JA = 0, yA = j.length; JA < yA; JA++) {
      const LA = j[JA],
        nA = LA.shadow
      if (nA === void 0) {
        console.warn("THREE.WebGLShadowMap:", LA, "has no shadow.")
        continue
      }
      if (nA.autoUpdate === !1 && nA.needsUpdate === !1) continue
      C.copy(nA.mapSize)
      const fA = nA.getFrameExtents()
      if (
        (C.multiply(fA),
        i.copy(nA.mapSize),
        (C.x > h || C.y > h) &&
          (C.x > h && ((i.x = Math.floor(h / fA.x)), (C.x = i.x * fA.x), (nA.mapSize.x = i.x)),
          C.y > h && ((i.y = Math.floor(h / fA.y)), (C.y = i.y * fA.y), (nA.mapSize.y = i.y))),
        nA.map === null || aA === !0 || lA === !0)
      ) {
        const $ = this.type !== pl ? { minFilter: iQ, magFilter: iQ } : {}
        ;(nA.map !== null && nA.map.dispose(),
          (nA.map = new BQ(C.x, C.y, $)),
          (nA.map.texture.name = LA.name + ".shadowMap"),
          nA.camera.updateProjectionMatrix())
      }
      ;(e.setRenderTarget(nA.map), e.clear())
      const sA = nA.getViewportCount()
      for (let $ = 0; $ < sA; $++) {
        const EA = nA.getViewport($)
        ;(B.set(i.x * EA.x, i.y * EA.y, i.x * EA.z, i.y * EA.w),
          CA.viewport(B),
          nA.updateMatrices(LA, $),
          (g = nA.getFrustum()),
          H(P, AA, nA.camera, LA, this.type))
      }
      ;(nA.isPointLightShadow !== !0 && this.type === pl && L(nA, AA), (nA.needsUpdate = !1))
    }
    ;((F = this.type), (R.needsUpdate = !1), e.setRenderTarget(X, _, eA))
  }
  function L(j, P) {
    const AA = A.update(K)
    ;(d.defines.VSM_SAMPLES !== j.blurSamples &&
      ((d.defines.VSM_SAMPLES = j.blurSamples),
      (w.defines.VSM_SAMPLES = j.blurSamples),
      (d.needsUpdate = !0),
      (w.needsUpdate = !0)),
      j.mapPass === null && (j.mapPass = new BQ(C.x, C.y)),
      (d.uniforms.shadow_pass.value = j.map.texture),
      (d.uniforms.resolution.value = j.mapSize),
      (d.uniforms.radius.value = j.radius),
      e.setRenderTarget(j.mapPass),
      e.clear(),
      e.renderBufferDirect(P, null, AA, d, K, null),
      (w.uniforms.shadow_pass.value = j.mapPass.texture),
      (w.uniforms.resolution.value = j.mapSize),
      (w.uniforms.radius.value = j.radius),
      e.setRenderTarget(j.map),
      e.clear(),
      e.renderBufferDirect(P, null, AA, w, K, null))
  }
  function Y(j, P, AA, X) {
    let _ = null
    const eA = AA.isPointLight === !0 ? j.customDistanceMaterial : j.customDepthMaterial
    if (eA !== void 0) _ = eA
    else if (
      ((_ = AA.isPointLight === !0 ? r : o),
      (e.localClippingEnabled &&
        P.clipShadows === !0 &&
        Array.isArray(P.clippingPlanes) &&
        P.clippingPlanes.length !== 0) ||
        (P.displacementMap && P.displacementScale !== 0) ||
        (P.alphaMap && P.alphaTest > 0) ||
        (P.map && P.alphaTest > 0))
    ) {
      const CA = _.uuid,
        aA = P.uuid
      let lA = s[CA]
      lA === void 0 && ((lA = {}), (s[CA] = lA))
      let JA = lA[aA]
      ;(JA === void 0 && ((JA = _.clone()), (lA[aA] = JA), P.addEventListener("dispose", V)),
        (_ = JA))
    }
    if (
      ((_.visible = P.visible),
      (_.wireframe = P.wireframe),
      X === pl
        ? (_.side = P.shadowSide !== null ? P.shadowSide : P.side)
        : (_.side = P.shadowSide !== null ? P.shadowSide : S[P.side]),
      (_.alphaMap = P.alphaMap),
      (_.alphaTest = P.alphaTest),
      (_.map = P.map),
      (_.clipShadows = P.clipShadows),
      (_.clippingPlanes = P.clippingPlanes),
      (_.clipIntersection = P.clipIntersection),
      (_.displacementMap = P.displacementMap),
      (_.displacementScale = P.displacementScale),
      (_.displacementBias = P.displacementBias),
      (_.wireframeLinewidth = P.wireframeLinewidth),
      (_.linewidth = P.linewidth),
      AA.isPointLight === !0 && _.isMeshDistanceMaterial === !0)
    ) {
      const CA = e.properties.get(_)
      CA.light = AA
    }
    return _
  }
  function H(j, P, AA, X, _) {
    if (j.visible === !1) return
    if (
      j.layers.test(P.layers) &&
      (j.isMesh || j.isLine || j.isPoints) &&
      (j.castShadow || (j.receiveShadow && _ === pl)) &&
      (!j.frustumCulled || g.intersectsObject(j))
    ) {
      j.modelViewMatrix.multiplyMatrices(AA.matrixWorldInverse, j.matrixWorld)
      const aA = A.update(j),
        lA = j.material
      if (Array.isArray(lA)) {
        const JA = aA.groups
        for (let yA = 0, LA = JA.length; yA < LA; yA++) {
          const nA = JA[yA],
            fA = lA[nA.materialIndex]
          if (fA && fA.visible) {
            const sA = Y(j, fA, X, _)
            ;(j.onBeforeShadow(e, j, P, AA, aA, sA, nA),
              e.renderBufferDirect(AA, null, aA, sA, j, nA),
              j.onAfterShadow(e, j, P, AA, aA, sA, nA))
          }
        }
      } else if (lA.visible) {
        const JA = Y(j, lA, X, _)
        ;(j.onBeforeShadow(e, j, P, AA, aA, JA, null),
          e.renderBufferDirect(AA, null, aA, JA, j, null),
          j.onAfterShadow(e, j, P, AA, aA, JA, null))
      }
    }
    const CA = j.children
    for (let aA = 0, lA = CA.length; aA < lA; aA++) H(CA[aA], P, AA, X, _)
  }
  function V(j) {
    j.target.removeEventListener("dispose", V)
    for (const AA in s) {
      const X = s[AA],
        _ = j.target.uuid
      _ in X && (X[_].dispose(), delete X[_])
    }
  }
}
const B5 = {
  [xU]: bU,
  [OU]: PU,
  [_U]: WU,
  [Lf]: ZU,
  [bU]: xU,
  [PU]: OU,
  [WU]: _U,
  [ZU]: Lf,
}
function Q5(e, A) {
  function I() {
    let SA = !1
    const NI = new Xe()
    let HA = null
    const iI = new Xe(0, 0, 0, 0)
    return {
      setMask: function (zI) {
        HA !== zI && !SA && (e.colorMask(zI, zI, zI, zI), (HA = zI))
      },
      setLocked: function (zI) {
        SA = zI
      },
      setClear: function (zI, qI, dg, $g, Qg) {
        ;(Qg === !0 && ((zI *= $g), (qI *= $g), (dg *= $g)),
          NI.set(zI, qI, dg, $g),
          iI.equals(NI) === !1 && (e.clearColor(zI, qI, dg, $g), iI.copy(NI)))
      },
      reset: function () {
        ;((SA = !1), (HA = null), iI.set(-1, 0, 0, 0))
      },
    }
  }
  function g() {
    let SA = !1,
      NI = !1,
      HA = null,
      iI = null,
      zI = null
    return {
      setReversed: function (qI) {
        if (NI !== qI) {
          const dg = A.get("EXT_clip_control")
          NI
            ? dg.clipControlEXT(dg.LOWER_LEFT_EXT, dg.ZERO_TO_ONE_EXT)
            : dg.clipControlEXT(dg.LOWER_LEFT_EXT, dg.NEGATIVE_ONE_TO_ONE_EXT)
          const $g = zI
          ;((zI = null), this.setClear($g))
        }
        NI = qI
      },
      getReversed: function () {
        return NI
      },
      setTest: function (qI) {
        qI ? NA(e.DEPTH_TEST) : qA(e.DEPTH_TEST)
      },
      setMask: function (qI) {
        HA !== qI && !SA && (e.depthMask(qI), (HA = qI))
      },
      setFunc: function (qI) {
        if ((NI && (qI = B5[qI]), iI !== qI)) {
          switch (qI) {
            case xU:
              e.depthFunc(e.NEVER)
              break
            case bU:
              e.depthFunc(e.ALWAYS)
              break
            case OU:
              e.depthFunc(e.LESS)
              break
            case Lf:
              e.depthFunc(e.LEQUAL)
              break
            case _U:
              e.depthFunc(e.EQUAL)
              break
            case ZU:
              e.depthFunc(e.GEQUAL)
              break
            case PU:
              e.depthFunc(e.GREATER)
              break
            case WU:
              e.depthFunc(e.NOTEQUAL)
              break
            default:
              e.depthFunc(e.LEQUAL)
          }
          iI = qI
        }
      },
      setLocked: function (qI) {
        SA = qI
      },
      setClear: function (qI) {
        zI !== qI && (NI && (qI = 1 - qI), e.clearDepth(qI), (zI = qI))
      },
      reset: function () {
        ;((SA = !1), (HA = null), (iI = null), (zI = null), (NI = !1))
      },
    }
  }
  function C() {
    let SA = !1,
      NI = null,
      HA = null,
      iI = null,
      zI = null,
      qI = null,
      dg = null,
      $g = null,
      Qg = null
    return {
      setTest: function (Fg) {
        SA || (Fg ? NA(e.STENCIL_TEST) : qA(e.STENCIL_TEST))
      },
      setMask: function (Fg) {
        NI !== Fg && !SA && (e.stencilMask(Fg), (NI = Fg))
      },
      setFunc: function (Fg, jC, mC) {
        ;(HA !== Fg || iI !== jC || zI !== mC) &&
          (e.stencilFunc(Fg, jC, mC), (HA = Fg), (iI = jC), (zI = mC))
      },
      setOp: function (Fg, jC, mC) {
        ;(qI !== Fg || dg !== jC || $g !== mC) &&
          (e.stencilOp(Fg, jC, mC), (qI = Fg), (dg = jC), ($g = mC))
      },
      setLocked: function (Fg) {
        SA = Fg
      },
      setClear: function (Fg) {
        Qg !== Fg && (e.clearStencil(Fg), (Qg = Fg))
      },
      reset: function () {
        ;((SA = !1),
          (NI = null),
          (HA = null),
          (iI = null),
          (zI = null),
          (qI = null),
          (dg = null),
          ($g = null),
          (Qg = null))
      },
    }
  }
  const i = new I(),
    B = new g(),
    o = new C(),
    r = /* @__PURE__ */ new WeakMap(),
    s = /* @__PURE__ */ new WeakMap()
  let h = {},
    S = {},
    d = /* @__PURE__ */ new WeakMap(),
    w = [],
    M = null,
    K = !1,
    R = null,
    F = null,
    L = null,
    Y = null,
    H = null,
    V = null,
    j = null,
    P = new Mg(0, 0, 0),
    AA = 0,
    X = !1,
    _ = null,
    eA = null,
    CA = null,
    aA = null,
    lA = null
  const JA = e.getParameter(e.MAX_COMBINED_TEXTURE_IMAGE_UNITS)
  let yA = !1,
    LA = 0
  const nA = e.getParameter(e.VERSION)
  nA.indexOf("WebGL") !== -1
    ? ((LA = parseFloat(/^WebGL (\d)/.exec(nA)[1])), (yA = LA >= 1))
    : nA.indexOf("OpenGL ES") !== -1 &&
      ((LA = parseFloat(/^OpenGL ES (\d)/.exec(nA)[1])), (yA = LA >= 2))
  let fA = null,
    sA = {}
  const $ = e.getParameter(e.SCISSOR_BOX),
    EA = e.getParameter(e.VIEWPORT),
    GA = new Xe().fromArray($),
    DA = new Xe().fromArray(EA)
  function dA(SA, NI, HA, iI) {
    const zI = new Uint8Array(4),
      qI = e.createTexture()
    ;(e.bindTexture(SA, qI),
      e.texParameteri(SA, e.TEXTURE_MIN_FILTER, e.NEAREST),
      e.texParameteri(SA, e.TEXTURE_MAG_FILTER, e.NEAREST))
    for (let dg = 0; dg < HA; dg++)
      SA === e.TEXTURE_3D || SA === e.TEXTURE_2D_ARRAY
        ? e.texImage3D(NI, 0, e.RGBA, 1, 1, iI, 0, e.RGBA, e.UNSIGNED_BYTE, zI)
        : e.texImage2D(NI + dg, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, zI)
    return qI
  }
  const kA = {}
  ;((kA[e.TEXTURE_2D] = dA(e.TEXTURE_2D, e.TEXTURE_2D, 1)),
    (kA[e.TEXTURE_CUBE_MAP] = dA(e.TEXTURE_CUBE_MAP, e.TEXTURE_CUBE_MAP_POSITIVE_X, 6)),
    (kA[e.TEXTURE_2D_ARRAY] = dA(e.TEXTURE_2D_ARRAY, e.TEXTURE_2D_ARRAY, 1, 1)),
    (kA[e.TEXTURE_3D] = dA(e.TEXTURE_3D, e.TEXTURE_3D, 1, 1)),
    i.setClear(0, 0, 0, 1),
    B.setClear(1),
    o.setClear(0),
    NA(e.DEPTH_TEST),
    B.setFunc(Lf),
    II(!1),
    pI(am),
    NA(e.CULL_FACE),
    uA(hE))
  function NA(SA) {
    h[SA] !== !0 && (e.enable(SA), (h[SA] = !0))
  }
  function qA(SA) {
    h[SA] !== !1 && (e.disable(SA), (h[SA] = !1))
  }
  function ZA(SA, NI) {
    return S[SA] !== NI
      ? (e.bindFramebuffer(SA, NI),
        (S[SA] = NI),
        SA === e.DRAW_FRAMEBUFFER && (S[e.FRAMEBUFFER] = NI),
        SA === e.FRAMEBUFFER && (S[e.DRAW_FRAMEBUFFER] = NI),
        !0)
      : !1
  }
  function sI(SA, NI) {
    let HA = w,
      iI = !1
    if (SA) {
      ;((HA = d.get(NI)), HA === void 0 && ((HA = []), d.set(NI, HA)))
      const zI = SA.textures
      if (HA.length !== zI.length || HA[0] !== e.COLOR_ATTACHMENT0) {
        for (let qI = 0, dg = zI.length; qI < dg; qI++) HA[qI] = e.COLOR_ATTACHMENT0 + qI
        ;((HA.length = zI.length), (iI = !0))
      }
    } else HA[0] !== e.BACK && ((HA[0] = e.BACK), (iI = !0))
    iI && e.drawBuffers(HA)
  }
  function cI(SA) {
    return M !== SA ? (e.useProgram(SA), (M = SA), !0) : !1
  }
  const YA = {
    [yD]: e.FUNC_ADD,
    [g2]: e.FUNC_SUBTRACT,
    [C2]: e.FUNC_REVERSE_SUBTRACT,
  }
  ;((YA[e2] = e.MIN), (YA[i2] = e.MAX))
  const eI = {
    [t2]: e.ZERO,
    [B2]: e.ONE,
    [Q2]: e.SRC_COLOR,
    [HU]: e.SRC_ALPHA,
    [s2]: e.SRC_ALPHA_SATURATE,
    [a2]: e.DST_COLOR,
    [n2]: e.DST_ALPHA,
    [o2]: e.ONE_MINUS_SRC_COLOR,
    [TU]: e.ONE_MINUS_SRC_ALPHA,
    [r2]: e.ONE_MINUS_DST_COLOR,
    [E2]: e.ONE_MINUS_DST_ALPHA,
    [l2]: e.CONSTANT_COLOR,
    [c2]: e.ONE_MINUS_CONSTANT_COLOR,
    [h2]: e.CONSTANT_ALPHA,
    [u2]: e.ONE_MINUS_CONSTANT_ALPHA,
  }
  function uA(SA, NI, HA, iI, zI, qI, dg, $g, Qg, Fg) {
    if (SA === hE) {
      K === !0 && (qA(e.BLEND), (K = !1))
      return
    }
    if ((K === !1 && (NA(e.BLEND), (K = !0)), SA !== I2)) {
      if (SA !== R || Fg !== X) {
        if (((F !== yD || H !== yD) && (e.blendEquation(e.FUNC_ADD), (F = yD), (H = yD)), Fg))
          switch (SA) {
            case Ff:
              e.blendFuncSeparate(e.ONE, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA)
              break
            case rm:
              e.blendFunc(e.ONE, e.ONE)
              break
            case sm:
              e.blendFuncSeparate(e.ZERO, e.ONE_MINUS_SRC_COLOR, e.ZERO, e.ONE)
              break
            case lm:
              e.blendFuncSeparate(e.ZERO, e.SRC_COLOR, e.ZERO, e.SRC_ALPHA)
              break
            default:
              console.error("THREE.WebGLState: Invalid blending: ", SA)
              break
          }
        else
          switch (SA) {
            case Ff:
              e.blendFuncSeparate(e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA)
              break
            case rm:
              e.blendFunc(e.SRC_ALPHA, e.ONE)
              break
            case sm:
              e.blendFuncSeparate(e.ZERO, e.ONE_MINUS_SRC_COLOR, e.ZERO, e.ONE)
              break
            case lm:
              e.blendFunc(e.ZERO, e.SRC_COLOR)
              break
            default:
              console.error("THREE.WebGLState: Invalid blending: ", SA)
              break
          }
        ;((L = null),
          (Y = null),
          (V = null),
          (j = null),
          P.set(0, 0, 0),
          (AA = 0),
          (R = SA),
          (X = Fg))
      }
      return
    }
    ;((zI = zI || NI),
      (qI = qI || HA),
      (dg = dg || iI),
      (NI !== F || zI !== H) && (e.blendEquationSeparate(YA[NI], YA[zI]), (F = NI), (H = zI)),
      (HA !== L || iI !== Y || qI !== V || dg !== j) &&
        (e.blendFuncSeparate(eI[HA], eI[iI], eI[qI], eI[dg]),
        (L = HA),
        (Y = iI),
        (V = qI),
        (j = dg)),
      ($g.equals(P) === !1 || Qg !== AA) &&
        (e.blendColor($g.r, $g.g, $g.b, Qg), P.copy($g), (AA = Qg)),
      (R = SA),
      (X = !1))
  }
  function hI(SA, NI) {
    SA.side === rE ? qA(e.CULL_FACE) : NA(e.CULL_FACE)
    let HA = SA.side === WQ
    ;(NI && (HA = !HA),
      II(HA),
      SA.blending === Ff && SA.transparent === !1
        ? uA(hE)
        : uA(
            SA.blending,
            SA.blendEquation,
            SA.blendSrc,
            SA.blendDst,
            SA.blendEquationAlpha,
            SA.blendSrcAlpha,
            SA.blendDstAlpha,
            SA.blendColor,
            SA.blendAlpha,
            SA.premultipliedAlpha,
          ),
      B.setFunc(SA.depthFunc),
      B.setTest(SA.depthTest),
      B.setMask(SA.depthWrite),
      i.setMask(SA.colorWrite))
    const iI = SA.stencilWrite
    ;(o.setTest(iI),
      iI &&
        (o.setMask(SA.stencilWriteMask),
        o.setFunc(SA.stencilFunc, SA.stencilRef, SA.stencilFuncMask),
        o.setOp(SA.stencilFail, SA.stencilZFail, SA.stencilZPass)),
      YI(SA.polygonOffset, SA.polygonOffsetFactor, SA.polygonOffsetUnits),
      SA.alphaToCoverage === !0 ? NA(e.SAMPLE_ALPHA_TO_COVERAGE) : qA(e.SAMPLE_ALPHA_TO_COVERAGE))
  }
  function II(SA) {
    _ !== SA && (SA ? e.frontFace(e.CW) : e.frontFace(e.CCW), (_ = SA))
  }
  function pI(SA) {
    ;(SA !== Xx
      ? (NA(e.CULL_FACE),
        SA !== eA &&
          (SA === am
            ? e.cullFace(e.BACK)
            : SA === $x
              ? e.cullFace(e.FRONT)
              : e.cullFace(e.FRONT_AND_BACK)))
      : qA(e.CULL_FACE),
      (eA = SA))
  }
  function AI(SA) {
    SA !== CA && (yA && e.lineWidth(SA), (CA = SA))
  }
  function YI(SA, NI, HA) {
    SA
      ? (NA(e.POLYGON_OFFSET_FILL),
        (aA !== NI || lA !== HA) && (e.polygonOffset(NI, HA), (aA = NI), (lA = HA)))
      : qA(e.POLYGON_OFFSET_FILL)
  }
  function SI(SA) {
    SA ? NA(e.SCISSOR_TEST) : qA(e.SCISSOR_TEST)
  }
  function QA(SA) {
    ;(SA === void 0 && (SA = e.TEXTURE0 + JA - 1), fA !== SA && (e.activeTexture(SA), (fA = SA)))
  }
  function tA(SA, NI, HA) {
    HA === void 0 && (fA === null ? (HA = e.TEXTURE0 + JA - 1) : (HA = fA))
    let iI = sA[HA]
    ;(iI === void 0 && ((iI = { type: void 0, texture: void 0 }), (sA[HA] = iI)),
      (iI.type !== SA || iI.texture !== NI) &&
        (fA !== HA && (e.activeTexture(HA), (fA = HA)),
        e.bindTexture(SA, NI || kA[SA]),
        (iI.type = SA),
        (iI.texture = NI)))
  }
  function FA() {
    const SA = sA[fA]
    SA !== void 0 &&
      SA.type !== void 0 &&
      (e.bindTexture(SA.type, null), (SA.type = void 0), (SA.texture = void 0))
  }
  function WA() {
    try {
      e.compressedTexImage2D.apply(e, arguments)
    } catch (SA) {
      console.error("THREE.WebGLState:", SA)
    }
  }
  function jA() {
    try {
      e.compressedTexImage3D.apply(e, arguments)
    } catch (SA) {
      console.error("THREE.WebGLState:", SA)
    }
  }
  function nI() {
    try {
      e.texSubImage2D.apply(e, arguments)
    } catch (SA) {
      console.error("THREE.WebGLState:", SA)
    }
  }
  function UI() {
    try {
      e.texSubImage3D.apply(e, arguments)
    } catch (SA) {
      console.error("THREE.WebGLState:", SA)
    }
  }
  function GI() {
    try {
      e.compressedTexSubImage2D.apply(e, arguments)
    } catch (SA) {
      console.error("THREE.WebGLState:", SA)
    }
  }
  function LI() {
    try {
      e.compressedTexSubImage3D.apply(e, arguments)
    } catch (SA) {
      console.error("THREE.WebGLState:", SA)
    }
  }
  function Bg() {
    try {
      e.texStorage2D.apply(e, arguments)
    } catch (SA) {
      console.error("THREE.WebGLState:", SA)
    }
  }
  function MA() {
    try {
      e.texStorage3D.apply(e, arguments)
    } catch (SA) {
      console.error("THREE.WebGLState:", SA)
    }
  }
  function OA() {
    try {
      e.texImage2D.apply(e, arguments)
    } catch (SA) {
      console.error("THREE.WebGLState:", SA)
    }
  }
  function aI() {
    try {
      e.texImage3D.apply(e, arguments)
    } catch (SA) {
      console.error("THREE.WebGLState:", SA)
    }
  }
  function RI(SA) {
    GA.equals(SA) === !1 && (e.scissor(SA.x, SA.y, SA.z, SA.w), GA.copy(SA))
  }
  function VA(SA) {
    DA.equals(SA) === !1 && (e.viewport(SA.x, SA.y, SA.z, SA.w), DA.copy(SA))
  }
  function ag(SA, NI) {
    let HA = s.get(NI)
    HA === void 0 && ((HA = /* @__PURE__ */ new WeakMap()), s.set(NI, HA))
    let iI = HA.get(SA)
    iI === void 0 && ((iI = e.getUniformBlockIndex(NI, SA.name)), HA.set(SA, iI))
  }
  function XI(SA, NI) {
    const iI = s.get(NI).get(SA)
    r.get(NI) !== iI && (e.uniformBlockBinding(NI, iI, SA.__bindingPointIndex), r.set(NI, iI))
  }
  function $I() {
    ;(e.disable(e.BLEND),
      e.disable(e.CULL_FACE),
      e.disable(e.DEPTH_TEST),
      e.disable(e.POLYGON_OFFSET_FILL),
      e.disable(e.SCISSOR_TEST),
      e.disable(e.STENCIL_TEST),
      e.disable(e.SAMPLE_ALPHA_TO_COVERAGE),
      e.blendEquation(e.FUNC_ADD),
      e.blendFunc(e.ONE, e.ZERO),
      e.blendFuncSeparate(e.ONE, e.ZERO, e.ONE, e.ZERO),
      e.blendColor(0, 0, 0, 0),
      e.colorMask(!0, !0, !0, !0),
      e.clearColor(0, 0, 0, 0),
      e.depthMask(!0),
      e.depthFunc(e.LESS),
      B.setReversed(!1),
      e.clearDepth(1),
      e.stencilMask(4294967295),
      e.stencilFunc(e.ALWAYS, 0, 4294967295),
      e.stencilOp(e.KEEP, e.KEEP, e.KEEP),
      e.clearStencil(0),
      e.cullFace(e.BACK),
      e.frontFace(e.CCW),
      e.polygonOffset(0, 0),
      e.activeTexture(e.TEXTURE0),
      e.bindFramebuffer(e.FRAMEBUFFER, null),
      e.bindFramebuffer(e.DRAW_FRAMEBUFFER, null),
      e.bindFramebuffer(e.READ_FRAMEBUFFER, null),
      e.useProgram(null),
      e.lineWidth(1),
      e.scissor(0, 0, e.canvas.width, e.canvas.height),
      e.viewport(0, 0, e.canvas.width, e.canvas.height),
      (h = {}),
      (fA = null),
      (sA = {}),
      (S = {}),
      (d = /* @__PURE__ */ new WeakMap()),
      (w = []),
      (M = null),
      (K = !1),
      (R = null),
      (F = null),
      (L = null),
      (Y = null),
      (H = null),
      (V = null),
      (j = null),
      (P = new Mg(0, 0, 0)),
      (AA = 0),
      (X = !1),
      (_ = null),
      (eA = null),
      (CA = null),
      (aA = null),
      (lA = null),
      GA.set(0, 0, e.canvas.width, e.canvas.height),
      DA.set(0, 0, e.canvas.width, e.canvas.height),
      i.reset(),
      B.reset(),
      o.reset())
  }
  return {
    buffers: {
      color: i,
      depth: B,
      stencil: o,
    },
    enable: NA,
    disable: qA,
    bindFramebuffer: ZA,
    drawBuffers: sI,
    useProgram: cI,
    setBlending: uA,
    setMaterial: hI,
    setFlipSided: II,
    setCullFace: pI,
    setLineWidth: AI,
    setPolygonOffset: YI,
    setScissorTest: SI,
    activeTexture: QA,
    bindTexture: tA,
    unbindTexture: FA,
    compressedTexImage2D: WA,
    compressedTexImage3D: jA,
    texImage2D: OA,
    texImage3D: aI,
    updateUBOMapping: ag,
    uniformBlockBinding: XI,
    texStorage2D: Bg,
    texStorage3D: MA,
    texSubImage2D: nI,
    texSubImage3D: UI,
    compressedTexSubImage2D: GI,
    compressedTexSubImage3D: LI,
    scissor: RI,
    viewport: VA,
    reset: $I,
  }
}
function o5(e, A) {
  const I = e.image && e.image.width ? e.image.width / e.image.height : 1
  return (
    I > A
      ? ((e.repeat.x = 1),
        (e.repeat.y = I / A),
        (e.offset.x = 0),
        (e.offset.y = (1 - e.repeat.y) / 2))
      : ((e.repeat.x = A / I),
        (e.repeat.y = 1),
        (e.offset.x = (1 - e.repeat.x) / 2),
        (e.offset.y = 0)),
    e
  )
}
function n5(e, A) {
  const I = e.image && e.image.width ? e.image.width / e.image.height : 1
  return (
    I > A
      ? ((e.repeat.x = A / I),
        (e.repeat.y = 1),
        (e.offset.x = (1 - e.repeat.x) / 2),
        (e.offset.y = 0))
      : ((e.repeat.x = 1),
        (e.repeat.y = I / A),
        (e.offset.x = 0),
        (e.offset.y = (1 - e.repeat.y) / 2)),
    e
  )
}
function E5(e) {
  return ((e.repeat.x = 1), (e.repeat.y = 1), (e.offset.x = 0), (e.offset.y = 0), e)
}
function fm(e, A, I, g) {
  const C = a5(g)
  switch (I) {
    // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
    case Om:
      return e * A
    case Zm:
      return e * A
    case Pm:
      return e * A * 2
    case WN:
      return ((e * A) / C.components) * C.byteLength
    case UG:
      return ((e * A) / C.components) * C.byteLength
    case Wm:
      return ((e * A * 2) / C.components) * C.byteLength
    case VN:
      return ((e * A * 2) / C.components) * C.byteLength
    case _m:
      return ((e * A * 3) / C.components) * C.byteLength
    case lE:
      return ((e * A * 4) / C.components) * C.byteLength
    case jN:
      return ((e * A * 4) / C.components) * C.byteLength
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
    case $0:
    case AG:
      return Math.floor((e + 3) / 4) * Math.floor((A + 3) / 4) * 8
    case IG:
    case gG:
      return Math.floor((e + 3) / 4) * Math.floor((A + 3) / 4) * 16
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
    case jU:
    case XU:
      return (Math.max(e, 16) * Math.max(A, 8)) / 4
    case VU:
    case zU:
      return (Math.max(e, 8) * Math.max(A, 8)) / 2
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
    case $U:
    case AN:
      return Math.floor((e + 3) / 4) * Math.floor((A + 3) / 4) * 8
    case IN:
      return Math.floor((e + 3) / 4) * Math.floor((A + 3) / 4) * 16
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
    case gN:
      return Math.floor((e + 3) / 4) * Math.floor((A + 3) / 4) * 16
    case CN:
      return Math.floor((e + 4) / 5) * Math.floor((A + 3) / 4) * 16
    case eN:
      return Math.floor((e + 4) / 5) * Math.floor((A + 4) / 5) * 16
    case iN:
      return Math.floor((e + 5) / 6) * Math.floor((A + 4) / 5) * 16
    case tN:
      return Math.floor((e + 5) / 6) * Math.floor((A + 5) / 6) * 16
    case BN:
      return Math.floor((e + 7) / 8) * Math.floor((A + 4) / 5) * 16
    case QN:
      return Math.floor((e + 7) / 8) * Math.floor((A + 5) / 6) * 16
    case oN:
      return Math.floor((e + 7) / 8) * Math.floor((A + 7) / 8) * 16
    case nN:
      return Math.floor((e + 9) / 10) * Math.floor((A + 4) / 5) * 16
    case EN:
      return Math.floor((e + 9) / 10) * Math.floor((A + 5) / 6) * 16
    case aN:
      return Math.floor((e + 9) / 10) * Math.floor((A + 7) / 8) * 16
    case rN:
      return Math.floor((e + 9) / 10) * Math.floor((A + 9) / 10) * 16
    case sN:
      return Math.floor((e + 11) / 12) * Math.floor((A + 9) / 10) * 16
    case lN:
      return Math.floor((e + 11) / 12) * Math.floor((A + 11) / 12) * 16
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
    case CG:
    case cN:
    case hN:
      return Math.ceil(e / 4) * Math.ceil(A / 4) * 16
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
    case Vm:
    case uN:
      return Math.ceil(e / 4) * Math.ceil(A / 4) * 8
    case DN:
    case SN:
      return Math.ceil(e / 4) * Math.ceil(A / 4) * 16
  }
  throw new Error(`Unable to determine texture byte length for ${I} format.`)
}
function a5(e) {
  switch (e) {
    case Xo:
    case Tm:
      return { byteLength: 1, components: 1 }
    case op:
    case xm:
    case KD:
      return { byteLength: 2, components: 1 }
    case ZN:
    case PN:
      return { byteLength: 2, components: 4 }
    case Zc:
    case _N:
    case sE:
      return { byteLength: 4, components: 1 }
    case bm:
      return { byteLength: 4, components: 3 }
  }
  throw new Error(`Unknown texture type ${e}.`)
}
const r5 = {
  contain: o5,
  cover: n5,
  fill: E5,
  getByteLength: fm,
}
function s5(e, A, I, g, C, i, B) {
  const o = A.has("WEBGL_multisampled_render_to_texture")
      ? A.get("WEBGL_multisampled_render_to_texture")
      : null,
    r = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent),
    s = new ZI(),
    h = /* @__PURE__ */ new WeakMap()
  let S
  const d = /* @__PURE__ */ new WeakMap()
  let w = !1
  try {
    w = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null
  } catch {}
  function M(QA, tA) {
    return w
      ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(QA, tA)
      : lG("canvas")
  }
  function K(QA, tA, FA) {
    let WA = 1
    const jA = SI(QA)
    if (((jA.width > FA || jA.height > FA) && (WA = FA / Math.max(jA.width, jA.height)), WA < 1))
      if (
        (typeof HTMLImageElement < "u" && QA instanceof HTMLImageElement) ||
        (typeof HTMLCanvasElement < "u" && QA instanceof HTMLCanvasElement) ||
        (typeof ImageBitmap < "u" && QA instanceof ImageBitmap) ||
        (typeof VideoFrame < "u" && QA instanceof VideoFrame)
      ) {
        const nI = Math.floor(WA * jA.width),
          UI = Math.floor(WA * jA.height)
        S === void 0 && (S = M(nI, UI))
        const GI = tA ? M(nI, UI) : S
        return (
          (GI.width = nI),
          (GI.height = UI),
          GI.getContext("2d").drawImage(QA, 0, 0, nI, UI),
          console.warn(
            "THREE.WebGLRenderer: Texture has been resized from (" +
              jA.width +
              "x" +
              jA.height +
              ") to (" +
              nI +
              "x" +
              UI +
              ").",
          ),
          GI
        )
      } else
        return (
          "data" in QA &&
            console.warn(
              "THREE.WebGLRenderer: Image in DataTexture is too big (" +
                jA.width +
                "x" +
                jA.height +
                ").",
            ),
          QA
        )
    return QA
  }
  function R(QA) {
    return QA.generateMipmaps
  }
  function F(QA) {
    e.generateMipmap(QA)
  }
  function L(QA) {
    return QA.isWebGLCubeRenderTarget
      ? e.TEXTURE_CUBE_MAP
      : QA.isWebGL3DRenderTarget
        ? e.TEXTURE_3D
        : QA.isWebGLArrayRenderTarget || QA.isCompressedArrayTexture
          ? e.TEXTURE_2D_ARRAY
          : e.TEXTURE_2D
  }
  function Y(QA, tA, FA, WA, jA = !1) {
    if (QA !== null) {
      if (e[QA] !== void 0) return e[QA]
      console.warn(
        "THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + QA + "'",
      )
    }
    let nI = tA
    if (
      (tA === e.RED &&
        (FA === e.FLOAT && (nI = e.R32F),
        FA === e.HALF_FLOAT && (nI = e.R16F),
        FA === e.UNSIGNED_BYTE && (nI = e.R8)),
      tA === e.RED_INTEGER &&
        (FA === e.UNSIGNED_BYTE && (nI = e.R8UI),
        FA === e.UNSIGNED_SHORT && (nI = e.R16UI),
        FA === e.UNSIGNED_INT && (nI = e.R32UI),
        FA === e.BYTE && (nI = e.R8I),
        FA === e.SHORT && (nI = e.R16I),
        FA === e.INT && (nI = e.R32I)),
      tA === e.RG &&
        (FA === e.FLOAT && (nI = e.RG32F),
        FA === e.HALF_FLOAT && (nI = e.RG16F),
        FA === e.UNSIGNED_BYTE && (nI = e.RG8)),
      tA === e.RG_INTEGER &&
        (FA === e.UNSIGNED_BYTE && (nI = e.RG8UI),
        FA === e.UNSIGNED_SHORT && (nI = e.RG16UI),
        FA === e.UNSIGNED_INT && (nI = e.RG32UI),
        FA === e.BYTE && (nI = e.RG8I),
        FA === e.SHORT && (nI = e.RG16I),
        FA === e.INT && (nI = e.RG32I)),
      tA === e.RGB_INTEGER &&
        (FA === e.UNSIGNED_BYTE && (nI = e.RGB8UI),
        FA === e.UNSIGNED_SHORT && (nI = e.RGB16UI),
        FA === e.UNSIGNED_INT && (nI = e.RGB32UI),
        FA === e.BYTE && (nI = e.RGB8I),
        FA === e.SHORT && (nI = e.RGB16I),
        FA === e.INT && (nI = e.RGB32I)),
      tA === e.RGBA_INTEGER &&
        (FA === e.UNSIGNED_BYTE && (nI = e.RGBA8UI),
        FA === e.UNSIGNED_SHORT && (nI = e.RGBA16UI),
        FA === e.UNSIGNED_INT && (nI = e.RGBA32UI),
        FA === e.BYTE && (nI = e.RGBA8I),
        FA === e.SHORT && (nI = e.RGBA16I),
        FA === e.INT && (nI = e.RGBA32I)),
      tA === e.RGB && FA === e.UNSIGNED_INT_5_9_9_9_REV && (nI = e.RGB9_E5),
      tA === e.RGBA)
    ) {
      const UI = jA ? NG : ni.getTransfer(WA)
      ;(FA === e.FLOAT && (nI = e.RGBA32F),
        FA === e.HALF_FLOAT && (nI = e.RGBA16F),
        FA === e.UNSIGNED_BYTE && (nI = UI === ot ? e.SRGB8_ALPHA8 : e.RGBA8),
        FA === e.UNSIGNED_SHORT_4_4_4_4 && (nI = e.RGBA4),
        FA === e.UNSIGNED_SHORT_5_5_5_1 && (nI = e.RGB5_A1))
    }
    return (
      (nI === e.R16F ||
        nI === e.R32F ||
        nI === e.RG16F ||
        nI === e.RG32F ||
        nI === e.RGBA16F ||
        nI === e.RGBA32F) &&
        A.get("EXT_color_buffer_float"),
      nI
    )
  }
  function H(QA, tA) {
    let FA
    return (
      QA
        ? tA === null || tA === Zc || tA === UD
          ? (FA = e.DEPTH24_STENCIL8)
          : tA === sE
            ? (FA = e.DEPTH32F_STENCIL8)
            : tA === op &&
              ((FA = e.DEPTH24_STENCIL8),
              console.warn(
                "DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.",
              ))
        : tA === null || tA === Zc || tA === UD
          ? (FA = e.DEPTH_COMPONENT24)
          : tA === sE
            ? (FA = e.DEPTH_COMPONENT32F)
            : tA === op && (FA = e.DEPTH_COMPONENT16),
      FA
    )
  }
  function V(QA, tA) {
    return R(QA) === !0 || (QA.isFramebufferTexture && QA.minFilter !== iQ && QA.minFilter !== nt)
      ? Math.log2(Math.max(tA.width, tA.height)) + 1
      : QA.mipmaps !== void 0 && QA.mipmaps.length > 0
        ? QA.mipmaps.length
        : QA.isCompressedTexture && Array.isArray(QA.image)
          ? tA.mipmaps.length
          : 1
  }
  function j(QA) {
    const tA = QA.target
    ;(tA.removeEventListener("dispose", j), AA(tA), tA.isVideoTexture && h.delete(tA))
  }
  function P(QA) {
    const tA = QA.target
    ;(tA.removeEventListener("dispose", P), _(tA))
  }
  function AA(QA) {
    const tA = g.get(QA)
    if (tA.__webglInit === void 0) return
    const FA = QA.source,
      WA = d.get(FA)
    if (WA) {
      const jA = WA[tA.__cacheKey]
      ;(jA.usedTimes--, jA.usedTimes === 0 && X(QA), Object.keys(WA).length === 0 && d.delete(FA))
    }
    g.remove(QA)
  }
  function X(QA) {
    const tA = g.get(QA)
    e.deleteTexture(tA.__webglTexture)
    const FA = QA.source,
      WA = d.get(FA)
    ;(delete WA[tA.__cacheKey], B.memory.textures--)
  }
  function _(QA) {
    const tA = g.get(QA)
    if (
      (QA.depthTexture && (QA.depthTexture.dispose(), g.remove(QA.depthTexture)),
      QA.isWebGLCubeRenderTarget)
    )
      for (let WA = 0; WA < 6; WA++) {
        if (Array.isArray(tA.__webglFramebuffer[WA]))
          for (let jA = 0; jA < tA.__webglFramebuffer[WA].length; jA++)
            e.deleteFramebuffer(tA.__webglFramebuffer[WA][jA])
        else e.deleteFramebuffer(tA.__webglFramebuffer[WA])
        tA.__webglDepthbuffer && e.deleteRenderbuffer(tA.__webglDepthbuffer[WA])
      }
    else {
      if (Array.isArray(tA.__webglFramebuffer))
        for (let WA = 0; WA < tA.__webglFramebuffer.length; WA++)
          e.deleteFramebuffer(tA.__webglFramebuffer[WA])
      else e.deleteFramebuffer(tA.__webglFramebuffer)
      if (
        (tA.__webglDepthbuffer && e.deleteRenderbuffer(tA.__webglDepthbuffer),
        tA.__webglMultisampledFramebuffer && e.deleteFramebuffer(tA.__webglMultisampledFramebuffer),
        tA.__webglColorRenderbuffer)
      )
        for (let WA = 0; WA < tA.__webglColorRenderbuffer.length; WA++)
          tA.__webglColorRenderbuffer[WA] && e.deleteRenderbuffer(tA.__webglColorRenderbuffer[WA])
      tA.__webglDepthRenderbuffer && e.deleteRenderbuffer(tA.__webglDepthRenderbuffer)
    }
    const FA = QA.textures
    for (let WA = 0, jA = FA.length; WA < jA; WA++) {
      const nI = g.get(FA[WA])
      ;(nI.__webglTexture && (e.deleteTexture(nI.__webglTexture), B.memory.textures--),
        g.remove(FA[WA]))
    }
    g.remove(QA)
  }
  let eA = 0
  function CA() {
    eA = 0
  }
  function aA() {
    const QA = eA
    return (
      QA >= C.maxTextures &&
        console.warn(
          "THREE.WebGLTextures: Trying to use " +
            QA +
            " texture units while this GPU supports only " +
            C.maxTextures,
        ),
      (eA += 1),
      QA
    )
  }
  function lA(QA) {
    const tA = []
    return (
      tA.push(QA.wrapS),
      tA.push(QA.wrapT),
      tA.push(QA.wrapR || 0),
      tA.push(QA.magFilter),
      tA.push(QA.minFilter),
      tA.push(QA.anisotropy),
      tA.push(QA.internalFormat),
      tA.push(QA.format),
      tA.push(QA.type),
      tA.push(QA.generateMipmaps),
      tA.push(QA.premultiplyAlpha),
      tA.push(QA.flipY),
      tA.push(QA.unpackAlignment),
      tA.push(QA.colorSpace),
      tA.join()
    )
  }
  function JA(QA, tA) {
    const FA = g.get(QA)
    if (
      (QA.isVideoTexture && AI(QA),
      QA.isRenderTargetTexture === !1 && QA.version > 0 && FA.__version !== QA.version)
    ) {
      const WA = QA.image
      if (WA === null)
        console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.")
      else if (WA.complete === !1)
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete")
      else {
        DA(FA, QA, tA)
        return
      }
    }
    I.bindTexture(e.TEXTURE_2D, FA.__webglTexture, e.TEXTURE0 + tA)
  }
  function yA(QA, tA) {
    const FA = g.get(QA)
    if (QA.version > 0 && FA.__version !== QA.version) {
      DA(FA, QA, tA)
      return
    }
    I.bindTexture(e.TEXTURE_2D_ARRAY, FA.__webglTexture, e.TEXTURE0 + tA)
  }
  function LA(QA, tA) {
    const FA = g.get(QA)
    if (QA.version > 0 && FA.__version !== QA.version) {
      DA(FA, QA, tA)
      return
    }
    I.bindTexture(e.TEXTURE_3D, FA.__webglTexture, e.TEXTURE0 + tA)
  }
  function nA(QA, tA) {
    const FA = g.get(QA)
    if (QA.version > 0 && FA.__version !== QA.version) {
      dA(FA, QA, tA)
      return
    }
    I.bindTexture(e.TEXTURE_CUBE_MAP, FA.__webglTexture, e.TEXTURE0 + tA)
  }
  const fA = {
      [MD]: e.REPEAT,
      [vr]: e.CLAMP_TO_EDGE,
      [Qp]: e.MIRRORED_REPEAT,
    },
    sA = {
      [iQ]: e.NEAREST,
      [ON]: e.NEAREST_MIPMAP_NEAREST,
      [pf]: e.NEAREST_MIPMAP_LINEAR,
      [nt]: e.LINEAR,
      [ep]: e.LINEAR_MIPMAP_NEAREST,
      [ks]: e.LINEAR_MIPMAP_LINEAR,
    },
    $ = {
      [J2]: e.NEVER,
      [q2]: e.ALWAYS,
      [K2]: e.LESS,
      [$m]: e.LEQUAL,
      [m2]: e.EQUAL,
      [Y2]: e.GEQUAL,
      [v2]: e.GREATER,
      [L2]: e.NOTEQUAL,
    }
  function EA(QA, tA) {
    if (
      (tA.type === sE &&
        A.has("OES_texture_float_linear") === !1 &&
        (tA.magFilter === nt ||
          tA.magFilter === ep ||
          tA.magFilter === pf ||
          tA.magFilter === ks ||
          tA.minFilter === nt ||
          tA.minFilter === ep ||
          tA.minFilter === pf ||
          tA.minFilter === ks) &&
        console.warn(
          "THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.",
        ),
      e.texParameteri(QA, e.TEXTURE_WRAP_S, fA[tA.wrapS]),
      e.texParameteri(QA, e.TEXTURE_WRAP_T, fA[tA.wrapT]),
      (QA === e.TEXTURE_3D || QA === e.TEXTURE_2D_ARRAY) &&
        e.texParameteri(QA, e.TEXTURE_WRAP_R, fA[tA.wrapR]),
      e.texParameteri(QA, e.TEXTURE_MAG_FILTER, sA[tA.magFilter]),
      e.texParameteri(QA, e.TEXTURE_MIN_FILTER, sA[tA.minFilter]),
      tA.compareFunction &&
        (e.texParameteri(QA, e.TEXTURE_COMPARE_MODE, e.COMPARE_REF_TO_TEXTURE),
        e.texParameteri(QA, e.TEXTURE_COMPARE_FUNC, $[tA.compareFunction])),
      A.has("EXT_texture_filter_anisotropic") === !0)
    ) {
      if (
        tA.magFilter === iQ ||
        (tA.minFilter !== pf && tA.minFilter !== ks) ||
        (tA.type === sE && A.has("OES_texture_float_linear") === !1)
      )
        return
      if (tA.anisotropy > 1 || g.get(tA).__currentAnisotropy) {
        const FA = A.get("EXT_texture_filter_anisotropic")
        ;(e.texParameterf(
          QA,
          FA.TEXTURE_MAX_ANISOTROPY_EXT,
          Math.min(tA.anisotropy, C.getMaxAnisotropy()),
        ),
          (g.get(tA).__currentAnisotropy = tA.anisotropy))
      }
    }
  }
  function GA(QA, tA) {
    let FA = !1
    QA.__webglInit === void 0 && ((QA.__webglInit = !0), tA.addEventListener("dispose", j))
    const WA = tA.source
    let jA = d.get(WA)
    jA === void 0 && ((jA = {}), d.set(WA, jA))
    const nI = lA(tA)
    if (nI !== QA.__cacheKey) {
      ;(jA[nI] === void 0 &&
        ((jA[nI] = {
          texture: e.createTexture(),
          usedTimes: 0,
        }),
        B.memory.textures++,
        (FA = !0)),
        jA[nI].usedTimes++)
      const UI = jA[QA.__cacheKey]
      ;(UI !== void 0 && (jA[QA.__cacheKey].usedTimes--, UI.usedTimes === 0 && X(tA)),
        (QA.__cacheKey = nI),
        (QA.__webglTexture = jA[nI].texture))
    }
    return FA
  }
  function DA(QA, tA, FA) {
    let WA = e.TEXTURE_2D
    ;((tA.isDataArrayTexture || tA.isCompressedArrayTexture) && (WA = e.TEXTURE_2D_ARRAY),
      tA.isData3DTexture && (WA = e.TEXTURE_3D))
    const jA = GA(QA, tA),
      nI = tA.source
    I.bindTexture(WA, QA.__webglTexture, e.TEXTURE0 + FA)
    const UI = g.get(nI)
    if (nI.version !== UI.__version || jA === !0) {
      I.activeTexture(e.TEXTURE0 + FA)
      const GI = ni.getPrimaries(ni.workingColorSpace),
        LI = tA.colorSpace === kl ? null : ni.getPrimaries(tA.colorSpace),
        Bg = tA.colorSpace === kl || GI === LI ? e.NONE : e.BROWSER_DEFAULT_WEBGL
      ;(e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, tA.flipY),
        e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, tA.premultiplyAlpha),
        e.pixelStorei(e.UNPACK_ALIGNMENT, tA.unpackAlignment),
        e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, Bg))
      let MA = K(tA.image, !1, C.maxTextureSize)
      MA = YI(tA, MA)
      const OA = i.convert(tA.format, tA.colorSpace),
        aI = i.convert(tA.type)
      let RI = Y(tA.internalFormat, OA, aI, tA.colorSpace, tA.isVideoTexture)
      EA(WA, tA)
      let VA
      const ag = tA.mipmaps,
        XI = tA.isVideoTexture !== !0,
        $I = UI.__version === void 0 || jA === !0,
        SA = nI.dataReady,
        NI = V(tA, MA)
      if (tA.isDepthTexture)
        ((RI = H(tA.format === ND, tA.type)),
          $I &&
            (XI
              ? I.texStorage2D(e.TEXTURE_2D, 1, RI, MA.width, MA.height)
              : I.texImage2D(e.TEXTURE_2D, 0, RI, MA.width, MA.height, 0, OA, aI, null)))
      else if (tA.isDataTexture)
        if (ag.length > 0) {
          XI && $I && I.texStorage2D(e.TEXTURE_2D, NI, RI, ag[0].width, ag[0].height)
          for (let HA = 0, iI = ag.length; HA < iI; HA++)
            ((VA = ag[HA]),
              XI
                ? SA &&
                  I.texSubImage2D(e.TEXTURE_2D, HA, 0, 0, VA.width, VA.height, OA, aI, VA.data)
                : I.texImage2D(e.TEXTURE_2D, HA, RI, VA.width, VA.height, 0, OA, aI, VA.data))
          tA.generateMipmaps = !1
        } else
          XI
            ? ($I && I.texStorage2D(e.TEXTURE_2D, NI, RI, MA.width, MA.height),
              SA && I.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, MA.width, MA.height, OA, aI, MA.data))
            : I.texImage2D(e.TEXTURE_2D, 0, RI, MA.width, MA.height, 0, OA, aI, MA.data)
      else if (tA.isCompressedTexture)
        if (tA.isCompressedArrayTexture) {
          XI &&
            $I &&
            I.texStorage3D(e.TEXTURE_2D_ARRAY, NI, RI, ag[0].width, ag[0].height, MA.depth)
          for (let HA = 0, iI = ag.length; HA < iI; HA++)
            if (((VA = ag[HA]), tA.format !== lE))
              if (OA !== null)
                if (XI) {
                  if (SA)
                    if (tA.layerUpdates.size > 0) {
                      const zI = fm(VA.width, VA.height, tA.format, tA.type)
                      for (const qI of tA.layerUpdates) {
                        const dg = VA.data.subarray(
                          (qI * zI) / VA.data.BYTES_PER_ELEMENT,
                          ((qI + 1) * zI) / VA.data.BYTES_PER_ELEMENT,
                        )
                        I.compressedTexSubImage3D(
                          e.TEXTURE_2D_ARRAY,
                          HA,
                          0,
                          0,
                          qI,
                          VA.width,
                          VA.height,
                          1,
                          OA,
                          dg,
                        )
                      }
                      tA.clearLayerUpdates()
                    } else
                      I.compressedTexSubImage3D(
                        e.TEXTURE_2D_ARRAY,
                        HA,
                        0,
                        0,
                        0,
                        VA.width,
                        VA.height,
                        MA.depth,
                        OA,
                        VA.data,
                      )
                } else
                  I.compressedTexImage3D(
                    e.TEXTURE_2D_ARRAY,
                    HA,
                    RI,
                    VA.width,
                    VA.height,
                    MA.depth,
                    0,
                    VA.data,
                    0,
                    0,
                  )
              else
                console.warn(
                  "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()",
                )
            else
              XI
                ? SA &&
                  I.texSubImage3D(
                    e.TEXTURE_2D_ARRAY,
                    HA,
                    0,
                    0,
                    0,
                    VA.width,
                    VA.height,
                    MA.depth,
                    OA,
                    aI,
                    VA.data,
                  )
                : I.texImage3D(
                    e.TEXTURE_2D_ARRAY,
                    HA,
                    RI,
                    VA.width,
                    VA.height,
                    MA.depth,
                    0,
                    OA,
                    aI,
                    VA.data,
                  )
        } else {
          XI && $I && I.texStorage2D(e.TEXTURE_2D, NI, RI, ag[0].width, ag[0].height)
          for (let HA = 0, iI = ag.length; HA < iI; HA++)
            ((VA = ag[HA]),
              tA.format !== lE
                ? OA !== null
                  ? XI
                    ? SA &&
                      I.compressedTexSubImage2D(
                        e.TEXTURE_2D,
                        HA,
                        0,
                        0,
                        VA.width,
                        VA.height,
                        OA,
                        VA.data,
                      )
                    : I.compressedTexImage2D(e.TEXTURE_2D, HA, RI, VA.width, VA.height, 0, VA.data)
                  : console.warn(
                      "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()",
                    )
                : XI
                  ? SA &&
                    I.texSubImage2D(e.TEXTURE_2D, HA, 0, 0, VA.width, VA.height, OA, aI, VA.data)
                  : I.texImage2D(e.TEXTURE_2D, HA, RI, VA.width, VA.height, 0, OA, aI, VA.data))
        }
      else if (tA.isDataArrayTexture)
        if (XI) {
          if (($I && I.texStorage3D(e.TEXTURE_2D_ARRAY, NI, RI, MA.width, MA.height, MA.depth), SA))
            if (tA.layerUpdates.size > 0) {
              const HA = fm(MA.width, MA.height, tA.format, tA.type)
              for (const iI of tA.layerUpdates) {
                const zI = MA.data.subarray(
                  (iI * HA) / MA.data.BYTES_PER_ELEMENT,
                  ((iI + 1) * HA) / MA.data.BYTES_PER_ELEMENT,
                )
                I.texSubImage3D(e.TEXTURE_2D_ARRAY, 0, 0, 0, iI, MA.width, MA.height, 1, OA, aI, zI)
              }
              tA.clearLayerUpdates()
            } else
              I.texSubImage3D(
                e.TEXTURE_2D_ARRAY,
                0,
                0,
                0,
                0,
                MA.width,
                MA.height,
                MA.depth,
                OA,
                aI,
                MA.data,
              )
        } else
          I.texImage3D(e.TEXTURE_2D_ARRAY, 0, RI, MA.width, MA.height, MA.depth, 0, OA, aI, MA.data)
      else if (tA.isData3DTexture)
        XI
          ? ($I && I.texStorage3D(e.TEXTURE_3D, NI, RI, MA.width, MA.height, MA.depth),
            SA &&
              I.texSubImage3D(
                e.TEXTURE_3D,
                0,
                0,
                0,
                0,
                MA.width,
                MA.height,
                MA.depth,
                OA,
                aI,
                MA.data,
              ))
          : I.texImage3D(e.TEXTURE_3D, 0, RI, MA.width, MA.height, MA.depth, 0, OA, aI, MA.data)
      else if (tA.isFramebufferTexture) {
        if ($I)
          if (XI) I.texStorage2D(e.TEXTURE_2D, NI, RI, MA.width, MA.height)
          else {
            let HA = MA.width,
              iI = MA.height
            for (let zI = 0; zI < NI; zI++)
              (I.texImage2D(e.TEXTURE_2D, zI, RI, HA, iI, 0, OA, aI, null), (HA >>= 1), (iI >>= 1))
          }
      } else if (ag.length > 0) {
        if (XI && $I) {
          const HA = SI(ag[0])
          I.texStorage2D(e.TEXTURE_2D, NI, RI, HA.width, HA.height)
        }
        for (let HA = 0, iI = ag.length; HA < iI; HA++)
          ((VA = ag[HA]),
            XI
              ? SA && I.texSubImage2D(e.TEXTURE_2D, HA, 0, 0, OA, aI, VA)
              : I.texImage2D(e.TEXTURE_2D, HA, RI, OA, aI, VA))
        tA.generateMipmaps = !1
      } else if (XI) {
        if ($I) {
          const HA = SI(MA)
          I.texStorage2D(e.TEXTURE_2D, NI, RI, HA.width, HA.height)
        }
        SA && I.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, OA, aI, MA)
      } else I.texImage2D(e.TEXTURE_2D, 0, RI, OA, aI, MA)
      ;(R(tA) && F(WA), (UI.__version = nI.version), tA.onUpdate && tA.onUpdate(tA))
    }
    QA.__version = tA.version
  }
  function dA(QA, tA, FA) {
    if (tA.image.length !== 6) return
    const WA = GA(QA, tA),
      jA = tA.source
    I.bindTexture(e.TEXTURE_CUBE_MAP, QA.__webglTexture, e.TEXTURE0 + FA)
    const nI = g.get(jA)
    if (jA.version !== nI.__version || WA === !0) {
      I.activeTexture(e.TEXTURE0 + FA)
      const UI = ni.getPrimaries(ni.workingColorSpace),
        GI = tA.colorSpace === kl ? null : ni.getPrimaries(tA.colorSpace),
        LI = tA.colorSpace === kl || UI === GI ? e.NONE : e.BROWSER_DEFAULT_WEBGL
      ;(e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, tA.flipY),
        e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, tA.premultiplyAlpha),
        e.pixelStorei(e.UNPACK_ALIGNMENT, tA.unpackAlignment),
        e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, LI))
      const Bg = tA.isCompressedTexture || tA.image[0].isCompressedTexture,
        MA = tA.image[0] && tA.image[0].isDataTexture,
        OA = []
      for (let iI = 0; iI < 6; iI++)
        (!Bg && !MA
          ? (OA[iI] = K(tA.image[iI], !0, C.maxCubemapSize))
          : (OA[iI] = MA ? tA.image[iI].image : tA.image[iI]),
          (OA[iI] = YI(tA, OA[iI])))
      const aI = OA[0],
        RI = i.convert(tA.format, tA.colorSpace),
        VA = i.convert(tA.type),
        ag = Y(tA.internalFormat, RI, VA, tA.colorSpace),
        XI = tA.isVideoTexture !== !0,
        $I = nI.__version === void 0 || WA === !0,
        SA = jA.dataReady
      let NI = V(tA, aI)
      EA(e.TEXTURE_CUBE_MAP, tA)
      let HA
      if (Bg) {
        XI && $I && I.texStorage2D(e.TEXTURE_CUBE_MAP, NI, ag, aI.width, aI.height)
        for (let iI = 0; iI < 6; iI++) {
          HA = OA[iI].mipmaps
          for (let zI = 0; zI < HA.length; zI++) {
            const qI = HA[zI]
            tA.format !== lE
              ? RI !== null
                ? XI
                  ? SA &&
                    I.compressedTexSubImage2D(
                      e.TEXTURE_CUBE_MAP_POSITIVE_X + iI,
                      zI,
                      0,
                      0,
                      qI.width,
                      qI.height,
                      RI,
                      qI.data,
                    )
                  : I.compressedTexImage2D(
                      e.TEXTURE_CUBE_MAP_POSITIVE_X + iI,
                      zI,
                      ag,
                      qI.width,
                      qI.height,
                      0,
                      qI.data,
                    )
                : console.warn(
                    "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()",
                  )
              : XI
                ? SA &&
                  I.texSubImage2D(
                    e.TEXTURE_CUBE_MAP_POSITIVE_X + iI,
                    zI,
                    0,
                    0,
                    qI.width,
                    qI.height,
                    RI,
                    VA,
                    qI.data,
                  )
                : I.texImage2D(
                    e.TEXTURE_CUBE_MAP_POSITIVE_X + iI,
                    zI,
                    ag,
                    qI.width,
                    qI.height,
                    0,
                    RI,
                    VA,
                    qI.data,
                  )
          }
        }
      } else {
        if (((HA = tA.mipmaps), XI && $I)) {
          HA.length > 0 && NI++
          const iI = SI(OA[0])
          I.texStorage2D(e.TEXTURE_CUBE_MAP, NI, ag, iI.width, iI.height)
        }
        for (let iI = 0; iI < 6; iI++)
          if (MA) {
            XI
              ? SA &&
                I.texSubImage2D(
                  e.TEXTURE_CUBE_MAP_POSITIVE_X + iI,
                  0,
                  0,
                  0,
                  OA[iI].width,
                  OA[iI].height,
                  RI,
                  VA,
                  OA[iI].data,
                )
              : I.texImage2D(
                  e.TEXTURE_CUBE_MAP_POSITIVE_X + iI,
                  0,
                  ag,
                  OA[iI].width,
                  OA[iI].height,
                  0,
                  RI,
                  VA,
                  OA[iI].data,
                )
            for (let zI = 0; zI < HA.length; zI++) {
              const dg = HA[zI].image[iI].image
              XI
                ? SA &&
                  I.texSubImage2D(
                    e.TEXTURE_CUBE_MAP_POSITIVE_X + iI,
                    zI + 1,
                    0,
                    0,
                    dg.width,
                    dg.height,
                    RI,
                    VA,
                    dg.data,
                  )
                : I.texImage2D(
                    e.TEXTURE_CUBE_MAP_POSITIVE_X + iI,
                    zI + 1,
                    ag,
                    dg.width,
                    dg.height,
                    0,
                    RI,
                    VA,
                    dg.data,
                  )
            }
          } else {
            XI
              ? SA && I.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + iI, 0, 0, 0, RI, VA, OA[iI])
              : I.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + iI, 0, ag, RI, VA, OA[iI])
            for (let zI = 0; zI < HA.length; zI++) {
              const qI = HA[zI]
              XI
                ? SA &&
                  I.texSubImage2D(
                    e.TEXTURE_CUBE_MAP_POSITIVE_X + iI,
                    zI + 1,
                    0,
                    0,
                    RI,
                    VA,
                    qI.image[iI],
                  )
                : I.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + iI, zI + 1, ag, RI, VA, qI.image[iI])
            }
          }
      }
      ;(R(tA) && F(e.TEXTURE_CUBE_MAP), (nI.__version = jA.version), tA.onUpdate && tA.onUpdate(tA))
    }
    QA.__version = tA.version
  }
  function kA(QA, tA, FA, WA, jA, nI) {
    const UI = i.convert(FA.format, FA.colorSpace),
      GI = i.convert(FA.type),
      LI = Y(FA.internalFormat, UI, GI, FA.colorSpace),
      Bg = g.get(tA),
      MA = g.get(FA)
    if (((MA.__renderTarget = tA), !Bg.__hasExternalTextures)) {
      const OA = Math.max(1, tA.width >> nI),
        aI = Math.max(1, tA.height >> nI)
      jA === e.TEXTURE_3D || jA === e.TEXTURE_2D_ARRAY
        ? I.texImage3D(jA, nI, LI, OA, aI, tA.depth, 0, UI, GI, null)
        : I.texImage2D(jA, nI, LI, OA, aI, 0, UI, GI, null)
    }
    ;(I.bindFramebuffer(e.FRAMEBUFFER, QA),
      pI(tA)
        ? o.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, WA, jA, MA.__webglTexture, 0, II(tA))
        : (jA === e.TEXTURE_2D ||
            (jA >= e.TEXTURE_CUBE_MAP_POSITIVE_X && jA <= e.TEXTURE_CUBE_MAP_NEGATIVE_Z)) &&
          e.framebufferTexture2D(e.FRAMEBUFFER, WA, jA, MA.__webglTexture, nI),
      I.bindFramebuffer(e.FRAMEBUFFER, null))
  }
  function NA(QA, tA, FA) {
    if ((e.bindRenderbuffer(e.RENDERBUFFER, QA), tA.depthBuffer)) {
      const WA = tA.depthTexture,
        jA = WA && WA.isDepthTexture ? WA.type : null,
        nI = H(tA.stencilBuffer, jA),
        UI = tA.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT,
        GI = II(tA)
      ;(pI(tA)
        ? o.renderbufferStorageMultisampleEXT(e.RENDERBUFFER, GI, nI, tA.width, tA.height)
        : FA
          ? e.renderbufferStorageMultisample(e.RENDERBUFFER, GI, nI, tA.width, tA.height)
          : e.renderbufferStorage(e.RENDERBUFFER, nI, tA.width, tA.height),
        e.framebufferRenderbuffer(e.FRAMEBUFFER, UI, e.RENDERBUFFER, QA))
    } else {
      const WA = tA.textures
      for (let jA = 0; jA < WA.length; jA++) {
        const nI = WA[jA],
          UI = i.convert(nI.format, nI.colorSpace),
          GI = i.convert(nI.type),
          LI = Y(nI.internalFormat, UI, GI, nI.colorSpace),
          Bg = II(tA)
        FA && pI(tA) === !1
          ? e.renderbufferStorageMultisample(e.RENDERBUFFER, Bg, LI, tA.width, tA.height)
          : pI(tA)
            ? o.renderbufferStorageMultisampleEXT(e.RENDERBUFFER, Bg, LI, tA.width, tA.height)
            : e.renderbufferStorage(e.RENDERBUFFER, LI, tA.width, tA.height)
      }
    }
    e.bindRenderbuffer(e.RENDERBUFFER, null)
  }
  function qA(QA, tA) {
    if (tA && tA.isWebGLCubeRenderTarget)
      throw new Error("Depth Texture with cube render targets is not supported")
    if (
      (I.bindFramebuffer(e.FRAMEBUFFER, QA), !(tA.depthTexture && tA.depthTexture.isDepthTexture))
    )
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture")
    const WA = g.get(tA.depthTexture)
    ;((WA.__renderTarget = tA),
      (!WA.__webglTexture ||
        tA.depthTexture.image.width !== tA.width ||
        tA.depthTexture.image.height !== tA.height) &&
        ((tA.depthTexture.image.width = tA.width),
        (tA.depthTexture.image.height = tA.height),
        (tA.depthTexture.needsUpdate = !0)),
      JA(tA.depthTexture, 0))
    const jA = WA.__webglTexture,
      nI = II(tA)
    if (tA.depthTexture.format === Rf)
      pI(tA)
        ? o.framebufferTexture2DMultisampleEXT(
            e.FRAMEBUFFER,
            e.DEPTH_ATTACHMENT,
            e.TEXTURE_2D,
            jA,
            0,
            nI,
          )
        : e.framebufferTexture2D(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.TEXTURE_2D, jA, 0)
    else if (tA.depthTexture.format === ND)
      pI(tA)
        ? o.framebufferTexture2DMultisampleEXT(
            e.FRAMEBUFFER,
            e.DEPTH_STENCIL_ATTACHMENT,
            e.TEXTURE_2D,
            jA,
            0,
            nI,
          )
        : e.framebufferTexture2D(e.FRAMEBUFFER, e.DEPTH_STENCIL_ATTACHMENT, e.TEXTURE_2D, jA, 0)
    else throw new Error("Unknown depthTexture format")
  }
  function ZA(QA) {
    const tA = g.get(QA),
      FA = QA.isWebGLCubeRenderTarget === !0
    if (tA.__boundDepthTexture !== QA.depthTexture) {
      const WA = QA.depthTexture
      if ((tA.__depthDisposeCallback && tA.__depthDisposeCallback(), WA)) {
        const jA = () => {
          ;(delete tA.__boundDepthTexture,
            delete tA.__depthDisposeCallback,
            WA.removeEventListener("dispose", jA))
        }
        ;(WA.addEventListener("dispose", jA), (tA.__depthDisposeCallback = jA))
      }
      tA.__boundDepthTexture = WA
    }
    if (QA.depthTexture && !tA.__autoAllocateDepthBuffer) {
      if (FA) throw new Error("target.depthTexture not supported in Cube render targets")
      qA(tA.__webglFramebuffer, QA)
    } else if (FA) {
      tA.__webglDepthbuffer = []
      for (let WA = 0; WA < 6; WA++)
        if (
          (I.bindFramebuffer(e.FRAMEBUFFER, tA.__webglFramebuffer[WA]),
          tA.__webglDepthbuffer[WA] === void 0)
        )
          ((tA.__webglDepthbuffer[WA] = e.createRenderbuffer()),
            NA(tA.__webglDepthbuffer[WA], QA, !1))
        else {
          const jA = QA.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT,
            nI = tA.__webglDepthbuffer[WA]
          ;(e.bindRenderbuffer(e.RENDERBUFFER, nI),
            e.framebufferRenderbuffer(e.FRAMEBUFFER, jA, e.RENDERBUFFER, nI))
        }
    } else if (
      (I.bindFramebuffer(e.FRAMEBUFFER, tA.__webglFramebuffer), tA.__webglDepthbuffer === void 0)
    )
      ((tA.__webglDepthbuffer = e.createRenderbuffer()), NA(tA.__webglDepthbuffer, QA, !1))
    else {
      const WA = QA.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT,
        jA = tA.__webglDepthbuffer
      ;(e.bindRenderbuffer(e.RENDERBUFFER, jA),
        e.framebufferRenderbuffer(e.FRAMEBUFFER, WA, e.RENDERBUFFER, jA))
    }
    I.bindFramebuffer(e.FRAMEBUFFER, null)
  }
  function sI(QA, tA, FA) {
    const WA = g.get(QA)
    ;(tA !== void 0 &&
      kA(WA.__webglFramebuffer, QA, QA.texture, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, 0),
      FA !== void 0 && ZA(QA))
  }
  function cI(QA) {
    const tA = QA.texture,
      FA = g.get(QA),
      WA = g.get(tA)
    QA.addEventListener("dispose", P)
    const jA = QA.textures,
      nI = QA.isWebGLCubeRenderTarget === !0,
      UI = jA.length > 1
    if (
      (UI ||
        (WA.__webglTexture === void 0 && (WA.__webglTexture = e.createTexture()),
        (WA.__version = tA.version),
        B.memory.textures++),
      nI)
    ) {
      FA.__webglFramebuffer = []
      for (let GI = 0; GI < 6; GI++)
        if (tA.mipmaps && tA.mipmaps.length > 0) {
          FA.__webglFramebuffer[GI] = []
          for (let LI = 0; LI < tA.mipmaps.length; LI++)
            FA.__webglFramebuffer[GI][LI] = e.createFramebuffer()
        } else FA.__webglFramebuffer[GI] = e.createFramebuffer()
    } else {
      if (tA.mipmaps && tA.mipmaps.length > 0) {
        FA.__webglFramebuffer = []
        for (let GI = 0; GI < tA.mipmaps.length; GI++)
          FA.__webglFramebuffer[GI] = e.createFramebuffer()
      } else FA.__webglFramebuffer = e.createFramebuffer()
      if (UI)
        for (let GI = 0, LI = jA.length; GI < LI; GI++) {
          const Bg = g.get(jA[GI])
          Bg.__webglTexture === void 0 &&
            ((Bg.__webglTexture = e.createTexture()), B.memory.textures++)
        }
      if (QA.samples > 0 && pI(QA) === !1) {
        ;((FA.__webglMultisampledFramebuffer = e.createFramebuffer()),
          (FA.__webglColorRenderbuffer = []),
          I.bindFramebuffer(e.FRAMEBUFFER, FA.__webglMultisampledFramebuffer))
        for (let GI = 0; GI < jA.length; GI++) {
          const LI = jA[GI]
          ;((FA.__webglColorRenderbuffer[GI] = e.createRenderbuffer()),
            e.bindRenderbuffer(e.RENDERBUFFER, FA.__webglColorRenderbuffer[GI]))
          const Bg = i.convert(LI.format, LI.colorSpace),
            MA = i.convert(LI.type),
            OA = Y(LI.internalFormat, Bg, MA, LI.colorSpace, QA.isXRRenderTarget === !0),
            aI = II(QA)
          ;(e.renderbufferStorageMultisample(e.RENDERBUFFER, aI, OA, QA.width, QA.height),
            e.framebufferRenderbuffer(
              e.FRAMEBUFFER,
              e.COLOR_ATTACHMENT0 + GI,
              e.RENDERBUFFER,
              FA.__webglColorRenderbuffer[GI],
            ))
        }
        ;(e.bindRenderbuffer(e.RENDERBUFFER, null),
          QA.depthBuffer &&
            ((FA.__webglDepthRenderbuffer = e.createRenderbuffer()),
            NA(FA.__webglDepthRenderbuffer, QA, !0)),
          I.bindFramebuffer(e.FRAMEBUFFER, null))
      }
    }
    if (nI) {
      ;(I.bindTexture(e.TEXTURE_CUBE_MAP, WA.__webglTexture), EA(e.TEXTURE_CUBE_MAP, tA))
      for (let GI = 0; GI < 6; GI++)
        if (tA.mipmaps && tA.mipmaps.length > 0)
          for (let LI = 0; LI < tA.mipmaps.length; LI++)
            kA(
              FA.__webglFramebuffer[GI][LI],
              QA,
              tA,
              e.COLOR_ATTACHMENT0,
              e.TEXTURE_CUBE_MAP_POSITIVE_X + GI,
              LI,
            )
        else
          kA(
            FA.__webglFramebuffer[GI],
            QA,
            tA,
            e.COLOR_ATTACHMENT0,
            e.TEXTURE_CUBE_MAP_POSITIVE_X + GI,
            0,
          )
      ;(R(tA) && F(e.TEXTURE_CUBE_MAP), I.unbindTexture())
    } else if (UI) {
      for (let GI = 0, LI = jA.length; GI < LI; GI++) {
        const Bg = jA[GI],
          MA = g.get(Bg)
        ;(I.bindTexture(e.TEXTURE_2D, MA.__webglTexture),
          EA(e.TEXTURE_2D, Bg),
          kA(FA.__webglFramebuffer, QA, Bg, e.COLOR_ATTACHMENT0 + GI, e.TEXTURE_2D, 0),
          R(Bg) && F(e.TEXTURE_2D))
      }
      I.unbindTexture()
    } else {
      let GI = e.TEXTURE_2D
      if (
        ((QA.isWebGL3DRenderTarget || QA.isWebGLArrayRenderTarget) &&
          (GI = QA.isWebGL3DRenderTarget ? e.TEXTURE_3D : e.TEXTURE_2D_ARRAY),
        I.bindTexture(GI, WA.__webglTexture),
        EA(GI, tA),
        tA.mipmaps && tA.mipmaps.length > 0)
      )
        for (let LI = 0; LI < tA.mipmaps.length; LI++)
          kA(FA.__webglFramebuffer[LI], QA, tA, e.COLOR_ATTACHMENT0, GI, LI)
      else kA(FA.__webglFramebuffer, QA, tA, e.COLOR_ATTACHMENT0, GI, 0)
      ;(R(tA) && F(GI), I.unbindTexture())
    }
    QA.depthBuffer && ZA(QA)
  }
  function YA(QA) {
    const tA = QA.textures
    for (let FA = 0, WA = tA.length; FA < WA; FA++) {
      const jA = tA[FA]
      if (R(jA)) {
        const nI = L(QA),
          UI = g.get(jA).__webglTexture
        ;(I.bindTexture(nI, UI), F(nI), I.unbindTexture())
      }
    }
  }
  const eI = [],
    uA = []
  function hI(QA) {
    if (QA.samples > 0) {
      if (pI(QA) === !1) {
        const tA = QA.textures,
          FA = QA.width,
          WA = QA.height
        let jA = e.COLOR_BUFFER_BIT
        const nI = QA.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT,
          UI = g.get(QA),
          GI = tA.length > 1
        if (GI)
          for (let LI = 0; LI < tA.length; LI++)
            (I.bindFramebuffer(e.FRAMEBUFFER, UI.__webglMultisampledFramebuffer),
              e.framebufferRenderbuffer(
                e.FRAMEBUFFER,
                e.COLOR_ATTACHMENT0 + LI,
                e.RENDERBUFFER,
                null,
              ),
              I.bindFramebuffer(e.FRAMEBUFFER, UI.__webglFramebuffer),
              e.framebufferTexture2D(
                e.DRAW_FRAMEBUFFER,
                e.COLOR_ATTACHMENT0 + LI,
                e.TEXTURE_2D,
                null,
                0,
              ))
        ;(I.bindFramebuffer(e.READ_FRAMEBUFFER, UI.__webglMultisampledFramebuffer),
          I.bindFramebuffer(e.DRAW_FRAMEBUFFER, UI.__webglFramebuffer))
        for (let LI = 0; LI < tA.length; LI++) {
          if (
            (QA.resolveDepthBuffer &&
              (QA.depthBuffer && (jA |= e.DEPTH_BUFFER_BIT),
              QA.stencilBuffer && QA.resolveStencilBuffer && (jA |= e.STENCIL_BUFFER_BIT)),
            GI)
          ) {
            e.framebufferRenderbuffer(
              e.READ_FRAMEBUFFER,
              e.COLOR_ATTACHMENT0,
              e.RENDERBUFFER,
              UI.__webglColorRenderbuffer[LI],
            )
            const Bg = g.get(tA[LI]).__webglTexture
            e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, Bg, 0)
          }
          ;(e.blitFramebuffer(0, 0, FA, WA, 0, 0, FA, WA, jA, e.NEAREST),
            r === !0 &&
              ((eI.length = 0),
              (uA.length = 0),
              eI.push(e.COLOR_ATTACHMENT0 + LI),
              QA.depthBuffer &&
                QA.resolveDepthBuffer === !1 &&
                (eI.push(nI), uA.push(nI), e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER, uA)),
              e.invalidateFramebuffer(e.READ_FRAMEBUFFER, eI)))
        }
        if (
          (I.bindFramebuffer(e.READ_FRAMEBUFFER, null),
          I.bindFramebuffer(e.DRAW_FRAMEBUFFER, null),
          GI)
        )
          for (let LI = 0; LI < tA.length; LI++) {
            ;(I.bindFramebuffer(e.FRAMEBUFFER, UI.__webglMultisampledFramebuffer),
              e.framebufferRenderbuffer(
                e.FRAMEBUFFER,
                e.COLOR_ATTACHMENT0 + LI,
                e.RENDERBUFFER,
                UI.__webglColorRenderbuffer[LI],
              ))
            const Bg = g.get(tA[LI]).__webglTexture
            ;(I.bindFramebuffer(e.FRAMEBUFFER, UI.__webglFramebuffer),
              e.framebufferTexture2D(
                e.DRAW_FRAMEBUFFER,
                e.COLOR_ATTACHMENT0 + LI,
                e.TEXTURE_2D,
                Bg,
                0,
              ))
          }
        I.bindFramebuffer(e.DRAW_FRAMEBUFFER, UI.__webglMultisampledFramebuffer)
      } else if (QA.depthBuffer && QA.resolveDepthBuffer === !1 && r) {
        const tA = QA.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT
        e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER, [tA])
      }
    }
  }
  function II(QA) {
    return Math.min(C.maxSamples, QA.samples)
  }
  function pI(QA) {
    const tA = g.get(QA)
    return (
      QA.samples > 0 &&
      A.has("WEBGL_multisampled_render_to_texture") === !0 &&
      tA.__useRenderToTexture !== !1
    )
  }
  function AI(QA) {
    const tA = B.render.frame
    h.get(QA) !== tA && (h.set(QA, tA), QA.update())
  }
  function YI(QA, tA) {
    const FA = QA.colorSpace,
      WA = QA.format,
      jA = QA.type
    return (
      QA.isCompressedTexture === !0 ||
        QA.isVideoTexture === !0 ||
        (FA !== ru &&
          FA !== kl &&
          (ni.getTransfer(FA) === ot
            ? (WA !== lE || jA !== Xo) &&
              console.warn(
                "THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.",
              )
            : console.error("THREE.WebGLTextures: Unsupported texture color space:", FA))),
      tA
    )
  }
  function SI(QA) {
    return (
      typeof HTMLImageElement < "u" && QA instanceof HTMLImageElement
        ? ((s.width = QA.naturalWidth || QA.width), (s.height = QA.naturalHeight || QA.height))
        : typeof VideoFrame < "u" && QA instanceof VideoFrame
          ? ((s.width = QA.displayWidth), (s.height = QA.displayHeight))
          : ((s.width = QA.width), (s.height = QA.height)),
      s
    )
  }
  ;((this.allocateTextureUnit = aA),
    (this.resetTextureUnits = CA),
    (this.setTexture2D = JA),
    (this.setTexture2DArray = yA),
    (this.setTexture3D = LA),
    (this.setTextureCube = nA),
    (this.rebindTextures = sI),
    (this.setupRenderTarget = cI),
    (this.updateRenderTargetMipmap = YA),
    (this.updateMultisampleRenderTarget = hI),
    (this.setupDepthRenderbuffer = ZA),
    (this.setupFrameBufferTexture = kA),
    (this.useMultisampledRTT = pI))
}
function Ab(e, A) {
  function I(g, C = kl) {
    let i
    const B = ni.getTransfer(C)
    if (g === Xo) return e.UNSIGNED_BYTE
    if (g === ZN) return e.UNSIGNED_SHORT_4_4_4_4
    if (g === PN) return e.UNSIGNED_SHORT_5_5_5_1
    if (g === bm) return e.UNSIGNED_INT_5_9_9_9_REV
    if (g === Tm) return e.BYTE
    if (g === xm) return e.SHORT
    if (g === op) return e.UNSIGNED_SHORT
    if (g === _N) return e.INT
    if (g === Zc) return e.UNSIGNED_INT
    if (g === sE) return e.FLOAT
    if (g === KD) return e.HALF_FLOAT
    if (g === Om) return e.ALPHA
    if (g === _m) return e.RGB
    if (g === lE) return e.RGBA
    if (g === Zm) return e.LUMINANCE
    if (g === Pm) return e.LUMINANCE_ALPHA
    if (g === Rf) return e.DEPTH_COMPONENT
    if (g === ND) return e.DEPTH_STENCIL
    if (g === WN) return e.RED
    if (g === UG) return e.RED_INTEGER
    if (g === Wm) return e.RG
    if (g === VN) return e.RG_INTEGER
    if (g === jN) return e.RGBA_INTEGER
    if (g === $0 || g === AG || g === IG || g === gG)
      if (B === ot)
        if (((i = A.get("WEBGL_compressed_texture_s3tc_srgb")), i !== null)) {
          if (g === $0) return i.COMPRESSED_SRGB_S3TC_DXT1_EXT
          if (g === AG) return i.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT
          if (g === IG) return i.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT
          if (g === gG) return i.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
        } else return null
      else if (((i = A.get("WEBGL_compressed_texture_s3tc")), i !== null)) {
        if (g === $0) return i.COMPRESSED_RGB_S3TC_DXT1_EXT
        if (g === AG) return i.COMPRESSED_RGBA_S3TC_DXT1_EXT
        if (g === IG) return i.COMPRESSED_RGBA_S3TC_DXT3_EXT
        if (g === gG) return i.COMPRESSED_RGBA_S3TC_DXT5_EXT
      } else return null
    if (g === VU || g === jU || g === zU || g === XU)
      if (((i = A.get("WEBGL_compressed_texture_pvrtc")), i !== null)) {
        if (g === VU) return i.COMPRESSED_RGB_PVRTC_4BPPV1_IMG
        if (g === jU) return i.COMPRESSED_RGB_PVRTC_2BPPV1_IMG
        if (g === zU) return i.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG
        if (g === XU) return i.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG
      } else return null
    if (g === $U || g === AN || g === IN)
      if (((i = A.get("WEBGL_compressed_texture_etc")), i !== null)) {
        if (g === $U || g === AN) return B === ot ? i.COMPRESSED_SRGB8_ETC2 : i.COMPRESSED_RGB8_ETC2
        if (g === IN)
          return B === ot ? i.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : i.COMPRESSED_RGBA8_ETC2_EAC
      } else return null
    if (
      g === gN ||
      g === CN ||
      g === eN ||
      g === iN ||
      g === tN ||
      g === BN ||
      g === QN ||
      g === oN ||
      g === nN ||
      g === EN ||
      g === aN ||
      g === rN ||
      g === sN ||
      g === lN
    )
      if (((i = A.get("WEBGL_compressed_texture_astc")), i !== null)) {
        if (g === gN)
          return B === ot ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : i.COMPRESSED_RGBA_ASTC_4x4_KHR
        if (g === CN)
          return B === ot ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : i.COMPRESSED_RGBA_ASTC_5x4_KHR
        if (g === eN)
          return B === ot ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : i.COMPRESSED_RGBA_ASTC_5x5_KHR
        if (g === iN)
          return B === ot ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : i.COMPRESSED_RGBA_ASTC_6x5_KHR
        if (g === tN)
          return B === ot ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : i.COMPRESSED_RGBA_ASTC_6x6_KHR
        if (g === BN)
          return B === ot ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : i.COMPRESSED_RGBA_ASTC_8x5_KHR
        if (g === QN)
          return B === ot ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : i.COMPRESSED_RGBA_ASTC_8x6_KHR
        if (g === oN)
          return B === ot ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : i.COMPRESSED_RGBA_ASTC_8x8_KHR
        if (g === nN)
          return B === ot
            ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR
            : i.COMPRESSED_RGBA_ASTC_10x5_KHR
        if (g === EN)
          return B === ot
            ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR
            : i.COMPRESSED_RGBA_ASTC_10x6_KHR
        if (g === aN)
          return B === ot
            ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR
            : i.COMPRESSED_RGBA_ASTC_10x8_KHR
        if (g === rN)
          return B === ot
            ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR
            : i.COMPRESSED_RGBA_ASTC_10x10_KHR
        if (g === sN)
          return B === ot
            ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR
            : i.COMPRESSED_RGBA_ASTC_12x10_KHR
        if (g === lN)
          return B === ot
            ? i.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR
            : i.COMPRESSED_RGBA_ASTC_12x12_KHR
      } else return null
    if (g === CG || g === cN || g === hN)
      if (((i = A.get("EXT_texture_compression_bptc")), i !== null)) {
        if (g === CG)
          return B === ot
            ? i.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT
            : i.COMPRESSED_RGBA_BPTC_UNORM_EXT
        if (g === cN) return i.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT
        if (g === hN) return i.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT
      } else return null
    if (g === Vm || g === uN || g === DN || g === SN)
      if (((i = A.get("EXT_texture_compression_rgtc")), i !== null)) {
        if (g === CG) return i.COMPRESSED_RED_RGTC1_EXT
        if (g === uN) return i.COMPRESSED_SIGNED_RED_RGTC1_EXT
        if (g === DN) return i.COMPRESSED_RED_GREEN_RGTC2_EXT
        if (g === SN) return i.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT
      } else return null
    return g === UD ? e.UNSIGNED_INT_24_8 : e[g] !== void 0 ? e[g] : null
  }
  return { convert: I }
}
class Ib extends PQ {
  constructor(A = []) {
    ;(super(), (this.isArrayCamera = !0), (this.cameras = A))
  }
}
class Iu extends Ci {
  constructor() {
    ;(super(), (this.isGroup = !0), (this.type = "Group"))
  }
}
const l5 = { type: "move" }
class SK {
  constructor() {
    ;((this._targetRay = null), (this._grip = null), (this._hand = null))
  }
  getHandSpace() {
    return (
      this._hand === null &&
        ((this._hand = new Iu()),
        (this._hand.matrixAutoUpdate = !1),
        (this._hand.visible = !1),
        (this._hand.joints = {}),
        (this._hand.inputState = { pinching: !1 })),
      this._hand
    )
  }
  getTargetRaySpace() {
    return (
      this._targetRay === null &&
        ((this._targetRay = new Iu()),
        (this._targetRay.matrixAutoUpdate = !1),
        (this._targetRay.visible = !1),
        (this._targetRay.hasLinearVelocity = !1),
        (this._targetRay.linearVelocity = new wA()),
        (this._targetRay.hasAngularVelocity = !1),
        (this._targetRay.angularVelocity = new wA())),
      this._targetRay
    )
  }
  getGripSpace() {
    return (
      this._grip === null &&
        ((this._grip = new Iu()),
        (this._grip.matrixAutoUpdate = !1),
        (this._grip.visible = !1),
        (this._grip.hasLinearVelocity = !1),
        (this._grip.linearVelocity = new wA()),
        (this._grip.hasAngularVelocity = !1),
        (this._grip.angularVelocity = new wA())),
      this._grip
    )
  }
  dispatchEvent(A) {
    return (
      this._targetRay !== null && this._targetRay.dispatchEvent(A),
      this._grip !== null && this._grip.dispatchEvent(A),
      this._hand !== null && this._hand.dispatchEvent(A),
      this
    )
  }
  connect(A) {
    if (A && A.hand) {
      const I = this._hand
      if (I) for (const g of A.hand.values()) this._getHandJoint(I, g)
    }
    return (this.dispatchEvent({ type: "connected", data: A }), this)
  }
  disconnect(A) {
    return (
      this.dispatchEvent({ type: "disconnected", data: A }),
      this._targetRay !== null && (this._targetRay.visible = !1),
      this._grip !== null && (this._grip.visible = !1),
      this._hand !== null && (this._hand.visible = !1),
      this
    )
  }
  update(A, I, g) {
    let C = null,
      i = null,
      B = null
    const o = this._targetRay,
      r = this._grip,
      s = this._hand
    if (A && I.session.visibilityState !== "visible-blurred") {
      if (s && A.hand) {
        B = !0
        for (const K of A.hand.values()) {
          const R = I.getJointPose(K, g),
            F = this._getHandJoint(s, K)
          ;(R !== null &&
            (F.matrix.fromArray(R.transform.matrix),
            F.matrix.decompose(F.position, F.rotation, F.scale),
            (F.matrixWorldNeedsUpdate = !0),
            (F.jointRadius = R.radius)),
            (F.visible = R !== null))
        }
        const h = s.joints["index-finger-tip"],
          S = s.joints["thumb-tip"],
          d = h.position.distanceTo(S.position),
          w = 0.02,
          M = 5e-3
        s.inputState.pinching && d > w + M
          ? ((s.inputState.pinching = !1),
            this.dispatchEvent({
              type: "pinchend",
              handedness: A.handedness,
              target: this,
            }))
          : !s.inputState.pinching &&
            d <= w - M &&
            ((s.inputState.pinching = !0),
            this.dispatchEvent({
              type: "pinchstart",
              handedness: A.handedness,
              target: this,
            }))
      } else
        r !== null &&
          A.gripSpace &&
          ((i = I.getPose(A.gripSpace, g)),
          i !== null &&
            (r.matrix.fromArray(i.transform.matrix),
            r.matrix.decompose(r.position, r.rotation, r.scale),
            (r.matrixWorldNeedsUpdate = !0),
            i.linearVelocity
              ? ((r.hasLinearVelocity = !0), r.linearVelocity.copy(i.linearVelocity))
              : (r.hasLinearVelocity = !1),
            i.angularVelocity
              ? ((r.hasAngularVelocity = !0), r.angularVelocity.copy(i.angularVelocity))
              : (r.hasAngularVelocity = !1)))
      o !== null &&
        ((C = I.getPose(A.targetRaySpace, g)),
        C === null && i !== null && (C = i),
        C !== null &&
          (o.matrix.fromArray(C.transform.matrix),
          o.matrix.decompose(o.position, o.rotation, o.scale),
          (o.matrixWorldNeedsUpdate = !0),
          C.linearVelocity
            ? ((o.hasLinearVelocity = !0), o.linearVelocity.copy(C.linearVelocity))
            : (o.hasLinearVelocity = !1),
          C.angularVelocity
            ? ((o.hasAngularVelocity = !0), o.angularVelocity.copy(C.angularVelocity))
            : (o.hasAngularVelocity = !1),
          this.dispatchEvent(l5)))
    }
    return (
      o !== null && (o.visible = C !== null),
      r !== null && (r.visible = i !== null),
      s !== null && (s.visible = B !== null),
      this
    )
  }
  // private method
  _getHandJoint(A, I) {
    if (A.joints[I.jointName] === void 0) {
      const g = new Iu()
      ;((g.matrixAutoUpdate = !1), (g.visible = !1), (A.joints[I.jointName] = g), A.add(g))
    }
    return A.joints[I.jointName]
  }
}
const c5 = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`,
  h5 = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`
class u5 {
  constructor() {
    ;((this.texture = null), (this.mesh = null), (this.depthNear = 0), (this.depthFar = 0))
  }
  init(A, I, g) {
    if (this.texture === null) {
      const C = new pt(),
        i = A.properties.get(C)
      ;((i.__webglTexture = I.texture),
        (I.depthNear != g.depthNear || I.depthFar != g.depthFar) &&
          ((this.depthNear = I.depthNear), (this.depthFar = I.depthFar)),
        (this.texture = C))
    }
  }
  getMesh(A) {
    if (this.texture !== null && this.mesh === null) {
      const I = A.cameras[0].viewport,
        g = new VQ({
          vertexShader: c5,
          fragmentShader: h5,
          uniforms: {
            depthColor: { value: this.texture },
            depthWidth: { value: I.z },
            depthHeight: { value: I.w },
          },
        })
      this.mesh = new EB(new su(20, 20), g)
    }
    return this.mesh
  }
  reset() {
    ;((this.texture = null), (this.mesh = null))
  }
  getDepthTexture() {
    return this.texture
  }
}
class D5 extends qr {
  constructor(A, I) {
    super()
    const g = this
    let C = null,
      i = 1,
      B = null,
      o = "local-floor",
      r = 1,
      s = null,
      h = null,
      S = null,
      d = null,
      w = null,
      M = null
    const K = new u5(),
      R = I.getContextAttributes()
    let F = null,
      L = null
    const Y = [],
      H = [],
      V = new ZI()
    let j = null
    const P = new PQ()
    P.viewport = new Xe()
    const AA = new PQ()
    AA.viewport = new Xe()
    const X = [P, AA],
      _ = new Ib()
    let eA = null,
      CA = null
    ;((this.cameraAutoUpdate = !0),
      (this.enabled = !1),
      (this.isPresenting = !1),
      (this.getController = function (DA) {
        let dA = Y[DA]
        return (dA === void 0 && ((dA = new SK()), (Y[DA] = dA)), dA.getTargetRaySpace())
      }),
      (this.getControllerGrip = function (DA) {
        let dA = Y[DA]
        return (dA === void 0 && ((dA = new SK()), (Y[DA] = dA)), dA.getGripSpace())
      }),
      (this.getHand = function (DA) {
        let dA = Y[DA]
        return (dA === void 0 && ((dA = new SK()), (Y[DA] = dA)), dA.getHandSpace())
      }))
    function aA(DA) {
      const dA = H.indexOf(DA.inputSource)
      if (dA === -1) return
      const kA = Y[dA]
      kA !== void 0 &&
        (kA.update(DA.inputSource, DA.frame, s || B),
        kA.dispatchEvent({ type: DA.type, data: DA.inputSource }))
    }
    function lA() {
      ;(C.removeEventListener("select", aA),
        C.removeEventListener("selectstart", aA),
        C.removeEventListener("selectend", aA),
        C.removeEventListener("squeeze", aA),
        C.removeEventListener("squeezestart", aA),
        C.removeEventListener("squeezeend", aA),
        C.removeEventListener("end", lA),
        C.removeEventListener("inputsourceschange", JA))
      for (let DA = 0; DA < Y.length; DA++) {
        const dA = H[DA]
        dA !== null && ((H[DA] = null), Y[DA].disconnect(dA))
      }
      ;((eA = null),
        (CA = null),
        K.reset(),
        A.setRenderTarget(F),
        (w = null),
        (d = null),
        (S = null),
        (C = null),
        (L = null),
        GA.stop(),
        (g.isPresenting = !1),
        A.setPixelRatio(j),
        A.setSize(V.width, V.height, !1),
        g.dispatchEvent({ type: "sessionend" }))
    }
    ;((this.setFramebufferScaleFactor = function (DA) {
      ;((i = DA),
        g.isPresenting === !0 &&
          console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting."))
    }),
      (this.setReferenceSpaceType = function (DA) {
        ;((o = DA),
          g.isPresenting === !0 &&
            console.warn(
              "THREE.WebXRManager: Cannot change reference space type while presenting.",
            ))
      }),
      (this.getReferenceSpace = function () {
        return s || B
      }),
      (this.setReferenceSpace = function (DA) {
        s = DA
      }),
      (this.getBaseLayer = function () {
        return d !== null ? d : w
      }),
      (this.getBinding = function () {
        return S
      }),
      (this.getFrame = function () {
        return M
      }),
      (this.getSession = function () {
        return C
      }),
      (this.setSession = async function (DA) {
        if (((C = DA), C !== null)) {
          if (
            ((F = A.getRenderTarget()),
            C.addEventListener("select", aA),
            C.addEventListener("selectstart", aA),
            C.addEventListener("selectend", aA),
            C.addEventListener("squeeze", aA),
            C.addEventListener("squeezestart", aA),
            C.addEventListener("squeezeend", aA),
            C.addEventListener("end", lA),
            C.addEventListener("inputsourceschange", JA),
            R.xrCompatible !== !0 && (await I.makeXRCompatible()),
            (j = A.getPixelRatio()),
            A.getSize(V),
            C.renderState.layers === void 0)
          ) {
            const dA = {
              antialias: R.antialias,
              alpha: !0,
              depth: R.depth,
              stencil: R.stencil,
              framebufferScaleFactor: i,
            }
            ;((w = new XRWebGLLayer(C, I, dA)),
              C.updateRenderState({ baseLayer: w }),
              A.setPixelRatio(1),
              A.setSize(w.framebufferWidth, w.framebufferHeight, !1),
              (L = new BQ(w.framebufferWidth, w.framebufferHeight, {
                format: lE,
                type: Xo,
                colorSpace: A.outputColorSpace,
                stencilBuffer: R.stencil,
              })))
          } else {
            let dA = null,
              kA = null,
              NA = null
            R.depth &&
              ((NA = R.stencil ? I.DEPTH24_STENCIL8 : I.DEPTH_COMPONENT24),
              (dA = R.stencil ? ND : Rf),
              (kA = R.stencil ? UD : Zc))
            const qA = {
              colorFormat: I.RGBA8,
              depthFormat: NA,
              scaleFactor: i,
            }
            ;((S = new XRWebGLBinding(C, I)),
              (d = S.createProjectionLayer(qA)),
              C.updateRenderState({ layers: [d] }),
              A.setPixelRatio(1),
              A.setSize(d.textureWidth, d.textureHeight, !1),
              (L = new BQ(d.textureWidth, d.textureHeight, {
                format: lE,
                type: Xo,
                depthTexture: new JG(
                  d.textureWidth,
                  d.textureHeight,
                  kA,
                  void 0,
                  void 0,
                  void 0,
                  void 0,
                  void 0,
                  void 0,
                  dA,
                ),
                stencilBuffer: R.stencil,
                colorSpace: A.outputColorSpace,
                samples: R.antialias ? 4 : 0,
                resolveDepthBuffer: d.ignoreDepthValues === !1,
              })))
          }
          ;((L.isXRRenderTarget = !0),
            this.setFoveation(r),
            (s = null),
            (B = await C.requestReferenceSpace(o)),
            GA.setContext(C),
            GA.start(),
            (g.isPresenting = !0),
            g.dispatchEvent({ type: "sessionstart" }))
        }
      }),
      (this.getEnvironmentBlendMode = function () {
        if (C !== null) return C.environmentBlendMode
      }),
      (this.getDepthTexture = function () {
        return K.getDepthTexture()
      }))
    function JA(DA) {
      for (let dA = 0; dA < DA.removed.length; dA++) {
        const kA = DA.removed[dA],
          NA = H.indexOf(kA)
        NA >= 0 && ((H[NA] = null), Y[NA].disconnect(kA))
      }
      for (let dA = 0; dA < DA.added.length; dA++) {
        const kA = DA.added[dA]
        let NA = H.indexOf(kA)
        if (NA === -1) {
          for (let ZA = 0; ZA < Y.length; ZA++)
            if (ZA >= H.length) {
              ;(H.push(kA), (NA = ZA))
              break
            } else if (H[ZA] === null) {
              ;((H[ZA] = kA), (NA = ZA))
              break
            }
          if (NA === -1) break
        }
        const qA = Y[NA]
        qA && qA.connect(kA)
      }
    }
    const yA = new wA(),
      LA = new wA()
    function nA(DA, dA, kA) {
      ;(yA.setFromMatrixPosition(dA.matrixWorld), LA.setFromMatrixPosition(kA.matrixWorld))
      const NA = yA.distanceTo(LA),
        qA = dA.projectionMatrix.elements,
        ZA = kA.projectionMatrix.elements,
        sI = qA[14] / (qA[10] - 1),
        cI = qA[14] / (qA[10] + 1),
        YA = (qA[9] + 1) / qA[5],
        eI = (qA[9] - 1) / qA[5],
        uA = (qA[8] - 1) / qA[0],
        hI = (ZA[8] + 1) / ZA[0],
        II = sI * uA,
        pI = sI * hI,
        AI = NA / (-uA + hI),
        YI = AI * -uA
      if (
        (dA.matrixWorld.decompose(DA.position, DA.quaternion, DA.scale),
        DA.translateX(YI),
        DA.translateZ(AI),
        DA.matrixWorld.compose(DA.position, DA.quaternion, DA.scale),
        DA.matrixWorldInverse.copy(DA.matrixWorld).invert(),
        qA[10] === -1)
      )
        (DA.projectionMatrix.copy(dA.projectionMatrix),
          DA.projectionMatrixInverse.copy(dA.projectionMatrixInverse))
      else {
        const SI = sI + AI,
          QA = cI + AI,
          tA = II - YI,
          FA = pI + (NA - YI),
          WA = ((YA * cI) / QA) * SI,
          jA = ((eI * cI) / QA) * SI
        ;(DA.projectionMatrix.makePerspective(tA, FA, WA, jA, SI, QA),
          DA.projectionMatrixInverse.copy(DA.projectionMatrix).invert())
      }
    }
    function fA(DA, dA) {
      ;(dA === null
        ? DA.matrixWorld.copy(DA.matrix)
        : DA.matrixWorld.multiplyMatrices(dA.matrixWorld, DA.matrix),
        DA.matrixWorldInverse.copy(DA.matrixWorld).invert())
    }
    this.updateCamera = function (DA) {
      if (C === null) return
      let dA = DA.near,
        kA = DA.far
      ;(K.texture !== null &&
        (K.depthNear > 0 && (dA = K.depthNear), K.depthFar > 0 && (kA = K.depthFar)),
        (_.near = AA.near = P.near = dA),
        (_.far = AA.far = P.far = kA),
        (eA !== _.near || CA !== _.far) &&
          (C.updateRenderState({
            depthNear: _.near,
            depthFar: _.far,
          }),
          (eA = _.near),
          (CA = _.far)),
        (P.layers.mask = DA.layers.mask | 2),
        (AA.layers.mask = DA.layers.mask | 4),
        (_.layers.mask = P.layers.mask | AA.layers.mask))
      const NA = DA.parent,
        qA = _.cameras
      fA(_, NA)
      for (let ZA = 0; ZA < qA.length; ZA++) fA(qA[ZA], NA)
      ;(qA.length === 2 ? nA(_, P, AA) : _.projectionMatrix.copy(P.projectionMatrix), sA(DA, _, NA))
    }
    function sA(DA, dA, kA) {
      ;(kA === null
        ? DA.matrix.copy(dA.matrixWorld)
        : (DA.matrix.copy(kA.matrixWorld), DA.matrix.invert(), DA.matrix.multiply(dA.matrixWorld)),
        DA.matrix.decompose(DA.position, DA.quaternion, DA.scale),
        DA.updateMatrixWorld(!0),
        DA.projectionMatrix.copy(dA.projectionMatrix),
        DA.projectionMatrixInverse.copy(dA.projectionMatrixInverse),
        DA.isPerspectiveCamera &&
          ((DA.fov = ap * 2 * Math.atan(1 / DA.projectionMatrix.elements[5])), (DA.zoom = 1)))
    }
    ;((this.getCamera = function () {
      return _
    }),
      (this.getFoveation = function () {
        if (!(d === null && w === null)) return r
      }),
      (this.setFoveation = function (DA) {
        ;((r = DA),
          d !== null && (d.fixedFoveation = DA),
          w !== null && w.fixedFoveation !== void 0 && (w.fixedFoveation = DA))
      }),
      (this.hasDepthSensing = function () {
        return K.texture !== null
      }),
      (this.getDepthSensingMesh = function () {
        return K.getMesh(_)
      }))
    let $ = null
    function EA(DA, dA) {
      if (((h = dA.getViewerPose(s || B)), (M = dA), h !== null)) {
        const kA = h.views
        w !== null && (A.setRenderTargetFramebuffer(L, w.framebuffer), A.setRenderTarget(L))
        let NA = !1
        kA.length !== _.cameras.length && ((_.cameras.length = 0), (NA = !0))
        for (let ZA = 0; ZA < kA.length; ZA++) {
          const sI = kA[ZA]
          let cI = null
          if (w !== null) cI = w.getViewport(sI)
          else {
            const eI = S.getViewSubImage(d, sI)
            ;((cI = eI.viewport),
              ZA === 0 &&
                (A.setRenderTargetTextures(
                  L,
                  eI.colorTexture,
                  d.ignoreDepthValues ? void 0 : eI.depthStencilTexture,
                ),
                A.setRenderTarget(L)))
          }
          let YA = X[ZA]
          ;(YA === void 0 &&
            ((YA = new PQ()), YA.layers.enable(ZA), (YA.viewport = new Xe()), (X[ZA] = YA)),
            YA.matrix.fromArray(sI.transform.matrix),
            YA.matrix.decompose(YA.position, YA.quaternion, YA.scale),
            YA.projectionMatrix.fromArray(sI.projectionMatrix),
            YA.projectionMatrixInverse.copy(YA.projectionMatrix).invert(),
            YA.viewport.set(cI.x, cI.y, cI.width, cI.height),
            ZA === 0 &&
              (_.matrix.copy(YA.matrix), _.matrix.decompose(_.position, _.quaternion, _.scale)),
            NA === !0 && _.cameras.push(YA))
        }
        const qA = C.enabledFeatures
        if (qA && qA.includes("depth-sensing")) {
          const ZA = S.getDepthInformation(kA[0])
          ZA && ZA.isValid && ZA.texture && K.init(A, ZA, C.renderState)
        }
      }
      for (let kA = 0; kA < Y.length; kA++) {
        const NA = H[kA],
          qA = Y[kA]
        NA !== null && qA !== void 0 && qA.update(NA, dA, s || B)
      }
      ;($ && $(DA, dA),
        dA.detectedPlanes && g.dispatchEvent({ type: "planesdetected", data: dA }),
        (M = null))
    }
    const GA = new V2()
    ;(GA.setAnimationLoop(EA),
      (this.setAnimationLoop = function (DA) {
        $ = DA
      }),
      (this.dispose = function () {}))
  }
}
const nf = /* @__PURE__ */ new uE(),
  S5 = /* @__PURE__ */ new RC()
function f5(e, A) {
  function I(R, F) {
    ;(R.matrixAutoUpdate === !0 && R.updateMatrix(), F.value.copy(R.matrix))
  }
  function g(R, F) {
    ;(F.color.getRGB(R.fogColor.value, Z2(e)),
      F.isFog
        ? ((R.fogNear.value = F.near), (R.fogFar.value = F.far))
        : F.isFogExp2 && (R.fogDensity.value = F.density))
  }
  function C(R, F, L, Y, H) {
    F.isMeshBasicMaterial || F.isMeshLambertMaterial
      ? i(R, F)
      : F.isMeshToonMaterial
        ? (i(R, F), S(R, F))
        : F.isMeshPhongMaterial
          ? (i(R, F), h(R, F))
          : F.isMeshStandardMaterial
            ? (i(R, F), d(R, F), F.isMeshPhysicalMaterial && w(R, F, H))
            : F.isMeshMatcapMaterial
              ? (i(R, F), M(R, F))
              : F.isMeshDepthMaterial
                ? i(R, F)
                : F.isMeshDistanceMaterial
                  ? (i(R, F), K(R, F))
                  : F.isMeshNormalMaterial
                    ? i(R, F)
                    : F.isLineBasicMaterial
                      ? (B(R, F), F.isLineDashedMaterial && o(R, F))
                      : F.isPointsMaterial
                        ? r(R, F, L, Y)
                        : F.isSpriteMaterial
                          ? s(R, F)
                          : F.isShadowMaterial
                            ? (R.color.value.copy(F.color), (R.opacity.value = F.opacity))
                            : F.isShaderMaterial && (F.uniformsNeedUpdate = !1)
  }
  function i(R, F) {
    ;((R.opacity.value = F.opacity),
      F.color && R.diffuse.value.copy(F.color),
      F.emissive && R.emissive.value.copy(F.emissive).multiplyScalar(F.emissiveIntensity),
      F.map && ((R.map.value = F.map), I(F.map, R.mapTransform)),
      F.alphaMap && ((R.alphaMap.value = F.alphaMap), I(F.alphaMap, R.alphaMapTransform)),
      F.bumpMap &&
        ((R.bumpMap.value = F.bumpMap),
        I(F.bumpMap, R.bumpMapTransform),
        (R.bumpScale.value = F.bumpScale),
        F.side === WQ && (R.bumpScale.value *= -1)),
      F.normalMap &&
        ((R.normalMap.value = F.normalMap),
        I(F.normalMap, R.normalMapTransform),
        R.normalScale.value.copy(F.normalScale),
        F.side === WQ && R.normalScale.value.negate()),
      F.displacementMap &&
        ((R.displacementMap.value = F.displacementMap),
        I(F.displacementMap, R.displacementMapTransform),
        (R.displacementScale.value = F.displacementScale),
        (R.displacementBias.value = F.displacementBias)),
      F.emissiveMap &&
        ((R.emissiveMap.value = F.emissiveMap), I(F.emissiveMap, R.emissiveMapTransform)),
      F.specularMap &&
        ((R.specularMap.value = F.specularMap), I(F.specularMap, R.specularMapTransform)),
      F.alphaTest > 0 && (R.alphaTest.value = F.alphaTest))
    const L = A.get(F),
      Y = L.envMap,
      H = L.envMapRotation
    ;(Y &&
      ((R.envMap.value = Y),
      nf.copy(H),
      (nf.x *= -1),
      (nf.y *= -1),
      (nf.z *= -1),
      Y.isCubeTexture && Y.isRenderTargetTexture === !1 && ((nf.y *= -1), (nf.z *= -1)),
      R.envMapRotation.value.setFromMatrix4(S5.makeRotationFromEuler(nf)),
      (R.flipEnvMap.value = Y.isCubeTexture && Y.isRenderTargetTexture === !1 ? -1 : 1),
      (R.reflectivity.value = F.reflectivity),
      (R.ior.value = F.ior),
      (R.refractionRatio.value = F.refractionRatio)),
      F.lightMap &&
        ((R.lightMap.value = F.lightMap),
        (R.lightMapIntensity.value = F.lightMapIntensity),
        I(F.lightMap, R.lightMapTransform)),
      F.aoMap &&
        ((R.aoMap.value = F.aoMap),
        (R.aoMapIntensity.value = F.aoMapIntensity),
        I(F.aoMap, R.aoMapTransform)))
  }
  function B(R, F) {
    ;(R.diffuse.value.copy(F.color),
      (R.opacity.value = F.opacity),
      F.map && ((R.map.value = F.map), I(F.map, R.mapTransform)))
  }
  function o(R, F) {
    ;((R.dashSize.value = F.dashSize),
      (R.totalSize.value = F.dashSize + F.gapSize),
      (R.scale.value = F.scale))
  }
  function r(R, F, L, Y) {
    ;(R.diffuse.value.copy(F.color),
      (R.opacity.value = F.opacity),
      (R.size.value = F.size * L),
      (R.scale.value = Y * 0.5),
      F.map && ((R.map.value = F.map), I(F.map, R.uvTransform)),
      F.alphaMap && ((R.alphaMap.value = F.alphaMap), I(F.alphaMap, R.alphaMapTransform)),
      F.alphaTest > 0 && (R.alphaTest.value = F.alphaTest))
  }
  function s(R, F) {
    ;(R.diffuse.value.copy(F.color),
      (R.opacity.value = F.opacity),
      (R.rotation.value = F.rotation),
      F.map && ((R.map.value = F.map), I(F.map, R.mapTransform)),
      F.alphaMap && ((R.alphaMap.value = F.alphaMap), I(F.alphaMap, R.alphaMapTransform)),
      F.alphaTest > 0 && (R.alphaTest.value = F.alphaTest))
  }
  function h(R, F) {
    ;(R.specular.value.copy(F.specular), (R.shininess.value = Math.max(F.shininess, 1e-4)))
  }
  function S(R, F) {
    F.gradientMap && (R.gradientMap.value = F.gradientMap)
  }
  function d(R, F) {
    ;((R.metalness.value = F.metalness),
      F.metalnessMap &&
        ((R.metalnessMap.value = F.metalnessMap), I(F.metalnessMap, R.metalnessMapTransform)),
      (R.roughness.value = F.roughness),
      F.roughnessMap &&
        ((R.roughnessMap.value = F.roughnessMap), I(F.roughnessMap, R.roughnessMapTransform)),
      F.envMap && (R.envMapIntensity.value = F.envMapIntensity))
  }
  function w(R, F, L) {
    ;((R.ior.value = F.ior),
      F.sheen > 0 &&
        (R.sheenColor.value.copy(F.sheenColor).multiplyScalar(F.sheen),
        (R.sheenRoughness.value = F.sheenRoughness),
        F.sheenColorMap &&
          ((R.sheenColorMap.value = F.sheenColorMap), I(F.sheenColorMap, R.sheenColorMapTransform)),
        F.sheenRoughnessMap &&
          ((R.sheenRoughnessMap.value = F.sheenRoughnessMap),
          I(F.sheenRoughnessMap, R.sheenRoughnessMapTransform))),
      F.clearcoat > 0 &&
        ((R.clearcoat.value = F.clearcoat),
        (R.clearcoatRoughness.value = F.clearcoatRoughness),
        F.clearcoatMap &&
          ((R.clearcoatMap.value = F.clearcoatMap), I(F.clearcoatMap, R.clearcoatMapTransform)),
        F.clearcoatRoughnessMap &&
          ((R.clearcoatRoughnessMap.value = F.clearcoatRoughnessMap),
          I(F.clearcoatRoughnessMap, R.clearcoatRoughnessMapTransform)),
        F.clearcoatNormalMap &&
          ((R.clearcoatNormalMap.value = F.clearcoatNormalMap),
          I(F.clearcoatNormalMap, R.clearcoatNormalMapTransform),
          R.clearcoatNormalScale.value.copy(F.clearcoatNormalScale),
          F.side === WQ && R.clearcoatNormalScale.value.negate())),
      F.dispersion > 0 && (R.dispersion.value = F.dispersion),
      F.iridescence > 0 &&
        ((R.iridescence.value = F.iridescence),
        (R.iridescenceIOR.value = F.iridescenceIOR),
        (R.iridescenceThicknessMinimum.value = F.iridescenceThicknessRange[0]),
        (R.iridescenceThicknessMaximum.value = F.iridescenceThicknessRange[1]),
        F.iridescenceMap &&
          ((R.iridescenceMap.value = F.iridescenceMap),
          I(F.iridescenceMap, R.iridescenceMapTransform)),
        F.iridescenceThicknessMap &&
          ((R.iridescenceThicknessMap.value = F.iridescenceThicknessMap),
          I(F.iridescenceThicknessMap, R.iridescenceThicknessMapTransform))),
      F.transmission > 0 &&
        ((R.transmission.value = F.transmission),
        (R.transmissionSamplerMap.value = L.texture),
        R.transmissionSamplerSize.value.set(L.width, L.height),
        F.transmissionMap &&
          ((R.transmissionMap.value = F.transmissionMap),
          I(F.transmissionMap, R.transmissionMapTransform)),
        (R.thickness.value = F.thickness),
        F.thicknessMap &&
          ((R.thicknessMap.value = F.thicknessMap), I(F.thicknessMap, R.thicknessMapTransform)),
        (R.attenuationDistance.value = F.attenuationDistance),
        R.attenuationColor.value.copy(F.attenuationColor)),
      F.anisotropy > 0 &&
        (R.anisotropyVector.value.set(
          F.anisotropy * Math.cos(F.anisotropyRotation),
          F.anisotropy * Math.sin(F.anisotropyRotation),
        ),
        F.anisotropyMap &&
          ((R.anisotropyMap.value = F.anisotropyMap),
          I(F.anisotropyMap, R.anisotropyMapTransform))),
      (R.specularIntensity.value = F.specularIntensity),
      R.specularColor.value.copy(F.specularColor),
      F.specularColorMap &&
        ((R.specularColorMap.value = F.specularColorMap),
        I(F.specularColorMap, R.specularColorMapTransform)),
      F.specularIntensityMap &&
        ((R.specularIntensityMap.value = F.specularIntensityMap),
        I(F.specularIntensityMap, R.specularIntensityMapTransform)))
  }
  function M(R, F) {
    F.matcap && (R.matcap.value = F.matcap)
  }
  function K(R, F) {
    const L = A.get(F).light
    ;(R.referencePosition.value.setFromMatrixPosition(L.matrixWorld),
      (R.nearDistance.value = L.shadow.camera.near),
      (R.farDistance.value = L.shadow.camera.far))
  }
  return {
    refreshFogUniforms: g,
    refreshMaterialUniforms: C,
  }
}
function d5(e, A, I, g) {
  let C = {},
    i = {},
    B = []
  const o = e.getParameter(e.MAX_UNIFORM_BUFFER_BINDINGS)
  function r(L, Y) {
    const H = Y.program
    g.uniformBlockBinding(L, H)
  }
  function s(L, Y) {
    let H = C[L.id]
    H === void 0 && (M(L), (H = h(L)), (C[L.id] = H), L.addEventListener("dispose", R))
    const V = Y.program
    g.updateUBOMapping(L, V)
    const j = A.render.frame
    i[L.id] !== j && (d(L), (i[L.id] = j))
  }
  function h(L) {
    const Y = S()
    L.__bindingPointIndex = Y
    const H = e.createBuffer(),
      V = L.__size,
      j = L.usage
    return (
      e.bindBuffer(e.UNIFORM_BUFFER, H),
      e.bufferData(e.UNIFORM_BUFFER, V, j),
      e.bindBuffer(e.UNIFORM_BUFFER, null),
      e.bindBufferBase(e.UNIFORM_BUFFER, Y, H),
      H
    )
  }
  function S() {
    for (let L = 0; L < o; L++) if (B.indexOf(L) === -1) return (B.push(L), L)
    return (
      console.error(
        "THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.",
      ),
      0
    )
  }
  function d(L) {
    const Y = C[L.id],
      H = L.uniforms,
      V = L.__cache
    e.bindBuffer(e.UNIFORM_BUFFER, Y)
    for (let j = 0, P = H.length; j < P; j++) {
      const AA = Array.isArray(H[j]) ? H[j] : [H[j]]
      for (let X = 0, _ = AA.length; X < _; X++) {
        const eA = AA[X]
        if (w(eA, j, X, V) === !0) {
          const CA = eA.__offset,
            aA = Array.isArray(eA.value) ? eA.value : [eA.value]
          let lA = 0
          for (let JA = 0; JA < aA.length; JA++) {
            const yA = aA[JA],
              LA = K(yA)
            typeof yA == "number" || typeof yA == "boolean"
              ? ((eA.__data[0] = yA), e.bufferSubData(e.UNIFORM_BUFFER, CA + lA, eA.__data))
              : yA.isMatrix3
                ? ((eA.__data[0] = yA.elements[0]),
                  (eA.__data[1] = yA.elements[1]),
                  (eA.__data[2] = yA.elements[2]),
                  (eA.__data[3] = 0),
                  (eA.__data[4] = yA.elements[3]),
                  (eA.__data[5] = yA.elements[4]),
                  (eA.__data[6] = yA.elements[5]),
                  (eA.__data[7] = 0),
                  (eA.__data[8] = yA.elements[6]),
                  (eA.__data[9] = yA.elements[7]),
                  (eA.__data[10] = yA.elements[8]),
                  (eA.__data[11] = 0))
                : (yA.toArray(eA.__data, lA), (lA += LA.storage / Float32Array.BYTES_PER_ELEMENT))
          }
          e.bufferSubData(e.UNIFORM_BUFFER, CA, eA.__data)
        }
      }
    }
    e.bindBuffer(e.UNIFORM_BUFFER, null)
  }
  function w(L, Y, H, V) {
    const j = L.value,
      P = Y + "_" + H
    if (V[P] === void 0)
      return (typeof j == "number" || typeof j == "boolean" ? (V[P] = j) : (V[P] = j.clone()), !0)
    {
      const AA = V[P]
      if (typeof j == "number" || typeof j == "boolean") {
        if (AA !== j) return ((V[P] = j), !0)
      } else if (AA.equals(j) === !1) return (AA.copy(j), !0)
    }
    return !1
  }
  function M(L) {
    const Y = L.uniforms
    let H = 0
    const V = 16
    for (let P = 0, AA = Y.length; P < AA; P++) {
      const X = Array.isArray(Y[P]) ? Y[P] : [Y[P]]
      for (let _ = 0, eA = X.length; _ < eA; _++) {
        const CA = X[_],
          aA = Array.isArray(CA.value) ? CA.value : [CA.value]
        for (let lA = 0, JA = aA.length; lA < JA; lA++) {
          const yA = aA[lA],
            LA = K(yA),
            nA = H % V,
            fA = nA % LA.boundary,
            sA = nA + fA
          ;((H += fA),
            sA !== 0 && V - sA < LA.storage && (H += V - sA),
            (CA.__data = new Float32Array(LA.storage / Float32Array.BYTES_PER_ELEMENT)),
            (CA.__offset = H),
            (H += LA.storage))
        }
      }
    }
    const j = H % V
    return (j > 0 && (H += V - j), (L.__size = H), (L.__cache = {}), this)
  }
  function K(L) {
    const Y = {
      boundary: 0,
      // bytes
      storage: 0,
      // bytes
    }
    return (
      typeof L == "number" || typeof L == "boolean"
        ? ((Y.boundary = 4), (Y.storage = 4))
        : L.isVector2
          ? ((Y.boundary = 8), (Y.storage = 8))
          : L.isVector3 || L.isColor
            ? ((Y.boundary = 16), (Y.storage = 12))
            : L.isVector4
              ? ((Y.boundary = 16), (Y.storage = 16))
              : L.isMatrix3
                ? ((Y.boundary = 48), (Y.storage = 48))
                : L.isMatrix4
                  ? ((Y.boundary = 64), (Y.storage = 64))
                  : L.isTexture
                    ? console.warn(
                        "THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.",
                      )
                    : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", L),
      Y
    )
  }
  function R(L) {
    const Y = L.target
    Y.removeEventListener("dispose", R)
    const H = B.indexOf(Y.__bindingPointIndex)
    ;(B.splice(H, 1), e.deleteBuffer(C[Y.id]), delete C[Y.id], delete i[Y.id])
  }
  function F() {
    for (const L in C) e.deleteBuffer(C[L])
    ;((B = []), (C = {}), (i = {}))
  }
  return {
    bind: r,
    update: s,
    dispose: F,
  }
}
class gb {
  constructor(A = {}) {
    const {
      canvas: I = x2(),
      context: g = null,
      depth: C = !0,
      stencil: i = !1,
      alpha: B = !1,
      antialias: o = !1,
      premultipliedAlpha: r = !0,
      preserveDrawingBuffer: s = !1,
      powerPreference: h = "default",
      failIfMajorPerformanceCaveat: S = !1,
      reverseDepthBuffer: d = !1,
    } = A
    this.isWebGLRenderer = !0
    let w
    if (g !== null) {
      if (typeof WebGLRenderingContext < "u" && g instanceof WebGLRenderingContext)
        throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.")
      w = g.getContextAttributes().alpha
    } else w = B
    const M = new Uint32Array(4),
      K = new Int32Array(4)
    let R = null,
      F = null
    const L = [],
      Y = []
    ;((this.domElement = I),
      (this.debug = {
        /**
         * Enables error checking and reporting when shader programs are being compiled
         * @type {boolean}
         */
        checkShaderErrors: !0,
        /**
         * Callback for custom error reporting.
         * @type {?Function}
         */
        onShaderError: null,
      }),
      (this.autoClear = !0),
      (this.autoClearColor = !0),
      (this.autoClearDepth = !0),
      (this.autoClearStencil = !0),
      (this.sortObjects = !0),
      (this.clippingPlanes = []),
      (this.localClippingEnabled = !1),
      (this._outputColorSpace = zi),
      (this.toneMapping = Ms),
      (this.toneMappingExposure = 1))
    const H = this
    let V = !1,
      j = 0,
      P = 0,
      AA = null,
      X = -1,
      _ = null
    const eA = new Xe(),
      CA = new Xe()
    let aA = null
    const lA = new Mg(0)
    let JA = 0,
      yA = I.width,
      LA = I.height,
      nA = 1,
      fA = null,
      sA = null
    const $ = new Xe(0, 0, yA, LA),
      EA = new Xe(0, 0, yA, LA)
    let GA = !1
    const DA = new RG()
    let dA = !1,
      kA = !1
    const NA = new RC(),
      qA = new RC(),
      ZA = new wA(),
      sI = new Xe(),
      cI = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: !0 }
    let YA = !1
    function eI() {
      return AA === null ? nA : 1
    }
    let uA = g
    function hI(rA, _A) {
      return I.getContext(rA, _A)
    }
    try {
      const rA = {
        alpha: !0,
        depth: C,
        stencil: i,
        antialias: o,
        premultipliedAlpha: r,
        preserveDrawingBuffer: s,
        powerPreference: h,
        failIfMajorPerformanceCaveat: S,
      }
      if (
        ("setAttribute" in I && I.setAttribute("data-engine", `three.js r${Wf}`),
        I.addEventListener("webglcontextlost", iI, !1),
        I.addEventListener("webglcontextrestored", zI, !1),
        I.addEventListener("webglcontextcreationerror", qI, !1),
        uA === null)
      ) {
        const _A = "webgl2"
        if (((uA = hI(_A, rA)), uA === null))
          throw hI(_A)
            ? new Error("Error creating WebGL context with your selected attributes.")
            : new Error("Error creating WebGL context.")
      }
    } catch (rA) {
      throw (console.error("THREE.WebGLRenderer: " + rA.message), rA)
    }
    let II,
      pI,
      AI,
      YI,
      SI,
      QA,
      tA,
      FA,
      WA,
      jA,
      nI,
      UI,
      GI,
      LI,
      Bg,
      MA,
      OA,
      aI,
      RI,
      VA,
      ag,
      XI,
      $I,
      SA
    function NI() {
      ;((II = new MW(uA)),
        II.init(),
        (XI = new Ab(uA, II)),
        (pI = new dW(uA, II, A, XI)),
        (AI = new Q5(uA, II)),
        pI.reverseDepthBuffer && d && AI.buffers.depth.setReversed(!0),
        (YI = new FW(uA)),
        (SI = new VV()),
        (QA = new s5(uA, II, AI, SI, pI, XI, YI)),
        (tA = new pW(H)),
        (FA = new kW(H)),
        (WA = new YZ(uA)),
        ($I = new SW(uA, WA)),
        (jA = new UW(uA, WA, YI, $I)),
        (nI = new JW(uA, jA, WA, YI)),
        (RI = new RW(uA, pI, QA)),
        (MA = new yW(SI)),
        (UI = new WV(H, tA, FA, II, pI, $I, MA)),
        (GI = new f5(H, SI)),
        (LI = new zV()),
        (Bg = new C5(II)),
        (aI = new DW(H, tA, FA, AI, nI, w, r)),
        (OA = new t5(H, nI, pI)),
        (SA = new d5(uA, YI, pI, AI)),
        (VA = new fW(uA, II, YI)),
        (ag = new NW(uA, II, YI)),
        (YI.programs = UI.programs),
        (H.capabilities = pI),
        (H.extensions = II),
        (H.properties = SI),
        (H.renderLists = LI),
        (H.shadowMap = OA),
        (H.state = AI),
        (H.info = YI))
    }
    NI()
    const HA = new D5(H, uA)
    ;((this.xr = HA),
      (this.getContext = function () {
        return uA
      }),
      (this.getContextAttributes = function () {
        return uA.getContextAttributes()
      }),
      (this.forceContextLoss = function () {
        const rA = II.get("WEBGL_lose_context")
        rA && rA.loseContext()
      }),
      (this.forceContextRestore = function () {
        const rA = II.get("WEBGL_lose_context")
        rA && rA.restoreContext()
      }),
      (this.getPixelRatio = function () {
        return nA
      }),
      (this.setPixelRatio = function (rA) {
        rA !== void 0 && ((nA = rA), this.setSize(yA, LA, !1))
      }),
      (this.getSize = function (rA) {
        return rA.set(yA, LA)
      }),
      (this.setSize = function (rA, _A, oI = !0) {
        if (HA.isPresenting) {
          console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.")
          return
        }
        ;((yA = rA),
          (LA = _A),
          (I.width = Math.floor(rA * nA)),
          (I.height = Math.floor(_A * nA)),
          oI === !0 && ((I.style.width = rA + "px"), (I.style.height = _A + "px")),
          this.setViewport(0, 0, rA, _A))
      }),
      (this.getDrawingBufferSize = function (rA) {
        return rA.set(yA * nA, LA * nA).floor()
      }),
      (this.setDrawingBufferSize = function (rA, _A, oI) {
        ;((yA = rA),
          (LA = _A),
          (nA = oI),
          (I.width = Math.floor(rA * oI)),
          (I.height = Math.floor(_A * oI)),
          this.setViewport(0, 0, rA, _A))
      }),
      (this.getCurrentViewport = function (rA) {
        return rA.copy(eA)
      }),
      (this.getViewport = function (rA) {
        return rA.copy($)
      }),
      (this.setViewport = function (rA, _A, oI, QI) {
        ;(rA.isVector4 ? $.set(rA.x, rA.y, rA.z, rA.w) : $.set(rA, _A, oI, QI),
          AI.viewport(eA.copy($).multiplyScalar(nA).round()))
      }),
      (this.getScissor = function (rA) {
        return rA.copy(EA)
      }),
      (this.setScissor = function (rA, _A, oI, QI) {
        ;(rA.isVector4 ? EA.set(rA.x, rA.y, rA.z, rA.w) : EA.set(rA, _A, oI, QI),
          AI.scissor(CA.copy(EA).multiplyScalar(nA).round()))
      }),
      (this.getScissorTest = function () {
        return GA
      }),
      (this.setScissorTest = function (rA) {
        AI.setScissorTest((GA = rA))
      }),
      (this.setOpaqueSort = function (rA) {
        fA = rA
      }),
      (this.setTransparentSort = function (rA) {
        sA = rA
      }),
      (this.getClearColor = function (rA) {
        return rA.copy(aI.getClearColor())
      }),
      (this.setClearColor = function () {
        aI.setClearColor.apply(aI, arguments)
      }),
      (this.getClearAlpha = function () {
        return aI.getClearAlpha()
      }),
      (this.setClearAlpha = function () {
        aI.setClearAlpha.apply(aI, arguments)
      }),
      (this.clear = function (rA = !0, _A = !0, oI = !0) {
        let QI = 0
        if (rA) {
          let PA = !1
          if (AA !== null) {
            const gg = AA.texture.format
            PA = gg === jN || gg === VN || gg === UG
          }
          if (PA) {
            const gg = AA.texture.type,
              EI = gg === Xo || gg === Zc || gg === op || gg === UD || gg === ZN || gg === PN,
              hg = aI.getClearColor(),
              yg = aI.getClearAlpha(),
              rg = hg.r,
              eC = hg.g,
              Rg = hg.b
            EI
              ? ((M[0] = rg),
                (M[1] = eC),
                (M[2] = Rg),
                (M[3] = yg),
                uA.clearBufferuiv(uA.COLOR, 0, M))
              : ((K[0] = rg),
                (K[1] = eC),
                (K[2] = Rg),
                (K[3] = yg),
                uA.clearBufferiv(uA.COLOR, 0, K))
          } else QI |= uA.COLOR_BUFFER_BIT
        }
        ;(_A && (QI |= uA.DEPTH_BUFFER_BIT),
          oI && ((QI |= uA.STENCIL_BUFFER_BIT), this.state.buffers.stencil.setMask(4294967295)),
          uA.clear(QI))
      }),
      (this.clearColor = function () {
        this.clear(!0, !1, !1)
      }),
      (this.clearDepth = function () {
        this.clear(!1, !0, !1)
      }),
      (this.clearStencil = function () {
        this.clear(!1, !1, !0)
      }),
      (this.dispose = function () {
        ;(I.removeEventListener("webglcontextlost", iI, !1),
          I.removeEventListener("webglcontextrestored", zI, !1),
          I.removeEventListener("webglcontextcreationerror", qI, !1),
          LI.dispose(),
          Bg.dispose(),
          SI.dispose(),
          tA.dispose(),
          FA.dispose(),
          nI.dispose(),
          $I.dispose(),
          SA.dispose(),
          UI.dispose(),
          HA.dispose(),
          HA.removeEventListener("sessionstart", zC),
          HA.removeEventListener("sessionend", Ee),
          ei.stop())
      }))
    function iI(rA) {
      ;(rA.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), (V = !0))
    }
    function zI() {
      ;(console.log("THREE.WebGLRenderer: Context Restored."), (V = !1))
      const rA = YI.autoReset,
        _A = OA.enabled,
        oI = OA.autoUpdate,
        QI = OA.needsUpdate,
        PA = OA.type
      ;(NI(),
        (YI.autoReset = rA),
        (OA.enabled = _A),
        (OA.autoUpdate = oI),
        (OA.needsUpdate = QI),
        (OA.type = PA))
    }
    function qI(rA) {
      console.error(
        "THREE.WebGLRenderer: A WebGL context could not be created. Reason: ",
        rA.statusMessage,
      )
    }
    function dg(rA) {
      const _A = rA.target
      ;(_A.removeEventListener("dispose", dg), $g(_A))
    }
    function $g(rA) {
      ;(Qg(rA), SI.remove(rA))
    }
    function Qg(rA) {
      const _A = SI.get(rA).programs
      _A !== void 0 &&
        (_A.forEach(function (oI) {
          UI.releaseProgram(oI)
        }),
        rA.isShaderMaterial && UI.releaseShaderCache(rA))
    }
    this.renderBufferDirect = function (rA, _A, oI, QI, PA, gg) {
      _A === null && (_A = cI)
      const EI = PA.isMesh && PA.matrixWorld.determinant() < 0,
        hg = OC(rA, _A, oI, QI, PA)
      AI.setMaterial(QI, EI)
      let yg = oI.index,
        rg = 1
      if (QI.wireframe === !0) {
        if (((yg = jA.getWireframeAttribute(oI)), yg === void 0)) return
        rg = 2
      }
      const eC = oI.drawRange,
        Rg = oI.attributes.position
      let pC = eC.start * rg,
        wC = (eC.start + eC.count) * rg
      ;(gg !== null &&
        ((pC = Math.max(pC, gg.start * rg)), (wC = Math.min(wC, (gg.start + gg.count) * rg))),
        yg !== null
          ? ((pC = Math.max(pC, 0)), (wC = Math.min(wC, yg.count)))
          : Rg != null && ((pC = Math.max(pC, 0)), (wC = Math.min(wC, Rg.count))))
      const mg = wC - pC
      if (mg < 0 || mg === 1 / 0) return
      $I.setup(PA, QI, hg, oI, yg)
      let UC,
        iC = VA
      if ((yg !== null && ((UC = WA.get(yg)), (iC = ag), iC.setIndex(UC)), PA.isMesh))
        QI.wireframe === !0
          ? (AI.setLineWidth(QI.wireframeLinewidth * eI()), iC.setMode(uA.LINES))
          : iC.setMode(uA.TRIANGLES)
      else if (PA.isLine) {
        let Gg = QI.linewidth
        ;(Gg === void 0 && (Gg = 1),
          AI.setLineWidth(Gg * eI()),
          PA.isLineSegments
            ? iC.setMode(uA.LINES)
            : PA.isLineLoop
              ? iC.setMode(uA.LINE_LOOP)
              : iC.setMode(uA.LINE_STRIP))
      } else PA.isPoints ? iC.setMode(uA.POINTS) : PA.isSprite && iC.setMode(uA.TRIANGLES)
      if (PA.isBatchedMesh)
        if (PA._multiDrawInstances !== null)
          iC.renderMultiDrawInstances(
            PA._multiDrawStarts,
            PA._multiDrawCounts,
            PA._multiDrawCount,
            PA._multiDrawInstances,
          )
        else if (II.get("WEBGL_multi_draw"))
          iC.renderMultiDraw(PA._multiDrawStarts, PA._multiDrawCounts, PA._multiDrawCount)
        else {
          const Gg = PA._multiDrawStarts,
            _C = PA._multiDrawCounts,
            vC = PA._multiDrawCount,
            ii = yg ? WA.get(yg).bytesPerElement : 1,
            qe = SI.get(QI).currentProgram.getUniforms()
          for (let pe = 0; pe < vC; pe++)
            (qe.setValue(uA, "_gl_DrawID", pe), iC.render(Gg[pe] / ii, _C[pe]))
        }
      else if (PA.isInstancedMesh) iC.renderInstances(pC, mg, PA.count)
      else if (oI.isInstancedBufferGeometry) {
        const Gg = oI._maxInstanceCount !== void 0 ? oI._maxInstanceCount : 1 / 0,
          _C = Math.min(oI.instanceCount, Gg)
        iC.renderInstances(pC, mg, _C)
      } else iC.render(pC, mg)
    }
    function Fg(rA, _A, oI) {
      rA.transparent === !0 && rA.side === rE && rA.forceSinglePass === !1
        ? ((rA.side = WQ),
          (rA.needsUpdate = !0),
          TI(rA, _A, oI),
          (rA.side = Us),
          (rA.needsUpdate = !0),
          TI(rA, _A, oI),
          (rA.side = rE))
        : TI(rA, _A, oI)
    }
    ;((this.compile = function (rA, _A, oI = null) {
      ;(oI === null && (oI = rA),
        (F = Bg.get(oI)),
        F.init(_A),
        Y.push(F),
        oI.traverseVisible(function (PA) {
          PA.isLight &&
            PA.layers.test(_A.layers) &&
            (F.pushLight(PA), PA.castShadow && F.pushShadow(PA))
        }),
        rA !== oI &&
          rA.traverseVisible(function (PA) {
            PA.isLight &&
              PA.layers.test(_A.layers) &&
              (F.pushLight(PA), PA.castShadow && F.pushShadow(PA))
          }),
        F.setupLights())
      const QI = /* @__PURE__ */ new Set()
      return (
        rA.traverse(function (PA) {
          if (!(PA.isMesh || PA.isPoints || PA.isLine || PA.isSprite)) return
          const gg = PA.material
          if (gg)
            if (Array.isArray(gg))
              for (let EI = 0; EI < gg.length; EI++) {
                const hg = gg[EI]
                ;(Fg(hg, oI, PA), QI.add(hg))
              }
            else (Fg(gg, oI, PA), QI.add(gg))
        }),
        Y.pop(),
        (F = null),
        QI
      )
    }),
      (this.compileAsync = function (rA, _A, oI = null) {
        const QI = this.compile(rA, _A, oI)
        return new Promise((PA) => {
          function gg() {
            if (
              (QI.forEach(function (EI) {
                SI.get(EI).currentProgram.isReady() && QI.delete(EI)
              }),
              QI.size === 0)
            ) {
              PA(rA)
              return
            }
            setTimeout(gg, 10)
          }
          II.get("KHR_parallel_shader_compile") !== null ? gg() : setTimeout(gg, 10)
        })
      }))
    let jC = null
    function mC(rA) {
      jC && jC(rA)
    }
    function zC() {
      ei.stop()
    }
    function Ee() {
      ei.start()
    }
    const ei = new V2()
    ;(ei.setAnimationLoop(mC),
      typeof self < "u" && ei.setContext(self),
      (this.setAnimationLoop = function (rA) {
        ;((jC = rA), HA.setAnimationLoop(rA), rA === null ? ei.stop() : ei.start())
      }),
      HA.addEventListener("sessionstart", zC),
      HA.addEventListener("sessionend", Ee),
      (this.render = function (rA, _A) {
        if (_A !== void 0 && _A.isCamera !== !0) {
          console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.")
          return
        }
        if (V === !0) return
        if (
          (rA.matrixWorldAutoUpdate === !0 && rA.updateMatrixWorld(),
          _A.parent === null && _A.matrixWorldAutoUpdate === !0 && _A.updateMatrixWorld(),
          HA.enabled === !0 &&
            HA.isPresenting === !0 &&
            (HA.cameraAutoUpdate === !0 && HA.updateCamera(_A), (_A = HA.getCamera())),
          rA.isScene === !0 && rA.onBeforeRender(H, rA, _A, AA),
          (F = Bg.get(rA, Y.length)),
          F.init(_A),
          Y.push(F),
          qA.multiplyMatrices(_A.projectionMatrix, _A.matrixWorldInverse),
          DA.setFromProjectionMatrix(qA),
          (kA = this.localClippingEnabled),
          (dA = MA.init(this.clippingPlanes, kA)),
          (R = LI.get(rA, L.length)),
          R.init(),
          L.push(R),
          HA.enabled === !0 && HA.isPresenting === !0)
        ) {
          const gg = H.xr.getDepthSensingMesh()
          gg !== null && fe(gg, _A, -1 / 0, H.sortObjects)
        }
        ;(fe(rA, _A, 0, H.sortObjects),
          R.finish(),
          H.sortObjects === !0 && R.sort(fA, sA),
          (YA = HA.enabled === !1 || HA.isPresenting === !1 || HA.hasDepthSensing() === !1),
          YA && aI.addToRenderList(R, rA),
          this.info.render.frame++,
          dA === !0 && MA.beginShadows())
        const oI = F.state.shadowsArray
        ;(OA.render(oI, rA, _A),
          dA === !0 && MA.endShadows(),
          this.info.autoReset === !0 && this.info.reset())
        const QI = R.opaque,
          PA = R.transmissive
        if ((F.setupLights(), _A.isArrayCamera)) {
          const gg = _A.cameras
          if (PA.length > 0)
            for (let EI = 0, hg = gg.length; EI < hg; EI++) {
              const yg = gg[EI]
              vi(QI, PA, rA, yg)
            }
          YA && aI.render(rA)
          for (let EI = 0, hg = gg.length; EI < hg; EI++) {
            const yg = gg[EI]
            Ei(R, rA, yg, yg.viewport)
          }
        } else (PA.length > 0 && vi(QI, PA, rA, _A), YA && aI.render(rA), Ei(R, rA, _A))
        ;(AA !== null && (QA.updateMultisampleRenderTarget(AA), QA.updateRenderTargetMipmap(AA)),
          rA.isScene === !0 && rA.onAfterRender(H, rA, _A),
          $I.resetDefaultState(),
          (X = -1),
          (_ = null),
          Y.pop(),
          Y.length > 0
            ? ((F = Y[Y.length - 1]),
              dA === !0 && MA.setGlobalState(H.clippingPlanes, F.state.camera))
            : (F = null),
          L.pop(),
          L.length > 0 ? (R = L[L.length - 1]) : (R = null))
      }))
    function fe(rA, _A, oI, QI) {
      if (rA.visible === !1) return
      if (rA.layers.test(_A.layers)) {
        if (rA.isGroup) oI = rA.renderOrder
        else if (rA.isLOD) rA.autoUpdate === !0 && rA.update(_A)
        else if (rA.isLight) (F.pushLight(rA), rA.castShadow && F.pushShadow(rA))
        else if (rA.isSprite) {
          if (!rA.frustumCulled || DA.intersectsSprite(rA)) {
            QI && sI.setFromMatrixPosition(rA.matrixWorld).applyMatrix4(qA)
            const EI = nI.update(rA),
              hg = rA.material
            hg.visible && R.push(rA, EI, hg, oI, sI.z, null)
          }
        } else if (
          (rA.isMesh || rA.isLine || rA.isPoints) &&
          (!rA.frustumCulled || DA.intersectsObject(rA))
        ) {
          const EI = nI.update(rA),
            hg = rA.material
          if (
            (QI &&
              (rA.boundingSphere !== void 0
                ? (rA.boundingSphere === null && rA.computeBoundingSphere(),
                  sI.copy(rA.boundingSphere.center))
                : (EI.boundingSphere === null && EI.computeBoundingSphere(),
                  sI.copy(EI.boundingSphere.center)),
              sI.applyMatrix4(rA.matrixWorld).applyMatrix4(qA)),
            Array.isArray(hg))
          ) {
            const yg = EI.groups
            for (let rg = 0, eC = yg.length; rg < eC; rg++) {
              const Rg = yg[rg],
                pC = hg[Rg.materialIndex]
              pC && pC.visible && R.push(rA, EI, pC, oI, sI.z, Rg)
            }
          } else hg.visible && R.push(rA, EI, hg, oI, sI.z, null)
        }
      }
      const gg = rA.children
      for (let EI = 0, hg = gg.length; EI < hg; EI++) fe(gg[EI], _A, oI, QI)
    }
    function Ei(rA, _A, oI, QI) {
      const PA = rA.opaque,
        gg = rA.transmissive,
        EI = rA.transparent
      ;(F.setupLightsView(oI),
        dA === !0 && MA.setGlobalState(H.clippingPlanes, oI),
        QI && AI.viewport(eA.copy(QI)),
        PA.length > 0 && Li(PA, _A, oI),
        gg.length > 0 && Li(gg, _A, oI),
        EI.length > 0 && Li(EI, _A, oI),
        AI.buffers.depth.setTest(!0),
        AI.buffers.depth.setMask(!0),
        AI.buffers.color.setMask(!0),
        AI.setPolygonOffset(!1))
    }
    function vi(rA, _A, oI, QI) {
      if ((oI.isScene === !0 ? oI.overrideMaterial : null) !== null) return
      F.state.transmissionRenderTarget[QI.id] === void 0 &&
        (F.state.transmissionRenderTarget[QI.id] = new BQ(1, 1, {
          generateMipmaps: !0,
          type: II.has("EXT_color_buffer_half_float") || II.has("EXT_color_buffer_float") ? KD : Xo,
          minFilter: ks,
          samples: 4,
          stencilBuffer: i,
          resolveDepthBuffer: !1,
          resolveStencilBuffer: !1,
          colorSpace: ni.workingColorSpace,
        }))
      const gg = F.state.transmissionRenderTarget[QI.id],
        EI = QI.viewport || eA
      gg.setSize(EI.z, EI.w)
      const hg = H.getRenderTarget()
      ;(H.setRenderTarget(gg),
        H.getClearColor(lA),
        (JA = H.getClearAlpha()),
        JA < 1 && H.setClearColor(16777215, 0.5),
        H.clear(),
        YA && aI.render(oI))
      const yg = H.toneMapping
      H.toneMapping = Ms
      const rg = QI.viewport
      if (
        (QI.viewport !== void 0 && (QI.viewport = void 0),
        F.setupLightsView(QI),
        dA === !0 && MA.setGlobalState(H.clippingPlanes, QI),
        Li(rA, oI, QI),
        QA.updateMultisampleRenderTarget(gg),
        QA.updateRenderTargetMipmap(gg),
        II.has("WEBGL_multisampled_render_to_texture") === !1)
      ) {
        let eC = !1
        for (let Rg = 0, pC = _A.length; Rg < pC; Rg++) {
          const wC = _A[Rg],
            mg = wC.object,
            UC = wC.geometry,
            iC = wC.material,
            Gg = wC.group
          if (iC.side === rE && mg.layers.test(QI.layers)) {
            const _C = iC.side
            ;((iC.side = WQ),
              (iC.needsUpdate = !0),
              mA(mg, oI, QI, UC, iC, Gg),
              (iC.side = _C),
              (iC.needsUpdate = !0),
              (eC = !0))
          }
        }
        eC === !0 && (QA.updateMultisampleRenderTarget(gg), QA.updateRenderTargetMipmap(gg))
      }
      ;(H.setRenderTarget(hg),
        H.setClearColor(lA, JA),
        rg !== void 0 && (QI.viewport = rg),
        (H.toneMapping = yg))
    }
    function Li(rA, _A, oI) {
      const QI = _A.isScene === !0 ? _A.overrideMaterial : null
      for (let PA = 0, gg = rA.length; PA < gg; PA++) {
        const EI = rA[PA],
          hg = EI.object,
          yg = EI.geometry,
          rg = QI === null ? EI.material : QI,
          eC = EI.group
        hg.layers.test(oI.layers) && mA(hg, _A, oI, yg, rg, eC)
      }
    }
    function mA(rA, _A, oI, QI, PA, gg) {
      ;(rA.onBeforeRender(H, _A, oI, QI, PA, gg),
        rA.modelViewMatrix.multiplyMatrices(oI.matrixWorldInverse, rA.matrixWorld),
        rA.normalMatrix.getNormalMatrix(rA.modelViewMatrix),
        PA.onBeforeRender(H, _A, oI, QI, rA, gg),
        PA.transparent === !0 && PA.side === rE && PA.forceSinglePass === !1
          ? ((PA.side = WQ),
            (PA.needsUpdate = !0),
            H.renderBufferDirect(oI, _A, QI, PA, rA, gg),
            (PA.side = Us),
            (PA.needsUpdate = !0),
            H.renderBufferDirect(oI, _A, QI, PA, rA, gg),
            (PA.side = rE))
          : H.renderBufferDirect(oI, _A, QI, PA, rA, gg),
        rA.onAfterRender(H, _A, oI, QI, PA, gg))
    }
    function TI(rA, _A, oI) {
      _A.isScene !== !0 && (_A = cI)
      const QI = SI.get(rA),
        PA = F.state.lights,
        gg = F.state.shadowsArray,
        EI = PA.state.version,
        hg = UI.getParameters(rA, PA.state, gg, _A, oI),
        yg = UI.getProgramCacheKey(hg)
      let rg = QI.programs
      ;((QI.environment = rA.isMeshStandardMaterial ? _A.environment : null),
        (QI.fog = _A.fog),
        (QI.envMap = (rA.isMeshStandardMaterial ? FA : tA).get(rA.envMap || QI.environment)),
        (QI.envMapRotation =
          QI.environment !== null && rA.envMap === null
            ? _A.environmentRotation
            : rA.envMapRotation),
        rg === void 0 &&
          (rA.addEventListener("dispose", dg),
          (rg = /* @__PURE__ */ new Map()),
          (QI.programs = rg)))
      let eC = rg.get(yg)
      if (eC !== void 0) {
        if (QI.currentProgram === eC && QI.lightsStateVersion === EI) return (Tg(rA, hg), eC)
      } else
        ((hg.uniforms = UI.getUniforms(rA)),
          rA.onBeforeCompile(hg, H),
          (eC = UI.acquireProgram(hg, yg)),
          rg.set(yg, eC),
          (QI.uniforms = hg.uniforms))
      const Rg = QI.uniforms
      return (
        ((!rA.isShaderMaterial && !rA.isRawShaderMaterial) || rA.clipping === !0) &&
          (Rg.clippingPlanes = MA.uniform),
        Tg(rA, hg),
        (QI.needsLights = jg(rA)),
        (QI.lightsStateVersion = EI),
        QI.needsLights &&
          ((Rg.ambientLightColor.value = PA.state.ambient),
          (Rg.lightProbe.value = PA.state.probe),
          (Rg.directionalLights.value = PA.state.directional),
          (Rg.directionalLightShadows.value = PA.state.directionalShadow),
          (Rg.spotLights.value = PA.state.spot),
          (Rg.spotLightShadows.value = PA.state.spotShadow),
          (Rg.rectAreaLights.value = PA.state.rectArea),
          (Rg.ltc_1.value = PA.state.rectAreaLTC1),
          (Rg.ltc_2.value = PA.state.rectAreaLTC2),
          (Rg.pointLights.value = PA.state.point),
          (Rg.pointLightShadows.value = PA.state.pointShadow),
          (Rg.hemisphereLights.value = PA.state.hemi),
          (Rg.directionalShadowMap.value = PA.state.directionalShadowMap),
          (Rg.directionalShadowMatrix.value = PA.state.directionalShadowMatrix),
          (Rg.spotShadowMap.value = PA.state.spotShadowMap),
          (Rg.spotLightMatrix.value = PA.state.spotLightMatrix),
          (Rg.spotLightMap.value = PA.state.spotLightMap),
          (Rg.pointShadowMap.value = PA.state.pointShadowMap),
          (Rg.pointShadowMatrix.value = PA.state.pointShadowMatrix)),
        (QI.currentProgram = eC),
        (QI.uniformsList = null),
        eC
      )
    }
    function eg(rA) {
      if (rA.uniformsList === null) {
        const _A = rA.currentProgram.getUniforms()
        rA.uniformsList = vU.seqWithValue(_A.seq, rA.uniforms)
      }
      return rA.uniformsList
    }
    function Tg(rA, _A) {
      const oI = SI.get(rA)
      ;((oI.outputColorSpace = _A.outputColorSpace),
        (oI.batching = _A.batching),
        (oI.batchingColor = _A.batchingColor),
        (oI.instancing = _A.instancing),
        (oI.instancingColor = _A.instancingColor),
        (oI.instancingMorph = _A.instancingMorph),
        (oI.skinning = _A.skinning),
        (oI.morphTargets = _A.morphTargets),
        (oI.morphNormals = _A.morphNormals),
        (oI.morphColors = _A.morphColors),
        (oI.morphTargetsCount = _A.morphTargetsCount),
        (oI.numClippingPlanes = _A.numClippingPlanes),
        (oI.numIntersection = _A.numClipIntersection),
        (oI.vertexAlphas = _A.vertexAlphas),
        (oI.vertexTangents = _A.vertexTangents),
        (oI.toneMapping = _A.toneMapping))
    }
    function OC(rA, _A, oI, QI, PA) {
      ;(_A.isScene !== !0 && (_A = cI), QA.resetTextureUnits())
      const gg = _A.fog,
        EI = QI.isMeshStandardMaterial ? _A.environment : null,
        hg =
          AA === null
            ? H.outputColorSpace
            : AA.isXRRenderTarget === !0
              ? AA.texture.colorSpace
              : ru,
        yg = (QI.isMeshStandardMaterial ? FA : tA).get(QI.envMap || EI),
        rg = QI.vertexColors === !0 && !!oI.attributes.color && oI.attributes.color.itemSize === 4,
        eC = !!oI.attributes.tangent && (!!QI.normalMap || QI.anisotropy > 0),
        Rg = !!oI.morphAttributes.position,
        pC = !!oI.morphAttributes.normal,
        wC = !!oI.morphAttributes.color
      let mg = Ms
      QI.toneMapped && (AA === null || AA.isXRRenderTarget === !0) && (mg = H.toneMapping)
      const UC =
          oI.morphAttributes.position || oI.morphAttributes.normal || oI.morphAttributes.color,
        iC = UC !== void 0 ? UC.length : 0,
        Gg = SI.get(QI),
        _C = F.state.lights
      if (dA === !0 && (kA === !0 || rA !== _)) {
        const He = rA === _ && QI.id === X
        MA.setState(QI, rA, He)
      }
      let vC = !1
      QI.version === Gg.__version
        ? ((Gg.needsLights && Gg.lightsStateVersion !== _C.state.version) ||
            Gg.outputColorSpace !== hg ||
            (PA.isBatchedMesh && Gg.batching === !1) ||
            (!PA.isBatchedMesh && Gg.batching === !0) ||
            (PA.isBatchedMesh && Gg.batchingColor === !0 && PA.colorTexture === null) ||
            (PA.isBatchedMesh && Gg.batchingColor === !1 && PA.colorTexture !== null) ||
            (PA.isInstancedMesh && Gg.instancing === !1) ||
            (!PA.isInstancedMesh && Gg.instancing === !0) ||
            (PA.isSkinnedMesh && Gg.skinning === !1) ||
            (!PA.isSkinnedMesh && Gg.skinning === !0) ||
            (PA.isInstancedMesh && Gg.instancingColor === !0 && PA.instanceColor === null) ||
            (PA.isInstancedMesh && Gg.instancingColor === !1 && PA.instanceColor !== null) ||
            (PA.isInstancedMesh && Gg.instancingMorph === !0 && PA.morphTexture === null) ||
            (PA.isInstancedMesh && Gg.instancingMorph === !1 && PA.morphTexture !== null) ||
            Gg.envMap !== yg ||
            (QI.fog === !0 && Gg.fog !== gg) ||
            (Gg.numClippingPlanes !== void 0 &&
              (Gg.numClippingPlanes !== MA.numPlanes ||
                Gg.numIntersection !== MA.numIntersection)) ||
            Gg.vertexAlphas !== rg ||
            Gg.vertexTangents !== eC ||
            Gg.morphTargets !== Rg ||
            Gg.morphNormals !== pC ||
            Gg.morphColors !== wC ||
            Gg.toneMapping !== mg ||
            Gg.morphTargetsCount !== iC) &&
          (vC = !0)
        : ((vC = !0), (Gg.__version = QI.version))
      let ii = Gg.currentProgram
      vC === !0 && (ii = TI(QI, _A, PA))
      let qe = !1,
        pe = !1,
        Mi = !1
      const ae = ii.getUniforms(),
        ai = Gg.uniforms
      if (
        (AI.useProgram(ii.program) && ((qe = !0), (pe = !0), (Mi = !0)),
        QI.id !== X && ((X = QI.id), (pe = !0)),
        qe || _ !== rA)
      ) {
        ;(AI.buffers.depth.getReversed()
          ? (NA.copy(rA.projectionMatrix), oZ(NA), nZ(NA), ae.setValue(uA, "projectionMatrix", NA))
          : ae.setValue(uA, "projectionMatrix", rA.projectionMatrix),
          ae.setValue(uA, "viewMatrix", rA.matrixWorldInverse))
        const Et = ae.map.cameraPosition
        ;(Et !== void 0 && Et.setValue(uA, ZA.setFromMatrixPosition(rA.matrixWorld)),
          pI.logarithmicDepthBuffer &&
            ae.setValue(uA, "logDepthBufFC", 2 / (Math.log(rA.far + 1) / Math.LN2)),
          (QI.isMeshPhongMaterial ||
            QI.isMeshToonMaterial ||
            QI.isMeshLambertMaterial ||
            QI.isMeshBasicMaterial ||
            QI.isMeshStandardMaterial ||
            QI.isShaderMaterial) &&
            ae.setValue(uA, "isOrthographic", rA.isOrthographicCamera === !0),
          _ !== rA && ((_ = rA), (pe = !0), (Mi = !0)))
      }
      if (PA.isSkinnedMesh) {
        ;(ae.setOptional(uA, PA, "bindMatrix"), ae.setOptional(uA, PA, "bindMatrixInverse"))
        const He = PA.skeleton
        He &&
          (He.boneTexture === null && He.computeBoneTexture(),
          ae.setValue(uA, "boneTexture", He.boneTexture, QA))
      }
      PA.isBatchedMesh &&
        (ae.setOptional(uA, PA, "batchingTexture"),
        ae.setValue(uA, "batchingTexture", PA._matricesTexture, QA),
        ae.setOptional(uA, PA, "batchingIdTexture"),
        ae.setValue(uA, "batchingIdTexture", PA._indirectTexture, QA),
        ae.setOptional(uA, PA, "batchingColorTexture"),
        PA._colorsTexture !== null &&
          ae.setValue(uA, "batchingColorTexture", PA._colorsTexture, QA))
      const fi = oI.morphAttributes
      if (
        ((fi.position !== void 0 || fi.normal !== void 0 || fi.color !== void 0) &&
          RI.update(PA, oI, ii),
        (pe || Gg.receiveShadow !== PA.receiveShadow) &&
          ((Gg.receiveShadow = PA.receiveShadow),
          ae.setValue(uA, "receiveShadow", PA.receiveShadow)),
        QI.isMeshGouraudMaterial &&
          QI.envMap !== null &&
          ((ai.envMap.value = yg),
          (ai.flipEnvMap.value = yg.isCubeTexture && yg.isRenderTargetTexture === !1 ? -1 : 1)),
        QI.isMeshStandardMaterial &&
          QI.envMap === null &&
          _A.environment !== null &&
          (ai.envMapIntensity.value = _A.environmentIntensity),
        pe &&
          (ae.setValue(uA, "toneMappingExposure", H.toneMappingExposure),
          Gg.needsLights && JC(ai, Mi),
          gg && QI.fog === !0 && GI.refreshFogUniforms(ai, gg),
          GI.refreshMaterialUniforms(ai, QI, nA, LA, F.state.transmissionRenderTarget[rA.id]),
          vU.upload(uA, eg(Gg), ai, QA)),
        QI.isShaderMaterial &&
          QI.uniformsNeedUpdate === !0 &&
          (vU.upload(uA, eg(Gg), ai, QA), (QI.uniformsNeedUpdate = !1)),
        QI.isSpriteMaterial && ae.setValue(uA, "center", PA.center),
        ae.setValue(uA, "modelViewMatrix", PA.modelViewMatrix),
        ae.setValue(uA, "normalMatrix", PA.normalMatrix),
        ae.setValue(uA, "modelMatrix", PA.matrixWorld),
        QI.isShaderMaterial || QI.isRawShaderMaterial)
      ) {
        const He = QI.uniformsGroups
        for (let Et = 0, Yi = He.length; Et < Yi; Et++) {
          const vn = He[Et]
          ;(SA.update(vn, ii), SA.bind(vn, ii))
        }
      }
      return ii
    }
    function JC(rA, _A) {
      ;((rA.ambientLightColor.needsUpdate = _A),
        (rA.lightProbe.needsUpdate = _A),
        (rA.directionalLights.needsUpdate = _A),
        (rA.directionalLightShadows.needsUpdate = _A),
        (rA.pointLights.needsUpdate = _A),
        (rA.pointLightShadows.needsUpdate = _A),
        (rA.spotLights.needsUpdate = _A),
        (rA.spotLightShadows.needsUpdate = _A),
        (rA.rectAreaLights.needsUpdate = _A),
        (rA.hemisphereLights.needsUpdate = _A))
    }
    function jg(rA) {
      return (
        rA.isMeshLambertMaterial ||
        rA.isMeshToonMaterial ||
        rA.isMeshPhongMaterial ||
        rA.isMeshStandardMaterial ||
        rA.isShadowMaterial ||
        (rA.isShaderMaterial && rA.lights === !0)
      )
    }
    ;((this.getActiveCubeFace = function () {
      return j
    }),
      (this.getActiveMipmapLevel = function () {
        return P
      }),
      (this.getRenderTarget = function () {
        return AA
      }),
      (this.setRenderTargetTextures = function (rA, _A, oI) {
        ;((SI.get(rA.texture).__webglTexture = _A), (SI.get(rA.depthTexture).__webglTexture = oI))
        const QI = SI.get(rA)
        ;((QI.__hasExternalTextures = !0),
          (QI.__autoAllocateDepthBuffer = oI === void 0),
          QI.__autoAllocateDepthBuffer ||
            (II.has("WEBGL_multisampled_render_to_texture") === !0 &&
              (console.warn(
                "THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided",
              ),
              (QI.__useRenderToTexture = !1))))
      }),
      (this.setRenderTargetFramebuffer = function (rA, _A) {
        const oI = SI.get(rA)
        ;((oI.__webglFramebuffer = _A), (oI.__useDefaultFramebuffer = _A === void 0))
      }),
      (this.setRenderTarget = function (rA, _A = 0, oI = 0) {
        ;((AA = rA), (j = _A), (P = oI))
        let QI = !0,
          PA = null,
          gg = !1,
          EI = !1
        if (rA) {
          const yg = SI.get(rA)
          if (yg.__useDefaultFramebuffer !== void 0)
            (AI.bindFramebuffer(uA.FRAMEBUFFER, null), (QI = !1))
          else if (yg.__webglFramebuffer === void 0) QA.setupRenderTarget(rA)
          else if (yg.__hasExternalTextures)
            QA.rebindTextures(
              rA,
              SI.get(rA.texture).__webglTexture,
              SI.get(rA.depthTexture).__webglTexture,
            )
          else if (rA.depthBuffer) {
            const Rg = rA.depthTexture
            if (yg.__boundDepthTexture !== Rg) {
              if (
                Rg !== null &&
                SI.has(Rg) &&
                (rA.width !== Rg.image.width || rA.height !== Rg.image.height)
              )
                throw new Error(
                  "WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.",
                )
              QA.setupDepthRenderbuffer(rA)
            }
          }
          const rg = rA.texture
          ;(rg.isData3DTexture || rg.isDataArrayTexture || rg.isCompressedArrayTexture) && (EI = !0)
          const eC = SI.get(rA).__webglFramebuffer
          ;(rA.isWebGLCubeRenderTarget
            ? (Array.isArray(eC[_A]) ? (PA = eC[_A][oI]) : (PA = eC[_A]), (gg = !0))
            : rA.samples > 0 && QA.useMultisampledRTT(rA) === !1
              ? (PA = SI.get(rA).__webglMultisampledFramebuffer)
              : Array.isArray(eC)
                ? (PA = eC[oI])
                : (PA = eC),
            eA.copy(rA.viewport),
            CA.copy(rA.scissor),
            (aA = rA.scissorTest))
        } else
          (eA.copy($).multiplyScalar(nA).floor(), CA.copy(EA).multiplyScalar(nA).floor(), (aA = GA))
        if (
          (AI.bindFramebuffer(uA.FRAMEBUFFER, PA) && QI && AI.drawBuffers(rA, PA),
          AI.viewport(eA),
          AI.scissor(CA),
          AI.setScissorTest(aA),
          gg)
        ) {
          const yg = SI.get(rA.texture)
          uA.framebufferTexture2D(
            uA.FRAMEBUFFER,
            uA.COLOR_ATTACHMENT0,
            uA.TEXTURE_CUBE_MAP_POSITIVE_X + _A,
            yg.__webglTexture,
            oI,
          )
        } else if (EI) {
          const yg = SI.get(rA.texture),
            rg = _A || 0
          uA.framebufferTextureLayer(
            uA.FRAMEBUFFER,
            uA.COLOR_ATTACHMENT0,
            yg.__webglTexture,
            oI || 0,
            rg,
          )
        }
        X = -1
      }),
      (this.readRenderTargetPixels = function (rA, _A, oI, QI, PA, gg, EI) {
        if (!(rA && rA.isWebGLRenderTarget)) {
          console.error(
            "THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.",
          )
          return
        }
        let hg = SI.get(rA).__webglFramebuffer
        if ((rA.isWebGLCubeRenderTarget && EI !== void 0 && (hg = hg[EI]), hg)) {
          AI.bindFramebuffer(uA.FRAMEBUFFER, hg)
          try {
            const yg = rA.texture,
              rg = yg.format,
              eC = yg.type
            if (!pI.textureFormatReadable(rg)) {
              console.error(
                "THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.",
              )
              return
            }
            if (!pI.textureTypeReadable(eC)) {
              console.error(
                "THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.",
              )
              return
            }
            _A >= 0 &&
              _A <= rA.width - QI &&
              oI >= 0 &&
              oI <= rA.height - PA &&
              uA.readPixels(_A, oI, QI, PA, XI.convert(rg), XI.convert(eC), gg)
          } finally {
            const yg = AA !== null ? SI.get(AA).__webglFramebuffer : null
            AI.bindFramebuffer(uA.FRAMEBUFFER, yg)
          }
        }
      }),
      (this.readRenderTargetPixelsAsync = async function (rA, _A, oI, QI, PA, gg, EI) {
        if (!(rA && rA.isWebGLRenderTarget))
          throw new Error(
            "THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.",
          )
        let hg = SI.get(rA).__webglFramebuffer
        if ((rA.isWebGLCubeRenderTarget && EI !== void 0 && (hg = hg[EI]), hg)) {
          const yg = rA.texture,
            rg = yg.format,
            eC = yg.type
          if (!pI.textureFormatReadable(rg))
            throw new Error(
              "THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.",
            )
          if (!pI.textureTypeReadable(eC))
            throw new Error(
              "THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.",
            )
          if (_A >= 0 && _A <= rA.width - QI && oI >= 0 && oI <= rA.height - PA) {
            AI.bindFramebuffer(uA.FRAMEBUFFER, hg)
            const Rg = uA.createBuffer()
            ;(uA.bindBuffer(uA.PIXEL_PACK_BUFFER, Rg),
              uA.bufferData(uA.PIXEL_PACK_BUFFER, gg.byteLength, uA.STREAM_READ),
              uA.readPixels(_A, oI, QI, PA, XI.convert(rg), XI.convert(eC), 0))
            const pC = AA !== null ? SI.get(AA).__webglFramebuffer : null
            AI.bindFramebuffer(uA.FRAMEBUFFER, pC)
            const wC = uA.fenceSync(uA.SYNC_GPU_COMMANDS_COMPLETE, 0)
            return (
              uA.flush(),
              await QZ(uA, wC, 4),
              uA.bindBuffer(uA.PIXEL_PACK_BUFFER, Rg),
              uA.getBufferSubData(uA.PIXEL_PACK_BUFFER, 0, gg),
              uA.deleteBuffer(Rg),
              uA.deleteSync(wC),
              gg
            )
          } else
            throw new Error(
              "THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.",
            )
        }
      }),
      (this.copyFramebufferToTexture = function (rA, _A = null, oI = 0) {
        rA.isTexture !== !0 &&
          (O0("WebGLRenderer: copyFramebufferToTexture function signature has changed."),
          (_A = arguments[0] || null),
          (rA = arguments[1]))
        const QI = Math.pow(2, -oI),
          PA = Math.floor(rA.image.width * QI),
          gg = Math.floor(rA.image.height * QI),
          EI = _A !== null ? _A.x : 0,
          hg = _A !== null ? _A.y : 0
        ;(QA.setTexture2D(rA, 0),
          uA.copyTexSubImage2D(uA.TEXTURE_2D, oI, 0, 0, EI, hg, PA, gg),
          AI.unbindTexture())
      }),
      (this.copyTextureToTexture = function (rA, _A, oI = null, QI = null, PA = 0) {
        rA.isTexture !== !0 &&
          (O0("WebGLRenderer: copyTextureToTexture function signature has changed."),
          (QI = arguments[0] || null),
          (rA = arguments[1]),
          (_A = arguments[2]),
          (PA = arguments[3] || 0),
          (oI = null))
        let gg, EI, hg, yg, rg, eC, Rg, pC, wC
        const mg = rA.isCompressedTexture ? rA.mipmaps[PA] : rA.image
        ;(oI !== null
          ? ((gg = oI.max.x - oI.min.x),
            (EI = oI.max.y - oI.min.y),
            (hg = oI.isBox3 ? oI.max.z - oI.min.z : 1),
            (yg = oI.min.x),
            (rg = oI.min.y),
            (eC = oI.isBox3 ? oI.min.z : 0))
          : ((gg = mg.width), (EI = mg.height), (hg = mg.depth || 1), (yg = 0), (rg = 0), (eC = 0)),
          QI !== null ? ((Rg = QI.x), (pC = QI.y), (wC = QI.z)) : ((Rg = 0), (pC = 0), (wC = 0)))
        const UC = XI.convert(_A.format),
          iC = XI.convert(_A.type)
        let Gg
        ;(_A.isData3DTexture
          ? (QA.setTexture3D(_A, 0), (Gg = uA.TEXTURE_3D))
          : _A.isDataArrayTexture || _A.isCompressedArrayTexture
            ? (QA.setTexture2DArray(_A, 0), (Gg = uA.TEXTURE_2D_ARRAY))
            : (QA.setTexture2D(_A, 0), (Gg = uA.TEXTURE_2D)),
          uA.pixelStorei(uA.UNPACK_FLIP_Y_WEBGL, _A.flipY),
          uA.pixelStorei(uA.UNPACK_PREMULTIPLY_ALPHA_WEBGL, _A.premultiplyAlpha),
          uA.pixelStorei(uA.UNPACK_ALIGNMENT, _A.unpackAlignment))
        const _C = uA.getParameter(uA.UNPACK_ROW_LENGTH),
          vC = uA.getParameter(uA.UNPACK_IMAGE_HEIGHT),
          ii = uA.getParameter(uA.UNPACK_SKIP_PIXELS),
          qe = uA.getParameter(uA.UNPACK_SKIP_ROWS),
          pe = uA.getParameter(uA.UNPACK_SKIP_IMAGES)
        ;(uA.pixelStorei(uA.UNPACK_ROW_LENGTH, mg.width),
          uA.pixelStorei(uA.UNPACK_IMAGE_HEIGHT, mg.height),
          uA.pixelStorei(uA.UNPACK_SKIP_PIXELS, yg),
          uA.pixelStorei(uA.UNPACK_SKIP_ROWS, rg),
          uA.pixelStorei(uA.UNPACK_SKIP_IMAGES, eC))
        const Mi = rA.isDataArrayTexture || rA.isData3DTexture,
          ae = _A.isDataArrayTexture || _A.isData3DTexture
        if (rA.isRenderTargetTexture || rA.isDepthTexture) {
          const ai = SI.get(rA),
            fi = SI.get(_A),
            He = SI.get(ai.__renderTarget),
            Et = SI.get(fi.__renderTarget)
          ;(AI.bindFramebuffer(uA.READ_FRAMEBUFFER, He.__webglFramebuffer),
            AI.bindFramebuffer(uA.DRAW_FRAMEBUFFER, Et.__webglFramebuffer))
          for (let Yi = 0; Yi < hg; Yi++)
            (Mi &&
              uA.framebufferTextureLayer(
                uA.READ_FRAMEBUFFER,
                uA.COLOR_ATTACHMENT0,
                SI.get(rA).__webglTexture,
                PA,
                eC + Yi,
              ),
              rA.isDepthTexture
                ? (ae &&
                    uA.framebufferTextureLayer(
                      uA.DRAW_FRAMEBUFFER,
                      uA.COLOR_ATTACHMENT0,
                      SI.get(_A).__webglTexture,
                      PA,
                      wC + Yi,
                    ),
                  uA.blitFramebuffer(
                    yg,
                    rg,
                    gg,
                    EI,
                    Rg,
                    pC,
                    gg,
                    EI,
                    uA.DEPTH_BUFFER_BIT,
                    uA.NEAREST,
                  ))
                : ae
                  ? uA.copyTexSubImage3D(Gg, PA, Rg, pC, wC + Yi, yg, rg, gg, EI)
                  : uA.copyTexSubImage2D(Gg, PA, Rg, pC, wC + Yi, yg, rg, gg, EI))
          ;(AI.bindFramebuffer(uA.READ_FRAMEBUFFER, null),
            AI.bindFramebuffer(uA.DRAW_FRAMEBUFFER, null))
        } else
          ae
            ? rA.isDataTexture || rA.isData3DTexture
              ? uA.texSubImage3D(Gg, PA, Rg, pC, wC, gg, EI, hg, UC, iC, mg.data)
              : _A.isCompressedArrayTexture
                ? uA.compressedTexSubImage3D(Gg, PA, Rg, pC, wC, gg, EI, hg, UC, mg.data)
                : uA.texSubImage3D(Gg, PA, Rg, pC, wC, gg, EI, hg, UC, iC, mg)
            : rA.isDataTexture
              ? uA.texSubImage2D(uA.TEXTURE_2D, PA, Rg, pC, gg, EI, UC, iC, mg.data)
              : rA.isCompressedTexture
                ? uA.compressedTexSubImage2D(
                    uA.TEXTURE_2D,
                    PA,
                    Rg,
                    pC,
                    mg.width,
                    mg.height,
                    UC,
                    mg.data,
                  )
                : uA.texSubImage2D(uA.TEXTURE_2D, PA, Rg, pC, gg, EI, UC, iC, mg)
        ;(uA.pixelStorei(uA.UNPACK_ROW_LENGTH, _C),
          uA.pixelStorei(uA.UNPACK_IMAGE_HEIGHT, vC),
          uA.pixelStorei(uA.UNPACK_SKIP_PIXELS, ii),
          uA.pixelStorei(uA.UNPACK_SKIP_ROWS, qe),
          uA.pixelStorei(uA.UNPACK_SKIP_IMAGES, pe),
          PA === 0 && _A.generateMipmaps && uA.generateMipmap(Gg),
          AI.unbindTexture())
      }),
      (this.copyTextureToTexture3D = function (rA, _A, oI = null, QI = null, PA = 0) {
        return (
          rA.isTexture !== !0 &&
            (O0("WebGLRenderer: copyTextureToTexture3D function signature has changed."),
            (oI = arguments[0] || null),
            (QI = arguments[1] || null),
            (rA = arguments[2]),
            (_A = arguments[3]),
            (PA = arguments[4] || 0)),
          O0(
            'WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.',
          ),
          this.copyTextureToTexture(rA, _A, oI, QI, PA)
        )
      }),
      (this.initRenderTarget = function (rA) {
        SI.get(rA).__webglFramebuffer === void 0 && QA.setupRenderTarget(rA)
      }),
      (this.initTexture = function (rA) {
        ;(rA.isCubeTexture
          ? QA.setTextureCube(rA, 0)
          : rA.isData3DTexture
            ? QA.setTexture3D(rA, 0)
            : rA.isDataArrayTexture || rA.isCompressedArrayTexture
              ? QA.setTexture2DArray(rA, 0)
              : QA.setTexture2D(rA, 0),
          AI.unbindTexture())
      }),
      (this.resetState = function () {
        ;((j = 0), (P = 0), (AA = null), AI.reset(), $I.reset())
      }),
      typeof __THREE_DEVTOOLS__ < "u" &&
        __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this })))
  }
  get coordinateSystem() {
    return bc
  }
  get outputColorSpace() {
    return this._outputColorSpace
  }
  set outputColorSpace(A) {
    this._outputColorSpace = A
    const I = this.getContext()
    ;((I.drawingBufferColorspace = ni._getDrawingBufferColorSpace(A)),
      (I.unpackColorSpace = ni._getUnpackColorSpace()))
  }
}
class eF {
  constructor(A, I = 25e-5) {
    ;((this.isFogExp2 = !0), (this.name = ""), (this.color = new Mg(A)), (this.density = I))
  }
  clone() {
    return new eF(this.color, this.density)
  }
  toJSON() {
    return {
      type: "FogExp2",
      name: this.name,
      color: this.color.getHex(),
      density: this.density,
    }
  }
}
class iF {
  constructor(A, I = 1, g = 1e3) {
    ;((this.isFog = !0),
      (this.name = ""),
      (this.color = new Mg(A)),
      (this.near = I),
      (this.far = g))
  }
  clone() {
    return new iF(this.color, this.near, this.far)
  }
  toJSON() {
    return {
      type: "Fog",
      name: this.name,
      color: this.color.getHex(),
      near: this.near,
      far: this.far,
    }
  }
}
let sp = class extends Ci {
  constructor() {
    ;(super(),
      (this.isScene = !0),
      (this.type = "Scene"),
      (this.background = null),
      (this.environment = null),
      (this.fog = null),
      (this.backgroundBlurriness = 0),
      (this.backgroundIntensity = 1),
      (this.backgroundRotation = new uE()),
      (this.environmentIntensity = 1),
      (this.environmentRotation = new uE()),
      (this.overrideMaterial = null),
      typeof __THREE_DEVTOOLS__ < "u" &&
        __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this })))
  }
  copy(A, I) {
    return (
      super.copy(A, I),
      A.background !== null && (this.background = A.background.clone()),
      A.environment !== null && (this.environment = A.environment.clone()),
      A.fog !== null && (this.fog = A.fog.clone()),
      (this.backgroundBlurriness = A.backgroundBlurriness),
      (this.backgroundIntensity = A.backgroundIntensity),
      this.backgroundRotation.copy(A.backgroundRotation),
      (this.environmentIntensity = A.environmentIntensity),
      this.environmentRotation.copy(A.environmentRotation),
      A.overrideMaterial !== null && (this.overrideMaterial = A.overrideMaterial.clone()),
      (this.matrixAutoUpdate = A.matrixAutoUpdate),
      this
    )
  }
  toJSON(A) {
    const I = super.toJSON(A)
    return (
      this.fog !== null && (I.object.fog = this.fog.toJSON()),
      this.backgroundBlurriness > 0 && (I.object.backgroundBlurriness = this.backgroundBlurriness),
      this.backgroundIntensity !== 1 && (I.object.backgroundIntensity = this.backgroundIntensity),
      (I.object.backgroundRotation = this.backgroundRotation.toArray()),
      this.environmentIntensity !== 1 &&
        (I.object.environmentIntensity = this.environmentIntensity),
      (I.object.environmentRotation = this.environmentRotation.toArray()),
      I
    )
  }
}
class KG {
  constructor(A, I) {
    ;((this.isInterleavedBuffer = !0),
      (this.array = A),
      (this.stride = I),
      (this.count = A !== void 0 ? A.length / I : 0),
      (this.usage = rG),
      (this.updateRanges = []),
      (this.version = 0),
      (this.uuid = Lr()))
  }
  onUploadCallback() {}
  set needsUpdate(A) {
    A === !0 && this.version++
  }
  setUsage(A) {
    return ((this.usage = A), this)
  }
  addUpdateRange(A, I) {
    this.updateRanges.push({ start: A, count: I })
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0
  }
  copy(A) {
    return (
      (this.array = new A.array.constructor(A.array)),
      (this.count = A.count),
      (this.stride = A.stride),
      (this.usage = A.usage),
      this
    )
  }
  copyAt(A, I, g) {
    ;((A *= this.stride), (g *= I.stride))
    for (let C = 0, i = this.stride; C < i; C++) this.array[A + C] = I.array[g + C]
    return this
  }
  set(A, I = 0) {
    return (this.array.set(A, I), this)
  }
  clone(A) {
    ;(A.arrayBuffers === void 0 && (A.arrayBuffers = {}),
      this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = Lr()),
      A.arrayBuffers[this.array.buffer._uuid] === void 0 &&
        (A.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer))
    const I = new this.array.constructor(A.arrayBuffers[this.array.buffer._uuid]),
      g = new this.constructor(I, this.stride)
    return (g.setUsage(this.usage), g)
  }
  onUpload(A) {
    return ((this.onUploadCallback = A), this)
  }
  toJSON(A) {
    return (
      A.arrayBuffers === void 0 && (A.arrayBuffers = {}),
      this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = Lr()),
      A.arrayBuffers[this.array.buffer._uuid] === void 0 &&
        (A.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))),
      {
        uuid: this.uuid,
        buffer: this.array.buffer._uuid,
        type: this.array.constructor.name,
        stride: this.stride,
      }
    )
  }
}
const VE = /* @__PURE__ */ new wA()
class FD {
  constructor(A, I, g, C = !1) {
    ;((this.isInterleavedBufferAttribute = !0),
      (this.name = ""),
      (this.data = A),
      (this.itemSize = I),
      (this.offset = g),
      (this.normalized = C))
  }
  get count() {
    return this.data.count
  }
  get array() {
    return this.data.array
  }
  set needsUpdate(A) {
    this.data.needsUpdate = A
  }
  applyMatrix4(A) {
    for (let I = 0, g = this.data.count; I < g; I++)
      (VE.fromBufferAttribute(this, I), VE.applyMatrix4(A), this.setXYZ(I, VE.x, VE.y, VE.z))
    return this
  }
  applyNormalMatrix(A) {
    for (let I = 0, g = this.count; I < g; I++)
      (VE.fromBufferAttribute(this, I), VE.applyNormalMatrix(A), this.setXYZ(I, VE.x, VE.y, VE.z))
    return this
  }
  transformDirection(A) {
    for (let I = 0, g = this.count; I < g; I++)
      (VE.fromBufferAttribute(this, I), VE.transformDirection(A), this.setXYZ(I, VE.x, VE.y, VE.z))
    return this
  }
  getComponent(A, I) {
    let g = this.array[A * this.data.stride + this.offset + I]
    return (this.normalized && (g = zE(g, this.array)), g)
  }
  setComponent(A, I, g) {
    return (
      this.normalized && (g = ye(g, this.array)),
      (this.data.array[A * this.data.stride + this.offset + I] = g),
      this
    )
  }
  setX(A, I) {
    return (
      this.normalized && (I = ye(I, this.array)),
      (this.data.array[A * this.data.stride + this.offset] = I),
      this
    )
  }
  setY(A, I) {
    return (
      this.normalized && (I = ye(I, this.array)),
      (this.data.array[A * this.data.stride + this.offset + 1] = I),
      this
    )
  }
  setZ(A, I) {
    return (
      this.normalized && (I = ye(I, this.array)),
      (this.data.array[A * this.data.stride + this.offset + 2] = I),
      this
    )
  }
  setW(A, I) {
    return (
      this.normalized && (I = ye(I, this.array)),
      (this.data.array[A * this.data.stride + this.offset + 3] = I),
      this
    )
  }
  getX(A) {
    let I = this.data.array[A * this.data.stride + this.offset]
    return (this.normalized && (I = zE(I, this.array)), I)
  }
  getY(A) {
    let I = this.data.array[A * this.data.stride + this.offset + 1]
    return (this.normalized && (I = zE(I, this.array)), I)
  }
  getZ(A) {
    let I = this.data.array[A * this.data.stride + this.offset + 2]
    return (this.normalized && (I = zE(I, this.array)), I)
  }
  getW(A) {
    let I = this.data.array[A * this.data.stride + this.offset + 3]
    return (this.normalized && (I = zE(I, this.array)), I)
  }
  setXY(A, I, g) {
    return (
      (A = A * this.data.stride + this.offset),
      this.normalized && ((I = ye(I, this.array)), (g = ye(g, this.array))),
      (this.data.array[A + 0] = I),
      (this.data.array[A + 1] = g),
      this
    )
  }
  setXYZ(A, I, g, C) {
    return (
      (A = A * this.data.stride + this.offset),
      this.normalized &&
        ((I = ye(I, this.array)), (g = ye(g, this.array)), (C = ye(C, this.array))),
      (this.data.array[A + 0] = I),
      (this.data.array[A + 1] = g),
      (this.data.array[A + 2] = C),
      this
    )
  }
  setXYZW(A, I, g, C, i) {
    return (
      (A = A * this.data.stride + this.offset),
      this.normalized &&
        ((I = ye(I, this.array)),
        (g = ye(g, this.array)),
        (C = ye(C, this.array)),
        (i = ye(i, this.array))),
      (this.data.array[A + 0] = I),
      (this.data.array[A + 1] = g),
      (this.data.array[A + 2] = C),
      (this.data.array[A + 3] = i),
      this
    )
  }
  clone(A) {
    if (A === void 0) {
      console.log(
        "THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.",
      )
      const I = []
      for (let g = 0; g < this.count; g++) {
        const C = g * this.data.stride + this.offset
        for (let i = 0; i < this.itemSize; i++) I.push(this.data.array[C + i])
      }
      return new Ye(new this.array.constructor(I), this.itemSize, this.normalized)
    } else
      return (
        A.interleavedBuffers === void 0 && (A.interleavedBuffers = {}),
        A.interleavedBuffers[this.data.uuid] === void 0 &&
          (A.interleavedBuffers[this.data.uuid] = this.data.clone(A)),
        new FD(A.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized)
      )
  }
  toJSON(A) {
    if (A === void 0) {
      console.log(
        "THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.",
      )
      const I = []
      for (let g = 0; g < this.count; g++) {
        const C = g * this.data.stride + this.offset
        for (let i = 0; i < this.itemSize; i++) I.push(this.data.array[C + i])
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: I,
        normalized: this.normalized,
      }
    } else
      return (
        A.interleavedBuffers === void 0 && (A.interleavedBuffers = {}),
        A.interleavedBuffers[this.data.uuid] === void 0 &&
          (A.interleavedBuffers[this.data.uuid] = this.data.toJSON(A)),
        {
          isInterleavedBufferAttribute: !0,
          itemSize: this.itemSize,
          data: this.data.uuid,
          offset: this.offset,
          normalized: this.normalized,
        }
      )
  }
}
class iv extends tQ {
  static get type() {
    return "SpriteMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isSpriteMaterial = !0),
      (this.color = new Mg(16777215)),
      (this.map = null),
      (this.alphaMap = null),
      (this.rotation = 0),
      (this.sizeAttenuation = !0),
      (this.transparent = !0),
      (this.fog = !0),
      this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      this.color.copy(A.color),
      (this.map = A.map),
      (this.alphaMap = A.alphaMap),
      (this.rotation = A.rotation),
      (this.sizeAttenuation = A.sizeAttenuation),
      (this.fog = A.fog),
      this
    )
  }
}
let xy
const N0 = /* @__PURE__ */ new wA(),
  by = /* @__PURE__ */ new wA(),
  Oy = /* @__PURE__ */ new wA(),
  _y = /* @__PURE__ */ new ZI(),
  F0 = /* @__PURE__ */ new ZI(),
  Cb = /* @__PURE__ */ new RC(),
  $M = /* @__PURE__ */ new wA(),
  R0 = /* @__PURE__ */ new wA(),
  AU = /* @__PURE__ */ new wA(),
  dH = /* @__PURE__ */ new ZI(),
  fK = /* @__PURE__ */ new ZI(),
  yH = /* @__PURE__ */ new ZI()
class eb extends Ci {
  constructor(A = new iv()) {
    if ((super(), (this.isSprite = !0), (this.type = "Sprite"), xy === void 0)) {
      xy = new se()
      const I = new Float32Array([
          -0.5, -0.5, 0, 0, 0, 0.5, -0.5, 0, 1, 0, 0.5, 0.5, 0, 1, 1, -0.5, 0.5, 0, 0, 1,
        ]),
        g = new KG(I, 5)
      ;(xy.setIndex([0, 1, 2, 0, 2, 3]),
        xy.setAttribute("position", new FD(g, 3, 0, !1)),
        xy.setAttribute("uv", new FD(g, 2, 3, !1)))
    }
    ;((this.geometry = xy), (this.material = A), (this.center = new ZI(0.5, 0.5)))
  }
  raycast(A, I) {
    ;(A.camera === null &&
      console.error(
        'THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.',
      ),
      by.setFromMatrixScale(this.matrixWorld),
      Cb.copy(A.camera.matrixWorld),
      this.modelViewMatrix.multiplyMatrices(A.camera.matrixWorldInverse, this.matrixWorld),
      Oy.setFromMatrixPosition(this.modelViewMatrix),
      A.camera.isPerspectiveCamera &&
        this.material.sizeAttenuation === !1 &&
        by.multiplyScalar(-Oy.z))
    const g = this.material.rotation
    let C, i
    g !== 0 && ((i = Math.cos(g)), (C = Math.sin(g)))
    const B = this.center
    ;(IU($M.set(-0.5, -0.5, 0), Oy, B, by, C, i),
      IU(R0.set(0.5, -0.5, 0), Oy, B, by, C, i),
      IU(AU.set(0.5, 0.5, 0), Oy, B, by, C, i),
      dH.set(0, 0),
      fK.set(1, 0),
      yH.set(1, 1))
    let o = A.ray.intersectTriangle($M, R0, AU, !1, N0)
    if (
      o === null &&
      (IU(R0.set(-0.5, 0.5, 0), Oy, B, by, C, i),
      fK.set(0, 1),
      (o = A.ray.intersectTriangle($M, AU, R0, !1, N0)),
      o === null)
    )
      return
    const r = A.ray.origin.distanceTo(N0)
    r < A.near ||
      r > A.far ||
      I.push({
        distance: r,
        point: N0.clone(),
        uv: va.getInterpolation(N0, $M, R0, AU, dH, fK, yH, new ZI()),
        face: null,
        object: this,
      })
  }
  copy(A, I) {
    return (
      super.copy(A, I),
      A.center !== void 0 && this.center.copy(A.center),
      (this.material = A.material),
      this
    )
  }
}
function IU(e, A, I, g, C, i) {
  ;(_y.subVectors(e, I).addScalar(0.5).multiply(g),
    C !== void 0 ? ((F0.x = i * _y.x - C * _y.y), (F0.y = C * _y.x + i * _y.y)) : F0.copy(_y),
    e.copy(A),
    (e.x += F0.x),
    (e.y += F0.y),
    e.applyMatrix4(Cb))
}
const gU = /* @__PURE__ */ new wA(),
  pH = /* @__PURE__ */ new wA()
class ib extends Ci {
  constructor() {
    ;(super(),
      (this._currentLevel = 0),
      (this.type = "LOD"),
      Object.defineProperties(this, {
        levels: {
          enumerable: !0,
          value: [],
        },
        isLOD: {
          value: !0,
        },
      }),
      (this.autoUpdate = !0))
  }
  copy(A) {
    super.copy(A, !1)
    const I = A.levels
    for (let g = 0, C = I.length; g < C; g++) {
      const i = I[g]
      this.addLevel(i.object.clone(), i.distance, i.hysteresis)
    }
    return ((this.autoUpdate = A.autoUpdate), this)
  }
  addLevel(A, I = 0, g = 0) {
    I = Math.abs(I)
    const C = this.levels
    let i
    for (i = 0; i < C.length && !(I < C[i].distance); i++);
    return (C.splice(i, 0, { distance: I, hysteresis: g, object: A }), this.add(A), this)
  }
  removeLevel(A) {
    const I = this.levels
    for (let g = 0; g < I.length; g++)
      if (I[g].distance === A) {
        const C = I.splice(g, 1)
        return (this.remove(C[0].object), !0)
      }
    return !1
  }
  getCurrentLevel() {
    return this._currentLevel
  }
  getObjectForDistance(A) {
    const I = this.levels
    if (I.length > 0) {
      let g, C
      for (g = 1, C = I.length; g < C; g++) {
        let i = I[g].distance
        if ((I[g].object.visible && (i -= i * I[g].hysteresis), A < i)) break
      }
      return I[g - 1].object
    }
    return null
  }
  raycast(A, I) {
    if (this.levels.length > 0) {
      gU.setFromMatrixPosition(this.matrixWorld)
      const C = A.ray.origin.distanceTo(gU)
      this.getObjectForDistance(C).raycast(A, I)
    }
  }
  update(A) {
    const I = this.levels
    if (I.length > 1) {
      ;(gU.setFromMatrixPosition(A.matrixWorld), pH.setFromMatrixPosition(this.matrixWorld))
      const g = gU.distanceTo(pH) / A.zoom
      I[0].object.visible = !0
      let C, i
      for (C = 1, i = I.length; C < i; C++) {
        let B = I[C].distance
        if ((I[C].object.visible && (B -= B * I[C].hysteresis), g >= B))
          ((I[C - 1].object.visible = !1), (I[C].object.visible = !0))
        else break
      }
      for (this._currentLevel = C - 1; C < i; C++) I[C].object.visible = !1
    }
  }
  toJSON(A) {
    const I = super.toJSON(A)
    ;(this.autoUpdate === !1 && (I.object.autoUpdate = !1), (I.object.levels = []))
    const g = this.levels
    for (let C = 0, i = g.length; C < i; C++) {
      const B = g[C]
      I.object.levels.push({
        object: B.object.uuid,
        distance: B.distance,
        hysteresis: B.hysteresis,
      })
    }
    return I
  }
}
const wH = /* @__PURE__ */ new wA(),
  GH = /* @__PURE__ */ new Xe(),
  kH = /* @__PURE__ */ new Xe(),
  y5 = /* @__PURE__ */ new wA(),
  MH = /* @__PURE__ */ new RC(),
  CU = /* @__PURE__ */ new wA(),
  dK = /* @__PURE__ */ new jo(),
  UH = /* @__PURE__ */ new RC(),
  yK = /* @__PURE__ */ new fp()
class tv extends EB {
  constructor(A, I) {
    ;(super(A, I),
      (this.isSkinnedMesh = !0),
      (this.type = "SkinnedMesh"),
      (this.bindMode = cm),
      (this.bindMatrix = new RC()),
      (this.bindMatrixInverse = new RC()),
      (this.boundingBox = null),
      (this.boundingSphere = null))
  }
  computeBoundingBox() {
    const A = this.geometry
    ;(this.boundingBox === null && (this.boundingBox = new Vo()), this.boundingBox.makeEmpty())
    const I = A.getAttribute("position")
    for (let g = 0; g < I.count; g++)
      (this.getVertexPosition(g, CU), this.boundingBox.expandByPoint(CU))
  }
  computeBoundingSphere() {
    const A = this.geometry
    ;(this.boundingSphere === null && (this.boundingSphere = new jo()),
      this.boundingSphere.makeEmpty())
    const I = A.getAttribute("position")
    for (let g = 0; g < I.count; g++)
      (this.getVertexPosition(g, CU), this.boundingSphere.expandByPoint(CU))
  }
  copy(A, I) {
    return (
      super.copy(A, I),
      (this.bindMode = A.bindMode),
      this.bindMatrix.copy(A.bindMatrix),
      this.bindMatrixInverse.copy(A.bindMatrixInverse),
      (this.skeleton = A.skeleton),
      A.boundingBox !== null && (this.boundingBox = A.boundingBox.clone()),
      A.boundingSphere !== null && (this.boundingSphere = A.boundingSphere.clone()),
      this
    )
  }
  raycast(A, I) {
    const g = this.material,
      C = this.matrixWorld
    g !== void 0 &&
      (this.boundingSphere === null && this.computeBoundingSphere(),
      dK.copy(this.boundingSphere),
      dK.applyMatrix4(C),
      A.ray.intersectsSphere(dK) !== !1 &&
        (UH.copy(C).invert(),
        yK.copy(A.ray).applyMatrix4(UH),
        !(this.boundingBox !== null && yK.intersectsBox(this.boundingBox) === !1) &&
          this._computeIntersections(A, I, yK)))
  }
  getVertexPosition(A, I) {
    return (super.getVertexPosition(A, I), this.applyBoneTransform(A, I), I)
  }
  bind(A, I) {
    ;((this.skeleton = A),
      I === void 0 &&
        (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), (I = this.matrixWorld)),
      this.bindMatrix.copy(I),
      this.bindMatrixInverse.copy(I).invert())
  }
  pose() {
    this.skeleton.pose()
  }
  normalizeSkinWeights() {
    const A = new Xe(),
      I = this.geometry.attributes.skinWeight
    for (let g = 0, C = I.count; g < C; g++) {
      A.fromBufferAttribute(I, g)
      const i = 1 / A.manhattanLength()
      ;(i !== 1 / 0 ? A.multiplyScalar(i) : A.set(1, 0, 0, 0), I.setXYZW(g, A.x, A.y, A.z, A.w))
    }
  }
  updateMatrixWorld(A) {
    ;(super.updateMatrixWorld(A),
      this.bindMode === cm
        ? this.bindMatrixInverse.copy(this.matrixWorld).invert()
        : this.bindMode === k2
          ? this.bindMatrixInverse.copy(this.bindMatrix).invert()
          : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode))
  }
  applyBoneTransform(A, I) {
    const g = this.skeleton,
      C = this.geometry
    ;(GH.fromBufferAttribute(C.attributes.skinIndex, A),
      kH.fromBufferAttribute(C.attributes.skinWeight, A),
      wH.copy(I).applyMatrix4(this.bindMatrix),
      I.set(0, 0, 0))
    for (let i = 0; i < 4; i++) {
      const B = kH.getComponent(i)
      if (B !== 0) {
        const o = GH.getComponent(i)
        ;(MH.multiplyMatrices(g.bones[o].matrixWorld, g.boneInverses[o]),
          I.addScaledVector(y5.copy(wH).applyMatrix4(MH), B))
      }
    }
    return I.applyMatrix4(this.bindMatrixInverse)
  }
}
class tF extends Ci {
  constructor() {
    ;(super(), (this.isBone = !0), (this.type = "Bone"))
  }
}
class Oc extends pt {
  constructor(A = null, I = 1, g = 1, C, i, B, o, r, s = iQ, h = iQ, S, d) {
    ;(super(null, B, o, r, s, h, C, i, S, d),
      (this.isDataTexture = !0),
      (this.image = { data: A, width: I, height: g }),
      (this.generateMipmaps = !1),
      (this.flipY = !1),
      (this.unpackAlignment = 1))
  }
}
const NH = /* @__PURE__ */ new RC(),
  p5 = /* @__PURE__ */ new RC()
class mG {
  constructor(A = [], I = []) {
    ;((this.uuid = Lr()),
      (this.bones = A.slice(0)),
      (this.boneInverses = I),
      (this.boneMatrices = null),
      (this.boneTexture = null),
      this.init())
  }
  init() {
    const A = this.bones,
      I = this.boneInverses
    if (((this.boneMatrices = new Float32Array(A.length * 16)), I.length === 0))
      this.calculateInverses()
    else if (A.length !== I.length) {
      ;(console.warn(
        "THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.",
      ),
        (this.boneInverses = []))
      for (let g = 0, C = this.bones.length; g < C; g++) this.boneInverses.push(new RC())
    }
  }
  calculateInverses() {
    this.boneInverses.length = 0
    for (let A = 0, I = this.bones.length; A < I; A++) {
      const g = new RC()
      ;(this.bones[A] && g.copy(this.bones[A].matrixWorld).invert(), this.boneInverses.push(g))
    }
  }
  pose() {
    for (let A = 0, I = this.bones.length; A < I; A++) {
      const g = this.bones[A]
      g && g.matrixWorld.copy(this.boneInverses[A]).invert()
    }
    for (let A = 0, I = this.bones.length; A < I; A++) {
      const g = this.bones[A]
      g &&
        (g.parent && g.parent.isBone
          ? (g.matrix.copy(g.parent.matrixWorld).invert(), g.matrix.multiply(g.matrixWorld))
          : g.matrix.copy(g.matrixWorld),
        g.matrix.decompose(g.position, g.quaternion, g.scale))
    }
  }
  update() {
    const A = this.bones,
      I = this.boneInverses,
      g = this.boneMatrices,
      C = this.boneTexture
    for (let i = 0, B = A.length; i < B; i++) {
      const o = A[i] ? A[i].matrixWorld : p5
      ;(NH.multiplyMatrices(o, I[i]), NH.toArray(g, i * 16))
    }
    C !== null && (C.needsUpdate = !0)
  }
  clone() {
    return new mG(this.bones, this.boneInverses)
  }
  computeBoneTexture() {
    let A = Math.sqrt(this.bones.length * 4)
    ;((A = Math.ceil(A / 4) * 4), (A = Math.max(A, 4)))
    const I = new Float32Array(A * A * 4)
    I.set(this.boneMatrices)
    const g = new Oc(I, A, A, lE, sE)
    return ((g.needsUpdate = !0), (this.boneMatrices = I), (this.boneTexture = g), this)
  }
  getBoneByName(A) {
    for (let I = 0, g = this.bones.length; I < g; I++) {
      const C = this.bones[I]
      if (C.name === A) return C
    }
  }
  dispose() {
    this.boneTexture !== null && (this.boneTexture.dispose(), (this.boneTexture = null))
  }
  fromJSON(A, I) {
    this.uuid = A.uuid
    for (let g = 0, C = A.bones.length; g < C; g++) {
      const i = A.bones[g]
      let B = I[i]
      ;(B === void 0 &&
        (console.warn("THREE.Skeleton: No bone found with UUID:", i), (B = new tF())),
        this.bones.push(B),
        this.boneInverses.push(new RC().fromArray(A.boneInverses[g])))
    }
    return (this.init(), this)
  }
  toJSON() {
    const A = {
      metadata: {
        version: 4.6,
        type: "Skeleton",
        generator: "Skeleton.toJSON",
      },
      bones: [],
      boneInverses: [],
    }
    A.uuid = this.uuid
    const I = this.bones,
      g = this.boneInverses
    for (let C = 0, i = I.length; C < i; C++) {
      const B = I[C]
      A.bones.push(B.uuid)
      const o = g[C]
      A.boneInverses.push(o.toArray())
    }
    return A
  }
}
class RD extends Ye {
  constructor(A, I, g, C = 1) {
    ;(super(A, I, g), (this.isInstancedBufferAttribute = !0), (this.meshPerAttribute = C))
  }
  copy(A) {
    return (super.copy(A), (this.meshPerAttribute = A.meshPerAttribute), this)
  }
  toJSON() {
    const A = super.toJSON()
    return ((A.meshPerAttribute = this.meshPerAttribute), (A.isInstancedBufferAttribute = !0), A)
  }
}
const Zy = /* @__PURE__ */ new RC(),
  FH = /* @__PURE__ */ new RC(),
  eU = [],
  RH = /* @__PURE__ */ new Vo(),
  w5 = /* @__PURE__ */ new RC(),
  J0 = /* @__PURE__ */ new EB(),
  K0 = /* @__PURE__ */ new jo()
class Bv extends EB {
  constructor(A, I, g) {
    ;(super(A, I),
      (this.isInstancedMesh = !0),
      (this.instanceMatrix = new RD(new Float32Array(g * 16), 16)),
      (this.instanceColor = null),
      (this.morphTexture = null),
      (this.count = g),
      (this.boundingBox = null),
      (this.boundingSphere = null))
    for (let C = 0; C < g; C++) this.setMatrixAt(C, w5)
  }
  computeBoundingBox() {
    const A = this.geometry,
      I = this.count
    ;(this.boundingBox === null && (this.boundingBox = new Vo()),
      A.boundingBox === null && A.computeBoundingBox(),
      this.boundingBox.makeEmpty())
    for (let g = 0; g < I; g++)
      (this.getMatrixAt(g, Zy), RH.copy(A.boundingBox).applyMatrix4(Zy), this.boundingBox.union(RH))
  }
  computeBoundingSphere() {
    const A = this.geometry,
      I = this.count
    ;(this.boundingSphere === null && (this.boundingSphere = new jo()),
      A.boundingSphere === null && A.computeBoundingSphere(),
      this.boundingSphere.makeEmpty())
    for (let g = 0; g < I; g++)
      (this.getMatrixAt(g, Zy),
        K0.copy(A.boundingSphere).applyMatrix4(Zy),
        this.boundingSphere.union(K0))
  }
  copy(A, I) {
    return (
      super.copy(A, I),
      this.instanceMatrix.copy(A.instanceMatrix),
      A.morphTexture !== null && (this.morphTexture = A.morphTexture.clone()),
      A.instanceColor !== null && (this.instanceColor = A.instanceColor.clone()),
      (this.count = A.count),
      A.boundingBox !== null && (this.boundingBox = A.boundingBox.clone()),
      A.boundingSphere !== null && (this.boundingSphere = A.boundingSphere.clone()),
      this
    )
  }
  getColorAt(A, I) {
    I.fromArray(this.instanceColor.array, A * 3)
  }
  getMatrixAt(A, I) {
    I.fromArray(this.instanceMatrix.array, A * 16)
  }
  getMorphAt(A, I) {
    const g = I.morphTargetInfluences,
      C = this.morphTexture.source.data.data,
      i = g.length + 1,
      B = A * i + 1
    for (let o = 0; o < g.length; o++) g[o] = C[B + o]
  }
  raycast(A, I) {
    const g = this.matrixWorld,
      C = this.count
    if (
      ((J0.geometry = this.geometry),
      (J0.material = this.material),
      J0.material !== void 0 &&
        (this.boundingSphere === null && this.computeBoundingSphere(),
        K0.copy(this.boundingSphere),
        K0.applyMatrix4(g),
        A.ray.intersectsSphere(K0) !== !1))
    )
      for (let i = 0; i < C; i++) {
        ;(this.getMatrixAt(i, Zy),
          FH.multiplyMatrices(g, Zy),
          (J0.matrixWorld = FH),
          J0.raycast(A, eU))
        for (let B = 0, o = eU.length; B < o; B++) {
          const r = eU[B]
          ;((r.instanceId = i), (r.object = this), I.push(r))
        }
        eU.length = 0
      }
  }
  setColorAt(A, I) {
    ;(this.instanceColor === null &&
      (this.instanceColor = new RD(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3)),
      I.toArray(this.instanceColor.array, A * 3))
  }
  setMatrixAt(A, I) {
    I.toArray(this.instanceMatrix.array, A * 16)
  }
  setMorphAt(A, I) {
    const g = I.morphTargetInfluences,
      C = g.length + 1
    this.morphTexture === null &&
      (this.morphTexture = new Oc(new Float32Array(C * this.count), C, this.count, WN, sE))
    const i = this.morphTexture.source.data.data
    let B = 0
    for (let s = 0; s < g.length; s++) B += g[s]
    const o = this.geometry.morphTargetsRelative ? 1 : 1 - B,
      r = C * A
    ;((i[r] = o), i.set(g, r + 1))
  }
  updateMorphTargets() {}
  dispose() {
    return (
      this.dispatchEvent({ type: "dispose" }),
      this.morphTexture !== null && (this.morphTexture.dispose(), (this.morphTexture = null)),
      this
    )
  }
}
function pK(e, A) {
  return e - A
}
function G5(e, A) {
  return e.z - A.z
}
function k5(e, A) {
  return A.z - e.z
}
class M5 {
  constructor() {
    ;((this.index = 0), (this.pool = []), (this.list = []))
  }
  push(A, I, g, C) {
    const i = this.pool,
      B = this.list
    this.index >= i.length &&
      i.push({
        start: -1,
        count: -1,
        z: -1,
        index: -1,
      })
    const o = i[this.index]
    ;(B.push(o), this.index++, (o.start = A), (o.count = I), (o.z = g), (o.index = C))
  }
  reset() {
    ;((this.list.length = 0), (this.index = 0))
  }
}
const Ka = /* @__PURE__ */ new RC(),
  U5 = /* @__PURE__ */ new Mg(1, 1, 1),
  wK = /* @__PURE__ */ new RG(),
  iU = /* @__PURE__ */ new Vo(),
  Ef = /* @__PURE__ */ new jo(),
  m0 = /* @__PURE__ */ new wA(),
  JH = /* @__PURE__ */ new wA(),
  N5 = /* @__PURE__ */ new wA(),
  GK = /* @__PURE__ */ new M5(),
  aE = /* @__PURE__ */ new EB(),
  tU = []
function F5(e, A, I = 0) {
  const g = A.itemSize
  if (e.isInterleavedBufferAttribute || e.array.constructor !== A.array.constructor) {
    const C = e.count
    for (let i = 0; i < C; i++)
      for (let B = 0; B < g; B++) A.setComponent(i + I, B, e.getComponent(i, B))
  } else A.array.set(e.array, I * g)
  A.needsUpdate = !0
}
function af(e, A) {
  if (e.constructor !== A.constructor) {
    const I = Math.min(e.length, A.length)
    for (let g = 0; g < I; g++) A[g] = e[g]
  } else {
    const I = Math.min(e.length, A.length)
    A.set(new e.constructor(e.buffer, 0, I))
  }
}
class tb extends EB {
  get maxInstanceCount() {
    return this._maxInstanceCount
  }
  get instanceCount() {
    return this._instanceInfo.length - this._availableInstanceIds.length
  }
  get unusedVertexCount() {
    return this._maxVertexCount - this._nextVertexStart
  }
  get unusedIndexCount() {
    return this._maxIndexCount - this._nextIndexStart
  }
  constructor(A, I, g = I * 2, C) {
    ;(super(new se(), C),
      (this.isBatchedMesh = !0),
      (this.perObjectFrustumCulled = !0),
      (this.sortObjects = !0),
      (this.boundingBox = null),
      (this.boundingSphere = null),
      (this.customSort = null),
      (this._instanceInfo = []),
      (this._geometryInfo = []),
      (this._availableInstanceIds = []),
      (this._availableGeometryIds = []),
      (this._nextIndexStart = 0),
      (this._nextVertexStart = 0),
      (this._geometryCount = 0),
      (this._visibilityChanged = !0),
      (this._geometryInitialized = !1),
      (this._maxInstanceCount = A),
      (this._maxVertexCount = I),
      (this._maxIndexCount = g),
      (this._multiDrawCounts = new Int32Array(A)),
      (this._multiDrawStarts = new Int32Array(A)),
      (this._multiDrawCount = 0),
      (this._multiDrawInstances = null),
      (this._matricesTexture = null),
      (this._indirectTexture = null),
      (this._colorsTexture = null),
      this._initMatricesTexture(),
      this._initIndirectTexture())
  }
  _initMatricesTexture() {
    let A = Math.sqrt(this._maxInstanceCount * 4)
    ;((A = Math.ceil(A / 4) * 4), (A = Math.max(A, 4)))
    const I = new Float32Array(A * A * 4),
      g = new Oc(I, A, A, lE, sE)
    this._matricesTexture = g
  }
  _initIndirectTexture() {
    let A = Math.sqrt(this._maxInstanceCount)
    A = Math.ceil(A)
    const I = new Uint32Array(A * A),
      g = new Oc(I, A, A, UG, Zc)
    this._indirectTexture = g
  }
  _initColorsTexture() {
    let A = Math.sqrt(this._maxInstanceCount)
    A = Math.ceil(A)
    const I = new Float32Array(A * A * 4).fill(1),
      g = new Oc(I, A, A, lE, sE)
    ;((g.colorSpace = ni.workingColorSpace), (this._colorsTexture = g))
  }
  _initializeGeometry(A) {
    const I = this.geometry,
      g = this._maxVertexCount,
      C = this._maxIndexCount
    if (this._geometryInitialized === !1) {
      for (const i in A.attributes) {
        const B = A.getAttribute(i),
          { array: o, itemSize: r, normalized: s } = B,
          h = new o.constructor(g * r),
          S = new Ye(h, r, s)
        I.setAttribute(i, S)
      }
      if (A.getIndex() !== null) {
        const i = g > 65535 ? new Uint32Array(C) : new Uint16Array(C)
        I.setIndex(new Ye(i, 1))
      }
      this._geometryInitialized = !0
    }
  }
  // Make sure the geometry is compatible with the existing combined geometry attributes
  _validateGeometry(A) {
    const I = this.geometry
    if (!!A.getIndex() != !!I.getIndex())
      throw new Error('BatchedMesh: All geometries must consistently have "index".')
    for (const g in I.attributes) {
      if (!A.hasAttribute(g))
        throw new Error(
          `BatchedMesh: Added geometry missing "${g}". All geometries must have consistent attributes.`,
        )
      const C = A.getAttribute(g),
        i = I.getAttribute(g)
      if (C.itemSize !== i.itemSize || C.normalized !== i.normalized)
        throw new Error(
          "BatchedMesh: All attributes must have a consistent itemSize and normalized value.",
        )
    }
  }
  setCustomSort(A) {
    return ((this.customSort = A), this)
  }
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new Vo())
    const A = this.boundingBox,
      I = this._instanceInfo
    A.makeEmpty()
    for (let g = 0, C = I.length; g < C; g++) {
      if (I[g].active === !1) continue
      const i = I[g].geometryIndex
      ;(this.getMatrixAt(g, Ka), this.getBoundingBoxAt(i, iU).applyMatrix4(Ka), A.union(iU))
    }
  }
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new jo())
    const A = this.boundingSphere,
      I = this._instanceInfo
    A.makeEmpty()
    for (let g = 0, C = I.length; g < C; g++) {
      if (I[g].active === !1) continue
      const i = I[g].geometryIndex
      ;(this.getMatrixAt(g, Ka), this.getBoundingSphereAt(i, Ef).applyMatrix4(Ka), A.union(Ef))
    }
  }
  addInstance(A) {
    if (
      this._instanceInfo.length >= this.maxInstanceCount &&
      this._availableInstanceIds.length === 0
    )
      throw new Error("BatchedMesh: Maximum item count reached.")
    const g = {
      visible: !0,
      active: !0,
      geometryIndex: A,
    }
    let C = null
    this._availableInstanceIds.length > 0
      ? (this._availableInstanceIds.sort(pK),
        (C = this._availableInstanceIds.shift()),
        (this._instanceInfo[C] = g))
      : ((C = this._instanceInfo.length), this._instanceInfo.push(g))
    const i = this._matricesTexture
    ;(Ka.identity().toArray(i.image.data, C * 16), (i.needsUpdate = !0))
    const B = this._colorsTexture
    return (
      B && (U5.toArray(B.image.data, C * 4), (B.needsUpdate = !0)),
      (this._visibilityChanged = !0),
      C
    )
  }
  addGeometry(A, I = -1, g = -1) {
    ;(this._initializeGeometry(A), this._validateGeometry(A))
    const C = {
        // geometry information
        vertexStart: -1,
        vertexCount: -1,
        reservedVertexCount: -1,
        indexStart: -1,
        indexCount: -1,
        reservedIndexCount: -1,
        // draw range information
        start: -1,
        count: -1,
        // state
        boundingBox: null,
        boundingSphere: null,
        active: !0,
      },
      i = this._geometryInfo
    ;((C.vertexStart = this._nextVertexStart),
      (C.reservedVertexCount = I === -1 ? A.getAttribute("position").count : I))
    const B = A.getIndex()
    if (
      (B !== null &&
        ((C.indexStart = this._nextIndexStart), (C.reservedIndexCount = g === -1 ? B.count : g)),
      (C.indexStart !== -1 && C.indexStart + C.reservedIndexCount > this._maxIndexCount) ||
        C.vertexStart + C.reservedVertexCount > this._maxVertexCount)
    )
      throw new Error("BatchedMesh: Reserved space request exceeds the maximum buffer size.")
    let r
    return (
      this._availableGeometryIds.length > 0
        ? (this._availableGeometryIds.sort(pK),
          (r = this._availableGeometryIds.shift()),
          (i[r] = C))
        : ((r = this._geometryCount), this._geometryCount++, i.push(C)),
      this.setGeometryAt(r, A),
      (this._nextIndexStart = C.indexStart + C.reservedIndexCount),
      (this._nextVertexStart = C.vertexStart + C.reservedVertexCount),
      r
    )
  }
  setGeometryAt(A, I) {
    if (A >= this._geometryCount) throw new Error("BatchedMesh: Maximum geometry count reached.")
    this._validateGeometry(I)
    const g = this.geometry,
      C = g.getIndex() !== null,
      i = g.getIndex(),
      B = I.getIndex(),
      o = this._geometryInfo[A]
    if (
      (C && B.count > o.reservedIndexCount) ||
      I.attributes.position.count > o.reservedVertexCount
    )
      throw new Error("BatchedMesh: Reserved space not large enough for provided geometry.")
    const r = o.vertexStart,
      s = o.reservedVertexCount
    o.vertexCount = I.getAttribute("position").count
    for (const h in g.attributes) {
      const S = I.getAttribute(h),
        d = g.getAttribute(h)
      F5(S, d, r)
      const w = S.itemSize
      for (let M = S.count, K = s; M < K; M++) {
        const R = r + M
        for (let F = 0; F < w; F++) d.setComponent(R, F, 0)
      }
      ;((d.needsUpdate = !0), d.addUpdateRange(r * w, s * w))
    }
    if (C) {
      const h = o.indexStart,
        S = o.reservedIndexCount
      o.indexCount = I.getIndex().count
      for (let d = 0; d < B.count; d++) i.setX(h + d, r + B.getX(d))
      for (let d = B.count, w = S; d < w; d++) i.setX(h + d, r)
      ;((i.needsUpdate = !0), i.addUpdateRange(h, o.reservedIndexCount))
    }
    return (
      (o.start = C ? o.indexStart : o.vertexStart),
      (o.count = C ? o.indexCount : o.vertexCount),
      (o.boundingBox = null),
      I.boundingBox !== null && (o.boundingBox = I.boundingBox.clone()),
      (o.boundingSphere = null),
      I.boundingSphere !== null && (o.boundingSphere = I.boundingSphere.clone()),
      (this._visibilityChanged = !0),
      A
    )
  }
  deleteGeometry(A) {
    const I = this._geometryInfo
    if (A >= I.length || I[A].active === !1) return this
    const g = this._instanceInfo
    for (let C = 0, i = g.length; C < i; C++) g[C].geometryIndex === A && this.deleteInstance(C)
    return (
      (I[A].active = !1),
      this._availableGeometryIds.push(A),
      (this._visibilityChanged = !0),
      this
    )
  }
  deleteInstance(A) {
    const I = this._instanceInfo
    return A >= I.length || I[A].active === !1
      ? this
      : ((I[A].active = !1),
        this._availableInstanceIds.push(A),
        (this._visibilityChanged = !0),
        this)
  }
  optimize() {
    let A = 0,
      I = 0
    const g = this._geometryInfo,
      C = g.map((B, o) => o).sort((B, o) => g[B].vertexStart - g[o].vertexStart),
      i = this.geometry
    for (let B = 0, o = g.length; B < o; B++) {
      const r = C[B],
        s = g[r]
      if (s.active !== !1) {
        if (i.index !== null) {
          if (s.indexStart !== I) {
            const { indexStart: h, vertexStart: S, reservedIndexCount: d } = s,
              w = i.index,
              M = w.array,
              K = A - S
            for (let R = h; R < h + d; R++) M[R] = M[R] + K
            ;(w.array.copyWithin(I, h, h + d), w.addUpdateRange(I, d), (s.indexStart = I))
          }
          I += s.reservedIndexCount
        }
        if (s.vertexStart !== A) {
          const { vertexStart: h, reservedVertexCount: S } = s,
            d = i.attributes
          for (const w in d) {
            const M = d[w],
              { array: K, itemSize: R } = M
            ;(K.copyWithin(A * R, h * R, (h + S) * R), M.addUpdateRange(A * R, S * R))
          }
          s.vertexStart = A
        }
        ;((A += s.reservedVertexCount),
          (s.start = i.index ? s.indexStart : s.vertexStart),
          (this._nextIndexStart = i.index ? s.indexStart + s.reservedIndexCount : 0),
          (this._nextVertexStart = s.vertexStart + s.reservedVertexCount))
      }
    }
    return this
  }
  // get bounding box and compute it if it doesn't exist
  getBoundingBoxAt(A, I) {
    if (A >= this._geometryCount) return null
    const g = this.geometry,
      C = this._geometryInfo[A]
    if (C.boundingBox === null) {
      const i = new Vo(),
        B = g.index,
        o = g.attributes.position
      for (let r = C.start, s = C.start + C.count; r < s; r++) {
        let h = r
        ;(B && (h = B.getX(h)), i.expandByPoint(m0.fromBufferAttribute(o, h)))
      }
      C.boundingBox = i
    }
    return (I.copy(C.boundingBox), I)
  }
  // get bounding sphere and compute it if it doesn't exist
  getBoundingSphereAt(A, I) {
    if (A >= this._geometryCount) return null
    const g = this.geometry,
      C = this._geometryInfo[A]
    if (C.boundingSphere === null) {
      const i = new jo()
      ;(this.getBoundingBoxAt(A, iU), iU.getCenter(i.center))
      const B = g.index,
        o = g.attributes.position
      let r = 0
      for (let s = C.start, h = C.start + C.count; s < h; s++) {
        let S = s
        ;(B && (S = B.getX(S)),
          m0.fromBufferAttribute(o, S),
          (r = Math.max(r, i.center.distanceToSquared(m0))))
      }
      ;((i.radius = Math.sqrt(r)), (C.boundingSphere = i))
    }
    return (I.copy(C.boundingSphere), I)
  }
  setMatrixAt(A, I) {
    const g = this._instanceInfo,
      C = this._matricesTexture,
      i = this._matricesTexture.image.data
    return A >= g.length || g[A].active === !1
      ? this
      : (I.toArray(i, A * 16), (C.needsUpdate = !0), this)
  }
  getMatrixAt(A, I) {
    const g = this._instanceInfo,
      C = this._matricesTexture.image.data
    return A >= g.length || g[A].active === !1 ? null : I.fromArray(C, A * 16)
  }
  setColorAt(A, I) {
    this._colorsTexture === null && this._initColorsTexture()
    const g = this._colorsTexture,
      C = this._colorsTexture.image.data,
      i = this._instanceInfo
    return A >= i.length || i[A].active === !1
      ? this
      : (I.toArray(C, A * 4), (g.needsUpdate = !0), this)
  }
  getColorAt(A, I) {
    const g = this._colorsTexture.image.data,
      C = this._instanceInfo
    return A >= C.length || C[A].active === !1 ? null : I.fromArray(g, A * 4)
  }
  setVisibleAt(A, I) {
    const g = this._instanceInfo
    return A >= g.length || g[A].active === !1 || g[A].visible === I
      ? this
      : ((g[A].visible = I), (this._visibilityChanged = !0), this)
  }
  getVisibleAt(A) {
    const I = this._instanceInfo
    return A >= I.length || I[A].active === !1 ? !1 : I[A].visible
  }
  setGeometryIdAt(A, I) {
    const g = this._instanceInfo,
      C = this._geometryInfo
    return A >= g.length || g[A].active === !1 || I >= C.length || C[I].active === !1
      ? null
      : ((g[A].geometryIndex = I), this)
  }
  getGeometryIdAt(A) {
    const I = this._instanceInfo
    return A >= I.length || I[A].active === !1 ? -1 : I[A].geometryIndex
  }
  getGeometryRangeAt(A, I = {}) {
    if (A < 0 || A >= this._geometryCount) return null
    const g = this._geometryInfo[A]
    return (
      (I.vertexStart = g.vertexStart),
      (I.vertexCount = g.vertexCount),
      (I.reservedVertexCount = g.reservedVertexCount),
      (I.indexStart = g.indexStart),
      (I.indexCount = g.indexCount),
      (I.reservedIndexCount = g.reservedIndexCount),
      (I.start = g.start),
      (I.count = g.count),
      I
    )
  }
  setInstanceCount(A) {
    const I = this._availableInstanceIds,
      g = this._instanceInfo
    for (I.sort(pK); I[I.length - 1] === g.length; ) (g.pop(), I.pop())
    if (A < g.length)
      throw new Error(
        `BatchedMesh: Instance ids outside the range ${A} are being used. Cannot shrink instance count.`,
      )
    const C = new Int32Array(A),
      i = new Int32Array(A)
    ;(af(this._multiDrawCounts, C),
      af(this._multiDrawStarts, i),
      (this._multiDrawCounts = C),
      (this._multiDrawStarts = i),
      (this._maxInstanceCount = A))
    const B = this._indirectTexture,
      o = this._matricesTexture,
      r = this._colorsTexture
    ;(B.dispose(),
      this._initIndirectTexture(),
      af(B.image.data, this._indirectTexture.image.data),
      o.dispose(),
      this._initMatricesTexture(),
      af(o.image.data, this._matricesTexture.image.data),
      r &&
        (r.dispose(), this._initColorsTexture(), af(r.image.data, this._colorsTexture.image.data)))
  }
  setGeometrySize(A, I) {
    const g = [...this._geometryInfo].filter((o) => o.active)
    if (Math.max(...g.map((o) => o.vertexStart + o.reservedVertexCount)) > A)
      throw new Error(
        `BatchedMesh: Geometry vertex values are being used outside the range ${I}. Cannot shrink further.`,
      )
    if (this.geometry.index && Math.max(...g.map((r) => r.indexStart + r.reservedIndexCount)) > I)
      throw new Error(
        `BatchedMesh: Geometry index values are being used outside the range ${I}. Cannot shrink further.`,
      )
    const i = this.geometry
    ;(i.dispose(),
      (this._maxVertexCount = A),
      (this._maxIndexCount = I),
      this._geometryInitialized &&
        ((this._geometryInitialized = !1), (this.geometry = new se()), this._initializeGeometry(i)))
    const B = this.geometry
    i.index && af(i.index.array, B.index.array)
    for (const o in i.attributes) af(i.attributes[o].array, B.attributes[o].array)
  }
  raycast(A, I) {
    const g = this._instanceInfo,
      C = this._geometryInfo,
      i = this.matrixWorld,
      B = this.geometry
    ;((aE.material = this.material),
      (aE.geometry.index = B.index),
      (aE.geometry.attributes = B.attributes),
      aE.geometry.boundingBox === null && (aE.geometry.boundingBox = new Vo()),
      aE.geometry.boundingSphere === null && (aE.geometry.boundingSphere = new jo()))
    for (let o = 0, r = g.length; o < r; o++) {
      if (!g[o].visible || !g[o].active) continue
      const s = g[o].geometryIndex,
        h = C[s]
      ;(aE.geometry.setDrawRange(h.start, h.count),
        this.getMatrixAt(o, aE.matrixWorld).premultiply(i),
        this.getBoundingBoxAt(s, aE.geometry.boundingBox),
        this.getBoundingSphereAt(s, aE.geometry.boundingSphere),
        aE.raycast(A, tU))
      for (let S = 0, d = tU.length; S < d; S++) {
        const w = tU[S]
        ;((w.object = this), (w.batchId = o), I.push(w))
      }
      tU.length = 0
    }
    ;((aE.material = null),
      (aE.geometry.index = null),
      (aE.geometry.attributes = {}),
      aE.geometry.setDrawRange(0, 1 / 0))
  }
  copy(A) {
    return (
      super.copy(A),
      (this.geometry = A.geometry.clone()),
      (this.perObjectFrustumCulled = A.perObjectFrustumCulled),
      (this.sortObjects = A.sortObjects),
      (this.boundingBox = A.boundingBox !== null ? A.boundingBox.clone() : null),
      (this.boundingSphere = A.boundingSphere !== null ? A.boundingSphere.clone() : null),
      (this._geometryInfo = A._geometryInfo.map((I) => ({
        ...I,
        boundingBox: I.boundingBox !== null ? I.boundingBox.clone() : null,
        boundingSphere: I.boundingSphere !== null ? I.boundingSphere.clone() : null,
      }))),
      (this._instanceInfo = A._instanceInfo.map((I) => ({ ...I }))),
      (this._maxInstanceCount = A._maxInstanceCount),
      (this._maxVertexCount = A._maxVertexCount),
      (this._maxIndexCount = A._maxIndexCount),
      (this._geometryInitialized = A._geometryInitialized),
      (this._geometryCount = A._geometryCount),
      (this._multiDrawCounts = A._multiDrawCounts.slice()),
      (this._multiDrawStarts = A._multiDrawStarts.slice()),
      (this._matricesTexture = A._matricesTexture.clone()),
      (this._matricesTexture.image.data = this._matricesTexture.image.data.slice()),
      this._colorsTexture !== null &&
        ((this._colorsTexture = A._colorsTexture.clone()),
        (this._colorsTexture.image.data = this._colorsTexture.image.data.slice())),
      this
    )
  }
  dispose() {
    return (
      this.geometry.dispose(),
      this._matricesTexture.dispose(),
      (this._matricesTexture = null),
      this._indirectTexture.dispose(),
      (this._indirectTexture = null),
      this._colorsTexture !== null && (this._colorsTexture.dispose(), (this._colorsTexture = null)),
      this
    )
  }
  onBeforeRender(A, I, g, C, i) {
    if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return
    const B = C.getIndex(),
      o = B === null ? 1 : B.array.BYTES_PER_ELEMENT,
      r = this._instanceInfo,
      s = this._multiDrawStarts,
      h = this._multiDrawCounts,
      S = this._geometryInfo,
      d = this.perObjectFrustumCulled,
      w = this._indirectTexture,
      M = w.image.data
    d &&
      (Ka.multiplyMatrices(g.projectionMatrix, g.matrixWorldInverse).multiply(this.matrixWorld),
      wK.setFromProjectionMatrix(Ka, A.coordinateSystem))
    let K = 0
    if (this.sortObjects) {
      ;(Ka.copy(this.matrixWorld).invert(),
        m0.setFromMatrixPosition(g.matrixWorld).applyMatrix4(Ka),
        JH.set(0, 0, -1).transformDirection(g.matrixWorld).transformDirection(Ka))
      for (let L = 0, Y = r.length; L < Y; L++)
        if (r[L].visible && r[L].active) {
          const H = r[L].geometryIndex
          ;(this.getMatrixAt(L, Ka), this.getBoundingSphereAt(H, Ef).applyMatrix4(Ka))
          let V = !1
          if ((d && (V = !wK.intersectsSphere(Ef)), !V)) {
            const j = S[H],
              P = N5.subVectors(Ef.center, m0).dot(JH)
            GK.push(j.start, j.count, P, L)
          }
        }
      const R = GK.list,
        F = this.customSort
      F === null ? R.sort(i.transparent ? k5 : G5) : F.call(this, R, g)
      for (let L = 0, Y = R.length; L < Y; L++) {
        const H = R[L]
        ;((s[K] = H.start * o), (h[K] = H.count), (M[K] = H.index), K++)
      }
      GK.reset()
    } else
      for (let R = 0, F = r.length; R < F; R++)
        if (r[R].visible && r[R].active) {
          const L = r[R].geometryIndex
          let Y = !1
          if (
            (d &&
              (this.getMatrixAt(R, Ka),
              this.getBoundingSphereAt(L, Ef).applyMatrix4(Ka),
              (Y = !wK.intersectsSphere(Ef))),
            !Y)
          ) {
            const H = S[L]
            ;((s[K] = H.start * o), (h[K] = H.count), (M[K] = R), K++)
          }
        }
    ;((w.needsUpdate = !0), (this._multiDrawCount = K), (this._visibilityChanged = !1))
  }
  onBeforeShadow(A, I, g, C, i, B) {
    this.onBeforeRender(A, null, C, i, B)
  }
}
class DE extends tQ {
  static get type() {
    return "LineBasicMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isLineBasicMaterial = !0),
      (this.color = new Mg(16777215)),
      (this.map = null),
      (this.linewidth = 1),
      (this.linecap = "round"),
      (this.linejoin = "round"),
      (this.fog = !0),
      this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      this.color.copy(A.color),
      (this.map = A.map),
      (this.linewidth = A.linewidth),
      (this.linecap = A.linecap),
      (this.linejoin = A.linejoin),
      (this.fog = A.fog),
      this
    )
  }
}
const dN = /* @__PURE__ */ new wA(),
  yN = /* @__PURE__ */ new wA(),
  KH = /* @__PURE__ */ new RC(),
  v0 = /* @__PURE__ */ new fp(),
  BU = /* @__PURE__ */ new jo(),
  kK = /* @__PURE__ */ new wA(),
  mH = /* @__PURE__ */ new wA()
class Qu extends Ci {
  constructor(A = new se(), I = new DE()) {
    ;(super(),
      (this.isLine = !0),
      (this.type = "Line"),
      (this.geometry = A),
      (this.material = I),
      this.updateMorphTargets())
  }
  copy(A, I) {
    return (
      super.copy(A, I),
      (this.material = Array.isArray(A.material) ? A.material.slice() : A.material),
      (this.geometry = A.geometry),
      this
    )
  }
  computeLineDistances() {
    const A = this.geometry
    if (A.index === null) {
      const I = A.attributes.position,
        g = [0]
      for (let C = 1, i = I.count; C < i; C++)
        (dN.fromBufferAttribute(I, C - 1),
          yN.fromBufferAttribute(I, C),
          (g[C] = g[C - 1]),
          (g[C] += dN.distanceTo(yN)))
      A.setAttribute("lineDistance", new aC(g, 1))
    } else
      console.warn(
        "THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.",
      )
    return this
  }
  raycast(A, I) {
    const g = this.geometry,
      C = this.matrixWorld,
      i = A.params.Line.threshold,
      B = g.drawRange
    if (
      (g.boundingSphere === null && g.computeBoundingSphere(),
      BU.copy(g.boundingSphere),
      BU.applyMatrix4(C),
      (BU.radius += i),
      A.ray.intersectsSphere(BU) === !1)
    )
      return
    ;(KH.copy(C).invert(), v0.copy(A.ray).applyMatrix4(KH))
    const o = i / ((this.scale.x + this.scale.y + this.scale.z) / 3),
      r = o * o,
      s = this.isLineSegments ? 2 : 1,
      h = g.index,
      d = g.attributes.position
    if (h !== null) {
      const w = Math.max(0, B.start),
        M = Math.min(h.count, B.start + B.count)
      for (let K = w, R = M - 1; K < R; K += s) {
        const F = h.getX(K),
          L = h.getX(K + 1),
          Y = QU(this, A, v0, r, F, L)
        Y && I.push(Y)
      }
      if (this.isLineLoop) {
        const K = h.getX(M - 1),
          R = h.getX(w),
          F = QU(this, A, v0, r, K, R)
        F && I.push(F)
      }
    } else {
      const w = Math.max(0, B.start),
        M = Math.min(d.count, B.start + B.count)
      for (let K = w, R = M - 1; K < R; K += s) {
        const F = QU(this, A, v0, r, K, K + 1)
        F && I.push(F)
      }
      if (this.isLineLoop) {
        const K = QU(this, A, v0, r, M - 1, w)
        K && I.push(K)
      }
    }
  }
  updateMorphTargets() {
    const I = this.geometry.morphAttributes,
      g = Object.keys(I)
    if (g.length > 0) {
      const C = I[g[0]]
      if (C !== void 0) {
        ;((this.morphTargetInfluences = []), (this.morphTargetDictionary = {}))
        for (let i = 0, B = C.length; i < B; i++) {
          const o = C[i].name || String(i)
          ;(this.morphTargetInfluences.push(0), (this.morphTargetDictionary[o] = i))
        }
      }
    }
  }
}
function QU(e, A, I, g, C, i) {
  const B = e.geometry.attributes.position
  if (
    (dN.fromBufferAttribute(B, C),
    yN.fromBufferAttribute(B, i),
    I.distanceSqToSegment(dN, yN, kK, mH) > g)
  )
    return
  kK.applyMatrix4(e.matrixWorld)
  const r = A.ray.origin.distanceTo(kK)
  if (!(r < A.near || r > A.far))
    return {
      distance: r,
      // What do we want? intersection point on the ray or on the segment??
      // point: raycaster.ray.at( distance ),
      point: mH.clone().applyMatrix4(e.matrixWorld),
      index: C,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: e,
    }
}
const vH = /* @__PURE__ */ new wA(),
  LH = /* @__PURE__ */ new wA()
class Ul extends Qu {
  constructor(A, I) {
    ;(super(A, I), (this.isLineSegments = !0), (this.type = "LineSegments"))
  }
  computeLineDistances() {
    const A = this.geometry
    if (A.index === null) {
      const I = A.attributes.position,
        g = []
      for (let C = 0, i = I.count; C < i; C += 2)
        (vH.fromBufferAttribute(I, C),
          LH.fromBufferAttribute(I, C + 1),
          (g[C] = C === 0 ? 0 : g[C - 1]),
          (g[C + 1] = g[C] + vH.distanceTo(LH)))
      A.setAttribute("lineDistance", new aC(g, 1))
    } else
      console.warn(
        "THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.",
      )
    return this
  }
}
class Qv extends Qu {
  constructor(A, I) {
    ;(super(A, I), (this.isLineLoop = !0), (this.type = "LineLoop"))
  }
}
class BF extends tQ {
  static get type() {
    return "PointsMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isPointsMaterial = !0),
      (this.color = new Mg(16777215)),
      (this.map = null),
      (this.alphaMap = null),
      (this.size = 1),
      (this.sizeAttenuation = !0),
      (this.fog = !0),
      this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      this.color.copy(A.color),
      (this.map = A.map),
      (this.alphaMap = A.alphaMap),
      (this.size = A.size),
      (this.sizeAttenuation = A.sizeAttenuation),
      (this.fog = A.fog),
      this
    )
  }
}
const YH = /* @__PURE__ */ new RC(),
  dm = /* @__PURE__ */ new fp(),
  oU = /* @__PURE__ */ new jo(),
  nU = /* @__PURE__ */ new wA()
class ov extends Ci {
  constructor(A = new se(), I = new BF()) {
    ;(super(),
      (this.isPoints = !0),
      (this.type = "Points"),
      (this.geometry = A),
      (this.material = I),
      this.updateMorphTargets())
  }
  copy(A, I) {
    return (
      super.copy(A, I),
      (this.material = Array.isArray(A.material) ? A.material.slice() : A.material),
      (this.geometry = A.geometry),
      this
    )
  }
  raycast(A, I) {
    const g = this.geometry,
      C = this.matrixWorld,
      i = A.params.Points.threshold,
      B = g.drawRange
    if (
      (g.boundingSphere === null && g.computeBoundingSphere(),
      oU.copy(g.boundingSphere),
      oU.applyMatrix4(C),
      (oU.radius += i),
      A.ray.intersectsSphere(oU) === !1)
    )
      return
    ;(YH.copy(C).invert(), dm.copy(A.ray).applyMatrix4(YH))
    const o = i / ((this.scale.x + this.scale.y + this.scale.z) / 3),
      r = o * o,
      s = g.index,
      S = g.attributes.position
    if (s !== null) {
      const d = Math.max(0, B.start),
        w = Math.min(s.count, B.start + B.count)
      for (let M = d, K = w; M < K; M++) {
        const R = s.getX(M)
        ;(nU.fromBufferAttribute(S, R), qH(nU, R, r, C, A, I, this))
      }
    } else {
      const d = Math.max(0, B.start),
        w = Math.min(S.count, B.start + B.count)
      for (let M = d, K = w; M < K; M++) (nU.fromBufferAttribute(S, M), qH(nU, M, r, C, A, I, this))
    }
  }
  updateMorphTargets() {
    const I = this.geometry.morphAttributes,
      g = Object.keys(I)
    if (g.length > 0) {
      const C = I[g[0]]
      if (C !== void 0) {
        ;((this.morphTargetInfluences = []), (this.morphTargetDictionary = {}))
        for (let i = 0, B = C.length; i < B; i++) {
          const o = C[i].name || String(i)
          ;(this.morphTargetInfluences.push(0), (this.morphTargetDictionary[o] = i))
        }
      }
    }
  }
}
function qH(e, A, I, g, C, i, B) {
  const o = dm.distanceSqToPoint(e)
  if (o < I) {
    const r = new wA()
    ;(dm.closestPointToPoint(e, r), r.applyMatrix4(g))
    const s = C.ray.origin.distanceTo(r)
    if (s < C.near || s > C.far) return
    i.push({
      distance: s,
      distanceToRay: Math.sqrt(o),
      point: r,
      index: A,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: B,
    })
  }
}
class R5 extends pt {
  constructor(A, I, g, C, i, B, o, r, s) {
    ;(super(A, I, g, C, i, B, o, r, s),
      (this.isVideoTexture = !0),
      (this.minFilter = B !== void 0 ? B : nt),
      (this.magFilter = i !== void 0 ? i : nt),
      (this.generateMipmaps = !1))
    const h = this
    function S() {
      ;((h.needsUpdate = !0), A.requestVideoFrameCallback(S))
    }
    "requestVideoFrameCallback" in A && A.requestVideoFrameCallback(S)
  }
  clone() {
    return new this.constructor(this.image).copy(this)
  }
  update() {
    const A = this.image
    "requestVideoFrameCallback" in A === !1 &&
      A.readyState >= A.HAVE_CURRENT_DATA &&
      (this.needsUpdate = !0)
  }
}
class J5 extends pt {
  constructor(A, I) {
    ;(super({ width: A, height: I }),
      (this.isFramebufferTexture = !0),
      (this.magFilter = iQ),
      (this.minFilter = iQ),
      (this.generateMipmaps = !1),
      (this.needsUpdate = !0))
  }
}
class QF extends pt {
  constructor(A, I, g, C, i, B, o, r, s, h, S, d) {
    ;(super(null, B, o, r, s, h, C, i, S, d),
      (this.isCompressedTexture = !0),
      (this.image = { width: I, height: g }),
      (this.mipmaps = A),
      (this.flipY = !1),
      (this.generateMipmaps = !1))
  }
}
class K5 extends QF {
  constructor(A, I, g, C, i, B) {
    ;(super(A, I, g, i, B),
      (this.isCompressedArrayTexture = !0),
      (this.image.depth = C),
      (this.wrapR = vr),
      (this.layerUpdates = /* @__PURE__ */ new Set()))
  }
  addLayerUpdate(A) {
    this.layerUpdates.add(A)
  }
  clearLayerUpdates() {
    this.layerUpdates.clear()
  }
}
class m5 extends QF {
  constructor(A, I, g) {
    ;(super(void 0, A[0].width, A[0].height, I, g, Bu),
      (this.isCompressedCubeTexture = !0),
      (this.isCubeTexture = !0),
      (this.image = A))
  }
}
class v5 extends pt {
  constructor(A, I, g, C, i, B, o, r, s) {
    ;(super(A, I, g, C, i, B, o, r, s), (this.isCanvasTexture = !0), (this.needsUpdate = !0))
  }
}
class Nl {
  constructor() {
    ;((this.type = "Curve"), (this.arcLengthDivisions = 200))
  }
  // Virtual base class method to overwrite and implement in subclasses
  //	- t [0 .. 1]
  getPoint() {
    return (console.warn("THREE.Curve: .getPoint() not implemented."), null)
  }
  // Get point at relative position in curve according to arc length
  // - u [0 .. 1]
  getPointAt(A, I) {
    const g = this.getUtoTmapping(A)
    return this.getPoint(g, I)
  }
  // Get sequence of points using getPoint( t )
  getPoints(A = 5) {
    const I = []
    for (let g = 0; g <= A; g++) I.push(this.getPoint(g / A))
    return I
  }
  // Get sequence of points using getPointAt( u )
  getSpacedPoints(A = 5) {
    const I = []
    for (let g = 0; g <= A; g++) I.push(this.getPointAt(g / A))
    return I
  }
  // Get total curve arc length
  getLength() {
    const A = this.getLengths()
    return A[A.length - 1]
  }
  // Get list of cumulative segment lengths
  getLengths(A = this.arcLengthDivisions) {
    if (this.cacheArcLengths && this.cacheArcLengths.length === A + 1 && !this.needsUpdate)
      return this.cacheArcLengths
    this.needsUpdate = !1
    const I = []
    let g,
      C = this.getPoint(0),
      i = 0
    I.push(0)
    for (let B = 1; B <= A; B++)
      ((g = this.getPoint(B / A)), (i += g.distanceTo(C)), I.push(i), (C = g))
    return ((this.cacheArcLengths = I), I)
  }
  updateArcLengths() {
    ;((this.needsUpdate = !0), this.getLengths())
  }
  // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
  getUtoTmapping(A, I) {
    const g = this.getLengths()
    let C = 0
    const i = g.length
    let B
    I ? (B = I) : (B = A * g[i - 1])
    let o = 0,
      r = i - 1,
      s
    for (; o <= r; )
      if (((C = Math.floor(o + (r - o) / 2)), (s = g[C] - B), s < 0)) o = C + 1
      else if (s > 0) r = C - 1
      else {
        r = C
        break
      }
    if (((C = r), g[C] === B)) return C / (i - 1)
    const h = g[C],
      d = g[C + 1] - h,
      w = (B - h) / d
    return (C + w) / (i - 1)
  }
  // Returns a unit vector tangent at t
  // In case any sub curve does not implement its tangent derivation,
  // 2 points a small delta apart will be used to find its gradient
  // which seems to give a reasonable approximation
  getTangent(A, I) {
    let C = A - 1e-4,
      i = A + 1e-4
    ;(C < 0 && (C = 0), i > 1 && (i = 1))
    const B = this.getPoint(C),
      o = this.getPoint(i),
      r = I || (B.isVector2 ? new ZI() : new wA())
    return (r.copy(o).sub(B).normalize(), r)
  }
  getTangentAt(A, I) {
    const g = this.getUtoTmapping(A)
    return this.getTangent(g, I)
  }
  computeFrenetFrames(A, I) {
    const g = new wA(),
      C = [],
      i = [],
      B = [],
      o = new wA(),
      r = new RC()
    for (let w = 0; w <= A; w++) {
      const M = w / A
      C[w] = this.getTangentAt(M, new wA())
    }
    ;((i[0] = new wA()), (B[0] = new wA()))
    let s = Number.MAX_VALUE
    const h = Math.abs(C[0].x),
      S = Math.abs(C[0].y),
      d = Math.abs(C[0].z)
    ;(h <= s && ((s = h), g.set(1, 0, 0)),
      S <= s && ((s = S), g.set(0, 1, 0)),
      d <= s && g.set(0, 0, 1),
      o.crossVectors(C[0], g).normalize(),
      i[0].crossVectors(C[0], o),
      B[0].crossVectors(C[0], i[0]))
    for (let w = 1; w <= A; w++) {
      if (
        ((i[w] = i[w - 1].clone()),
        (B[w] = B[w - 1].clone()),
        o.crossVectors(C[w - 1], C[w]),
        o.length() > Number.EPSILON)
      ) {
        o.normalize()
        const M = Math.acos(eQ(C[w - 1].dot(C[w]), -1, 1))
        i[w].applyMatrix4(r.makeRotationAxis(o, M))
      }
      B[w].crossVectors(C[w], i[w])
    }
    if (I === !0) {
      let w = Math.acos(eQ(i[0].dot(i[A]), -1, 1))
      ;((w /= A), C[0].dot(o.crossVectors(i[0], i[A])) > 0 && (w = -w))
      for (let M = 1; M <= A; M++)
        (i[M].applyMatrix4(r.makeRotationAxis(C[M], w * M)), B[M].crossVectors(C[M], i[M]))
    }
    return {
      tangents: C,
      normals: i,
      binormals: B,
    }
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(A) {
    return ((this.arcLengthDivisions = A.arcLengthDivisions), this)
  }
  toJSON() {
    const A = {
      metadata: {
        version: 4.6,
        type: "Curve",
        generator: "Curve.toJSON",
      },
    }
    return ((A.arcLengthDivisions = this.arcLengthDivisions), (A.type = this.type), A)
  }
  fromJSON(A) {
    return ((this.arcLengthDivisions = A.arcLengthDivisions), this)
  }
}
class oF extends Nl {
  constructor(A = 0, I = 0, g = 1, C = 1, i = 0, B = Math.PI * 2, o = !1, r = 0) {
    ;(super(),
      (this.isEllipseCurve = !0),
      (this.type = "EllipseCurve"),
      (this.aX = A),
      (this.aY = I),
      (this.xRadius = g),
      (this.yRadius = C),
      (this.aStartAngle = i),
      (this.aEndAngle = B),
      (this.aClockwise = o),
      (this.aRotation = r))
  }
  getPoint(A, I = new ZI()) {
    const g = I,
      C = Math.PI * 2
    let i = this.aEndAngle - this.aStartAngle
    const B = Math.abs(i) < Number.EPSILON
    for (; i < 0; ) i += C
    for (; i > C; ) i -= C
    ;(i < Number.EPSILON && (B ? (i = 0) : (i = C)),
      this.aClockwise === !0 && !B && (i === C ? (i = -C) : (i = i - C)))
    const o = this.aStartAngle + A * i
    let r = this.aX + this.xRadius * Math.cos(o),
      s = this.aY + this.yRadius * Math.sin(o)
    if (this.aRotation !== 0) {
      const h = Math.cos(this.aRotation),
        S = Math.sin(this.aRotation),
        d = r - this.aX,
        w = s - this.aY
      ;((r = d * h - w * S + this.aX), (s = d * S + w * h + this.aY))
    }
    return g.set(r, s)
  }
  copy(A) {
    return (
      super.copy(A),
      (this.aX = A.aX),
      (this.aY = A.aY),
      (this.xRadius = A.xRadius),
      (this.yRadius = A.yRadius),
      (this.aStartAngle = A.aStartAngle),
      (this.aEndAngle = A.aEndAngle),
      (this.aClockwise = A.aClockwise),
      (this.aRotation = A.aRotation),
      this
    )
  }
  toJSON() {
    const A = super.toJSON()
    return (
      (A.aX = this.aX),
      (A.aY = this.aY),
      (A.xRadius = this.xRadius),
      (A.yRadius = this.yRadius),
      (A.aStartAngle = this.aStartAngle),
      (A.aEndAngle = this.aEndAngle),
      (A.aClockwise = this.aClockwise),
      (A.aRotation = this.aRotation),
      A
    )
  }
  fromJSON(A) {
    return (
      super.fromJSON(A),
      (this.aX = A.aX),
      (this.aY = A.aY),
      (this.xRadius = A.xRadius),
      (this.yRadius = A.yRadius),
      (this.aStartAngle = A.aStartAngle),
      (this.aEndAngle = A.aEndAngle),
      (this.aClockwise = A.aClockwise),
      (this.aRotation = A.aRotation),
      this
    )
  }
}
class Bb extends oF {
  constructor(A, I, g, C, i, B) {
    ;(super(A, I, g, g, C, i, B), (this.isArcCurve = !0), (this.type = "ArcCurve"))
  }
}
function nv() {
  let e = 0,
    A = 0,
    I = 0,
    g = 0
  function C(i, B, o, r) {
    ;((e = i), (A = o), (I = -3 * i + 3 * B - 2 * o - r), (g = 2 * i - 2 * B + o + r))
  }
  return {
    initCatmullRom: function (i, B, o, r, s) {
      C(B, o, s * (o - i), s * (r - B))
    },
    initNonuniformCatmullRom: function (i, B, o, r, s, h, S) {
      let d = (B - i) / s - (o - i) / (s + h) + (o - B) / h,
        w = (o - B) / h - (r - B) / (h + S) + (r - o) / S
      ;((d *= h), (w *= h), C(B, o, d, w))
    },
    calc: function (i) {
      const B = i * i,
        o = B * i
      return e + A * i + I * B + g * o
    },
  }
}
const EU = /* @__PURE__ */ new wA(),
  MK = /* @__PURE__ */ new nv(),
  UK = /* @__PURE__ */ new nv(),
  NK = /* @__PURE__ */ new nv()
class Qb extends Nl {
  constructor(A = [], I = !1, g = "centripetal", C = 0.5) {
    ;(super(),
      (this.isCatmullRomCurve3 = !0),
      (this.type = "CatmullRomCurve3"),
      (this.points = A),
      (this.closed = I),
      (this.curveType = g),
      (this.tension = C))
  }
  getPoint(A, I = new wA()) {
    const g = I,
      C = this.points,
      i = C.length,
      B = (i - (this.closed ? 0 : 1)) * A
    let o = Math.floor(B),
      r = B - o
    this.closed
      ? (o += o > 0 ? 0 : (Math.floor(Math.abs(o) / i) + 1) * i)
      : r === 0 && o === i - 1 && ((o = i - 2), (r = 1))
    let s, h
    this.closed || o > 0 ? (s = C[(o - 1) % i]) : (EU.subVectors(C[0], C[1]).add(C[0]), (s = EU))
    const S = C[o % i],
      d = C[(o + 1) % i]
    if (
      (this.closed || o + 2 < i
        ? (h = C[(o + 2) % i])
        : (EU.subVectors(C[i - 1], C[i - 2]).add(C[i - 1]), (h = EU)),
      this.curveType === "centripetal" || this.curveType === "chordal")
    ) {
      const w = this.curveType === "chordal" ? 0.5 : 0.25
      let M = Math.pow(s.distanceToSquared(S), w),
        K = Math.pow(S.distanceToSquared(d), w),
        R = Math.pow(d.distanceToSquared(h), w)
      ;(K < 1e-4 && (K = 1),
        M < 1e-4 && (M = K),
        R < 1e-4 && (R = K),
        MK.initNonuniformCatmullRom(s.x, S.x, d.x, h.x, M, K, R),
        UK.initNonuniformCatmullRom(s.y, S.y, d.y, h.y, M, K, R),
        NK.initNonuniformCatmullRom(s.z, S.z, d.z, h.z, M, K, R))
    } else
      this.curveType === "catmullrom" &&
        (MK.initCatmullRom(s.x, S.x, d.x, h.x, this.tension),
        UK.initCatmullRom(s.y, S.y, d.y, h.y, this.tension),
        NK.initCatmullRom(s.z, S.z, d.z, h.z, this.tension))
    return (g.set(MK.calc(r), UK.calc(r), NK.calc(r)), g)
  }
  copy(A) {
    ;(super.copy(A), (this.points = []))
    for (let I = 0, g = A.points.length; I < g; I++) {
      const C = A.points[I]
      this.points.push(C.clone())
    }
    return (
      (this.closed = A.closed),
      (this.curveType = A.curveType),
      (this.tension = A.tension),
      this
    )
  }
  toJSON() {
    const A = super.toJSON()
    A.points = []
    for (let I = 0, g = this.points.length; I < g; I++) {
      const C = this.points[I]
      A.points.push(C.toArray())
    }
    return ((A.closed = this.closed), (A.curveType = this.curveType), (A.tension = this.tension), A)
  }
  fromJSON(A) {
    ;(super.fromJSON(A), (this.points = []))
    for (let I = 0, g = A.points.length; I < g; I++) {
      const C = A.points[I]
      this.points.push(new wA().fromArray(C))
    }
    return (
      (this.closed = A.closed),
      (this.curveType = A.curveType),
      (this.tension = A.tension),
      this
    )
  }
}
function HH(e, A, I, g, C) {
  const i = (g - A) * 0.5,
    B = (C - I) * 0.5,
    o = e * e,
    r = e * o
  return (2 * I - 2 * g + i + B) * r + (-3 * I + 3 * g - 2 * i - B) * o + i * e + I
}
function L5(e, A) {
  const I = 1 - e
  return I * I * A
}
function Y5(e, A) {
  return 2 * (1 - e) * e * A
}
function q5(e, A) {
  return e * e * A
}
function iG(e, A, I, g) {
  return L5(e, A) + Y5(e, I) + q5(e, g)
}
function H5(e, A) {
  const I = 1 - e
  return I * I * I * A
}
function T5(e, A) {
  const I = 1 - e
  return 3 * I * I * e * A
}
function x5(e, A) {
  return 3 * (1 - e) * e * e * A
}
function b5(e, A) {
  return e * e * e * A
}
function tG(e, A, I, g, C) {
  return H5(e, A) + T5(e, I) + x5(e, g) + b5(e, C)
}
class Ev extends Nl {
  constructor(A = new ZI(), I = new ZI(), g = new ZI(), C = new ZI()) {
    ;(super(),
      (this.isCubicBezierCurve = !0),
      (this.type = "CubicBezierCurve"),
      (this.v0 = A),
      (this.v1 = I),
      (this.v2 = g),
      (this.v3 = C))
  }
  getPoint(A, I = new ZI()) {
    const g = I,
      C = this.v0,
      i = this.v1,
      B = this.v2,
      o = this.v3
    return (g.set(tG(A, C.x, i.x, B.x, o.x), tG(A, C.y, i.y, B.y, o.y)), g)
  }
  copy(A) {
    return (
      super.copy(A),
      this.v0.copy(A.v0),
      this.v1.copy(A.v1),
      this.v2.copy(A.v2),
      this.v3.copy(A.v3),
      this
    )
  }
  toJSON() {
    const A = super.toJSON()
    return (
      (A.v0 = this.v0.toArray()),
      (A.v1 = this.v1.toArray()),
      (A.v2 = this.v2.toArray()),
      (A.v3 = this.v3.toArray()),
      A
    )
  }
  fromJSON(A) {
    return (
      super.fromJSON(A),
      this.v0.fromArray(A.v0),
      this.v1.fromArray(A.v1),
      this.v2.fromArray(A.v2),
      this.v3.fromArray(A.v3),
      this
    )
  }
}
class ob extends Nl {
  constructor(A = new wA(), I = new wA(), g = new wA(), C = new wA()) {
    ;(super(),
      (this.isCubicBezierCurve3 = !0),
      (this.type = "CubicBezierCurve3"),
      (this.v0 = A),
      (this.v1 = I),
      (this.v2 = g),
      (this.v3 = C))
  }
  getPoint(A, I = new wA()) {
    const g = I,
      C = this.v0,
      i = this.v1,
      B = this.v2,
      o = this.v3
    return (
      g.set(tG(A, C.x, i.x, B.x, o.x), tG(A, C.y, i.y, B.y, o.y), tG(A, C.z, i.z, B.z, o.z)),
      g
    )
  }
  copy(A) {
    return (
      super.copy(A),
      this.v0.copy(A.v0),
      this.v1.copy(A.v1),
      this.v2.copy(A.v2),
      this.v3.copy(A.v3),
      this
    )
  }
  toJSON() {
    const A = super.toJSON()
    return (
      (A.v0 = this.v0.toArray()),
      (A.v1 = this.v1.toArray()),
      (A.v2 = this.v2.toArray()),
      (A.v3 = this.v3.toArray()),
      A
    )
  }
  fromJSON(A) {
    return (
      super.fromJSON(A),
      this.v0.fromArray(A.v0),
      this.v1.fromArray(A.v1),
      this.v2.fromArray(A.v2),
      this.v3.fromArray(A.v3),
      this
    )
  }
}
class av extends Nl {
  constructor(A = new ZI(), I = new ZI()) {
    ;(super(), (this.isLineCurve = !0), (this.type = "LineCurve"), (this.v1 = A), (this.v2 = I))
  }
  getPoint(A, I = new ZI()) {
    const g = I
    return (
      A === 1 ? g.copy(this.v2) : (g.copy(this.v2).sub(this.v1), g.multiplyScalar(A).add(this.v1)),
      g
    )
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(A, I) {
    return this.getPoint(A, I)
  }
  getTangent(A, I = new ZI()) {
    return I.subVectors(this.v2, this.v1).normalize()
  }
  getTangentAt(A, I) {
    return this.getTangent(A, I)
  }
  copy(A) {
    return (super.copy(A), this.v1.copy(A.v1), this.v2.copy(A.v2), this)
  }
  toJSON() {
    const A = super.toJSON()
    return ((A.v1 = this.v1.toArray()), (A.v2 = this.v2.toArray()), A)
  }
  fromJSON(A) {
    return (super.fromJSON(A), this.v1.fromArray(A.v1), this.v2.fromArray(A.v2), this)
  }
}
class nb extends Nl {
  constructor(A = new wA(), I = new wA()) {
    ;(super(), (this.isLineCurve3 = !0), (this.type = "LineCurve3"), (this.v1 = A), (this.v2 = I))
  }
  getPoint(A, I = new wA()) {
    const g = I
    return (
      A === 1 ? g.copy(this.v2) : (g.copy(this.v2).sub(this.v1), g.multiplyScalar(A).add(this.v1)),
      g
    )
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(A, I) {
    return this.getPoint(A, I)
  }
  getTangent(A, I = new wA()) {
    return I.subVectors(this.v2, this.v1).normalize()
  }
  getTangentAt(A, I) {
    return this.getTangent(A, I)
  }
  copy(A) {
    return (super.copy(A), this.v1.copy(A.v1), this.v2.copy(A.v2), this)
  }
  toJSON() {
    const A = super.toJSON()
    return ((A.v1 = this.v1.toArray()), (A.v2 = this.v2.toArray()), A)
  }
  fromJSON(A) {
    return (super.fromJSON(A), this.v1.fromArray(A.v1), this.v2.fromArray(A.v2), this)
  }
}
class rv extends Nl {
  constructor(A = new ZI(), I = new ZI(), g = new ZI()) {
    ;(super(),
      (this.isQuadraticBezierCurve = !0),
      (this.type = "QuadraticBezierCurve"),
      (this.v0 = A),
      (this.v1 = I),
      (this.v2 = g))
  }
  getPoint(A, I = new ZI()) {
    const g = I,
      C = this.v0,
      i = this.v1,
      B = this.v2
    return (g.set(iG(A, C.x, i.x, B.x), iG(A, C.y, i.y, B.y)), g)
  }
  copy(A) {
    return (super.copy(A), this.v0.copy(A.v0), this.v1.copy(A.v1), this.v2.copy(A.v2), this)
  }
  toJSON() {
    const A = super.toJSON()
    return ((A.v0 = this.v0.toArray()), (A.v1 = this.v1.toArray()), (A.v2 = this.v2.toArray()), A)
  }
  fromJSON(A) {
    return (
      super.fromJSON(A),
      this.v0.fromArray(A.v0),
      this.v1.fromArray(A.v1),
      this.v2.fromArray(A.v2),
      this
    )
  }
}
class sv extends Nl {
  constructor(A = new wA(), I = new wA(), g = new wA()) {
    ;(super(),
      (this.isQuadraticBezierCurve3 = !0),
      (this.type = "QuadraticBezierCurve3"),
      (this.v0 = A),
      (this.v1 = I),
      (this.v2 = g))
  }
  getPoint(A, I = new wA()) {
    const g = I,
      C = this.v0,
      i = this.v1,
      B = this.v2
    return (g.set(iG(A, C.x, i.x, B.x), iG(A, C.y, i.y, B.y), iG(A, C.z, i.z, B.z)), g)
  }
  copy(A) {
    return (super.copy(A), this.v0.copy(A.v0), this.v1.copy(A.v1), this.v2.copy(A.v2), this)
  }
  toJSON() {
    const A = super.toJSON()
    return ((A.v0 = this.v0.toArray()), (A.v1 = this.v1.toArray()), (A.v2 = this.v2.toArray()), A)
  }
  fromJSON(A) {
    return (
      super.fromJSON(A),
      this.v0.fromArray(A.v0),
      this.v1.fromArray(A.v1),
      this.v2.fromArray(A.v2),
      this
    )
  }
}
class lv extends Nl {
  constructor(A = []) {
    ;(super(), (this.isSplineCurve = !0), (this.type = "SplineCurve"), (this.points = A))
  }
  getPoint(A, I = new ZI()) {
    const g = I,
      C = this.points,
      i = (C.length - 1) * A,
      B = Math.floor(i),
      o = i - B,
      r = C[B === 0 ? B : B - 1],
      s = C[B],
      h = C[B > C.length - 2 ? C.length - 1 : B + 1],
      S = C[B > C.length - 3 ? C.length - 1 : B + 2]
    return (g.set(HH(o, r.x, s.x, h.x, S.x), HH(o, r.y, s.y, h.y, S.y)), g)
  }
  copy(A) {
    ;(super.copy(A), (this.points = []))
    for (let I = 0, g = A.points.length; I < g; I++) {
      const C = A.points[I]
      this.points.push(C.clone())
    }
    return this
  }
  toJSON() {
    const A = super.toJSON()
    A.points = []
    for (let I = 0, g = this.points.length; I < g; I++) {
      const C = this.points[I]
      A.points.push(C.toArray())
    }
    return A
  }
  fromJSON(A) {
    ;(super.fromJSON(A), (this.points = []))
    for (let I = 0, g = A.points.length; I < g; I++) {
      const C = A.points[I]
      this.points.push(new ZI().fromArray(C))
    }
    return this
  }
}
var pN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcCurve: Bb,
  CatmullRomCurve3: Qb,
  CubicBezierCurve: Ev,
  CubicBezierCurve3: ob,
  EllipseCurve: oF,
  LineCurve: av,
  LineCurve3: nb,
  QuadraticBezierCurve: rv,
  QuadraticBezierCurve3: sv,
  SplineCurve: lv,
})
class Eb extends Nl {
  constructor() {
    ;(super(), (this.type = "CurvePath"), (this.curves = []), (this.autoClose = !1))
  }
  add(A) {
    this.curves.push(A)
  }
  closePath() {
    const A = this.curves[0].getPoint(0),
      I = this.curves[this.curves.length - 1].getPoint(1)
    if (!A.equals(I)) {
      const g = A.isVector2 === !0 ? "LineCurve" : "LineCurve3"
      this.curves.push(new pN[g](I, A))
    }
    return this
  }
  // To get accurate point with reference to
  // entire path distance at time t,
  // following has to be done:
  // 1. Length of each sub path have to be known
  // 2. Locate and identify type of curve
  // 3. Get t for the curve
  // 4. Return curve.getPointAt(t')
  getPoint(A, I) {
    const g = A * this.getLength(),
      C = this.getCurveLengths()
    let i = 0
    for (; i < C.length; ) {
      if (C[i] >= g) {
        const B = C[i] - g,
          o = this.curves[i],
          r = o.getLength(),
          s = r === 0 ? 0 : 1 - B / r
        return o.getPointAt(s, I)
      }
      i++
    }
    return null
  }
  // We cannot use the default THREE.Curve getPoint() with getLength() because in
  // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
  // getPoint() depends on getLength
  getLength() {
    const A = this.getCurveLengths()
    return A[A.length - 1]
  }
  // cacheLengths must be recalculated.
  updateArcLengths() {
    ;((this.needsUpdate = !0), (this.cacheLengths = null), this.getCurveLengths())
  }
  // Compute lengths and cache them
  // We cannot overwrite getLengths() because UtoT mapping uses it.
  getCurveLengths() {
    if (this.cacheLengths && this.cacheLengths.length === this.curves.length)
      return this.cacheLengths
    const A = []
    let I = 0
    for (let g = 0, C = this.curves.length; g < C; g++)
      ((I += this.curves[g].getLength()), A.push(I))
    return ((this.cacheLengths = A), A)
  }
  getSpacedPoints(A = 40) {
    const I = []
    for (let g = 0; g <= A; g++) I.push(this.getPoint(g / A))
    return (this.autoClose && I.push(I[0]), I)
  }
  getPoints(A = 12) {
    const I = []
    let g
    for (let C = 0, i = this.curves; C < i.length; C++) {
      const B = i[C],
        o = B.isEllipseCurve
          ? A * 2
          : B.isLineCurve || B.isLineCurve3
            ? 1
            : B.isSplineCurve
              ? A * B.points.length
              : A,
        r = B.getPoints(o)
      for (let s = 0; s < r.length; s++) {
        const h = r[s]
        ;(g && g.equals(h)) || (I.push(h), (g = h))
      }
    }
    return (this.autoClose && I.length > 1 && !I[I.length - 1].equals(I[0]) && I.push(I[0]), I)
  }
  copy(A) {
    ;(super.copy(A), (this.curves = []))
    for (let I = 0, g = A.curves.length; I < g; I++) {
      const C = A.curves[I]
      this.curves.push(C.clone())
    }
    return ((this.autoClose = A.autoClose), this)
  }
  toJSON() {
    const A = super.toJSON()
    ;((A.autoClose = this.autoClose), (A.curves = []))
    for (let I = 0, g = this.curves.length; I < g; I++) {
      const C = this.curves[I]
      A.curves.push(C.toJSON())
    }
    return A
  }
  fromJSON(A) {
    ;(super.fromJSON(A), (this.autoClose = A.autoClose), (this.curves = []))
    for (let I = 0, g = A.curves.length; I < g; I++) {
      const C = A.curves[I]
      this.curves.push(new pN[C.type]().fromJSON(C))
    }
    return this
  }
}
class cG extends Eb {
  constructor(A) {
    ;(super(), (this.type = "Path"), (this.currentPoint = new ZI()), A && this.setFromPoints(A))
  }
  setFromPoints(A) {
    this.moveTo(A[0].x, A[0].y)
    for (let I = 1, g = A.length; I < g; I++) this.lineTo(A[I].x, A[I].y)
    return this
  }
  moveTo(A, I) {
    return (this.currentPoint.set(A, I), this)
  }
  lineTo(A, I) {
    const g = new av(this.currentPoint.clone(), new ZI(A, I))
    return (this.curves.push(g), this.currentPoint.set(A, I), this)
  }
  quadraticCurveTo(A, I, g, C) {
    const i = new rv(this.currentPoint.clone(), new ZI(A, I), new ZI(g, C))
    return (this.curves.push(i), this.currentPoint.set(g, C), this)
  }
  bezierCurveTo(A, I, g, C, i, B) {
    const o = new Ev(this.currentPoint.clone(), new ZI(A, I), new ZI(g, C), new ZI(i, B))
    return (this.curves.push(o), this.currentPoint.set(i, B), this)
  }
  splineThru(A) {
    const I = [this.currentPoint.clone()].concat(A),
      g = new lv(I)
    return (this.curves.push(g), this.currentPoint.copy(A[A.length - 1]), this)
  }
  arc(A, I, g, C, i, B) {
    const o = this.currentPoint.x,
      r = this.currentPoint.y
    return (this.absarc(A + o, I + r, g, C, i, B), this)
  }
  absarc(A, I, g, C, i, B) {
    return (this.absellipse(A, I, g, g, C, i, B), this)
  }
  ellipse(A, I, g, C, i, B, o, r) {
    const s = this.currentPoint.x,
      h = this.currentPoint.y
    return (this.absellipse(A + s, I + h, g, C, i, B, o, r), this)
  }
  absellipse(A, I, g, C, i, B, o, r) {
    const s = new oF(A, I, g, C, i, B, o, r)
    if (this.curves.length > 0) {
      const S = s.getPoint(0)
      S.equals(this.currentPoint) || this.lineTo(S.x, S.y)
    }
    this.curves.push(s)
    const h = s.getPoint(1)
    return (this.currentPoint.copy(h), this)
  }
  copy(A) {
    return (super.copy(A), this.currentPoint.copy(A.currentPoint), this)
  }
  toJSON() {
    const A = super.toJSON()
    return ((A.currentPoint = this.currentPoint.toArray()), A)
  }
  fromJSON(A) {
    return (super.fromJSON(A), this.currentPoint.fromArray(A.currentPoint), this)
  }
}
class vG extends se {
  constructor(
    A = [new ZI(0, -0.5), new ZI(0.5, 0), new ZI(0, 0.5)],
    I = 12,
    g = 0,
    C = Math.PI * 2,
  ) {
    ;(super(),
      (this.type = "LatheGeometry"),
      (this.parameters = {
        points: A,
        segments: I,
        phiStart: g,
        phiLength: C,
      }),
      (I = Math.floor(I)),
      (C = eQ(C, 0, Math.PI * 2)))
    const i = [],
      B = [],
      o = [],
      r = [],
      s = [],
      h = 1 / I,
      S = new wA(),
      d = new ZI(),
      w = new wA(),
      M = new wA(),
      K = new wA()
    let R = 0,
      F = 0
    for (let L = 0; L <= A.length - 1; L++)
      switch (L) {
        case 0:
          ;((R = A[L + 1].x - A[L].x),
            (F = A[L + 1].y - A[L].y),
            (w.x = F * 1),
            (w.y = -R),
            (w.z = F * 0),
            K.copy(w),
            w.normalize(),
            r.push(w.x, w.y, w.z))
          break
        case A.length - 1:
          r.push(K.x, K.y, K.z)
          break
        default:
          ;((R = A[L + 1].x - A[L].x),
            (F = A[L + 1].y - A[L].y),
            (w.x = F * 1),
            (w.y = -R),
            (w.z = F * 0),
            M.copy(w),
            (w.x += K.x),
            (w.y += K.y),
            (w.z += K.z),
            w.normalize(),
            r.push(w.x, w.y, w.z),
            K.copy(M))
      }
    for (let L = 0; L <= I; L++) {
      const Y = g + L * h * C,
        H = Math.sin(Y),
        V = Math.cos(Y)
      for (let j = 0; j <= A.length - 1; j++) {
        ;((S.x = A[j].x * H),
          (S.y = A[j].y),
          (S.z = A[j].x * V),
          B.push(S.x, S.y, S.z),
          (d.x = L / I),
          (d.y = j / (A.length - 1)),
          o.push(d.x, d.y))
        const P = r[3 * j + 0] * H,
          AA = r[3 * j + 1],
          X = r[3 * j + 0] * V
        s.push(P, AA, X)
      }
    }
    for (let L = 0; L < I; L++)
      for (let Y = 0; Y < A.length - 1; Y++) {
        const H = Y + L * A.length,
          V = H,
          j = H + A.length,
          P = H + A.length + 1,
          AA = H + 1
        ;(i.push(V, j, AA), i.push(P, AA, j))
      }
    ;(this.setIndex(i),
      this.setAttribute("position", new aC(B, 3)),
      this.setAttribute("uv", new aC(o, 2)),
      this.setAttribute("normal", new aC(s, 3)))
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
  static fromJSON(A) {
    return new vG(A.points, A.segments, A.phiStart, A.phiLength)
  }
}
class nF extends vG {
  constructor(A = 1, I = 1, g = 4, C = 8) {
    const i = new cG()
    ;(i.absarc(0, -I / 2, A, Math.PI * 1.5, 0),
      i.absarc(0, I / 2, A, 0, Math.PI * 0.5),
      super(i.getPoints(g), C),
      (this.type = "CapsuleGeometry"),
      (this.parameters = {
        radius: A,
        length: I,
        capSegments: g,
        radialSegments: C,
      }))
  }
  static fromJSON(A) {
    return new nF(A.radius, A.length, A.capSegments, A.radialSegments)
  }
}
class EF extends se {
  constructor(A = 1, I = 32, g = 0, C = Math.PI * 2) {
    ;(super(),
      (this.type = "CircleGeometry"),
      (this.parameters = {
        radius: A,
        segments: I,
        thetaStart: g,
        thetaLength: C,
      }),
      (I = Math.max(3, I)))
    const i = [],
      B = [],
      o = [],
      r = [],
      s = new wA(),
      h = new ZI()
    ;(B.push(0, 0, 0), o.push(0, 0, 1), r.push(0.5, 0.5))
    for (let S = 0, d = 3; S <= I; S++, d += 3) {
      const w = g + (S / I) * C
      ;((s.x = A * Math.cos(w)),
        (s.y = A * Math.sin(w)),
        B.push(s.x, s.y, s.z),
        o.push(0, 0, 1),
        (h.x = (B[d] / A + 1) / 2),
        (h.y = (B[d + 1] / A + 1) / 2),
        r.push(h.x, h.y))
    }
    for (let S = 1; S <= I; S++) i.push(S, S + 1, 0)
    ;(this.setIndex(i),
      this.setAttribute("position", new aC(B, 3)),
      this.setAttribute("normal", new aC(o, 3)),
      this.setAttribute("uv", new aC(r, 2)))
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
  static fromJSON(A) {
    return new EF(A.radius, A.segments, A.thetaStart, A.thetaLength)
  }
}
class wp extends se {
  constructor(A = 1, I = 1, g = 1, C = 32, i = 1, B = !1, o = 0, r = Math.PI * 2) {
    ;(super(),
      (this.type = "CylinderGeometry"),
      (this.parameters = {
        radiusTop: A,
        radiusBottom: I,
        height: g,
        radialSegments: C,
        heightSegments: i,
        openEnded: B,
        thetaStart: o,
        thetaLength: r,
      }))
    const s = this
    ;((C = Math.floor(C)), (i = Math.floor(i)))
    const h = [],
      S = [],
      d = [],
      w = []
    let M = 0
    const K = [],
      R = g / 2
    let F = 0
    ;(L(),
      B === !1 && (A > 0 && Y(!0), I > 0 && Y(!1)),
      this.setIndex(h),
      this.setAttribute("position", new aC(S, 3)),
      this.setAttribute("normal", new aC(d, 3)),
      this.setAttribute("uv", new aC(w, 2)))
    function L() {
      const H = new wA(),
        V = new wA()
      let j = 0
      const P = (I - A) / g
      for (let AA = 0; AA <= i; AA++) {
        const X = [],
          _ = AA / i,
          eA = _ * (I - A) + A
        for (let CA = 0; CA <= C; CA++) {
          const aA = CA / C,
            lA = aA * r + o,
            JA = Math.sin(lA),
            yA = Math.cos(lA)
          ;((V.x = eA * JA),
            (V.y = -_ * g + R),
            (V.z = eA * yA),
            S.push(V.x, V.y, V.z),
            H.set(JA, P, yA).normalize(),
            d.push(H.x, H.y, H.z),
            w.push(aA, 1 - _),
            X.push(M++))
        }
        K.push(X)
      }
      for (let AA = 0; AA < C; AA++)
        for (let X = 0; X < i; X++) {
          const _ = K[X][AA],
            eA = K[X + 1][AA],
            CA = K[X + 1][AA + 1],
            aA = K[X][AA + 1]
          ;((A > 0 || X !== 0) && (h.push(_, eA, aA), (j += 3)),
            (I > 0 || X !== i - 1) && (h.push(eA, CA, aA), (j += 3)))
        }
      ;(s.addGroup(F, j, 0), (F += j))
    }
    function Y(H) {
      const V = M,
        j = new ZI(),
        P = new wA()
      let AA = 0
      const X = H === !0 ? A : I,
        _ = H === !0 ? 1 : -1
      for (let CA = 1; CA <= C; CA++) (S.push(0, R * _, 0), d.push(0, _, 0), w.push(0.5, 0.5), M++)
      const eA = M
      for (let CA = 0; CA <= C; CA++) {
        const lA = (CA / C) * r + o,
          JA = Math.cos(lA),
          yA = Math.sin(lA)
        ;((P.x = X * yA),
          (P.y = R * _),
          (P.z = X * JA),
          S.push(P.x, P.y, P.z),
          d.push(0, _, 0),
          (j.x = JA * 0.5 + 0.5),
          (j.y = yA * 0.5 * _ + 0.5),
          w.push(j.x, j.y),
          M++)
      }
      for (let CA = 0; CA < C; CA++) {
        const aA = V + CA,
          lA = eA + CA
        ;(H === !0 ? h.push(lA, lA + 1, aA) : h.push(lA + 1, lA, aA), (AA += 3))
      }
      ;(s.addGroup(F, AA, H === !0 ? 1 : 2), (F += AA))
    }
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
  static fromJSON(A) {
    return new wp(
      A.radiusTop,
      A.radiusBottom,
      A.height,
      A.radialSegments,
      A.heightSegments,
      A.openEnded,
      A.thetaStart,
      A.thetaLength,
    )
  }
}
class aF extends wp {
  constructor(A = 1, I = 1, g = 32, C = 1, i = !1, B = 0, o = Math.PI * 2) {
    ;(super(0, A, I, g, C, i, B, o),
      (this.type = "ConeGeometry"),
      (this.parameters = {
        radius: A,
        height: I,
        radialSegments: g,
        heightSegments: C,
        openEnded: i,
        thetaStart: B,
        thetaLength: o,
      }))
  }
  static fromJSON(A) {
    return new aF(
      A.radius,
      A.height,
      A.radialSegments,
      A.heightSegments,
      A.openEnded,
      A.thetaStart,
      A.thetaLength,
    )
  }
}
class LD extends se {
  constructor(A = [], I = [], g = 1, C = 0) {
    ;(super(),
      (this.type = "PolyhedronGeometry"),
      (this.parameters = {
        vertices: A,
        indices: I,
        radius: g,
        detail: C,
      }))
    const i = [],
      B = []
    ;(o(C),
      s(g),
      h(),
      this.setAttribute("position", new aC(i, 3)),
      this.setAttribute("normal", new aC(i.slice(), 3)),
      this.setAttribute("uv", new aC(B, 2)),
      C === 0 ? this.computeVertexNormals() : this.normalizeNormals())
    function o(L) {
      const Y = new wA(),
        H = new wA(),
        V = new wA()
      for (let j = 0; j < I.length; j += 3)
        (w(I[j + 0], Y), w(I[j + 1], H), w(I[j + 2], V), r(Y, H, V, L))
    }
    function r(L, Y, H, V) {
      const j = V + 1,
        P = []
      for (let AA = 0; AA <= j; AA++) {
        P[AA] = []
        const X = L.clone().lerp(H, AA / j),
          _ = Y.clone().lerp(H, AA / j),
          eA = j - AA
        for (let CA = 0; CA <= eA; CA++)
          CA === 0 && AA === j ? (P[AA][CA] = X) : (P[AA][CA] = X.clone().lerp(_, CA / eA))
      }
      for (let AA = 0; AA < j; AA++)
        for (let X = 0; X < 2 * (j - AA) - 1; X++) {
          const _ = Math.floor(X / 2)
          X % 2 === 0
            ? (d(P[AA][_ + 1]), d(P[AA + 1][_]), d(P[AA][_]))
            : (d(P[AA][_ + 1]), d(P[AA + 1][_ + 1]), d(P[AA + 1][_]))
        }
    }
    function s(L) {
      const Y = new wA()
      for (let H = 0; H < i.length; H += 3)
        ((Y.x = i[H + 0]),
          (Y.y = i[H + 1]),
          (Y.z = i[H + 2]),
          Y.normalize().multiplyScalar(L),
          (i[H + 0] = Y.x),
          (i[H + 1] = Y.y),
          (i[H + 2] = Y.z))
    }
    function h() {
      const L = new wA()
      for (let Y = 0; Y < i.length; Y += 3) {
        ;((L.x = i[Y + 0]), (L.y = i[Y + 1]), (L.z = i[Y + 2]))
        const H = R(L) / 2 / Math.PI + 0.5,
          V = F(L) / Math.PI + 0.5
        B.push(H, 1 - V)
      }
      ;(M(), S())
    }
    function S() {
      for (let L = 0; L < B.length; L += 6) {
        const Y = B[L + 0],
          H = B[L + 2],
          V = B[L + 4],
          j = Math.max(Y, H, V),
          P = Math.min(Y, H, V)
        j > 0.9 &&
          P < 0.1 &&
          (Y < 0.2 && (B[L + 0] += 1), H < 0.2 && (B[L + 2] += 1), V < 0.2 && (B[L + 4] += 1))
      }
    }
    function d(L) {
      i.push(L.x, L.y, L.z)
    }
    function w(L, Y) {
      const H = L * 3
      ;((Y.x = A[H + 0]), (Y.y = A[H + 1]), (Y.z = A[H + 2]))
    }
    function M() {
      const L = new wA(),
        Y = new wA(),
        H = new wA(),
        V = new wA(),
        j = new ZI(),
        P = new ZI(),
        AA = new ZI()
      for (let X = 0, _ = 0; X < i.length; X += 9, _ += 6) {
        ;(L.set(i[X + 0], i[X + 1], i[X + 2]),
          Y.set(i[X + 3], i[X + 4], i[X + 5]),
          H.set(i[X + 6], i[X + 7], i[X + 8]),
          j.set(B[_ + 0], B[_ + 1]),
          P.set(B[_ + 2], B[_ + 3]),
          AA.set(B[_ + 4], B[_ + 5]),
          V.copy(L).add(Y).add(H).divideScalar(3))
        const eA = R(V)
        ;(K(j, _ + 0, L, eA), K(P, _ + 2, Y, eA), K(AA, _ + 4, H, eA))
      }
    }
    function K(L, Y, H, V) {
      ;(V < 0 && L.x === 1 && (B[Y] = L.x - 1),
        H.x === 0 && H.z === 0 && (B[Y] = V / 2 / Math.PI + 0.5))
    }
    function R(L) {
      return Math.atan2(L.z, -L.x)
    }
    function F(L) {
      return Math.atan2(-L.y, Math.sqrt(L.x * L.x + L.z * L.z))
    }
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
  static fromJSON(A) {
    return new LD(A.vertices, A.indices, A.radius, A.details)
  }
}
class rF extends LD {
  constructor(A = 1, I = 0) {
    const g = (1 + Math.sqrt(5)) / 2,
      C = 1 / g,
      i = [
        // (±1, ±1, ±1)
        -1,
        -1,
        -1,
        -1,
        -1,
        1,
        -1,
        1,
        -1,
        -1,
        1,
        1,
        1,
        -1,
        -1,
        1,
        -1,
        1,
        1,
        1,
        -1,
        1,
        1,
        1,
        // (0, ±1/φ, ±φ)
        0,
        -C,
        -g,
        0,
        -C,
        g,
        0,
        C,
        -g,
        0,
        C,
        g,
        // (±1/φ, ±φ, 0)
        -C,
        -g,
        0,
        -C,
        g,
        0,
        C,
        -g,
        0,
        C,
        g,
        0,
        // (±φ, 0, ±1/φ)
        -g,
        0,
        -C,
        g,
        0,
        -C,
        -g,
        0,
        C,
        g,
        0,
        C,
      ],
      B = [
        3, 11, 7, 3, 7, 15, 3, 15, 13, 7, 19, 17, 7, 17, 6, 7, 6, 15, 17, 4, 8, 17, 8, 10, 17, 10,
        6, 8, 0, 16, 8, 16, 2, 8, 2, 10, 0, 12, 1, 0, 1, 18, 0, 18, 16, 6, 10, 2, 6, 2, 13, 6, 13,
        15, 2, 16, 18, 2, 18, 3, 2, 3, 13, 18, 1, 9, 18, 9, 11, 18, 11, 3, 4, 14, 12, 4, 12, 0, 4,
        0, 8, 11, 9, 5, 11, 5, 19, 11, 19, 7, 19, 5, 14, 19, 14, 4, 19, 4, 17, 1, 12, 14, 1, 14, 5,
        1, 5, 9,
      ]
    ;(super(i, B, A, I),
      (this.type = "DodecahedronGeometry"),
      (this.parameters = {
        radius: A,
        detail: I,
      }))
  }
  static fromJSON(A) {
    return new rF(A.radius, A.detail)
  }
}
const aU = /* @__PURE__ */ new wA(),
  rU = /* @__PURE__ */ new wA(),
  FK = /* @__PURE__ */ new wA(),
  sU = /* @__PURE__ */ new va()
class ab extends se {
  constructor(A = null, I = 1) {
    if (
      (super(),
      (this.type = "EdgesGeometry"),
      (this.parameters = {
        geometry: A,
        thresholdAngle: I,
      }),
      A !== null)
    ) {
      const C = Math.pow(10, 4),
        i = Math.cos(Jf * I),
        B = A.getIndex(),
        o = A.getAttribute("position"),
        r = B ? B.count : o.count,
        s = [0, 0, 0],
        h = ["a", "b", "c"],
        S = new Array(3),
        d = {},
        w = []
      for (let M = 0; M < r; M += 3) {
        B
          ? ((s[0] = B.getX(M)), (s[1] = B.getX(M + 1)), (s[2] = B.getX(M + 2)))
          : ((s[0] = M), (s[1] = M + 1), (s[2] = M + 2))
        const { a: K, b: R, c: F } = sU
        if (
          (K.fromBufferAttribute(o, s[0]),
          R.fromBufferAttribute(o, s[1]),
          F.fromBufferAttribute(o, s[2]),
          sU.getNormal(FK),
          (S[0] = `${Math.round(K.x * C)},${Math.round(K.y * C)},${Math.round(K.z * C)}`),
          (S[1] = `${Math.round(R.x * C)},${Math.round(R.y * C)},${Math.round(R.z * C)}`),
          (S[2] = `${Math.round(F.x * C)},${Math.round(F.y * C)},${Math.round(F.z * C)}`),
          !(S[0] === S[1] || S[1] === S[2] || S[2] === S[0]))
        )
          for (let L = 0; L < 3; L++) {
            const Y = (L + 1) % 3,
              H = S[L],
              V = S[Y],
              j = sU[h[L]],
              P = sU[h[Y]],
              AA = `${H}_${V}`,
              X = `${V}_${H}`
            X in d && d[X]
              ? (FK.dot(d[X].normal) <= i && (w.push(j.x, j.y, j.z), w.push(P.x, P.y, P.z)),
                (d[X] = null))
              : AA in d ||
                (d[AA] = {
                  index0: s[L],
                  index1: s[Y],
                  normal: FK.clone(),
                })
          }
      }
      for (const M in d)
        if (d[M]) {
          const { index0: K, index1: R } = d[M]
          ;(aU.fromBufferAttribute(o, K),
            rU.fromBufferAttribute(o, R),
            w.push(aU.x, aU.y, aU.z),
            w.push(rU.x, rU.y, rU.z))
        }
      this.setAttribute("position", new aC(w, 3))
    }
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
}
class mf extends cG {
  constructor(A) {
    ;(super(A), (this.uuid = Lr()), (this.type = "Shape"), (this.holes = []))
  }
  getPointsHoles(A) {
    const I = []
    for (let g = 0, C = this.holes.length; g < C; g++) I[g] = this.holes[g].getPoints(A)
    return I
  }
  // get points of shape and holes (keypoints based on segments parameter)
  extractPoints(A) {
    return {
      shape: this.getPoints(A),
      holes: this.getPointsHoles(A),
    }
  }
  copy(A) {
    ;(super.copy(A), (this.holes = []))
    for (let I = 0, g = A.holes.length; I < g; I++) {
      const C = A.holes[I]
      this.holes.push(C.clone())
    }
    return this
  }
  toJSON() {
    const A = super.toJSON()
    ;((A.uuid = this.uuid), (A.holes = []))
    for (let I = 0, g = this.holes.length; I < g; I++) {
      const C = this.holes[I]
      A.holes.push(C.toJSON())
    }
    return A
  }
  fromJSON(A) {
    ;(super.fromJSON(A), (this.uuid = A.uuid), (this.holes = []))
    for (let I = 0, g = A.holes.length; I < g; I++) {
      const C = A.holes[I]
      this.holes.push(new cG().fromJSON(C))
    }
    return this
  }
}
const O5 = {
  triangulate: function (e, A, I = 2) {
    const g = A && A.length,
      C = g ? A[0] * I : e.length
    let i = rb(e, 0, C, I, !0)
    const B = []
    if (!i || i.next === i.prev) return B
    let o, r, s, h, S, d, w
    if ((g && (i = V5(e, A, i, I)), e.length > 80 * I)) {
      ;((o = s = e[0]), (r = h = e[1]))
      for (let M = I; M < C; M += I)
        ((S = e[M]),
          (d = e[M + 1]),
          S < o && (o = S),
          d < r && (r = d),
          S > s && (s = S),
          d > h && (h = d))
      ;((w = Math.max(s - o, h - r)), (w = w !== 0 ? 32767 / w : 0))
    }
    return (hG(i, B, I, o, r, w, 0), B)
  },
}
function rb(e, A, I, g, C) {
  let i, B
  if (C === tj(e, A, I, g) > 0) for (i = A; i < I; i += g) B = TH(i, e[i], e[i + 1], B)
  else for (i = I - g; i >= A; i -= g) B = TH(i, e[i], e[i + 1], B)
  return (B && sF(B, B.next) && (DG(B), (B = B.next)), B)
}
function Yf(e, A) {
  if (!e) return e
  A || (A = e)
  let I = e,
    g
  do
    if (((g = !1), !I.steiner && (sF(I, I.next) || qB(I.prev, I, I.next) === 0))) {
      if ((DG(I), (I = A = I.prev), I === I.next)) break
      g = !0
    } else I = I.next
  while (g || I !== A)
  return A
}
function hG(e, A, I, g, C, i, B) {
  if (!e) return
  !B && i && Aj(e, g, C, i)
  let o = e,
    r,
    s
  for (; e.prev !== e.next; ) {
    if (((r = e.prev), (s = e.next), i ? Z5(e, g, C, i) : _5(e))) {
      ;(A.push((r.i / I) | 0),
        A.push((e.i / I) | 0),
        A.push((s.i / I) | 0),
        DG(e),
        (e = s.next),
        (o = s.next))
      continue
    }
    if (((e = s), e === o)) {
      B
        ? B === 1
          ? ((e = P5(Yf(e), A, I)), hG(e, A, I, g, C, i, 2))
          : B === 2 && W5(e, A, I, g, C, i)
        : hG(Yf(e), A, I, g, C, i, 1)
      break
    }
  }
}
function _5(e) {
  const A = e.prev,
    I = e,
    g = e.next
  if (qB(A, I, g) >= 0) return !1
  const C = A.x,
    i = I.x,
    B = g.x,
    o = A.y,
    r = I.y,
    s = g.y,
    h = C < i ? (C < B ? C : B) : i < B ? i : B,
    S = o < r ? (o < s ? o : s) : r < s ? r : s,
    d = C > i ? (C > B ? C : B) : i > B ? i : B,
    w = o > r ? (o > s ? o : s) : r > s ? r : s
  let M = g.next
  for (; M !== A; ) {
    if (
      M.x >= h &&
      M.x <= d &&
      M.y >= S &&
      M.y <= w &&
      gp(C, o, i, r, B, s, M.x, M.y) &&
      qB(M.prev, M, M.next) >= 0
    )
      return !1
    M = M.next
  }
  return !0
}
function Z5(e, A, I, g) {
  const C = e.prev,
    i = e,
    B = e.next
  if (qB(C, i, B) >= 0) return !1
  const o = C.x,
    r = i.x,
    s = B.x,
    h = C.y,
    S = i.y,
    d = B.y,
    w = o < r ? (o < s ? o : s) : r < s ? r : s,
    M = h < S ? (h < d ? h : d) : S < d ? S : d,
    K = o > r ? (o > s ? o : s) : r > s ? r : s,
    R = h > S ? (h > d ? h : d) : S > d ? S : d,
    F = ym(w, M, A, I, g),
    L = ym(K, R, A, I, g)
  let Y = e.prevZ,
    H = e.nextZ
  for (; Y && Y.z >= F && H && H.z <= L; ) {
    if (
      (Y.x >= w &&
        Y.x <= K &&
        Y.y >= M &&
        Y.y <= R &&
        Y !== C &&
        Y !== B &&
        gp(o, h, r, S, s, d, Y.x, Y.y) &&
        qB(Y.prev, Y, Y.next) >= 0) ||
      ((Y = Y.prevZ),
      H.x >= w &&
        H.x <= K &&
        H.y >= M &&
        H.y <= R &&
        H !== C &&
        H !== B &&
        gp(o, h, r, S, s, d, H.x, H.y) &&
        qB(H.prev, H, H.next) >= 0)
    )
      return !1
    H = H.nextZ
  }
  for (; Y && Y.z >= F; ) {
    if (
      Y.x >= w &&
      Y.x <= K &&
      Y.y >= M &&
      Y.y <= R &&
      Y !== C &&
      Y !== B &&
      gp(o, h, r, S, s, d, Y.x, Y.y) &&
      qB(Y.prev, Y, Y.next) >= 0
    )
      return !1
    Y = Y.prevZ
  }
  for (; H && H.z <= L; ) {
    if (
      H.x >= w &&
      H.x <= K &&
      H.y >= M &&
      H.y <= R &&
      H !== C &&
      H !== B &&
      gp(o, h, r, S, s, d, H.x, H.y) &&
      qB(H.prev, H, H.next) >= 0
    )
      return !1
    H = H.nextZ
  }
  return !0
}
function P5(e, A, I) {
  let g = e
  do {
    const C = g.prev,
      i = g.next.next
    ;(!sF(C, i) &&
      sb(C, g, g.next, i) &&
      uG(C, i) &&
      uG(i, C) &&
      (A.push((C.i / I) | 0),
      A.push((g.i / I) | 0),
      A.push((i.i / I) | 0),
      DG(g),
      DG(g.next),
      (g = e = i)),
      (g = g.next))
  } while (g !== e)
  return Yf(g)
}
function W5(e, A, I, g, C, i) {
  let B = e
  do {
    let o = B.next.next
    for (; o !== B.prev; ) {
      if (B.i !== o.i && Cj(B, o)) {
        let r = lb(B, o)
        ;((B = Yf(B, B.next)),
          (r = Yf(r, r.next)),
          hG(B, A, I, g, C, i, 0),
          hG(r, A, I, g, C, i, 0))
        return
      }
      o = o.next
    }
    B = B.next
  } while (B !== e)
}
function V5(e, A, I, g) {
  const C = []
  let i, B, o, r, s
  for (i = 0, B = A.length; i < B; i++)
    ((o = A[i] * g),
      (r = i < B - 1 ? A[i + 1] * g : e.length),
      (s = rb(e, o, r, g, !1)),
      s === s.next && (s.steiner = !0),
      C.push(gj(s)))
  for (C.sort(j5), i = 0; i < C.length; i++) I = z5(C[i], I)
  return I
}
function j5(e, A) {
  return e.x - A.x
}
function z5(e, A) {
  const I = X5(e, A)
  if (!I) return A
  const g = lb(I, e)
  return (Yf(g, g.next), Yf(I, I.next))
}
function X5(e, A) {
  let I = A,
    g = -1 / 0,
    C
  const i = e.x,
    B = e.y
  do {
    if (B <= I.y && B >= I.next.y && I.next.y !== I.y) {
      const d = I.x + ((B - I.y) * (I.next.x - I.x)) / (I.next.y - I.y)
      if (d <= i && d > g && ((g = d), (C = I.x < I.next.x ? I : I.next), d === i)) return C
    }
    I = I.next
  } while (I !== A)
  if (!C) return null
  const o = C,
    r = C.x,
    s = C.y
  let h = 1 / 0,
    S
  I = C
  do
    (i >= I.x &&
      I.x >= r &&
      i !== I.x &&
      gp(B < s ? i : g, B, r, s, B < s ? g : i, B, I.x, I.y) &&
      ((S = Math.abs(B - I.y) / (i - I.x)),
      uG(I, e) &&
        (S < h || (S === h && (I.x > C.x || (I.x === C.x && $5(C, I))))) &&
        ((C = I), (h = S))),
      (I = I.next))
  while (I !== o)
  return C
}
function $5(e, A) {
  return qB(e.prev, e, A.prev) < 0 && qB(A.next, e, e.next) < 0
}
function Aj(e, A, I, g) {
  let C = e
  do
    (C.z === 0 && (C.z = ym(C.x, C.y, A, I, g)),
      (C.prevZ = C.prev),
      (C.nextZ = C.next),
      (C = C.next))
  while (C !== e)
  ;((C.prevZ.nextZ = null), (C.prevZ = null), Ij(C))
}
function Ij(e) {
  let A,
    I,
    g,
    C,
    i,
    B,
    o,
    r,
    s = 1
  do {
    for (I = e, e = null, i = null, B = 0; I; ) {
      for (B++, g = I, o = 0, A = 0; A < s && (o++, (g = g.nextZ), !!g); A++);
      for (r = s; o > 0 || (r > 0 && g); )
        (o !== 0 && (r === 0 || !g || I.z <= g.z)
          ? ((C = I), (I = I.nextZ), o--)
          : ((C = g), (g = g.nextZ), r--),
          i ? (i.nextZ = C) : (e = C),
          (C.prevZ = i),
          (i = C))
      I = g
    }
    ;((i.nextZ = null), (s *= 2))
  } while (B > 1)
  return e
}
function ym(e, A, I, g, C) {
  return (
    (e = ((e - I) * C) | 0),
    (A = ((A - g) * C) | 0),
    (e = (e | (e << 8)) & 16711935),
    (e = (e | (e << 4)) & 252645135),
    (e = (e | (e << 2)) & 858993459),
    (e = (e | (e << 1)) & 1431655765),
    (A = (A | (A << 8)) & 16711935),
    (A = (A | (A << 4)) & 252645135),
    (A = (A | (A << 2)) & 858993459),
    (A = (A | (A << 1)) & 1431655765),
    e | (A << 1)
  )
}
function gj(e) {
  let A = e,
    I = e
  do ((A.x < I.x || (A.x === I.x && A.y < I.y)) && (I = A), (A = A.next))
  while (A !== e)
  return I
}
function gp(e, A, I, g, C, i, B, o) {
  return (
    (C - B) * (A - o) >= (e - B) * (i - o) &&
    (e - B) * (g - o) >= (I - B) * (A - o) &&
    (I - B) * (i - o) >= (C - B) * (g - o)
  )
}
function Cj(e, A) {
  return (
    e.next.i !== A.i &&
    e.prev.i !== A.i &&
    !ej(e, A) && // dones't intersect other edges
    ((uG(e, A) &&
      uG(A, e) &&
      ij(e, A) && // locally visible
      (qB(e.prev, e, A.prev) || qB(e, A.prev, A))) || // does not create opposite-facing sectors
      (sF(e, A) && qB(e.prev, e, e.next) > 0 && qB(A.prev, A, A.next) > 0))
  )
}
function qB(e, A, I) {
  return (A.y - e.y) * (I.x - A.x) - (A.x - e.x) * (I.y - A.y)
}
function sF(e, A) {
  return e.x === A.x && e.y === A.y
}
function sb(e, A, I, g) {
  const C = cU(qB(e, A, I)),
    i = cU(qB(e, A, g)),
    B = cU(qB(I, g, e)),
    o = cU(qB(I, g, A))
  return !!(
    (C !== i && B !== o) ||
    (C === 0 && lU(e, I, A)) ||
    (i === 0 && lU(e, g, A)) ||
    (B === 0 && lU(I, e, g)) ||
    (o === 0 && lU(I, A, g))
  )
}
function lU(e, A, I) {
  return (
    A.x <= Math.max(e.x, I.x) &&
    A.x >= Math.min(e.x, I.x) &&
    A.y <= Math.max(e.y, I.y) &&
    A.y >= Math.min(e.y, I.y)
  )
}
function cU(e) {
  return e > 0 ? 1 : e < 0 ? -1 : 0
}
function ej(e, A) {
  let I = e
  do {
    if (I.i !== e.i && I.next.i !== e.i && I.i !== A.i && I.next.i !== A.i && sb(I, I.next, e, A))
      return !0
    I = I.next
  } while (I !== e)
  return !1
}
function uG(e, A) {
  return qB(e.prev, e, e.next) < 0
    ? qB(e, A, e.next) >= 0 && qB(e, e.prev, A) >= 0
    : qB(e, A, e.prev) < 0 || qB(e, e.next, A) < 0
}
function ij(e, A) {
  let I = e,
    g = !1
  const C = (e.x + A.x) / 2,
    i = (e.y + A.y) / 2
  do
    (I.y > i != I.next.y > i &&
      I.next.y !== I.y &&
      C < ((I.next.x - I.x) * (i - I.y)) / (I.next.y - I.y) + I.x &&
      (g = !g),
      (I = I.next))
  while (I !== e)
  return g
}
function lb(e, A) {
  const I = new pm(e.i, e.x, e.y),
    g = new pm(A.i, A.x, A.y),
    C = e.next,
    i = A.prev
  return (
    (e.next = A),
    (A.prev = e),
    (I.next = C),
    (C.prev = I),
    (g.next = I),
    (I.prev = g),
    (i.next = g),
    (g.prev = i),
    g
  )
}
function TH(e, A, I, g) {
  const C = new pm(e, A, I)
  return (
    g
      ? ((C.next = g.next), (C.prev = g), (g.next.prev = C), (g.next = C))
      : ((C.prev = C), (C.next = C)),
    C
  )
}
function DG(e) {
  ;((e.next.prev = e.prev),
    (e.prev.next = e.next),
    e.prevZ && (e.prevZ.nextZ = e.nextZ),
    e.nextZ && (e.nextZ.prevZ = e.prevZ))
}
function pm(e, A, I) {
  ;((this.i = e),
    (this.x = A),
    (this.y = I),
    (this.prev = null),
    (this.next = null),
    (this.z = 0),
    (this.prevZ = null),
    (this.nextZ = null),
    (this.steiner = !1))
}
function tj(e, A, I, g) {
  let C = 0
  for (let i = A, B = I - g; i < I; i += g) ((C += (e[B] - e[i]) * (e[i + 1] + e[B + 1])), (B = i))
  return C
}
class _c {
  // calculate area of the contour polygon
  static area(A) {
    const I = A.length
    let g = 0
    for (let C = I - 1, i = 0; i < I; C = i++) g += A[C].x * A[i].y - A[i].x * A[C].y
    return g * 0.5
  }
  static isClockWise(A) {
    return _c.area(A) < 0
  }
  static triangulateShape(A, I) {
    const g = [],
      C = [],
      i = []
    ;(xH(A), bH(g, A))
    let B = A.length
    I.forEach(xH)
    for (let r = 0; r < I.length; r++) (C.push(B), (B += I[r].length), bH(g, I[r]))
    const o = O5.triangulate(g, C)
    for (let r = 0; r < o.length; r += 3) i.push(o.slice(r, r + 3))
    return i
  }
}
function xH(e) {
  const A = e.length
  A > 2 && e[A - 1].equals(e[0]) && e.pop()
}
function bH(e, A) {
  for (let I = 0; I < A.length; I++) (e.push(A[I].x), e.push(A[I].y))
}
class lF extends se {
  constructor(
    A = new mf([new ZI(0.5, 0.5), new ZI(-0.5, 0.5), new ZI(-0.5, -0.5), new ZI(0.5, -0.5)]),
    I = {},
  ) {
    ;(super(),
      (this.type = "ExtrudeGeometry"),
      (this.parameters = {
        shapes: A,
        options: I,
      }),
      (A = Array.isArray(A) ? A : [A]))
    const g = this,
      C = [],
      i = []
    for (let o = 0, r = A.length; o < r; o++) {
      const s = A[o]
      B(s)
    }
    ;(this.setAttribute("position", new aC(C, 3)),
      this.setAttribute("uv", new aC(i, 2)),
      this.computeVertexNormals())
    function B(o) {
      const r = [],
        s = I.curveSegments !== void 0 ? I.curveSegments : 12,
        h = I.steps !== void 0 ? I.steps : 1,
        S = I.depth !== void 0 ? I.depth : 1
      let d = I.bevelEnabled !== void 0 ? I.bevelEnabled : !0,
        w = I.bevelThickness !== void 0 ? I.bevelThickness : 0.2,
        M = I.bevelSize !== void 0 ? I.bevelSize : w - 0.1,
        K = I.bevelOffset !== void 0 ? I.bevelOffset : 0,
        R = I.bevelSegments !== void 0 ? I.bevelSegments : 3
      const F = I.extrudePath,
        L = I.UVGenerator !== void 0 ? I.UVGenerator : Bj
      let Y,
        H = !1,
        V,
        j,
        P,
        AA
      ;(F &&
        ((Y = F.getSpacedPoints(h)),
        (H = !0),
        (d = !1),
        (V = F.computeFrenetFrames(h, !1)),
        (j = new wA()),
        (P = new wA()),
        (AA = new wA())),
        d || ((R = 0), (w = 0), (M = 0), (K = 0)))
      const X = o.extractPoints(s)
      let _ = X.shape
      const eA = X.holes
      if (!_c.isClockWise(_)) {
        _ = _.reverse()
        for (let YA = 0, eI = eA.length; YA < eI; YA++) {
          const uA = eA[YA]
          _c.isClockWise(uA) && (eA[YA] = uA.reverse())
        }
      }
      const aA = _c.triangulateShape(_, eA),
        lA = _
      for (let YA = 0, eI = eA.length; YA < eI; YA++) {
        const uA = eA[YA]
        _ = _.concat(uA)
      }
      function JA(YA, eI, uA) {
        return (
          eI || console.error("THREE.ExtrudeGeometry: vec does not exist"),
          YA.clone().addScaledVector(eI, uA)
        )
      }
      const yA = _.length,
        LA = aA.length
      function nA(YA, eI, uA) {
        let hI, II, pI
        const AI = YA.x - eI.x,
          YI = YA.y - eI.y,
          SI = uA.x - YA.x,
          QA = uA.y - YA.y,
          tA = AI * AI + YI * YI,
          FA = AI * QA - YI * SI
        if (Math.abs(FA) > Number.EPSILON) {
          const WA = Math.sqrt(tA),
            jA = Math.sqrt(SI * SI + QA * QA),
            nI = eI.x - YI / WA,
            UI = eI.y + AI / WA,
            GI = uA.x - QA / jA,
            LI = uA.y + SI / jA,
            Bg = ((GI - nI) * QA - (LI - UI) * SI) / (AI * QA - YI * SI)
          ;((hI = nI + AI * Bg - YA.x), (II = UI + YI * Bg - YA.y))
          const MA = hI * hI + II * II
          if (MA <= 2) return new ZI(hI, II)
          pI = Math.sqrt(MA / 2)
        } else {
          let WA = !1
          ;(AI > Number.EPSILON
            ? SI > Number.EPSILON && (WA = !0)
            : AI < -Number.EPSILON
              ? SI < -Number.EPSILON && (WA = !0)
              : Math.sign(YI) === Math.sign(QA) && (WA = !0),
            WA
              ? ((hI = -YI), (II = AI), (pI = Math.sqrt(tA)))
              : ((hI = AI), (II = YI), (pI = Math.sqrt(tA / 2))))
        }
        return new ZI(hI / pI, II / pI)
      }
      const fA = []
      for (let YA = 0, eI = lA.length, uA = eI - 1, hI = YA + 1; YA < eI; YA++, uA++, hI++)
        (uA === eI && (uA = 0), hI === eI && (hI = 0), (fA[YA] = nA(lA[YA], lA[uA], lA[hI])))
      const sA = []
      let $,
        EA = fA.concat()
      for (let YA = 0, eI = eA.length; YA < eI; YA++) {
        const uA = eA[YA]
        $ = []
        for (let hI = 0, II = uA.length, pI = II - 1, AI = hI + 1; hI < II; hI++, pI++, AI++)
          (pI === II && (pI = 0), AI === II && (AI = 0), ($[hI] = nA(uA[hI], uA[pI], uA[AI])))
        ;(sA.push($), (EA = EA.concat($)))
      }
      for (let YA = 0; YA < R; YA++) {
        const eI = YA / R,
          uA = w * Math.cos((eI * Math.PI) / 2),
          hI = M * Math.sin((eI * Math.PI) / 2) + K
        for (let II = 0, pI = lA.length; II < pI; II++) {
          const AI = JA(lA[II], fA[II], hI)
          NA(AI.x, AI.y, -uA)
        }
        for (let II = 0, pI = eA.length; II < pI; II++) {
          const AI = eA[II]
          $ = sA[II]
          for (let YI = 0, SI = AI.length; YI < SI; YI++) {
            const QA = JA(AI[YI], $[YI], hI)
            NA(QA.x, QA.y, -uA)
          }
        }
      }
      const GA = M + K
      for (let YA = 0; YA < yA; YA++) {
        const eI = d ? JA(_[YA], EA[YA], GA) : _[YA]
        H
          ? (P.copy(V.normals[0]).multiplyScalar(eI.x),
            j.copy(V.binormals[0]).multiplyScalar(eI.y),
            AA.copy(Y[0]).add(P).add(j),
            NA(AA.x, AA.y, AA.z))
          : NA(eI.x, eI.y, 0)
      }
      for (let YA = 1; YA <= h; YA++)
        for (let eI = 0; eI < yA; eI++) {
          const uA = d ? JA(_[eI], EA[eI], GA) : _[eI]
          H
            ? (P.copy(V.normals[YA]).multiplyScalar(uA.x),
              j.copy(V.binormals[YA]).multiplyScalar(uA.y),
              AA.copy(Y[YA]).add(P).add(j),
              NA(AA.x, AA.y, AA.z))
            : NA(uA.x, uA.y, (S / h) * YA)
        }
      for (let YA = R - 1; YA >= 0; YA--) {
        const eI = YA / R,
          uA = w * Math.cos((eI * Math.PI) / 2),
          hI = M * Math.sin((eI * Math.PI) / 2) + K
        for (let II = 0, pI = lA.length; II < pI; II++) {
          const AI = JA(lA[II], fA[II], hI)
          NA(AI.x, AI.y, S + uA)
        }
        for (let II = 0, pI = eA.length; II < pI; II++) {
          const AI = eA[II]
          $ = sA[II]
          for (let YI = 0, SI = AI.length; YI < SI; YI++) {
            const QA = JA(AI[YI], $[YI], hI)
            H ? NA(QA.x, QA.y + Y[h - 1].y, Y[h - 1].x + uA) : NA(QA.x, QA.y, S + uA)
          }
        }
      }
      ;(DA(), dA())
      function DA() {
        const YA = C.length / 3
        if (d) {
          let eI = 0,
            uA = yA * eI
          for (let hI = 0; hI < LA; hI++) {
            const II = aA[hI]
            qA(II[2] + uA, II[1] + uA, II[0] + uA)
          }
          ;((eI = h + R * 2), (uA = yA * eI))
          for (let hI = 0; hI < LA; hI++) {
            const II = aA[hI]
            qA(II[0] + uA, II[1] + uA, II[2] + uA)
          }
        } else {
          for (let eI = 0; eI < LA; eI++) {
            const uA = aA[eI]
            qA(uA[2], uA[1], uA[0])
          }
          for (let eI = 0; eI < LA; eI++) {
            const uA = aA[eI]
            qA(uA[0] + yA * h, uA[1] + yA * h, uA[2] + yA * h)
          }
        }
        g.addGroup(YA, C.length / 3 - YA, 0)
      }
      function dA() {
        const YA = C.length / 3
        let eI = 0
        ;(kA(lA, eI), (eI += lA.length))
        for (let uA = 0, hI = eA.length; uA < hI; uA++) {
          const II = eA[uA]
          ;(kA(II, eI), (eI += II.length))
        }
        g.addGroup(YA, C.length / 3 - YA, 1)
      }
      function kA(YA, eI) {
        let uA = YA.length
        for (; --uA >= 0; ) {
          const hI = uA
          let II = uA - 1
          II < 0 && (II = YA.length - 1)
          for (let pI = 0, AI = h + R * 2; pI < AI; pI++) {
            const YI = yA * pI,
              SI = yA * (pI + 1),
              QA = eI + hI + YI,
              tA = eI + II + YI,
              FA = eI + II + SI,
              WA = eI + hI + SI
            ZA(QA, tA, FA, WA)
          }
        }
      }
      function NA(YA, eI, uA) {
        ;(r.push(YA), r.push(eI), r.push(uA))
      }
      function qA(YA, eI, uA) {
        ;(sI(YA), sI(eI), sI(uA))
        const hI = C.length / 3,
          II = L.generateTopUV(g, C, hI - 3, hI - 2, hI - 1)
        ;(cI(II[0]), cI(II[1]), cI(II[2]))
      }
      function ZA(YA, eI, uA, hI) {
        ;(sI(YA), sI(eI), sI(hI), sI(eI), sI(uA), sI(hI))
        const II = C.length / 3,
          pI = L.generateSideWallUV(g, C, II - 6, II - 3, II - 2, II - 1)
        ;(cI(pI[0]), cI(pI[1]), cI(pI[3]), cI(pI[1]), cI(pI[2]), cI(pI[3]))
      }
      function sI(YA) {
        ;(C.push(r[YA * 3 + 0]), C.push(r[YA * 3 + 1]), C.push(r[YA * 3 + 2]))
      }
      function cI(YA) {
        ;(i.push(YA.x), i.push(YA.y))
      }
    }
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
  toJSON() {
    const A = super.toJSON(),
      I = this.parameters.shapes,
      g = this.parameters.options
    return Qj(I, g, A)
  }
  static fromJSON(A, I) {
    const g = []
    for (let i = 0, B = A.shapes.length; i < B; i++) {
      const o = I[A.shapes[i]]
      g.push(o)
    }
    const C = A.options.extrudePath
    return (
      C !== void 0 && (A.options.extrudePath = new pN[C.type]().fromJSON(C)),
      new lF(g, A.options)
    )
  }
}
const Bj = {
  generateTopUV: function (e, A, I, g, C) {
    const i = A[I * 3],
      B = A[I * 3 + 1],
      o = A[g * 3],
      r = A[g * 3 + 1],
      s = A[C * 3],
      h = A[C * 3 + 1]
    return [new ZI(i, B), new ZI(o, r), new ZI(s, h)]
  },
  generateSideWallUV: function (e, A, I, g, C, i) {
    const B = A[I * 3],
      o = A[I * 3 + 1],
      r = A[I * 3 + 2],
      s = A[g * 3],
      h = A[g * 3 + 1],
      S = A[g * 3 + 2],
      d = A[C * 3],
      w = A[C * 3 + 1],
      M = A[C * 3 + 2],
      K = A[i * 3],
      R = A[i * 3 + 1],
      F = A[i * 3 + 2]
    return Math.abs(o - h) < Math.abs(B - s)
      ? [new ZI(B, 1 - r), new ZI(s, 1 - S), new ZI(d, 1 - M), new ZI(K, 1 - F)]
      : [new ZI(o, 1 - r), new ZI(h, 1 - S), new ZI(w, 1 - M), new ZI(R, 1 - F)]
  },
}
function Qj(e, A, I) {
  if (((I.shapes = []), Array.isArray(e)))
    for (let g = 0, C = e.length; g < C; g++) {
      const i = e[g]
      I.shapes.push(i.uuid)
    }
  else I.shapes.push(e.uuid)
  return (
    (I.options = Object.assign({}, A)),
    A.extrudePath !== void 0 && (I.options.extrudePath = A.extrudePath.toJSON()),
    I
  )
}
class cF extends LD {
  constructor(A = 1, I = 0) {
    const g = (1 + Math.sqrt(5)) / 2,
      C = [
        -1,
        g,
        0,
        1,
        g,
        0,
        -1,
        -g,
        0,
        1,
        -g,
        0,
        0,
        -1,
        g,
        0,
        1,
        g,
        0,
        -1,
        -g,
        0,
        1,
        -g,
        g,
        0,
        -1,
        g,
        0,
        1,
        -g,
        0,
        -1,
        -g,
        0,
        1,
      ],
      i = [
        0, 11, 5, 0, 5, 1, 0, 1, 7, 0, 7, 10, 0, 10, 11, 1, 5, 9, 5, 11, 4, 11, 10, 2, 10, 7, 6, 7,
        1, 8, 3, 9, 4, 3, 4, 2, 3, 2, 6, 3, 6, 8, 3, 8, 9, 4, 9, 5, 2, 4, 11, 6, 2, 10, 8, 6, 7, 9,
        8, 1,
      ]
    ;(super(C, i, A, I),
      (this.type = "IcosahedronGeometry"),
      (this.parameters = {
        radius: A,
        detail: I,
      }))
  }
  static fromJSON(A) {
    return new cF(A.radius, A.detail)
  }
}
class LG extends LD {
  constructor(A = 1, I = 0) {
    const g = [1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1],
      C = [0, 2, 4, 0, 4, 3, 0, 3, 5, 0, 5, 2, 1, 2, 5, 1, 5, 3, 1, 3, 4, 1, 4, 2]
    ;(super(g, C, A, I),
      (this.type = "OctahedronGeometry"),
      (this.parameters = {
        radius: A,
        detail: I,
      }))
  }
  static fromJSON(A) {
    return new LG(A.radius, A.detail)
  }
}
class hF extends se {
  constructor(A = 0.5, I = 1, g = 32, C = 1, i = 0, B = Math.PI * 2) {
    ;(super(),
      (this.type = "RingGeometry"),
      (this.parameters = {
        innerRadius: A,
        outerRadius: I,
        thetaSegments: g,
        phiSegments: C,
        thetaStart: i,
        thetaLength: B,
      }),
      (g = Math.max(3, g)),
      (C = Math.max(1, C)))
    const o = [],
      r = [],
      s = [],
      h = []
    let S = A
    const d = (I - A) / C,
      w = new wA(),
      M = new ZI()
    for (let K = 0; K <= C; K++) {
      for (let R = 0; R <= g; R++) {
        const F = i + (R / g) * B
        ;((w.x = S * Math.cos(F)),
          (w.y = S * Math.sin(F)),
          r.push(w.x, w.y, w.z),
          s.push(0, 0, 1),
          (M.x = (w.x / I + 1) / 2),
          (M.y = (w.y / I + 1) / 2),
          h.push(M.x, M.y))
      }
      S += d
    }
    for (let K = 0; K < C; K++) {
      const R = K * (g + 1)
      for (let F = 0; F < g; F++) {
        const L = F + R,
          Y = L,
          H = L + g + 1,
          V = L + g + 2,
          j = L + 1
        ;(o.push(Y, H, j), o.push(H, V, j))
      }
    }
    ;(this.setIndex(o),
      this.setAttribute("position", new aC(r, 3)),
      this.setAttribute("normal", new aC(s, 3)),
      this.setAttribute("uv", new aC(h, 2)))
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
  static fromJSON(A) {
    return new hF(
      A.innerRadius,
      A.outerRadius,
      A.thetaSegments,
      A.phiSegments,
      A.thetaStart,
      A.thetaLength,
    )
  }
}
class uF extends se {
  constructor(A = new mf([new ZI(0, 0.5), new ZI(-0.5, -0.5), new ZI(0.5, -0.5)]), I = 12) {
    ;(super(),
      (this.type = "ShapeGeometry"),
      (this.parameters = {
        shapes: A,
        curveSegments: I,
      }))
    const g = [],
      C = [],
      i = [],
      B = []
    let o = 0,
      r = 0
    if (Array.isArray(A) === !1) s(A)
    else for (let h = 0; h < A.length; h++) (s(A[h]), this.addGroup(o, r, h), (o += r), (r = 0))
    ;(this.setIndex(g),
      this.setAttribute("position", new aC(C, 3)),
      this.setAttribute("normal", new aC(i, 3)),
      this.setAttribute("uv", new aC(B, 2)))
    function s(h) {
      const S = C.length / 3,
        d = h.extractPoints(I)
      let w = d.shape
      const M = d.holes
      _c.isClockWise(w) === !1 && (w = w.reverse())
      for (let R = 0, F = M.length; R < F; R++) {
        const L = M[R]
        _c.isClockWise(L) === !0 && (M[R] = L.reverse())
      }
      const K = _c.triangulateShape(w, M)
      for (let R = 0, F = M.length; R < F; R++) {
        const L = M[R]
        w = w.concat(L)
      }
      for (let R = 0, F = w.length; R < F; R++) {
        const L = w[R]
        ;(C.push(L.x, L.y, 0), i.push(0, 0, 1), B.push(L.x, L.y))
      }
      for (let R = 0, F = K.length; R < F; R++) {
        const L = K[R],
          Y = L[0] + S,
          H = L[1] + S,
          V = L[2] + S
        ;(g.push(Y, H, V), (r += 3))
      }
    }
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
  toJSON() {
    const A = super.toJSON(),
      I = this.parameters.shapes
    return oj(I, A)
  }
  static fromJSON(A, I) {
    const g = []
    for (let C = 0, i = A.shapes.length; C < i; C++) {
      const B = I[A.shapes[C]]
      g.push(B)
    }
    return new uF(g, A.curveSegments)
  }
}
function oj(e, A) {
  if (((A.shapes = []), Array.isArray(e)))
    for (let I = 0, g = e.length; I < g; I++) {
      const C = e[I]
      A.shapes.push(C.uuid)
    }
  else A.shapes.push(e.uuid)
  return A
}
class YG extends se {
  constructor(A = 1, I = 32, g = 16, C = 0, i = Math.PI * 2, B = 0, o = Math.PI) {
    ;(super(),
      (this.type = "SphereGeometry"),
      (this.parameters = {
        radius: A,
        widthSegments: I,
        heightSegments: g,
        phiStart: C,
        phiLength: i,
        thetaStart: B,
        thetaLength: o,
      }),
      (I = Math.max(3, Math.floor(I))),
      (g = Math.max(2, Math.floor(g))))
    const r = Math.min(B + o, Math.PI)
    let s = 0
    const h = [],
      S = new wA(),
      d = new wA(),
      w = [],
      M = [],
      K = [],
      R = []
    for (let F = 0; F <= g; F++) {
      const L = [],
        Y = F / g
      let H = 0
      F === 0 && B === 0 ? (H = 0.5 / I) : F === g && r === Math.PI && (H = -0.5 / I)
      for (let V = 0; V <= I; V++) {
        const j = V / I
        ;((S.x = -A * Math.cos(C + j * i) * Math.sin(B + Y * o)),
          (S.y = A * Math.cos(B + Y * o)),
          (S.z = A * Math.sin(C + j * i) * Math.sin(B + Y * o)),
          M.push(S.x, S.y, S.z),
          d.copy(S).normalize(),
          K.push(d.x, d.y, d.z),
          R.push(j + H, 1 - Y),
          L.push(s++))
      }
      h.push(L)
    }
    for (let F = 0; F < g; F++)
      for (let L = 0; L < I; L++) {
        const Y = h[F][L + 1],
          H = h[F][L],
          V = h[F + 1][L],
          j = h[F + 1][L + 1]
        ;((F !== 0 || B > 0) && w.push(Y, H, j), (F !== g - 1 || r < Math.PI) && w.push(H, V, j))
      }
    ;(this.setIndex(w),
      this.setAttribute("position", new aC(M, 3)),
      this.setAttribute("normal", new aC(K, 3)),
      this.setAttribute("uv", new aC(R, 2)))
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
  static fromJSON(A) {
    return new YG(
      A.radius,
      A.widthSegments,
      A.heightSegments,
      A.phiStart,
      A.phiLength,
      A.thetaStart,
      A.thetaLength,
    )
  }
}
class DF extends LD {
  constructor(A = 1, I = 0) {
    const g = [1, 1, 1, -1, -1, 1, -1, 1, -1, 1, -1, -1],
      C = [2, 1, 0, 0, 3, 2, 1, 3, 0, 2, 3, 1]
    ;(super(g, C, A, I),
      (this.type = "TetrahedronGeometry"),
      (this.parameters = {
        radius: A,
        detail: I,
      }))
  }
  static fromJSON(A) {
    return new DF(A.radius, A.detail)
  }
}
class SF extends se {
  constructor(A = 1, I = 0.4, g = 12, C = 48, i = Math.PI * 2) {
    ;(super(),
      (this.type = "TorusGeometry"),
      (this.parameters = {
        radius: A,
        tube: I,
        radialSegments: g,
        tubularSegments: C,
        arc: i,
      }),
      (g = Math.floor(g)),
      (C = Math.floor(C)))
    const B = [],
      o = [],
      r = [],
      s = [],
      h = new wA(),
      S = new wA(),
      d = new wA()
    for (let w = 0; w <= g; w++)
      for (let M = 0; M <= C; M++) {
        const K = (M / C) * i,
          R = (w / g) * Math.PI * 2
        ;((S.x = (A + I * Math.cos(R)) * Math.cos(K)),
          (S.y = (A + I * Math.cos(R)) * Math.sin(K)),
          (S.z = I * Math.sin(R)),
          o.push(S.x, S.y, S.z),
          (h.x = A * Math.cos(K)),
          (h.y = A * Math.sin(K)),
          d.subVectors(S, h).normalize(),
          r.push(d.x, d.y, d.z),
          s.push(M / C),
          s.push(w / g))
      }
    for (let w = 1; w <= g; w++)
      for (let M = 1; M <= C; M++) {
        const K = (C + 1) * w + M - 1,
          R = (C + 1) * (w - 1) + M - 1,
          F = (C + 1) * (w - 1) + M,
          L = (C + 1) * w + M
        ;(B.push(K, R, L), B.push(R, F, L))
      }
    ;(this.setIndex(B),
      this.setAttribute("position", new aC(o, 3)),
      this.setAttribute("normal", new aC(r, 3)),
      this.setAttribute("uv", new aC(s, 2)))
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
  static fromJSON(A) {
    return new SF(A.radius, A.tube, A.radialSegments, A.tubularSegments, A.arc)
  }
}
class fF extends se {
  constructor(A = 1, I = 0.4, g = 64, C = 8, i = 2, B = 3) {
    ;(super(),
      (this.type = "TorusKnotGeometry"),
      (this.parameters = {
        radius: A,
        tube: I,
        tubularSegments: g,
        radialSegments: C,
        p: i,
        q: B,
      }),
      (g = Math.floor(g)),
      (C = Math.floor(C)))
    const o = [],
      r = [],
      s = [],
      h = [],
      S = new wA(),
      d = new wA(),
      w = new wA(),
      M = new wA(),
      K = new wA(),
      R = new wA(),
      F = new wA()
    for (let Y = 0; Y <= g; ++Y) {
      const H = (Y / g) * i * Math.PI * 2
      ;(L(H, i, B, A, w),
        L(H + 0.01, i, B, A, M),
        R.subVectors(M, w),
        F.addVectors(M, w),
        K.crossVectors(R, F),
        F.crossVectors(K, R),
        K.normalize(),
        F.normalize())
      for (let V = 0; V <= C; ++V) {
        const j = (V / C) * Math.PI * 2,
          P = -I * Math.cos(j),
          AA = I * Math.sin(j)
        ;((S.x = w.x + (P * F.x + AA * K.x)),
          (S.y = w.y + (P * F.y + AA * K.y)),
          (S.z = w.z + (P * F.z + AA * K.z)),
          r.push(S.x, S.y, S.z),
          d.subVectors(S, w).normalize(),
          s.push(d.x, d.y, d.z),
          h.push(Y / g),
          h.push(V / C))
      }
    }
    for (let Y = 1; Y <= g; Y++)
      for (let H = 1; H <= C; H++) {
        const V = (C + 1) * (Y - 1) + (H - 1),
          j = (C + 1) * Y + (H - 1),
          P = (C + 1) * Y + H,
          AA = (C + 1) * (Y - 1) + H
        ;(o.push(V, j, AA), o.push(j, P, AA))
      }
    ;(this.setIndex(o),
      this.setAttribute("position", new aC(r, 3)),
      this.setAttribute("normal", new aC(s, 3)),
      this.setAttribute("uv", new aC(h, 2)))
    function L(Y, H, V, j, P) {
      const AA = Math.cos(Y),
        X = Math.sin(Y),
        _ = (V / H) * Y,
        eA = Math.cos(_)
      ;((P.x = j * (2 + eA) * 0.5 * AA),
        (P.y = j * (2 + eA) * X * 0.5),
        (P.z = j * Math.sin(_) * 0.5))
    }
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
  static fromJSON(A) {
    return new fF(A.radius, A.tube, A.tubularSegments, A.radialSegments, A.p, A.q)
  }
}
class dF extends se {
  constructor(
    A = new sv(new wA(-1, -1, 0), new wA(-1, 1, 0), new wA(1, 1, 0)),
    I = 64,
    g = 1,
    C = 8,
    i = !1,
  ) {
    ;(super(),
      (this.type = "TubeGeometry"),
      (this.parameters = {
        path: A,
        tubularSegments: I,
        radius: g,
        radialSegments: C,
        closed: i,
      }))
    const B = A.computeFrenetFrames(I, i)
    ;((this.tangents = B.tangents), (this.normals = B.normals), (this.binormals = B.binormals))
    const o = new wA(),
      r = new wA(),
      s = new ZI()
    let h = new wA()
    const S = [],
      d = [],
      w = [],
      M = []
    ;(K(),
      this.setIndex(M),
      this.setAttribute("position", new aC(S, 3)),
      this.setAttribute("normal", new aC(d, 3)),
      this.setAttribute("uv", new aC(w, 2)))
    function K() {
      for (let Y = 0; Y < I; Y++) R(Y)
      ;(R(i === !1 ? I : 0), L(), F())
    }
    function R(Y) {
      h = A.getPointAt(Y / I, h)
      const H = B.normals[Y],
        V = B.binormals[Y]
      for (let j = 0; j <= C; j++) {
        const P = (j / C) * Math.PI * 2,
          AA = Math.sin(P),
          X = -Math.cos(P)
        ;((r.x = X * H.x + AA * V.x),
          (r.y = X * H.y + AA * V.y),
          (r.z = X * H.z + AA * V.z),
          r.normalize(),
          d.push(r.x, r.y, r.z),
          (o.x = h.x + g * r.x),
          (o.y = h.y + g * r.y),
          (o.z = h.z + g * r.z),
          S.push(o.x, o.y, o.z))
      }
    }
    function F() {
      for (let Y = 1; Y <= I; Y++)
        for (let H = 1; H <= C; H++) {
          const V = (C + 1) * (Y - 1) + (H - 1),
            j = (C + 1) * Y + (H - 1),
            P = (C + 1) * Y + H,
            AA = (C + 1) * (Y - 1) + H
          ;(M.push(V, j, AA), M.push(j, P, AA))
        }
    }
    function L() {
      for (let Y = 0; Y <= I; Y++)
        for (let H = 0; H <= C; H++) ((s.x = Y / I), (s.y = H / C), w.push(s.x, s.y))
    }
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
  toJSON() {
    const A = super.toJSON()
    return ((A.path = this.parameters.path.toJSON()), A)
  }
  static fromJSON(A) {
    return new dF(
      new pN[A.path.type]().fromJSON(A.path),
      A.tubularSegments,
      A.radius,
      A.radialSegments,
      A.closed,
    )
  }
}
class cb extends se {
  constructor(A = null) {
    if (
      (super(),
      (this.type = "WireframeGeometry"),
      (this.parameters = {
        geometry: A,
      }),
      A !== null)
    ) {
      const I = [],
        g = /* @__PURE__ */ new Set(),
        C = new wA(),
        i = new wA()
      if (A.index !== null) {
        const B = A.attributes.position,
          o = A.index
        let r = A.groups
        r.length === 0 && (r = [{ start: 0, count: o.count, materialIndex: 0 }])
        for (let s = 0, h = r.length; s < h; ++s) {
          const S = r[s],
            d = S.start,
            w = S.count
          for (let M = d, K = d + w; M < K; M += 3)
            for (let R = 0; R < 3; R++) {
              const F = o.getX(M + R),
                L = o.getX(M + ((R + 1) % 3))
              ;(C.fromBufferAttribute(B, F),
                i.fromBufferAttribute(B, L),
                OH(C, i, g) === !0 && (I.push(C.x, C.y, C.z), I.push(i.x, i.y, i.z)))
            }
        }
      } else {
        const B = A.attributes.position
        for (let o = 0, r = B.count / 3; o < r; o++)
          for (let s = 0; s < 3; s++) {
            const h = 3 * o + s,
              S = 3 * o + ((s + 1) % 3)
            ;(C.fromBufferAttribute(B, h),
              i.fromBufferAttribute(B, S),
              OH(C, i, g) === !0 && (I.push(C.x, C.y, C.z), I.push(i.x, i.y, i.z)))
          }
      }
      this.setAttribute("position", new aC(I, 3))
    }
  }
  copy(A) {
    return (super.copy(A), (this.parameters = Object.assign({}, A.parameters)), this)
  }
}
function OH(e, A, I) {
  const g = `${e.x},${e.y},${e.z}-${A.x},${A.y},${A.z}`,
    C = `${A.x},${A.y},${A.z}-${e.x},${e.y},${e.z}`
  return I.has(g) === !0 || I.has(C) === !0 ? !1 : (I.add(g), I.add(C), !0)
}
var _H = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BoxGeometry: Vf,
  CapsuleGeometry: nF,
  CircleGeometry: EF,
  ConeGeometry: aF,
  CylinderGeometry: wp,
  DodecahedronGeometry: rF,
  EdgesGeometry: ab,
  ExtrudeGeometry: lF,
  IcosahedronGeometry: cF,
  LatheGeometry: vG,
  OctahedronGeometry: LG,
  PlaneGeometry: su,
  PolyhedronGeometry: LD,
  RingGeometry: hF,
  ShapeGeometry: uF,
  SphereGeometry: YG,
  TetrahedronGeometry: DF,
  TorusGeometry: SF,
  TorusKnotGeometry: fF,
  TubeGeometry: dF,
  WireframeGeometry: cb,
})
class hb extends tQ {
  static get type() {
    return "ShadowMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isShadowMaterial = !0),
      (this.color = new Mg(0)),
      (this.transparent = !0),
      (this.fog = !0),
      this.setValues(A))
  }
  copy(A) {
    return (super.copy(A), this.color.copy(A.color), (this.fog = A.fog), this)
  }
}
class ub extends VQ {
  static get type() {
    return "RawShaderMaterial"
  }
  constructor(A) {
    ;(super(A), (this.isRawShaderMaterial = !0))
  }
}
class qG extends tQ {
  static get type() {
    return "MeshStandardMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isMeshStandardMaterial = !0),
      (this.defines = { STANDARD: "" }),
      (this.color = new Mg(16777215)),
      (this.roughness = 1),
      (this.metalness = 0),
      (this.map = null),
      (this.lightMap = null),
      (this.lightMapIntensity = 1),
      (this.aoMap = null),
      (this.aoMapIntensity = 1),
      (this.emissive = new Mg(0)),
      (this.emissiveIntensity = 1),
      (this.emissiveMap = null),
      (this.bumpMap = null),
      (this.bumpScale = 1),
      (this.normalMap = null),
      (this.normalMapType = vD),
      (this.normalScale = new ZI(1, 1)),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.roughnessMap = null),
      (this.metalnessMap = null),
      (this.alphaMap = null),
      (this.envMap = null),
      (this.envMapRotation = new uE()),
      (this.envMapIntensity = 1),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.wireframeLinecap = "round"),
      (this.wireframeLinejoin = "round"),
      (this.flatShading = !1),
      (this.fog = !0),
      this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      (this.defines = { STANDARD: "" }),
      this.color.copy(A.color),
      (this.roughness = A.roughness),
      (this.metalness = A.metalness),
      (this.map = A.map),
      (this.lightMap = A.lightMap),
      (this.lightMapIntensity = A.lightMapIntensity),
      (this.aoMap = A.aoMap),
      (this.aoMapIntensity = A.aoMapIntensity),
      this.emissive.copy(A.emissive),
      (this.emissiveMap = A.emissiveMap),
      (this.emissiveIntensity = A.emissiveIntensity),
      (this.bumpMap = A.bumpMap),
      (this.bumpScale = A.bumpScale),
      (this.normalMap = A.normalMap),
      (this.normalMapType = A.normalMapType),
      this.normalScale.copy(A.normalScale),
      (this.displacementMap = A.displacementMap),
      (this.displacementScale = A.displacementScale),
      (this.displacementBias = A.displacementBias),
      (this.roughnessMap = A.roughnessMap),
      (this.metalnessMap = A.metalnessMap),
      (this.alphaMap = A.alphaMap),
      (this.envMap = A.envMap),
      this.envMapRotation.copy(A.envMapRotation),
      (this.envMapIntensity = A.envMapIntensity),
      (this.wireframe = A.wireframe),
      (this.wireframeLinewidth = A.wireframeLinewidth),
      (this.wireframeLinecap = A.wireframeLinecap),
      (this.wireframeLinejoin = A.wireframeLinejoin),
      (this.flatShading = A.flatShading),
      (this.fog = A.fog),
      this
    )
  }
}
class Hr extends qG {
  static get type() {
    return "MeshPhysicalMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isMeshPhysicalMaterial = !0),
      (this.defines = {
        STANDARD: "",
        PHYSICAL: "",
      }),
      (this.anisotropyRotation = 0),
      (this.anisotropyMap = null),
      (this.clearcoatMap = null),
      (this.clearcoatRoughness = 0),
      (this.clearcoatRoughnessMap = null),
      (this.clearcoatNormalScale = new ZI(1, 1)),
      (this.clearcoatNormalMap = null),
      (this.ior = 1.5),
      Object.defineProperty(this, "reflectivity", {
        get: function () {
          return eQ((2.5 * (this.ior - 1)) / (this.ior + 1), 0, 1)
        },
        set: function (I) {
          this.ior = (1 + 0.4 * I) / (1 - 0.4 * I)
        },
      }),
      (this.iridescenceMap = null),
      (this.iridescenceIOR = 1.3),
      (this.iridescenceThicknessRange = [100, 400]),
      (this.iridescenceThicknessMap = null),
      (this.sheenColor = new Mg(0)),
      (this.sheenColorMap = null),
      (this.sheenRoughness = 1),
      (this.sheenRoughnessMap = null),
      (this.transmissionMap = null),
      (this.thickness = 0),
      (this.thicknessMap = null),
      (this.attenuationDistance = 1 / 0),
      (this.attenuationColor = new Mg(1, 1, 1)),
      (this.specularIntensity = 1),
      (this.specularIntensityMap = null),
      (this.specularColor = new Mg(1, 1, 1)),
      (this.specularColorMap = null),
      (this._anisotropy = 0),
      (this._clearcoat = 0),
      (this._dispersion = 0),
      (this._iridescence = 0),
      (this._sheen = 0),
      (this._transmission = 0),
      this.setValues(A))
  }
  get anisotropy() {
    return this._anisotropy
  }
  set anisotropy(A) {
    ;(this._anisotropy > 0 != A > 0 && this.version++, (this._anisotropy = A))
  }
  get clearcoat() {
    return this._clearcoat
  }
  set clearcoat(A) {
    ;(this._clearcoat > 0 != A > 0 && this.version++, (this._clearcoat = A))
  }
  get iridescence() {
    return this._iridescence
  }
  set iridescence(A) {
    ;(this._iridescence > 0 != A > 0 && this.version++, (this._iridescence = A))
  }
  get dispersion() {
    return this._dispersion
  }
  set dispersion(A) {
    ;(this._dispersion > 0 != A > 0 && this.version++, (this._dispersion = A))
  }
  get sheen() {
    return this._sheen
  }
  set sheen(A) {
    ;(this._sheen > 0 != A > 0 && this.version++, (this._sheen = A))
  }
  get transmission() {
    return this._transmission
  }
  set transmission(A) {
    ;(this._transmission > 0 != A > 0 && this.version++, (this._transmission = A))
  }
  copy(A) {
    return (
      super.copy(A),
      (this.defines = {
        STANDARD: "",
        PHYSICAL: "",
      }),
      (this.anisotropy = A.anisotropy),
      (this.anisotropyRotation = A.anisotropyRotation),
      (this.anisotropyMap = A.anisotropyMap),
      (this.clearcoat = A.clearcoat),
      (this.clearcoatMap = A.clearcoatMap),
      (this.clearcoatRoughness = A.clearcoatRoughness),
      (this.clearcoatRoughnessMap = A.clearcoatRoughnessMap),
      (this.clearcoatNormalMap = A.clearcoatNormalMap),
      this.clearcoatNormalScale.copy(A.clearcoatNormalScale),
      (this.dispersion = A.dispersion),
      (this.ior = A.ior),
      (this.iridescence = A.iridescence),
      (this.iridescenceMap = A.iridescenceMap),
      (this.iridescenceIOR = A.iridescenceIOR),
      (this.iridescenceThicknessRange = [...A.iridescenceThicknessRange]),
      (this.iridescenceThicknessMap = A.iridescenceThicknessMap),
      (this.sheen = A.sheen),
      this.sheenColor.copy(A.sheenColor),
      (this.sheenColorMap = A.sheenColorMap),
      (this.sheenRoughness = A.sheenRoughness),
      (this.sheenRoughnessMap = A.sheenRoughnessMap),
      (this.transmission = A.transmission),
      (this.transmissionMap = A.transmissionMap),
      (this.thickness = A.thickness),
      (this.thicknessMap = A.thicknessMap),
      (this.attenuationDistance = A.attenuationDistance),
      this.attenuationColor.copy(A.attenuationColor),
      (this.specularIntensity = A.specularIntensity),
      (this.specularIntensityMap = A.specularIntensityMap),
      this.specularColor.copy(A.specularColor),
      (this.specularColorMap = A.specularColorMap),
      this
    )
  }
}
class Db extends tQ {
  static get type() {
    return "MeshPhongMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isMeshPhongMaterial = !0),
      (this.color = new Mg(16777215)),
      (this.specular = new Mg(1118481)),
      (this.shininess = 30),
      (this.map = null),
      (this.lightMap = null),
      (this.lightMapIntensity = 1),
      (this.aoMap = null),
      (this.aoMapIntensity = 1),
      (this.emissive = new Mg(0)),
      (this.emissiveIntensity = 1),
      (this.emissiveMap = null),
      (this.bumpMap = null),
      (this.bumpScale = 1),
      (this.normalMap = null),
      (this.normalMapType = vD),
      (this.normalScale = new ZI(1, 1)),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.specularMap = null),
      (this.alphaMap = null),
      (this.envMap = null),
      (this.envMapRotation = new uE()),
      (this.combine = MG),
      (this.reflectivity = 1),
      (this.refractionRatio = 0.98),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.wireframeLinecap = "round"),
      (this.wireframeLinejoin = "round"),
      (this.flatShading = !1),
      (this.fog = !0),
      this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      this.color.copy(A.color),
      this.specular.copy(A.specular),
      (this.shininess = A.shininess),
      (this.map = A.map),
      (this.lightMap = A.lightMap),
      (this.lightMapIntensity = A.lightMapIntensity),
      (this.aoMap = A.aoMap),
      (this.aoMapIntensity = A.aoMapIntensity),
      this.emissive.copy(A.emissive),
      (this.emissiveMap = A.emissiveMap),
      (this.emissiveIntensity = A.emissiveIntensity),
      (this.bumpMap = A.bumpMap),
      (this.bumpScale = A.bumpScale),
      (this.normalMap = A.normalMap),
      (this.normalMapType = A.normalMapType),
      this.normalScale.copy(A.normalScale),
      (this.displacementMap = A.displacementMap),
      (this.displacementScale = A.displacementScale),
      (this.displacementBias = A.displacementBias),
      (this.specularMap = A.specularMap),
      (this.alphaMap = A.alphaMap),
      (this.envMap = A.envMap),
      this.envMapRotation.copy(A.envMapRotation),
      (this.combine = A.combine),
      (this.reflectivity = A.reflectivity),
      (this.refractionRatio = A.refractionRatio),
      (this.wireframe = A.wireframe),
      (this.wireframeLinewidth = A.wireframeLinewidth),
      (this.wireframeLinecap = A.wireframeLinecap),
      (this.wireframeLinejoin = A.wireframeLinejoin),
      (this.flatShading = A.flatShading),
      (this.fog = A.fog),
      this
    )
  }
}
class Sb extends tQ {
  static get type() {
    return "MeshToonMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isMeshToonMaterial = !0),
      (this.defines = { TOON: "" }),
      (this.color = new Mg(16777215)),
      (this.map = null),
      (this.gradientMap = null),
      (this.lightMap = null),
      (this.lightMapIntensity = 1),
      (this.aoMap = null),
      (this.aoMapIntensity = 1),
      (this.emissive = new Mg(0)),
      (this.emissiveIntensity = 1),
      (this.emissiveMap = null),
      (this.bumpMap = null),
      (this.bumpScale = 1),
      (this.normalMap = null),
      (this.normalMapType = vD),
      (this.normalScale = new ZI(1, 1)),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.alphaMap = null),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.wireframeLinecap = "round"),
      (this.wireframeLinejoin = "round"),
      (this.fog = !0),
      this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      this.color.copy(A.color),
      (this.map = A.map),
      (this.gradientMap = A.gradientMap),
      (this.lightMap = A.lightMap),
      (this.lightMapIntensity = A.lightMapIntensity),
      (this.aoMap = A.aoMap),
      (this.aoMapIntensity = A.aoMapIntensity),
      this.emissive.copy(A.emissive),
      (this.emissiveMap = A.emissiveMap),
      (this.emissiveIntensity = A.emissiveIntensity),
      (this.bumpMap = A.bumpMap),
      (this.bumpScale = A.bumpScale),
      (this.normalMap = A.normalMap),
      (this.normalMapType = A.normalMapType),
      this.normalScale.copy(A.normalScale),
      (this.displacementMap = A.displacementMap),
      (this.displacementScale = A.displacementScale),
      (this.displacementBias = A.displacementBias),
      (this.alphaMap = A.alphaMap),
      (this.wireframe = A.wireframe),
      (this.wireframeLinewidth = A.wireframeLinewidth),
      (this.wireframeLinecap = A.wireframeLinecap),
      (this.wireframeLinejoin = A.wireframeLinejoin),
      (this.fog = A.fog),
      this
    )
  }
}
class cv extends tQ {
  static get type() {
    return "MeshNormalMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isMeshNormalMaterial = !0),
      (this.bumpMap = null),
      (this.bumpScale = 1),
      (this.normalMap = null),
      (this.normalMapType = vD),
      (this.normalScale = new ZI(1, 1)),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.flatShading = !1),
      this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      (this.bumpMap = A.bumpMap),
      (this.bumpScale = A.bumpScale),
      (this.normalMap = A.normalMap),
      (this.normalMapType = A.normalMapType),
      this.normalScale.copy(A.normalScale),
      (this.displacementMap = A.displacementMap),
      (this.displacementScale = A.displacementScale),
      (this.displacementBias = A.displacementBias),
      (this.wireframe = A.wireframe),
      (this.wireframeLinewidth = A.wireframeLinewidth),
      (this.flatShading = A.flatShading),
      this
    )
  }
}
class fb extends tQ {
  static get type() {
    return "MeshLambertMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isMeshLambertMaterial = !0),
      (this.color = new Mg(16777215)),
      (this.map = null),
      (this.lightMap = null),
      (this.lightMapIntensity = 1),
      (this.aoMap = null),
      (this.aoMapIntensity = 1),
      (this.emissive = new Mg(0)),
      (this.emissiveIntensity = 1),
      (this.emissiveMap = null),
      (this.bumpMap = null),
      (this.bumpScale = 1),
      (this.normalMap = null),
      (this.normalMapType = vD),
      (this.normalScale = new ZI(1, 1)),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.specularMap = null),
      (this.alphaMap = null),
      (this.envMap = null),
      (this.envMapRotation = new uE()),
      (this.combine = MG),
      (this.reflectivity = 1),
      (this.refractionRatio = 0.98),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.wireframeLinecap = "round"),
      (this.wireframeLinejoin = "round"),
      (this.flatShading = !1),
      (this.fog = !0),
      this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      this.color.copy(A.color),
      (this.map = A.map),
      (this.lightMap = A.lightMap),
      (this.lightMapIntensity = A.lightMapIntensity),
      (this.aoMap = A.aoMap),
      (this.aoMapIntensity = A.aoMapIntensity),
      this.emissive.copy(A.emissive),
      (this.emissiveMap = A.emissiveMap),
      (this.emissiveIntensity = A.emissiveIntensity),
      (this.bumpMap = A.bumpMap),
      (this.bumpScale = A.bumpScale),
      (this.normalMap = A.normalMap),
      (this.normalMapType = A.normalMapType),
      this.normalScale.copy(A.normalScale),
      (this.displacementMap = A.displacementMap),
      (this.displacementScale = A.displacementScale),
      (this.displacementBias = A.displacementBias),
      (this.specularMap = A.specularMap),
      (this.alphaMap = A.alphaMap),
      (this.envMap = A.envMap),
      this.envMapRotation.copy(A.envMapRotation),
      (this.combine = A.combine),
      (this.reflectivity = A.reflectivity),
      (this.refractionRatio = A.refractionRatio),
      (this.wireframe = A.wireframe),
      (this.wireframeLinewidth = A.wireframeLinewidth),
      (this.wireframeLinecap = A.wireframeLinecap),
      (this.wireframeLinejoin = A.wireframeLinejoin),
      (this.flatShading = A.flatShading),
      (this.fog = A.fog),
      this
    )
  }
}
class db extends tQ {
  static get type() {
    return "MeshMatcapMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isMeshMatcapMaterial = !0),
      (this.defines = { MATCAP: "" }),
      (this.color = new Mg(16777215)),
      (this.matcap = null),
      (this.map = null),
      (this.bumpMap = null),
      (this.bumpScale = 1),
      (this.normalMap = null),
      (this.normalMapType = vD),
      (this.normalScale = new ZI(1, 1)),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.alphaMap = null),
      (this.flatShading = !1),
      (this.fog = !0),
      this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      (this.defines = { MATCAP: "" }),
      this.color.copy(A.color),
      (this.matcap = A.matcap),
      (this.map = A.map),
      (this.bumpMap = A.bumpMap),
      (this.bumpScale = A.bumpScale),
      (this.normalMap = A.normalMap),
      (this.normalMapType = A.normalMapType),
      this.normalScale.copy(A.normalScale),
      (this.displacementMap = A.displacementMap),
      (this.displacementScale = A.displacementScale),
      (this.displacementBias = A.displacementBias),
      (this.alphaMap = A.alphaMap),
      (this.flatShading = A.flatShading),
      (this.fog = A.fog),
      this
    )
  }
}
class yb extends DE {
  static get type() {
    return "LineDashedMaterial"
  }
  constructor(A) {
    ;(super(),
      (this.isLineDashedMaterial = !0),
      (this.scale = 1),
      (this.dashSize = 3),
      (this.gapSize = 1),
      this.setValues(A))
  }
  copy(A) {
    return (
      super.copy(A),
      (this.scale = A.scale),
      (this.dashSize = A.dashSize),
      (this.gapSize = A.gapSize),
      this
    )
  }
}
function Mf(e, A, I) {
  return !e || // let 'undefined' and 'null' pass
    (!I && e.constructor === A)
    ? e
    : typeof A.BYTES_PER_ELEMENT == "number"
      ? new A(e)
      : Array.prototype.slice.call(e)
}
function pb(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView)
}
function wb(e) {
  function A(C, i) {
    return e[C] - e[i]
  }
  const I = e.length,
    g = new Array(I)
  for (let C = 0; C !== I; ++C) g[C] = C
  return (g.sort(A), g)
}
function wm(e, A, I) {
  const g = e.length,
    C = new e.constructor(g)
  for (let i = 0, B = 0; B !== g; ++i) {
    const o = I[i] * A
    for (let r = 0; r !== A; ++r) C[B++] = e[o + r]
  }
  return C
}
function hv(e, A, I, g) {
  let C = 1,
    i = e[0]
  for (; i !== void 0 && i[g] === void 0; ) i = e[C++]
  if (i === void 0) return
  let B = i[g]
  if (B !== void 0)
    if (Array.isArray(B))
      do ((B = i[g]), B !== void 0 && (A.push(i.time), I.push.apply(I, B)), (i = e[C++]))
      while (i !== void 0)
    else if (B.toArray !== void 0)
      do ((B = i[g]), B !== void 0 && (A.push(i.time), B.toArray(I, I.length)), (i = e[C++]))
      while (i !== void 0)
    else
      do ((B = i[g]), B !== void 0 && (A.push(i.time), I.push(B)), (i = e[C++]))
      while (i !== void 0)
}
function nj(e, A, I, g, C = 30) {
  const i = e.clone()
  i.name = A
  const B = []
  for (let r = 0; r < i.tracks.length; ++r) {
    const s = i.tracks[r],
      h = s.getValueSize(),
      S = [],
      d = []
    for (let w = 0; w < s.times.length; ++w) {
      const M = s.times[w] * C
      if (!(M < I || M >= g)) {
        S.push(s.times[w])
        for (let K = 0; K < h; ++K) d.push(s.values[w * h + K])
      }
    }
    S.length !== 0 &&
      ((s.times = Mf(S, s.times.constructor)), (s.values = Mf(d, s.values.constructor)), B.push(s))
  }
  i.tracks = B
  let o = 1 / 0
  for (let r = 0; r < i.tracks.length; ++r) o > i.tracks[r].times[0] && (o = i.tracks[r].times[0])
  for (let r = 0; r < i.tracks.length; ++r) i.tracks[r].shift(-1 * o)
  return (i.resetDuration(), i)
}
function Ej(e, A = 0, I = e, g = 30) {
  g <= 0 && (g = 30)
  const C = I.tracks.length,
    i = A / g
  for (let B = 0; B < C; ++B) {
    const o = I.tracks[B],
      r = o.ValueTypeName
    if (r === "bool" || r === "string") continue
    const s = e.tracks.find(function (F) {
      return F.name === o.name && F.ValueTypeName === r
    })
    if (s === void 0) continue
    let h = 0
    const S = o.getValueSize()
    o.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (h = S / 3)
    let d = 0
    const w = s.getValueSize()
    s.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (d = w / 3)
    const M = o.times.length - 1
    let K
    if (i <= o.times[0]) {
      const F = h,
        L = S - h
      K = o.values.slice(F, L)
    } else if (i >= o.times[M]) {
      const F = M * S + h,
        L = F + S - h
      K = o.values.slice(F, L)
    } else {
      const F = o.createInterpolant(),
        L = h,
        Y = S - h
      ;(F.evaluate(i), (K = F.resultBuffer.slice(L, Y)))
    }
    r === "quaternion" && new ho().fromArray(K).normalize().conjugate().toArray(K)
    const R = s.times.length
    for (let F = 0; F < R; ++F) {
      const L = F * w + d
      if (r === "quaternion") ho.multiplyQuaternionsFlat(s.values, L, K, 0, s.values, L)
      else {
        const Y = w - d * 2
        for (let H = 0; H < Y; ++H) s.values[L + H] -= K[H]
      }
    }
  }
  return ((e.blendMode = jm), e)
}
const aj = {
  convertArray: Mf,
  isTypedArray: pb,
  getKeyframeOrder: wb,
  sortedArray: wm,
  flattenJSON: hv,
  subclip: nj,
  makeClipAdditive: Ej,
}
class Gp {
  constructor(A, I, g, C) {
    ;((this.parameterPositions = A),
      (this._cachedIndex = 0),
      (this.resultBuffer = C !== void 0 ? C : new I.constructor(g)),
      (this.sampleValues = I),
      (this.valueSize = g),
      (this.settings = null),
      (this.DefaultSettings_ = {}))
  }
  evaluate(A) {
    const I = this.parameterPositions
    let g = this._cachedIndex,
      C = I[g],
      i = I[g - 1]
    A: {
      I: {
        let B
        g: {
          C: if (!(A < C)) {
            for (let o = g + 2; ; ) {
              if (C === void 0) {
                if (A < i) break C
                return ((g = I.length), (this._cachedIndex = g), this.copySampleValue_(g - 1))
              }
              if (g === o) break
              if (((i = C), (C = I[++g]), A < C)) break I
            }
            B = I.length
            break g
          }
          if (!(A >= i)) {
            const o = I[1]
            A < o && ((g = 2), (i = o))
            for (let r = g - 2; ; ) {
              if (i === void 0) return ((this._cachedIndex = 0), this.copySampleValue_(0))
              if (g === r) break
              if (((C = i), (i = I[--g - 1]), A >= i)) break I
            }
            ;((B = g), (g = 0))
            break g
          }
          break A
        }
        for (; g < B; ) {
          const o = (g + B) >>> 1
          A < I[o] ? (B = o) : (g = o + 1)
        }
        if (((C = I[g]), (i = I[g - 1]), i === void 0))
          return ((this._cachedIndex = 0), this.copySampleValue_(0))
        if (C === void 0)
          return ((g = I.length), (this._cachedIndex = g), this.copySampleValue_(g - 1))
      }
      ;((this._cachedIndex = g), this.intervalChanged_(g, i, C))
    }
    return this.interpolate_(g, i, A, C)
  }
  getSettings_() {
    return this.settings || this.DefaultSettings_
  }
  copySampleValue_(A) {
    const I = this.resultBuffer,
      g = this.sampleValues,
      C = this.valueSize,
      i = A * C
    for (let B = 0; B !== C; ++B) I[B] = g[i + B]
    return I
  }
  // Template methods for derived classes:
  interpolate_() {
    throw new Error("call to abstract method")
  }
  intervalChanged_() {}
}
class Gb extends Gp {
  constructor(A, I, g, C) {
    ;(super(A, I, g, C),
      (this._weightPrev = -0),
      (this._offsetPrev = -0),
      (this._weightNext = -0),
      (this._offsetNext = -0),
      (this.DefaultSettings_ = {
        endingStart: wf,
        endingEnd: wf,
      }))
  }
  intervalChanged_(A, I, g) {
    const C = this.parameterPositions
    let i = A - 2,
      B = A + 1,
      o = C[i],
      r = C[B]
    if (o === void 0)
      switch (this.getSettings_().endingStart) {
        case Gf:
          ;((i = A), (o = 2 * I - g))
          break
        case aG:
          ;((i = C.length - 2), (o = I + C[i] - C[i + 1]))
          break
        default:
          ;((i = A), (o = g))
      }
    if (r === void 0)
      switch (this.getSettings_().endingEnd) {
        case Gf:
          ;((B = A), (r = 2 * g - I))
          break
        case aG:
          ;((B = 1), (r = g + C[1] - C[0]))
          break
        default:
          ;((B = A - 1), (r = I))
      }
    const s = (g - I) * 0.5,
      h = this.valueSize
    ;((this._weightPrev = s / (I - o)),
      (this._weightNext = s / (r - g)),
      (this._offsetPrev = i * h),
      (this._offsetNext = B * h))
  }
  interpolate_(A, I, g, C) {
    const i = this.resultBuffer,
      B = this.sampleValues,
      o = this.valueSize,
      r = A * o,
      s = r - o,
      h = this._offsetPrev,
      S = this._offsetNext,
      d = this._weightPrev,
      w = this._weightNext,
      M = (g - I) / (C - I),
      K = M * M,
      R = K * M,
      F = -d * R + 2 * d * K - d * M,
      L = (1 + d) * R + (-1.5 - 2 * d) * K + (-0.5 + d) * M + 1,
      Y = (-1 - w) * R + (1.5 + w) * K + 0.5 * M,
      H = w * R - w * K
    for (let V = 0; V !== o; ++V) i[V] = F * B[h + V] + L * B[s + V] + Y * B[r + V] + H * B[S + V]
    return i
  }
}
class uv extends Gp {
  constructor(A, I, g, C) {
    super(A, I, g, C)
  }
  interpolate_(A, I, g, C) {
    const i = this.resultBuffer,
      B = this.sampleValues,
      o = this.valueSize,
      r = A * o,
      s = r - o,
      h = (g - I) / (C - I),
      S = 1 - h
    for (let d = 0; d !== o; ++d) i[d] = B[s + d] * S + B[r + d] * h
    return i
  }
}
class kb extends Gp {
  constructor(A, I, g, C) {
    super(A, I, g, C)
  }
  interpolate_(A) {
    return this.copySampleValue_(A - 1)
  }
}
class Fl {
  constructor(A, I, g, C) {
    if (A === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined")
    if (I === void 0 || I.length === 0)
      throw new Error("THREE.KeyframeTrack: no keyframes in track named " + A)
    ;((this.name = A),
      (this.times = Mf(I, this.TimeBufferType)),
      (this.values = Mf(g, this.ValueBufferType)),
      this.setInterpolation(C || this.DefaultInterpolation))
  }
  // Serialization (in static context, because of constructor invocation
  // and automatic invocation of .toJSON):
  static toJSON(A) {
    const I = A.constructor
    let g
    if (I.toJSON !== this.toJSON) g = I.toJSON(A)
    else {
      g = {
        name: A.name,
        times: Mf(A.times, Array),
        values: Mf(A.values, Array),
      }
      const C = A.getInterpolation()
      C !== A.DefaultInterpolation && (g.interpolation = C)
    }
    return ((g.type = A.ValueTypeName), g)
  }
  InterpolantFactoryMethodDiscrete(A) {
    return new kb(this.times, this.values, this.getValueSize(), A)
  }
  InterpolantFactoryMethodLinear(A) {
    return new uv(this.times, this.values, this.getValueSize(), A)
  }
  InterpolantFactoryMethodSmooth(A) {
    return new Gb(this.times, this.values, this.getValueSize(), A)
  }
  setInterpolation(A) {
    let I
    switch (A) {
      case np:
        I = this.InterpolantFactoryMethodDiscrete
        break
      case Ep:
        I = this.InterpolantFactoryMethodLinear
        break
      case mU:
        I = this.InterpolantFactoryMethodSmooth
        break
    }
    if (I === void 0) {
      const g =
        "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name
      if (this.createInterpolant === void 0)
        if (A !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation)
        else throw new Error(g)
      return (console.warn("THREE.KeyframeTrack:", g), this)
    }
    return ((this.createInterpolant = I), this)
  }
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return np
      case this.InterpolantFactoryMethodLinear:
        return Ep
      case this.InterpolantFactoryMethodSmooth:
        return mU
    }
  }
  getValueSize() {
    return this.values.length / this.times.length
  }
  // move all keyframes either forwards or backwards in time
  shift(A) {
    if (A !== 0) {
      const I = this.times
      for (let g = 0, C = I.length; g !== C; ++g) I[g] += A
    }
    return this
  }
  // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
  scale(A) {
    if (A !== 1) {
      const I = this.times
      for (let g = 0, C = I.length; g !== C; ++g) I[g] *= A
    }
    return this
  }
  // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
  // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
  trim(A, I) {
    const g = this.times,
      C = g.length
    let i = 0,
      B = C - 1
    for (; i !== C && g[i] < A; ) ++i
    for (; B !== -1 && g[B] > I; ) --B
    if ((++B, i !== 0 || B !== C)) {
      i >= B && ((B = Math.max(B, 1)), (i = B - 1))
      const o = this.getValueSize()
      ;((this.times = g.slice(i, B)), (this.values = this.values.slice(i * o, B * o)))
    }
    return this
  }
  // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
  validate() {
    let A = !0
    const I = this.getValueSize()
    I - Math.floor(I) !== 0 &&
      (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), (A = !1))
    const g = this.times,
      C = this.values,
      i = g.length
    i === 0 && (console.error("THREE.KeyframeTrack: Track is empty.", this), (A = !1))
    let B = null
    for (let o = 0; o !== i; o++) {
      const r = g[o]
      if (typeof r == "number" && isNaN(r)) {
        ;(console.error("THREE.KeyframeTrack: Time is not a valid number.", this, o, r), (A = !1))
        break
      }
      if (B !== null && B > r) {
        ;(console.error("THREE.KeyframeTrack: Out of order keys.", this, o, r, B), (A = !1))
        break
      }
      B = r
    }
    if (C !== void 0 && pb(C))
      for (let o = 0, r = C.length; o !== r; ++o) {
        const s = C[o]
        if (isNaN(s)) {
          ;(console.error("THREE.KeyframeTrack: Value is not a valid number.", this, o, s),
            (A = !1))
          break
        }
      }
    return A
  }
  // removes equivalent sequential keys as common in morph target sequences
  // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
  optimize() {
    const A = this.times.slice(),
      I = this.values.slice(),
      g = this.getValueSize(),
      C = this.getInterpolation() === mU,
      i = A.length - 1
    let B = 1
    for (let o = 1; o < i; ++o) {
      let r = !1
      const s = A[o],
        h = A[o + 1]
      if (s !== h && (o !== 1 || s !== A[0]))
        if (C) r = !0
        else {
          const S = o * g,
            d = S - g,
            w = S + g
          for (let M = 0; M !== g; ++M) {
            const K = I[S + M]
            if (K !== I[d + M] || K !== I[w + M]) {
              r = !0
              break
            }
          }
        }
      if (r) {
        if (o !== B) {
          A[B] = A[o]
          const S = o * g,
            d = B * g
          for (let w = 0; w !== g; ++w) I[d + w] = I[S + w]
        }
        ++B
      }
    }
    if (i > 0) {
      A[B] = A[i]
      for (let o = i * g, r = B * g, s = 0; s !== g; ++s) I[r + s] = I[o + s]
      ++B
    }
    return (
      B !== A.length
        ? ((this.times = A.slice(0, B)), (this.values = I.slice(0, B * g)))
        : ((this.times = A), (this.values = I)),
      this
    )
  }
  clone() {
    const A = this.times.slice(),
      I = this.values.slice(),
      g = this.constructor,
      C = new g(this.name, A, I)
    return ((C.createInterpolant = this.createInterpolant), C)
  }
}
Fl.prototype.TimeBufferType = Float32Array
Fl.prototype.ValueBufferType = Float32Array
Fl.prototype.DefaultInterpolation = Ep
class jf extends Fl {
  // No interpolation parameter because only InterpolateDiscrete is valid.
  constructor(A, I, g) {
    super(A, I, g)
  }
}
jf.prototype.ValueTypeName = "bool"
jf.prototype.ValueBufferType = Array
jf.prototype.DefaultInterpolation = np
jf.prototype.InterpolantFactoryMethodLinear = void 0
jf.prototype.InterpolantFactoryMethodSmooth = void 0
class Dv extends Fl {}
Dv.prototype.ValueTypeName = "color"
class qf extends Fl {}
qf.prototype.ValueTypeName = "number"
class Mb extends Gp {
  constructor(A, I, g, C) {
    super(A, I, g, C)
  }
  interpolate_(A, I, g, C) {
    const i = this.resultBuffer,
      B = this.sampleValues,
      o = this.valueSize,
      r = (g - I) / (C - I)
    let s = A * o
    for (let h = s + o; s !== h; s += 4) ho.slerpFlat(i, 0, B, s - o, B, s, r)
    return i
  }
}
class Hf extends Fl {
  InterpolantFactoryMethodLinear(A) {
    return new Mb(this.times, this.values, this.getValueSize(), A)
  }
}
Hf.prototype.ValueTypeName = "quaternion"
Hf.prototype.InterpolantFactoryMethodSmooth = void 0
class zf extends Fl {
  // No interpolation parameter because only InterpolateDiscrete is valid.
  constructor(A, I, g) {
    super(A, I, g)
  }
}
zf.prototype.ValueTypeName = "string"
zf.prototype.ValueBufferType = Array
zf.prototype.DefaultInterpolation = np
zf.prototype.InterpolantFactoryMethodLinear = void 0
zf.prototype.InterpolantFactoryMethodSmooth = void 0
class Tf extends Fl {}
Tf.prototype.ValueTypeName = "vector"
class lp {
  constructor(A = "", I = -1, g = [], C = zN) {
    ;((this.name = A),
      (this.tracks = g),
      (this.duration = I),
      (this.blendMode = C),
      (this.uuid = Lr()),
      this.duration < 0 && this.resetDuration())
  }
  static parse(A) {
    const I = [],
      g = A.tracks,
      C = 1 / (A.fps || 1)
    for (let B = 0, o = g.length; B !== o; ++B) I.push(sj(g[B]).scale(C))
    const i = new this(A.name, A.duration, I, A.blendMode)
    return ((i.uuid = A.uuid), i)
  }
  static toJSON(A) {
    const I = [],
      g = A.tracks,
      C = {
        name: A.name,
        duration: A.duration,
        tracks: I,
        uuid: A.uuid,
        blendMode: A.blendMode,
      }
    for (let i = 0, B = g.length; i !== B; ++i) I.push(Fl.toJSON(g[i]))
    return C
  }
  static CreateFromMorphTargetSequence(A, I, g, C) {
    const i = I.length,
      B = []
    for (let o = 0; o < i; o++) {
      let r = [],
        s = []
      ;(r.push((o + i - 1) % i, o, (o + 1) % i), s.push(0, 1, 0))
      const h = wb(r)
      ;((r = wm(r, 1, h)),
        (s = wm(s, 1, h)),
        !C && r[0] === 0 && (r.push(i), s.push(s[0])),
        B.push(new qf(".morphTargetInfluences[" + I[o].name + "]", r, s).scale(1 / g)))
    }
    return new this(A, -1, B)
  }
  static findByName(A, I) {
    let g = A
    if (!Array.isArray(A)) {
      const C = A
      g = (C.geometry && C.geometry.animations) || C.animations
    }
    for (let C = 0; C < g.length; C++) if (g[C].name === I) return g[C]
    return null
  }
  static CreateClipsFromMorphTargetSequences(A, I, g) {
    const C = {},
      i = /^([\w-]*?)([\d]+)$/
    for (let o = 0, r = A.length; o < r; o++) {
      const s = A[o],
        h = s.name.match(i)
      if (h && h.length > 1) {
        const S = h[1]
        let d = C[S]
        ;(d || (C[S] = d = []), d.push(s))
      }
    }
    const B = []
    for (const o in C) B.push(this.CreateFromMorphTargetSequence(o, C[o], I, g))
    return B
  }
  // parse the animation.hierarchy format
  static parseAnimation(A, I) {
    if (!A) return (console.error("THREE.AnimationClip: No animation in JSONLoader data."), null)
    const g = function (S, d, w, M, K) {
        if (w.length !== 0) {
          const R = [],
            F = []
          ;(hv(w, R, F, M), R.length !== 0 && K.push(new S(d, R, F)))
        }
      },
      C = [],
      i = A.name || "default",
      B = A.fps || 30,
      o = A.blendMode
    let r = A.length || -1
    const s = A.hierarchy || []
    for (let S = 0; S < s.length; S++) {
      const d = s[S].keys
      if (!(!d || d.length === 0))
        if (d[0].morphTargets) {
          const w = {}
          let M
          for (M = 0; M < d.length; M++)
            if (d[M].morphTargets)
              for (let K = 0; K < d[M].morphTargets.length; K++) w[d[M].morphTargets[K]] = -1
          for (const K in w) {
            const R = [],
              F = []
            for (let L = 0; L !== d[M].morphTargets.length; ++L) {
              const Y = d[M]
              ;(R.push(Y.time), F.push(Y.morphTarget === K ? 1 : 0))
            }
            C.push(new qf(".morphTargetInfluence[" + K + "]", R, F))
          }
          r = w.length * B
        } else {
          const w = ".bones[" + I[S].name + "]"
          ;(g(Tf, w + ".position", d, "pos", C),
            g(Hf, w + ".quaternion", d, "rot", C),
            g(Tf, w + ".scale", d, "scl", C))
        }
    }
    return C.length === 0 ? null : new this(i, r, C, o)
  }
  resetDuration() {
    const A = this.tracks
    let I = 0
    for (let g = 0, C = A.length; g !== C; ++g) {
      const i = this.tracks[g]
      I = Math.max(I, i.times[i.times.length - 1])
    }
    return ((this.duration = I), this)
  }
  trim() {
    for (let A = 0; A < this.tracks.length; A++) this.tracks[A].trim(0, this.duration)
    return this
  }
  validate() {
    let A = !0
    for (let I = 0; I < this.tracks.length; I++) A = A && this.tracks[I].validate()
    return A
  }
  optimize() {
    for (let A = 0; A < this.tracks.length; A++) this.tracks[A].optimize()
    return this
  }
  clone() {
    const A = []
    for (let I = 0; I < this.tracks.length; I++) A.push(this.tracks[I].clone())
    return new this.constructor(this.name, this.duration, A, this.blendMode)
  }
  toJSON() {
    return this.constructor.toJSON(this)
  }
}
function rj(e) {
  switch (e.toLowerCase()) {
    case "scalar":
    case "double":
    case "float":
    case "number":
    case "integer":
      return qf
    case "vector":
    case "vector2":
    case "vector3":
    case "vector4":
      return Tf
    case "color":
      return Dv
    case "quaternion":
      return Hf
    case "bool":
    case "boolean":
      return jf
    case "string":
      return zf
  }
  throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + e)
}
function sj(e) {
  if (e.type === void 0) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse")
  const A = rj(e.type)
  if (e.times === void 0) {
    const I = [],
      g = []
    ;(hv(e.keys, I, g, "value"), (e.times = I), (e.values = g))
  }
  return A.parse !== void 0 ? A.parse(e) : new A(e.name, e.times, e.values, e.interpolation)
}
const gu = {
  enabled: !1,
  files: {},
  add: function (e, A) {
    this.enabled !== !1 && (this.files[e] = A)
  },
  get: function (e) {
    if (this.enabled !== !1) return this.files[e]
  },
  remove: function (e) {
    delete this.files[e]
  },
  clear: function () {
    this.files = {}
  },
}
class Sv {
  constructor(A, I, g) {
    const C = this
    let i = !1,
      B = 0,
      o = 0,
      r
    const s = []
    ;((this.onStart = void 0),
      (this.onLoad = A),
      (this.onProgress = I),
      (this.onError = g),
      (this.itemStart = function (h) {
        ;(o++, i === !1 && C.onStart !== void 0 && C.onStart(h, B, o), (i = !0))
      }),
      (this.itemEnd = function (h) {
        ;(B++,
          C.onProgress !== void 0 && C.onProgress(h, B, o),
          B === o && ((i = !1), C.onLoad !== void 0 && C.onLoad()))
      }),
      (this.itemError = function (h) {
        C.onError !== void 0 && C.onError(h)
      }),
      (this.resolveURL = function (h) {
        return r ? r(h) : h
      }),
      (this.setURLModifier = function (h) {
        return ((r = h), this)
      }),
      (this.addHandler = function (h, S) {
        return (s.push(h, S), this)
      }),
      (this.removeHandler = function (h) {
        const S = s.indexOf(h)
        return (S !== -1 && s.splice(S, 2), this)
      }),
      (this.getHandler = function (h) {
        for (let S = 0, d = s.length; S < d; S += 2) {
          const w = s[S],
            M = s[S + 1]
          if ((w.global && (w.lastIndex = 0), w.test(h))) return M
        }
        return null
      }))
  }
}
const Ub = /* @__PURE__ */ new Sv()
class SE {
  constructor(A) {
    ;((this.manager = A !== void 0 ? A : Ub),
      (this.crossOrigin = "anonymous"),
      (this.withCredentials = !1),
      (this.path = ""),
      (this.resourcePath = ""),
      (this.requestHeader = {}))
  }
  load() {}
  loadAsync(A, I) {
    const g = this
    return new Promise(function (C, i) {
      g.load(A, C, I, i)
    })
  }
  parse() {}
  setCrossOrigin(A) {
    return ((this.crossOrigin = A), this)
  }
  setWithCredentials(A) {
    return ((this.withCredentials = A), this)
  }
  setPath(A) {
    return ((this.path = A), this)
  }
  setResourcePath(A) {
    return ((this.resourcePath = A), this)
  }
  setRequestHeader(A) {
    return ((this.requestHeader = A), this)
  }
}
SE.DEFAULT_MATERIAL_NAME = "__DEFAULT"
const Xh = {}
class lj extends Error {
  constructor(A, I) {
    ;(super(A), (this.response = I))
  }
}
class Yr extends SE {
  constructor(A) {
    super(A)
  }
  load(A, I, g, C) {
    ;(A === void 0 && (A = ""),
      this.path !== void 0 && (A = this.path + A),
      (A = this.manager.resolveURL(A)))
    const i = gu.get(A)
    if (i !== void 0)
      return (
        this.manager.itemStart(A),
        setTimeout(() => {
          ;(I && I(i), this.manager.itemEnd(A))
        }, 0),
        i
      )
    if (Xh[A] !== void 0) {
      Xh[A].push({
        onLoad: I,
        onProgress: g,
        onError: C,
      })
      return
    }
    ;((Xh[A] = []),
      Xh[A].push({
        onLoad: I,
        onProgress: g,
        onError: C,
      }))
    const B = new Request(A, {
        headers: new Headers(this.requestHeader),
        credentials: this.withCredentials ? "include" : "same-origin",
        // An abort controller could be added within a future PR
      }),
      o = this.mimeType,
      r = this.responseType
    ;(fetch(B)
      .then((s) => {
        if (s.status === 200 || s.status === 0) {
          if (
            (s.status === 0 && console.warn("THREE.FileLoader: HTTP Status 0 received."),
            typeof ReadableStream > "u" || s.body === void 0 || s.body.getReader === void 0)
          )
            return s
          const h = Xh[A],
            S = s.body.getReader(),
            d = s.headers.get("X-File-Size") || s.headers.get("Content-Length"),
            w = d ? parseInt(d) : 0,
            M = w !== 0
          let K = 0
          const R = new ReadableStream({
            start(F) {
              L()
              function L() {
                S.read().then(
                  ({ done: Y, value: H }) => {
                    if (Y) F.close()
                    else {
                      K += H.byteLength
                      const V = new ProgressEvent("progress", {
                        lengthComputable: M,
                        loaded: K,
                        total: w,
                      })
                      for (let j = 0, P = h.length; j < P; j++) {
                        const AA = h[j]
                        AA.onProgress && AA.onProgress(V)
                      }
                      ;(F.enqueue(H), L())
                    }
                  },
                  (Y) => {
                    F.error(Y)
                  },
                )
              }
            },
          })
          return new Response(R)
        } else throw new lj(`fetch for "${s.url}" responded with ${s.status}: ${s.statusText}`, s)
      })
      .then((s) => {
        switch (r) {
          case "arraybuffer":
            return s.arrayBuffer()
          case "blob":
            return s.blob()
          case "document":
            return s.text().then((h) => new DOMParser().parseFromString(h, o))
          case "json":
            return s.json()
          default:
            if (o === void 0) return s.text()
            {
              const S = /charset="?([^;"\s]*)"?/i.exec(o),
                d = S && S[1] ? S[1].toLowerCase() : void 0,
                w = new TextDecoder(d)
              return s.arrayBuffer().then((M) => w.decode(M))
            }
        }
      })
      .then((s) => {
        gu.add(A, s)
        const h = Xh[A]
        delete Xh[A]
        for (let S = 0, d = h.length; S < d; S++) {
          const w = h[S]
          w.onLoad && w.onLoad(s)
        }
      })
      .catch((s) => {
        const h = Xh[A]
        if (h === void 0) throw (this.manager.itemError(A), s)
        delete Xh[A]
        for (let S = 0, d = h.length; S < d; S++) {
          const w = h[S]
          w.onError && w.onError(s)
        }
        this.manager.itemError(A)
      })
      .finally(() => {
        this.manager.itemEnd(A)
      }),
      this.manager.itemStart(A))
  }
  setResponseType(A) {
    return ((this.responseType = A), this)
  }
  setMimeType(A) {
    return ((this.mimeType = A), this)
  }
}
class cj extends SE {
  constructor(A) {
    super(A)
  }
  load(A, I, g, C) {
    const i = this,
      B = new Yr(this.manager)
    ;(B.setPath(this.path),
      B.setRequestHeader(this.requestHeader),
      B.setWithCredentials(this.withCredentials),
      B.load(
        A,
        function (o) {
          try {
            I(i.parse(JSON.parse(o)))
          } catch (r) {
            ;(C ? C(r) : console.error(r), i.manager.itemError(A))
          }
        },
        g,
        C,
      ))
  }
  parse(A) {
    const I = []
    for (let g = 0; g < A.length; g++) {
      const C = lp.parse(A[g])
      I.push(C)
    }
    return I
  }
}
class hj extends SE {
  constructor(A) {
    super(A)
  }
  load(A, I, g, C) {
    const i = this,
      B = [],
      o = new QF(),
      r = new Yr(this.manager)
    ;(r.setPath(this.path),
      r.setResponseType("arraybuffer"),
      r.setRequestHeader(this.requestHeader),
      r.setWithCredentials(i.withCredentials))
    let s = 0
    function h(S) {
      r.load(
        A[S],
        function (d) {
          const w = i.parse(d, !0)
          ;((B[S] = {
            width: w.width,
            height: w.height,
            format: w.format,
            mipmaps: w.mipmaps,
          }),
            (s += 1),
            s === 6 &&
              (w.mipmapCount === 1 && (o.minFilter = nt),
              (o.image = B),
              (o.format = w.format),
              (o.needsUpdate = !0),
              I && I(o)))
        },
        g,
        C,
      )
    }
    if (Array.isArray(A)) for (let S = 0, d = A.length; S < d; ++S) h(S)
    else
      r.load(
        A,
        function (S) {
          const d = i.parse(S, !0)
          if (d.isCubemap) {
            const w = d.mipmaps.length / d.mipmapCount
            for (let M = 0; M < w; M++) {
              B[M] = { mipmaps: [] }
              for (let K = 0; K < d.mipmapCount; K++)
                (B[M].mipmaps.push(d.mipmaps[M * d.mipmapCount + K]),
                  (B[M].format = d.format),
                  (B[M].width = d.width),
                  (B[M].height = d.height))
            }
            o.image = B
          } else ((o.image.width = d.width), (o.image.height = d.height), (o.mipmaps = d.mipmaps))
          ;(d.mipmapCount === 1 && (o.minFilter = nt),
            (o.format = d.format),
            (o.needsUpdate = !0),
            I && I(o))
        },
        g,
        C,
      )
    return o
  }
}
class SG extends SE {
  constructor(A) {
    super(A)
  }
  load(A, I, g, C) {
    ;(this.path !== void 0 && (A = this.path + A), (A = this.manager.resolveURL(A)))
    const i = this,
      B = gu.get(A)
    if (B !== void 0)
      return (
        i.manager.itemStart(A),
        setTimeout(function () {
          ;(I && I(B), i.manager.itemEnd(A))
        }, 0),
        B
      )
    const o = lG("img")
    function r() {
      ;(h(), gu.add(A, this), I && I(this), i.manager.itemEnd(A))
    }
    function s(S) {
      ;(h(), C && C(S), i.manager.itemError(A), i.manager.itemEnd(A))
    }
    function h() {
      ;(o.removeEventListener("load", r, !1), o.removeEventListener("error", s, !1))
    }
    return (
      o.addEventListener("load", r, !1),
      o.addEventListener("error", s, !1),
      A.slice(0, 5) !== "data:" &&
        this.crossOrigin !== void 0 &&
        (o.crossOrigin = this.crossOrigin),
      i.manager.itemStart(A),
      (o.src = A),
      o
    )
  }
}
class uj extends SE {
  constructor(A) {
    super(A)
  }
  load(A, I, g, C) {
    const i = new FG()
    i.colorSpace = zi
    const B = new SG(this.manager)
    ;(B.setCrossOrigin(this.crossOrigin), B.setPath(this.path))
    let o = 0
    function r(s) {
      B.load(
        A[s],
        function (h) {
          ;((i.images[s] = h), o++, o === 6 && ((i.needsUpdate = !0), I && I(i)))
        },
        void 0,
        C,
      )
    }
    for (let s = 0; s < A.length; ++s) r(s)
    return i
  }
}
class Dj extends SE {
  constructor(A) {
    super(A)
  }
  load(A, I, g, C) {
    const i = this,
      B = new Oc(),
      o = new Yr(this.manager)
    return (
      o.setResponseType("arraybuffer"),
      o.setRequestHeader(this.requestHeader),
      o.setPath(this.path),
      o.setWithCredentials(i.withCredentials),
      o.load(
        A,
        function (r) {
          let s
          try {
            s = i.parse(r)
          } catch (h) {
            if (C !== void 0) C(h)
            else {
              console.error(h)
              return
            }
          }
          ;(s.image !== void 0
            ? (B.image = s.image)
            : s.data !== void 0 &&
              ((B.image.width = s.width), (B.image.height = s.height), (B.image.data = s.data)),
            (B.wrapS = s.wrapS !== void 0 ? s.wrapS : vr),
            (B.wrapT = s.wrapT !== void 0 ? s.wrapT : vr),
            (B.magFilter = s.magFilter !== void 0 ? s.magFilter : nt),
            (B.minFilter = s.minFilter !== void 0 ? s.minFilter : nt),
            (B.anisotropy = s.anisotropy !== void 0 ? s.anisotropy : 1),
            s.colorSpace !== void 0 && (B.colorSpace = s.colorSpace),
            s.flipY !== void 0 && (B.flipY = s.flipY),
            s.format !== void 0 && (B.format = s.format),
            s.type !== void 0 && (B.type = s.type),
            s.mipmaps !== void 0 && ((B.mipmaps = s.mipmaps), (B.minFilter = ks)),
            s.mipmapCount === 1 && (B.minFilter = nt),
            s.generateMipmaps !== void 0 && (B.generateMipmaps = s.generateMipmaps),
            (B.needsUpdate = !0),
            I && I(B, s))
        },
        g,
        C,
      ),
      B
    )
  }
}
class Nb extends SE {
  constructor(A) {
    super(A)
  }
  load(A, I, g, C) {
    const i = new pt(),
      B = new SG(this.manager)
    return (
      B.setCrossOrigin(this.crossOrigin),
      B.setPath(this.path),
      B.load(
        A,
        function (o) {
          ;((i.image = o), (i.needsUpdate = !0), I !== void 0 && I(i))
        },
        g,
        C,
      ),
      i
    )
  }
}
let YD = class extends Ci {
  constructor(A, I = 1) {
    ;(super(),
      (this.isLight = !0),
      (this.type = "Light"),
      (this.color = new Mg(A)),
      (this.intensity = I))
  }
  dispose() {}
  copy(A, I) {
    return (super.copy(A, I), this.color.copy(A.color), (this.intensity = A.intensity), this)
  }
  toJSON(A) {
    const I = super.toJSON(A)
    return (
      (I.object.color = this.color.getHex()),
      (I.object.intensity = this.intensity),
      this.groundColor !== void 0 && (I.object.groundColor = this.groundColor.getHex()),
      this.distance !== void 0 && (I.object.distance = this.distance),
      this.angle !== void 0 && (I.object.angle = this.angle),
      this.decay !== void 0 && (I.object.decay = this.decay),
      this.penumbra !== void 0 && (I.object.penumbra = this.penumbra),
      this.shadow !== void 0 && (I.object.shadow = this.shadow.toJSON()),
      this.target !== void 0 && (I.object.target = this.target.uuid),
      I
    )
  }
}
class Fb extends YD {
  constructor(A, I, g) {
    ;(super(A, g),
      (this.isHemisphereLight = !0),
      (this.type = "HemisphereLight"),
      this.position.copy(Ci.DEFAULT_UP),
      this.updateMatrix(),
      (this.groundColor = new Mg(I)))
  }
  copy(A, I) {
    return (super.copy(A, I), this.groundColor.copy(A.groundColor), this)
  }
}
const RK = /* @__PURE__ */ new RC(),
  ZH = /* @__PURE__ */ new wA(),
  PH = /* @__PURE__ */ new wA()
class fv {
  constructor(A) {
    ;((this.camera = A),
      (this.intensity = 1),
      (this.bias = 0),
      (this.normalBias = 0),
      (this.radius = 1),
      (this.blurSamples = 8),
      (this.mapSize = new ZI(512, 512)),
      (this.map = null),
      (this.mapPass = null),
      (this.matrix = new RC()),
      (this.autoUpdate = !0),
      (this.needsUpdate = !1),
      (this._frustum = new RG()),
      (this._frameExtents = new ZI(1, 1)),
      (this._viewportCount = 1),
      (this._viewports = [new Xe(0, 0, 1, 1)]))
  }
  getViewportCount() {
    return this._viewportCount
  }
  getFrustum() {
    return this._frustum
  }
  updateMatrices(A) {
    const I = this.camera,
      g = this.matrix
    ;(ZH.setFromMatrixPosition(A.matrixWorld),
      I.position.copy(ZH),
      PH.setFromMatrixPosition(A.target.matrixWorld),
      I.lookAt(PH),
      I.updateMatrixWorld(),
      RK.multiplyMatrices(I.projectionMatrix, I.matrixWorldInverse),
      this._frustum.setFromProjectionMatrix(RK),
      g.set(0.5, 0, 0, 0.5, 0, 0.5, 0, 0.5, 0, 0, 0.5, 0.5, 0, 0, 0, 1),
      g.multiply(RK))
  }
  getViewport(A) {
    return this._viewports[A]
  }
  getFrameExtents() {
    return this._frameExtents
  }
  dispose() {
    ;(this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose())
  }
  copy(A) {
    return (
      (this.camera = A.camera.clone()),
      (this.intensity = A.intensity),
      (this.bias = A.bias),
      (this.radius = A.radius),
      this.mapSize.copy(A.mapSize),
      this
    )
  }
  clone() {
    return new this.constructor().copy(this)
  }
  toJSON() {
    const A = {}
    return (
      this.intensity !== 1 && (A.intensity = this.intensity),
      this.bias !== 0 && (A.bias = this.bias),
      this.normalBias !== 0 && (A.normalBias = this.normalBias),
      this.radius !== 1 && (A.radius = this.radius),
      (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (A.mapSize = this.mapSize.toArray()),
      (A.camera = this.camera.toJSON(!1).object),
      delete A.camera.matrix,
      A
    )
  }
}
class Sj extends fv {
  constructor() {
    ;(super(new PQ(50, 1, 0.5, 500)), (this.isSpotLightShadow = !0), (this.focus = 1))
  }
  updateMatrices(A) {
    const I = this.camera,
      g = ap * 2 * A.angle * this.focus,
      C = this.mapSize.width / this.mapSize.height,
      i = A.distance || I.far
    ;((g !== I.fov || C !== I.aspect || i !== I.far) &&
      ((I.fov = g), (I.aspect = C), (I.far = i), I.updateProjectionMatrix()),
      super.updateMatrices(A))
  }
  copy(A) {
    return (super.copy(A), (this.focus = A.focus), this)
  }
}
class dv extends YD {
  constructor(A, I, g = 0, C = Math.PI / 3, i = 0, B = 2) {
    ;(super(A, I),
      (this.isSpotLight = !0),
      (this.type = "SpotLight"),
      this.position.copy(Ci.DEFAULT_UP),
      this.updateMatrix(),
      (this.target = new Ci()),
      (this.distance = g),
      (this.angle = C),
      (this.penumbra = i),
      (this.decay = B),
      (this.map = null),
      (this.shadow = new Sj()))
  }
  get power() {
    return this.intensity * Math.PI
  }
  set power(A) {
    this.intensity = A / Math.PI
  }
  dispose() {
    this.shadow.dispose()
  }
  copy(A, I) {
    return (
      super.copy(A, I),
      (this.distance = A.distance),
      (this.angle = A.angle),
      (this.penumbra = A.penumbra),
      (this.decay = A.decay),
      (this.target = A.target.clone()),
      (this.shadow = A.shadow.clone()),
      this
    )
  }
}
const WH = /* @__PURE__ */ new RC(),
  L0 = /* @__PURE__ */ new wA(),
  JK = /* @__PURE__ */ new wA()
class fj extends fv {
  constructor() {
    ;(super(new PQ(90, 1, 0.5, 500)),
      (this.isPointLightShadow = !0),
      (this._frameExtents = new ZI(4, 2)),
      (this._viewportCount = 6),
      (this._viewports = [
        // These viewports map a cube-map onto a 2D texture with the
        // following orientation:
        //
        //  xzXZ
        //   y Y
        //
        // X - Positive x direction
        // x - Negative x direction
        // Y - Positive y direction
        // y - Negative y direction
        // Z - Positive z direction
        // z - Negative z direction
        // positive X
        new Xe(2, 1, 1, 1),
        // negative X
        new Xe(0, 1, 1, 1),
        // positive Z
        new Xe(3, 1, 1, 1),
        // negative Z
        new Xe(1, 1, 1, 1),
        // positive Y
        new Xe(3, 0, 1, 1),
        // negative Y
        new Xe(1, 0, 1, 1),
      ]),
      (this._cubeDirections = [
        new wA(1, 0, 0),
        new wA(-1, 0, 0),
        new wA(0, 0, 1),
        new wA(0, 0, -1),
        new wA(0, 1, 0),
        new wA(0, -1, 0),
      ]),
      (this._cubeUps = [
        new wA(0, 1, 0),
        new wA(0, 1, 0),
        new wA(0, 1, 0),
        new wA(0, 1, 0),
        new wA(0, 0, 1),
        new wA(0, 0, -1),
      ]))
  }
  updateMatrices(A, I = 0) {
    const g = this.camera,
      C = this.matrix,
      i = A.distance || g.far
    ;(i !== g.far && ((g.far = i), g.updateProjectionMatrix()),
      L0.setFromMatrixPosition(A.matrixWorld),
      g.position.copy(L0),
      JK.copy(g.position),
      JK.add(this._cubeDirections[I]),
      g.up.copy(this._cubeUps[I]),
      g.lookAt(JK),
      g.updateMatrixWorld(),
      C.makeTranslation(-L0.x, -L0.y, -L0.z),
      WH.multiplyMatrices(g.projectionMatrix, g.matrixWorldInverse),
      this._frustum.setFromProjectionMatrix(WH))
  }
}
class yv extends YD {
  constructor(A, I, g = 0, C = 2) {
    ;(super(A, I),
      (this.isPointLight = !0),
      (this.type = "PointLight"),
      (this.distance = g),
      (this.decay = C),
      (this.shadow = new fj()))
  }
  get power() {
    return this.intensity * 4 * Math.PI
  }
  set power(A) {
    this.intensity = A / (4 * Math.PI)
  }
  dispose() {
    this.shadow.dispose()
  }
  copy(A, I) {
    return (
      super.copy(A, I),
      (this.distance = A.distance),
      (this.decay = A.decay),
      (this.shadow = A.shadow.clone()),
      this
    )
  }
}
class dj extends fv {
  constructor() {
    ;(super(new yp(-5, 5, 5, -5, 0.5, 500)), (this.isDirectionalLightShadow = !0))
  }
}
class pv extends YD {
  constructor(A, I) {
    ;(super(A, I),
      (this.isDirectionalLight = !0),
      (this.type = "DirectionalLight"),
      this.position.copy(Ci.DEFAULT_UP),
      this.updateMatrix(),
      (this.target = new Ci()),
      (this.shadow = new dj()))
  }
  dispose() {
    this.shadow.dispose()
  }
  copy(A) {
    return (super.copy(A), (this.target = A.target.clone()), (this.shadow = A.shadow.clone()), this)
  }
}
class Rb extends YD {
  constructor(A, I) {
    ;(super(A, I), (this.isAmbientLight = !0), (this.type = "AmbientLight"))
  }
}
class Jb extends YD {
  constructor(A, I, g = 10, C = 10) {
    ;(super(A, I),
      (this.isRectAreaLight = !0),
      (this.type = "RectAreaLight"),
      (this.width = g),
      (this.height = C))
  }
  get power() {
    return this.intensity * this.width * this.height * Math.PI
  }
  set power(A) {
    this.intensity = A / (this.width * this.height * Math.PI)
  }
  copy(A) {
    return (super.copy(A), (this.width = A.width), (this.height = A.height), this)
  }
  toJSON(A) {
    const I = super.toJSON(A)
    return ((I.object.width = this.width), (I.object.height = this.height), I)
  }
}
class Kb {
  constructor() {
    ;((this.isSphericalHarmonics3 = !0), (this.coefficients = []))
    for (let A = 0; A < 9; A++) this.coefficients.push(new wA())
  }
  set(A) {
    for (let I = 0; I < 9; I++) this.coefficients[I].copy(A[I])
    return this
  }
  zero() {
    for (let A = 0; A < 9; A++) this.coefficients[A].set(0, 0, 0)
    return this
  }
  // get the radiance in the direction of the normal
  // target is a Vector3
  getAt(A, I) {
    const g = A.x,
      C = A.y,
      i = A.z,
      B = this.coefficients
    return (
      I.copy(B[0]).multiplyScalar(0.282095),
      I.addScaledVector(B[1], 0.488603 * C),
      I.addScaledVector(B[2], 0.488603 * i),
      I.addScaledVector(B[3], 0.488603 * g),
      I.addScaledVector(B[4], 1.092548 * (g * C)),
      I.addScaledVector(B[5], 1.092548 * (C * i)),
      I.addScaledVector(B[6], 0.315392 * (3 * i * i - 1)),
      I.addScaledVector(B[7], 1.092548 * (g * i)),
      I.addScaledVector(B[8], 0.546274 * (g * g - C * C)),
      I
    )
  }
  // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
  // target is a Vector3
  // https://graphics.stanford.edu/papers/envmap/envmap.pdf
  getIrradianceAt(A, I) {
    const g = A.x,
      C = A.y,
      i = A.z,
      B = this.coefficients
    return (
      I.copy(B[0]).multiplyScalar(0.886227),
      I.addScaledVector(B[1], 2 * 0.511664 * C),
      I.addScaledVector(B[2], 2 * 0.511664 * i),
      I.addScaledVector(B[3], 2 * 0.511664 * g),
      I.addScaledVector(B[4], 2 * 0.429043 * g * C),
      I.addScaledVector(B[5], 2 * 0.429043 * C * i),
      I.addScaledVector(B[6], 0.743125 * i * i - 0.247708),
      I.addScaledVector(B[7], 2 * 0.429043 * g * i),
      I.addScaledVector(B[8], 0.429043 * (g * g - C * C)),
      I
    )
  }
  add(A) {
    for (let I = 0; I < 9; I++) this.coefficients[I].add(A.coefficients[I])
    return this
  }
  addScaledSH(A, I) {
    for (let g = 0; g < 9; g++) this.coefficients[g].addScaledVector(A.coefficients[g], I)
    return this
  }
  scale(A) {
    for (let I = 0; I < 9; I++) this.coefficients[I].multiplyScalar(A)
    return this
  }
  lerp(A, I) {
    for (let g = 0; g < 9; g++) this.coefficients[g].lerp(A.coefficients[g], I)
    return this
  }
  equals(A) {
    for (let I = 0; I < 9; I++) if (!this.coefficients[I].equals(A.coefficients[I])) return !1
    return !0
  }
  copy(A) {
    return this.set(A.coefficients)
  }
  clone() {
    return new this.constructor().copy(this)
  }
  fromArray(A, I = 0) {
    const g = this.coefficients
    for (let C = 0; C < 9; C++) g[C].fromArray(A, I + C * 3)
    return this
  }
  toArray(A = [], I = 0) {
    const g = this.coefficients
    for (let C = 0; C < 9; C++) g[C].toArray(A, I + C * 3)
    return A
  }
  // evaluate the basis functions
  // shBasis is an Array[ 9 ]
  static getBasisAt(A, I) {
    const g = A.x,
      C = A.y,
      i = A.z
    ;((I[0] = 0.282095),
      (I[1] = 0.488603 * C),
      (I[2] = 0.488603 * i),
      (I[3] = 0.488603 * g),
      (I[4] = 1.092548 * g * C),
      (I[5] = 1.092548 * C * i),
      (I[6] = 0.315392 * (3 * i * i - 1)),
      (I[7] = 1.092548 * g * i),
      (I[8] = 0.546274 * (g * g - C * C)))
  }
}
class mb extends YD {
  constructor(A = new Kb(), I = 1) {
    ;(super(void 0, I), (this.isLightProbe = !0), (this.sh = A))
  }
  copy(A) {
    return (super.copy(A), this.sh.copy(A.sh), this)
  }
  fromJSON(A) {
    return ((this.intensity = A.intensity), this.sh.fromArray(A.sh), this)
  }
  toJSON(A) {
    const I = super.toJSON(A)
    return ((I.object.sh = this.sh.toArray()), I)
  }
}
class yF extends SE {
  constructor(A) {
    ;(super(A), (this.textures = {}))
  }
  load(A, I, g, C) {
    const i = this,
      B = new Yr(i.manager)
    ;(B.setPath(i.path),
      B.setRequestHeader(i.requestHeader),
      B.setWithCredentials(i.withCredentials),
      B.load(
        A,
        function (o) {
          try {
            I(i.parse(JSON.parse(o)))
          } catch (r) {
            ;(C ? C(r) : console.error(r), i.manager.itemError(A))
          }
        },
        g,
        C,
      ))
  }
  parse(A) {
    const I = this.textures
    function g(i) {
      return (I[i] === void 0 && console.warn("THREE.MaterialLoader: Undefined texture", i), I[i])
    }
    const C = this.createMaterialFromType(A.type)
    if (
      (A.uuid !== void 0 && (C.uuid = A.uuid),
      A.name !== void 0 && (C.name = A.name),
      A.color !== void 0 && C.color !== void 0 && C.color.setHex(A.color),
      A.roughness !== void 0 && (C.roughness = A.roughness),
      A.metalness !== void 0 && (C.metalness = A.metalness),
      A.sheen !== void 0 && (C.sheen = A.sheen),
      A.sheenColor !== void 0 && (C.sheenColor = new Mg().setHex(A.sheenColor)),
      A.sheenRoughness !== void 0 && (C.sheenRoughness = A.sheenRoughness),
      A.emissive !== void 0 && C.emissive !== void 0 && C.emissive.setHex(A.emissive),
      A.specular !== void 0 && C.specular !== void 0 && C.specular.setHex(A.specular),
      A.specularIntensity !== void 0 && (C.specularIntensity = A.specularIntensity),
      A.specularColor !== void 0 &&
        C.specularColor !== void 0 &&
        C.specularColor.setHex(A.specularColor),
      A.shininess !== void 0 && (C.shininess = A.shininess),
      A.clearcoat !== void 0 && (C.clearcoat = A.clearcoat),
      A.clearcoatRoughness !== void 0 && (C.clearcoatRoughness = A.clearcoatRoughness),
      A.dispersion !== void 0 && (C.dispersion = A.dispersion),
      A.iridescence !== void 0 && (C.iridescence = A.iridescence),
      A.iridescenceIOR !== void 0 && (C.iridescenceIOR = A.iridescenceIOR),
      A.iridescenceThicknessRange !== void 0 &&
        (C.iridescenceThicknessRange = A.iridescenceThicknessRange),
      A.transmission !== void 0 && (C.transmission = A.transmission),
      A.thickness !== void 0 && (C.thickness = A.thickness),
      A.attenuationDistance !== void 0 && (C.attenuationDistance = A.attenuationDistance),
      A.attenuationColor !== void 0 &&
        C.attenuationColor !== void 0 &&
        C.attenuationColor.setHex(A.attenuationColor),
      A.anisotropy !== void 0 && (C.anisotropy = A.anisotropy),
      A.anisotropyRotation !== void 0 && (C.anisotropyRotation = A.anisotropyRotation),
      A.fog !== void 0 && (C.fog = A.fog),
      A.flatShading !== void 0 && (C.flatShading = A.flatShading),
      A.blending !== void 0 && (C.blending = A.blending),
      A.combine !== void 0 && (C.combine = A.combine),
      A.side !== void 0 && (C.side = A.side),
      A.shadowSide !== void 0 && (C.shadowSide = A.shadowSide),
      A.opacity !== void 0 && (C.opacity = A.opacity),
      A.transparent !== void 0 && (C.transparent = A.transparent),
      A.alphaTest !== void 0 && (C.alphaTest = A.alphaTest),
      A.alphaHash !== void 0 && (C.alphaHash = A.alphaHash),
      A.depthFunc !== void 0 && (C.depthFunc = A.depthFunc),
      A.depthTest !== void 0 && (C.depthTest = A.depthTest),
      A.depthWrite !== void 0 && (C.depthWrite = A.depthWrite),
      A.colorWrite !== void 0 && (C.colorWrite = A.colorWrite),
      A.blendSrc !== void 0 && (C.blendSrc = A.blendSrc),
      A.blendDst !== void 0 && (C.blendDst = A.blendDst),
      A.blendEquation !== void 0 && (C.blendEquation = A.blendEquation),
      A.blendSrcAlpha !== void 0 && (C.blendSrcAlpha = A.blendSrcAlpha),
      A.blendDstAlpha !== void 0 && (C.blendDstAlpha = A.blendDstAlpha),
      A.blendEquationAlpha !== void 0 && (C.blendEquationAlpha = A.blendEquationAlpha),
      A.blendColor !== void 0 && C.blendColor !== void 0 && C.blendColor.setHex(A.blendColor),
      A.blendAlpha !== void 0 && (C.blendAlpha = A.blendAlpha),
      A.stencilWriteMask !== void 0 && (C.stencilWriteMask = A.stencilWriteMask),
      A.stencilFunc !== void 0 && (C.stencilFunc = A.stencilFunc),
      A.stencilRef !== void 0 && (C.stencilRef = A.stencilRef),
      A.stencilFuncMask !== void 0 && (C.stencilFuncMask = A.stencilFuncMask),
      A.stencilFail !== void 0 && (C.stencilFail = A.stencilFail),
      A.stencilZFail !== void 0 && (C.stencilZFail = A.stencilZFail),
      A.stencilZPass !== void 0 && (C.stencilZPass = A.stencilZPass),
      A.stencilWrite !== void 0 && (C.stencilWrite = A.stencilWrite),
      A.wireframe !== void 0 && (C.wireframe = A.wireframe),
      A.wireframeLinewidth !== void 0 && (C.wireframeLinewidth = A.wireframeLinewidth),
      A.wireframeLinecap !== void 0 && (C.wireframeLinecap = A.wireframeLinecap),
      A.wireframeLinejoin !== void 0 && (C.wireframeLinejoin = A.wireframeLinejoin),
      A.rotation !== void 0 && (C.rotation = A.rotation),
      A.linewidth !== void 0 && (C.linewidth = A.linewidth),
      A.dashSize !== void 0 && (C.dashSize = A.dashSize),
      A.gapSize !== void 0 && (C.gapSize = A.gapSize),
      A.scale !== void 0 && (C.scale = A.scale),
      A.polygonOffset !== void 0 && (C.polygonOffset = A.polygonOffset),
      A.polygonOffsetFactor !== void 0 && (C.polygonOffsetFactor = A.polygonOffsetFactor),
      A.polygonOffsetUnits !== void 0 && (C.polygonOffsetUnits = A.polygonOffsetUnits),
      A.dithering !== void 0 && (C.dithering = A.dithering),
      A.alphaToCoverage !== void 0 && (C.alphaToCoverage = A.alphaToCoverage),
      A.premultipliedAlpha !== void 0 && (C.premultipliedAlpha = A.premultipliedAlpha),
      A.forceSinglePass !== void 0 && (C.forceSinglePass = A.forceSinglePass),
      A.visible !== void 0 && (C.visible = A.visible),
      A.toneMapped !== void 0 && (C.toneMapped = A.toneMapped),
      A.userData !== void 0 && (C.userData = A.userData),
      A.vertexColors !== void 0 &&
        (typeof A.vertexColors == "number"
          ? (C.vertexColors = A.vertexColors > 0)
          : (C.vertexColors = A.vertexColors)),
      A.uniforms !== void 0)
    )
      for (const i in A.uniforms) {
        const B = A.uniforms[i]
        switch (((C.uniforms[i] = {}), B.type)) {
          case "t":
            C.uniforms[i].value = g(B.value)
            break
          case "c":
            C.uniforms[i].value = new Mg().setHex(B.value)
            break
          case "v2":
            C.uniforms[i].value = new ZI().fromArray(B.value)
            break
          case "v3":
            C.uniforms[i].value = new wA().fromArray(B.value)
            break
          case "v4":
            C.uniforms[i].value = new Xe().fromArray(B.value)
            break
          case "m3":
            C.uniforms[i].value = new ce().fromArray(B.value)
            break
          case "m4":
            C.uniforms[i].value = new RC().fromArray(B.value)
            break
          default:
            C.uniforms[i].value = B.value
        }
      }
    if (
      (A.defines !== void 0 && (C.defines = A.defines),
      A.vertexShader !== void 0 && (C.vertexShader = A.vertexShader),
      A.fragmentShader !== void 0 && (C.fragmentShader = A.fragmentShader),
      A.glslVersion !== void 0 && (C.glslVersion = A.glslVersion),
      A.extensions !== void 0)
    )
      for (const i in A.extensions) C.extensions[i] = A.extensions[i]
    if (
      (A.lights !== void 0 && (C.lights = A.lights),
      A.clipping !== void 0 && (C.clipping = A.clipping),
      A.size !== void 0 && (C.size = A.size),
      A.sizeAttenuation !== void 0 && (C.sizeAttenuation = A.sizeAttenuation),
      A.map !== void 0 && (C.map = g(A.map)),
      A.matcap !== void 0 && (C.matcap = g(A.matcap)),
      A.alphaMap !== void 0 && (C.alphaMap = g(A.alphaMap)),
      A.bumpMap !== void 0 && (C.bumpMap = g(A.bumpMap)),
      A.bumpScale !== void 0 && (C.bumpScale = A.bumpScale),
      A.normalMap !== void 0 && (C.normalMap = g(A.normalMap)),
      A.normalMapType !== void 0 && (C.normalMapType = A.normalMapType),
      A.normalScale !== void 0)
    ) {
      let i = A.normalScale
      ;(Array.isArray(i) === !1 && (i = [i, i]), (C.normalScale = new ZI().fromArray(i)))
    }
    return (
      A.displacementMap !== void 0 && (C.displacementMap = g(A.displacementMap)),
      A.displacementScale !== void 0 && (C.displacementScale = A.displacementScale),
      A.displacementBias !== void 0 && (C.displacementBias = A.displacementBias),
      A.roughnessMap !== void 0 && (C.roughnessMap = g(A.roughnessMap)),
      A.metalnessMap !== void 0 && (C.metalnessMap = g(A.metalnessMap)),
      A.emissiveMap !== void 0 && (C.emissiveMap = g(A.emissiveMap)),
      A.emissiveIntensity !== void 0 && (C.emissiveIntensity = A.emissiveIntensity),
      A.specularMap !== void 0 && (C.specularMap = g(A.specularMap)),
      A.specularIntensityMap !== void 0 && (C.specularIntensityMap = g(A.specularIntensityMap)),
      A.specularColorMap !== void 0 && (C.specularColorMap = g(A.specularColorMap)),
      A.envMap !== void 0 && (C.envMap = g(A.envMap)),
      A.envMapRotation !== void 0 && C.envMapRotation.fromArray(A.envMapRotation),
      A.envMapIntensity !== void 0 && (C.envMapIntensity = A.envMapIntensity),
      A.reflectivity !== void 0 && (C.reflectivity = A.reflectivity),
      A.refractionRatio !== void 0 && (C.refractionRatio = A.refractionRatio),
      A.lightMap !== void 0 && (C.lightMap = g(A.lightMap)),
      A.lightMapIntensity !== void 0 && (C.lightMapIntensity = A.lightMapIntensity),
      A.aoMap !== void 0 && (C.aoMap = g(A.aoMap)),
      A.aoMapIntensity !== void 0 && (C.aoMapIntensity = A.aoMapIntensity),
      A.gradientMap !== void 0 && (C.gradientMap = g(A.gradientMap)),
      A.clearcoatMap !== void 0 && (C.clearcoatMap = g(A.clearcoatMap)),
      A.clearcoatRoughnessMap !== void 0 && (C.clearcoatRoughnessMap = g(A.clearcoatRoughnessMap)),
      A.clearcoatNormalMap !== void 0 && (C.clearcoatNormalMap = g(A.clearcoatNormalMap)),
      A.clearcoatNormalScale !== void 0 &&
        (C.clearcoatNormalScale = new ZI().fromArray(A.clearcoatNormalScale)),
      A.iridescenceMap !== void 0 && (C.iridescenceMap = g(A.iridescenceMap)),
      A.iridescenceThicknessMap !== void 0 &&
        (C.iridescenceThicknessMap = g(A.iridescenceThicknessMap)),
      A.transmissionMap !== void 0 && (C.transmissionMap = g(A.transmissionMap)),
      A.thicknessMap !== void 0 && (C.thicknessMap = g(A.thicknessMap)),
      A.anisotropyMap !== void 0 && (C.anisotropyMap = g(A.anisotropyMap)),
      A.sheenColorMap !== void 0 && (C.sheenColorMap = g(A.sheenColorMap)),
      A.sheenRoughnessMap !== void 0 && (C.sheenRoughnessMap = g(A.sheenRoughnessMap)),
      C
    )
  }
  setTextures(A) {
    return ((this.textures = A), this)
  }
  createMaterialFromType(A) {
    return yF.createMaterialFromType(A)
  }
  static createMaterialFromType(A) {
    const I = {
      ShadowMaterial: hb,
      SpriteMaterial: iv,
      RawShaderMaterial: ub,
      ShaderMaterial: VQ,
      PointsMaterial: BF,
      MeshPhysicalMaterial: Hr,
      MeshStandardMaterial: qG,
      MeshPhongMaterial: Db,
      MeshToonMaterial: Sb,
      MeshNormalMaterial: cv,
      MeshLambertMaterial: fb,
      MeshDepthMaterial: gF,
      MeshDistanceMaterial: CF,
      MeshBasicMaterial: La,
      MeshMatcapMaterial: db,
      LineDashedMaterial: yb,
      LineBasicMaterial: DE,
      Material: tQ,
    }
    return new I[A]()
  }
}
class wD {
  static decodeText(A) {
    if (
      (console.warn(
        "THREE.LoaderUtils: decodeText() has been deprecated with r165 and will be removed with r175. Use TextDecoder instead.",
      ),
      typeof TextDecoder < "u")
    )
      return new TextDecoder().decode(A)
    let I = ""
    for (let g = 0, C = A.length; g < C; g++) I += String.fromCharCode(A[g])
    try {
      return decodeURIComponent(escape(I))
    } catch {
      return I
    }
  }
  static extractUrlBase(A) {
    const I = A.lastIndexOf("/")
    return I === -1 ? "./" : A.slice(0, I + 1)
  }
  static resolveURL(A, I) {
    return typeof A != "string" || A === ""
      ? ""
      : (/^https?:\/\//i.test(I) &&
          /^\//.test(A) &&
          (I = I.replace(/(^https?:\/\/[^\/]+).*/i, "$1")),
        /^(https?:)?\/\//i.test(A) || /^data:.*,.*$/i.test(A) || /^blob:.*$/i.test(A) ? A : I + A)
  }
}
class wv extends se {
  constructor() {
    ;(super(),
      (this.isInstancedBufferGeometry = !0),
      (this.type = "InstancedBufferGeometry"),
      (this.instanceCount = 1 / 0))
  }
  copy(A) {
    return (super.copy(A), (this.instanceCount = A.instanceCount), this)
  }
  toJSON() {
    const A = super.toJSON()
    return ((A.instanceCount = this.instanceCount), (A.isInstancedBufferGeometry = !0), A)
  }
}
class vb extends SE {
  constructor(A) {
    super(A)
  }
  load(A, I, g, C) {
    const i = this,
      B = new Yr(i.manager)
    ;(B.setPath(i.path),
      B.setRequestHeader(i.requestHeader),
      B.setWithCredentials(i.withCredentials),
      B.load(
        A,
        function (o) {
          try {
            I(i.parse(JSON.parse(o)))
          } catch (r) {
            ;(C ? C(r) : console.error(r), i.manager.itemError(A))
          }
        },
        g,
        C,
      ))
  }
  parse(A) {
    const I = {},
      g = {}
    function C(w, M) {
      if (I[M] !== void 0) return I[M]
      const R = w.interleavedBuffers[M],
        F = i(w, R.buffer),
        L = Ap(R.type, F),
        Y = new KG(L, R.stride)
      return ((Y.uuid = R.uuid), (I[M] = Y), Y)
    }
    function i(w, M) {
      if (g[M] !== void 0) return g[M]
      const R = w.arrayBuffers[M],
        F = new Uint32Array(R).buffer
      return ((g[M] = F), F)
    }
    const B = A.isInstancedBufferGeometry ? new wv() : new se(),
      o = A.data.index
    if (o !== void 0) {
      const w = Ap(o.type, o.array)
      B.setIndex(new Ye(w, 1))
    }
    const r = A.data.attributes
    for (const w in r) {
      const M = r[w]
      let K
      if (M.isInterleavedBufferAttribute) {
        const R = C(A.data, M.data)
        K = new FD(R, M.itemSize, M.offset, M.normalized)
      } else {
        const R = Ap(M.type, M.array),
          F = M.isInstancedBufferAttribute ? RD : Ye
        K = new F(R, M.itemSize, M.normalized)
      }
      ;(M.name !== void 0 && (K.name = M.name),
        M.usage !== void 0 && K.setUsage(M.usage),
        B.setAttribute(w, K))
    }
    const s = A.data.morphAttributes
    if (s)
      for (const w in s) {
        const M = s[w],
          K = []
        for (let R = 0, F = M.length; R < F; R++) {
          const L = M[R]
          let Y
          if (L.isInterleavedBufferAttribute) {
            const H = C(A.data, L.data)
            Y = new FD(H, L.itemSize, L.offset, L.normalized)
          } else {
            const H = Ap(L.type, L.array)
            Y = new Ye(H, L.itemSize, L.normalized)
          }
          ;(L.name !== void 0 && (Y.name = L.name), K.push(Y))
        }
        B.morphAttributes[w] = K
      }
    A.data.morphTargetsRelative && (B.morphTargetsRelative = !0)
    const S = A.data.groups || A.data.drawcalls || A.data.offsets
    if (S !== void 0)
      for (let w = 0, M = S.length; w !== M; ++w) {
        const K = S[w]
        B.addGroup(K.start, K.count, K.materialIndex)
      }
    const d = A.data.boundingSphere
    if (d !== void 0) {
      const w = new wA()
      ;(d.center !== void 0 && w.fromArray(d.center), (B.boundingSphere = new jo(w, d.radius)))
    }
    return (A.name && (B.name = A.name), A.userData && (B.userData = A.userData), B)
  }
}
class yj extends SE {
  constructor(A) {
    super(A)
  }
  load(A, I, g, C) {
    const i = this,
      B = this.path === "" ? wD.extractUrlBase(A) : this.path
    this.resourcePath = this.resourcePath || B
    const o = new Yr(this.manager)
    ;(o.setPath(this.path),
      o.setRequestHeader(this.requestHeader),
      o.setWithCredentials(this.withCredentials),
      o.load(
        A,
        function (r) {
          let s = null
          try {
            s = JSON.parse(r)
          } catch (S) {
            ;(C !== void 0 && C(S),
              console.error("THREE:ObjectLoader: Can't parse " + A + ".", S.message))
            return
          }
          const h = s.metadata
          if (h === void 0 || h.type === void 0 || h.type.toLowerCase() === "geometry") {
            ;(C !== void 0 && C(new Error("THREE.ObjectLoader: Can't load " + A)),
              console.error("THREE.ObjectLoader: Can't load " + A))
            return
          }
          i.parse(s, I)
        },
        g,
        C,
      ))
  }
  async loadAsync(A, I) {
    const g = this,
      C = this.path === "" ? wD.extractUrlBase(A) : this.path
    this.resourcePath = this.resourcePath || C
    const i = new Yr(this.manager)
    ;(i.setPath(this.path),
      i.setRequestHeader(this.requestHeader),
      i.setWithCredentials(this.withCredentials))
    const B = await i.loadAsync(A, I),
      o = JSON.parse(B),
      r = o.metadata
    if (r === void 0 || r.type === void 0 || r.type.toLowerCase() === "geometry")
      throw new Error("THREE.ObjectLoader: Can't load " + A)
    return await g.parseAsync(o)
  }
  parse(A, I) {
    const g = this.parseAnimations(A.animations),
      C = this.parseShapes(A.shapes),
      i = this.parseGeometries(A.geometries, C),
      B = this.parseImages(A.images, function () {
        I !== void 0 && I(s)
      }),
      o = this.parseTextures(A.textures, B),
      r = this.parseMaterials(A.materials, o),
      s = this.parseObject(A.object, i, r, o, g),
      h = this.parseSkeletons(A.skeletons, s)
    if ((this.bindSkeletons(s, h), this.bindLightTargets(s), I !== void 0)) {
      let S = !1
      for (const d in B)
        if (B[d].data instanceof HTMLImageElement) {
          S = !0
          break
        }
      S === !1 && I(s)
    }
    return s
  }
  async parseAsync(A) {
    const I = this.parseAnimations(A.animations),
      g = this.parseShapes(A.shapes),
      C = this.parseGeometries(A.geometries, g),
      i = await this.parseImagesAsync(A.images),
      B = this.parseTextures(A.textures, i),
      o = this.parseMaterials(A.materials, B),
      r = this.parseObject(A.object, C, o, B, I),
      s = this.parseSkeletons(A.skeletons, r)
    return (this.bindSkeletons(r, s), this.bindLightTargets(r), r)
  }
  parseShapes(A) {
    const I = {}
    if (A !== void 0)
      for (let g = 0, C = A.length; g < C; g++) {
        const i = new mf().fromJSON(A[g])
        I[i.uuid] = i
      }
    return I
  }
  parseSkeletons(A, I) {
    const g = {},
      C = {}
    if (
      (I.traverse(function (i) {
        i.isBone && (C[i.uuid] = i)
      }),
      A !== void 0)
    )
      for (let i = 0, B = A.length; i < B; i++) {
        const o = new mG().fromJSON(A[i], C)
        g[o.uuid] = o
      }
    return g
  }
  parseGeometries(A, I) {
    const g = {}
    if (A !== void 0) {
      const C = new vb()
      for (let i = 0, B = A.length; i < B; i++) {
        let o
        const r = A[i]
        switch (r.type) {
          case "BufferGeometry":
          case "InstancedBufferGeometry":
            o = C.parse(r)
            break
          default:
            r.type in _H
              ? (o = _H[r.type].fromJSON(r, I))
              : console.warn(`THREE.ObjectLoader: Unsupported geometry type "${r.type}"`)
        }
        ;((o.uuid = r.uuid),
          r.name !== void 0 && (o.name = r.name),
          r.userData !== void 0 && (o.userData = r.userData),
          (g[r.uuid] = o))
      }
    }
    return g
  }
  parseMaterials(A, I) {
    const g = {},
      C = {}
    if (A !== void 0) {
      const i = new yF()
      i.setTextures(I)
      for (let B = 0, o = A.length; B < o; B++) {
        const r = A[B]
        ;(g[r.uuid] === void 0 && (g[r.uuid] = i.parse(r)), (C[r.uuid] = g[r.uuid]))
      }
    }
    return C
  }
  parseAnimations(A) {
    const I = {}
    if (A !== void 0)
      for (let g = 0; g < A.length; g++) {
        const C = A[g],
          i = lp.parse(C)
        I[i.uuid] = i
      }
    return I
  }
  parseImages(A, I) {
    const g = this,
      C = {}
    let i
    function B(r) {
      return (
        g.manager.itemStart(r),
        i.load(
          r,
          function () {
            g.manager.itemEnd(r)
          },
          void 0,
          function () {
            ;(g.manager.itemError(r), g.manager.itemEnd(r))
          },
        )
      )
    }
    function o(r) {
      if (typeof r == "string") {
        const s = r,
          h = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(s) ? s : g.resourcePath + s
        return B(h)
      } else
        return r.data
          ? {
              data: Ap(r.type, r.data),
              width: r.width,
              height: r.height,
            }
          : null
    }
    if (A !== void 0 && A.length > 0) {
      const r = new Sv(I)
      ;((i = new SG(r)), i.setCrossOrigin(this.crossOrigin))
      for (let s = 0, h = A.length; s < h; s++) {
        const S = A[s],
          d = S.url
        if (Array.isArray(d)) {
          const w = []
          for (let M = 0, K = d.length; M < K; M++) {
            const R = d[M],
              F = o(R)
            F !== null &&
              (F instanceof HTMLImageElement
                ? w.push(F)
                : w.push(new Oc(F.data, F.width, F.height)))
          }
          C[S.uuid] = new kf(w)
        } else {
          const w = o(S.url)
          C[S.uuid] = new kf(w)
        }
      }
    }
    return C
  }
  async parseImagesAsync(A) {
    const I = this,
      g = {}
    let C
    async function i(B) {
      if (typeof B == "string") {
        const o = B,
          r = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(o) ? o : I.resourcePath + o
        return await C.loadAsync(r)
      } else
        return B.data
          ? {
              data: Ap(B.type, B.data),
              width: B.width,
              height: B.height,
            }
          : null
    }
    if (A !== void 0 && A.length > 0) {
      ;((C = new SG(this.manager)), C.setCrossOrigin(this.crossOrigin))
      for (let B = 0, o = A.length; B < o; B++) {
        const r = A[B],
          s = r.url
        if (Array.isArray(s)) {
          const h = []
          for (let S = 0, d = s.length; S < d; S++) {
            const w = s[S],
              M = await i(w)
            M !== null &&
              (M instanceof HTMLImageElement
                ? h.push(M)
                : h.push(new Oc(M.data, M.width, M.height)))
          }
          g[r.uuid] = new kf(h)
        } else {
          const h = await i(r.url)
          g[r.uuid] = new kf(h)
        }
      }
    }
    return g
  }
  parseTextures(A, I) {
    function g(i, B) {
      return typeof i == "number"
        ? i
        : (console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", i),
          B[i])
    }
    const C = {}
    if (A !== void 0)
      for (let i = 0, B = A.length; i < B; i++) {
        const o = A[i]
        ;(o.image === void 0 &&
          console.warn('THREE.ObjectLoader: No "image" specified for', o.uuid),
          I[o.image] === void 0 && console.warn("THREE.ObjectLoader: Undefined image", o.image))
        const r = I[o.image],
          s = r.data
        let h
        ;(Array.isArray(s)
          ? ((h = new FG()), s.length === 6 && (h.needsUpdate = !0))
          : (s && s.data ? (h = new Oc()) : (h = new pt()), s && (h.needsUpdate = !0)),
          (h.source = r),
          (h.uuid = o.uuid),
          o.name !== void 0 && (h.name = o.name),
          o.mapping !== void 0 && (h.mapping = g(o.mapping, pj)),
          o.channel !== void 0 && (h.channel = o.channel),
          o.offset !== void 0 && h.offset.fromArray(o.offset),
          o.repeat !== void 0 && h.repeat.fromArray(o.repeat),
          o.center !== void 0 && h.center.fromArray(o.center),
          o.rotation !== void 0 && (h.rotation = o.rotation),
          o.wrap !== void 0 && ((h.wrapS = g(o.wrap[0], VH)), (h.wrapT = g(o.wrap[1], VH))),
          o.format !== void 0 && (h.format = o.format),
          o.internalFormat !== void 0 && (h.internalFormat = o.internalFormat),
          o.type !== void 0 && (h.type = o.type),
          o.colorSpace !== void 0 && (h.colorSpace = o.colorSpace),
          o.minFilter !== void 0 && (h.minFilter = g(o.minFilter, jH)),
          o.magFilter !== void 0 && (h.magFilter = g(o.magFilter, jH)),
          o.anisotropy !== void 0 && (h.anisotropy = o.anisotropy),
          o.flipY !== void 0 && (h.flipY = o.flipY),
          o.generateMipmaps !== void 0 && (h.generateMipmaps = o.generateMipmaps),
          o.premultiplyAlpha !== void 0 && (h.premultiplyAlpha = o.premultiplyAlpha),
          o.unpackAlignment !== void 0 && (h.unpackAlignment = o.unpackAlignment),
          o.compareFunction !== void 0 && (h.compareFunction = o.compareFunction),
          o.userData !== void 0 && (h.userData = o.userData),
          (C[o.uuid] = h))
      }
    return C
  }
  parseObject(A, I, g, C, i) {
    let B
    function o(d) {
      return (I[d] === void 0 && console.warn("THREE.ObjectLoader: Undefined geometry", d), I[d])
    }
    function r(d) {
      if (d !== void 0) {
        if (Array.isArray(d)) {
          const w = []
          for (let M = 0, K = d.length; M < K; M++) {
            const R = d[M]
            ;(g[R] === void 0 && console.warn("THREE.ObjectLoader: Undefined material", R),
              w.push(g[R]))
          }
          return w
        }
        return (g[d] === void 0 && console.warn("THREE.ObjectLoader: Undefined material", d), g[d])
      }
    }
    function s(d) {
      return (C[d] === void 0 && console.warn("THREE.ObjectLoader: Undefined texture", d), C[d])
    }
    let h, S
    switch (A.type) {
      case "Scene":
        ;((B = new sp()),
          A.background !== void 0 &&
            (Number.isInteger(A.background)
              ? (B.background = new Mg(A.background))
              : (B.background = s(A.background))),
          A.environment !== void 0 && (B.environment = s(A.environment)),
          A.fog !== void 0 &&
            (A.fog.type === "Fog"
              ? (B.fog = new iF(A.fog.color, A.fog.near, A.fog.far))
              : A.fog.type === "FogExp2" && (B.fog = new eF(A.fog.color, A.fog.density)),
            A.fog.name !== "" && (B.fog.name = A.fog.name)),
          A.backgroundBlurriness !== void 0 && (B.backgroundBlurriness = A.backgroundBlurriness),
          A.backgroundIntensity !== void 0 && (B.backgroundIntensity = A.backgroundIntensity),
          A.backgroundRotation !== void 0 && B.backgroundRotation.fromArray(A.backgroundRotation),
          A.environmentIntensity !== void 0 && (B.environmentIntensity = A.environmentIntensity),
          A.environmentRotation !== void 0 &&
            B.environmentRotation.fromArray(A.environmentRotation))
        break
      case "PerspectiveCamera":
        ;((B = new PQ(A.fov, A.aspect, A.near, A.far)),
          A.focus !== void 0 && (B.focus = A.focus),
          A.zoom !== void 0 && (B.zoom = A.zoom),
          A.filmGauge !== void 0 && (B.filmGauge = A.filmGauge),
          A.filmOffset !== void 0 && (B.filmOffset = A.filmOffset),
          A.view !== void 0 && (B.view = Object.assign({}, A.view)))
        break
      case "OrthographicCamera":
        ;((B = new yp(A.left, A.right, A.top, A.bottom, A.near, A.far)),
          A.zoom !== void 0 && (B.zoom = A.zoom),
          A.view !== void 0 && (B.view = Object.assign({}, A.view)))
        break
      case "AmbientLight":
        B = new Rb(A.color, A.intensity)
        break
      case "DirectionalLight":
        ;((B = new pv(A.color, A.intensity)), (B.target = A.target || ""))
        break
      case "PointLight":
        B = new yv(A.color, A.intensity, A.distance, A.decay)
        break
      case "RectAreaLight":
        B = new Jb(A.color, A.intensity, A.width, A.height)
        break
      case "SpotLight":
        ;((B = new dv(A.color, A.intensity, A.distance, A.angle, A.penumbra, A.decay)),
          (B.target = A.target || ""))
        break
      case "HemisphereLight":
        B = new Fb(A.color, A.groundColor, A.intensity)
        break
      case "LightProbe":
        B = new mb().fromJSON(A)
        break
      case "SkinnedMesh":
        ;((h = o(A.geometry)),
          (S = r(A.material)),
          (B = new tv(h, S)),
          A.bindMode !== void 0 && (B.bindMode = A.bindMode),
          A.bindMatrix !== void 0 && B.bindMatrix.fromArray(A.bindMatrix),
          A.skeleton !== void 0 && (B.skeleton = A.skeleton))
        break
      case "Mesh":
        ;((h = o(A.geometry)), (S = r(A.material)), (B = new EB(h, S)))
        break
      case "InstancedMesh":
        ;((h = o(A.geometry)), (S = r(A.material)))
        const d = A.count,
          w = A.instanceMatrix,
          M = A.instanceColor
        ;((B = new Bv(h, S, d)),
          (B.instanceMatrix = new RD(new Float32Array(w.array), 16)),
          M !== void 0 && (B.instanceColor = new RD(new Float32Array(M.array), M.itemSize)))
        break
      case "BatchedMesh":
        ;((h = o(A.geometry)),
          (S = r(A.material)),
          (B = new tb(A.maxInstanceCount, A.maxVertexCount, A.maxIndexCount, S)),
          (B.geometry = h),
          (B.perObjectFrustumCulled = A.perObjectFrustumCulled),
          (B.sortObjects = A.sortObjects),
          (B._drawRanges = A.drawRanges),
          (B._reservedRanges = A.reservedRanges),
          (B._visibility = A.visibility),
          (B._active = A.active),
          (B._bounds = A.bounds.map((K) => {
            const R = new Vo()
            ;(R.min.fromArray(K.boxMin), R.max.fromArray(K.boxMax))
            const F = new jo()
            return (
              (F.radius = K.sphereRadius),
              F.center.fromArray(K.sphereCenter),
              {
                boxInitialized: K.boxInitialized,
                box: R,
                sphereInitialized: K.sphereInitialized,
                sphere: F,
              }
            )
          })),
          (B._maxInstanceCount = A.maxInstanceCount),
          (B._maxVertexCount = A.maxVertexCount),
          (B._maxIndexCount = A.maxIndexCount),
          (B._geometryInitialized = A.geometryInitialized),
          (B._geometryCount = A.geometryCount),
          (B._matricesTexture = s(A.matricesTexture.uuid)),
          A.colorsTexture !== void 0 && (B._colorsTexture = s(A.colorsTexture.uuid)))
        break
      case "LOD":
        B = new ib()
        break
      case "Line":
        B = new Qu(o(A.geometry), r(A.material))
        break
      case "LineLoop":
        B = new Qv(o(A.geometry), r(A.material))
        break
      case "LineSegments":
        B = new Ul(o(A.geometry), r(A.material))
        break
      case "PointCloud":
      case "Points":
        B = new ov(o(A.geometry), r(A.material))
        break
      case "Sprite":
        B = new eb(r(A.material))
        break
      case "Group":
        B = new Iu()
        break
      case "Bone":
        B = new tF()
        break
      default:
        B = new Ci()
    }
    if (
      ((B.uuid = A.uuid),
      A.name !== void 0 && (B.name = A.name),
      A.matrix !== void 0
        ? (B.matrix.fromArray(A.matrix),
          A.matrixAutoUpdate !== void 0 && (B.matrixAutoUpdate = A.matrixAutoUpdate),
          B.matrixAutoUpdate && B.matrix.decompose(B.position, B.quaternion, B.scale))
        : (A.position !== void 0 && B.position.fromArray(A.position),
          A.rotation !== void 0 && B.rotation.fromArray(A.rotation),
          A.quaternion !== void 0 && B.quaternion.fromArray(A.quaternion),
          A.scale !== void 0 && B.scale.fromArray(A.scale)),
      A.up !== void 0 && B.up.fromArray(A.up),
      A.castShadow !== void 0 && (B.castShadow = A.castShadow),
      A.receiveShadow !== void 0 && (B.receiveShadow = A.receiveShadow),
      A.shadow &&
        (A.shadow.intensity !== void 0 && (B.shadow.intensity = A.shadow.intensity),
        A.shadow.bias !== void 0 && (B.shadow.bias = A.shadow.bias),
        A.shadow.normalBias !== void 0 && (B.shadow.normalBias = A.shadow.normalBias),
        A.shadow.radius !== void 0 && (B.shadow.radius = A.shadow.radius),
        A.shadow.mapSize !== void 0 && B.shadow.mapSize.fromArray(A.shadow.mapSize),
        A.shadow.camera !== void 0 && (B.shadow.camera = this.parseObject(A.shadow.camera))),
      A.visible !== void 0 && (B.visible = A.visible),
      A.frustumCulled !== void 0 && (B.frustumCulled = A.frustumCulled),
      A.renderOrder !== void 0 && (B.renderOrder = A.renderOrder),
      A.userData !== void 0 && (B.userData = A.userData),
      A.layers !== void 0 && (B.layers.mask = A.layers),
      A.children !== void 0)
    ) {
      const d = A.children
      for (let w = 0; w < d.length; w++) B.add(this.parseObject(d[w], I, g, C, i))
    }
    if (A.animations !== void 0) {
      const d = A.animations
      for (let w = 0; w < d.length; w++) {
        const M = d[w]
        B.animations.push(i[M])
      }
    }
    if (A.type === "LOD") {
      A.autoUpdate !== void 0 && (B.autoUpdate = A.autoUpdate)
      const d = A.levels
      for (let w = 0; w < d.length; w++) {
        const M = d[w],
          K = B.getObjectByProperty("uuid", M.object)
        K !== void 0 && B.addLevel(K, M.distance, M.hysteresis)
      }
    }
    return B
  }
  bindSkeletons(A, I) {
    Object.keys(I).length !== 0 &&
      A.traverse(function (g) {
        if (g.isSkinnedMesh === !0 && g.skeleton !== void 0) {
          const C = I[g.skeleton]
          C === void 0
            ? console.warn("THREE.ObjectLoader: No skeleton found with UUID:", g.skeleton)
            : g.bind(C, g.bindMatrix)
        }
      })
  }
  bindLightTargets(A) {
    A.traverse(function (I) {
      if (I.isDirectionalLight || I.isSpotLight) {
        const g = I.target,
          C = A.getObjectByProperty("uuid", g)
        C !== void 0 ? (I.target = C) : (I.target = new Ci())
      }
    })
  }
}
const pj = {
    UVMapping: bN,
    CubeReflectionMapping: Bu,
    CubeRefractionMapping: kD,
    EquirectangularReflectionMapping: nG,
    EquirectangularRefractionMapping: EG,
    CubeUVReflectionMapping: Sp,
  },
  VH = {
    RepeatWrapping: MD,
    ClampToEdgeWrapping: vr,
    MirroredRepeatWrapping: Qp,
  },
  jH = {
    NearestFilter: iQ,
    NearestMipmapNearestFilter: ON,
    NearestMipmapLinearFilter: pf,
    LinearFilter: nt,
    LinearMipmapNearestFilter: ep,
    LinearMipmapLinearFilter: ks,
  }
class Lb extends SE {
  constructor(A) {
    ;(super(A),
      (this.isImageBitmapLoader = !0),
      typeof createImageBitmap > "u" &&
        console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."),
      typeof fetch > "u" && console.warn("THREE.ImageBitmapLoader: fetch() not supported."),
      (this.options = { premultiplyAlpha: "none" }))
  }
  setOptions(A) {
    return ((this.options = A), this)
  }
  load(A, I, g, C) {
    ;(A === void 0 && (A = ""),
      this.path !== void 0 && (A = this.path + A),
      (A = this.manager.resolveURL(A)))
    const i = this,
      B = gu.get(A)
    if (B !== void 0) {
      if ((i.manager.itemStart(A), B.then)) {
        B.then((s) => {
          ;(I && I(s), i.manager.itemEnd(A))
        }).catch((s) => {
          C && C(s)
        })
        return
      }
      return (
        setTimeout(function () {
          ;(I && I(B), i.manager.itemEnd(A))
        }, 0),
        B
      )
    }
    const o = {}
    ;((o.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include"),
      (o.headers = this.requestHeader))
    const r = fetch(A, o)
      .then(function (s) {
        return s.blob()
      })
      .then(function (s) {
        return createImageBitmap(s, Object.assign(i.options, { colorSpaceConversion: "none" }))
      })
      .then(function (s) {
        return (gu.add(A, s), I && I(s), i.manager.itemEnd(A), s)
      })
      .catch(function (s) {
        ;(C && C(s), gu.remove(A), i.manager.itemError(A), i.manager.itemEnd(A))
      })
    ;(gu.add(A, r), i.manager.itemStart(A))
  }
}
let hU
class Gv {
  static getContext() {
    return (hU === void 0 && (hU = new (window.AudioContext || window.webkitAudioContext)()), hU)
  }
  static setContext(A) {
    hU = A
  }
}
class wj extends SE {
  constructor(A) {
    super(A)
  }
  load(A, I, g, C) {
    const i = this,
      B = new Yr(this.manager)
    ;(B.setResponseType("arraybuffer"),
      B.setPath(this.path),
      B.setRequestHeader(this.requestHeader),
      B.setWithCredentials(this.withCredentials),
      B.load(
        A,
        function (r) {
          try {
            const s = r.slice(0)
            Gv.getContext()
              .decodeAudioData(s, function (S) {
                I(S)
              })
              .catch(o)
          } catch (s) {
            o(s)
          }
        },
        g,
        C,
      ))
    function o(r) {
      ;(C ? C(r) : console.error(r), i.manager.itemError(A))
    }
  }
}
const zH = /* @__PURE__ */ new RC(),
  XH = /* @__PURE__ */ new RC(),
  rf = /* @__PURE__ */ new RC()
class Gj {
  constructor() {
    ;((this.type = "StereoCamera"),
      (this.aspect = 1),
      (this.eyeSep = 0.064),
      (this.cameraL = new PQ()),
      this.cameraL.layers.enable(1),
      (this.cameraL.matrixAutoUpdate = !1),
      (this.cameraR = new PQ()),
      this.cameraR.layers.enable(2),
      (this.cameraR.matrixAutoUpdate = !1),
      (this._cache = {
        focus: null,
        fov: null,
        aspect: null,
        near: null,
        far: null,
        zoom: null,
        eyeSep: null,
      }))
  }
  update(A) {
    const I = this._cache
    if (
      I.focus !== A.focus ||
      I.fov !== A.fov ||
      I.aspect !== A.aspect * this.aspect ||
      I.near !== A.near ||
      I.far !== A.far ||
      I.zoom !== A.zoom ||
      I.eyeSep !== this.eyeSep
    ) {
      ;((I.focus = A.focus),
        (I.fov = A.fov),
        (I.aspect = A.aspect * this.aspect),
        (I.near = A.near),
        (I.far = A.far),
        (I.zoom = A.zoom),
        (I.eyeSep = this.eyeSep),
        rf.copy(A.projectionMatrix))
      const C = I.eyeSep / 2,
        i = (C * I.near) / I.focus,
        B = (I.near * Math.tan(Jf * I.fov * 0.5)) / I.zoom
      let o, r
      ;((XH.elements[12] = -C),
        (zH.elements[12] = C),
        (o = -B * I.aspect + i),
        (r = B * I.aspect + i),
        (rf.elements[0] = (2 * I.near) / (r - o)),
        (rf.elements[8] = (r + o) / (r - o)),
        this.cameraL.projectionMatrix.copy(rf),
        (o = -B * I.aspect - i),
        (r = B * I.aspect - i),
        (rf.elements[0] = (2 * I.near) / (r - o)),
        (rf.elements[8] = (r + o) / (r - o)),
        this.cameraR.projectionMatrix.copy(rf))
    }
    ;(this.cameraL.matrixWorld.copy(A.matrixWorld).multiply(XH),
      this.cameraR.matrixWorld.copy(A.matrixWorld).multiply(zH))
  }
}
class kv {
  constructor(A = !0) {
    ;((this.autoStart = A),
      (this.startTime = 0),
      (this.oldTime = 0),
      (this.elapsedTime = 0),
      (this.running = !1))
  }
  start() {
    ;((this.startTime = $H()),
      (this.oldTime = this.startTime),
      (this.elapsedTime = 0),
      (this.running = !0))
  }
  stop() {
    ;(this.getElapsedTime(), (this.running = !1), (this.autoStart = !1))
  }
  getElapsedTime() {
    return (this.getDelta(), this.elapsedTime)
  }
  getDelta() {
    let A = 0
    if (this.autoStart && !this.running) return (this.start(), 0)
    if (this.running) {
      const I = $H()
      ;((A = (I - this.oldTime) / 1e3), (this.oldTime = I), (this.elapsedTime += A))
    }
    return A
  }
}
function $H() {
  return performance.now()
}
const sf = /* @__PURE__ */ new wA(),
  AT = /* @__PURE__ */ new ho(),
  kj = /* @__PURE__ */ new wA(),
  lf = /* @__PURE__ */ new wA()
class Mj extends Ci {
  constructor() {
    ;(super(),
      (this.type = "AudioListener"),
      (this.context = Gv.getContext()),
      (this.gain = this.context.createGain()),
      this.gain.connect(this.context.destination),
      (this.filter = null),
      (this.timeDelta = 0),
      (this._clock = new kv()))
  }
  getInput() {
    return this.gain
  }
  removeFilter() {
    return (
      this.filter !== null &&
        (this.gain.disconnect(this.filter),
        this.filter.disconnect(this.context.destination),
        this.gain.connect(this.context.destination),
        (this.filter = null)),
      this
    )
  }
  getFilter() {
    return this.filter
  }
  setFilter(A) {
    return (
      this.filter !== null
        ? (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination))
        : this.gain.disconnect(this.context.destination),
      (this.filter = A),
      this.gain.connect(this.filter),
      this.filter.connect(this.context.destination),
      this
    )
  }
  getMasterVolume() {
    return this.gain.gain.value
  }
  setMasterVolume(A) {
    return (this.gain.gain.setTargetAtTime(A, this.context.currentTime, 0.01), this)
  }
  updateMatrixWorld(A) {
    super.updateMatrixWorld(A)
    const I = this.context.listener,
      g = this.up
    if (
      ((this.timeDelta = this._clock.getDelta()),
      this.matrixWorld.decompose(sf, AT, kj),
      lf.set(0, 0, -1).applyQuaternion(AT),
      I.positionX)
    ) {
      const C = this.context.currentTime + this.timeDelta
      ;(I.positionX.linearRampToValueAtTime(sf.x, C),
        I.positionY.linearRampToValueAtTime(sf.y, C),
        I.positionZ.linearRampToValueAtTime(sf.z, C),
        I.forwardX.linearRampToValueAtTime(lf.x, C),
        I.forwardY.linearRampToValueAtTime(lf.y, C),
        I.forwardZ.linearRampToValueAtTime(lf.z, C),
        I.upX.linearRampToValueAtTime(g.x, C),
        I.upY.linearRampToValueAtTime(g.y, C),
        I.upZ.linearRampToValueAtTime(g.z, C))
    } else (I.setPosition(sf.x, sf.y, sf.z), I.setOrientation(lf.x, lf.y, lf.z, g.x, g.y, g.z))
  }
}
class Yb extends Ci {
  constructor(A) {
    ;(super(),
      (this.type = "Audio"),
      (this.listener = A),
      (this.context = A.context),
      (this.gain = this.context.createGain()),
      this.gain.connect(A.getInput()),
      (this.autoplay = !1),
      (this.buffer = null),
      (this.detune = 0),
      (this.loop = !1),
      (this.loopStart = 0),
      (this.loopEnd = 0),
      (this.offset = 0),
      (this.duration = void 0),
      (this.playbackRate = 1),
      (this.isPlaying = !1),
      (this.hasPlaybackControl = !0),
      (this.source = null),
      (this.sourceType = "empty"),
      (this._startedAt = 0),
      (this._progress = 0),
      (this._connected = !1),
      (this.filters = []))
  }
  getOutput() {
    return this.gain
  }
  setNodeSource(A) {
    return (
      (this.hasPlaybackControl = !1),
      (this.sourceType = "audioNode"),
      (this.source = A),
      this.connect(),
      this
    )
  }
  setMediaElementSource(A) {
    return (
      (this.hasPlaybackControl = !1),
      (this.sourceType = "mediaNode"),
      (this.source = this.context.createMediaElementSource(A)),
      this.connect(),
      this
    )
  }
  setMediaStreamSource(A) {
    return (
      (this.hasPlaybackControl = !1),
      (this.sourceType = "mediaStreamNode"),
      (this.source = this.context.createMediaStreamSource(A)),
      this.connect(),
      this
    )
  }
  setBuffer(A) {
    return ((this.buffer = A), (this.sourceType = "buffer"), this.autoplay && this.play(), this)
  }
  play(A = 0) {
    if (this.isPlaying === !0) {
      console.warn("THREE.Audio: Audio is already playing.")
      return
    }
    if (this.hasPlaybackControl === !1) {
      console.warn("THREE.Audio: this Audio has no playback control.")
      return
    }
    this._startedAt = this.context.currentTime + A
    const I = this.context.createBufferSource()
    return (
      (I.buffer = this.buffer),
      (I.loop = this.loop),
      (I.loopStart = this.loopStart),
      (I.loopEnd = this.loopEnd),
      (I.onended = this.onEnded.bind(this)),
      I.start(this._startedAt, this._progress + this.offset, this.duration),
      (this.isPlaying = !0),
      (this.source = I),
      this.setDetune(this.detune),
      this.setPlaybackRate(this.playbackRate),
      this.connect()
    )
  }
  pause() {
    if (this.hasPlaybackControl === !1) {
      console.warn("THREE.Audio: this Audio has no playback control.")
      return
    }
    return (
      this.isPlaying === !0 &&
        ((this._progress +=
          Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate),
        this.loop === !0 &&
          (this._progress = this._progress % (this.duration || this.buffer.duration)),
        this.source.stop(),
        (this.source.onended = null),
        (this.isPlaying = !1)),
      this
    )
  }
  stop(A = 0) {
    if (this.hasPlaybackControl === !1) {
      console.warn("THREE.Audio: this Audio has no playback control.")
      return
    }
    return (
      (this._progress = 0),
      this.source !== null &&
        (this.source.stop(this.context.currentTime + A), (this.source.onended = null)),
      (this.isPlaying = !1),
      this
    )
  }
  connect() {
    if (this.filters.length > 0) {
      this.source.connect(this.filters[0])
      for (let A = 1, I = this.filters.length; A < I; A++)
        this.filters[A - 1].connect(this.filters[A])
      this.filters[this.filters.length - 1].connect(this.getOutput())
    } else this.source.connect(this.getOutput())
    return ((this._connected = !0), this)
  }
  disconnect() {
    if (this._connected !== !1) {
      if (this.filters.length > 0) {
        this.source.disconnect(this.filters[0])
        for (let A = 1, I = this.filters.length; A < I; A++)
          this.filters[A - 1].disconnect(this.filters[A])
        this.filters[this.filters.length - 1].disconnect(this.getOutput())
      } else this.source.disconnect(this.getOutput())
      return ((this._connected = !1), this)
    }
  }
  getFilters() {
    return this.filters
  }
  setFilters(A) {
    return (
      A || (A = []),
      this._connected === !0
        ? (this.disconnect(), (this.filters = A.slice()), this.connect())
        : (this.filters = A.slice()),
      this
    )
  }
  setDetune(A) {
    return (
      (this.detune = A),
      this.isPlaying === !0 &&
        this.source.detune !== void 0 &&
        this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01),
      this
    )
  }
  getDetune() {
    return this.detune
  }
  getFilter() {
    return this.getFilters()[0]
  }
  setFilter(A) {
    return this.setFilters(A ? [A] : [])
  }
  setPlaybackRate(A) {
    if (this.hasPlaybackControl === !1) {
      console.warn("THREE.Audio: this Audio has no playback control.")
      return
    }
    return (
      (this.playbackRate = A),
      this.isPlaying === !0 &&
        this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01),
      this
    )
  }
  getPlaybackRate() {
    return this.playbackRate
  }
  onEnded() {
    this.isPlaying = !1
  }
  getLoop() {
    return this.hasPlaybackControl === !1
      ? (console.warn("THREE.Audio: this Audio has no playback control."), !1)
      : this.loop
  }
  setLoop(A) {
    if (this.hasPlaybackControl === !1) {
      console.warn("THREE.Audio: this Audio has no playback control.")
      return
    }
    return ((this.loop = A), this.isPlaying === !0 && (this.source.loop = this.loop), this)
  }
  setLoopStart(A) {
    return ((this.loopStart = A), this)
  }
  setLoopEnd(A) {
    return ((this.loopEnd = A), this)
  }
  getVolume() {
    return this.gain.gain.value
  }
  setVolume(A) {
    return (this.gain.gain.setTargetAtTime(A, this.context.currentTime, 0.01), this)
  }
}
const cf = /* @__PURE__ */ new wA(),
  IT = /* @__PURE__ */ new ho(),
  Uj = /* @__PURE__ */ new wA(),
  hf = /* @__PURE__ */ new wA()
class Nj extends Yb {
  constructor(A) {
    ;(super(A),
      (this.panner = this.context.createPanner()),
      (this.panner.panningModel = "HRTF"),
      this.panner.connect(this.gain))
  }
  connect() {
    ;(super.connect(), this.panner.connect(this.gain))
  }
  disconnect() {
    ;(super.disconnect(), this.panner.disconnect(this.gain))
  }
  getOutput() {
    return this.panner
  }
  getRefDistance() {
    return this.panner.refDistance
  }
  setRefDistance(A) {
    return ((this.panner.refDistance = A), this)
  }
  getRolloffFactor() {
    return this.panner.rolloffFactor
  }
  setRolloffFactor(A) {
    return ((this.panner.rolloffFactor = A), this)
  }
  getDistanceModel() {
    return this.panner.distanceModel
  }
  setDistanceModel(A) {
    return ((this.panner.distanceModel = A), this)
  }
  getMaxDistance() {
    return this.panner.maxDistance
  }
  setMaxDistance(A) {
    return ((this.panner.maxDistance = A), this)
  }
  setDirectionalCone(A, I, g) {
    return (
      (this.panner.coneInnerAngle = A),
      (this.panner.coneOuterAngle = I),
      (this.panner.coneOuterGain = g),
      this
    )
  }
  updateMatrixWorld(A) {
    if ((super.updateMatrixWorld(A), this.hasPlaybackControl === !0 && this.isPlaying === !1))
      return
    ;(this.matrixWorld.decompose(cf, IT, Uj), hf.set(0, 0, 1).applyQuaternion(IT))
    const I = this.panner
    if (I.positionX) {
      const g = this.context.currentTime + this.listener.timeDelta
      ;(I.positionX.linearRampToValueAtTime(cf.x, g),
        I.positionY.linearRampToValueAtTime(cf.y, g),
        I.positionZ.linearRampToValueAtTime(cf.z, g),
        I.orientationX.linearRampToValueAtTime(hf.x, g),
        I.orientationY.linearRampToValueAtTime(hf.y, g),
        I.orientationZ.linearRampToValueAtTime(hf.z, g))
    } else (I.setPosition(cf.x, cf.y, cf.z), I.setOrientation(hf.x, hf.y, hf.z))
  }
}
class Fj {
  constructor(A, I = 2048) {
    ;((this.analyser = A.context.createAnalyser()),
      (this.analyser.fftSize = I),
      (this.data = new Uint8Array(this.analyser.frequencyBinCount)),
      A.getOutput().connect(this.analyser))
  }
  getFrequencyData() {
    return (this.analyser.getByteFrequencyData(this.data), this.data)
  }
  getAverageFrequency() {
    let A = 0
    const I = this.getFrequencyData()
    for (let g = 0; g < I.length; g++) A += I[g]
    return A / I.length
  }
}
class qb {
  constructor(A, I, g) {
    ;((this.binding = A), (this.valueSize = g))
    let C, i, B
    switch (I) {
      case "quaternion":
        ;((C = this._slerp),
          (i = this._slerpAdditive),
          (B = this._setAdditiveIdentityQuaternion),
          (this.buffer = new Float64Array(g * 6)),
          (this._workIndex = 5))
        break
      case "string":
      case "bool":
        ;((C = this._select),
          (i = this._select),
          (B = this._setAdditiveIdentityOther),
          (this.buffer = new Array(g * 5)))
        break
      default:
        ;((C = this._lerp),
          (i = this._lerpAdditive),
          (B = this._setAdditiveIdentityNumeric),
          (this.buffer = new Float64Array(g * 5)))
    }
    ;((this._mixBufferRegion = C),
      (this._mixBufferRegionAdditive = i),
      (this._setIdentity = B),
      (this._origIndex = 3),
      (this._addIndex = 4),
      (this.cumulativeWeight = 0),
      (this.cumulativeWeightAdditive = 0),
      (this.useCount = 0),
      (this.referenceCount = 0))
  }
  // accumulate data in the 'incoming' region into 'accu<i>'
  accumulate(A, I) {
    const g = this.buffer,
      C = this.valueSize,
      i = A * C + C
    let B = this.cumulativeWeight
    if (B === 0) {
      for (let o = 0; o !== C; ++o) g[i + o] = g[o]
      B = I
    } else {
      B += I
      const o = I / B
      this._mixBufferRegion(g, i, 0, o, C)
    }
    this.cumulativeWeight = B
  }
  // accumulate data in the 'incoming' region into 'add'
  accumulateAdditive(A) {
    const I = this.buffer,
      g = this.valueSize,
      C = g * this._addIndex
    ;(this.cumulativeWeightAdditive === 0 && this._setIdentity(),
      this._mixBufferRegionAdditive(I, C, 0, A, g),
      (this.cumulativeWeightAdditive += A))
  }
  // apply the state of 'accu<i>' to the binding when accus differ
  apply(A) {
    const I = this.valueSize,
      g = this.buffer,
      C = A * I + I,
      i = this.cumulativeWeight,
      B = this.cumulativeWeightAdditive,
      o = this.binding
    if (((this.cumulativeWeight = 0), (this.cumulativeWeightAdditive = 0), i < 1)) {
      const r = I * this._origIndex
      this._mixBufferRegion(g, C, r, 1 - i, I)
    }
    B > 0 && this._mixBufferRegionAdditive(g, C, this._addIndex * I, 1, I)
    for (let r = I, s = I + I; r !== s; ++r)
      if (g[r] !== g[r + I]) {
        o.setValue(g, C)
        break
      }
  }
  // remember the state of the bound property and copy it to both accus
  saveOriginalState() {
    const A = this.binding,
      I = this.buffer,
      g = this.valueSize,
      C = g * this._origIndex
    A.getValue(I, C)
    for (let i = g, B = C; i !== B; ++i) I[i] = I[C + (i % g)]
    ;(this._setIdentity(), (this.cumulativeWeight = 0), (this.cumulativeWeightAdditive = 0))
  }
  // apply the state previously taken via 'saveOriginalState' to the binding
  restoreOriginalState() {
    const A = this.valueSize * 3
    this.binding.setValue(this.buffer, A)
  }
  _setAdditiveIdentityNumeric() {
    const A = this._addIndex * this.valueSize,
      I = A + this.valueSize
    for (let g = A; g < I; g++) this.buffer[g] = 0
  }
  _setAdditiveIdentityQuaternion() {
    ;(this._setAdditiveIdentityNumeric(), (this.buffer[this._addIndex * this.valueSize + 3] = 1))
  }
  _setAdditiveIdentityOther() {
    const A = this._origIndex * this.valueSize,
      I = this._addIndex * this.valueSize
    for (let g = 0; g < this.valueSize; g++) this.buffer[I + g] = this.buffer[A + g]
  }
  // mix functions
  _select(A, I, g, C, i) {
    if (C >= 0.5) for (let B = 0; B !== i; ++B) A[I + B] = A[g + B]
  }
  _slerp(A, I, g, C) {
    ho.slerpFlat(A, I, A, I, A, g, C)
  }
  _slerpAdditive(A, I, g, C, i) {
    const B = this._workIndex * i
    ;(ho.multiplyQuaternionsFlat(A, B, A, I, A, g), ho.slerpFlat(A, I, A, I, A, B, C))
  }
  _lerp(A, I, g, C, i) {
    const B = 1 - C
    for (let o = 0; o !== i; ++o) {
      const r = I + o
      A[r] = A[r] * B + A[g + o] * C
    }
  }
  _lerpAdditive(A, I, g, C, i) {
    for (let B = 0; B !== i; ++B) {
      const o = I + B
      A[o] = A[o] + A[g + B] * C
    }
  }
}
const Mv = "\\[\\]\\.:\\/",
  Rj = new RegExp("[" + Mv + "]", "g"),
  Uv = "[^" + Mv + "]",
  Jj = "[^" + Mv.replace("\\.", "") + "]",
  Kj = /* @__PURE__ */ /((?:WC+[\/:])*)/.source.replace("WC", Uv),
  mj = /* @__PURE__ */ /(WCOD+)?/.source.replace("WCOD", Jj),
  vj = /* @__PURE__ */ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", Uv),
  Lj = /* @__PURE__ */ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", Uv),
  Yj = new RegExp("^" + Kj + mj + vj + Lj + "$"),
  qj = ["material", "materials", "bones", "map"]
class Hj {
  constructor(A, I, g) {
    const C = g || Di.parseTrackName(I)
    ;((this._targetGroup = A), (this._bindings = A.subscribe_(I, C)))
  }
  getValue(A, I) {
    this.bind()
    const g = this._targetGroup.nCachedObjects_,
      C = this._bindings[g]
    C !== void 0 && C.getValue(A, I)
  }
  setValue(A, I) {
    const g = this._bindings
    for (let C = this._targetGroup.nCachedObjects_, i = g.length; C !== i; ++C) g[C].setValue(A, I)
  }
  bind() {
    const A = this._bindings
    for (let I = this._targetGroup.nCachedObjects_, g = A.length; I !== g; ++I) A[I].bind()
  }
  unbind() {
    const A = this._bindings
    for (let I = this._targetGroup.nCachedObjects_, g = A.length; I !== g; ++I) A[I].unbind()
  }
}
class Di {
  constructor(A, I, g) {
    ;((this.path = I),
      (this.parsedPath = g || Di.parseTrackName(I)),
      (this.node = Di.findNode(A, this.parsedPath.nodeName)),
      (this.rootNode = A),
      (this.getValue = this._getValue_unbound),
      (this.setValue = this._setValue_unbound))
  }
  static create(A, I, g) {
    return A && A.isAnimationObjectGroup ? new Di.Composite(A, I, g) : new Di(A, I, g)
  }
  /**
   * Replaces spaces with underscores and removes unsupported characters from
   * node names, to ensure compatibility with parseTrackName().
   *
   * @param {string} name Node name to be sanitized.
   * @return {string}
   */
  static sanitizeNodeName(A) {
    return A.replace(/\s/g, "_").replace(Rj, "")
  }
  static parseTrackName(A) {
    const I = Yj.exec(A)
    if (I === null) throw new Error("PropertyBinding: Cannot parse trackName: " + A)
    const g = {
        // directoryName: matches[ 1 ], // (tschw) currently unused
        nodeName: I[2],
        objectName: I[3],
        objectIndex: I[4],
        propertyName: I[5],
        // required
        propertyIndex: I[6],
      },
      C = g.nodeName && g.nodeName.lastIndexOf(".")
    if (C !== void 0 && C !== -1) {
      const i = g.nodeName.substring(C + 1)
      qj.indexOf(i) !== -1 && ((g.nodeName = g.nodeName.substring(0, C)), (g.objectName = i))
    }
    if (g.propertyName === null || g.propertyName.length === 0)
      throw new Error("PropertyBinding: can not parse propertyName from trackName: " + A)
    return g
  }
  static findNode(A, I) {
    if (I === void 0 || I === "" || I === "." || I === -1 || I === A.name || I === A.uuid) return A
    if (A.skeleton) {
      const g = A.skeleton.getBoneByName(I)
      if (g !== void 0) return g
    }
    if (A.children) {
      const g = function (i) {
          for (let B = 0; B < i.length; B++) {
            const o = i[B]
            if (o.name === I || o.uuid === I) return o
            const r = g(o.children)
            if (r) return r
          }
          return null
        },
        C = g(A.children)
      if (C) return C
    }
    return null
  }
  // these are used to "bind" a nonexistent property
  _getValue_unavailable() {}
  _setValue_unavailable() {}
  // Getters
  _getValue_direct(A, I) {
    A[I] = this.targetObject[this.propertyName]
  }
  _getValue_array(A, I) {
    const g = this.resolvedProperty
    for (let C = 0, i = g.length; C !== i; ++C) A[I++] = g[C]
  }
  _getValue_arrayElement(A, I) {
    A[I] = this.resolvedProperty[this.propertyIndex]
  }
  _getValue_toArray(A, I) {
    this.resolvedProperty.toArray(A, I)
  }
  // Direct
  _setValue_direct(A, I) {
    this.targetObject[this.propertyName] = A[I]
  }
  _setValue_direct_setNeedsUpdate(A, I) {
    ;((this.targetObject[this.propertyName] = A[I]), (this.targetObject.needsUpdate = !0))
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(A, I) {
    ;((this.targetObject[this.propertyName] = A[I]),
      (this.targetObject.matrixWorldNeedsUpdate = !0))
  }
  // EntireArray
  _setValue_array(A, I) {
    const g = this.resolvedProperty
    for (let C = 0, i = g.length; C !== i; ++C) g[C] = A[I++]
  }
  _setValue_array_setNeedsUpdate(A, I) {
    const g = this.resolvedProperty
    for (let C = 0, i = g.length; C !== i; ++C) g[C] = A[I++]
    this.targetObject.needsUpdate = !0
  }
  _setValue_array_setMatrixWorldNeedsUpdate(A, I) {
    const g = this.resolvedProperty
    for (let C = 0, i = g.length; C !== i; ++C) g[C] = A[I++]
    this.targetObject.matrixWorldNeedsUpdate = !0
  }
  // ArrayElement
  _setValue_arrayElement(A, I) {
    this.resolvedProperty[this.propertyIndex] = A[I]
  }
  _setValue_arrayElement_setNeedsUpdate(A, I) {
    ;((this.resolvedProperty[this.propertyIndex] = A[I]), (this.targetObject.needsUpdate = !0))
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(A, I) {
    ;((this.resolvedProperty[this.propertyIndex] = A[I]),
      (this.targetObject.matrixWorldNeedsUpdate = !0))
  }
  // HasToFromArray
  _setValue_fromArray(A, I) {
    this.resolvedProperty.fromArray(A, I)
  }
  _setValue_fromArray_setNeedsUpdate(A, I) {
    ;(this.resolvedProperty.fromArray(A, I), (this.targetObject.needsUpdate = !0))
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(A, I) {
    ;(this.resolvedProperty.fromArray(A, I), (this.targetObject.matrixWorldNeedsUpdate = !0))
  }
  _getValue_unbound(A, I) {
    ;(this.bind(), this.getValue(A, I))
  }
  _setValue_unbound(A, I) {
    ;(this.bind(), this.setValue(A, I))
  }
  // create getter / setter pair for a property in the scene graph
  bind() {
    let A = this.node
    const I = this.parsedPath,
      g = I.objectName,
      C = I.propertyName
    let i = I.propertyIndex
    if (
      (A || ((A = Di.findNode(this.rootNode, I.nodeName)), (this.node = A)),
      (this.getValue = this._getValue_unavailable),
      (this.setValue = this._setValue_unavailable),
      !A)
    ) {
      console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".")
      return
    }
    if (g) {
      let s = I.objectIndex
      switch (g) {
        case "materials":
          if (!A.material) {
            console.error(
              "THREE.PropertyBinding: Can not bind to material as node does not have a material.",
              this,
            )
            return
          }
          if (!A.material.materials) {
            console.error(
              "THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.",
              this,
            )
            return
          }
          A = A.material.materials
          break
        case "bones":
          if (!A.skeleton) {
            console.error(
              "THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.",
              this,
            )
            return
          }
          A = A.skeleton.bones
          for (let h = 0; h < A.length; h++)
            if (A[h].name === s) {
              s = h
              break
            }
          break
        case "map":
          if ("map" in A) {
            A = A.map
            break
          }
          if (!A.material) {
            console.error(
              "THREE.PropertyBinding: Can not bind to material as node does not have a material.",
              this,
            )
            return
          }
          if (!A.material.map) {
            console.error(
              "THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.",
              this,
            )
            return
          }
          A = A.material.map
          break
        default:
          if (A[g] === void 0) {
            console.error(
              "THREE.PropertyBinding: Can not bind to objectName of node undefined.",
              this,
            )
            return
          }
          A = A[g]
      }
      if (s !== void 0) {
        if (A[s] === void 0) {
          console.error(
            "THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.",
            this,
            A,
          )
          return
        }
        A = A[s]
      }
    }
    const B = A[C]
    if (B === void 0) {
      const s = I.nodeName
      console.error(
        "THREE.PropertyBinding: Trying to update property for track: " +
          s +
          "." +
          C +
          " but it wasn't found.",
        A,
      )
      return
    }
    let o = this.Versioning.None
    ;((this.targetObject = A),
      A.needsUpdate !== void 0
        ? (o = this.Versioning.NeedsUpdate)
        : A.matrixWorldNeedsUpdate !== void 0 && (o = this.Versioning.MatrixWorldNeedsUpdate))
    let r = this.BindingType.Direct
    if (i !== void 0) {
      if (C === "morphTargetInfluences") {
        if (!A.geometry) {
          console.error(
            "THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.",
            this,
          )
          return
        }
        if (!A.geometry.morphAttributes) {
          console.error(
            "THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.",
            this,
          )
          return
        }
        A.morphTargetDictionary[i] !== void 0 && (i = A.morphTargetDictionary[i])
      }
      ;((r = this.BindingType.ArrayElement), (this.resolvedProperty = B), (this.propertyIndex = i))
    } else
      B.fromArray !== void 0 && B.toArray !== void 0
        ? ((r = this.BindingType.HasFromToArray), (this.resolvedProperty = B))
        : Array.isArray(B)
          ? ((r = this.BindingType.EntireArray), (this.resolvedProperty = B))
          : (this.propertyName = C)
    ;((this.getValue = this.GetterByBindingType[r]),
      (this.setValue = this.SetterByBindingTypeAndVersioning[r][o]))
  }
  unbind() {
    ;((this.node = null),
      (this.getValue = this._getValue_unbound),
      (this.setValue = this._setValue_unbound))
  }
}
Di.Composite = Hj
Di.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3,
}
Di.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2,
}
Di.prototype.GetterByBindingType = [
  Di.prototype._getValue_direct,
  Di.prototype._getValue_array,
  Di.prototype._getValue_arrayElement,
  Di.prototype._getValue_toArray,
]
Di.prototype.SetterByBindingTypeAndVersioning = [
  [
    // Direct
    Di.prototype._setValue_direct,
    Di.prototype._setValue_direct_setNeedsUpdate,
    Di.prototype._setValue_direct_setMatrixWorldNeedsUpdate,
  ],
  [
    // EntireArray
    Di.prototype._setValue_array,
    Di.prototype._setValue_array_setNeedsUpdate,
    Di.prototype._setValue_array_setMatrixWorldNeedsUpdate,
  ],
  [
    // ArrayElement
    Di.prototype._setValue_arrayElement,
    Di.prototype._setValue_arrayElement_setNeedsUpdate,
    Di.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate,
  ],
  [
    // HasToFromArray
    Di.prototype._setValue_fromArray,
    Di.prototype._setValue_fromArray_setNeedsUpdate,
    Di.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate,
  ],
]
class Tj {
  constructor() {
    ;((this.isAnimationObjectGroup = !0),
      (this.uuid = Lr()),
      (this._objects = Array.prototype.slice.call(arguments)),
      (this.nCachedObjects_ = 0))
    const A = {}
    this._indicesByUUID = A
    for (let g = 0, C = arguments.length; g !== C; ++g) A[arguments[g].uuid] = g
    ;((this._paths = []),
      (this._parsedPaths = []),
      (this._bindings = []),
      (this._bindingsIndicesByPath = {}))
    const I = this
    this.stats = {
      objects: {
        get total() {
          return I._objects.length
        },
        get inUse() {
          return this.total - I.nCachedObjects_
        },
      },
      get bindingsPerObject() {
        return I._bindings.length
      },
    }
  }
  add() {
    const A = this._objects,
      I = this._indicesByUUID,
      g = this._paths,
      C = this._parsedPaths,
      i = this._bindings,
      B = i.length
    let o,
      r = A.length,
      s = this.nCachedObjects_
    for (let h = 0, S = arguments.length; h !== S; ++h) {
      const d = arguments[h],
        w = d.uuid
      let M = I[w]
      if (M === void 0) {
        ;((M = r++), (I[w] = M), A.push(d))
        for (let K = 0, R = B; K !== R; ++K) i[K].push(new Di(d, g[K], C[K]))
      } else if (M < s) {
        o = A[M]
        const K = --s,
          R = A[K]
        ;((I[R.uuid] = M), (A[M] = R), (I[w] = K), (A[K] = d))
        for (let F = 0, L = B; F !== L; ++F) {
          const Y = i[F],
            H = Y[K]
          let V = Y[M]
          ;((Y[M] = H), V === void 0 && (V = new Di(d, g[F], C[F])), (Y[K] = V))
        }
      } else
        A[M] !== o &&
          console.error(
            "THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.",
          )
    }
    this.nCachedObjects_ = s
  }
  remove() {
    const A = this._objects,
      I = this._indicesByUUID,
      g = this._bindings,
      C = g.length
    let i = this.nCachedObjects_
    for (let B = 0, o = arguments.length; B !== o; ++B) {
      const r = arguments[B],
        s = r.uuid,
        h = I[s]
      if (h !== void 0 && h >= i) {
        const S = i++,
          d = A[S]
        ;((I[d.uuid] = h), (A[h] = d), (I[s] = S), (A[S] = r))
        for (let w = 0, M = C; w !== M; ++w) {
          const K = g[w],
            R = K[S],
            F = K[h]
          ;((K[h] = R), (K[S] = F))
        }
      }
    }
    this.nCachedObjects_ = i
  }
  // remove & forget
  uncache() {
    const A = this._objects,
      I = this._indicesByUUID,
      g = this._bindings,
      C = g.length
    let i = this.nCachedObjects_,
      B = A.length
    for (let o = 0, r = arguments.length; o !== r; ++o) {
      const s = arguments[o],
        h = s.uuid,
        S = I[h]
      if (S !== void 0)
        if ((delete I[h], S < i)) {
          const d = --i,
            w = A[d],
            M = --B,
            K = A[M]
          ;((I[w.uuid] = S), (A[S] = w), (I[K.uuid] = d), (A[d] = K), A.pop())
          for (let R = 0, F = C; R !== F; ++R) {
            const L = g[R],
              Y = L[d],
              H = L[M]
            ;((L[S] = Y), (L[d] = H), L.pop())
          }
        } else {
          const d = --B,
            w = A[d]
          ;(d > 0 && (I[w.uuid] = S), (A[S] = w), A.pop())
          for (let M = 0, K = C; M !== K; ++M) {
            const R = g[M]
            ;((R[S] = R[d]), R.pop())
          }
        }
    }
    this.nCachedObjects_ = i
  }
  // Internal interface used by befriended PropertyBinding.Composite:
  subscribe_(A, I) {
    const g = this._bindingsIndicesByPath
    let C = g[A]
    const i = this._bindings
    if (C !== void 0) return i[C]
    const B = this._paths,
      o = this._parsedPaths,
      r = this._objects,
      s = r.length,
      h = this.nCachedObjects_,
      S = new Array(s)
    ;((C = i.length), (g[A] = C), B.push(A), o.push(I), i.push(S))
    for (let d = h, w = r.length; d !== w; ++d) {
      const M = r[d]
      S[d] = new Di(M, A, I)
    }
    return S
  }
  unsubscribe_(A) {
    const I = this._bindingsIndicesByPath,
      g = I[A]
    if (g !== void 0) {
      const C = this._paths,
        i = this._parsedPaths,
        B = this._bindings,
        o = B.length - 1,
        r = B[o],
        s = A[o]
      ;((I[s] = g), (B[g] = r), B.pop(), (i[g] = i[o]), i.pop(), (C[g] = C[o]), C.pop())
    }
  }
}
class Hb {
  constructor(A, I, g = null, C = I.blendMode) {
    ;((this._mixer = A), (this._clip = I), (this._localRoot = g), (this.blendMode = C))
    const i = I.tracks,
      B = i.length,
      o = new Array(B),
      r = {
        endingStart: wf,
        endingEnd: wf,
      }
    for (let s = 0; s !== B; ++s) {
      const h = i[s].createInterpolant(null)
      ;((o[s] = h), (h.settings = r))
    }
    ;((this._interpolantSettings = r),
      (this._interpolants = o),
      (this._propertyBindings = new Array(B)),
      (this._cacheIndex = null),
      (this._byClipCacheIndex = null),
      (this._timeScaleInterpolant = null),
      (this._weightInterpolant = null),
      (this.loop = U2),
      (this._loopCount = -1),
      (this._startTime = null),
      (this.time = 0),
      (this.timeScale = 1),
      (this._effectiveTimeScale = 1),
      (this.weight = 1),
      (this._effectiveWeight = 1),
      (this.repetitions = 1 / 0),
      (this.paused = !1),
      (this.enabled = !0),
      (this.clampWhenFinished = !1),
      (this.zeroSlopeAtStart = !0),
      (this.zeroSlopeAtEnd = !0))
  }
  // State & Scheduling
  play() {
    return (this._mixer._activateAction(this), this)
  }
  stop() {
    return (this._mixer._deactivateAction(this), this.reset())
  }
  reset() {
    return (
      (this.paused = !1),
      (this.enabled = !0),
      (this.time = 0),
      (this._loopCount = -1),
      (this._startTime = null),
      this.stopFading().stopWarping()
    )
  }
  isRunning() {
    return (
      this.enabled &&
      !this.paused &&
      this.timeScale !== 0 &&
      this._startTime === null &&
      this._mixer._isActiveAction(this)
    )
  }
  // return true when play has been called
  isScheduled() {
    return this._mixer._isActiveAction(this)
  }
  startAt(A) {
    return ((this._startTime = A), this)
  }
  setLoop(A, I) {
    return ((this.loop = A), (this.repetitions = I), this)
  }
  // Weight
  // set the weight stopping any scheduled fading
  // although .enabled = false yields an effective weight of zero, this
  // method does *not* change .enabled, because it would be confusing
  setEffectiveWeight(A) {
    return ((this.weight = A), (this._effectiveWeight = this.enabled ? A : 0), this.stopFading())
  }
  // return the weight considering fading and .enabled
  getEffectiveWeight() {
    return this._effectiveWeight
  }
  fadeIn(A) {
    return this._scheduleFading(A, 0, 1)
  }
  fadeOut(A) {
    return this._scheduleFading(A, 1, 0)
  }
  crossFadeFrom(A, I, g) {
    if ((A.fadeOut(I), this.fadeIn(I), g)) {
      const C = this._clip.duration,
        i = A._clip.duration,
        B = i / C,
        o = C / i
      ;(A.warp(1, B, I), this.warp(o, 1, I))
    }
    return this
  }
  crossFadeTo(A, I, g) {
    return A.crossFadeFrom(this, I, g)
  }
  stopFading() {
    const A = this._weightInterpolant
    return (
      A !== null && ((this._weightInterpolant = null), this._mixer._takeBackControlInterpolant(A)),
      this
    )
  }
  // Time Scale Control
  // set the time scale stopping any scheduled warping
  // although .paused = true yields an effective time scale of zero, this
  // method does *not* change .paused, because it would be confusing
  setEffectiveTimeScale(A) {
    return (
      (this.timeScale = A),
      (this._effectiveTimeScale = this.paused ? 0 : A),
      this.stopWarping()
    )
  }
  // return the time scale considering warping and .paused
  getEffectiveTimeScale() {
    return this._effectiveTimeScale
  }
  setDuration(A) {
    return ((this.timeScale = this._clip.duration / A), this.stopWarping())
  }
  syncWith(A) {
    return ((this.time = A.time), (this.timeScale = A.timeScale), this.stopWarping())
  }
  halt(A) {
    return this.warp(this._effectiveTimeScale, 0, A)
  }
  warp(A, I, g) {
    const C = this._mixer,
      i = C.time,
      B = this.timeScale
    let o = this._timeScaleInterpolant
    o === null && ((o = C._lendControlInterpolant()), (this._timeScaleInterpolant = o))
    const r = o.parameterPositions,
      s = o.sampleValues
    return ((r[0] = i), (r[1] = i + g), (s[0] = A / B), (s[1] = I / B), this)
  }
  stopWarping() {
    const A = this._timeScaleInterpolant
    return (
      A !== null &&
        ((this._timeScaleInterpolant = null), this._mixer._takeBackControlInterpolant(A)),
      this
    )
  }
  // Object Accessors
  getMixer() {
    return this._mixer
  }
  getClip() {
    return this._clip
  }
  getRoot() {
    return this._localRoot || this._mixer._root
  }
  // Interna
  _update(A, I, g, C) {
    if (!this.enabled) {
      this._updateWeight(A)
      return
    }
    const i = this._startTime
    if (i !== null) {
      const r = (A - i) * g
      r < 0 || g === 0 ? (I = 0) : ((this._startTime = null), (I = g * r))
    }
    I *= this._updateTimeScale(A)
    const B = this._updateTime(I),
      o = this._updateWeight(A)
    if (o > 0) {
      const r = this._interpolants,
        s = this._propertyBindings
      switch (this.blendMode) {
        case jm:
          for (let h = 0, S = r.length; h !== S; ++h) (r[h].evaluate(B), s[h].accumulateAdditive(o))
          break
        case zN:
        default:
          for (let h = 0, S = r.length; h !== S; ++h) (r[h].evaluate(B), s[h].accumulate(C, o))
      }
    }
  }
  _updateWeight(A) {
    let I = 0
    if (this.enabled) {
      I = this.weight
      const g = this._weightInterpolant
      if (g !== null) {
        const C = g.evaluate(A)[0]
        ;((I *= C),
          A > g.parameterPositions[1] && (this.stopFading(), C === 0 && (this.enabled = !1)))
      }
    }
    return ((this._effectiveWeight = I), I)
  }
  _updateTimeScale(A) {
    let I = 0
    if (!this.paused) {
      I = this.timeScale
      const g = this._timeScaleInterpolant
      if (g !== null) {
        const C = g.evaluate(A)[0]
        ;((I *= C),
          A > g.parameterPositions[1] &&
            (this.stopWarping(), I === 0 ? (this.paused = !0) : (this.timeScale = I)))
      }
    }
    return ((this._effectiveTimeScale = I), I)
  }
  _updateTime(A) {
    const I = this._clip.duration,
      g = this.loop
    let C = this.time + A,
      i = this._loopCount
    const B = g === N2
    if (A === 0) return i === -1 ? C : B && (i & 1) === 1 ? I - C : C
    if (g === M2) {
      i === -1 && ((this._loopCount = 0), this._setEndings(!0, !0, !1))
      A: {
        if (C >= I) C = I
        else if (C < 0) C = 0
        else {
          this.time = C
          break A
        }
        ;(this.clampWhenFinished ? (this.paused = !0) : (this.enabled = !1),
          (this.time = C),
          this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: A < 0 ? -1 : 1,
          }))
      }
    } else {
      if (
        (i === -1 &&
          (A >= 0
            ? ((i = 0), this._setEndings(!0, this.repetitions === 0, B))
            : this._setEndings(this.repetitions === 0, !0, B)),
        C >= I || C < 0)
      ) {
        const o = Math.floor(C / I)
        ;((C -= I * o), (i += Math.abs(o)))
        const r = this.repetitions - i
        if (r <= 0)
          (this.clampWhenFinished ? (this.paused = !0) : (this.enabled = !1),
            (C = A > 0 ? I : 0),
            (this.time = C),
            this._mixer.dispatchEvent({
              type: "finished",
              action: this,
              direction: A > 0 ? 1 : -1,
            }))
        else {
          if (r === 1) {
            const s = A < 0
            this._setEndings(s, !s, B)
          } else this._setEndings(!1, !1, B)
          ;((this._loopCount = i),
            (this.time = C),
            this._mixer.dispatchEvent({
              type: "loop",
              action: this,
              loopDelta: o,
            }))
        }
      } else this.time = C
      if (B && (i & 1) === 1) return I - C
    }
    return C
  }
  _setEndings(A, I, g) {
    const C = this._interpolantSettings
    g
      ? ((C.endingStart = Gf), (C.endingEnd = Gf))
      : (A ? (C.endingStart = this.zeroSlopeAtStart ? Gf : wf) : (C.endingStart = aG),
        I ? (C.endingEnd = this.zeroSlopeAtEnd ? Gf : wf) : (C.endingEnd = aG))
  }
  _scheduleFading(A, I, g) {
    const C = this._mixer,
      i = C.time
    let B = this._weightInterpolant
    B === null && ((B = C._lendControlInterpolant()), (this._weightInterpolant = B))
    const o = B.parameterPositions,
      r = B.sampleValues
    return ((o[0] = i), (r[0] = I), (o[1] = i + A), (r[1] = g), this)
  }
}
const xj = new Float32Array(1)
class bj extends qr {
  constructor(A) {
    ;(super(),
      (this._root = A),
      this._initMemoryManager(),
      (this._accuIndex = 0),
      (this.time = 0),
      (this.timeScale = 1))
  }
  _bindAction(A, I) {
    const g = A._localRoot || this._root,
      C = A._clip.tracks,
      i = C.length,
      B = A._propertyBindings,
      o = A._interpolants,
      r = g.uuid,
      s = this._bindingsByRootAndName
    let h = s[r]
    h === void 0 && ((h = {}), (s[r] = h))
    for (let S = 0; S !== i; ++S) {
      const d = C[S],
        w = d.name
      let M = h[w]
      if (M !== void 0) (++M.referenceCount, (B[S] = M))
      else {
        if (((M = B[S]), M !== void 0)) {
          M._cacheIndex === null && (++M.referenceCount, this._addInactiveBinding(M, r, w))
          continue
        }
        const K = I && I._propertyBindings[S].binding.parsedPath
        ;((M = new qb(Di.create(g, w, K), d.ValueTypeName, d.getValueSize())),
          ++M.referenceCount,
          this._addInactiveBinding(M, r, w),
          (B[S] = M))
      }
      o[S].resultBuffer = M.buffer
    }
  }
  _activateAction(A) {
    if (!this._isActiveAction(A)) {
      if (A._cacheIndex === null) {
        const g = (A._localRoot || this._root).uuid,
          C = A._clip.uuid,
          i = this._actionsByClip[C]
        ;(this._bindAction(A, i && i.knownActions[0]), this._addInactiveAction(A, C, g))
      }
      const I = A._propertyBindings
      for (let g = 0, C = I.length; g !== C; ++g) {
        const i = I[g]
        i.useCount++ === 0 && (this._lendBinding(i), i.saveOriginalState())
      }
      this._lendAction(A)
    }
  }
  _deactivateAction(A) {
    if (this._isActiveAction(A)) {
      const I = A._propertyBindings
      for (let g = 0, C = I.length; g !== C; ++g) {
        const i = I[g]
        --i.useCount === 0 && (i.restoreOriginalState(), this._takeBackBinding(i))
      }
      this._takeBackAction(A)
    }
  }
  // Memory manager
  _initMemoryManager() {
    ;((this._actions = []),
      (this._nActiveActions = 0),
      (this._actionsByClip = {}),
      (this._bindings = []),
      (this._nActiveBindings = 0),
      (this._bindingsByRootAndName = {}),
      (this._controlInterpolants = []),
      (this._nActiveControlInterpolants = 0))
    const A = this
    this.stats = {
      actions: {
        get total() {
          return A._actions.length
        },
        get inUse() {
          return A._nActiveActions
        },
      },
      bindings: {
        get total() {
          return A._bindings.length
        },
        get inUse() {
          return A._nActiveBindings
        },
      },
      controlInterpolants: {
        get total() {
          return A._controlInterpolants.length
        },
        get inUse() {
          return A._nActiveControlInterpolants
        },
      },
    }
  }
  // Memory management for AnimationAction objects
  _isActiveAction(A) {
    const I = A._cacheIndex
    return I !== null && I < this._nActiveActions
  }
  _addInactiveAction(A, I, g) {
    const C = this._actions,
      i = this._actionsByClip
    let B = i[I]
    if (B === void 0)
      ((B = {
        knownActions: [A],
        actionByRoot: {},
      }),
        (A._byClipCacheIndex = 0),
        (i[I] = B))
    else {
      const o = B.knownActions
      ;((A._byClipCacheIndex = o.length), o.push(A))
    }
    ;((A._cacheIndex = C.length), C.push(A), (B.actionByRoot[g] = A))
  }
  _removeInactiveAction(A) {
    const I = this._actions,
      g = I[I.length - 1],
      C = A._cacheIndex
    ;((g._cacheIndex = C), (I[C] = g), I.pop(), (A._cacheIndex = null))
    const i = A._clip.uuid,
      B = this._actionsByClip,
      o = B[i],
      r = o.knownActions,
      s = r[r.length - 1],
      h = A._byClipCacheIndex
    ;((s._byClipCacheIndex = h), (r[h] = s), r.pop(), (A._byClipCacheIndex = null))
    const S = o.actionByRoot,
      d = (A._localRoot || this._root).uuid
    ;(delete S[d], r.length === 0 && delete B[i], this._removeInactiveBindingsForAction(A))
  }
  _removeInactiveBindingsForAction(A) {
    const I = A._propertyBindings
    for (let g = 0, C = I.length; g !== C; ++g) {
      const i = I[g]
      --i.referenceCount === 0 && this._removeInactiveBinding(i)
    }
  }
  _lendAction(A) {
    const I = this._actions,
      g = A._cacheIndex,
      C = this._nActiveActions++,
      i = I[C]
    ;((A._cacheIndex = C), (I[C] = A), (i._cacheIndex = g), (I[g] = i))
  }
  _takeBackAction(A) {
    const I = this._actions,
      g = A._cacheIndex,
      C = --this._nActiveActions,
      i = I[C]
    ;((A._cacheIndex = C), (I[C] = A), (i._cacheIndex = g), (I[g] = i))
  }
  // Memory management for PropertyMixer objects
  _addInactiveBinding(A, I, g) {
    const C = this._bindingsByRootAndName,
      i = this._bindings
    let B = C[I]
    ;(B === void 0 && ((B = {}), (C[I] = B)), (B[g] = A), (A._cacheIndex = i.length), i.push(A))
  }
  _removeInactiveBinding(A) {
    const I = this._bindings,
      g = A.binding,
      C = g.rootNode.uuid,
      i = g.path,
      B = this._bindingsByRootAndName,
      o = B[C],
      r = I[I.length - 1],
      s = A._cacheIndex
    ;((r._cacheIndex = s),
      (I[s] = r),
      I.pop(),
      delete o[i],
      Object.keys(o).length === 0 && delete B[C])
  }
  _lendBinding(A) {
    const I = this._bindings,
      g = A._cacheIndex,
      C = this._nActiveBindings++,
      i = I[C]
    ;((A._cacheIndex = C), (I[C] = A), (i._cacheIndex = g), (I[g] = i))
  }
  _takeBackBinding(A) {
    const I = this._bindings,
      g = A._cacheIndex,
      C = --this._nActiveBindings,
      i = I[C]
    ;((A._cacheIndex = C), (I[C] = A), (i._cacheIndex = g), (I[g] = i))
  }
  // Memory management of Interpolants for weight and time scale
  _lendControlInterpolant() {
    const A = this._controlInterpolants,
      I = this._nActiveControlInterpolants++
    let g = A[I]
    return (
      g === void 0 &&
        ((g = new uv(new Float32Array(2), new Float32Array(2), 1, xj)),
        (g.__cacheIndex = I),
        (A[I] = g)),
      g
    )
  }
  _takeBackControlInterpolant(A) {
    const I = this._controlInterpolants,
      g = A.__cacheIndex,
      C = --this._nActiveControlInterpolants,
      i = I[C]
    ;((A.__cacheIndex = C), (I[C] = A), (i.__cacheIndex = g), (I[g] = i))
  }
  // return an action for a clip optionally using a custom root target
  // object (this method allocates a lot of dynamic memory in case a
  // previously unknown clip/root combination is specified)
  clipAction(A, I, g) {
    const C = I || this._root,
      i = C.uuid
    let B = typeof A == "string" ? lp.findByName(C, A) : A
    const o = B !== null ? B.uuid : A,
      r = this._actionsByClip[o]
    let s = null
    if ((g === void 0 && (B !== null ? (g = B.blendMode) : (g = zN)), r !== void 0)) {
      const S = r.actionByRoot[i]
      if (S !== void 0 && S.blendMode === g) return S
      ;((s = r.knownActions[0]), B === null && (B = s._clip))
    }
    if (B === null) return null
    const h = new Hb(this, B, I, g)
    return (this._bindAction(h, s), this._addInactiveAction(h, o, i), h)
  }
  // get an existing action
  existingAction(A, I) {
    const g = I || this._root,
      C = g.uuid,
      i = typeof A == "string" ? lp.findByName(g, A) : A,
      B = i ? i.uuid : A,
      o = this._actionsByClip[B]
    return (o !== void 0 && o.actionByRoot[C]) || null
  }
  // deactivates all previously scheduled actions
  stopAllAction() {
    const A = this._actions,
      I = this._nActiveActions
    for (let g = I - 1; g >= 0; --g) A[g].stop()
    return this
  }
  // advance the time and update apply the animation
  update(A) {
    A *= this.timeScale
    const I = this._actions,
      g = this._nActiveActions,
      C = (this.time += A),
      i = Math.sign(A),
      B = (this._accuIndex ^= 1)
    for (let s = 0; s !== g; ++s) I[s]._update(C, A, i, B)
    const o = this._bindings,
      r = this._nActiveBindings
    for (let s = 0; s !== r; ++s) o[s].apply(B)
    return this
  }
  // Allows you to seek to a specific time in an animation.
  setTime(A) {
    this.time = 0
    for (let I = 0; I < this._actions.length; I++) this._actions[I].time = 0
    return this.update(A)
  }
  // return this mixer's root target object
  getRoot() {
    return this._root
  }
  // free all resources specific to a particular clip
  uncacheClip(A) {
    const I = this._actions,
      g = A.uuid,
      C = this._actionsByClip,
      i = C[g]
    if (i !== void 0) {
      const B = i.knownActions
      for (let o = 0, r = B.length; o !== r; ++o) {
        const s = B[o]
        this._deactivateAction(s)
        const h = s._cacheIndex,
          S = I[I.length - 1]
        ;((s._cacheIndex = null),
          (s._byClipCacheIndex = null),
          (S._cacheIndex = h),
          (I[h] = S),
          I.pop(),
          this._removeInactiveBindingsForAction(s))
      }
      delete C[g]
    }
  }
  // free all resources specific to a particular root target object
  uncacheRoot(A) {
    const I = A.uuid,
      g = this._actionsByClip
    for (const B in g) {
      const o = g[B].actionByRoot,
        r = o[I]
      r !== void 0 && (this._deactivateAction(r), this._removeInactiveAction(r))
    }
    const C = this._bindingsByRootAndName,
      i = C[I]
    if (i !== void 0)
      for (const B in i) {
        const o = i[B]
        ;(o.restoreOriginalState(), this._removeInactiveBinding(o))
      }
  }
  // remove a targeted clip from the cache
  uncacheAction(A, I) {
    const g = this.existingAction(A, I)
    g !== null && (this._deactivateAction(g), this._removeInactiveAction(g))
  }
}
class ki {
  constructor(A) {
    this.value = A
  }
  clone() {
    return new ki(this.value.clone === void 0 ? this.value : this.value.clone())
  }
}
let Oj = 0
class _j extends qr {
  constructor() {
    ;(super(),
      (this.isUniformsGroup = !0),
      Object.defineProperty(this, "id", { value: Oj++ }),
      (this.name = ""),
      (this.usage = rG),
      (this.uniforms = []))
  }
  add(A) {
    return (this.uniforms.push(A), this)
  }
  remove(A) {
    const I = this.uniforms.indexOf(A)
    return (I !== -1 && this.uniforms.splice(I, 1), this)
  }
  setName(A) {
    return ((this.name = A), this)
  }
  setUsage(A) {
    return ((this.usage = A), this)
  }
  dispose() {
    return (this.dispatchEvent({ type: "dispose" }), this)
  }
  copy(A) {
    ;((this.name = A.name), (this.usage = A.usage))
    const I = A.uniforms
    this.uniforms.length = 0
    for (let g = 0, C = I.length; g < C; g++) {
      const i = Array.isArray(I[g]) ? I[g] : [I[g]]
      for (let B = 0; B < i.length; B++) this.uniforms.push(i[B].clone())
    }
    return this
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
class Zj extends KG {
  constructor(A, I, g = 1) {
    ;(super(A, I), (this.isInstancedInterleavedBuffer = !0), (this.meshPerAttribute = g))
  }
  copy(A) {
    return (super.copy(A), (this.meshPerAttribute = A.meshPerAttribute), this)
  }
  clone(A) {
    const I = super.clone(A)
    return ((I.meshPerAttribute = this.meshPerAttribute), I)
  }
  toJSON(A) {
    const I = super.toJSON(A)
    return ((I.isInstancedInterleavedBuffer = !0), (I.meshPerAttribute = this.meshPerAttribute), I)
  }
}
class Pj {
  constructor(A, I, g, C, i) {
    ;((this.isGLBufferAttribute = !0),
      (this.name = ""),
      (this.buffer = A),
      (this.type = I),
      (this.itemSize = g),
      (this.elementSize = C),
      (this.count = i),
      (this.version = 0))
  }
  set needsUpdate(A) {
    A === !0 && this.version++
  }
  setBuffer(A) {
    return ((this.buffer = A), this)
  }
  setType(A, I) {
    return ((this.type = A), (this.elementSize = I), this)
  }
  setItemSize(A) {
    return ((this.itemSize = A), this)
  }
  setCount(A) {
    return ((this.count = A), this)
  }
}
const gT = /* @__PURE__ */ new RC()
class Tb {
  constructor(A, I, g = 0, C = 1 / 0) {
    ;((this.ray = new fp(A, I)),
      (this.near = g),
      (this.far = C),
      (this.camera = null),
      (this.layers = new Kf()),
      (this.params = {
        Mesh: {},
        Line: { threshold: 1 },
        LOD: {},
        Points: { threshold: 1 },
        Sprite: {},
      }))
  }
  set(A, I) {
    this.ray.set(A, I)
  }
  setFromCamera(A, I) {
    I.isPerspectiveCamera
      ? (this.ray.origin.setFromMatrixPosition(I.matrixWorld),
        this.ray.direction.set(A.x, A.y, 0.5).unproject(I).sub(this.ray.origin).normalize(),
        (this.camera = I))
      : I.isOrthographicCamera
        ? (this.ray.origin.set(A.x, A.y, (I.near + I.far) / (I.near - I.far)).unproject(I),
          this.ray.direction.set(0, 0, -1).transformDirection(I.matrixWorld),
          (this.camera = I))
        : console.error("THREE.Raycaster: Unsupported camera type: " + I.type)
  }
  setFromXRController(A) {
    return (
      gT.identity().extractRotation(A.matrixWorld),
      this.ray.origin.setFromMatrixPosition(A.matrixWorld),
      this.ray.direction.set(0, 0, -1).applyMatrix4(gT),
      this
    )
  }
  intersectObject(A, I = !0, g = []) {
    return (Gm(A, this, g, I), g.sort(CT), g)
  }
  intersectObjects(A, I = !0, g = []) {
    for (let C = 0, i = A.length; C < i; C++) Gm(A[C], this, g, I)
    return (g.sort(CT), g)
  }
}
function CT(e, A) {
  return e.distance - A.distance
}
function Gm(e, A, I, g) {
  let C = !0
  if ((e.layers.test(A.layers) && e.raycast(A, I) === !1 && (C = !1), C === !0 && g === !0)) {
    const i = e.children
    for (let B = 0, o = i.length; B < o; B++) Gm(i[B], A, I, !0)
  }
}
class Wj {
  constructor(A = 1, I = 0, g = 0) {
    return ((this.radius = A), (this.phi = I), (this.theta = g), this)
  }
  set(A, I, g) {
    return ((this.radius = A), (this.phi = I), (this.theta = g), this)
  }
  copy(A) {
    return ((this.radius = A.radius), (this.phi = A.phi), (this.theta = A.theta), this)
  }
  // restrict phi to be between EPS and PI-EPS
  makeSafe() {
    return ((this.phi = Math.max(1e-6, Math.min(Math.PI - 1e-6, this.phi))), this)
  }
  setFromVector3(A) {
    return this.setFromCartesianCoords(A.x, A.y, A.z)
  }
  setFromCartesianCoords(A, I, g) {
    return (
      (this.radius = Math.sqrt(A * A + I * I + g * g)),
      this.radius === 0
        ? ((this.theta = 0), (this.phi = 0))
        : ((this.theta = Math.atan2(A, g)), (this.phi = Math.acos(eQ(I / this.radius, -1, 1)))),
      this
    )
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
class Vj {
  constructor(A = 1, I = 0, g = 0) {
    return ((this.radius = A), (this.theta = I), (this.y = g), this)
  }
  set(A, I, g) {
    return ((this.radius = A), (this.theta = I), (this.y = g), this)
  }
  copy(A) {
    return ((this.radius = A.radius), (this.theta = A.theta), (this.y = A.y), this)
  }
  setFromVector3(A) {
    return this.setFromCartesianCoords(A.x, A.y, A.z)
  }
  setFromCartesianCoords(A, I, g) {
    return (
      (this.radius = Math.sqrt(A * A + g * g)),
      (this.theta = Math.atan2(A, g)),
      (this.y = I),
      this
    )
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
class Nv {
  constructor(A, I, g, C) {
    ;((Nv.prototype.isMatrix2 = !0),
      (this.elements = [1, 0, 0, 1]),
      A !== void 0 && this.set(A, I, g, C))
  }
  identity() {
    return (this.set(1, 0, 0, 1), this)
  }
  fromArray(A, I = 0) {
    for (let g = 0; g < 4; g++) this.elements[g] = A[g + I]
    return this
  }
  set(A, I, g, C) {
    const i = this.elements
    return ((i[0] = A), (i[2] = I), (i[1] = g), (i[3] = C), this)
  }
}
const eT = /* @__PURE__ */ new ZI()
class jj {
  constructor(A = new ZI(1 / 0, 1 / 0), I = new ZI(-1 / 0, -1 / 0)) {
    ;((this.isBox2 = !0), (this.min = A), (this.max = I))
  }
  set(A, I) {
    return (this.min.copy(A), this.max.copy(I), this)
  }
  setFromPoints(A) {
    this.makeEmpty()
    for (let I = 0, g = A.length; I < g; I++) this.expandByPoint(A[I])
    return this
  }
  setFromCenterAndSize(A, I) {
    const g = eT.copy(I).multiplyScalar(0.5)
    return (this.min.copy(A).sub(g), this.max.copy(A).add(g), this)
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(A) {
    return (this.min.copy(A.min), this.max.copy(A.max), this)
  }
  makeEmpty() {
    return ((this.min.x = this.min.y = 1 / 0), (this.max.x = this.max.y = -1 / 0), this)
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y
  }
  getCenter(A) {
    return this.isEmpty() ? A.set(0, 0) : A.addVectors(this.min, this.max).multiplyScalar(0.5)
  }
  getSize(A) {
    return this.isEmpty() ? A.set(0, 0) : A.subVectors(this.max, this.min)
  }
  expandByPoint(A) {
    return (this.min.min(A), this.max.max(A), this)
  }
  expandByVector(A) {
    return (this.min.sub(A), this.max.add(A), this)
  }
  expandByScalar(A) {
    return (this.min.addScalar(-A), this.max.addScalar(A), this)
  }
  containsPoint(A) {
    return A.x >= this.min.x && A.x <= this.max.x && A.y >= this.min.y && A.y <= this.max.y
  }
  containsBox(A) {
    return (
      this.min.x <= A.min.x &&
      A.max.x <= this.max.x &&
      this.min.y <= A.min.y &&
      A.max.y <= this.max.y
    )
  }
  getParameter(A, I) {
    return I.set(
      (A.x - this.min.x) / (this.max.x - this.min.x),
      (A.y - this.min.y) / (this.max.y - this.min.y),
    )
  }
  intersectsBox(A) {
    return (
      A.max.x >= this.min.x &&
      A.min.x <= this.max.x &&
      A.max.y >= this.min.y &&
      A.min.y <= this.max.y
    )
  }
  clampPoint(A, I) {
    return I.copy(A).clamp(this.min, this.max)
  }
  distanceToPoint(A) {
    return this.clampPoint(A, eT).distanceTo(A)
  }
  intersect(A) {
    return (this.min.max(A.min), this.max.min(A.max), this.isEmpty() && this.makeEmpty(), this)
  }
  union(A) {
    return (this.min.min(A.min), this.max.max(A.max), this)
  }
  translate(A) {
    return (this.min.add(A), this.max.add(A), this)
  }
  equals(A) {
    return A.min.equals(this.min) && A.max.equals(this.max)
  }
}
const iT = /* @__PURE__ */ new wA(),
  uU = /* @__PURE__ */ new wA()
class zj {
  constructor(A = new wA(), I = new wA()) {
    ;((this.start = A), (this.end = I))
  }
  set(A, I) {
    return (this.start.copy(A), this.end.copy(I), this)
  }
  copy(A) {
    return (this.start.copy(A.start), this.end.copy(A.end), this)
  }
  getCenter(A) {
    return A.addVectors(this.start, this.end).multiplyScalar(0.5)
  }
  delta(A) {
    return A.subVectors(this.end, this.start)
  }
  distanceSq() {
    return this.start.distanceToSquared(this.end)
  }
  distance() {
    return this.start.distanceTo(this.end)
  }
  at(A, I) {
    return this.delta(I).multiplyScalar(A).add(this.start)
  }
  closestPointToPointParameter(A, I) {
    ;(iT.subVectors(A, this.start), uU.subVectors(this.end, this.start))
    const g = uU.dot(uU)
    let i = uU.dot(iT) / g
    return (I && (i = eQ(i, 0, 1)), i)
  }
  closestPointToPoint(A, I, g) {
    const C = this.closestPointToPointParameter(A, I)
    return this.delta(g).multiplyScalar(C).add(this.start)
  }
  applyMatrix4(A) {
    return (this.start.applyMatrix4(A), this.end.applyMatrix4(A), this)
  }
  equals(A) {
    return A.start.equals(this.start) && A.end.equals(this.end)
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
const tT = /* @__PURE__ */ new wA()
class Xj extends Ci {
  constructor(A, I) {
    ;(super(),
      (this.light = A),
      (this.matrixAutoUpdate = !1),
      (this.color = I),
      (this.type = "SpotLightHelper"))
    const g = new se(),
      C = [
        0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, -1, 0, 1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, -1, 1,
      ]
    for (let B = 0, o = 1, r = 32; B < r; B++, o++) {
      const s = (B / r) * Math.PI * 2,
        h = (o / r) * Math.PI * 2
      C.push(Math.cos(s), Math.sin(s), 1, Math.cos(h), Math.sin(h), 1)
    }
    g.setAttribute("position", new aC(C, 3))
    const i = new DE({ fog: !1, toneMapped: !1 })
    ;((this.cone = new Ul(g, i)), this.add(this.cone), this.update())
  }
  dispose() {
    ;(this.cone.geometry.dispose(), this.cone.material.dispose())
  }
  update() {
    ;(this.light.updateWorldMatrix(!0, !1),
      this.light.target.updateWorldMatrix(!0, !1),
      this.parent
        ? (this.parent.updateWorldMatrix(!0),
          this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld))
        : this.matrix.copy(this.light.matrixWorld),
      this.matrixWorld.copy(this.light.matrixWorld))
    const A = this.light.distance ? this.light.distance : 1e3,
      I = A * Math.tan(this.light.angle)
    ;(this.cone.scale.set(I, I, A),
      tT.setFromMatrixPosition(this.light.target.matrixWorld),
      this.cone.lookAt(tT),
      this.color !== void 0
        ? this.cone.material.color.set(this.color)
        : this.cone.material.color.copy(this.light.color))
  }
}
const lD = /* @__PURE__ */ new wA(),
  DU = /* @__PURE__ */ new RC(),
  KK = /* @__PURE__ */ new RC()
class $j extends Ul {
  constructor(A) {
    const I = xb(A),
      g = new se(),
      C = [],
      i = [],
      B = new Mg(0, 0, 1),
      o = new Mg(0, 1, 0)
    for (let s = 0; s < I.length; s++) {
      const h = I[s]
      h.parent &&
        h.parent.isBone &&
        (C.push(0, 0, 0), C.push(0, 0, 0), i.push(B.r, B.g, B.b), i.push(o.r, o.g, o.b))
    }
    ;(g.setAttribute("position", new aC(C, 3)), g.setAttribute("color", new aC(i, 3)))
    const r = new DE({
      vertexColors: !0,
      depthTest: !1,
      depthWrite: !1,
      toneMapped: !1,
      transparent: !0,
    })
    ;(super(g, r),
      (this.isSkeletonHelper = !0),
      (this.type = "SkeletonHelper"),
      (this.root = A),
      (this.bones = I),
      (this.matrix = A.matrixWorld),
      (this.matrixAutoUpdate = !1))
  }
  updateMatrixWorld(A) {
    const I = this.bones,
      g = this.geometry,
      C = g.getAttribute("position")
    KK.copy(this.root.matrixWorld).invert()
    for (let i = 0, B = 0; i < I.length; i++) {
      const o = I[i]
      o.parent &&
        o.parent.isBone &&
        (DU.multiplyMatrices(KK, o.matrixWorld),
        lD.setFromMatrixPosition(DU),
        C.setXYZ(B, lD.x, lD.y, lD.z),
        DU.multiplyMatrices(KK, o.parent.matrixWorld),
        lD.setFromMatrixPosition(DU),
        C.setXYZ(B + 1, lD.x, lD.y, lD.z),
        (B += 2))
    }
    ;((g.getAttribute("position").needsUpdate = !0), super.updateMatrixWorld(A))
  }
  dispose() {
    ;(this.geometry.dispose(), this.material.dispose())
  }
}
function xb(e) {
  const A = []
  e.isBone === !0 && A.push(e)
  for (let I = 0; I < e.children.length; I++) A.push.apply(A, xb(e.children[I]))
  return A
}
class Az extends EB {
  constructor(A, I, g) {
    const C = new YG(I, 4, 2),
      i = new La({ wireframe: !0, fog: !1, toneMapped: !1 })
    ;(super(C, i),
      (this.light = A),
      (this.color = g),
      (this.type = "PointLightHelper"),
      (this.matrix = this.light.matrixWorld),
      (this.matrixAutoUpdate = !1),
      this.update())
  }
  dispose() {
    ;(this.geometry.dispose(), this.material.dispose())
  }
  update() {
    ;(this.light.updateWorldMatrix(!0, !1),
      this.color !== void 0
        ? this.material.color.set(this.color)
        : this.material.color.copy(this.light.color))
  }
}
const Iz = /* @__PURE__ */ new wA(),
  BT = /* @__PURE__ */ new Mg(),
  QT = /* @__PURE__ */ new Mg()
class gz extends Ci {
  constructor(A, I, g) {
    ;(super(),
      (this.light = A),
      (this.matrix = A.matrixWorld),
      (this.matrixAutoUpdate = !1),
      (this.color = g),
      (this.type = "HemisphereLightHelper"))
    const C = new LG(I)
    ;(C.rotateY(Math.PI * 0.5),
      (this.material = new La({ wireframe: !0, fog: !1, toneMapped: !1 })),
      this.color === void 0 && (this.material.vertexColors = !0))
    const i = C.getAttribute("position"),
      B = new Float32Array(i.count * 3)
    ;(C.setAttribute("color", new Ye(B, 3)), this.add(new EB(C, this.material)), this.update())
  }
  dispose() {
    ;(this.children[0].geometry.dispose(), this.children[0].material.dispose())
  }
  update() {
    const A = this.children[0]
    if (this.color !== void 0) this.material.color.set(this.color)
    else {
      const I = A.geometry.getAttribute("color")
      ;(BT.copy(this.light.color), QT.copy(this.light.groundColor))
      for (let g = 0, C = I.count; g < C; g++) {
        const i = g < C / 2 ? BT : QT
        I.setXYZ(g, i.r, i.g, i.b)
      }
      I.needsUpdate = !0
    }
    ;(this.light.updateWorldMatrix(!0, !1),
      A.lookAt(Iz.setFromMatrixPosition(this.light.matrixWorld).negate()))
  }
}
class Cz extends Ul {
  constructor(A = 10, I = 10, g = 4473924, C = 8947848) {
    ;((g = new Mg(g)), (C = new Mg(C)))
    const i = I / 2,
      B = A / I,
      o = A / 2,
      r = [],
      s = []
    for (let d = 0, w = 0, M = -o; d <= I; d++, M += B) {
      ;(r.push(-o, 0, M, o, 0, M), r.push(M, 0, -o, M, 0, o))
      const K = d === i ? g : C
      ;(K.toArray(s, w),
        (w += 3),
        K.toArray(s, w),
        (w += 3),
        K.toArray(s, w),
        (w += 3),
        K.toArray(s, w),
        (w += 3))
    }
    const h = new se()
    ;(h.setAttribute("position", new aC(r, 3)), h.setAttribute("color", new aC(s, 3)))
    const S = new DE({ vertexColors: !0, toneMapped: !1 })
    ;(super(h, S), (this.type = "GridHelper"))
  }
  dispose() {
    ;(this.geometry.dispose(), this.material.dispose())
  }
}
class ez extends Ul {
  constructor(A = 10, I = 16, g = 8, C = 64, i = 4473924, B = 8947848) {
    ;((i = new Mg(i)), (B = new Mg(B)))
    const o = [],
      r = []
    if (I > 1)
      for (let S = 0; S < I; S++) {
        const d = (S / I) * (Math.PI * 2),
          w = Math.sin(d) * A,
          M = Math.cos(d) * A
        ;(o.push(0, 0, 0), o.push(w, 0, M))
        const K = S & 1 ? i : B
        ;(r.push(K.r, K.g, K.b), r.push(K.r, K.g, K.b))
      }
    for (let S = 0; S < g; S++) {
      const d = S & 1 ? i : B,
        w = A - (A / g) * S
      for (let M = 0; M < C; M++) {
        let K = (M / C) * (Math.PI * 2),
          R = Math.sin(K) * w,
          F = Math.cos(K) * w
        ;(o.push(R, 0, F),
          r.push(d.r, d.g, d.b),
          (K = ((M + 1) / C) * (Math.PI * 2)),
          (R = Math.sin(K) * w),
          (F = Math.cos(K) * w),
          o.push(R, 0, F),
          r.push(d.r, d.g, d.b))
      }
    }
    const s = new se()
    ;(s.setAttribute("position", new aC(o, 3)), s.setAttribute("color", new aC(r, 3)))
    const h = new DE({ vertexColors: !0, toneMapped: !1 })
    ;(super(s, h), (this.type = "PolarGridHelper"))
  }
  dispose() {
    ;(this.geometry.dispose(), this.material.dispose())
  }
}
const oT = /* @__PURE__ */ new wA(),
  SU = /* @__PURE__ */ new wA(),
  nT = /* @__PURE__ */ new wA()
class iz extends Ci {
  constructor(A, I, g) {
    ;(super(),
      (this.light = A),
      (this.matrix = A.matrixWorld),
      (this.matrixAutoUpdate = !1),
      (this.color = g),
      (this.type = "DirectionalLightHelper"),
      I === void 0 && (I = 1))
    let C = new se()
    C.setAttribute("position", new aC([-I, I, 0, I, I, 0, I, -I, 0, -I, -I, 0, -I, I, 0], 3))
    const i = new DE({ fog: !1, toneMapped: !1 })
    ;((this.lightPlane = new Qu(C, i)),
      this.add(this.lightPlane),
      (C = new se()),
      C.setAttribute("position", new aC([0, 0, 0, 0, 0, 1], 3)),
      (this.targetLine = new Qu(C, i)),
      this.add(this.targetLine),
      this.update())
  }
  dispose() {
    ;(this.lightPlane.geometry.dispose(),
      this.lightPlane.material.dispose(),
      this.targetLine.geometry.dispose(),
      this.targetLine.material.dispose())
  }
  update() {
    ;(this.light.updateWorldMatrix(!0, !1),
      this.light.target.updateWorldMatrix(!0, !1),
      oT.setFromMatrixPosition(this.light.matrixWorld),
      SU.setFromMatrixPosition(this.light.target.matrixWorld),
      nT.subVectors(SU, oT),
      this.lightPlane.lookAt(SU),
      this.color !== void 0
        ? (this.lightPlane.material.color.set(this.color),
          this.targetLine.material.color.set(this.color))
        : (this.lightPlane.material.color.copy(this.light.color),
          this.targetLine.material.color.copy(this.light.color)),
      this.targetLine.lookAt(SU),
      (this.targetLine.scale.z = nT.length()))
  }
}
const fU = /* @__PURE__ */ new wA(),
  gQ = /* @__PURE__ */ new dp()
class tz extends Ul {
  constructor(A) {
    const I = new se(),
      g = new DE({ color: 16777215, vertexColors: !0, toneMapped: !1 }),
      C = [],
      i = [],
      B = {}
    ;(o("n1", "n2"),
      o("n2", "n4"),
      o("n4", "n3"),
      o("n3", "n1"),
      o("f1", "f2"),
      o("f2", "f4"),
      o("f4", "f3"),
      o("f3", "f1"),
      o("n1", "f1"),
      o("n2", "f2"),
      o("n3", "f3"),
      o("n4", "f4"),
      o("p", "n1"),
      o("p", "n2"),
      o("p", "n3"),
      o("p", "n4"),
      o("u1", "u2"),
      o("u2", "u3"),
      o("u3", "u1"),
      o("c", "t"),
      o("p", "c"),
      o("cn1", "cn2"),
      o("cn3", "cn4"),
      o("cf1", "cf2"),
      o("cf3", "cf4"))
    function o(M, K) {
      ;(r(M), r(K))
    }
    function r(M) {
      ;(C.push(0, 0, 0),
        i.push(0, 0, 0),
        B[M] === void 0 && (B[M] = []),
        B[M].push(C.length / 3 - 1))
    }
    ;(I.setAttribute("position", new aC(C, 3)),
      I.setAttribute("color", new aC(i, 3)),
      super(I, g),
      (this.type = "CameraHelper"),
      (this.camera = A),
      this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(),
      (this.matrix = A.matrixWorld),
      (this.matrixAutoUpdate = !1),
      (this.pointMap = B),
      this.update())
    const s = new Mg(16755200),
      h = new Mg(16711680),
      S = new Mg(43775),
      d = new Mg(16777215),
      w = new Mg(3355443)
    this.setColors(s, h, S, d, w)
  }
  setColors(A, I, g, C, i) {
    const o = this.geometry.getAttribute("color")
    ;(o.setXYZ(0, A.r, A.g, A.b),
      o.setXYZ(1, A.r, A.g, A.b),
      o.setXYZ(2, A.r, A.g, A.b),
      o.setXYZ(3, A.r, A.g, A.b),
      o.setXYZ(4, A.r, A.g, A.b),
      o.setXYZ(5, A.r, A.g, A.b),
      o.setXYZ(6, A.r, A.g, A.b),
      o.setXYZ(7, A.r, A.g, A.b),
      o.setXYZ(8, A.r, A.g, A.b),
      o.setXYZ(9, A.r, A.g, A.b),
      o.setXYZ(10, A.r, A.g, A.b),
      o.setXYZ(11, A.r, A.g, A.b),
      o.setXYZ(12, A.r, A.g, A.b),
      o.setXYZ(13, A.r, A.g, A.b),
      o.setXYZ(14, A.r, A.g, A.b),
      o.setXYZ(15, A.r, A.g, A.b),
      o.setXYZ(16, A.r, A.g, A.b),
      o.setXYZ(17, A.r, A.g, A.b),
      o.setXYZ(18, A.r, A.g, A.b),
      o.setXYZ(19, A.r, A.g, A.b),
      o.setXYZ(20, A.r, A.g, A.b),
      o.setXYZ(21, A.r, A.g, A.b),
      o.setXYZ(22, A.r, A.g, A.b),
      o.setXYZ(23, A.r, A.g, A.b),
      o.setXYZ(24, I.r, I.g, I.b),
      o.setXYZ(25, I.r, I.g, I.b),
      o.setXYZ(26, I.r, I.g, I.b),
      o.setXYZ(27, I.r, I.g, I.b),
      o.setXYZ(28, I.r, I.g, I.b),
      o.setXYZ(29, I.r, I.g, I.b),
      o.setXYZ(30, I.r, I.g, I.b),
      o.setXYZ(31, I.r, I.g, I.b),
      o.setXYZ(32, g.r, g.g, g.b),
      o.setXYZ(33, g.r, g.g, g.b),
      o.setXYZ(34, g.r, g.g, g.b),
      o.setXYZ(35, g.r, g.g, g.b),
      o.setXYZ(36, g.r, g.g, g.b),
      o.setXYZ(37, g.r, g.g, g.b),
      o.setXYZ(38, C.r, C.g, C.b),
      o.setXYZ(39, C.r, C.g, C.b),
      o.setXYZ(40, i.r, i.g, i.b),
      o.setXYZ(41, i.r, i.g, i.b),
      o.setXYZ(42, i.r, i.g, i.b),
      o.setXYZ(43, i.r, i.g, i.b),
      o.setXYZ(44, i.r, i.g, i.b),
      o.setXYZ(45, i.r, i.g, i.b),
      o.setXYZ(46, i.r, i.g, i.b),
      o.setXYZ(47, i.r, i.g, i.b),
      o.setXYZ(48, i.r, i.g, i.b),
      o.setXYZ(49, i.r, i.g, i.b),
      (o.needsUpdate = !0))
  }
  update() {
    const A = this.geometry,
      I = this.pointMap,
      g = 1,
      C = 1
    ;(gQ.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse),
      UQ("c", I, A, gQ, 0, 0, -1),
      UQ("t", I, A, gQ, 0, 0, 1),
      UQ("n1", I, A, gQ, -g, -C, -1),
      UQ("n2", I, A, gQ, g, -C, -1),
      UQ("n3", I, A, gQ, -g, C, -1),
      UQ("n4", I, A, gQ, g, C, -1),
      UQ("f1", I, A, gQ, -g, -C, 1),
      UQ("f2", I, A, gQ, g, -C, 1),
      UQ("f3", I, A, gQ, -g, C, 1),
      UQ("f4", I, A, gQ, g, C, 1),
      UQ("u1", I, A, gQ, g * 0.7, C * 1.1, -1),
      UQ("u2", I, A, gQ, -g * 0.7, C * 1.1, -1),
      UQ("u3", I, A, gQ, 0, C * 2, -1),
      UQ("cf1", I, A, gQ, -g, 0, 1),
      UQ("cf2", I, A, gQ, g, 0, 1),
      UQ("cf3", I, A, gQ, 0, -C, 1),
      UQ("cf4", I, A, gQ, 0, C, 1),
      UQ("cn1", I, A, gQ, -g, 0, -1),
      UQ("cn2", I, A, gQ, g, 0, -1),
      UQ("cn3", I, A, gQ, 0, -C, -1),
      UQ("cn4", I, A, gQ, 0, C, -1),
      (A.getAttribute("position").needsUpdate = !0))
  }
  dispose() {
    ;(this.geometry.dispose(), this.material.dispose())
  }
}
function UQ(e, A, I, g, C, i, B) {
  fU.set(C, i, B).unproject(g)
  const o = A[e]
  if (o !== void 0) {
    const r = I.getAttribute("position")
    for (let s = 0, h = o.length; s < h; s++) r.setXYZ(o[s], fU.x, fU.y, fU.z)
  }
}
const dU = /* @__PURE__ */ new Vo()
class Bz extends Ul {
  constructor(A, I = 16776960) {
    const g = new Uint16Array([
        0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7,
      ]),
      C = new Float32Array(8 * 3),
      i = new se()
    ;(i.setIndex(new Ye(g, 1)),
      i.setAttribute("position", new Ye(C, 3)),
      super(i, new DE({ color: I, toneMapped: !1 })),
      (this.object = A),
      (this.type = "BoxHelper"),
      (this.matrixAutoUpdate = !1),
      this.update())
  }
  update(A) {
    if (
      (A !== void 0 && console.warn("THREE.BoxHelper: .update() has no longer arguments."),
      this.object !== void 0 && dU.setFromObject(this.object),
      dU.isEmpty())
    )
      return
    const I = dU.min,
      g = dU.max,
      C = this.geometry.attributes.position,
      i = C.array
    ;((i[0] = g.x),
      (i[1] = g.y),
      (i[2] = g.z),
      (i[3] = I.x),
      (i[4] = g.y),
      (i[5] = g.z),
      (i[6] = I.x),
      (i[7] = I.y),
      (i[8] = g.z),
      (i[9] = g.x),
      (i[10] = I.y),
      (i[11] = g.z),
      (i[12] = g.x),
      (i[13] = g.y),
      (i[14] = I.z),
      (i[15] = I.x),
      (i[16] = g.y),
      (i[17] = I.z),
      (i[18] = I.x),
      (i[19] = I.y),
      (i[20] = I.z),
      (i[21] = g.x),
      (i[22] = I.y),
      (i[23] = I.z),
      (C.needsUpdate = !0),
      this.geometry.computeBoundingSphere())
  }
  setFromObject(A) {
    return ((this.object = A), this.update(), this)
  }
  copy(A, I) {
    return (super.copy(A, I), (this.object = A.object), this)
  }
  dispose() {
    ;(this.geometry.dispose(), this.material.dispose())
  }
}
class Qz extends Ul {
  constructor(A, I = 16776960) {
    const g = new Uint16Array([
        0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7,
      ]),
      C = [1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1],
      i = new se()
    ;(i.setIndex(new Ye(g, 1)),
      i.setAttribute("position", new aC(C, 3)),
      super(i, new DE({ color: I, toneMapped: !1 })),
      (this.box = A),
      (this.type = "Box3Helper"),
      this.geometry.computeBoundingSphere())
  }
  updateMatrixWorld(A) {
    const I = this.box
    I.isEmpty() ||
      (I.getCenter(this.position),
      I.getSize(this.scale),
      this.scale.multiplyScalar(0.5),
      super.updateMatrixWorld(A))
  }
  dispose() {
    ;(this.geometry.dispose(), this.material.dispose())
  }
}
class oz extends Qu {
  constructor(A, I = 1, g = 16776960) {
    const C = g,
      i = [1, -1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, 1, 0, -1, -1, 0, 1, -1, 0, 1, 1, 0],
      B = new se()
    ;(B.setAttribute("position", new aC(i, 3)),
      B.computeBoundingSphere(),
      super(B, new DE({ color: C, toneMapped: !1 })),
      (this.type = "PlaneHelper"),
      (this.plane = A),
      (this.size = I))
    const o = [1, 1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, -1, 0, 1, -1, 0],
      r = new se()
    ;(r.setAttribute("position", new aC(o, 3)),
      r.computeBoundingSphere(),
      this.add(
        new EB(
          r,
          new La({ color: C, opacity: 0.2, transparent: !0, depthWrite: !1, toneMapped: !1 }),
        ),
      ))
  }
  updateMatrixWorld(A) {
    ;(this.position.set(0, 0, 0),
      this.scale.set(0.5 * this.size, 0.5 * this.size, 1),
      this.lookAt(this.plane.normal),
      this.translateZ(-this.plane.constant),
      super.updateMatrixWorld(A))
  }
  dispose() {
    ;(this.geometry.dispose(),
      this.material.dispose(),
      this.children[0].geometry.dispose(),
      this.children[0].material.dispose())
  }
}
const ET = /* @__PURE__ */ new wA()
let yU, mK
class nz extends Ci {
  // dir is assumed to be normalized
  constructor(
    A = new wA(0, 0, 1),
    I = new wA(0, 0, 0),
    g = 1,
    C = 16776960,
    i = g * 0.2,
    B = i * 0.2,
  ) {
    ;(super(),
      (this.type = "ArrowHelper"),
      yU === void 0 &&
        ((yU = new se()),
        yU.setAttribute("position", new aC([0, 0, 0, 0, 1, 0], 3)),
        (mK = new wp(0, 0.5, 1, 5, 1)),
        mK.translate(0, -0.5, 0)),
      this.position.copy(I),
      (this.line = new Qu(yU, new DE({ color: C, toneMapped: !1 }))),
      (this.line.matrixAutoUpdate = !1),
      this.add(this.line),
      (this.cone = new EB(mK, new La({ color: C, toneMapped: !1 }))),
      (this.cone.matrixAutoUpdate = !1),
      this.add(this.cone),
      this.setDirection(A),
      this.setLength(g, i, B))
  }
  setDirection(A) {
    if (A.y > 0.99999) this.quaternion.set(0, 0, 0, 1)
    else if (A.y < -0.99999) this.quaternion.set(1, 0, 0, 0)
    else {
      ET.set(A.z, 0, -A.x).normalize()
      const I = Math.acos(A.y)
      this.quaternion.setFromAxisAngle(ET, I)
    }
  }
  setLength(A, I = A * 0.2, g = I * 0.2) {
    ;(this.line.scale.set(1, Math.max(1e-4, A - I), 1),
      this.line.updateMatrix(),
      this.cone.scale.set(g, I, g),
      (this.cone.position.y = A),
      this.cone.updateMatrix())
  }
  setColor(A) {
    ;(this.line.material.color.set(A), this.cone.material.color.set(A))
  }
  copy(A) {
    return (super.copy(A, !1), this.line.copy(A.line), this.cone.copy(A.cone), this)
  }
  dispose() {
    ;(this.line.geometry.dispose(),
      this.line.material.dispose(),
      this.cone.geometry.dispose(),
      this.cone.material.dispose())
  }
}
class Ez extends Ul {
  constructor(A = 1) {
    const I = [0, 0, 0, A, 0, 0, 0, 0, 0, 0, A, 0, 0, 0, 0, 0, 0, A],
      g = [1, 0, 0, 1, 0.6, 0, 0, 1, 0, 0.6, 1, 0, 0, 0, 1, 0, 0.6, 1],
      C = new se()
    ;(C.setAttribute("position", new aC(I, 3)), C.setAttribute("color", new aC(g, 3)))
    const i = new DE({ vertexColors: !0, toneMapped: !1 })
    ;(super(C, i), (this.type = "AxesHelper"))
  }
  setColors(A, I, g) {
    const C = new Mg(),
      i = this.geometry.attributes.color.array
    return (
      C.set(A),
      C.toArray(i, 0),
      C.toArray(i, 3),
      C.set(I),
      C.toArray(i, 6),
      C.toArray(i, 9),
      C.set(g),
      C.toArray(i, 12),
      C.toArray(i, 15),
      (this.geometry.attributes.color.needsUpdate = !0),
      this
    )
  }
  dispose() {
    ;(this.geometry.dispose(), this.material.dispose())
  }
}
class az {
  constructor() {
    ;((this.type = "ShapePath"),
      (this.color = new Mg()),
      (this.subPaths = []),
      (this.currentPath = null))
  }
  moveTo(A, I) {
    return (
      (this.currentPath = new cG()),
      this.subPaths.push(this.currentPath),
      this.currentPath.moveTo(A, I),
      this
    )
  }
  lineTo(A, I) {
    return (this.currentPath.lineTo(A, I), this)
  }
  quadraticCurveTo(A, I, g, C) {
    return (this.currentPath.quadraticCurveTo(A, I, g, C), this)
  }
  bezierCurveTo(A, I, g, C, i, B) {
    return (this.currentPath.bezierCurveTo(A, I, g, C, i, B), this)
  }
  splineThru(A) {
    return (this.currentPath.splineThru(A), this)
  }
  toShapes(A) {
    function I(F) {
      const L = []
      for (let Y = 0, H = F.length; Y < H; Y++) {
        const V = F[Y],
          j = new mf()
        ;((j.curves = V.curves), L.push(j))
      }
      return L
    }
    function g(F, L) {
      const Y = L.length
      let H = !1
      for (let V = Y - 1, j = 0; j < Y; V = j++) {
        let P = L[V],
          AA = L[j],
          X = AA.x - P.x,
          _ = AA.y - P.y
        if (Math.abs(_) > Number.EPSILON) {
          if ((_ < 0 && ((P = L[j]), (X = -X), (AA = L[V]), (_ = -_)), F.y < P.y || F.y > AA.y))
            continue
          if (F.y === P.y) {
            if (F.x === P.x) return !0
          } else {
            const eA = _ * (F.x - P.x) - X * (F.y - P.y)
            if (eA === 0) return !0
            if (eA < 0) continue
            H = !H
          }
        } else {
          if (F.y !== P.y) continue
          if ((AA.x <= F.x && F.x <= P.x) || (P.x <= F.x && F.x <= AA.x)) return !0
        }
      }
      return H
    }
    const C = _c.isClockWise,
      i = this.subPaths
    if (i.length === 0) return []
    let B, o, r
    const s = []
    if (i.length === 1) return ((o = i[0]), (r = new mf()), (r.curves = o.curves), s.push(r), s)
    let h = !C(i[0].getPoints())
    h = A ? !h : h
    const S = [],
      d = []
    let w = [],
      M = 0,
      K
    ;((d[M] = void 0), (w[M] = []))
    for (let F = 0, L = i.length; F < L; F++)
      ((o = i[F]),
        (K = o.getPoints()),
        (B = C(K)),
        (B = A ? !B : B),
        B
          ? (!h && d[M] && M++,
            (d[M] = { s: new mf(), p: K }),
            (d[M].s.curves = o.curves),
            h && M++,
            (w[M] = []))
          : w[M].push({ h: o, p: K[0] }))
    if (!d[0]) return I(i)
    if (d.length > 1) {
      let F = !1,
        L = 0
      for (let Y = 0, H = d.length; Y < H; Y++) S[Y] = []
      for (let Y = 0, H = d.length; Y < H; Y++) {
        const V = w[Y]
        for (let j = 0; j < V.length; j++) {
          const P = V[j]
          let AA = !0
          for (let X = 0; X < d.length; X++)
            g(P.p, d[X].p) && (Y !== X && L++, AA ? ((AA = !1), S[X].push(P)) : (F = !0))
          AA && S[Y].push(P)
        }
      }
      L > 0 && F === !1 && (w = S)
    }
    let R
    for (let F = 0, L = d.length; F < L; F++) {
      ;((r = d[F].s), s.push(r), (R = w[F]))
      for (let Y = 0, H = R.length; Y < H; Y++) r.holes.push(R[Y].h)
    }
    return s
  }
}
class rz extends qr {
  constructor(A, I = null) {
    ;(super(),
      (this.object = A),
      (this.domElement = I),
      (this.enabled = !0),
      (this.state = -1),
      (this.keys = {}),
      (this.mouseButtons = { LEFT: null, MIDDLE: null, RIGHT: null }),
      (this.touches = { ONE: null, TWO: null }))
  }
  connect() {}
  disconnect() {}
  dispose() {}
  update() {}
}
class sz extends BQ {
  // @deprecated, r162
  constructor(A = 1, I = 1, g = 1, C = {}) {
    ;(console.warn(
      'THREE.WebGLMultipleRenderTargets has been deprecated and will be removed in r172. Use THREE.WebGLRenderTarget and set the "count" parameter to enable MRT.',
    ),
      super(A, I, { ...C, count: g }),
      (this.isWebGLMultipleRenderTargets = !0))
  }
  get texture() {
    return this.textures
  }
}
typeof __THREE_DEVTOOLS__ < "u" &&
  __THREE_DEVTOOLS__.dispatchEvent(
    new CustomEvent("register", {
      detail: {
        revision: Wf,
      },
    }),
  )
typeof window < "u" &&
  (window.__THREE__
    ? console.warn("WARNING: Multiple instances of Three.js being imported.")
    : (window.__THREE__ = Wf))
const lz = /* @__PURE__ */ Object.freeze(
  /* @__PURE__ */ Object.defineProperty(
    {
      __proto__: null,
      ACESFilmicToneMapping: Hm,
      AddEquation: yD,
      AddOperation: S2,
      AdditiveAnimationBlendMode: jm,
      AdditiveBlending: rm,
      AgXToneMapping: w2,
      AlphaFormat: Om,
      AlwaysCompare: q2,
      AlwaysDepth: bU,
      AlwaysStencilFunc: hm,
      AmbientLight: Rb,
      AnimationAction: Hb,
      AnimationClip: lp,
      AnimationLoader: cj,
      AnimationMixer: bj,
      AnimationObjectGroup: Tj,
      AnimationUtils: aj,
      ArcCurve: Bb,
      ArrayCamera: Ib,
      ArrowHelper: nz,
      AttachedBindMode: cm,
      Audio: Yb,
      AudioAnalyser: Fj,
      AudioContext: Gv,
      AudioListener: Mj,
      AudioLoader: wj,
      AxesHelper: Ez,
      BackSide: WQ,
      BasicDepthPacking: mD,
      BasicShadowMap: A2,
      BatchedMesh: tb,
      Bone: tF,
      BooleanKeyframeTrack: jf,
      Box2: jj,
      Box3: Vo,
      Box3Helper: Qz,
      BoxGeometry: Vf,
      BoxHelper: Bz,
      BufferAttribute: Ye,
      BufferGeometry: se,
      BufferGeometryLoader: vb,
      ByteType: Tm,
      Cache: gu,
      Camera: dp,
      CameraHelper: tz,
      CanvasTexture: v5,
      CapsuleGeometry: nF,
      CatmullRomCurve3: Qb,
      CineonToneMapping: y2,
      CircleGeometry: EF,
      ClampToEdgeWrapping: vr,
      Clock: kv,
      Color: Mg,
      ColorKeyframeTrack: Dv,
      ColorManagement: ni,
      CompressedArrayTexture: K5,
      CompressedCubeTexture: m5,
      CompressedTexture: QF,
      CompressedTextureLoader: hj,
      ConeGeometry: aF,
      ConstantAlphaFactor: h2,
      ConstantColorFactor: l2,
      Controls: rz,
      CubeCamera: P2,
      CubeReflectionMapping: Bu,
      CubeRefractionMapping: kD,
      CubeTexture: FG,
      CubeTextureLoader: uj,
      CubeUVReflectionMapping: Sp,
      CubicBezierCurve: Ev,
      CubicBezierCurve3: ob,
      CubicInterpolant: Gb,
      CullFaceBack: am,
      CullFaceFront: $x,
      CullFaceFrontBack: l1,
      CullFaceNone: Xx,
      Curve: Nl,
      CurvePath: Eb,
      CustomBlending: I2,
      CustomToneMapping: p2,
      CylinderGeometry: wp,
      Cylindrical: Vj,
      Data3DTexture: Iv,
      DataArrayTexture: $N,
      DataTexture: Oc,
      DataTextureLoader: Dj,
      DataUtils: pZ,
      DecrementStencilOp: G1,
      DecrementWrapStencilOp: M1,
      DefaultLoadingManager: Ub,
      DepthFormat: Rf,
      DepthStencilFormat: ND,
      DepthTexture: JG,
      DetachedBindMode: k2,
      DirectionalLight: pv,
      DirectionalLightHelper: iz,
      DiscreteInterpolant: kb,
      DodecahedronGeometry: rF,
      DoubleSide: rE,
      DstAlphaFactor: n2,
      DstColorFactor: a2,
      DynamicCopyUsage: x1,
      DynamicDrawUsage: H2,
      DynamicReadUsage: q1,
      EdgesGeometry: ab,
      EllipseCurve: oF,
      EqualCompare: m2,
      EqualDepth: _U,
      EqualStencilFunc: R1,
      EquirectangularReflectionMapping: nG,
      EquirectangularRefractionMapping: EG,
      Euler: uE,
      EventDispatcher: qr,
      ExtrudeGeometry: lF,
      FileLoader: Yr,
      Float16BufferAttribute: NZ,
      Float32BufferAttribute: aC,
      FloatType: sE,
      Fog: iF,
      FogExp2: eF,
      FramebufferTexture: J5,
      FrontSide: Us,
      Frustum: RG,
      GLBufferAttribute: Pj,
      GLSL1: O1,
      GLSL3: um,
      GreaterCompare: v2,
      GreaterDepth: PU,
      GreaterEqualCompare: Y2,
      GreaterEqualDepth: ZU,
      GreaterEqualStencilFunc: v1,
      GreaterStencilFunc: K1,
      GridHelper: Cz,
      Group: Iu,
      HalfFloatType: KD,
      HemisphereLight: Fb,
      HemisphereLightHelper: gz,
      IcosahedronGeometry: cF,
      ImageBitmapLoader: Lb,
      ImageLoader: SG,
      ImageUtils: b2,
      IncrementStencilOp: w1,
      IncrementWrapStencilOp: k1,
      InstancedBufferAttribute: RD,
      InstancedBufferGeometry: wv,
      InstancedInterleavedBuffer: Zj,
      InstancedMesh: Bv,
      Int16BufferAttribute: MZ,
      Int32BufferAttribute: UZ,
      Int8BufferAttribute: wZ,
      IntType: _N,
      InterleavedBuffer: KG,
      InterleavedBufferAttribute: FD,
      Interpolant: Gp,
      InterpolateDiscrete: np,
      InterpolateLinear: Ep,
      InterpolateSmooth: mU,
      InvertStencilOp: U1,
      KeepStencilOp: ff,
      KeyframeTrack: Fl,
      LOD: ib,
      LatheGeometry: vG,
      Layers: Kf,
      LessCompare: K2,
      LessDepth: OU,
      LessEqualCompare: $m,
      LessEqualDepth: Lf,
      LessEqualStencilFunc: J1,
      LessStencilFunc: F1,
      Light: YD,
      LightProbe: mb,
      Line: Qu,
      Line3: zj,
      LineBasicMaterial: DE,
      LineCurve: av,
      LineCurve3: nb,
      LineDashedMaterial: yb,
      LineLoop: Qv,
      LineSegments: Ul,
      LinearFilter: nt,
      LinearInterpolant: uv,
      LinearMipMapLinearFilter: D1,
      LinearMipMapNearestFilter: u1,
      LinearMipmapLinearFilter: ks,
      LinearMipmapNearestFilter: ep,
      LinearSRGBColorSpace: ru,
      LinearToneMapping: f2,
      LinearTransfer: NG,
      Loader: SE,
      LoaderUtils: wD,
      LoadingManager: Sv,
      LoopOnce: M2,
      LoopPingPong: N2,
      LoopRepeat: U2,
      LuminanceAlphaFormat: Pm,
      LuminanceFormat: Zm,
      MOUSE: r1,
      Material: tQ,
      MaterialLoader: yF,
      MathUtils: XN,
      Matrix2: Nv,
      Matrix3: ce,
      Matrix4: RC,
      MaxEquation: i2,
      Mesh: EB,
      MeshBasicMaterial: La,
      MeshDepthMaterial: gF,
      MeshDistanceMaterial: CF,
      MeshLambertMaterial: fb,
      MeshMatcapMaterial: db,
      MeshNormalMaterial: cv,
      MeshPhongMaterial: Db,
      MeshPhysicalMaterial: Hr,
      MeshStandardMaterial: qG,
      MeshToonMaterial: Sb,
      MinEquation: e2,
      MirroredRepeatWrapping: Qp,
      MixOperation: D2,
      MultiplyBlending: lm,
      MultiplyOperation: MG,
      NearestFilter: iQ,
      NearestMipMapLinearFilter: h1,
      NearestMipMapNearestFilter: c1,
      NearestMipmapLinearFilter: pf,
      NearestMipmapNearestFilter: ON,
      NeutralToneMapping: G2,
      NeverCompare: J2,
      NeverDepth: xU,
      NeverStencilFunc: N1,
      NoBlending: hE,
      NoColorSpace: kl,
      NoToneMapping: Ms,
      NormalAnimationBlendMode: zN,
      NormalBlending: Ff,
      NotEqualCompare: L2,
      NotEqualDepth: WU,
      NotEqualStencilFunc: m1,
      NumberKeyframeTrack: qf,
      Object3D: Ci,
      ObjectLoader: yj,
      ObjectSpaceNormalMap: R2,
      OctahedronGeometry: LG,
      OneFactor: B2,
      OneMinusConstantAlphaFactor: u2,
      OneMinusConstantColorFactor: c2,
      OneMinusDstAlphaFactor: E2,
      OneMinusDstColorFactor: r2,
      OneMinusSrcAlphaFactor: TU,
      OneMinusSrcColorFactor: o2,
      OrthographicCamera: yp,
      PCFShadowMap: xN,
      PCFSoftShadowMap: X0,
      PMREMGenerator: Dm,
      Path: cG,
      PerspectiveCamera: PQ,
      Plane: fD,
      PlaneGeometry: su,
      PlaneHelper: oz,
      PointLight: yv,
      PointLightHelper: Az,
      Points: ov,
      PointsMaterial: BF,
      PolarGridHelper: ez,
      PolyhedronGeometry: LD,
      PositionalAudio: Nj,
      PropertyBinding: Di,
      PropertyMixer: qb,
      QuadraticBezierCurve: rv,
      QuadraticBezierCurve3: sv,
      Quaternion: ho,
      QuaternionKeyframeTrack: Hf,
      QuaternionLinearInterpolant: Mb,
      RED_GREEN_RGTC2_Format: DN,
      RED_RGTC1_Format: Vm,
      REVISION: Wf,
      RGBADepthPacking: Xm,
      RGBAFormat: lE,
      RGBAIntegerFormat: jN,
      RGBA_ASTC_10x10_Format: rN,
      RGBA_ASTC_10x5_Format: nN,
      RGBA_ASTC_10x6_Format: EN,
      RGBA_ASTC_10x8_Format: aN,
      RGBA_ASTC_12x10_Format: sN,
      RGBA_ASTC_12x12_Format: lN,
      RGBA_ASTC_4x4_Format: gN,
      RGBA_ASTC_5x4_Format: CN,
      RGBA_ASTC_5x5_Format: eN,
      RGBA_ASTC_6x5_Format: iN,
      RGBA_ASTC_6x6_Format: tN,
      RGBA_ASTC_8x5_Format: BN,
      RGBA_ASTC_8x6_Format: QN,
      RGBA_ASTC_8x8_Format: oN,
      RGBA_BPTC_Format: CG,
      RGBA_ETC2_EAC_Format: IN,
      RGBA_PVRTC_2BPPV1_Format: XU,
      RGBA_PVRTC_4BPPV1_Format: zU,
      RGBA_S3TC_DXT1_Format: AG,
      RGBA_S3TC_DXT3_Format: IG,
      RGBA_S3TC_DXT5_Format: gG,
      RGBDepthPacking: f1,
      RGBFormat: _m,
      RGBIntegerFormat: S1,
      RGB_BPTC_SIGNED_Format: cN,
      RGB_BPTC_UNSIGNED_Format: hN,
      RGB_ETC1_Format: $U,
      RGB_ETC2_Format: AN,
      RGB_PVRTC_2BPPV1_Format: jU,
      RGB_PVRTC_4BPPV1_Format: VU,
      RGB_S3TC_DXT1_Format: $0,
      RGDepthPacking: d1,
      RGFormat: Wm,
      RGIntegerFormat: VN,
      RawShaderMaterial: ub,
      Ray: fp,
      Raycaster: Tb,
      RectAreaLight: Jb,
      RedFormat: WN,
      RedIntegerFormat: UG,
      ReinhardToneMapping: d2,
      RenderTarget: O2,
      RepeatWrapping: MD,
      ReplaceStencilOp: p1,
      ReverseSubtractEquation: C2,
      RingGeometry: hF,
      SIGNED_RED_GREEN_RGTC2_Format: SN,
      SIGNED_RED_RGTC1_Format: uN,
      SRGBColorSpace: zi,
      SRGBTransfer: ot,
      Scene: sp,
      ShaderChunk: ne,
      ShaderLib: Gl,
      ShaderMaterial: VQ,
      ShadowMaterial: hb,
      Shape: mf,
      ShapeGeometry: uF,
      ShapePath: az,
      ShapeUtils: _c,
      ShortType: xm,
      Skeleton: mG,
      SkeletonHelper: $j,
      SkinnedMesh: tv,
      Source: kf,
      Sphere: jo,
      SphereGeometry: YG,
      Spherical: Wj,
      SphericalHarmonics3: Kb,
      SplineCurve: lv,
      SpotLight: dv,
      SpotLightHelper: Xj,
      Sprite: eb,
      SpriteMaterial: iv,
      SrcAlphaFactor: HU,
      SrcAlphaSaturateFactor: s2,
      SrcColorFactor: Q2,
      StaticCopyUsage: T1,
      StaticDrawUsage: rG,
      StaticReadUsage: Y1,
      StereoCamera: Gj,
      StreamCopyUsage: b1,
      StreamDrawUsage: L1,
      StreamReadUsage: H1,
      StringKeyframeTrack: zf,
      SubtractEquation: g2,
      SubtractiveBlending: sm,
      TOUCH: s1,
      TangentSpaceNormalMap: vD,
      TetrahedronGeometry: DF,
      Texture: pt,
      TextureLoader: Nb,
      TextureUtils: r5,
      TorusGeometry: SF,
      TorusKnotGeometry: fF,
      Triangle: va,
      TriangleFanDrawMode: fN,
      TriangleStripDrawMode: zm,
      TrianglesDrawMode: F2,
      TubeGeometry: dF,
      UVMapping: bN,
      Uint16BufferAttribute: gv,
      Uint32BufferAttribute: Cv,
      Uint8BufferAttribute: GZ,
      Uint8ClampedBufferAttribute: kZ,
      Uniform: ki,
      UniformsGroup: _j,
      UniformsLib: Yg,
      UniformsUtils: AF,
      UnsignedByteType: Xo,
      UnsignedInt248Type: UD,
      UnsignedInt5999Type: bm,
      UnsignedIntType: Zc,
      UnsignedShort4444Type: ZN,
      UnsignedShort5551Type: PN,
      UnsignedShortType: op,
      VSMShadowMap: pl,
      Vector2: ZI,
      Vector3: wA,
      Vector4: Xe,
      VectorKeyframeTrack: Tf,
      VideoTexture: R5,
      WebGL3DRenderTarget: sZ,
      WebGLArrayRenderTarget: rZ,
      WebGLCoordinateSystem: bc,
      WebGLCubeRenderTarget: W2,
      WebGLMultipleRenderTargets: sz,
      WebGLRenderTarget: BQ,
      WebGLRenderer: gb,
      WebGLUtils: Ab,
      WebGPUCoordinateSystem: sG,
      WireframeGeometry: cb,
      WrapAroundEnding: aG,
      ZeroCurvatureEnding: wf,
      ZeroFactor: t2,
      ZeroSlopeEnding: Gf,
      ZeroStencilOp: y1,
      createCanvasElement: x2,
    },
    Symbol.toStringTag,
    { value: "Module" },
  ),
)
var xI = Pf()
const HC = /* @__PURE__ */ qm(xI)
var pU = { exports: {} },
  cD = {}
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aT
function cz() {
  return (
    aT ||
      ((aT = 1),
      (cD.ConcurrentRoot = 1),
      (cD.ContinuousEventPriority = 4),
      (cD.DefaultEventPriority = 16),
      (cD.DiscreteEventPriority = 1),
      (cD.IdleEventPriority = 536870912),
      (cD.LegacyRoot = 0)),
    cD
  )
}
var hD = {}
/**
 * @license React
 * react-reconciler-constants.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rT
function hz() {
  return (
    rT ||
      ((rT = 1),
      process.env.NODE_ENV !== "production" &&
        (function () {
          var e =
              /*                        */
              1,
            A =
              /*            */
              4,
            I =
              /*                    */
              16,
            g =
              /*                       */
              536870912,
            C = e,
            i = A,
            B = I,
            o = g,
            r = 0,
            s = 1
          ;((hD.ConcurrentRoot = s),
            (hD.ContinuousEventPriority = i),
            (hD.DefaultEventPriority = B),
            (hD.DiscreteEventPriority = C),
            (hD.IdleEventPriority = o),
            (hD.LegacyRoot = r))
        })()),
    hD
  )
}
var sT
function uz() {
  return (
    sT ||
      ((sT = 1), process.env.NODE_ENV === "production" ? (pU.exports = cz()) : (pU.exports = hz())),
    pU.exports
  )
}
var Cp = uz()
function Dz(e) {
  let A
  const I = /* @__PURE__ */ new Set(),
    g = (s, h) => {
      const S = typeof s == "function" ? s(A) : s
      if (S !== A) {
        const d = A
        ;((A = h ? S : Object.assign({}, A, S)), I.forEach((w) => w(A, d)))
      }
    },
    C = () => A,
    i = (s, h = C, S = Object.is) => {
      console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware")
      let d = h(A)
      function w() {
        const M = h(A)
        if (!S(d, M)) {
          const K = d
          s((d = M), K)
        }
      }
      return (I.add(w), () => I.delete(w))
    },
    r = {
      setState: g,
      getState: C,
      subscribe: (s, h, S) => (h || S ? i(s, h, S) : (I.add(s), () => I.delete(s))),
      destroy: () => I.clear(),
    }
  return ((A = e(g, C, r)), r)
}
const Sz =
    typeof window > "u" ||
    !window.navigator ||
    /ServerSideRendering|^Deno\//.test(window.navigator.userAgent),
  lT = Sz ? xI.useEffect : xI.useLayoutEffect
function fz(e) {
  const A = typeof e == "function" ? Dz(e) : e,
    I = (g = A.getState, C = Object.is) => {
      const [, i] = xI.useReducer((R) => R + 1, 0),
        B = A.getState(),
        o = xI.useRef(B),
        r = xI.useRef(g),
        s = xI.useRef(C),
        h = xI.useRef(!1),
        S = xI.useRef()
      S.current === void 0 && (S.current = g(B))
      let d,
        w = !1
      ;((o.current !== B || r.current !== g || s.current !== C || h.current) &&
        ((d = g(B)), (w = !C(S.current, d))),
        lT(() => {
          ;(w && (S.current = d),
            (o.current = B),
            (r.current = g),
            (s.current = C),
            (h.current = !1))
        }))
      const M = xI.useRef(B)
      lT(() => {
        const R = () => {
            try {
              const L = A.getState(),
                Y = r.current(L)
              s.current(S.current, Y) || ((o.current = L), (S.current = Y), i())
            } catch {
              ;((h.current = !0), i())
            }
          },
          F = A.subscribe(R)
        return (A.getState() !== M.current && R(), F)
      }, [])
      const K = w ? d : S.current
      return (xI.useDebugValue(K), K)
    }
  return (
    Object.assign(I, A),
    (I[Symbol.iterator] = function () {
      console.warn("[useStore, api] = create() is deprecated and will be removed in v4")
      const g = [I, A]
      return {
        next() {
          const C = g.length <= 0
          return { value: g.shift(), done: C }
        },
      }
    }),
    I
  )
}
const dz = (e) => typeof e == "object" && typeof e.then == "function",
  Uf = []
function bb(e, A, I = (g, C) => g === C) {
  if (e === A) return !0
  if (!e || !A) return !1
  const g = e.length
  if (A.length !== g) return !1
  for (let C = 0; C < g; C++) if (!I(e[C], A[C])) return !1
  return !0
}
function Ob(e, A = null, I = !1, g = {}) {
  A === null && (A = [e])
  for (const i of Uf)
    if (bb(A, i.keys, i.equal)) {
      if (I) return
      if (Object.prototype.hasOwnProperty.call(i, "error")) throw i.error
      if (Object.prototype.hasOwnProperty.call(i, "response"))
        return (
          g.lifespan &&
            g.lifespan > 0 &&
            (i.timeout && clearTimeout(i.timeout), (i.timeout = setTimeout(i.remove, g.lifespan))),
          i.response
        )
      if (!I) throw i.promise
    }
  const C = {
    keys: A,
    equal: g.equal,
    remove: () => {
      const i = Uf.indexOf(C)
      i !== -1 && Uf.splice(i, 1)
    },
    promise:
      // Execute the promise
      (dz(e) ? e : e(...A))
        .then((i) => {
          ;((C.response = i),
            g.lifespan && g.lifespan > 0 && (C.timeout = setTimeout(C.remove, g.lifespan)))
        })
        .catch((i) => (C.error = i)),
  }
  if ((Uf.push(C), !I)) throw C.promise
}
const pF = (e, A, I) => Ob(e, A, !1, I),
  yz = (e, A, I) => void Ob(e, A, !0, I),
  pz = (e) => {
    if (e === void 0 || e.length === 0) Uf.splice(0, Uf.length)
    else {
      const A = Uf.find((I) => bb(e, I.keys, I.equal))
      A && A.remove()
    }
  }
var wU = { exports: {} },
  GU = { exports: {} },
  vK = {}
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cT
function wz() {
  return (
    cT ||
      ((cT = 1),
      (function (e) {
        function A(nA, fA) {
          var sA = nA.length
          nA.push(fA)
          A: for (; 0 < sA; ) {
            var $ = (sA - 1) >>> 1,
              EA = nA[$]
            if (0 < C(EA, fA)) ((nA[$] = fA), (nA[sA] = EA), (sA = $))
            else break A
          }
        }
        function I(nA) {
          return nA.length === 0 ? null : nA[0]
        }
        function g(nA) {
          if (nA.length === 0) return null
          var fA = nA[0],
            sA = nA.pop()
          if (sA !== fA) {
            nA[0] = sA
            A: for (var $ = 0, EA = nA.length, GA = EA >>> 1; $ < GA; ) {
              var DA = 2 * ($ + 1) - 1,
                dA = nA[DA],
                kA = DA + 1,
                NA = nA[kA]
              if (0 > C(dA, sA))
                kA < EA && 0 > C(NA, dA)
                  ? ((nA[$] = NA), (nA[kA] = sA), ($ = kA))
                  : ((nA[$] = dA), (nA[DA] = sA), ($ = DA))
              else if (kA < EA && 0 > C(NA, sA)) ((nA[$] = NA), (nA[kA] = sA), ($ = kA))
              else break A
            }
          }
          return fA
        }
        function C(nA, fA) {
          var sA = nA.sortIndex - fA.sortIndex
          return sA !== 0 ? sA : nA.id - fA.id
        }
        if (typeof performance == "object" && typeof performance.now == "function") {
          var i = performance
          e.unstable_now = function () {
            return i.now()
          }
        } else {
          var B = Date,
            o = B.now()
          e.unstable_now = function () {
            return B.now() - o
          }
        }
        var r = [],
          s = [],
          h = 1,
          S = null,
          d = 3,
          w = !1,
          M = !1,
          K = !1,
          R = typeof setTimeout == "function" ? setTimeout : null,
          F = typeof clearTimeout == "function" ? clearTimeout : null,
          L = typeof setImmediate < "u" ? setImmediate : null
        typeof navigator < "u" &&
          navigator.scheduling !== void 0 &&
          navigator.scheduling.isInputPending !== void 0 &&
          navigator.scheduling.isInputPending.bind(navigator.scheduling)
        function Y(nA) {
          for (var fA = I(s); fA !== null; ) {
            if (fA.callback === null) g(s)
            else if (fA.startTime <= nA) (g(s), (fA.sortIndex = fA.expirationTime), A(r, fA))
            else break
            fA = I(s)
          }
        }
        function H(nA) {
          if (((K = !1), Y(nA), !M))
            if (I(r) !== null) ((M = !0), yA(V))
            else {
              var fA = I(s)
              fA !== null && LA(H, fA.startTime - nA)
            }
        }
        function V(nA, fA) {
          ;((M = !1), K && ((K = !1), F(AA), (AA = -1)), (w = !0))
          var sA = d
          try {
            for (Y(fA), S = I(r); S !== null && (!(S.expirationTime > fA) || (nA && !eA())); ) {
              var $ = S.callback
              if (typeof $ == "function") {
                ;((S.callback = null), (d = S.priorityLevel))
                var EA = $(S.expirationTime <= fA)
                ;((fA = e.unstable_now()),
                  typeof EA == "function" ? (S.callback = EA) : S === I(r) && g(r),
                  Y(fA))
              } else g(r)
              S = I(r)
            }
            if (S !== null) var GA = !0
            else {
              var DA = I(s)
              ;(DA !== null && LA(H, DA.startTime - fA), (GA = !1))
            }
            return GA
          } finally {
            ;((S = null), (d = sA), (w = !1))
          }
        }
        var j = !1,
          P = null,
          AA = -1,
          X = 5,
          _ = -1
        function eA() {
          return !(e.unstable_now() - _ < X)
        }
        function CA() {
          if (P !== null) {
            var nA = e.unstable_now()
            _ = nA
            var fA = !0
            try {
              fA = P(!0, nA)
            } finally {
              fA ? aA() : ((j = !1), (P = null))
            }
          } else j = !1
        }
        var aA
        if (typeof L == "function")
          aA = function () {
            L(CA)
          }
        else if (typeof MessageChannel < "u") {
          var lA = new MessageChannel(),
            JA = lA.port2
          ;((lA.port1.onmessage = CA),
            (aA = function () {
              JA.postMessage(null)
            }))
        } else
          aA = function () {
            R(CA, 0)
          }
        function yA(nA) {
          ;((P = nA), j || ((j = !0), aA()))
        }
        function LA(nA, fA) {
          AA = R(function () {
            nA(e.unstable_now())
          }, fA)
        }
        ;((e.unstable_IdlePriority = 5),
          (e.unstable_ImmediatePriority = 1),
          (e.unstable_LowPriority = 4),
          (e.unstable_NormalPriority = 3),
          (e.unstable_Profiling = null),
          (e.unstable_UserBlockingPriority = 2),
          (e.unstable_cancelCallback = function (nA) {
            nA.callback = null
          }),
          (e.unstable_continueExecution = function () {
            M || w || ((M = !0), yA(V))
          }),
          (e.unstable_forceFrameRate = function (nA) {
            0 > nA || 125 < nA
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
                )
              : (X = 0 < nA ? Math.floor(1e3 / nA) : 5)
          }),
          (e.unstable_getCurrentPriorityLevel = function () {
            return d
          }),
          (e.unstable_getFirstCallbackNode = function () {
            return I(r)
          }),
          (e.unstable_next = function (nA) {
            switch (d) {
              case 1:
              case 2:
              case 3:
                var fA = 3
                break
              default:
                fA = d
            }
            var sA = d
            d = fA
            try {
              return nA()
            } finally {
              d = sA
            }
          }),
          (e.unstable_pauseExecution = function () {}),
          (e.unstable_requestPaint = function () {}),
          (e.unstable_runWithPriority = function (nA, fA) {
            switch (nA) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break
              default:
                nA = 3
            }
            var sA = d
            d = nA
            try {
              return fA()
            } finally {
              d = sA
            }
          }),
          (e.unstable_scheduleCallback = function (nA, fA, sA) {
            var $ = e.unstable_now()
            switch (
              (typeof sA == "object" && sA !== null
                ? ((sA = sA.delay), (sA = typeof sA == "number" && 0 < sA ? $ + sA : $))
                : (sA = $),
              nA)
            ) {
              case 1:
                var EA = -1
                break
              case 2:
                EA = 250
                break
              case 5:
                EA = 1073741823
                break
              case 4:
                EA = 1e4
                break
              default:
                EA = 5e3
            }
            return (
              (EA = sA + EA),
              (nA = {
                id: h++,
                callback: fA,
                priorityLevel: nA,
                startTime: sA,
                expirationTime: EA,
                sortIndex: -1,
              }),
              sA > $
                ? ((nA.sortIndex = sA),
                  A(s, nA),
                  I(r) === null &&
                    nA === I(s) &&
                    (K ? (F(AA), (AA = -1)) : (K = !0), LA(H, sA - $)))
                : ((nA.sortIndex = EA), A(r, nA), M || w || ((M = !0), yA(V))),
              nA
            )
          }),
          (e.unstable_shouldYield = eA),
          (e.unstable_wrapCallback = function (nA) {
            var fA = d
            return function () {
              var sA = d
              d = fA
              try {
                return nA.apply(this, arguments)
              } finally {
                d = sA
              }
            }
          }))
      })(vK)),
    vK
  )
}
var LK = {}
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hT
function Gz() {
  return (
    hT ||
      ((hT = 1),
      (function (e) {
        process.env.NODE_ENV !== "production" &&
          (function () {
            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" &&
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" &&
              __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error())
            var A = !1,
              I = !1,
              g = 5
            function C(MA, OA) {
              var aI = MA.length
              ;(MA.push(OA), o(MA, OA, aI))
            }
            function i(MA) {
              return MA.length === 0 ? null : MA[0]
            }
            function B(MA) {
              if (MA.length === 0) return null
              var OA = MA[0],
                aI = MA.pop()
              return (aI !== OA && ((MA[0] = aI), r(MA, aI, 0)), OA)
            }
            function o(MA, OA, aI) {
              for (var RI = aI; RI > 0; ) {
                var VA = (RI - 1) >>> 1,
                  ag = MA[VA]
                if (s(ag, OA) > 0) ((MA[VA] = OA), (MA[RI] = ag), (RI = VA))
                else return
              }
            }
            function r(MA, OA, aI) {
              for (var RI = aI, VA = MA.length, ag = VA >>> 1; RI < ag; ) {
                var XI = (RI + 1) * 2 - 1,
                  $I = MA[XI],
                  SA = XI + 1,
                  NI = MA[SA]
                if (s($I, OA) < 0)
                  SA < VA && s(NI, $I) < 0
                    ? ((MA[RI] = NI), (MA[SA] = OA), (RI = SA))
                    : ((MA[RI] = $I), (MA[XI] = OA), (RI = XI))
                else if (SA < VA && s(NI, OA) < 0) ((MA[RI] = NI), (MA[SA] = OA), (RI = SA))
                else return
              }
            }
            function s(MA, OA) {
              var aI = MA.sortIndex - OA.sortIndex
              return aI !== 0 ? aI : MA.id - OA.id
            }
            var h = 1,
              S = 2,
              d = 3,
              w = 4,
              M = 5
            function K(MA, OA) {}
            var R = typeof performance == "object" && typeof performance.now == "function"
            if (R) {
              var F = performance
              e.unstable_now = function () {
                return F.now()
              }
            } else {
              var L = Date,
                Y = L.now()
              e.unstable_now = function () {
                return L.now() - Y
              }
            }
            var H = 1073741823,
              V = -1,
              j = 250,
              P = 5e3,
              AA = 1e4,
              X = H,
              _ = [],
              eA = [],
              CA = 1,
              aA = null,
              lA = d,
              JA = !1,
              yA = !1,
              LA = !1,
              nA = typeof setTimeout == "function" ? setTimeout : null,
              fA = typeof clearTimeout == "function" ? clearTimeout : null,
              sA = typeof setImmediate < "u" ? setImmediate : null
            typeof navigator < "u" &&
              navigator.scheduling !== void 0 &&
              navigator.scheduling.isInputPending !== void 0 &&
              navigator.scheduling.isInputPending.bind(navigator.scheduling)
            function $(MA) {
              for (var OA = i(eA); OA !== null; ) {
                if (OA.callback === null) B(eA)
                else if (OA.startTime <= MA) (B(eA), (OA.sortIndex = OA.expirationTime), C(_, OA))
                else return
                OA = i(eA)
              }
            }
            function EA(MA) {
              if (((LA = !1), $(MA), !yA))
                if (i(_) !== null) ((yA = !0), nI(GA))
                else {
                  var OA = i(eA)
                  OA !== null && UI(EA, OA.startTime - MA)
                }
            }
            function GA(MA, OA) {
              ;((yA = !1), LA && ((LA = !1), GI()), (JA = !0))
              var aI = lA
              try {
                var RI
                if (!I) return DA(MA, OA)
              } finally {
                ;((aA = null), (lA = aI), (JA = !1))
              }
            }
            function DA(MA, OA) {
              var aI = OA
              for (
                $(aI), aA = i(_);
                aA !== null && !A && !(aA.expirationTime > aI && (!MA || YI()));
              ) {
                var RI = aA.callback
                if (typeof RI == "function") {
                  ;((aA.callback = null), (lA = aA.priorityLevel))
                  var VA = aA.expirationTime <= aI,
                    ag = RI(VA)
                  ;((aI = e.unstable_now()),
                    typeof ag == "function" ? (aA.callback = ag) : aA === i(_) && B(_),
                    $(aI))
                } else B(_)
                aA = i(_)
              }
              if (aA !== null) return !0
              var XI = i(eA)
              return (XI !== null && UI(EA, XI.startTime - aI), !1)
            }
            function dA(MA, OA) {
              switch (MA) {
                case h:
                case S:
                case d:
                case w:
                case M:
                  break
                default:
                  MA = d
              }
              var aI = lA
              lA = MA
              try {
                return OA()
              } finally {
                lA = aI
              }
            }
            function kA(MA) {
              var OA
              switch (lA) {
                case h:
                case S:
                case d:
                  OA = d
                  break
                default:
                  OA = lA
                  break
              }
              var aI = lA
              lA = OA
              try {
                return MA()
              } finally {
                lA = aI
              }
            }
            function NA(MA) {
              var OA = lA
              return function () {
                var aI = lA
                lA = OA
                try {
                  return MA.apply(this, arguments)
                } finally {
                  lA = aI
                }
              }
            }
            function qA(MA, OA, aI) {
              var RI = e.unstable_now(),
                VA
              if (typeof aI == "object" && aI !== null) {
                var ag = aI.delay
                typeof ag == "number" && ag > 0 ? (VA = RI + ag) : (VA = RI)
              } else VA = RI
              var XI
              switch (MA) {
                case h:
                  XI = V
                  break
                case S:
                  XI = j
                  break
                case M:
                  XI = X
                  break
                case w:
                  XI = AA
                  break
                case d:
                default:
                  XI = P
                  break
              }
              var $I = VA + XI,
                SA = {
                  id: CA++,
                  callback: OA,
                  priorityLevel: MA,
                  startTime: VA,
                  expirationTime: $I,
                  sortIndex: -1,
                }
              return (
                VA > RI
                  ? ((SA.sortIndex = VA),
                    C(eA, SA),
                    i(_) === null && SA === i(eA) && (LA ? GI() : (LA = !0), UI(EA, VA - RI)))
                  : ((SA.sortIndex = $I), C(_, SA), !yA && !JA && ((yA = !0), nI(GA))),
                SA
              )
            }
            function ZA() {}
            function sI() {
              !yA && !JA && ((yA = !0), nI(GA))
            }
            function cI() {
              return i(_)
            }
            function YA(MA) {
              MA.callback = null
            }
            function eI() {
              return lA
            }
            var uA = !1,
              hI = null,
              II = -1,
              pI = g,
              AI = -1
            function YI() {
              var MA = e.unstable_now() - AI
              return !(MA < pI)
            }
            function SI() {}
            function QA(MA) {
              if (MA < 0 || MA > 125) {
                console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
                )
                return
              }
              MA > 0 ? (pI = Math.floor(1e3 / MA)) : (pI = g)
            }
            var tA = function () {
                if (hI !== null) {
                  var MA = e.unstable_now()
                  AI = MA
                  var OA = !0,
                    aI = !0
                  try {
                    aI = hI(OA, MA)
                  } finally {
                    aI ? FA() : ((uA = !1), (hI = null))
                  }
                } else uA = !1
              },
              FA
            if (typeof sA == "function")
              FA = function () {
                sA(tA)
              }
            else if (typeof MessageChannel < "u") {
              var WA = new MessageChannel(),
                jA = WA.port2
              ;((WA.port1.onmessage = tA),
                (FA = function () {
                  jA.postMessage(null)
                }))
            } else
              FA = function () {
                nA(tA, 0)
              }
            function nI(MA) {
              ;((hI = MA), uA || ((uA = !0), FA()))
            }
            function UI(MA, OA) {
              II = nA(function () {
                MA(e.unstable_now())
              }, OA)
            }
            function GI() {
              ;(fA(II), (II = -1))
            }
            var LI = SI,
              Bg = null
            ;((e.unstable_IdlePriority = M),
              (e.unstable_ImmediatePriority = h),
              (e.unstable_LowPriority = w),
              (e.unstable_NormalPriority = d),
              (e.unstable_Profiling = Bg),
              (e.unstable_UserBlockingPriority = S),
              (e.unstable_cancelCallback = YA),
              (e.unstable_continueExecution = sI),
              (e.unstable_forceFrameRate = QA),
              (e.unstable_getCurrentPriorityLevel = eI),
              (e.unstable_getFirstCallbackNode = cI),
              (e.unstable_next = kA),
              (e.unstable_pauseExecution = ZA),
              (e.unstable_requestPaint = LI),
              (e.unstable_runWithPriority = dA),
              (e.unstable_scheduleCallback = qA),
              (e.unstable_shouldYield = YI),
              (e.unstable_wrapCallback = NA),
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" &&
                typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" &&
                __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error()))
          })()
      })(LK)),
    LK
  )
}
var uT
function Fv() {
  return (
    uT ||
      ((uT = 1), process.env.NODE_ENV === "production" ? (GU.exports = wz()) : (GU.exports = Gz())),
    GU.exports
  )
}
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var YK, DT
function kz() {
  return (
    DT ||
      ((DT = 1),
      (YK = function (A) {
        var I = {},
          g = Pf(),
          C = Fv(),
          i = Object.assign
        function B(u) {
          for (
            var D = "https://reactjs.org/docs/error-decoder.html?invariant=" + u, N = 1;
            N < arguments.length;
            N++
          )
            D += "&args[]=" + encodeURIComponent(arguments[N])
          return (
            "Minified React error #" +
            u +
            "; visit " +
            D +
            " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
          )
        }
        var o = g.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
          r = Symbol.for("react.element"),
          s = Symbol.for("react.portal"),
          h = Symbol.for("react.fragment"),
          S = Symbol.for("react.strict_mode"),
          d = Symbol.for("react.profiler"),
          w = Symbol.for("react.provider"),
          M = Symbol.for("react.context"),
          K = Symbol.for("react.forward_ref"),
          R = Symbol.for("react.suspense"),
          F = Symbol.for("react.suspense_list"),
          L = Symbol.for("react.memo"),
          Y = Symbol.for("react.lazy"),
          H = Symbol.for("react.offscreen"),
          V = Symbol.iterator
        function j(u) {
          return u === null || typeof u != "object"
            ? null
            : ((u = (V && u[V]) || u["@@iterator"]), typeof u == "function" ? u : null)
        }
        function P(u) {
          if (u == null) return null
          if (typeof u == "function") return u.displayName || u.name || null
          if (typeof u == "string") return u
          switch (u) {
            case h:
              return "Fragment"
            case s:
              return "Portal"
            case d:
              return "Profiler"
            case S:
              return "StrictMode"
            case R:
              return "Suspense"
            case F:
              return "SuspenseList"
          }
          if (typeof u == "object")
            switch (u.$$typeof) {
              case M:
                return (u.displayName || "Context") + ".Consumer"
              case w:
                return (u._context.displayName || "Context") + ".Provider"
              case K:
                var D = u.render
                return (
                  (u = u.displayName),
                  u ||
                    ((u = D.displayName || D.name || ""),
                    (u = u !== "" ? "ForwardRef(" + u + ")" : "ForwardRef")),
                  u
                )
              case L:
                return ((D = u.displayName || null), D !== null ? D : P(u.type) || "Memo")
              case Y:
                ;((D = u._payload), (u = u._init))
                try {
                  return P(u(D))
                } catch {}
            }
          return null
        }
        function AA(u) {
          var D = u.type
          switch (u.tag) {
            case 24:
              return "Cache"
            case 9:
              return (D.displayName || "Context") + ".Consumer"
            case 10:
              return (D._context.displayName || "Context") + ".Provider"
            case 18:
              return "DehydratedFragment"
            case 11:
              return (
                (u = D.render),
                (u = u.displayName || u.name || ""),
                D.displayName || (u !== "" ? "ForwardRef(" + u + ")" : "ForwardRef")
              )
            case 7:
              return "Fragment"
            case 5:
              return D
            case 4:
              return "Portal"
            case 3:
              return "Root"
            case 6:
              return "Text"
            case 16:
              return P(D)
            case 8:
              return D === S ? "StrictMode" : "Mode"
            case 22:
              return "Offscreen"
            case 12:
              return "Profiler"
            case 21:
              return "Scope"
            case 13:
              return "Suspense"
            case 19:
              return "SuspenseList"
            case 25:
              return "TracingMarker"
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
              if (typeof D == "function") return D.displayName || D.name || null
              if (typeof D == "string") return D
          }
          return null
        }
        function X(u) {
          var D = u,
            N = u
          if (u.alternate) for (; D.return; ) D = D.return
          else {
            u = D
            do ((D = u), D.flags & 4098 && (N = D.return), (u = D.return))
            while (u)
          }
          return D.tag === 3 ? N : null
        }
        function _(u) {
          if (X(u) !== u) throw Error(B(188))
        }
        function eA(u) {
          var D = u.alternate
          if (!D) {
            if (((D = X(u)), D === null)) throw Error(B(188))
            return D !== u ? null : u
          }
          for (var N = u, v = D; ; ) {
            var O = N.return
            if (O === null) break
            var IA = O.alternate
            if (IA === null) {
              if (((v = O.return), v !== null)) {
                N = v
                continue
              }
              break
            }
            if (O.child === IA.child) {
              for (IA = O.child; IA; ) {
                if (IA === N) return (_(O), u)
                if (IA === v) return (_(O), D)
                IA = IA.sibling
              }
              throw Error(B(188))
            }
            if (N.return !== v.return) ((N = O), (v = IA))
            else {
              for (var UA = !1, CI = O.child; CI; ) {
                if (CI === N) {
                  ;((UA = !0), (N = O), (v = IA))
                  break
                }
                if (CI === v) {
                  ;((UA = !0), (v = O), (N = IA))
                  break
                }
                CI = CI.sibling
              }
              if (!UA) {
                for (CI = IA.child; CI; ) {
                  if (CI === N) {
                    ;((UA = !0), (N = IA), (v = O))
                    break
                  }
                  if (CI === v) {
                    ;((UA = !0), (v = IA), (N = O))
                    break
                  }
                  CI = CI.sibling
                }
                if (!UA) throw Error(B(189))
              }
            }
            if (N.alternate !== v) throw Error(B(190))
          }
          if (N.tag !== 3) throw Error(B(188))
          return N.stateNode.current === N ? u : D
        }
        function CA(u) {
          return ((u = eA(u)), u !== null ? aA(u) : null)
        }
        function aA(u) {
          if (u.tag === 5 || u.tag === 6) return u
          for (u = u.child; u !== null; ) {
            var D = aA(u)
            if (D !== null) return D
            u = u.sibling
          }
          return null
        }
        function lA(u) {
          if (u.tag === 5 || u.tag === 6) return u
          for (u = u.child; u !== null; ) {
            if (u.tag !== 4) {
              var D = lA(u)
              if (D !== null) return D
            }
            u = u.sibling
          }
          return null
        }
        var JA = Array.isArray,
          yA = A.getPublicInstance,
          LA = A.getRootHostContext,
          nA = A.getChildHostContext,
          fA = A.prepareForCommit,
          sA = A.resetAfterCommit,
          $ = A.createInstance,
          EA = A.appendInitialChild,
          GA = A.finalizeInitialChildren,
          DA = A.prepareUpdate,
          dA = A.shouldSetTextContent,
          kA = A.createTextInstance,
          NA = A.scheduleTimeout,
          qA = A.cancelTimeout,
          ZA = A.noTimeout,
          sI = A.isPrimaryRenderer,
          cI = A.supportsMutation,
          YA = A.supportsPersistence,
          eI = A.supportsHydration,
          uA = A.getInstanceFromNode,
          hI = A.preparePortalMount,
          II = A.getCurrentEventPriority,
          pI = A.detachDeletedInstance,
          AI = A.supportsMicrotasks,
          YI = A.scheduleMicrotask,
          SI = A.supportsTestSelectors,
          QA = A.findFiberRoot,
          tA = A.getBoundingRect,
          FA = A.getTextContent,
          WA = A.isHiddenSubtree,
          jA = A.matchAccessibilityRole,
          nI = A.setFocusIfFocusable,
          UI = A.setupIntersectionObserver,
          GI = A.appendChild,
          LI = A.appendChildToContainer,
          Bg = A.commitTextUpdate,
          MA = A.commitMount,
          OA = A.commitUpdate,
          aI = A.insertBefore,
          RI = A.insertInContainerBefore,
          VA = A.removeChild,
          ag = A.removeChildFromContainer,
          XI = A.resetTextContent,
          $I = A.hideInstance,
          SA = A.hideTextInstance,
          NI = A.unhideInstance,
          HA = A.unhideTextInstance,
          iI = A.clearContainer,
          zI = A.cloneInstance,
          qI = A.createContainerChildSet,
          dg = A.appendChildToContainerChildSet,
          $g = A.finalizeContainerChildren,
          Qg = A.replaceContainerChildren,
          Fg = A.cloneHiddenInstance,
          jC = A.cloneHiddenTextInstance,
          mC = A.canHydrateInstance,
          zC = A.canHydrateTextInstance,
          Ee = A.canHydrateSuspenseInstance,
          ei = A.isSuspenseInstancePending,
          fe = A.isSuspenseInstanceFallback,
          Ei = A.registerSuspenseInstanceRetry,
          vi = A.getNextHydratableSibling,
          Li = A.getFirstHydratableChild,
          mA = A.getFirstHydratableChildWithinContainer,
          TI = A.getFirstHydratableChildWithinSuspenseInstance,
          eg = A.hydrateInstance,
          Tg = A.hydrateTextInstance,
          OC = A.hydrateSuspenseInstance,
          JC = A.getNextHydratableInstanceAfterSuspenseInstance,
          jg = A.commitHydratedContainer,
          rA = A.commitHydratedSuspenseInstance,
          _A = A.clearSuspenseBoundary,
          oI = A.clearSuspenseBoundaryFromContainer,
          QI = A.shouldDeleteUnhydratedTailInstances,
          PA = A.didNotMatchHydratedContainerTextInstance,
          gg = A.didNotMatchHydratedTextInstance,
          EI
        function hg(u) {
          if (EI === void 0)
            try {
              throw Error()
            } catch (N) {
              var D = N.stack.trim().match(/\n( *(at )?)/)
              EI = (D && D[1]) || ""
            }
          return (
            `
` +
            EI +
            u
          )
        }
        var yg = !1
        function rg(u, D) {
          if (!u || yg) return ""
          yg = !0
          var N = Error.prepareStackTrace
          Error.prepareStackTrace = void 0
          try {
            if (D)
              if (
                ((D = function () {
                  throw Error()
                }),
                Object.defineProperty(D.prototype, "props", {
                  set: function () {
                    throw Error()
                  },
                }),
                typeof Reflect == "object" && Reflect.construct)
              ) {
                try {
                  Reflect.construct(D, [])
                } catch (ng) {
                  var v = ng
                }
                Reflect.construct(u, [], D)
              } else {
                try {
                  D.call()
                } catch (ng) {
                  v = ng
                }
                u.call(D.prototype)
              }
            else {
              try {
                throw Error()
              } catch (ng) {
                v = ng
              }
              u()
            }
          } catch (ng) {
            if (ng && v && typeof ng.stack == "string") {
              for (
                var O = ng.stack.split(`
`),
                  IA = v.stack.split(`
`),
                  UA = O.length - 1,
                  CI = IA.length - 1;
                1 <= UA && 0 <= CI && O[UA] !== IA[CI];
              )
                CI--
              for (; 1 <= UA && 0 <= CI; UA--, CI--)
                if (O[UA] !== IA[CI]) {
                  if (UA !== 1 || CI !== 1)
                    do
                      if ((UA--, CI--, 0 > CI || O[UA] !== IA[CI])) {
                        var HI =
                          `
` + O[UA].replace(" at new ", " at ")
                        return (
                          u.displayName &&
                            HI.includes("<anonymous>") &&
                            (HI = HI.replace("<anonymous>", u.displayName)),
                          HI
                        )
                      }
                    while (1 <= UA && 0 <= CI)
                  break
                }
            }
          } finally {
            ;((yg = !1), (Error.prepareStackTrace = N))
          }
          return (u = u ? u.displayName || u.name : "") ? hg(u) : ""
        }
        var eC = Object.prototype.hasOwnProperty,
          Rg = [],
          pC = -1
        function wC(u) {
          return { current: u }
        }
        function mg(u) {
          0 > pC || ((u.current = Rg[pC]), (Rg[pC] = null), pC--)
        }
        function UC(u, D) {
          ;(pC++, (Rg[pC] = u.current), (u.current = D))
        }
        var iC = {},
          Gg = wC(iC),
          _C = wC(!1),
          vC = iC
        function ii(u, D) {
          var N = u.type.contextTypes
          if (!N) return iC
          var v = u.stateNode
          if (v && v.__reactInternalMemoizedUnmaskedChildContext === D)
            return v.__reactInternalMemoizedMaskedChildContext
          var O = {},
            IA
          for (IA in N) O[IA] = D[IA]
          return (
            v &&
              ((u = u.stateNode),
              (u.__reactInternalMemoizedUnmaskedChildContext = D),
              (u.__reactInternalMemoizedMaskedChildContext = O)),
            O
          )
        }
        function qe(u) {
          return ((u = u.childContextTypes), u != null)
        }
        function pe() {
          ;(mg(_C), mg(Gg))
        }
        function Mi(u, D, N) {
          if (Gg.current !== iC) throw Error(B(168))
          ;(UC(Gg, D), UC(_C, N))
        }
        function ae(u, D, N) {
          var v = u.stateNode
          if (((D = D.childContextTypes), typeof v.getChildContext != "function")) return N
          v = v.getChildContext()
          for (var O in v) if (!(O in D)) throw Error(B(108, AA(u) || "Unknown", O))
          return i({}, N, v)
        }
        function ai(u) {
          return (
            (u = ((u = u.stateNode) && u.__reactInternalMemoizedMergedChildContext) || iC),
            (vC = Gg.current),
            UC(Gg, u),
            UC(_C, _C.current),
            !0
          )
        }
        function fi(u, D, N) {
          var v = u.stateNode
          if (!v) throw Error(B(169))
          ;(N
            ? ((u = ae(u, D, vC)),
              (v.__reactInternalMemoizedMergedChildContext = u),
              mg(_C),
              mg(Gg),
              UC(Gg, u))
            : mg(_C),
            UC(_C, N))
        }
        var He = Math.clz32 ? Math.clz32 : vn,
          Et = Math.log,
          Yi = Math.LN2
        function vn(u) {
          return ((u >>>= 0), u === 0 ? 32 : (31 - ((Et(u) / Yi) | 0)) | 0)
        }
        var aB = 64,
          XC = 4194304
        function dB(u) {
          switch (u & -u) {
            case 1:
              return 1
            case 2:
              return 2
            case 4:
              return 4
            case 8:
              return 8
            case 16:
              return 16
            case 32:
              return 32
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return u & 4194240
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              return u & 130023424
            case 134217728:
              return 134217728
            case 268435456:
              return 268435456
            case 536870912:
              return 536870912
            case 1073741824:
              return 1073741824
            default:
              return u
          }
        }
        function zQ(u, D) {
          var N = u.pendingLanes
          if (N === 0) return 0
          var v = 0,
            O = u.suspendedLanes,
            IA = u.pingedLanes,
            UA = N & 268435455
          if (UA !== 0) {
            var CI = UA & ~O
            CI !== 0 ? (v = dB(CI)) : ((IA &= UA), IA !== 0 && (v = dB(IA)))
          } else ((UA = N & ~O), UA !== 0 ? (v = dB(UA)) : IA !== 0 && (v = dB(IA)))
          if (v === 0) return 0
          if (
            D !== 0 &&
            D !== v &&
            !(D & O) &&
            ((O = v & -v), (IA = D & -D), O >= IA || (O === 16 && (IA & 4194240) !== 0))
          )
            return D
          if ((v & 4 && (v |= N & 16), (D = u.entangledLanes), D !== 0))
            for (u = u.entanglements, D &= v; 0 < D; )
              ((N = 31 - He(D)), (O = 1 << N), (v |= u[N]), (D &= ~O))
          return v
        }
        function Wt(u, D) {
          switch (u) {
            case 1:
            case 2:
            case 4:
              return D + 250
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return D + 5e3
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              return -1
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
              return -1
            default:
              return -1
          }
        }
        function ZC(u, D) {
          for (
            var N = u.suspendedLanes, v = u.pingedLanes, O = u.expirationTimes, IA = u.pendingLanes;
            0 < IA;
          ) {
            var UA = 31 - He(IA),
              CI = 1 << UA,
              HI = O[UA]
            ;(HI === -1
              ? (!(CI & N) || CI & v) && (O[UA] = Wt(CI, D))
              : HI <= D && (u.expiredLanes |= CI),
              (IA &= ~CI))
          }
        }
        function Ui(u) {
          return ((u = u.pendingLanes & -1073741825), u !== 0 ? u : u & 1073741824 ? 1073741824 : 0)
        }
        function $o(u) {
          for (var D = [], N = 0; 31 > N; N++) D.push(u)
          return D
        }
        function oC(u, D, N) {
          ;((u.pendingLanes |= D),
            D !== 536870912 && ((u.suspendedLanes = 0), (u.pingedLanes = 0)),
            (u = u.eventTimes),
            (D = 31 - He(D)),
            (u[D] = N))
        }
        function RQ(u, D) {
          var N = u.pendingLanes & ~D
          ;((u.pendingLanes = D),
            (u.suspendedLanes = 0),
            (u.pingedLanes = 0),
            (u.expiredLanes &= D),
            (u.mutableReadLanes &= D),
            (u.entangledLanes &= D),
            (D = u.entanglements))
          var v = u.eventTimes
          for (u = u.expirationTimes; 0 < N; ) {
            var O = 31 - He(N),
              IA = 1 << O
            ;((D[O] = 0), (v[O] = -1), (u[O] = -1), (N &= ~IA))
          }
        }
        function Te(u, D) {
          var N = (u.entangledLanes |= D)
          for (u = u.entanglements; N; ) {
            var v = 31 - He(N),
              O = 1 << v
            ;((O & D) | (u[v] & D) && (u[v] |= D), (N &= ~O))
          }
        }
        var hC = 0
        function Vt(u) {
          return ((u &= -u), 1 < u ? (4 < u ? (u & 268435455 ? 16 : 536870912) : 4) : 1)
        }
        var wt = C.unstable_scheduleCallback,
          di = C.unstable_cancelCallback,
          Me = C.unstable_shouldYield,
          Ha = C.unstable_requestPaint,
          ee = C.unstable_now,
          Zi = C.unstable_ImmediatePriority,
          XQ = C.unstable_UserBlockingPriority,
          rB = C.unstable_NormalPriority,
          $Q = C.unstable_IdlePriority,
          JQ = null,
          HB = null
        function TB(u) {
          if (HB && typeof HB.onCommitFiberRoot == "function")
            try {
              HB.onCommitFiberRoot(JQ, u, void 0, (u.current.flags & 128) === 128)
            } catch {}
        }
        function An(u, D) {
          return (u === D && (u !== 0 || 1 / u === 1 / D)) || (u !== u && D !== D)
        }
        var Gt = typeof Object.is == "function" ? Object.is : An,
          Ni = null,
          QQ = !1,
          jt = !1
        function Ao(u) {
          Ni === null ? (Ni = [u]) : Ni.push(u)
        }
        function In(u) {
          ;((QQ = !0), Ao(u))
        }
        function zt() {
          if (!jt && Ni !== null) {
            jt = !0
            var u = 0,
              D = hC
            try {
              var N = Ni
              for (hC = 1; u < N.length; u++) {
                var v = N[u]
                do v = v(!0)
                while (v !== null)
              }
              ;((Ni = null), (QQ = !1))
            } catch (O) {
              throw (Ni !== null && (Ni = Ni.slice(u + 1)), wt(Zi, zt), O)
            } finally {
              ;((hC = D), (jt = !1))
            }
          }
          return null
        }
        var gn = o.ReactCurrentBatchConfig
        function yB(u, D) {
          if (Gt(u, D)) return !0
          if (typeof u != "object" || u === null || typeof D != "object" || D === null) return !1
          var N = Object.keys(u),
            v = Object.keys(D)
          if (N.length !== v.length) return !1
          for (v = 0; v < N.length; v++) {
            var O = N[v]
            if (!eC.call(D, O) || !Gt(u[O], D[O])) return !1
          }
          return !0
        }
        function iA(u) {
          switch (u.tag) {
            case 5:
              return hg(u.type)
            case 16:
              return hg("Lazy")
            case 13:
              return hg("Suspense")
            case 19:
              return hg("SuspenseList")
            case 0:
            case 2:
            case 15:
              return ((u = rg(u.type, !1)), u)
            case 11:
              return ((u = rg(u.type.render, !1)), u)
            case 1:
              return ((u = rg(u.type, !0)), u)
            default:
              return ""
          }
        }
        function vA(u, D) {
          if (u && u.defaultProps) {
            ;((D = i({}, D)), (u = u.defaultProps))
            for (var N in u) D[N] === void 0 && (D[N] = u[N])
            return D
          }
          return D
        }
        var rI = wC(null),
          mI = null,
          ig = null,
          AC = null
        function pg() {
          AC = ig = mI = null
        }
        function tC(u, D, N) {
          sI
            ? (UC(rI, D._currentValue), (D._currentValue = N))
            : (UC(rI, D._currentValue2), (D._currentValue2 = N))
        }
        function BC(u) {
          var D = rI.current
          ;(mg(rI), sI ? (u._currentValue = D) : (u._currentValue2 = D))
        }
        function NC(u, D, N) {
          for (; u !== null; ) {
            var v = u.alternate
            if (
              ((u.childLanes & D) !== D
                ? ((u.childLanes |= D), v !== null && (v.childLanes |= D))
                : v !== null && (v.childLanes & D) !== D && (v.childLanes |= D),
              u === N)
            )
              break
            u = u.return
          }
        }
        function KC(u, D) {
          ;((mI = u),
            (AC = ig = null),
            (u = u.dependencies),
            u !== null &&
              u.firstContext !== null &&
              (u.lanes & D && (te = !0), (u.firstContext = null)))
        }
        function GC(u) {
          var D = sI ? u._currentValue : u._currentValue2
          if (AC !== u)
            if (((u = { context: u, memoizedValue: D, next: null }), ig === null)) {
              if (mI === null) throw Error(B(308))
              ;((ig = u), (mI.dependencies = { lanes: 0, firstContext: u }))
            } else ig = ig.next = u
          return D
        }
        var ie = null,
          we = !1
        function le(u) {
          u.updateQueue = {
            baseState: u.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, interleaved: null, lanes: 0 },
            effects: null,
          }
        }
        function Io(u, D) {
          ;((u = u.updateQueue),
            D.updateQueue === u &&
              (D.updateQueue = {
                baseState: u.baseState,
                firstBaseUpdate: u.firstBaseUpdate,
                lastBaseUpdate: u.lastBaseUpdate,
                shared: u.shared,
                effects: u.effects,
              }))
        }
        function KQ(u, D) {
          return { eventTime: u, lane: D, tag: 0, payload: null, callback: null, next: null }
        }
        function So(u, D) {
          var N = u.updateQueue
          N !== null &&
            ((N = N.shared),
            xi !== null && u.mode & 1 && !($C & 2)
              ? ((u = N.interleaved),
                u === null
                  ? ((D.next = D), ie === null ? (ie = [N]) : ie.push(N))
                  : ((D.next = u.next), (u.next = D)),
                (N.interleaved = D))
              : ((u = N.pending),
                u === null ? (D.next = D) : ((D.next = u.next), (u.next = D)),
                (N.pending = D)))
        }
        function xr(u, D, N) {
          if (((D = D.updateQueue), D !== null && ((D = D.shared), (N & 4194240) !== 0))) {
            var v = D.lanes
            ;((v &= u.pendingLanes), (N |= v), (D.lanes = N), Te(u, N))
          }
        }
        function fo(u, D) {
          var N = u.updateQueue,
            v = u.alternate
          if (v !== null && ((v = v.updateQueue), N === v)) {
            var O = null,
              IA = null
            if (((N = N.firstBaseUpdate), N !== null)) {
              do {
                var UA = {
                  eventTime: N.eventTime,
                  lane: N.lane,
                  tag: N.tag,
                  payload: N.payload,
                  callback: N.callback,
                  next: null,
                }
                ;(IA === null ? (O = IA = UA) : (IA = IA.next = UA), (N = N.next))
              } while (N !== null)
              IA === null ? (O = IA = D) : (IA = IA.next = D)
            } else O = IA = D
            ;((N = {
              baseState: v.baseState,
              firstBaseUpdate: O,
              lastBaseUpdate: IA,
              shared: v.shared,
              effects: v.effects,
            }),
              (u.updateQueue = N))
            return
          }
          ;((u = N.lastBaseUpdate),
            u === null ? (N.firstBaseUpdate = D) : (u.next = D),
            (N.lastBaseUpdate = D))
        }
        function XE(u, D, N, v) {
          var O = u.updateQueue
          we = !1
          var IA = O.firstBaseUpdate,
            UA = O.lastBaseUpdate,
            CI = O.shared.pending
          if (CI !== null) {
            O.shared.pending = null
            var HI = CI,
              ng = HI.next
            ;((HI.next = null), UA === null ? (IA = ng) : (UA.next = ng), (UA = HI))
            var Sg = u.alternate
            Sg !== null &&
              ((Sg = Sg.updateQueue),
              (CI = Sg.lastBaseUpdate),
              CI !== UA &&
                (CI === null ? (Sg.firstBaseUpdate = ng) : (CI.next = ng),
                (Sg.lastBaseUpdate = HI)))
          }
          if (IA !== null) {
            var DC = O.baseState
            ;((UA = 0), (Sg = ng = HI = null), (CI = IA))
            do {
              var sC = CI.lane,
                Be = CI.eventTime
              if ((v & sC) === sC) {
                Sg !== null &&
                  (Sg = Sg.next =
                    {
                      eventTime: Be,
                      lane: 0,
                      tag: CI.tag,
                      payload: CI.payload,
                      callback: CI.callback,
                      next: null,
                    })
                A: {
                  var kg = u,
                    ut = CI
                  switch (((sC = D), (Be = N), ut.tag)) {
                    case 1:
                      if (((kg = ut.payload), typeof kg == "function")) {
                        DC = kg.call(Be, DC, sC)
                        break A
                      }
                      DC = kg
                      break A
                    case 3:
                      kg.flags = (kg.flags & -65537) | 128
                    case 0:
                      if (
                        ((kg = ut.payload),
                        (sC = typeof kg == "function" ? kg.call(Be, DC, sC) : kg),
                        sC == null)
                      )
                        break A
                      DC = i({}, DC, sC)
                      break A
                    case 2:
                      we = !0
                  }
                }
                CI.callback !== null &&
                  CI.lane !== 0 &&
                  ((u.flags |= 64),
                  (sC = O.effects),
                  sC === null ? (O.effects = [CI]) : sC.push(CI))
              } else
                ((Be = {
                  eventTime: Be,
                  lane: sC,
                  tag: CI.tag,
                  payload: CI.payload,
                  callback: CI.callback,
                  next: null,
                }),
                  Sg === null ? ((ng = Sg = Be), (HI = DC)) : (Sg = Sg.next = Be),
                  (UA |= sC))
              if (((CI = CI.next), CI === null)) {
                if (((CI = O.shared.pending), CI === null)) break
                ;((sC = CI),
                  (CI = sC.next),
                  (sC.next = null),
                  (O.lastBaseUpdate = sC),
                  (O.shared.pending = null))
              }
            } while (!0)
            if (
              (Sg === null && (HI = DC),
              (O.baseState = HI),
              (O.firstBaseUpdate = ng),
              (O.lastBaseUpdate = Sg),
              (D = O.shared.interleaved),
              D !== null)
            ) {
              O = D
              do ((UA |= O.lane), (O = O.next))
              while (O !== D)
            } else IA === null && (O.shared.lanes = 0)
            ;((HQ |= UA), (u.lanes = UA), (u.memoizedState = DC))
          }
        }
        function br(u, D, N) {
          if (((u = D.effects), (D.effects = null), u !== null))
            for (D = 0; D < u.length; D++) {
              var v = u[D],
                O = v.callback
              if (O !== null) {
                if (((v.callback = null), (v = N), typeof O != "function")) throw Error(B(191, O))
                O.call(v)
              }
            }
        }
        var Rl = new g.Component().refs
        function Jl(u, D, N, v) {
          ;((D = u.memoizedState),
            (N = N(v, D)),
            (N = N == null ? D : i({}, D, N)),
            (u.memoizedState = N),
            u.lanes === 0 && (u.updateQueue.baseState = N))
        }
        var Kl = {
          isMounted: function (u) {
            return (u = u._reactInternals) ? X(u) === u : !1
          },
          enqueueSetState: function (u, D, N) {
            u = u._reactInternals
            var v = rC(),
              O = xt(u),
              IA = KQ(v, O)
            ;((IA.payload = D),
              N != null && (IA.callback = N),
              So(u, IA),
              (D = GB(u, O, v)),
              D !== null && xr(D, u, O))
          },
          enqueueReplaceState: function (u, D, N) {
            u = u._reactInternals
            var v = rC(),
              O = xt(u),
              IA = KQ(v, O)
            ;((IA.tag = 1),
              (IA.payload = D),
              N != null && (IA.callback = N),
              So(u, IA),
              (D = GB(u, O, v)),
              D !== null && xr(D, u, O))
          },
          enqueueForceUpdate: function (u, D) {
            u = u._reactInternals
            var N = rC(),
              v = xt(u),
              O = KQ(N, v)
            ;((O.tag = 2),
              D != null && (O.callback = D),
              So(u, O),
              (D = GB(u, v, N)),
              D !== null && xr(D, u, v))
          },
        }
        function ml(u, D, N, v, O, IA, UA) {
          return (
            (u = u.stateNode),
            typeof u.shouldComponentUpdate == "function"
              ? u.shouldComponentUpdate(v, IA, UA)
              : D.prototype && D.prototype.isPureReactComponent
                ? !yB(N, v) || !yB(O, IA)
                : !0
          )
        }
        function vl(u, D, N) {
          var v = !1,
            O = iC,
            IA = D.contextType
          return (
            typeof IA == "object" && IA !== null
              ? (IA = GC(IA))
              : ((O = qe(D) ? vC : Gg.current),
                (v = D.contextTypes),
                (IA = (v = v != null) ? ii(u, O) : iC)),
            (D = new D(N, IA)),
            (u.memoizedState = D.state !== null && D.state !== void 0 ? D.state : null),
            (D.updater = Kl),
            (u.stateNode = D),
            (D._reactInternals = u),
            v &&
              ((u = u.stateNode),
              (u.__reactInternalMemoizedUnmaskedChildContext = O),
              (u.__reactInternalMemoizedMaskedChildContext = IA)),
            D
          )
        }
        function Pc(u, D, N, v) {
          ;((u = D.state),
            typeof D.componentWillReceiveProps == "function" && D.componentWillReceiveProps(N, v),
            typeof D.UNSAFE_componentWillReceiveProps == "function" &&
              D.UNSAFE_componentWillReceiveProps(N, v),
            D.state !== u && Kl.enqueueReplaceState(D, D.state, null))
        }
        function Ll(u, D, N, v) {
          var O = u.stateNode
          ;((O.props = N), (O.state = u.memoizedState), (O.refs = Rl), le(u))
          var IA = D.contextType
          ;(typeof IA == "object" && IA !== null
            ? (O.context = GC(IA))
            : ((IA = qe(D) ? vC : Gg.current), (O.context = ii(u, IA))),
            (O.state = u.memoizedState),
            (IA = D.getDerivedStateFromProps),
            typeof IA == "function" && (Jl(u, D, IA, N), (O.state = u.memoizedState)),
            typeof D.getDerivedStateFromProps == "function" ||
              typeof O.getSnapshotBeforeUpdate == "function" ||
              (typeof O.UNSAFE_componentWillMount != "function" &&
                typeof O.componentWillMount != "function") ||
              ((D = O.state),
              typeof O.componentWillMount == "function" && O.componentWillMount(),
              typeof O.UNSAFE_componentWillMount == "function" && O.UNSAFE_componentWillMount(),
              D !== O.state && Kl.enqueueReplaceState(O, O.state, null),
              XE(u, N, O, v),
              (O.state = u.memoizedState)),
            typeof O.componentDidMount == "function" && (u.flags |= 4194308))
        }
        var Ta = [],
          $E = 0,
          yo = null,
          Yl = 0,
          mQ = [],
          oQ = 0,
          fE = null,
          dE = 1,
          po = ""
        function Aa(u, D) {
          ;((Ta[$E++] = Yl), (Ta[$E++] = yo), (yo = u), (Yl = D))
        }
        function nQ(u, D, N) {
          ;((mQ[oQ++] = dE), (mQ[oQ++] = po), (mQ[oQ++] = fE), (fE = u))
          var v = dE
          u = po
          var O = 32 - He(v) - 1
          ;((v &= ~(1 << O)), (N += 1))
          var IA = 32 - He(D) + O
          if (30 < IA) {
            var UA = O - (O % 5)
            ;((IA = (v & ((1 << UA) - 1)).toString(32)),
              (v >>= UA),
              (O -= UA),
              (dE = (1 << (32 - He(D) + O)) | (N << O) | v),
              (po = IA + u))
          } else ((dE = (1 << IA) | (N << O) | v), (po = u))
        }
        function Cn(u) {
          u.return !== null && (Aa(u, 1), nQ(u, 1, 0))
        }
        function at(u) {
          for (; u === yo; ) ((yo = Ta[--$E]), (Ta[$E] = null), (Yl = Ta[--$E]), (Ta[$E] = null))
          for (; u === fE; )
            ((fE = mQ[--oQ]),
              (mQ[oQ] = null),
              (po = mQ[--oQ]),
              (mQ[oQ] = null),
              (dE = mQ[--oQ]),
              (mQ[oQ] = null))
        }
        var Xi = null,
          $i = null,
          ri = !1,
          xa = !1,
          pB = null
        function ql(u, D) {
          var N = CB(5, null, null, 0)
          ;((N.elementType = "DELETED"),
            (N.stateNode = D),
            (N.return = u),
            (D = u.deletions),
            D === null ? ((u.deletions = [N]), (u.flags |= 16)) : D.push(N))
        }
        function Hl(u, D) {
          switch (u.tag) {
            case 5:
              return (
                (D = mC(D, u.type, u.pendingProps)),
                D !== null ? ((u.stateNode = D), (Xi = u), ($i = Li(D)), !0) : !1
              )
            case 6:
              return (
                (D = zC(D, u.pendingProps)),
                D !== null ? ((u.stateNode = D), (Xi = u), ($i = null), !0) : !1
              )
            case 13:
              if (((D = Ee(D)), D !== null)) {
                var N = fE !== null ? { id: dE, overflow: po } : null
                return (
                  (u.memoizedState = { dehydrated: D, treeContext: N, retryLane: 1073741824 }),
                  (N = CB(18, null, null, 0)),
                  (N.stateNode = D),
                  (N.return = u),
                  (u.child = N),
                  (Xi = u),
                  ($i = null),
                  !0
                )
              }
              return !1
            default:
              return !1
          }
        }
        function ba(u) {
          return (u.mode & 1) !== 0 && (u.flags & 128) === 0
        }
        function yE(u) {
          if (ri) {
            var D = $i
            if (D) {
              var N = D
              if (!Hl(u, D)) {
                if (ba(u)) throw Error(B(418))
                D = vi(N)
                var v = Xi
                D && Hl(u, D) ? ql(v, N) : ((u.flags = (u.flags & -4097) | 2), (ri = !1), (Xi = u))
              }
            } else {
              if (ba(u)) throw Error(B(418))
              ;((u.flags = (u.flags & -4097) | 2), (ri = !1), (Xi = u))
            }
          }
        }
        function Wc(u) {
          for (u = u.return; u !== null && u.tag !== 5 && u.tag !== 3 && u.tag !== 13; )
            u = u.return
          Xi = u
        }
        function Fs(u) {
          if (!eI || u !== Xi) return !1
          if (!ri) return (Wc(u), (ri = !0), !1)
          if (u.tag !== 3 && (u.tag !== 5 || (QI(u.type) && !dA(u.type, u.memoizedProps)))) {
            var D = $i
            if (D) {
              if (ba(u)) {
                for (u = $i; u; ) u = vi(u)
                throw Error(B(418))
              }
              for (; D; ) (ql(u, D), (D = vi(D)))
            }
          }
          if ((Wc(u), u.tag === 13)) {
            if (!eI) throw Error(B(316))
            if (((u = u.memoizedState), (u = u !== null ? u.dehydrated : null), !u))
              throw Error(B(317))
            $i = JC(u)
          } else $i = Xi ? vi(u.stateNode) : null
          return !0
        }
        function Oa() {
          eI && (($i = Xi = null), (xa = ri = !1))
        }
        function Or(u) {
          pB === null ? (pB = [u]) : pB.push(u)
        }
        function Ia(u, D, N) {
          if (((u = N.ref), u !== null && typeof u != "function" && typeof u != "object")) {
            if (N._owner) {
              if (((N = N._owner), N)) {
                if (N.tag !== 1) throw Error(B(309))
                var v = N.stateNode
              }
              if (!v) throw Error(B(147, u))
              var O = v,
                IA = "" + u
              return D !== null &&
                D.ref !== null &&
                typeof D.ref == "function" &&
                D.ref._stringRef === IA
                ? D.ref
                : ((D = function (UA) {
                    var CI = O.refs
                    ;(CI === Rl && (CI = O.refs = {}), UA === null ? delete CI[IA] : (CI[IA] = UA))
                  }),
                  (D._stringRef = IA),
                  D)
            }
            if (typeof u != "string") throw Error(B(284))
            if (!N._owner) throw Error(B(290, u))
          }
          return u
        }
        function EQ(u, D) {
          throw (
            (u = Object.prototype.toString.call(D)),
            Error(
              B(
                31,
                u === "[object Object]"
                  ? "object with keys {" + Object.keys(D).join(", ") + "}"
                  : u,
              ),
            )
          )
        }
        function pE(u) {
          var D = u._init
          return D(u._payload)
        }
        function Ln(u) {
          function D(yI, zA) {
            if (u) {
              var JI = yI.deletions
              JI === null ? ((yI.deletions = [zA]), (yI.flags |= 16)) : JI.push(zA)
            }
          }
          function N(yI, zA) {
            if (!u) return null
            for (; zA !== null; ) (D(yI, zA), (zA = zA.sibling))
            return null
          }
          function v(yI, zA) {
            for (yI = /* @__PURE__ */ new Map(); zA !== null; )
              (zA.key !== null ? yI.set(zA.key, zA) : yI.set(zA.index, zA), (zA = zA.sibling))
            return yI
          }
          function O(yI, zA) {
            return ((yI = MB(yI, zA)), (yI.index = 0), (yI.sibling = null), yI)
          }
          function IA(yI, zA, JI) {
            return (
              (yI.index = JI),
              u
                ? ((JI = yI.alternate),
                  JI !== null
                    ? ((JI = JI.index), JI < zA ? ((yI.flags |= 2), zA) : JI)
                    : ((yI.flags |= 2), zA))
                : ((yI.flags |= 1048576), zA)
            )
          }
          function UA(yI) {
            return (u && yI.alternate === null && (yI.flags |= 2), yI)
          }
          function CI(yI, zA, JI, WI) {
            return zA === null || zA.tag !== 6
              ? ((zA = mE(JI, yI.mode, WI)), (zA.return = yI), zA)
              : ((zA = O(zA, JI)), (zA.return = yI), zA)
          }
          function HI(yI, zA, JI, WI) {
            var Zg = JI.type
            return Zg === h
              ? Sg(yI, zA, JI.props.children, WI, JI.key)
              : zA !== null &&
                  (zA.elementType === Zg ||
                    (typeof Zg == "object" &&
                      Zg !== null &&
                      Zg.$$typeof === Y &&
                      pE(Zg) === zA.type))
                ? ((WI = O(zA, JI.props)), (WI.ref = Ia(yI, zA, JI)), (WI.return = yI), WI)
                : ((WI = ca(JI.type, JI.key, JI.props, null, yI.mode, WI)),
                  (WI.ref = Ia(yI, zA, JI)),
                  (WI.return = yI),
                  WI)
          }
          function ng(yI, zA, JI, WI) {
            return zA === null ||
              zA.tag !== 4 ||
              zA.stateNode.containerInfo !== JI.containerInfo ||
              zA.stateNode.implementation !== JI.implementation
              ? ((zA = Jo(JI, yI.mode, WI)), (zA.return = yI), zA)
              : ((zA = O(zA, JI.children || [])), (zA.return = yI), zA)
          }
          function Sg(yI, zA, JI, WI, Zg) {
            return zA === null || zA.tag !== 7
              ? ((zA = Ro(JI, yI.mode, WI, Zg)), (zA.return = yI), zA)
              : ((zA = O(zA, JI)), (zA.return = yI), zA)
          }
          function DC(yI, zA, JI) {
            if ((typeof zA == "string" && zA !== "") || typeof zA == "number")
              return ((zA = mE("" + zA, yI.mode, JI)), (zA.return = yI), zA)
            if (typeof zA == "object" && zA !== null) {
              switch (zA.$$typeof) {
                case r:
                  return (
                    (JI = ca(zA.type, zA.key, zA.props, null, yI.mode, JI)),
                    (JI.ref = Ia(yI, null, zA)),
                    (JI.return = yI),
                    JI
                  )
                case s:
                  return ((zA = Jo(zA, yI.mode, JI)), (zA.return = yI), zA)
                case Y:
                  var WI = zA._init
                  return DC(yI, WI(zA._payload), JI)
              }
              if (JA(zA) || j(zA)) return ((zA = Ro(zA, yI.mode, JI, null)), (zA.return = yI), zA)
              EQ(yI, zA)
            }
            return null
          }
          function sC(yI, zA, JI, WI) {
            var Zg = zA !== null ? zA.key : null
            if ((typeof JI == "string" && JI !== "") || typeof JI == "number")
              return Zg !== null ? null : CI(yI, zA, "" + JI, WI)
            if (typeof JI == "object" && JI !== null) {
              switch (JI.$$typeof) {
                case r:
                  return JI.key === Zg ? HI(yI, zA, JI, WI) : null
                case s:
                  return JI.key === Zg ? ng(yI, zA, JI, WI) : null
                case Y:
                  return ((Zg = JI._init), sC(yI, zA, Zg(JI._payload), WI))
              }
              if (JA(JI) || j(JI)) return Zg !== null ? null : Sg(yI, zA, JI, WI, null)
              EQ(yI, JI)
            }
            return null
          }
          function Be(yI, zA, JI, WI, Zg) {
            if ((typeof WI == "string" && WI !== "") || typeof WI == "number")
              return ((yI = yI.get(JI) || null), CI(zA, yI, "" + WI, Zg))
            if (typeof WI == "object" && WI !== null) {
              switch (WI.$$typeof) {
                case r:
                  return ((yI = yI.get(WI.key === null ? JI : WI.key) || null), HI(zA, yI, WI, Zg))
                case s:
                  return ((yI = yI.get(WI.key === null ? JI : WI.key) || null), ng(zA, yI, WI, Zg))
                case Y:
                  var WC = WI._init
                  return Be(yI, zA, JI, WC(WI._payload), Zg)
              }
              if (JA(WI) || j(WI)) return ((yI = yI.get(JI) || null), Sg(zA, yI, WI, Zg, null))
              EQ(zA, WI)
            }
            return null
          }
          function kg(yI, zA, JI, WI) {
            for (
              var Zg = null, WC = null, SC = zA, Qe = (zA = 0), bi = null;
              SC !== null && Qe < JI.length;
              Qe++
            ) {
              SC.index > Qe ? ((bi = SC), (SC = null)) : (bi = SC.sibling)
              var oe = sC(yI, SC, JI[Qe], WI)
              if (oe === null) {
                SC === null && (SC = bi)
                break
              }
              ;(u && SC && oe.alternate === null && D(yI, SC),
                (zA = IA(oe, zA, Qe)),
                WC === null ? (Zg = oe) : (WC.sibling = oe),
                (WC = oe),
                (SC = bi))
            }
            if (Qe === JI.length) return (N(yI, SC), ri && Aa(yI, Qe), Zg)
            if (SC === null) {
              for (; Qe < JI.length; Qe++)
                ((SC = DC(yI, JI[Qe], WI)),
                  SC !== null &&
                    ((zA = IA(SC, zA, Qe)), WC === null ? (Zg = SC) : (WC.sibling = SC), (WC = SC)))
              return (ri && Aa(yI, Qe), Zg)
            }
            for (SC = v(yI, SC); Qe < JI.length; Qe++)
              ((bi = Be(SC, yI, Qe, JI[Qe], WI)),
                bi !== null &&
                  (u && bi.alternate !== null && SC.delete(bi.key === null ? Qe : bi.key),
                  (zA = IA(bi, zA, Qe)),
                  WC === null ? (Zg = bi) : (WC.sibling = bi),
                  (WC = bi)))
            return (
              u &&
                SC.forEach(function (vE) {
                  return D(yI, vE)
                }),
              ri && Aa(yI, Qe),
              Zg
            )
          }
          function ut(yI, zA, JI, WI) {
            var Zg = j(JI)
            if (typeof Zg != "function") throw Error(B(150))
            if (((JI = Zg.call(JI)), JI == null)) throw Error(B(151))
            for (
              var WC = (Zg = null), SC = zA, Qe = (zA = 0), bi = null, oe = JI.next();
              SC !== null && !oe.done;
              Qe++, oe = JI.next()
            ) {
              SC.index > Qe ? ((bi = SC), (SC = null)) : (bi = SC.sibling)
              var vE = sC(yI, SC, oe.value, WI)
              if (vE === null) {
                SC === null && (SC = bi)
                break
              }
              ;(u && SC && vE.alternate === null && D(yI, SC),
                (zA = IA(vE, zA, Qe)),
                WC === null ? (Zg = vE) : (WC.sibling = vE),
                (WC = vE),
                (SC = bi))
            }
            if (oe.done) return (N(yI, SC), ri && Aa(yI, Qe), Zg)
            if (SC === null) {
              for (; !oe.done; Qe++, oe = JI.next())
                ((oe = DC(yI, oe.value, WI)),
                  oe !== null &&
                    ((zA = IA(oe, zA, Qe)), WC === null ? (Zg = oe) : (WC.sibling = oe), (WC = oe)))
              return (ri && Aa(yI, Qe), Zg)
            }
            for (SC = v(yI, SC); !oe.done; Qe++, oe = JI.next())
              ((oe = Be(SC, yI, Qe, oe.value, WI)),
                oe !== null &&
                  (u && oe.alternate !== null && SC.delete(oe.key === null ? Qe : oe.key),
                  (zA = IA(oe, zA, Qe)),
                  WC === null ? (Zg = oe) : (WC.sibling = oe),
                  (WC = oe)))
            return (
              u &&
                SC.forEach(function (sr) {
                  return D(yI, sr)
                }),
              ri && Aa(yI, Qe),
              Zg
            )
          }
          function Dt(yI, zA, JI, WI) {
            if (
              (typeof JI == "object" &&
                JI !== null &&
                JI.type === h &&
                JI.key === null &&
                (JI = JI.props.children),
              typeof JI == "object" && JI !== null)
            ) {
              switch (JI.$$typeof) {
                case r:
                  A: {
                    for (var Zg = JI.key, WC = zA; WC !== null; ) {
                      if (WC.key === Zg) {
                        if (((Zg = JI.type), Zg === h)) {
                          if (WC.tag === 7) {
                            ;(N(yI, WC.sibling),
                              (zA = O(WC, JI.props.children)),
                              (zA.return = yI),
                              (yI = zA))
                            break A
                          }
                        } else if (
                          WC.elementType === Zg ||
                          (typeof Zg == "object" &&
                            Zg !== null &&
                            Zg.$$typeof === Y &&
                            pE(Zg) === WC.type)
                        ) {
                          ;(N(yI, WC.sibling),
                            (zA = O(WC, JI.props)),
                            (zA.ref = Ia(yI, WC, JI)),
                            (zA.return = yI),
                            (yI = zA))
                          break A
                        }
                        N(yI, WC)
                        break
                      } else D(yI, WC)
                      WC = WC.sibling
                    }
                    JI.type === h
                      ? ((zA = Ro(JI.props.children, yI.mode, WI, JI.key)),
                        (zA.return = yI),
                        (yI = zA))
                      : ((WI = ca(JI.type, JI.key, JI.props, null, yI.mode, WI)),
                        (WI.ref = Ia(yI, zA, JI)),
                        (WI.return = yI),
                        (yI = WI))
                  }
                  return UA(yI)
                case s:
                  A: {
                    for (WC = JI.key; zA !== null; ) {
                      if (zA.key === WC)
                        if (
                          zA.tag === 4 &&
                          zA.stateNode.containerInfo === JI.containerInfo &&
                          zA.stateNode.implementation === JI.implementation
                        ) {
                          ;(N(yI, zA.sibling),
                            (zA = O(zA, JI.children || [])),
                            (zA.return = yI),
                            (yI = zA))
                          break A
                        } else {
                          N(yI, zA)
                          break
                        }
                      else D(yI, zA)
                      zA = zA.sibling
                    }
                    ;((zA = Jo(JI, yI.mode, WI)), (zA.return = yI), (yI = zA))
                  }
                  return UA(yI)
                case Y:
                  return ((WC = JI._init), Dt(yI, zA, WC(JI._payload), WI))
              }
              if (JA(JI)) return kg(yI, zA, JI, WI)
              if (j(JI)) return ut(yI, zA, JI, WI)
              EQ(yI, JI)
            }
            return (typeof JI == "string" && JI !== "") || typeof JI == "number"
              ? ((JI = "" + JI),
                zA !== null && zA.tag === 6
                  ? (N(yI, zA.sibling), (zA = O(zA, JI)), (zA.return = yI), (yI = zA))
                  : (N(yI, zA), (zA = mE(JI, yI.mode, WI)), (zA.return = yI), (yI = zA)),
                UA(yI))
              : N(yI, zA)
          }
          return Dt
        }
        var en = Ln(!0),
          Rs = Ln(!1),
          _a = {},
          xB = wC(_a),
          Za = wC(_a),
          wE = wC(_a)
        function wo(u) {
          if (u === _a) throw Error(B(174))
          return u
        }
        function Js(u, D) {
          ;(UC(wE, D), UC(Za, u), UC(xB, _a), (u = LA(D)), mg(xB), UC(xB, u))
        }
        function Pa() {
          ;(mg(xB), mg(Za), mg(wE))
        }
        function Ks(u) {
          var D = wo(wE.current),
            N = wo(xB.current)
          ;((D = nA(N, u.type, D)), N !== D && (UC(Za, u), UC(xB, D)))
        }
        function go(u) {
          Za.current === u && (mg(xB), mg(Za))
        }
        var Fi = wC(0)
        function Wa(u) {
          for (var D = u; D !== null; ) {
            if (D.tag === 13) {
              var N = D.memoizedState
              if (N !== null && ((N = N.dehydrated), N === null || ei(N) || fe(N))) return D
            } else if (D.tag === 19 && D.memoizedProps.revealOrder !== void 0) {
              if (D.flags & 128) return D
            } else if (D.child !== null) {
              ;((D.child.return = D), (D = D.child))
              continue
            }
            if (D === u) break
            for (; D.sibling === null; ) {
              if (D.return === null || D.return === u) return null
              D = D.return
            }
            ;((D.sibling.return = D.return), (D = D.sibling))
          }
          return null
        }
        var rt = []
        function vQ() {
          for (var u = 0; u < rt.length; u++) {
            var D = rt[u]
            sI
              ? (D._workInProgressVersionPrimary = null)
              : (D._workInProgressVersionSecondary = null)
          }
          rt.length = 0
        }
        var vt = o.ReactCurrentDispatcher,
          ti = o.ReactCurrentBatchConfig,
          GE = 0,
          he = null,
          xe = null,
          $e = null,
          Va = !1,
          Lt = !1,
          ga = 0,
          Yn = 0
        function kt() {
          throw Error(B(321))
        }
        function Co(u, D) {
          if (D === null) return !1
          for (var N = 0; N < D.length && N < u.length; N++) if (!Gt(u[N], D[N])) return !1
          return !0
        }
        function kE(u, D, N, v, O, IA) {
          if (
            ((GE = IA),
            (he = D),
            (D.memoizedState = null),
            (D.updateQueue = null),
            (D.lanes = 0),
            (vt.current = u === null || u.memoizedState === null ? ME : $a),
            (u = N(v, O)),
            Lt)
          ) {
            IA = 0
            do {
              if (((Lt = !1), (ga = 0), 25 <= IA)) throw Error(B(301))
              ;((IA += 1),
                ($e = xe = null),
                (D.updateQueue = null),
                (vt.current = UE),
                (u = N(v, O)))
            } while (Lt)
          }
          if (
            ((vt.current = ia),
            (D = xe !== null && xe.next !== null),
            (GE = 0),
            ($e = xe = he = null),
            (Va = !1),
            D)
          )
            throw Error(B(300))
          return u
        }
        function tn() {
          var u = ga !== 0
          return ((ga = 0), u)
        }
        function Go() {
          var u = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null }
          return ($e === null ? (he.memoizedState = $e = u) : ($e = $e.next = u), $e)
        }
        function eo() {
          if (xe === null) {
            var u = he.alternate
            u = u !== null ? u.memoizedState : null
          } else u = xe.next
          var D = $e === null ? he.memoizedState : $e.next
          if (D !== null) (($e = D), (xe = u))
          else {
            if (u === null) throw Error(B(310))
            ;((xe = u),
              (u = {
                memoizedState: xe.memoizedState,
                baseState: xe.baseState,
                baseQueue: xe.baseQueue,
                queue: xe.queue,
                next: null,
              }),
              $e === null ? (he.memoizedState = $e = u) : ($e = $e.next = u))
          }
          return $e
        }
        function yi(u, D) {
          return typeof D == "function" ? D(u) : D
        }
        function ja(u) {
          var D = eo(),
            N = D.queue
          if (N === null) throw Error(B(311))
          N.lastRenderedReducer = u
          var v = xe,
            O = v.baseQueue,
            IA = N.pending
          if (IA !== null) {
            if (O !== null) {
              var UA = O.next
              ;((O.next = IA.next), (IA.next = UA))
            }
            ;((v.baseQueue = O = IA), (N.pending = null))
          }
          if (O !== null) {
            ;((IA = O.next), (v = v.baseState))
            var CI = (UA = null),
              HI = null,
              ng = IA
            do {
              var Sg = ng.lane
              if ((GE & Sg) === Sg)
                (HI !== null &&
                  (HI = HI.next =
                    {
                      lane: 0,
                      action: ng.action,
                      hasEagerState: ng.hasEagerState,
                      eagerState: ng.eagerState,
                      next: null,
                    }),
                  (v = ng.hasEagerState ? ng.eagerState : u(v, ng.action)))
              else {
                var DC = {
                  lane: Sg,
                  action: ng.action,
                  hasEagerState: ng.hasEagerState,
                  eagerState: ng.eagerState,
                  next: null,
                }
                ;(HI === null ? ((CI = HI = DC), (UA = v)) : (HI = HI.next = DC),
                  (he.lanes |= Sg),
                  (HQ |= Sg))
              }
              ng = ng.next
            } while (ng !== null && ng !== IA)
            ;(HI === null ? (UA = v) : (HI.next = CI),
              Gt(v, D.memoizedState) || (te = !0),
              (D.memoizedState = v),
              (D.baseState = UA),
              (D.baseQueue = HI),
              (N.lastRenderedState = v))
          }
          if (((u = N.interleaved), u !== null)) {
            O = u
            do ((IA = O.lane), (he.lanes |= IA), (HQ |= IA), (O = O.next))
            while (O !== u)
          } else O === null && (N.lanes = 0)
          return [D.memoizedState, N.dispatch]
        }
        function ms(u) {
          var D = eo(),
            N = D.queue
          if (N === null) throw Error(B(311))
          N.lastRenderedReducer = u
          var v = N.dispatch,
            O = N.pending,
            IA = D.memoizedState
          if (O !== null) {
            N.pending = null
            var UA = (O = O.next)
            do ((IA = u(IA, UA.action)), (UA = UA.next))
            while (UA !== O)
            ;(Gt(IA, D.memoizedState) || (te = !0),
              (D.memoizedState = IA),
              D.baseQueue === null && (D.baseState = IA),
              (N.lastRenderedState = IA))
          }
          return [IA, v]
        }
        function Ca() {}
        function Tl(u, D) {
          var N = he,
            v = eo(),
            O = D(),
            IA = !Gt(v.memoizedState, O)
          if (
            (IA && ((v.memoizedState = O), (te = !0)),
            (v = v.queue),
            Cg(Ae.bind(null, N, v, u), [u]),
            v.getSnapshot !== D || IA || ($e !== null && $e.memoizedState.tag & 1))
          ) {
            if (((N.flags |= 2048), _r(9, Ai.bind(null, N, v, O, D), void 0, null), xi === null))
              throw Error(B(349))
            GE & 30 || FC(N, D, O)
          }
          return O
        }
        function FC(u, D, N) {
          ;((u.flags |= 16384),
            (u = { getSnapshot: D, value: N }),
            (D = he.updateQueue),
            D === null
              ? ((D = { lastEffect: null, stores: null }), (he.updateQueue = D), (D.stores = [u]))
              : ((N = D.stores), N === null ? (D.stores = [u]) : N.push(u)))
        }
        function Ai(u, D, N, v) {
          ;((D.value = N), (D.getSnapshot = v), qi(D) && GB(u, 1, -1))
        }
        function Ae(u, D, N) {
          return N(function () {
            qi(D) && GB(u, 1, -1)
          })
        }
        function qi(u) {
          var D = u.getSnapshot
          u = u.value
          try {
            var N = D()
            return !Gt(u, N)
          } catch {
            return !0
          }
        }
        function sB(u) {
          var D = Go()
          return (
            typeof u == "function" && (u = u()),
            (D.memoizedState = D.baseState = u),
            (u = {
              pending: null,
              interleaved: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: yi,
              lastRenderedState: u,
            }),
            (D.queue = u),
            (u = u.dispatch = Ls.bind(null, he, u)),
            [D.memoizedState, u]
          )
        }
        function _r(u, D, N, v) {
          return (
            (u = { tag: u, create: D, destroy: N, deps: v, next: null }),
            (D = he.updateQueue),
            D === null
              ? ((D = { lastEffect: null, stores: null }),
                (he.updateQueue = D),
                (D.lastEffect = u.next = u))
              : ((N = D.lastEffect),
                N === null
                  ? (D.lastEffect = u.next = u)
                  : ((v = N.next), (N.next = u), (u.next = v), (D.lastEffect = u))),
            u
          )
        }
        function Zr() {
          return eo().memoizedState
        }
        function ea(u, D, N, v) {
          var O = Go()
          ;((he.flags |= u), (O.memoizedState = _r(1 | D, N, void 0, v === void 0 ? null : v)))
        }
        function xl(u, D, N, v) {
          var O = eo()
          v = v === void 0 ? null : v
          var IA = void 0
          if (xe !== null) {
            var UA = xe.memoizedState
            if (((IA = UA.destroy), v !== null && Co(v, UA.deps))) {
              O.memoizedState = _r(D, N, IA, v)
              return
            }
          }
          ;((he.flags |= u), (O.memoizedState = _r(1 | D, N, IA, v)))
        }
        function Pr(u, D) {
          return ea(8390656, 8, u, D)
        }
        function Cg(u, D) {
          return xl(2048, 8, u, D)
        }
        function TC(u, D) {
          return xl(4, 2, u, D)
        }
        function PC(u, D) {
          return xl(4, 4, u, D)
        }
        function aQ(u, D) {
          if (typeof D == "function")
            return (
              (u = u()),
              D(u),
              function () {
                D(null)
              }
            )
          if (D != null)
            return (
              (u = u()),
              (D.current = u),
              function () {
                D.current = null
              }
            )
        }
        function LQ(u, D, N) {
          return ((N = N != null ? N.concat([u]) : null), xl(4, 4, aQ.bind(null, D, u), N))
        }
        function qn() {}
        function io(u, D) {
          var N = eo()
          D = D === void 0 ? null : D
          var v = N.memoizedState
          return v !== null && D !== null && Co(D, v[1]) ? v[0] : ((N.memoizedState = [u, D]), u)
        }
        function Hn(u, D) {
          var N = eo()
          D = D === void 0 ? null : D
          var v = N.memoizedState
          return v !== null && D !== null && Co(D, v[1])
            ? v[0]
            : ((u = u()), (N.memoizedState = [u, D]), u)
        }
        function Tn(u, D) {
          var N = hC
          ;((hC = N !== 0 && 4 > N ? N : 4), u(!0))
          var v = ti.transition
          ti.transition = {}
          try {
            ;(u(!1), D())
          } finally {
            ;((hC = N), (ti.transition = v))
          }
        }
        function ko() {
          return eo().memoizedState
        }
        function vs(u, D, N) {
          var v = xt(u)
          ;((N = { lane: v, action: N, hasEagerState: !1, eagerState: null, next: null }),
            bl(u)
              ? Wr(D, N)
              : (za(u, D, N), (N = rC()), (u = GB(u, v, N)), u !== null && Xa(u, D, v)))
        }
        function Ls(u, D, N) {
          var v = xt(u),
            O = { lane: v, action: N, hasEagerState: !1, eagerState: null, next: null }
          if (bl(u)) Wr(D, O)
          else {
            za(u, D, O)
            var IA = u.alternate
            if (
              u.lanes === 0 &&
              (IA === null || IA.lanes === 0) &&
              ((IA = D.lastRenderedReducer), IA !== null)
            )
              try {
                var UA = D.lastRenderedState,
                  CI = IA(UA, N)
                if (((O.hasEagerState = !0), (O.eagerState = CI), Gt(CI, UA))) return
              } catch {
              } finally {
              }
            ;((N = rC()), (u = GB(u, v, N)), u !== null && Xa(u, D, v))
          }
        }
        function bl(u) {
          var D = u.alternate
          return u === he || (D !== null && D === he)
        }
        function Wr(u, D) {
          Lt = Va = !0
          var N = u.pending
          ;(N === null ? (D.next = D) : ((D.next = N.next), (N.next = D)), (u.pending = D))
        }
        function za(u, D, N) {
          xi !== null && u.mode & 1 && !($C & 2)
            ? ((u = D.interleaved),
              u === null
                ? ((N.next = N), ie === null ? (ie = [D]) : ie.push(D))
                : ((N.next = u.next), (u.next = N)),
              (D.interleaved = N))
            : ((u = D.pending),
              u === null ? (N.next = N) : ((N.next = u.next), (u.next = N)),
              (D.pending = N))
        }
        function Xa(u, D, N) {
          if (N & 4194240) {
            var v = D.lanes
            ;((v &= u.pendingLanes), (N |= v), (D.lanes = N), Te(u, N))
          }
        }
        var ia = {
            readContext: GC,
            useCallback: kt,
            useContext: kt,
            useEffect: kt,
            useImperativeHandle: kt,
            useInsertionEffect: kt,
            useLayoutEffect: kt,
            useMemo: kt,
            useReducer: kt,
            useRef: kt,
            useState: kt,
            useDebugValue: kt,
            useDeferredValue: kt,
            useTransition: kt,
            useMutableSource: kt,
            useSyncExternalStore: kt,
            useId: kt,
            unstable_isNewReconciler: !1,
          },
          ME = {
            readContext: GC,
            useCallback: function (u, D) {
              return ((Go().memoizedState = [u, D === void 0 ? null : D]), u)
            },
            useContext: GC,
            useEffect: Pr,
            useImperativeHandle: function (u, D, N) {
              return (
                (N = N != null ? N.concat([u]) : null),
                ea(4194308, 4, aQ.bind(null, D, u), N)
              )
            },
            useLayoutEffect: function (u, D) {
              return ea(4194308, 4, u, D)
            },
            useInsertionEffect: function (u, D) {
              return ea(4, 2, u, D)
            },
            useMemo: function (u, D) {
              var N = Go()
              return ((D = D === void 0 ? null : D), (u = u()), (N.memoizedState = [u, D]), u)
            },
            useReducer: function (u, D, N) {
              var v = Go()
              return (
                (D = N !== void 0 ? N(D) : D),
                (v.memoizedState = v.baseState = D),
                (u = {
                  pending: null,
                  interleaved: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: u,
                  lastRenderedState: D,
                }),
                (v.queue = u),
                (u = u.dispatch = vs.bind(null, he, u)),
                [v.memoizedState, u]
              )
            },
            useRef: function (u) {
              var D = Go()
              return ((u = { current: u }), (D.memoizedState = u))
            },
            useState: sB,
            useDebugValue: qn,
            useDeferredValue: function (u) {
              var D = sB(u),
                N = D[0],
                v = D[1]
              return (
                Pr(
                  function () {
                    var O = ti.transition
                    ti.transition = {}
                    try {
                      v(u)
                    } finally {
                      ti.transition = O
                    }
                  },
                  [u],
                ),
                N
              )
            },
            useTransition: function () {
              var u = sB(!1),
                D = u[0]
              return ((u = Tn.bind(null, u[1])), (Go().memoizedState = u), [D, u])
            },
            useMutableSource: function () {},
            useSyncExternalStore: function (u, D, N) {
              var v = he,
                O = Go()
              if (ri) {
                if (N === void 0) throw Error(B(407))
                N = N()
              } else {
                if (((N = D()), xi === null)) throw Error(B(349))
                GE & 30 || FC(v, D, N)
              }
              O.memoizedState = N
              var IA = { value: N, getSnapshot: D }
              return (
                (O.queue = IA),
                Pr(Ae.bind(null, v, IA, u), [u]),
                (v.flags |= 2048),
                _r(9, Ai.bind(null, v, IA, N, D), void 0, null),
                N
              )
            },
            useId: function () {
              var u = Go(),
                D = xi.identifierPrefix
              if (ri) {
                var N = po,
                  v = dE
                ;((N = (v & ~(1 << (32 - He(v) - 1))).toString(32) + N),
                  (D = ":" + D + "R" + N),
                  (N = ga++),
                  0 < N && (D += "H" + N.toString(32)),
                  (D += ":"))
              } else ((N = Yn++), (D = ":" + D + "r" + N.toString(32) + ":"))
              return (u.memoizedState = D)
            },
            unstable_isNewReconciler: !1,
          },
          $a = {
            readContext: GC,
            useCallback: io,
            useContext: GC,
            useEffect: Cg,
            useImperativeHandle: LQ,
            useInsertionEffect: TC,
            useLayoutEffect: PC,
            useMemo: Hn,
            useReducer: ja,
            useRef: Zr,
            useState: function () {
              return ja(yi)
            },
            useDebugValue: qn,
            useDeferredValue: function (u) {
              var D = ja(yi),
                N = D[0],
                v = D[1]
              return (
                Cg(
                  function () {
                    var O = ti.transition
                    ti.transition = {}
                    try {
                      v(u)
                    } finally {
                      ti.transition = O
                    }
                  },
                  [u],
                ),
                N
              )
            },
            useTransition: function () {
              var u = ja(yi)[0],
                D = eo().memoizedState
              return [u, D]
            },
            useMutableSource: Ca,
            useSyncExternalStore: Tl,
            useId: ko,
            unstable_isNewReconciler: !1,
          },
          UE = {
            readContext: GC,
            useCallback: io,
            useContext: GC,
            useEffect: Cg,
            useImperativeHandle: LQ,
            useInsertionEffect: TC,
            useLayoutEffect: PC,
            useMemo: Hn,
            useReducer: ms,
            useRef: Zr,
            useState: function () {
              return ms(yi)
            },
            useDebugValue: qn,
            useDeferredValue: function (u) {
              var D = ms(yi),
                N = D[0],
                v = D[1]
              return (
                Cg(
                  function () {
                    var O = ti.transition
                    ti.transition = {}
                    try {
                      v(u)
                    } finally {
                      ti.transition = O
                    }
                  },
                  [u],
                ),
                N
              )
            },
            useTransition: function () {
              var u = ms(yi)[0],
                D = eo().memoizedState
              return [u, D]
            },
            useMutableSource: Ca,
            useSyncExternalStore: Tl,
            useId: ko,
            unstable_isNewReconciler: !1,
          }
        function Vr(u, D) {
          try {
            var N = "",
              v = D
            do ((N += iA(v)), (v = v.return))
            while (v)
            var O = N
          } catch (IA) {
            O =
              `
Error generating stack: ` +
              IA.message +
              `
` +
              IA.stack
          }
          return { value: u, source: D, stack: O }
        }
        function Ar(u, D) {
          try {
            console.error(D.value)
          } catch (N) {
            setTimeout(function () {
              throw N
            })
          }
        }
        var Ys = typeof WeakMap == "function" ? WeakMap : Map
        function Ol(u, D, N) {
          ;((N = KQ(-1, N)), (N.tag = 3), (N.payload = { element: null }))
          var v = D.value
          return (
            (N.callback = function () {
              ;(Qr || ((Qr = !0), (wi = v)), Ar(u, D))
            }),
            N
          )
        }
        function Bn(u, D, N) {
          ;((N = KQ(-1, N)), (N.tag = 3))
          var v = u.type.getDerivedStateFromError
          if (typeof v == "function") {
            var O = D.value
            ;((N.payload = function () {
              return v(O)
            }),
              (N.callback = function () {
                Ar(u, D)
              }))
          }
          var IA = u.stateNode
          return (
            IA !== null &&
              typeof IA.componentDidCatch == "function" &&
              (N.callback = function () {
                ;(Ar(u, D),
                  typeof v != "function" &&
                    (sn === null ? (sn = /* @__PURE__ */ new Set([this])) : sn.add(this)))
                var UA = D.stack
                this.componentDidCatch(D.value, { componentStack: UA !== null ? UA : "" })
              }),
            N
          )
        }
        function rQ(u, D, N) {
          var v = u.pingCache
          if (v === null) {
            v = u.pingCache = new Ys()
            var O = /* @__PURE__ */ new Set()
            v.set(D, O)
          } else ((O = v.get(D)), O === void 0 && ((O = /* @__PURE__ */ new Set()), v.set(D, O)))
          O.has(N) || (O.add(N), (u = xQ.bind(null, u, D, N)), D.then(u, u))
        }
        function Qn(u) {
          do {
            var D
            if (
              ((D = u.tag === 13) &&
                ((D = u.memoizedState), (D = D !== null ? D.dehydrated !== null : !0)),
              D)
            )
              return u
            u = u.return
          } while (u !== null)
          return null
        }
        function on(u, D, N, v, O) {
          return u.mode & 1
            ? ((u.flags |= 65536), (u.lanes = O), u)
            : (u === D
                ? (u.flags |= 65536)
                : ((u.flags |= 128),
                  (N.flags |= 131072),
                  (N.flags &= -52805),
                  N.tag === 1 &&
                    (N.alternate === null
                      ? (N.tag = 17)
                      : ((D = KQ(-1, 1)), (D.tag = 2), So(N, D))),
                  (N.lanes |= 1)),
              u)
        }
        function Mt(u) {
          u.flags |= 4
        }
        function xn(u, D) {
          if (u !== null && u.child === D.child) return !0
          if (D.flags & 16) return !1
          for (u = D.child; u !== null; ) {
            if (u.flags & 12854 || u.subtreeFlags & 12854) return !1
            u = u.sibling
          }
          return !0
        }
        var sQ, ta, Ba, Ir
        if (cI)
          ((sQ = function (u, D) {
            for (var N = D.child; N !== null; ) {
              if (N.tag === 5 || N.tag === 6) EA(u, N.stateNode)
              else if (N.tag !== 4 && N.child !== null) {
                ;((N.child.return = N), (N = N.child))
                continue
              }
              if (N === D) break
              for (; N.sibling === null; ) {
                if (N.return === null || N.return === D) return
                N = N.return
              }
              ;((N.sibling.return = N.return), (N = N.sibling))
            }
          }),
            (ta = function () {}),
            (Ba = function (u, D, N, v, O) {
              if (((u = u.memoizedProps), u !== v)) {
                var IA = D.stateNode,
                  UA = wo(xB.current)
                ;((N = DA(IA, N, u, v, O, UA)), (D.updateQueue = N) && Mt(D))
              }
            }),
            (Ir = function (u, D, N, v) {
              N !== v && Mt(D)
            }))
        else if (YA) {
          sQ = function (u, D, N, v) {
            for (var O = D.child; O !== null; ) {
              if (O.tag === 5) {
                var IA = O.stateNode
                ;(N && v && (IA = Fg(IA, O.type, O.memoizedProps, O)), EA(u, IA))
              } else if (O.tag === 6)
                ((IA = O.stateNode), N && v && (IA = jC(IA, O.memoizedProps, O)), EA(u, IA))
              else if (O.tag !== 4) {
                if (O.tag === 22 && O.memoizedState !== null)
                  ((IA = O.child), IA !== null && (IA.return = O), sQ(u, O, !0, !0))
                else if (O.child !== null) {
                  ;((O.child.return = O), (O = O.child))
                  continue
                }
              }
              if (O === D) break
              for (; O.sibling === null; ) {
                if (O.return === null || O.return === D) return
                O = O.return
              }
              ;((O.sibling.return = O.return), (O = O.sibling))
            }
          }
          var wB = function (u, D, N, v) {
            for (var O = D.child; O !== null; ) {
              if (O.tag === 5) {
                var IA = O.stateNode
                ;(N && v && (IA = Fg(IA, O.type, O.memoizedProps, O)), dg(u, IA))
              } else if (O.tag === 6)
                ((IA = O.stateNode), N && v && (IA = jC(IA, O.memoizedProps, O)), dg(u, IA))
              else if (O.tag !== 4) {
                if (O.tag === 22 && O.memoizedState !== null)
                  ((IA = O.child), IA !== null && (IA.return = O), wB(u, O, !0, !0))
                else if (O.child !== null) {
                  ;((O.child.return = O), (O = O.child))
                  continue
                }
              }
              if (O === D) break
              for (; O.sibling === null; ) {
                if (O.return === null || O.return === D) return
                O = O.return
              }
              ;((O.sibling.return = O.return), (O = O.sibling))
            }
          }
          ;((ta = function (u, D) {
            var N = D.stateNode
            if (!xn(u, D)) {
              u = N.containerInfo
              var v = qI(u)
              ;(wB(v, D, !1, !1), (N.pendingChildren = v), Mt(D), $g(u, v))
            }
          }),
            (Ba = function (u, D, N, v, O) {
              var IA = u.stateNode,
                UA = u.memoizedProps
              if ((u = xn(u, D)) && UA === v) D.stateNode = IA
              else {
                var CI = D.stateNode,
                  HI = wo(xB.current),
                  ng = null
                ;(UA !== v && (ng = DA(CI, N, UA, v, O, HI)),
                  u && ng === null
                    ? (D.stateNode = IA)
                    : ((IA = zI(IA, ng, N, UA, v, D, u, CI)),
                      GA(IA, N, v, O, HI) && Mt(D),
                      (D.stateNode = IA),
                      u ? Mt(D) : sQ(IA, D, !1, !1)))
              }
            }),
            (Ir = function (u, D, N, v) {
              N !== v
                ? ((u = wo(wE.current)),
                  (N = wo(xB.current)),
                  (D.stateNode = kA(v, u, N, D)),
                  Mt(D))
                : (D.stateNode = u.stateNode)
            }))
        } else ((ta = function () {}), (Ba = function () {}), (Ir = function () {}))
        function lQ(u, D) {
          if (!ri)
            switch (u.tailMode) {
              case "hidden":
                D = u.tail
                for (var N = null; D !== null; ) (D.alternate !== null && (N = D), (D = D.sibling))
                N === null ? (u.tail = null) : (N.sibling = null)
                break
              case "collapsed":
                N = u.tail
                for (var v = null; N !== null; ) (N.alternate !== null && (v = N), (N = N.sibling))
                v === null
                  ? D || u.tail === null
                    ? (u.tail = null)
                    : (u.tail.sibling = null)
                  : (v.sibling = null)
            }
        }
        function Re(u) {
          var D = u.alternate !== null && u.alternate.child === u.child,
            N = 0,
            v = 0
          if (D)
            for (var O = u.child; O !== null; )
              ((N |= O.lanes | O.childLanes),
                (v |= O.subtreeFlags & 14680064),
                (v |= O.flags & 14680064),
                (O.return = u),
                (O = O.sibling))
          else
            for (O = u.child; O !== null; )
              ((N |= O.lanes | O.childLanes),
                (v |= O.subtreeFlags),
                (v |= O.flags),
                (O.return = u),
                (O = O.sibling))
          return ((u.subtreeFlags |= v), (u.childLanes = N), D)
        }
        function nC(u, D, N) {
          var v = D.pendingProps
          switch ((at(D), D.tag)) {
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return (Re(D), null)
            case 1:
              return (qe(D.type) && pe(), Re(D), null)
            case 3:
              return (
                (v = D.stateNode),
                Pa(),
                mg(_C),
                mg(Gg),
                vQ(),
                v.pendingContext && ((v.context = v.pendingContext), (v.pendingContext = null)),
                (u === null || u.child === null) &&
                  (Fs(D)
                    ? Mt(D)
                    : u === null ||
                      (u.memoizedState.isDehydrated && !(D.flags & 256)) ||
                      ((D.flags |= 1024), pB !== null && (Ag(pB), (pB = null)))),
                ta(u, D),
                Re(D),
                null
              )
            case 5:
              ;(go(D), (N = wo(wE.current)))
              var O = D.type
              if (u !== null && D.stateNode != null)
                (Ba(u, D, O, v, N), u.ref !== D.ref && ((D.flags |= 512), (D.flags |= 2097152)))
              else {
                if (!v) {
                  if (D.stateNode === null) throw Error(B(166))
                  return (Re(D), null)
                }
                if (((u = wo(xB.current)), Fs(D))) {
                  if (!eI) throw Error(B(175))
                  ;((u = eg(D.stateNode, D.type, D.memoizedProps, N, u, D, !xa)),
                    (D.updateQueue = u),
                    u !== null && Mt(D))
                } else {
                  var IA = $(O, v, N, u, D)
                  ;(sQ(IA, D, !1, !1), (D.stateNode = IA), GA(IA, O, v, N, u) && Mt(D))
                }
                D.ref !== null && ((D.flags |= 512), (D.flags |= 2097152))
              }
              return (Re(D), null)
            case 6:
              if (u && D.stateNode != null) Ir(u, D, u.memoizedProps, v)
              else {
                if (typeof v != "string" && D.stateNode === null) throw Error(B(166))
                if (((u = wo(wE.current)), (N = wo(xB.current)), Fs(D))) {
                  if (!eI) throw Error(B(176))
                  if (
                    ((u = D.stateNode),
                    (v = D.memoizedProps),
                    (N = Tg(u, v, D, !xa)) && ((O = Xi), O !== null))
                  )
                    switch (((IA = (O.mode & 1) !== 0), O.tag)) {
                      case 3:
                        PA(O.stateNode.containerInfo, u, v, IA)
                        break
                      case 5:
                        gg(O.type, O.memoizedProps, O.stateNode, u, v, IA)
                    }
                  N && Mt(D)
                } else D.stateNode = kA(v, u, N, D)
              }
              return (Re(D), null)
            case 13:
              if (
                (mg(Fi), (v = D.memoizedState), ri && $i !== null && D.mode & 1 && !(D.flags & 128))
              ) {
                for (u = $i; u; ) u = vi(u)
                return (Oa(), (D.flags |= 98560), D)
              }
              if (v !== null && v.dehydrated !== null) {
                if (((v = Fs(D)), u === null)) {
                  if (!v) throw Error(B(318))
                  if (!eI) throw Error(B(344))
                  if (((u = D.memoizedState), (u = u !== null ? u.dehydrated : null), !u))
                    throw Error(B(317))
                  OC(u, D)
                } else (Oa(), !(D.flags & 128) && (D.memoizedState = null), (D.flags |= 4))
                return (Re(D), null)
              }
              return (
                pB !== null && (Ag(pB), (pB = null)),
                D.flags & 128
                  ? ((D.lanes = N), D)
                  : ((v = v !== null),
                    (N = !1),
                    u === null ? Fs(D) : (N = u.memoizedState !== null),
                    v &&
                      !N &&
                      ((D.child.flags |= 8192),
                      D.mode & 1 && (u === null || Fi.current & 1 ? lt === 0 && (lt = 3) : la())),
                    D.updateQueue !== null && (D.flags |= 4),
                    Re(D),
                    null)
              )
            case 4:
              return (Pa(), ta(u, D), u === null && hI(D.stateNode.containerInfo), Re(D), null)
            case 10:
              return (BC(D.type._context), Re(D), null)
            case 17:
              return (qe(D.type) && pe(), Re(D), null)
            case 19:
              if ((mg(Fi), (O = D.memoizedState), O === null)) return (Re(D), null)
              if (((v = (D.flags & 128) !== 0), (IA = O.rendering), IA === null))
                if (v) lQ(O, !1)
                else {
                  if (lt !== 0 || (u !== null && u.flags & 128))
                    for (u = D.child; u !== null; ) {
                      if (((IA = Wa(u)), IA !== null)) {
                        for (
                          D.flags |= 128,
                            lQ(O, !1),
                            u = IA.updateQueue,
                            u !== null && ((D.updateQueue = u), (D.flags |= 4)),
                            D.subtreeFlags = 0,
                            u = N,
                            v = D.child;
                          v !== null;
                        )
                          ((N = v),
                            (O = u),
                            (N.flags &= 14680066),
                            (IA = N.alternate),
                            IA === null
                              ? ((N.childLanes = 0),
                                (N.lanes = O),
                                (N.child = null),
                                (N.subtreeFlags = 0),
                                (N.memoizedProps = null),
                                (N.memoizedState = null),
                                (N.updateQueue = null),
                                (N.dependencies = null),
                                (N.stateNode = null))
                              : ((N.childLanes = IA.childLanes),
                                (N.lanes = IA.lanes),
                                (N.child = IA.child),
                                (N.subtreeFlags = 0),
                                (N.deletions = null),
                                (N.memoizedProps = IA.memoizedProps),
                                (N.memoizedState = IA.memoizedState),
                                (N.updateQueue = IA.updateQueue),
                                (N.type = IA.type),
                                (O = IA.dependencies),
                                (N.dependencies =
                                  O === null
                                    ? null
                                    : { lanes: O.lanes, firstContext: O.firstContext })),
                            (v = v.sibling))
                        return (UC(Fi, (Fi.current & 1) | 2), D.child)
                      }
                      u = u.sibling
                    }
                  O.tail !== null &&
                    ee() > ra &&
                    ((D.flags |= 128), (v = !0), lQ(O, !1), (D.lanes = 4194304))
                }
              else {
                if (!v)
                  if (((u = Wa(IA)), u !== null)) {
                    if (
                      ((D.flags |= 128),
                      (v = !0),
                      (u = u.updateQueue),
                      u !== null && ((D.updateQueue = u), (D.flags |= 4)),
                      lQ(O, !0),
                      O.tail === null && O.tailMode === "hidden" && !IA.alternate && !ri)
                    )
                      return (Re(D), null)
                  } else
                    2 * ee() - O.renderingStartTime > ra &&
                      N !== 1073741824 &&
                      ((D.flags |= 128), (v = !0), lQ(O, !1), (D.lanes = 4194304))
                O.isBackwards
                  ? ((IA.sibling = D.child), (D.child = IA))
                  : ((u = O.last), u !== null ? (u.sibling = IA) : (D.child = IA), (O.last = IA))
              }
              return O.tail !== null
                ? ((D = O.tail),
                  (O.rendering = D),
                  (O.tail = D.sibling),
                  (O.renderingStartTime = ee()),
                  (D.sibling = null),
                  (u = Fi.current),
                  UC(Fi, v ? (u & 1) | 2 : u & 1),
                  D)
                : (Re(D), null)
            case 22:
            case 23:
              return (
                bt(),
                (v = D.memoizedState !== null),
                u !== null && (u.memoizedState !== null) !== v && (D.flags |= 8192),
                v && D.mode & 1
                  ? PB & 1073741824 && (Re(D), cI && D.subtreeFlags & 6 && (D.flags |= 8192))
                  : Re(D),
                null
              )
            case 24:
              return null
            case 25:
              return null
          }
          throw Error(B(156, D.tag))
        }
        var Je = o.ReactCurrentOwner,
          te = !1
        function IC(u, D, N, v) {
          D.child = u === null ? Rs(D, null, N, v) : en(D, u.child, N, v)
        }
        function de(u, D, N, v, O) {
          N = N.render
          var IA = D.ref
          return (
            KC(D, O),
            (v = kE(u, D, N, v, IA, O)),
            (N = tn()),
            u !== null && !te
              ? ((D.updateQueue = u.updateQueue), (D.flags &= -2053), (u.lanes &= ~O), Ne(u, D, O))
              : (ri && N && Cn(D), (D.flags |= 1), IC(u, D, v, O), D.child)
          )
        }
        function Ue(u, D, N, v, O) {
          if (u === null) {
            var IA = N.type
            return typeof IA == "function" &&
              !Vn(IA) &&
              IA.defaultProps === void 0 &&
              N.compare === null &&
              N.defaultProps === void 0
              ? ((D.tag = 15), (D.type = IA), nn(u, D, IA, v, O))
              : ((u = ca(N.type, null, v, D, D.mode, O)),
                (u.ref = D.ref),
                (u.return = D),
                (D.child = u))
          }
          if (((IA = u.child), !(u.lanes & O))) {
            var UA = IA.memoizedProps
            if (((N = N.compare), (N = N !== null ? N : yB), N(UA, v) && u.ref === D.ref))
              return Ne(u, D, O)
          }
          return ((D.flags |= 1), (u = MB(IA, v)), (u.ref = D.ref), (u.return = D), (D.child = u))
        }
        function nn(u, D, N, v, O) {
          if (u !== null && yB(u.memoizedProps, v) && u.ref === D.ref)
            if (((te = !1), (u.lanes & O) !== 0)) u.flags & 131072 && (te = !0)
            else return ((D.lanes = u.lanes), Ne(u, D, O))
          return bB(u, D, N, v, O)
        }
        function kC(u, D, N) {
          var v = D.pendingProps,
            O = v.children,
            IA = u !== null ? u.memoizedState : null
          if (v.mode === "hidden")
            if (!(D.mode & 1))
              ((D.memoizedState = { baseLanes: 0, cachePool: null }), UC(ir, PB), (PB |= N))
            else if (N & 1073741824)
              ((D.memoizedState = { baseLanes: 0, cachePool: null }),
                (v = IA !== null ? IA.baseLanes : N),
                UC(ir, PB),
                (PB |= v))
            else
              return (
                (u = IA !== null ? IA.baseLanes | N : N),
                (D.lanes = D.childLanes = 1073741824),
                (D.memoizedState = { baseLanes: u, cachePool: null }),
                (D.updateQueue = null),
                UC(ir, PB),
                (PB |= u),
                null
              )
          else
            (IA !== null ? ((v = IA.baseLanes | N), (D.memoizedState = null)) : (v = N),
              UC(ir, PB),
              (PB |= v))
          return (IC(u, D, O, N), D.child)
        }
        function At(u, D) {
          var N = D.ref
          ;((u === null && N !== null) || (u !== null && u.ref !== N)) &&
            ((D.flags |= 512), (D.flags |= 2097152))
        }
        function bB(u, D, N, v, O) {
          var IA = qe(N) ? vC : Gg.current
          return (
            (IA = ii(D, IA)),
            KC(D, O),
            (N = kE(u, D, N, v, IA, O)),
            (v = tn()),
            u !== null && !te
              ? ((D.updateQueue = u.updateQueue), (D.flags &= -2053), (u.lanes &= ~O), Ne(u, D, O))
              : (ri && v && Cn(D), (D.flags |= 1), IC(u, D, N, O), D.child)
          )
        }
        function cQ(u, D, N, v, O) {
          if (qe(N)) {
            var IA = !0
            ai(D)
          } else IA = !1
          if ((KC(D, O), D.stateNode === null))
            (u !== null && ((u.alternate = null), (D.alternate = null), (D.flags |= 2)),
              vl(D, N, v),
              Ll(D, N, v, O),
              (v = !0))
          else if (u === null) {
            var UA = D.stateNode,
              CI = D.memoizedProps
            UA.props = CI
            var HI = UA.context,
              ng = N.contextType
            typeof ng == "object" && ng !== null
              ? (ng = GC(ng))
              : ((ng = qe(N) ? vC : Gg.current), (ng = ii(D, ng)))
            var Sg = N.getDerivedStateFromProps,
              DC = typeof Sg == "function" || typeof UA.getSnapshotBeforeUpdate == "function"
            ;(DC ||
              (typeof UA.UNSAFE_componentWillReceiveProps != "function" &&
                typeof UA.componentWillReceiveProps != "function") ||
              ((CI !== v || HI !== ng) && Pc(D, UA, v, ng)),
              (we = !1))
            var sC = D.memoizedState
            ;((UA.state = sC),
              XE(D, v, UA, O),
              (HI = D.memoizedState),
              CI !== v || sC !== HI || _C.current || we
                ? (typeof Sg == "function" && (Jl(D, N, Sg, v), (HI = D.memoizedState)),
                  (CI = we || ml(D, N, CI, v, sC, HI, ng))
                    ? (DC ||
                        (typeof UA.UNSAFE_componentWillMount != "function" &&
                          typeof UA.componentWillMount != "function") ||
                        (typeof UA.componentWillMount == "function" && UA.componentWillMount(),
                        typeof UA.UNSAFE_componentWillMount == "function" &&
                          UA.UNSAFE_componentWillMount()),
                      typeof UA.componentDidMount == "function" && (D.flags |= 4194308))
                    : (typeof UA.componentDidMount == "function" && (D.flags |= 4194308),
                      (D.memoizedProps = v),
                      (D.memoizedState = HI)),
                  (UA.props = v),
                  (UA.state = HI),
                  (UA.context = ng),
                  (v = CI))
                : (typeof UA.componentDidMount == "function" && (D.flags |= 4194308), (v = !1)))
          } else {
            ;((UA = D.stateNode),
              Io(u, D),
              (CI = D.memoizedProps),
              (ng = D.type === D.elementType ? CI : vA(D.type, CI)),
              (UA.props = ng),
              (DC = D.pendingProps),
              (sC = UA.context),
              (HI = N.contextType),
              typeof HI == "object" && HI !== null
                ? (HI = GC(HI))
                : ((HI = qe(N) ? vC : Gg.current), (HI = ii(D, HI))))
            var Be = N.getDerivedStateFromProps
            ;((Sg = typeof Be == "function" || typeof UA.getSnapshotBeforeUpdate == "function") ||
              (typeof UA.UNSAFE_componentWillReceiveProps != "function" &&
                typeof UA.componentWillReceiveProps != "function") ||
              ((CI !== DC || sC !== HI) && Pc(D, UA, v, HI)),
              (we = !1),
              (sC = D.memoizedState),
              (UA.state = sC),
              XE(D, v, UA, O))
            var kg = D.memoizedState
            CI !== DC || sC !== kg || _C.current || we
              ? (typeof Be == "function" && (Jl(D, N, Be, v), (kg = D.memoizedState)),
                (ng = we || ml(D, N, ng, v, sC, kg, HI) || !1)
                  ? (Sg ||
                      (typeof UA.UNSAFE_componentWillUpdate != "function" &&
                        typeof UA.componentWillUpdate != "function") ||
                      (typeof UA.componentWillUpdate == "function" &&
                        UA.componentWillUpdate(v, kg, HI),
                      typeof UA.UNSAFE_componentWillUpdate == "function" &&
                        UA.UNSAFE_componentWillUpdate(v, kg, HI)),
                    typeof UA.componentDidUpdate == "function" && (D.flags |= 4),
                    typeof UA.getSnapshotBeforeUpdate == "function" && (D.flags |= 1024))
                  : (typeof UA.componentDidUpdate != "function" ||
                      (CI === u.memoizedProps && sC === u.memoizedState) ||
                      (D.flags |= 4),
                    typeof UA.getSnapshotBeforeUpdate != "function" ||
                      (CI === u.memoizedProps && sC === u.memoizedState) ||
                      (D.flags |= 1024),
                    (D.memoizedProps = v),
                    (D.memoizedState = kg)),
                (UA.props = v),
                (UA.state = kg),
                (UA.context = HI),
                (v = ng))
              : (typeof UA.componentDidUpdate != "function" ||
                  (CI === u.memoizedProps && sC === u.memoizedState) ||
                  (D.flags |= 4),
                typeof UA.getSnapshotBeforeUpdate != "function" ||
                  (CI === u.memoizedProps && sC === u.memoizedState) ||
                  (D.flags |= 1024),
                (v = !1))
          }
          return Ri(u, D, N, v, IA, O)
        }
        function Ri(u, D, N, v, O, IA) {
          At(u, D)
          var UA = (D.flags & 128) !== 0
          if (!v && !UA) return (O && fi(D, N, !1), Ne(u, D, IA))
          ;((v = D.stateNode), (Je.current = D))
          var CI = UA && typeof N.getDerivedStateFromError != "function" ? null : v.render()
          return (
            (D.flags |= 1),
            u !== null && UA
              ? ((D.child = en(D, u.child, null, IA)), (D.child = en(D, null, CI, IA)))
              : IC(u, D, CI, IA),
            (D.memoizedState = v.state),
            O && fi(D, N, !0),
            D.child
          )
        }
        function hQ(u) {
          var D = u.stateNode
          ;(D.pendingContext
            ? Mi(u, D.pendingContext, D.pendingContext !== D.context)
            : D.context && Mi(u, D.context, !1),
            Js(u, D.containerInfo))
        }
        function bn(u, D, N, v, O) {
          return (Oa(), Or(O), (D.flags |= 256), IC(u, D, N, v), D.child)
        }
        var Qa = { dehydrated: null, treeContext: null, retryLane: 0 }
        function On(u) {
          return { baseLanes: u, cachePool: null }
        }
        function Vc(u, D, N) {
          var v = D.pendingProps,
            O = Fi.current,
            IA = !1,
            UA = (D.flags & 128) !== 0,
            CI
          if (
            ((CI = UA) || (CI = u !== null && u.memoizedState === null ? !1 : (O & 2) !== 0),
            CI
              ? ((IA = !0), (D.flags &= -129))
              : (u === null || u.memoizedState !== null) && (O |= 1),
            UC(Fi, O & 1),
            u === null)
          )
            return (
              yE(D),
              (u = D.memoizedState),
              u !== null && ((u = u.dehydrated), u !== null)
                ? (D.mode & 1 ? (fe(u) ? (D.lanes = 8) : (D.lanes = 1073741824)) : (D.lanes = 1),
                  null)
                : ((O = v.children),
                  (u = v.fallback),
                  IA
                    ? ((v = D.mode),
                      (IA = D.child),
                      (O = { mode: "hidden", children: O }),
                      !(v & 1) && IA !== null
                        ? ((IA.childLanes = 0), (IA.pendingProps = O))
                        : (IA = rr(O, v, 0, null)),
                      (u = Ro(u, v, N, null)),
                      (IA.return = D),
                      (u.return = D),
                      (IA.sibling = u),
                      (D.child = IA),
                      (D.child.memoizedState = On(N)),
                      (D.memoizedState = Qa),
                      u)
                    : OB(D, O))
            )
          if (((O = u.memoizedState), O !== null)) {
            if (((CI = O.dehydrated), CI !== null)) {
              if (UA)
                return D.flags & 256
                  ? ((D.flags &= -257), Mo(u, D, N, Error(B(422))))
                  : D.memoizedState !== null
                    ? ((D.child = u.child), (D.flags |= 128), null)
                    : ((IA = v.fallback),
                      (O = D.mode),
                      (v = rr({ mode: "visible", children: v.children }, O, 0, null)),
                      (IA = Ro(IA, O, N, null)),
                      (IA.flags |= 2),
                      (v.return = D),
                      (IA.return = D),
                      (v.sibling = IA),
                      (D.child = v),
                      D.mode & 1 && en(D, u.child, null, N),
                      (D.child.memoizedState = On(N)),
                      (D.memoizedState = Qa),
                      IA)
              if (!(D.mode & 1)) D = Mo(u, D, N, null)
              else if (fe(CI)) D = Mo(u, D, N, Error(B(419)))
              else if (((v = (N & u.childLanes) !== 0), te || v)) {
                if (((v = xi), v !== null)) {
                  switch (N & -N) {
                    case 4:
                      IA = 2
                      break
                    case 16:
                      IA = 8
                      break
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                    case 67108864:
                      IA = 32
                      break
                    case 536870912:
                      IA = 268435456
                      break
                    default:
                      IA = 0
                  }
                  ;((v = IA & (v.suspendedLanes | N) ? 0 : IA),
                    v !== 0 && v !== O.retryLane && ((O.retryLane = v), GB(u, v, -1)))
                }
                ;(la(), (D = Mo(u, D, N, Error(B(421)))))
              } else
                ei(CI)
                  ? ((D.flags |= 128),
                    (D.child = u.child),
                    (D = jl.bind(null, u)),
                    Ei(CI, D),
                    (D = null))
                  : ((N = O.treeContext),
                    eI &&
                      (($i = TI(CI)),
                      (Xi = D),
                      (ri = !0),
                      (pB = null),
                      (xa = !1),
                      N !== null &&
                        ((mQ[oQ++] = dE),
                        (mQ[oQ++] = po),
                        (mQ[oQ++] = fE),
                        (dE = N.id),
                        (po = N.overflow),
                        (fE = D))),
                    (D = OB(D, D.pendingProps.children)),
                    (D.flags |= 4096))
              return D
            }
            return IA
              ? ((v = jr(u, D, v.children, v.fallback, N)),
                (IA = D.child),
                (O = u.child.memoizedState),
                (IA.memoizedState =
                  O === null ? On(N) : { baseLanes: O.baseLanes | N, cachePool: null }),
                (IA.childLanes = u.childLanes & ~N),
                (D.memoizedState = Qa),
                v)
              : ((N = Xt(u, D, v.children, N)), (D.memoizedState = null), N)
          }
          return IA
            ? ((v = jr(u, D, v.children, v.fallback, N)),
              (IA = D.child),
              (O = u.child.memoizedState),
              (IA.memoizedState =
                O === null ? On(N) : { baseLanes: O.baseLanes | N, cachePool: null }),
              (IA.childLanes = u.childLanes & ~N),
              (D.memoizedState = Qa),
              v)
            : ((N = Xt(u, D, v.children, N)), (D.memoizedState = null), N)
        }
        function OB(u, D) {
          return (
            (D = rr({ mode: "visible", children: D }, u.mode, 0, null)),
            (D.return = u),
            (u.child = D)
          )
        }
        function Xt(u, D, N, v) {
          var O = u.child
          return (
            (u = O.sibling),
            (N = MB(O, { mode: "visible", children: N })),
            !(D.mode & 1) && (N.lanes = v),
            (N.return = D),
            (N.sibling = null),
            u !== null &&
              ((v = D.deletions), v === null ? ((D.deletions = [u]), (D.flags |= 16)) : v.push(u)),
            (D.child = N)
          )
        }
        function jr(u, D, N, v, O) {
          var IA = D.mode
          u = u.child
          var UA = u.sibling,
            CI = { mode: "hidden", children: N }
          return (
            !(IA & 1) && D.child !== u
              ? ((N = D.child), (N.childLanes = 0), (N.pendingProps = CI), (D.deletions = null))
              : ((N = MB(u, CI)), (N.subtreeFlags = u.subtreeFlags & 14680064)),
            UA !== null ? (v = MB(UA, v)) : ((v = Ro(v, IA, O, null)), (v.flags |= 2)),
            (v.return = D),
            (N.return = D),
            (N.sibling = v),
            (D.child = N),
            v
          )
        }
        function Mo(u, D, N, v) {
          return (
            v !== null && Or(v),
            en(D, u.child, null, N),
            (u = OB(D, D.pendingProps.children)),
            (u.flags |= 2),
            (D.memoizedState = null),
            u
          )
        }
        function oa(u, D, N) {
          u.lanes |= D
          var v = u.alternate
          ;(v !== null && (v.lanes |= D), NC(u.return, D, N))
        }
        function st(u, D, N, v, O) {
          var IA = u.memoizedState
          IA === null
            ? (u.memoizedState = {
                isBackwards: D,
                rendering: null,
                renderingStartTime: 0,
                last: v,
                tail: N,
                tailMode: O,
              })
            : ((IA.isBackwards = D),
              (IA.rendering = null),
              (IA.renderingStartTime = 0),
              (IA.last = v),
              (IA.tail = N),
              (IA.tailMode = O))
        }
        function En(u, D, N) {
          var v = D.pendingProps,
            O = v.revealOrder,
            IA = v.tail
          if ((IC(u, D, v.children, N), (v = Fi.current), v & 2))
            ((v = (v & 1) | 2), (D.flags |= 128))
          else {
            if (u !== null && u.flags & 128)
              A: for (u = D.child; u !== null; ) {
                if (u.tag === 13) u.memoizedState !== null && oa(u, N, D)
                else if (u.tag === 19) oa(u, N, D)
                else if (u.child !== null) {
                  ;((u.child.return = u), (u = u.child))
                  continue
                }
                if (u === D) break A
                for (; u.sibling === null; ) {
                  if (u.return === null || u.return === D) break A
                  u = u.return
                }
                ;((u.sibling.return = u.return), (u = u.sibling))
              }
            v &= 1
          }
          if ((UC(Fi, v), !(D.mode & 1))) D.memoizedState = null
          else
            switch (O) {
              case "forwards":
                for (N = D.child, O = null; N !== null; )
                  ((u = N.alternate), u !== null && Wa(u) === null && (O = N), (N = N.sibling))
                ;((N = O),
                  N === null
                    ? ((O = D.child), (D.child = null))
                    : ((O = N.sibling), (N.sibling = null)),
                  st(D, !1, O, N, IA))
                break
              case "backwards":
                for (N = null, O = D.child, D.child = null; O !== null; ) {
                  if (((u = O.alternate), u !== null && Wa(u) === null)) {
                    D.child = O
                    break
                  }
                  ;((u = O.sibling), (O.sibling = N), (N = O), (O = u))
                }
                st(D, !0, N, null, IA)
                break
              case "together":
                st(D, !1, null, null, void 0)
                break
              default:
                D.memoizedState = null
            }
          return D.child
        }
        function Ne(u, D, N) {
          if (
            (u !== null && (D.dependencies = u.dependencies), (HQ |= D.lanes), !(N & D.childLanes))
          )
            return null
          if (u !== null && D.child !== u.child) throw Error(B(153))
          if (D.child !== null) {
            for (
              u = D.child, N = MB(u, u.pendingProps), D.child = N, N.return = D;
              u.sibling !== null;
            )
              ((u = u.sibling), (N = N.sibling = MB(u, u.pendingProps)), (N.return = D))
            N.sibling = null
          }
          return D.child
        }
        function Uo(u, D, N) {
          switch (D.tag) {
            case 3:
              ;(hQ(D), Oa())
              break
            case 5:
              Ks(D)
              break
            case 1:
              qe(D.type) && ai(D)
              break
            case 4:
              Js(D, D.stateNode.containerInfo)
              break
            case 10:
              tC(D, D.type._context, D.memoizedProps.value)
              break
            case 13:
              var v = D.memoizedState
              if (v !== null)
                return v.dehydrated !== null
                  ? (UC(Fi, Fi.current & 1), (D.flags |= 128), null)
                  : N & D.child.childLanes
                    ? Vc(u, D, N)
                    : (UC(Fi, Fi.current & 1), (u = Ne(u, D, N)), u !== null ? u.sibling : null)
              UC(Fi, Fi.current & 1)
              break
            case 19:
              if (((v = (N & D.childLanes) !== 0), u.flags & 128)) {
                if (v) return En(u, D, N)
                D.flags |= 128
              }
              var O = D.memoizedState
              if (
                (O !== null && ((O.rendering = null), (O.tail = null), (O.lastEffect = null)),
                UC(Fi, Fi.current),
                v)
              )
                break
              return null
            case 22:
            case 23:
              return ((D.lanes = 0), kC(u, D, N))
          }
          return Ne(u, D, N)
        }
        function LC(u, D) {
          switch ((at(D), D.tag)) {
            case 1:
              return (
                qe(D.type) && pe(),
                (u = D.flags),
                u & 65536 ? ((D.flags = (u & -65537) | 128), D) : null
              )
            case 3:
              return (
                Pa(),
                mg(_C),
                mg(Gg),
                vQ(),
                (u = D.flags),
                u & 65536 && !(u & 128) ? ((D.flags = (u & -65537) | 128), D) : null
              )
            case 5:
              return (go(D), null)
            case 13:
              if ((mg(Fi), (u = D.memoizedState), u !== null && u.dehydrated !== null)) {
                if (D.alternate === null) throw Error(B(340))
                Oa()
              }
              return ((u = D.flags), u & 65536 ? ((D.flags = (u & -65537) | 128), D) : null)
            case 19:
              return (mg(Fi), null)
            case 4:
              return (Pa(), null)
            case 10:
              return (BC(D.type._context), null)
            case 22:
            case 23:
              return (bt(), null)
            case 24:
              return null
            default:
              return null
          }
        }
        var Yt = !1,
          It = !1,
          an = typeof WeakSet == "function" ? WeakSet : Set,
          lg = null
        function YQ(u, D) {
          var N = u.ref
          if (N !== null)
            if (typeof N == "function")
              try {
                N(null)
              } catch (v) {
                Fe(u, D, v)
              }
            else N.current = null
        }
        function $t(u, D, N) {
          try {
            N()
          } catch (v) {
            Fe(u, D, v)
          }
        }
        var _l = !1
        function qs(u, D) {
          for (fA(u.containerInfo), lg = D; lg !== null; )
            if (((u = lg), (D = u.child), (u.subtreeFlags & 1028) !== 0 && D !== null))
              ((D.return = u), (lg = D))
            else
              for (; lg !== null; ) {
                u = lg
                try {
                  var N = u.alternate
                  if (u.flags & 1024)
                    switch (u.tag) {
                      case 0:
                      case 11:
                      case 15:
                        break
                      case 1:
                        if (N !== null) {
                          var v = N.memoizedProps,
                            O = N.memoizedState,
                            IA = u.stateNode,
                            UA = IA.getSnapshotBeforeUpdate(
                              u.elementType === u.type ? v : vA(u.type, v),
                              O,
                            )
                          IA.__reactInternalSnapshotBeforeUpdate = UA
                        }
                        break
                      case 3:
                        cI && iI(u.stateNode.containerInfo)
                        break
                      case 5:
                      case 6:
                      case 4:
                      case 17:
                        break
                      default:
                        throw Error(B(163))
                    }
                } catch (CI) {
                  Fe(u, u.return, CI)
                }
                if (((D = u.sibling), D !== null)) {
                  ;((D.return = u.return), (lg = D))
                  break
                }
                lg = u.return
              }
          return ((N = _l), (_l = !1), N)
        }
        function NE(u, D, N) {
          var v = D.updateQueue
          if (((v = v !== null ? v.lastEffect : null), v !== null)) {
            var O = (v = v.next)
            do {
              if ((O.tag & u) === u) {
                var IA = O.destroy
                ;((O.destroy = void 0), IA !== void 0 && $t(D, N, IA))
              }
              O = O.next
            } while (O !== v)
          }
        }
        function AB(u, D) {
          if (((D = D.updateQueue), (D = D !== null ? D.lastEffect : null), D !== null)) {
            var N = (D = D.next)
            do {
              if ((N.tag & u) === u) {
                var v = N.create
                N.destroy = v()
              }
              N = N.next
            } while (N !== D)
          }
        }
        function _B(u) {
          var D = u.ref
          if (D !== null) {
            var N = u.stateNode
            switch (u.tag) {
              case 5:
                u = yA(N)
                break
              default:
                u = N
            }
            typeof D == "function" ? D(u) : (D.current = u)
          }
        }
        function pi(u, D, N) {
          if (HB && typeof HB.onCommitFiberUnmount == "function")
            try {
              HB.onCommitFiberUnmount(JQ, D)
            } catch {}
          switch (D.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              if (((u = D.updateQueue), u !== null && ((u = u.lastEffect), u !== null))) {
                var v = (u = u.next)
                do {
                  var O = v,
                    IA = O.destroy
                  ;((O = O.tag), IA !== void 0 && (O & 2 || O & 4) && $t(D, N, IA), (v = v.next))
                } while (v !== u)
              }
              break
            case 1:
              if ((YQ(D, N), (u = D.stateNode), typeof u.componentWillUnmount == "function"))
                try {
                  ;((u.props = D.memoizedProps),
                    (u.state = D.memoizedState),
                    u.componentWillUnmount())
                } catch (UA) {
                  Fe(D, N, UA)
                }
              break
            case 5:
              YQ(D, N)
              break
            case 4:
              cI
                ? qt(u, D, N)
                : YA && YA && ((D = D.stateNode.containerInfo), (N = qI(D)), Qg(D, N))
          }
        }
        function qQ(u, D, N) {
          for (var v = D; ; )
            if ((pi(u, v, N), v.child === null || (cI && v.tag === 4))) {
              if (v === D) break
              for (; v.sibling === null; ) {
                if (v.return === null || v.return === D) return
                v = v.return
              }
              ;((v.sibling.return = v.return), (v = v.sibling))
            } else ((v.child.return = v), (v = v.child))
        }
        function to(u) {
          var D = u.alternate
          ;(D !== null && ((u.alternate = null), to(D)),
            (u.child = null),
            (u.deletions = null),
            (u.sibling = null),
            u.tag === 5 && ((D = u.stateNode), D !== null && pI(D)),
            (u.stateNode = null),
            (u.return = null),
            (u.dependencies = null),
            (u.memoizedProps = null),
            (u.memoizedState = null),
            (u.pendingProps = null),
            (u.stateNode = null),
            (u.updateQueue = null))
        }
        function gr(u) {
          return u.tag === 5 || u.tag === 3 || u.tag === 4
        }
        function FE(u) {
          A: for (;;) {
            for (; u.sibling === null; ) {
              if (u.return === null || gr(u.return)) return null
              u = u.return
            }
            for (
              u.sibling.return = u.return, u = u.sibling;
              u.tag !== 5 && u.tag !== 6 && u.tag !== 18;
            ) {
              if (u.flags & 2 || u.child === null || u.tag === 4) continue A
              ;((u.child.return = u), (u = u.child))
            }
            if (!(u.flags & 2)) return u.stateNode
          }
        }
        function Cr(u) {
          if (cI) {
            A: {
              for (var D = u.return; D !== null; ) {
                if (gr(D)) break A
                D = D.return
              }
              throw Error(B(160))
            }
            var N = D
            switch (N.tag) {
              case 5:
                ;((D = N.stateNode),
                  N.flags & 32 && (XI(D), (N.flags &= -33)),
                  (N = FE(u)),
                  ZB(u, N, D))
                break
              case 3:
              case 4:
                ;((D = N.stateNode.containerInfo), (N = FE(u)), na(u, N, D))
                break
              default:
                throw Error(B(161))
            }
          }
        }
        function na(u, D, N) {
          var v = u.tag
          if (v === 5 || v === 6) ((u = u.stateNode), D ? RI(N, u, D) : LI(N, u))
          else if (v !== 4 && ((u = u.child), u !== null))
            for (na(u, D, N), u = u.sibling; u !== null; ) (na(u, D, N), (u = u.sibling))
        }
        function ZB(u, D, N) {
          var v = u.tag
          if (v === 5 || v === 6) ((u = u.stateNode), D ? aI(N, u, D) : GI(N, u))
          else if (v !== 4 && ((u = u.child), u !== null))
            for (ZB(u, D, N), u = u.sibling; u !== null; ) (ZB(u, D, N), (u = u.sibling))
        }
        function qt(u, D, N) {
          for (var v = D, O = !1, IA, UA; ; ) {
            if (!O) {
              O = v.return
              A: for (;;) {
                if (O === null) throw Error(B(160))
                switch (((IA = O.stateNode), O.tag)) {
                  case 5:
                    UA = !1
                    break A
                  case 3:
                    ;((IA = IA.containerInfo), (UA = !0))
                    break A
                  case 4:
                    ;((IA = IA.containerInfo), (UA = !0))
                    break A
                }
                O = O.return
              }
              O = !0
            }
            if (v.tag === 5 || v.tag === 6)
              (qQ(u, v, N), UA ? ag(IA, v.stateNode) : VA(IA, v.stateNode))
            else if (v.tag === 18) UA ? oI(IA, v.stateNode) : _A(IA, v.stateNode)
            else if (v.tag === 4) {
              if (v.child !== null) {
                ;((IA = v.stateNode.containerInfo), (UA = !0), (v.child.return = v), (v = v.child))
                continue
              }
            } else if ((pi(u, v, N), v.child !== null)) {
              ;((v.child.return = v), (v = v.child))
              continue
            }
            if (v === D) break
            for (; v.sibling === null; ) {
              if (v.return === null || v.return === D) return
              ;((v = v.return), v.tag === 4 && (O = !1))
            }
            ;((v.sibling.return = v.return), (v = v.sibling))
          }
        }
        function Hi(u, D) {
          if (cI) {
            switch (D.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                ;(NE(3, D, D.return), AB(3, D), NE(5, D, D.return))
                return
              case 1:
                return
              case 5:
                var N = D.stateNode
                if (N != null) {
                  var v = D.memoizedProps
                  u = u !== null ? u.memoizedProps : v
                  var O = D.type,
                    IA = D.updateQueue
                  ;((D.updateQueue = null), IA !== null && OA(N, IA, O, u, v, D))
                }
                return
              case 6:
                if (D.stateNode === null) throw Error(B(162))
                ;((N = D.memoizedProps), Bg(D.stateNode, u !== null ? u.memoizedProps : N, N))
                return
              case 3:
                eI && u !== null && u.memoizedState.isDehydrated && jg(D.stateNode.containerInfo)
                return
              case 12:
                return
              case 13:
                zr(D)
                return
              case 19:
                zr(D)
                return
              case 17:
                return
            }
            throw Error(B(163))
          }
          switch (D.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              ;(NE(3, D, D.return), AB(3, D), NE(5, D, D.return))
              return
            case 12:
              return
            case 13:
              zr(D)
              return
            case 19:
              zr(D)
              return
            case 3:
              eI && u !== null && u.memoizedState.isDehydrated && jg(D.stateNode.containerInfo)
              break
            case 22:
            case 23:
              return
          }
          A: if (YA) {
            switch (D.tag) {
              case 1:
              case 5:
              case 6:
                break A
              case 3:
              case 4:
                ;((D = D.stateNode), Qg(D.containerInfo, D.pendingChildren))
                break A
            }
            throw Error(B(163))
          }
        }
        function zr(u) {
          var D = u.updateQueue
          if (D !== null) {
            u.updateQueue = null
            var N = u.stateNode
            ;(N === null && (N = u.stateNode = new an()),
              D.forEach(function (v) {
                var O = Wn.bind(null, u, v)
                N.has(v) || (N.add(v), v.then(O, O))
              }))
          }
        }
        function Zl(u, D) {
          for (lg = D; lg !== null; ) {
            D = lg
            var N = D.deletions
            if (N !== null)
              for (var v = 0; v < N.length; v++) {
                var O = N[v]
                try {
                  var IA = u
                  cI ? qt(IA, O, D) : qQ(IA, O, D)
                  var UA = O.alternate
                  ;(UA !== null && (UA.return = null), (O.return = null))
                } catch (Zg) {
                  Fe(O, D, Zg)
                }
              }
            if (((N = D.child), D.subtreeFlags & 12854 && N !== null)) ((N.return = D), (lg = N))
            else
              for (; lg !== null; ) {
                D = lg
                try {
                  var CI = D.flags
                  if ((CI & 32 && cI && XI(D.stateNode), CI & 512)) {
                    var HI = D.alternate
                    if (HI !== null) {
                      var ng = HI.ref
                      ng !== null && (typeof ng == "function" ? ng(null) : (ng.current = null))
                    }
                  }
                  if (CI & 8192)
                    switch (D.tag) {
                      case 13:
                        if (D.memoizedState !== null) {
                          var Sg = D.alternate
                          ;(Sg === null || Sg.memoizedState === null) && (Os = ee())
                        }
                        break
                      case 22:
                        var DC = D.memoizedState !== null,
                          sC = D.alternate,
                          Be = sC !== null && sC.memoizedState !== null
                        if (((N = D), cI)) {
                          A: if (((v = N), (O = DC), (IA = null), cI))
                            for (var kg = v; ; ) {
                              if (kg.tag === 5) {
                                if (IA === null) {
                                  IA = kg
                                  var ut = kg.stateNode
                                  O ? $I(ut) : NI(kg.stateNode, kg.memoizedProps)
                                }
                              } else if (kg.tag === 6) {
                                if (IA === null) {
                                  var Dt = kg.stateNode
                                  O ? SA(Dt) : HA(Dt, kg.memoizedProps)
                                }
                              } else if (
                                ((kg.tag !== 22 && kg.tag !== 23) ||
                                  kg.memoizedState === null ||
                                  kg === v) &&
                                kg.child !== null
                              ) {
                                ;((kg.child.return = kg), (kg = kg.child))
                                continue
                              }
                              if (kg === v) break
                              for (; kg.sibling === null; ) {
                                if (kg.return === null || kg.return === v) break A
                                ;(IA === kg && (IA = null), (kg = kg.return))
                              }
                              ;(IA === kg && (IA = null),
                                (kg.sibling.return = kg.return),
                                (kg = kg.sibling))
                            }
                        }
                        if (DC && !Be && N.mode & 1) {
                          lg = N
                          for (var yI = N.child; yI !== null; ) {
                            for (N = lg = yI; lg !== null; ) {
                              v = lg
                              var zA = v.child
                              switch (v.tag) {
                                case 0:
                                case 11:
                                case 14:
                                case 15:
                                  NE(4, v, v.return)
                                  break
                                case 1:
                                  YQ(v, v.return)
                                  var JI = v.stateNode
                                  if (typeof JI.componentWillUnmount == "function") {
                                    var WI = v.return
                                    try {
                                      ;((JI.props = v.memoizedProps),
                                        (JI.state = v.memoizedState),
                                        JI.componentWillUnmount())
                                    } catch (Zg) {
                                      Fe(v, WI, Zg)
                                    }
                                  }
                                  break
                                case 5:
                                  YQ(v, v.return)
                                  break
                                case 22:
                                  if (v.memoizedState !== null) {
                                    Hs(N)
                                    continue
                                  }
                              }
                              zA !== null ? ((zA.return = v), (lg = zA)) : Hs(N)
                            }
                            yI = yI.sibling
                          }
                        }
                    }
                  switch (CI & 4102) {
                    case 2:
                      ;(Cr(D), (D.flags &= -3))
                      break
                    case 6:
                      ;(Cr(D), (D.flags &= -3), Hi(D.alternate, D))
                      break
                    case 4096:
                      D.flags &= -4097
                      break
                    case 4100:
                      ;((D.flags &= -4097), Hi(D.alternate, D))
                      break
                    case 4:
                      Hi(D.alternate, D)
                  }
                } catch (Zg) {
                  Fe(D, D.return, Zg)
                }
                if (((N = D.sibling), N !== null)) {
                  ;((N.return = D.return), (lg = N))
                  break
                }
                lg = D.return
              }
          }
        }
        function Ea(u, D, N) {
          ;((lg = u), No(u))
        }
        function No(u, D, N) {
          for (var v = (u.mode & 1) !== 0; lg !== null; ) {
            var O = lg,
              IA = O.child
            if (O.tag === 22 && v) {
              var UA = O.memoizedState !== null || Yt
              if (!UA) {
                var CI = O.alternate,
                  HI = (CI !== null && CI.memoizedState !== null) || It
                CI = Yt
                var ng = It
                if (((Yt = UA), (It = HI) && !ng))
                  for (lg = O; lg !== null; )
                    ((UA = lg),
                      (HI = UA.child),
                      UA.tag === 22 && UA.memoizedState !== null
                        ? er(O)
                        : HI !== null
                          ? ((HI.return = UA), (lg = HI))
                          : er(O))
                for (; IA !== null; ) ((lg = IA), No(IA), (IA = IA.sibling))
                ;((lg = O), (Yt = CI), (It = ng))
              }
              Pl(u)
            } else O.subtreeFlags & 8772 && IA !== null ? ((IA.return = O), (lg = IA)) : Pl(u)
          }
        }
        function Pl(u) {
          for (; lg !== null; ) {
            var D = lg
            if (D.flags & 8772) {
              var N = D.alternate
              try {
                if (D.flags & 8772)
                  switch (D.tag) {
                    case 0:
                    case 11:
                    case 15:
                      It || AB(5, D)
                      break
                    case 1:
                      var v = D.stateNode
                      if (D.flags & 4 && !It)
                        if (N === null) v.componentDidMount()
                        else {
                          var O =
                            D.elementType === D.type ? N.memoizedProps : vA(D.type, N.memoizedProps)
                          v.componentDidUpdate(
                            O,
                            N.memoizedState,
                            v.__reactInternalSnapshotBeforeUpdate,
                          )
                        }
                      var IA = D.updateQueue
                      IA !== null && br(D, IA, v)
                      break
                    case 3:
                      var UA = D.updateQueue
                      if (UA !== null) {
                        if (((N = null), D.child !== null))
                          switch (D.child.tag) {
                            case 5:
                              N = yA(D.child.stateNode)
                              break
                            case 1:
                              N = D.child.stateNode
                          }
                        br(D, UA, N)
                      }
                      break
                    case 5:
                      var CI = D.stateNode
                      N === null && D.flags & 4 && MA(CI, D.type, D.memoizedProps, D)
                      break
                    case 6:
                      break
                    case 4:
                      break
                    case 12:
                      break
                    case 13:
                      if (eI && D.memoizedState === null) {
                        var HI = D.alternate
                        if (HI !== null) {
                          var ng = HI.memoizedState
                          if (ng !== null) {
                            var Sg = ng.dehydrated
                            Sg !== null && rA(Sg)
                          }
                        }
                      }
                      break
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                      break
                    default:
                      throw Error(B(163))
                  }
                It || (D.flags & 512 && _B(D))
              } catch (DC) {
                Fe(D, D.return, DC)
              }
            }
            if (D === u) {
              lg = null
              break
            }
            if (((N = D.sibling), N !== null)) {
              ;((N.return = D.return), (lg = N))
              break
            }
            lg = D.return
          }
        }
        function Hs(u) {
          for (; lg !== null; ) {
            var D = lg
            if (D === u) {
              lg = null
              break
            }
            var N = D.sibling
            if (N !== null) {
              ;((N.return = D.return), (lg = N))
              break
            }
            lg = D.return
          }
        }
        function er(u) {
          for (; lg !== null; ) {
            var D = lg
            try {
              switch (D.tag) {
                case 0:
                case 11:
                case 15:
                  var N = D.return
                  try {
                    AB(4, D)
                  } catch (HI) {
                    Fe(D, N, HI)
                  }
                  break
                case 1:
                  var v = D.stateNode
                  if (typeof v.componentDidMount == "function") {
                    var O = D.return
                    try {
                      v.componentDidMount()
                    } catch (HI) {
                      Fe(D, O, HI)
                    }
                  }
                  var IA = D.return
                  try {
                    _B(D)
                  } catch (HI) {
                    Fe(D, IA, HI)
                  }
                  break
                case 5:
                  var UA = D.return
                  try {
                    _B(D)
                  } catch (HI) {
                    Fe(D, UA, HI)
                  }
              }
            } catch (HI) {
              Fe(D, D.return, HI)
            }
            if (D === u) {
              lg = null
              break
            }
            var CI = D.sibling
            if (CI !== null) {
              ;((CI.return = D.return), (lg = CI))
              break
            }
            lg = D.return
          }
        }
        var Ts = 0,
          Bi = 1,
          Ti = 2,
          fg = 3,
          Ht = 4
        if (typeof Symbol == "function" && Symbol.for) {
          var lB = Symbol.for
          ;((Ts = lB("selector.component")),
            (Bi = lB("selector.has_pseudo_class")),
            (Ti = lB("selector.role")),
            (fg = lB("selector.test_id")),
            (Ht = lB("selector.text")))
        }
        function xs(u) {
          var D = uA(u)
          if (D != null) {
            if (typeof D.memoizedProps["data-testname"] != "string") throw Error(B(364))
            return D
          }
          if (((u = QA(u)), u === null)) throw Error(B(362))
          return u.stateNode.current
        }
        function bs(u, D) {
          switch (D.$$typeof) {
            case Ts:
              if (u.type === D.value) return !0
              break
            case Bi:
              A: {
                ;((D = D.value), (u = [u, 0]))
                for (var N = 0; N < u.length; ) {
                  var v = u[N++],
                    O = u[N++],
                    IA = D[O]
                  if (v.tag !== 5 || !WA(v)) {
                    for (; IA != null && bs(v, IA); ) (O++, (IA = D[O]))
                    if (O === D.length) {
                      D = !0
                      break A
                    } else for (v = v.child; v !== null; ) (u.push(v, O), (v = v.sibling))
                  }
                }
                D = !1
              }
              return D
            case Ti:
              if (u.tag === 5 && jA(u.stateNode, D.value)) return !0
              break
            case Ht:
              if (
                (u.tag === 5 || u.tag === 6) &&
                ((u = FA(u)), u !== null && 0 <= u.indexOf(D.value))
              )
                return !0
              break
            case fg:
              if (
                u.tag === 5 &&
                ((u = u.memoizedProps["data-testname"]),
                typeof u == "string" && u.toLowerCase() === D.value.toLowerCase())
              )
                return !0
              break
            default:
              throw Error(B(365))
          }
          return !1
        }
        function Bo(u) {
          switch (u.$$typeof) {
            case Ts:
              return "<" + (P(u.value) || "Unknown") + ">"
            case Bi:
              return ":has(" + (Bo(u) || "") + ")"
            case Ti:
              return '[role="' + u.value + '"]'
            case Ht:
              return '"' + u.value + '"'
            case fg:
              return '[data-testname="' + u.value + '"]'
            default:
              throw Error(B(365))
          }
        }
        function si(u, D) {
          var N = []
          u = [u, 0]
          for (var v = 0; v < u.length; ) {
            var O = u[v++],
              IA = u[v++],
              UA = D[IA]
            if (O.tag !== 5 || !WA(O)) {
              for (; UA != null && bs(O, UA); ) (IA++, (UA = D[IA]))
              if (IA === D.length) N.push(O)
              else for (O = O.child; O !== null; ) (u.push(O, IA), (O = O.sibling))
            }
          }
          return N
        }
        function wg(u, D) {
          if (!SI) throw Error(B(363))
          ;((u = xs(u)), (u = si(u, D)), (D = []), (u = Array.from(u)))
          for (var N = 0; N < u.length; ) {
            var v = u[N++]
            if (v.tag === 5) WA(v) || D.push(v.stateNode)
            else for (v = v.child; v !== null; ) (u.push(v), (v = v.sibling))
          }
          return D
        }
        var Qi = Math.ceil,
          uQ = o.ReactCurrentDispatcher,
          rn = o.ReactCurrentOwner,
          li = o.ReactCurrentBatchConfig,
          $C = 0,
          xi = null,
          Ke = null,
          Ie = 0,
          PB = 0,
          ir = wC(0),
          lt = 0,
          tr = null,
          HQ = 0,
          IB = 0,
          aa = 0,
          RE = null,
          Tt = null,
          Os = 0,
          ra = 1 / 0
        function Br() {
          ra = ee() + 500
        }
        var Qr = !1,
          wi = null,
          sn = null,
          or = !1,
          _n = null,
          nr = 0,
          JE = 0,
          zg = null,
          Pg = -1,
          uC = 0
        function rC() {
          return $C & 6 ? ee() : Pg !== -1 ? Pg : (Pg = ee())
        }
        function xt(u) {
          return u.mode & 1
            ? $C & 2 && Ie !== 0
              ? Ie & -Ie
              : gn.transition !== null
                ? (uC === 0 && ((u = aB), (aB <<= 1), !(aB & 4194240) && (aB = 64), (uC = u)), uC)
                : ((u = hC), u !== 0 ? u : II())
            : 1
        }
        function GB(u, D, N) {
          if (50 < JE) throw ((JE = 0), (zg = null), Error(B(185)))
          var v = Zn(u, D)
          return v === null
            ? null
            : (oC(v, D, N),
              (!($C & 2) || v !== xi) &&
                (v === xi && (!($C & 2) && (IB |= D), lt === 4 && bg(v, Ie)),
                TQ(v, N),
                D === 1 && $C === 0 && !(u.mode & 1) && (Br(), QQ && zt())),
              v)
        }
        function Zn(u, D) {
          u.lanes |= D
          var N = u.alternate
          for (N !== null && (N.lanes |= D), N = u, u = u.return; u !== null; )
            ((u.childLanes |= D),
              (N = u.alternate),
              N !== null && (N.childLanes |= D),
              (N = u),
              (u = u.return))
          return N.tag === 3 ? N.stateNode : null
        }
        function TQ(u, D) {
          var N = u.callbackNode
          ZC(u, D)
          var v = zQ(u, u === xi ? Ie : 0)
          if (v === 0) (N !== null && di(N), (u.callbackNode = null), (u.callbackPriority = 0))
          else if (((D = v & -v), u.callbackPriority !== D)) {
            if ((N != null && di(N), D === 1))
              (u.tag === 0 ? In(cB.bind(null, u)) : Ao(cB.bind(null, u)),
                AI
                  ? YI(function () {
                      $C === 0 && zt()
                    })
                  : wt(Zi, zt),
                (N = null))
            else {
              switch (Vt(v)) {
                case 1:
                  N = Zi
                  break
                case 4:
                  N = XQ
                  break
                case 16:
                  N = rB
                  break
                case 536870912:
                  N = $Q
                  break
                default:
                  N = rB
              }
              N = ln(N, ci.bind(null, u))
            }
            ;((u.callbackPriority = D), (u.callbackNode = N))
          }
        }
        function ci(u, D) {
          if (((Pg = -1), (uC = 0), $C & 6)) throw Error(B(327))
          var N = u.callbackNode
          if (Fo() && u.callbackNode !== N) return null
          var v = zQ(u, u === xi ? Ie : 0)
          if (v === 0) return null
          if (v & 30 || v & u.expiredLanes || D) D = Pn(u, v)
          else {
            D = v
            var O = $C
            $C |= 2
            var IA = sa()
            ;(xi !== u || Ie !== D) && (Br(), gB(u, D))
            do
              try {
                _s()
                break
              } catch (CI) {
                Er(u, CI)
              }
            while (!0)
            ;(pg(),
              (uQ.current = IA),
              ($C = O),
              Ke !== null ? (D = 0) : ((xi = null), (Ie = 0), (D = lt)))
          }
          if (D !== 0) {
            if ((D === 2 && ((O = Ui(u)), O !== 0 && ((v = O), (D = DQ(u, O)))), D === 1))
              throw ((N = tr), gB(u, 0), bg(u, v), TQ(u, ee()), N)
            if (D === 6) bg(u, v)
            else {
              if (
                ((O = u.current.alternate),
                !(v & 30) &&
                  !ct(O) &&
                  ((D = Pn(u, v)),
                  D === 2 && ((IA = Ui(u)), IA !== 0 && ((v = IA), (D = DQ(u, IA)))),
                  D === 1))
              )
                throw ((N = tr), gB(u, 0), bg(u, v), TQ(u, ee()), N)
              switch (((u.finishedWork = O), (u.finishedLanes = v), D)) {
                case 0:
                case 1:
                  throw Error(B(345))
                case 2:
                  kB(u, Tt)
                  break
                case 3:
                  if ((bg(u, v), (v & 130023424) === v && ((D = Os + 500 - ee()), 10 < D))) {
                    if (zQ(u, 0) !== 0) break
                    if (((O = u.suspendedLanes), (O & v) !== v)) {
                      ;(rC(), (u.pingedLanes |= u.suspendedLanes & O))
                      break
                    }
                    u.timeoutHandle = NA(kB.bind(null, u, Tt), D)
                    break
                  }
                  kB(u, Tt)
                  break
                case 4:
                  if ((bg(u, v), (v & 4194240) === v)) break
                  for (D = u.eventTimes, O = -1; 0 < v; ) {
                    var UA = 31 - He(v)
                    ;((IA = 1 << UA), (UA = D[UA]), UA > O && (O = UA), (v &= ~IA))
                  }
                  if (
                    ((v = O),
                    (v = ee() - v),
                    (v =
                      (120 > v
                        ? 120
                        : 480 > v
                          ? 480
                          : 1080 > v
                            ? 1080
                            : 1920 > v
                              ? 1920
                              : 3e3 > v
                                ? 3e3
                                : 4320 > v
                                  ? 4320
                                  : 1960 * Qi(v / 1960)) - v),
                    10 < v)
                  ) {
                    u.timeoutHandle = NA(kB.bind(null, u, Tt), v)
                    break
                  }
                  kB(u, Tt)
                  break
                case 5:
                  kB(u, Tt)
                  break
                default:
                  throw Error(B(329))
              }
            }
          }
          return (TQ(u, ee()), u.callbackNode === N ? ci.bind(null, u) : null)
        }
        function DQ(u, D) {
          var N = RE
          return (
            u.current.memoizedState.isDehydrated && (gB(u, D).flags |= 256),
            (u = Pn(u, D)),
            u !== 2 && ((D = Tt), (Tt = N), D !== null && Ag(D)),
            u
          )
        }
        function Ag(u) {
          Tt === null ? (Tt = u) : Tt.push.apply(Tt, u)
        }
        function ct(u) {
          for (var D = u; ; ) {
            if (D.flags & 16384) {
              var N = D.updateQueue
              if (N !== null && ((N = N.stores), N !== null))
                for (var v = 0; v < N.length; v++) {
                  var O = N[v],
                    IA = O.getSnapshot
                  O = O.value
                  try {
                    if (!Gt(IA(), O)) return !1
                  } catch {
                    return !1
                  }
                }
            }
            if (((N = D.child), D.subtreeFlags & 16384 && N !== null)) ((N.return = D), (D = N))
            else {
              if (D === u) break
              for (; D.sibling === null; ) {
                if (D.return === null || D.return === u) return !0
                D = D.return
              }
              ;((D.sibling.return = D.return), (D = D.sibling))
            }
          }
          return !0
        }
        function bg(u, D) {
          for (
            D &= ~aa, D &= ~IB, u.suspendedLanes |= D, u.pingedLanes &= ~D, u = u.expirationTimes;
            0 < D;
          ) {
            var N = 31 - He(D),
              v = 1 << N
            ;((u[N] = -1), (D &= ~v))
          }
        }
        function cB(u) {
          if ($C & 6) throw Error(B(327))
          Fo()
          var D = zQ(u, 0)
          if (!(D & 1)) return (TQ(u, ee()), null)
          var N = Pn(u, D)
          if (u.tag !== 0 && N === 2) {
            var v = Ui(u)
            v !== 0 && ((D = v), (N = DQ(u, v)))
          }
          if (N === 1) throw ((N = tr), gB(u, 0), bg(u, D), TQ(u, ee()), N)
          if (N === 6) throw Error(B(345))
          return (
            (u.finishedWork = u.current.alternate),
            (u.finishedLanes = D),
            kB(u, Tt),
            TQ(u, ee()),
            null
          )
        }
        function SQ(u) {
          _n !== null && _n.tag === 0 && !($C & 6) && Fo()
          var D = $C
          $C |= 1
          var N = li.transition,
            v = hC
          try {
            if (((li.transition = null), (hC = 1), u)) return u()
          } finally {
            ;((hC = v), (li.transition = N), ($C = D), !($C & 6) && zt())
          }
        }
        function bt() {
          ;((PB = ir.current), mg(ir))
        }
        function gB(u, D) {
          ;((u.finishedWork = null), (u.finishedLanes = 0))
          var N = u.timeoutHandle
          if ((N !== ZA && ((u.timeoutHandle = ZA), qA(N)), Ke !== null))
            for (N = Ke.return; N !== null; ) {
              var v = N
              switch ((at(v), v.tag)) {
                case 1:
                  ;((v = v.type.childContextTypes), v != null && pe())
                  break
                case 3:
                  ;(Pa(), mg(_C), mg(Gg), vQ())
                  break
                case 5:
                  go(v)
                  break
                case 4:
                  Pa()
                  break
                case 13:
                  mg(Fi)
                  break
                case 19:
                  mg(Fi)
                  break
                case 10:
                  BC(v.type._context)
                  break
                case 22:
                case 23:
                  bt()
              }
              N = N.return
            }
          if (
            ((xi = u),
            (Ke = u = MB(u.current, null)),
            (Ie = PB = D),
            (lt = 0),
            (tr = null),
            (aa = IB = HQ = 0),
            (Tt = RE = null),
            ie !== null)
          ) {
            for (D = 0; D < ie.length; D++)
              if (((N = ie[D]), (v = N.interleaved), v !== null)) {
                N.interleaved = null
                var O = v.next,
                  IA = N.pending
                if (IA !== null) {
                  var UA = IA.next
                  ;((IA.next = O), (v.next = UA))
                }
                N.pending = v
              }
            ie = null
          }
          return u
        }
        function Er(u, D) {
          do {
            var N = Ke
            try {
              if ((pg(), (vt.current = ia), Va)) {
                for (var v = he.memoizedState; v !== null; ) {
                  var O = v.queue
                  ;(O !== null && (O.pending = null), (v = v.next))
                }
                Va = !1
              }
              if (
                ((GE = 0),
                ($e = xe = he = null),
                (Lt = !1),
                (ga = 0),
                (rn.current = null),
                N === null || N.return === null)
              ) {
                ;((lt = 1), (tr = D), (Ke = null))
                break
              }
              A: {
                var IA = u,
                  UA = N.return,
                  CI = N,
                  HI = D
                if (
                  ((D = Ie),
                  (CI.flags |= 32768),
                  HI !== null && typeof HI == "object" && typeof HI.then == "function")
                ) {
                  var ng = HI,
                    Sg = CI,
                    DC = Sg.tag
                  if (!(Sg.mode & 1) && (DC === 0 || DC === 11 || DC === 15)) {
                    var sC = Sg.alternate
                    sC
                      ? ((Sg.updateQueue = sC.updateQueue),
                        (Sg.memoizedState = sC.memoizedState),
                        (Sg.lanes = sC.lanes))
                      : ((Sg.updateQueue = null), (Sg.memoizedState = null))
                  }
                  var Be = Qn(UA)
                  if (Be !== null) {
                    ;((Be.flags &= -257),
                      on(Be, UA, CI, IA, D),
                      Be.mode & 1 && rQ(IA, ng, D),
                      (D = Be),
                      (HI = ng))
                    var kg = D.updateQueue
                    if (kg === null) {
                      var ut = /* @__PURE__ */ new Set()
                      ;(ut.add(HI), (D.updateQueue = ut))
                    } else kg.add(HI)
                    break A
                  } else {
                    if (!(D & 1)) {
                      ;(rQ(IA, ng, D), la())
                      break A
                    }
                    HI = Error(B(426))
                  }
                } else if (ri && CI.mode & 1) {
                  var Dt = Qn(UA)
                  if (Dt !== null) {
                    ;(!(Dt.flags & 65536) && (Dt.flags |= 256), on(Dt, UA, CI, IA, D), Or(HI))
                    break A
                  }
                }
                ;((IA = HI),
                  lt !== 4 && (lt = 2),
                  RE === null ? (RE = [IA]) : RE.push(IA),
                  (HI = Vr(HI, CI)),
                  (CI = UA))
                do {
                  switch (CI.tag) {
                    case 3:
                      ;((CI.flags |= 65536), (D &= -D), (CI.lanes |= D))
                      var yI = Ol(CI, HI, D)
                      fo(CI, yI)
                      break A
                    case 1:
                      IA = HI
                      var zA = CI.type,
                        JI = CI.stateNode
                      if (
                        !(CI.flags & 128) &&
                        (typeof zA.getDerivedStateFromError == "function" ||
                          (JI !== null &&
                            typeof JI.componentDidCatch == "function" &&
                            (sn === null || !sn.has(JI))))
                      ) {
                        ;((CI.flags |= 65536), (D &= -D), (CI.lanes |= D))
                        var WI = Bn(CI, IA, D)
                        fo(CI, WI)
                        break A
                      }
                  }
                  CI = CI.return
                } while (CI !== null)
              }
              WB(N)
            } catch (Zg) {
              ;((D = Zg), Ke === N && N !== null && (Ke = N = N.return))
              continue
            }
            break
          } while (!0)
        }
        function sa() {
          var u = uQ.current
          return ((uQ.current = ia), u === null ? ia : u)
        }
        function la() {
          ;((lt === 0 || lt === 3 || lt === 2) && (lt = 4),
            xi === null || (!(HQ & 268435455) && !(IB & 268435455)) || bg(xi, Ie))
        }
        function Pn(u, D) {
          var N = $C
          $C |= 2
          var v = sa()
          ;(xi === u && Ie === D) || gB(u, D)
          do
            try {
              Wl()
              break
            } catch (O) {
              Er(u, O)
            }
          while (!0)
          if ((pg(), ($C = N), (uQ.current = v), Ke !== null)) throw Error(B(261))
          return ((xi = null), (Ie = 0), lt)
        }
        function Wl() {
          for (; Ke !== null; ) Xr(Ke)
        }
        function _s() {
          for (; Ke !== null && !Me(); ) Xr(Ke)
        }
        function Xr(u) {
          var D = KE(u.alternate, u, PB)
          ;((u.memoizedProps = u.pendingProps), D === null ? WB(u) : (Ke = D), (rn.current = null))
        }
        function WB(u) {
          var D = u
          do {
            var N = D.alternate
            if (((u = D.return), D.flags & 32768)) {
              if (((N = LC(N, D)), N !== null)) {
                ;((N.flags &= 32767), (Ke = N))
                return
              }
              if (u !== null) ((u.flags |= 32768), (u.subtreeFlags = 0), (u.deletions = null))
              else {
                ;((lt = 6), (Ke = null))
                return
              }
            } else if (((N = nC(N, D, PB)), N !== null)) {
              Ke = N
              return
            }
            if (((D = D.sibling), D !== null)) {
              Ke = D
              return
            }
            Ke = D = u
          } while (D !== null)
          lt === 0 && (lt = 5)
        }
        function kB(u, D) {
          var N = hC,
            v = li.transition
          try {
            ;((li.transition = null), (hC = 1), Vl(u, D, N))
          } finally {
            ;((li.transition = v), (hC = N))
          }
          return null
        }
        function Vl(u, D, N) {
          do Fo()
          while (_n !== null)
          if ($C & 6) throw Error(B(327))
          var v = u.finishedWork,
            O = u.finishedLanes
          if (v === null) return null
          if (((u.finishedWork = null), (u.finishedLanes = 0), v === u.current)) throw Error(B(177))
          ;((u.callbackNode = null), (u.callbackPriority = 0))
          var IA = v.lanes | v.childLanes
          if (
            (RQ(u, IA),
            u === xi && ((Ke = xi = null), (Ie = 0)),
            (!(v.subtreeFlags & 2064) && !(v.flags & 2064)) ||
              or ||
              ((or = !0),
              ln(rB, function () {
                return (Fo(), null)
              })),
            (IA = (v.flags & 15990) !== 0),
            v.subtreeFlags & 15990 || IA)
          ) {
            ;((IA = li.transition), (li.transition = null))
            var UA = hC
            hC = 1
            var CI = $C
            ;(($C |= 4),
              (rn.current = null),
              qs(u, v),
              Zl(u, v),
              sA(u.containerInfo),
              (u.current = v),
              Ea(v),
              Ha(),
              ($C = CI),
              (hC = UA),
              (li.transition = IA))
          } else u.current = v
          if (
            (or && ((or = !1), (_n = u), (nr = O)),
            (IA = u.pendingLanes),
            IA === 0 && (sn = null),
            TB(v.stateNode),
            TQ(u, ee()),
            D !== null)
          )
            for (N = u.onRecoverableError, v = 0; v < D.length; v++) N(D[v])
          if (Qr) throw ((Qr = !1), (u = wi), (wi = null), u)
          return (
            nr & 1 && u.tag !== 0 && Fo(),
            (IA = u.pendingLanes),
            IA & 1 ? (u === zg ? JE++ : ((JE = 0), (zg = u))) : (JE = 0),
            zt(),
            null
          )
        }
        function Fo() {
          if (_n !== null) {
            var u = Vt(nr),
              D = li.transition,
              N = hC
            try {
              if (((li.transition = null), (hC = 16 > u ? 16 : u), _n === null)) var v = !1
              else {
                if (((u = _n), (_n = null), (nr = 0), $C & 6)) throw Error(B(331))
                var O = $C
                for ($C |= 4, lg = u.current; lg !== null; ) {
                  var IA = lg,
                    UA = IA.child
                  if (lg.flags & 16) {
                    var CI = IA.deletions
                    if (CI !== null) {
                      for (var HI = 0; HI < CI.length; HI++) {
                        var ng = CI[HI]
                        for (lg = ng; lg !== null; ) {
                          var Sg = lg
                          switch (Sg.tag) {
                            case 0:
                            case 11:
                            case 15:
                              NE(8, Sg, IA)
                          }
                          var DC = Sg.child
                          if (DC !== null) ((DC.return = Sg), (lg = DC))
                          else
                            for (; lg !== null; ) {
                              Sg = lg
                              var sC = Sg.sibling,
                                Be = Sg.return
                              if ((to(Sg), Sg === ng)) {
                                lg = null
                                break
                              }
                              if (sC !== null) {
                                ;((sC.return = Be), (lg = sC))
                                break
                              }
                              lg = Be
                            }
                        }
                      }
                      var kg = IA.alternate
                      if (kg !== null) {
                        var ut = kg.child
                        if (ut !== null) {
                          kg.child = null
                          do {
                            var Dt = ut.sibling
                            ;((ut.sibling = null), (ut = Dt))
                          } while (ut !== null)
                        }
                      }
                      lg = IA
                    }
                  }
                  if (IA.subtreeFlags & 2064 && UA !== null) ((UA.return = IA), (lg = UA))
                  else
                    A: for (; lg !== null; ) {
                      if (((IA = lg), IA.flags & 2048))
                        switch (IA.tag) {
                          case 0:
                          case 11:
                          case 15:
                            NE(9, IA, IA.return)
                        }
                      var yI = IA.sibling
                      if (yI !== null) {
                        ;((yI.return = IA.return), (lg = yI))
                        break A
                      }
                      lg = IA.return
                    }
                }
                var zA = u.current
                for (lg = zA; lg !== null; ) {
                  UA = lg
                  var JI = UA.child
                  if (UA.subtreeFlags & 2064 && JI !== null) ((JI.return = UA), (lg = JI))
                  else
                    A: for (UA = zA; lg !== null; ) {
                      if (((CI = lg), CI.flags & 2048))
                        try {
                          switch (CI.tag) {
                            case 0:
                            case 11:
                            case 15:
                              AB(9, CI)
                          }
                        } catch (Zg) {
                          Fe(CI, CI.return, Zg)
                        }
                      if (CI === UA) {
                        lg = null
                        break A
                      }
                      var WI = CI.sibling
                      if (WI !== null) {
                        ;((WI.return = CI.return), (lg = WI))
                        break A
                      }
                      lg = CI.return
                    }
                }
                if ((($C = O), zt(), HB && typeof HB.onPostCommitFiberRoot == "function"))
                  try {
                    HB.onPostCommitFiberRoot(JQ, u)
                  } catch {}
                v = !0
              }
              return v
            } finally {
              ;((hC = N), (li.transition = D))
            }
          }
          return !1
        }
        function ht(u, D, N) {
          ;((D = Vr(N, D)),
            (D = Ol(u, D, 1)),
            So(u, D),
            (D = rC()),
            (u = Zn(u, 1)),
            u !== null && (oC(u, 1, D), TQ(u, D)))
        }
        function Fe(u, D, N) {
          if (u.tag === 3) ht(u, u, N)
          else
            for (; D !== null; ) {
              if (D.tag === 3) {
                ht(D, u, N)
                break
              } else if (D.tag === 1) {
                var v = D.stateNode
                if (
                  typeof D.type.getDerivedStateFromError == "function" ||
                  (typeof v.componentDidCatch == "function" && (sn === null || !sn.has(v)))
                ) {
                  ;((u = Vr(N, u)),
                    (u = Bn(D, u, 1)),
                    So(D, u),
                    (u = rC()),
                    (D = Zn(D, 1)),
                    D !== null && (oC(D, 1, u), TQ(D, u)))
                  break
                }
              }
              D = D.return
            }
        }
        function xQ(u, D, N) {
          var v = u.pingCache
          ;(v !== null && v.delete(D),
            (D = rC()),
            (u.pingedLanes |= u.suspendedLanes & N),
            xi === u &&
              (Ie & N) === N &&
              (lt === 4 || (lt === 3 && (Ie & 130023424) === Ie && 500 > ee() - Os)
                ? gB(u, 0)
                : (aa |= N)),
            TQ(u, D))
        }
        function fQ(u, D) {
          D === 0 &&
            (u.mode & 1 ? ((D = XC), (XC <<= 1), !(XC & 130023424) && (XC = 4194304)) : (D = 1))
          var N = rC()
          ;((u = Zn(u, D)), u !== null && (oC(u, D, N), TQ(u, N)))
        }
        function jl(u) {
          var D = u.memoizedState,
            N = 0
          ;(D !== null && (N = D.retryLane), fQ(u, N))
        }
        function Wn(u, D) {
          var N = 0
          switch (u.tag) {
            case 13:
              var v = u.stateNode,
                O = u.memoizedState
              O !== null && (N = O.retryLane)
              break
            case 19:
              v = u.stateNode
              break
            default:
              throw Error(B(314))
          }
          ;(v !== null && v.delete(D), fQ(u, N))
        }
        var KE
        KE = function (u, D, N) {
          if (u !== null)
            if (u.memoizedProps !== D.pendingProps || _C.current) te = !0
            else {
              if (!(u.lanes & N) && !(D.flags & 128)) return ((te = !1), Uo(u, D, N))
              te = !!(u.flags & 131072)
            }
          else ((te = !1), ri && D.flags & 1048576 && nQ(D, Yl, D.index))
          switch (((D.lanes = 0), D.tag)) {
            case 2:
              var v = D.type
              ;(u !== null && ((u.alternate = null), (D.alternate = null), (D.flags |= 2)),
                (u = D.pendingProps))
              var O = ii(D, Gg.current)
              ;(KC(D, N), (O = kE(null, D, v, u, O, N)))
              var IA = tn()
              return (
                (D.flags |= 1),
                typeof O == "object" &&
                O !== null &&
                typeof O.render == "function" &&
                O.$$typeof === void 0
                  ? ((D.tag = 1),
                    (D.memoizedState = null),
                    (D.updateQueue = null),
                    qe(v) ? ((IA = !0), ai(D)) : (IA = !1),
                    (D.memoizedState = O.state !== null && O.state !== void 0 ? O.state : null),
                    le(D),
                    (O.updater = Kl),
                    (D.stateNode = O),
                    (O._reactInternals = D),
                    Ll(D, v, u, N),
                    (D = Ri(null, D, v, !0, IA, N)))
                  : ((D.tag = 0), ri && IA && Cn(D), IC(null, D, O, N), (D = D.child)),
                D
              )
            case 16:
              v = D.elementType
              A: {
                switch (
                  (u !== null && ((u.alternate = null), (D.alternate = null), (D.flags |= 2)),
                  (u = D.pendingProps),
                  (O = v._init),
                  (v = O(v._payload)),
                  (D.type = v),
                  (O = D.tag = ar(v)),
                  (u = vA(v, u)),
                  O)
                ) {
                  case 0:
                    D = bB(null, D, v, u, N)
                    break A
                  case 1:
                    D = cQ(null, D, v, u, N)
                    break A
                  case 11:
                    D = de(null, D, v, u, N)
                    break A
                  case 14:
                    D = Ue(null, D, v, vA(v.type, u), N)
                    break A
                }
                throw Error(B(306, v, ""))
              }
              return D
            case 0:
              return (
                (v = D.type),
                (O = D.pendingProps),
                (O = D.elementType === v ? O : vA(v, O)),
                bB(u, D, v, O, N)
              )
            case 1:
              return (
                (v = D.type),
                (O = D.pendingProps),
                (O = D.elementType === v ? O : vA(v, O)),
                cQ(u, D, v, O, N)
              )
            case 3:
              A: {
                if ((hQ(D), u === null)) throw Error(B(387))
                ;((v = D.pendingProps),
                  (IA = D.memoizedState),
                  (O = IA.element),
                  Io(u, D),
                  XE(D, v, null, N))
                var UA = D.memoizedState
                if (((v = UA.element), eI && IA.isDehydrated))
                  if (
                    ((IA = {
                      element: v,
                      isDehydrated: !1,
                      cache: UA.cache,
                      transitions: UA.transitions,
                    }),
                    (D.updateQueue.baseState = IA),
                    (D.memoizedState = IA),
                    D.flags & 256)
                  ) {
                    ;((O = Error(B(423))), (D = bn(u, D, v, N, O)))
                    break A
                  } else if (v !== O) {
                    ;((O = Error(B(424))), (D = bn(u, D, v, N, O)))
                    break A
                  } else
                    for (
                      eI &&
                        (($i = mA(D.stateNode.containerInfo)),
                        (Xi = D),
                        (ri = !0),
                        (pB = null),
                        (xa = !1)),
                        N = Rs(D, null, v, N),
                        D.child = N;
                      N;
                    )
                      ((N.flags = (N.flags & -3) | 4096), (N = N.sibling))
                else {
                  if ((Oa(), v === O)) {
                    D = Ne(u, D, N)
                    break A
                  }
                  IC(u, D, v, N)
                }
                D = D.child
              }
              return D
            case 5:
              return (
                Ks(D),
                u === null && yE(D),
                (v = D.type),
                (O = D.pendingProps),
                (IA = u !== null ? u.memoizedProps : null),
                (UA = O.children),
                dA(v, O) ? (UA = null) : IA !== null && dA(v, IA) && (D.flags |= 32),
                At(u, D),
                IC(u, D, UA, N),
                D.child
              )
            case 6:
              return (u === null && yE(D), null)
            case 13:
              return Vc(u, D, N)
            case 4:
              return (
                Js(D, D.stateNode.containerInfo),
                (v = D.pendingProps),
                u === null ? (D.child = en(D, null, v, N)) : IC(u, D, v, N),
                D.child
              )
            case 11:
              return (
                (v = D.type),
                (O = D.pendingProps),
                (O = D.elementType === v ? O : vA(v, O)),
                de(u, D, v, O, N)
              )
            case 7:
              return (IC(u, D, D.pendingProps, N), D.child)
            case 8:
              return (IC(u, D, D.pendingProps.children, N), D.child)
            case 12:
              return (IC(u, D, D.pendingProps.children, N), D.child)
            case 10:
              A: {
                if (
                  ((v = D.type._context),
                  (O = D.pendingProps),
                  (IA = D.memoizedProps),
                  (UA = O.value),
                  tC(D, v, UA),
                  IA !== null)
                )
                  if (Gt(IA.value, UA)) {
                    if (IA.children === O.children && !_C.current) {
                      D = Ne(u, D, N)
                      break A
                    }
                  } else
                    for (IA = D.child, IA !== null && (IA.return = D); IA !== null; ) {
                      var CI = IA.dependencies
                      if (CI !== null) {
                        UA = IA.child
                        for (var HI = CI.firstContext; HI !== null; ) {
                          if (HI.context === v) {
                            if (IA.tag === 1) {
                              ;((HI = KQ(-1, N & -N)), (HI.tag = 2))
                              var ng = IA.updateQueue
                              if (ng !== null) {
                                ng = ng.shared
                                var Sg = ng.pending
                                ;(Sg === null
                                  ? (HI.next = HI)
                                  : ((HI.next = Sg.next), (Sg.next = HI)),
                                  (ng.pending = HI))
                              }
                            }
                            ;((IA.lanes |= N),
                              (HI = IA.alternate),
                              HI !== null && (HI.lanes |= N),
                              NC(IA.return, N, D),
                              (CI.lanes |= N))
                            break
                          }
                          HI = HI.next
                        }
                      } else if (IA.tag === 10) UA = IA.type === D.type ? null : IA.child
                      else if (IA.tag === 18) {
                        if (((UA = IA.return), UA === null)) throw Error(B(341))
                        ;((UA.lanes |= N),
                          (CI = UA.alternate),
                          CI !== null && (CI.lanes |= N),
                          NC(UA, N, D),
                          (UA = IA.sibling))
                      } else UA = IA.child
                      if (UA !== null) UA.return = IA
                      else
                        for (UA = IA; UA !== null; ) {
                          if (UA === D) {
                            UA = null
                            break
                          }
                          if (((IA = UA.sibling), IA !== null)) {
                            ;((IA.return = UA.return), (UA = IA))
                            break
                          }
                          UA = UA.return
                        }
                      IA = UA
                    }
                ;(IC(u, D, O.children, N), (D = D.child))
              }
              return D
            case 9:
              return (
                (O = D.type),
                (v = D.pendingProps.children),
                KC(D, N),
                (O = GC(O)),
                (v = v(O)),
                (D.flags |= 1),
                IC(u, D, v, N),
                D.child
              )
            case 14:
              return (
                (v = D.type),
                (O = vA(v, D.pendingProps)),
                (O = vA(v.type, O)),
                Ue(u, D, v, O, N)
              )
            case 15:
              return nn(u, D, D.type, D.pendingProps, N)
            case 17:
              return (
                (v = D.type),
                (O = D.pendingProps),
                (O = D.elementType === v ? O : vA(v, O)),
                u !== null && ((u.alternate = null), (D.alternate = null), (D.flags |= 2)),
                (D.tag = 1),
                qe(v) ? ((u = !0), ai(D)) : (u = !1),
                KC(D, N),
                vl(D, v, O),
                Ll(D, v, O, N),
                Ri(null, D, v, !0, u, N)
              )
            case 19:
              return En(u, D, N)
            case 22:
              return kC(u, D, N)
          }
          throw Error(B(156, D.tag))
        }
        function ln(u, D) {
          return wt(u, D)
        }
        function cn(u, D, N, v) {
          ;((this.tag = u),
            (this.key = N),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.ref = null),
            (this.pendingProps = D),
            (this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null),
            (this.mode = v),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null))
        }
        function CB(u, D, N, v) {
          return new cn(u, D, N, v)
        }
        function Vn(u) {
          return ((u = u.prototype), !(!u || !u.isReactComponent))
        }
        function ar(u) {
          if (typeof u == "function") return Vn(u) ? 1 : 0
          if (u != null) {
            if (((u = u.$$typeof), u === K)) return 11
            if (u === L) return 14
          }
          return 2
        }
        function MB(u, D) {
          var N = u.alternate
          return (
            N === null
              ? ((N = CB(u.tag, D, u.key, u.mode)),
                (N.elementType = u.elementType),
                (N.type = u.type),
                (N.stateNode = u.stateNode),
                (N.alternate = u),
                (u.alternate = N))
              : ((N.pendingProps = D),
                (N.type = u.type),
                (N.flags = 0),
                (N.subtreeFlags = 0),
                (N.deletions = null)),
            (N.flags = u.flags & 14680064),
            (N.childLanes = u.childLanes),
            (N.lanes = u.lanes),
            (N.child = u.child),
            (N.memoizedProps = u.memoizedProps),
            (N.memoizedState = u.memoizedState),
            (N.updateQueue = u.updateQueue),
            (D = u.dependencies),
            (N.dependencies = D === null ? null : { lanes: D.lanes, firstContext: D.firstContext }),
            (N.sibling = u.sibling),
            (N.index = u.index),
            (N.ref = u.ref),
            N
          )
        }
        function ca(u, D, N, v, O, IA) {
          var UA = 2
          if (((v = u), typeof u == "function")) Vn(u) && (UA = 1)
          else if (typeof u == "string") UA = 5
          else
            A: switch (u) {
              case h:
                return Ro(N.children, O, IA, D)
              case S:
                ;((UA = 8), (O |= 8))
                break
              case d:
                return ((u = CB(12, N, D, O | 2)), (u.elementType = d), (u.lanes = IA), u)
              case R:
                return ((u = CB(13, N, D, O)), (u.elementType = R), (u.lanes = IA), u)
              case F:
                return ((u = CB(19, N, D, O)), (u.elementType = F), (u.lanes = IA), u)
              case H:
                return rr(N, O, IA, D)
              default:
                if (typeof u == "object" && u !== null)
                  switch (u.$$typeof) {
                    case w:
                      UA = 10
                      break A
                    case M:
                      UA = 9
                      break A
                    case K:
                      UA = 11
                      break A
                    case L:
                      UA = 14
                      break A
                    case Y:
                      ;((UA = 16), (v = null))
                      break A
                  }
                throw Error(B(130, u == null ? u : typeof u, ""))
            }
          return ((D = CB(UA, N, D, O)), (D.elementType = u), (D.type = v), (D.lanes = IA), D)
        }
        function Ro(u, D, N, v) {
          return ((u = CB(7, u, v, D)), (u.lanes = N), u)
        }
        function rr(u, D, N, v) {
          return ((u = CB(22, u, v, D)), (u.elementType = H), (u.lanes = N), (u.stateNode = {}), u)
        }
        function mE(u, D, N) {
          return ((u = CB(6, u, null, D)), (u.lanes = N), u)
        }
        function Jo(u, D, N) {
          return (
            (D = CB(4, u.children !== null ? u.children : [], u.key, D)),
            (D.lanes = N),
            (D.stateNode = {
              containerInfo: u.containerInfo,
              pendingChildren: null,
              implementation: u.implementation,
            }),
            D
          )
        }
        function VB(u, D, N, v, O) {
          ;((this.tag = D),
            (this.containerInfo = u),
            (this.finishedWork = this.pingCache = this.current = this.pendingChildren = null),
            (this.timeoutHandle = ZA),
            (this.callbackNode = this.pendingContext = this.context = null),
            (this.callbackPriority = 0),
            (this.eventTimes = $o(0)),
            (this.expirationTimes = $o(-1)),
            (this.entangledLanes =
              this.finishedLanes =
              this.mutableReadLanes =
              this.expiredLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = $o(0)),
            (this.identifierPrefix = v),
            (this.onRecoverableError = O),
            eI && (this.mutableSourceEagerHydrationData = null))
        }
        function lu(u, D, N, v, O, IA, UA, CI, HI) {
          return (
            (u = new VB(u, D, N, CI, HI)),
            D === 1 ? ((D = 1), IA === !0 && (D |= 8)) : (D = 0),
            (IA = CB(3, null, null, D)),
            (u.current = IA),
            (IA.stateNode = u),
            (IA.memoizedState = { element: v, isDehydrated: N, cache: null, transitions: null }),
            le(IA),
            u
          )
        }
        function ue(u) {
          if (!u) return iC
          u = u._reactInternals
          A: {
            if (X(u) !== u || u.tag !== 1) throw Error(B(170))
            var D = u
            do {
              switch (D.tag) {
                case 3:
                  D = D.stateNode.context
                  break A
                case 1:
                  if (qe(D.type)) {
                    D = D.stateNode.__reactInternalMemoizedMergedChildContext
                    break A
                  }
              }
              D = D.return
            } while (D !== null)
            throw Error(B(171))
          }
          if (u.tag === 1) {
            var N = u.type
            if (qe(N)) return ae(u, N, D)
          }
          return D
        }
        function ha(u) {
          var D = u._reactInternals
          if (D === void 0)
            throw typeof u.render == "function"
              ? Error(B(188))
              : ((u = Object.keys(u).join(",")), Error(B(268, u)))
          return ((u = CA(D)), u === null ? null : u.stateNode)
        }
        function eB(u, D) {
          if (((u = u.memoizedState), u !== null && u.dehydrated !== null)) {
            var N = u.retryLane
            u.retryLane = N !== 0 && N < D ? N : D
          }
        }
        function Ko(u, D) {
          ;(eB(u, D), (u = u.alternate) && eB(u, D))
        }
        function mo(u) {
          return ((u = CA(u)), u === null ? null : u.stateNode)
        }
        function zl() {
          return null
        }
        return (
          (I.attemptContinuousHydration = function (u) {
            if (u.tag === 13) {
              var D = rC()
              ;(GB(u, 134217728, D), Ko(u, 134217728))
            }
          }),
          (I.attemptHydrationAtCurrentPriority = function (u) {
            if (u.tag === 13) {
              var D = rC(),
                N = xt(u)
              ;(GB(u, N, D), Ko(u, N))
            }
          }),
          (I.attemptSynchronousHydration = function (u) {
            switch (u.tag) {
              case 3:
                var D = u.stateNode
                if (D.current.memoizedState.isDehydrated) {
                  var N = dB(D.pendingLanes)
                  N !== 0 && (Te(D, N | 1), TQ(D, ee()), !($C & 6) && (Br(), zt()))
                }
                break
              case 13:
                var v = rC()
                ;(SQ(function () {
                  return GB(u, 1, v)
                }),
                  Ko(u, 1))
            }
          }),
          (I.batchedUpdates = function (u, D) {
            var N = $C
            $C |= 1
            try {
              return u(D)
            } finally {
              ;(($C = N), $C === 0 && (Br(), QQ && zt()))
            }
          }),
          (I.createComponentSelector = function (u) {
            return { $$typeof: Ts, value: u }
          }),
          (I.createContainer = function (u, D, N, v, O, IA, UA) {
            return lu(u, D, !1, null, N, v, O, IA, UA)
          }),
          (I.createHasPseudoClassSelector = function (u) {
            return { $$typeof: Bi, value: u }
          }),
          (I.createHydrationContainer = function (u, D, N, v, O, IA, UA, CI, HI) {
            return (
              (u = lu(N, v, !0, u, O, IA, UA, CI, HI)),
              (u.context = ue(null)),
              (N = u.current),
              (v = rC()),
              (O = xt(N)),
              (IA = KQ(v, O)),
              (IA.callback = D ?? null),
              So(N, IA),
              (u.current.lanes = O),
              oC(u, O, v),
              TQ(u, v),
              u
            )
          }),
          (I.createPortal = function (u, D, N) {
            var v = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null
            return {
              $$typeof: s,
              key: v == null ? null : "" + v,
              children: u,
              containerInfo: D,
              implementation: N,
            }
          }),
          (I.createRoleSelector = function (u) {
            return { $$typeof: Ti, value: u }
          }),
          (I.createTestNameSelector = function (u) {
            return { $$typeof: fg, value: u }
          }),
          (I.createTextSelector = function (u) {
            return { $$typeof: Ht, value: u }
          }),
          (I.deferredUpdates = function (u) {
            var D = hC,
              N = li.transition
            try {
              return ((li.transition = null), (hC = 16), u())
            } finally {
              ;((hC = D), (li.transition = N))
            }
          }),
          (I.discreteUpdates = function (u, D, N, v, O) {
            var IA = hC,
              UA = li.transition
            try {
              return ((li.transition = null), (hC = 1), u(D, N, v, O))
            } finally {
              ;((hC = IA), (li.transition = UA), $C === 0 && Br())
            }
          }),
          (I.findAllNodes = wg),
          (I.findBoundingRects = function (u, D) {
            if (!SI) throw Error(B(363))
            ;((D = wg(u, D)), (u = []))
            for (var N = 0; N < D.length; N++) u.push(tA(D[N]))
            for (D = u.length - 1; 0 < D; D--) {
              N = u[D]
              for (
                var v = N.x, O = v + N.width, IA = N.y, UA = IA + N.height, CI = D - 1;
                0 <= CI;
                CI--
              )
                if (D !== CI) {
                  var HI = u[CI],
                    ng = HI.x,
                    Sg = ng + HI.width,
                    DC = HI.y,
                    sC = DC + HI.height
                  if (v >= ng && IA >= DC && O <= Sg && UA <= sC) {
                    u.splice(D, 1)
                    break
                  } else if (v !== ng || N.width !== HI.width || sC < IA || DC > UA) {
                    if (!(IA !== DC || N.height !== HI.height || Sg < v || ng > O)) {
                      ;(ng > v && ((HI.width += ng - v), (HI.x = v)),
                        Sg < O && (HI.width = O - ng),
                        u.splice(D, 1))
                      break
                    }
                  } else {
                    ;(DC > IA && ((HI.height += DC - IA), (HI.y = IA)),
                      sC < UA && (HI.height = UA - DC),
                      u.splice(D, 1))
                    break
                  }
                }
            }
            return u
          }),
          (I.findHostInstance = ha),
          (I.findHostInstanceWithNoPortals = function (u) {
            return ((u = eA(u)), (u = u !== null ? lA(u) : null), u === null ? null : u.stateNode)
          }),
          (I.findHostInstanceWithWarning = function (u) {
            return ha(u)
          }),
          (I.flushControlled = function (u) {
            var D = $C
            $C |= 1
            var N = li.transition,
              v = hC
            try {
              ;((li.transition = null), (hC = 1), u())
            } finally {
              ;((hC = v), (li.transition = N), ($C = D), $C === 0 && (Br(), zt()))
            }
          }),
          (I.flushPassiveEffects = Fo),
          (I.flushSync = SQ),
          (I.focusWithin = function (u, D) {
            if (!SI) throw Error(B(363))
            for (u = xs(u), D = si(u, D), D = Array.from(D), u = 0; u < D.length; ) {
              var N = D[u++]
              if (!WA(N)) {
                if (N.tag === 5 && nI(N.stateNode)) return !0
                for (N = N.child; N !== null; ) (D.push(N), (N = N.sibling))
              }
            }
            return !1
          }),
          (I.getCurrentUpdatePriority = function () {
            return hC
          }),
          (I.getFindAllNodesFailureDescription = function (u, D) {
            if (!SI) throw Error(B(363))
            var N = 0,
              v = []
            u = [xs(u), 0]
            for (var O = 0; O < u.length; ) {
              var IA = u[O++],
                UA = u[O++],
                CI = D[UA]
              if (
                (IA.tag !== 5 || !WA(IA)) &&
                (bs(IA, CI) && (v.push(Bo(CI)), UA++, UA > N && (N = UA)), UA < D.length)
              )
                for (IA = IA.child; IA !== null; ) (u.push(IA, UA), (IA = IA.sibling))
            }
            if (N < D.length) {
              for (u = []; N < D.length; N++) u.push(Bo(D[N]))
              return (
                `findAllNodes was able to match part of the selector:
  ` +
                (v.join(" > ") +
                  `

No matching component was found for:
  `) +
                u.join(" > ")
              )
            }
            return null
          }),
          (I.getPublicRootInstance = function (u) {
            if (((u = u.current), !u.child)) return null
            switch (u.child.tag) {
              case 5:
                return yA(u.child.stateNode)
              default:
                return u.child.stateNode
            }
          }),
          (I.injectIntoDevTools = function (u) {
            if (
              ((u = {
                bundleType: u.bundleType,
                version: u.version,
                rendererPackageName: u.rendererPackageName,
                rendererConfig: u.rendererConfig,
                overrideHookState: null,
                overrideHookStateDeletePath: null,
                overrideHookStateRenamePath: null,
                overrideProps: null,
                overridePropsDeletePath: null,
                overridePropsRenamePath: null,
                setErrorHandler: null,
                setSuspenseHandler: null,
                scheduleUpdate: null,
                currentDispatcherRef: o.ReactCurrentDispatcher,
                findHostInstanceByFiber: mo,
                findFiberByHostInstance: u.findFiberByHostInstance || zl,
                findHostInstancesForRefresh: null,
                scheduleRefresh: null,
                scheduleRoot: null,
                setRefreshHandler: null,
                getCurrentFiber: null,
                reconcilerVersion: "18.0.0-fc46dba67-20220329",
              }),
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
            )
              u = !1
            else {
              var D = __REACT_DEVTOOLS_GLOBAL_HOOK__
              if (D.isDisabled || !D.supportsFiber) u = !0
              else {
                try {
                  ;((JQ = D.inject(u)), (HB = D))
                } catch {}
                u = !!D.checkDCE
              }
            }
            return u
          }),
          (I.isAlreadyRendering = function () {
            return !1
          }),
          (I.observeVisibleRects = function (u, D, N, v) {
            if (!SI) throw Error(B(363))
            u = wg(u, D)
            var O = UI(u, N, v).disconnect
            return {
              disconnect: function () {
                O()
              },
            }
          }),
          (I.registerMutableSourceForHydration = function (u, D) {
            var N = D._getVersion
            ;((N = N(D._source)),
              u.mutableSourceEagerHydrationData == null
                ? (u.mutableSourceEagerHydrationData = [D, N])
                : u.mutableSourceEagerHydrationData.push(D, N))
          }),
          (I.runWithPriority = function (u, D) {
            var N = hC
            try {
              return ((hC = u), D())
            } finally {
              hC = N
            }
          }),
          (I.shouldError = function () {
            return null
          }),
          (I.shouldSuspend = function () {
            return !1
          }),
          (I.updateContainer = function (u, D, N, v) {
            var O = D.current,
              IA = rC(),
              UA = xt(O)
            return (
              (N = ue(N)),
              D.context === null ? (D.context = N) : (D.pendingContext = N),
              (D = KQ(IA, UA)),
              (D.payload = { element: u }),
              (v = v === void 0 ? null : v),
              v !== null && (D.callback = v),
              So(O, D),
              (u = GB(O, UA, IA)),
              u !== null && xr(u, O, UA),
              UA
            )
          }),
          I
        )
      })),
    YK
  )
}
var qK = { exports: {} }
/**
 * @license React
 * react-reconciler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ST
function Mz() {
  return (
    ST ||
      ((ST = 1),
      process.env.NODE_ENV !== "production" &&
        (qK.exports = function (A) {
          var I = {},
            g = Pf(),
            C = Fv(),
            i = g.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
            B = !1
          function o(n) {
            B = n
          }
          function r(n) {
            if (!B) {
              for (var a = arguments.length, y = new Array(a > 1 ? a - 1 : 0), k = 1; k < a; k++)
                y[k - 1] = arguments[k]
              h("warn", n, y)
            }
          }
          function s(n) {
            if (!B) {
              for (var a = arguments.length, y = new Array(a > 1 ? a - 1 : 0), k = 1; k < a; k++)
                y[k - 1] = arguments[k]
              h("error", n, y)
            }
          }
          function h(n, a, y) {
            {
              var k = i.ReactDebugCurrentFrame,
                J = k.getStackAddendum()
              J !== "" && ((a += "%s"), (y = y.concat([J])))
              var T = y.map(function (W) {
                return String(W)
              })
              ;(T.unshift("Warning: " + a), Function.prototype.apply.call(console[n], console, T))
            }
          }
          var S = Object.assign
          function d(n) {
            return n._reactInternals
          }
          function w(n, a) {
            n._reactInternals = a
          }
          var M = !1,
            K = !1,
            R = !1,
            F = !1,
            L = !1,
            Y = !1,
            H = !0,
            V = !0,
            j = !0,
            P = 0,
            AA = 1,
            X = 2,
            _ = 3,
            eA = 4,
            CA = 5,
            aA = 6,
            lA = 7,
            JA = 8,
            yA = 9,
            LA = 10,
            nA = 11,
            fA = 12,
            sA = 13,
            $ = 14,
            EA = 15,
            GA = 16,
            DA = 17,
            dA = 18,
            kA = 19,
            NA = 21,
            qA = 22,
            ZA = 23,
            sI = 24,
            cI = 25,
            YA = Symbol.for("react.element"),
            eI = Symbol.for("react.portal"),
            uA = Symbol.for("react.fragment"),
            hI = Symbol.for("react.strict_mode"),
            II = Symbol.for("react.profiler"),
            pI = Symbol.for("react.provider"),
            AI = Symbol.for("react.context"),
            YI = Symbol.for("react.forward_ref"),
            SI = Symbol.for("react.suspense"),
            QA = Symbol.for("react.suspense_list"),
            tA = Symbol.for("react.memo"),
            FA = Symbol.for("react.lazy"),
            WA = Symbol.for("react.scope"),
            jA = Symbol.for("react.debug_trace_mode"),
            nI = Symbol.for("react.offscreen"),
            UI = Symbol.for("react.legacy_hidden"),
            GI = Symbol.for("react.cache"),
            LI = Symbol.for("react.tracing_marker"),
            Bg = Symbol.iterator,
            MA = "@@iterator"
          function OA(n) {
            if (n === null || typeof n != "object") return null
            var a = (Bg && n[Bg]) || n[MA]
            return typeof a == "function" ? a : null
          }
          function aI(n, a, y) {
            var k = n.displayName
            if (k) return k
            var J = a.displayName || a.name || ""
            return J !== "" ? y + "(" + J + ")" : y
          }
          function RI(n) {
            return n.displayName || "Context"
          }
          function VA(n) {
            if (n == null) return null
            if (
              (typeof n.tag == "number" &&
                s(
                  "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.",
                ),
              typeof n == "function")
            )
              return n.displayName || n.name || null
            if (typeof n == "string") return n
            switch (n) {
              case uA:
                return "Fragment"
              case eI:
                return "Portal"
              case II:
                return "Profiler"
              case hI:
                return "StrictMode"
              case SI:
                return "Suspense"
              case QA:
                return "SuspenseList"
            }
            if (typeof n == "object")
              switch (n.$$typeof) {
                case AI:
                  var a = n
                  return RI(a) + ".Consumer"
                case pI:
                  var y = n
                  return RI(y._context) + ".Provider"
                case YI:
                  return aI(n, n.render, "ForwardRef")
                case tA:
                  var k = n.displayName || null
                  return k !== null ? k : VA(n.type) || "Memo"
                case FA: {
                  var J = n,
                    T = J._payload,
                    W = J._init
                  try {
                    return VA(W(T))
                  } catch {
                    return null
                  }
                }
              }
            return null
          }
          function ag(n, a, y) {
            var k = a.displayName || a.name || ""
            return n.displayName || (k !== "" ? y + "(" + k + ")" : y)
          }
          function XI(n) {
            return n.displayName || "Context"
          }
          function $I(n) {
            var a = n.tag,
              y = n.type
            switch (a) {
              case sI:
                return "Cache"
              case yA:
                var k = y
                return XI(k) + ".Consumer"
              case LA:
                var J = y
                return XI(J._context) + ".Provider"
              case dA:
                return "DehydratedFragment"
              case nA:
                return ag(y, y.render, "ForwardRef")
              case lA:
                return "Fragment"
              case CA:
                return y
              case eA:
                return "Portal"
              case _:
                return "Root"
              case aA:
                return "Text"
              case GA:
                return VA(y)
              case JA:
                return y === hI ? "StrictMode" : "Mode"
              case qA:
                return "Offscreen"
              case fA:
                return "Profiler"
              case NA:
                return "Scope"
              case sA:
                return "Suspense"
              case kA:
                return "SuspenseList"
              case cI:
                return "TracingMarker"
              // The display name for this tags come from the user-provided type:
              case AA:
              case P:
              case DA:
              case X:
              case $:
              case EA:
                if (typeof y == "function") return y.displayName || y.name || null
                if (typeof y == "string") return y
                break
            }
            return null
          }
          var SA =
              /*                      */
              0,
            NI =
              /*                */
              1,
            HA =
              /*                    */
              2,
            iI =
              /*                       */
              4,
            zI =
              /*           */
              HA | iI,
            qI =
              /*                */
              16,
            dg =
              /*                 */
              32,
            $g =
              /*                     */
              64,
            Qg =
              /*                   */
              128,
            Fg =
              /*            */
              256,
            jC =
              /*                          */
              512,
            mC =
              /*                     */
              1024,
            zC =
              /*                      */
              2048,
            Ee =
              /*                    */
              4096,
            ei =
              /*           */
              Ee | iI,
            fe =
              /*                   */
              8192,
            Ei =
              /*             */
              16384,
            vi = zC | iI | $g | jC | mC | Ei,
            Li =
              /*               */
              32767,
            mA =
              /*                   */
              32768,
            TI =
              /*                */
              65536,
            eg =
              /* */
              131072,
            Tg =
              /*                       */
              1048576,
            OC =
              /*                    */
              2097152,
            JC =
              /*                 */
              4194304,
            jg =
              /*                */
              8388608,
            rA =
              /*               */
              16777216,
            _A =
              /*              */
              33554432,
            oI =
              // TODO: Remove Update flag from before mutation phase by re-landing Visibility
              // flag logic (see #20043)
              iI | mC | 0,
            QI = HA | iI | qI | dg | jC | Ee | fe,
            PA = iI | $g | jC | fe,
            gg = zC | qI,
            EI = JC | jg | OC,
            hg = i.ReactCurrentOwner
          function yg(n) {
            var a = n,
              y = n
            if (n.alternate) for (; a.return; ) a = a.return
            else {
              var k = a
              do ((a = k), (a.flags & (HA | Ee)) !== SA && (y = a.return), (k = a.return))
              while (k)
            }
            return a.tag === _ ? y : null
          }
          function rg(n) {
            return yg(n) === n
          }
          function eC(n) {
            {
              var a = hg.current
              if (a !== null && a.tag === AA) {
                var y = a,
                  k = y.stateNode
                ;(k._warnedAboutRefsInRender ||
                  s(
                    "%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.",
                    $I(y) || "A component",
                  ),
                  (k._warnedAboutRefsInRender = !0))
              }
            }
            var J = d(n)
            return J ? yg(J) === J : !1
          }
          function Rg(n) {
            if (yg(n) !== n) throw new Error("Unable to find node on an unmounted component.")
          }
          function pC(n) {
            var a = n.alternate
            if (!a) {
              var y = yg(n)
              if (y === null) throw new Error("Unable to find node on an unmounted component.")
              return y !== n ? null : n
            }
            for (var k = n, J = a; ; ) {
              var T = k.return
              if (T === null) break
              var W = T.alternate
              if (W === null) {
                var BA = T.return
                if (BA !== null) {
                  k = J = BA
                  continue
                }
                break
              }
              if (T.child === W.child) {
                for (var cA = T.child; cA; ) {
                  if (cA === k) return (Rg(T), n)
                  if (cA === J) return (Rg(T), a)
                  cA = cA.sibling
                }
                throw new Error("Unable to find node on an unmounted component.")
              }
              if (k.return !== J.return) ((k = T), (J = W))
              else {
                for (var RA = !1, TA = T.child; TA; ) {
                  if (TA === k) {
                    ;((RA = !0), (k = T), (J = W))
                    break
                  }
                  if (TA === J) {
                    ;((RA = !0), (J = T), (k = W))
                    break
                  }
                  TA = TA.sibling
                }
                if (!RA) {
                  for (TA = W.child; TA; ) {
                    if (TA === k) {
                      ;((RA = !0), (k = W), (J = T))
                      break
                    }
                    if (TA === J) {
                      ;((RA = !0), (J = W), (k = T))
                      break
                    }
                    TA = TA.sibling
                  }
                  if (!RA)
                    throw new Error(
                      "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.",
                    )
                }
              }
              if (k.alternate !== J)
                throw new Error(
                  "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.",
                )
            }
            if (k.tag !== _) throw new Error("Unable to find node on an unmounted component.")
            return k.stateNode.current === k ? n : a
          }
          function wC(n) {
            var a = pC(n)
            return a !== null ? mg(a) : null
          }
          function mg(n) {
            if (n.tag === CA || n.tag === aA) return n
            for (var a = n.child; a !== null; ) {
              var y = mg(a)
              if (y !== null) return y
              a = a.sibling
            }
            return null
          }
          function UC(n) {
            var a = pC(n)
            return a !== null ? iC(a) : null
          }
          function iC(n) {
            if (n.tag === CA || n.tag === aA) return n
            for (var a = n.child; a !== null; ) {
              if (a.tag !== eA) {
                var y = iC(a)
                if (y !== null) return y
              }
              a = a.sibling
            }
            return null
          }
          var Gg = Array.isArray
          function _C(n) {
            return Gg(n)
          }
          var vC = A.getPublicInstance,
            ii = A.getRootHostContext,
            qe = A.getChildHostContext,
            pe = A.prepareForCommit,
            Mi = A.resetAfterCommit,
            ae = A.createInstance,
            ai = A.appendInitialChild,
            fi = A.finalizeInitialChildren,
            He = A.prepareUpdate,
            Et = A.shouldSetTextContent,
            Yi = A.createTextInstance,
            vn = A.scheduleTimeout,
            aB = A.cancelTimeout,
            XC = A.noTimeout
          A.now
          var dB = A.isPrimaryRenderer,
            zQ = A.warnsIfNotActing,
            Wt = A.supportsMutation,
            ZC = A.supportsPersistence,
            Ui = A.supportsHydration,
            $o = A.getInstanceFromNode
          ;(A.beforeActiveInstanceBlur, A.afterActiveInstanceBlur)
          var oC = A.preparePortalMount
          ;(A.preparePortalMount, A.getInstanceFromScope)
          var RQ = A.getCurrentEventPriority,
            Te = A.detachDeletedInstance,
            hC = A.supportsMicrotasks,
            Vt = A.scheduleMicrotask,
            wt = A.supportsTestSelectors,
            di = A.findFiberRoot,
            Me = A.getBoundingRect,
            Ha = A.getTextContent,
            ee = A.isHiddenSubtree,
            Zi = A.matchAccessibilityRole,
            XQ = A.setFocusIfFocusable,
            rB = A.setupIntersectionObserver,
            $Q = A.appendChild,
            JQ = A.appendChildToContainer,
            HB = A.commitTextUpdate,
            TB = A.commitMount,
            An = A.commitUpdate,
            Gt = A.insertBefore,
            Ni = A.insertInContainerBefore,
            QQ = A.removeChild,
            jt = A.removeChildFromContainer,
            Ao = A.resetTextContent,
            In = A.hideInstance,
            zt = A.hideTextInstance,
            gn = A.unhideInstance,
            yB = A.unhideTextInstance,
            iA = A.clearContainer,
            vA = A.cloneInstance,
            rI = A.createContainerChildSet,
            mI = A.appendChildToContainerChildSet,
            ig = A.finalizeContainerChildren,
            AC = A.replaceContainerChildren
          A.getOffscreenContainerType
          var pg = A.getOffscreenContainerProps,
            tC = A.cloneHiddenInstance,
            BC = A.cloneHiddenTextInstance,
            NC = A.canHydrateInstance,
            KC = A.canHydrateTextInstance,
            GC = A.canHydrateSuspenseInstance,
            ie = A.isSuspenseInstancePending,
            we = A.isSuspenseInstanceFallback,
            le = A.registerSuspenseInstanceRetry,
            Io = A.getNextHydratableSibling,
            KQ = A.getFirstHydratableChild,
            So = A.getFirstHydratableChildWithinContainer,
            xr = A.getFirstHydratableChildWithinSuspenseInstance,
            fo = A.hydrateInstance,
            XE = A.hydrateTextInstance,
            br = A.hydrateSuspenseInstance,
            Rl = A.getNextHydratableInstanceAfterSuspenseInstance,
            Jl = A.commitHydratedContainer,
            Kl = A.commitHydratedSuspenseInstance,
            ml = A.clearSuspenseBoundary,
            vl = A.clearSuspenseBoundaryFromContainer,
            Pc = A.shouldDeleteUnhydratedTailInstances,
            Ll = A.didNotMatchHydratedContainerTextInstance,
            Ta = A.didNotMatchHydratedTextInstance,
            $E = A.didNotHydrateInstanceWithinContainer,
            yo = A.didNotHydrateInstanceWithinSuspenseInstance,
            Yl = A.didNotHydrateInstance,
            mQ = A.didNotFindHydratableInstanceWithinContainer,
            oQ = A.didNotFindHydratableTextInstanceWithinContainer,
            fE = A.didNotFindHydratableSuspenseInstanceWithinContainer,
            dE = A.didNotFindHydratableInstanceWithinSuspenseInstance,
            po = A.didNotFindHydratableTextInstanceWithinSuspenseInstance,
            Aa = A.didNotFindHydratableSuspenseInstanceWithinSuspenseInstance,
            nQ = A.didNotFindHydratableInstance,
            Cn = A.didNotFindHydratableTextInstance,
            at = A.didNotFindHydratableSuspenseInstance,
            Xi = A.errorHydratingContainer,
            $i = 0,
            ri,
            xa,
            pB,
            ql,
            Hl,
            ba,
            yE
          function Wc() {}
          Wc.__reactDisabledLog = !0
          function Fs() {
            {
              if ($i === 0) {
                ;((ri = console.log),
                  (xa = console.info),
                  (pB = console.warn),
                  (ql = console.error),
                  (Hl = console.group),
                  (ba = console.groupCollapsed),
                  (yE = console.groupEnd))
                var n = {
                  configurable: !0,
                  enumerable: !0,
                  value: Wc,
                  writable: !0,
                }
                Object.defineProperties(console, {
                  info: n,
                  log: n,
                  warn: n,
                  error: n,
                  group: n,
                  groupCollapsed: n,
                  groupEnd: n,
                })
              }
              $i++
            }
          }
          function Oa() {
            {
              if (($i--, $i === 0)) {
                var n = {
                  configurable: !0,
                  enumerable: !0,
                  writable: !0,
                }
                Object.defineProperties(console, {
                  log: S({}, n, {
                    value: ri,
                  }),
                  info: S({}, n, {
                    value: xa,
                  }),
                  warn: S({}, n, {
                    value: pB,
                  }),
                  error: S({}, n, {
                    value: ql,
                  }),
                  group: S({}, n, {
                    value: Hl,
                  }),
                  groupCollapsed: S({}, n, {
                    value: ba,
                  }),
                  groupEnd: S({}, n, {
                    value: yE,
                  }),
                })
              }
              $i < 0 &&
                s("disabledDepth fell below zero. This is a bug in React. Please file an issue.")
            }
          }
          var Or = i.ReactCurrentDispatcher,
            Ia
          function EQ(n, a, y) {
            {
              if (Ia === void 0)
                try {
                  throw Error()
                } catch (J) {
                  var k = J.stack.trim().match(/\n( *(at )?)/)
                  Ia = (k && k[1]) || ""
                }
              return (
                `
` +
                Ia +
                n
              )
            }
          }
          var pE = !1,
            Ln
          {
            var en = typeof WeakMap == "function" ? WeakMap : Map
            Ln = new en()
          }
          function Rs(n, a) {
            if (!n || pE) return ""
            {
              var y = Ln.get(n)
              if (y !== void 0) return y
            }
            var k
            pE = !0
            var J = Error.prepareStackTrace
            Error.prepareStackTrace = void 0
            var T
            ;((T = Or.current), (Or.current = null), Fs())
            try {
              if (a) {
                var W = function () {
                  throw Error()
                }
                if (
                  (Object.defineProperty(W.prototype, "props", {
                    set: function () {
                      throw Error()
                    },
                  }),
                  typeof Reflect == "object" && Reflect.construct)
                ) {
                  try {
                    Reflect.construct(W, [])
                  } catch (og) {
                    k = og
                  }
                  Reflect.construct(n, [], W)
                } else {
                  try {
                    W.call()
                  } catch (og) {
                    k = og
                  }
                  n.call(W.prototype)
                }
              } else {
                try {
                  throw Error()
                } catch (og) {
                  k = og
                }
                n()
              }
            } catch (og) {
              if (og && k && typeof og.stack == "string") {
                for (
                  var BA = og.stack.split(`
`),
                    cA = k.stack.split(`
`),
                    RA = BA.length - 1,
                    TA = cA.length - 1;
                  RA >= 1 && TA >= 0 && BA[RA] !== cA[TA];
                )
                  TA--
                for (; RA >= 1 && TA >= 0; RA--, TA--)
                  if (BA[RA] !== cA[TA]) {
                    if (RA !== 1 || TA !== 1)
                      do
                        if ((RA--, TA--, TA < 0 || BA[RA] !== cA[TA])) {
                          var DI =
                            `
` + BA[RA].replace(" at new ", " at ")
                          return (
                            n.displayName &&
                              DI.includes("<anonymous>") &&
                              (DI = DI.replace("<anonymous>", n.displayName)),
                            typeof n == "function" && Ln.set(n, DI),
                            DI
                          )
                        }
                      while (RA >= 1 && TA >= 0)
                    break
                  }
              }
            } finally {
              ;((pE = !1), (Or.current = T), Oa(), (Error.prepareStackTrace = J))
            }
            var vI = n ? n.displayName || n.name : "",
              bI = vI ? EQ(vI) : ""
            return (typeof n == "function" && Ln.set(n, bI), bI)
          }
          function _a(n, a, y) {
            return Rs(n, !0)
          }
          function xB(n, a, y) {
            return Rs(n, !1)
          }
          function Za(n) {
            var a = n.prototype
            return !!(a && a.isReactComponent)
          }
          function wE(n, a, y) {
            if (n == null) return ""
            if (typeof n == "function") return Rs(n, Za(n))
            if (typeof n == "string") return EQ(n)
            switch (n) {
              case SI:
                return EQ("Suspense")
              case QA:
                return EQ("SuspenseList")
            }
            if (typeof n == "object")
              switch (n.$$typeof) {
                case YI:
                  return xB(n.render)
                case tA:
                  return wE(n.type, a, y)
                case FA: {
                  var k = n,
                    J = k._payload,
                    T = k._init
                  try {
                    return wE(T(J), a, y)
                  } catch {}
                }
              }
            return ""
          }
          var wo = Object.prototype.hasOwnProperty,
            Js = {},
            Pa = i.ReactDebugCurrentFrame
          function Ks(n) {
            if (n) {
              var a = n._owner,
                y = wE(n.type, n._source, a ? a.type : null)
              Pa.setExtraStackFrame(y)
            } else Pa.setExtraStackFrame(null)
          }
          function go(n, a, y, k, J) {
            {
              var T = Function.call.bind(wo)
              for (var W in n)
                if (T(n, W)) {
                  var BA = void 0
                  try {
                    if (typeof n[W] != "function") {
                      var cA = Error(
                        (k || "React class") +
                          ": " +
                          y +
                          " type `" +
                          W +
                          "` is invalid; it must be a function, usually from the `prop-types` package, but received `" +
                          typeof n[W] +
                          "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.",
                      )
                      throw ((cA.name = "Invariant Violation"), cA)
                    }
                    BA = n[W](a, W, k, y, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED")
                  } catch (RA) {
                    BA = RA
                  }
                  ;(BA &&
                    !(BA instanceof Error) &&
                    (Ks(J),
                    s(
                      "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",
                      k || "React class",
                      y,
                      W,
                      typeof BA,
                    ),
                    Ks(null)),
                    BA instanceof Error &&
                      !(BA.message in Js) &&
                      ((Js[BA.message] = !0),
                      Ks(J),
                      s("Failed %s type: %s", y, BA.message),
                      Ks(null)))
                }
            }
          }
          var Fi = [],
            Wa
          Wa = []
          var rt = -1
          function vQ(n) {
            return {
              current: n,
            }
          }
          function vt(n, a) {
            if (rt < 0) {
              s("Unexpected pop.")
              return
            }
            ;(a !== Wa[rt] && s("Unexpected Fiber popped."),
              (n.current = Fi[rt]),
              (Fi[rt] = null),
              (Wa[rt] = null),
              rt--)
          }
          function ti(n, a, y) {
            ;(rt++, (Fi[rt] = n.current), (Wa[rt] = y), (n.current = a))
          }
          var GE
          GE = {}
          var he = {}
          Object.freeze(he)
          var xe = vQ(he),
            $e = vQ(!1),
            Va = he
          function Lt(n, a, y) {
            return y && Co(a) ? Va : xe.current
          }
          function ga(n, a, y) {
            {
              var k = n.stateNode
              ;((k.__reactInternalMemoizedUnmaskedChildContext = a),
                (k.__reactInternalMemoizedMaskedChildContext = y))
            }
          }
          function Yn(n, a) {
            {
              var y = n.type,
                k = y.contextTypes
              if (!k) return he
              var J = n.stateNode
              if (J && J.__reactInternalMemoizedUnmaskedChildContext === a)
                return J.__reactInternalMemoizedMaskedChildContext
              var T = {}
              for (var W in k) T[W] = a[W]
              {
                var BA = $I(n) || "Unknown"
                go(k, T, "context", BA)
              }
              return (J && ga(n, a, T), T)
            }
          }
          function kt() {
            return $e.current
          }
          function Co(n) {
            {
              var a = n.childContextTypes
              return a != null
            }
          }
          function kE(n) {
            ;(vt($e, n), vt(xe, n))
          }
          function tn(n) {
            ;(vt($e, n), vt(xe, n))
          }
          function Go(n, a, y) {
            {
              if (xe.current !== he)
                throw new Error(
                  "Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.",
                )
              ;(ti(xe, a, n), ti($e, y, n))
            }
          }
          function eo(n, a, y) {
            {
              var k = n.stateNode,
                J = a.childContextTypes
              if (typeof k.getChildContext != "function") {
                {
                  var T = $I(n) || "Unknown"
                  GE[T] ||
                    ((GE[T] = !0),
                    s(
                      "%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.",
                      T,
                      T,
                    ))
                }
                return y
              }
              var W = k.getChildContext()
              for (var BA in W)
                if (!(BA in J))
                  throw new Error(
                    ($I(n) || "Unknown") +
                      '.getChildContext(): key "' +
                      BA +
                      '" is not defined in childContextTypes.',
                  )
              {
                var cA = $I(n) || "Unknown"
                go(J, W, "child context", cA)
              }
              return S({}, y, W)
            }
          }
          function yi(n) {
            {
              var a = n.stateNode,
                y = (a && a.__reactInternalMemoizedMergedChildContext) || he
              return ((Va = xe.current), ti(xe, y, n), ti($e, $e.current, n), !0)
            }
          }
          function ja(n, a, y) {
            {
              var k = n.stateNode
              if (!k)
                throw new Error(
                  "Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.",
                )
              if (y) {
                var J = eo(n, a, Va)
                ;((k.__reactInternalMemoizedMergedChildContext = J),
                  vt($e, n),
                  vt(xe, n),
                  ti(xe, J, n),
                  ti($e, y, n))
              } else (vt($e, n), ti($e, y, n))
            }
          }
          function ms(n) {
            {
              if (!rg(n) || n.tag !== AA)
                throw new Error(
                  "Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.",
                )
              var a = n
              do {
                switch (a.tag) {
                  case _:
                    return a.stateNode.context
                  case AA: {
                    var y = a.type
                    if (Co(y)) return a.stateNode.__reactInternalMemoizedMergedChildContext
                    break
                  }
                }
                a = a.return
              } while (a !== null)
              throw new Error(
                "Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.",
              )
            }
          }
          var Ca = 0,
            Tl = 1,
            FC =
              /*                         */
              0,
            Ai =
              /*                 */
              1,
            Ae =
              /*                    */
              2,
            qi =
              /*               */
              8,
            sB =
              /*              */
              16,
            _r = Math.clz32 ? Math.clz32 : xl,
            Zr = Math.log,
            ea = Math.LN2
          function xl(n) {
            var a = n >>> 0
            return a === 0 ? 32 : (31 - ((Zr(a) / ea) | 0)) | 0
          }
          var Pr = 31,
            Cg =
              /*                        */
              0,
            TC =
              /*                          */
              0,
            PC =
              /*                        */
              1,
            aQ =
              /*    */
              2,
            LQ =
              /*            */
              4,
            qn =
              /*            */
              8,
            io =
              /*                    */
              16,
            Hn =
              /*                */
              32,
            Tn =
              /*                       */
              4194240,
            ko =
              /*                        */
              64,
            vs =
              /*                        */
              128,
            Ls =
              /*                        */
              256,
            bl =
              /*                        */
              512,
            Wr =
              /*                        */
              1024,
            za =
              /*                        */
              2048,
            Xa =
              /*                        */
              4096,
            ia =
              /*                        */
              8192,
            ME =
              /*                        */
              16384,
            $a =
              /*                       */
              32768,
            UE =
              /*                       */
              65536,
            Vr =
              /*                       */
              131072,
            Ar =
              /*                       */
              262144,
            Ys =
              /*                       */
              524288,
            Ol =
              /*                       */
              1048576,
            Bn =
              /*                       */
              2097152,
            rQ =
              /*                            */
              130023424,
            Qn =
              /*                             */
              4194304,
            on =
              /*                             */
              8388608,
            Mt =
              /*                             */
              16777216,
            xn =
              /*                             */
              33554432,
            sQ =
              /*                             */
              67108864,
            ta = Qn,
            Ba =
              /*          */
              134217728,
            Ir =
              /*                                 */
              268435455,
            wB =
              /*               */
              268435456,
            lQ =
              /*                       */
              536870912,
            Re =
              /*                   */
              1073741824
          function nC(n) {
            {
              if (n & PC) return "Sync"
              if (n & aQ) return "InputContinuousHydration"
              if (n & LQ) return "InputContinuous"
              if (n & qn) return "DefaultHydration"
              if (n & io) return "Default"
              if (n & Hn) return "TransitionHydration"
              if (n & Tn) return "Transition"
              if (n & rQ) return "Retry"
              if (n & Ba) return "SelectiveHydration"
              if (n & wB) return "IdleHydration"
              if (n & lQ) return "Idle"
              if (n & Re) return "Offscreen"
            }
          }
          var Je = -1,
            te = ko,
            IC = Qn
          function de(n) {
            switch (Mo(n)) {
              case PC:
                return PC
              case aQ:
                return aQ
              case LQ:
                return LQ
              case qn:
                return qn
              case io:
                return io
              case Hn:
                return Hn
              case ko:
              case vs:
              case Ls:
              case bl:
              case Wr:
              case za:
              case Xa:
              case ia:
              case ME:
              case $a:
              case UE:
              case Vr:
              case Ar:
              case Ys:
              case Ol:
              case Bn:
                return n & Tn
              case Qn:
              case on:
              case Mt:
              case xn:
              case sQ:
                return n & rQ
              case Ba:
                return Ba
              case wB:
                return wB
              case lQ:
                return lQ
              case Re:
                return Re
              default:
                return (s("Should have found matching lanes. This is a bug in React."), n)
            }
          }
          function Ue(n, a) {
            var y = n.pendingLanes
            if (y === Cg) return Cg
            var k = Cg,
              J = n.suspendedLanes,
              T = n.pingedLanes,
              W = y & Ir
            if (W !== Cg) {
              var BA = W & ~J
              if (BA !== Cg) k = de(BA)
              else {
                var cA = W & T
                cA !== Cg && (k = de(cA))
              }
            } else {
              var RA = y & ~J
              RA !== Cg ? (k = de(RA)) : T !== Cg && (k = de(T))
            }
            if (k === Cg) return Cg
            if (
              a !== Cg &&
              a !== k && // If we already suspended with a delay, then interrupting is fine. Don't
              // bother waiting until the root is complete.
              (a & J) === Cg
            ) {
              var TA = Mo(k),
                DI = Mo(a)
              if (
                // Tests whether the next lane is equal or lower priority than the wip
                // one. This works because the bits decrease in priority as you go left.
                TA >= DI || // Default priority updates should not interrupt transition updates. The
                // only difference between default updates and transition updates is that
                // default updates do not support refresh transitions.
                (TA === io && (DI & Tn) !== Cg)
              )
                return a
            }
            ;(k & LQ) !== Cg && (k |= y & io)
            var vI = n.entangledLanes
            if (vI !== Cg)
              for (var bI = n.entanglements, og = k & vI; og > 0; ) {
                var cg = st(og),
                  cC = 1 << cg
                ;((k |= bI[cg]), (og &= ~cC))
              }
            return k
          }
          function nn(n, a) {
            for (var y = n.eventTimes, k = Je; a > 0; ) {
              var J = st(a),
                T = 1 << J,
                W = y[J]
              ;(W > k && (k = W), (a &= ~T))
            }
            return k
          }
          function kC(n, a) {
            switch (n) {
              case PC:
              case aQ:
              case LQ:
                return a + 250
              case qn:
              case io:
              case Hn:
              case ko:
              case vs:
              case Ls:
              case bl:
              case Wr:
              case za:
              case Xa:
              case ia:
              case ME:
              case $a:
              case UE:
              case Vr:
              case Ar:
              case Ys:
              case Ol:
              case Bn:
                return a + 5e3
              case Qn:
              case on:
              case Mt:
              case xn:
              case sQ:
                return Je
              case Ba:
              case wB:
              case lQ:
              case Re:
                return Je
              default:
                return (s("Should have found matching lanes. This is a bug in React."), Je)
            }
          }
          function At(n, a) {
            for (
              var y = n.pendingLanes,
                k = n.suspendedLanes,
                J = n.pingedLanes,
                T = n.expirationTimes,
                W = y;
              W > 0;
            ) {
              var BA = st(W),
                cA = 1 << BA,
                RA = T[BA]
              ;(RA === Je
                ? ((cA & k) === Cg || (cA & J) !== Cg) && (T[BA] = kC(cA, a))
                : RA <= a && (n.expiredLanes |= cA),
                (W &= ~cA))
            }
          }
          function bB(n) {
            return de(n.pendingLanes)
          }
          function cQ(n) {
            var a = n.pendingLanes & ~Re
            return a !== Cg ? a : a & Re ? Re : Cg
          }
          function Ri(n) {
            return (n & PC) !== Cg
          }
          function hQ(n) {
            return (n & Ir) !== Cg
          }
          function bn(n) {
            return (n & rQ) === n
          }
          function Qa(n) {
            return (n & Tn) === n
          }
          function On(n, a) {
            var y = aQ | LQ | qn | io
            return (a & y) !== Cg
          }
          function Vc(n, a) {
            return (a & n.expiredLanes) !== Cg
          }
          function OB(n) {
            return (n & Tn) !== 0
          }
          function Xt() {
            var n = te
            return ((te <<= 1), te & Tn || (te = ko), n)
          }
          function jr() {
            var n = IC
            return ((IC <<= 1), IC & rQ || (IC = Qn), n)
          }
          function Mo(n) {
            return n & -n
          }
          function oa(n) {
            return Mo(n)
          }
          function st(n) {
            return 31 - _r(n)
          }
          function En(n) {
            return st(n)
          }
          function Ne(n, a) {
            return (n & a) !== Cg
          }
          function Uo(n, a) {
            return (n & a) === a
          }
          function LC(n, a) {
            return n | a
          }
          function Yt(n, a) {
            return n & ~a
          }
          function It(n, a) {
            return n & a
          }
          function an(n) {
            return n
          }
          function lg(n, a) {
            return n !== TC && n < a ? n : a
          }
          function YQ(n) {
            for (var a = [], y = 0; y < Pr; y++) a.push(n)
            return a
          }
          function $t(n, a, y) {
            ;((n.pendingLanes |= a), a !== lQ && ((n.suspendedLanes = Cg), (n.pingedLanes = Cg)))
            var k = n.eventTimes,
              J = En(a)
            k[J] = y
          }
          function _l(n, a) {
            ;((n.suspendedLanes |= a), (n.pingedLanes &= ~a))
            for (var y = n.expirationTimes, k = a; k > 0; ) {
              var J = st(k),
                T = 1 << J
              ;((y[J] = Je), (k &= ~T))
            }
          }
          function qs(n, a, y) {
            n.pingedLanes |= n.suspendedLanes & a
          }
          function NE(n, a) {
            var y = n.pendingLanes & ~a
            ;((n.pendingLanes = a),
              (n.suspendedLanes = 0),
              (n.pingedLanes = 0),
              (n.expiredLanes &= a),
              (n.mutableReadLanes &= a),
              (n.entangledLanes &= a))
            for (var k = n.entanglements, J = n.eventTimes, T = n.expirationTimes, W = y; W > 0; ) {
              var BA = st(W),
                cA = 1 << BA
              ;((k[BA] = Cg), (J[BA] = Je), (T[BA] = Je), (W &= ~cA))
            }
          }
          function AB(n, a) {
            for (var y = (n.entangledLanes |= a), k = n.entanglements, J = y; J; ) {
              var T = st(J),
                W = 1 << T
              // Is this one of the newly entangled lanes?
              ;((W & a) | // Is this lane transitively entangled with the newly entangled lanes?
                (k[T] & a) && (k[T] |= a),
                (J &= ~W))
            }
          }
          function _B(n, a) {
            var y = Mo(a),
              k
            switch (y) {
              case LQ:
                k = aQ
                break
              case io:
                k = qn
                break
              case ko:
              case vs:
              case Ls:
              case bl:
              case Wr:
              case za:
              case Xa:
              case ia:
              case ME:
              case $a:
              case UE:
              case Vr:
              case Ar:
              case Ys:
              case Ol:
              case Bn:
              case Qn:
              case on:
              case Mt:
              case xn:
              case sQ:
                k = Hn
                break
              case lQ:
                k = wB
                break
              default:
                k = TC
                break
            }
            return (k & (n.suspendedLanes | a)) !== TC ? TC : k
          }
          function pi(n, a, y) {
            if (uQ)
              for (var k = n.pendingUpdatersLaneMap; y > 0; ) {
                var J = En(y),
                  T = 1 << J,
                  W = k[J]
                ;(W.add(a), (y &= ~T))
              }
          }
          function qQ(n, a) {
            if (uQ)
              for (var y = n.pendingUpdatersLaneMap, k = n.memoizedUpdaters; a > 0; ) {
                var J = En(a),
                  T = 1 << J,
                  W = y[J]
                ;(W.size > 0 &&
                  (W.forEach(function (BA) {
                    var cA = BA.alternate
                    ;(cA === null || !k.has(cA)) && k.add(BA)
                  }),
                  W.clear()),
                  (a &= ~T))
              }
          }
          var to = PC,
            gr = LQ,
            FE = io,
            Cr = lQ,
            na = TC
          function ZB() {
            return na
          }
          function qt(n) {
            na = n
          }
          function Hi(n, a) {
            var y = na
            try {
              return ((na = n), a())
            } finally {
              na = y
            }
          }
          function zr(n, a) {
            return n !== 0 && n < a ? n : a
          }
          function Zl(n, a) {
            return n > a ? n : a
          }
          function Ea(n, a) {
            return n !== 0 && n < a
          }
          function No(n) {
            var a = Mo(n)
            return Ea(to, a) ? (Ea(gr, a) ? (hQ(a) ? FE : Cr) : gr) : to
          }
          var Pl = C.unstable_scheduleCallback,
            Hs = C.unstable_cancelCallback,
            er = C.unstable_shouldYield,
            Ts = C.unstable_requestPaint,
            Bi = C.unstable_now,
            Ti = C.unstable_ImmediatePriority,
            fg = C.unstable_UserBlockingPriority,
            Ht = C.unstable_NormalPriority,
            lB = C.unstable_IdlePriority,
            xs = C.unstable_yieldValue,
            bs = C.unstable_setDisableYieldValue,
            Bo = null,
            si = null,
            wg = null,
            Qi = !1,
            uQ = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u"
          function rn(n) {
            if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1
            var a = __REACT_DEVTOOLS_GLOBAL_HOOK__
            if (a.isDisabled) return !0
            if (!a.supportsFiber)
              return (
                s(
                  "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools",
                ),
                !0
              )
            try {
              ;(H &&
                (n = S({}, n, {
                  getLaneLabelMap: ir,
                  injectProfilingHooks: PB,
                })),
                (Bo = a.inject(n)),
                (si = a))
            } catch (y) {
              s("React instrumentation encountered an error: %s.", y)
            }
            return !!a.checkDCE
          }
          function li(n, a) {
            if (si && typeof si.onScheduleFiberRoot == "function")
              try {
                si.onScheduleFiberRoot(Bo, n, a)
              } catch (y) {
                Qi || ((Qi = !0), s("React instrumentation encountered an error: %s", y))
              }
          }
          function $C(n, a) {
            if (si && typeof si.onCommitFiberRoot == "function")
              try {
                var y = (n.current.flags & Qg) === Qg
                if (V) {
                  var k
                  switch (a) {
                    case to:
                      k = Ti
                      break
                    case gr:
                      k = fg
                      break
                    case FE:
                      k = Ht
                      break
                    case Cr:
                      k = lB
                      break
                    default:
                      k = Ht
                      break
                  }
                  si.onCommitFiberRoot(Bo, n, k, y)
                }
              } catch (J) {
                Qi || ((Qi = !0), s("React instrumentation encountered an error: %s", J))
              }
          }
          function xi(n) {
            if (si && typeof si.onPostCommitFiberRoot == "function")
              try {
                si.onPostCommitFiberRoot(Bo, n)
              } catch (a) {
                Qi || ((Qi = !0), s("React instrumentation encountered an error: %s", a))
              }
          }
          function Ke(n) {
            if (si && typeof si.onCommitFiberUnmount == "function")
              try {
                si.onCommitFiberUnmount(Bo, n)
              } catch (a) {
                Qi || ((Qi = !0), s("React instrumentation encountered an error: %s", a))
              }
          }
          function Ie(n) {
            if (
              (typeof xs == "function" && (bs(n), o(n)),
              si && typeof si.setStrictMode == "function")
            )
              try {
                si.setStrictMode(Bo, n)
              } catch (a) {
                Qi || ((Qi = !0), s("React instrumentation encountered an error: %s", a))
              }
          }
          function PB(n) {
            wg = n
          }
          function ir() {
            {
              for (var n = /* @__PURE__ */ new Map(), a = 1, y = 0; y < Pr; y++) {
                var k = nC(a)
                ;(n.set(a, k), (a *= 2))
              }
              return n
            }
          }
          function lt(n) {
            wg !== null && typeof wg.markCommitStarted == "function" && wg.markCommitStarted(n)
          }
          function tr() {
            wg !== null && typeof wg.markCommitStopped == "function" && wg.markCommitStopped()
          }
          function HQ(n) {
            wg !== null &&
              typeof wg.markComponentRenderStarted == "function" &&
              wg.markComponentRenderStarted(n)
          }
          function IB() {
            wg !== null &&
              typeof wg.markComponentRenderStopped == "function" &&
              wg.markComponentRenderStopped()
          }
          function aa(n) {
            wg !== null &&
              typeof wg.markComponentPassiveEffectMountStarted == "function" &&
              wg.markComponentPassiveEffectMountStarted(n)
          }
          function RE() {
            wg !== null &&
              typeof wg.markComponentPassiveEffectMountStopped == "function" &&
              wg.markComponentPassiveEffectMountStopped()
          }
          function Tt(n) {
            wg !== null &&
              typeof wg.markComponentPassiveEffectUnmountStarted == "function" &&
              wg.markComponentPassiveEffectUnmountStarted(n)
          }
          function Os() {
            wg !== null &&
              typeof wg.markComponentPassiveEffectUnmountStopped == "function" &&
              wg.markComponentPassiveEffectUnmountStopped()
          }
          function ra(n) {
            wg !== null &&
              typeof wg.markComponentLayoutEffectMountStarted == "function" &&
              wg.markComponentLayoutEffectMountStarted(n)
          }
          function Br() {
            wg !== null &&
              typeof wg.markComponentLayoutEffectMountStopped == "function" &&
              wg.markComponentLayoutEffectMountStopped()
          }
          function Qr(n) {
            wg !== null &&
              typeof wg.markComponentLayoutEffectUnmountStarted == "function" &&
              wg.markComponentLayoutEffectUnmountStarted(n)
          }
          function wi() {
            wg !== null &&
              typeof wg.markComponentLayoutEffectUnmountStopped == "function" &&
              wg.markComponentLayoutEffectUnmountStopped()
          }
          function sn(n, a, y) {
            wg !== null &&
              typeof wg.markComponentErrored == "function" &&
              wg.markComponentErrored(n, a, y)
          }
          function or(n, a, y) {
            wg !== null &&
              typeof wg.markComponentSuspended == "function" &&
              wg.markComponentSuspended(n, a, y)
          }
          function _n(n) {
            wg !== null &&
              typeof wg.markLayoutEffectsStarted == "function" &&
              wg.markLayoutEffectsStarted(n)
          }
          function nr() {
            wg !== null &&
              typeof wg.markLayoutEffectsStopped == "function" &&
              wg.markLayoutEffectsStopped()
          }
          function JE(n) {
            wg !== null &&
              typeof wg.markPassiveEffectsStarted == "function" &&
              wg.markPassiveEffectsStarted(n)
          }
          function zg() {
            wg !== null &&
              typeof wg.markPassiveEffectsStopped == "function" &&
              wg.markPassiveEffectsStopped()
          }
          function Pg(n) {
            wg !== null && typeof wg.markRenderStarted == "function" && wg.markRenderStarted(n)
          }
          function uC() {
            wg !== null && typeof wg.markRenderYielded == "function" && wg.markRenderYielded()
          }
          function rC() {
            wg !== null && typeof wg.markRenderStopped == "function" && wg.markRenderStopped()
          }
          function xt(n) {
            wg !== null && typeof wg.markRenderScheduled == "function" && wg.markRenderScheduled(n)
          }
          function GB(n, a) {
            wg !== null &&
              typeof wg.markForceUpdateScheduled == "function" &&
              wg.markForceUpdateScheduled(n, a)
          }
          function Zn(n, a) {
            wg !== null &&
              typeof wg.markStateUpdateScheduled == "function" &&
              wg.markStateUpdateScheduled(n, a)
          }
          function TQ(n, a) {
            return (n === a && (n !== 0 || 1 / n === 1 / a)) || (n !== n && a !== a)
          }
          var ci = typeof Object.is == "function" ? Object.is : TQ,
            DQ = null,
            Ag = !1,
            ct = !1
          function bg(n) {
            DQ === null ? (DQ = [n]) : DQ.push(n)
          }
          function cB(n) {
            ;((Ag = !0), bg(n))
          }
          function SQ() {
            Ag && bt()
          }
          function bt() {
            if (!ct && DQ !== null) {
              ct = !0
              var n = 0,
                a = ZB()
              try {
                var y = !0,
                  k = DQ
                for (qt(to); n < k.length; n++) {
                  var J = k[n]
                  do J = J(y)
                  while (J !== null)
                }
                ;((DQ = null), (Ag = !1))
              } catch (T) {
                throw (DQ !== null && (DQ = DQ.slice(n + 1)), Pl(Ti, bt), T)
              } finally {
                ;(qt(a), (ct = !1))
              }
            }
            return null
          }
          function gB(n) {
            var a = n.current.memoizedState
            return a.isDehydrated
          }
          var Er = i.ReactCurrentBatchConfig,
            sa = null
          function la() {
            return Er.transition
          }
          function Pn(n, a) {
            if (ci(n, a)) return !0
            if (typeof n != "object" || n === null || typeof a != "object" || a === null) return !1
            var y = Object.keys(n),
              k = Object.keys(a)
            if (y.length !== k.length) return !1
            for (var J = 0; J < y.length; J++) {
              var T = y[J]
              if (!wo.call(a, T) || !ci(n[T], a[T])) return !1
            }
            return !0
          }
          function Wl(n) {
            switch ((n._debugOwner && n._debugOwner.type, n._debugSource, n.tag)) {
              case CA:
                return EQ(n.type)
              case GA:
                return EQ("Lazy")
              case sA:
                return EQ("Suspense")
              case kA:
                return EQ("SuspenseList")
              case P:
              case X:
              case EA:
                return xB(n.type)
              case nA:
                return xB(n.type.render)
              case AA:
                return _a(n.type)
              default:
                return ""
            }
          }
          function _s(n) {
            try {
              var a = "",
                y = n
              do ((a += Wl(y)), (y = y.return))
              while (y)
              return a
            } catch (k) {
              return (
                `
Error generating stack: ` +
                k.message +
                `
` +
                k.stack
              )
            }
          }
          var Xr = i.ReactDebugCurrentFrame,
            WB = null,
            kB = !1
          function Vl() {
            {
              if (WB === null) return null
              var n = WB._debugOwner
              if (n !== null && typeof n < "u") return $I(n)
            }
            return null
          }
          function Fo() {
            return WB === null ? "" : _s(WB)
          }
          function ht() {
            ;((Xr.getCurrentStack = null), (WB = null), (kB = !1))
          }
          function Fe(n) {
            ;((Xr.getCurrentStack = Fo), (WB = n), (kB = !1))
          }
          function xQ(n) {
            kB = n
          }
          var fQ = {
            recordUnsafeLifecycleWarnings: function (n, a) {},
            flushPendingUnsafeLifecycleWarnings: function () {},
            recordLegacyContextWarning: function (n, a) {},
            flushLegacyContextWarning: function () {},
            discardPendingWarnings: function () {},
          }
          {
            var jl = function (n) {
                for (var a = null, y = n; y !== null; ) (y.mode & qi && (a = y), (y = y.return))
                return a
              },
              Wn = function (n) {
                var a = []
                return (
                  n.forEach(function (y) {
                    a.push(y)
                  }),
                  a.sort().join(", ")
                )
              },
              KE = [],
              ln = [],
              cn = [],
              CB = [],
              Vn = [],
              ar = [],
              MB = /* @__PURE__ */ new Set()
            ;((fQ.recordUnsafeLifecycleWarnings = function (n, a) {
              MB.has(n.type) ||
                (typeof a.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
                  a.componentWillMount.__suppressDeprecationWarning !== !0 &&
                  KE.push(n),
                n.mode & qi && typeof a.UNSAFE_componentWillMount == "function" && ln.push(n),
                typeof a.componentWillReceiveProps == "function" &&
                  a.componentWillReceiveProps.__suppressDeprecationWarning !== !0 &&
                  cn.push(n),
                n.mode & qi &&
                  typeof a.UNSAFE_componentWillReceiveProps == "function" &&
                  CB.push(n),
                typeof a.componentWillUpdate == "function" &&
                  a.componentWillUpdate.__suppressDeprecationWarning !== !0 &&
                  Vn.push(n),
                n.mode & qi && typeof a.UNSAFE_componentWillUpdate == "function" && ar.push(n))
            }),
              (fQ.flushPendingUnsafeLifecycleWarnings = function () {
                var n = /* @__PURE__ */ new Set()
                KE.length > 0 &&
                  (KE.forEach(function (vI) {
                    ;(n.add($I(vI) || "Component"), MB.add(vI.type))
                  }),
                  (KE = []))
                var a = /* @__PURE__ */ new Set()
                ln.length > 0 &&
                  (ln.forEach(function (vI) {
                    ;(a.add($I(vI) || "Component"), MB.add(vI.type))
                  }),
                  (ln = []))
                var y = /* @__PURE__ */ new Set()
                cn.length > 0 &&
                  (cn.forEach(function (vI) {
                    ;(y.add($I(vI) || "Component"), MB.add(vI.type))
                  }),
                  (cn = []))
                var k = /* @__PURE__ */ new Set()
                CB.length > 0 &&
                  (CB.forEach(function (vI) {
                    ;(k.add($I(vI) || "Component"), MB.add(vI.type))
                  }),
                  (CB = []))
                var J = /* @__PURE__ */ new Set()
                Vn.length > 0 &&
                  (Vn.forEach(function (vI) {
                    ;(J.add($I(vI) || "Component"), MB.add(vI.type))
                  }),
                  (Vn = []))
                var T = /* @__PURE__ */ new Set()
                if (
                  (ar.length > 0 &&
                    (ar.forEach(function (vI) {
                      ;(T.add($I(vI) || "Component"), MB.add(vI.type))
                    }),
                    (ar = [])),
                  a.size > 0)
                ) {
                  var W = Wn(a)
                  s(
                    `Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`,
                    W,
                  )
                }
                if (k.size > 0) {
                  var BA = Wn(k)
                  s(
                    `Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`,
                    BA,
                  )
                }
                if (T.size > 0) {
                  var cA = Wn(T)
                  s(
                    `Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`,
                    cA,
                  )
                }
                if (n.size > 0) {
                  var RA = Wn(n)
                  r(
                    `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
                    RA,
                  )
                }
                if (y.size > 0) {
                  var TA = Wn(y)
                  r(
                    `componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
                    TA,
                  )
                }
                if (J.size > 0) {
                  var DI = Wn(J)
                  r(
                    `componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
                    DI,
                  )
                }
              }))
            var ca = /* @__PURE__ */ new Map(),
              Ro = /* @__PURE__ */ new Set()
            ;((fQ.recordLegacyContextWarning = function (n, a) {
              var y = jl(n)
              if (y === null) {
                s(
                  "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.",
                )
                return
              }
              if (!Ro.has(n.type)) {
                var k = ca.get(y)
                ;(n.type.contextTypes != null ||
                  n.type.childContextTypes != null ||
                  (a !== null && typeof a.getChildContext == "function")) &&
                  (k === void 0 && ((k = []), ca.set(y, k)), k.push(n))
              }
            }),
              (fQ.flushLegacyContextWarning = function () {
                ca.forEach(function (n, a) {
                  if (n.length !== 0) {
                    var y = n[0],
                      k = /* @__PURE__ */ new Set()
                    n.forEach(function (T) {
                      ;(k.add($I(T) || "Component"), Ro.add(T.type))
                    })
                    var J = Wn(k)
                    try {
                      ;(Fe(y),
                        s(
                          `Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`,
                          J,
                        ))
                    } finally {
                      ht()
                    }
                  }
                })
              }),
              (fQ.discardPendingWarnings = function () {
                ;((KE = []),
                  (ln = []),
                  (cn = []),
                  (CB = []),
                  (Vn = []),
                  (ar = []),
                  (ca = /* @__PURE__ */ new Map()))
              }))
          }
          function rr(n) {
            {
              var a = typeof Symbol == "function" && Symbol.toStringTag,
                y = (a && n[Symbol.toStringTag]) || n.constructor.name || "Object"
              return y
            }
          }
          function mE(n) {
            try {
              return (Jo(n), !1)
            } catch {
              return !0
            }
          }
          function Jo(n) {
            return "" + n
          }
          function VB(n) {
            if (mE(n))
              return (
                s(
                  "The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.",
                  rr(n),
                ),
                Jo(n)
              )
          }
          function lu(n, a) {
            if (mE(n))
              return (
                s(
                  "The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.",
                  a,
                  rr(n),
                ),
                Jo(n)
              )
          }
          function ue(n, a) {
            if (n && n.defaultProps) {
              var y = S({}, a),
                k = n.defaultProps
              for (var J in k) y[J] === void 0 && (y[J] = k[J])
              return y
            }
            return a
          }
          var ha = vQ(null),
            eB
          eB = {}
          var Ko = null,
            mo = null,
            zl = null,
            u = !1
          function D() {
            ;((Ko = null), (mo = null), (zl = null), (u = !1))
          }
          function N() {
            u = !0
          }
          function v() {
            u = !1
          }
          function O(n, a, y) {
            dB
              ? (ti(ha, a._currentValue, n),
                (a._currentValue = y),
                a._currentRenderer !== void 0 &&
                  a._currentRenderer !== null &&
                  a._currentRenderer !== eB &&
                  s(
                    "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.",
                  ),
                (a._currentRenderer = eB))
              : (ti(ha, a._currentValue2, n),
                (a._currentValue2 = y),
                a._currentRenderer2 !== void 0 &&
                  a._currentRenderer2 !== null &&
                  a._currentRenderer2 !== eB &&
                  s(
                    "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.",
                  ),
                (a._currentRenderer2 = eB))
          }
          function IA(n, a) {
            var y = ha.current
            ;(vt(ha, a), dB ? (n._currentValue = y) : (n._currentValue2 = y))
          }
          function UA(n, a, y) {
            for (var k = n; k !== null; ) {
              var J = k.alternate
              if (
                (Uo(k.childLanes, a)
                  ? J !== null && !Uo(J.childLanes, a) && (J.childLanes = LC(J.childLanes, a))
                  : ((k.childLanes = LC(k.childLanes, a)),
                    J !== null && (J.childLanes = LC(J.childLanes, a))),
                k === y)
              )
                break
              k = k.return
            }
            k !== y &&
              s(
                "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.",
              )
          }
          function CI(n, a, y) {
            HI(n, a, y)
          }
          function HI(n, a, y) {
            var k = n.child
            for (k !== null && (k.return = n); k !== null; ) {
              var J = void 0,
                T = k.dependencies
              if (T !== null) {
                J = k.child
                for (var W = T.firstContext; W !== null; ) {
                  if (W.context === a) {
                    if (k.tag === AA) {
                      var BA = oa(y),
                        cA = SC(Je, BA)
                      cA.tag = Dt
                      var RA = k.updateQueue
                      if (RA !== null) {
                        var TA = RA.shared,
                          DI = TA.pending
                        ;(DI === null ? (cA.next = cA) : ((cA.next = DI.next), (DI.next = cA)),
                          (TA.pending = cA))
                      }
                    }
                    k.lanes = LC(k.lanes, y)
                    var vI = k.alternate
                    ;(vI !== null && (vI.lanes = LC(vI.lanes, y)),
                      UA(k.return, y, n),
                      (T.lanes = LC(T.lanes, y)))
                    break
                  }
                  W = W.next
                }
              } else if (k.tag === LA) J = k.type === n.type ? null : k.child
              else if (k.tag === dA) {
                var bI = k.return
                if (bI === null)
                  throw new Error(
                    "We just came from a parent so we must have had a parent. This is a bug in React.",
                  )
                bI.lanes = LC(bI.lanes, y)
                var og = bI.alternate
                ;(og !== null && (og.lanes = LC(og.lanes, y)), UA(bI, y, n), (J = k.sibling))
              } else J = k.child
              if (J !== null) J.return = k
              else
                for (J = k; J !== null; ) {
                  if (J === n) {
                    J = null
                    break
                  }
                  var cg = J.sibling
                  if (cg !== null) {
                    ;((cg.return = J.return), (J = cg))
                    break
                  }
                  J = J.return
                }
              k = J
            }
          }
          function ng(n, a) {
            ;((Ko = n), (mo = null), (zl = null))
            var y = n.dependencies
            if (y !== null) {
              var k = y.firstContext
              k !== null && (Ne(y.lanes, a) && Nd(), (y.firstContext = null))
            }
          }
          function Sg(n) {
            u &&
              s(
                "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().",
              )
            var a = dB ? n._currentValue : n._currentValue2
            if (zl !== n) {
              var y = {
                context: n,
                memoizedValue: a,
                next: null,
              }
              if (mo === null) {
                if (Ko === null)
                  throw new Error(
                    "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().",
                  )
                ;((mo = y),
                  (Ko.dependencies = {
                    lanes: Cg,
                    firstContext: y,
                  }))
              } else mo = mo.next = y
            }
            return a
          }
          var DC = null
          function sC(n) {
            DC === null ? (DC = [n]) : DC.push(n)
          }
          function Be() {
            if (DC !== null) {
              for (var n = 0; n < DC.length; n++) {
                var a = DC[n],
                  y = a.interleaved
                if (y !== null) {
                  a.interleaved = null
                  var k = y.next,
                    J = a.pending
                  if (J !== null) {
                    var T = J.next
                    ;((J.next = k), (y.next = T))
                  }
                  a.pending = y
                }
              }
              DC = null
            }
          }
          var kg = 0,
            ut = 1,
            Dt = 2,
            yI = 3,
            zA = !1,
            JI,
            WI
          ;((JI = !1), (WI = null))
          function Zg(n) {
            var a = {
              baseState: n.memoizedState,
              firstBaseUpdate: null,
              lastBaseUpdate: null,
              shared: {
                pending: null,
                interleaved: null,
                lanes: Cg,
              },
              effects: null,
            }
            n.updateQueue = a
          }
          function WC(n, a) {
            var y = a.updateQueue,
              k = n.updateQueue
            if (y === k) {
              var J = {
                baseState: k.baseState,
                firstBaseUpdate: k.firstBaseUpdate,
                lastBaseUpdate: k.lastBaseUpdate,
                shared: k.shared,
                effects: k.effects,
              }
              a.updateQueue = J
            }
          }
          function SC(n, a) {
            var y = {
              eventTime: n,
              lane: a,
              tag: kg,
              payload: null,
              callback: null,
              next: null,
            }
            return y
          }
          function Qe(n, a, y) {
            var k = n.updateQueue
            if (k !== null) {
              var J = k.shared
              if (KB(n)) {
                var T = J.interleaved
                ;(T === null ? ((a.next = a), sC(J)) : ((a.next = T.next), (T.next = a)),
                  (J.interleaved = a))
              } else {
                var W = J.pending
                ;(W === null ? (a.next = a) : ((a.next = W.next), (W.next = a)), (J.pending = a))
              }
              WI === J &&
                !JI &&
                (s(
                  "An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.",
                ),
                (JI = !0))
            }
          }
          function bi(n, a, y) {
            var k = a.updateQueue
            if (k !== null) {
              var J = k.shared
              if (OB(y)) {
                var T = J.lanes
                T = It(T, n.pendingLanes)
                var W = LC(T, y)
                ;((J.lanes = W), AB(n, W))
              }
            }
          }
          function oe(n, a) {
            var y = n.updateQueue,
              k = n.alternate
            if (k !== null) {
              var J = k.updateQueue
              if (y === J) {
                var T = null,
                  W = null,
                  BA = y.firstBaseUpdate
                if (BA !== null) {
                  var cA = BA
                  do {
                    var RA = {
                      eventTime: cA.eventTime,
                      lane: cA.lane,
                      tag: cA.tag,
                      payload: cA.payload,
                      callback: cA.callback,
                      next: null,
                    }
                    ;(W === null ? (T = W = RA) : ((W.next = RA), (W = RA)), (cA = cA.next))
                  } while (cA !== null)
                  W === null ? (T = W = a) : ((W.next = a), (W = a))
                } else T = W = a
                ;((y = {
                  baseState: J.baseState,
                  firstBaseUpdate: T,
                  lastBaseUpdate: W,
                  shared: J.shared,
                  effects: J.effects,
                }),
                  (n.updateQueue = y))
                return
              }
            }
            var TA = y.lastBaseUpdate
            ;(TA === null ? (y.firstBaseUpdate = a) : (TA.next = a), (y.lastBaseUpdate = a))
          }
          function vE(n, a, y, k, J, T) {
            switch (y.tag) {
              case ut: {
                var W = y.payload
                if (typeof W == "function") {
                  N()
                  var BA = W.call(T, k, J)
                  {
                    if (n.mode & qi) {
                      Ie(!0)
                      try {
                        W.call(T, k, J)
                      } finally {
                        Ie(!1)
                      }
                    }
                    v()
                  }
                  return BA
                }
                return W
              }
              case yI:
                n.flags = (n.flags & ~TI) | Qg
              // Intentional fallthrough
              case kg: {
                var cA = y.payload,
                  RA
                if (typeof cA == "function") {
                  ;(N(), (RA = cA.call(T, k, J)))
                  {
                    if (n.mode & qi) {
                      Ie(!0)
                      try {
                        cA.call(T, k, J)
                      } finally {
                        Ie(!1)
                      }
                    }
                    v()
                  }
                } else RA = cA
                return RA == null ? k : S({}, k, RA)
              }
              case Dt:
                return ((zA = !0), k)
            }
            return k
          }
          function sr(n, a, y, k) {
            var J = n.updateQueue
            ;((zA = !1), (WI = J.shared))
            var T = J.firstBaseUpdate,
              W = J.lastBaseUpdate,
              BA = J.shared.pending
            if (BA !== null) {
              J.shared.pending = null
              var cA = BA,
                RA = cA.next
              ;((cA.next = null), W === null ? (T = RA) : (W.next = RA), (W = cA))
              var TA = n.alternate
              if (TA !== null) {
                var DI = TA.updateQueue,
                  vI = DI.lastBaseUpdate
                vI !== W &&
                  (vI === null ? (DI.firstBaseUpdate = RA) : (vI.next = RA),
                  (DI.lastBaseUpdate = cA))
              }
            }
            if (T !== null) {
              var bI = J.baseState,
                og = Cg,
                cg = null,
                cC = null,
                re = null,
                MC = T
              do {
                var yt = MC.lane,
                  Qt = MC.eventTime
                if (Uo(k, yt)) {
                  if (re !== null) {
                    var PI = {
                      eventTime: Qt,
                      // This update is going to be committed so we never want uncommit
                      // it. Using NoLane works because 0 is a subset of all bitmasks, so
                      // this will never be skipped by the check above.
                      lane: TC,
                      tag: MC.tag,
                      payload: MC.payload,
                      callback: MC.callback,
                      next: null,
                    }
                    re = re.next = PI
                  }
                  bI = vE(n, J, MC, bI, a, y)
                  var uI = MC.callback
                  if (
                    uI !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    MC.lane !== TC
                  ) {
                    n.flags |= $g
                    var ug = J.effects
                    ug === null ? (J.effects = [MC]) : ug.push(MC)
                  }
                } else {
                  var MI = {
                    eventTime: Qt,
                    lane: yt,
                    tag: MC.tag,
                    payload: MC.payload,
                    callback: MC.callback,
                    next: null,
                  }
                  ;(re === null ? ((cC = re = MI), (cg = bI)) : (re = re.next = MI),
                    (og = LC(og, yt)))
                }
                if (((MC = MC.next), MC === null)) {
                  if (((BA = J.shared.pending), BA === null)) break
                  var Og = BA,
                    qg = Og.next
                  ;((Og.next = null), (MC = qg), (J.lastBaseUpdate = Og), (J.shared.pending = null))
                }
              } while (!0)
              ;(re === null && (cg = bI),
                (J.baseState = cg),
                (J.firstBaseUpdate = cC),
                (J.lastBaseUpdate = re))
              var Ge = J.shared.interleaved
              if (Ge !== null) {
                var De = Ge
                do ((og = LC(og, De.lane)), (De = De.next))
                while (De !== Ge)
              } else T === null && (J.shared.lanes = Cg)
              ;(zd(og), (n.lanes = og), (n.memoizedState = bI))
            }
            WI = null
          }
          function cu(n, a) {
            if (typeof n != "function")
              throw new Error(
                "Invalid argument passed as callback. Expected a function. Instead " +
                  ("received: " + n),
              )
            n.call(a)
          }
          function hu() {
            zA = !1
          }
          function jc() {
            return zA
          }
          function zc(n, a, y) {
            var k = a.effects
            if (((a.effects = null), k !== null))
              for (var J = 0; J < k.length; J++) {
                var T = k[J],
                  W = T.callback
                W !== null && ((T.callback = null), cu(W, y))
              }
          }
          var Xc = {},
            Xl = new g.Component().refs,
            Ut,
            LE,
            jn,
            $r,
            As,
            hn,
            gt,
            jB,
            qD,
            HD
          {
            ;((Ut = /* @__PURE__ */ new Set()),
              (LE = /* @__PURE__ */ new Set()),
              (jn = /* @__PURE__ */ new Set()),
              ($r = /* @__PURE__ */ new Set()),
              (jB = /* @__PURE__ */ new Set()),
              (As = /* @__PURE__ */ new Set()),
              (qD = /* @__PURE__ */ new Set()),
              (HD = /* @__PURE__ */ new Set()))
            var Zs = /* @__PURE__ */ new Set()
            ;((gt = function (n, a) {
              if (!(n === null || typeof n == "function")) {
                var y = a + "_" + n
                Zs.has(y) ||
                  (Zs.add(y),
                  s(
                    "%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.",
                    a,
                    n,
                  ))
              }
            }),
              (hn = function (n, a) {
                if (a === void 0) {
                  var y = VA(n) || "Component"
                  As.has(y) ||
                    (As.add(y),
                    s(
                      "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
                      y,
                    ))
                }
              }),
              Object.defineProperty(Xc, "_processChildContext", {
                enumerable: !1,
                value: function () {
                  throw new Error(
                    "_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).",
                  )
                },
              }),
              Object.freeze(Xc))
          }
          function UB(n, a, y, k) {
            var J = n.memoizedState,
              T = y(k, J)
            {
              if (n.mode & qi) {
                Ie(!0)
                try {
                  T = y(k, J)
                } finally {
                  Ie(!1)
                }
              }
              hn(a, T)
            }
            var W = T == null ? J : S({}, J, T)
            if (((n.memoizedState = W), n.lanes === Cg)) {
              var BA = n.updateQueue
              BA.baseState = W
            }
          }
          var $l = {
            isMounted: eC,
            enqueueSetState: function (n, a, y) {
              var k = d(n),
                J = Oo(),
                T = ls(k),
                W = SC(J, T)
              ;((W.payload = a), y != null && (gt(y, "setState"), (W.callback = y)), Qe(k, W))
              var BA = wQ(k, T, J)
              ;(BA !== null && bi(BA, k, T), Zn(k, T))
            },
            enqueueReplaceState: function (n, a, y) {
              var k = d(n),
                J = Oo(),
                T = ls(k),
                W = SC(J, T)
              ;((W.tag = ut),
                (W.payload = a),
                y != null && (gt(y, "replaceState"), (W.callback = y)),
                Qe(k, W))
              var BA = wQ(k, T, J)
              ;(BA !== null && bi(BA, k, T), Zn(k, T))
            },
            enqueueForceUpdate: function (n, a) {
              var y = d(n),
                k = Oo(),
                J = ls(y),
                T = SC(k, J)
              ;((T.tag = Dt), a != null && (gt(a, "forceUpdate"), (T.callback = a)), Qe(y, T))
              var W = wQ(y, J, k)
              ;(W !== null && bi(W, y, J), GB(y, J))
            },
          }
          function xg(n, a, y, k, J, T, W) {
            var BA = n.stateNode
            if (typeof BA.shouldComponentUpdate == "function") {
              var cA = BA.shouldComponentUpdate(k, T, W)
              {
                if (n.mode & qi) {
                  Ie(!0)
                  try {
                    cA = BA.shouldComponentUpdate(k, T, W)
                  } finally {
                    Ie(!1)
                  }
                }
                cA === void 0 &&
                  s(
                    "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
                    VA(a) || "Component",
                  )
              }
              return cA
            }
            return a.prototype && a.prototype.isPureReactComponent ? !Pn(y, k) || !Pn(J, T) : !0
          }
          function Ac(n, a, y) {
            var k = n.stateNode
            {
              var J = VA(a) || "Component",
                T = k.render
              ;(T ||
                (a.prototype && typeof a.prototype.render == "function"
                  ? s(
                      "%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?",
                      J,
                    )
                  : s(
                      "%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.",
                      J,
                    )),
                k.getInitialState &&
                  !k.getInitialState.isReactClassApproved &&
                  !k.state &&
                  s(
                    "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
                    J,
                  ),
                k.getDefaultProps &&
                  !k.getDefaultProps.isReactClassApproved &&
                  s(
                    "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
                    J,
                  ),
                k.propTypes &&
                  s(
                    "propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.",
                    J,
                  ),
                k.contextType &&
                  s(
                    "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
                    J,
                  ),
                k.contextTypes &&
                  s(
                    "contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.",
                    J,
                  ),
                a.contextType &&
                  a.contextTypes &&
                  !qD.has(a) &&
                  (qD.add(a),
                  s(
                    "%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.",
                    J,
                  )),
                typeof k.componentShouldUpdate == "function" &&
                  s(
                    "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
                    J,
                  ),
                a.prototype &&
                  a.prototype.isPureReactComponent &&
                  typeof k.shouldComponentUpdate < "u" &&
                  s(
                    "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
                    VA(a) || "A pure component",
                  ),
                typeof k.componentDidUnmount == "function" &&
                  s(
                    "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
                    J,
                  ),
                typeof k.componentDidReceiveProps == "function" &&
                  s(
                    "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
                    J,
                  ),
                typeof k.componentWillRecieveProps == "function" &&
                  s(
                    "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
                    J,
                  ),
                typeof k.UNSAFE_componentWillRecieveProps == "function" &&
                  s(
                    "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
                    J,
                  ))
              var W = k.props !== y
              ;(k.props !== void 0 &&
                W &&
                s(
                  "%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
                  J,
                  J,
                ),
                k.defaultProps &&
                  s(
                    "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
                    J,
                    J,
                  ),
                typeof k.getSnapshotBeforeUpdate == "function" &&
                  typeof k.componentDidUpdate != "function" &&
                  !jn.has(a) &&
                  (jn.add(a),
                  s(
                    "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
                    VA(a),
                  )),
                typeof k.getDerivedStateFromProps == "function" &&
                  s(
                    "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
                    J,
                  ),
                typeof k.getDerivedStateFromError == "function" &&
                  s(
                    "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
                    J,
                  ),
                typeof a.getSnapshotBeforeUpdate == "function" &&
                  s(
                    "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
                    J,
                  ))
              var BA = k.state
              ;(BA &&
                (typeof BA != "object" || _C(BA)) &&
                s("%s.state: must be set to an object or null", J),
                typeof k.getChildContext == "function" &&
                  typeof a.childContextTypes != "object" &&
                  s(
                    "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
                    J,
                  ))
            }
          }
          function uu(n, a) {
            ;((a.updater = $l), (n.stateNode = a), w(a, n), (a._reactInternalInstance = Xc))
          }
          function $c(n, a, y) {
            var k = !1,
              J = he,
              T = he,
              W = a.contextType
            if ("contextType" in a) {
              var BA =
                // Allow null for conditional declaration
                W === null || (W !== void 0 && W.$$typeof === AI && W._context === void 0)
              if (!BA && !HD.has(a)) {
                HD.add(a)
                var cA = ""
                ;(W === void 0
                  ? (cA =
                      " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.")
                  : typeof W != "object"
                    ? (cA = " However, it is set to a " + typeof W + ".")
                    : W.$$typeof === pI
                      ? (cA = " Did you accidentally pass the Context.Provider instead?")
                      : W._context !== void 0
                        ? (cA = " Did you accidentally pass the Context.Consumer instead?")
                        : (cA =
                            " However, it is set to an object with keys {" +
                            Object.keys(W).join(", ") +
                            "}."),
                  s(
                    "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
                    VA(a) || "Component",
                    cA,
                  ))
              }
            }
            if (typeof W == "object" && W !== null) T = Sg(W)
            else {
              J = Lt(n, a, !0)
              var RA = a.contextTypes
              ;((k = RA != null), (T = k ? Yn(n, J) : he))
            }
            var TA = new a(y, T)
            if (n.mode & qi) {
              Ie(!0)
              try {
                TA = new a(y, T)
              } finally {
                Ie(!1)
              }
            }
            var DI = (n.memoizedState = TA.state !== null && TA.state !== void 0 ? TA.state : null)
            uu(n, TA)
            {
              if (typeof a.getDerivedStateFromProps == "function" && DI === null) {
                var vI = VA(a) || "Component"
                LE.has(vI) ||
                  (LE.add(vI),
                  s(
                    "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
                    vI,
                    TA.state === null ? "null" : "undefined",
                    vI,
                  ))
              }
              if (
                typeof a.getDerivedStateFromProps == "function" ||
                typeof TA.getSnapshotBeforeUpdate == "function"
              ) {
                var bI = null,
                  og = null,
                  cg = null
                if (
                  (typeof TA.componentWillMount == "function" &&
                  TA.componentWillMount.__suppressDeprecationWarning !== !0
                    ? (bI = "componentWillMount")
                    : typeof TA.UNSAFE_componentWillMount == "function" &&
                      (bI = "UNSAFE_componentWillMount"),
                  typeof TA.componentWillReceiveProps == "function" &&
                  TA.componentWillReceiveProps.__suppressDeprecationWarning !== !0
                    ? (og = "componentWillReceiveProps")
                    : typeof TA.UNSAFE_componentWillReceiveProps == "function" &&
                      (og = "UNSAFE_componentWillReceiveProps"),
                  typeof TA.componentWillUpdate == "function" &&
                  TA.componentWillUpdate.__suppressDeprecationWarning !== !0
                    ? (cg = "componentWillUpdate")
                    : typeof TA.UNSAFE_componentWillUpdate == "function" &&
                      (cg = "UNSAFE_componentWillUpdate"),
                  bI !== null || og !== null || cg !== null)
                ) {
                  var cC = VA(a) || "Component",
                    re =
                      typeof a.getDerivedStateFromProps == "function"
                        ? "getDerivedStateFromProps()"
                        : "getSnapshotBeforeUpdate()"
                  $r.has(cC) ||
                    ($r.add(cC),
                    s(
                      `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`,
                      cC,
                      re,
                      bI !== null
                        ? `
  ` + bI
                        : "",
                      og !== null
                        ? `
  ` + og
                        : "",
                      cg !== null
                        ? `
  ` + cg
                        : "",
                    ))
                }
              }
            }
            return (k && ga(n, J, T), TA)
          }
          function Jp(n, a) {
            var y = a.state
            ;(typeof a.componentWillMount == "function" && a.componentWillMount(),
              typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(),
              y !== a.state &&
                (s(
                  "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
                  $I(n) || "Component",
                ),
                $l.enqueueReplaceState(a, a.state, null)))
          }
          function Ps(n, a, y, k) {
            var J = a.state
            if (
              (typeof a.componentWillReceiveProps == "function" &&
                a.componentWillReceiveProps(y, k),
              typeof a.UNSAFE_componentWillReceiveProps == "function" &&
                a.UNSAFE_componentWillReceiveProps(y, k),
              a.state !== J)
            ) {
              {
                var T = $I(n) || "Component"
                Ut.has(T) ||
                  (Ut.add(T),
                  s(
                    "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
                    T,
                  ))
              }
              $l.enqueueReplaceState(a, a.state, null)
            }
          }
          function Ic(n, a, y, k) {
            Ac(n, a, y)
            var J = n.stateNode
            ;((J.props = y), (J.state = n.memoizedState), (J.refs = Xl), Zg(n))
            var T = a.contextType
            if (typeof T == "object" && T !== null) J.context = Sg(T)
            else {
              var W = Lt(n, a, !0)
              J.context = Yn(n, W)
            }
            {
              if (J.state === y) {
                var BA = VA(a) || "Component"
                jB.has(BA) ||
                  (jB.add(BA),
                  s(
                    "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
                    BA,
                  ))
              }
              ;(n.mode & qi && fQ.recordLegacyContextWarning(n, J),
                fQ.recordUnsafeLifecycleWarnings(n, J))
            }
            J.state = n.memoizedState
            var cA = a.getDerivedStateFromProps
            if (
              (typeof cA == "function" && (UB(n, a, cA, y), (J.state = n.memoizedState)),
              typeof a.getDerivedStateFromProps != "function" &&
                typeof J.getSnapshotBeforeUpdate != "function" &&
                (typeof J.UNSAFE_componentWillMount == "function" ||
                  typeof J.componentWillMount == "function") &&
                (Jp(n, J), sr(n, y, J, k), (J.state = n.memoizedState)),
              typeof J.componentDidMount == "function")
            ) {
              var RA = iI
              ;((RA |= JC), (n.mode & sB) !== FC && (RA |= rA), (n.flags |= RA))
            }
          }
          function Du(n, a, y, k) {
            var J = n.stateNode,
              T = n.memoizedProps
            J.props = T
            var W = J.context,
              BA = a.contextType,
              cA = he
            if (typeof BA == "object" && BA !== null) cA = Sg(BA)
            else {
              var RA = Lt(n, a, !0)
              cA = Yn(n, RA)
            }
            var TA = a.getDerivedStateFromProps,
              DI = typeof TA == "function" || typeof J.getSnapshotBeforeUpdate == "function"
            ;(!DI &&
              (typeof J.UNSAFE_componentWillReceiveProps == "function" ||
                typeof J.componentWillReceiveProps == "function") &&
              (T !== y || W !== cA) &&
              Ps(n, J, y, cA),
              hu())
            var vI = n.memoizedState,
              bI = (J.state = vI)
            if ((sr(n, y, J, k), (bI = n.memoizedState), T === y && vI === bI && !kt() && !jc())) {
              if (typeof J.componentDidMount == "function") {
                var og = iI
                ;((og |= JC), (n.mode & sB) !== FC && (og |= rA), (n.flags |= og))
              }
              return !1
            }
            typeof TA == "function" && (UB(n, a, TA, y), (bI = n.memoizedState))
            var cg = jc() || xg(n, a, T, y, vI, bI, cA)
            if (cg) {
              if (
                (!DI &&
                  (typeof J.UNSAFE_componentWillMount == "function" ||
                    typeof J.componentWillMount == "function") &&
                  (typeof J.componentWillMount == "function" && J.componentWillMount(),
                  typeof J.UNSAFE_componentWillMount == "function" &&
                    J.UNSAFE_componentWillMount()),
                typeof J.componentDidMount == "function")
              ) {
                var cC = iI
                ;((cC |= JC), (n.mode & sB) !== FC && (cC |= rA), (n.flags |= cC))
              }
            } else {
              if (typeof J.componentDidMount == "function") {
                var re = iI
                ;((re |= JC), (n.mode & sB) !== FC && (re |= rA), (n.flags |= re))
              }
              ;((n.memoizedProps = y), (n.memoizedState = bI))
            }
            return ((J.props = y), (J.state = bI), (J.context = cA), cg)
          }
          function $f(n, a, y, k, J) {
            var T = a.stateNode
            WC(n, a)
            var W = a.memoizedProps,
              BA = a.type === a.elementType ? W : ue(a.type, W)
            T.props = BA
            var cA = a.pendingProps,
              RA = T.context,
              TA = y.contextType,
              DI = he
            if (typeof TA == "object" && TA !== null) DI = Sg(TA)
            else {
              var vI = Lt(a, y, !0)
              DI = Yn(a, vI)
            }
            var bI = y.getDerivedStateFromProps,
              og = typeof bI == "function" || typeof T.getSnapshotBeforeUpdate == "function"
            ;(!og &&
              (typeof T.UNSAFE_componentWillReceiveProps == "function" ||
                typeof T.componentWillReceiveProps == "function") &&
              (W !== cA || RA !== DI) &&
              Ps(a, T, k, DI),
              hu())
            var cg = a.memoizedState,
              cC = (T.state = cg)
            if (
              (sr(a, k, T, J),
              (cC = a.memoizedState),
              W === cA && cg === cC && !kt() && !jc() && !R)
            )
              return (
                typeof T.componentDidUpdate == "function" &&
                  (W !== n.memoizedProps || cg !== n.memoizedState) &&
                  (a.flags |= iI),
                typeof T.getSnapshotBeforeUpdate == "function" &&
                  (W !== n.memoizedProps || cg !== n.memoizedState) &&
                  (a.flags |= mC),
                !1
              )
            typeof bI == "function" && (UB(a, y, bI, k), (cC = a.memoizedState))
            var re =
              jc() ||
              xg(a, y, BA, k, cg, cC, DI) || // TODO: In some cases, we'll end up checking if context has changed twice,
              // both before and after `shouldComponentUpdate` has been called. Not ideal,
              // but I'm loath to refactor this function. This only happens for memoized
              // components so it's not that common.
              R
            return (
              re
                ? (!og &&
                    (typeof T.UNSAFE_componentWillUpdate == "function" ||
                      typeof T.componentWillUpdate == "function") &&
                    (typeof T.componentWillUpdate == "function" && T.componentWillUpdate(k, cC, DI),
                    typeof T.UNSAFE_componentWillUpdate == "function" &&
                      T.UNSAFE_componentWillUpdate(k, cC, DI)),
                  typeof T.componentDidUpdate == "function" && (a.flags |= iI),
                  typeof T.getSnapshotBeforeUpdate == "function" && (a.flags |= mC))
                : (typeof T.componentDidUpdate == "function" &&
                    (W !== n.memoizedProps || cg !== n.memoizedState) &&
                    (a.flags |= iI),
                  typeof T.getSnapshotBeforeUpdate == "function" &&
                    (W !== n.memoizedProps || cg !== n.memoizedState) &&
                    (a.flags |= mC),
                  (a.memoizedProps = k),
                  (a.memoizedState = cC)),
              (T.props = k),
              (T.state = cC),
              (T.context = DI),
              re
            )
          }
          var Is = [],
            Ws = 0,
            gs = null,
            lr = 0,
            me = [],
            Gi = 0,
            iB = null,
            vo = 1,
            Lo = ""
          function zB(n) {
            return (XB(), (n.flags & Tg) !== SA)
          }
          function Ad(n) {
            return (XB(), lr)
          }
          function ua() {
            var n = Lo,
              a = vo,
              y = a & ~TD(a)
            return y.toString(32) + n
          }
          function Vs(n, a) {
            ;(XB(), (Is[Ws++] = lr), (Is[Ws++] = gs), (gs = n), (lr = a))
          }
          function Su(n, a, y) {
            ;(XB(), (me[Gi++] = vo), (me[Gi++] = Lo), (me[Gi++] = iB), (iB = n))
            var k = vo,
              J = Lo,
              T = Ah(k) - 1,
              W = k & ~(1 << T),
              BA = y + 1,
              cA = Ah(a) + T
            if (cA > 30) {
              var RA = T - (T % 5),
                TA = (1 << RA) - 1,
                DI = (W & TA).toString(32),
                vI = W >> RA,
                bI = T - RA,
                og = Ah(a) + bI,
                cg = BA << bI,
                cC = cg | vI,
                re = DI + J
              ;((vo = (1 << og) | cC), (Lo = re))
            } else {
              var MC = BA << T,
                yt = MC | W,
                Qt = J
              ;((vo = (1 << cA) | yt), (Lo = Qt))
            }
          }
          function Cs(n) {
            XB()
            var a = n.return
            if (a !== null) {
              var y = 1,
                k = 0
              ;(Vs(n, y), Su(n, y, k))
            }
          }
          function Ah(n) {
            return 32 - _r(n)
          }
          function TD(n) {
            return 1 << (Ah(n) - 1)
          }
          function xD(n) {
            for (; n === gs; ) ((gs = Is[--Ws]), (Is[Ws] = null), (lr = Is[--Ws]), (Is[Ws] = null))
            for (; n === iB; )
              ((iB = me[--Gi]),
                (me[Gi] = null),
                (Lo = me[--Gi]),
                (me[Gi] = null),
                (vo = me[--Gi]),
                (me[Gi] = null))
          }
          function js() {
            return (
              XB(),
              iB !== null
                ? {
                    id: vo,
                    overflow: Lo,
                  }
                : null
            )
          }
          function fu(n, a) {
            ;(XB(),
              (me[Gi++] = vo),
              (me[Gi++] = Lo),
              (me[Gi++] = iB),
              (vo = a.id),
              (Lo = a.overflow),
              (iB = n))
          }
          function XB() {
            St() || s("Expected to be hydrating. This is a bug in React. Please file an issue.")
          }
          var fC = null,
            Oe = null,
            ve = !1,
            Ct = !1,
            tB = null
          function gc() {
            ve && s("We should not be hydrating here. This is a bug in React. Please file a bug.")
          }
          function NB() {
            Ct = !0
          }
          function Ih(n) {
            if (!Ui) return !1
            var a = n.stateNode.containerInfo
            return ((Oe = So(a)), (fC = n), (ve = !0), (tB = null), (Ct = !1), !0)
          }
          function zs(n, a, y) {
            return Ui
              ? ((Oe = xr(a)),
                (fC = n),
                (ve = !0),
                (tB = null),
                (Ct = !1),
                y !== null && fu(n, y),
                !0)
              : !1
          }
          function Xs(n, a) {
            switch (n.tag) {
              case _:
                $E(n.stateNode.containerInfo, a)
                break
              case CA:
                Yl(n.type, n.memoizedProps, n.stateNode, a)
                break
              case sA:
                var y = n.memoizedState
                y.dehydrated !== null && yo(y.dehydrated, a)
                break
            }
          }
          function du(n, a) {
            Xs(n, a)
            var y = zk()
            ;((y.stateNode = a), (y.return = n))
            var k = n.deletions
            k === null ? ((n.deletions = [y]), (n.flags |= qI)) : k.push(y)
          }
          function Da(n, a) {
            {
              if (Ct) return
              switch (n.tag) {
                case _: {
                  var y = n.stateNode.containerInfo
                  switch (a.tag) {
                    case CA:
                      var k = a.type,
                        J = a.pendingProps
                      mQ(y, k, J)
                      break
                    case aA:
                      var T = a.pendingProps
                      oQ(y, T)
                      break
                    case sA:
                      fE(y)
                      break
                  }
                  break
                }
                case CA: {
                  var W = n.type,
                    BA = n.memoizedProps,
                    cA = n.stateNode
                  switch (a.tag) {
                    case CA:
                      var RA = a.type,
                        TA = a.pendingProps
                      nQ(W, BA, cA, RA, TA)
                      break
                    case aA:
                      var DI = a.pendingProps
                      Cn(W, BA, cA, DI)
                      break
                    case sA:
                      at(W, BA, cA)
                      break
                  }
                  break
                }
                case sA: {
                  var vI = n.memoizedState,
                    bI = vI.dehydrated
                  if (bI !== null)
                    switch (a.tag) {
                      case CA:
                        var og = a.type,
                          cg = a.pendingProps
                        dE(bI, og, cg)
                        break
                      case aA:
                        var cC = a.pendingProps
                        po(bI, cC)
                        break
                      case sA:
                        Aa(bI)
                        break
                    }
                  break
                }
                default:
                  return
              }
            }
          }
          function dQ(n, a) {
            ;((a.flags = (a.flags & ~Ee) | HA), Da(n, a))
          }
          function gh(n, a) {
            switch (n.tag) {
              case CA: {
                var y = n.type,
                  k = n.pendingProps,
                  J = NC(a, y, k)
                return J !== null ? ((n.stateNode = J), (fC = n), (Oe = KQ(J)), !0) : !1
              }
              case aA: {
                var T = n.pendingProps,
                  W = KC(a, T)
                return W !== null ? ((n.stateNode = W), (fC = n), (Oe = null), !0) : !1
              }
              case sA: {
                {
                  var BA = GC(a)
                  if (BA !== null) {
                    var cA = {
                      dehydrated: BA,
                      treeContext: js(),
                      retryLane: Re,
                    }
                    n.memoizedState = cA
                    var RA = Xk(BA)
                    return ((RA.return = n), (n.child = RA), (fC = n), (Oe = null), !0)
                  }
                }
                return !1
              }
              default:
                return !1
            }
          }
          function es(n) {
            return (n.mode & Ai) !== FC && (n.flags & Qg) === SA
          }
          function YE(n) {
            throw new Error(
              "Hydration failed because the initial UI does not match what was rendered on the server.",
            )
          }
          function Cc(n) {
            if (ve) {
              var a = Oe
              if (!a) {
                ;(es(n) && (Da(fC, n), YE()), dQ(fC, n), (ve = !1), (fC = n))
                return
              }
              var y = a
              if (!gh(n, a)) {
                ;(es(n) && (Da(fC, n), YE()), (a = Io(y)))
                var k = fC
                if (!a || !gh(n, a)) {
                  ;(dQ(fC, n), (ve = !1), (fC = n))
                  return
                }
                du(k, y)
              }
            }
          }
          function bD(n, a, y) {
            if (!Ui)
              throw new Error(
                "Expected prepareToHydrateHostInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.",
              )
            var k = n.stateNode,
              J = !Ct,
              T = fo(k, n.type, n.memoizedProps, a, y, n, J)
            return ((n.updateQueue = T), T !== null)
          }
          function zn(n) {
            if (!Ui)
              throw new Error(
                "Expected prepareToHydrateHostTextInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.",
              )
            var a = n.stateNode,
              y = n.memoizedProps,
              k = !Ct,
              J = XE(a, y, n, k)
            if (J) {
              var T = fC
              if (T !== null) {
                var W = (T.mode & Ai) !== FC
                switch (T.tag) {
                  case _: {
                    var BA = T.stateNode.containerInfo
                    Ll(
                      BA,
                      a,
                      y,
                      // TODO: Delete this argument when we remove the legacy root API.
                      W,
                    )
                    break
                  }
                  case CA: {
                    var cA = T.type,
                      RA = T.memoizedProps,
                      TA = T.stateNode
                    Ta(
                      cA,
                      RA,
                      TA,
                      a,
                      y,
                      // TODO: Delete this argument when we remove the legacy root API.
                      W,
                    )
                    break
                  }
                }
              }
            }
            return J
          }
          function ec(n) {
            if (!Ui)
              throw new Error(
                "Expected prepareToHydrateHostSuspenseInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.",
              )
            var a = n.memoizedState,
              y = a !== null ? a.dehydrated : null
            if (!y)
              throw new Error(
                "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.",
              )
            br(y, n)
          }
          function Xn(n) {
            if (!Ui)
              throw new Error(
                "Expected skipPastDehydratedSuspenseInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.",
              )
            var a = n.memoizedState,
              y = a !== null ? a.dehydrated : null
            if (!y)
              throw new Error(
                "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.",
              )
            return Rl(y)
          }
          function Ch(n) {
            for (var a = n.return; a !== null && a.tag !== CA && a.tag !== _ && a.tag !== sA; )
              a = a.return
            fC = a
          }
          function cr(n) {
            if (!Ui || n !== fC) return !1
            if (!ve) return (Ch(n), (ve = !0), !1)
            if (n.tag !== _ && (n.tag !== CA || (Pc(n.type) && !Et(n.type, n.memoizedProps)))) {
              var a = Oe
              if (a)
                if (es(n)) (ic(n), YE())
                else for (; a; ) (du(n, a), (a = Io(a)))
            }
            return (Ch(n), n.tag === sA ? (Oe = Xn(n)) : (Oe = fC ? Io(n.stateNode) : null), !0)
          }
          function yu() {
            return ve && Oe !== null
          }
          function ic(n) {
            for (var a = Oe; a; ) (Xs(n, a), (a = Io(a)))
          }
          function $n() {
            Ui && ((fC = null), (Oe = null), (ve = !1), (Ct = !1))
          }
          function FB() {
            tB !== null && (Mw(tB), (tB = null))
          }
          function St() {
            return ve
          }
          function et(n) {
            tB === null ? (tB = [n]) : tB.push(n)
          }
          var BB,
            tc,
            hr,
            eh,
            ih,
            qE = function (n, a) {}
          ;((BB = !1),
            (tc = !1),
            (hr = {}),
            (eh = {}),
            (ih = {}),
            (qE = function (n, a) {
              if (
                !(n === null || typeof n != "object") &&
                !(!n._store || n._store.validated || n.key != null)
              ) {
                if (typeof n._store != "object")
                  throw new Error(
                    "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.",
                  )
                n._store.validated = !0
                var y = $I(a) || "Component"
                eh[y] ||
                  ((eh[y] = !0),
                  s(
                    'Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.',
                  ))
              }
            }))
          function Sa(n, a, y) {
            var k = y.ref
            if (k !== null && typeof k != "function" && typeof k != "object") {
              if (
                (n.mode & qi || Y) && // We warn in ReactElement.js if owner and self are equal for string refs
                // because these cannot be automatically converted to an arrow function
                // using a codemod. Therefore, we don't have to warn about string refs again.
                !(y._owner && y._self && y._owner.stateNode !== y._self)
              ) {
                var J = $I(n) || "Component"
                hr[J] ||
                  (s(
                    'A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref',
                    k,
                  ),
                  (hr[J] = !0))
              }
              if (y._owner) {
                var T = y._owner,
                  W
                if (T) {
                  var BA = T
                  if (BA.tag !== AA)
                    throw new Error(
                      "Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref",
                    )
                  W = BA.stateNode
                }
                if (!W)
                  throw new Error(
                    "Missing owner for string ref " +
                      k +
                      ". This error is likely caused by a bug in React. Please file an issue.",
                  )
                var cA = W
                lu(k, "ref")
                var RA = "" + k
                if (
                  a !== null &&
                  a.ref !== null &&
                  typeof a.ref == "function" &&
                  a.ref._stringRef === RA
                )
                  return a.ref
                var TA = function (DI) {
                  var vI = cA.refs
                  ;(vI === Xl && (vI = cA.refs = {}), DI === null ? delete vI[RA] : (vI[RA] = DI))
                }
                return ((TA._stringRef = RA), TA)
              } else {
                if (typeof k != "string")
                  throw new Error(
                    "Expected ref to be a function, a string, an object returned by React.createRef(), or null.",
                  )
                if (!y._owner)
                  throw new Error(
                    "Element ref was specified as a string (" +
                      k +
                      `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`,
                  )
              }
            }
            return k
          }
          function Bc(n, a) {
            var y = Object.prototype.toString.call(a)
            throw new Error(
              "Objects are not valid as a React child (found: " +
                (y === "[object Object]"
                  ? "object with keys {" + Object.keys(a).join(", ") + "}"
                  : y) +
                "). If you meant to render a collection of children, use an array instead.",
            )
          }
          function un(n) {
            {
              var a = $I(n) || "Component"
              if (ih[a]) return
              ;((ih[a] = !0),
                s(
                  "Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.",
                ))
            }
          }
          function th(n) {
            var a = n._payload,
              y = n._init
            return y(a)
          }
          function is(n) {
            function a(MI, PI) {
              if (n) {
                var uI = MI.deletions
                uI === null ? ((MI.deletions = [PI]), (MI.flags |= qI)) : uI.push(PI)
              }
            }
            function y(MI, PI) {
              if (!n) return null
              for (var uI = PI; uI !== null; ) (a(MI, uI), (uI = uI.sibling))
              return null
            }
            function k(MI, PI) {
              for (var uI = /* @__PURE__ */ new Map(), ug = PI; ug !== null; )
                (ug.key !== null ? uI.set(ug.key, ug) : uI.set(ug.index, ug), (ug = ug.sibling))
              return uI
            }
            function J(MI, PI) {
              var uI = Kc(MI, PI)
              return ((uI.index = 0), (uI.sibling = null), uI)
            }
            function T(MI, PI, uI) {
              if (((MI.index = uI), !n)) return ((MI.flags |= Tg), PI)
              var ug = MI.alternate
              if (ug !== null) {
                var Og = ug.index
                return Og < PI ? ((MI.flags |= HA), PI) : Og
              } else return ((MI.flags |= HA), PI)
            }
            function W(MI) {
              return (n && MI.alternate === null && (MI.flags |= HA), MI)
            }
            function BA(MI, PI, uI, ug) {
              if (PI === null || PI.tag !== aA) {
                var Og = ey(uI, MI.mode, ug)
                return ((Og.return = MI), Og)
              } else {
                var qg = J(PI, uI)
                return ((qg.return = MI), qg)
              }
            }
            function cA(MI, PI, uI, ug) {
              var Og = uI.type
              if (Og === uA) return TA(MI, PI, uI.props.children, ug, uI.key)
              if (
                PI !== null &&
                (PI.elementType === Og || // Keep this check inline so it only runs on the false path:
                  jI(PI, uI) || // Lazy types should reconcile their resolved type.
                  // We need to do this after the Hot Reloading check above,
                  // because hot reloading has different semantics than prod because
                  // it doesn't resuspend. So we can't let the call below suspend.
                  (typeof Og == "object" &&
                    Og !== null &&
                    Og.$$typeof === FA &&
                    th(Og) === PI.type))
              ) {
                var qg = J(PI, uI.props)
                return (
                  (qg.ref = Sa(MI, PI, uI)),
                  (qg.return = MI),
                  (qg._debugSource = uI._source),
                  (qg._debugOwner = uI._owner),
                  qg
                )
              }
              var Ge = bS(uI, MI.mode, ug)
              return ((Ge.ref = Sa(MI, PI, uI)), (Ge.return = MI), Ge)
            }
            function RA(MI, PI, uI, ug) {
              if (
                PI === null ||
                PI.tag !== eA ||
                PI.stateNode.containerInfo !== uI.containerInfo ||
                PI.stateNode.implementation !== uI.implementation
              ) {
                var Og = iy(uI, MI.mode, ug)
                return ((Og.return = MI), Og)
              } else {
                var qg = J(PI, uI.children || [])
                return ((qg.return = MI), qg)
              }
            }
            function TA(MI, PI, uI, ug, Og) {
              if (PI === null || PI.tag !== lA) {
                var qg = Yh(uI, MI.mode, ug, Og)
                return ((qg.return = MI), qg)
              } else {
                var Ge = J(PI, uI)
                return ((Ge.return = MI), Ge)
              }
            }
            function DI(MI, PI, uI) {
              if ((typeof PI == "string" && PI !== "") || typeof PI == "number") {
                var ug = ey("" + PI, MI.mode, uI)
                return ((ug.return = MI), ug)
              }
              if (typeof PI == "object" && PI !== null) {
                switch (PI.$$typeof) {
                  case YA: {
                    var Og = bS(PI, MI.mode, uI)
                    return ((Og.ref = Sa(MI, null, PI)), (Og.return = MI), Og)
                  }
                  case eI: {
                    var qg = iy(PI, MI.mode, uI)
                    return ((qg.return = MI), qg)
                  }
                  case FA: {
                    var Ge = PI._payload,
                      De = PI._init
                    return DI(MI, De(Ge), uI)
                  }
                }
                if (_C(PI) || OA(PI)) {
                  var _i = Yh(PI, MI.mode, uI, null)
                  return ((_i.return = MI), _i)
                }
                Bc(MI, PI)
              }
              return (typeof PI == "function" && un(MI), null)
            }
            function vI(MI, PI, uI, ug) {
              var Og = PI !== null ? PI.key : null
              if ((typeof uI == "string" && uI !== "") || typeof uI == "number")
                return Og !== null ? null : BA(MI, PI, "" + uI, ug)
              if (typeof uI == "object" && uI !== null) {
                switch (uI.$$typeof) {
                  case YA:
                    return uI.key === Og ? cA(MI, PI, uI, ug) : null
                  case eI:
                    return uI.key === Og ? RA(MI, PI, uI, ug) : null
                  case FA: {
                    var qg = uI._payload,
                      Ge = uI._init
                    return vI(MI, PI, Ge(qg), ug)
                  }
                }
                if (_C(uI) || OA(uI)) return Og !== null ? null : TA(MI, PI, uI, ug, null)
                Bc(MI, uI)
              }
              return (typeof uI == "function" && un(MI), null)
            }
            function bI(MI, PI, uI, ug, Og) {
              if ((typeof ug == "string" && ug !== "") || typeof ug == "number") {
                var qg = MI.get(uI) || null
                return BA(PI, qg, "" + ug, Og)
              }
              if (typeof ug == "object" && ug !== null) {
                switch (ug.$$typeof) {
                  case YA: {
                    var Ge = MI.get(ug.key === null ? uI : ug.key) || null
                    return cA(PI, Ge, ug, Og)
                  }
                  case eI: {
                    var De = MI.get(ug.key === null ? uI : ug.key) || null
                    return RA(PI, De, ug, Og)
                  }
                  case FA: {
                    var _i = ug._payload,
                      oi = ug._init
                    return bI(MI, PI, uI, oi(_i), Og)
                  }
                }
                if (_C(ug) || OA(ug)) {
                  var Jt = MI.get(uI) || null
                  return TA(PI, Jt, ug, Og, null)
                }
                Bc(PI, ug)
              }
              return (typeof ug == "function" && un(PI), null)
            }
            function og(MI, PI, uI) {
              {
                if (typeof MI != "object" || MI === null) return PI
                switch (MI.$$typeof) {
                  case YA:
                  case eI:
                    qE(MI, uI)
                    var ug = MI.key
                    if (typeof ug != "string") break
                    if (PI === null) {
                      ;((PI = /* @__PURE__ */ new Set()), PI.add(ug))
                      break
                    }
                    if (!PI.has(ug)) {
                      PI.add(ug)
                      break
                    }
                    s(
                      "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",
                      ug,
                    )
                    break
                  case FA: {
                    var Og = MI._payload,
                      qg = MI._init
                    og(qg(Og), PI, uI)
                    break
                  }
                }
              }
              return PI
            }
            function cg(MI, PI, uI, ug) {
              for (var Og = null, qg = 0; qg < uI.length; qg++) {
                var Ge = uI[qg]
                Og = og(Ge, Og, MI)
              }
              for (
                var De = null, _i = null, oi = PI, Jt = 0, Ze = 0, Se = null;
                oi !== null && Ze < uI.length;
                Ze++
              ) {
                oi.index > Ze ? ((Se = oi), (oi = null)) : (Se = oi.sibling)
                var oB = vI(MI, oi, uI[Ze], ug)
                if (oB === null) {
                  oi === null && (oi = Se)
                  break
                }
                ;(n && oi && oB.alternate === null && a(MI, oi),
                  (Jt = T(oB, Jt, Ze)),
                  _i === null ? (De = oB) : (_i.sibling = oB),
                  (_i = oB),
                  (oi = Se))
              }
              if (Ze === uI.length) {
                if ((y(MI, oi), St())) {
                  var Zt = Ze
                  Vs(MI, Zt)
                }
                return De
              }
              if (oi === null) {
                for (; Ze < uI.length; Ze++) {
                  var yn = DI(MI, uI[Ze], ug)
                  yn !== null &&
                    ((Jt = T(yn, Jt, Ze)), _i === null ? (De = yn) : (_i.sibling = yn), (_i = yn))
                }
                if (St()) {
                  var kQ = Ze
                  Vs(MI, kQ)
                }
                return De
              }
              for (var pn = k(MI, oi); Ze < uI.length; Ze++) {
                var wn = bI(pn, MI, Ze, uI[Ze], ug)
                wn !== null &&
                  (n && wn.alternate !== null && pn.delete(wn.key === null ? Ze : wn.key),
                  (Jt = T(wn, Jt, Ze)),
                  _i === null ? (De = wn) : (_i.sibling = wn),
                  (_i = wn))
              }
              if (
                (n &&
                  pn.forEach(function (Hh) {
                    return a(MI, Hh)
                  }),
                St())
              ) {
                var BE = Ze
                Vs(MI, BE)
              }
              return De
            }
            function cC(MI, PI, uI, ug) {
              var Og = OA(uI)
              if (typeof Og != "function")
                throw new Error(
                  "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.",
                )
              {
                ;(typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
                  uI[Symbol.toStringTag] === "Generator" &&
                  (tc ||
                    s(
                      "Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.",
                    ),
                  (tc = !0)),
                  uI.entries === Og &&
                    (BB ||
                      s(
                        "Using Maps as children is not supported. Use an array of keyed ReactElements instead.",
                      ),
                    (BB = !0)))
                var qg = Og.call(uI)
                if (qg)
                  for (var Ge = null, De = qg.next(); !De.done; De = qg.next()) {
                    var _i = De.value
                    Ge = og(_i, Ge, MI)
                  }
              }
              var oi = Og.call(uI)
              if (oi == null) throw new Error("An iterable object provided no iterator.")
              for (
                var Jt = null, Ze = null, Se = PI, oB = 0, Zt = 0, yn = null, kQ = oi.next();
                Se !== null && !kQ.done;
                Zt++, kQ = oi.next()
              ) {
                Se.index > Zt ? ((yn = Se), (Se = null)) : (yn = Se.sibling)
                var pn = vI(MI, Se, kQ.value, ug)
                if (pn === null) {
                  Se === null && (Se = yn)
                  break
                }
                ;(n && Se && pn.alternate === null && a(MI, Se),
                  (oB = T(pn, oB, Zt)),
                  Ze === null ? (Jt = pn) : (Ze.sibling = pn),
                  (Ze = pn),
                  (Se = yn))
              }
              if (kQ.done) {
                if ((y(MI, Se), St())) {
                  var wn = Zt
                  Vs(MI, wn)
                }
                return Jt
              }
              if (Se === null) {
                for (; !kQ.done; Zt++, kQ = oi.next()) {
                  var BE = DI(MI, kQ.value, ug)
                  BE !== null &&
                    ((oB = T(BE, oB, Zt)), Ze === null ? (Jt = BE) : (Ze.sibling = BE), (Ze = BE))
                }
                if (St()) {
                  var Hh = Zt
                  Vs(MI, Hh)
                }
                return Jt
              }
              for (var mc = k(MI, Se); !kQ.done; Zt++, kQ = oi.next()) {
                var Gn = bI(mc, MI, Zt, kQ.value, ug)
                Gn !== null &&
                  (n && Gn.alternate !== null && mc.delete(Gn.key === null ? Zt : Gn.key),
                  (oB = T(Gn, oB, Zt)),
                  Ze === null ? (Jt = Gn) : (Ze.sibling = Gn),
                  (Ze = Gn))
              }
              if (
                (n &&
                  mc.forEach(function (I0) {
                    return a(MI, I0)
                  }),
                St())
              ) {
                var vc = Zt
                Vs(MI, vc)
              }
              return Jt
            }
            function re(MI, PI, uI, ug) {
              if (PI !== null && PI.tag === aA) {
                y(MI, PI.sibling)
                var Og = J(PI, uI)
                return ((Og.return = MI), Og)
              }
              y(MI, PI)
              var qg = ey(uI, MI.mode, ug)
              return ((qg.return = MI), qg)
            }
            function MC(MI, PI, uI, ug) {
              for (var Og = uI.key, qg = PI; qg !== null; ) {
                if (qg.key === Og) {
                  var Ge = uI.type
                  if (Ge === uA) {
                    if (qg.tag === lA) {
                      y(MI, qg.sibling)
                      var De = J(qg, uI.props.children)
                      return (
                        (De.return = MI),
                        (De._debugSource = uI._source),
                        (De._debugOwner = uI._owner),
                        De
                      )
                    }
                  } else if (
                    qg.elementType === Ge || // Keep this check inline so it only runs on the false path:
                    jI(qg, uI) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    (typeof Ge == "object" &&
                      Ge !== null &&
                      Ge.$$typeof === FA &&
                      th(Ge) === qg.type)
                  ) {
                    y(MI, qg.sibling)
                    var _i = J(qg, uI.props)
                    return (
                      (_i.ref = Sa(MI, qg, uI)),
                      (_i.return = MI),
                      (_i._debugSource = uI._source),
                      (_i._debugOwner = uI._owner),
                      _i
                    )
                  }
                  y(MI, qg)
                  break
                } else a(MI, qg)
                qg = qg.sibling
              }
              if (uI.type === uA) {
                var oi = Yh(uI.props.children, MI.mode, ug, uI.key)
                return ((oi.return = MI), oi)
              } else {
                var Jt = bS(uI, MI.mode, ug)
                return ((Jt.ref = Sa(MI, PI, uI)), (Jt.return = MI), Jt)
              }
            }
            function yt(MI, PI, uI, ug) {
              for (var Og = uI.key, qg = PI; qg !== null; ) {
                if (qg.key === Og)
                  if (
                    qg.tag === eA &&
                    qg.stateNode.containerInfo === uI.containerInfo &&
                    qg.stateNode.implementation === uI.implementation
                  ) {
                    y(MI, qg.sibling)
                    var Ge = J(qg, uI.children || [])
                    return ((Ge.return = MI), Ge)
                  } else {
                    y(MI, qg)
                    break
                  }
                else a(MI, qg)
                qg = qg.sibling
              }
              var De = iy(uI, MI.mode, ug)
              return ((De.return = MI), De)
            }
            function Qt(MI, PI, uI, ug) {
              var Og = typeof uI == "object" && uI !== null && uI.type === uA && uI.key === null
              if ((Og && (uI = uI.props.children), typeof uI == "object" && uI !== null)) {
                switch (uI.$$typeof) {
                  case YA:
                    return W(MC(MI, PI, uI, ug))
                  case eI:
                    return W(yt(MI, PI, uI, ug))
                  case FA: {
                    var qg = uI._payload,
                      Ge = uI._init
                    return Qt(MI, PI, Ge(qg), ug)
                  }
                }
                if (_C(uI)) return cg(MI, PI, uI, ug)
                if (OA(uI)) return cC(MI, PI, uI, ug)
                Bc(MI, uI)
              }
              return (typeof uI == "string" && uI !== "") || typeof uI == "number"
                ? W(re(MI, PI, "" + uI, ug))
                : (typeof uI == "function" && un(MI), y(MI, PI))
            }
            return Qt
          }
          var $s = is(!0),
            OD = is(!1)
          function Bh(n, a) {
            if (n !== null && a.child !== n.child)
              throw new Error("Resuming work not yet implemented.")
            if (a.child !== null) {
              var y = a.child,
                k = Kc(y, y.pendingProps)
              for (a.child = k, k.return = a; y.sibling !== null; )
                ((y = y.sibling), (k = k.sibling = Kc(y, y.pendingProps)), (k.return = a))
              k.sibling = null
            }
          }
          function pu(n, a) {
            for (var y = n.child; y !== null; ) (qw(y, a), (y = y.sibling))
          }
          var Qh = {},
            ts = vQ(Qh),
            Qc = vQ(Qh),
            oh = vQ(Qh)
          function HE(n) {
            if (n === Qh)
              throw new Error(
                "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.",
              )
            return n
          }
          function _D() {
            var n = HE(oh.current)
            return n
          }
          function Bs(n, a) {
            ;(ti(oh, a, n), ti(Qc, n, n), ti(ts, Qh, n))
            var y = ii(a)
            ;(vt(ts, n), ti(ts, y, n))
          }
          function Al(n) {
            ;(vt(ts, n), vt(Qc, n), vt(oh, n))
          }
          function Pi() {
            var n = HE(ts.current)
            return n
          }
          function Id(n) {
            var a = HE(oh.current),
              y = HE(ts.current),
              k = qe(y, n.type, a)
            y !== k && (ti(Qc, n, n), ti(ts, k, n))
          }
          function wu(n) {
            Qc.current === n && (vt(ts, n), vt(Qc, n))
          }
          var ZD = 0,
            gd = 1,
            PD = 1,
            oc = 2,
            AE = vQ(ZD)
          function Yo(n, a) {
            return (n & a) !== 0
          }
          function Qs(n) {
            return n & gd
          }
          function WD(n, a) {
            return (n & gd) | a
          }
          function os(n, a) {
            return n | a
          }
          function TE(n, a) {
            ti(AE, a, n)
          }
          function IE(n) {
            vt(AE, n)
          }
          function Gu(n, a) {
            var y = n.memoizedState
            return y !== null ? y.dehydrated !== null : (n.memoizedProps, !0)
          }
          function Il(n) {
            for (var a = n; a !== null; ) {
              if (a.tag === sA) {
                var y = a.memoizedState
                if (y !== null) {
                  var k = y.dehydrated
                  if (k === null || ie(k) || we(k)) return a
                }
              } else if (
                a.tag === kA && // revealOrder undefined can't be trusted because it don't
                // keep track of whether it suspended or not.
                a.memoizedProps.revealOrder !== void 0
              ) {
                var J = (a.flags & Qg) !== SA
                if (J) return a
              } else if (a.child !== null) {
                ;((a.child.return = a), (a = a.child))
                continue
              }
              if (a === n) return null
              for (; a.sibling === null; ) {
                if (a.return === null || a.return === n) return null
                a = a.return
              }
              ;((a.sibling.return = a.return), (a = a.sibling))
            }
            return null
          }
          var qo =
              /*   */
              0,
            Oi =
              /* */
              1,
            fa =
              /*  */
              2,
            Ot =
              /*    */
              4,
            RB =
              /*   */
              8,
            nh = []
          function nc() {
            for (var n = 0; n < nh.length; n++) {
              var a = nh[n]
              dB
                ? (a._workInProgressVersionPrimary = null)
                : (a._workInProgressVersionSecondary = null)
            }
            nh.length = 0
          }
          function Eh(n, a) {
            var y = a._getVersion,
              k = y(a._source)
            n.mutableSourceEagerHydrationData == null
              ? (n.mutableSourceEagerHydrationData = [a, k])
              : n.mutableSourceEagerHydrationData.push(a, k)
          }
          var Kg = i.ReactCurrentDispatcher,
            bQ = i.ReactCurrentBatchConfig,
            VD,
            ns
          VD = /* @__PURE__ */ new Set()
          var ur = Cg,
            Ii = null,
            Nt = null,
            _t = null,
            ah = !1,
            rh = !1,
            Es = 0,
            Kp = 0,
            sh = 25,
            VI = null,
            Qo = null,
            E = -1,
            l = !1
          function p() {
            {
              var n = VI
              Qo === null ? (Qo = [n]) : Qo.push(n)
            }
          }
          function U() {
            {
              var n = VI
              Qo !== null && (E++, Qo[E] !== n && Z(n))
            }
          }
          function q(n) {
            n != null &&
              !_C(n) &&
              s(
                "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
                VI,
                typeof n,
              )
          }
          function Z(n) {
            {
              var a = $I(Ii)
              if (!VD.has(a) && (VD.add(a), Qo !== null)) {
                for (var y = "", k = 30, J = 0; J <= E; J++) {
                  for (var T = Qo[J], W = J === E ? n : T, BA = J + 1 + ". " + T; BA.length < k; )
                    BA += " "
                  ;((BA +=
                    W +
                    `
`),
                    (y += BA))
                }
                s(
                  `React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`,
                  a,
                  y,
                )
              }
            }
          }
          function oA() {
            throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`)
          }
          function KA(n, a) {
            if (l) return !1
            if (a === null)
              return (
                s(
                  "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
                  VI,
                ),
                !1
              )
            n.length !== a.length &&
              s(
                `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
                VI,
                "[" + a.join(", ") + "]",
                "[" + n.join(", ") + "]",
              )
            for (var y = 0; y < a.length && y < n.length; y++) if (!ci(n[y], a[y])) return !1
            return !0
          }
          function bA(n, a, y, k, J, T) {
            ;((ur = T),
              (Ii = a),
              (Qo = n !== null ? n._debugHookTypes : null),
              (E = -1),
              (l = n !== null && n.type !== a.type),
              (a.memoizedState = null),
              (a.updateQueue = null),
              (a.lanes = Cg),
              n !== null && n.memoizedState !== null
                ? (Kg.current = ft)
                : Qo !== null
                  ? (Kg.current = jG)
                  : (Kg.current = xp))
            var W = y(k, J)
            if (rh) {
              var BA = 0
              do {
                if (((rh = !1), (Es = 0), BA >= sh))
                  throw new Error(
                    "Too many re-renders. React limits the number of renders to prevent an infinite loop.",
                  )
                ;((BA += 1),
                  (l = !1),
                  (Nt = null),
                  (_t = null),
                  (a.updateQueue = null),
                  (E = -1),
                  (Kg.current = cd),
                  (W = y(k, J)))
              } while (rh)
            }
            ;((Kg.current = ld), (a._debugHookTypes = Qo))
            var cA = Nt !== null && Nt.next !== null
            if (
              ((ur = Cg),
              (Ii = null),
              (Nt = null),
              (_t = null),
              (VI = null),
              (Qo = null),
              (E = -1),
              n !== null &&
                (n.flags & EI) !== (a.flags & EI) && // Disable this warning in legacy mode, because legacy Suspense is weird
                // and creates false positives. To make this work in legacy mode, we'd
                // need to mark fibers that commit in an incomplete state, somehow. For
                // now I'll disable the warning that most of the bugs that would trigger
                // it are either exclusive to concurrent mode or exist in both.
                (n.mode & Ai) !== FC &&
                s(
                  "Internal React error: Expected static flag was missing. Please notify the React team.",
                ),
              (ah = !1),
              cA)
            )
              throw new Error(
                "Rendered fewer hooks than expected. This may be caused by an accidental early return statement.",
              )
            return W
          }
          function kI() {
            var n = Es !== 0
            return ((Es = 0), n)
          }
          function tg(n, a, y) {
            ;((a.updateQueue = n.updateQueue),
              (a.mode & sB) !== FC ? (a.flags &= ~(_A | rA | zC | iI)) : (a.flags &= ~(zC | iI)),
              (n.lanes = Yt(n.lanes, y)))
          }
          function Eg() {
            if (((Kg.current = ld), ah)) {
              for (var n = Ii.memoizedState; n !== null; ) {
                var a = n.queue
                ;(a !== null && (a.pending = null), (n = n.next))
              }
              ah = !1
            }
            ;((ur = Cg),
              (Ii = null),
              (Nt = null),
              (_t = null),
              (Qo = null),
              (E = -1),
              (VI = null),
              (Hp = !1),
              (rh = !1),
              (Es = 0))
          }
          function Ig() {
            var n = {
              memoizedState: null,
              baseState: null,
              baseQueue: null,
              queue: null,
              next: null,
            }
            return (_t === null ? (Ii.memoizedState = _t = n) : (_t = _t.next = n), _t)
          }
          function Ug() {
            var n
            if (Nt === null) {
              var a = Ii.alternate
              a !== null ? (n = a.memoizedState) : (n = null)
            } else n = Nt.next
            var y
            if ((_t === null ? (y = Ii.memoizedState) : (y = _t.next), y !== null))
              ((_t = y), (y = _t.next), (Nt = n))
            else {
              if (n === null)
                throw new Error("Rendered more hooks than during the previous render.")
              Nt = n
              var k = {
                memoizedState: Nt.memoizedState,
                baseState: Nt.baseState,
                baseQueue: Nt.baseQueue,
                queue: Nt.queue,
                next: null,
              }
              _t === null ? (Ii.memoizedState = _t = k) : (_t = _t.next = k)
            }
            return _t
          }
          function Wg() {
            return {
              lastEffect: null,
              stores: null,
            }
          }
          function Xg(n, a) {
            return typeof a == "function" ? a(n) : a
          }
          function Ft(n, a, y) {
            var k = Ig(),
              J
            ;(y !== void 0 ? (J = y(a)) : (J = a), (k.memoizedState = k.baseState = J))
            var T = {
              pending: null,
              interleaved: null,
              lanes: Cg,
              dispatch: null,
              lastRenderedReducer: n,
              lastRenderedState: J,
            }
            k.queue = T
            var W = (T.dispatch = ac.bind(null, Ii, T))
            return [k.memoizedState, W]
          }
          function lI(n, a, y) {
            var k = Ug(),
              J = k.queue
            if (J === null)
              throw new Error(
                "Should have a queue. This is likely a bug in React. Please file an issue.",
              )
            J.lastRenderedReducer = n
            var T = Nt,
              W = T.baseQueue,
              BA = J.pending
            if (BA !== null) {
              if (W !== null) {
                var cA = W.next,
                  RA = BA.next
                ;((W.next = RA), (BA.next = cA))
              }
              ;(T.baseQueue !== W &&
                s(
                  "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.",
                ),
                (T.baseQueue = W = BA),
                (J.pending = null))
            }
            if (W !== null) {
              var TA = W.next,
                DI = T.baseState,
                vI = null,
                bI = null,
                og = null,
                cg = TA
              do {
                var cC = cg.lane
                if (Uo(ur, cC)) {
                  if (og !== null) {
                    var MC = {
                      // This update is going to be committed so we never want uncommit
                      // it. Using NoLane works because 0 is a subset of all bitmasks, so
                      // this will never be skipped by the check above.
                      lane: TC,
                      action: cg.action,
                      hasEagerState: cg.hasEagerState,
                      eagerState: cg.eagerState,
                      next: null,
                    }
                    og = og.next = MC
                  }
                  if (cg.hasEagerState) DI = cg.eagerState
                  else {
                    var yt = cg.action
                    DI = n(DI, yt)
                  }
                } else {
                  var re = {
                    lane: cC,
                    action: cg.action,
                    hasEagerState: cg.hasEagerState,
                    eagerState: cg.eagerState,
                    next: null,
                  }
                  ;(og === null ? ((bI = og = re), (vI = DI)) : (og = og.next = re),
                    (Ii.lanes = LC(Ii.lanes, cC)),
                    zd(cC))
                }
                cg = cg.next
              } while (cg !== null && cg !== TA)
              ;(og === null ? (vI = DI) : (og.next = bI),
                ci(DI, k.memoizedState) || Nd(),
                (k.memoizedState = DI),
                (k.baseState = vI),
                (k.baseQueue = og),
                (J.lastRenderedState = DI))
            }
            var Qt = J.interleaved
            if (Qt !== null) {
              var MI = Qt
              do {
                var PI = MI.lane
                ;((Ii.lanes = LC(Ii.lanes, PI)), zd(PI), (MI = MI.next))
              } while (MI !== Qt)
            } else W === null && (J.lanes = Cg)
            var uI = J.dispatch
            return [k.memoizedState, uI]
          }
          function XA(n, a, y) {
            var k = Ug(),
              J = k.queue
            if (J === null)
              throw new Error(
                "Should have a queue. This is likely a bug in React. Please file an issue.",
              )
            J.lastRenderedReducer = n
            var T = J.dispatch,
              W = J.pending,
              BA = k.memoizedState
            if (W !== null) {
              J.pending = null
              var cA = W.next,
                RA = cA
              do {
                var TA = RA.action
                ;((BA = n(BA, TA)), (RA = RA.next))
              } while (RA !== cA)
              ;(ci(BA, k.memoizedState) || Nd(),
                (k.memoizedState = BA),
                k.baseQueue === null && (k.baseState = BA),
                (J.lastRenderedState = BA))
            }
            return [BA, T]
          }
          function wI(n, a, y) {}
          function Dg(n, a, y) {}
          function gC(n, a, y) {
            var k = Ii,
              J = Ig(),
              T,
              W = St()
            if (W) {
              if (y === void 0)
                throw new Error(
                  "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.",
                )
              ;((T = y()),
                ns ||
                  (T !== y() &&
                    (s(
                      "The result of getServerSnapshot should be cached to avoid an infinite loop",
                    ),
                    (ns = !0))))
            } else {
              if (((T = a()), !ns)) {
                var BA = a()
                ci(T, BA) ||
                  (s("The result of getSnapshot should be cached to avoid an infinite loop"),
                  (ns = !0))
              }
              var cA = NS()
              if (cA === null)
                throw new Error(
                  "Expected a work-in-progress root. This is a bug in React. Please file an issue.",
                )
              On(cA, ur) || Vg(k, a, T)
            }
            J.memoizedState = T
            var RA = {
              value: T,
              getSnapshot: a,
            }
            return (
              (J.queue = RA),
              ch(hB.bind(null, k, RA, n), [n]),
              (k.flags |= zC),
              ku(Oi | RB, dC.bind(null, k, RA, T, a), void 0, null),
              T
            )
          }
          function lC(n, a, y) {
            var k = Ii,
              J = Ug(),
              T = a()
            if (!ns) {
              var W = a()
              ci(T, W) ||
                (s("The result of getSnapshot should be cached to avoid an infinite loop"),
                (ns = !0))
            }
            var BA = J.memoizedState,
              cA = !ci(BA, T)
            cA && ((J.memoizedState = T), Nd())
            var RA = J.queue
            if (
              (hh(hB.bind(null, k, RA, n), [n]),
              RA.getSnapshot !== a ||
                cA || // Check if the susbcribe function changed. We can save some memory by
                // checking whether we scheduled a subscription effect above.
                (_t !== null && _t.memoizedState.tag & Oi))
            ) {
              ;((k.flags |= zC), ku(Oi | RB, dC.bind(null, k, RA, T, a), void 0, null))
              var TA = NS()
              if (TA === null)
                throw new Error(
                  "Expected a work-in-progress root. This is a bug in React. Please file an issue.",
                )
              On(TA, ur) || Vg(k, a, T)
            }
            return T
          }
          function Vg(n, a, y) {
            n.flags |= Ei
            var k = {
                getSnapshot: a,
                value: y,
              },
              J = Ii.updateQueue
            if (J === null) ((J = Wg()), (Ii.updateQueue = J), (J.stores = [k]))
            else {
              var T = J.stores
              T === null ? (J.stores = [k]) : T.push(k)
            }
          }
          function dC(n, a, y, k) {
            ;((a.value = y), (a.getSnapshot = k), _e(a) && da(n))
          }
          function hB(n, a, y) {
            var k = function () {
              _e(a) && da(n)
            }
            return y(k)
          }
          function _e(n) {
            var a = n.getSnapshot,
              y = n.value
            try {
              var k = a()
              return !ci(y, k)
            } catch {
              return !0
            }
          }
          function da(n) {
            wQ(n, PC, Je)
          }
          function lh(n) {
            var a = Ig()
            ;(typeof n == "function" && (n = n()), (a.memoizedState = a.baseState = n))
            var y = {
              pending: null,
              interleaved: null,
              lanes: Cg,
              dispatch: null,
              lastRenderedReducer: Xg,
              lastRenderedState: n,
            }
            a.queue = y
            var k = (y.dispatch = zF.bind(null, Ii, y))
            return [a.memoizedState, k]
          }
          function Cd(n) {
            return lI(Xg)
          }
          function ed(n) {
            return XA(Xg)
          }
          function ku(n, a, y, k) {
            var J = {
                tag: n,
                create: a,
                destroy: y,
                deps: k,
                // Circular
                next: null,
              },
              T = Ii.updateQueue
            if (T === null) ((T = Wg()), (Ii.updateQueue = T), (T.lastEffect = J.next = J))
            else {
              var W = T.lastEffect
              if (W === null) T.lastEffect = J.next = J
              else {
                var BA = W.next
                ;((W.next = J), (J.next = BA), (T.lastEffect = J))
              }
            }
            return J
          }
          function id(n) {
            var a = Ig()
            {
              var y = {
                current: n,
              }
              return ((a.memoizedState = y), y)
            }
          }
          function td(n) {
            var a = Ug()
            return a.memoizedState
          }
          function jD(n, a, y, k) {
            var J = Ig(),
              T = k === void 0 ? null : k
            ;((Ii.flags |= n), (J.memoizedState = ku(Oi | a, y, void 0, T)))
          }
          function zD(n, a, y, k) {
            var J = Ug(),
              T = k === void 0 ? null : k,
              W = void 0
            if (Nt !== null) {
              var BA = Nt.memoizedState
              if (((W = BA.destroy), T !== null)) {
                var cA = BA.deps
                if (KA(T, cA)) {
                  J.memoizedState = ku(a, y, W, T)
                  return
                }
              }
            }
            ;((Ii.flags |= n), (J.memoizedState = ku(Oi | a, y, W, T)))
          }
          function ch(n, a) {
            return (Ii.mode & sB) !== FC ? jD(_A | zC | jg, RB, n, a) : jD(zC | jg, RB, n, a)
          }
          function hh(n, a) {
            return zD(zC, RB, n, a)
          }
          function mp(n, a) {
            return jD(iI, fa, n, a)
          }
          function Bd(n, a) {
            return zD(iI, fa, n, a)
          }
          function vp(n, a) {
            var y = iI
            return ((y |= JC), (Ii.mode & sB) !== FC && (y |= rA), jD(y, Ot, n, a))
          }
          function Qd(n, a) {
            return zD(iI, Ot, n, a)
          }
          function _G(n, a) {
            if (typeof a == "function") {
              var y = a,
                k = n()
              return (
                y(k),
                function () {
                  y(null)
                }
              )
            } else if (a != null) {
              var J = a
              J.hasOwnProperty("current") ||
                s(
                  "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
                  "an object with keys {" + Object.keys(J).join(", ") + "}",
                )
              var T = n()
              return (
                (J.current = T),
                function () {
                  J.current = null
                }
              )
            }
          }
          function Ec(n, a, y) {
            typeof a != "function" &&
              s(
                "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
                a !== null ? typeof a : "null",
              )
            var k = y != null ? y.concat([n]) : null,
              J = iI
            return (
              (J |= JC),
              (Ii.mode & sB) !== FC && (J |= rA),
              jD(J, Ot, _G.bind(null, a, n), k)
            )
          }
          function Mu(n, a, y) {
            typeof a != "function" &&
              s(
                "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
                a !== null ? typeof a : "null",
              )
            var k = y != null ? y.concat([n]) : null
            return zD(iI, Ot, _G.bind(null, a, n), k)
          }
          function XD(n, a) {}
          var Uu = XD
          function Lp(n, a) {
            var y = Ig(),
              k = a === void 0 ? null : a
            return ((y.memoizedState = [n, k]), n)
          }
          function od(n, a) {
            var y = Ug(),
              k = a === void 0 ? null : a,
              J = y.memoizedState
            if (J !== null && k !== null) {
              var T = J[1]
              if (KA(k, T)) return J[0]
            }
            return ((y.memoizedState = [n, k]), n)
          }
          function nd(n, a) {
            var y = Ig(),
              k = a === void 0 ? null : a,
              J = n()
            return ((y.memoizedState = [J, k]), J)
          }
          function Ed(n, a) {
            var y = Ug(),
              k = a === void 0 ? null : a,
              J = y.memoizedState
            if (J !== null && k !== null) {
              var T = J[1]
              if (KA(k, T)) return J[0]
            }
            var W = n()
            return ((y.memoizedState = [W, k]), W)
          }
          function Nu(n) {
            var a = lh(n),
              y = a[0],
              k = a[1]
            return (
              ch(
                function () {
                  var J = bQ.transition
                  bQ.transition = {}
                  try {
                    k(n)
                  } finally {
                    bQ.transition = J
                  }
                },
                [n],
              ),
              y
            )
          }
          function uh(n) {
            var a = Cd(),
              y = a[0],
              k = a[1]
            return (
              hh(
                function () {
                  var J = bQ.transition
                  bQ.transition = {}
                  try {
                    k(n)
                  } finally {
                    bQ.transition = J
                  }
                },
                [n],
              ),
              y
            )
          }
          function ad(n) {
            var a = ed(),
              y = a[0],
              k = a[1]
            return (
              hh(
                function () {
                  var J = bQ.transition
                  bQ.transition = {}
                  try {
                    k(n)
                  } finally {
                    bQ.transition = J
                  }
                },
                [n],
              ),
              y
            )
          }
          function ZG(n, a, y) {
            var k = ZB()
            ;(qt(zr(k, gr)), n(!0))
            var J = bQ.transition
            bQ.transition = {}
            var T = bQ.transition
            bQ.transition._updatedFibers = /* @__PURE__ */ new Set()
            try {
              ;(n(!1), a())
            } finally {
              if ((qt(k), (bQ.transition = J), J === null && T._updatedFibers)) {
                var W = T._updatedFibers.size
                ;(W > 10 &&
                  r(
                    "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.",
                  ),
                  T._updatedFibers.clear())
              }
            }
          }
          function Fu() {
            var n = lh(!1),
              a = n[0],
              y = n[1],
              k = ZG.bind(null, y),
              J = Ig()
            return ((J.memoizedState = k), [a, k])
          }
          function Yp() {
            var n = Cd(),
              a = n[0],
              y = Ug(),
              k = y.memoizedState
            return [a, k]
          }
          function qp() {
            var n = ed(),
              a = n[0],
              y = Ug(),
              k = y.memoizedState
            return [a, k]
          }
          var Hp = !1
          function PG() {
            return Hp
          }
          function rd() {
            var n = Ig(),
              a = NS(),
              y = a.identifierPrefix,
              k
            if (St()) {
              var J = ua()
              k = ":" + y + "R" + J
              var T = Es++
              ;(T > 0 && (k += "H" + T.toString(32)), (k += ":"))
            } else {
              var W = Kp++
              k = ":" + y + "r" + W.toString(32) + ":"
            }
            return ((n.memoizedState = k), k)
          }
          function $D() {
            var n = Ug(),
              a = n.memoizedState
            return a
          }
          function ac(n, a, y) {
            typeof arguments[3] == "function" &&
              s(
                "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().",
              )
            var k = ls(n),
              J = {
                lane: k,
                action: y,
                hasEagerState: !1,
                eagerState: null,
                next: null,
              }
            if (WG(n)) VG(a, J)
            else {
              Ru(n, a, J)
              var T = Oo(),
                W = wQ(n, k, T)
              W !== null && sd(W, a, k)
            }
            Tp(n, k)
          }
          function zF(n, a, y) {
            typeof arguments[3] == "function" &&
              s(
                "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().",
              )
            var k = ls(n),
              J = {
                lane: k,
                action: y,
                hasEagerState: !1,
                eagerState: null,
                next: null,
              }
            if (WG(n)) VG(a, J)
            else {
              Ru(n, a, J)
              var T = n.alternate
              if (n.lanes === Cg && (T === null || T.lanes === Cg)) {
                var W = a.lastRenderedReducer
                if (W !== null) {
                  var BA
                  ;((BA = Kg.current), (Kg.current = Dn))
                  try {
                    var cA = a.lastRenderedState,
                      RA = W(cA, y)
                    if (((J.hasEagerState = !0), (J.eagerState = RA), ci(RA, cA))) return
                  } catch {
                  } finally {
                    Kg.current = BA
                  }
                }
              }
              var TA = Oo(),
                DI = wQ(n, k, TA)
              DI !== null && sd(DI, a, k)
            }
            Tp(n, k)
          }
          function WG(n) {
            var a = n.alternate
            return n === Ii || (a !== null && a === Ii)
          }
          function VG(n, a) {
            rh = ah = !0
            var y = n.pending
            ;(y === null ? (a.next = a) : ((a.next = y.next), (y.next = a)), (n.pending = a))
          }
          function Ru(n, a, y, k) {
            if (KB(n)) {
              var J = a.interleaved
              ;(J === null ? ((y.next = y), sC(a)) : ((y.next = J.next), (J.next = y)),
                (a.interleaved = y))
            } else {
              var T = a.pending
              ;(T === null ? (y.next = y) : ((y.next = T.next), (T.next = y)), (a.pending = y))
            }
          }
          function sd(n, a, y) {
            if (OB(y)) {
              var k = a.lanes
              k = It(k, n.pendingLanes)
              var J = LC(k, y)
              ;((a.lanes = J), AB(n, J))
            }
          }
          function Tp(n, a, y) {
            Zn(n, a)
          }
          var ld = {
              readContext: Sg,
              useCallback: oA,
              useContext: oA,
              useEffect: oA,
              useImperativeHandle: oA,
              useInsertionEffect: oA,
              useLayoutEffect: oA,
              useMemo: oA,
              useReducer: oA,
              useRef: oA,
              useState: oA,
              useDebugValue: oA,
              useDeferredValue: oA,
              useTransition: oA,
              useMutableSource: oA,
              useSyncExternalStore: oA,
              useId: oA,
              unstable_isNewReconciler: K,
            },
            xp = null,
            jG = null,
            ft = null,
            cd = null,
            xE = null,
            Dn = null,
            AS = null
          {
            var hd = function () {
                s(
                  "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().",
                )
              },
              YC = function () {
                s(
                  "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks",
                )
              }
            ;((xp = {
              readContext: function (n) {
                return Sg(n)
              },
              useCallback: function (n, a) {
                return ((VI = "useCallback"), p(), q(a), Lp(n, a))
              },
              useContext: function (n) {
                return ((VI = "useContext"), p(), Sg(n))
              },
              useEffect: function (n, a) {
                return ((VI = "useEffect"), p(), q(a), ch(n, a))
              },
              useImperativeHandle: function (n, a, y) {
                return ((VI = "useImperativeHandle"), p(), q(y), Ec(n, a, y))
              },
              useInsertionEffect: function (n, a) {
                return ((VI = "useInsertionEffect"), p(), q(a), mp(n, a))
              },
              useLayoutEffect: function (n, a) {
                return ((VI = "useLayoutEffect"), p(), q(a), vp(n, a))
              },
              useMemo: function (n, a) {
                ;((VI = "useMemo"), p(), q(a))
                var y = Kg.current
                Kg.current = xE
                try {
                  return nd(n, a)
                } finally {
                  Kg.current = y
                }
              },
              useReducer: function (n, a, y) {
                ;((VI = "useReducer"), p())
                var k = Kg.current
                Kg.current = xE
                try {
                  return Ft(n, a, y)
                } finally {
                  Kg.current = k
                }
              },
              useRef: function (n) {
                return ((VI = "useRef"), p(), id(n))
              },
              useState: function (n) {
                ;((VI = "useState"), p())
                var a = Kg.current
                Kg.current = xE
                try {
                  return lh(n)
                } finally {
                  Kg.current = a
                }
              },
              useDebugValue: function (n, a) {
                return ((VI = "useDebugValue"), p(), void 0)
              },
              useDeferredValue: function (n) {
                return ((VI = "useDeferredValue"), p(), Nu(n))
              },
              useTransition: function () {
                return ((VI = "useTransition"), p(), Fu())
              },
              useMutableSource: function (n, a, y) {
                return ((VI = "useMutableSource"), p(), void 0)
              },
              useSyncExternalStore: function (n, a, y) {
                return ((VI = "useSyncExternalStore"), p(), gC(n, a, y))
              },
              useId: function () {
                return ((VI = "useId"), p(), rd())
              },
              unstable_isNewReconciler: K,
            }),
              (jG = {
                readContext: function (n) {
                  return Sg(n)
                },
                useCallback: function (n, a) {
                  return ((VI = "useCallback"), U(), Lp(n, a))
                },
                useContext: function (n) {
                  return ((VI = "useContext"), U(), Sg(n))
                },
                useEffect: function (n, a) {
                  return ((VI = "useEffect"), U(), ch(n, a))
                },
                useImperativeHandle: function (n, a, y) {
                  return ((VI = "useImperativeHandle"), U(), Ec(n, a, y))
                },
                useInsertionEffect: function (n, a) {
                  return ((VI = "useInsertionEffect"), U(), mp(n, a))
                },
                useLayoutEffect: function (n, a) {
                  return ((VI = "useLayoutEffect"), U(), vp(n, a))
                },
                useMemo: function (n, a) {
                  ;((VI = "useMemo"), U())
                  var y = Kg.current
                  Kg.current = xE
                  try {
                    return nd(n, a)
                  } finally {
                    Kg.current = y
                  }
                },
                useReducer: function (n, a, y) {
                  ;((VI = "useReducer"), U())
                  var k = Kg.current
                  Kg.current = xE
                  try {
                    return Ft(n, a, y)
                  } finally {
                    Kg.current = k
                  }
                },
                useRef: function (n) {
                  return ((VI = "useRef"), U(), id(n))
                },
                useState: function (n) {
                  ;((VI = "useState"), U())
                  var a = Kg.current
                  Kg.current = xE
                  try {
                    return lh(n)
                  } finally {
                    Kg.current = a
                  }
                },
                useDebugValue: function (n, a) {
                  return ((VI = "useDebugValue"), U(), void 0)
                },
                useDeferredValue: function (n) {
                  return ((VI = "useDeferredValue"), U(), Nu(n))
                },
                useTransition: function () {
                  return ((VI = "useTransition"), U(), Fu())
                },
                useMutableSource: function (n, a, y) {
                  return ((VI = "useMutableSource"), U(), void 0)
                },
                useSyncExternalStore: function (n, a, y) {
                  return ((VI = "useSyncExternalStore"), U(), gC(n, a, y))
                },
                useId: function () {
                  return ((VI = "useId"), U(), rd())
                },
                unstable_isNewReconciler: K,
              }),
              (ft = {
                readContext: function (n) {
                  return Sg(n)
                },
                useCallback: function (n, a) {
                  return ((VI = "useCallback"), U(), od(n, a))
                },
                useContext: function (n) {
                  return ((VI = "useContext"), U(), Sg(n))
                },
                useEffect: function (n, a) {
                  return ((VI = "useEffect"), U(), hh(n, a))
                },
                useImperativeHandle: function (n, a, y) {
                  return ((VI = "useImperativeHandle"), U(), Mu(n, a, y))
                },
                useInsertionEffect: function (n, a) {
                  return ((VI = "useInsertionEffect"), U(), Bd(n, a))
                },
                useLayoutEffect: function (n, a) {
                  return ((VI = "useLayoutEffect"), U(), Qd(n, a))
                },
                useMemo: function (n, a) {
                  ;((VI = "useMemo"), U())
                  var y = Kg.current
                  Kg.current = Dn
                  try {
                    return Ed(n, a)
                  } finally {
                    Kg.current = y
                  }
                },
                useReducer: function (n, a, y) {
                  ;((VI = "useReducer"), U())
                  var k = Kg.current
                  Kg.current = Dn
                  try {
                    return lI(n, a, y)
                  } finally {
                    Kg.current = k
                  }
                },
                useRef: function (n) {
                  return ((VI = "useRef"), U(), td())
                },
                useState: function (n) {
                  ;((VI = "useState"), U())
                  var a = Kg.current
                  Kg.current = Dn
                  try {
                    return Cd(n)
                  } finally {
                    Kg.current = a
                  }
                },
                useDebugValue: function (n, a) {
                  return ((VI = "useDebugValue"), U(), Uu())
                },
                useDeferredValue: function (n) {
                  return ((VI = "useDeferredValue"), U(), uh(n))
                },
                useTransition: function () {
                  return ((VI = "useTransition"), U(), Yp())
                },
                useMutableSource: function (n, a, y) {
                  return ((VI = "useMutableSource"), U(), void 0)
                },
                useSyncExternalStore: function (n, a, y) {
                  return ((VI = "useSyncExternalStore"), U(), lC(n, a))
                },
                useId: function () {
                  return ((VI = "useId"), U(), $D())
                },
                unstable_isNewReconciler: K,
              }),
              (cd = {
                readContext: function (n) {
                  return Sg(n)
                },
                useCallback: function (n, a) {
                  return ((VI = "useCallback"), U(), od(n, a))
                },
                useContext: function (n) {
                  return ((VI = "useContext"), U(), Sg(n))
                },
                useEffect: function (n, a) {
                  return ((VI = "useEffect"), U(), hh(n, a))
                },
                useImperativeHandle: function (n, a, y) {
                  return ((VI = "useImperativeHandle"), U(), Mu(n, a, y))
                },
                useInsertionEffect: function (n, a) {
                  return ((VI = "useInsertionEffect"), U(), Bd(n, a))
                },
                useLayoutEffect: function (n, a) {
                  return ((VI = "useLayoutEffect"), U(), Qd(n, a))
                },
                useMemo: function (n, a) {
                  ;((VI = "useMemo"), U())
                  var y = Kg.current
                  Kg.current = AS
                  try {
                    return Ed(n, a)
                  } finally {
                    Kg.current = y
                  }
                },
                useReducer: function (n, a, y) {
                  ;((VI = "useReducer"), U())
                  var k = Kg.current
                  Kg.current = AS
                  try {
                    return XA(n, a, y)
                  } finally {
                    Kg.current = k
                  }
                },
                useRef: function (n) {
                  return ((VI = "useRef"), U(), td())
                },
                useState: function (n) {
                  ;((VI = "useState"), U())
                  var a = Kg.current
                  Kg.current = AS
                  try {
                    return ed(n)
                  } finally {
                    Kg.current = a
                  }
                },
                useDebugValue: function (n, a) {
                  return ((VI = "useDebugValue"), U(), Uu())
                },
                useDeferredValue: function (n) {
                  return ((VI = "useDeferredValue"), U(), ad(n))
                },
                useTransition: function () {
                  return ((VI = "useTransition"), U(), qp())
                },
                useMutableSource: function (n, a, y) {
                  return ((VI = "useMutableSource"), U(), void 0)
                },
                useSyncExternalStore: function (n, a, y) {
                  return ((VI = "useSyncExternalStore"), U(), lC(n, a))
                },
                useId: function () {
                  return ((VI = "useId"), U(), $D())
                },
                unstable_isNewReconciler: K,
              }),
              (xE = {
                readContext: function (n) {
                  return (hd(), Sg(n))
                },
                useCallback: function (n, a) {
                  return ((VI = "useCallback"), YC(), p(), Lp(n, a))
                },
                useContext: function (n) {
                  return ((VI = "useContext"), YC(), p(), Sg(n))
                },
                useEffect: function (n, a) {
                  return ((VI = "useEffect"), YC(), p(), ch(n, a))
                },
                useImperativeHandle: function (n, a, y) {
                  return ((VI = "useImperativeHandle"), YC(), p(), Ec(n, a, y))
                },
                useInsertionEffect: function (n, a) {
                  return ((VI = "useInsertionEffect"), YC(), p(), mp(n, a))
                },
                useLayoutEffect: function (n, a) {
                  return ((VI = "useLayoutEffect"), YC(), p(), vp(n, a))
                },
                useMemo: function (n, a) {
                  ;((VI = "useMemo"), YC(), p())
                  var y = Kg.current
                  Kg.current = xE
                  try {
                    return nd(n, a)
                  } finally {
                    Kg.current = y
                  }
                },
                useReducer: function (n, a, y) {
                  ;((VI = "useReducer"), YC(), p())
                  var k = Kg.current
                  Kg.current = xE
                  try {
                    return Ft(n, a, y)
                  } finally {
                    Kg.current = k
                  }
                },
                useRef: function (n) {
                  return ((VI = "useRef"), YC(), p(), id(n))
                },
                useState: function (n) {
                  ;((VI = "useState"), YC(), p())
                  var a = Kg.current
                  Kg.current = xE
                  try {
                    return lh(n)
                  } finally {
                    Kg.current = a
                  }
                },
                useDebugValue: function (n, a) {
                  return ((VI = "useDebugValue"), YC(), p(), void 0)
                },
                useDeferredValue: function (n) {
                  return ((VI = "useDeferredValue"), YC(), p(), Nu(n))
                },
                useTransition: function () {
                  return ((VI = "useTransition"), YC(), p(), Fu())
                },
                useMutableSource: function (n, a, y) {
                  return ((VI = "useMutableSource"), YC(), p(), void 0)
                },
                useSyncExternalStore: function (n, a, y) {
                  return ((VI = "useSyncExternalStore"), YC(), p(), gC(n, a, y))
                },
                useId: function () {
                  return ((VI = "useId"), YC(), p(), rd())
                },
                unstable_isNewReconciler: K,
              }),
              (Dn = {
                readContext: function (n) {
                  return (hd(), Sg(n))
                },
                useCallback: function (n, a) {
                  return ((VI = "useCallback"), YC(), U(), od(n, a))
                },
                useContext: function (n) {
                  return ((VI = "useContext"), YC(), U(), Sg(n))
                },
                useEffect: function (n, a) {
                  return ((VI = "useEffect"), YC(), U(), hh(n, a))
                },
                useImperativeHandle: function (n, a, y) {
                  return ((VI = "useImperativeHandle"), YC(), U(), Mu(n, a, y))
                },
                useInsertionEffect: function (n, a) {
                  return ((VI = "useInsertionEffect"), YC(), U(), Bd(n, a))
                },
                useLayoutEffect: function (n, a) {
                  return ((VI = "useLayoutEffect"), YC(), U(), Qd(n, a))
                },
                useMemo: function (n, a) {
                  ;((VI = "useMemo"), YC(), U())
                  var y = Kg.current
                  Kg.current = Dn
                  try {
                    return Ed(n, a)
                  } finally {
                    Kg.current = y
                  }
                },
                useReducer: function (n, a, y) {
                  ;((VI = "useReducer"), YC(), U())
                  var k = Kg.current
                  Kg.current = Dn
                  try {
                    return lI(n, a, y)
                  } finally {
                    Kg.current = k
                  }
                },
                useRef: function (n) {
                  return ((VI = "useRef"), YC(), U(), td())
                },
                useState: function (n) {
                  ;((VI = "useState"), YC(), U())
                  var a = Kg.current
                  Kg.current = Dn
                  try {
                    return Cd(n)
                  } finally {
                    Kg.current = a
                  }
                },
                useDebugValue: function (n, a) {
                  return ((VI = "useDebugValue"), YC(), U(), Uu())
                },
                useDeferredValue: function (n) {
                  return ((VI = "useDeferredValue"), YC(), U(), uh(n))
                },
                useTransition: function () {
                  return ((VI = "useTransition"), YC(), U(), Yp())
                },
                useMutableSource: function (n, a, y) {
                  return ((VI = "useMutableSource"), YC(), U(), void 0)
                },
                useSyncExternalStore: function (n, a, y) {
                  return ((VI = "useSyncExternalStore"), YC(), U(), lC(n, a))
                },
                useId: function () {
                  return ((VI = "useId"), YC(), U(), $D())
                },
                unstable_isNewReconciler: K,
              }),
              (AS = {
                readContext: function (n) {
                  return (hd(), Sg(n))
                },
                useCallback: function (n, a) {
                  return ((VI = "useCallback"), YC(), U(), od(n, a))
                },
                useContext: function (n) {
                  return ((VI = "useContext"), YC(), U(), Sg(n))
                },
                useEffect: function (n, a) {
                  return ((VI = "useEffect"), YC(), U(), hh(n, a))
                },
                useImperativeHandle: function (n, a, y) {
                  return ((VI = "useImperativeHandle"), YC(), U(), Mu(n, a, y))
                },
                useInsertionEffect: function (n, a) {
                  return ((VI = "useInsertionEffect"), YC(), U(), Bd(n, a))
                },
                useLayoutEffect: function (n, a) {
                  return ((VI = "useLayoutEffect"), YC(), U(), Qd(n, a))
                },
                useMemo: function (n, a) {
                  ;((VI = "useMemo"), YC(), U())
                  var y = Kg.current
                  Kg.current = Dn
                  try {
                    return Ed(n, a)
                  } finally {
                    Kg.current = y
                  }
                },
                useReducer: function (n, a, y) {
                  ;((VI = "useReducer"), YC(), U())
                  var k = Kg.current
                  Kg.current = Dn
                  try {
                    return XA(n, a, y)
                  } finally {
                    Kg.current = k
                  }
                },
                useRef: function (n) {
                  return ((VI = "useRef"), YC(), U(), td())
                },
                useState: function (n) {
                  ;((VI = "useState"), YC(), U())
                  var a = Kg.current
                  Kg.current = Dn
                  try {
                    return ed(n)
                  } finally {
                    Kg.current = a
                  }
                },
                useDebugValue: function (n, a) {
                  return ((VI = "useDebugValue"), YC(), U(), Uu())
                },
                useDeferredValue: function (n) {
                  return ((VI = "useDeferredValue"), YC(), U(), ad(n))
                },
                useTransition: function () {
                  return ((VI = "useTransition"), YC(), U(), qp())
                },
                useMutableSource: function (n, a, y) {
                  return ((VI = "useMutableSource"), YC(), U(), void 0)
                },
                useSyncExternalStore: function (n, a, y) {
                  return ((VI = "useSyncExternalStore"), YC(), U(), lC(n, a))
                },
                useId: function () {
                  return ((VI = "useId"), YC(), U(), $D())
                },
                unstable_isNewReconciler: K,
              }))
          }
          var ya = C.unstable_now,
            zG = 0,
            Dh = -1,
            as = -1,
            ud = -1,
            Dd = !1,
            Sd = !1
          function XG() {
            return Dd
          }
          function gE() {
            Sd = !0
          }
          function IS() {
            ;((Dd = !1), (Sd = !1))
          }
          function fd() {
            ;((Dd = Sd), (Sd = !1))
          }
          function gl() {
            return zG
          }
          function bp() {
            zG = ya()
          }
          function Cl(n) {
            ;((as = ya()), n.actualStartTime < 0 && (n.actualStartTime = ya()))
          }
          function rc(n) {
            as = -1
          }
          function Sh(n, a) {
            if (as >= 0) {
              var y = ya() - as
              ;((n.actualDuration += y), a && (n.selfBaseDuration = y), (as = -1))
            }
          }
          function CE(n) {
            if (Dh >= 0) {
              var a = ya() - Dh
              Dh = -1
              for (var y = n.return; y !== null; ) {
                switch (y.tag) {
                  case _:
                    var k = y.stateNode
                    k.effectDuration += a
                    return
                  case fA:
                    var J = y.stateNode
                    J.effectDuration += a
                    return
                }
                y = y.return
              }
            }
          }
          function Ju(n) {
            if (ud >= 0) {
              var a = ya() - ud
              ud = -1
              for (var y = n.return; y !== null; ) {
                switch (y.tag) {
                  case _:
                    var k = y.stateNode
                    k !== null && (k.passiveEffectDuration += a)
                    return
                  case fA:
                    var J = y.stateNode
                    J !== null && (J.passiveEffectDuration += a)
                    return
                }
                y = y.return
              }
            }
          }
          function Ho() {
            Dh = ya()
          }
          function dd() {
            ud = ya()
          }
          function Ku(n) {
            for (var a = n.child; a; ) ((n.actualDuration += a.actualDuration), (a = a.sibling))
          }
          function gS(n, a) {
            return {
              value: n,
              source: a,
              stack: _s(a),
            }
          }
          function $G(n, a) {
            return !0
          }
          function Op(n, a) {
            try {
              var y = $G(n, a)
              if (y === !1) return
              var k = a.value,
                J = a.source,
                T = a.stack,
                W = T !== null ? T : ""
              if (k != null && k._suppressLogging) {
                if (n.tag === AA) return
                console.error(k)
              }
              var BA = J ? $I(J) : null,
                cA = BA
                  ? "The above error occurred in the <" + BA + "> component:"
                  : "The above error occurred in one of your React components:",
                RA
              if (n.tag === _)
                RA = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`
              else {
                var TA = $I(n) || "Anonymous"
                RA =
                  "React will try to recreate this component tree from scratch " +
                  ("using the error boundary you provided, " + TA + ".")
              }
              var DI =
                cA +
                `
` +
                W +
                `

` +
                ("" + RA)
              console.error(DI)
            } catch (vI) {
              setTimeout(function () {
                throw vI
              })
            }
          }
          var XF = typeof WeakMap == "function" ? WeakMap : Map
          function CS(n, a, y) {
            var k = SC(Je, y)
            ;((k.tag = yI),
              (k.payload = {
                element: null,
              }))
            var J = a.value
            return (
              (k.callback = function () {
                ;(jk(J), Op(n, a))
              }),
              k
            )
          }
          function mu(n, a, y) {
            var k = SC(Je, y)
            k.tag = yI
            var J = n.type.getDerivedStateFromError
            if (typeof J == "function") {
              var T = a.value
              ;((k.payload = function () {
                return J(T)
              }),
                (k.callback = function () {
                  ;(bE(n), Op(n, a))
                }))
            }
            var W = n.stateNode
            return (
              W !== null &&
                typeof W.componentDidCatch == "function" &&
                (k.callback = function () {
                  ;(bE(n), Op(n, a), typeof J != "function" && KR(this))
                  var cA = a.value,
                    RA = a.stack
                  ;(this.componentDidCatch(cA, {
                    componentStack: RA !== null ? RA : "",
                  }),
                    typeof J != "function" &&
                      (Ne(n.lanes, PC) ||
                        s(
                          "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
                          $I(n) || "Unknown",
                        )))
                }),
              k
            )
          }
          function _p(n, a, y) {
            var k = n.pingCache,
              J
            if (
              (k === null
                ? ((k = n.pingCache = new XF()), (J = /* @__PURE__ */ new Set()), k.set(a, J))
                : ((J = k.get(a)), J === void 0 && ((J = /* @__PURE__ */ new Set()), k.set(a, J))),
              !J.has(y))
            ) {
              J.add(y)
              var T = Kw.bind(null, n, a, y)
              ;(uQ && Jg(n, y), a.then(T, T))
            }
          }
          function $F(n, a, y, k) {
            var J = n.updateQueue
            if (J === null) {
              var T = /* @__PURE__ */ new Set()
              ;(T.add(y), (n.updateQueue = T))
            } else J.add(y)
          }
          function yd(n, a) {
            var y = n.tag
            if ((n.mode & Ai) === FC && (y === P || y === nA || y === EA)) {
              var k = n.alternate
              k
                ? ((n.updateQueue = k.updateQueue),
                  (n.memoizedState = k.memoizedState),
                  (n.lanes = k.lanes))
                : ((n.updateQueue = null), (n.memoizedState = null))
            }
          }
          function Ak(n) {
            var a = n
            do {
              if (a.tag === sA && Gu(a)) return a
              a = a.return
            } while (a !== null)
            return null
          }
          function Ik(n, a, y, k, J) {
            if ((n.mode & Ai) === FC) {
              if (n === a) n.flags |= TI
              else {
                if (((n.flags |= Qg), (y.flags |= eg), (y.flags &= ~(vi | mA)), ZC && M)) {
                  var T = n.alternate
                  if (T === null) {
                    var W = n.child,
                      BA = W.child
                    if (BA !== null) {
                      var cA = BA.memoizedProps.children,
                        RA = pg("hidden", cA)
                      ;((BA.pendingProps = RA), (BA.memoizedProps = RA))
                    }
                  }
                }
                if (y.tag === AA) {
                  var TA = y.alternate
                  if (TA === null) y.tag = DA
                  else {
                    var DI = SC(Je, PC)
                    ;((DI.tag = Dt), Qe(y, DI))
                  }
                }
                y.lanes = LC(y.lanes, PC)
              }
              return n
            }
            return ((n.flags |= TI), (n.lanes = J), n)
          }
          function AR(n, a, y, k, J) {
            if (
              ((y.flags |= mA),
              uQ && Jg(n, J),
              k !== null && typeof k == "object" && typeof k.then == "function")
            ) {
              var T = k
              yd(y)
              var W = Ak(a)
              if (W !== null) {
                ;((W.flags &= ~Fg), Ik(W, a, y, n, J), W.mode & Ai && _p(n, T, J), $F(W, n, T))
                return
              } else {
                if (!Ri(J)) {
                  ;(_p(n, T, J), Fw())
                  return
                }
                var BA = new Error(
                  "A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.",
                )
                k = BA
              }
            } else if (St() && y.mode & Ai) {
              NB()
              var cA = Ak(a)
              if (cA !== null) {
                ;((cA.flags & TI) === SA && (cA.flags |= Fg), Ik(cA, a, y, n, J), et(k))
                return
              }
            }
            ;(Pk(k), (k = gS(k, y)))
            var RA = a
            do {
              switch (RA.tag) {
                case _: {
                  var TA = k
                  RA.flags |= TI
                  var DI = oa(J)
                  RA.lanes = LC(RA.lanes, DI)
                  var vI = CS(RA, TA, DI)
                  oe(RA, vI)
                  return
                }
                case AA:
                  var bI = k,
                    og = RA.type,
                    cg = RA.stateNode
                  if (
                    (RA.flags & Qg) === SA &&
                    (typeof og.getDerivedStateFromError == "function" ||
                      (cg !== null && typeof cg.componentDidCatch == "function" && !Ay(cg)))
                  ) {
                    RA.flags |= TI
                    var cC = oa(J)
                    RA.lanes = LC(RA.lanes, cC)
                    var re = mu(RA, bI, cC)
                    oe(RA, re)
                    return
                  }
                  break
              }
              RA = RA.return
            } while (RA !== null)
          }
          function IR() {
            return null
          }
          function rs(n) {
            n.flags |= iI
          }
          function gk(n) {
            ;((n.flags |= jC), (n.flags |= OC))
          }
          function Ck(n, a) {
            var y = n !== null && n.child === a.child
            if (y) return !0
            if ((a.flags & qI) !== SA) return !1
            for (var k = a.child; k !== null; ) {
              if ((k.flags & QI) !== SA || (k.subtreeFlags & QI) !== SA) return !1
              k = k.sibling
            }
            return !0
          }
          var eS, iS, pd, vu
          if (Wt)
            ((eS = function (n, a, y, k) {
              for (var J = a.child; J !== null; ) {
                if (J.tag === CA || J.tag === aA) ai(n, J.stateNode)
                else if (J.tag !== eA) {
                  if (J.child !== null) {
                    ;((J.child.return = J), (J = J.child))
                    continue
                  }
                }
                if (J === a) return
                for (; J.sibling === null; ) {
                  if (J.return === null || J.return === a) return
                  J = J.return
                }
                ;((J.sibling.return = J.return), (J = J.sibling))
              }
            }),
              (iS = function (n, a) {}),
              (pd = function (n, a, y, k, J) {
                var T = n.memoizedProps
                if (T !== k) {
                  var W = a.stateNode,
                    BA = Pi(),
                    cA = He(W, y, T, k, J, BA)
                  ;((a.updateQueue = cA), cA && rs(a))
                }
              }),
              (vu = function (n, a, y, k) {
                y !== k && rs(a)
              }))
          else if (ZC) {
            eS = function (n, a, y, k) {
              for (var J = a.child; J !== null; ) {
                if (J.tag === CA) {
                  var T = J.stateNode
                  if (y && k) {
                    var W = J.memoizedProps,
                      BA = J.type
                    T = tC(T, BA, W, J)
                  }
                  ai(n, T)
                } else if (J.tag === aA) {
                  var cA = J.stateNode
                  if (y && k) {
                    var RA = J.memoizedProps
                    cA = BC(cA, RA, J)
                  }
                  ai(n, cA)
                } else if (J.tag !== eA) {
                  if (J.tag === qA && J.memoizedState !== null) {
                    var TA = J.child
                    ;(TA !== null && (TA.return = J), eS(n, J, !0, !0))
                  } else if (J.child !== null) {
                    ;((J.child.return = J), (J = J.child))
                    continue
                  }
                }
                if (((J = J), J === a)) return
                for (; J.sibling === null; ) {
                  if (J.return === null || J.return === a) return
                  J = J.return
                }
                ;((J.sibling.return = J.return), (J = J.sibling))
              }
            }
            var wd = function (n, a, y, k) {
              for (var J = a.child; J !== null; ) {
                if (J.tag === CA) {
                  var T = J.stateNode
                  if (y && k) {
                    var W = J.memoizedProps,
                      BA = J.type
                    T = tC(T, BA, W, J)
                  }
                  mI(n, T)
                } else if (J.tag === aA) {
                  var cA = J.stateNode
                  if (y && k) {
                    var RA = J.memoizedProps
                    cA = BC(cA, RA, J)
                  }
                  mI(n, cA)
                } else if (J.tag !== eA) {
                  if (J.tag === qA && J.memoizedState !== null) {
                    var TA = J.child
                    ;(TA !== null && (TA.return = J), wd(n, J, !0, !0))
                  } else if (J.child !== null) {
                    ;((J.child.return = J), (J = J.child))
                    continue
                  }
                }
                if (((J = J), J === a)) return
                for (; J.sibling === null; ) {
                  if (J.return === null || J.return === a) return
                  J = J.return
                }
                ;((J.sibling.return = J.return), (J = J.sibling))
              }
            }
            ;((iS = function (n, a) {
              var y = a.stateNode,
                k = Ck(n, a)
              if (!k) {
                var J = y.containerInfo,
                  T = rI(J)
                ;(wd(T, a, !1, !1), (y.pendingChildren = T), rs(a), ig(J, T))
              }
            }),
              (pd = function (n, a, y, k, J) {
                var T = n.stateNode,
                  W = n.memoizedProps,
                  BA = Ck(n, a)
                if (BA && W === k) {
                  a.stateNode = T
                  return
                }
                var cA = a.stateNode,
                  RA = Pi(),
                  TA = null
                if ((W !== k && (TA = He(cA, y, W, k, J, RA)), BA && TA === null)) {
                  a.stateNode = T
                  return
                }
                var DI = vA(T, TA, y, W, k, a, BA, cA)
                ;(fi(DI, y, k, J, RA) && rs(a), (a.stateNode = DI), BA ? rs(a) : eS(DI, a, !1, !1))
              }),
              (vu = function (n, a, y, k) {
                if (y !== k) {
                  var J = _D(),
                    T = Pi()
                  ;((a.stateNode = Yi(k, J, T, a)), rs(a))
                } else a.stateNode = n.stateNode
              }))
          } else
            ((iS = function (n, a) {}),
              (pd = function (n, a, y, k, J) {}),
              (vu = function (n, a, y, k) {}))
          function fh(n, a) {
            if (!St())
              switch (n.tailMode) {
                case "hidden": {
                  for (var y = n.tail, k = null; y !== null; )
                    (y.alternate !== null && (k = y), (y = y.sibling))
                  k === null ? (n.tail = null) : (k.sibling = null)
                  break
                }
                case "collapsed": {
                  for (var J = n.tail, T = null; J !== null; )
                    (J.alternate !== null && (T = J), (J = J.sibling))
                  T === null
                    ? !a && n.tail !== null
                      ? (n.tail.sibling = null)
                      : (n.tail = null)
                    : (T.sibling = null)
                  break
                }
              }
          }
          function yQ(n) {
            var a = n.alternate !== null && n.alternate.child === n.child,
              y = Cg,
              k = SA
            if (a) {
              if ((n.mode & Ae) !== FC) {
                for (var cA = n.selfBaseDuration, RA = n.child; RA !== null; )
                  ((y = LC(y, LC(RA.lanes, RA.childLanes))),
                    (k |= RA.subtreeFlags & EI),
                    (k |= RA.flags & EI),
                    (cA += RA.treeBaseDuration),
                    (RA = RA.sibling))
                n.treeBaseDuration = cA
              } else
                for (var TA = n.child; TA !== null; )
                  ((y = LC(y, LC(TA.lanes, TA.childLanes))),
                    (k |= TA.subtreeFlags & EI),
                    (k |= TA.flags & EI),
                    (TA.return = n),
                    (TA = TA.sibling))
              n.subtreeFlags |= k
            } else {
              if ((n.mode & Ae) !== FC) {
                for (var J = n.actualDuration, T = n.selfBaseDuration, W = n.child; W !== null; )
                  ((y = LC(y, LC(W.lanes, W.childLanes))),
                    (k |= W.subtreeFlags),
                    (k |= W.flags),
                    (J += W.actualDuration),
                    (T += W.treeBaseDuration),
                    (W = W.sibling))
                ;((n.actualDuration = J), (n.treeBaseDuration = T))
              } else
                for (var BA = n.child; BA !== null; )
                  ((y = LC(y, LC(BA.lanes, BA.childLanes))),
                    (k |= BA.subtreeFlags),
                    (k |= BA.flags),
                    (BA.return = n),
                    (BA = BA.sibling))
              n.subtreeFlags |= k
            }
            return ((n.childLanes = y), a)
          }
          function ek(n, a, y) {
            var k = a.pendingProps
            switch ((xD(a), a.tag)) {
              case X:
              case GA:
              case EA:
              case P:
              case nA:
              case lA:
              case JA:
              case fA:
              case yA:
              case $:
                return (yQ(a), null)
              case AA: {
                var J = a.type
                return (Co(J) && kE(a), yQ(a), null)
              }
              case _: {
                var T = a.stateNode
                if (
                  (Al(a),
                  tn(a),
                  nc(),
                  T.pendingContext && ((T.context = T.pendingContext), (T.pendingContext = null)),
                  n === null || n.child === null)
                ) {
                  var W = cr(a)
                  if (W) rs(a)
                  else if (n !== null) {
                    var BA = n.memoizedState
                    // Check if this is a client root
                    ;(!BA.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                      (a.flags & Fg) !== SA) &&
                      ((a.flags |= mC), FB())
                  }
                }
                return (iS(n, a), yQ(a), null)
              }
              case CA: {
                wu(a)
                var cA = _D(),
                  RA = a.type
                if (n !== null && a.stateNode != null)
                  (pd(n, a, RA, k, cA), n.ref !== a.ref && gk(a))
                else {
                  if (!k) {
                    if (a.stateNode === null)
                      throw new Error(
                        "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.",
                      )
                    return (yQ(a), null)
                  }
                  var TA = Pi(),
                    DI = cr(a)
                  if (DI) bD(a, cA, TA) && rs(a)
                  else {
                    var vI = ae(RA, k, cA, TA, a)
                    ;(eS(vI, a, !1, !1), (a.stateNode = vI), fi(vI, RA, k, cA, TA) && rs(a))
                  }
                  a.ref !== null && gk(a)
                }
                return (yQ(a), null)
              }
              case aA: {
                var bI = k
                if (n && a.stateNode != null) {
                  var og = n.memoizedProps
                  vu(n, a, og, bI)
                } else {
                  if (typeof bI != "string" && a.stateNode === null)
                    throw new Error(
                      "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.",
                    )
                  var cg = _D(),
                    cC = Pi(),
                    re = cr(a)
                  re ? zn(a) && rs(a) : (a.stateNode = Yi(bI, cg, cC, a))
                }
                return (yQ(a), null)
              }
              case sA: {
                IE(a)
                var MC = a.memoizedState
                {
                  if (yu() && (a.mode & Ai) !== FC && (a.flags & Qg) === SA)
                    return (ic(a), $n(), (a.flags |= Fg | mA | TI), a)
                  if (MC !== null && MC.dehydrated !== null) {
                    var yt = cr(a)
                    if (n === null) {
                      if (!yt)
                        throw new Error(
                          "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.",
                        )
                      if ((ec(a), yQ(a), (a.mode & Ae) !== FC)) {
                        var Qt = MC !== null
                        if (Qt) {
                          var MI = a.child
                          MI !== null && (a.treeBaseDuration -= MI.treeBaseDuration)
                        }
                      }
                      return null
                    } else {
                      if (
                        ($n(),
                        (a.flags & Qg) === SA && (a.memoizedState = null),
                        (a.flags |= iI),
                        yQ(a),
                        (a.mode & Ae) !== FC)
                      ) {
                        var PI = MC !== null
                        if (PI) {
                          var uI = a.child
                          uI !== null && (a.treeBaseDuration -= uI.treeBaseDuration)
                        }
                      }
                      return null
                    }
                  }
                  FB()
                }
                if ((a.flags & Qg) !== SA) return ((a.lanes = y), (a.mode & Ae) !== FC && Ku(a), a)
                var ug = MC !== null,
                  Og = !1
                if (n === null) cr(a)
                else {
                  var qg = n.memoizedState
                  Og = qg !== null
                }
                if (ug && !Og) {
                  var Ge = a.child
                  if (((Ge.flags |= fe), (a.mode & Ai) !== FC)) {
                    var De = n === null && (a.memoizedProps.unstable_avoidThisFallback !== !0 || !L)
                    De || Yo(AE.current, PD) ? Xd() : Fw()
                  }
                }
                var _i = a.updateQueue
                if ((_i !== null && (a.flags |= iI), yQ(a), (a.mode & Ae) !== FC && ug)) {
                  var oi = a.child
                  oi !== null && (a.treeBaseDuration -= oi.treeBaseDuration)
                }
                return null
              }
              case eA:
                return (Al(a), iS(n, a), n === null && oC(a.stateNode.containerInfo), yQ(a), null)
              case LA:
                var Jt = a.type._context
                return (IA(Jt, a), yQ(a), null)
              case DA: {
                var Ze = a.type
                return (Co(Ze) && kE(a), yQ(a), null)
              }
              case kA: {
                IE(a)
                var Se = a.memoizedState
                if (Se === null) return (yQ(a), null)
                var oB = (a.flags & Qg) !== SA,
                  Zt = Se.rendering
                if (Zt === null)
                  if (oB) fh(Se, !1)
                  else {
                    var yn = $d() && (n === null || (n.flags & Qg) === SA)
                    if (!yn)
                      for (var kQ = a.child; kQ !== null; ) {
                        var pn = Il(kQ)
                        if (pn !== null) {
                          ;((oB = !0), (a.flags |= Qg), fh(Se, !1))
                          var wn = pn.updateQueue
                          return (
                            wn !== null && ((a.updateQueue = wn), (a.flags |= iI)),
                            (a.subtreeFlags = SA),
                            pu(a, y),
                            TE(a, WD(AE.current, oc)),
                            a.child
                          )
                        }
                        kQ = kQ.sibling
                      }
                    Se.tail !== null &&
                      Bi() > wS() &&
                      ((a.flags |= Qg), (oB = !0), fh(Se, !1), (a.lanes = ta))
                  }
                else {
                  if (!oB) {
                    var BE = Il(Zt)
                    if (BE !== null) {
                      ;((a.flags |= Qg), (oB = !0))
                      var Hh = BE.updateQueue
                      if (
                        (Hh !== null && ((a.updateQueue = Hh), (a.flags |= iI)),
                        fh(Se, !0),
                        Se.tail === null && Se.tailMode === "hidden" && !Zt.alternate && !St())
                      )
                        return (yQ(a), null)
                    } // The time it took to render last row is greater than the remaining
                    else
                      // time we have to render. So rendering one more row would likely
                      // exceed it.
                      Bi() * 2 - Se.renderingStartTime > wS() &&
                        y !== Re &&
                        ((a.flags |= Qg), (oB = !0), fh(Se, !1), (a.lanes = ta))
                  }
                  if (Se.isBackwards) ((Zt.sibling = a.child), (a.child = Zt))
                  else {
                    var mc = Se.last
                    ;(mc !== null ? (mc.sibling = Zt) : (a.child = Zt), (Se.last = Zt))
                  }
                }
                if (Se.tail !== null) {
                  var Gn = Se.tail
                  ;((Se.rendering = Gn),
                    (Se.tail = Gn.sibling),
                    (Se.renderingStartTime = Bi()),
                    (Gn.sibling = null))
                  var vc = AE.current
                  return (oB ? (vc = WD(vc, oc)) : (vc = Qs(vc)), TE(a, vc), Gn)
                }
                return (yQ(a), null)
              }
              case NA:
                break
              case qA:
              case ZA: {
                FS(a)
                var I0 = a.memoizedState,
                  g0 = I0 !== null
                if (n !== null) {
                  var BM = n.memoizedState,
                    HR = BM !== null
                  HR !== g0 && // LegacyHidden doesn't do any hiding — it only pre-renders.
                    !F &&
                    (a.flags |= fe)
                }
                return (
                  !g0 || (a.mode & Ai) === FC
                    ? yQ(a)
                    : Ne(iE, Re) && (yQ(a), Wt && a.subtreeFlags & (HA | iI) && (a.flags |= fe)),
                  null
                )
              }
              case sI:
                return null
              case cI:
                return null
            }
            throw new Error(
              "Unknown unit of work tag (" +
                a.tag +
                "). This error is likely caused by a bug in React. Please file an issue.",
            )
          }
          var el = i.ReactCurrentOwner,
            Sn = !1,
            Zp,
            Lu,
            Pp,
            Wp,
            Gd,
            dh,
            Vp,
            tS
          ;((Zp = {}), (Lu = {}), (Pp = {}), (Wp = {}), (Gd = {}), (dh = !1), (Vp = {}), (tS = {}))
          function OQ(n, a, y, k) {
            n === null ? (a.child = OD(a, null, y, k)) : (a.child = $s(a, n.child, y, k))
          }
          function kd(n, a, y, k) {
            ;((a.child = $s(a, n.child, null, k)), (a.child = $s(a, null, y, k)))
          }
          function BS(n, a, y, k, J) {
            if (a.type !== a.elementType) {
              var T = y.propTypes
              T &&
                go(
                  T,
                  k,
                  // Resolved props
                  "prop",
                  VA(y),
                )
            }
            var W = y.render,
              BA = a.ref,
              cA,
              RA
            ;(ng(a, J), HQ(a))
            {
              if (
                ((el.current = a), xQ(!0), (cA = bA(n, a, W, k, BA, J)), (RA = kI()), a.mode & qi)
              ) {
                Ie(!0)
                try {
                  ;((cA = bA(n, a, W, k, BA, J)), (RA = kI()))
                } finally {
                  Ie(!1)
                }
              }
              xQ(!1)
            }
            return (
              IB(),
              n !== null && !Sn
                ? (tg(n, a, J), il(n, a, J))
                : (St() && RA && Cs(a), (a.flags |= NI), OQ(n, a, cA, J), a.child)
            )
          }
          function Yu(n, a, y, k, J) {
            if (n === null) {
              var T = y.type
              if (
                us(T) &&
                y.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
                y.defaultProps === void 0
              ) {
                var W = T
                return ((W = hs(T)), (a.tag = EA), (a.type = W), Iw(a, T), qu(n, a, W, k, J))
              }
              {
                var BA = T.propTypes
                BA &&
                  go(
                    BA,
                    k,
                    // Resolved props
                    "prop",
                    VA(T),
                  )
              }
              var cA = xS(y.type, null, k, a, a.mode, J)
              return ((cA.ref = a.ref), (cA.return = a), (a.child = cA), cA)
            }
            {
              var RA = y.type,
                TA = RA.propTypes
              TA &&
                go(
                  TA,
                  k,
                  // Resolved props
                  "prop",
                  VA(RA),
                )
            }
            var DI = n.child,
              vI = Bw(n, J)
            if (!vI) {
              var bI = DI.memoizedProps,
                og = y.compare
              if (((og = og !== null ? og : Pn), og(bI, k) && n.ref === a.ref)) return il(n, a, J)
            }
            a.flags |= NI
            var cg = Kc(DI, k)
            return ((cg.ref = a.ref), (cg.return = a), (a.child = cg), cg)
          }
          function qu(n, a, y, k, J) {
            if (a.type !== a.elementType) {
              var T = a.elementType
              if (T.$$typeof === FA) {
                var W = T,
                  BA = W._payload,
                  cA = W._init
                try {
                  T = cA(BA)
                } catch {
                  T = null
                }
                var RA = T && T.propTypes
                RA &&
                  go(
                    RA,
                    k,
                    // Resolved (SimpleMemoComponent has no defaultProps)
                    "prop",
                    VA(T),
                  )
              }
            }
            if (n !== null) {
              var TA = n.memoizedProps
              if (
                Pn(TA, k) &&
                n.ref === a.ref && // Prevent bailout if the implementation changed due to hot reload.
                a.type === n.type
              )
                if (((Sn = !1), Bw(n, J))) (n.flags & eg) !== SA && (Sn = !0)
                else return ((a.lanes = n.lanes), il(n, a, J))
            }
            return Bk(n, a, y, k, J)
          }
          function ik(n, a, y) {
            var k = a.pendingProps,
              J = k.children,
              T = n !== null ? n.memoizedState : null
            if (k.mode === "hidden" || F)
              if ((a.mode & Ai) === FC) {
                var W = {
                  baseLanes: Cg,
                  cachePool: null,
                }
                ;((a.memoizedState = W), Jh(a, y))
              } else if (Ne(y, Re)) {
                var DI = {
                  baseLanes: Cg,
                  cachePool: null,
                }
                a.memoizedState = DI
                var vI = T !== null ? T.baseLanes : y
                Jh(a, vI)
              } else {
                var BA = null,
                  cA
                if (T !== null) {
                  var RA = T.baseLanes
                  cA = LC(RA, y)
                } else cA = y
                a.lanes = a.childLanes = Re
                var TA = {
                  baseLanes: cA,
                  cachePool: BA,
                }
                return ((a.memoizedState = TA), (a.updateQueue = null), Jh(a, cA), null)
              }
            else {
              var bI
              ;(T !== null ? ((bI = LC(T.baseLanes, y)), (a.memoizedState = null)) : (bI = y),
                Jh(a, bI))
            }
            return (OQ(n, a, J, y), a.child)
          }
          function jp(n, a, y) {
            var k = a.pendingProps
            return (OQ(n, a, k, y), a.child)
          }
          function zp(n, a, y) {
            var k = a.pendingProps.children
            return (OQ(n, a, k, y), a.child)
          }
          function gR(n, a, y) {
            {
              a.flags |= iI
              {
                var k = a.stateNode
                ;((k.effectDuration = 0), (k.passiveEffectDuration = 0))
              }
            }
            var J = a.pendingProps,
              T = J.children
            return (OQ(n, a, T, y), a.child)
          }
          function tk(n, a) {
            var y = a.ref
            ;((n === null && y !== null) || (n !== null && n.ref !== y)) &&
              ((a.flags |= jC), (a.flags |= OC))
          }
          function Bk(n, a, y, k, J) {
            if (a.type !== a.elementType) {
              var T = y.propTypes
              T &&
                go(
                  T,
                  k,
                  // Resolved props
                  "prop",
                  VA(y),
                )
            }
            var W
            {
              var BA = Lt(a, y, !0)
              W = Yn(a, BA)
            }
            var cA, RA
            ;(ng(a, J), HQ(a))
            {
              if (
                ((el.current = a), xQ(!0), (cA = bA(n, a, y, k, W, J)), (RA = kI()), a.mode & qi)
              ) {
                Ie(!0)
                try {
                  ;((cA = bA(n, a, y, k, W, J)), (RA = kI()))
                } finally {
                  Ie(!1)
                }
              }
              xQ(!1)
            }
            return (
              IB(),
              n !== null && !Sn
                ? (tg(n, a, J), il(n, a, J))
                : (St() && RA && Cs(a), (a.flags |= NI), OQ(n, a, cA, J), a.child)
            )
          }
          function Qk(n, a, y, k, J) {
            {
              switch (ry(a)) {
                case !1: {
                  var T = a.stateNode,
                    W = a.type,
                    BA = new W(a.memoizedProps, T.context),
                    cA = BA.state
                  T.updater.enqueueSetState(T, cA, null)
                  break
                }
                case !0: {
                  ;((a.flags |= Qg), (a.flags |= TI))
                  var RA = new Error("Simulated error coming from DevTools"),
                    TA = oa(J)
                  a.lanes = LC(a.lanes, TA)
                  var DI = mu(a, gS(RA, a), TA)
                  oe(a, DI)
                  break
                }
              }
              if (a.type !== a.elementType) {
                var vI = y.propTypes
                vI &&
                  go(
                    vI,
                    k,
                    // Resolved props
                    "prop",
                    VA(y),
                  )
              }
            }
            var bI
            ;(Co(y) ? ((bI = !0), yi(a)) : (bI = !1), ng(a, J))
            var og = a.stateNode,
              cg
            og === null
              ? (n !== null && ((n.alternate = null), (a.alternate = null), (a.flags |= HA)),
                $c(a, y, k),
                Ic(a, y, k, J),
                (cg = !0))
              : n === null
                ? (cg = Du(a, y, k, J))
                : (cg = $f(n, a, y, k, J))
            var cC = Xp(n, a, y, cg, bI, J)
            {
              var re = a.stateNode
              cg &&
                re.props !== k &&
                (dh ||
                  s(
                    "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
                    $I(a) || "a component",
                  ),
                (dh = !0))
            }
            return cC
          }
          function Xp(n, a, y, k, J, T) {
            tk(n, a)
            var W = (a.flags & Qg) !== SA
            if (!k && !W) return (J && ja(a, y, !1), il(n, a, T))
            var BA = a.stateNode
            el.current = a
            var cA
            if (W && typeof y.getDerivedStateFromError != "function") ((cA = null), rc())
            else {
              HQ(a)
              {
                if ((xQ(!0), (cA = BA.render()), a.mode & qi)) {
                  Ie(!0)
                  try {
                    BA.render()
                  } finally {
                    Ie(!1)
                  }
                }
                xQ(!1)
              }
              IB()
            }
            return (
              (a.flags |= NI),
              n !== null && W ? kd(n, a, cA, T) : OQ(n, a, cA, T),
              (a.memoizedState = BA.state),
              J && ja(a, y, !0),
              a.child
            )
          }
          function ok(n) {
            var a = n.stateNode
            ;(a.pendingContext
              ? Go(n, a.pendingContext, a.pendingContext !== a.context)
              : a.context && Go(n, a.context, !1),
              Bs(n, a.containerInfo))
          }
          function CR(n, a, y) {
            if ((ok(a), n === null))
              throw new Error("Should have a current fiber. This is a bug in React.")
            var k = a.pendingProps,
              J = a.memoizedState,
              T = J.element
            ;(WC(n, a), sr(a, k, null, y))
            var W = a.memoizedState
            a.stateNode
            var BA = W.element
            if (Ui && J.isDehydrated) {
              var cA = {
                  element: BA,
                  isDehydrated: !1,
                  cache: W.cache,
                  transitions: W.transitions,
                },
                RA = a.updateQueue
              if (((RA.baseState = cA), (a.memoizedState = cA), a.flags & Fg)) {
                var TA = new Error(
                  "There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.",
                )
                return nk(n, a, BA, y, TA)
              } else if (BA !== T) {
                var DI = new Error(
                  "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.",
                )
                return nk(n, a, BA, y, DI)
              } else {
                Ih(a)
                var vI = OD(a, null, BA, y)
                a.child = vI
                for (var bI = vI; bI; ) ((bI.flags = (bI.flags & ~HA) | Ee), (bI = bI.sibling))
              }
            } else {
              if (($n(), BA === T)) return il(n, a, y)
              OQ(n, a, BA, y)
            }
            return a.child
          }
          function nk(n, a, y, k, J) {
            return ($n(), et(J), (a.flags |= Fg), OQ(n, a, y, k), a.child)
          }
          function eR(n, a, y) {
            ;(Id(a), n === null && Cc(a))
            var k = a.type,
              J = a.pendingProps,
              T = n !== null ? n.memoizedProps : null,
              W = J.children,
              BA = Et(k, J)
            return (
              BA ? (W = null) : T !== null && Et(k, T) && (a.flags |= dg),
              tk(n, a),
              OQ(n, a, W, y),
              a.child
            )
          }
          function $p(n, a) {
            return (n === null && Cc(a), null)
          }
          function iR(n, a, y, k) {
            n !== null && ((n.alternate = null), (a.alternate = null), (a.flags |= HA))
            var J = a.pendingProps,
              T = y,
              W = T._payload,
              BA = T._init,
              cA = BA(W)
            a.type = cA
            var RA = (a.tag = Ua(cA)),
              TA = ue(cA, J),
              DI
            switch (RA) {
              case P:
                return (Iw(a, cA), (a.type = cA = hs(cA)), (DI = Bk(null, a, cA, TA, k)), DI)
              case AA:
                return ((a.type = cA = vw(cA)), (DI = Qk(null, a, cA, TA, k)), DI)
              case nA:
                return ((a.type = cA = Lw(cA)), (DI = BS(null, a, cA, TA, k)), DI)
              case $: {
                if (a.type !== a.elementType) {
                  var vI = cA.propTypes
                  vI &&
                    go(
                      vI,
                      TA,
                      // Resolved for outer only
                      "prop",
                      VA(cA),
                    )
                }
                return (
                  (DI = Yu(
                    null,
                    a,
                    cA,
                    ue(cA.type, TA),
                    // The inner type can have defaults too
                    k,
                  )),
                  DI
                )
              }
            }
            var bI = ""
            throw (
              cA !== null &&
                typeof cA == "object" &&
                cA.$$typeof === FA &&
                (bI = " Did you wrap a component in React.lazy() more than once?"),
              new Error(
                "Element type is invalid. Received a promise that resolves to: " +
                  cA +
                  ". " +
                  ("Lazy element type must resolve to a class or function." + bI),
              )
            )
          }
          function tR(n, a, y, k, J) {
            ;(n !== null && ((n.alternate = null), (a.alternate = null), (a.flags |= HA)),
              (a.tag = AA))
            var T
            return (
              Co(y) ? ((T = !0), yi(a)) : (T = !1),
              ng(a, J),
              $c(a, y, k),
              Ic(a, y, k, J),
              Xp(null, a, y, !0, T, J)
            )
          }
          function Aw(n, a, y, k) {
            n !== null && ((n.alternate = null), (a.alternate = null), (a.flags |= HA))
            var J = a.pendingProps,
              T
            {
              var W = Lt(a, y, !1)
              T = Yn(a, W)
            }
            ng(a, k)
            var BA, cA
            HQ(a)
            {
              if (y.prototype && typeof y.prototype.render == "function") {
                var RA = VA(y) || "Unknown"
                Zp[RA] ||
                  (s(
                    "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
                    RA,
                    RA,
                  ),
                  (Zp[RA] = !0))
              }
              ;(a.mode & qi && fQ.recordLegacyContextWarning(a, null),
                xQ(!0),
                (el.current = a),
                (BA = bA(null, a, y, J, T, k)),
                (cA = kI()),
                xQ(!1))
            }
            if (
              (IB(),
              (a.flags |= NI),
              typeof BA == "object" &&
                BA !== null &&
                typeof BA.render == "function" &&
                BA.$$typeof === void 0)
            ) {
              var TA = VA(y) || "Unknown"
              Lu[TA] ||
                (s(
                  "The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.",
                  TA,
                  TA,
                  TA,
                ),
                (Lu[TA] = !0))
            }
            if (
              // Run these checks in production only if the flag is off.
              // Eventually we'll delete this branch altogether.
              typeof BA == "object" &&
              BA !== null &&
              typeof BA.render == "function" &&
              BA.$$typeof === void 0
            ) {
              {
                var DI = VA(y) || "Unknown"
                Lu[DI] ||
                  (s(
                    "The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.",
                    DI,
                    DI,
                    DI,
                  ),
                  (Lu[DI] = !0))
              }
              ;((a.tag = AA), (a.memoizedState = null), (a.updateQueue = null))
              var vI = !1
              return (
                Co(y) ? ((vI = !0), yi(a)) : (vI = !1),
                (a.memoizedState = BA.state !== null && BA.state !== void 0 ? BA.state : null),
                Zg(a),
                uu(a, BA),
                Ic(a, y, J, k),
                Xp(null, a, y, !0, vI, k)
              )
            } else {
              if (((a.tag = P), a.mode & qi)) {
                Ie(!0)
                try {
                  ;((BA = bA(null, a, y, J, T, k)), (cA = kI()))
                } finally {
                  Ie(!1)
                }
              }
              return (St() && cA && Cs(a), OQ(null, a, BA, k), Iw(a, y), a.child)
            }
          }
          function Iw(n, a) {
            {
              if (
                (a &&
                  a.childContextTypes &&
                  s(
                    "%s(...): childContextTypes cannot be defined on a function component.",
                    a.displayName || a.name || "Component",
                  ),
                n.ref !== null)
              ) {
                var y = "",
                  k = Vl()
                k &&
                  (y +=
                    `

Check the render method of \`` +
                    k +
                    "`.")
                var J = k || "",
                  T = n._debugSource
                ;(T && (J = T.fileName + ":" + T.lineNumber),
                  Gd[J] ||
                    ((Gd[J] = !0),
                    s(
                      "Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s",
                      y,
                    )))
              }
              if (typeof a.getDerivedStateFromProps == "function") {
                var W = VA(a) || "Unknown"
                Wp[W] ||
                  (s("%s: Function components do not support getDerivedStateFromProps.", W),
                  (Wp[W] = !0))
              }
              if (typeof a.contextType == "object" && a.contextType !== null) {
                var BA = VA(a) || "Unknown"
                Pp[BA] ||
                  (s("%s: Function components do not support contextType.", BA), (Pp[BA] = !0))
              }
            }
          }
          var Hu = {
            dehydrated: null,
            treeContext: null,
            retryLane: TC,
          }
          function QS(n) {
            return {
              baseLanes: n,
              cachePool: IR(),
            }
          }
          function Ek(n, a) {
            var y = null
            return {
              baseLanes: LC(n.baseLanes, a),
              cachePool: y,
            }
          }
          function BR(n, a, y, k) {
            if (a !== null) {
              var J = a.memoizedState
              if (J === null) return !1
            }
            return Yo(n, oc)
          }
          function ak(n, a) {
            return Yt(n.childLanes, a)
          }
          function rk(n, a, y) {
            var k = a.pendingProps
            sy(a) && (a.flags |= Qg)
            var J = AE.current,
              T = !1,
              W = (a.flags & Qg) !== SA
            if (
              (W || BR(J, n)
                ? ((T = !0), (a.flags &= ~Qg))
                : (n === null || n.memoizedState !== null) && (J = os(J, PD)),
              (J = Qs(J)),
              TE(a, J),
              n === null)
            ) {
              Cc(a)
              {
                var BA = a.memoizedState
                if (BA !== null) {
                  var cA = BA.dehydrated
                  if (cA !== null) return Cw(a, cA)
                }
              }
              var RA = k.children,
                TA = k.fallback
              if (T) {
                var DI = QR(a, RA, TA, y),
                  vI = a.child
                return ((vI.memoizedState = QS(y)), (a.memoizedState = Hu), DI)
              } else return Md(a, RA)
            } else {
              var bI = n.memoizedState
              if (bI !== null) {
                {
                  var og = bI.dehydrated
                  if (og !== null)
                    if (W) {
                      if (a.flags & Fg)
                        return (
                          (a.flags &= ~Fg),
                          Ud(
                            n,
                            a,
                            y,
                            new Error(
                              "There was an error while hydrating this Suspense boundary. Switched to client rendering.",
                            ),
                          )
                        )
                      if (a.memoizedState !== null)
                        return ((a.child = n.child), (a.flags |= Qg), null)
                      var cg = k.children,
                        cC = k.fallback,
                        re = oR(n, a, cg, cC, y),
                        MC = a.child
                      return ((MC.memoizedState = QS(y)), (a.memoizedState = Hu), re)
                    } else return nR(n, a, og, bI, y)
                }
                if (T) {
                  var yt = k.fallback,
                    Qt = k.children,
                    MI = ck(n, a, Qt, yt, y),
                    PI = a.child,
                    uI = n.child.memoizedState
                  return (
                    (PI.memoizedState = uI === null ? QS(y) : Ek(uI, y)),
                    (PI.childLanes = ak(n, y)),
                    (a.memoizedState = Hu),
                    MI
                  )
                } else {
                  var ug = k.children,
                    Og = lk(n, a, ug, y)
                  return ((a.memoizedState = null), Og)
                }
              } else if (T) {
                var qg = k.fallback,
                  Ge = k.children,
                  De = ck(n, a, Ge, qg, y),
                  _i = a.child,
                  oi = n.child.memoizedState
                return (
                  (_i.memoizedState = oi === null ? QS(y) : Ek(oi, y)),
                  (_i.childLanes = ak(n, y)),
                  (a.memoizedState = Hu),
                  De
                )
              } else {
                var Jt = k.children,
                  Ze = lk(n, a, Jt, y)
                return ((a.memoizedState = null), Ze)
              }
            }
          }
          function Md(n, a, y) {
            var k = n.mode,
              J = {
                mode: "visible",
                children: a,
              },
              T = gw(J, k)
            return ((T.return = n), (n.child = T), T)
          }
          function QR(n, a, y, k) {
            var J = n.mode,
              T = n.child,
              W = {
                mode: "hidden",
                children: a,
              },
              BA,
              cA
            return (
              (J & Ai) === FC && T !== null
                ? ((BA = T),
                  (BA.childLanes = Cg),
                  (BA.pendingProps = W),
                  n.mode & Ae &&
                    ((BA.actualDuration = 0),
                    (BA.actualStartTime = -1),
                    (BA.selfBaseDuration = 0),
                    (BA.treeBaseDuration = 0)),
                  (cA = Yh(y, J, k, null)))
                : ((BA = gw(W, J)), (cA = Yh(y, J, k, null))),
              (BA.return = n),
              (cA.return = n),
              (BA.sibling = cA),
              (n.child = BA),
              cA
            )
          }
          function gw(n, a, y) {
            return xw(n, a, Cg, null)
          }
          function sk(n, a) {
            return Kc(n, a)
          }
          function lk(n, a, y, k) {
            var J = n.child,
              T = J.sibling,
              W = sk(J, {
                mode: "visible",
                children: y,
              })
            if (
              ((a.mode & Ai) === FC && (W.lanes = k),
              (W.return = a),
              (W.sibling = null),
              T !== null)
            ) {
              var BA = a.deletions
              BA === null ? ((a.deletions = [T]), (a.flags |= qI)) : BA.push(T)
            }
            return ((a.child = W), W)
          }
          function ck(n, a, y, k, J) {
            var T = a.mode,
              W = n.child,
              BA = W.sibling,
              cA = {
                mode: "hidden",
                children: y,
              },
              RA
            if (
              // In legacy mode, we commit the primary tree as if it successfully
              // completed, even though it's in an inconsistent state.
              (T & Ai) === FC && // Make sure we're on the second pass, i.e. the primary child fragment was
              // already cloned. In legacy mode, the only case where this isn't true is
              // when DevTools forces us to display a fallback; we skip the first render
              // pass entirely and go straight to rendering the fallback. (In Concurrent
              // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
              // only codepath.)
              a.child !== W
            ) {
              var TA = a.child
              ;((RA = TA),
                (RA.childLanes = Cg),
                (RA.pendingProps = cA),
                a.mode & Ae &&
                  ((RA.actualDuration = 0),
                  (RA.actualStartTime = -1),
                  (RA.selfBaseDuration = W.selfBaseDuration),
                  (RA.treeBaseDuration = W.treeBaseDuration)),
                (a.deletions = null))
            } else ((RA = sk(W, cA)), (RA.subtreeFlags = W.subtreeFlags & EI))
            var DI
            return (
              BA !== null ? (DI = Kc(BA, k)) : ((DI = Yh(k, T, J, null)), (DI.flags |= HA)),
              (DI.return = a),
              (RA.return = a),
              (RA.sibling = DI),
              (a.child = RA),
              DI
            )
          }
          function Ud(n, a, y, k) {
            ;(k !== null && et(k), $s(a, n.child, null, y))
            var J = a.pendingProps,
              T = J.children,
              W = Md(a, T)
            return ((W.flags |= HA), (a.memoizedState = null), W)
          }
          function oR(n, a, y, k, J) {
            var T = a.mode,
              W = {
                mode: "visible",
                children: y,
              },
              BA = gw(W, T),
              cA = Yh(k, T, J, null)
            return (
              (cA.flags |= HA),
              (BA.return = a),
              (cA.return = a),
              (BA.sibling = cA),
              (a.child = BA),
              (a.mode & Ai) !== FC && $s(a, n.child, null, J),
              cA
            )
          }
          function Cw(n, a, y) {
            return (
              (n.mode & Ai) === FC
                ? (s(
                    "Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.",
                  ),
                  (n.lanes = PC))
                : we(a)
                  ? (n.lanes = qn)
                  : (n.lanes = Re),
              null
            )
          }
          function nR(n, a, y, k, J) {
            if ((gc(), (a.mode & Ai) === FC))
              return Ud(
                n,
                a,
                J,
                // TODO: When we delete legacy mode, we should make this error argument
                // required — every concurrent mode path that causes hydration to
                // de-opt to client rendering should have an error message.
                null,
              )
            if (we(y))
              return Ud(
                n,
                a,
                J,
                // TODO: The server should serialize the error message so we can log it
                // here on the client. Or, in production, a hash/id that corresponds to
                // the error.
                new Error(
                  "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.",
                ),
              )
            var T = Ne(J, n.childLanes)
            if (Sn || T) {
              var W = NS()
              if (W !== null) {
                var BA = _B(W, J)
                if (BA !== TC && BA !== k.retryLane) {
                  k.retryLane = BA
                  var cA = Je
                  wQ(n, BA, cA)
                }
              }
              return (
                Fw(),
                Ud(
                  n,
                  a,
                  J,
                  new Error(
                    "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.",
                  ),
                )
              )
            } else if (ie(y)) {
              ;((a.flags |= Qg), (a.child = n.child))
              var RA = mw.bind(null, n)
              return (le(y, RA), null)
            } else {
              zs(a, y, k.treeContext)
              var TA = a.pendingProps,
                DI = TA.children,
                vI = Md(a, DI)
              return ((vI.flags |= Ee), vI)
            }
          }
          function hk(n, a, y) {
            n.lanes = LC(n.lanes, a)
            var k = n.alternate
            ;(k !== null && (k.lanes = LC(k.lanes, a)), UA(n.return, a, y))
          }
          function ER(n, a, y) {
            for (var k = a; k !== null; ) {
              if (k.tag === sA) {
                var J = k.memoizedState
                J !== null && hk(k, y, n)
              } else if (k.tag === kA) hk(k, y, n)
              else if (k.child !== null) {
                ;((k.child.return = k), (k = k.child))
                continue
              }
              if (k === n) return
              for (; k.sibling === null; ) {
                if (k.return === null || k.return === n) return
                k = k.return
              }
              ;((k.sibling.return = k.return), (k = k.sibling))
            }
          }
          function aR(n) {
            for (var a = n, y = null; a !== null; ) {
              var k = a.alternate
              ;(k !== null && Il(k) === null && (y = a), (a = a.sibling))
            }
            return y
          }
          function rR(n) {
            if (n !== void 0 && n !== "forwards" && n !== "backwards" && n !== "together" && !Vp[n])
              if (((Vp[n] = !0), typeof n == "string"))
                switch (n.toLowerCase()) {
                  case "together":
                  case "forwards":
                  case "backwards": {
                    s(
                      '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                      n,
                      n.toLowerCase(),
                    )
                    break
                  }
                  case "forward":
                  case "backward": {
                    s(
                      '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                      n,
                      n.toLowerCase(),
                    )
                    break
                  }
                  default:
                    s(
                      '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
                      n,
                    )
                    break
                }
              else
                s(
                  '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
                  n,
                )
          }
          function sR(n, a) {
            n !== void 0 &&
              !tS[n] &&
              (n !== "collapsed" && n !== "hidden"
                ? ((tS[n] = !0),
                  s(
                    '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?',
                    n,
                  ))
                : a !== "forwards" &&
                  a !== "backwards" &&
                  ((tS[n] = !0),
                  s(
                    '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
                    n,
                  )))
          }
          function uk(n, a) {
            {
              var y = _C(n),
                k = !y && typeof OA(n) == "function"
              if (y || k) {
                var J = y ? "array" : "iterable"
                return (
                  s(
                    "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
                    J,
                    a,
                    J,
                  ),
                  !1
                )
              }
            }
            return !0
          }
          function lR(n, a) {
            if ((a === "forwards" || a === "backwards") && n !== void 0 && n !== null && n !== !1)
              if (_C(n)) {
                for (var y = 0; y < n.length; y++) if (!uk(n[y], y)) return
              } else {
                var k = OA(n)
                if (typeof k == "function") {
                  var J = k.call(n)
                  if (J)
                    for (var T = J.next(), W = 0; !T.done; T = J.next()) {
                      if (!uk(T.value, W)) return
                      W++
                    }
                } else
                  s(
                    'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
                    a,
                  )
              }
          }
          function ew(n, a, y, k, J) {
            var T = n.memoizedState
            T === null
              ? (n.memoizedState = {
                  isBackwards: a,
                  rendering: null,
                  renderingStartTime: 0,
                  last: k,
                  tail: y,
                  tailMode: J,
                })
              : ((T.isBackwards = a),
                (T.rendering = null),
                (T.renderingStartTime = 0),
                (T.last = k),
                (T.tail = y),
                (T.tailMode = J))
          }
          function iw(n, a, y) {
            var k = a.pendingProps,
              J = k.revealOrder,
              T = k.tail,
              W = k.children
            ;(rR(J), sR(T, J), lR(W, J), OQ(n, a, W, y))
            var BA = AE.current,
              cA = Yo(BA, oc)
            if (cA) ((BA = WD(BA, oc)), (a.flags |= Qg))
            else {
              var RA = n !== null && (n.flags & Qg) !== SA
              ;(RA && ER(a, a.child, y), (BA = Qs(BA)))
            }
            if ((TE(a, BA), (a.mode & Ai) === FC)) a.memoizedState = null
            else
              switch (J) {
                case "forwards": {
                  var TA = aR(a.child),
                    DI
                  ;(TA === null
                    ? ((DI = a.child), (a.child = null))
                    : ((DI = TA.sibling), (TA.sibling = null)),
                    ew(
                      a,
                      !1,
                      // isBackwards
                      DI,
                      TA,
                      T,
                    ))
                  break
                }
                case "backwards": {
                  var vI = null,
                    bI = a.child
                  for (a.child = null; bI !== null; ) {
                    var og = bI.alternate
                    if (og !== null && Il(og) === null) {
                      a.child = bI
                      break
                    }
                    var cg = bI.sibling
                    ;((bI.sibling = vI), (vI = bI), (bI = cg))
                  }
                  ew(
                    a,
                    !0,
                    // isBackwards
                    vI,
                    null,
                    // last
                    T,
                  )
                  break
                }
                case "together": {
                  ew(
                    a,
                    !1,
                    // isBackwards
                    null,
                    // tail
                    null,
                    // last
                    void 0,
                  )
                  break
                }
                default:
                  a.memoizedState = null
              }
            return a.child
          }
          function tw(n, a, y) {
            Bs(a, a.stateNode.containerInfo)
            var k = a.pendingProps
            return (n === null ? (a.child = $s(a, null, k, y)) : OQ(n, a, k, y), a.child)
          }
          var Dk = !1
          function cR(n, a, y) {
            var k = a.type,
              J = k._context,
              T = a.pendingProps,
              W = a.memoizedProps,
              BA = T.value
            {
              "value" in T ||
                Dk ||
                ((Dk = !0),
                s(
                  "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?",
                ))
              var cA = a.type.propTypes
              cA && go(cA, T, "prop", "Context.Provider")
            }
            if ((O(a, J, BA), W !== null)) {
              var RA = W.value
              if (ci(RA, BA)) {
                if (W.children === T.children && !kt()) return il(n, a, y)
              } else CI(a, J, y)
            }
            var TA = T.children
            return (OQ(n, a, TA, y), a.child)
          }
          var oS = !1
          function nS(n, a, y) {
            var k = a.type
            k._context === void 0
              ? k !== k.Consumer &&
                (oS ||
                  ((oS = !0),
                  s(
                    "Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?",
                  )))
              : (k = k._context)
            var J = a.pendingProps,
              T = J.children
            ;(typeof T != "function" &&
              s(
                "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.",
              ),
              ng(a, y))
            var W = Sg(k)
            HQ(a)
            var BA
            return (
              (el.current = a),
              xQ(!0),
              (BA = T(W)),
              xQ(!1),
              IB(),
              (a.flags |= NI),
              OQ(n, a, BA, y),
              a.child
            )
          }
          function Nd() {
            Sn = !0
          }
          function il(n, a, y) {
            return (
              n !== null && (a.dependencies = n.dependencies),
              rc(),
              zd(a.lanes),
              Ne(y, a.childLanes) ? (Bh(n, a), a.child) : null
            )
          }
          function hR(n, a, y) {
            {
              var k = a.return
              if (k === null) throw new Error("Cannot swap the root fiber.")
              if (
                ((n.alternate = null),
                (a.alternate = null),
                (y.index = a.index),
                (y.sibling = a.sibling),
                (y.return = a.return),
                (y.ref = a.ref),
                a === k.child)
              )
                k.child = y
              else {
                var J = k.child
                if (J === null) throw new Error("Expected parent to have a child.")
                for (; J.sibling !== a; )
                  if (((J = J.sibling), J === null))
                    throw new Error("Expected to find the previous sibling.")
                J.sibling = y
              }
              var T = k.deletions
              return (
                T === null ? ((k.deletions = [n]), (k.flags |= qI)) : T.push(n),
                (y.flags |= HA),
                y
              )
            }
          }
          function Bw(n, a) {
            var y = n.lanes
            return !!Ne(y, a)
          }
          function uR(n, a, y) {
            switch (a.tag) {
              case _:
                ;(ok(a), a.stateNode, $n())
                break
              case CA:
                Id(a)
                break
              case AA: {
                var k = a.type
                Co(k) && yi(a)
                break
              }
              case eA:
                Bs(a, a.stateNode.containerInfo)
                break
              case LA: {
                var J = a.memoizedProps.value,
                  T = a.type._context
                O(a, T, J)
                break
              }
              case fA:
                {
                  var W = Ne(y, a.childLanes)
                  W && (a.flags |= iI)
                  {
                    var BA = a.stateNode
                    ;((BA.effectDuration = 0), (BA.passiveEffectDuration = 0))
                  }
                }
                break
              case sA: {
                var cA = a.memoizedState
                if (cA !== null) {
                  if (cA.dehydrated !== null) return (TE(a, Qs(AE.current)), (a.flags |= Qg), null)
                  var RA = a.child,
                    TA = RA.childLanes
                  if (Ne(y, TA)) return rk(n, a, y)
                  TE(a, Qs(AE.current))
                  var DI = il(n, a, y)
                  return DI !== null ? DI.sibling : null
                } else TE(a, Qs(AE.current))
                break
              }
              case kA: {
                var vI = (n.flags & Qg) !== SA,
                  bI = Ne(y, a.childLanes)
                if (vI) {
                  if (bI) return iw(n, a, y)
                  a.flags |= Qg
                }
                var og = a.memoizedState
                if (
                  (og !== null && ((og.rendering = null), (og.tail = null), (og.lastEffect = null)),
                  TE(a, AE.current),
                  bI)
                )
                  break
                return null
              }
              case qA:
              case ZA:
                return ((a.lanes = Cg), ik(n, a, y))
            }
            return il(n, a, y)
          }
          function Sk(n, a, y) {
            if (a._debugNeedsRemount && n !== null)
              return hR(
                n,
                a,
                xS(a.type, a.key, a.pendingProps, a._debugOwner || null, a.mode, a.lanes),
              )
            if (n !== null) {
              var k = n.memoizedProps,
                J = a.pendingProps
              if (
                k !== J ||
                kt() || // Force a re-render if the implementation changed due to hot reload:
                a.type !== n.type
              )
                Sn = !0
              else {
                var T = Bw(n, y)
                if (
                  !T && // If this is the second pass of an error or suspense boundary, there
                  // may not be work scheduled on `current`, so we check for this flag.
                  (a.flags & Qg) === SA
                )
                  return ((Sn = !1), uR(n, a, y))
                ;(n.flags & eg) !== SA ? (Sn = !0) : (Sn = !1)
              }
            } else if (((Sn = !1), St() && zB(a))) {
              var W = a.index,
                BA = Ad()
              Su(a, BA, W)
            }
            switch (((a.lanes = Cg), a.tag)) {
              case X:
                return Aw(n, a, a.type, y)
              case GA: {
                var cA = a.elementType
                return iR(n, a, cA, y)
              }
              case P: {
                var RA = a.type,
                  TA = a.pendingProps,
                  DI = a.elementType === RA ? TA : ue(RA, TA)
                return Bk(n, a, RA, DI, y)
              }
              case AA: {
                var vI = a.type,
                  bI = a.pendingProps,
                  og = a.elementType === vI ? bI : ue(vI, bI)
                return Qk(n, a, vI, og, y)
              }
              case _:
                return CR(n, a, y)
              case CA:
                return eR(n, a, y)
              case aA:
                return $p(n, a)
              case sA:
                return rk(n, a, y)
              case eA:
                return tw(n, a, y)
              case nA: {
                var cg = a.type,
                  cC = a.pendingProps,
                  re = a.elementType === cg ? cC : ue(cg, cC)
                return BS(n, a, cg, re, y)
              }
              case lA:
                return jp(n, a, y)
              case JA:
                return zp(n, a, y)
              case fA:
                return gR(n, a, y)
              case LA:
                return cR(n, a, y)
              case yA:
                return nS(n, a, y)
              case $: {
                var MC = a.type,
                  yt = a.pendingProps,
                  Qt = ue(MC, yt)
                if (a.type !== a.elementType) {
                  var MI = MC.propTypes
                  MI &&
                    go(
                      MI,
                      Qt,
                      // Resolved for outer only
                      "prop",
                      VA(MC),
                    )
                }
                return ((Qt = ue(MC.type, Qt)), Yu(n, a, MC, Qt, y))
              }
              case EA:
                return qu(n, a, a.type, a.pendingProps, y)
              case DA: {
                var PI = a.type,
                  uI = a.pendingProps,
                  ug = a.elementType === PI ? uI : ue(PI, uI)
                return tR(n, a, PI, ug, y)
              }
              case kA:
                return iw(n, a, y)
              case NA:
                break
              case qA:
                return ik(n, a, y)
            }
            throw new Error(
              "Unknown unit of work tag (" +
                a.tag +
                "). This error is likely caused by a bug in React. Please file an issue.",
            )
          }
          function DR(n, a, y) {
            switch ((xD(a), a.tag)) {
              case AA: {
                var k = a.type
                Co(k) && kE(a)
                var J = a.flags
                return J & TI
                  ? ((a.flags = (J & ~TI) | Qg), (a.mode & Ae) !== FC && Ku(a), a)
                  : null
              }
              case _: {
                ;(Al(a), tn(a), nc())
                var T = a.flags
                return (T & TI) !== SA && (T & Qg) === SA ? ((a.flags = (T & ~TI) | Qg), a) : null
              }
              case CA:
                return (wu(a), null)
              case sA: {
                IE(a)
                {
                  var W = a.memoizedState
                  if (W !== null && W.dehydrated !== null) {
                    if (a.alternate === null)
                      throw new Error(
                        "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.",
                      )
                    $n()
                  }
                }
                var BA = a.flags
                return BA & TI
                  ? ((a.flags = (BA & ~TI) | Qg), (a.mode & Ae) !== FC && Ku(a), a)
                  : null
              }
              case kA:
                return (IE(a), null)
              case eA:
                return (Al(a), null)
              case LA:
                var cA = a.type._context
                return (IA(cA, a), null)
              case qA:
              case ZA:
                return (FS(a), null)
              case sI:
                return null
              default:
                return null
            }
          }
          function Qw(n, a, y) {
            switch ((xD(a), a.tag)) {
              case AA: {
                var k = a.type.childContextTypes
                k != null && kE(a)
                break
              }
              case _: {
                ;(Al(a), tn(a), nc())
                break
              }
              case CA: {
                wu(a)
                break
              }
              case eA:
                Al(a)
                break
              case sA:
                IE(a)
                break
              case kA:
                IE(a)
                break
              case LA:
                var J = a.type._context
                IA(J, a)
                break
              case qA:
              case ZA:
                FS(a)
                break
            }
          }
          function fk(n, a, y, k, J, T, W, BA, cA) {
            var RA = Array.prototype.slice.call(arguments, 3)
            try {
              a.apply(y, RA)
            } catch (TA) {
              this.onError(TA)
            }
          }
          var dk = fk
          if (
            typeof window < "u" &&
            typeof window.dispatchEvent == "function" &&
            typeof document < "u" &&
            typeof document.createEvent == "function"
          ) {
            var ow = document.createElement("react")
            dk = function (a, y, k, J, T, W, BA, cA, RA) {
              if (typeof document > "u" || document === null)
                throw new Error(
                  "The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.",
                )
              var TA = document.createEvent("Event"),
                DI = !1,
                vI = !0,
                bI = window.event,
                og = Object.getOwnPropertyDescriptor(window, "event")
              function cg() {
                ;(ow.removeEventListener(PI, re, !1),
                  typeof window.event < "u" &&
                    window.hasOwnProperty("event") &&
                    (window.event = bI))
              }
              var cC = Array.prototype.slice.call(arguments, 3)
              function re() {
                ;((DI = !0), cg(), y.apply(k, cC), (vI = !1))
              }
              var MC,
                yt = !1,
                Qt = !1
              function MI(uI) {
                if (
                  ((MC = uI.error),
                  (yt = !0),
                  MC === null && uI.colno === 0 && uI.lineno === 0 && (Qt = !0),
                  uI.defaultPrevented && MC != null && typeof MC == "object")
                )
                  try {
                    MC._suppressLogging = !0
                  } catch {}
              }
              var PI = "react-" + (a || "invokeguardedcallback")
              if (
                (window.addEventListener("error", MI),
                ow.addEventListener(PI, re, !1),
                TA.initEvent(PI, !1, !1),
                ow.dispatchEvent(TA),
                og && Object.defineProperty(window, "event", og),
                DI &&
                  vI &&
                  (yt
                    ? Qt &&
                      (MC = new Error(
                        "A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.",
                      ))
                    : (MC = new Error(
                        `An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`,
                      )),
                  this.onError(MC)),
                window.removeEventListener("error", MI),
                !DI)
              )
                return (cg(), fk.apply(this, arguments))
            }
          }
          var SR = dk,
            ES = !1,
            Fd = null,
            fR = {
              onError: function (n) {
                ;((ES = !0), (Fd = n))
              },
            }
          function yk(n, a, y, k, J, T, W, BA, cA) {
            ;((ES = !1), (Fd = null), SR.apply(fR, arguments))
          }
          function dR() {
            return ES
          }
          function pk() {
            if (ES) {
              var n = Fd
              return ((ES = !1), (Fd = null), n)
            } else
              throw new Error(
                "clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.",
              )
          }
          var wk = null
          wk = /* @__PURE__ */ new Set()
          var Rd = !1,
            sc = !1,
            yR = typeof WeakSet == "function" ? WeakSet : Set,
            vg = null,
            Tu = null,
            Dr = null
          function uB(n) {
            ;(yk(null, function () {
              throw n
            }),
              pk())
          }
          var nw = function (n, a) {
            if (((a.props = n.memoizedProps), (a.state = n.memoizedState), n.mode & Ae))
              try {
                ;(Ho(), a.componentWillUnmount())
              } finally {
                CE(n)
              }
            else a.componentWillUnmount()
          }
          function xu(n, a) {
            try {
              pa(Ot, n)
            } catch (y) {
              ;(uB(y), Bt(n, a, y))
            }
          }
          function aS(n, a, y) {
            try {
              nw(n, y)
            } catch (k) {
              ;(uB(k), Bt(n, a, k))
            }
          }
          function pR(n, a, y) {
            try {
              y.componentDidMount()
            } catch (k) {
              ;(uB(k), Bt(n, a, k))
            }
          }
          function Gk(n, a) {
            try {
              lS(n)
            } catch (y) {
              ;(uB(y), Bt(n, a, y))
            }
          }
          function Jd(n, a) {
            var y = n.ref
            if (y !== null)
              if (typeof y == "function") {
                var k
                try {
                  if (V && j && n.mode & Ae)
                    try {
                      ;(Ho(), (k = y(null)))
                    } finally {
                      CE(n)
                    }
                  else k = y(null)
                } catch (J) {
                  ;(uB(J), Bt(n, a, J))
                }
                typeof k == "function" &&
                  s(
                    "Unexpected return value from a callback ref in %s. A callback ref should not return a function.",
                    $I(n),
                  )
              } else y.current = null
          }
          function lc(n, a, y) {
            try {
              y()
            } catch (k) {
              ;(uB(k), Bt(n, a, k))
            }
          }
          var rS = !1
          function kk(n, a) {
            ;(pe(n.containerInfo), (vg = a), sS())
            var y = rS
            return ((rS = !1), y)
          }
          function sS() {
            for (; vg !== null; ) {
              var n = vg,
                a = n.child
              ;(n.subtreeFlags & oI) !== SA && a !== null ? (ka(a, n), (vg = a)) : yh()
            }
          }
          function yh() {
            for (; vg !== null; ) {
              var n = vg
              Fe(n)
              try {
                cc(n)
              } catch (y) {
                ;(uB(y), Bt(n, n.return, y))
              }
              ht()
              var a = n.sibling
              if (a !== null) {
                ;(ka(a, n.return), (vg = a))
                return
              }
              vg = n.return
            }
          }
          function cc(n) {
            var a = n.alternate,
              y = n.flags
            if ((y & mC) !== SA) {
              switch ((Fe(n), n.tag)) {
                case P:
                case nA:
                case EA:
                  break
                case AA: {
                  if (a !== null) {
                    var k = a.memoizedProps,
                      J = a.memoizedState,
                      T = n.stateNode
                    n.type === n.elementType &&
                      !dh &&
                      (T.props !== n.memoizedProps &&
                        s(
                          "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                          $I(n) || "instance",
                        ),
                      T.state !== n.memoizedState &&
                        s(
                          "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                          $I(n) || "instance",
                        ))
                    var W = T.getSnapshotBeforeUpdate(
                      n.elementType === n.type ? k : ue(n.type, k),
                      J,
                    )
                    {
                      var BA = wk
                      W === void 0 &&
                        !BA.has(n.type) &&
                        (BA.add(n.type),
                        s(
                          "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
                          $I(n),
                        ))
                    }
                    T.__reactInternalSnapshotBeforeUpdate = W
                  }
                  break
                }
                case _: {
                  if (Wt) {
                    var cA = n.stateNode
                    iA(cA.containerInfo)
                  }
                  break
                }
                case CA:
                case aA:
                case eA:
                case DA:
                  break
                default:
                  throw new Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.",
                  )
              }
              ht()
            }
          }
          function pQ(n, a, y) {
            var k = a.updateQueue,
              J = k !== null ? k.lastEffect : null
            if (J !== null) {
              var T = J.next,
                W = T
              do {
                if ((W.tag & n) === n) {
                  var BA = W.destroy
                  ;((W.destroy = void 0),
                    BA !== void 0 &&
                      ((n & RB) !== qo ? Tt(a) : (n & Ot) !== qo && Qr(a),
                      lc(a, y, BA),
                      (n & RB) !== qo ? Os() : (n & Ot) !== qo && wi()))
                }
                W = W.next
              } while (W !== T)
            }
          }
          function pa(n, a) {
            var y = a.updateQueue,
              k = y !== null ? y.lastEffect : null
            if (k !== null) {
              var J = k.next,
                T = J
              do {
                if ((T.tag & n) === n) {
                  ;(n & RB) !== qo ? aa(a) : (n & Ot) !== qo && ra(a)
                  var W = T.create
                  ;((T.destroy = W()), (n & RB) !== qo ? RE() : (n & Ot) !== qo && Br())
                  {
                    var BA = T.destroy
                    if (BA !== void 0 && typeof BA != "function") {
                      var cA = void 0
                      ;(T.tag & Ot) !== SA
                        ? (cA = "useLayoutEffect")
                        : (T.tag & fa) !== SA
                          ? (cA = "useInsertionEffect")
                          : (cA = "useEffect")
                      var RA = void 0
                      ;(BA === null
                        ? (RA =
                            " You returned null. If your effect does not require clean up, return undefined (or nothing).")
                        : typeof BA.then == "function"
                          ? (RA =
                              `

It looks like you wrote ` +
                              cA +
                              `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` +
                              cA +
                              `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching`)
                          : (RA = " You returned: " + BA),
                        s(
                          "%s must not return anything besides a function, which is used for clean-up.%s",
                          cA,
                          RA,
                        ))
                    }
                  }
                }
                T = T.next
              } while (T !== J)
            }
          }
          function Ew(n, a) {
            if ((a.flags & iI) !== SA)
              switch (a.tag) {
                case fA: {
                  var y = a.stateNode.passiveEffectDuration,
                    k = a.memoizedProps,
                    J = k.id,
                    T = k.onPostCommit,
                    W = gl(),
                    BA = a.alternate === null ? "mount" : "update"
                  ;(XG() && (BA = "nested-update"), typeof T == "function" && T(J, BA, y, W))
                  var cA = a.return
                  A: for (; cA !== null; ) {
                    switch (cA.tag) {
                      case _:
                        var RA = cA.stateNode
                        RA.passiveEffectDuration += y
                        break A
                      case fA:
                        var TA = cA.stateNode
                        TA.passiveEffectDuration += y
                        break A
                    }
                    cA = cA.return
                  }
                  break
                }
              }
          }
          function wR(n, a, y, k) {
            if ((y.flags & PA) !== SA)
              switch (y.tag) {
                case P:
                case nA:
                case EA: {
                  if (!sc)
                    if (y.mode & Ae)
                      try {
                        ;(Ho(), pa(Ot | Oi, y))
                      } finally {
                        CE(y)
                      }
                    else pa(Ot | Oi, y)
                  break
                }
                case AA: {
                  var J = y.stateNode
                  if (y.flags & iI && !sc)
                    if (a === null)
                      if (
                        (y.type === y.elementType &&
                          !dh &&
                          (J.props !== y.memoizedProps &&
                            s(
                              "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                              $I(y) || "instance",
                            ),
                          J.state !== y.memoizedState &&
                            s(
                              "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                              $I(y) || "instance",
                            )),
                        y.mode & Ae)
                      )
                        try {
                          ;(Ho(), J.componentDidMount())
                        } finally {
                          CE(y)
                        }
                      else J.componentDidMount()
                    else {
                      var T =
                          y.elementType === y.type ? a.memoizedProps : ue(y.type, a.memoizedProps),
                        W = a.memoizedState
                      if (
                        (y.type === y.elementType &&
                          !dh &&
                          (J.props !== y.memoizedProps &&
                            s(
                              "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                              $I(y) || "instance",
                            ),
                          J.state !== y.memoizedState &&
                            s(
                              "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                              $I(y) || "instance",
                            )),
                        y.mode & Ae)
                      )
                        try {
                          ;(Ho(), J.componentDidUpdate(T, W, J.__reactInternalSnapshotBeforeUpdate))
                        } finally {
                          CE(y)
                        }
                      else J.componentDidUpdate(T, W, J.__reactInternalSnapshotBeforeUpdate)
                    }
                  var BA = y.updateQueue
                  BA !== null &&
                    (y.type === y.elementType &&
                      !dh &&
                      (J.props !== y.memoizedProps &&
                        s(
                          "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                          $I(y) || "instance",
                        ),
                      J.state !== y.memoizedState &&
                        s(
                          "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                          $I(y) || "instance",
                        )),
                    zc(y, BA, J))
                  break
                }
                case _: {
                  var cA = y.updateQueue
                  if (cA !== null) {
                    var RA = null
                    if (y.child !== null)
                      switch (y.child.tag) {
                        case CA:
                          RA = vC(y.child.stateNode)
                          break
                        case AA:
                          RA = y.child.stateNode
                          break
                      }
                    zc(y, cA, RA)
                  }
                  break
                }
                case CA: {
                  var TA = y.stateNode
                  if (a === null && y.flags & iI) {
                    var DI = y.type,
                      vI = y.memoizedProps
                    TB(TA, DI, vI, y)
                  }
                  break
                }
                case aA:
                  break
                case eA:
                  break
                case fA: {
                  {
                    var bI = y.memoizedProps,
                      og = bI.onCommit,
                      cg = bI.onRender,
                      cC = y.stateNode.effectDuration,
                      re = gl(),
                      MC = a === null ? "mount" : "update"
                    ;(XG() && (MC = "nested-update"),
                      typeof cg == "function" &&
                        cg(
                          y.memoizedProps.id,
                          MC,
                          y.actualDuration,
                          y.treeBaseDuration,
                          y.actualStartTime,
                          re,
                        ))
                    {
                      ;(typeof og == "function" && og(y.memoizedProps.id, MC, cC, re), Jw(y))
                      var yt = y.return
                      A: for (; yt !== null; ) {
                        switch (yt.tag) {
                          case _:
                            var Qt = yt.stateNode
                            Qt.effectDuration += cC
                            break A
                          case fA:
                            var MI = yt.stateNode
                            MI.effectDuration += cC
                            break A
                        }
                        yt = yt.return
                      }
                    }
                  }
                  break
                }
                case sA: {
                  md(n, y)
                  break
                }
                case kA:
                case DA:
                case NA:
                case qA:
                case ZA:
                  break
                default:
                  throw new Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.",
                  )
              }
            sc || (y.flags & jC && lS(y))
          }
          function Mk(n) {
            switch (n.tag) {
              case P:
              case nA:
              case EA: {
                if (n.mode & Ae)
                  try {
                    ;(Ho(), xu(n, n.return))
                  } finally {
                    CE(n)
                  }
                else xu(n, n.return)
                break
              }
              case AA: {
                var a = n.stateNode
                ;(typeof a.componentDidMount == "function" && pR(n, n.return, a), Gk(n, n.return))
                break
              }
              case CA: {
                Gk(n, n.return)
                break
              }
            }
          }
          function Uk(n, a) {
            var y = null
            if (Wt)
              for (var k = n; ; ) {
                if (k.tag === CA) {
                  if (y === null) {
                    y = k
                    var J = k.stateNode
                    a ? In(J) : gn(k.stateNode, k.memoizedProps)
                  }
                } else if (k.tag === aA) {
                  if (y === null) {
                    var T = k.stateNode
                    a ? zt(T) : yB(T, k.memoizedProps)
                  }
                } else if (
                  !((k.tag === qA || k.tag === ZA) && k.memoizedState !== null && k !== n)
                ) {
                  if (k.child !== null) {
                    ;((k.child.return = k), (k = k.child))
                    continue
                  }
                }
                if (k === n) return
                for (; k.sibling === null; ) {
                  if (k.return === null || k.return === n) return
                  ;(y === k && (y = null), (k = k.return))
                }
                ;(y === k && (y = null), (k.sibling.return = k.return), (k = k.sibling))
              }
          }
          function lS(n) {
            var a = n.ref
            if (a !== null) {
              var y = n.stateNode,
                k
              switch (n.tag) {
                case CA:
                  k = vC(y)
                  break
                default:
                  k = y
              }
              if (typeof a == "function") {
                var J
                if (n.mode & Ae)
                  try {
                    ;(Ho(), (J = a(k)))
                  } finally {
                    CE(n)
                  }
                else J = a(k)
                typeof J == "function" &&
                  s(
                    "Unexpected return value from a callback ref in %s. A callback ref should not return a function.",
                    $I(n),
                  )
              } else
                (a.hasOwnProperty("current") ||
                  s(
                    "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
                    $I(n),
                  ),
                  (a.current = k))
            }
          }
          function Sr(n) {
            var a = n.ref
            if (a !== null)
              if (typeof a == "function")
                if (n.mode & Ae)
                  try {
                    ;(Ho(), a(null))
                  } finally {
                    CE(n)
                  }
                else a(null)
              else a.current = null
          }
          function Kd(n, a, y) {
            switch ((Ke(a), a.tag)) {
              case P:
              case nA:
              case $:
              case EA: {
                var k = a.updateQueue
                if (k !== null) {
                  var J = k.lastEffect
                  if (J !== null) {
                    var T = J.next,
                      W = T
                    do {
                      var BA = W,
                        cA = BA.destroy,
                        RA = BA.tag
                      ;(cA !== void 0 &&
                        ((RA & fa) !== qo
                          ? lc(a, y, cA)
                          : (RA & Ot) !== qo &&
                            (Qr(a),
                            a.mode & Ae ? (Ho(), lc(a, y, cA), CE(a)) : lc(a, y, cA),
                            wi())),
                        (W = W.next))
                    } while (W !== T)
                  }
                }
                return
              }
              case AA: {
                Jd(a, y)
                var TA = a.stateNode
                typeof TA.componentWillUnmount == "function" && aS(a, y, TA)
                return
              }
              case CA: {
                Jd(a, y)
                return
              }
              case eA: {
                Wt ? rw(n, a, y) : ZC && To(a)
                return
              }
              case dA:
                return
              case NA:
                return
            }
          }
          function cS(n, a, y) {
            for (var k = a; ; ) {
              if (
                (Kd(n, k, y),
                k.child !== null && // If we use mutation we drill down into portals using commitUnmount above.
                  // If we don't use mutation we drill down into portals here instead.
                  (!Wt || k.tag !== eA))
              ) {
                ;((k.child.return = k), (k = k.child))
                continue
              }
              if (k === a) return
              for (; k.sibling === null; ) {
                if (k.return === null || k.return === a) return
                k = k.return
              }
              ;((k.sibling.return = k.return), (k = k.sibling))
            }
          }
          function tl(n) {
            var a = n.alternate
            ;(a !== null && (a.return = null), (n.return = null))
          }
          function Bl(n) {
            var a = n.alternate
            a !== null && ((n.alternate = null), Bl(a))
            {
              if (((n.child = null), (n.deletions = null), (n.sibling = null), n.tag === CA)) {
                var y = n.stateNode
                y !== null && Te(y)
              }
              ;((n.stateNode = null),
                (n._debugOwner = null),
                (n.return = null),
                (n.dependencies = null),
                (n.memoizedProps = null),
                (n.memoizedState = null),
                (n.pendingProps = null),
                (n.stateNode = null),
                (n.updateQueue = null))
            }
          }
          function To(n) {
            if (ZC) {
              var a = n.stateNode,
                y = a.containerInfo,
                k = rI(y)
              AC(y, k)
            }
          }
          function xo(n) {
            if (ZC) {
              switch (n.tag) {
                case AA:
                case CA:
                case aA:
                  return
                case _:
                case eA: {
                  var a = n.stateNode,
                    y = a.containerInfo,
                    k = a.pendingChildren
                  AC(y, k)
                  return
                }
              }
              throw new Error(
                "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.",
              )
            }
          }
          function aw(n) {
            for (var a = n.return; a !== null; ) {
              if (eE(a)) return a
              a = a.return
            }
            throw new Error(
              "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.",
            )
          }
          function eE(n) {
            return n.tag === CA || n.tag === _ || n.tag === eA
          }
          function ss(n) {
            var a = n
            A: for (;;) {
              for (; a.sibling === null; ) {
                if (a.return === null || eE(a.return)) return null
                a = a.return
              }
              for (
                a.sibling.return = a.return, a = a.sibling;
                a.tag !== CA && a.tag !== aA && a.tag !== dA;
              ) {
                if (a.flags & HA || a.child === null || a.tag === eA) continue A
                ;((a.child.return = a), (a = a.child))
              }
              if (!(a.flags & HA)) return a.stateNode
            }
          }
          function fr(n) {
            if (Wt) {
              var a = aw(n)
              switch (a.tag) {
                case CA: {
                  var y = a.stateNode
                  a.flags & dg && (Ao(y), (a.flags &= ~dg))
                  var k = ss(n)
                  hc(n, k, y)
                  break
                }
                case _:
                case eA: {
                  var J = a.stateNode.containerInfo,
                    T = ss(n)
                  hS(n, T, J)
                  break
                }
                // eslint-disable-next-line-no-fallthrough
                default:
                  throw new Error(
                    "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.",
                  )
              }
            }
          }
          function hS(n, a, y) {
            var k = n.tag,
              J = k === CA || k === aA
            if (J) {
              var T = n.stateNode
              a ? Ni(y, T, a) : JQ(y, T)
            } else if (k !== eA) {
              var W = n.child
              if (W !== null) {
                hS(W, a, y)
                for (var BA = W.sibling; BA !== null; ) (hS(BA, a, y), (BA = BA.sibling))
              }
            }
          }
          function hc(n, a, y) {
            var k = n.tag,
              J = k === CA || k === aA
            if (J) {
              var T = n.stateNode
              a ? Gt(y, T, a) : $Q(y, T)
            } else if (k !== eA) {
              var W = n.child
              if (W !== null) {
                hc(W, a, y)
                for (var BA = W.sibling; BA !== null; ) (hc(BA, a, y), (BA = BA.sibling))
              }
            }
          }
          function rw(n, a, y) {
            for (var k = a, J = !1, T, W; ; ) {
              if (!J) {
                var BA = k.return
                A: for (;;) {
                  if (BA === null)
                    throw new Error(
                      "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.",
                    )
                  var cA = BA.stateNode
                  switch (BA.tag) {
                    case CA:
                      ;((T = cA), (W = !1))
                      break A
                    case _:
                      ;((T = cA.containerInfo), (W = !0))
                      break A
                    case eA:
                      ;((T = cA.containerInfo), (W = !0))
                      break A
                  }
                  BA = BA.return
                }
                J = !0
              }
              if (k.tag === CA || k.tag === aA)
                (cS(n, k, y), W ? jt(T, k.stateNode) : QQ(T, k.stateNode))
              else if (k.tag === dA) W ? vl(T, k.stateNode) : ml(T, k.stateNode)
              else if (k.tag === eA) {
                if (k.child !== null) {
                  ;((T = k.stateNode.containerInfo), (W = !0), (k.child.return = k), (k = k.child))
                  continue
                }
              } else if ((Kd(n, k, y), k.child !== null)) {
                ;((k.child.return = k), (k = k.child))
                continue
              }
              if (k === a) return
              for (; k.sibling === null; ) {
                if (k.return === null || k.return === a) return
                ;((k = k.return), k.tag === eA && (J = !1))
              }
              ;((k.sibling.return = k.return), (k = k.sibling))
            }
          }
          function bu(n, a, y) {
            ;(Wt ? rw(n, a, y) : cS(n, a, y), tl(a))
          }
          function Ou(n, a) {
            if (!Wt) {
              switch (a.tag) {
                case P:
                case nA:
                case $:
                case EA: {
                  if ((pQ(fa | Oi, a, a.return), pa(fa | Oi, a), a.mode & Ae))
                    try {
                      ;(Ho(), pQ(Ot | Oi, a, a.return))
                    } finally {
                      CE(a)
                    }
                  else pQ(Ot | Oi, a, a.return)
                  return
                }
                case fA:
                  return
                case sA: {
                  ;(dr(a), _u(a))
                  return
                }
                case kA: {
                  _u(a)
                  return
                }
                case _: {
                  if (Ui && n !== null) {
                    var y = n.memoizedState
                    if (y.isDehydrated) {
                      var k = a.stateNode
                      Jl(k.containerInfo)
                    }
                  }
                  break
                }
                case qA:
                case ZA:
                  return
              }
              xo(a)
              return
            }
            switch (a.tag) {
              case P:
              case nA:
              case $:
              case EA: {
                if ((pQ(fa | Oi, a, a.return), pa(fa | Oi, a), a.mode & Ae))
                  try {
                    ;(Ho(), pQ(Ot | Oi, a, a.return))
                  } finally {
                    CE(a)
                  }
                else pQ(Ot | Oi, a, a.return)
                return
              }
              case AA:
                return
              case CA: {
                var J = a.stateNode
                if (J != null) {
                  var T = a.memoizedProps,
                    W = n !== null ? n.memoizedProps : T,
                    BA = a.type,
                    cA = a.updateQueue
                  ;((a.updateQueue = null), cA !== null && An(J, cA, BA, W, T, a))
                }
                return
              }
              case aA: {
                if (a.stateNode === null)
                  throw new Error(
                    "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.",
                  )
                var RA = a.stateNode,
                  TA = a.memoizedProps,
                  DI = n !== null ? n.memoizedProps : TA
                HB(RA, DI, TA)
                return
              }
              case _: {
                if (Ui && n !== null) {
                  var vI = n.memoizedState
                  if (vI.isDehydrated) {
                    var bI = a.stateNode
                    Jl(bI.containerInfo)
                  }
                }
                return
              }
              case fA:
                return
              case sA: {
                ;(dr(a), _u(a))
                return
              }
              case kA: {
                _u(a)
                return
              }
              case DA:
                return
            }
            throw new Error(
              "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.",
            )
          }
          function dr(n) {
            n.memoizedState
          }
          function md(n, a) {
            if (Ui) {
              var y = a.memoizedState
              if (y === null) {
                var k = a.alternate
                if (k !== null) {
                  var J = k.memoizedState
                  if (J !== null) {
                    var T = J.dehydrated
                    T !== null && Kl(T)
                  }
                }
              }
            }
          }
          function _u(n) {
            var a = n.updateQueue
            if (a !== null) {
              n.updateQueue = null
              var y = n.stateNode
              ;(y === null && (y = n.stateNode = new yR()),
                a.forEach(function (k) {
                  var J = mR.bind(null, n, k)
                  if (!y.has(k)) {
                    if ((y.add(k), uQ))
                      if (Tu !== null && Dr !== null) Jg(Dr, Tu)
                      else
                        throw Error(
                          "Expected finished root and lanes to be set. This is a bug in React.",
                        )
                    k.then(J, J)
                  }
                }))
            }
          }
          function Nk(n) {
            Wt && Ao(n.stateNode)
          }
          function Fk(n, a, y) {
            ;((Tu = y), (Dr = n), (vg = a), vd(n, y), (Tu = null), (Dr = null))
          }
          function vd(n, a) {
            for (; vg !== null; ) {
              var y = vg,
                k = y.deletions
              if (k !== null)
                for (var J = 0; J < k.length; J++) {
                  var T = k[J]
                  try {
                    bu(n, T, y)
                  } catch (BA) {
                    ;(uB(BA), Bt(T, y, BA))
                  }
                }
              var W = y.child
              ;(y.subtreeFlags & QI) !== SA && W !== null ? (ka(W, y), (vg = W)) : Rk(n, a)
            }
          }
          function Rk(n, a) {
            for (; vg !== null; ) {
              var y = vg
              Fe(y)
              try {
                GR(y, n, a)
              } catch (J) {
                ;(uB(J), Bt(y, y.return, J))
              }
              ht()
              var k = y.sibling
              if (k !== null) {
                ;(ka(k, y.return), (vg = k))
                return
              }
              vg = y.return
            }
          }
          function GR(n, a, y) {
            var k = n.flags
            if ((k & dg && Nk(n), k & jC)) {
              var J = n.alternate
              J !== null && Sr(J)
            }
            if (k & fe)
              switch (n.tag) {
                case sA: {
                  var T = n.memoizedState,
                    W = T !== null
                  if (W) {
                    var BA = n.alternate,
                      cA = BA !== null && BA.memoizedState !== null
                    cA || Nw()
                  }
                  break
                }
                case qA: {
                  var RA = n.memoizedState,
                    TA = RA !== null,
                    DI = n.alternate,
                    vI = DI !== null && DI.memoizedState !== null,
                    bI = n
                  Wt && Uk(bI, TA)
                  {
                    if (TA && !vI && (bI.mode & Ai) !== FC) {
                      vg = bI
                      for (var og = bI.child; og !== null; ) ((vg = og), sw(og), (og = og.sibling))
                    }
                    break
                  }
                }
              }
            var cg = k & (HA | iI | Ee)
            switch (cg) {
              case HA: {
                ;(fr(n), (n.flags &= ~HA))
                break
              }
              case zI: {
                ;(fr(n), (n.flags &= ~HA))
                var cC = n.alternate
                Ou(cC, n)
                break
              }
              case Ee: {
                n.flags &= ~Ee
                break
              }
              case ei: {
                n.flags &= ~Ee
                var re = n.alternate
                Ou(re, n)
                break
              }
              case iI: {
                var MC = n.alternate
                Ou(MC, n)
                break
              }
            }
          }
          function uc(n, a, y) {
            ;((Tu = y), (Dr = a), (vg = n), uS(n, a, y), (Tu = null), (Dr = null))
          }
          function uS(n, a, y) {
            for (var k = (n.mode & Ai) !== FC; vg !== null; ) {
              var J = vg,
                T = J.child
              if (J.tag === qA && k) {
                var W = J.memoizedState !== null,
                  BA = W || Rd
                if (BA) {
                  yr(n, a, y)
                  continue
                } else {
                  var cA = J.alternate,
                    RA = cA !== null && cA.memoizedState !== null,
                    TA = RA || sc,
                    DI = Rd,
                    vI = sc
                  ;((Rd = BA), (sc = TA), sc && !vI && ((vg = J), Jk(J)))
                  for (var bI = T; bI !== null; )
                    ((vg = bI),
                      uS(
                        bI,
                        // New root; bubble back up to here and stop.
                        a,
                        y,
                      ),
                      (bI = bI.sibling))
                  ;((vg = J), (Rd = DI), (sc = vI), yr(n, a, y))
                  continue
                }
              }
              ;(J.subtreeFlags & PA) !== SA && T !== null ? (ka(T, J), (vg = T)) : yr(n, a, y)
            }
          }
          function yr(n, a, y) {
            for (; vg !== null; ) {
              var k = vg
              if ((k.flags & PA) !== SA) {
                var J = k.alternate
                Fe(k)
                try {
                  wR(a, J, k, y)
                } catch (W) {
                  ;(uB(W), Bt(k, k.return, W))
                }
                ht()
              }
              if (k === n) {
                vg = null
                return
              }
              var T = k.sibling
              if (T !== null) {
                ;(ka(T, k.return), (vg = T))
                return
              }
              vg = k.return
            }
          }
          function sw(n) {
            for (; vg !== null; ) {
              var a = vg,
                y = a.child
              switch (a.tag) {
                case P:
                case nA:
                case $:
                case EA: {
                  if (a.mode & Ae)
                    try {
                      ;(Ho(), pQ(Ot, a, a.return))
                    } finally {
                      CE(a)
                    }
                  else pQ(Ot, a, a.return)
                  break
                }
                case AA: {
                  Jd(a, a.return)
                  var k = a.stateNode
                  typeof k.componentWillUnmount == "function" && aS(a, a.return, k)
                  break
                }
                case CA: {
                  Jd(a, a.return)
                  break
                }
                case qA: {
                  var J = a.memoizedState !== null
                  if (J) {
                    Ld(n)
                    continue
                  }
                  break
                }
              }
              y !== null ? ((y.return = a), (vg = y)) : Ld(n)
            }
          }
          function Ld(n) {
            for (; vg !== null; ) {
              var a = vg
              if (a === n) {
                vg = null
                return
              }
              var y = a.sibling
              if (y !== null) {
                ;((y.return = a.return), (vg = y))
                return
              }
              vg = a.return
            }
          }
          function Jk(n) {
            for (; vg !== null; ) {
              var a = vg,
                y = a.child
              if (a.tag === qA) {
                var k = a.memoizedState !== null
                if (k) {
                  Kk(n)
                  continue
                }
              }
              y !== null ? ((y.return = a), (vg = y)) : Kk(n)
            }
          }
          function Kk(n) {
            for (; vg !== null; ) {
              var a = vg
              Fe(a)
              try {
                Mk(a)
              } catch (k) {
                ;(uB(k), Bt(a, a.return, k))
              }
              if ((ht(), a === n)) {
                vg = null
                return
              }
              var y = a.sibling
              if (y !== null) {
                ;((y.return = a.return), (vg = y))
                return
              }
              vg = a.return
            }
          }
          function mk(n, a) {
            ;((vg = a), Dc(a, n))
          }
          function Dc(n, a) {
            for (; vg !== null; ) {
              var y = vg,
                k = y.child
              ;(y.subtreeFlags & gg) !== SA && k !== null ? (ka(k, y), (vg = k)) : Zu(n, a)
            }
          }
          function Zu(n, a) {
            for (; vg !== null; ) {
              var y = vg
              if ((y.flags & zC) !== SA) {
                Fe(y)
                try {
                  Pu(a, y)
                } catch (J) {
                  ;(uB(J), Bt(y, y.return, J))
                }
                ht()
              }
              if (y === n) {
                vg = null
                return
              }
              var k = y.sibling
              if (k !== null) {
                ;(ka(k, y.return), (vg = k))
                return
              }
              vg = y.return
            }
          }
          function Pu(n, a) {
            switch (a.tag) {
              case P:
              case nA:
              case EA: {
                if (a.mode & Ae) {
                  dd()
                  try {
                    pa(RB | Oi, a)
                  } finally {
                    Ju(a)
                  }
                } else pa(RB | Oi, a)
                break
              }
            }
          }
          function Yd(n) {
            ;((vg = n), qd())
          }
          function qd() {
            for (; vg !== null; ) {
              var n = vg,
                a = n.child
              if ((vg.flags & qI) !== SA) {
                var y = n.deletions
                if (y !== null) {
                  for (var k = 0; k < y.length; k++) {
                    var J = y[k]
                    ;((vg = J), ph(J, n))
                  }
                  {
                    var T = n.alternate
                    if (T !== null) {
                      var W = T.child
                      if (W !== null) {
                        T.child = null
                        do {
                          var BA = W.sibling
                          ;((W.sibling = null), (W = BA))
                        } while (W !== null)
                      }
                    }
                  }
                  vg = n
                }
              }
              ;(n.subtreeFlags & gg) !== SA && a !== null ? (ka(a, n), (vg = a)) : wa()
            }
          }
          function wa() {
            for (; vg !== null; ) {
              var n = vg
              ;(n.flags & zC) !== SA && (Fe(n), Ga(n), ht())
              var a = n.sibling
              if (a !== null) {
                ;(ka(a, n.return), (vg = a))
                return
              }
              vg = n.return
            }
          }
          function Ga(n) {
            switch (n.tag) {
              case P:
              case nA:
              case EA: {
                n.mode & Ae ? (dd(), pQ(RB | Oi, n, n.return), Ju(n)) : pQ(RB | Oi, n, n.return)
                break
              }
            }
          }
          function ph(n, a) {
            for (; vg !== null; ) {
              var y = vg
              ;(Fe(y), ol(y, a), ht())
              var k = y.child
              k !== null ? (ka(k, y), (vg = k)) : Ql(n)
            }
          }
          function Ql(n) {
            for (; vg !== null; ) {
              var a = vg,
                y = a.sibling,
                k = a.return
              if ((Bl(a), a === n)) {
                vg = null
                return
              }
              if (y !== null) {
                ;(ka(y, k), (vg = y))
                return
              }
              vg = k
            }
          }
          function ol(n, a) {
            switch (n.tag) {
              case P:
              case nA:
              case EA: {
                n.mode & Ae ? (dd(), pQ(RB, n, a), Ju(n)) : pQ(RB, n, a)
                break
              }
            }
          }
          var vk = !1
          function ka(n, a) {
            ;(!vk &&
              n.return !== a &&
              ((vk = !0), s("Internal React error: Return pointer is inconsistent with parent.")),
              (n.return = a))
          }
          function kR(n) {
            switch (n.tag) {
              case P:
              case nA:
              case EA: {
                try {
                  pa(Ot | Oi, n)
                } catch (y) {
                  ;(uB(y), Bt(n, n.return, y))
                }
                break
              }
              case AA: {
                var a = n.stateNode
                try {
                  a.componentDidMount()
                } catch (y) {
                  ;(uB(y), Bt(n, n.return, y))
                }
                break
              }
            }
          }
          function wh(n) {
            switch (n.tag) {
              case P:
              case nA:
              case EA: {
                try {
                  pa(RB | Oi, n)
                } catch (a) {
                  ;(uB(a), Bt(n, n.return, a))
                }
                break
              }
            }
          }
          function Lk(n) {
            switch (n.tag) {
              case P:
              case nA:
              case EA: {
                try {
                  pQ(Ot | Oi, n, n.return)
                } catch (y) {
                  ;(uB(y), Bt(n, n.return, y))
                }
                break
              }
              case AA: {
                var a = n.stateNode
                typeof a.componentWillUnmount == "function" && aS(n, n.return, a)
                break
              }
            }
          }
          function lw(n) {
            switch (n.tag) {
              case P:
              case nA:
              case EA:
                try {
                  pQ(RB | Oi, n, n.return)
                } catch (a) {
                  ;(uB(a), Bt(n, n.return, a))
                }
            }
          }
          var Gh = 0,
            Hd = 1,
            Wu = 2,
            Td = 3,
            xd = 4
          if (typeof Symbol == "function" && Symbol.for) {
            var pr = Symbol.for
            ;((Gh = pr("selector.component")),
              (Hd = pr("selector.has_pseudo_class")),
              (Wu = pr("selector.role")),
              (Td = pr("selector.test_id")),
              (xd = pr("selector.text")))
          }
          function oo(n) {
            return {
              $$typeof: Gh,
              value: n,
            }
          }
          function Ma(n) {
            return {
              $$typeof: Hd,
              value: n,
            }
          }
          function wr(n) {
            return {
              $$typeof: Wu,
              value: n,
            }
          }
          function kh(n) {
            return {
              $$typeof: xd,
              value: n,
            }
          }
          function Sc(n) {
            return {
              $$typeof: Td,
              value: n,
            }
          }
          function cw(n) {
            var a = $o(n)
            if (a != null) {
              if (typeof a.memoizedProps["data-testname"] != "string")
                throw new Error(
                  "Invalid host root specified. Should be either a React container or a node with a testname attribute.",
                )
              return a
            } else {
              var y = di(n)
              if (y === null)
                throw new Error("Could not find React container within specified host subtree.")
              return y.stateNode.current
            }
          }
          function bd(n, a) {
            switch (a.$$typeof) {
              case Gh:
                if (n.type === a.value) return !0
                break
              case Hd:
                return MR(n, a.value)
              case Wu:
                if (n.tag === CA) {
                  var y = n.stateNode
                  if (Zi(y, a.value)) return !0
                }
                break
              case xd:
                if (n.tag === CA || n.tag === aA) {
                  var k = Ha(n)
                  if (k !== null && k.indexOf(a.value) >= 0) return !0
                }
                break
              case Td:
                if (n.tag === CA) {
                  var J = n.memoizedProps["data-testname"]
                  if (typeof J == "string" && J.toLowerCase() === a.value.toLowerCase()) return !0
                }
                break
              default:
                throw new Error("Invalid selector type specified.")
            }
            return !1
          }
          function hw(n) {
            switch (n.$$typeof) {
              case Gh:
                var a = VA(n.value) || "Unknown"
                return "<" + a + ">"
              case Hd:
                return ":has(" + (hw(n) || "") + ")"
              case Wu:
                return '[role="' + n.value + '"]'
              case xd:
                return '"' + n.value + '"'
              case Td:
                return '[data-testname="' + n.value + '"]'
              default:
                throw new Error("Invalid selector type specified.")
            }
          }
          function Yk(n, a) {
            for (var y = [], k = [n, 0], J = 0; J < k.length; ) {
              var T = k[J++],
                W = k[J++],
                BA = a[W]
              if (!(T.tag === CA && ee(T))) {
                for (; BA != null && bd(T, BA); ) (W++, (BA = a[W]))
                if (W === a.length) y.push(T)
                else for (var cA = T.child; cA !== null; ) (k.push(cA, W), (cA = cA.sibling))
              }
            }
            return y
          }
          function MR(n, a) {
            for (var y = [n, 0], k = 0; k < y.length; ) {
              var J = y[k++],
                T = y[k++],
                W = a[T]
              if (!(J.tag === CA && ee(J))) {
                for (; W != null && bd(J, W); ) (T++, (W = a[T]))
                if (T === a.length) return !0
                for (var BA = J.child; BA !== null; ) (y.push(BA, T), (BA = BA.sibling))
              }
            }
            return !1
          }
          function DS(n, a) {
            if (!wt) throw new Error("Test selector API is not supported by this renderer.")
            for (var y = cw(n), k = Yk(y, a), J = [], T = Array.from(k), W = 0; W < T.length; ) {
              var BA = T[W++]
              if (BA.tag === CA) {
                if (ee(BA)) continue
                J.push(BA.stateNode)
              } else for (var cA = BA.child; cA !== null; ) (T.push(cA), (cA = cA.sibling))
            }
            return J
          }
          function qk(n, a) {
            if (!wt) throw new Error("Test selector API is not supported by this renderer.")
            for (var y = cw(n), k = 0, J = [], T = [y, 0], W = 0; W < T.length; ) {
              var BA = T[W++],
                cA = T[W++],
                RA = a[cA]
              if (
                !(BA.tag === CA && ee(BA)) &&
                (bd(BA, RA) && (J.push(hw(RA)), cA++, cA > k && (k = cA)), cA < a.length)
              )
                for (var TA = BA.child; TA !== null; ) (T.push(TA, cA), (TA = TA.sibling))
            }
            if (k < a.length) {
              for (var DI = [], vI = k; vI < a.length; vI++) DI.push(hw(a[vI]))
              return (
                `findAllNodes was able to match part of the selector:
` +
                ("  " +
                  J.join(" > ") +
                  `

`) +
                `No matching component was found for:
` +
                ("  " + DI.join(" > "))
              )
            }
            return null
          }
          function uw(n, a) {
            if (!wt) throw new Error("Test selector API is not supported by this renderer.")
            for (var y = DS(n, a), k = [], J = 0; J < y.length; J++) k.push(Me(y[J]))
            for (var T = k.length - 1; T > 0; T--)
              for (
                var W = k[T], BA = W.x, cA = BA + W.width, RA = W.y, TA = RA + W.height, DI = T - 1;
                DI >= 0;
                DI--
              )
                if (T !== DI) {
                  var vI = k[DI],
                    bI = vI.x,
                    og = bI + vI.width,
                    cg = vI.y,
                    cC = cg + vI.height
                  if (BA >= bI && RA >= cg && cA <= og && TA <= cC) {
                    k.splice(T, 1)
                    break
                  } else if (BA === bI && W.width === vI.width && !(cC < RA) && !(cg > TA)) {
                    ;(cg > RA && ((vI.height += cg - RA), (vI.y = RA)),
                      cC < TA && (vI.height = TA - cg),
                      k.splice(T, 1))
                    break
                  } else if (RA === cg && W.height === vI.height && !(og < BA) && !(bI > cA)) {
                    ;(bI > BA && ((vI.width += bI - BA), (vI.x = BA)),
                      og < cA && (vI.width = cA - bI),
                      k.splice(T, 1))
                    break
                  }
                }
            return k
          }
          function Hk(n, a) {
            if (!wt) throw new Error("Test selector API is not supported by this renderer.")
            for (var y = cw(n), k = Yk(y, a), J = Array.from(k), T = 0; T < J.length; ) {
              var W = J[T++]
              if (!ee(W)) {
                if (W.tag === CA) {
                  var BA = W.stateNode
                  if (XQ(BA)) return !0
                }
                for (var cA = W.child; cA !== null; ) (J.push(cA), (cA = cA.sibling))
              }
            }
            return !1
          }
          var SS = []
          function Dw() {
            wt &&
              SS.forEach(function (n) {
                return n()
              })
          }
          function Sw(n, a, y, k) {
            if (!wt) throw new Error("Test selector API is not supported by this renderer.")
            var J = DS(n, a),
              T = rB(J, y, k),
              W = T.disconnect,
              BA = T.observe,
              cA = T.unobserve,
              RA = function () {
                var TA = DS(n, a)
                ;(J.forEach(function (DI) {
                  TA.indexOf(DI) < 0 && cA(DI)
                }),
                  TA.forEach(function (DI) {
                    J.indexOf(DI) < 0 && BA(DI)
                  }))
              }
            return (
              SS.push(RA),
              {
                disconnect: function () {
                  var TA = SS.indexOf(RA)
                  ;(TA >= 0 && SS.splice(TA, 1), W())
                },
              }
            )
          }
          var fw = i.ReactCurrentActQueue
          function UR(n) {
            {
              var a =
                  // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
                  typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0,
                y = typeof jest < "u"
              return zQ && y && a !== !1
            }
          }
          function Tk() {
            {
              var n =
                // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
                typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
              return (
                !n &&
                  fw.current !== null &&
                  s("The current testing environment is not configured to support act(...)"),
                n
              )
            }
          }
          var NR = Math.ceil,
            dw = i.ReactCurrentDispatcher,
            Od = i.ReactCurrentOwner,
            dt = i.ReactCurrentBatchConfig,
            Gr = i.ReactCurrentActQueue,
            JB =
              /*             */
              0,
            fc =
              /*               */
              1,
            no =
              /*                */
              2,
            it =
              /*                */
              4,
            kr = 0,
            fS = 1,
            Mh = 2,
            _d = 3,
            fn = 4,
            xk = 5,
            nl = 6,
            ge = JB,
            $B = null,
            tt = null,
            QB = Cg,
            iE = Cg,
            Uh = vQ(Cg),
            Rt = kr,
            dc = null,
            dS = Cg,
            Nh = Cg,
            Vu = Cg,
            Fh = null,
            bo = null,
            yS = 0,
            yw = 500,
            bk = 1 / 0,
            pS = 500
          function El() {
            bk = Bi() + pS
          }
          function wS() {
            return bk
          }
          var GS = !1,
            Zd = null,
            Mr = null,
            yc = !1,
            al = null,
            kS = Cg,
            MS = [],
            pw = 50,
            pc = 0,
            wc = null,
            ww = 50,
            Rh = 0,
            Gc = Je,
            US = Cg
          function NS() {
            return $B
          }
          function Oo() {
            return (ge & (no | it)) !== JB ? Bi() : (Gc !== Je || (Gc = Bi()), Gc)
          }
          function ls(n) {
            var a = n.mode
            if ((a & Ai) === FC) return PC
            if ((ge & no) !== JB && QB !== Cg) return oa(QB)
            var y = la() !== sa
            if (y) {
              if (dt.transition !== null) {
                var k = dt.transition
                ;(k._updatedFibers || (k._updatedFibers = /* @__PURE__ */ new Set()),
                  k._updatedFibers.add(n))
              }
              return (US === TC && (US = Xt()), US)
            }
            var J = ZB()
            if (J !== TC) return J
            var T = RQ()
            return T
          }
          function Gw(n) {
            var a = n.mode
            return (a & Ai) === FC ? PC : jr()
          }
          function wQ(n, a, y) {
            Xu()
            var k = rl(n, a)
            return k === null
              ? null
              : ($t(k, a, y),
                (ge & no) !== Cg && k === $B
                  ? LR(n)
                  : (uQ && pi(k, n, a),
                    Ji(n),
                    k === $B && ((ge & no) === JB && (Nh = LC(Nh, a)), Rt === fn && mB(k, QB)),
                    AQ(k, y),
                    a === PC &&
                      ge === JB &&
                      (n.mode & Ai) === FC && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
                      !Gr.isBatchingLegacy &&
                      (El(), SQ())),
                k)
          }
          function FR(n, a, y) {
            var k = n.current
            ;((k.lanes = a), $t(n, a, y), AQ(n, y))
          }
          function rl(n, a) {
            n.lanes = LC(n.lanes, a)
            var y = n.alternate
            ;(y !== null && (y.lanes = LC(y.lanes, a)),
              y === null && (n.flags & (HA | Ee)) !== SA && Ur(n))
            for (var k = n, J = n.return; J !== null; )
              ((J.childLanes = LC(J.childLanes, a)),
                (y = J.alternate),
                y !== null
                  ? (y.childLanes = LC(y.childLanes, a))
                  : (J.flags & (HA | Ee)) !== SA && Ur(n),
                (k = J),
                (J = J.return))
            if (k.tag === _) {
              var T = k.stateNode
              return T
            } else return null
          }
          function KB(n, a) {
            return (
              // TODO: Optimize slightly by comparing to root that fiber belongs to.
              // Requires some refactoring. Not a big deal though since it's rare for
              // concurrent apps to have more than a single root.
              $B !== null &&
              (n.mode & Ai) !== FC && // If this is a render phase update (i.e. UNSAFE_componentWillReceiveProps),
              // then don't treat this as an interleaved update. This pattern is
              // accompanied by a warning but we haven't fully deprecated it yet. We can
              // remove once the deferRenderPhaseUpdateToNextBatch flag is enabled.
              (ge & no) === JB
            )
          }
          function AQ(n, a) {
            var y = n.callbackNode
            At(n, a)
            var k = Ue(n, n === $B ? QB : Cg)
            if (k === Cg) {
              ;(y !== null && vh(y), (n.callbackNode = null), (n.callbackPriority = TC))
              return
            }
            var J = Mo(k),
              T = n.callbackPriority
            if (
              T === J && // Special case related to `act`. If the currently scheduled task is a
              // Scheduler task, rather than an `act` task, cancel it and re-scheduled
              // on the `act` queue.
              !(Gr.current !== null && y !== mh)
            ) {
              y == null &&
                T !== PC &&
                s(
                  "Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.",
                )
              return
            }
            y != null && vh(y)
            var W
            if (J === PC)
              (n.tag === Ca
                ? (Gr.isBatchingLegacy !== null && (Gr.didScheduleLegacyUpdate = !0),
                  cB(Ok.bind(null, n)))
                : bg(Ok.bind(null, n)),
                hC
                  ? Gr.current !== null
                    ? Gr.current.push(bt)
                    : Vt(function () {
                        ge === JB && bt()
                      })
                  : $u(Ti, bt),
                (W = null))
            else {
              var BA
              switch (No(k)) {
                case to:
                  BA = Ti
                  break
                case gr:
                  BA = fg
                  break
                case FE:
                  BA = Ht
                  break
                case Cr:
                  BA = lB
                  break
                default:
                  BA = Ht
                  break
              }
              W = $u(BA, Pd.bind(null, n))
            }
            ;((n.callbackPriority = J), (n.callbackNode = W))
          }
          function Pd(n, a) {
            if ((IS(), (Gc = Je), (US = Cg), (ge & (no | it)) !== JB))
              throw new Error("Should not already be working.")
            var y = n.callbackNode,
              k = dn()
            if (k && n.callbackNode !== y) return null
            var J = Ue(n, n === $B ? QB : Cg)
            if (J === Cg) return null
            var T = !On(n, J) && !Vc(n, J) && !a,
              W = T ? Mc(n, J) : JS(n, J)
            if (W !== kr) {
              if (W === Mh) {
                var BA = cQ(n)
                BA !== Cg && ((J = BA), (W = kw(n, BA)))
              }
              if (W === fS) {
                var cA = dc
                throw (kc(n, Cg), mB(n, J), AQ(n, Bi()), cA)
              }
              if (W === nl) mB(n, J)
              else {
                var RA = !On(n, J),
                  TA = n.current.alternate
                if (RA && !JR(TA)) {
                  if (((W = JS(n, J)), W === Mh)) {
                    var DI = cQ(n)
                    DI !== Cg && ((J = DI), (W = kw(n, DI)))
                  }
                  if (W === fS) {
                    var vI = dc
                    throw (kc(n, Cg), mB(n, J), AQ(n, Bi()), vI)
                  }
                }
                ;((n.finishedWork = TA), (n.finishedLanes = J), RR(n, W, J))
              }
            }
            return (AQ(n, Bi()), n.callbackNode === y ? Pd.bind(null, n) : null)
          }
          function kw(n, a) {
            var y = Fh
            if (gB(n)) {
              var k = kc(n, a)
              ;((k.flags |= Fg), Xi(n.containerInfo))
            }
            var J = JS(n, a)
            if (J !== Mh) {
              var T = bo
              ;((bo = y), T !== null && Mw(T))
            }
            return J
          }
          function Mw(n) {
            bo === null ? (bo = n) : bo.push.apply(bo, n)
          }
          function RR(n, a, y) {
            switch (a) {
              case kr:
              case fS:
                throw new Error("Root did not complete. This is a bug in React.")
              // Flow knows about invariant, so it complains if I add a break
              // statement, but eslint doesn't know about invariant, so it complains
              // if I do. eslint-disable-next-line no-fallthrough
              case Mh: {
                Uc(n, bo)
                break
              }
              case _d: {
                if (
                  (mB(n, y),
                  bn(y) && // do not delay if we're inside an act() scope
                    !Fc())
                ) {
                  var k = yS + yw - Bi()
                  if (k > 10) {
                    var J = Ue(n, Cg)
                    if (J !== Cg) break
                    var T = n.suspendedLanes
                    if (!Uo(T, y)) {
                      ;(Oo(), qs(n, T))
                      break
                    }
                    n.timeoutHandle = vn(Uc.bind(null, n, bo), k)
                    break
                  }
                }
                Uc(n, bo)
                break
              }
              case fn: {
                if ((mB(n, y), Qa(y))) break
                if (!Fc()) {
                  var W = nn(n, y),
                    BA = W,
                    cA = Bi() - BA,
                    RA = Nc(cA) - cA
                  if (RA > 10) {
                    n.timeoutHandle = vn(Uc.bind(null, n, bo), RA)
                    break
                  }
                }
                Uc(n, bo)
                break
              }
              case xk: {
                Uc(n, bo)
                break
              }
              default:
                throw new Error("Unknown root exit status.")
            }
          }
          function JR(n) {
            for (var a = n; ; ) {
              if (a.flags & Ei) {
                var y = a.updateQueue
                if (y !== null) {
                  var k = y.stores
                  if (k !== null)
                    for (var J = 0; J < k.length; J++) {
                      var T = k[J],
                        W = T.getSnapshot,
                        BA = T.value
                      try {
                        if (!ci(W(), BA)) return !1
                      } catch {
                        return !1
                      }
                    }
                }
              }
              var cA = a.child
              if (a.subtreeFlags & Ei && cA !== null) {
                ;((cA.return = a), (a = cA))
                continue
              }
              if (a === n) return !0
              for (; a.sibling === null; ) {
                if (a.return === null || a.return === n) return !0
                a = a.return
              }
              ;((a.sibling.return = a.return), (a = a.sibling))
            }
            return !0
          }
          function mB(n, a) {
            ;((a = Yt(a, Vu)), (a = Yt(a, Nh)), _l(n, a))
          }
          function Ok(n) {
            if ((fd(), (ge & (no | it)) !== JB)) throw new Error("Should not already be working.")
            dn()
            var a = Ue(n, Cg)
            if (!Ne(a, PC)) return (AQ(n, Bi()), null)
            var y = JS(n, a)
            if (n.tag !== Ca && y === Mh) {
              var k = cQ(n)
              k !== Cg && ((a = k), (y = kw(n, k)))
            }
            if (y === fS) {
              var J = dc
              throw (kc(n, Cg), mB(n, a), AQ(n, Bi()), J)
            }
            if (y === nl) throw new Error("Root did not complete. This is a bug in React.")
            var T = n.current.alternate
            return ((n.finishedWork = T), (n.finishedLanes = a), Uc(n, bo), AQ(n, Bi()), null)
          }
          function Wd(n, a) {
            a !== Cg && (AB(n, LC(a, PC)), AQ(n, Bi()), (ge & (no | it)) === JB && (El(), bt()))
          }
          function _k(n) {
            var a = ZB(),
              y = dt.transition
            try {
              return ((dt.transition = null), qt(FE), n())
            } finally {
              ;(qt(a), (dt.transition = y))
            }
          }
          function Zk(n, a) {
            var y = ge
            ge |= fc
            try {
              return n(a)
            } finally {
              ;((ge = y),
                ge === JB && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
                  !Gr.isBatchingLegacy &&
                  (El(), SQ()))
            }
          }
          function Vd(n, a, y, k, J) {
            var T = ZB(),
              W = dt.transition
            try {
              return ((dt.transition = null), qt(to), n(a, y, k, J))
            } finally {
              ;(qt(T), (dt.transition = W), ge === JB && El())
            }
          }
          function ju(n) {
            al !== null && al.tag === Ca && (ge & (no | it)) === JB && dn()
            var a = ge
            ge |= fc
            var y = dt.transition,
              k = ZB()
            try {
              return ((dt.transition = null), qt(to), n ? n() : void 0)
            } finally {
              ;(qt(k), (dt.transition = y), (ge = a), (ge & (no | it)) === JB && bt())
            }
          }
          function jd() {
            return (ge & (no | it)) !== JB
          }
          function Uw(n) {
            var a = ge
            ge |= fc
            var y = dt.transition,
              k = ZB()
            try {
              ;((dt.transition = null), qt(to), n())
            } finally {
              ;(qt(k), (dt.transition = y), (ge = a), ge === JB && (El(), bt()))
            }
          }
          function Jh(n, a) {
            ;(ti(Uh, iE, n), (iE = LC(iE, a)))
          }
          function FS(n) {
            ;((iE = Uh.current), vt(Uh, n))
          }
          function kc(n, a) {
            ;((n.finishedWork = null), (n.finishedLanes = Cg))
            var y = n.timeoutHandle
            if ((y !== XC && ((n.timeoutHandle = XC), aB(y)), tt !== null))
              for (var k = tt.return; k !== null; ) {
                var J = k.alternate
                ;(Qw(J, k), (k = k.return))
              }
            $B = n
            var T = Kc(n.current, null)
            return (
              (tt = T),
              (QB = iE = a),
              (Rt = kr),
              (dc = null),
              (dS = Cg),
              (Nh = Cg),
              (Vu = Cg),
              (Fh = null),
              (bo = null),
              Be(),
              fQ.discardPendingWarnings(),
              T
            )
          }
          function cs(n, a) {
            do {
              var y = tt
              try {
                if ((D(), Eg(), ht(), (Od.current = null), y === null || y.return === null)) {
                  ;((Rt = fS), (dc = a), (tt = null))
                  return
                }
                if ((V && y.mode & Ae && Sh(y, !0), H))
                  if ((IB(), a !== null && typeof a == "object" && typeof a.then == "function")) {
                    var k = a
                    or(y, k, QB)
                  } else sn(y, a, QB)
                ;(AR(n, y.return, y, a, QB), LS(y))
              } catch (J) {
                ;((a = J), tt === y && y !== null ? ((y = y.return), (tt = y)) : (y = tt))
                continue
              }
              return
            } while (!0)
          }
          function sl() {
            var n = dw.current
            return ((dw.current = ld), n === null ? ld : n)
          }
          function RS(n) {
            dw.current = n
          }
          function Nw() {
            yS = Bi()
          }
          function zd(n) {
            dS = LC(n, dS)
          }
          function Xd() {
            Rt === kr && (Rt = _d)
          }
          function Fw() {
            ;((Rt === kr || Rt === _d || Rt === Mh) && (Rt = fn),
              $B !== null && (hQ(dS) || hQ(Nh)) && mB($B, QB))
          }
          function Pk(n) {
            ;(Rt !== fn && (Rt = Mh), Fh === null ? (Fh = [n]) : Fh.push(n))
          }
          function $d() {
            return Rt === kr
          }
          function JS(n, a) {
            var y = ge
            ge |= no
            var k = sl()
            if ($B !== n || QB !== a) {
              if (uQ) {
                var J = n.memoizedUpdaters
                ;(J.size > 0 && (Jg(n, QB), J.clear()), qQ(n, a))
              }
              kc(n, a)
            }
            Pg(a)
            do
              try {
                KS()
                break
              } catch (T) {
                cs(n, T)
              }
            while (!0)
            if ((D(), (ge = y), RS(k), tt !== null))
              throw new Error(
                "Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.",
              )
            return (rC(), ($B = null), (QB = Cg), Rt)
          }
          function KS() {
            for (; tt !== null; ) vS(tt)
          }
          function Mc(n, a) {
            var y = ge
            ge |= no
            var k = sl()
            if ($B !== n || QB !== a) {
              if (uQ) {
                var J = n.memoizedUpdaters
                ;(J.size > 0 && (Jg(n, QB), J.clear()), qQ(n, a))
              }
              ;(El(), kc(n, a))
            }
            Pg(a)
            do
              try {
                mS()
                break
              } catch (T) {
                cs(n, T)
              }
            while (!0)
            return (
              D(),
              RS(k),
              (ge = y),
              tt !== null ? (uC(), kr) : (rC(), ($B = null), (QB = Cg), Rt)
            )
          }
          function mS() {
            for (; tt !== null && !er(); ) vS(tt)
          }
          function vS(n) {
            var a = n.alternate
            Fe(n)
            var y
            ;((n.mode & Ae) !== FC ? (Cl(n), (y = vB(a, n, iE)), Sh(n, !0)) : (y = vB(a, n, iE)),
              ht(),
              (n.memoizedProps = n.pendingProps),
              y === null ? LS(n) : (tt = y),
              (Od.current = null))
          }
          function LS(n) {
            var a = n
            do {
              var y = a.alternate,
                k = a.return
              if ((a.flags & mA) === SA) {
                Fe(a)
                var J = void 0
                if (
                  ((a.mode & Ae) === FC
                    ? (J = ek(y, a, iE))
                    : (Cl(a), (J = ek(y, a, iE)), Sh(a, !1)),
                  ht(),
                  J !== null)
                ) {
                  tt = J
                  return
                }
              } else {
                var T = DR(y, a)
                if (T !== null) {
                  ;((T.flags &= Li), (tt = T))
                  return
                }
                if ((a.mode & Ae) !== FC) {
                  Sh(a, !1)
                  for (var W = a.actualDuration, BA = a.child; BA !== null; )
                    ((W += BA.actualDuration), (BA = BA.sibling))
                  a.actualDuration = W
                }
                if (k !== null) ((k.flags |= mA), (k.subtreeFlags = SA), (k.deletions = null))
                else {
                  ;((Rt = nl), (tt = null))
                  return
                }
              }
              var cA = a.sibling
              if (cA !== null) {
                tt = cA
                return
              }
              ;((a = k), (tt = a))
            } while (a !== null)
            Rt === kr && (Rt = xk)
          }
          function Uc(n, a) {
            var y = ZB(),
              k = dt.transition
            try {
              ;((dt.transition = null), qt(to), Rw(n, a, y))
            } finally {
              ;((dt.transition = k), qt(y))
            }
            return null
          }
          function Rw(n, a, y) {
            do dn()
            while (al !== null)
            if ((vR(), (ge & (no | it)) !== JB)) throw new Error("Should not already be working.")
            var k = n.finishedWork,
              J = n.finishedLanes
            if ((lt(J), k === null)) return (tr(), null)
            if (
              (J === Cg &&
                s(
                  "root.finishedLanes should not be empty during a commit. This is a bug in React.",
                ),
              (n.finishedWork = null),
              (n.finishedLanes = Cg),
              k === n.current)
            )
              throw new Error(
                "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.",
              )
            ;((n.callbackNode = null), (n.callbackPriority = TC))
            var T = LC(k.lanes, k.childLanes)
            ;(NE(n, T),
              n === $B && (($B = null), (tt = null), (QB = Cg)),
              ((k.subtreeFlags & gg) !== SA || (k.flags & gg) !== SA) &&
                (yc ||
                  ((yc = !0),
                  $u(Ht, function () {
                    return (dn(), null)
                  }))))
            var W = (k.subtreeFlags & (oI | QI | PA | gg)) !== SA,
              BA = (k.flags & (oI | QI | PA | gg)) !== SA
            if (W || BA) {
              var cA = dt.transition
              dt.transition = null
              var RA = ZB()
              qt(to)
              var TA = ge
              ;((ge |= it),
                (Od.current = null),
                kk(n, k),
                bp(),
                Fk(n, k, J),
                Mi(n.containerInfo),
                (n.current = k),
                _n(J),
                uc(k, n, J),
                nr(),
                Ts(),
                (ge = TA),
                qt(RA),
                (dt.transition = cA))
            } else ((n.current = k), bp())
            var DI = yc
            if (
              (yc && ((yc = !1), (al = n), (kS = J)),
              (T = n.pendingLanes),
              T === Cg && (Mr = null),
              DI || YS(n.current, !1),
              $C(k.stateNode, y),
              uQ && n.memoizedUpdaters.clear(),
              Dw(),
              AQ(n, Bi()),
              a !== null)
            )
              for (var vI = n.onRecoverableError, bI = 0; bI < a.length; bI++) {
                var og = a[bI]
                vI(og)
              }
            if (GS) {
              GS = !1
              var cg = Zd
              throw ((Zd = null), cg)
            }
            return (
              Ne(kS, PC) && n.tag !== Ca && dn(),
              (T = n.pendingLanes),
              Ne(T, PC) ? (gE(), n === wc ? pc++ : ((pc = 0), (wc = n))) : (pc = 0),
              bt(),
              tr(),
              null
            )
          }
          function dn() {
            if (al !== null) {
              var n = No(kS),
                a = Zl(FE, n),
                y = dt.transition,
                k = ZB()
              try {
                return ((dt.transition = null), qt(a), Wk())
              } finally {
                ;(qt(k), (dt.transition = y))
              }
            }
            return !1
          }
          function Jw(n) {
            ;(MS.push(n),
              yc ||
                ((yc = !0),
                $u(Ht, function () {
                  return (dn(), null)
                })))
          }
          function Wk() {
            if (al === null) return !1
            var n = al,
              a = kS
            if (((al = null), (kS = Cg), (ge & (no | it)) !== JB))
              throw new Error("Cannot flush passive effects while already rendering.")
            JE(a)
            var y = ge
            ;((ge |= it), Yd(n.current), mk(n, n.current))
            {
              var k = MS
              MS = []
              for (var J = 0; J < k.length; J++) {
                var T = k[J]
                Ew(n, T)
              }
            }
            ;(zg(), YS(n.current, !0), (ge = y), bt(), (Rh = al === null ? 0 : Rh + 1), xi(n))
            {
              var W = n.current.stateNode
              ;((W.effectDuration = 0), (W.passiveEffectDuration = 0))
            }
            return !0
          }
          function Ay(n) {
            return Mr !== null && Mr.has(n)
          }
          function KR(n) {
            Mr === null ? (Mr = /* @__PURE__ */ new Set([n])) : Mr.add(n)
          }
          function Vk(n) {
            GS || ((GS = !0), (Zd = n))
          }
          var jk = Vk
          function zu(n, a, y) {
            var k = gS(y, a),
              J = CS(n, k, PC)
            Qe(n, J)
            var T = Oo(),
              W = rl(n, PC)
            W !== null && ($t(W, PC, T), AQ(W, T))
          }
          function Bt(n, a, y) {
            if (n.tag === _) {
              zu(n, n, y)
              return
            }
            var k = null
            for (k = a; k !== null; ) {
              if (k.tag === _) {
                zu(k, n, y)
                return
              } else if (k.tag === AA) {
                var J = k.type,
                  T = k.stateNode
                if (
                  typeof J.getDerivedStateFromError == "function" ||
                  (typeof T.componentDidCatch == "function" && !Ay(T))
                ) {
                  var W = gS(y, n),
                    BA = mu(k, W, PC)
                  Qe(k, BA)
                  var cA = Oo(),
                    RA = rl(k, PC)
                  RA !== null && ($t(RA, PC, cA), AQ(RA, cA))
                  return
                }
              }
              k = k.return
            }
            s(
              `Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`,
              y,
            )
          }
          function Kw(n, a, y) {
            var k = n.pingCache
            k !== null && k.delete(a)
            var J = Oo()
            ;(qs(n, y),
              GQ(n),
              $B === n &&
                Uo(QB, y) &&
                (Rt === fn || (Rt === _d && bn(QB) && Bi() - yS < yw)
                  ? kc(n, Cg)
                  : (Vu = LC(Vu, y))),
              AQ(n, J))
          }
          function Kh(n, a) {
            a === TC && (a = Gw(n))
            var y = Oo(),
              k = rl(n, a)
            k !== null && ($t(k, a, y), AQ(k, y))
          }
          function mw(n) {
            var a = n.memoizedState,
              y = TC
            ;(a !== null && (y = a.retryLane), Kh(n, y))
          }
          function mR(n, a) {
            var y = TC,
              k
            switch (n.tag) {
              case sA:
                k = n.stateNode
                var J = n.memoizedState
                J !== null && (y = J.retryLane)
                break
              case kA:
                k = n.stateNode
                break
              default:
                throw new Error(
                  "Pinged unknown suspense boundary type. This is probably a bug in React.",
                )
            }
            ;(k !== null && k.delete(a), Kh(n, y))
          }
          function Nc(n) {
            return n < 120
              ? 120
              : n < 480
                ? 480
                : n < 1080
                  ? 1080
                  : n < 1920
                    ? 1920
                    : n < 3e3
                      ? 3e3
                      : n < 4320
                        ? 4320
                        : NR(n / 1960) * 1960
          }
          function Xu() {
            if (pc > pw)
              throw (
                (pc = 0),
                (wc = null),
                new Error(
                  "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.",
                )
              )
            Rh > ww &&
              ((Rh = 0),
              s(
                "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.",
              ))
          }
          function vR() {
            ;(fQ.flushLegacyContextWarning(), fQ.flushPendingUnsafeLifecycleWarnings())
          }
          function YS(n, a) {
            ;(Fe(n), Eo(n, rA, Lk), a && Eo(n, _A, lw), Eo(n, rA, kR), a && Eo(n, _A, wh), ht())
          }
          function Eo(n, a, y) {
            for (var k = n, J = null; k !== null; ) {
              var T = k.subtreeFlags & a
              k !== J && k.child !== null && T !== SA
                ? (k = k.child)
                : ((k.flags & a) !== SA && y(k),
                  k.sibling !== null ? (k = k.sibling) : (k = J = k.return))
            }
          }
          var DB = null
          function Ur(n) {
            {
              if ((ge & no) !== JB || !(n.mode & Ai)) return
              var a = n.tag
              if (a !== X && a !== _ && a !== AA && a !== P && a !== nA && a !== $ && a !== EA)
                return
              var y = $I(n) || "ReactComponent"
              if (DB !== null) {
                if (DB.has(y)) return
                DB.add(y)
              } else DB = /* @__PURE__ */ new Set([y])
              var k = WB
              try {
                ;(Fe(n),
                  s(
                    "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.",
                  ))
              } finally {
                k ? Fe(n) : ht()
              }
            }
          }
          var vB
          {
            var ao = null
            vB = function (n, a, y) {
              var k = OS(ao, a)
              try {
                return Sk(n, a, y)
              } catch (T) {
                if (T !== null && typeof T == "object" && typeof T.then == "function") throw T
                if (
                  (D(),
                  Eg(),
                  Qw(n, a),
                  OS(a, k),
                  a.mode & Ae && Cl(a),
                  yk(null, Sk, null, n, a, y),
                  dR())
                ) {
                  var J = pk()
                  typeof J == "object" &&
                    J !== null &&
                    J._suppressLogging &&
                    typeof T == "object" &&
                    T !== null &&
                    !T._suppressLogging &&
                    (T._suppressLogging = !0)
                }
                throw T
              }
            }
          }
          var Iy = !1,
            qS
          qS = /* @__PURE__ */ new Set()
          function LR(n) {
            if (kB && !PG())
              switch (n.tag) {
                case P:
                case nA:
                case EA: {
                  var a = (tt && $I(tt)) || "Unknown",
                    y = a
                  if (!qS.has(y)) {
                    qS.add(y)
                    var k = $I(n) || "Unknown"
                    s(
                      "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render",
                      k,
                      a,
                      a,
                    )
                  }
                  break
                }
                case AA: {
                  Iy ||
                    (s(
                      "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.",
                    ),
                    (Iy = !0))
                  break
                }
              }
          }
          function Jg(n, a) {
            if (uQ) {
              var y = n.memoizedUpdaters
              y.forEach(function (k) {
                pi(n, k, a)
              })
            }
          }
          var mh = {}
          function $u(n, a) {
            {
              var y = Gr.current
              return y !== null ? (y.push(a), mh) : Pl(n, a)
            }
          }
          function vh(n) {
            if (n !== mh) return Hs(n)
          }
          function Fc() {
            return Gr.current !== null
          }
          function Ji(n) {
            {
              if (n.mode & Ai) {
                if (!Tk()) return
              } else if (!UR() || ge !== JB || (n.tag !== P && n.tag !== nA && n.tag !== EA)) return
              if (Gr.current === null) {
                var a = WB
                try {
                  ;(Fe(n),
                    s(
                      `An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`,
                      $I(n),
                    ))
                } finally {
                  a ? Fe(n) : ht()
                }
              }
            }
          }
          function GQ(n) {
            n.tag !== Ca &&
              Tk() &&
              Gr.current === null &&
              s(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`)
          }
          var Ki = null,
            ll = null,
            HS = function (n) {
              Ki = n
            }
          function hs(n) {
            {
              if (Ki === null) return n
              var a = Ki(n)
              return a === void 0 ? n : a.current
            }
          }
          function vw(n) {
            return hs(n)
          }
          function Lw(n) {
            {
              if (Ki === null) return n
              var a = Ki(n)
              if (a === void 0) {
                if (n != null && typeof n.render == "function") {
                  var y = hs(n.render)
                  if (n.render !== y) {
                    var k = {
                      $$typeof: YI,
                      render: y,
                    }
                    return (n.displayName !== void 0 && (k.displayName = n.displayName), k)
                  }
                }
                return n
              }
              return a.current
            }
          }
          function jI(n, a) {
            {
              if (Ki === null) return !1
              var y = n.elementType,
                k = a.type,
                J = !1,
                T = typeof k == "object" && k !== null ? k.$$typeof : null
              switch (n.tag) {
                case AA: {
                  typeof k == "function" && (J = !0)
                  break
                }
                case P: {
                  ;(typeof k == "function" || T === FA) && (J = !0)
                  break
                }
                case nA: {
                  ;(T === YI || T === FA) && (J = !0)
                  break
                }
                case $:
                case EA: {
                  ;(T === tA || T === FA) && (J = !0)
                  break
                }
                default:
                  return !1
              }
              if (J) {
                var W = Ki(y)
                if (W !== void 0 && W === Ki(k)) return !0
              }
              return !1
            }
          }
          function bE(n) {
            {
              if (Ki === null || typeof WeakSet != "function") return
              ;(ll === null && (ll = /* @__PURE__ */ new WeakSet()), ll.add(n))
            }
          }
          var Rc = function (n, a) {
              {
                if (Ki === null) return
                var y = a.staleFamilies,
                  k = a.updatedFamilies
                ;(dn(),
                  ju(function () {
                    gi(n.current, k, y)
                  }))
              }
            },
            Yw = function (n, a) {
              {
                if (n.context !== he) return
                ;(dn(),
                  ju(function () {
                    oy(a, n, null, null)
                  }))
              }
            }
          function gi(n, a, y) {
            {
              var k = n.alternate,
                J = n.child,
                T = n.sibling,
                W = n.tag,
                BA = n.type,
                cA = null
              switch (W) {
                case P:
                case EA:
                case AA:
                  cA = BA
                  break
                case nA:
                  cA = BA.render
                  break
              }
              if (Ki === null)
                throw new Error("Expected resolveFamily to be set during hot reload.")
              var RA = !1,
                TA = !1
              if (cA !== null) {
                var DI = Ki(cA)
                DI !== void 0 &&
                  (y.has(DI) ? (TA = !0) : a.has(DI) && (W === AA ? (TA = !0) : (RA = !0)))
              }
              ;(ll !== null && (ll.has(n) || (k !== null && ll.has(k))) && (TA = !0),
                TA && (n._debugNeedsRemount = !0),
                (TA || RA) && wQ(n, PC, Je),
                J !== null && !TA && gi(J, a, y),
                T !== null && gi(T, a, y))
            }
          }
          var Ng = function (n, a) {
            {
              var y = /* @__PURE__ */ new Set(),
                k = new Set(
                  a.map(function (J) {
                    return J.current
                  }),
                )
              return (Jc(n.current, k, y), y)
            }
          }
          function Jc(n, a, y) {
            {
              var k = n.child,
                J = n.sibling,
                T = n.tag,
                W = n.type,
                BA = null
              switch (T) {
                case P:
                case EA:
                case AA:
                  BA = W
                  break
                case nA:
                  BA = W.render
                  break
              }
              var cA = !1
              ;(BA !== null && a.has(BA) && (cA = !0),
                cA ? YR(n, y) : k !== null && Jc(k, a, y),
                J !== null && Jc(J, a, y))
            }
          }
          function YR(n, a) {
            {
              var y = _o(n, a)
              if (y) return
              for (var k = n; ; ) {
                switch (k.tag) {
                  case CA:
                    a.add(k.stateNode)
                    return
                  case eA:
                    a.add(k.stateNode.containerInfo)
                    return
                  case _:
                    a.add(k.stateNode.containerInfo)
                    return
                }
                if (k.return === null) throw new Error("Expected to reach root first.")
                k = k.return
              }
            }
          }
          function _o(n, a) {
            for (var y = n, k = !1; ; ) {
              if (y.tag === CA) ((k = !0), a.add(y.stateNode))
              else if (y.child !== null) {
                ;((y.child.return = y), (y = y.child))
                continue
              }
              if (y === n) return k
              for (; y.sibling === null; ) {
                if (y.return === null || y.return === n) return k
                y = y.return
              }
              ;((y.sibling.return = y.return), (y = y.sibling))
            }
            return !1
          }
          var TS
          {
            TS = !1
            try {
              var Lh = Object.preventExtensions({})
            } catch {
              TS = !0
            }
          }
          function AD(n, a, y, k) {
            ;((this.tag = n),
              (this.key = y),
              (this.elementType = null),
              (this.type = null),
              (this.stateNode = null),
              (this.return = null),
              (this.child = null),
              (this.sibling = null),
              (this.index = 0),
              (this.ref = null),
              (this.pendingProps = a),
              (this.memoizedProps = null),
              (this.updateQueue = null),
              (this.memoizedState = null),
              (this.dependencies = null),
              (this.mode = k),
              (this.flags = SA),
              (this.subtreeFlags = SA),
              (this.deletions = null),
              (this.lanes = Cg),
              (this.childLanes = Cg),
              (this.alternate = null),
              (this.actualDuration = Number.NaN),
              (this.actualStartTime = Number.NaN),
              (this.selfBaseDuration = Number.NaN),
              (this.treeBaseDuration = Number.NaN),
              (this.actualDuration = 0),
              (this.actualStartTime = -1),
              (this.selfBaseDuration = 0),
              (this.treeBaseDuration = 0),
              (this._debugSource = null),
              (this._debugOwner = null),
              (this._debugNeedsRemount = !1),
              (this._debugHookTypes = null),
              !TS &&
                typeof Object.preventExtensions == "function" &&
                Object.preventExtensions(this))
          }
          var tE = function (n, a, y, k) {
            return new AD(n, a, y, k)
          }
          function gy(n) {
            var a = n.prototype
            return !!(a && a.isReactComponent)
          }
          function us(n) {
            return typeof n == "function" && !gy(n) && n.defaultProps === void 0
          }
          function Ua(n) {
            if (typeof n == "function") return gy(n) ? AA : P
            if (n != null) {
              var a = n.$$typeof
              if (a === YI) return nA
              if (a === tA) return $
            }
            return X
          }
          function Kc(n, a) {
            var y = n.alternate
            ;(y === null
              ? ((y = tE(n.tag, a, n.key, n.mode)),
                (y.elementType = n.elementType),
                (y.type = n.type),
                (y.stateNode = n.stateNode),
                (y._debugSource = n._debugSource),
                (y._debugOwner = n._debugOwner),
                (y._debugHookTypes = n._debugHookTypes),
                (y.alternate = n),
                (n.alternate = y))
              : ((y.pendingProps = a),
                (y.type = n.type),
                (y.flags = SA),
                (y.subtreeFlags = SA),
                (y.deletions = null),
                (y.actualDuration = 0),
                (y.actualStartTime = -1)),
              (y.flags = n.flags & EI),
              (y.childLanes = n.childLanes),
              (y.lanes = n.lanes),
              (y.child = n.child),
              (y.memoizedProps = n.memoizedProps),
              (y.memoizedState = n.memoizedState),
              (y.updateQueue = n.updateQueue))
            var k = n.dependencies
            switch (
              ((y.dependencies =
                k === null
                  ? null
                  : {
                      lanes: k.lanes,
                      firstContext: k.firstContext,
                    }),
              (y.sibling = n.sibling),
              (y.index = n.index),
              (y.ref = n.ref),
              (y.selfBaseDuration = n.selfBaseDuration),
              (y.treeBaseDuration = n.treeBaseDuration),
              (y._debugNeedsRemount = n._debugNeedsRemount),
              y.tag)
            ) {
              case X:
              case P:
              case EA:
                y.type = hs(n.type)
                break
              case AA:
                y.type = vw(n.type)
                break
              case nA:
                y.type = Lw(n.type)
                break
            }
            return y
          }
          function qw(n, a) {
            n.flags &= EI | HA
            var y = n.alternate
            if (y === null)
              ((n.childLanes = Cg),
                (n.lanes = a),
                (n.child = null),
                (n.subtreeFlags = SA),
                (n.memoizedProps = null),
                (n.memoizedState = null),
                (n.updateQueue = null),
                (n.dependencies = null),
                (n.stateNode = null),
                (n.selfBaseDuration = 0),
                (n.treeBaseDuration = 0))
            else {
              ;((n.childLanes = y.childLanes),
                (n.lanes = y.lanes),
                (n.child = y.child),
                (n.subtreeFlags = SA),
                (n.deletions = null),
                (n.memoizedProps = y.memoizedProps),
                (n.memoizedState = y.memoizedState),
                (n.updateQueue = y.updateQueue),
                (n.type = y.type))
              var k = y.dependencies
              ;((n.dependencies =
                k === null
                  ? null
                  : {
                      lanes: k.lanes,
                      firstContext: k.firstContext,
                    }),
                (n.selfBaseDuration = y.selfBaseDuration),
                (n.treeBaseDuration = y.treeBaseDuration))
            }
            return n
          }
          function Hw(n, a, y) {
            var k
            return (
              n === Tl ? ((k = Ai), a === !0 && ((k |= qi), (k |= sB))) : (k = FC),
              uQ && (k |= Ae),
              tE(_, null, null, k)
            )
          }
          function xS(n, a, y, k, J, T) {
            var W = X,
              BA = n
            if (typeof n == "function") gy(n) ? ((W = AA), (BA = vw(BA))) : (BA = hs(BA))
            else if (typeof n == "string") W = CA
            else
              A: switch (n) {
                case uA:
                  return Yh(y.children, J, T, a)
                case hI:
                  ;((W = JA), (J |= qi), (J & Ai) !== FC && (J |= sB))
                  break
                case II:
                  return GL(y, J, T, a)
                case SI:
                  return Tw(y, J, T, a)
                case QA:
                  return Cy(y, J, T, a)
                case nI:
                  return xw(y, J, T, a)
                case UI:
                // eslint-disable-next-line no-fallthrough
                case WA:
                // eslint-disable-next-line no-fallthrough
                case GI:
                // eslint-disable-next-line no-fallthrough
                case LI:
                // eslint-disable-next-line no-fallthrough
                case jA:
                // eslint-disable-next-line no-fallthrough
                default: {
                  if (typeof n == "object" && n !== null)
                    switch (n.$$typeof) {
                      case pI:
                        W = LA
                        break A
                      case AI:
                        W = yA
                        break A
                      case YI:
                        ;((W = nA), (BA = Lw(BA)))
                        break A
                      case tA:
                        W = $
                        break A
                      case FA:
                        ;((W = GA), (BA = null))
                        break A
                    }
                  var cA = ""
                  {
                    ;(n === void 0 ||
                      (typeof n == "object" && n !== null && Object.keys(n).length === 0)) &&
                      (cA +=
                        " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.")
                    var RA = k ? $I(k) : null
                    RA &&
                      (cA +=
                        `

Check the render method of \`` +
                        RA +
                        "`.")
                  }
                  throw new Error(
                    "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " +
                      ("but got: " + (n == null ? n : typeof n) + "." + cA),
                  )
                }
              }
            var TA = tE(W, y, a, J)
            return ((TA.elementType = n), (TA.type = BA), (TA.lanes = T), (TA._debugOwner = k), TA)
          }
          function bS(n, a, y) {
            var k = null
            k = n._owner
            var J = n.type,
              T = n.key,
              W = n.props,
              BA = xS(J, T, W, k, a, y)
            return ((BA._debugSource = n._source), (BA._debugOwner = n._owner), BA)
          }
          function Yh(n, a, y, k) {
            var J = tE(lA, n, k, a)
            return ((J.lanes = y), J)
          }
          function GL(n, a, y, k) {
            typeof n.id != "string" &&
              s(
                'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
                typeof n.id,
              )
            var J = tE(fA, n, k, a | Ae)
            return (
              (J.elementType = II),
              (J.lanes = y),
              (J.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0,
              }),
              J
            )
          }
          function Tw(n, a, y, k) {
            var J = tE(sA, n, k, a)
            return ((J.elementType = SI), (J.lanes = y), J)
          }
          function Cy(n, a, y, k) {
            var J = tE(kA, n, k, a)
            return ((J.elementType = QA), (J.lanes = y), J)
          }
          function xw(n, a, y, k) {
            var J = tE(qA, n, k, a)
            ;((J.elementType = nI), (J.lanes = y))
            var T = {}
            return ((J.stateNode = T), J)
          }
          function ey(n, a, y) {
            var k = tE(aA, n, null, a)
            return ((k.lanes = y), k)
          }
          function zk() {
            var n = tE(CA, null, null, FC)
            return ((n.elementType = "DELETED"), n)
          }
          function Xk(n) {
            var a = tE(dA, null, null, FC)
            return ((a.stateNode = n), a)
          }
          function iy(n, a, y) {
            var k = n.children !== null ? n.children : [],
              J = tE(eA, k, n.key, a)
            return (
              (J.lanes = y),
              (J.stateNode = {
                containerInfo: n.containerInfo,
                pendingChildren: null,
                // Used by persistent updates
                implementation: n.implementation,
              }),
              J
            )
          }
          function OS(n, a) {
            return (
              n === null && (n = tE(X, null, null, FC)),
              (n.tag = a.tag),
              (n.key = a.key),
              (n.elementType = a.elementType),
              (n.type = a.type),
              (n.stateNode = a.stateNode),
              (n.return = a.return),
              (n.child = a.child),
              (n.sibling = a.sibling),
              (n.index = a.index),
              (n.ref = a.ref),
              (n.pendingProps = a.pendingProps),
              (n.memoizedProps = a.memoizedProps),
              (n.updateQueue = a.updateQueue),
              (n.memoizedState = a.memoizedState),
              (n.dependencies = a.dependencies),
              (n.mode = a.mode),
              (n.flags = a.flags),
              (n.subtreeFlags = a.subtreeFlags),
              (n.deletions = a.deletions),
              (n.lanes = a.lanes),
              (n.childLanes = a.childLanes),
              (n.alternate = a.alternate),
              (n.actualDuration = a.actualDuration),
              (n.actualStartTime = a.actualStartTime),
              (n.selfBaseDuration = a.selfBaseDuration),
              (n.treeBaseDuration = a.treeBaseDuration),
              (n._debugSource = a._debugSource),
              (n._debugOwner = a._debugOwner),
              (n._debugNeedsRemount = a._debugNeedsRemount),
              (n._debugHookTypes = a._debugHookTypes),
              n
            )
          }
          function bw(n, a, y, k, J) {
            ;((this.tag = a),
              (this.containerInfo = n),
              (this.pendingChildren = null),
              (this.current = null),
              (this.pingCache = null),
              (this.finishedWork = null),
              (this.timeoutHandle = XC),
              (this.context = null),
              (this.pendingContext = null),
              (this.callbackNode = null),
              (this.callbackPriority = TC),
              (this.eventTimes = YQ(Cg)),
              (this.expirationTimes = YQ(Je)),
              (this.pendingLanes = Cg),
              (this.suspendedLanes = Cg),
              (this.pingedLanes = Cg),
              (this.expiredLanes = Cg),
              (this.mutableReadLanes = Cg),
              (this.finishedLanes = Cg),
              (this.entangledLanes = Cg),
              (this.entanglements = YQ(Cg)),
              (this.identifierPrefix = k),
              (this.onRecoverableError = J),
              Ui && (this.mutableSourceEagerHydrationData = null),
              (this.effectDuration = 0),
              (this.passiveEffectDuration = 0))
            {
              this.memoizedUpdaters = /* @__PURE__ */ new Set()
              for (var T = (this.pendingUpdatersLaneMap = []), W = 0; W < Pr; W++)
                T.push(/* @__PURE__ */ new Set())
            }
            switch (a) {
              case Tl:
                this._debugRootType = y ? "hydrateRoot()" : "createRoot()"
                break
              case Ca:
                this._debugRootType = y ? "hydrate()" : "render()"
                break
            }
          }
          function ty(n, a, y, k, J, T, W, BA, cA, RA) {
            var TA = new bw(n, a, y, BA, cA),
              DI = Hw(a, T)
            ;((TA.current = DI), (DI.stateNode = TA))
            {
              var vI = {
                element: k,
                isDehydrated: y,
                cache: null,
                // not enabled yet
                transitions: null,
              }
              DI.memoizedState = vI
            }
            return (Zg(DI), TA)
          }
          var _S = "18.0.0-fc46dba67-20220329"
          function Ow(n, a, y) {
            var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null
            return (
              VB(k),
              {
                // This tag allow us to uniquely identify this as a React Portal
                $$typeof: eI,
                key: k == null ? null : "" + k,
                children: n,
                containerInfo: a,
                implementation: y,
              }
            )
          }
          var ID, qh
          ;((ID = !1), (qh = {}))
          function ZS(n) {
            if (!n) return he
            var a = d(n),
              y = ms(a)
            if (a.tag === AA) {
              var k = a.type
              if (Co(k)) return eo(a, k, y)
            }
            return y
          }
          function By(n) {
            var a = d(n)
            if (a === void 0) {
              if (typeof n.render == "function")
                throw new Error("Unable to find node on an unmounted component.")
              var y = Object.keys(n).join(",")
              throw new Error("Argument appears to not be a ReactComponent. Keys: " + y)
            }
            var k = wC(a)
            return k === null ? null : k.stateNode
          }
          function PS(n, a) {
            {
              var y = d(n)
              if (y === void 0) {
                if (typeof n.render == "function")
                  throw new Error("Unable to find node on an unmounted component.")
                var k = Object.keys(n).join(",")
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + k)
              }
              var J = wC(y)
              if (J === null) return null
              if (J.mode & qi) {
                var T = $I(y) || "Component"
                if (!qh[T]) {
                  qh[T] = !0
                  var W = WB
                  try {
                    ;(Fe(J),
                      y.mode & qi
                        ? s(
                            "%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node",
                            a,
                            a,
                            T,
                          )
                        : s(
                            "%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node",
                            a,
                            a,
                            T,
                          ))
                  } finally {
                    W ? Fe(W) : ht()
                  }
                }
              }
              return J.stateNode
            }
          }
          function _w(n, a, y, k, J, T, W, BA) {
            var cA = !1,
              RA = null
            return ty(n, a, cA, RA, y, k, J, T, W)
          }
          function Qy(n, a, y, k, J, T, W, BA, cA, RA) {
            var TA = !0,
              DI = ty(y, k, TA, n, J, T, W, BA, cA)
            DI.context = ZS(null)
            var vI = DI.current,
              bI = Oo(),
              og = ls(vI),
              cg = SC(bI, og)
            return ((cg.callback = a ?? null), Qe(vI, cg), FR(DI, og, bI), DI)
          }
          function oy(n, a, y, k) {
            li(a, n)
            var J = a.current,
              T = Oo(),
              W = ls(J)
            xt(W)
            var BA = ZS(y)
            ;(a.context === null ? (a.context = BA) : (a.pendingContext = BA),
              kB &&
                WB !== null &&
                !ID &&
                ((ID = !0),
                s(
                  `Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`,
                  $I(WB) || "Unknown",
                )))
            var cA = SC(T, W)
            ;((cA.payload = {
              element: n,
            }),
              (k = k === void 0 ? null : k),
              k !== null &&
                (typeof k != "function" &&
                  s(
                    "render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.",
                    k,
                  ),
                (cA.callback = k)),
              Qe(J, cA))
            var RA = wQ(J, W, T)
            return (RA !== null && bi(RA, J, W), W)
          }
          function ny(n) {
            var a = n.current
            if (!a.child) return null
            switch (a.child.tag) {
              case CA:
                return vC(a.child.stateNode)
              default:
                return a.child.stateNode
            }
          }
          function $k(n) {
            switch (n.tag) {
              case _:
                var a = n.stateNode
                if (gB(a)) {
                  var y = bB(a)
                  Wd(a, y)
                }
                break
              case sA:
                var k = Oo()
                ju(function () {
                  return wQ(n, PC, k)
                })
                var J = PC
                gD(n, J)
                break
            }
          }
          function Ey(n, a) {
            var y = n.memoizedState
            y !== null && y.dehydrated !== null && (y.retryLane = lg(y.retryLane, a))
          }
          function gD(n, a) {
            Ey(n, a)
            var y = n.alternate
            y && Ey(y, a)
          }
          function qR(n) {
            if (n.tag === sA) {
              var a = Oo(),
                y = Ba
              ;(wQ(n, y, a), gD(n, y))
            }
          }
          function ay(n) {
            if (n.tag === sA) {
              var a = Oo(),
                y = ls(n)
              ;(wQ(n, y, a), gD(n, y))
            }
          }
          function Zw(n) {
            var a = UC(n)
            return a === null ? null : a.stateNode
          }
          var WS = function (n) {
            return null
          }
          function ry(n) {
            return WS(n)
          }
          var VS = function (n) {
            return !1
          }
          function sy(n) {
            return VS(n)
          }
          var Pw = null,
            Ww = null,
            Vw = null,
            AM = null,
            ly = null,
            jw = null,
            zw = null,
            Xw = null,
            IM = null
          {
            var cy = function (n, a, y) {
                var k = a[y],
                  J = _C(n) ? n.slice() : S({}, n)
                return y + 1 === a.length
                  ? (_C(J) ? J.splice(k, 1) : delete J[k], J)
                  : ((J[k] = cy(n[k], a, y + 1)), J)
              },
              jS = function (n, a) {
                return cy(n, a, 0)
              },
              gM = function (n, a, y, k) {
                var J = a[k],
                  T = _C(n) ? n.slice() : S({}, n)
                if (k + 1 === a.length) {
                  var W = y[k]
                  ;((T[W] = T[J]), _C(T) ? T.splice(J, 1) : delete T[J])
                } else
                  T[J] = gM(
                    // $FlowFixMe number or string is fine here
                    n[J],
                    a,
                    y,
                    k + 1,
                  )
                return T
              },
              CM = function (n, a, y) {
                if (a.length !== y.length) {
                  r("copyWithRename() expects paths of the same length")
                  return
                } else
                  for (var k = 0; k < y.length - 1; k++)
                    if (a[k] !== y[k]) {
                      r("copyWithRename() expects paths to be the same except for the deepest key")
                      return
                    }
                return gM(n, a, y, 0)
              },
              $w = function (n, a, y, k) {
                if (y >= a.length) return k
                var J = a[y],
                  T = _C(n) ? n.slice() : S({}, n)
                return ((T[J] = $w(n[J], a, y + 1, k)), T)
              },
              A0 = function (n, a, y) {
                return $w(n, a, 0, y)
              },
              hy = function (n, a) {
                for (var y = n.memoizedState; y !== null && a > 0; ) ((y = y.next), a--)
                return y
              }
            ;((Pw = function (n, a, y, k) {
              var J = hy(n, a)
              if (J !== null) {
                var T = A0(J.memoizedState, y, k)
                ;((J.memoizedState = T),
                  (J.baseState = T),
                  (n.memoizedProps = S({}, n.memoizedProps)),
                  wQ(n, PC, Je))
              }
            }),
              (Ww = function (n, a, y) {
                var k = hy(n, a)
                if (k !== null) {
                  var J = jS(k.memoizedState, y)
                  ;((k.memoizedState = J),
                    (k.baseState = J),
                    (n.memoizedProps = S({}, n.memoizedProps)),
                    wQ(n, PC, Je))
                }
              }),
              (Vw = function (n, a, y, k) {
                var J = hy(n, a)
                if (J !== null) {
                  var T = CM(J.memoizedState, y, k)
                  ;((J.memoizedState = T),
                    (J.baseState = T),
                    (n.memoizedProps = S({}, n.memoizedProps)),
                    wQ(n, PC, Je))
                }
              }),
              (AM = function (n, a, y) {
                ;((n.pendingProps = A0(n.memoizedProps, a, y)),
                  n.alternate && (n.alternate.pendingProps = n.pendingProps),
                  wQ(n, PC, Je))
              }),
              (ly = function (n, a) {
                ;((n.pendingProps = jS(n.memoizedProps, a)),
                  n.alternate && (n.alternate.pendingProps = n.pendingProps),
                  wQ(n, PC, Je))
              }),
              (jw = function (n, a, y) {
                ;((n.pendingProps = CM(n.memoizedProps, a, y)),
                  n.alternate && (n.alternate.pendingProps = n.pendingProps),
                  wQ(n, PC, Je))
              }),
              (zw = function (n) {
                wQ(n, PC, Je)
              }),
              (Xw = function (n) {
                WS = n
              }),
              (IM = function (n) {
                VS = n
              }))
          }
          function eM(n) {
            var a = wC(n)
            return a === null ? null : a.stateNode
          }
          function uy(n) {
            return null
          }
          function iM() {
            return WB
          }
          function tM(n) {
            var a = n.findFiberByHostInstance,
              y = i.ReactCurrentDispatcher
            return rn({
              bundleType: n.bundleType,
              version: n.version,
              rendererPackageName: n.rendererPackageName,
              rendererConfig: n.rendererConfig,
              overrideHookState: Pw,
              overrideHookStateDeletePath: Ww,
              overrideHookStateRenamePath: Vw,
              overrideProps: AM,
              overridePropsDeletePath: ly,
              overridePropsRenamePath: jw,
              setErrorHandler: Xw,
              setSuspenseHandler: IM,
              scheduleUpdate: zw,
              currentDispatcherRef: y,
              findHostInstanceByFiber: eM,
              findFiberByHostInstance: a || uy,
              // React Refresh
              findHostInstancesForRefresh: Ng,
              scheduleRefresh: Rc,
              scheduleRoot: Yw,
              setRefreshHandler: HS,
              // Enables DevTools to append owner stacks to error messages in DEV mode.
              getCurrentFiber: iM,
              // Enables DevTools to detect reconciler version rather than renderer version
              // which may not match for third party renderers.
              reconcilerVersion: _S,
            })
          }
          return (
            (I.attemptContinuousHydration = qR),
            (I.attemptHydrationAtCurrentPriority = ay),
            (I.attemptSynchronousHydration = $k),
            (I.batchedUpdates = Zk),
            (I.createComponentSelector = oo),
            (I.createContainer = _w),
            (I.createHasPseudoClassSelector = Ma),
            (I.createHydrationContainer = Qy),
            (I.createPortal = Ow),
            (I.createRoleSelector = wr),
            (I.createTestNameSelector = Sc),
            (I.createTextSelector = kh),
            (I.deferredUpdates = _k),
            (I.discreteUpdates = Vd),
            (I.findAllNodes = DS),
            (I.findBoundingRects = uw),
            (I.findHostInstance = By),
            (I.findHostInstanceWithNoPortals = Zw),
            (I.findHostInstanceWithWarning = PS),
            (I.flushControlled = Uw),
            (I.flushPassiveEffects = dn),
            (I.flushSync = ju),
            (I.focusWithin = Hk),
            (I.getCurrentUpdatePriority = ZB),
            (I.getFindAllNodesFailureDescription = qk),
            (I.getPublicRootInstance = ny),
            (I.injectIntoDevTools = tM),
            (I.isAlreadyRendering = jd),
            (I.observeVisibleRects = Sw),
            (I.registerMutableSourceForHydration = Eh),
            (I.runWithPriority = Hi),
            (I.shouldError = ry),
            (I.shouldSuspend = sy),
            (I.updateContainer = oy),
            I
          )
        })),
    qK.exports
  )
}
var fT
function Uz() {
  return (
    fT ||
      ((fT = 1), process.env.NODE_ENV === "production" ? (wU.exports = kz()) : (wU.exports = Mz())),
    wU.exports
  )
}
var Nz = Uz()
const Fz = /* @__PURE__ */ qm(Nz)
var dT = Fv()
const Rv = {},
  Jv = (e) => void Object.assign(Rv, e)
function Rz(e, A) {
  function I(h, { args: S = [], attach: d, ...w }, M) {
    let K = `${h[0].toUpperCase()}${h.slice(1)}`,
      R
    if (h === "primitive") {
      if (w.object === void 0) throw new Error("R3F: Primitives without 'object' are invalid!")
      const F = w.object
      R = zy(F, {
        type: h,
        root: M,
        attach: d,
        primitive: !0,
      })
    } else {
      const F = Rv[K]
      if (!F)
        throw new Error(
          `R3F: ${K} is not part of the THREE namespace! Did you forget to extend? See: https://docs.pmnd.rs/react-three-fiber/api/objects#using-3rd-party-objects-declaratively`,
        )
      if (!Array.isArray(S)) throw new Error("R3F: The args prop must be an array!")
      R = zy(new F(...S), {
        type: h,
        root: M,
        attach: d,
        // Save args in case we need to reconstruct later for HMR
        memoizedProps: {
          args: S,
        },
      })
    }
    return (
      R.__r3f.attach === void 0 &&
        (R instanceof se
          ? (R.__r3f.attach = "geometry")
          : R instanceof tQ && (R.__r3f.attach = "material")),
      K !== "inject" && xK(R, w),
      R
    )
  }
  function g(h, S) {
    let d = !1
    if (S) {
      var w, M
      ;((w = S.__r3f) != null && w.attach
        ? TK(h, S, S.__r3f.attach)
        : S.isObject3D && h.isObject3D && (h.add(S), (d = !0)),
        d || (M = h.__r3f) == null || M.objects.push(S),
        S.__r3f || zy(S, {}),
        (S.__r3f.parent = h),
        Mm(S),
        Xy(S))
    }
  }
  function C(h, S, d) {
    let w = !1
    if (S) {
      var M, K
      if ((M = S.__r3f) != null && M.attach) TK(h, S, S.__r3f.attach)
      else if (S.isObject3D && h.isObject3D) {
        ;((S.parent = h),
          S.dispatchEvent({
            type: "added",
          }),
          h.dispatchEvent({
            type: "childadded",
            child: S,
          }))
        const R = h.children.filter((L) => L !== S),
          F = R.indexOf(d)
        ;((h.children = [...R.slice(0, F), S, ...R.slice(F)]), (w = !0))
      }
      ;(w || (K = h.__r3f) == null || K.objects.push(S),
        S.__r3f || zy(S, {}),
        (S.__r3f.parent = h),
        Mm(S),
        Xy(S))
    }
  }
  function i(h, S, d = !1) {
    h && [...h].forEach((w) => B(S, w, d))
  }
  function B(h, S, d) {
    if (S) {
      var w, M, K
      if (
        (S.__r3f && (S.__r3f.parent = null),
        (w = h.__r3f) != null &&
          w.objects &&
          (h.__r3f.objects = h.__r3f.objects.filter((H) => H !== S)),
        (M = S.__r3f) != null && M.attach)
      )
        kT(h, S, S.__r3f.attach)
      else if (S.isObject3D && h.isObject3D) {
        var R
        ;(h.remove(S), (R = S.__r3f) != null && R.root && Tz(LU(S), S))
      }
      const L = (K = S.__r3f) == null ? void 0 : K.primitive,
        Y = !L && (d === void 0 ? S.dispose !== null : d)
      if (!L) {
        var F
        ;(i((F = S.__r3f) == null ? void 0 : F.objects, S, Y), i(S.children, S, Y))
      }
      if ((delete S.__r3f, Y && S.dispose && S.type !== "Scene")) {
        const H = () => {
          try {
            S.dispose()
          } catch {}
        }
        typeof IS_REACT_ACT_ENVIRONMENT > "u"
          ? dT.unstable_scheduleCallback(dT.unstable_IdlePriority, H)
          : H()
      }
      Xy(h)
    }
  }
  function o(h, S, d, w) {
    var M
    const K = (M = h.__r3f) == null ? void 0 : M.parent
    if (!K) return
    const R = I(S, d, h.__r3f.root)
    if (h.children) {
      for (const F of h.children) F.__r3f && g(R, F)
      h.children = h.children.filter((F) => !F.__r3f)
    }
    ;(h.__r3f.objects.forEach((F) => g(R, F)),
      (h.__r3f.objects = []),
      h.__r3f.autoRemovedBeforeAppend || B(K, h),
      R.parent && (R.__r3f.autoRemovedBeforeAppend = !0),
      g(K, R),
      R.raycast && R.__r3f.eventCount && LU(R).getState().internal.interaction.push(R),
      [w, w.alternate].forEach((F) => {
        F !== null &&
          ((F.stateNode = R),
          F.ref && (typeof F.ref == "function" ? F.ref(R) : (F.ref.current = R)))
      }))
  }
  const r = () => {}
  return {
    reconciler: Fz({
      createInstance: I,
      removeChild: B,
      appendChild: g,
      appendInitialChild: g,
      insertBefore: C,
      supportsMutation: !0,
      isPrimaryRenderer: !1,
      supportsPersistence: !1,
      supportsHydration: !1,
      noTimeout: -1,
      appendChildToContainer: (h, S) => {
        if (!S) return
        const d = h.getState().scene
        d.__r3f && ((d.__r3f.root = h), g(d, S))
      },
      removeChildFromContainer: (h, S) => {
        S && B(h.getState().scene, S)
      },
      insertInContainerBefore: (h, S, d) => {
        if (!S || !d) return
        const w = h.getState().scene
        w.__r3f && C(w, S, d)
      },
      getRootHostContext: () => null,
      getChildHostContext: (h) => h,
      finalizeInitialChildren(h) {
        var S
        return !!((S = h?.__r3f) != null ? S : {}).handlers
      },
      prepareUpdate(h, S, d, w) {
        var M
        if (((M = h?.__r3f) != null ? M : {}).primitive && w.object && w.object !== h) return [!0]
        {
          const { args: R = [], children: F, ...L } = w,
            { args: Y = [], children: H, ...V } = d
          if (!Array.isArray(R)) throw new Error("R3F: the args prop must be an array!")
          if (R.some((P, AA) => P !== Y[AA])) return [!0]
          const j = zb(h, L, V, !0)
          return j.changes.length ? [!1, j] : null
        }
      },
      commitUpdate(h, [S, d], w, M, K, R) {
        S ? o(h, w, K, R) : xK(h, d)
      },
      commitMount(h, S, d, w) {
        var M
        const K = (M = h.__r3f) != null ? M : {}
        h.raycast && K.handlers && K.eventCount && LU(h).getState().internal.interaction.push(h)
      },
      getPublicInstance: (h) => h,
      prepareForCommit: () => null,
      preparePortalMount: (h) => zy(h.getState().scene),
      resetAfterCommit: () => {},
      shouldSetTextContent: () => !1,
      clearContainer: () => !1,
      hideInstance(h) {
        var S
        const { attach: d, parent: w } = (S = h.__r3f) != null ? S : {}
        ;(d && w && kT(w, h, d), h.isObject3D && (h.visible = !1), Xy(h))
      },
      unhideInstance(h, S) {
        var d
        const { attach: w, parent: M } = (d = h.__r3f) != null ? d : {}
        ;(w && M && TK(M, h, w),
          ((h.isObject3D && S.visible == null) || S.visible) && (h.visible = !0),
          Xy(h))
      },
      createTextInstance: r,
      hideTextInstance: r,
      unhideTextInstance: r,
      // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r916356874
      // @ts-expect-error
      getCurrentEventPriority: () => (A ? A() : Cp.DefaultEventPriority),
      beforeActiveInstanceBlur: () => {},
      afterActiveInstanceBlur: () => {},
      detachDeletedInstance: () => {},
      now:
        typeof performance < "u" && Pt.fun(performance.now)
          ? performance.now
          : Pt.fun(Date.now)
            ? Date.now
            : () => 0,
      // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r920883503
      scheduleTimeout: Pt.fun(setTimeout) ? setTimeout : void 0,
      cancelTimeout: Pt.fun(clearTimeout) ? clearTimeout : void 0,
    }),
    applyProps: xK,
  }
}
var yT, pT
const HK = (e) => "colorSpace" in e || "outputColorSpace" in e,
  _b = () => {
    var e
    return (e = Rv.ColorManagement) != null ? e : null
  },
  Zb = (e) => e && e.isOrthographicCamera,
  Jz = (e) => e && e.hasOwnProperty("current"),
  kp =
    typeof window < "u" &&
    (((yT = window.document) != null && yT.createElement) ||
      ((pT = window.navigator) == null ? void 0 : pT.product) === "ReactNative")
      ? xI.useLayoutEffect
      : xI.useEffect
function Pb(e) {
  const A = xI.useRef(e)
  return (kp(() => void (A.current = e), [e]), A)
}
function Kz({ set: e }) {
  return (kp(() => (e(new Promise(() => null)), () => e(!1)), [e]), null)
}
class Wb extends xI.Component {
  constructor(...A) {
    ;(super(...A),
      (this.state = {
        error: !1,
      }))
  }
  componentDidCatch(A) {
    this.props.set(A)
  }
  render() {
    return this.state.error ? null : this.props.children
  }
}
Wb.getDerivedStateFromError = () => ({
  error: !0,
})
const Vb = "__default",
  wT = /* @__PURE__ */ new Map(),
  mz = (e) => e && !!e.memoized && !!e.changes
function jb(e) {
  var A
  const I = typeof window < "u" ? ((A = window.devicePixelRatio) != null ? A : 2) : 1
  return Array.isArray(e) ? Math.min(Math.max(e[0], I), e[1]) : e
}
const Y0 = (e) => {
  var A
  return (A = e.__r3f) == null ? void 0 : A.root.getState()
}
function LU(e) {
  let A = e.__r3f.root
  for (; A.getState().previousRoot; ) A = A.getState().previousRoot
  return A
}
const Pt = {
  obj: (e) => e === Object(e) && !Pt.arr(e) && typeof e != "function",
  fun: (e) => typeof e == "function",
  str: (e) => typeof e == "string",
  num: (e) => typeof e == "number",
  boo: (e) => typeof e == "boolean",
  und: (e) => e === void 0,
  arr: (e) => Array.isArray(e),
  equ(e, A, { arrays: I = "shallow", objects: g = "reference", strict: C = !0 } = {}) {
    if (typeof e != typeof A || !!e != !!A) return !1
    if (Pt.str(e) || Pt.num(e) || Pt.boo(e)) return e === A
    const i = Pt.obj(e)
    if (i && g === "reference") return e === A
    const B = Pt.arr(e)
    if (B && I === "reference") return e === A
    if ((B || i) && e === A) return !0
    let o
    for (o in e) if (!(o in A)) return !1
    if (i && I === "shallow" && g === "shallow") {
      for (o in C ? A : e)
        if (
          !Pt.equ(e[o], A[o], {
            strict: C,
            objects: "reference",
          })
        )
          return !1
    } else for (o in C ? A : e) if (e[o] !== A[o]) return !1
    if (Pt.und(o)) {
      if (
        (B && e.length === 0 && A.length === 0) ||
        (i && Object.keys(e).length === 0 && Object.keys(A).length === 0)
      )
        return !0
      if (e !== A) return !1
    }
    return !0
  },
}
function vz(e) {
  const A = {
    nodes: {},
    materials: {},
  }
  return (
    e &&
      e.traverse((I) => {
        ;(I.name && (A.nodes[I.name] = I),
          I.material &&
            !A.materials[I.material.name] &&
            (A.materials[I.material.name] = I.material))
      }),
    A
  )
}
function Lz(e) {
  e.dispose && e.type !== "Scene" && e.dispose()
  for (const A in e) (A.dispose == null || A.dispose(), delete e[A])
}
function zy(e, A) {
  const I = e
  return (
    (I.__r3f = {
      type: "",
      root: null,
      previousAttach: null,
      memoizedProps: {},
      eventCount: 0,
      handlers: {},
      objects: [],
      parent: null,
      ...A,
    }),
    e
  )
}
function km(e, A) {
  let I = e
  if (A.includes("-")) {
    const g = A.split("-"),
      C = g.pop()
    return (
      (I = g.reduce((i, B) => i[B], e)),
      {
        target: I,
        key: C,
      }
    )
  } else
    return {
      target: I,
      key: A,
    }
}
const GT = /-\d+$/
function TK(e, A, I) {
  if (Pt.str(I)) {
    if (GT.test(I)) {
      const i = I.replace(GT, ""),
        { target: B, key: o } = km(e, i)
      Array.isArray(B[o]) || (B[o] = [])
    }
    const { target: g, key: C } = km(e, I)
    ;((A.__r3f.previousAttach = g[C]), (g[C] = A))
  } else A.__r3f.previousAttach = I(e, A)
}
function kT(e, A, I) {
  var g, C
  if (Pt.str(I)) {
    const { target: i, key: B } = km(e, I),
      o = A.__r3f.previousAttach
    o === void 0 ? delete i[B] : (i[B] = o)
  } else (g = A.__r3f) == null || g.previousAttach == null || g.previousAttach(e, A)
  ;(C = A.__r3f) == null || delete C.previousAttach
}
function zb(
  e,
  { children: A, key: I, ref: g, ...C },
  { children: i, key: B, ref: o, ...r } = {},
  s = !1,
) {
  const h = e.__r3f,
    S = Object.entries(C),
    d = []
  if (s) {
    const M = Object.keys(r)
    for (let K = 0; K < M.length; K++) C.hasOwnProperty(M[K]) || S.unshift([M[K], Vb + "remove"])
  }
  S.forEach(([M, K]) => {
    var R
    if (((R = e.__r3f) != null && R.primitive && M === "object") || Pt.equ(K, r[M])) return
    if (/^on(Pointer|Click|DoubleClick|ContextMenu|Wheel)/.test(M)) return d.push([M, K, !0, []])
    let F = []
    ;(M.includes("-") && (F = M.split("-")), d.push([M, K, !1, F]))
    for (const L in C) {
      const Y = C[L]
      L.startsWith(`${M}-`) && d.push([L, Y, !1, L.split("-")])
    }
  })
  const w = {
    ...C,
  }
  return (
    h != null &&
      h.memoizedProps &&
      h != null &&
      h.memoizedProps.args &&
      (w.args = h.memoizedProps.args),
    h != null &&
      h.memoizedProps &&
      h != null &&
      h.memoizedProps.attach &&
      (w.attach = h.memoizedProps.attach),
    {
      memoized: w,
      changes: d,
    }
  )
}
const Yz = typeof process < "u" && process.env.NODE_ENV !== "production"
function xK(e, A) {
  var I
  const g = e.__r3f,
    C = g?.root,
    i = C == null || C.getState == null ? void 0 : C.getState(),
    { memoized: B, changes: o } = mz(A) ? A : zb(e, A),
    r = g?.eventCount
  e.__r3f && (e.__r3f.memoizedProps = B)
  for (let h = 0; h < o.length; h++) {
    let [S, d, w, M] = o[h]
    if (HK(e)) {
      const L = "srgb",
        Y = "srgb-linear"
      S === "encoding"
        ? ((S = "colorSpace"), (d = d === 3001 ? L : Y))
        : S === "outputEncoding" && ((S = "outputColorSpace"), (d = d === 3001 ? L : Y))
    }
    let K = e,
      R = K[S]
    if (M.length && ((R = M.reduce((F, L) => F[L], e)), !(R && R.set))) {
      const [F, ...L] = M.reverse()
      ;((K = L.reverse().reduce((Y, H) => Y[H], e)), (S = F))
    }
    if (d === Vb + "remove")
      if (K.constructor) {
        let F = wT.get(K.constructor)
        ;(F || ((F = new K.constructor()), wT.set(K.constructor, F)), (d = F[S]))
      } else d = 0
    if (w && g)
      (d ? (g.handlers[S] = d) : delete g.handlers[S],
        (g.eventCount = Object.keys(g.handlers).length))
    else if (R && R.set && (R.copy || R instanceof Kf)) {
      if (Array.isArray(d)) R.fromArray ? R.fromArray(d) : R.set(...d)
      else if (
        R.copy &&
        d &&
        d.constructor && // Some environments may break strict identity checks by duplicating versions of three.js.
        // Loosen to unminified names, ignoring descendents.
        // https://github.com/pmndrs/react-three-fiber/issues/2856
        // TODO: fix upstream and remove in v9
        (Yz ? R.constructor.name === d.constructor.name : R.constructor === d.constructor)
      )
        R.copy(d)
      else if (d !== void 0) {
        const F = R instanceof Mg
        ;(!F && R.setScalar
          ? R.setScalar(d)
          : R instanceof Kf && d instanceof Kf
            ? (R.mask = d.mask)
            : R.set(d),
          !_b() && i && !i.linear && F && R.convertSRGBToLinear())
      }
    } else if (
      ((K[S] = d),
      K[S] instanceof pt && // sRGB textures must be RGBA8 since r137 https://github.com/mrdoob/three.js/pull/23129
        K[S].format === lE &&
        K[S].type === Xo &&
        i)
    ) {
      const F = K[S]
      HK(F) && HK(i.gl)
        ? (F.colorSpace = i.gl.outputColorSpace)
        : (F.encoding = i.gl.outputEncoding)
    }
    Xy(e)
  }
  if (g && g.parent && e.raycast && r !== g.eventCount) {
    const h = LU(e).getState().internal,
      S = h.interaction.indexOf(e)
    ;(S > -1 && h.interaction.splice(S, 1), g.eventCount && h.interaction.push(e))
  }
  return (
    !(o.length === 1 && o[0][0] === "onUpdate") &&
      o.length &&
      (I = e.__r3f) != null &&
      I.parent &&
      Mm(e),
    e
  )
}
function Xy(e) {
  var A, I
  const g =
    (A = e.__r3f) == null || (I = A.root) == null || I.getState == null ? void 0 : I.getState()
  g && g.internal.frames === 0 && g.invalidate()
}
function Mm(e) {
  e.onUpdate == null || e.onUpdate(e)
}
function qz(e, A) {
  e.manual ||
    (Zb(e)
      ? ((e.left = A.width / -2),
        (e.right = A.width / 2),
        (e.top = A.height / 2),
        (e.bottom = A.height / -2))
      : (e.aspect = A.width / A.height),
    e.updateProjectionMatrix(),
    e.updateMatrixWorld())
}
function kU(e) {
  return (e.eventObject || e.object).uuid + "/" + e.index + e.instanceId
}
function Hz() {
  var e
  const A = (typeof self < "u" && self) || (typeof window < "u" && window)
  if (!A) return Cp.DefaultEventPriority
  switch ((e = A.event) == null ? void 0 : e.type) {
    case "click":
    case "contextmenu":
    case "dblclick":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
      return Cp.DiscreteEventPriority
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "pointerenter":
    case "pointerleave":
    case "wheel":
      return Cp.ContinuousEventPriority
    default:
      return Cp.DefaultEventPriority
  }
}
function Xb(e, A, I, g) {
  const C = I.get(A)
  C && (I.delete(A), I.size === 0 && (e.delete(g), C.target.releasePointerCapture(g)))
}
function Tz(e, A) {
  const { internal: I } = e.getState()
  ;((I.interaction = I.interaction.filter((g) => g !== A)),
    (I.initialHits = I.initialHits.filter((g) => g !== A)),
    I.hovered.forEach((g, C) => {
      ;(g.eventObject === A || g.object === A) && I.hovered.delete(C)
    }),
    I.capturedMap.forEach((g, C) => {
      Xb(I.capturedMap, A, g, C)
    }))
}
function xz(e) {
  function A(r) {
    const { internal: s } = e.getState(),
      h = r.offsetX - s.initialClick[0],
      S = r.offsetY - s.initialClick[1]
    return Math.round(Math.sqrt(h * h + S * S))
  }
  function I(r) {
    return r.filter((s) =>
      ["Move", "Over", "Enter", "Out", "Leave"].some((h) => {
        var S
        return (S = s.__r3f) == null ? void 0 : S.handlers["onPointer" + h]
      }),
    )
  }
  function g(r, s) {
    const h = e.getState(),
      S = /* @__PURE__ */ new Set(),
      d = [],
      w = s ? s(h.internal.interaction) : h.internal.interaction
    for (let F = 0; F < w.length; F++) {
      const L = Y0(w[F])
      L && (L.raycaster.camera = void 0)
    }
    h.previousRoot || h.events.compute == null || h.events.compute(r, h)
    function M(F) {
      const L = Y0(F)
      if (!L || !L.events.enabled || L.raycaster.camera === null) return []
      if (L.raycaster.camera === void 0) {
        var Y
        ;(L.events.compute == null ||
          L.events.compute(r, L, (Y = L.previousRoot) == null ? void 0 : Y.getState()),
          L.raycaster.camera === void 0 && (L.raycaster.camera = null))
      }
      return L.raycaster.camera ? L.raycaster.intersectObject(F, !0) : []
    }
    let K = w
      .flatMap(M)
      .sort((F, L) => {
        const Y = Y0(F.object),
          H = Y0(L.object)
        return !Y || !H
          ? F.distance - L.distance
          : H.events.priority - Y.events.priority || F.distance - L.distance
      })
      .filter((F) => {
        const L = kU(F)
        return S.has(L) ? !1 : (S.add(L), !0)
      })
    h.events.filter && (K = h.events.filter(K, h))
    for (const F of K) {
      let L = F.object
      for (; L; ) {
        var R
        ;((R = L.__r3f) != null &&
          R.eventCount &&
          d.push({
            ...F,
            eventObject: L,
          }),
          (L = L.parent))
      }
    }
    if ("pointerId" in r && h.internal.capturedMap.has(r.pointerId))
      for (let F of h.internal.capturedMap.get(r.pointerId).values())
        S.has(kU(F.intersection)) || d.push(F.intersection)
    return d
  }
  function C(r, s, h, S) {
    const d = e.getState()
    if (r.length) {
      const w = {
        stopped: !1,
      }
      for (const M of r) {
        const K = Y0(M.object) || d,
          { raycaster: R, pointer: F, camera: L, internal: Y } = K,
          H = new wA(F.x, F.y, 0).unproject(L),
          V = (_) => {
            var eA, CA
            return (eA = (CA = Y.capturedMap.get(_)) == null ? void 0 : CA.has(M.eventObject)) !=
              null
              ? eA
              : !1
          },
          j = (_) => {
            const eA = {
              intersection: M,
              target: s.target,
            }
            ;(Y.capturedMap.has(_)
              ? Y.capturedMap.get(_).set(M.eventObject, eA)
              : Y.capturedMap.set(_, /* @__PURE__ */ new Map([[M.eventObject, eA]])),
              s.target.setPointerCapture(_))
          },
          P = (_) => {
            const eA = Y.capturedMap.get(_)
            eA && Xb(Y.capturedMap, M.eventObject, eA, _)
          }
        let AA = {}
        for (let _ in s) {
          let eA = s[_]
          typeof eA != "function" && (AA[_] = eA)
        }
        let X = {
          ...M,
          ...AA,
          pointer: F,
          intersections: r,
          stopped: w.stopped,
          delta: h,
          unprojectedPoint: H,
          ray: R.ray,
          camera: L,
          // Hijack stopPropagation, which just sets a flag
          stopPropagation() {
            const _ = "pointerId" in s && Y.capturedMap.get(s.pointerId)
            if (
              // ...if this pointer hasn't been captured
              (!_ || // ... or if the hit object is capturing the pointer
                _.has(M.eventObject)) &&
              ((X.stopped = w.stopped = !0),
              Y.hovered.size &&
                Array.from(Y.hovered.values()).find((eA) => eA.eventObject === M.eventObject))
            ) {
              const eA = r.slice(0, r.indexOf(M))
              i([...eA, M])
            }
          },
          // there should be a distinction between target and currentTarget
          target: {
            hasPointerCapture: V,
            setPointerCapture: j,
            releasePointerCapture: P,
          },
          currentTarget: {
            hasPointerCapture: V,
            setPointerCapture: j,
            releasePointerCapture: P,
          },
          nativeEvent: s,
        }
        if ((S(X), w.stopped === !0)) break
      }
    }
    return r
  }
  function i(r) {
    const { internal: s } = e.getState()
    for (const h of s.hovered.values())
      if (
        !r.length ||
        !r.find(
          (S) => S.object === h.object && S.index === h.index && S.instanceId === h.instanceId,
        )
      ) {
        const d = h.eventObject.__r3f,
          w = d?.handlers
        if ((s.hovered.delete(kU(h)), d != null && d.eventCount)) {
          const M = {
            ...h,
            intersections: r,
          }
          ;(w.onPointerOut == null || w.onPointerOut(M),
            w.onPointerLeave == null || w.onPointerLeave(M))
        }
      }
  }
  function B(r, s) {
    for (let h = 0; h < s.length; h++) {
      const S = s[h].__r3f
      S == null || S.handlers.onPointerMissed == null || S.handlers.onPointerMissed(r)
    }
  }
  function o(r) {
    switch (r) {
      case "onPointerLeave":
      case "onPointerCancel":
        return () => i([])
      case "onLostPointerCapture":
        return (s) => {
          const { internal: h } = e.getState()
          "pointerId" in s &&
            h.capturedMap.has(s.pointerId) &&
            requestAnimationFrame(() => {
              h.capturedMap.has(s.pointerId) && (h.capturedMap.delete(s.pointerId), i([]))
            })
        }
    }
    return function (h) {
      const { onPointerMissed: S, internal: d } = e.getState()
      d.lastEvent.current = h
      const w = r === "onPointerMove",
        M = r === "onClick" || r === "onContextMenu" || r === "onDoubleClick",
        R = g(h, w ? I : void 0),
        F = M ? A(h) : 0
      ;(r === "onPointerDown" &&
        ((d.initialClick = [h.offsetX, h.offsetY]), (d.initialHits = R.map((Y) => Y.eventObject))),
        M && !R.length && F <= 2 && (B(h, d.interaction), S && S(h)),
        w && i(R))
      function L(Y) {
        const H = Y.eventObject,
          V = H.__r3f,
          j = V?.handlers
        if (V != null && V.eventCount)
          if (w) {
            if (j.onPointerOver || j.onPointerEnter || j.onPointerOut || j.onPointerLeave) {
              const P = kU(Y),
                AA = d.hovered.get(P)
              AA
                ? AA.stopped && Y.stopPropagation()
                : (d.hovered.set(P, Y),
                  j.onPointerOver == null || j.onPointerOver(Y),
                  j.onPointerEnter == null || j.onPointerEnter(Y))
            }
            j.onPointerMove == null || j.onPointerMove(Y)
          } else {
            const P = j[r]
            P
              ? (!M || d.initialHits.includes(H)) &&
                (B(
                  h,
                  d.interaction.filter((AA) => !d.initialHits.includes(AA)),
                ),
                P(Y))
              : M &&
                d.initialHits.includes(H) &&
                B(
                  h,
                  d.interaction.filter((AA) => !d.initialHits.includes(AA)),
                )
          }
      }
      C(R, h, F, L)
    }
  }
  return {
    handlePointer: o,
  }
}
const $b = (e) => !!(e != null && e.render),
  AO = /* @__PURE__ */ xI.createContext(null),
  bz = (e, A) => {
    const I = fz((o, r) => {
        const s = new wA(),
          h = new wA(),
          S = new wA()
        function d(F = r().camera, L = h, Y = r().size) {
          const { width: H, height: V, top: j, left: P } = Y,
            AA = H / V
          L instanceof wA ? S.copy(L) : S.set(...L)
          const X = F.getWorldPosition(s).distanceTo(S)
          if (Zb(F))
            return {
              width: H / F.zoom,
              height: V / F.zoom,
              top: j,
              left: P,
              factor: 1,
              distance: X,
              aspect: AA,
            }
          {
            const _ = (F.fov * Math.PI) / 180,
              eA = 2 * Math.tan(_ / 2) * X,
              CA = eA * (H / V)
            return {
              width: CA,
              height: eA,
              top: j,
              left: P,
              factor: H / CA,
              distance: X,
              aspect: AA,
            }
          }
        }
        let w
        const M = (F) =>
            o((L) => ({
              performance: {
                ...L.performance,
                current: F,
              },
            })),
          K = new ZI()
        return {
          set: o,
          get: r,
          // Mock objects that have to be configured
          gl: null,
          camera: null,
          raycaster: null,
          events: {
            priority: 1,
            enabled: !0,
            connected: !1,
          },
          xr: null,
          scene: null,
          invalidate: (F = 1) => e(r(), F),
          advance: (F, L) => A(F, L, r()),
          legacy: !1,
          linear: !1,
          flat: !1,
          controls: null,
          clock: new kv(),
          pointer: K,
          mouse: K,
          frameloop: "always",
          onPointerMissed: void 0,
          performance: {
            current: 1,
            min: 0.5,
            max: 1,
            debounce: 200,
            regress: () => {
              const F = r()
              ;(w && clearTimeout(w),
                F.performance.current !== F.performance.min && M(F.performance.min),
                (w = setTimeout(() => M(r().performance.max), F.performance.debounce)))
            },
          },
          size: {
            width: 0,
            height: 0,
            top: 0,
            left: 0,
            updateStyle: !1,
          },
          viewport: {
            initialDpr: 0,
            dpr: 0,
            width: 0,
            height: 0,
            top: 0,
            left: 0,
            aspect: 0,
            distance: 0,
            factor: 0,
            getCurrentViewport: d,
          },
          setEvents: (F) =>
            o((L) => ({
              ...L,
              events: {
                ...L.events,
                ...F,
              },
            })),
          setSize: (F, L, Y, H, V) => {
            const j = r().camera,
              P = {
                width: F,
                height: L,
                top: H || 0,
                left: V || 0,
                updateStyle: Y,
              }
            o((AA) => ({
              size: P,
              viewport: {
                ...AA.viewport,
                ...d(j, h, P),
              },
            }))
          },
          setDpr: (F) =>
            o((L) => {
              const Y = jb(F)
              return {
                viewport: {
                  ...L.viewport,
                  dpr: Y,
                  initialDpr: L.viewport.initialDpr || Y,
                },
              }
            }),
          setFrameloop: (F = "always") => {
            const L = r().clock
            ;(L.stop(),
              (L.elapsedTime = 0),
              F !== "never" && (L.start(), (L.elapsedTime = 0)),
              o(() => ({
                frameloop: F,
              })))
          },
          previousRoot: void 0,
          internal: {
            active: !1,
            priority: 0,
            frames: 0,
            lastEvent: /* @__PURE__ */ xI.createRef(),
            interaction: [],
            hovered: /* @__PURE__ */ new Map(),
            subscribers: [],
            initialClick: [0, 0],
            initialHits: [],
            capturedMap: /* @__PURE__ */ new Map(),
            subscribe: (F, L, Y) => {
              const H = r().internal
              return (
                (H.priority = H.priority + (L > 0 ? 1 : 0)),
                H.subscribers.push({
                  ref: F,
                  priority: L,
                  store: Y,
                }),
                (H.subscribers = H.subscribers.sort((V, j) => V.priority - j.priority)),
                () => {
                  const V = r().internal
                  V != null &&
                    V.subscribers &&
                    ((V.priority = V.priority - (L > 0 ? 1 : 0)),
                    (V.subscribers = V.subscribers.filter((j) => j.ref !== F)))
                }
              )
            },
          },
        }
      }),
      g = I.getState()
    let C = g.size,
      i = g.viewport.dpr,
      B = g.camera
    return (
      I.subscribe(() => {
        const { camera: o, size: r, viewport: s, gl: h, set: S } = I.getState()
        if (r.width !== C.width || r.height !== C.height || s.dpr !== i) {
          var d
          ;((C = r), (i = s.dpr), qz(o, r), h.setPixelRatio(s.dpr))
          const w =
            (d = r.updateStyle) != null
              ? d
              : typeof HTMLCanvasElement < "u" && h.domElement instanceof HTMLCanvasElement
          h.setSize(r.width, r.height, w)
        }
        o !== B &&
          ((B = o),
          S((w) => ({
            viewport: {
              ...w.viewport,
              ...w.viewport.getCurrentViewport(o),
            },
          })))
      }),
      I.subscribe((o) => e(o)),
      I
    )
  }
let MU,
  Oz = /* @__PURE__ */ new Set(),
  _z = /* @__PURE__ */ new Set(),
  Zz = /* @__PURE__ */ new Set()
function bK(e, A) {
  if (e.size) for (const { callback: I } of e.values()) I(A)
}
function q0(e, A) {
  switch (e) {
    case "before":
      return bK(Oz, A)
    case "after":
      return bK(_z, A)
    case "tail":
      return bK(Zz, A)
  }
}
let OK, _K
function ZK(e, A, I) {
  let g = A.clock.getDelta()
  for (
    A.frameloop === "never" &&
      typeof e == "number" &&
      ((g = e - A.clock.elapsedTime),
      (A.clock.oldTime = A.clock.elapsedTime),
      (A.clock.elapsedTime = e)),
      OK = A.internal.subscribers,
      MU = 0;
    MU < OK.length;
    MU++
  )
    ((_K = OK[MU]), _K.ref.current(_K.store.getState(), g, I))
  return (
    !A.internal.priority && A.gl.render && A.gl.render(A.scene, A.camera),
    (A.internal.frames = Math.max(0, A.internal.frames - 1)),
    A.frameloop === "always" ? 1 : A.internal.frames
  )
}
function Pz(e) {
  let A = !1,
    I = !1,
    g,
    C,
    i
  function B(s) {
    ;((C = requestAnimationFrame(B)), (A = !0), (g = 0), q0("before", s), (I = !0))
    for (const S of e.values()) {
      var h
      ;((i = S.store.getState()),
        i.internal.active &&
          (i.frameloop === "always" || i.internal.frames > 0) &&
          !((h = i.gl.xr) != null && h.isPresenting) &&
          (g += ZK(s, i)))
    }
    if (((I = !1), q0("after", s), g === 0))
      return (q0("tail", s), (A = !1), cancelAnimationFrame(C))
  }
  function o(s, h = 1) {
    var S
    if (!s) return e.forEach((d) => o(d.store.getState(), h))
    ;((S = s.gl.xr) != null && S.isPresenting) ||
      !s.internal.active ||
      s.frameloop === "never" ||
      (h > 1
        ? (s.internal.frames = Math.min(60, s.internal.frames + h))
        : I
          ? (s.internal.frames = 2)
          : (s.internal.frames = 1),
      A || ((A = !0), requestAnimationFrame(B)))
  }
  function r(s, h = !0, S, d) {
    if ((h && q0("before", s), S)) ZK(s, S, d)
    else for (const w of e.values()) ZK(s, w.store.getState())
    h && q0("after", s)
  }
  return {
    loop: B,
    invalidate: o,
    advance: r,
  }
}
function Wz(e) {
  const A = xI.useRef(null)
  return (kp(() => void (A.current = e.current.__r3f), [e]), A)
}
function IO() {
  const e = xI.useContext(AO)
  if (!e) throw new Error("R3F: Hooks can only be used within the Canvas component!")
  return e
}
function Ya(e = (I) => I, A) {
  return IO()(e, A)
}
function Mp(e, A = 0) {
  const I = IO(),
    g = I.getState().internal.subscribe,
    C = Pb(e)
  return (kp(() => g(C, A, I), [A, g, I]), null)
}
const MT = /* @__PURE__ */ new WeakMap()
function gO(e, A) {
  return function (I, ...g) {
    let C = MT.get(I)
    return (
      C || ((C = new I()), MT.set(I, C)),
      e && e(C),
      Promise.all(
        g.map(
          (i) =>
            new Promise((B, o) =>
              C.load(
                i,
                (r) => {
                  ;(r.scene && Object.assign(r, vz(r.scene)), B(r))
                },
                A,
                (r) => o(new Error(`Could not load ${i}: ${r?.message}`)),
              ),
            ),
        ),
      )
    )
  }
}
function HG(e, A, I, g) {
  const C = Array.isArray(A) ? A : [A],
    i = pF(gO(I, g), [e, ...C], {
      equal: Pt.equ,
    })
  return Array.isArray(A) ? i : i[0]
}
HG.preload = function (e, A, I) {
  const g = Array.isArray(A) ? A : [A]
  return yz(gO(I), [e, ...g])
}
HG.clear = function (e, A) {
  const I = Array.isArray(A) ? A : [A]
  return pz([e, ...I])
}
const cp = /* @__PURE__ */ new Map(),
  { invalidate: UT, advance: NT } = Pz(cp),
  { reconciler: wN, applyProps: Py } = Rz(cp, Hz),
  Wy = {
    objects: "shallow",
    strict: !1,
  },
  Vz = (e, A) => {
    const I = typeof e == "function" ? e(A) : e
    return $b(I)
      ? I
      : new gb({
          powerPreference: "high-performance",
          canvas: A,
          antialias: !0,
          alpha: !0,
          ...e,
        })
  }
function jz(e, A) {
  const I = typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement
  if (A) {
    const { width: g, height: C, top: i, left: B, updateStyle: o = I } = A
    return {
      width: g,
      height: C,
      top: i,
      left: B,
      updateStyle: o,
    }
  } else if (typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement && e.parentElement) {
    const { width: g, height: C, top: i, left: B } = e.parentElement.getBoundingClientRect()
    return {
      width: g,
      height: C,
      top: i,
      left: B,
      updateStyle: I,
    }
  } else if (typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas)
    return {
      width: e.width,
      height: e.height,
      top: 0,
      left: 0,
      updateStyle: I,
    }
  return {
    width: 0,
    height: 0,
    top: 0,
    left: 0,
  }
}
function zz(e) {
  const A = cp.get(e),
    I = A?.fiber,
    g = A?.store
  A && console.warn("R3F.createRoot should only be called once!")
  const C =
      typeof reportError == "function"
        ? // In modern browsers, reportError will dispatch an error event,
          // emulating an uncaught JavaScript error.
          reportError
        : // In older browsers and test environments, fallback to console.error.
          console.error,
    i = g || bz(UT, NT),
    B = I || wN.createContainer(i, Cp.ConcurrentRoot, null, !1, null, "", C, null)
  A ||
    cp.set(e, {
      fiber: B,
      store: i,
    })
  let o,
    r = !1,
    s
  return {
    configure(h = {}) {
      let {
          gl: S,
          size: d,
          scene: w,
          events: M,
          onCreated: K,
          shadows: R = !1,
          linear: F = !1,
          flat: L = !1,
          legacy: Y = !1,
          orthographic: H = !1,
          frameloop: V = "always",
          dpr: j = [1, 2],
          performance: P,
          raycaster: AA,
          camera: X,
          onPointerMissed: _,
        } = h,
        eA = i.getState(),
        CA = eA.gl
      eA.gl ||
        eA.set({
          gl: (CA = Vz(S, e)),
        })
      let aA = eA.raycaster
      aA ||
        eA.set({
          raycaster: (aA = new Tb()),
        })
      const { params: lA, ...JA } = AA || {}
      if (
        (Pt.equ(JA, aA, Wy) ||
          Py(aA, {
            ...JA,
          }),
        Pt.equ(lA, aA.params, Wy) ||
          Py(aA, {
            params: {
              ...aA.params,
              ...lA,
            },
          }),
        !eA.camera || (eA.camera === s && !Pt.equ(s, X, Wy)))
      ) {
        s = X
        const sA = X instanceof dp,
          $ = sA ? X : H ? new yp(0, 0, 0, 0, 0.1, 1e3) : new PQ(75, 0, 0.1, 1e3)
        ;(sA ||
          (($.position.z = 5),
          X &&
            (Py($, X),
            ("aspect" in X || "left" in X || "right" in X || "bottom" in X || "top" in X) &&
              (($.manual = !0), $.updateProjectionMatrix())),
          !eA.camera && !(X != null && X.rotation) && $.lookAt(0, 0, 0)),
          eA.set({
            camera: $,
          }),
          (aA.camera = $))
      }
      if (!eA.scene) {
        let sA
        ;(w instanceof sp ? (sA = w) : ((sA = new sp()), w && Py(sA, w)),
          eA.set({
            scene: zy(sA),
          }))
      }
      if (!eA.xr) {
        var yA
        const sA = (GA, DA) => {
            const dA = i.getState()
            dA.frameloop !== "never" && NT(GA, !0, dA, DA)
          },
          $ = () => {
            const GA = i.getState()
            ;((GA.gl.xr.enabled = GA.gl.xr.isPresenting),
              GA.gl.xr.setAnimationLoop(GA.gl.xr.isPresenting ? sA : null),
              GA.gl.xr.isPresenting || UT(GA))
          },
          EA = {
            connect() {
              const GA = i.getState().gl
              ;(GA.xr.addEventListener("sessionstart", $), GA.xr.addEventListener("sessionend", $))
            },
            disconnect() {
              const GA = i.getState().gl
              ;(GA.xr.removeEventListener("sessionstart", $),
                GA.xr.removeEventListener("sessionend", $))
            },
          }
        ;(typeof ((yA = CA.xr) == null ? void 0 : yA.addEventListener) == "function" &&
          EA.connect(),
          eA.set({
            xr: EA,
          }))
      }
      if (CA.shadowMap) {
        const sA = CA.shadowMap.enabled,
          $ = CA.shadowMap.type
        if (((CA.shadowMap.enabled = !!R), Pt.boo(R))) CA.shadowMap.type = X0
        else if (Pt.str(R)) {
          var LA
          const EA = {
            basic: A2,
            percentage: xN,
            soft: X0,
            variance: pl,
          }
          CA.shadowMap.type = (LA = EA[R]) != null ? LA : X0
        } else Pt.obj(R) && Object.assign(CA.shadowMap, R)
        ;(sA !== CA.shadowMap.enabled || $ !== CA.shadowMap.type) && (CA.shadowMap.needsUpdate = !0)
      }
      const nA = _b()
      ;(nA && ("enabled" in nA ? (nA.enabled = !Y) : "legacyMode" in nA && (nA.legacyMode = Y)),
        r ||
          Py(CA, {
            outputEncoding: F ? 3e3 : 3001,
            toneMapping: L ? Ms : Hm,
          }),
        eA.legacy !== Y &&
          eA.set(() => ({
            legacy: Y,
          })),
        eA.linear !== F &&
          eA.set(() => ({
            linear: F,
          })),
        eA.flat !== L &&
          eA.set(() => ({
            flat: L,
          })),
        S && !Pt.fun(S) && !$b(S) && !Pt.equ(S, CA, Wy) && Py(CA, S),
        M &&
          !eA.events.handlers &&
          eA.set({
            events: M(i),
          }))
      const fA = jz(e, d)
      return (
        Pt.equ(fA, eA.size, Wy) || eA.setSize(fA.width, fA.height, fA.updateStyle, fA.top, fA.left),
        j && eA.viewport.dpr !== jb(j) && eA.setDpr(j),
        eA.frameloop !== V && eA.setFrameloop(V),
        eA.onPointerMissed ||
          eA.set({
            onPointerMissed: _,
          }),
        P &&
          !Pt.equ(P, eA.performance, Wy) &&
          eA.set((sA) => ({
            performance: {
              ...sA.performance,
              ...P,
            },
          })),
        (o = K),
        (r = !0),
        this
      )
    },
    render(h) {
      return (
        r || this.configure(),
        wN.updateContainer(
          /* @__PURE__ */ qC.jsx(Xz, {
            store: i,
            children: h,
            onCreated: o,
            rootElement: e,
          }),
          B,
          null,
          () => {},
        ),
        i
      )
    },
    unmount() {
      CO(e)
    },
  }
}
function Xz({ store: e, children: A, onCreated: I, rootElement: g }) {
  return (
    kp(() => {
      const C = e.getState()
      ;(C.set((i) => ({
        internal: {
          ...i.internal,
          active: !0,
        },
      })),
        I && I(C),
        e.getState().events.connected || C.events.connect == null || C.events.connect(g))
    }, []),
    /* @__PURE__ */ qC.jsx(AO.Provider, {
      value: e,
      children: A,
    })
  )
}
function CO(e, A) {
  const I = cp.get(e),
    g = I?.fiber
  if (g) {
    const C = I?.store.getState()
    ;(C && (C.internal.active = !1),
      wN.updateContainer(null, g, null, () => {
        C &&
          setTimeout(() => {
            try {
              var i, B, o, r
              ;(C.events.disconnect == null || C.events.disconnect(),
                (i = C.gl) == null ||
                  (B = i.renderLists) == null ||
                  B.dispose == null ||
                  B.dispose(),
                (o = C.gl) == null || o.forceContextLoss == null || o.forceContextLoss(),
                (r = C.gl) != null && r.xr && C.xr.disconnect(),
                Lz(C),
                cp.delete(e))
            } catch {}
          }, 500)
      }))
  }
}
wN.injectIntoDevTools({
  bundleType: process.env.NODE_ENV === "production" ? 0 : 1,
  rendererPackageName: "@react-three/fiber",
  version: xI.version,
})
const PK = {
  onClick: ["click", !1],
  onContextMenu: ["contextmenu", !1],
  onDoubleClick: ["dblclick", !1],
  onWheel: ["wheel", !0],
  onPointerDown: ["pointerdown", !0],
  onPointerUp: ["pointerup", !0],
  onPointerLeave: ["pointerleave", !0],
  onPointerMove: ["pointermove", !0],
  onPointerCancel: ["pointercancel", !0],
  onLostPointerCapture: ["lostpointercapture", !0],
}
function $z(e) {
  const { handlePointer: A } = xz(e)
  return {
    priority: 1,
    enabled: !0,
    compute(I, g, C) {
      ;(g.pointer.set((I.offsetX / g.size.width) * 2 - 1, -(I.offsetY / g.size.height) * 2 + 1),
        g.raycaster.setFromCamera(g.pointer, g.camera))
    },
    connected: void 0,
    handlers: Object.keys(PK).reduce(
      (I, g) => ({
        ...I,
        [g]: A(g),
      }),
      {},
    ),
    update: () => {
      var I
      const { events: g, internal: C } = e.getState()
      ;(I = C.lastEvent) != null &&
        I.current &&
        g.handlers &&
        g.handlers.onPointerMove(C.lastEvent.current)
    },
    connect: (I) => {
      var g
      const { set: C, events: i } = e.getState()
      ;(i.disconnect == null || i.disconnect(),
        C((B) => ({
          events: {
            ...B.events,
            connected: I,
          },
        })),
        Object.entries((g = i.handlers) != null ? g : []).forEach(([B, o]) => {
          const [r, s] = PK[B]
          I.addEventListener(r, o, {
            passive: s,
          })
        }))
    },
    disconnect: () => {
      const { set: I, events: g } = e.getState()
      if (g.connected) {
        var C
        ;(Object.entries((C = g.handlers) != null ? C : []).forEach(([i, B]) => {
          if (g && g.connected instanceof HTMLElement) {
            const [o] = PK[i]
            g.connected.removeEventListener(o, B)
          }
        }),
          I((i) => ({
            events: {
              ...i.events,
              connected: void 0,
            },
          })))
      }
    },
  }
}
var WK, FT
function AX() {
  if (FT) return WK
  FT = 1
  function e(A, I, g) {
    var C, i, B, o, r
    I == null && (I = 100)
    function s() {
      var S = Date.now() - o
      S < I && S >= 0
        ? (C = setTimeout(s, I - S))
        : ((C = null), g || ((r = A.apply(B, i)), (B = i = null)))
    }
    var h = function () {
      ;((B = this), (i = arguments), (o = Date.now()))
      var S = g && !C
      return (C || (C = setTimeout(s, I)), S && ((r = A.apply(B, i)), (B = i = null)), r)
    }
    return (
      (h.clear = function () {
        C && (clearTimeout(C), (C = null))
      }),
      (h.flush = function () {
        C && ((r = A.apply(B, i)), (B = i = null), clearTimeout(C), (C = null))
      }),
      h
    )
  }
  return ((e.debounce = e), (WK = e), WK)
}
var IX = AX()
const RT = /* @__PURE__ */ qm(IX)
var gX = Object.defineProperty,
  CX = Object.defineProperties,
  eX = Object.getOwnPropertyDescriptors,
  JT = Object.getOwnPropertySymbols,
  iX = Object.prototype.hasOwnProperty,
  tX = Object.prototype.propertyIsEnumerable,
  KT = (e, A, I) =>
    A in e ? gX(e, A, { enumerable: !0, configurable: !0, writable: !0, value: I }) : (e[A] = I),
  mT = (e, A) => {
    for (var I in A || (A = {})) iX.call(A, I) && KT(e, I, A[I])
    if (JT) for (var I of JT(A)) tX.call(A, I) && KT(e, I, A[I])
    return e
  },
  BX = (e, A) => CX(e, eX(A)),
  vT,
  LT
typeof window < "u" &&
(((vT = window.document) != null && vT.createElement) ||
  ((LT = window.navigator) == null ? void 0 : LT.product) === "ReactNative")
  ? xI.useLayoutEffect
  : xI.useEffect
function eO(e, A, I) {
  if (!e) return
  if (I(e) === !0) return e
  let g = e.child
  for (; g; ) {
    const C = eO(g, A, I)
    if (C) return C
    g = g.sibling
  }
}
function iO(e) {
  try {
    return Object.defineProperties(e, {
      _currentRenderer: {
        get() {
          return null
        },
        set() {},
      },
      _currentRenderer2: {
        get() {
          return null
        },
        set() {},
      },
    })
  } catch {
    return e
  }
}
const YT = console.error
console.error = function () {
  const e = [...arguments].join("")
  if (e?.startsWith("Warning:") && e.includes("useContext")) {
    console.error = YT
    return
  }
  return YT.apply(this, arguments)
}
const Kv = iO(xI.createContext(null))
class tO extends xI.Component {
  render() {
    return /* @__PURE__ */ xI.createElement(
      Kv.Provider,
      {
        value: this._reactInternals,
      },
      this.props.children,
    )
  }
}
function QX() {
  const e = xI.useContext(Kv)
  if (e === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!")
  const A = xI.useId()
  return xI.useMemo(() => {
    for (const g of [e, e?.alternate]) {
      if (!g) continue
      const C = eO(g, !1, (i) => {
        let B = i.memoizedState
        for (; B; ) {
          if (B.memoizedState === A) return !0
          B = B.next
        }
      })
      if (C) return C
    }
  }, [e, A])
}
function oX() {
  const e = QX(),
    [A] = xI.useState(() => /* @__PURE__ */ new Map())
  A.clear()
  let I = e
  for (; I; ) {
    if (I.type && typeof I.type == "object") {
      const C = I.type._context === void 0 && I.type.Provider === I.type ? I.type : I.type._context
      C && C !== Kv && !A.has(C) && A.set(C, xI.useContext(iO(C)))
    }
    I = I.return
  }
  return A
}
function nX() {
  const e = oX()
  return xI.useMemo(
    () =>
      Array.from(e.keys()).reduce(
        (A, I) => (g) =>
          /* @__PURE__ */ xI.createElement(
            A,
            null,
            /* @__PURE__ */ xI.createElement(
              I.Provider,
              BX(mT({}, g), {
                value: e.get(I),
              }),
            ),
          ),
        (A) => /* @__PURE__ */ xI.createElement(tO, mT({}, A)),
      ),
    [e],
  )
}
function EX(
  { debounce: e, scroll: A, polyfill: I, offsetSize: g } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1,
  },
) {
  const C = I || (typeof window < "u" && window.ResizeObserver),
    [i, B] = xI.useState({
      left: 0,
      top: 0,
      width: 0,
      height: 0,
      bottom: 0,
      right: 0,
      x: 0,
      y: 0,
    })
  if (!C) return ((i.width = 1280), (i.height = 800), [() => {}, i, () => {}])
  const o = xI.useRef({
      element: null,
      scrollContainers: null,
      resizeObserver: null,
      lastBounds: i,
      orientationHandler: null,
    }),
    r = e ? (typeof e == "number" ? e : e.scroll) : null,
    s = e ? (typeof e == "number" ? e : e.resize) : null,
    h = xI.useRef(!1)
  xI.useEffect(() => ((h.current = !0), () => void (h.current = !1)))
  const [S, d, w] = xI.useMemo(() => {
    const F = () => {
      if (!o.current.element) return
      const {
          left: L,
          top: Y,
          width: H,
          height: V,
          bottom: j,
          right: P,
          x: AA,
          y: X,
        } = o.current.element.getBoundingClientRect(),
        _ = {
          left: L,
          top: Y,
          width: H,
          height: V,
          bottom: j,
          right: P,
          x: AA,
          y: X,
        }
      ;(o.current.element instanceof HTMLElement &&
        g &&
        ((_.height = o.current.element.offsetHeight), (_.width = o.current.element.offsetWidth)),
        Object.freeze(_),
        h.current && !lX(o.current.lastBounds, _) && B((o.current.lastBounds = _)))
    }
    return [F, s ? RT(F, s) : F, r ? RT(F, r) : F]
  }, [B, g, r, s])
  function M() {
    ;(o.current.scrollContainers &&
      (o.current.scrollContainers.forEach((F) => F.removeEventListener("scroll", w, !0)),
      (o.current.scrollContainers = null)),
      o.current.resizeObserver &&
        (o.current.resizeObserver.disconnect(), (o.current.resizeObserver = null)),
      o.current.orientationHandler &&
        ("orientation" in screen && "removeEventListener" in screen.orientation
          ? screen.orientation.removeEventListener("change", o.current.orientationHandler)
          : "onorientationchange" in window &&
            window.removeEventListener("orientationchange", o.current.orientationHandler)))
  }
  function K() {
    var F
    o.current.element &&
      ((o.current.resizeObserver = new C(d)),
      (F = o.current.resizeObserver) == null || F.observe(o.current.element),
      A &&
        o.current.scrollContainers &&
        o.current.scrollContainers.forEach((L) =>
          L.addEventListener("scroll", w, {
            capture: !0,
            passive: !0,
          }),
        ),
      (o.current.orientationHandler = () => {
        w()
      }),
      "orientation" in screen && "addEventListener" in screen.orientation
        ? screen.orientation.addEventListener("change", o.current.orientationHandler)
        : "onorientationchange" in window &&
          window.addEventListener("orientationchange", o.current.orientationHandler))
  }
  const R = (F) => {
    !F ||
      F === o.current.element ||
      (M(), (o.current.element = F), (o.current.scrollContainers = BO(F)), K())
  }
  return (
    rX(w, !!A),
    aX(d),
    xI.useEffect(() => {
      ;(M(), K())
    }, [A, w, d]),
    xI.useEffect(() => M, []),
    [R, i, S]
  )
}
function aX(e) {
  xI.useEffect(() => {
    const A = e
    return (
      window.addEventListener("resize", A),
      () => void window.removeEventListener("resize", A)
    )
  }, [e])
}
function rX(e, A) {
  xI.useEffect(() => {
    if (A) {
      const I = e
      return (
        window.addEventListener("scroll", I, {
          capture: !0,
          passive: !0,
        }),
        () => void window.removeEventListener("scroll", I, !0)
      )
    }
  }, [e, A])
}
function BO(e) {
  const A = []
  if (!e || e === document.body) return A
  const { overflow: I, overflowX: g, overflowY: C } = window.getComputedStyle(e)
  return (
    [I, g, C].some((i) => i === "auto" || i === "scroll") && A.push(e),
    [...A, ...BO(e.parentElement)]
  )
}
const sX = ["x", "y", "top", "bottom", "left", "right", "width", "height"],
  lX = (e, A) => sX.every((I) => e[I] === A[I]),
  cX = /* @__PURE__ */ xI.forwardRef(function (
    {
      children: A,
      fallback: I,
      resize: g,
      style: C,
      gl: i,
      events: B = $z,
      eventSource: o,
      eventPrefix: r,
      shadows: s,
      linear: h,
      flat: S,
      legacy: d,
      orthographic: w,
      frameloop: M,
      dpr: K,
      performance: R,
      raycaster: F,
      camera: L,
      scene: Y,
      onPointerMissed: H,
      onCreated: V,
      ...j
    },
    P,
  ) {
    xI.useMemo(() => Jv(lz), [])
    const AA = nX(),
      [X, _] = EX({
        scroll: !0,
        debounce: {
          scroll: 50,
          resize: 0,
        },
        ...g,
      }),
      eA = xI.useRef(null),
      CA = xI.useRef(null)
    xI.useImperativeHandle(P, () => eA.current)
    const aA = Pb(H),
      [lA, JA] = xI.useState(!1),
      [yA, LA] = xI.useState(!1)
    if (lA) throw lA
    if (yA) throw yA
    const nA = xI.useRef(null)
    ;(kp(() => {
      const sA = eA.current
      _.width > 0 &&
        _.height > 0 &&
        sA &&
        (nA.current || (nA.current = zz(sA)),
        nA.current.configure({
          gl: i,
          events: B,
          shadows: s,
          linear: h,
          flat: S,
          legacy: d,
          orthographic: w,
          frameloop: M,
          dpr: K,
          performance: R,
          raycaster: F,
          camera: L,
          scene: Y,
          size: _,
          // Pass mutable reference to onPointerMissed so it's free to update
          onPointerMissed: (...$) => (aA.current == null ? void 0 : aA.current(...$)),
          onCreated: ($) => {
            ;($.events.connect == null ||
              $.events.connect(o ? (Jz(o) ? o.current : o) : CA.current),
              r &&
                $.setEvents({
                  compute: (EA, GA) => {
                    const DA = EA[r + "X"],
                      dA = EA[r + "Y"]
                    ;(GA.pointer.set((DA / GA.size.width) * 2 - 1, -(dA / GA.size.height) * 2 + 1),
                      GA.raycaster.setFromCamera(GA.pointer, GA.camera))
                  },
                }),
              V?.($))
          },
        }),
        nA.current.render(
          /* @__PURE__ */ qC.jsx(AA, {
            children: /* @__PURE__ */ qC.jsx(Wb, {
              set: LA,
              children: /* @__PURE__ */ qC.jsx(xI.Suspense, {
                fallback: /* @__PURE__ */ qC.jsx(Kz, {
                  set: JA,
                }),
                children: A,
              }),
            }),
          }),
        ))
    }),
      xI.useEffect(() => {
        const sA = eA.current
        if (sA) return () => CO(sA)
      }, []))
    const fA = o ? "none" : "auto"
    return /* @__PURE__ */ qC.jsx("div", {
      ref: CA,
      style: {
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        pointerEvents: fA,
        ...C,
      },
      ...j,
      children: /* @__PURE__ */ qC.jsx("div", {
        ref: X,
        style: {
          width: "100%",
          height: "100%",
        },
        children: /* @__PURE__ */ qC.jsx("canvas", {
          ref: eA,
          style: {
            display: "block",
          },
          children: I,
        }),
      }),
    })
  }),
  hX = /* @__PURE__ */ xI.forwardRef(function (A, I) {
    return /* @__PURE__ */ qC.jsx(tO, {
      children: /* @__PURE__ */ qC.jsx(cX, {
        ...A,
        ref: I,
      }),
    })
  })
function GN() {
  return (
    (GN = Object.assign
      ? Object.assign.bind()
      : function (e) {
          for (var A = 1; A < arguments.length; A++) {
            var I = arguments[A]
            for (var g in I) ({}).hasOwnProperty.call(I, g) && (e[g] = I[g])
          }
          return e
        }),
    GN.apply(null, arguments)
  )
}
let H0
function uX() {
  var e
  if (H0 !== void 0) return H0
  try {
    let A
    const I = document.createElement("canvas")
    return (
      (H0 = !!(window.WebGL2RenderingContext && (A = I.getContext("webgl2")))),
      A && ((e = A.getExtension("WEBGL_lose_context")) == null || e.loseContext()),
      H0
    )
  } catch {
    return (H0 = !1)
  }
}
const DX = parseInt(Wf.replace(/\D+/g, ""))
function SX(e, A = 1e-4) {
  A = Math.max(A, Number.EPSILON)
  const I = {},
    g = e.getIndex(),
    C = e.getAttribute("position"),
    i = g ? g.count : C.count
  let B = 0
  const o = Object.keys(e.attributes),
    r = {},
    s = {},
    h = [],
    S = ["getX", "getY", "getZ", "getW"]
  for (let K = 0, R = o.length; K < R; K++) {
    const F = o[K]
    r[F] = []
    const L = e.morphAttributes[F]
    L && (s[F] = new Array(L.length).fill(0).map(() => []))
  }
  const d = Math.log10(1 / A),
    w = Math.pow(10, d)
  for (let K = 0; K < i; K++) {
    const R = g ? g.getX(K) : K
    let F = ""
    for (let L = 0, Y = o.length; L < Y; L++) {
      const H = o[L],
        V = e.getAttribute(H),
        j = V.itemSize
      for (let P = 0; P < j; P++) F += `${~~(V[S[P]](R) * w)},`
    }
    if (F in I) h.push(I[F])
    else {
      for (let L = 0, Y = o.length; L < Y; L++) {
        const H = o[L],
          V = e.getAttribute(H),
          j = e.morphAttributes[H],
          P = V.itemSize,
          AA = r[H],
          X = s[H]
        for (let _ = 0; _ < P; _++) {
          const eA = S[_]
          if ((AA.push(V[eA](R)), j))
            for (let CA = 0, aA = j.length; CA < aA; CA++) X[CA].push(j[CA][eA](R))
        }
      }
      ;((I[F] = B), h.push(B), B++)
    }
  }
  const M = e.clone()
  for (let K = 0, R = o.length; K < R; K++) {
    const F = o[K],
      L = e.getAttribute(F),
      Y = new L.array.constructor(r[F]),
      H = new Ye(Y, L.itemSize, L.normalized)
    if ((M.setAttribute(F, H), F in s))
      for (let V = 0; V < s[F].length; V++) {
        const j = e.morphAttributes[F][V],
          P = new j.array.constructor(s[F][V]),
          AA = new Ye(P, j.itemSize, j.normalized)
        M.morphAttributes[F][V] = AA
      }
  }
  return (M.setIndex(h), M)
}
function qT(e, A) {
  if (A === F2)
    return (
      console.warn(
        "THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.",
      ),
      e
    )
  if (A === fN || A === zm) {
    let I = e.getIndex()
    if (I === null) {
      const B = [],
        o = e.getAttribute("position")
      if (o !== void 0) {
        for (let r = 0; r < o.count; r++) B.push(r)
        ;(e.setIndex(B), (I = e.getIndex()))
      } else
        return (
          console.error(
            "THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.",
          ),
          e
        )
    }
    const g = I.count - 2,
      C = []
    if (I)
      if (A === fN)
        for (let B = 1; B <= g; B++) (C.push(I.getX(0)), C.push(I.getX(B)), C.push(I.getX(B + 1)))
      else
        for (let B = 0; B < g; B++)
          B % 2 === 0
            ? (C.push(I.getX(B)), C.push(I.getX(B + 1)), C.push(I.getX(B + 2)))
            : (C.push(I.getX(B + 2)), C.push(I.getX(B + 1)), C.push(I.getX(B)))
    C.length / 3 !== g &&
      console.error(
        "THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.",
      )
    const i = e.clone()
    return (i.setIndex(C), i.clearGroups(), i)
  } else
    return (
      console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", A),
      e
    )
}
function kN(e) {
  if (typeof TextDecoder < "u") return new TextDecoder().decode(e)
  let A = ""
  for (let I = 0, g = e.length; I < g; I++) A += String.fromCharCode(e[I])
  try {
    return decodeURIComponent(escape(A))
  } catch {
    return A
  }
}
const Nf = "srgb",
  iu = "srgb-linear",
  HT = 3001,
  fX = 3e3
class mv extends SE {
  constructor(A) {
    ;(super(A),
      (this.dracoLoader = null),
      (this.ktx2Loader = null),
      (this.meshoptDecoder = null),
      (this.pluginCallbacks = []),
      this.register(function (I) {
        return new GX(I)
      }),
      this.register(function (I) {
        return new kX(I)
      }),
      this.register(function (I) {
        return new vX(I)
      }),
      this.register(function (I) {
        return new LX(I)
      }),
      this.register(function (I) {
        return new YX(I)
      }),
      this.register(function (I) {
        return new UX(I)
      }),
      this.register(function (I) {
        return new NX(I)
      }),
      this.register(function (I) {
        return new FX(I)
      }),
      this.register(function (I) {
        return new RX(I)
      }),
      this.register(function (I) {
        return new wX(I)
      }),
      this.register(function (I) {
        return new JX(I)
      }),
      this.register(function (I) {
        return new MX(I)
      }),
      this.register(function (I) {
        return new mX(I)
      }),
      this.register(function (I) {
        return new KX(I)
      }),
      this.register(function (I) {
        return new yX(I)
      }),
      this.register(function (I) {
        return new qX(I)
      }),
      this.register(function (I) {
        return new HX(I)
      }))
  }
  load(A, I, g, C) {
    const i = this
    let B
    if (this.resourcePath !== "") B = this.resourcePath
    else if (this.path !== "") {
      const s = wD.extractUrlBase(A)
      B = wD.resolveURL(s, this.path)
    } else B = wD.extractUrlBase(A)
    this.manager.itemStart(A)
    const o = function (s) {
        ;(C ? C(s) : console.error(s), i.manager.itemError(A), i.manager.itemEnd(A))
      },
      r = new Yr(this.manager)
    ;(r.setPath(this.path),
      r.setResponseType("arraybuffer"),
      r.setRequestHeader(this.requestHeader),
      r.setWithCredentials(this.withCredentials),
      r.load(
        A,
        function (s) {
          try {
            i.parse(
              s,
              B,
              function (h) {
                ;(I(h), i.manager.itemEnd(A))
              },
              o,
            )
          } catch (h) {
            o(h)
          }
        },
        g,
        o,
      ))
  }
  setDRACOLoader(A) {
    return ((this.dracoLoader = A), this)
  }
  setDDSLoader() {
    throw new Error(
      'THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".',
    )
  }
  setKTX2Loader(A) {
    return ((this.ktx2Loader = A), this)
  }
  setMeshoptDecoder(A) {
    return ((this.meshoptDecoder = A), this)
  }
  register(A) {
    return (this.pluginCallbacks.indexOf(A) === -1 && this.pluginCallbacks.push(A), this)
  }
  unregister(A) {
    return (
      this.pluginCallbacks.indexOf(A) !== -1 &&
        this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(A), 1),
      this
    )
  }
  parse(A, I, g, C) {
    let i
    const B = {},
      o = {}
    if (typeof A == "string") i = JSON.parse(A)
    else if (A instanceof ArrayBuffer)
      if (kN(new Uint8Array(A.slice(0, 4))) === QO) {
        try {
          B[ze.KHR_BINARY_GLTF] = new TX(A)
        } catch (h) {
          C && C(h)
          return
        }
        i = JSON.parse(B[ze.KHR_BINARY_GLTF].content)
      } else i = JSON.parse(kN(new Uint8Array(A)))
    else i = A
    if (i.asset === void 0 || i.asset.version[0] < 2) {
      C && C(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."))
      return
    }
    const r = new A9(i, {
      path: I || this.resourcePath || "",
      crossOrigin: this.crossOrigin,
      requestHeader: this.requestHeader,
      manager: this.manager,
      ktx2Loader: this.ktx2Loader,
      meshoptDecoder: this.meshoptDecoder,
    })
    r.fileLoader.setRequestHeader(this.requestHeader)
    for (let s = 0; s < this.pluginCallbacks.length; s++) {
      const h = this.pluginCallbacks[s](r)
      ;(h.name || console.error("THREE.GLTFLoader: Invalid plugin found: missing name"),
        (o[h.name] = h),
        (B[h.name] = !0))
    }
    if (i.extensionsUsed)
      for (let s = 0; s < i.extensionsUsed.length; ++s) {
        const h = i.extensionsUsed[s],
          S = i.extensionsRequired || []
        switch (h) {
          case ze.KHR_MATERIALS_UNLIT:
            B[h] = new pX()
            break
          case ze.KHR_DRACO_MESH_COMPRESSION:
            B[h] = new xX(i, this.dracoLoader)
            break
          case ze.KHR_TEXTURE_TRANSFORM:
            B[h] = new bX()
            break
          case ze.KHR_MESH_QUANTIZATION:
            B[h] = new OX()
            break
          default:
            S.indexOf(h) >= 0 &&
              o[h] === void 0 &&
              console.warn('THREE.GLTFLoader: Unknown extension "' + h + '".')
        }
      }
    ;(r.setExtensions(B), r.setPlugins(o), r.parse(g, C))
  }
  parseAsync(A, I) {
    const g = this
    return new Promise(function (C, i) {
      g.parse(A, I, C, i)
    })
  }
}
function dX() {
  let e = {}
  return {
    get: function (A) {
      return e[A]
    },
    add: function (A, I) {
      e[A] = I
    },
    remove: function (A) {
      delete e[A]
    },
    removeAll: function () {
      e = {}
    },
  }
}
const ze = {
  KHR_BINARY_GLTF: "KHR_binary_glTF",
  KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
  KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
  KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
  KHR_MATERIALS_DISPERSION: "KHR_materials_dispersion",
  KHR_MATERIALS_IOR: "KHR_materials_ior",
  KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
  KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
  KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
  KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
  KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
  KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
  KHR_MATERIALS_VOLUME: "KHR_materials_volume",
  KHR_TEXTURE_BASISU: "KHR_texture_basisu",
  KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
  KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
  KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
  EXT_MATERIALS_BUMP: "EXT_materials_bump",
  EXT_TEXTURE_WEBP: "EXT_texture_webp",
  EXT_TEXTURE_AVIF: "EXT_texture_avif",
  EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
  EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing",
}
class yX {
  constructor(A) {
    ;((this.parser = A),
      (this.name = ze.KHR_LIGHTS_PUNCTUAL),
      (this.cache = { refs: {}, uses: {} }))
  }
  _markDefs() {
    const A = this.parser,
      I = this.parser.json.nodes || []
    for (let g = 0, C = I.length; g < C; g++) {
      const i = I[g]
      i.extensions &&
        i.extensions[this.name] &&
        i.extensions[this.name].light !== void 0 &&
        A._addNodeRef(this.cache, i.extensions[this.name].light)
    }
  }
  _loadLight(A) {
    const I = this.parser,
      g = "light:" + A
    let C = I.cache.get(g)
    if (C) return C
    const i = I.json,
      r = (((i.extensions && i.extensions[this.name]) || {}).lights || [])[A]
    let s
    const h = new Mg(16777215)
    r.color !== void 0 && h.setRGB(r.color[0], r.color[1], r.color[2], iu)
    const S = r.range !== void 0 ? r.range : 0
    switch (r.type) {
      case "directional":
        ;((s = new pv(h)), s.target.position.set(0, 0, -1), s.add(s.target))
        break
      case "point":
        ;((s = new yv(h)), (s.distance = S))
        break
      case "spot":
        ;((s = new dv(h)),
          (s.distance = S),
          (r.spot = r.spot || {}),
          (r.spot.innerConeAngle = r.spot.innerConeAngle !== void 0 ? r.spot.innerConeAngle : 0),
          (r.spot.outerConeAngle =
            r.spot.outerConeAngle !== void 0 ? r.spot.outerConeAngle : Math.PI / 4),
          (s.angle = r.spot.outerConeAngle),
          (s.penumbra = 1 - r.spot.innerConeAngle / r.spot.outerConeAngle),
          s.target.position.set(0, 0, -1),
          s.add(s.target))
        break
      default:
        throw new Error("THREE.GLTFLoader: Unexpected light type: " + r.type)
    }
    return (
      s.position.set(0, 0, 0),
      (s.decay = 2),
      $h(s, r),
      r.intensity !== void 0 && (s.intensity = r.intensity),
      (s.name = I.createUniqueName(r.name || "light_" + A)),
      (C = Promise.resolve(s)),
      I.cache.add(g, C),
      C
    )
  }
  getDependency(A, I) {
    if (A === "light") return this._loadLight(I)
  }
  createNodeAttachment(A) {
    const I = this,
      g = this.parser,
      i = g.json.nodes[A],
      o = ((i.extensions && i.extensions[this.name]) || {}).light
    return o === void 0
      ? null
      : this._loadLight(o).then(function (r) {
          return g._getNodeRef(I.cache, o, r)
        })
  }
}
class pX {
  constructor() {
    this.name = ze.KHR_MATERIALS_UNLIT
  }
  getMaterialType() {
    return La
  }
  extendParams(A, I, g) {
    const C = []
    ;((A.color = new Mg(1, 1, 1)), (A.opacity = 1))
    const i = I.pbrMetallicRoughness
    if (i) {
      if (Array.isArray(i.baseColorFactor)) {
        const B = i.baseColorFactor
        ;(A.color.setRGB(B[0], B[1], B[2], iu), (A.opacity = B[3]))
      }
      i.baseColorTexture !== void 0 && C.push(g.assignTexture(A, "map", i.baseColorTexture, Nf))
    }
    return Promise.all(C)
  }
}
class wX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.KHR_MATERIALS_EMISSIVE_STRENGTH))
  }
  extendMaterialParams(A, I) {
    const C = this.parser.json.materials[A]
    if (!C.extensions || !C.extensions[this.name]) return Promise.resolve()
    const i = C.extensions[this.name].emissiveStrength
    return (i !== void 0 && (I.emissiveIntensity = i), Promise.resolve())
  }
}
class GX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.KHR_MATERIALS_CLEARCOAT))
  }
  getMaterialType(A) {
    const g = this.parser.json.materials[A]
    return !g.extensions || !g.extensions[this.name] ? null : Hr
  }
  extendMaterialParams(A, I) {
    const g = this.parser,
      C = g.json.materials[A]
    if (!C.extensions || !C.extensions[this.name]) return Promise.resolve()
    const i = [],
      B = C.extensions[this.name]
    if (
      (B.clearcoatFactor !== void 0 && (I.clearcoat = B.clearcoatFactor),
      B.clearcoatTexture !== void 0 &&
        i.push(g.assignTexture(I, "clearcoatMap", B.clearcoatTexture)),
      B.clearcoatRoughnessFactor !== void 0 && (I.clearcoatRoughness = B.clearcoatRoughnessFactor),
      B.clearcoatRoughnessTexture !== void 0 &&
        i.push(g.assignTexture(I, "clearcoatRoughnessMap", B.clearcoatRoughnessTexture)),
      B.clearcoatNormalTexture !== void 0 &&
        (i.push(g.assignTexture(I, "clearcoatNormalMap", B.clearcoatNormalTexture)),
        B.clearcoatNormalTexture.scale !== void 0))
    ) {
      const o = B.clearcoatNormalTexture.scale
      I.clearcoatNormalScale = new ZI(o, o)
    }
    return Promise.all(i)
  }
}
class kX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.KHR_MATERIALS_DISPERSION))
  }
  getMaterialType(A) {
    const g = this.parser.json.materials[A]
    return !g.extensions || !g.extensions[this.name] ? null : Hr
  }
  extendMaterialParams(A, I) {
    const C = this.parser.json.materials[A]
    if (!C.extensions || !C.extensions[this.name]) return Promise.resolve()
    const i = C.extensions[this.name]
    return ((I.dispersion = i.dispersion !== void 0 ? i.dispersion : 0), Promise.resolve())
  }
}
class MX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.KHR_MATERIALS_IRIDESCENCE))
  }
  getMaterialType(A) {
    const g = this.parser.json.materials[A]
    return !g.extensions || !g.extensions[this.name] ? null : Hr
  }
  extendMaterialParams(A, I) {
    const g = this.parser,
      C = g.json.materials[A]
    if (!C.extensions || !C.extensions[this.name]) return Promise.resolve()
    const i = [],
      B = C.extensions[this.name]
    return (
      B.iridescenceFactor !== void 0 && (I.iridescence = B.iridescenceFactor),
      B.iridescenceTexture !== void 0 &&
        i.push(g.assignTexture(I, "iridescenceMap", B.iridescenceTexture)),
      B.iridescenceIor !== void 0 && (I.iridescenceIOR = B.iridescenceIor),
      I.iridescenceThicknessRange === void 0 && (I.iridescenceThicknessRange = [100, 400]),
      B.iridescenceThicknessMinimum !== void 0 &&
        (I.iridescenceThicknessRange[0] = B.iridescenceThicknessMinimum),
      B.iridescenceThicknessMaximum !== void 0 &&
        (I.iridescenceThicknessRange[1] = B.iridescenceThicknessMaximum),
      B.iridescenceThicknessTexture !== void 0 &&
        i.push(g.assignTexture(I, "iridescenceThicknessMap", B.iridescenceThicknessTexture)),
      Promise.all(i)
    )
  }
}
class UX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.KHR_MATERIALS_SHEEN))
  }
  getMaterialType(A) {
    const g = this.parser.json.materials[A]
    return !g.extensions || !g.extensions[this.name] ? null : Hr
  }
  extendMaterialParams(A, I) {
    const g = this.parser,
      C = g.json.materials[A]
    if (!C.extensions || !C.extensions[this.name]) return Promise.resolve()
    const i = []
    ;((I.sheenColor = new Mg(0, 0, 0)), (I.sheenRoughness = 0), (I.sheen = 1))
    const B = C.extensions[this.name]
    if (B.sheenColorFactor !== void 0) {
      const o = B.sheenColorFactor
      I.sheenColor.setRGB(o[0], o[1], o[2], iu)
    }
    return (
      B.sheenRoughnessFactor !== void 0 && (I.sheenRoughness = B.sheenRoughnessFactor),
      B.sheenColorTexture !== void 0 &&
        i.push(g.assignTexture(I, "sheenColorMap", B.sheenColorTexture, Nf)),
      B.sheenRoughnessTexture !== void 0 &&
        i.push(g.assignTexture(I, "sheenRoughnessMap", B.sheenRoughnessTexture)),
      Promise.all(i)
    )
  }
}
class NX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.KHR_MATERIALS_TRANSMISSION))
  }
  getMaterialType(A) {
    const g = this.parser.json.materials[A]
    return !g.extensions || !g.extensions[this.name] ? null : Hr
  }
  extendMaterialParams(A, I) {
    const g = this.parser,
      C = g.json.materials[A]
    if (!C.extensions || !C.extensions[this.name]) return Promise.resolve()
    const i = [],
      B = C.extensions[this.name]
    return (
      B.transmissionFactor !== void 0 && (I.transmission = B.transmissionFactor),
      B.transmissionTexture !== void 0 &&
        i.push(g.assignTexture(I, "transmissionMap", B.transmissionTexture)),
      Promise.all(i)
    )
  }
}
class FX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.KHR_MATERIALS_VOLUME))
  }
  getMaterialType(A) {
    const g = this.parser.json.materials[A]
    return !g.extensions || !g.extensions[this.name] ? null : Hr
  }
  extendMaterialParams(A, I) {
    const g = this.parser,
      C = g.json.materials[A]
    if (!C.extensions || !C.extensions[this.name]) return Promise.resolve()
    const i = [],
      B = C.extensions[this.name]
    ;((I.thickness = B.thicknessFactor !== void 0 ? B.thicknessFactor : 0),
      B.thicknessTexture !== void 0 &&
        i.push(g.assignTexture(I, "thicknessMap", B.thicknessTexture)),
      (I.attenuationDistance = B.attenuationDistance || 1 / 0))
    const o = B.attenuationColor || [1, 1, 1]
    return ((I.attenuationColor = new Mg().setRGB(o[0], o[1], o[2], iu)), Promise.all(i))
  }
}
class RX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.KHR_MATERIALS_IOR))
  }
  getMaterialType(A) {
    const g = this.parser.json.materials[A]
    return !g.extensions || !g.extensions[this.name] ? null : Hr
  }
  extendMaterialParams(A, I) {
    const C = this.parser.json.materials[A]
    if (!C.extensions || !C.extensions[this.name]) return Promise.resolve()
    const i = C.extensions[this.name]
    return ((I.ior = i.ior !== void 0 ? i.ior : 1.5), Promise.resolve())
  }
}
class JX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.KHR_MATERIALS_SPECULAR))
  }
  getMaterialType(A) {
    const g = this.parser.json.materials[A]
    return !g.extensions || !g.extensions[this.name] ? null : Hr
  }
  extendMaterialParams(A, I) {
    const g = this.parser,
      C = g.json.materials[A]
    if (!C.extensions || !C.extensions[this.name]) return Promise.resolve()
    const i = [],
      B = C.extensions[this.name]
    ;((I.specularIntensity = B.specularFactor !== void 0 ? B.specularFactor : 1),
      B.specularTexture !== void 0 &&
        i.push(g.assignTexture(I, "specularIntensityMap", B.specularTexture)))
    const o = B.specularColorFactor || [1, 1, 1]
    return (
      (I.specularColor = new Mg().setRGB(o[0], o[1], o[2], iu)),
      B.specularColorTexture !== void 0 &&
        i.push(g.assignTexture(I, "specularColorMap", B.specularColorTexture, Nf)),
      Promise.all(i)
    )
  }
}
class KX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.EXT_MATERIALS_BUMP))
  }
  getMaterialType(A) {
    const g = this.parser.json.materials[A]
    return !g.extensions || !g.extensions[this.name] ? null : Hr
  }
  extendMaterialParams(A, I) {
    const g = this.parser,
      C = g.json.materials[A]
    if (!C.extensions || !C.extensions[this.name]) return Promise.resolve()
    const i = [],
      B = C.extensions[this.name]
    return (
      (I.bumpScale = B.bumpFactor !== void 0 ? B.bumpFactor : 1),
      B.bumpTexture !== void 0 && i.push(g.assignTexture(I, "bumpMap", B.bumpTexture)),
      Promise.all(i)
    )
  }
}
class mX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.KHR_MATERIALS_ANISOTROPY))
  }
  getMaterialType(A) {
    const g = this.parser.json.materials[A]
    return !g.extensions || !g.extensions[this.name] ? null : Hr
  }
  extendMaterialParams(A, I) {
    const g = this.parser,
      C = g.json.materials[A]
    if (!C.extensions || !C.extensions[this.name]) return Promise.resolve()
    const i = [],
      B = C.extensions[this.name]
    return (
      B.anisotropyStrength !== void 0 && (I.anisotropy = B.anisotropyStrength),
      B.anisotropyRotation !== void 0 && (I.anisotropyRotation = B.anisotropyRotation),
      B.anisotropyTexture !== void 0 &&
        i.push(g.assignTexture(I, "anisotropyMap", B.anisotropyTexture)),
      Promise.all(i)
    )
  }
}
class vX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.KHR_TEXTURE_BASISU))
  }
  loadTexture(A) {
    const I = this.parser,
      g = I.json,
      C = g.textures[A]
    if (!C.extensions || !C.extensions[this.name]) return null
    const i = C.extensions[this.name],
      B = I.options.ktx2Loader
    if (!B) {
      if (g.extensionsRequired && g.extensionsRequired.indexOf(this.name) >= 0)
        throw new Error(
          "THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures",
        )
      return null
    }
    return I.loadTextureImage(A, i.source, B)
  }
}
class LX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.EXT_TEXTURE_WEBP), (this.isSupported = null))
  }
  loadTexture(A) {
    const I = this.name,
      g = this.parser,
      C = g.json,
      i = C.textures[A]
    if (!i.extensions || !i.extensions[I]) return null
    const B = i.extensions[I],
      o = C.images[B.source]
    let r = g.textureLoader
    if (o.uri) {
      const s = g.options.manager.getHandler(o.uri)
      s !== null && (r = s)
    }
    return this.detectSupport().then(function (s) {
      if (s) return g.loadTextureImage(A, B.source, r)
      if (C.extensionsRequired && C.extensionsRequired.indexOf(I) >= 0)
        throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.")
      return g.loadTexture(A)
    })
  }
  detectSupport() {
    return (
      this.isSupported ||
        (this.isSupported = new Promise(function (A) {
          const I = new Image()
          ;((I.src =
            "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA"),
            (I.onload = I.onerror =
              function () {
                A(I.height === 1)
              }))
        })),
      this.isSupported
    )
  }
}
class YX {
  constructor(A) {
    ;((this.parser = A), (this.name = ze.EXT_TEXTURE_AVIF), (this.isSupported = null))
  }
  loadTexture(A) {
    const I = this.name,
      g = this.parser,
      C = g.json,
      i = C.textures[A]
    if (!i.extensions || !i.extensions[I]) return null
    const B = i.extensions[I],
      o = C.images[B.source]
    let r = g.textureLoader
    if (o.uri) {
      const s = g.options.manager.getHandler(o.uri)
      s !== null && (r = s)
    }
    return this.detectSupport().then(function (s) {
      if (s) return g.loadTextureImage(A, B.source, r)
      if (C.extensionsRequired && C.extensionsRequired.indexOf(I) >= 0)
        throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.")
      return g.loadTexture(A)
    })
  }
  detectSupport() {
    return (
      this.isSupported ||
        (this.isSupported = new Promise(function (A) {
          const I = new Image()
          ;((I.src =
            "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI="),
            (I.onload = I.onerror =
              function () {
                A(I.height === 1)
              }))
        })),
      this.isSupported
    )
  }
}
class qX {
  constructor(A) {
    ;((this.name = ze.EXT_MESHOPT_COMPRESSION), (this.parser = A))
  }
  loadBufferView(A) {
    const I = this.parser.json,
      g = I.bufferViews[A]
    if (g.extensions && g.extensions[this.name]) {
      const C = g.extensions[this.name],
        i = this.parser.getDependency("buffer", C.buffer),
        B = this.parser.options.meshoptDecoder
      if (!B || !B.supported) {
        if (I.extensionsRequired && I.extensionsRequired.indexOf(this.name) >= 0)
          throw new Error(
            "THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files",
          )
        return null
      }
      return i.then(function (o) {
        const r = C.byteOffset || 0,
          s = C.byteLength || 0,
          h = C.count,
          S = C.byteStride,
          d = new Uint8Array(o, r, s)
        return B.decodeGltfBufferAsync
          ? B.decodeGltfBufferAsync(h, S, d, C.mode, C.filter).then(function (w) {
              return w.buffer
            })
          : B.ready.then(function () {
              const w = new ArrayBuffer(h * S)
              return (B.decodeGltfBuffer(new Uint8Array(w), h, S, d, C.mode, C.filter), w)
            })
      })
    } else return null
  }
}
class HX {
  constructor(A) {
    ;((this.name = ze.EXT_MESH_GPU_INSTANCING), (this.parser = A))
  }
  createNodeMesh(A) {
    const I = this.parser.json,
      g = I.nodes[A]
    if (!g.extensions || !g.extensions[this.name] || g.mesh === void 0) return null
    const C = I.meshes[g.mesh]
    for (const s of C.primitives)
      if (
        s.mode !== ps.TRIANGLES &&
        s.mode !== ps.TRIANGLE_STRIP &&
        s.mode !== ps.TRIANGLE_FAN &&
        s.mode !== void 0
      )
        return null
    const B = g.extensions[this.name].attributes,
      o = [],
      r = {}
    for (const s in B)
      o.push(this.parser.getDependency("accessor", B[s]).then((h) => ((r[s] = h), r[s])))
    return o.length < 1
      ? null
      : (o.push(this.parser.createNodeMesh(A)),
        Promise.all(o).then((s) => {
          const h = s.pop(),
            S = h.isGroup ? h.children : [h],
            d = s[0].count,
            w = []
          for (const M of S) {
            const K = new RC(),
              R = new wA(),
              F = new ho(),
              L = new wA(1, 1, 1),
              Y = new Bv(M.geometry, M.material, d)
            for (let H = 0; H < d; H++)
              (r.TRANSLATION && R.fromBufferAttribute(r.TRANSLATION, H),
                r.ROTATION && F.fromBufferAttribute(r.ROTATION, H),
                r.SCALE && L.fromBufferAttribute(r.SCALE, H),
                Y.setMatrixAt(H, K.compose(R, F, L)))
            for (const H in r)
              if (H === "_COLOR_0") {
                const V = r[H]
                Y.instanceColor = new RD(V.array, V.itemSize, V.normalized)
              } else
                H !== "TRANSLATION" &&
                  H !== "ROTATION" &&
                  H !== "SCALE" &&
                  M.geometry.setAttribute(H, r[H])
            ;(Ci.prototype.copy.call(Y, M), this.parser.assignFinalMaterial(Y), w.push(Y))
          }
          return h.isGroup ? (h.clear(), h.add(...w), h) : w[0]
        }))
  }
}
const QO = "glTF",
  T0 = 12,
  TT = { JSON: 1313821514, BIN: 5130562 }
class TX {
  constructor(A) {
    ;((this.name = ze.KHR_BINARY_GLTF), (this.content = null), (this.body = null))
    const I = new DataView(A, 0, T0)
    if (
      ((this.header = {
        magic: kN(new Uint8Array(A.slice(0, 4))),
        version: I.getUint32(4, !0),
        length: I.getUint32(8, !0),
      }),
      this.header.magic !== QO)
    )
      throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.")
    if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.")
    const g = this.header.length - T0,
      C = new DataView(A, T0)
    let i = 0
    for (; i < g; ) {
      const B = C.getUint32(i, !0)
      i += 4
      const o = C.getUint32(i, !0)
      if (((i += 4), o === TT.JSON)) {
        const r = new Uint8Array(A, T0 + i, B)
        this.content = kN(r)
      } else if (o === TT.BIN) {
        const r = T0 + i
        this.body = A.slice(r, r + B)
      }
      i += B
    }
    if (this.content === null) throw new Error("THREE.GLTFLoader: JSON content not found.")
  }
}
class xX {
  constructor(A, I) {
    if (!I) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.")
    ;((this.name = ze.KHR_DRACO_MESH_COMPRESSION),
      (this.json = A),
      (this.dracoLoader = I),
      this.dracoLoader.preload())
  }
  decodePrimitive(A, I) {
    const g = this.json,
      C = this.dracoLoader,
      i = A.extensions[this.name].bufferView,
      B = A.extensions[this.name].attributes,
      o = {},
      r = {},
      s = {}
    for (const h in B) {
      const S = Um[h] || h.toLowerCase()
      o[S] = B[h]
    }
    for (const h in A.attributes) {
      const S = Um[h] || h.toLowerCase()
      if (B[h] !== void 0) {
        const d = g.accessors[A.attributes[h]],
          w = tp[d.componentType]
        ;((s[S] = w.name), (r[S] = d.normalized === !0))
      }
    }
    return I.getDependency("bufferView", i).then(function (h) {
      return new Promise(function (S, d) {
        C.decodeDracoFile(
          h,
          function (w) {
            for (const M in w.attributes) {
              const K = w.attributes[M],
                R = r[M]
              R !== void 0 && (K.normalized = R)
            }
            S(w)
          },
          o,
          s,
          iu,
          d,
        )
      })
    })
  }
}
class bX {
  constructor() {
    this.name = ze.KHR_TEXTURE_TRANSFORM
  }
  extendTexture(A, I) {
    return (
      ((I.texCoord === void 0 || I.texCoord === A.channel) &&
        I.offset === void 0 &&
        I.rotation === void 0 &&
        I.scale === void 0) ||
        ((A = A.clone()),
        I.texCoord !== void 0 && (A.channel = I.texCoord),
        I.offset !== void 0 && A.offset.fromArray(I.offset),
        I.rotation !== void 0 && (A.rotation = I.rotation),
        I.scale !== void 0 && A.repeat.fromArray(I.scale),
        (A.needsUpdate = !0)),
      A
    )
  }
}
class OX {
  constructor() {
    this.name = ze.KHR_MESH_QUANTIZATION
  }
}
class oO extends Gp {
  constructor(A, I, g, C) {
    super(A, I, g, C)
  }
  copySampleValue_(A) {
    const I = this.resultBuffer,
      g = this.sampleValues,
      C = this.valueSize,
      i = A * C * 3 + C
    for (let B = 0; B !== C; B++) I[B] = g[i + B]
    return I
  }
  interpolate_(A, I, g, C) {
    const i = this.resultBuffer,
      B = this.sampleValues,
      o = this.valueSize,
      r = o * 2,
      s = o * 3,
      h = C - I,
      S = (g - I) / h,
      d = S * S,
      w = d * S,
      M = A * s,
      K = M - s,
      R = -2 * w + 3 * d,
      F = w - d,
      L = 1 - R,
      Y = F - d + S
    for (let H = 0; H !== o; H++) {
      const V = B[K + H + o],
        j = B[K + H + r] * h,
        P = B[M + H + o],
        AA = B[M + H] * h
      i[H] = L * V + Y * j + R * P + F * AA
    }
    return i
  }
}
const _X = new ho()
class ZX extends oO {
  interpolate_(A, I, g, C) {
    const i = super.interpolate_(A, I, g, C)
    return (_X.fromArray(i).normalize().toArray(i), i)
  }
}
const ps = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123,
  },
  tp = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array,
  },
  xT = {
    9728: iQ,
    9729: nt,
    9984: ON,
    9985: ep,
    9986: pf,
    9987: ks,
  },
  bT = {
    33071: vr,
    33648: Qp,
    10497: MD,
  },
  VK = {
    SCALAR: 1,
    VEC2: 2,
    VEC3: 3,
    VEC4: 4,
    MAT2: 4,
    MAT3: 9,
    MAT4: 16,
  },
  Um = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    // uv => uv1, 4 uv channels
    // https://github.com/mrdoob/three.js/pull/25943
    // https://github.com/mrdoob/three.js/pull/25788
    ...(DX >= 152
      ? {
          TEXCOORD_0: "uv",
          TEXCOORD_1: "uv1",
          TEXCOORD_2: "uv2",
          TEXCOORD_3: "uv3",
        }
      : {
          TEXCOORD_0: "uv",
          TEXCOORD_1: "uv2",
        }),
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex",
  },
  uD = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion",
    weights: "morphTargetInfluences",
  },
  PX = {
    CUBICSPLINE: void 0,
    // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: Ep,
    STEP: np,
  },
  jK = {
    OPAQUE: "OPAQUE",
    MASK: "MASK",
    BLEND: "BLEND",
  }
function WX(e) {
  return (
    e.DefaultMaterial === void 0 &&
      (e.DefaultMaterial = new qG({
        color: 16777215,
        emissive: 0,
        metalness: 1,
        roughness: 1,
        transparent: !1,
        depthTest: !0,
        side: Us,
      })),
    e.DefaultMaterial
  )
}
function uf(e, A, I) {
  for (const g in I.extensions)
    e[g] === void 0 &&
      ((A.userData.gltfExtensions = A.userData.gltfExtensions || {}),
      (A.userData.gltfExtensions[g] = I.extensions[g]))
}
function $h(e, A) {
  A.extras !== void 0 &&
    (typeof A.extras == "object"
      ? Object.assign(e.userData, A.extras)
      : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + A.extras))
}
function VX(e, A, I) {
  let g = !1,
    C = !1,
    i = !1
  for (let s = 0, h = A.length; s < h; s++) {
    const S = A[s]
    if (
      (S.POSITION !== void 0 && (g = !0),
      S.NORMAL !== void 0 && (C = !0),
      S.COLOR_0 !== void 0 && (i = !0),
      g && C && i)
    )
      break
  }
  if (!g && !C && !i) return Promise.resolve(e)
  const B = [],
    o = [],
    r = []
  for (let s = 0, h = A.length; s < h; s++) {
    const S = A[s]
    if (g) {
      const d =
        S.POSITION !== void 0 ? I.getDependency("accessor", S.POSITION) : e.attributes.position
      B.push(d)
    }
    if (C) {
      const d = S.NORMAL !== void 0 ? I.getDependency("accessor", S.NORMAL) : e.attributes.normal
      o.push(d)
    }
    if (i) {
      const d = S.COLOR_0 !== void 0 ? I.getDependency("accessor", S.COLOR_0) : e.attributes.color
      r.push(d)
    }
  }
  return Promise.all([Promise.all(B), Promise.all(o), Promise.all(r)]).then(function (s) {
    const h = s[0],
      S = s[1],
      d = s[2]
    return (
      g && (e.morphAttributes.position = h),
      C && (e.morphAttributes.normal = S),
      i && (e.morphAttributes.color = d),
      (e.morphTargetsRelative = !0),
      e
    )
  })
}
function jX(e, A) {
  if ((e.updateMorphTargets(), A.weights !== void 0))
    for (let I = 0, g = A.weights.length; I < g; I++) e.morphTargetInfluences[I] = A.weights[I]
  if (A.extras && Array.isArray(A.extras.targetNames)) {
    const I = A.extras.targetNames
    if (e.morphTargetInfluences.length === I.length) {
      e.morphTargetDictionary = {}
      for (let g = 0, C = I.length; g < C; g++) e.morphTargetDictionary[I[g]] = g
    } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.")
  }
}
function zX(e) {
  let A
  const I = e.extensions && e.extensions[ze.KHR_DRACO_MESH_COMPRESSION]
  if (
    (I
      ? (A = "draco:" + I.bufferView + ":" + I.indices + ":" + zK(I.attributes))
      : (A = e.indices + ":" + zK(e.attributes) + ":" + e.mode),
    e.targets !== void 0)
  )
    for (let g = 0, C = e.targets.length; g < C; g++) A += ":" + zK(e.targets[g])
  return A
}
function zK(e) {
  let A = ""
  const I = Object.keys(e).sort()
  for (let g = 0, C = I.length; g < C; g++) A += I[g] + ":" + e[I[g]] + ";"
  return A
}
function Nm(e) {
  switch (e) {
    case Int8Array:
      return 1 / 127
    case Uint8Array:
      return 1 / 255
    case Int16Array:
      return 1 / 32767
    case Uint16Array:
      return 1 / 65535
    default:
      throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.")
  }
}
function XX(e) {
  return e.search(/\.jpe?g($|\?)/i) > 0 || e.search(/^data\:image\/jpeg/) === 0
    ? "image/jpeg"
    : e.search(/\.webp($|\?)/i) > 0 || e.search(/^data\:image\/webp/) === 0
      ? "image/webp"
      : "image/png"
}
const $X = new RC()
class A9 {
  constructor(A = {}, I = {}) {
    ;((this.json = A),
      (this.extensions = {}),
      (this.plugins = {}),
      (this.options = I),
      (this.cache = new dX()),
      (this.associations = /* @__PURE__ */ new Map()),
      (this.primitiveCache = {}),
      (this.nodeCache = {}),
      (this.meshCache = { refs: {}, uses: {} }),
      (this.cameraCache = { refs: {}, uses: {} }),
      (this.lightCache = { refs: {}, uses: {} }),
      (this.sourceCache = {}),
      (this.textureCache = {}),
      (this.nodeNamesUsed = {}))
    let g = !1,
      C = !1,
      i = -1
    ;(typeof navigator < "u" &&
      typeof navigator.userAgent < "u" &&
      ((g = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === !0),
      (C = navigator.userAgent.indexOf("Firefox") > -1),
      (i = C ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1)),
      typeof createImageBitmap > "u" || g || (C && i < 98)
        ? (this.textureLoader = new Nb(this.options.manager))
        : (this.textureLoader = new Lb(this.options.manager)),
      this.textureLoader.setCrossOrigin(this.options.crossOrigin),
      this.textureLoader.setRequestHeader(this.options.requestHeader),
      (this.fileLoader = new Yr(this.options.manager)),
      this.fileLoader.setResponseType("arraybuffer"),
      this.options.crossOrigin === "use-credentials" && this.fileLoader.setWithCredentials(!0))
  }
  setExtensions(A) {
    this.extensions = A
  }
  setPlugins(A) {
    this.plugins = A
  }
  parse(A, I) {
    const g = this,
      C = this.json,
      i = this.extensions
    ;(this.cache.removeAll(),
      (this.nodeCache = {}),
      this._invokeAll(function (B) {
        return B._markDefs && B._markDefs()
      }),
      Promise.all(
        this._invokeAll(function (B) {
          return B.beforeRoot && B.beforeRoot()
        }),
      )
        .then(function () {
          return Promise.all([
            g.getDependencies("scene"),
            g.getDependencies("animation"),
            g.getDependencies("camera"),
          ])
        })
        .then(function (B) {
          const o = {
            scene: B[0][C.scene || 0],
            scenes: B[0],
            animations: B[1],
            cameras: B[2],
            asset: C.asset,
            parser: g,
            userData: {},
          }
          return (
            uf(i, o, C),
            $h(o, C),
            Promise.all(
              g._invokeAll(function (r) {
                return r.afterRoot && r.afterRoot(o)
              }),
            ).then(function () {
              for (const r of o.scenes) r.updateMatrixWorld()
              A(o)
            })
          )
        })
        .catch(I))
  }
  /**
   * Marks the special nodes/meshes in json for efficient parse.
   */
  _markDefs() {
    const A = this.json.nodes || [],
      I = this.json.skins || [],
      g = this.json.meshes || []
    for (let C = 0, i = I.length; C < i; C++) {
      const B = I[C].joints
      for (let o = 0, r = B.length; o < r; o++) A[B[o]].isBone = !0
    }
    for (let C = 0, i = A.length; C < i; C++) {
      const B = A[C]
      ;(B.mesh !== void 0 &&
        (this._addNodeRef(this.meshCache, B.mesh),
        B.skin !== void 0 && (g[B.mesh].isSkinnedMesh = !0)),
        B.camera !== void 0 && this._addNodeRef(this.cameraCache, B.camera))
    }
  }
  /**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   */
  _addNodeRef(A, I) {
    I !== void 0 && (A.refs[I] === void 0 && (A.refs[I] = A.uses[I] = 0), A.refs[I]++)
  }
  /** Returns a reference to a shared resource, cloning it if necessary. */
  _getNodeRef(A, I, g) {
    if (A.refs[I] <= 1) return g
    const C = g.clone(),
      i = (B, o) => {
        const r = this.associations.get(B)
        r != null && this.associations.set(o, r)
        for (const [s, h] of B.children.entries()) i(h, o.children[s])
      }
    return (i(g, C), (C.name += "_instance_" + A.uses[I]++), C)
  }
  _invokeOne(A) {
    const I = Object.values(this.plugins)
    I.push(this)
    for (let g = 0; g < I.length; g++) {
      const C = A(I[g])
      if (C) return C
    }
    return null
  }
  _invokeAll(A) {
    const I = Object.values(this.plugins)
    I.unshift(this)
    const g = []
    for (let C = 0; C < I.length; C++) {
      const i = A(I[C])
      i && g.push(i)
    }
    return g
  }
  /**
   * Requests the specified dependency asynchronously, with caching.
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
   */
  getDependency(A, I) {
    const g = A + ":" + I
    let C = this.cache.get(g)
    if (!C) {
      switch (A) {
        case "scene":
          C = this.loadScene(I)
          break
        case "node":
          C = this._invokeOne(function (i) {
            return i.loadNode && i.loadNode(I)
          })
          break
        case "mesh":
          C = this._invokeOne(function (i) {
            return i.loadMesh && i.loadMesh(I)
          })
          break
        case "accessor":
          C = this.loadAccessor(I)
          break
        case "bufferView":
          C = this._invokeOne(function (i) {
            return i.loadBufferView && i.loadBufferView(I)
          })
          break
        case "buffer":
          C = this.loadBuffer(I)
          break
        case "material":
          C = this._invokeOne(function (i) {
            return i.loadMaterial && i.loadMaterial(I)
          })
          break
        case "texture":
          C = this._invokeOne(function (i) {
            return i.loadTexture && i.loadTexture(I)
          })
          break
        case "skin":
          C = this.loadSkin(I)
          break
        case "animation":
          C = this._invokeOne(function (i) {
            return i.loadAnimation && i.loadAnimation(I)
          })
          break
        case "camera":
          C = this.loadCamera(I)
          break
        default:
          if (
            ((C = this._invokeOne(function (i) {
              return i != this && i.getDependency && i.getDependency(A, I)
            })),
            !C)
          )
            throw new Error("Unknown type: " + A)
          break
      }
      this.cache.add(g, C)
    }
    return C
  }
  /**
   * Requests all dependencies of the specified type asynchronously, with caching.
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */
  getDependencies(A) {
    let I = this.cache.get(A)
    if (!I) {
      const g = this,
        C = this.json[A + (A === "mesh" ? "es" : "s")] || []
      ;((I = Promise.all(
        C.map(function (i, B) {
          return g.getDependency(A, B)
        }),
      )),
        this.cache.add(A, I))
    }
    return I
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBuffer(A) {
    const I = this.json.buffers[A],
      g = this.fileLoader
    if (I.type && I.type !== "arraybuffer")
      throw new Error("THREE.GLTFLoader: " + I.type + " buffer type is not supported.")
    if (I.uri === void 0 && A === 0)
      return Promise.resolve(this.extensions[ze.KHR_BINARY_GLTF].body)
    const C = this.options
    return new Promise(function (i, B) {
      g.load(wD.resolveURL(I.uri, C.path), i, void 0, function () {
        B(new Error('THREE.GLTFLoader: Failed to load buffer "' + I.uri + '".'))
      })
    })
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBufferView(A) {
    const I = this.json.bufferViews[A]
    return this.getDependency("buffer", I.buffer).then(function (g) {
      const C = I.byteLength || 0,
        i = I.byteOffset || 0
      return g.slice(i, i + C)
    })
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */
  loadAccessor(A) {
    const I = this,
      g = this.json,
      C = this.json.accessors[A]
    if (C.bufferView === void 0 && C.sparse === void 0) {
      const B = VK[C.type],
        o = tp[C.componentType],
        r = C.normalized === !0,
        s = new o(C.count * B)
      return Promise.resolve(new Ye(s, B, r))
    }
    const i = []
    return (
      C.bufferView !== void 0
        ? i.push(this.getDependency("bufferView", C.bufferView))
        : i.push(null),
      C.sparse !== void 0 &&
        (i.push(this.getDependency("bufferView", C.sparse.indices.bufferView)),
        i.push(this.getDependency("bufferView", C.sparse.values.bufferView))),
      Promise.all(i).then(function (B) {
        const o = B[0],
          r = VK[C.type],
          s = tp[C.componentType],
          h = s.BYTES_PER_ELEMENT,
          S = h * r,
          d = C.byteOffset || 0,
          w = C.bufferView !== void 0 ? g.bufferViews[C.bufferView].byteStride : void 0,
          M = C.normalized === !0
        let K, R
        if (w && w !== S) {
          const F = Math.floor(d / w),
            L =
              "InterleavedBuffer:" + C.bufferView + ":" + C.componentType + ":" + F + ":" + C.count
          let Y = I.cache.get(L)
          ;(Y ||
            ((K = new s(o, F * w, (C.count * w) / h)), (Y = new KG(K, w / h)), I.cache.add(L, Y)),
            (R = new FD(Y, r, (d % w) / h, M)))
        } else
          (o === null ? (K = new s(C.count * r)) : (K = new s(o, d, C.count * r)),
            (R = new Ye(K, r, M)))
        if (C.sparse !== void 0) {
          const F = VK.SCALAR,
            L = tp[C.sparse.indices.componentType],
            Y = C.sparse.indices.byteOffset || 0,
            H = C.sparse.values.byteOffset || 0,
            V = new L(B[1], Y, C.sparse.count * F),
            j = new s(B[2], H, C.sparse.count * r)
          o !== null && (R = new Ye(R.array.slice(), R.itemSize, R.normalized))
          for (let P = 0, AA = V.length; P < AA; P++) {
            const X = V[P]
            if (
              (R.setX(X, j[P * r]),
              r >= 2 && R.setY(X, j[P * r + 1]),
              r >= 3 && R.setZ(X, j[P * r + 2]),
              r >= 4 && R.setW(X, j[P * r + 3]),
              r >= 5)
            )
              throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.")
          }
        }
        return R
      })
    )
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   * @param {number} textureIndex
   * @return {Promise<THREE.Texture|null>}
   */
  loadTexture(A) {
    const I = this.json,
      g = this.options,
      i = I.textures[A].source,
      B = I.images[i]
    let o = this.textureLoader
    if (B.uri) {
      const r = g.manager.getHandler(B.uri)
      r !== null && (o = r)
    }
    return this.loadTextureImage(A, i, o)
  }
  loadTextureImage(A, I, g) {
    const C = this,
      i = this.json,
      B = i.textures[A],
      o = i.images[I],
      r = (o.uri || o.bufferView) + ":" + B.sampler
    if (this.textureCache[r]) return this.textureCache[r]
    const s = this.loadImageSource(I, g)
      .then(function (h) {
        ;((h.flipY = !1),
          (h.name = B.name || o.name || ""),
          h.name === "" &&
            typeof o.uri == "string" &&
            o.uri.startsWith("data:image/") === !1 &&
            (h.name = o.uri))
        const d = (i.samplers || {})[B.sampler] || {}
        return (
          (h.magFilter = xT[d.magFilter] || nt),
          (h.minFilter = xT[d.minFilter] || ks),
          (h.wrapS = bT[d.wrapS] || MD),
          (h.wrapT = bT[d.wrapT] || MD),
          C.associations.set(h, { textures: A }),
          h
        )
      })
      .catch(function () {
        return null
      })
    return ((this.textureCache[r] = s), s)
  }
  loadImageSource(A, I) {
    const g = this,
      C = this.json,
      i = this.options
    if (this.sourceCache[A] !== void 0) return this.sourceCache[A].then((S) => S.clone())
    const B = C.images[A],
      o = self.URL || self.webkitURL
    let r = B.uri || "",
      s = !1
    if (B.bufferView !== void 0)
      r = g.getDependency("bufferView", B.bufferView).then(function (S) {
        s = !0
        const d = new Blob([S], { type: B.mimeType })
        return ((r = o.createObjectURL(d)), r)
      })
    else if (B.uri === void 0)
      throw new Error("THREE.GLTFLoader: Image " + A + " is missing URI and bufferView")
    const h = Promise.resolve(r)
      .then(function (S) {
        return new Promise(function (d, w) {
          let M = d
          ;(I.isImageBitmapLoader === !0 &&
            (M = function (K) {
              const R = new pt(K)
              ;((R.needsUpdate = !0), d(R))
            }),
            I.load(wD.resolveURL(S, i.path), M, void 0, w))
        })
      })
      .then(function (S) {
        return (
          s === !0 && o.revokeObjectURL(r),
          $h(S, B),
          (S.userData.mimeType = B.mimeType || XX(B.uri)),
          S
        )
      })
      .catch(function (S) {
        throw (console.error("THREE.GLTFLoader: Couldn't load texture", r), S)
      })
    return ((this.sourceCache[A] = h), h)
  }
  /**
   * Asynchronously assigns a texture to the given material parameters.
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @return {Promise<Texture>}
   */
  assignTexture(A, I, g, C) {
    const i = this
    return this.getDependency("texture", g.index).then(function (B) {
      if (!B) return null
      if (
        (g.texCoord !== void 0 && g.texCoord > 0 && ((B = B.clone()), (B.channel = g.texCoord)),
        i.extensions[ze.KHR_TEXTURE_TRANSFORM])
      ) {
        const o = g.extensions !== void 0 ? g.extensions[ze.KHR_TEXTURE_TRANSFORM] : void 0
        if (o) {
          const r = i.associations.get(B)
          ;((B = i.extensions[ze.KHR_TEXTURE_TRANSFORM].extendTexture(B, o)),
            i.associations.set(B, r))
        }
      }
      return (
        C !== void 0 &&
          (typeof C == "number" && (C = C === HT ? Nf : iu),
          "colorSpace" in B ? (B.colorSpace = C) : (B.encoding = C === Nf ? HT : fX)),
        (A[I] = B),
        B
      )
    })
  }
  /**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   * @param  {Object3D} mesh Mesh, Line, or Points instance.
   */
  assignFinalMaterial(A) {
    const I = A.geometry
    let g = A.material
    const C = I.attributes.tangent === void 0,
      i = I.attributes.color !== void 0,
      B = I.attributes.normal === void 0
    if (A.isPoints) {
      const o = "PointsMaterial:" + g.uuid
      let r = this.cache.get(o)
      ;(r ||
        ((r = new BF()),
        tQ.prototype.copy.call(r, g),
        r.color.copy(g.color),
        (r.map = g.map),
        (r.sizeAttenuation = !1),
        this.cache.add(o, r)),
        (g = r))
    } else if (A.isLine) {
      const o = "LineBasicMaterial:" + g.uuid
      let r = this.cache.get(o)
      ;(r ||
        ((r = new DE()),
        tQ.prototype.copy.call(r, g),
        r.color.copy(g.color),
        (r.map = g.map),
        this.cache.add(o, r)),
        (g = r))
    }
    if (C || i || B) {
      let o = "ClonedMaterial:" + g.uuid + ":"
      ;(C && (o += "derivative-tangents:"),
        i && (o += "vertex-colors:"),
        B && (o += "flat-shading:"))
      let r = this.cache.get(o)
      ;(r ||
        ((r = g.clone()),
        i && (r.vertexColors = !0),
        B && (r.flatShading = !0),
        C &&
          (r.normalScale && (r.normalScale.y *= -1),
          r.clearcoatNormalScale && (r.clearcoatNormalScale.y *= -1)),
        this.cache.add(o, r),
        this.associations.set(r, this.associations.get(g))),
        (g = r))
    }
    A.material = g
  }
  getMaterialType() {
    return qG
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */
  loadMaterial(A) {
    const I = this,
      g = this.json,
      C = this.extensions,
      i = g.materials[A]
    let B
    const o = {},
      r = i.extensions || {},
      s = []
    if (r[ze.KHR_MATERIALS_UNLIT]) {
      const S = C[ze.KHR_MATERIALS_UNLIT]
      ;((B = S.getMaterialType()), s.push(S.extendParams(o, i, I)))
    } else {
      const S = i.pbrMetallicRoughness || {}
      if (((o.color = new Mg(1, 1, 1)), (o.opacity = 1), Array.isArray(S.baseColorFactor))) {
        const d = S.baseColorFactor
        ;(o.color.setRGB(d[0], d[1], d[2], iu), (o.opacity = d[3]))
      }
      ;(S.baseColorTexture !== void 0 && s.push(I.assignTexture(o, "map", S.baseColorTexture, Nf)),
        (o.metalness = S.metallicFactor !== void 0 ? S.metallicFactor : 1),
        (o.roughness = S.roughnessFactor !== void 0 ? S.roughnessFactor : 1),
        S.metallicRoughnessTexture !== void 0 &&
          (s.push(I.assignTexture(o, "metalnessMap", S.metallicRoughnessTexture)),
          s.push(I.assignTexture(o, "roughnessMap", S.metallicRoughnessTexture))),
        (B = this._invokeOne(function (d) {
          return d.getMaterialType && d.getMaterialType(A)
        })),
        s.push(
          Promise.all(
            this._invokeAll(function (d) {
              return d.extendMaterialParams && d.extendMaterialParams(A, o)
            }),
          ),
        ))
    }
    i.doubleSided === !0 && (o.side = rE)
    const h = i.alphaMode || jK.OPAQUE
    if (
      (h === jK.BLEND
        ? ((o.transparent = !0), (o.depthWrite = !1))
        : ((o.transparent = !1),
          h === jK.MASK && (o.alphaTest = i.alphaCutoff !== void 0 ? i.alphaCutoff : 0.5)),
      i.normalTexture !== void 0 &&
        B !== La &&
        (s.push(I.assignTexture(o, "normalMap", i.normalTexture)),
        (o.normalScale = new ZI(1, 1)),
        i.normalTexture.scale !== void 0))
    ) {
      const S = i.normalTexture.scale
      o.normalScale.set(S, S)
    }
    if (
      (i.occlusionTexture !== void 0 &&
        B !== La &&
        (s.push(I.assignTexture(o, "aoMap", i.occlusionTexture)),
        i.occlusionTexture.strength !== void 0 && (o.aoMapIntensity = i.occlusionTexture.strength)),
      i.emissiveFactor !== void 0 && B !== La)
    ) {
      const S = i.emissiveFactor
      o.emissive = new Mg().setRGB(S[0], S[1], S[2], iu)
    }
    return (
      i.emissiveTexture !== void 0 &&
        B !== La &&
        s.push(I.assignTexture(o, "emissiveMap", i.emissiveTexture, Nf)),
      Promise.all(s).then(function () {
        const S = new B(o)
        return (
          i.name && (S.name = i.name),
          $h(S, i),
          I.associations.set(S, { materials: A }),
          i.extensions && uf(C, S, i),
          S
        )
      })
    )
  }
  /** When Object3D instances are targeted by animation, they need unique names. */
  createUniqueName(A) {
    const I = Di.sanitizeNodeName(A || "")
    return I in this.nodeNamesUsed
      ? I + "_" + ++this.nodeNamesUsed[I]
      : ((this.nodeNamesUsed[I] = 0), I)
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */
  loadGeometries(A) {
    const I = this,
      g = this.extensions,
      C = this.primitiveCache
    function i(o) {
      return g[ze.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(o, I).then(function (r) {
        return OT(r, o, I)
      })
    }
    const B = []
    for (let o = 0, r = A.length; o < r; o++) {
      const s = A[o],
        h = zX(s),
        S = C[h]
      if (S) B.push(S.promise)
      else {
        let d
        ;(s.extensions && s.extensions[ze.KHR_DRACO_MESH_COMPRESSION]
          ? (d = i(s))
          : (d = OT(new se(), s, I)),
          (C[h] = { primitive: s, promise: d }),
          B.push(d))
      }
    }
    return Promise.all(B)
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh>}
   */
  loadMesh(A) {
    const I = this,
      g = this.json,
      C = this.extensions,
      i = g.meshes[A],
      B = i.primitives,
      o = []
    for (let r = 0, s = B.length; r < s; r++) {
      const h =
        B[r].material === void 0 ? WX(this.cache) : this.getDependency("material", B[r].material)
      o.push(h)
    }
    return (
      o.push(I.loadGeometries(B)),
      Promise.all(o).then(function (r) {
        const s = r.slice(0, r.length - 1),
          h = r[r.length - 1],
          S = []
        for (let w = 0, M = h.length; w < M; w++) {
          const K = h[w],
            R = B[w]
          let F
          const L = s[w]
          if (
            R.mode === ps.TRIANGLES ||
            R.mode === ps.TRIANGLE_STRIP ||
            R.mode === ps.TRIANGLE_FAN ||
            R.mode === void 0
          )
            ((F = i.isSkinnedMesh === !0 ? new tv(K, L) : new EB(K, L)),
              F.isSkinnedMesh === !0 && F.normalizeSkinWeights(),
              R.mode === ps.TRIANGLE_STRIP
                ? (F.geometry = qT(F.geometry, zm))
                : R.mode === ps.TRIANGLE_FAN && (F.geometry = qT(F.geometry, fN)))
          else if (R.mode === ps.LINES) F = new Ul(K, L)
          else if (R.mode === ps.LINE_STRIP) F = new Qu(K, L)
          else if (R.mode === ps.LINE_LOOP) F = new Qv(K, L)
          else if (R.mode === ps.POINTS) F = new ov(K, L)
          else throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + R.mode)
          ;(Object.keys(F.geometry.morphAttributes).length > 0 && jX(F, i),
            (F.name = I.createUniqueName(i.name || "mesh_" + A)),
            $h(F, i),
            R.extensions && uf(C, F, R),
            I.assignFinalMaterial(F),
            S.push(F))
        }
        for (let w = 0, M = S.length; w < M; w++)
          I.associations.set(S[w], {
            meshes: A,
            primitives: w,
          })
        if (S.length === 1) return (i.extensions && uf(C, S[0], i), S[0])
        const d = new Iu()
        ;(i.extensions && uf(C, d, i), I.associations.set(d, { meshes: A }))
        for (let w = 0, M = S.length; w < M; w++) d.add(S[w])
        return d
      })
    )
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   * @param {number} cameraIndex
   * @return {Promise<THREE.Camera>}
   */
  loadCamera(A) {
    let I
    const g = this.json.cameras[A],
      C = g[g.type]
    if (!C) {
      console.warn("THREE.GLTFLoader: Missing camera parameters.")
      return
    }
    return (
      g.type === "perspective"
        ? (I = new PQ(XN.radToDeg(C.yfov), C.aspectRatio || 1, C.znear || 1, C.zfar || 2e6))
        : g.type === "orthographic" &&
          (I = new yp(-C.xmag, C.xmag, C.ymag, -C.ymag, C.znear, C.zfar)),
      g.name && (I.name = this.createUniqueName(g.name)),
      $h(I, g),
      Promise.resolve(I)
    )
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   * @param {number} skinIndex
   * @return {Promise<Skeleton>}
   */
  loadSkin(A) {
    const I = this.json.skins[A],
      g = []
    for (let C = 0, i = I.joints.length; C < i; C++) g.push(this._loadNodeShallow(I.joints[C]))
    return (
      I.inverseBindMatrices !== void 0
        ? g.push(this.getDependency("accessor", I.inverseBindMatrices))
        : g.push(null),
      Promise.all(g).then(function (C) {
        const i = C.pop(),
          B = C,
          o = [],
          r = []
        for (let s = 0, h = B.length; s < h; s++) {
          const S = B[s]
          if (S) {
            o.push(S)
            const d = new RC()
            ;(i !== null && d.fromArray(i.array, s * 16), r.push(d))
          } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', I.joints[s])
        }
        return new mG(o, r)
      })
    )
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */
  loadAnimation(A) {
    const I = this.json,
      g = this,
      C = I.animations[A],
      i = C.name ? C.name : "animation_" + A,
      B = [],
      o = [],
      r = [],
      s = [],
      h = []
    for (let S = 0, d = C.channels.length; S < d; S++) {
      const w = C.channels[S],
        M = C.samplers[w.sampler],
        K = w.target,
        R = K.node,
        F = C.parameters !== void 0 ? C.parameters[M.input] : M.input,
        L = C.parameters !== void 0 ? C.parameters[M.output] : M.output
      K.node !== void 0 &&
        (B.push(this.getDependency("node", R)),
        o.push(this.getDependency("accessor", F)),
        r.push(this.getDependency("accessor", L)),
        s.push(M),
        h.push(K))
    }
    return Promise.all([
      Promise.all(B),
      Promise.all(o),
      Promise.all(r),
      Promise.all(s),
      Promise.all(h),
    ]).then(function (S) {
      const d = S[0],
        w = S[1],
        M = S[2],
        K = S[3],
        R = S[4],
        F = []
      for (let L = 0, Y = d.length; L < Y; L++) {
        const H = d[L],
          V = w[L],
          j = M[L],
          P = K[L],
          AA = R[L]
        if (H === void 0) continue
        H.updateMatrix && H.updateMatrix()
        const X = g._createAnimationTracks(H, V, j, P, AA)
        if (X) for (let _ = 0; _ < X.length; _++) F.push(X[_])
      }
      return new lp(i, void 0, F)
    })
  }
  createNodeMesh(A) {
    const I = this.json,
      g = this,
      C = I.nodes[A]
    return C.mesh === void 0
      ? null
      : g.getDependency("mesh", C.mesh).then(function (i) {
          const B = g._getNodeRef(g.meshCache, C.mesh, i)
          return (
            C.weights !== void 0 &&
              B.traverse(function (o) {
                if (o.isMesh)
                  for (let r = 0, s = C.weights.length; r < s; r++)
                    o.morphTargetInfluences[r] = C.weights[r]
              }),
            B
          )
        })
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */
  loadNode(A) {
    const I = this.json,
      g = this,
      C = I.nodes[A],
      i = g._loadNodeShallow(A),
      B = [],
      o = C.children || []
    for (let s = 0, h = o.length; s < h; s++) B.push(g.getDependency("node", o[s]))
    const r = C.skin === void 0 ? Promise.resolve(null) : g.getDependency("skin", C.skin)
    return Promise.all([i, Promise.all(B), r]).then(function (s) {
      const h = s[0],
        S = s[1],
        d = s[2]
      d !== null &&
        h.traverse(function (w) {
          w.isSkinnedMesh && w.bind(d, $X)
        })
      for (let w = 0, M = S.length; w < M; w++) h.add(S[w])
      return h
    })
  }
  // ._loadNodeShallow() parses a single node.
  // skin and child nodes are created and added in .loadNode() (no '_' prefix).
  _loadNodeShallow(A) {
    const I = this.json,
      g = this.extensions,
      C = this
    if (this.nodeCache[A] !== void 0) return this.nodeCache[A]
    const i = I.nodes[A],
      B = i.name ? C.createUniqueName(i.name) : "",
      o = [],
      r = C._invokeOne(function (s) {
        return s.createNodeMesh && s.createNodeMesh(A)
      })
    return (
      r && o.push(r),
      i.camera !== void 0 &&
        o.push(
          C.getDependency("camera", i.camera).then(function (s) {
            return C._getNodeRef(C.cameraCache, i.camera, s)
          }),
        ),
      C._invokeAll(function (s) {
        return s.createNodeAttachment && s.createNodeAttachment(A)
      }).forEach(function (s) {
        o.push(s)
      }),
      (this.nodeCache[A] = Promise.all(o).then(function (s) {
        let h
        if (
          (i.isBone === !0
            ? (h = new tF())
            : s.length > 1
              ? (h = new Iu())
              : s.length === 1
                ? (h = s[0])
                : (h = new Ci()),
          h !== s[0])
        )
          for (let S = 0, d = s.length; S < d; S++) h.add(s[S])
        if (
          (i.name && ((h.userData.name = i.name), (h.name = B)),
          $h(h, i),
          i.extensions && uf(g, h, i),
          i.matrix !== void 0)
        ) {
          const S = new RC()
          ;(S.fromArray(i.matrix), h.applyMatrix4(S))
        } else
          (i.translation !== void 0 && h.position.fromArray(i.translation),
            i.rotation !== void 0 && h.quaternion.fromArray(i.rotation),
            i.scale !== void 0 && h.scale.fromArray(i.scale))
        return (
          C.associations.has(h) || C.associations.set(h, {}),
          (C.associations.get(h).nodes = A),
          h
        )
      })),
      this.nodeCache[A]
    )
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */
  loadScene(A) {
    const I = this.extensions,
      g = this.json.scenes[A],
      C = this,
      i = new Iu()
    ;(g.name && (i.name = C.createUniqueName(g.name)), $h(i, g), g.extensions && uf(I, i, g))
    const B = g.nodes || [],
      o = []
    for (let r = 0, s = B.length; r < s; r++) o.push(C.getDependency("node", B[r]))
    return Promise.all(o).then(function (r) {
      for (let h = 0, S = r.length; h < S; h++) i.add(r[h])
      const s = (h) => {
        const S = /* @__PURE__ */ new Map()
        for (const [d, w] of C.associations) (d instanceof tQ || d instanceof pt) && S.set(d, w)
        return (
          h.traverse((d) => {
            const w = C.associations.get(d)
            w != null && S.set(d, w)
          }),
          S
        )
      }
      return ((C.associations = s(i)), i)
    })
  }
  _createAnimationTracks(A, I, g, C, i) {
    const B = [],
      o = A.name ? A.name : A.uuid,
      r = []
    uD[i.path] === uD.weights
      ? A.traverse(function (d) {
          d.morphTargetInfluences && r.push(d.name ? d.name : d.uuid)
        })
      : r.push(o)
    let s
    switch (uD[i.path]) {
      case uD.weights:
        s = qf
        break
      case uD.rotation:
        s = Hf
        break
      case uD.position:
      case uD.scale:
        s = Tf
        break
      default:
        switch (g.itemSize) {
          case 1:
            s = qf
            break
          case 2:
          case 3:
          default:
            s = Tf
            break
        }
        break
    }
    const h = C.interpolation !== void 0 ? PX[C.interpolation] : Ep,
      S = this._getArrayFromAccessor(g)
    for (let d = 0, w = r.length; d < w; d++) {
      const M = new s(r[d] + "." + uD[i.path], I.array, S, h)
      ;(C.interpolation === "CUBICSPLINE" && this._createCubicSplineTrackInterpolant(M), B.push(M))
    }
    return B
  }
  _getArrayFromAccessor(A) {
    let I = A.array
    if (A.normalized) {
      const g = Nm(I.constructor),
        C = new Float32Array(I.length)
      for (let i = 0, B = I.length; i < B; i++) C[i] = I[i] * g
      I = C
    }
    return I
  }
  _createCubicSplineTrackInterpolant(A) {
    ;((A.createInterpolant = function (g) {
      const C = this instanceof Hf ? ZX : oO
      return new C(this.times, this.values, this.getValueSize() / 3, g)
    }),
      (A.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0))
  }
}
function I9(e, A, I) {
  const g = A.attributes,
    C = new Vo()
  if (g.POSITION !== void 0) {
    const o = I.json.accessors[g.POSITION],
      r = o.min,
      s = o.max
    if (r !== void 0 && s !== void 0) {
      if ((C.set(new wA(r[0], r[1], r[2]), new wA(s[0], s[1], s[2])), o.normalized)) {
        const h = Nm(tp[o.componentType])
        ;(C.min.multiplyScalar(h), C.max.multiplyScalar(h))
      }
    } else {
      console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.")
      return
    }
  } else return
  const i = A.targets
  if (i !== void 0) {
    const o = new wA(),
      r = new wA()
    for (let s = 0, h = i.length; s < h; s++) {
      const S = i[s]
      if (S.POSITION !== void 0) {
        const d = I.json.accessors[S.POSITION],
          w = d.min,
          M = d.max
        if (w !== void 0 && M !== void 0) {
          if (
            (r.setX(Math.max(Math.abs(w[0]), Math.abs(M[0]))),
            r.setY(Math.max(Math.abs(w[1]), Math.abs(M[1]))),
            r.setZ(Math.max(Math.abs(w[2]), Math.abs(M[2]))),
            d.normalized)
          ) {
            const K = Nm(tp[d.componentType])
            r.multiplyScalar(K)
          }
          o.max(r)
        } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.")
      }
    }
    C.expandByVector(o)
  }
  e.boundingBox = C
  const B = new jo()
  ;(C.getCenter(B.center), (B.radius = C.min.distanceTo(C.max) / 2), (e.boundingSphere = B))
}
function OT(e, A, I) {
  const g = A.attributes,
    C = []
  function i(B, o) {
    return I.getDependency("accessor", B).then(function (r) {
      e.setAttribute(o, r)
    })
  }
  for (const B in g) {
    const o = Um[B] || B.toLowerCase()
    o in e.attributes || C.push(i(g[B], o))
  }
  if (A.indices !== void 0 && !e.index) {
    const B = I.getDependency("accessor", A.indices).then(function (o) {
      e.setIndex(o)
    })
    C.push(B)
  }
  return (
    $h(e, A),
    I9(e, A, I),
    Promise.all(C).then(function () {
      return A.targets !== void 0 ? VX(e, A.targets, I) : e
    })
  )
}
const XK = /* @__PURE__ */ new WeakMap()
class g9 extends SE {
  constructor(A) {
    ;(super(A),
      (this.decoderPath = ""),
      (this.decoderConfig = {}),
      (this.decoderBinary = null),
      (this.decoderPending = null),
      (this.workerLimit = 4),
      (this.workerPool = []),
      (this.workerNextTaskID = 1),
      (this.workerSourceURL = ""),
      (this.defaultAttributeIDs = {
        position: "POSITION",
        normal: "NORMAL",
        color: "COLOR",
        uv: "TEX_COORD",
      }),
      (this.defaultAttributeTypes = {
        position: "Float32Array",
        normal: "Float32Array",
        color: "Float32Array",
        uv: "Float32Array",
      }))
  }
  setDecoderPath(A) {
    return ((this.decoderPath = A), this)
  }
  setDecoderConfig(A) {
    return ((this.decoderConfig = A), this)
  }
  setWorkerLimit(A) {
    return ((this.workerLimit = A), this)
  }
  load(A, I, g, C) {
    const i = new Yr(this.manager)
    ;(i.setPath(this.path),
      i.setResponseType("arraybuffer"),
      i.setRequestHeader(this.requestHeader),
      i.setWithCredentials(this.withCredentials),
      i.load(
        A,
        (B) => {
          const o = {
            attributeIDs: this.defaultAttributeIDs,
            attributeTypes: this.defaultAttributeTypes,
            useUniqueIDs: !1,
          }
          this.decodeGeometry(B, o).then(I).catch(C)
        },
        g,
        C,
      ))
  }
  /** @deprecated Kept for backward-compatibility with previous DRACOLoader versions. */
  decodeDracoFile(A, I, g, C) {
    const i = {
      attributeIDs: g || this.defaultAttributeIDs,
      attributeTypes: C || this.defaultAttributeTypes,
      useUniqueIDs: !!g,
    }
    this.decodeGeometry(A, i).then(I)
  }
  decodeGeometry(A, I) {
    for (const r in I.attributeTypes) {
      const s = I.attributeTypes[r]
      s.BYTES_PER_ELEMENT !== void 0 && (I.attributeTypes[r] = s.name)
    }
    const g = JSON.stringify(I)
    if (XK.has(A)) {
      const r = XK.get(A)
      if (r.key === g) return r.promise
      if (A.byteLength === 0)
        throw new Error(
          "THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.",
        )
    }
    let C
    const i = this.workerNextTaskID++,
      B = A.byteLength,
      o = this._getWorker(i, B)
        .then(
          (r) => (
            (C = r),
            new Promise((s, h) => {
              ;((C._callbacks[i] = { resolve: s, reject: h }),
                C.postMessage({ type: "decode", id: i, taskConfig: I, buffer: A }, [A]))
            })
          ),
        )
        .then((r) => this._createGeometry(r.geometry))
    return (
      o
        .catch(() => !0)
        .then(() => {
          C && i && this._releaseTask(C, i)
        }),
      XK.set(A, {
        key: g,
        promise: o,
      }),
      o
    )
  }
  _createGeometry(A) {
    const I = new se()
    A.index && I.setIndex(new Ye(A.index.array, 1))
    for (let g = 0; g < A.attributes.length; g++) {
      const C = A.attributes[g],
        i = C.name,
        B = C.array,
        o = C.itemSize
      I.setAttribute(i, new Ye(B, o))
    }
    return I
  }
  _loadLibrary(A, I) {
    const g = new Yr(this.manager)
    return (
      g.setPath(this.decoderPath),
      g.setResponseType(I),
      g.setWithCredentials(this.withCredentials),
      new Promise((C, i) => {
        g.load(A, C, void 0, i)
      })
    )
  }
  preload() {
    return (this._initDecoder(), this)
  }
  _initDecoder() {
    if (this.decoderPending) return this.decoderPending
    const A = typeof WebAssembly != "object" || this.decoderConfig.type === "js",
      I = []
    return (
      A
        ? I.push(this._loadLibrary("draco_decoder.js", "text"))
        : (I.push(this._loadLibrary("draco_wasm_wrapper.js", "text")),
          I.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"))),
      (this.decoderPending = Promise.all(I).then((g) => {
        const C = g[0]
        A || (this.decoderConfig.wasmBinary = g[1])
        const i = C9.toString(),
          B = [
            "/* draco decoder */",
            C,
            "",
            "/* worker */",
            i.substring(i.indexOf("{") + 1, i.lastIndexOf("}")),
          ].join(`
`)
        this.workerSourceURL = URL.createObjectURL(new Blob([B]))
      })),
      this.decoderPending
    )
  }
  _getWorker(A, I) {
    return this._initDecoder().then(() => {
      if (this.workerPool.length < this.workerLimit) {
        const C = new Worker(this.workerSourceURL)
        ;((C._callbacks = {}),
          (C._taskCosts = {}),
          (C._taskLoad = 0),
          C.postMessage({ type: "init", decoderConfig: this.decoderConfig }),
          (C.onmessage = function (i) {
            const B = i.data
            switch (B.type) {
              case "decode":
                C._callbacks[B.id].resolve(B)
                break
              case "error":
                C._callbacks[B.id].reject(B)
                break
              default:
                console.error('THREE.DRACOLoader: Unexpected message, "' + B.type + '"')
            }
          }),
          this.workerPool.push(C))
      } else
        this.workerPool.sort(function (C, i) {
          return C._taskLoad > i._taskLoad ? -1 : 1
        })
      const g = this.workerPool[this.workerPool.length - 1]
      return ((g._taskCosts[A] = I), (g._taskLoad += I), g)
    })
  }
  _releaseTask(A, I) {
    ;((A._taskLoad -= A._taskCosts[I]), delete A._callbacks[I], delete A._taskCosts[I])
  }
  debug() {
    console.log(
      "Task load: ",
      this.workerPool.map((A) => A._taskLoad),
    )
  }
  dispose() {
    for (let A = 0; A < this.workerPool.length; ++A) this.workerPool[A].terminate()
    return ((this.workerPool.length = 0), this)
  }
}
function C9() {
  let e, A
  onmessage = function (B) {
    const o = B.data
    switch (o.type) {
      case "init":
        ;((e = o.decoderConfig),
          (A = new Promise(function (h) {
            ;((e.onModuleLoaded = function (S) {
              h({ draco: S })
            }),
              DracoDecoderModule(e))
          })))
        break
      case "decode":
        const r = o.buffer,
          s = o.taskConfig
        A.then((h) => {
          const S = h.draco,
            d = new S.Decoder(),
            w = new S.DecoderBuffer()
          w.Init(new Int8Array(r), r.byteLength)
          try {
            const M = I(S, d, w, s),
              K = M.attributes.map((R) => R.array.buffer)
            ;(M.index && K.push(M.index.array.buffer),
              self.postMessage({ type: "decode", id: o.id, geometry: M }, K))
          } catch (M) {
            ;(console.error(M), self.postMessage({ type: "error", id: o.id, error: M.message }))
          } finally {
            ;(S.destroy(w), S.destroy(d))
          }
        })
        break
    }
  }
  function I(B, o, r, s) {
    const h = s.attributeIDs,
      S = s.attributeTypes
    let d, w
    const M = o.GetEncodedGeometryType(r)
    if (M === B.TRIANGULAR_MESH) ((d = new B.Mesh()), (w = o.DecodeBufferToMesh(r, d)))
    else if (M === B.POINT_CLOUD) ((d = new B.PointCloud()), (w = o.DecodeBufferToPointCloud(r, d)))
    else throw new Error("THREE.DRACOLoader: Unexpected geometry type.")
    if (!w.ok() || d.ptr === 0)
      throw new Error("THREE.DRACOLoader: Decoding failed: " + w.error_msg())
    const K = { index: null, attributes: [] }
    for (const R in h) {
      const F = self[S[R]]
      let L, Y
      if (s.useUniqueIDs) ((Y = h[R]), (L = o.GetAttributeByUniqueId(d, Y)))
      else {
        if (((Y = o.GetAttributeId(d, B[h[R]])), Y === -1)) continue
        L = o.GetAttribute(d, Y)
      }
      K.attributes.push(C(B, o, d, R, F, L))
    }
    return (M === B.TRIANGULAR_MESH && (K.index = g(B, o, d)), B.destroy(d), K)
  }
  function g(B, o, r) {
    const h = r.num_faces() * 3,
      S = h * 4,
      d = B._malloc(S)
    o.GetTrianglesUInt32Array(r, S, d)
    const w = new Uint32Array(B.HEAPF32.buffer, d, h).slice()
    return (B._free(d), { array: w, itemSize: 1 })
  }
  function C(B, o, r, s, h, S) {
    const d = S.num_components(),
      M = r.num_points() * d,
      K = M * h.BYTES_PER_ELEMENT,
      R = i(B, h),
      F = B._malloc(K)
    o.GetAttributeDataArrayForAllPoints(r, S, R, K, F)
    const L = new h(B.HEAPF32.buffer, F, M).slice()
    return (
      B._free(F),
      {
        name: s,
        array: L,
        itemSize: d,
      }
    )
  }
  function i(B, o) {
    switch (o) {
      case Float32Array:
        return B.DT_FLOAT32
      case Int8Array:
        return B.DT_INT8
      case Int16Array:
        return B.DT_INT16
      case Int32Array:
        return B.DT_INT32
      case Uint8Array:
        return B.DT_UINT8
      case Uint16Array:
        return B.DT_UINT16
      case Uint32Array:
        return B.DT_UINT32
    }
  }
}
let UU
const $K = () => {
  if (UU) return UU
  const e =
      "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",
    A =
      "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",
    I = new Uint8Array([
      0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 3, 2, 0, 0, 5, 3, 1, 0, 1, 12, 1, 0, 10,
      22, 2, 12, 0, 65, 0, 65, 0, 65, 0, 252, 10, 0, 0, 11, 7, 0, 65, 0, 253, 15, 26, 11,
    ]),
    g = new Uint8Array([
      32, 0, 65, 253, 3, 1, 2, 34, 4, 106, 6, 5, 11, 8, 7, 20, 13, 33, 12, 16, 128, 9, 116, 64, 19,
      113, 127, 15, 10, 21, 22, 14, 255, 66, 24, 54, 136, 107, 18, 23, 192, 26, 114, 118, 132, 17,
      77, 101, 130, 144, 27, 87, 131, 44, 45, 74, 156, 154, 70, 167,
    ])
  if (typeof WebAssembly != "object")
    return {
      supported: !1,
    }
  let C = e
  WebAssembly.validate(I) && (C = A)
  let i
  const B = WebAssembly.instantiate(o(C), {}).then((S) => {
    ;((i = S.instance), i.exports.__wasm_call_ctors())
  })
  function o(S) {
    const d = new Uint8Array(S.length)
    for (let M = 0; M < S.length; ++M) {
      const K = S.charCodeAt(M)
      d[M] = K > 96 ? K - 71 : K > 64 ? K - 65 : K > 47 ? K + 4 : K > 46 ? 63 : 62
    }
    let w = 0
    for (let M = 0; M < S.length; ++M) d[w++] = d[M] < 60 ? g[d[M]] : (d[M] - 60) * 64 + d[++M]
    return d.buffer.slice(0, w)
  }
  function r(S, d, w, M, K, R) {
    const F = i.exports.sbrk,
      L = (w + 3) & -4,
      Y = F(L * M),
      H = F(K.length),
      V = new Uint8Array(i.exports.memory.buffer)
    V.set(K, H)
    const j = S(Y, w, M, H, K.length)
    if ((j === 0 && R && R(Y, L, M), d.set(V.subarray(Y, Y + w * M)), F(Y - F(0)), j !== 0))
      throw new Error(`Malformed buffer data: ${j}`)
  }
  const s = {
      // legacy index-based enums for glTF
      0: "",
      1: "meshopt_decodeFilterOct",
      2: "meshopt_decodeFilterQuat",
      3: "meshopt_decodeFilterExp",
      // string-based enums for glTF
      NONE: "",
      OCTAHEDRAL: "meshopt_decodeFilterOct",
      QUATERNION: "meshopt_decodeFilterQuat",
      EXPONENTIAL: "meshopt_decodeFilterExp",
    },
    h = {
      // legacy index-based enums for glTF
      0: "meshopt_decodeVertexBuffer",
      1: "meshopt_decodeIndexBuffer",
      2: "meshopt_decodeIndexSequence",
      // string-based enums for glTF
      ATTRIBUTES: "meshopt_decodeVertexBuffer",
      TRIANGLES: "meshopt_decodeIndexBuffer",
      INDICES: "meshopt_decodeIndexSequence",
    }
  return (
    (UU = {
      ready: B,
      supported: !0,
      decodeVertexBuffer(S, d, w, M, K) {
        r(i.exports.meshopt_decodeVertexBuffer, S, d, w, M, i.exports[s[K]])
      },
      decodeIndexBuffer(S, d, w, M) {
        r(i.exports.meshopt_decodeIndexBuffer, S, d, w, M)
      },
      decodeIndexSequence(S, d, w, M) {
        r(i.exports.meshopt_decodeIndexSequence, S, d, w, M)
      },
      decodeGltfBuffer(S, d, w, M, K, R) {
        r(i.exports[h[K]], S, d, w, M, i.exports[s[R]])
      },
    }),
    UU
  )
}
function e9() {
  var e = /* @__PURE__ */ Object.create(null)
  function A(C, i) {
    var B = C.id,
      o = C.name,
      r = C.dependencies
    r === void 0 && (r = [])
    var s = C.init
    s === void 0 && (s = function () {})
    var h = C.getTransferables
    if ((h === void 0 && (h = null), !e[B]))
      try {
        ;((r = r.map(function (d) {
          return (
            d &&
              d.isWorkerModule &&
              (A(d, function (w) {
                if (w instanceof Error) throw w
              }),
              (d = e[d.id].value)),
            d
          )
        })),
          (s = g("<" + o + ">.init", s)),
          h && (h = g("<" + o + ">.getTransferables", h)))
        var S = null
        ;(typeof s == "function"
          ? (S = s.apply(void 0, r))
          : console.error("worker module init function failed to rehydrate"),
          (e[B] = {
            id: B,
            value: S,
            getTransferables: h,
          }),
          i(S))
      } catch (d) {
        ;((d && d.noLog) || console.error(d), i(d))
      }
  }
  function I(C, i) {
    var B,
      o = C.id,
      r = C.args
    ;(!e[o] || typeof e[o].value != "function") &&
      i(new Error("Worker module " + o + ": not found or its 'init' did not return a function"))
    try {
      var s = (B = e[o]).value.apply(B, r)
      s && typeof s.then == "function"
        ? s.then(h, function (S) {
            return i(S instanceof Error ? S : new Error("" + S))
          })
        : h(s)
    } catch (S) {
      i(S)
    }
    function h(S) {
      try {
        var d = e[o].getTransferables && e[o].getTransferables(S)
        ;((!d || !Array.isArray(d) || !d.length) && (d = void 0), i(S, d))
      } catch (w) {
        ;(console.error(w), i(w))
      }
    }
  }
  function g(C, i) {
    var B = void 0
    self.troikaDefine = function (r) {
      return (B = r)
    }
    var o = URL.createObjectURL(
      new Blob(
        [
          "/** " +
            C.replace(/\*/g, "") +
            ` **/

troikaDefine(
` +
            i +
            `
)`,
        ],
        { type: "application/javascript" },
      ),
    )
    try {
      importScripts(o)
    } catch (r) {
      console.error(r)
    }
    return (URL.revokeObjectURL(o), delete self.troikaDefine, B)
  }
  self.addEventListener("message", function (C) {
    var i = C.data,
      B = i.messageId,
      o = i.action,
      r = i.data
    try {
      ;(o === "registerModule" &&
        A(r, function (s) {
          s instanceof Error
            ? postMessage({
                messageId: B,
                success: !1,
                error: s.message,
              })
            : postMessage({
                messageId: B,
                success: !0,
                result: { isCallable: typeof s == "function" },
              })
        }),
        o === "callModule" &&
          I(r, function (s, h) {
            s instanceof Error
              ? postMessage({
                  messageId: B,
                  success: !1,
                  error: s.message,
                })
              : postMessage(
                  {
                    messageId: B,
                    success: !0,
                    result: s,
                  },
                  h || void 0,
                )
          }))
    } catch (s) {
      postMessage({
        messageId: B,
        success: !1,
        error: s.stack,
      })
    }
  })
}
function i9(e) {
  var A = function () {
    for (var I = [], g = arguments.length; g--; ) I[g] = arguments[g]
    return A._getInitResult().then(function (C) {
      if (typeof C == "function") return C.apply(void 0, I)
      throw new Error(
        "Worker module function was called but `init` did not return a callable function",
      )
    })
  }
  return (
    (A._getInitResult = function () {
      var I = e.dependencies,
        g = e.init
      I = Array.isArray(I)
        ? I.map(function (i) {
            return (
              i && ((i = i.onMainThread || i), i._getInitResult && (i = i._getInitResult())),
              i
            )
          })
        : []
      var C = Promise.all(I).then(function (i) {
        return g.apply(null, i)
      })
      return (
        (A._getInitResult = function () {
          return C
        }),
        C
      )
    }),
    A
  )
}
var nO = function () {
    var e = !1
    if (typeof window < "u" && typeof window.document < "u")
      try {
        var A = new Worker(URL.createObjectURL(new Blob([""], { type: "application/javascript" })))
        ;(A.terminate(), (e = !0))
      } catch (I) {
        ;(typeof process < "u" && process.env.NODE_ENV === "test") ||
          console.log(
            "Troika createWorkerModule: web workers not allowed; falling back to main thread execution. Cause: [" +
              I.message +
              "]",
          )
      }
    return (
      (nO = function () {
        return e
      }),
      e
    )
  },
  t9 = 0,
  B9 = 0,
  Am = !1,
  BG = /* @__PURE__ */ Object.create(null),
  QG = /* @__PURE__ */ Object.create(null),
  Fm = /* @__PURE__ */ Object.create(null)
function Up(e) {
  if ((!e || typeof e.init != "function") && !Am)
    throw new Error("requires `options.init` function")
  var A = e.dependencies,
    I = e.init,
    g = e.getTransferables,
    C = e.workerId,
    i = i9(e)
  C == null && (C = "#default")
  var B = "workerModule" + ++t9,
    o = e.name || B,
    r = null
  A =
    A &&
    A.map(function (h) {
      return (
        typeof h == "function" &&
          !h.workerModuleData &&
          ((Am = !0),
          (h = Up({
            workerId: C,
            name: "<" + o + "> function dependency: " + h.name,
            init:
              `function(){return (
` +
              YU(h) +
              `
)}`,
          })),
          (Am = !1)),
        h && h.workerModuleData && (h = h.workerModuleData),
        h
      )
    })
  function s() {
    for (var h = [], S = arguments.length; S--; ) h[S] = arguments[S]
    if (!nO()) return i.apply(void 0, h)
    if (!r) {
      r = _T(C, "registerModule", s.workerModuleData)
      var d = function () {
        ;((r = null), QG[C].delete(d))
      }
      ;(QG[C] || (QG[C] = /* @__PURE__ */ new Set())).add(d)
    }
    return r.then(function (w) {
      var M = w.isCallable
      if (M) return _T(C, "callModule", { id: B, args: h })
      throw new Error(
        "Worker module function was called but `init` did not return a callable function",
      )
    })
  }
  return (
    (s.workerModuleData = {
      isWorkerModule: !0,
      id: B,
      name: o,
      dependencies: A,
      init: YU(I),
      getTransferables: g && YU(g),
    }),
    (s.onMainThread = i),
    s
  )
}
function Q9(e) {
  ;(QG[e] &&
    QG[e].forEach(function (A) {
      A()
    }),
    BG[e] && (BG[e].terminate(), delete BG[e]))
}
function YU(e) {
  var A = e.toString()
  return (!/^function/.test(A) && /^\w+\s*\(/.test(A) && (A = "function " + A), A)
}
function o9(e) {
  var A = BG[e]
  if (!A) {
    var I = YU(e9)
    ;((A = BG[e] =
      new Worker(
        URL.createObjectURL(
          new Blob(
            [
              "/** Worker Module Bootstrap: " +
                e.replace(/\*/g, "") +
                ` **/

;(` +
                I +
                ")()",
            ],
            { type: "application/javascript" },
          ),
        ),
      )),
      (A.onmessage = function (g) {
        var C = g.data,
          i = C.messageId,
          B = Fm[i]
        if (!B) throw new Error("WorkerModule response with empty or unknown messageId")
        ;(delete Fm[i], B(C))
      }))
  }
  return A
}
function _T(e, A, I) {
  return new Promise(function (g, C) {
    var i = ++B9
    ;((Fm[i] = function (B) {
      B.success ? g(B.result) : C(new Error("Error in worker " + A + " call: " + B.error))
    }),
      o9(e).postMessage({
        messageId: i,
        action: A,
        data: I,
      }))
  })
}
function EO() {
  var e = (function (A) {
    function I(fA, sA, $, EA, GA, DA, dA, kA) {
      var NA = 1 - dA
      ;((kA.x = NA * NA * fA + 2 * NA * dA * $ + dA * dA * GA),
        (kA.y = NA * NA * sA + 2 * NA * dA * EA + dA * dA * DA))
    }
    function g(fA, sA, $, EA, GA, DA, dA, kA, NA, qA) {
      var ZA = 1 - NA
      ;((qA.x =
        ZA * ZA * ZA * fA + 3 * ZA * ZA * NA * $ + 3 * ZA * NA * NA * GA + NA * NA * NA * dA),
        (qA.y =
          ZA * ZA * ZA * sA + 3 * ZA * ZA * NA * EA + 3 * ZA * NA * NA * DA + NA * NA * NA * kA))
    }
    function C(fA, sA) {
      for (var $ = /([MLQCZ])([^MLQCZ]*)/g, EA, GA, DA, dA, kA; (EA = $.exec(fA)); ) {
        var NA = EA[2]
          .replace(/^\s*|\s*$/g, "")
          .split(/[,\s]+/)
          .map(function (qA) {
            return parseFloat(qA)
          })
        switch (EA[1]) {
          case "M":
            ;((dA = GA = NA[0]), (kA = DA = NA[1]))
            break
          case "L":
            ;(NA[0] !== dA || NA[1] !== kA) && sA("L", dA, kA, (dA = NA[0]), (kA = NA[1]))
            break
          case "Q": {
            sA("Q", dA, kA, (dA = NA[2]), (kA = NA[3]), NA[0], NA[1])
            break
          }
          case "C": {
            sA("C", dA, kA, (dA = NA[4]), (kA = NA[5]), NA[0], NA[1], NA[2], NA[3])
            break
          }
          case "Z":
            ;(dA !== GA || kA !== DA) && sA("L", dA, kA, GA, DA)
            break
        }
      }
    }
    function i(fA, sA, $) {
      $ === void 0 && ($ = 16)
      var EA = { x: 0, y: 0 }
      C(fA, function (GA, DA, dA, kA, NA, qA, ZA, sI, cI) {
        switch (GA) {
          case "L":
            sA(DA, dA, kA, NA)
            break
          case "Q": {
            for (var YA = DA, eI = dA, uA = 1; uA < $; uA++)
              (I(DA, dA, qA, ZA, kA, NA, uA / ($ - 1), EA),
                sA(YA, eI, EA.x, EA.y),
                (YA = EA.x),
                (eI = EA.y))
            break
          }
          case "C": {
            for (var hI = DA, II = dA, pI = 1; pI < $; pI++)
              (g(DA, dA, qA, ZA, sI, cI, kA, NA, pI / ($ - 1), EA),
                sA(hI, II, EA.x, EA.y),
                (hI = EA.x),
                (II = EA.y))
            break
          }
        }
      })
    }
    var B =
        "precision highp float;attribute vec2 aUV;varying vec2 vUV;void main(){vUV=aUV;gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}",
      o =
        "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){gl_FragColor=texture2D(tex,vUV);}",
      r = /* @__PURE__ */ new WeakMap(),
      s = {
        premultipliedAlpha: !1,
        preserveDrawingBuffer: !0,
        antialias: !1,
        depth: !1,
      }
    function h(fA, sA) {
      var $ = fA.getContext ? fA.getContext("webgl", s) : fA,
        EA = r.get($)
      if (!EA) {
        let ZA = function (hI) {
            var II = DA[hI]
            if (!II && ((II = DA[hI] = $.getExtension(hI)), !II))
              throw new Error(hI + " not supported")
            return II
          },
          sI = function (hI, II) {
            var pI = $.createShader(II)
            return ($.shaderSource(pI, hI), $.compileShader(pI), pI)
          },
          cI = function (hI, II, pI, AI) {
            if (!dA[hI]) {
              var YI = {},
                SI = {},
                QA = $.createProgram()
              ;($.attachShader(QA, sI(II, $.VERTEX_SHADER)),
                $.attachShader(QA, sI(pI, $.FRAGMENT_SHADER)),
                $.linkProgram(QA),
                (dA[hI] = {
                  program: QA,
                  transaction: function (FA) {
                    ;($.useProgram(QA),
                      FA({
                        setUniform: function (jA, nI) {
                          for (var UI = [], GI = arguments.length - 2; GI-- > 0; )
                            UI[GI] = arguments[GI + 2]
                          var LI = SI[nI] || (SI[nI] = $.getUniformLocation(QA, nI))
                          $["uniform" + jA].apply($, [LI].concat(UI))
                        },
                        setAttribute: function (jA, nI, UI, GI, LI) {
                          var Bg = YI[jA]
                          ;(Bg ||
                            (Bg = YI[jA] =
                              {
                                buf: $.createBuffer(),
                                // TODO should we destroy our buffers?
                                loc: $.getAttribLocation(QA, jA),
                                data: null,
                              }),
                            $.bindBuffer($.ARRAY_BUFFER, Bg.buf),
                            $.vertexAttribPointer(Bg.loc, nI, $.FLOAT, !1, 0, 0),
                            $.enableVertexAttribArray(Bg.loc),
                            GA
                              ? $.vertexAttribDivisor(Bg.loc, GI)
                              : ZA("ANGLE_instanced_arrays").vertexAttribDivisorANGLE(Bg.loc, GI),
                            LI !== Bg.data &&
                              ($.bufferData($.ARRAY_BUFFER, LI, UI), (Bg.data = LI)))
                        },
                      }))
                  },
                }))
            }
            dA[hI].transaction(AI)
          },
          YA = function (hI, II) {
            NA++
            try {
              $.activeTexture($.TEXTURE0 + NA)
              var pI = kA[hI]
              ;(pI ||
                ((pI = kA[hI] = $.createTexture()),
                $.bindTexture($.TEXTURE_2D, pI),
                $.texParameteri($.TEXTURE_2D, $.TEXTURE_MIN_FILTER, $.NEAREST),
                $.texParameteri($.TEXTURE_2D, $.TEXTURE_MAG_FILTER, $.NEAREST)),
                $.bindTexture($.TEXTURE_2D, pI),
                II(pI, NA))
            } finally {
              NA--
            }
          },
          eI = function (hI, II, pI) {
            var AI = $.createFramebuffer()
            ;(qA.push(AI),
              $.bindFramebuffer($.FRAMEBUFFER, AI),
              $.activeTexture($.TEXTURE0 + II),
              $.bindTexture($.TEXTURE_2D, hI),
              $.framebufferTexture2D($.FRAMEBUFFER, $.COLOR_ATTACHMENT0, $.TEXTURE_2D, hI, 0))
            try {
              pI(AI)
            } finally {
              ;($.deleteFramebuffer(AI),
                $.bindFramebuffer($.FRAMEBUFFER, qA[--qA.length - 1] || null))
            }
          },
          uA = function () {
            ;((DA = {}), (dA = {}), (kA = {}), (NA = -1), (qA.length = 0))
          }
        var GA = typeof WebGL2RenderingContext < "u" && $ instanceof WebGL2RenderingContext,
          DA = {},
          dA = {},
          kA = {},
          NA = -1,
          qA = []
        ;($.canvas.addEventListener(
          "webglcontextlost",
          function (hI) {
            ;(uA(), hI.preventDefault())
          },
          !1,
        ),
          r.set(
            $,
            (EA = {
              gl: $,
              isWebGL2: GA,
              getExtension: ZA,
              withProgram: cI,
              withTexture: YA,
              withTextureFramebuffer: eI,
              handleContextLoss: uA,
            }),
          ))
      }
      sA(EA)
    }
    function S(fA, sA, $, EA, GA, DA, dA, kA) {
      ;(dA === void 0 && (dA = 15),
        kA === void 0 && (kA = null),
        h(fA, function (NA) {
          var qA = NA.gl,
            ZA = NA.withProgram,
            sI = NA.withTexture
          sI("copy", function (cI, YA) {
            ;(qA.texImage2D(qA.TEXTURE_2D, 0, qA.RGBA, GA, DA, 0, qA.RGBA, qA.UNSIGNED_BYTE, sA),
              ZA("copy", B, o, function (eI) {
                var uA = eI.setUniform,
                  hI = eI.setAttribute
                ;(hI("aUV", 2, qA.STATIC_DRAW, 0, new Float32Array([0, 0, 2, 0, 0, 2])),
                  uA("1i", "image", YA),
                  qA.bindFramebuffer(qA.FRAMEBUFFER, kA || null),
                  qA.disable(qA.BLEND),
                  qA.colorMask(dA & 8, dA & 4, dA & 2, dA & 1),
                  qA.viewport($, EA, GA, DA),
                  qA.scissor($, EA, GA, DA),
                  qA.drawArrays(qA.TRIANGLES, 0, 3))
              }))
          })
        }))
    }
    function d(fA, sA, $) {
      var EA = fA.width,
        GA = fA.height
      h(fA, function (DA) {
        var dA = DA.gl,
          kA = new Uint8Array(EA * GA * 4)
        ;(dA.readPixels(0, 0, EA, GA, dA.RGBA, dA.UNSIGNED_BYTE, kA),
          (fA.width = sA),
          (fA.height = $),
          S(dA, kA, 0, 0, EA, GA))
      })
    }
    var w = /* @__PURE__ */ Object.freeze({
      __proto__: null,
      withWebGLContext: h,
      renderImageData: S,
      resizeWebGLCanvasWithoutClearing: d,
    })
    function M(fA, sA, $, EA, GA, DA) {
      DA === void 0 && (DA = 1)
      var dA = new Uint8Array(fA * sA),
        kA = EA[2] - EA[0],
        NA = EA[3] - EA[1],
        qA = []
      ;(i($, function (hI, II, pI, AI) {
        qA.push({
          x1: hI,
          y1: II,
          x2: pI,
          y2: AI,
          minX: Math.min(hI, pI),
          minY: Math.min(II, AI),
          maxX: Math.max(hI, pI),
          maxY: Math.max(II, AI),
        })
      }),
        qA.sort(function (hI, II) {
          return hI.maxX - II.maxX
        }))
      for (var ZA = 0; ZA < fA; ZA++)
        for (var sI = 0; sI < sA; sI++) {
          var cI = eI(EA[0] + (kA * (ZA + 0.5)) / fA, EA[1] + (NA * (sI + 0.5)) / sA),
            YA = Math.pow(1 - Math.abs(cI) / GA, DA) / 2
          ;(cI < 0 && (YA = 1 - YA),
            (YA = Math.max(0, Math.min(255, Math.round(YA * 255)))),
            (dA[sI * fA + ZA] = YA))
        }
      return dA
      function eI(hI, II) {
        for (var pI = 1 / 0, AI = 1 / 0, YI = qA.length; YI--; ) {
          var SI = qA[YI]
          if (SI.maxX + AI <= hI) break
          if (hI + AI > SI.minX && II - AI < SI.maxY && II + AI > SI.minY) {
            var QA = F(hI, II, SI.x1, SI.y1, SI.x2, SI.y2)
            QA < pI && ((pI = QA), (AI = Math.sqrt(pI)))
          }
        }
        return (uA(hI, II) && (AI = -AI), AI)
      }
      function uA(hI, II) {
        for (var pI = 0, AI = qA.length; AI--; ) {
          var YI = qA[AI]
          if (YI.maxX <= hI) break
          var SI =
            YI.y1 > II != YI.y2 > II &&
            hI < ((YI.x2 - YI.x1) * (II - YI.y1)) / (YI.y2 - YI.y1) + YI.x1
          SI && (pI += YI.y1 < YI.y2 ? 1 : -1)
        }
        return pI !== 0
      }
    }
    function K(fA, sA, $, EA, GA, DA, dA, kA, NA, qA) {
      ;(DA === void 0 && (DA = 1),
        kA === void 0 && (kA = 0),
        NA === void 0 && (NA = 0),
        qA === void 0 && (qA = 0),
        R(fA, sA, $, EA, GA, DA, dA, null, kA, NA, qA))
    }
    function R(fA, sA, $, EA, GA, DA, dA, kA, NA, qA, ZA) {
      ;(DA === void 0 && (DA = 1),
        NA === void 0 && (NA = 0),
        qA === void 0 && (qA = 0),
        ZA === void 0 && (ZA = 0))
      for (
        var sI = M(fA, sA, $, EA, GA, DA), cI = new Uint8Array(sI.length * 4), YA = 0;
        YA < sI.length;
        YA++
      )
        cI[YA * 4 + ZA] = sI[YA]
      S(dA, cI, NA, qA, fA, sA, 1 << (3 - ZA), kA)
    }
    function F(fA, sA, $, EA, GA, DA) {
      var dA = GA - $,
        kA = DA - EA,
        NA = dA * dA + kA * kA,
        qA = NA ? Math.max(0, Math.min(1, ((fA - $) * dA + (sA - EA) * kA) / NA)) : 0,
        ZA = fA - ($ + qA * dA),
        sI = sA - (EA + qA * kA)
      return ZA * ZA + sI * sI
    }
    var L = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        generate: M,
        generateIntoCanvas: K,
        generateIntoFramebuffer: R,
      }),
      Y =
        "precision highp float;uniform vec4 uGlyphBounds;attribute vec2 aUV;attribute vec4 aLineSegment;varying vec4 vLineSegment;varying vec2 vGlyphXY;void main(){vLineSegment=aLineSegment;vGlyphXY=mix(uGlyphBounds.xy,uGlyphBounds.zw,aUV);gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}",
      H =
        "precision highp float;uniform vec4 uGlyphBounds;uniform float uMaxDistance;uniform float uExponent;varying vec4 vLineSegment;varying vec2 vGlyphXY;float absDistToSegment(vec2 point,vec2 lineA,vec2 lineB){vec2 lineDir=lineB-lineA;float lenSq=dot(lineDir,lineDir);float t=lenSq==0.0 ? 0.0 : clamp(dot(point-lineA,lineDir)/lenSq,0.0,1.0);vec2 linePt=lineA+t*lineDir;return distance(point,linePt);}void main(){vec4 seg=vLineSegment;vec2 p=vGlyphXY;float dist=absDistToSegment(p,seg.xy,seg.zw);float val=pow(1.0-clamp(dist/uMaxDistance,0.0,1.0),uExponent)*0.5;bool crossing=(seg.y>p.y!=seg.w>p.y)&&(p.x<(seg.z-seg.x)*(p.y-seg.y)/(seg.w-seg.y)+seg.x);bool crossingUp=crossing&&vLineSegment.y<vLineSegment.w;gl_FragColor=vec4(crossingUp ? 1.0/255.0 : 0.0,crossing&&!crossingUp ? 1.0/255.0 : 0.0,0.0,val);}",
      V =
        "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){vec4 color=texture2D(tex,vUV);bool inside=color.r!=color.g;float val=inside ? 1.0-color.a : color.a;gl_FragColor=vec4(val);}",
      j = new Float32Array([0, 0, 2, 0, 0, 2]),
      P = null,
      AA = !1,
      X = {},
      _ = /* @__PURE__ */ new WeakMap()
    function eA(fA) {
      if (!AA && !JA(fA)) throw new Error("WebGL generation not supported")
    }
    function CA(fA, sA, $, EA, GA, DA, dA) {
      if ((DA === void 0 && (DA = 1), dA === void 0 && (dA = null), !dA && ((dA = P), !dA))) {
        var kA =
          typeof OffscreenCanvas == "function"
            ? new OffscreenCanvas(1, 1)
            : typeof document < "u"
              ? document.createElement("canvas")
              : null
        if (!kA) throw new Error("OffscreenCanvas or DOM canvas not supported")
        dA = P = kA.getContext("webgl", { depth: !1 })
      }
      eA(dA)
      var NA = new Uint8Array(fA * sA * 4)
      h(dA, function (cI) {
        var YA = cI.gl,
          eI = cI.withTexture,
          uA = cI.withTextureFramebuffer
        eI("readable", function (hI, II) {
          ;(YA.texImage2D(YA.TEXTURE_2D, 0, YA.RGBA, fA, sA, 0, YA.RGBA, YA.UNSIGNED_BYTE, null),
            uA(hI, II, function (pI) {
              ;(lA(
                fA,
                sA,
                $,
                EA,
                GA,
                DA,
                YA,
                pI,
                0,
                0,
                0,
                // red channel
              ),
                YA.readPixels(0, 0, fA, sA, YA.RGBA, YA.UNSIGNED_BYTE, NA))
            }))
        })
      })
      for (var qA = new Uint8Array(fA * sA), ZA = 0, sI = 0; ZA < NA.length; ZA += 4)
        qA[sI++] = NA[ZA]
      return qA
    }
    function aA(fA, sA, $, EA, GA, DA, dA, kA, NA, qA) {
      ;(DA === void 0 && (DA = 1),
        kA === void 0 && (kA = 0),
        NA === void 0 && (NA = 0),
        qA === void 0 && (qA = 0),
        lA(fA, sA, $, EA, GA, DA, dA, null, kA, NA, qA))
    }
    function lA(fA, sA, $, EA, GA, DA, dA, kA, NA, qA, ZA) {
      ;(DA === void 0 && (DA = 1),
        NA === void 0 && (NA = 0),
        qA === void 0 && (qA = 0),
        ZA === void 0 && (ZA = 0),
        eA(dA))
      var sI = []
      ;(i($, function (cI, YA, eI, uA) {
        sI.push(cI, YA, eI, uA)
      }),
        (sI = new Float32Array(sI)),
        h(dA, function (cI) {
          var YA = cI.gl,
            eI = cI.isWebGL2,
            uA = cI.getExtension,
            hI = cI.withProgram,
            II = cI.withTexture,
            pI = cI.withTextureFramebuffer,
            AI = cI.handleContextLoss
          if (
            (II("rawDistances", function (YI, SI) {
              ;((fA !== YI._lastWidth || sA !== YI._lastHeight) &&
                YA.texImage2D(
                  YA.TEXTURE_2D,
                  0,
                  YA.RGBA,
                  (YI._lastWidth = fA),
                  (YI._lastHeight = sA),
                  0,
                  YA.RGBA,
                  YA.UNSIGNED_BYTE,
                  null,
                ),
                hI("main", Y, H, function (QA) {
                  var tA = QA.setAttribute,
                    FA = QA.setUniform,
                    WA = !eI && uA("ANGLE_instanced_arrays"),
                    jA = !eI && uA("EXT_blend_minmax")
                  ;(tA("aUV", 2, YA.STATIC_DRAW, 0, j),
                    tA("aLineSegment", 4, YA.DYNAMIC_DRAW, 1, sI),
                    FA.apply(void 0, ["4f", "uGlyphBounds"].concat(EA)),
                    FA("1f", "uMaxDistance", GA),
                    FA("1f", "uExponent", DA),
                    pI(YI, SI, function (nI) {
                      ;(YA.enable(YA.BLEND),
                        YA.colorMask(!0, !0, !0, !0),
                        YA.viewport(0, 0, fA, sA),
                        YA.scissor(0, 0, fA, sA),
                        YA.blendFunc(YA.ONE, YA.ONE),
                        YA.blendEquationSeparate(YA.FUNC_ADD, eI ? YA.MAX : jA.MAX_EXT),
                        YA.clear(YA.COLOR_BUFFER_BIT),
                        eI
                          ? YA.drawArraysInstanced(YA.TRIANGLES, 0, 3, sI.length / 4)
                          : WA.drawArraysInstancedANGLE(YA.TRIANGLES, 0, 3, sI.length / 4))
                    }))
                }),
                hI("post", B, V, function (QA) {
                  ;(QA.setAttribute("aUV", 2, YA.STATIC_DRAW, 0, j),
                    QA.setUniform("1i", "tex", SI),
                    YA.bindFramebuffer(YA.FRAMEBUFFER, kA),
                    YA.disable(YA.BLEND),
                    YA.colorMask(ZA === 0, ZA === 1, ZA === 2, ZA === 3),
                    YA.viewport(NA, qA, fA, sA),
                    YA.scissor(NA, qA, fA, sA),
                    YA.drawArrays(YA.TRIANGLES, 0, 3))
                }))
            }),
            YA.isContextLost())
          )
            throw (AI(), new Error("webgl context lost"))
        }))
    }
    function JA(fA) {
      var sA = !fA || fA === P ? X : fA.canvas || fA,
        $ = _.get(sA)
      if ($ === void 0) {
        AA = !0
        var EA = null
        try {
          var GA = [97, 106, 97, 61, 99, 137, 118, 80, 80, 118, 137, 99, 61, 97, 106, 97],
            DA = CA(4, 4, "M8,8L16,8L24,24L16,24Z", [0, 0, 32, 32], 24, 1, fA)
          ;(($ =
            DA &&
            GA.length === DA.length &&
            DA.every(function (dA, kA) {
              return dA === GA[kA]
            })),
            $ || ((EA = "bad trial run results"), console.info(GA, DA)))
        } catch (dA) {
          ;(($ = !1), (EA = dA.message))
        }
        ;(EA && console.warn("WebGL SDF generation not supported:", EA), (AA = !1), _.set(sA, $))
      }
      return $
    }
    var yA = /* @__PURE__ */ Object.freeze({
      __proto__: null,
      generate: CA,
      generateIntoCanvas: aA,
      generateIntoFramebuffer: lA,
      isSupported: JA,
    })
    function LA(fA, sA, $, EA, GA, DA) {
      ;(GA === void 0 && (GA = Math.max(EA[2] - EA[0], EA[3] - EA[1]) / 2),
        DA === void 0 && (DA = 1))
      try {
        return CA.apply(yA, arguments)
      } catch (dA) {
        return (
          console.info("WebGL SDF generation failed, falling back to JS", dA),
          M.apply(L, arguments)
        )
      }
    }
    function nA(fA, sA, $, EA, GA, DA, dA, kA, NA, qA) {
      ;(GA === void 0 && (GA = Math.max(EA[2] - EA[0], EA[3] - EA[1]) / 2),
        DA === void 0 && (DA = 1),
        kA === void 0 && (kA = 0),
        NA === void 0 && (NA = 0),
        qA === void 0 && (qA = 0))
      try {
        return aA.apply(yA, arguments)
      } catch (ZA) {
        return (
          console.info("WebGL SDF generation failed, falling back to JS", ZA),
          K.apply(L, arguments)
        )
      }
    }
    return (
      (A.forEachPathCommand = C),
      (A.generate = LA),
      (A.generateIntoCanvas = nA),
      (A.javascript = L),
      (A.pathToLineSegments = i),
      (A.webgl = yA),
      (A.webglUtils = w),
      Object.defineProperty(A, "__esModule", { value: !0 }),
      A
    )
  })({})
  return e
}
function n9() {
  var e = (function (A) {
    var I = {
        R: "13k,1a,2,3,3,2+1j,ch+16,a+1,5+2,2+n,5,a,4,6+16,4+3,h+1b,4mo,179q,2+9,2+11,2i9+7y,2+68,4,3+4,5+13,4+3,2+4k,3+29,8+cf,1t+7z,w+17,3+3m,1t+3z,16o1+5r,8+30,8+mc,29+1r,29+4v,75+73",
        EN: "1c+9,3d+1,6,187+9,513,4+5,7+9,sf+j,175h+9,qw+q,161f+1d,4xt+a,25i+9",
        ES: "17,2,6dp+1,f+1,av,16vr,mx+1,4o,2",
        ET: "z+2,3h+3,b+1,ym,3e+1,2o,p4+1,8,6u,7c,g6,1wc,1n9+4,30+1b,2n,6d,qhx+1,h0m,a+1,49+2,63+1,4+1,6bb+3,12jj",
        AN: "16o+5,2j+9,2+1,35,ed,1ff2+9,87+u",
        CS: "18,2+1,b,2u,12k,55v,l,17v0,2,3,53,2+1,b",
        B: "a,3,f+2,2v,690",
        S: "9,2,k",
        WS: "c,k,4f4,1vk+a,u,1j,335",
        ON: "x+1,4+4,h+5,r+5,r+3,z,5+3,2+1,2+1,5,2+2,3+4,o,w,ci+1,8+d,3+d,6+8,2+g,39+1,9,6+1,2,33,b8,3+1,3c+1,7+1,5r,b,7h+3,sa+5,2,3i+6,jg+3,ur+9,2v,ij+1,9g+9,7+a,8m,4+1,49+x,14u,2+2,c+2,e+2,e+2,e+1,i+n,e+e,2+p,u+2,e+2,36+1,2+3,2+1,b,2+2,6+5,2,2,2,h+1,5+4,6+3,3+f,16+2,5+3l,3+81,1y+p,2+40,q+a,m+13,2r+ch,2+9e,75+hf,3+v,2+2w,6e+5,f+6,75+2a,1a+p,2+2g,d+5x,r+b,6+3,4+o,g,6+1,6+2,2k+1,4,2j,5h+z,1m+1,1e+f,t+2,1f+e,d+3,4o+3,2s+1,w,535+1r,h3l+1i,93+2,2s,b+1,3l+x,2v,4g+3,21+3,kz+1,g5v+1,5a,j+9,n+v,2,3,2+8,2+1,3+2,2,3,46+1,4+4,h+5,r+5,r+a,3h+2,4+6,b+4,78,1r+24,4+c,4,1hb,ey+6,103+j,16j+c,1ux+7,5+g,fsh,jdq+1t,4,57+2e,p1,1m,1m,1m,1m,4kt+1,7j+17,5+2r,d+e,3+e,2+e,2+10,m+4,w,1n+5,1q,4z+5,4b+rb,9+c,4+c,4+37,d+2g,8+b,l+b,5+1j,9+9,7+13,9+t,3+1,27+3c,2+29,2+3q,d+d,3+4,4+2,6+6,a+o,8+6,a+2,e+6,16+42,2+1i",
        BN: "0+8,6+d,2s+5,2+p,e,4m9,1kt+2,2b+5,5+5,17q9+v,7k,6p+8,6+1,119d+3,440+7,96s+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+75,6p+2rz,1ben+1,1ekf+1,1ekf+1",
        NSM: "lc+33,7o+6,7c+18,2,2+1,2+1,2,21+a,1d+k,h,2u+6,3+5,3+1,2+3,10,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,g+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+g,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,k1+w,2db+2,3y,2p+v,ff+3,30+1,n9x+3,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,r2,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+5,3+1,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2d+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,f0c+4,1o+6,t5,1s+3,2a,f5l+1,43t+2,i+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,gzhy+6n",
        AL: "16w,3,2,e+1b,z+2,2+2s,g+1,8+1,b+m,2+t,s+2i,c+e,4h+f,1d+1e,1bwe+dp,3+3z,x+c,2+1,35+3y,2rm+z,5+7,b+5,dt+l,c+u,17nl+27,1t+27,4x+6n,3+d",
        LRO: "6ct",
        RLO: "6cu",
        LRE: "6cq",
        RLE: "6cr",
        PDF: "6cs",
        LRI: "6ee",
        RLI: "6ef",
        FSI: "6eg",
        PDI: "6eh",
      },
      g = {},
      C = {}
    ;((g.L = 1),
      (C[1] = "L"),
      Object.keys(I).forEach(function (AI, YI) {
        ;((g[AI] = 1 << (YI + 1)), (C[g[AI]] = AI))
      }),
      Object.freeze(g))
    var i = g.LRI | g.RLI | g.FSI,
      B = g.L | g.R | g.AL,
      o = g.B | g.S | g.WS | g.ON | g.FSI | g.LRI | g.RLI | g.PDI,
      r = g.BN | g.RLE | g.LRE | g.RLO | g.LRO | g.PDF,
      s = g.S | g.WS | g.B | i | g.PDI | r,
      h = null
    function S() {
      if (!h) {
        h = /* @__PURE__ */ new Map()
        var AI = function (SI) {
          if (I.hasOwnProperty(SI)) {
            var QA = 0
            I[SI].split(",").forEach(function (tA) {
              var FA = tA.split("+"),
                WA = FA[0],
                jA = FA[1]
              ;((WA = parseInt(WA, 36)), (jA = jA ? parseInt(jA, 36) : 0), h.set((QA += WA), g[SI]))
              for (var nI = 0; nI < jA; nI++) h.set(++QA, g[SI])
            })
          }
        }
        for (var YI in I) AI(YI)
      }
    }
    function d(AI) {
      return (S(), h.get(AI.codePointAt(0)) || g.L)
    }
    function w(AI) {
      return C[d(AI)]
    }
    var M = {
      pairs:
        "14>1,1e>2,u>2,2wt>1,1>1,1ge>1,1wp>1,1j>1,f>1,hm>1,1>1,u>1,u6>1,1>1,+5,28>1,w>1,1>1,+3,b8>1,1>1,+3,1>3,-1>-1,3>1,1>1,+2,1s>1,1>1,x>1,th>1,1>1,+2,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,4q>1,1e>2,u>2,2>1,+1",
      canonical:
        "6f1>-6dx,6dy>-6dx,6ec>-6ed,6ee>-6ed,6ww>2jj,-2ji>2jj,14r4>-1e7l,1e7m>-1e7l,1e7m>-1e5c,1e5d>-1e5b,1e5c>-14qx,14qy>-14qx,14vn>-1ecg,1ech>-1ecg,1edu>-1ecg,1eci>-1ecg,1eda>-1ecg,1eci>-1ecg,1eci>-168q,168r>-168q,168s>-14ye,14yf>-14ye",
    }
    function K(AI, YI) {
      var SI = 36,
        QA = 0,
        tA = /* @__PURE__ */ new Map(),
        FA = YI && /* @__PURE__ */ new Map(),
        WA
      return (
        AI.split(",").forEach(function jA(nI) {
          if (nI.indexOf("+") !== -1) for (var UI = +nI; UI--; ) jA(WA)
          else {
            WA = nI
            var GI = nI.split(">"),
              LI = GI[0],
              Bg = GI[1]
            ;((LI = String.fromCodePoint((QA += parseInt(LI, SI)))),
              (Bg = String.fromCodePoint((QA += parseInt(Bg, SI)))),
              tA.set(LI, Bg),
              YI && FA.set(Bg, LI))
          }
        }),
        { map: tA, reverseMap: FA }
      )
    }
    var R, F, L
    function Y() {
      if (!R) {
        var AI = K(M.pairs, !0),
          YI = AI.map,
          SI = AI.reverseMap
        ;((R = YI), (F = SI), (L = K(M.canonical, !1).map))
      }
    }
    function H(AI) {
      return (Y(), R.get(AI) || null)
    }
    function V(AI) {
      return (Y(), F.get(AI) || null)
    }
    function j(AI) {
      return (Y(), L.get(AI) || null)
    }
    var P = g.L,
      AA = g.R,
      X = g.EN,
      _ = g.ES,
      eA = g.ET,
      CA = g.AN,
      aA = g.CS,
      lA = g.B,
      JA = g.S,
      yA = g.ON,
      LA = g.BN,
      nA = g.NSM,
      fA = g.AL,
      sA = g.LRO,
      $ = g.RLO,
      EA = g.LRE,
      GA = g.RLE,
      DA = g.PDF,
      dA = g.LRI,
      kA = g.RLI,
      NA = g.FSI,
      qA = g.PDI
    function ZA(AI, YI) {
      for (var SI = 125, QA = new Uint32Array(AI.length), tA = 0; tA < AI.length; tA++)
        QA[tA] = d(AI[tA])
      var FA = /* @__PURE__ */ new Map()
      function WA(BC, NC) {
        var KC = QA[BC]
        ;((QA[BC] = NC),
          FA.set(KC, FA.get(KC) - 1),
          KC & o && FA.set(o, FA.get(o) - 1),
          FA.set(NC, (FA.get(NC) || 0) + 1),
          NC & o && FA.set(o, (FA.get(o) || 0) + 1))
      }
      for (
        var jA = new Uint8Array(AI.length),
          nI = /* @__PURE__ */ new Map(),
          UI = [],
          GI = null,
          LI = 0;
        LI < AI.length;
        LI++
      )
        (GI ||
          UI.push(
            (GI = {
              start: LI,
              end: AI.length - 1,
              // 3.3.1 P2-P3: Determine the paragraph level
              level: YI === "rtl" ? 1 : YI === "ltr" ? 0 : pg(LI, !1),
            }),
          ),
          QA[LI] & lA && ((GI.end = LI), (GI = null)))
      for (
        var Bg = GA | EA | $ | sA | i | qA | DA | lA,
          MA = function (BC) {
            return BC + (BC & 1 ? 1 : 2)
          },
          OA = function (BC) {
            return BC + (BC & 1 ? 2 : 1)
          },
          aI = 0;
        aI < UI.length;
        aI++
      ) {
        GI = UI[aI]
        var RI = [
            {
              _level: GI.level,
              _override: 0,
              //0=neutral, 1=L, 2=R
              _isolate: 0,
              //bool
            },
          ],
          VA = void 0,
          ag = 0,
          XI = 0,
          $I = 0
        FA.clear()
        for (var SA = GI.start; SA <= GI.end; SA++) {
          var NI = QA[SA]
          if (
            ((VA = RI[RI.length - 1]),
            FA.set(NI, (FA.get(NI) || 0) + 1),
            NI & o && FA.set(o, (FA.get(o) || 0) + 1),
            NI & Bg)
          )
            if (NI & (GA | EA)) {
              jA[SA] = VA._level
              var HA = (NI === GA ? OA : MA)(VA._level)
              HA <= SI && !ag && !XI
                ? RI.push({
                    _level: HA,
                    _override: 0,
                    _isolate: 0,
                  })
                : ag || XI++
            } else if (NI & ($ | sA)) {
              jA[SA] = VA._level
              var iI = (NI === $ ? OA : MA)(VA._level)
              iI <= SI && !ag && !XI
                ? RI.push({
                    _level: iI,
                    _override: NI & $ ? AA : P,
                    _isolate: 0,
                  })
                : ag || XI++
            } else if (NI & i) {
              ;(NI & NA && (NI = pg(SA + 1, !0) === 1 ? kA : dA),
                (jA[SA] = VA._level),
                VA._override && WA(SA, VA._override))
              var zI = (NI === kA ? OA : MA)(VA._level)
              zI <= SI && ag === 0 && XI === 0
                ? ($I++,
                  RI.push({
                    _level: zI,
                    _override: 0,
                    _isolate: 1,
                    _isolInitIndex: SA,
                  }))
                : ag++
            } else if (NI & qA) {
              if (ag > 0) ag--
              else if ($I > 0) {
                for (XI = 0; !RI[RI.length - 1]._isolate; ) RI.pop()
                var qI = RI[RI.length - 1]._isolInitIndex
                ;(qI != null && (nI.set(qI, SA), nI.set(SA, qI)), RI.pop(), $I--)
              }
              ;((VA = RI[RI.length - 1]),
                (jA[SA] = VA._level),
                VA._override && WA(SA, VA._override))
            } else
              NI & DA
                ? (ag === 0 &&
                    (XI > 0
                      ? XI--
                      : !VA._isolate && RI.length > 1 && (RI.pop(), (VA = RI[RI.length - 1]))),
                  (jA[SA] = VA._level))
                : NI & lA && (jA[SA] = GI.level)
          else ((jA[SA] = VA._level), VA._override && NI !== LA && WA(SA, VA._override))
        }
        for (var dg = [], $g = null, Qg = GI.start; Qg <= GI.end; Qg++) {
          var Fg = QA[Qg]
          if (!(Fg & r)) {
            var jC = jA[Qg],
              mC = Fg & i,
              zC = Fg === qA
            $g && jC === $g._level
              ? (($g._end = Qg), ($g._endsWithIsolInit = mC))
              : dg.push(
                  ($g = {
                    _start: Qg,
                    _end: Qg,
                    _level: jC,
                    _startsWithPDI: zC,
                    _endsWithIsolInit: mC,
                  }),
                )
          }
        }
        for (var Ee = [], ei = 0; ei < dg.length; ei++) {
          var fe = dg[ei]
          if (!fe._startsWithPDI || (fe._startsWithPDI && !nI.has(fe._start))) {
            for (
              var Ei = [($g = fe)], vi = void 0;
              $g && $g._endsWithIsolInit && (vi = nI.get($g._end)) != null;
            )
              for (var Li = ei + 1; Li < dg.length; Li++)
                if (dg[Li]._start === vi) {
                  Ei.push(($g = dg[Li]))
                  break
                }
            for (var mA = [], TI = 0; TI < Ei.length; TI++)
              for (var eg = Ei[TI], Tg = eg._start; Tg <= eg._end; Tg++) mA.push(Tg)
            for (var OC = jA[mA[0]], JC = GI.level, jg = mA[0] - 1; jg >= 0; jg--)
              if (!(QA[jg] & r)) {
                JC = jA[jg]
                break
              }
            var rA = mA[mA.length - 1],
              _A = jA[rA],
              oI = GI.level
            if (!(QA[rA] & i)) {
              for (var QI = rA + 1; QI <= GI.end; QI++)
                if (!(QA[QI] & r)) {
                  oI = jA[QI]
                  break
                }
            }
            Ee.push({
              _seqIndices: mA,
              _sosType: Math.max(JC, OC) % 2 ? AA : P,
              _eosType: Math.max(oI, _A) % 2 ? AA : P,
            })
          }
        }
        for (var PA = 0; PA < Ee.length; PA++) {
          var gg = Ee[PA],
            EI = gg._seqIndices,
            hg = gg._sosType,
            yg = gg._eosType,
            rg = jA[EI[0]] & 1 ? AA : P
          if (FA.get(nA))
            for (var eC = 0; eC < EI.length; eC++) {
              var Rg = EI[eC]
              if (QA[Rg] & nA) {
                for (var pC = hg, wC = eC - 1; wC >= 0; wC--)
                  if (!(QA[EI[wC]] & r)) {
                    pC = QA[EI[wC]]
                    break
                  }
                WA(Rg, pC & (i | qA) ? yA : pC)
              }
            }
          if (FA.get(X))
            for (var mg = 0; mg < EI.length; mg++) {
              var UC = EI[mg]
              if (QA[UC] & X)
                for (var iC = mg - 1; iC >= -1; iC--) {
                  var Gg = iC === -1 ? hg : QA[EI[iC]]
                  if (Gg & B) {
                    Gg === fA && WA(UC, CA)
                    break
                  }
                }
            }
          if (FA.get(fA))
            for (var _C = 0; _C < EI.length; _C++) {
              var vC = EI[_C]
              QA[vC] & fA && WA(vC, AA)
            }
          if (FA.get(_) || FA.get(aA))
            for (var ii = 1; ii < EI.length - 1; ii++) {
              var qe = EI[ii]
              if (QA[qe] & (_ | aA)) {
                for (
                  var pe = 0, Mi = 0, ae = ii - 1;
                  ae >= 0 && ((pe = QA[EI[ae]]), !!(pe & r));
                  ae--
                );
                for (var ai = ii + 1; ai < EI.length && ((Mi = QA[EI[ai]]), !!(Mi & r)); ai++);
                pe === Mi && (QA[qe] === _ ? pe === X : pe & (X | CA)) && WA(qe, pe)
              }
            }
          if (FA.get(X))
            for (var fi = 0; fi < EI.length; fi++) {
              var He = EI[fi]
              if (QA[He] & X) {
                for (var Et = fi - 1; Et >= 0 && QA[EI[Et]] & (eA | r); Et--) WA(EI[Et], X)
                for (fi++; fi < EI.length && QA[EI[fi]] & (eA | r | X); fi++)
                  QA[EI[fi]] !== X && WA(EI[fi], X)
              }
            }
          if (FA.get(eA) || FA.get(_) || FA.get(aA))
            for (var Yi = 0; Yi < EI.length; Yi++) {
              var vn = EI[Yi]
              if (QA[vn] & (eA | _ | aA)) {
                WA(vn, yA)
                for (var aB = Yi - 1; aB >= 0 && QA[EI[aB]] & r; aB--) WA(EI[aB], yA)
                for (var XC = Yi + 1; XC < EI.length && QA[EI[XC]] & r; XC++) WA(EI[XC], yA)
              }
            }
          if (FA.get(X))
            for (var dB = 0, zQ = hg; dB < EI.length; dB++) {
              var Wt = EI[dB],
                ZC = QA[Wt]
              ZC & X ? zQ === P && WA(Wt, P) : ZC & B && (zQ = ZC)
            }
          if (FA.get(o)) {
            var Ui = AA | X | CA,
              $o = Ui | P,
              oC = []
            {
              for (var RQ = [], Te = 0; Te < EI.length; Te++)
                if (QA[EI[Te]] & o) {
                  var hC = AI[EI[Te]],
                    Vt = void 0
                  if (H(hC) !== null)
                    if (RQ.length < 63) RQ.push({ char: hC, seqIndex: Te })
                    else break
                  else if ((Vt = V(hC)) !== null)
                    for (var wt = RQ.length - 1; wt >= 0; wt--) {
                      var di = RQ[wt].char
                      if (di === Vt || di === V(j(hC)) || H(j(di)) === hC) {
                        ;(oC.push([RQ[wt].seqIndex, Te]), (RQ.length = wt))
                        break
                      }
                    }
                }
              oC.sort(function (BC, NC) {
                return BC[0] - NC[0]
              })
            }
            for (var Me = 0; Me < oC.length; Me++) {
              for (
                var Ha = oC[Me], ee = Ha[0], Zi = Ha[1], XQ = !1, rB = 0, $Q = ee + 1;
                $Q < Zi;
                $Q++
              ) {
                var JQ = EI[$Q]
                if (QA[JQ] & $o) {
                  XQ = !0
                  var HB = QA[JQ] & Ui ? AA : P
                  if (HB === rg) {
                    rB = HB
                    break
                  }
                }
              }
              if (XQ && !rB) {
                rB = hg
                for (var TB = ee - 1; TB >= 0; TB--) {
                  var An = EI[TB]
                  if (QA[An] & $o) {
                    var Gt = QA[An] & Ui ? AA : P
                    Gt !== rg ? (rB = Gt) : (rB = rg)
                    break
                  }
                }
              }
              if (rB) {
                if (((QA[EI[ee]] = QA[EI[Zi]] = rB), rB !== rg)) {
                  for (var Ni = ee + 1; Ni < EI.length; Ni++)
                    if (!(QA[EI[Ni]] & r)) {
                      d(AI[EI[Ni]]) & nA && (QA[EI[Ni]] = rB)
                      break
                    }
                }
                if (rB !== rg) {
                  for (var QQ = Zi + 1; QQ < EI.length; QQ++)
                    if (!(QA[EI[QQ]] & r)) {
                      d(AI[EI[QQ]]) & nA && (QA[EI[QQ]] = rB)
                      break
                    }
                }
              }
            }
            for (var jt = 0; jt < EI.length; jt++)
              if (QA[EI[jt]] & o) {
                for (var Ao = jt, In = jt, zt = hg, gn = jt - 1; gn >= 0; gn--)
                  if (QA[EI[gn]] & r) Ao = gn
                  else {
                    zt = QA[EI[gn]] & Ui ? AA : P
                    break
                  }
                for (var yB = yg, iA = jt + 1; iA < EI.length; iA++)
                  if (QA[EI[iA]] & (o | r)) In = iA
                  else {
                    yB = QA[EI[iA]] & Ui ? AA : P
                    break
                  }
                for (var vA = Ao; vA <= In; vA++) QA[EI[vA]] = zt === yB ? zt : rg
                jt = In
              }
          }
        }
        for (var rI = GI.start; rI <= GI.end; rI++) {
          var mI = jA[rI],
            ig = QA[rI]
          if (
            (mI & 1
              ? ig & (P | X | CA) && jA[rI]++
              : ig & AA
                ? jA[rI]++
                : ig & (CA | X) && (jA[rI] += 2),
            ig & r && (jA[rI] = rI === 0 ? GI.level : jA[rI - 1]),
            rI === GI.end || d(AI[rI]) & (JA | lA))
          )
            for (var AC = rI; AC >= 0 && d(AI[AC]) & s; AC--) jA[AC] = GI.level
        }
      }
      return {
        levels: jA,
        paragraphs: UI,
      }
      function pg(BC, NC) {
        for (var KC = BC; KC < AI.length; KC++) {
          var GC = QA[KC]
          if (GC & (AA | fA)) return 1
          if (GC & (lA | P) || (NC && GC === qA)) return 0
          if (GC & i) {
            var ie = tC(KC)
            KC = ie === -1 ? AI.length : ie
          }
        }
        return 0
      }
      function tC(BC) {
        for (var NC = 1, KC = BC + 1; KC < AI.length; KC++) {
          var GC = QA[KC]
          if (GC & lA) break
          if (GC & qA) {
            if (--NC === 0) return KC
          } else GC & i && NC++
        }
        return -1
      }
    }
    var sI =
        "14>1,j>2,t>2,u>2,1a>g,2v3>1,1>1,1ge>1,1wd>1,b>1,1j>1,f>1,ai>3,-2>3,+1,8>1k0,-1jq>1y7,-1y6>1hf,-1he>1h6,-1h5>1ha,-1h8>1qi,-1pu>1,6>3u,-3s>7,6>1,1>1,f>1,1>1,+2,3>1,1>1,+13,4>1,1>1,6>1eo,-1ee>1,3>1mg,-1me>1mk,-1mj>1mi,-1mg>1mi,-1md>1,1>1,+2,1>10k,-103>1,1>1,4>1,5>1,1>1,+10,3>1,1>8,-7>8,+1,-6>7,+1,a>1,1>1,u>1,u6>1,1>1,+5,26>1,1>1,2>1,2>2,8>1,7>1,4>1,1>1,+5,b8>1,1>1,+3,1>3,-2>1,2>1,1>1,+2,c>1,3>1,1>1,+2,h>1,3>1,a>1,1>1,2>1,3>1,1>1,d>1,f>1,3>1,1a>1,1>1,6>1,7>1,13>1,k>1,1>1,+19,4>1,1>1,+2,2>1,1>1,+18,m>1,a>1,1>1,lk>1,1>1,4>1,2>1,f>1,3>1,1>1,+3,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,6>1,4j>1,j>2,t>2,u>2,2>1,+1",
      cI
    function YA() {
      if (!cI) {
        var AI = K(sI, !0),
          YI = AI.map,
          SI = AI.reverseMap
        ;(SI.forEach(function (QA, tA) {
          YI.set(tA, QA)
        }),
          (cI = YI))
      }
    }
    function eI(AI) {
      return (YA(), cI.get(AI) || null)
    }
    function uA(AI, YI, SI, QA) {
      var tA = AI.length
      ;((SI = Math.max(0, SI == null ? 0 : +SI)),
        (QA = Math.min(tA - 1, QA == null ? tA - 1 : +QA)))
      for (var FA = /* @__PURE__ */ new Map(), WA = SI; WA <= QA; WA++)
        if (YI[WA] & 1) {
          var jA = eI(AI[WA])
          jA !== null && FA.set(WA, jA)
        }
      return FA
    }
    function hI(AI, YI, SI, QA) {
      var tA = AI.length
      ;((SI = Math.max(0, SI == null ? 0 : +SI)),
        (QA = Math.min(tA - 1, QA == null ? tA - 1 : +QA)))
      var FA = []
      return (
        YI.paragraphs.forEach(function (WA) {
          var jA = Math.max(SI, WA.start),
            nI = Math.min(QA, WA.end)
          if (jA < nI) {
            for (var UI = YI.levels.slice(jA, nI + 1), GI = nI; GI >= jA && d(AI[GI]) & s; GI--)
              UI[GI] = WA.level
            for (var LI = WA.level, Bg = 1 / 0, MA = 0; MA < UI.length; MA++) {
              var OA = UI[MA]
              ;(OA > LI && (LI = OA), OA < Bg && (Bg = OA | 1))
            }
            for (var aI = LI; aI >= Bg; aI--)
              for (var RI = 0; RI < UI.length; RI++)
                if (UI[RI] >= aI) {
                  for (var VA = RI; RI + 1 < UI.length && UI[RI + 1] >= aI; ) RI++
                  RI > VA && FA.push([VA + jA, RI + jA])
                }
          }
        }),
        FA
      )
    }
    function II(AI, YI, SI, QA) {
      var tA = pI(AI, YI, SI, QA),
        FA = [].concat(AI)
      return (
        tA.forEach(function (WA, jA) {
          FA[jA] = (YI.levels[WA] & 1 ? eI(AI[WA]) : null) || AI[WA]
        }),
        FA.join("")
      )
    }
    function pI(AI, YI, SI, QA) {
      for (var tA = hI(AI, YI, SI, QA), FA = [], WA = 0; WA < AI.length; WA++) FA[WA] = WA
      return (
        tA.forEach(function (jA) {
          for (var nI = jA[0], UI = jA[1], GI = FA.slice(nI, UI + 1), LI = GI.length; LI--; )
            FA[UI - LI] = GI[LI]
        }),
        FA
      )
    }
    return (
      (A.closingToOpeningBracket = V),
      (A.getBidiCharType = d),
      (A.getBidiCharTypeName = w),
      (A.getCanonicalBracket = j),
      (A.getEmbeddingLevels = ZA),
      (A.getMirroredCharacter = eI),
      (A.getMirroredCharactersMap = uA),
      (A.getReorderSegments = hI),
      (A.getReorderedIndices = pI),
      (A.getReorderedString = II),
      (A.openingToClosingBracket = H),
      Object.defineProperty(A, "__esModule", { value: !0 }),
      A
    )
  })({})
  return e
}
const aO = /\bvoid\s+main\s*\(\s*\)\s*{/g
function Rm(e) {
  const A = /^[ \t]*#include +<([\w\d./]+)>/gm
  function I(g, C) {
    let i = ne[C]
    return i ? Rm(i) : g
  }
  return e.replace(A, I)
}
const Kn = []
for (let e = 0; e < 256; e++) Kn[e] = (e < 16 ? "0" : "") + e.toString(16)
function E9() {
  const e = (Math.random() * 4294967295) | 0,
    A = (Math.random() * 4294967295) | 0,
    I = (Math.random() * 4294967295) | 0,
    g = (Math.random() * 4294967295) | 0
  return (
    Kn[e & 255] +
    Kn[(e >> 8) & 255] +
    Kn[(e >> 16) & 255] +
    Kn[(e >> 24) & 255] +
    "-" +
    Kn[A & 255] +
    Kn[(A >> 8) & 255] +
    "-" +
    Kn[((A >> 16) & 15) | 64] +
    Kn[(A >> 24) & 255] +
    "-" +
    Kn[(I & 63) | 128] +
    Kn[(I >> 8) & 255] +
    "-" +
    Kn[(I >> 16) & 255] +
    Kn[(I >> 24) & 255] +
    Kn[g & 255] +
    Kn[(g >> 8) & 255] +
    Kn[(g >> 16) & 255] +
    Kn[(g >> 24) & 255]
  ).toUpperCase()
}
const Df =
    Object.assign ||
    function () {
      let e = arguments[0]
      for (let A = 1, I = arguments.length; A < I; A++) {
        let g = arguments[A]
        if (g) for (let C in g) Object.prototype.hasOwnProperty.call(g, C) && (e[C] = g[C])
      }
      return e
    },
  a9 = Date.now(),
  ZT = /* @__PURE__ */ new WeakMap(),
  PT = /* @__PURE__ */ new Map()
let r9 = 1e10
function Jm(e, A) {
  const I = h9(A)
  let g = ZT.get(e)
  if ((g || ZT.set(e, (g = /* @__PURE__ */ Object.create(null))), g[I])) return new g[I]()
  const C = `_onBeforeCompile${I}`,
    i = function (s, h) {
      e.onBeforeCompile.call(this, s, h)
      const S = this.customProgramCacheKey() + "|" + s.vertexShader + "|" + s.fragmentShader
      let d = PT[S]
      if (!d) {
        const w = s9(this, s, A, I)
        d = PT[S] = w
      }
      ;((s.vertexShader = d.vertexShader),
        (s.fragmentShader = d.fragmentShader),
        Df(s.uniforms, this.uniforms),
        A.timeUniform &&
          (s.uniforms[A.timeUniform] = {
            get value() {
              return Date.now() - a9
            },
          }),
        this[C] && this[C](s))
    },
    B = function () {
      return o(A.chained ? e : e.clone())
    },
    o = function (s) {
      const h = Object.create(s, r)
      return (
        Object.defineProperty(h, "baseMaterial", { value: e }),
        Object.defineProperty(h, "id", { value: r9++ }),
        (h.uuid = E9()),
        (h.uniforms = Df({}, s.uniforms, A.uniforms)),
        (h.defines = Df({}, s.defines, A.defines)),
        (h.defines[`TROIKA_DERIVED_MATERIAL_${I}`] = ""),
        (h.extensions = Df({}, s.extensions, A.extensions)),
        (h._listeners = void 0),
        h
      )
    },
    r = {
      constructor: { value: B },
      isDerivedMaterial: { value: !0 },
      type: {
        get: () => e.type,
        set: (s) => {
          e.type = s
        },
      },
      isDerivedFrom: {
        writable: !0,
        configurable: !0,
        value: function (s) {
          const h = this.baseMaterial
          return s === h || (h.isDerivedMaterial && h.isDerivedFrom(s)) || !1
        },
      },
      customProgramCacheKey: {
        writable: !0,
        configurable: !0,
        value: function () {
          return e.customProgramCacheKey() + "|" + I
        },
      },
      onBeforeCompile: {
        get() {
          return i
        },
        set(s) {
          this[C] = s
        },
      },
      copy: {
        writable: !0,
        configurable: !0,
        value: function (s) {
          return (
            e.copy.call(this, s),
            !e.isShaderMaterial &&
              !e.isDerivedMaterial &&
              (Df(this.extensions, s.extensions),
              Df(this.defines, s.defines),
              Df(this.uniforms, AF.clone(s.uniforms))),
            this
          )
        },
      },
      clone: {
        writable: !0,
        configurable: !0,
        value: function () {
          const s = new e.constructor()
          return o(s).copy(this)
        },
      },
      /**
       * Utility to get a MeshDepthMaterial that will honor this derived material's vertex
       * transformations and discarded fragments.
       */
      getDepthMaterial: {
        writable: !0,
        configurable: !0,
        value: function () {
          let s = this._depthMaterial
          return (
            s ||
              ((s = this._depthMaterial =
                Jm(e.isDerivedMaterial ? e.getDepthMaterial() : new gF({ depthPacking: Xm }), A)),
              (s.defines.IS_DEPTH_MATERIAL = ""),
              (s.uniforms = this.uniforms)),
            s
          )
        },
      },
      /**
       * Utility to get a MeshDistanceMaterial that will honor this derived material's vertex
       * transformations and discarded fragments.
       */
      getDistanceMaterial: {
        writable: !0,
        configurable: !0,
        value: function () {
          let s = this._distanceMaterial
          return (
            s ||
              ((s = this._distanceMaterial =
                Jm(e.isDerivedMaterial ? e.getDistanceMaterial() : new CF(), A)),
              (s.defines.IS_DISTANCE_MATERIAL = ""),
              (s.uniforms = this.uniforms)),
            s
          )
        },
      },
      dispose: {
        writable: !0,
        configurable: !0,
        value() {
          const { _depthMaterial: s, _distanceMaterial: h } = this
          ;(s && s.dispose(), h && h.dispose(), e.dispose.call(this))
        },
      },
    }
  return ((g[I] = B), new B())
}
function s9(e, { vertexShader: A, fragmentShader: I }, g, C) {
  let {
    vertexDefs: i,
    vertexMainIntro: B,
    vertexMainOutro: o,
    vertexTransform: r,
    fragmentDefs: s,
    fragmentMainIntro: h,
    fragmentMainOutro: S,
    fragmentColorTransform: d,
    customRewriter: w,
    timeUniform: M,
  } = g
  if (
    ((i = i || ""),
    (B = B || ""),
    (o = o || ""),
    (s = s || ""),
    (h = h || ""),
    (S = S || ""),
    (r || w) && (A = Rm(A)),
    (d || w) &&
      ((I = I.replace(
        /^[ \t]*#include <((?:tonemapping|encodings|colorspace|fog|premultiplied_alpha|dithering)_fragment)>/gm,
        `
//!BEGIN_POST_CHUNK $1
$&
//!END_POST_CHUNK
`,
      )),
      (I = Rm(I))),
    w)
  ) {
    let K = w({ vertexShader: A, fragmentShader: I })
    ;((A = K.vertexShader), (I = K.fragmentShader))
  }
  if (d) {
    let K = []
    ;((I = I.replace(
      /^\/\/!BEGIN_POST_CHUNK[^]+?^\/\/!END_POST_CHUNK/gm,
      // [^]+? = non-greedy match of any chars including newlines
      (R) => (K.push(R), ""),
    )),
      (S = `${d}
${K.join(`
`)}
${S}`))
  }
  if (M) {
    const K = `
uniform float ${M};
`
    ;((i = K + i), (s = K + s))
  }
  return (
    r &&
      ((A = `vec3 troika_position_${C};
vec3 troika_normal_${C};
vec2 troika_uv_${C};
${A}
`),
      (i = `${i}
void troikaVertexTransform${C}(inout vec3 position, inout vec3 normal, inout vec2 uv) {
  ${r}
}
`),
      (B = `
troika_position_${C} = vec3(position);
troika_normal_${C} = vec3(normal);
troika_uv_${C} = vec2(uv);
troikaVertexTransform${C}(troika_position_${C}, troika_normal_${C}, troika_uv_${C});
${B}
`),
      (A = A.replace(/\b(position|normal|uv)\b/g, (K, R, F, L) =>
        /\battribute\s+vec[23]\s+$/.test(L.substr(0, F)) ? R : `troika_${R}_${C}`,
      )),
      (e.map && e.map.channel > 0) || (A = A.replace(/\bMAP_UV\b/g, `troika_uv_${C}`))),
    (A = WT(A, C, i, B, o)),
    (I = WT(I, C, s, h, S)),
    {
      vertexShader: A,
      fragmentShader: I,
    }
  )
}
function WT(e, A, I, g, C) {
  return (
    (g || C || I) &&
      ((e = e.replace(
        aO,
        `
${I}
void troikaOrigMain${A}() {`,
      )),
      (e += `
void main() {
  ${g}
  troikaOrigMain${A}();
  ${C}
}`)),
    e
  )
}
function l9(e, A) {
  return e === "uniforms" ? void 0 : typeof A == "function" ? A.toString() : A
}
let c9 = 0
const VT = /* @__PURE__ */ new Map()
function h9(e) {
  const A = JSON.stringify(e, l9)
  let I = VT.get(A)
  return (I == null && VT.set(A, (I = ++c9)), I)
}
/*!
Custom build of Typr.ts (https://github.com/fredli74/Typr.ts) for use in Troika text rendering.
Original MIT license applies: https://github.com/fredli74/Typr.ts/blob/master/LICENSE
*/
function u9() {
  return (
    typeof window > "u" && (self.window = self),
    (function (e) {
      var A = {
        parse: function (C) {
          var i = A._bin,
            B = new Uint8Array(C)
          if (i.readASCII(B, 0, 4) == "ttcf") {
            var o = 4
            ;(i.readUshort(B, o), (o += 2), i.readUshort(B, o), (o += 2))
            var r = i.readUint(B, o)
            o += 4
            for (var s = [], h = 0; h < r; h++) {
              var S = i.readUint(B, o)
              ;((o += 4), s.push(A._readFont(B, S)))
            }
            return s
          }
          return [A._readFont(B, 0)]
        },
        _readFont: function (C, i) {
          var B = A._bin,
            o = i
          ;(B.readFixed(C, i), (i += 4))
          var r = B.readUshort(C, i)
          ;((i += 2),
            B.readUshort(C, i),
            (i += 2),
            B.readUshort(C, i),
            (i += 2),
            B.readUshort(C, i),
            (i += 2))
          for (
            var s = [
                "cmap",
                "head",
                "hhea",
                "maxp",
                "hmtx",
                "name",
                "OS/2",
                "post",
                "loca",
                "glyf",
                "kern",
                "CFF ",
                "GDEF",
                "GPOS",
                "GSUB",
                "SVG ",
              ],
              h = { _data: C, _offset: o },
              S = {},
              d = 0;
            d < r;
            d++
          ) {
            var w = B.readASCII(C, i, 4)
            ;((i += 4), B.readUint(C, i), (i += 4))
            var M = B.readUint(C, i)
            i += 4
            var K = B.readUint(C, i)
            ;((i += 4), (S[w] = { offset: M, length: K }))
          }
          for (d = 0; d < s.length; d++) {
            var R = s[d]
            S[R] && (h[R.trim()] = A[R.trim()].parse(C, S[R].offset, S[R].length, h))
          }
          return h
        },
        _tabOffset: function (C, i, B) {
          for (var o = A._bin, r = o.readUshort(C, B + 4), s = B + 12, h = 0; h < r; h++) {
            var S = o.readASCII(C, s, 4)
            ;((s += 4), o.readUint(C, s), (s += 4))
            var d = o.readUint(C, s)
            if (((s += 4), o.readUint(C, s), (s += 4), S == i)) return d
          }
          return 0
        },
      }
      ;((A._bin = {
        readFixed: function (C, i) {
          return ((C[i] << 8) | C[i + 1]) + ((C[i + 2] << 8) | C[i + 3]) / 65540
        },
        readF2dot14: function (C, i) {
          return A._bin.readShort(C, i) / 16384
        },
        readInt: function (C, i) {
          return A._bin._view(C).getInt32(i)
        },
        readInt8: function (C, i) {
          return A._bin._view(C).getInt8(i)
        },
        readShort: function (C, i) {
          return A._bin._view(C).getInt16(i)
        },
        readUshort: function (C, i) {
          return A._bin._view(C).getUint16(i)
        },
        readUshorts: function (C, i, B) {
          for (var o = [], r = 0; r < B; r++) o.push(A._bin.readUshort(C, i + 2 * r))
          return o
        },
        readUint: function (C, i) {
          return A._bin._view(C).getUint32(i)
        },
        readUint64: function (C, i) {
          return 4294967296 * A._bin.readUint(C, i) + A._bin.readUint(C, i + 4)
        },
        readASCII: function (C, i, B) {
          for (var o = "", r = 0; r < B; r++) o += String.fromCharCode(C[i + r])
          return o
        },
        readUnicode: function (C, i, B) {
          for (var o = "", r = 0; r < B; r++) {
            var s = (C[i++] << 8) | C[i++]
            o += String.fromCharCode(s)
          }
          return o
        },
        _tdec: typeof window < "u" && window.TextDecoder ? new window.TextDecoder() : null,
        readUTF8: function (C, i, B) {
          var o = A._bin._tdec
          return o && i == 0 && B == C.length ? o.decode(C) : A._bin.readASCII(C, i, B)
        },
        readBytes: function (C, i, B) {
          for (var o = [], r = 0; r < B; r++) o.push(C[i + r])
          return o
        },
        readASCIIArray: function (C, i, B) {
          for (var o = [], r = 0; r < B; r++) o.push(String.fromCharCode(C[i + r]))
          return o
        },
        _view: function (C) {
          return (
            C._dataView ||
            (C._dataView = C.buffer
              ? new DataView(C.buffer, C.byteOffset, C.byteLength)
              : new DataView(new Uint8Array(C).buffer))
          )
        },
      }),
        (A._lctf = {}),
        (A._lctf.parse = function (C, i, B, o, r) {
          var s = A._bin,
            h = {},
            S = i
          ;(s.readFixed(C, i), (i += 4))
          var d = s.readUshort(C, i)
          i += 2
          var w = s.readUshort(C, i)
          i += 2
          var M = s.readUshort(C, i)
          return (
            (i += 2),
            (h.scriptList = A._lctf.readScriptList(C, S + d)),
            (h.featureList = A._lctf.readFeatureList(C, S + w)),
            (h.lookupList = A._lctf.readLookupList(C, S + M, r)),
            h
          )
        }),
        (A._lctf.readLookupList = function (C, i, B) {
          var o = A._bin,
            r = i,
            s = [],
            h = o.readUshort(C, i)
          i += 2
          for (var S = 0; S < h; S++) {
            var d = o.readUshort(C, i)
            i += 2
            var w = A._lctf.readLookupTable(C, r + d, B)
            s.push(w)
          }
          return s
        }),
        (A._lctf.readLookupTable = function (C, i, B) {
          var o = A._bin,
            r = i,
            s = { tabs: [] }
          ;((s.ltype = o.readUshort(C, i)), (i += 2), (s.flag = o.readUshort(C, i)), (i += 2))
          var h = o.readUshort(C, i)
          i += 2
          for (var S = s.ltype, d = 0; d < h; d++) {
            var w = o.readUshort(C, i)
            i += 2
            var M = B(C, S, r + w, s)
            s.tabs.push(M)
          }
          return s
        }),
        (A._lctf.numOfOnes = function (C) {
          for (var i = 0, B = 0; B < 32; B++) (C >>> B) & 1 && i++
          return i
        }),
        (A._lctf.readClassDef = function (C, i) {
          var B = A._bin,
            o = [],
            r = B.readUshort(C, i)
          if (((i += 2), r == 1)) {
            var s = B.readUshort(C, i)
            i += 2
            var h = B.readUshort(C, i)
            i += 2
            for (var S = 0; S < h; S++)
              (o.push(s + S), o.push(s + S), o.push(B.readUshort(C, i)), (i += 2))
          }
          if (r == 2) {
            var d = B.readUshort(C, i)
            for (i += 2, S = 0; S < d; S++)
              (o.push(B.readUshort(C, i)),
                (i += 2),
                o.push(B.readUshort(C, i)),
                (i += 2),
                o.push(B.readUshort(C, i)),
                (i += 2))
          }
          return o
        }),
        (A._lctf.getInterval = function (C, i) {
          for (var B = 0; B < C.length; B += 3) {
            var o = C[B],
              r = C[B + 1]
            if ((C[B + 2], o <= i && i <= r)) return B
          }
          return -1
        }),
        (A._lctf.readCoverage = function (C, i) {
          var B = A._bin,
            o = {}
          ;((o.fmt = B.readUshort(C, i)), (i += 2))
          var r = B.readUshort(C, i)
          return (
            (i += 2),
            o.fmt == 1 && (o.tab = B.readUshorts(C, i, r)),
            o.fmt == 2 && (o.tab = B.readUshorts(C, i, 3 * r)),
            o
          )
        }),
        (A._lctf.coverageIndex = function (C, i) {
          var B = C.tab
          if (C.fmt == 1) return B.indexOf(i)
          if (C.fmt == 2) {
            var o = A._lctf.getInterval(B, i)
            if (o != -1) return B[o + 2] + (i - B[o])
          }
          return -1
        }),
        (A._lctf.readFeatureList = function (C, i) {
          var B = A._bin,
            o = i,
            r = [],
            s = B.readUshort(C, i)
          i += 2
          for (var h = 0; h < s; h++) {
            var S = B.readASCII(C, i, 4)
            i += 4
            var d = B.readUshort(C, i)
            i += 2
            var w = A._lctf.readFeatureTable(C, o + d)
            ;((w.tag = S.trim()), r.push(w))
          }
          return r
        }),
        (A._lctf.readFeatureTable = function (C, i) {
          var B = A._bin,
            o = i,
            r = {},
            s = B.readUshort(C, i)
          ;((i += 2), s > 0 && (r.featureParams = o + s))
          var h = B.readUshort(C, i)
          ;((i += 2), (r.tab = []))
          for (var S = 0; S < h; S++) r.tab.push(B.readUshort(C, i + 2 * S))
          return r
        }),
        (A._lctf.readScriptList = function (C, i) {
          var B = A._bin,
            o = i,
            r = {},
            s = B.readUshort(C, i)
          i += 2
          for (var h = 0; h < s; h++) {
            var S = B.readASCII(C, i, 4)
            i += 4
            var d = B.readUshort(C, i)
            ;((i += 2), (r[S.trim()] = A._lctf.readScriptTable(C, o + d)))
          }
          return r
        }),
        (A._lctf.readScriptTable = function (C, i) {
          var B = A._bin,
            o = i,
            r = {},
            s = B.readUshort(C, i)
          ;((i += 2), s > 0 && (r.default = A._lctf.readLangSysTable(C, o + s)))
          var h = B.readUshort(C, i)
          i += 2
          for (var S = 0; S < h; S++) {
            var d = B.readASCII(C, i, 4)
            i += 4
            var w = B.readUshort(C, i)
            ;((i += 2), (r[d.trim()] = A._lctf.readLangSysTable(C, o + w)))
          }
          return r
        }),
        (A._lctf.readLangSysTable = function (C, i) {
          var B = A._bin,
            o = {}
          ;(B.readUshort(C, i), (i += 2), (o.reqFeature = B.readUshort(C, i)), (i += 2))
          var r = B.readUshort(C, i)
          return ((i += 2), (o.features = B.readUshorts(C, i, r)), o)
        }),
        (A.CFF = {}),
        (A.CFF.parse = function (C, i, B) {
          var o = A._bin
          ;((C = new Uint8Array(C.buffer, i, B))[(i = 0)], C[++i], C[++i], C[++i], i++)
          var r = []
          i = A.CFF.readIndex(C, i, r)
          for (var s = [], h = 0; h < r.length - 1; h++)
            s.push(o.readASCII(C, i + r[h], r[h + 1] - r[h]))
          i += r[r.length - 1]
          var S = []
          i = A.CFF.readIndex(C, i, S)
          var d = []
          for (h = 0; h < S.length - 1; h++) d.push(A.CFF.readDict(C, i + S[h], i + S[h + 1]))
          i += S[S.length - 1]
          var w = d[0],
            M = []
          i = A.CFF.readIndex(C, i, M)
          var K = []
          for (h = 0; h < M.length - 1; h++) K.push(o.readASCII(C, i + M[h], M[h + 1] - M[h]))
          if (((i += M[M.length - 1]), A.CFF.readSubrs(C, i, w), w.CharStrings)) {
            ;((i = w.CharStrings), (M = []), (i = A.CFF.readIndex(C, i, M)))
            var R = []
            for (h = 0; h < M.length - 1; h++) R.push(o.readBytes(C, i + M[h], M[h + 1] - M[h]))
            w.CharStrings = R
          }
          if (w.ROS) {
            i = w.FDArray
            var F = []
            for (i = A.CFF.readIndex(C, i, F), w.FDArray = [], h = 0; h < F.length - 1; h++) {
              var L = A.CFF.readDict(C, i + F[h], i + F[h + 1])
              ;(A.CFF._readFDict(C, L, K), w.FDArray.push(L))
            }
            ;((i += F[F.length - 1]), (i = w.FDSelect), (w.FDSelect = []))
            var Y = C[i]
            if ((i++, Y != 3)) throw Y
            var H = o.readUshort(C, i)
            for (i += 2, h = 0; h < H + 1; h++)
              (w.FDSelect.push(o.readUshort(C, i), C[i + 2]), (i += 3))
          }
          return (
            w.Encoding && (w.Encoding = A.CFF.readEncoding(C, w.Encoding, w.CharStrings.length)),
            w.charset && (w.charset = A.CFF.readCharset(C, w.charset, w.CharStrings.length)),
            A.CFF._readFDict(C, w, K),
            w
          )
        }),
        (A.CFF._readFDict = function (C, i, B) {
          var o
          for (var r in (i.Private &&
            ((o = i.Private[1]),
            (i.Private = A.CFF.readDict(C, o, o + i.Private[0])),
            i.Private.Subrs && A.CFF.readSubrs(C, o + i.Private.Subrs, i.Private)),
          i))
            ["FamilyName", "FontName", "FullName", "Notice", "version", "Copyright"].indexOf(r) !=
              -1 && (i[r] = B[i[r] - 426 + 35])
        }),
        (A.CFF.readSubrs = function (C, i, B) {
          var o = A._bin,
            r = []
          i = A.CFF.readIndex(C, i, r)
          var s,
            h = r.length
          ;((s = h < 1240 ? 107 : h < 33900 ? 1131 : 32768), (B.Bias = s), (B.Subrs = []))
          for (var S = 0; S < r.length - 1; S++)
            B.Subrs.push(o.readBytes(C, i + r[S], r[S + 1] - r[S]))
        }),
        (A.CFF.tableSE = [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
          24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45,
          46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67,
          68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89,
          90, 91, 92, 93, 94, 95, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106,
          107, 108, 109, 110, 0, 111, 112, 113, 114, 0, 115, 116, 117, 118, 119, 120, 121, 122, 0,
          123, 0, 124, 125, 126, 127, 128, 129, 130, 131, 0, 132, 133, 0, 134, 135, 136, 137, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 138, 0, 139, 0, 0, 0, 0, 140, 141, 142, 143, 0,
          0, 0, 0, 0, 144, 0, 0, 0, 145, 0, 0, 146, 147, 148, 149, 0, 0, 0, 0,
        ]),
        (A.CFF.glyphByUnicode = function (C, i) {
          for (var B = 0; B < C.charset.length; B++) if (C.charset[B] == i) return B
          return -1
        }),
        (A.CFF.glyphBySE = function (C, i) {
          return i < 0 || i > 255 ? -1 : A.CFF.glyphByUnicode(C, A.CFF.tableSE[i])
        }),
        (A.CFF.readEncoding = function (C, i, B) {
          A._bin
          var o = [".notdef"],
            r = C[i]
          if ((i++, r != 0)) throw "error: unknown encoding format: " + r
          var s = C[i]
          i++
          for (var h = 0; h < s; h++) o.push(C[i + h])
          return o
        }),
        (A.CFF.readCharset = function (C, i, B) {
          var o = A._bin,
            r = [".notdef"],
            s = C[i]
          if ((i++, s == 0))
            for (var h = 0; h < B; h++) {
              var S = o.readUshort(C, i)
              ;((i += 2), r.push(S))
            }
          else {
            if (s != 1 && s != 2) throw "error: format: " + s
            for (; r.length < B; ) {
              ;((S = o.readUshort(C, i)), (i += 2))
              var d = 0
              for (
                s == 1 ? ((d = C[i]), i++) : ((d = o.readUshort(C, i)), (i += 2)), h = 0;
                h <= d;
                h++
              )
                (r.push(S), S++)
            }
          }
          return r
        }),
        (A.CFF.readIndex = function (C, i, B) {
          var o = A._bin,
            r = o.readUshort(C, i) + 1,
            s = C[(i += 2)]
          if ((i++, s == 1)) for (var h = 0; h < r; h++) B.push(C[i + h])
          else if (s == 2) for (h = 0; h < r; h++) B.push(o.readUshort(C, i + 2 * h))
          else if (s == 3) for (h = 0; h < r; h++) B.push(16777215 & o.readUint(C, i + 3 * h - 1))
          else if (r != 1) throw "unsupported offset size: " + s + ", count: " + r
          return (i += r * s) - 1
        }),
        (A.CFF.getCharString = function (C, i, B) {
          var o = A._bin,
            r = C[i],
            s = C[i + 1]
          ;(C[i + 2], C[i + 3], C[i + 4])
          var h = 1,
            S = null,
            d = null
          ;(r <= 20 && ((S = r), (h = 1)),
            r == 12 && ((S = 100 * r + s), (h = 2)),
            21 <= r && r <= 27 && ((S = r), (h = 1)),
            r == 28 && ((d = o.readShort(C, i + 1)), (h = 3)),
            29 <= r && r <= 31 && ((S = r), (h = 1)),
            32 <= r && r <= 246 && ((d = r - 139), (h = 1)),
            247 <= r && r <= 250 && ((d = 256 * (r - 247) + s + 108), (h = 2)),
            251 <= r && r <= 254 && ((d = 256 * -(r - 251) - s - 108), (h = 2)),
            r == 255 && ((d = o.readInt(C, i + 1) / 65535), (h = 5)),
            (B.val = d ?? "o" + S),
            (B.size = h))
        }),
        (A.CFF.readCharString = function (C, i, B) {
          for (var o = i + B, r = A._bin, s = []; i < o; ) {
            var h = C[i],
              S = C[i + 1]
            ;(C[i + 2], C[i + 3], C[i + 4])
            var d = 1,
              w = null,
              M = null
            ;(h <= 20 && ((w = h), (d = 1)),
              h == 12 && ((w = 100 * h + S), (d = 2)),
              (h != 19 && h != 20) || ((w = h), (d = 2)),
              21 <= h && h <= 27 && ((w = h), (d = 1)),
              h == 28 && ((M = r.readShort(C, i + 1)), (d = 3)),
              29 <= h && h <= 31 && ((w = h), (d = 1)),
              32 <= h && h <= 246 && ((M = h - 139), (d = 1)),
              247 <= h && h <= 250 && ((M = 256 * (h - 247) + S + 108), (d = 2)),
              251 <= h && h <= 254 && ((M = 256 * -(h - 251) - S - 108), (d = 2)),
              h == 255 && ((M = r.readInt(C, i + 1) / 65535), (d = 5)),
              s.push(M ?? "o" + w),
              (i += d))
          }
          return s
        }),
        (A.CFF.readDict = function (C, i, B) {
          for (var o = A._bin, r = {}, s = []; i < B; ) {
            var h = C[i],
              S = C[i + 1]
            ;(C[i + 2], C[i + 3], C[i + 4])
            var d = 1,
              w = null,
              M = null
            if (
              (h == 28 && ((M = o.readShort(C, i + 1)), (d = 3)),
              h == 29 && ((M = o.readInt(C, i + 1)), (d = 5)),
              32 <= h && h <= 246 && ((M = h - 139), (d = 1)),
              247 <= h && h <= 250 && ((M = 256 * (h - 247) + S + 108), (d = 2)),
              251 <= h && h <= 254 && ((M = 256 * -(h - 251) - S - 108), (d = 2)),
              h == 255)
            )
              throw ((M = o.readInt(C, i + 1) / 65535), (d = 5), "unknown number")
            if (h == 30) {
              var K = []
              for (d = 1; ; ) {
                var R = C[i + d]
                d++
                var F = R >> 4,
                  L = 15 & R
                if ((F != 15 && K.push(F), L != 15 && K.push(L), L == 15)) break
              }
              for (
                var Y = "",
                  H = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    ".",
                    "e",
                    "e-",
                    "reserved",
                    "-",
                    "endOfNumber",
                  ],
                  V = 0;
                V < K.length;
                V++
              )
                Y += H[K[V]]
              M = parseFloat(Y)
            }
            ;(h <= 21 &&
              ((w = [
                "version",
                "Notice",
                "FullName",
                "FamilyName",
                "Weight",
                "FontBBox",
                "BlueValues",
                "OtherBlues",
                "FamilyBlues",
                "FamilyOtherBlues",
                "StdHW",
                "StdVW",
                "escape",
                "UniqueID",
                "XUID",
                "charset",
                "Encoding",
                "CharStrings",
                "Private",
                "Subrs",
                "defaultWidthX",
                "nominalWidthX",
              ][h]),
              (d = 1),
              h == 12 &&
                ((w = [
                  "Copyright",
                  "isFixedPitch",
                  "ItalicAngle",
                  "UnderlinePosition",
                  "UnderlineThickness",
                  "PaintType",
                  "CharstringType",
                  "FontMatrix",
                  "StrokeWidth",
                  "BlueScale",
                  "BlueShift",
                  "BlueFuzz",
                  "StemSnapH",
                  "StemSnapV",
                  "ForceBold",
                  0,
                  0,
                  "LanguageGroup",
                  "ExpansionFactor",
                  "initialRandomSeed",
                  "SyntheticBase",
                  "PostScript",
                  "BaseFontName",
                  "BaseFontBlend",
                  0,
                  0,
                  0,
                  0,
                  0,
                  0,
                  "ROS",
                  "CIDFontVersion",
                  "CIDFontRevision",
                  "CIDFontType",
                  "CIDCount",
                  "UIDBase",
                  "FDArray",
                  "FDSelect",
                  "FontName",
                ][S]),
                (d = 2))),
              w != null ? ((r[w] = s.length == 1 ? s[0] : s), (s = [])) : s.push(M),
              (i += d))
          }
          return r
        }),
        (A.cmap = {}),
        (A.cmap.parse = function (C, i, B) {
          ;((C = new Uint8Array(C.buffer, i, B)), (i = 0))
          var o = A._bin,
            r = {}
          ;(o.readUshort(C, i), (i += 2))
          var s = o.readUshort(C, i)
          i += 2
          var h = []
          r.tables = []
          for (var S = 0; S < s; S++) {
            var d = o.readUshort(C, i)
            i += 2
            var w = o.readUshort(C, i)
            i += 2
            var M = o.readUint(C, i)
            i += 4
            var K = "p" + d + "e" + w,
              R = h.indexOf(M)
            if (R == -1) {
              var F
              ;((R = r.tables.length), h.push(M))
              var L = o.readUshort(C, M)
              ;(L == 0
                ? (F = A.cmap.parse0(C, M))
                : L == 4
                  ? (F = A.cmap.parse4(C, M))
                  : L == 6
                    ? (F = A.cmap.parse6(C, M))
                    : L == 12
                      ? (F = A.cmap.parse12(C, M))
                      : console.debug("unknown format: " + L, d, w, M),
                r.tables.push(F))
            }
            if (r[K] != null) throw "multiple tables for one platform+encoding"
            r[K] = R
          }
          return r
        }),
        (A.cmap.parse0 = function (C, i) {
          var B = A._bin,
            o = {}
          ;((o.format = B.readUshort(C, i)), (i += 2))
          var r = B.readUshort(C, i)
          ;((i += 2), B.readUshort(C, i), (i += 2), (o.map = []))
          for (var s = 0; s < r - 6; s++) o.map.push(C[i + s])
          return o
        }),
        (A.cmap.parse4 = function (C, i) {
          var B = A._bin,
            o = i,
            r = {}
          ;((r.format = B.readUshort(C, i)), (i += 2))
          var s = B.readUshort(C, i)
          ;((i += 2), B.readUshort(C, i), (i += 2))
          var h = B.readUshort(C, i)
          i += 2
          var S = h / 2
          ;((r.searchRange = B.readUshort(C, i)),
            (i += 2),
            (r.entrySelector = B.readUshort(C, i)),
            (i += 2),
            (r.rangeShift = B.readUshort(C, i)),
            (i += 2),
            (r.endCount = B.readUshorts(C, i, S)),
            (i += 2 * S),
            (i += 2),
            (r.startCount = B.readUshorts(C, i, S)),
            (i += 2 * S),
            (r.idDelta = []))
          for (var d = 0; d < S; d++) (r.idDelta.push(B.readShort(C, i)), (i += 2))
          for (
            r.idRangeOffset = B.readUshorts(C, i, S), i += 2 * S, r.glyphIdArray = [];
            i < o + s;
          )
            (r.glyphIdArray.push(B.readUshort(C, i)), (i += 2))
          return r
        }),
        (A.cmap.parse6 = function (C, i) {
          var B = A._bin,
            o = {}
          ;((o.format = B.readUshort(C, i)),
            (i += 2),
            B.readUshort(C, i),
            (i += 2),
            B.readUshort(C, i),
            (i += 2),
            (o.firstCode = B.readUshort(C, i)),
            (i += 2))
          var r = B.readUshort(C, i)
          ;((i += 2), (o.glyphIdArray = []))
          for (var s = 0; s < r; s++) (o.glyphIdArray.push(B.readUshort(C, i)), (i += 2))
          return o
        }),
        (A.cmap.parse12 = function (C, i) {
          var B = A._bin,
            o = {}
          ;((o.format = B.readUshort(C, i)),
            (i += 2),
            (i += 2),
            B.readUint(C, i),
            (i += 4),
            B.readUint(C, i),
            (i += 4))
          var r = B.readUint(C, i)
          ;((i += 4), (o.groups = []))
          for (var s = 0; s < r; s++) {
            var h = i + 12 * s,
              S = B.readUint(C, h + 0),
              d = B.readUint(C, h + 4),
              w = B.readUint(C, h + 8)
            o.groups.push([S, d, w])
          }
          return o
        }),
        (A.glyf = {}),
        (A.glyf.parse = function (C, i, B, o) {
          for (var r = [], s = 0; s < o.maxp.numGlyphs; s++) r.push(null)
          return r
        }),
        (A.glyf._parseGlyf = function (C, i) {
          var B = A._bin,
            o = C._data,
            r = A._tabOffset(o, "glyf", C._offset) + C.loca[i]
          if (C.loca[i] == C.loca[i + 1]) return null
          var s = {}
          if (
            ((s.noc = B.readShort(o, r)),
            (r += 2),
            (s.xMin = B.readShort(o, r)),
            (r += 2),
            (s.yMin = B.readShort(o, r)),
            (r += 2),
            (s.xMax = B.readShort(o, r)),
            (r += 2),
            (s.yMax = B.readShort(o, r)),
            (r += 2),
            s.xMin >= s.xMax || s.yMin >= s.yMax)
          )
            return null
          if (s.noc > 0) {
            s.endPts = []
            for (var h = 0; h < s.noc; h++) (s.endPts.push(B.readUshort(o, r)), (r += 2))
            var S = B.readUshort(o, r)
            if (((r += 2), o.length - r < S)) return null
            ;((s.instructions = B.readBytes(o, r, S)), (r += S))
            var d = s.endPts[s.noc - 1] + 1
            for (s.flags = [], h = 0; h < d; h++) {
              var w = o[r]
              if ((r++, s.flags.push(w), (8 & w) != 0)) {
                var M = o[r]
                r++
                for (var K = 0; K < M; K++) (s.flags.push(w), h++)
              }
            }
            for (s.xs = [], h = 0; h < d; h++) {
              var R = (2 & s.flags[h]) != 0,
                F = (16 & s.flags[h]) != 0
              R
                ? (s.xs.push(F ? o[r] : -o[r]), r++)
                : F
                  ? s.xs.push(0)
                  : (s.xs.push(B.readShort(o, r)), (r += 2))
            }
            for (s.ys = [], h = 0; h < d; h++)
              ((R = (4 & s.flags[h]) != 0),
                (F = (32 & s.flags[h]) != 0),
                R
                  ? (s.ys.push(F ? o[r] : -o[r]), r++)
                  : F
                    ? s.ys.push(0)
                    : (s.ys.push(B.readShort(o, r)), (r += 2)))
            var L = 0,
              Y = 0
            for (h = 0; h < d; h++) ((L += s.xs[h]), (Y += s.ys[h]), (s.xs[h] = L), (s.ys[h] = Y))
          } else {
            var H
            s.parts = []
            do {
              ;((H = B.readUshort(o, r)), (r += 2))
              var V = { m: { a: 1, b: 0, c: 0, d: 1, tx: 0, ty: 0 }, p1: -1, p2: -1 }
              if ((s.parts.push(V), (V.glyphIndex = B.readUshort(o, r)), (r += 2), 1 & H)) {
                var j = B.readShort(o, r)
                r += 2
                var P = B.readShort(o, r)
                r += 2
              } else ((j = B.readInt8(o, r)), r++, (P = B.readInt8(o, r)), r++)
              ;(2 & H ? ((V.m.tx = j), (V.m.ty = P)) : ((V.p1 = j), (V.p2 = P)),
                8 & H
                  ? ((V.m.a = V.m.d = B.readF2dot14(o, r)), (r += 2))
                  : 64 & H
                    ? ((V.m.a = B.readF2dot14(o, r)),
                      (r += 2),
                      (V.m.d = B.readF2dot14(o, r)),
                      (r += 2))
                    : 128 & H &&
                      ((V.m.a = B.readF2dot14(o, r)),
                      (r += 2),
                      (V.m.b = B.readF2dot14(o, r)),
                      (r += 2),
                      (V.m.c = B.readF2dot14(o, r)),
                      (r += 2),
                      (V.m.d = B.readF2dot14(o, r)),
                      (r += 2)))
            } while (32 & H)
            if (256 & H) {
              var AA = B.readUshort(o, r)
              for (r += 2, s.instr = [], h = 0; h < AA; h++) (s.instr.push(o[r]), r++)
            }
          }
          return s
        }),
        (A.GDEF = {}),
        (A.GDEF.parse = function (C, i, B, o) {
          var r = i
          i += 4
          var s = A._bin.readUshort(C, i)
          return { glyphClassDef: s === 0 ? null : A._lctf.readClassDef(C, r + s) }
        }),
        (A.GPOS = {}),
        (A.GPOS.parse = function (C, i, B, o) {
          return A._lctf.parse(C, i, B, o, A.GPOS.subt)
        }),
        (A.GPOS.subt = function (C, i, B, o) {
          var r = A._bin,
            s = B,
            h = {}
          if (
            ((h.fmt = r.readUshort(C, B)),
            (B += 2),
            i == 1 || i == 2 || i == 3 || i == 7 || (i == 8 && h.fmt <= 2))
          ) {
            var S = r.readUshort(C, B)
            ;((B += 2), (h.coverage = A._lctf.readCoverage(C, S + s)))
          }
          if (i == 1 && h.fmt == 1) {
            var d = r.readUshort(C, B)
            ;((B += 2), d != 0 && (h.pos = A.GPOS.readValueRecord(C, B, d)))
          } else if (i == 2 && h.fmt >= 1 && h.fmt <= 2) {
            ;((d = r.readUshort(C, B)), (B += 2))
            var w = r.readUshort(C, B)
            B += 2
            var M = A._lctf.numOfOnes(d),
              K = A._lctf.numOfOnes(w)
            if (h.fmt == 1) {
              h.pairsets = []
              var R = r.readUshort(C, B)
              B += 2
              for (var F = 0; F < R; F++) {
                var L = s + r.readUshort(C, B)
                B += 2
                var Y = r.readUshort(C, L)
                L += 2
                for (var H = [], V = 0; V < Y; V++) {
                  var j = r.readUshort(C, L)
                  ;((L += 2),
                    d != 0 && ((CA = A.GPOS.readValueRecord(C, L, d)), (L += 2 * M)),
                    w != 0 && ((aA = A.GPOS.readValueRecord(C, L, w)), (L += 2 * K)),
                    H.push({ gid2: j, val1: CA, val2: aA }))
                }
                h.pairsets.push(H)
              }
            }
            if (h.fmt == 2) {
              var P = r.readUshort(C, B)
              B += 2
              var AA = r.readUshort(C, B)
              B += 2
              var X = r.readUshort(C, B)
              B += 2
              var _ = r.readUshort(C, B)
              for (
                B += 2,
                  h.classDef1 = A._lctf.readClassDef(C, s + P),
                  h.classDef2 = A._lctf.readClassDef(C, s + AA),
                  h.matrix = [],
                  F = 0;
                F < X;
                F++
              ) {
                var eA = []
                for (V = 0; V < _; V++) {
                  var CA = null,
                    aA = null
                  ;(d != 0 && ((CA = A.GPOS.readValueRecord(C, B, d)), (B += 2 * M)),
                    w != 0 && ((aA = A.GPOS.readValueRecord(C, B, w)), (B += 2 * K)),
                    eA.push({ val1: CA, val2: aA }))
                }
                h.matrix.push(eA)
              }
            }
          } else if (i == 4 && h.fmt == 1)
            ((h.markCoverage = A._lctf.readCoverage(C, r.readUshort(C, B) + s)),
              (h.baseCoverage = A._lctf.readCoverage(C, r.readUshort(C, B + 2) + s)),
              (h.markClassCount = r.readUshort(C, B + 4)),
              (h.markArray = A.GPOS.readMarkArray(C, r.readUshort(C, B + 6) + s)),
              (h.baseArray = A.GPOS.readBaseArray(C, r.readUshort(C, B + 8) + s, h.markClassCount)))
          else if (i == 6 && h.fmt == 1)
            ((h.mark1Coverage = A._lctf.readCoverage(C, r.readUshort(C, B) + s)),
              (h.mark2Coverage = A._lctf.readCoverage(C, r.readUshort(C, B + 2) + s)),
              (h.markClassCount = r.readUshort(C, B + 4)),
              (h.mark1Array = A.GPOS.readMarkArray(C, r.readUshort(C, B + 6) + s)),
              (h.mark2Array = A.GPOS.readBaseArray(
                C,
                r.readUshort(C, B + 8) + s,
                h.markClassCount,
              )))
          else {
            if (i == 9 && h.fmt == 1) {
              var lA = r.readUshort(C, B)
              B += 2
              var JA = r.readUint(C, B)
              if (((B += 4), o.ltype == 9)) o.ltype = lA
              else if (o.ltype != lA) throw "invalid extension substitution"
              return A.GPOS.subt(C, o.ltype, s + JA)
            }
            console.debug("unsupported GPOS table LookupType", i, "format", h.fmt)
          }
          return h
        }),
        (A.GPOS.readValueRecord = function (C, i, B) {
          var o = A._bin,
            r = []
          return (
            r.push(1 & B ? o.readShort(C, i) : 0),
            (i += 1 & B ? 2 : 0),
            r.push(2 & B ? o.readShort(C, i) : 0),
            (i += 2 & B ? 2 : 0),
            r.push(4 & B ? o.readShort(C, i) : 0),
            (i += 4 & B ? 2 : 0),
            r.push(8 & B ? o.readShort(C, i) : 0),
            (i += 8 & B ? 2 : 0),
            r
          )
        }),
        (A.GPOS.readBaseArray = function (C, i, B) {
          var o = A._bin,
            r = [],
            s = i,
            h = o.readUshort(C, i)
          i += 2
          for (var S = 0; S < h; S++) {
            for (var d = [], w = 0; w < B; w++)
              (d.push(A.GPOS.readAnchorRecord(C, s + o.readUshort(C, i))), (i += 2))
            r.push(d)
          }
          return r
        }),
        (A.GPOS.readMarkArray = function (C, i) {
          var B = A._bin,
            o = [],
            r = i,
            s = B.readUshort(C, i)
          i += 2
          for (var h = 0; h < s; h++) {
            var S = A.GPOS.readAnchorRecord(C, B.readUshort(C, i + 2) + r)
            ;((S.markClass = B.readUshort(C, i)), o.push(S), (i += 4))
          }
          return o
        }),
        (A.GPOS.readAnchorRecord = function (C, i) {
          var B = A._bin,
            o = {}
          return (
            (o.fmt = B.readUshort(C, i)),
            (o.x = B.readShort(C, i + 2)),
            (o.y = B.readShort(C, i + 4)),
            o
          )
        }),
        (A.GSUB = {}),
        (A.GSUB.parse = function (C, i, B, o) {
          return A._lctf.parse(C, i, B, o, A.GSUB.subt)
        }),
        (A.GSUB.subt = function (C, i, B, o) {
          var r = A._bin,
            s = B,
            h = {}
          if (
            ((h.fmt = r.readUshort(C, B)), (B += 2), i != 1 && i != 2 && i != 4 && i != 5 && i != 6)
          )
            return null
          if (i == 1 || i == 2 || i == 4 || (i == 5 && h.fmt <= 2) || (i == 6 && h.fmt <= 2)) {
            var S = r.readUshort(C, B)
            ;((B += 2), (h.coverage = A._lctf.readCoverage(C, s + S)))
          }
          if (i == 1 && h.fmt >= 1 && h.fmt <= 2) {
            if (h.fmt == 1) ((h.delta = r.readShort(C, B)), (B += 2))
            else if (h.fmt == 2) {
              var d = r.readUshort(C, B)
              ;((B += 2), (h.newg = r.readUshorts(C, B, d)), (B += 2 * h.newg.length))
            }
          } else if (i == 2 && h.fmt == 1) {
            ;((d = r.readUshort(C, B)), (B += 2), (h.seqs = []))
            for (var w = 0; w < d; w++) {
              var M = r.readUshort(C, B) + s
              B += 2
              var K = r.readUshort(C, M)
              h.seqs.push(r.readUshorts(C, M + 2, K))
            }
          } else if (i == 4)
            for (h.vals = [], d = r.readUshort(C, B), B += 2, w = 0; w < d; w++) {
              var R = r.readUshort(C, B)
              ;((B += 2), h.vals.push(A.GSUB.readLigatureSet(C, s + R)))
            }
          else if (i == 5 && h.fmt == 2) {
            if (h.fmt == 2) {
              var F = r.readUshort(C, B)
              ;((B += 2), (h.cDef = A._lctf.readClassDef(C, s + F)), (h.scset = []))
              var L = r.readUshort(C, B)
              for (B += 2, w = 0; w < L; w++) {
                var Y = r.readUshort(C, B)
                ;((B += 2), h.scset.push(Y == 0 ? null : A.GSUB.readSubClassSet(C, s + Y)))
              }
            }
          } else if (i == 6 && h.fmt == 3) {
            if (h.fmt == 3) {
              for (w = 0; w < 3; w++) {
                ;((d = r.readUshort(C, B)), (B += 2))
                for (var H = [], V = 0; V < d; V++)
                  H.push(A._lctf.readCoverage(C, s + r.readUshort(C, B + 2 * V)))
                ;((B += 2 * d),
                  w == 0 && (h.backCvg = H),
                  w == 1 && (h.inptCvg = H),
                  w == 2 && (h.ahedCvg = H))
              }
              ;((d = r.readUshort(C, B)),
                (B += 2),
                (h.lookupRec = A.GSUB.readSubstLookupRecords(C, B, d)))
            }
          } else {
            if (i == 7 && h.fmt == 1) {
              var j = r.readUshort(C, B)
              B += 2
              var P = r.readUint(C, B)
              if (((B += 4), o.ltype == 9)) o.ltype = j
              else if (o.ltype != j) throw "invalid extension substitution"
              return A.GSUB.subt(C, o.ltype, s + P)
            }
            console.debug("unsupported GSUB table LookupType", i, "format", h.fmt)
          }
          return h
        }),
        (A.GSUB.readSubClassSet = function (C, i) {
          var B = A._bin.readUshort,
            o = i,
            r = [],
            s = B(C, i)
          i += 2
          for (var h = 0; h < s; h++) {
            var S = B(C, i)
            ;((i += 2), r.push(A.GSUB.readSubClassRule(C, o + S)))
          }
          return r
        }),
        (A.GSUB.readSubClassRule = function (C, i) {
          var B = A._bin.readUshort,
            o = {},
            r = B(C, i),
            s = B(C, (i += 2))
          ;((i += 2), (o.input = []))
          for (var h = 0; h < r - 1; h++) (o.input.push(B(C, i)), (i += 2))
          return ((o.substLookupRecords = A.GSUB.readSubstLookupRecords(C, i, s)), o)
        }),
        (A.GSUB.readSubstLookupRecords = function (C, i, B) {
          for (var o = A._bin.readUshort, r = [], s = 0; s < B; s++)
            (r.push(o(C, i), o(C, i + 2)), (i += 4))
          return r
        }),
        (A.GSUB.readChainSubClassSet = function (C, i) {
          var B = A._bin,
            o = i,
            r = [],
            s = B.readUshort(C, i)
          i += 2
          for (var h = 0; h < s; h++) {
            var S = B.readUshort(C, i)
            ;((i += 2), r.push(A.GSUB.readChainSubClassRule(C, o + S)))
          }
          return r
        }),
        (A.GSUB.readChainSubClassRule = function (C, i) {
          for (
            var B = A._bin, o = {}, r = ["backtrack", "input", "lookahead"], s = 0;
            s < r.length;
            s++
          ) {
            var h = B.readUshort(C, i)
            ;((i += 2),
              s == 1 && h--,
              (o[r[s]] = B.readUshorts(C, i, h)),
              (i += 2 * o[r[s]].length))
          }
          return (
            (h = B.readUshort(C, i)),
            (i += 2),
            (o.subst = B.readUshorts(C, i, 2 * h)),
            (i += 2 * o.subst.length),
            o
          )
        }),
        (A.GSUB.readLigatureSet = function (C, i) {
          var B = A._bin,
            o = i,
            r = [],
            s = B.readUshort(C, i)
          i += 2
          for (var h = 0; h < s; h++) {
            var S = B.readUshort(C, i)
            ;((i += 2), r.push(A.GSUB.readLigature(C, o + S)))
          }
          return r
        }),
        (A.GSUB.readLigature = function (C, i) {
          var B = A._bin,
            o = { chain: [] }
          ;((o.nglyph = B.readUshort(C, i)), (i += 2))
          var r = B.readUshort(C, i)
          i += 2
          for (var s = 0; s < r - 1; s++) (o.chain.push(B.readUshort(C, i)), (i += 2))
          return o
        }),
        (A.head = {}),
        (A.head.parse = function (C, i, B) {
          var o = A._bin,
            r = {}
          return (
            o.readFixed(C, i),
            (i += 4),
            (r.fontRevision = o.readFixed(C, i)),
            (i += 4),
            o.readUint(C, i),
            (i += 4),
            o.readUint(C, i),
            (i += 4),
            (r.flags = o.readUshort(C, i)),
            (i += 2),
            (r.unitsPerEm = o.readUshort(C, i)),
            (i += 2),
            (r.created = o.readUint64(C, i)),
            (i += 8),
            (r.modified = o.readUint64(C, i)),
            (i += 8),
            (r.xMin = o.readShort(C, i)),
            (i += 2),
            (r.yMin = o.readShort(C, i)),
            (i += 2),
            (r.xMax = o.readShort(C, i)),
            (i += 2),
            (r.yMax = o.readShort(C, i)),
            (i += 2),
            (r.macStyle = o.readUshort(C, i)),
            (i += 2),
            (r.lowestRecPPEM = o.readUshort(C, i)),
            (i += 2),
            (r.fontDirectionHint = o.readShort(C, i)),
            (i += 2),
            (r.indexToLocFormat = o.readShort(C, i)),
            (i += 2),
            (r.glyphDataFormat = o.readShort(C, i)),
            (i += 2),
            r
          )
        }),
        (A.hhea = {}),
        (A.hhea.parse = function (C, i, B) {
          var o = A._bin,
            r = {}
          return (
            o.readFixed(C, i),
            (i += 4),
            (r.ascender = o.readShort(C, i)),
            (i += 2),
            (r.descender = o.readShort(C, i)),
            (i += 2),
            (r.lineGap = o.readShort(C, i)),
            (i += 2),
            (r.advanceWidthMax = o.readUshort(C, i)),
            (i += 2),
            (r.minLeftSideBearing = o.readShort(C, i)),
            (i += 2),
            (r.minRightSideBearing = o.readShort(C, i)),
            (i += 2),
            (r.xMaxExtent = o.readShort(C, i)),
            (i += 2),
            (r.caretSlopeRise = o.readShort(C, i)),
            (i += 2),
            (r.caretSlopeRun = o.readShort(C, i)),
            (i += 2),
            (r.caretOffset = o.readShort(C, i)),
            (i += 2),
            (i += 8),
            (r.metricDataFormat = o.readShort(C, i)),
            (i += 2),
            (r.numberOfHMetrics = o.readUshort(C, i)),
            (i += 2),
            r
          )
        }),
        (A.hmtx = {}),
        (A.hmtx.parse = function (C, i, B, o) {
          for (
            var r = A._bin, s = { aWidth: [], lsBearing: [] }, h = 0, S = 0, d = 0;
            d < o.maxp.numGlyphs;
            d++
          )
            (d < o.hhea.numberOfHMetrics &&
              ((h = r.readUshort(C, i)), (i += 2), (S = r.readShort(C, i)), (i += 2)),
              s.aWidth.push(h),
              s.lsBearing.push(S))
          return s
        }),
        (A.kern = {}),
        (A.kern.parse = function (C, i, B, o) {
          var r = A._bin,
            s = r.readUshort(C, i)
          if (((i += 2), s == 1)) return A.kern.parseV1(C, i - 2, B, o)
          var h = r.readUshort(C, i)
          i += 2
          for (var S = { glyph1: [], rval: [] }, d = 0; d < h; d++) {
            ;((i += 2), (B = r.readUshort(C, i)), (i += 2))
            var w = r.readUshort(C, i)
            i += 2
            var M = w >>> 8
            if ((M &= 15) != 0) throw "unknown kern table format: " + M
            i = A.kern.readFormat0(C, i, S)
          }
          return S
        }),
        (A.kern.parseV1 = function (C, i, B, o) {
          var r = A._bin
          ;(r.readFixed(C, i), (i += 4))
          var s = r.readUint(C, i)
          i += 4
          for (var h = { glyph1: [], rval: [] }, S = 0; S < s; S++) {
            ;(r.readUint(C, i), (i += 4))
            var d = r.readUshort(C, i)
            ;((i += 2), r.readUshort(C, i), (i += 2))
            var w = d >>> 8
            if ((w &= 15) != 0) throw "unknown kern table format: " + w
            i = A.kern.readFormat0(C, i, h)
          }
          return h
        }),
        (A.kern.readFormat0 = function (C, i, B) {
          var o = A._bin,
            r = -1,
            s = o.readUshort(C, i)
          ;((i += 2),
            o.readUshort(C, i),
            (i += 2),
            o.readUshort(C, i),
            (i += 2),
            o.readUshort(C, i),
            (i += 2))
          for (var h = 0; h < s; h++) {
            var S = o.readUshort(C, i)
            i += 2
            var d = o.readUshort(C, i)
            i += 2
            var w = o.readShort(C, i)
            ;((i += 2), S != r && (B.glyph1.push(S), B.rval.push({ glyph2: [], vals: [] })))
            var M = B.rval[B.rval.length - 1]
            ;(M.glyph2.push(d), M.vals.push(w), (r = S))
          }
          return i
        }),
        (A.loca = {}),
        (A.loca.parse = function (C, i, B, o) {
          var r = A._bin,
            s = [],
            h = o.head.indexToLocFormat,
            S = o.maxp.numGlyphs + 1
          if (h == 0) for (var d = 0; d < S; d++) s.push(r.readUshort(C, i + (d << 1)) << 1)
          if (h == 1) for (d = 0; d < S; d++) s.push(r.readUint(C, i + (d << 2)))
          return s
        }),
        (A.maxp = {}),
        (A.maxp.parse = function (C, i, B) {
          var o = A._bin,
            r = {},
            s = o.readUint(C, i)
          return (
            (i += 4),
            (r.numGlyphs = o.readUshort(C, i)),
            (i += 2),
            s == 65536 &&
              ((r.maxPoints = o.readUshort(C, i)),
              (i += 2),
              (r.maxContours = o.readUshort(C, i)),
              (i += 2),
              (r.maxCompositePoints = o.readUshort(C, i)),
              (i += 2),
              (r.maxCompositeContours = o.readUshort(C, i)),
              (i += 2),
              (r.maxZones = o.readUshort(C, i)),
              (i += 2),
              (r.maxTwilightPoints = o.readUshort(C, i)),
              (i += 2),
              (r.maxStorage = o.readUshort(C, i)),
              (i += 2),
              (r.maxFunctionDefs = o.readUshort(C, i)),
              (i += 2),
              (r.maxInstructionDefs = o.readUshort(C, i)),
              (i += 2),
              (r.maxStackElements = o.readUshort(C, i)),
              (i += 2),
              (r.maxSizeOfInstructions = o.readUshort(C, i)),
              (i += 2),
              (r.maxComponentElements = o.readUshort(C, i)),
              (i += 2),
              (r.maxComponentDepth = o.readUshort(C, i)),
              (i += 2)),
            r
          )
        }),
        (A.name = {}),
        (A.name.parse = function (C, i, B) {
          var o = A._bin,
            r = {}
          ;(o.readUshort(C, i), (i += 2))
          var s = o.readUshort(C, i)
          ;((i += 2), o.readUshort(C, i))
          for (
            var h,
              S = [
                "copyright",
                "fontFamily",
                "fontSubfamily",
                "ID",
                "fullName",
                "version",
                "postScriptName",
                "trademark",
                "manufacturer",
                "designer",
                "description",
                "urlVendor",
                "urlDesigner",
                "licence",
                "licenceURL",
                "---",
                "typoFamilyName",
                "typoSubfamilyName",
                "compatibleFull",
                "sampleText",
                "postScriptCID",
                "wwsFamilyName",
                "wwsSubfamilyName",
                "lightPalette",
                "darkPalette",
              ],
              d = (i += 2),
              w = 0;
            w < s;
            w++
          ) {
            var M = o.readUshort(C, i)
            i += 2
            var K = o.readUshort(C, i)
            i += 2
            var R = o.readUshort(C, i)
            i += 2
            var F = o.readUshort(C, i)
            i += 2
            var L = o.readUshort(C, i)
            i += 2
            var Y = o.readUshort(C, i)
            i += 2
            var H,
              V = S[F],
              j = d + 12 * s + Y
            if (M == 0) H = o.readUnicode(C, j, L / 2)
            else if (M == 3 && K == 0) H = o.readUnicode(C, j, L / 2)
            else if (K == 0) H = o.readASCII(C, j, L)
            else if (K == 1) H = o.readUnicode(C, j, L / 2)
            else if (K == 3) H = o.readUnicode(C, j, L / 2)
            else {
              if (M != 1) throw "unknown encoding " + K + ", platformID: " + M
              ;((H = o.readASCII(C, j, L)),
                console.debug("reading unknown MAC encoding " + K + " as ASCII"))
            }
            var P = "p" + M + "," + R.toString(16)
            ;(r[P] == null && (r[P] = {}), (r[P][V !== void 0 ? V : F] = H), (r[P]._lang = R))
          }
          for (var AA in r) if (r[AA].postScriptName != null && r[AA]._lang == 1033) return r[AA]
          for (var AA in r) if (r[AA].postScriptName != null && r[AA]._lang == 0) return r[AA]
          for (var AA in r) if (r[AA].postScriptName != null && r[AA]._lang == 3084) return r[AA]
          for (var AA in r) if (r[AA].postScriptName != null) return r[AA]
          for (var AA in r) {
            h = AA
            break
          }
          return (console.debug("returning name table with languageID " + r[h]._lang), r[h])
        }),
        (A["OS/2"] = {}),
        (A["OS/2"].parse = function (C, i, B) {
          var o = A._bin.readUshort(C, i)
          i += 2
          var r = {}
          if (o == 0) A["OS/2"].version0(C, i, r)
          else if (o == 1) A["OS/2"].version1(C, i, r)
          else if (o == 2 || o == 3 || o == 4) A["OS/2"].version2(C, i, r)
          else {
            if (o != 5) throw "unknown OS/2 table version: " + o
            A["OS/2"].version5(C, i, r)
          }
          return r
        }),
        (A["OS/2"].version0 = function (C, i, B) {
          var o = A._bin
          return (
            (B.xAvgCharWidth = o.readShort(C, i)),
            (i += 2),
            (B.usWeightClass = o.readUshort(C, i)),
            (i += 2),
            (B.usWidthClass = o.readUshort(C, i)),
            (i += 2),
            (B.fsType = o.readUshort(C, i)),
            (i += 2),
            (B.ySubscriptXSize = o.readShort(C, i)),
            (i += 2),
            (B.ySubscriptYSize = o.readShort(C, i)),
            (i += 2),
            (B.ySubscriptXOffset = o.readShort(C, i)),
            (i += 2),
            (B.ySubscriptYOffset = o.readShort(C, i)),
            (i += 2),
            (B.ySuperscriptXSize = o.readShort(C, i)),
            (i += 2),
            (B.ySuperscriptYSize = o.readShort(C, i)),
            (i += 2),
            (B.ySuperscriptXOffset = o.readShort(C, i)),
            (i += 2),
            (B.ySuperscriptYOffset = o.readShort(C, i)),
            (i += 2),
            (B.yStrikeoutSize = o.readShort(C, i)),
            (i += 2),
            (B.yStrikeoutPosition = o.readShort(C, i)),
            (i += 2),
            (B.sFamilyClass = o.readShort(C, i)),
            (i += 2),
            (B.panose = o.readBytes(C, i, 10)),
            (i += 10),
            (B.ulUnicodeRange1 = o.readUint(C, i)),
            (i += 4),
            (B.ulUnicodeRange2 = o.readUint(C, i)),
            (i += 4),
            (B.ulUnicodeRange3 = o.readUint(C, i)),
            (i += 4),
            (B.ulUnicodeRange4 = o.readUint(C, i)),
            (i += 4),
            (B.achVendID = [
              o.readInt8(C, i),
              o.readInt8(C, i + 1),
              o.readInt8(C, i + 2),
              o.readInt8(C, i + 3),
            ]),
            (i += 4),
            (B.fsSelection = o.readUshort(C, i)),
            (i += 2),
            (B.usFirstCharIndex = o.readUshort(C, i)),
            (i += 2),
            (B.usLastCharIndex = o.readUshort(C, i)),
            (i += 2),
            (B.sTypoAscender = o.readShort(C, i)),
            (i += 2),
            (B.sTypoDescender = o.readShort(C, i)),
            (i += 2),
            (B.sTypoLineGap = o.readShort(C, i)),
            (i += 2),
            (B.usWinAscent = o.readUshort(C, i)),
            (i += 2),
            (B.usWinDescent = o.readUshort(C, i)),
            (i += 2)
          )
        }),
        (A["OS/2"].version1 = function (C, i, B) {
          var o = A._bin
          return (
            (i = A["OS/2"].version0(C, i, B)),
            (B.ulCodePageRange1 = o.readUint(C, i)),
            (i += 4),
            (B.ulCodePageRange2 = o.readUint(C, i)),
            (i += 4)
          )
        }),
        (A["OS/2"].version2 = function (C, i, B) {
          var o = A._bin
          return (
            (i = A["OS/2"].version1(C, i, B)),
            (B.sxHeight = o.readShort(C, i)),
            (i += 2),
            (B.sCapHeight = o.readShort(C, i)),
            (i += 2),
            (B.usDefault = o.readUshort(C, i)),
            (i += 2),
            (B.usBreak = o.readUshort(C, i)),
            (i += 2),
            (B.usMaxContext = o.readUshort(C, i)),
            (i += 2)
          )
        }),
        (A["OS/2"].version5 = function (C, i, B) {
          var o = A._bin
          return (
            (i = A["OS/2"].version2(C, i, B)),
            (B.usLowerOpticalPointSize = o.readUshort(C, i)),
            (i += 2),
            (B.usUpperOpticalPointSize = o.readUshort(C, i)),
            (i += 2)
          )
        }),
        (A.post = {}),
        (A.post.parse = function (C, i, B) {
          var o = A._bin,
            r = {}
          return (
            (r.version = o.readFixed(C, i)),
            (i += 4),
            (r.italicAngle = o.readFixed(C, i)),
            (i += 4),
            (r.underlinePosition = o.readShort(C, i)),
            (i += 2),
            (r.underlineThickness = o.readShort(C, i)),
            (i += 2),
            r
          )
        }),
        A == null && (A = {}),
        A.U == null && (A.U = {}),
        (A.U.codeToGlyph = function (C, i) {
          var B = C.cmap,
            o = -1
          if (
            (B.p0e4 != null
              ? (o = B.p0e4)
              : B.p3e1 != null
                ? (o = B.p3e1)
                : B.p1e0 != null
                  ? (o = B.p1e0)
                  : B.p0e3 != null && (o = B.p0e3),
            o == -1)
          )
            throw "no familiar platform and encoding!"
          var r = B.tables[o]
          if (r.format == 0) return i >= r.map.length ? 0 : r.map[i]
          if (r.format == 4) {
            for (var s = -1, h = 0; h < r.endCount.length; h++)
              if (i <= r.endCount[h]) {
                s = h
                break
              }
            return s == -1 || r.startCount[s] > i
              ? 0
              : 65535 &
                  (r.idRangeOffset[s] != 0
                    ? r.glyphIdArray[
                        i -
                          r.startCount[s] +
                          (r.idRangeOffset[s] >> 1) -
                          (r.idRangeOffset.length - s)
                      ]
                    : i + r.idDelta[s])
          }
          if (r.format == 12) {
            if (i > r.groups[r.groups.length - 1][1]) return 0
            for (h = 0; h < r.groups.length; h++) {
              var S = r.groups[h]
              if (S[0] <= i && i <= S[1]) return S[2] + (i - S[0])
            }
            return 0
          }
          throw "unknown cmap table format " + r.format
        }),
        (A.U.glyphToPath = function (C, i) {
          var B = { cmds: [], crds: [] }
          if (C.SVG && C.SVG.entries[i]) {
            var o = C.SVG.entries[i]
            return o == null
              ? B
              : (typeof o == "string" && ((o = A.SVG.toPath(o)), (C.SVG.entries[i] = o)), o)
          }
          if (C.CFF) {
            var r = {
                x: 0,
                y: 0,
                stack: [],
                nStems: 0,
                haveWidth: !1,
                width: C.CFF.Private ? C.CFF.Private.defaultWidthX : 0,
                open: !1,
              },
              s = C.CFF,
              h = C.CFF.Private
            if (s.ROS) {
              for (var S = 0; s.FDSelect[S + 2] <= i; ) S += 2
              h = s.FDArray[s.FDSelect[S + 1]].Private
            }
            A.U._drawCFF(C.CFF.CharStrings[i], r, s, h, B)
          } else C.glyf && A.U._drawGlyf(i, C, B)
          return B
        }),
        (A.U._drawGlyf = function (C, i, B) {
          var o = i.glyf[C]
          ;(o == null && (o = i.glyf[C] = A.glyf._parseGlyf(i, C)),
            o != null && (o.noc > -1 ? A.U._simpleGlyph(o, B) : A.U._compoGlyph(o, i, B)))
        }),
        (A.U._simpleGlyph = function (C, i) {
          for (var B = 0; B < C.noc; B++) {
            for (var o = B == 0 ? 0 : C.endPts[B - 1] + 1, r = C.endPts[B], s = o; s <= r; s++) {
              var h = s == o ? r : s - 1,
                S = s == r ? o : s + 1,
                d = 1 & C.flags[s],
                w = 1 & C.flags[h],
                M = 1 & C.flags[S],
                K = C.xs[s],
                R = C.ys[s]
              if (s == o)
                if (d) {
                  if (!w) {
                    A.U.P.moveTo(i, K, R)
                    continue
                  }
                  A.U.P.moveTo(i, C.xs[h], C.ys[h])
                } else
                  w
                    ? A.U.P.moveTo(i, C.xs[h], C.ys[h])
                    : A.U.P.moveTo(i, (C.xs[h] + K) / 2, (C.ys[h] + R) / 2)
              d
                ? w && A.U.P.lineTo(i, K, R)
                : M
                  ? A.U.P.qcurveTo(i, K, R, C.xs[S], C.ys[S])
                  : A.U.P.qcurveTo(i, K, R, (K + C.xs[S]) / 2, (R + C.ys[S]) / 2)
            }
            A.U.P.closePath(i)
          }
        }),
        (A.U._compoGlyph = function (C, i, B) {
          for (var o = 0; o < C.parts.length; o++) {
            var r = { cmds: [], crds: [] },
              s = C.parts[o]
            A.U._drawGlyf(s.glyphIndex, i, r)
            for (var h = s.m, S = 0; S < r.crds.length; S += 2) {
              var d = r.crds[S],
                w = r.crds[S + 1]
              ;(B.crds.push(d * h.a + w * h.b + h.tx), B.crds.push(d * h.c + w * h.d + h.ty))
            }
            for (S = 0; S < r.cmds.length; S++) B.cmds.push(r.cmds[S])
          }
        }),
        (A.U._getGlyphClass = function (C, i) {
          var B = A._lctf.getInterval(i, C)
          return B == -1 ? 0 : i[B + 2]
        }),
        (A.U._applySubs = function (C, i, B, o) {
          for (var r = C.length - i - 1, s = 0; s < B.tabs.length; s++)
            if (B.tabs[s] != null) {
              var h,
                S = B.tabs[s]
              if (!S.coverage || (h = A._lctf.coverageIndex(S.coverage, C[i])) != -1) {
                if (B.ltype == 1) (C[i], S.fmt == 1 ? (C[i] = C[i] + S.delta) : (C[i] = S.newg[h]))
                else if (B.ltype == 4)
                  for (var d = S.vals[h], w = 0; w < d.length; w++) {
                    var M = d[w],
                      K = M.chain.length
                    if (!(K > r)) {
                      for (var R = !0, F = 0, L = 0; L < K; L++) {
                        for (; C[i + F + (1 + L)] == -1; ) F++
                        M.chain[L] != C[i + F + (1 + L)] && (R = !1)
                      }
                      if (R) {
                        for (C[i] = M.nglyph, L = 0; L < K + F; L++) C[i + L + 1] = -1
                        break
                      }
                    }
                  }
                else if (B.ltype == 5 && S.fmt == 2)
                  for (
                    var Y = A._lctf.getInterval(S.cDef, C[i]),
                      H = S.cDef[Y + 2],
                      V = S.scset[H],
                      j = 0;
                    j < V.length;
                    j++
                  ) {
                    var P = V[j],
                      AA = P.input
                    if (!(AA.length > r)) {
                      for (R = !0, L = 0; L < AA.length; L++) {
                        var X = A._lctf.getInterval(S.cDef, C[i + 1 + L])
                        if (Y == -1 && S.cDef[X + 2] != AA[L]) {
                          R = !1
                          break
                        }
                      }
                      if (R) {
                        var _ = P.substLookupRecords
                        for (w = 0; w < _.length; w += 2) (_[w], _[w + 1])
                      }
                    }
                  }
                else if (B.ltype == 6 && S.fmt == 3) {
                  if (
                    !A.U._glsCovered(C, S.backCvg, i - S.backCvg.length) ||
                    !A.U._glsCovered(C, S.inptCvg, i) ||
                    !A.U._glsCovered(C, S.ahedCvg, i + S.inptCvg.length)
                  )
                    continue
                  var eA = S.lookupRec
                  for (j = 0; j < eA.length; j += 2) {
                    Y = eA[j]
                    var CA = o[eA[j + 1]]
                    A.U._applySubs(C, i + Y, CA, o)
                  }
                }
              }
            }
        }),
        (A.U._glsCovered = function (C, i, B) {
          for (var o = 0; o < i.length; o++)
            if (A._lctf.coverageIndex(i[o], C[B + o]) == -1) return !1
          return !0
        }),
        (A.U.glyphsToPath = function (C, i, B) {
          for (var o = { cmds: [], crds: [] }, r = 0, s = 0; s < i.length; s++) {
            var h = i[s]
            if (h != -1) {
              for (
                var S = s < i.length - 1 && i[s + 1] != -1 ? i[s + 1] : 0,
                  d = A.U.glyphToPath(C, h),
                  w = 0;
                w < d.crds.length;
                w += 2
              )
                (o.crds.push(d.crds[w] + r), o.crds.push(d.crds[w + 1]))
              for (B && o.cmds.push(B), w = 0; w < d.cmds.length; w++) o.cmds.push(d.cmds[w])
              ;(B && o.cmds.push("X"),
                (r += C.hmtx.aWidth[h]),
                s < i.length - 1 && (r += A.U.getPairAdjustment(C, h, S)))
            }
          }
          return o
        }),
        (A.U.P = {}),
        (A.U.P.moveTo = function (C, i, B) {
          ;(C.cmds.push("M"), C.crds.push(i, B))
        }),
        (A.U.P.lineTo = function (C, i, B) {
          ;(C.cmds.push("L"), C.crds.push(i, B))
        }),
        (A.U.P.curveTo = function (C, i, B, o, r, s, h) {
          ;(C.cmds.push("C"), C.crds.push(i, B, o, r, s, h))
        }),
        (A.U.P.qcurveTo = function (C, i, B, o, r) {
          ;(C.cmds.push("Q"), C.crds.push(i, B, o, r))
        }),
        (A.U.P.closePath = function (C) {
          C.cmds.push("Z")
        }),
        (A.U._drawCFF = function (C, i, B, o, r) {
          for (
            var s = i.stack,
              h = i.nStems,
              S = i.haveWidth,
              d = i.width,
              w = i.open,
              M = 0,
              K = i.x,
              R = i.y,
              F = 0,
              L = 0,
              Y = 0,
              H = 0,
              V = 0,
              j = 0,
              P = 0,
              AA = 0,
              X = 0,
              _ = 0,
              eA = { val: 0, size: 0 };
            M < C.length;
          ) {
            A.CFF.getCharString(C, M, eA)
            var CA = eA.val
            if (((M += eA.size), CA == "o1" || CA == "o18"))
              (s.length % 2 != 0 && !S && (d = s.shift() + o.nominalWidthX),
                (h += s.length >> 1),
                (s.length = 0),
                (S = !0))
            else if (CA == "o3" || CA == "o23")
              (s.length % 2 != 0 && !S && (d = s.shift() + o.nominalWidthX),
                (h += s.length >> 1),
                (s.length = 0),
                (S = !0))
            else if (CA == "o4")
              (s.length > 1 && !S && ((d = s.shift() + o.nominalWidthX), (S = !0)),
                w && A.U.P.closePath(r),
                (R += s.pop()),
                A.U.P.moveTo(r, K, R),
                (w = !0))
            else if (CA == "o5")
              for (; s.length > 0; ) ((K += s.shift()), (R += s.shift()), A.U.P.lineTo(r, K, R))
            else if (CA == "o6" || CA == "o7")
              for (var aA = s.length, lA = CA == "o6", JA = 0; JA < aA; JA++) {
                var yA = s.shift()
                ;(lA ? (K += yA) : (R += yA), (lA = !lA), A.U.P.lineTo(r, K, R))
              }
            else if (CA == "o8" || CA == "o24") {
              aA = s.length
              for (var LA = 0; LA + 6 <= aA; )
                ((F = K + s.shift()),
                  (L = R + s.shift()),
                  (Y = F + s.shift()),
                  (H = L + s.shift()),
                  (K = Y + s.shift()),
                  (R = H + s.shift()),
                  A.U.P.curveTo(r, F, L, Y, H, K, R),
                  (LA += 6))
              CA == "o24" && ((K += s.shift()), (R += s.shift()), A.U.P.lineTo(r, K, R))
            } else {
              if (CA == "o11") break
              if (CA == "o1234" || CA == "o1235" || CA == "o1236" || CA == "o1237")
                (CA == "o1234" &&
                  ((L = R),
                  (Y = (F = K + s.shift()) + s.shift()),
                  (_ = H = L + s.shift()),
                  (j = H),
                  (AA = R),
                  (K = (P = (V = (X = Y + s.shift()) + s.shift()) + s.shift()) + s.shift()),
                  A.U.P.curveTo(r, F, L, Y, H, X, _),
                  A.U.P.curveTo(r, V, j, P, AA, K, R)),
                  CA == "o1235" &&
                    ((F = K + s.shift()),
                    (L = R + s.shift()),
                    (Y = F + s.shift()),
                    (H = L + s.shift()),
                    (X = Y + s.shift()),
                    (_ = H + s.shift()),
                    (V = X + s.shift()),
                    (j = _ + s.shift()),
                    (P = V + s.shift()),
                    (AA = j + s.shift()),
                    (K = P + s.shift()),
                    (R = AA + s.shift()),
                    s.shift(),
                    A.U.P.curveTo(r, F, L, Y, H, X, _),
                    A.U.P.curveTo(r, V, j, P, AA, K, R)),
                  CA == "o1236" &&
                    ((F = K + s.shift()),
                    (L = R + s.shift()),
                    (Y = F + s.shift()),
                    (_ = H = L + s.shift()),
                    (j = H),
                    (P = (V = (X = Y + s.shift()) + s.shift()) + s.shift()),
                    (AA = j + s.shift()),
                    (K = P + s.shift()),
                    A.U.P.curveTo(r, F, L, Y, H, X, _),
                    A.U.P.curveTo(r, V, j, P, AA, K, R)),
                  CA == "o1237" &&
                    ((F = K + s.shift()),
                    (L = R + s.shift()),
                    (Y = F + s.shift()),
                    (H = L + s.shift()),
                    (X = Y + s.shift()),
                    (_ = H + s.shift()),
                    (V = X + s.shift()),
                    (j = _ + s.shift()),
                    (P = V + s.shift()),
                    (AA = j + s.shift()),
                    Math.abs(P - K) > Math.abs(AA - R) ? (K = P + s.shift()) : (R = AA + s.shift()),
                    A.U.P.curveTo(r, F, L, Y, H, X, _),
                    A.U.P.curveTo(r, V, j, P, AA, K, R)))
              else if (CA == "o14") {
                if (
                  (s.length > 0 && !S && ((d = s.shift() + B.nominalWidthX), (S = !0)),
                  s.length == 4)
                ) {
                  var nA = s.shift(),
                    fA = s.shift(),
                    sA = s.shift(),
                    $ = s.shift(),
                    EA = A.CFF.glyphBySE(B, sA),
                    GA = A.CFF.glyphBySE(B, $)
                  ;(A.U._drawCFF(B.CharStrings[EA], i, B, o, r),
                    (i.x = nA),
                    (i.y = fA),
                    A.U._drawCFF(B.CharStrings[GA], i, B, o, r))
                }
                w && (A.U.P.closePath(r), (w = !1))
              } else if (CA == "o19" || CA == "o20")
                (s.length % 2 != 0 && !S && (d = s.shift() + o.nominalWidthX),
                  (h += s.length >> 1),
                  (s.length = 0),
                  (S = !0),
                  (M += (h + 7) >> 3))
              else if (CA == "o21")
                (s.length > 2 && !S && ((d = s.shift() + o.nominalWidthX), (S = !0)),
                  (R += s.pop()),
                  (K += s.pop()),
                  w && A.U.P.closePath(r),
                  A.U.P.moveTo(r, K, R),
                  (w = !0))
              else if (CA == "o22")
                (s.length > 1 && !S && ((d = s.shift() + o.nominalWidthX), (S = !0)),
                  (K += s.pop()),
                  w && A.U.P.closePath(r),
                  A.U.P.moveTo(r, K, R),
                  (w = !0))
              else if (CA == "o25") {
                for (; s.length > 6; ) ((K += s.shift()), (R += s.shift()), A.U.P.lineTo(r, K, R))
                ;((F = K + s.shift()),
                  (L = R + s.shift()),
                  (Y = F + s.shift()),
                  (H = L + s.shift()),
                  (K = Y + s.shift()),
                  (R = H + s.shift()),
                  A.U.P.curveTo(r, F, L, Y, H, K, R))
              } else if (CA == "o26")
                for (s.length % 2 && (K += s.shift()); s.length > 0; )
                  ((F = K),
                    (L = R + s.shift()),
                    (K = Y = F + s.shift()),
                    (R = (H = L + s.shift()) + s.shift()),
                    A.U.P.curveTo(r, F, L, Y, H, K, R))
              else if (CA == "o27")
                for (s.length % 2 && (R += s.shift()); s.length > 0; )
                  ((L = R),
                    (Y = (F = K + s.shift()) + s.shift()),
                    (H = L + s.shift()),
                    (K = Y + s.shift()),
                    (R = H),
                    A.U.P.curveTo(r, F, L, Y, H, K, R))
              else if (CA == "o10" || CA == "o29") {
                var DA = CA == "o10" ? o : B
                if (s.length == 0) console.debug("error: empty stack")
                else {
                  var dA = s.pop(),
                    kA = DA.Subrs[dA + DA.Bias]
                  ;((i.x = K),
                    (i.y = R),
                    (i.nStems = h),
                    (i.haveWidth = S),
                    (i.width = d),
                    (i.open = w),
                    A.U._drawCFF(kA, i, B, o, r),
                    (K = i.x),
                    (R = i.y),
                    (h = i.nStems),
                    (S = i.haveWidth),
                    (d = i.width),
                    (w = i.open))
                }
              } else if (CA == "o30" || CA == "o31") {
                var NA = s.length,
                  qA = ((LA = 0), CA == "o31")
                for (LA += NA - (aA = -3 & NA); LA < aA; )
                  (qA
                    ? ((L = R),
                      (Y = (F = K + s.shift()) + s.shift()),
                      (R = (H = L + s.shift()) + s.shift()),
                      aA - LA == 5 ? ((K = Y + s.shift()), LA++) : (K = Y),
                      (qA = !1))
                    : ((F = K),
                      (L = R + s.shift()),
                      (Y = F + s.shift()),
                      (H = L + s.shift()),
                      (K = Y + s.shift()),
                      aA - LA == 5 ? ((R = H + s.shift()), LA++) : (R = H),
                      (qA = !0)),
                    A.U.P.curveTo(r, F, L, Y, H, K, R),
                    (LA += 4))
              } else {
                if ((CA + "").charAt(0) == "o")
                  throw (console.debug("Unknown operation: " + CA, C), CA)
                s.push(CA)
              }
            }
          }
          ;((i.x = K), (i.y = R), (i.nStems = h), (i.haveWidth = S), (i.width = d), (i.open = w))
        }))
      var I = A,
        g = { Typr: I }
      return (
        (e.Typr = I),
        (e.default = g),
        Object.defineProperty(e, "__esModule", { value: !0 }),
        e
      )
    })({}).Typr
  )
}
/*!
Custom bundle of woff2otf (https://github.com/arty-name/woff2otf) with fflate
(https://github.com/101arrowz/fflate) for use in Troika text rendering. 
Original licenses apply: 
- fflate: https://github.com/101arrowz/fflate/blob/master/LICENSE (MIT)
- woff2otf.js: https://github.com/arty-name/woff2otf/blob/master/woff2otf.js (Apache2)
*/
function D9() {
  return (function (e) {
    var A = Uint8Array,
      I = Uint16Array,
      g = Uint32Array,
      C = new A([
        0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0,
        0,
      ]),
      i = new A([
        0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12,
        13, 13, 0, 0,
      ]),
      B = new A([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
      o = function (CA, aA) {
        for (var lA = new I(31), JA = 0; JA < 31; ++JA) lA[JA] = aA += 1 << CA[JA - 1]
        var yA = new g(lA[30])
        for (JA = 1; JA < 30; ++JA)
          for (var LA = lA[JA]; LA < lA[JA + 1]; ++LA) yA[LA] = ((LA - lA[JA]) << 5) | JA
        return [lA, yA]
      },
      r = o(C, 2),
      s = r[0],
      h = r[1]
    ;((s[28] = 258), (h[258] = 28))
    for (var S = o(i, 0)[0], d = new I(32768), w = 0; w < 32768; ++w) {
      var M = ((43690 & w) >>> 1) | ((21845 & w) << 1)
      ;((M = ((61680 & (M = ((52428 & M) >>> 2) | ((13107 & M) << 2))) >>> 4) | ((3855 & M) << 4)),
        (d[w] = (((65280 & M) >>> 8) | ((255 & M) << 8)) >>> 1))
    }
    var K = function (CA, aA, lA) {
        for (var JA = CA.length, yA = 0, LA = new I(aA); yA < JA; ++yA) ++LA[CA[yA] - 1]
        var nA,
          fA = new I(aA)
        for (yA = 0; yA < aA; ++yA) fA[yA] = (fA[yA - 1] + LA[yA - 1]) << 1
        {
          nA = new I(1 << aA)
          var sA = 15 - aA
          for (yA = 0; yA < JA; ++yA)
            if (CA[yA])
              for (
                var $ = (yA << 4) | CA[yA],
                  EA = aA - CA[yA],
                  GA = fA[CA[yA] - 1]++ << EA,
                  DA = GA | ((1 << EA) - 1);
                GA <= DA;
                ++GA
              )
                nA[d[GA] >>> sA] = $
        }
        return nA
      },
      R = new A(288)
    for (w = 0; w < 144; ++w) R[w] = 8
    for (w = 144; w < 256; ++w) R[w] = 9
    for (w = 256; w < 280; ++w) R[w] = 7
    for (w = 280; w < 288; ++w) R[w] = 8
    var F = new A(32)
    for (w = 0; w < 32; ++w) F[w] = 5
    var L = K(R, 9),
      Y = K(F, 5),
      H = function (CA) {
        for (var aA = CA[0], lA = 1; lA < CA.length; ++lA) CA[lA] > aA && (aA = CA[lA])
        return aA
      },
      V = function (CA, aA, lA) {
        var JA = (aA / 8) | 0
        return ((CA[JA] | (CA[JA + 1] << 8)) >> (7 & aA)) & lA
      },
      j = function (CA, aA) {
        var lA = (aA / 8) | 0
        return (CA[lA] | (CA[lA + 1] << 8) | (CA[lA + 2] << 16)) >> (7 & aA)
      },
      P = [
        "unexpected EOF",
        "invalid block type",
        "invalid length/literal",
        "invalid distance",
        "stream finished",
        "no stream handler",
        ,
        "no callback",
        "invalid UTF-8 data",
        "extra field too long",
        "date not in range 1980-2099",
        "filename too long",
        "stream finishing",
        "invalid zip data",
      ],
      AA = function (CA, aA, lA) {
        var JA = new Error(aA || P[CA])
        if (((JA.code = CA), Error.captureStackTrace && Error.captureStackTrace(JA, AA), !lA))
          throw JA
        return JA
      },
      X = function (CA, aA, lA) {
        var JA = CA.length
        if (!JA || (lA && !lA.l && JA < 5)) return aA || new A(0)
        var yA = !aA || lA,
          LA = !lA || lA.i
        ;(lA || (lA = {}), aA || (aA = new A(3 * JA)))
        var nA,
          fA = function (VA) {
            var ag = aA.length
            if (VA > ag) {
              var XI = new A(Math.max(2 * ag, VA))
              ;(XI.set(aA), (aA = XI))
            }
          },
          sA = lA.f || 0,
          $ = lA.p || 0,
          EA = lA.b || 0,
          GA = lA.l,
          DA = lA.d,
          dA = lA.m,
          kA = lA.n,
          NA = 8 * JA
        do {
          if (!GA) {
            lA.f = sA = V(CA, $, 1)
            var qA = V(CA, $ + 1, 3)
            if ((($ += 3), !qA)) {
              var ZA = CA[(SI = (((nA = $) / 8) | 0) + (7 & nA && 1) + 4) - 4] | (CA[SI - 3] << 8),
                sI = SI + ZA
              if (sI > JA) {
                LA && AA(0)
                break
              }
              ;(yA && fA(EA + ZA),
                aA.set(CA.subarray(SI, sI), EA),
                (lA.b = EA += ZA),
                (lA.p = $ = 8 * sI))
              continue
            }
            if (qA == 1) ((GA = L), (DA = Y), (dA = 9), (kA = 5))
            else if (qA == 2) {
              var cI = V(CA, $, 31) + 257,
                YA = V(CA, $ + 10, 15) + 4,
                eI = cI + V(CA, $ + 5, 31) + 1
              $ += 14
              for (var uA = new A(eI), hI = new A(19), II = 0; II < YA; ++II)
                hI[B[II]] = V(CA, $ + 3 * II, 7)
              $ += 3 * YA
              var pI = H(hI),
                AI = (1 << pI) - 1,
                YI = K(hI, pI)
              for (II = 0; II < eI; ) {
                var SI,
                  QA = YI[V(CA, $, AI)]
                if ((($ += 15 & QA), (SI = QA >>> 4) < 16)) uA[II++] = SI
                else {
                  var tA = 0,
                    FA = 0
                  for (
                    SI == 16
                      ? ((FA = 3 + V(CA, $, 3)), ($ += 2), (tA = uA[II - 1]))
                      : SI == 17
                        ? ((FA = 3 + V(CA, $, 7)), ($ += 3))
                        : SI == 18 && ((FA = 11 + V(CA, $, 127)), ($ += 7));
                    FA--;
                  )
                    uA[II++] = tA
                }
              }
              var WA = uA.subarray(0, cI),
                jA = uA.subarray(cI)
              ;((dA = H(WA)), (kA = H(jA)), (GA = K(WA, dA)), (DA = K(jA, kA)))
            } else AA(1)
            if ($ > NA) {
              LA && AA(0)
              break
            }
          }
          yA && fA(EA + 131072)
          for (var nI = (1 << dA) - 1, UI = (1 << kA) - 1, GI = $; ; GI = $) {
            var LI = (tA = GA[j(CA, $) & nI]) >>> 4
            if (($ += 15 & tA) > NA) {
              LA && AA(0)
              break
            }
            if ((tA || AA(2), LI < 256)) aA[EA++] = LI
            else {
              if (LI == 256) {
                ;((GI = $), (GA = null))
                break
              }
              var Bg = LI - 254
              if (LI > 264) {
                var MA = C[(II = LI - 257)]
                ;((Bg = V(CA, $, (1 << MA) - 1) + s[II]), ($ += MA))
              }
              var OA = DA[j(CA, $) & UI],
                aI = OA >>> 4
              if (
                (OA || AA(3),
                ($ += 15 & OA),
                (jA = S[aI]),
                aI > 3 && ((MA = i[aI]), (jA += j(CA, $) & ((1 << MA) - 1)), ($ += MA)),
                $ > NA)
              ) {
                LA && AA(0)
                break
              }
              yA && fA(EA + 131072)
              for (var RI = EA + Bg; EA < RI; EA += 4)
                ((aA[EA] = aA[EA - jA]),
                  (aA[EA + 1] = aA[EA + 1 - jA]),
                  (aA[EA + 2] = aA[EA + 2 - jA]),
                  (aA[EA + 3] = aA[EA + 3 - jA]))
              EA = RI
            }
          }
          ;((lA.l = GA),
            (lA.p = GI),
            (lA.b = EA),
            GA && ((sA = 1), (lA.m = dA), (lA.d = DA), (lA.n = kA)))
        } while (!sA)
        return EA == aA.length
          ? aA
          : (function (VA, ag, XI) {
              ;(XI == null || XI > VA.length) && (XI = VA.length)
              var $I = new (VA instanceof I ? I : VA instanceof g ? g : A)(XI - ag)
              return ($I.set(VA.subarray(ag, XI)), $I)
            })(aA, 0, EA)
      },
      _ = new A(0),
      eA = typeof TextDecoder < "u" && new TextDecoder()
    try {
      eA.decode(_, { stream: !0 })
    } catch {}
    return (
      (e.convert_streams = function (CA) {
        var aA = new DataView(CA),
          lA = 0
        function JA() {
          var cI = aA.getUint16(lA)
          return ((lA += 2), cI)
        }
        function yA() {
          var cI = aA.getUint32(lA)
          return ((lA += 4), cI)
        }
        function LA(cI) {
          ;(ZA.setUint16(sI, cI), (sI += 2))
        }
        function nA(cI) {
          ;(ZA.setUint32(sI, cI), (sI += 4))
        }
        for (
          var fA = {
              signature: yA(),
              flavor: yA(),
              length: yA(),
              numTables: JA(),
              reserved: JA(),
              totalSfntSize: yA(),
              majorVersion: JA(),
              minorVersion: JA(),
              metaOffset: yA(),
              metaLength: yA(),
              metaOrigLength: yA(),
              privOffset: yA(),
              privLength: yA(),
            },
            sA = 0;
          Math.pow(2, sA) <= fA.numTables;
        )
          sA++
        sA--
        for (
          var $ = 16 * Math.pow(2, sA), EA = 16 * fA.numTables - $, GA = 12, DA = [], dA = 0;
          dA < fA.numTables;
          dA++
        )
          (DA.push({
            tag: yA(),
            offset: yA(),
            compLength: yA(),
            origLength: yA(),
            origChecksum: yA(),
          }),
            (GA += 16))
        var kA,
          NA = new Uint8Array(
            12 +
              16 * DA.length +
              DA.reduce(function (cI, YA) {
                return cI + YA.origLength + 4
              }, 0),
          ),
          qA = NA.buffer,
          ZA = new DataView(qA),
          sI = 0
        return (
          nA(fA.flavor),
          LA(fA.numTables),
          LA($),
          LA(sA),
          LA(EA),
          DA.forEach(function (cI) {
            ;(nA(cI.tag),
              nA(cI.origChecksum),
              nA(GA),
              nA(cI.origLength),
              (cI.outOffset = GA),
              (GA += cI.origLength) % 4 != 0 && (GA += 4 - (GA % 4)))
          }),
          DA.forEach(function (cI) {
            var YA,
              eI = CA.slice(cI.offset, cI.offset + cI.compLength)
            if (cI.compLength != cI.origLength) {
              var uA = new Uint8Array(cI.origLength)
              ;((YA = new Uint8Array(eI, 2)), X(YA, uA))
            } else uA = new Uint8Array(eI)
            NA.set(uA, cI.outOffset)
            var hI = 0
            ;((GA = cI.outOffset + cI.origLength) % 4 != 0 && (hI = 4 - (GA % 4)),
              NA.set(new Uint8Array(hI).buffer, cI.outOffset + cI.origLength),
              (kA = GA + hI))
          }),
          qA.slice(0, kA)
        )
      }),
      Object.defineProperty(e, "__esModule", { value: !0 }),
      e
    )
  })({}).convert_streams
}
function S9(e, A) {
  const I = {
      M: 2,
      L: 2,
      Q: 4,
      C: 6,
      Z: 0,
    },
    g = {
      C: "18g,ca,368,1kz",
      D: "17k,6,2,2+4,5+c,2+6,2+1,10+1,9+f,j+11,2+1,a,2,2+1,15+2,3,j+2,6+3,2+8,2,2,2+1,w+a,4+e,3+3,2,3+2,3+5,23+w,2f+4,3,2+9,2,b,2+3,3,1k+9,6+1,3+1,2+2,2+d,30g,p+y,1,1+1g,f+x,2,sd2+1d,jf3+4,f+3,2+4,2+2,b+3,42,2,4+2,2+1,2,3,t+1,9f+w,2,el+2,2+g,d+2,2l,2+1,5,3+1,2+1,2,3,6,16wm+1v",
      R: "17m+3,2,2,6+3,m,15+2,2+2,h+h,13,3+8,2,2,3+1,2,p+1,x,5+4,5,a,2,2,3,u,c+2,g+1,5,2+1,4+1,5j,6+1,2,b,2+2,f,2+1,1s+2,2,3+1,7,1ez0,2,2+1,4+4,b,4,3,b,42,2+2,4,3,2+1,2,o+3,ae,ep,x,2o+2,3+1,3,5+1,6",
      L: "x9u,jff,a,fd,jv",
      T: "4t,gj+33,7o+4,1+1,7c+18,2,2+1,2+1,2,21+a,2,1b+k,h,2u+6,3+5,3+1,2+3,y,2,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,3,7,6+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+d,1,1+1,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,ek,3+1,r+4,1e+4,6+5,2p+c,1+3,1,1+2,1+b,2db+2,3y,2p+v,ff+3,30+1,n9x,1+2,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,5s,6y+2,ea,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+9,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2,2b+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,470+8,at4+4,1o+6,t5,1s+3,2a,f5l+1,2+3,43o+2,a+7,1+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,1,gzau,v+2n,3l+6n",
    },
    C = 1,
    i = 2,
    B = 4,
    o = 8,
    r = 16,
    s = 32
  let h
  function S(P) {
    if (!h) {
      const AA = {
        R: i,
        L: C,
        D: B,
        C: r,
        U: s,
        T: o,
      }
      h = /* @__PURE__ */ new Map()
      for (let X in g) {
        let _ = 0
        g[X].split(",").forEach((eA) => {
          let [CA, aA] = eA.split("+")
          ;((CA = parseInt(CA, 36)), (aA = aA ? parseInt(aA, 36) : 0), h.set((_ += CA), AA[X]))
          for (let lA = aA; lA--; ) h.set(++_, AA[X])
        })
      }
    }
    return h.get(P) || s
  }
  const d = 1,
    w = 2,
    M = 3,
    K = 4,
    R = [null, "isol", "init", "fina", "medi"]
  function F(P) {
    const AA = new Uint8Array(P.length)
    let X = s,
      _ = d,
      eA = -1
    for (let CA = 0; CA < P.length; CA++) {
      const aA = P.codePointAt(CA)
      let lA = S(aA) | 0,
        JA = d
      lA & o ||
        (X & (C | B | r)
          ? lA & (i | B | r)
            ? ((JA = M), (_ === d || _ === M) && AA[eA]++)
            : lA & (C | s) && (_ === w || _ === K) && AA[eA]--
          : X & (i | s) && (_ === w || _ === K) && AA[eA]--,
        (_ = AA[CA] = JA),
        (X = lA),
        (eA = CA),
        aA > 65535 && CA++)
    }
    return AA
  }
  function L(P, AA) {
    const X = []
    for (let eA = 0; eA < AA.length; eA++) {
      const CA = AA.codePointAt(eA)
      ;(CA > 65535 && eA++, X.push(e.U.codeToGlyph(P, CA)))
    }
    const _ = P.GSUB
    if (_) {
      const { lookupList: eA, featureList: CA } = _
      let aA
      const lA = /^(rlig|liga|mset|isol|init|fina|medi|half|pres|blws|ccmp)$/,
        JA = []
      CA.forEach((yA) => {
        if (lA.test(yA.tag))
          for (let LA = 0; LA < yA.tab.length; LA++) {
            if (JA[yA.tab[LA]]) continue
            JA[yA.tab[LA]] = !0
            const nA = eA[yA.tab[LA]],
              fA = /^(isol|init|fina|medi)$/.test(yA.tag)
            fA && !aA && (aA = F(AA))
            for (let sA = 0; sA < X.length; sA++)
              (!aA || !fA || R[aA[sA]] === yA.tag) && e.U._applySubs(X, sA, nA, eA)
          }
      })
    }
    return X
  }
  function Y(P, AA) {
    const X = new Int16Array(AA.length * 3)
    let _ = 0
    for (; _ < AA.length; _++) {
      const lA = AA[_]
      if (lA === -1) continue
      X[_ * 3 + 2] = P.hmtx.aWidth[lA]
      const JA = P.GPOS
      if (JA) {
        const yA = JA.lookupList
        for (let LA = 0; LA < yA.length; LA++) {
          const nA = yA[LA]
          for (let fA = 0; fA < nA.tabs.length; fA++) {
            const sA = nA.tabs[fA]
            if (nA.ltype === 1) {
              if (e._lctf.coverageIndex(sA.coverage, lA) !== -1 && sA.pos) {
                aA(sA.pos, _)
                break
              }
            } else if (nA.ltype === 2) {
              let $ = null,
                EA = eA()
              if (EA !== -1) {
                const GA = e._lctf.coverageIndex(sA.coverage, AA[EA])
                if (GA !== -1) {
                  if (sA.fmt === 1) {
                    const DA = sA.pairsets[GA]
                    for (let dA = 0; dA < DA.length; dA++) DA[dA].gid2 === lA && ($ = DA[dA])
                  } else if (sA.fmt === 2) {
                    const DA = e.U._getGlyphClass(AA[EA], sA.classDef1),
                      dA = e.U._getGlyphClass(lA, sA.classDef2)
                    $ = sA.matrix[DA][dA]
                  }
                  if ($) {
                    ;($.val1 && aA($.val1, EA), $.val2 && aA($.val2, _))
                    break
                  }
                }
              }
            } else if (nA.ltype === 4) {
              const $ = e._lctf.coverageIndex(sA.markCoverage, lA)
              if ($ !== -1) {
                const EA = eA(CA),
                  GA = EA === -1 ? -1 : e._lctf.coverageIndex(sA.baseCoverage, AA[EA])
                if (GA !== -1) {
                  const DA = sA.markArray[$],
                    dA = sA.baseArray[GA][DA.markClass]
                  ;((X[_ * 3] = dA.x - DA.x + X[EA * 3] - X[EA * 3 + 2]),
                    (X[_ * 3 + 1] = dA.y - DA.y + X[EA * 3 + 1]))
                  break
                }
              }
            } else if (nA.ltype === 6) {
              const $ = e._lctf.coverageIndex(sA.mark1Coverage, lA)
              if ($ !== -1) {
                const EA = eA()
                if (EA !== -1) {
                  const GA = AA[EA]
                  if (H(P, GA) === 3) {
                    const DA = e._lctf.coverageIndex(sA.mark2Coverage, GA)
                    if (DA !== -1) {
                      const dA = sA.mark1Array[$],
                        kA = sA.mark2Array[DA][dA.markClass]
                      ;((X[_ * 3] = kA.x - dA.x + X[EA * 3] - X[EA * 3 + 2]),
                        (X[_ * 3 + 1] = kA.y - dA.y + X[EA * 3 + 1]))
                      break
                    }
                  }
                }
              }
            }
          }
        }
      } else if (P.kern && !P.cff) {
        const yA = eA()
        if (yA !== -1) {
          const LA = P.kern.glyph1.indexOf(AA[yA])
          if (LA !== -1) {
            const nA = P.kern.rval[LA].glyph2.indexOf(lA)
            nA !== -1 && (X[yA * 3 + 2] += P.kern.rval[LA].vals[nA])
          }
        }
      }
    }
    return X
    function eA(lA) {
      for (let JA = _ - 1; JA >= 0; JA--) if (AA[JA] !== -1 && (!lA || lA(AA[JA]))) return JA
      return -1
    }
    function CA(lA) {
      return H(P, lA) === 1
    }
    function aA(lA, JA) {
      for (let yA = 0; yA < 3; yA++) X[JA * 3 + yA] += lA[yA] || 0
    }
  }
  function H(P, AA) {
    const X = P.GDEF && P.GDEF.glyphClassDef
    return X ? e.U._getGlyphClass(AA, X) : 0
  }
  function V(...P) {
    for (let AA = 0; AA < P.length; AA++) if (typeof P[AA] == "number") return P[AA]
  }
  function j(P) {
    const AA = /* @__PURE__ */ Object.create(null),
      X = P["OS/2"],
      _ = P.hhea,
      eA = P.head.unitsPerEm,
      CA = V(X && X.sTypoAscender, _ && _.ascender, eA),
      aA = {
        unitsPerEm: eA,
        ascender: CA,
        descender: V(X && X.sTypoDescender, _ && _.descender, 0),
        capHeight: V(X && X.sCapHeight, CA),
        xHeight: V(X && X.sxHeight, CA),
        lineGap: V(X && X.sTypoLineGap, _ && _.lineGap),
        supportsCodePoint(lA) {
          return e.U.codeToGlyph(P, lA) > 0
        },
        forEachGlyph(lA, JA, yA, LA) {
          let nA = 0
          const fA = (1 / aA.unitsPerEm) * JA,
            sA = L(P, lA)
          let $ = 0
          const EA = Y(P, sA)
          return (
            sA.forEach((GA, DA) => {
              if (GA !== -1) {
                let dA = AA[GA]
                if (!dA) {
                  const { cmds: kA, crds: NA } = e.U.glyphToPath(P, GA)
                  let qA = "",
                    ZA = 0
                  for (let uA = 0, hI = kA.length; uA < hI; uA++) {
                    const II = I[kA[uA]]
                    qA += kA[uA]
                    for (let pI = 1; pI <= II; pI++) qA += (pI > 1 ? "," : "") + NA[ZA++]
                  }
                  let sI, cI, YA, eI
                  if (NA.length) {
                    ;((sI = cI = 1 / 0), (YA = eI = -1 / 0))
                    for (let uA = 0, hI = NA.length; uA < hI; uA += 2) {
                      let II = NA[uA],
                        pI = NA[uA + 1]
                      ;(II < sI && (sI = II),
                        pI < cI && (cI = pI),
                        II > YA && (YA = II),
                        pI > eI && (eI = pI))
                    }
                  } else sI = YA = cI = eI = 0
                  dA = AA[GA] = {
                    index: GA,
                    advanceWidth: P.hmtx.aWidth[GA],
                    xMin: sI,
                    yMin: cI,
                    xMax: YA,
                    yMax: eI,
                    path: qA,
                  }
                }
                ;(LA.call(null, dA, nA + EA[DA * 3] * fA, EA[DA * 3 + 1] * fA, $),
                  (nA += EA[DA * 3 + 2] * fA),
                  yA && (nA += yA * JA))
              }
              $ += lA.codePointAt($) > 65535 ? 2 : 1
            }),
            nA
          )
        },
      }
    return aA
  }
  return function (AA) {
    const X = new Uint8Array(AA, 0, 4),
      _ = e._bin.readASCII(X, 0, 4)
    if (_ === "wOFF") AA = A(AA)
    else if (_ === "wOF2") throw new Error("woff2 fonts not supported")
    return j(e.parse(AA)[0])
  }
}
const f9 = /* @__PURE__ */ Up({
  name: "Typr Font Parser",
  dependencies: [u9, D9, S9],
  init(e, A, I) {
    const g = e(),
      C = A()
    return I(g, C)
  },
})
/*!
Custom bundle of @unicode-font-resolver/client v1.0.2 (https://github.com/lojjic/unicode-font-resolver)
for use in Troika text rendering. 
Original MIT license applies
*/
function d9() {
  return (function (e) {
    var A = function () {
      this.buckets = /* @__PURE__ */ new Map()
    }
    ;((A.prototype.add = function (Y) {
      var H = Y >> 5
      this.buckets.set(H, (this.buckets.get(H) || 0) | (1 << (31 & Y)))
    }),
      (A.prototype.has = function (Y) {
        var H = this.buckets.get(Y >> 5)
        return H !== void 0 && (H & (1 << (31 & Y))) != 0
      }),
      (A.prototype.serialize = function () {
        var Y = []
        return (
          this.buckets.forEach(function (H, V) {
            Y.push((+V).toString(36) + ":" + H.toString(36))
          }),
          Y.join(",")
        )
      }),
      (A.prototype.deserialize = function (Y) {
        var H = this
        ;(this.buckets.clear(),
          Y.split(",").forEach(function (V) {
            var j = V.split(":")
            H.buckets.set(parseInt(j[0], 36), parseInt(j[1], 36))
          }))
      }))
    var I = Math.pow(2, 8),
      g = I - 1,
      C = ~g
    function i(Y) {
      var H = (function (j) {
          return j & C
        })(Y).toString(16),
        V = (function (j) {
          return (j & C) + I - 1
        })(Y).toString(16)
      return "codepoint-index/plane" + (Y >> 16) + "/" + H + "-" + V + ".json"
    }
    function B(Y, H) {
      var V = Y & g,
        j = H.codePointAt((V / 6) | 0)
      return ((j = (j || 48) - 48) & (1 << (V % 6))) != 0
    }
    function o(Y, H) {
      var V
      ;((V = Y),
      V.replace(/U\+/gi, "")
        .replace(/^,+|,+$/g, "")
        .split(/,+/)
        .map(function (j) {
          return j.split("-").map(function (P) {
            return parseInt(P.trim(), 16)
          })
        })).forEach(function (j) {
        var P = j[0],
          AA = j[1]
        ;(AA === void 0 && (AA = P), H(P, AA))
      })
    }
    function r(Y, H) {
      o(Y, function (V, j) {
        for (var P = V; P <= j; P++) H(P)
      })
    }
    var s = {},
      h = {},
      S = /* @__PURE__ */ new WeakMap(),
      d = "https://cdn.jsdelivr.net/gh/lojjic/unicode-font-resolver@v1.0.1/packages/data"
    function w(Y) {
      var H = S.get(Y)
      return (
        H ||
          ((H = new A()),
          r(Y.ranges, function (V) {
            return H.add(V)
          }),
          S.set(Y, H)),
        H
      )
    }
    var M,
      K = /* @__PURE__ */ new Map()
    function R(Y, H, V) {
      return Y[H]
        ? H
        : Y[V]
          ? V
          : (function (j) {
              for (var P in j) return P
            })(Y)
    }
    function F(Y, H) {
      var V = H
      if (!Y.includes(V)) {
        V = 1 / 0
        for (var j = 0; j < Y.length; j++) Math.abs(Y[j] - H) < Math.abs(V - H) && (V = Y[j])
      }
      return V
    }
    function L(Y) {
      return (
        M ||
          ((M = /* @__PURE__ */ new Set()),
          r("9-D,20,85,A0,1680,2000-200A,2028-202F,205F,3000", function (H) {
            M.add(H)
          })),
        M.has(Y)
      )
    }
    return (
      (e.CodePointSet = A),
      (e.clearCache = function () {
        ;((s = {}), (h = {}))
      }),
      (e.getFontsForString = function (Y, H) {
        H === void 0 && (H = {})
        var V,
          j = H.lang
        j === void 0 &&
          (j = /\p{Script=Hangul}/u.test((V = Y))
            ? "ko"
            : /\p{Script=Hiragana}|\p{Script=Katakana}/u.test(V)
              ? "ja"
              : "en")
        var P = H.category
        P === void 0 && (P = "sans-serif")
        var AA = H.style
        AA === void 0 && (AA = "normal")
        var X = H.weight
        X === void 0 && (X = 400)
        var _ = (H.dataUrl || d).replace(/\/$/g, ""),
          eA = /* @__PURE__ */ new Map(),
          CA = new Uint8Array(Y.length),
          aA = {},
          lA = {},
          JA = new Array(Y.length),
          yA = /* @__PURE__ */ new Map(),
          LA = !1
        function nA($) {
          var EA = K.get($)
          return (
            EA ||
              ((EA = fetch(_ + "/" + $)
                .then(function (GA) {
                  if (!GA.ok) throw new Error(GA.statusText)
                  return GA.json().then(function (DA) {
                    if (!Array.isArray(DA) || DA[0] !== 1)
                      throw new Error("Incorrect schema version; need 1, got " + DA[0])
                    return DA[1]
                  })
                })
                .catch(function (GA) {
                  if (_ !== d)
                    return (
                      LA ||
                        (console.error(
                          'unicode-font-resolver: Failed loading from dataUrl "' +
                            _ +
                            '", trying default CDN. ' +
                            GA.message,
                        ),
                        (LA = !0)),
                      (_ = d),
                      K.delete($),
                      nA($)
                    )
                  throw GA
                })),
              K.set($, EA)),
            EA
          )
        }
        for (
          var fA = function ($) {
              var EA = Y.codePointAt($),
                GA = i(EA)
              ;((JA[$] = GA),
                s[GA] ||
                  yA.has(GA) ||
                  yA.set(
                    GA,
                    nA(GA).then(function (DA) {
                      s[GA] = DA
                    }),
                  ),
                EA > 65535 && ($++, (sA = $)))
            },
            sA = 0;
          sA < Y.length;
          sA++
        )
          fA(sA)
        return Promise.all(yA.values())
          .then(function () {
            yA.clear()
            for (
              var $ = function (GA) {
                  var DA = Y.codePointAt(GA),
                    dA = null,
                    kA = s[JA[GA]],
                    NA = void 0
                  for (var qA in kA) {
                    var ZA = lA[qA]
                    if ((ZA === void 0 && (ZA = lA[qA] = new RegExp(qA).test(j || "en")), ZA)) {
                      for (var sI in ((NA = qA), kA[qA]))
                        if (B(DA, kA[qA][sI])) {
                          dA = sI
                          break
                        }
                      break
                    }
                  }
                  if (!dA) {
                    A: for (var cI in kA)
                      if (cI !== NA) {
                        for (var YA in kA[cI])
                          if (B(DA, kA[cI][YA])) {
                            dA = YA
                            break A
                          }
                      }
                  }
                  ;(dA ||
                    (console.debug("No font coverage for U+" + DA.toString(16)), (dA = "latin")),
                    (JA[GA] = dA),
                    h[dA] ||
                      yA.has(dA) ||
                      yA.set(
                        dA,
                        nA("font-meta/" + dA + ".json").then(function (eI) {
                          h[dA] = eI
                        }),
                      ),
                    DA > 65535 && (GA++, (EA = GA)))
                },
                EA = 0;
              EA < Y.length;
              EA++
            )
              $(EA)
            return Promise.all(yA.values())
          })
          .then(function () {
            for (var $, EA = null, GA = 0; GA < Y.length; GA++) {
              var DA = Y.codePointAt(GA)
              if (EA && (L(DA) || w(EA).has(DA))) CA[GA] = CA[GA - 1]
              else {
                EA = h[JA[GA]]
                var dA = aA[EA.id]
                if (!dA) {
                  var kA = EA.typeforms,
                    NA = R(kA, P, "sans-serif"),
                    qA = R(kA[NA], AA, "normal"),
                    ZA = F(($ = kA[NA]) === null || $ === void 0 ? void 0 : $[qA], X)
                  dA = aA[EA.id] =
                    _ + "/font-files/" + EA.id + "/" + NA + "." + qA + "." + ZA + ".woff"
                }
                var sI = eA.get(dA)
                ;(sI == null && ((sI = eA.size), eA.set(dA, sI)), (CA[GA] = sI))
              }
              DA > 65535 && (GA++, (CA[GA] = CA[GA - 1]))
            }
            return { fontUrls: Array.from(eA.keys()), chars: CA }
          })
      }),
      Object.defineProperty(e, "__esModule", { value: !0 }),
      e
    )
  })({})
}
function y9(e, A) {
  const I = /* @__PURE__ */ Object.create(null),
    g = /* @__PURE__ */ Object.create(null)
  function C(B, o) {
    const r = (s) => {
      console.error(`Failure loading font ${B}`, s)
    }
    try {
      const s = new XMLHttpRequest()
      ;(s.open("get", B, !0),
        (s.responseType = "arraybuffer"),
        (s.onload = function () {
          if (s.status >= 400) r(new Error(s.statusText))
          else if (s.status > 0)
            try {
              const h = e(s.response)
              ;((h.src = B), o(h))
            } catch (h) {
              r(h)
            }
        }),
        (s.onerror = r),
        s.send())
    } catch (s) {
      r(s)
    }
  }
  function i(B, o) {
    let r = I[B]
    r
      ? o(r)
      : g[B]
        ? g[B].push(o)
        : ((g[B] = [o]),
          C(B, (s) => {
            ;((s.src = B), (I[B] = s), g[B].forEach((h) => h(s)), delete g[B])
          }))
  }
  return function (
    B,
    o,
    { lang: r, fonts: s = [], style: h = "normal", weight: S = "normal", unicodeFontsURL: d } = {},
  ) {
    const w = new Uint8Array(B.length),
      M = []
    B.length || L()
    const K = /* @__PURE__ */ new Map(),
      R = []
    if (
      (h !== "italic" && (h = "normal"),
      typeof S != "number" && (S = S === "bold" ? 700 : 400),
      s && !Array.isArray(s) && (s = [s]),
      (s = s
        .slice()
        .filter((H) => !H.lang || H.lang.test(r))
        .reverse()),
      s.length)
    ) {
      let P = 0
      ;(function AA(X = 0) {
        for (let _ = X, eA = B.length; _ < eA; _++) {
          const CA = B.codePointAt(_)
          if ((P === 1 && M[w[_ - 1]].supportsCodePoint(CA)) || (_ > 0 && /\s/.test(B[_])))
            ((w[_] = w[_ - 1]), P === 2 && (R[R.length - 1][1] = _))
          else
            for (let aA = w[_], lA = s.length; aA <= lA; aA++)
              if (aA === lA) {
                const JA = P === 2 ? R[R.length - 1] : (R[R.length] = [_, _])
                ;((JA[1] = _), (P = 2))
              } else {
                w[_] = aA
                const { src: JA, unicodeRange: yA } = s[aA]
                if (!yA || Y(CA, yA)) {
                  const LA = I[JA]
                  if (!LA) {
                    i(JA, () => {
                      AA(_)
                    })
                    return
                  }
                  if (LA.supportsCodePoint(CA)) {
                    let nA = K.get(LA)
                    ;(typeof nA != "number" && ((nA = M.length), M.push(LA), K.set(LA, nA)),
                      (w[_] = nA),
                      (P = 1))
                    break
                  }
                }
              }
          CA > 65535 && _ + 1 < eA && ((w[_ + 1] = w[_]), _++, P === 2 && (R[R.length - 1][1] = _))
        }
        F()
      })()
    } else (R.push([0, B.length - 1]), F())
    function F() {
      if (R.length) {
        const H = R.map((V) => B.substring(V[0], V[1] + 1)).join(`
`)
        A.getFontsForString(H, {
          lang: r || void 0,
          style: h,
          weight: S,
          dataUrl: d,
        }).then(({ fontUrls: V, chars: j }) => {
          const P = M.length
          let AA = 0
          R.forEach((_) => {
            for (let eA = 0, CA = _[1] - _[0]; eA <= CA; eA++) w[_[0] + eA] = j[AA++] + P
            AA++
          })
          let X = 0
          V.forEach((_, eA) => {
            i(_, (CA) => {
              ;((M[eA + P] = CA), ++X === V.length && L())
            })
          })
        })
      } else L()
    }
    function L() {
      o({
        chars: w,
        fonts: M,
      })
    }
    function Y(H, V) {
      for (let j = 0; j < V.length; j++) {
        const [P, AA = P] = V[j]
        if (P <= H && H <= AA) return !0
      }
      return !1
    }
  }
}
const p9 = /* @__PURE__ */ Up({
  name: "FontResolver",
  dependencies: [y9, f9, d9],
  init(e, A, I) {
    return e(A, I())
  },
})
function w9(e, A) {
  const g =
      /[\u00AD\u034F\u061C\u115F-\u1160\u17B4-\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8]/,
    C = "[^\\S\\u00A0]",
    i = new RegExp(`${C}|[\\-\\u007C\\u00AD\\u2010\\u2012-\\u2014\\u2027\\u2056\\u2E17\\u2E40]`)
  function B(
    { text: M, lang: K, fonts: R, style: F, weight: L, preResolvedFonts: Y, unicodeFontsURL: H },
    V,
  ) {
    const j = ({ chars: P, fonts: AA }) => {
      let X, _
      const eA = []
      for (let CA = 0; CA < P.length; CA++)
        P[CA] !== _
          ? ((_ = P[CA]), eA.push((X = { start: CA, end: CA, fontObj: AA[P[CA]] })))
          : (X.end = CA)
      V(eA)
    }
    Y ? j(Y) : e(M, j, { lang: K, fonts: R, style: F, weight: L, unicodeFontsURL: H })
  }
  function o(
    {
      text: M = "",
      font: K,
      lang: R,
      sdfGlyphSize: F = 64,
      fontSize: L = 400,
      fontWeight: Y = 1,
      fontStyle: H = "normal",
      letterSpacing: V = 0,
      lineHeight: j = "normal",
      maxWidth: P = 1 / 0,
      direction: AA,
      textAlign: X = "left",
      textIndent: _ = 0,
      whiteSpace: eA = "normal",
      overflowWrap: CA = "normal",
      anchorX: aA = 0,
      anchorY: lA = 0,
      metricsOnly: JA = !1,
      unicodeFontsURL: yA,
      preResolvedFonts: LA = null,
      includeCaretPositions: nA = !1,
      chunkedBoundsSize: fA = 8192,
      colorRanges: sA = null,
    },
    $,
  ) {
    const EA = S(),
      GA = { fontLoad: 0, typesetting: 0 }
    ;(M.indexOf("\r") > -1 &&
      (console.info("Typesetter: got text with \\r chars; normalizing to \\n"),
      (M = M.replace(
        /\r\n/g,
        `
`,
      ).replace(
        /\r/g,
        `
`,
      ))),
      (L = +L),
      (V = +V),
      (P = +P),
      (j = j || "normal"),
      (_ = +_),
      B(
        {
          text: M,
          lang: R,
          style: H,
          weight: Y,
          fonts: typeof K == "string" ? [{ src: K }] : K,
          unicodeFontsURL: yA,
          preResolvedFonts: LA,
        },
        (DA) => {
          GA.fontLoad = S() - EA
          const dA = isFinite(P)
          let kA = null,
            NA = null,
            qA = null,
            ZA = null,
            sI = null,
            cI = null,
            YA = null,
            eI = null,
            uA = 0,
            hI = 0,
            II = eA !== "nowrap"
          const pI = /* @__PURE__ */ new Map(),
            AI = S()
          let YI = _,
            SI = 0,
            QA = new d()
          const tA = [QA]
          DA.forEach((UI) => {
            const { fontObj: GI } = UI,
              {
                ascender: LI,
                descender: Bg,
                unitsPerEm: MA,
                lineGap: OA,
                capHeight: aI,
                xHeight: RI,
              } = GI
            let VA = pI.get(GI)
            if (!VA) {
              const NI = L / MA,
                HA = j === "normal" ? (LI - Bg + OA) * NI : j * L,
                iI = (HA - (LI - Bg) * NI) / 2,
                zI = Math.min(HA, (LI - Bg) * NI),
                qI = ((LI + Bg) / 2) * NI + zI / 2
              ;((VA = {
                index: pI.size,
                src: GI.src,
                fontObj: GI,
                fontSizeMult: NI,
                unitsPerEm: MA,
                ascender: LI * NI,
                descender: Bg * NI,
                capHeight: aI * NI,
                xHeight: RI * NI,
                lineHeight: HA,
                baseline: -iI - LI * NI,
                // baseline offset from top of line height
                // cap: -halfLeading - capHeight * fontSizeMult, // cap from top of line height
                // ex: -halfLeading - xHeight * fontSizeMult, // ex from top of line height
                caretTop: qI,
                caretBottom: qI - zI,
              }),
                pI.set(GI, VA))
            }
            const { fontSizeMult: ag } = VA,
              XI = M.slice(UI.start, UI.end + 1)
            let $I, SA
            ;(GI.forEachGlyph(XI, L, V, (NI, HA, iI, zI) => {
              ;((HA += SI), (zI += UI.start), ($I = HA), (SA = NI))
              const qI = M.charAt(zI),
                dg = NI.advanceWidth * ag,
                $g = QA.count
              let Qg
              if (
                ("isEmpty" in NI ||
                  ((NI.isWhitespace = !!qI && new RegExp(C).test(qI)),
                  (NI.canBreakAfter = !!qI && i.test(qI)),
                  (NI.isEmpty = NI.xMin === NI.xMax || NI.yMin === NI.yMax || g.test(qI))),
                !NI.isWhitespace && !NI.isEmpty && hI++,
                II && dA && !NI.isWhitespace && HA + dg + YI > P && $g)
              ) {
                if (QA.glyphAt($g - 1).glyphObj.canBreakAfter) ((Qg = new d()), (YI = -HA))
                else
                  for (let jC = $g; jC--; )
                    if (jC === 0 && CA === "break-word") {
                      ;((Qg = new d()), (YI = -HA))
                      break
                    } else if (QA.glyphAt(jC).glyphObj.canBreakAfter) {
                      Qg = QA.splitAt(jC + 1)
                      const mC = Qg.glyphAt(0).x
                      YI -= mC
                      for (let zC = Qg.count; zC--; ) Qg.glyphAt(zC).x -= mC
                      break
                    }
                Qg && ((QA.isSoftWrapped = !0), (QA = Qg), tA.push(QA), (uA = P))
              }
              let Fg = QA.glyphAt(QA.count)
              ;((Fg.glyphObj = NI),
                (Fg.x = HA + YI),
                (Fg.y = iI),
                (Fg.width = dg),
                (Fg.charIndex = zI),
                (Fg.fontData = VA),
                qI ===
                  `
` && ((QA = new d()), tA.push(QA), (YI = -(HA + dg + V * L) + _)))
            }),
              (SI = $I + SA.advanceWidth * ag + V * L))
          })
          let FA = 0
          tA.forEach((UI) => {
            let GI = !0
            for (let LI = UI.count; LI--; ) {
              const Bg = UI.glyphAt(LI)
              GI &&
                !Bg.glyphObj.isWhitespace &&
                ((UI.width = Bg.x + Bg.width), UI.width > uA && (uA = UI.width), (GI = !1))
              let { lineHeight: MA, capHeight: OA, xHeight: aI, baseline: RI } = Bg.fontData
              MA > UI.lineHeight && (UI.lineHeight = MA)
              const VA = RI - UI.baseline
              ;(VA < 0 && ((UI.baseline += VA), (UI.cap += VA), (UI.ex += VA)),
                (UI.cap = Math.max(UI.cap, UI.baseline + OA)),
                (UI.ex = Math.max(UI.ex, UI.baseline + aI)))
            }
            ;((UI.baseline -= FA), (UI.cap -= FA), (UI.ex -= FA), (FA += UI.lineHeight))
          })
          let WA = 0,
            jA = 0
          if (
            (aA &&
              (typeof aA == "number"
                ? (WA = -aA)
                : typeof aA == "string" &&
                  (WA =
                    -uA *
                    (aA === "left" ? 0 : aA === "center" ? 0.5 : aA === "right" ? 1 : s(aA)))),
            lA &&
              (typeof lA == "number"
                ? (jA = -lA)
                : typeof lA == "string" &&
                  (jA =
                    lA === "top"
                      ? 0
                      : lA === "top-baseline"
                        ? -tA[0].baseline
                        : lA === "top-cap"
                          ? -tA[0].cap
                          : lA === "top-ex"
                            ? -tA[0].ex
                            : lA === "middle"
                              ? FA / 2
                              : lA === "bottom"
                                ? FA
                                : lA === "bottom-baseline"
                                  ? -tA[tA.length - 1].baseline
                                  : s(lA) * FA)),
            !JA)
          ) {
            const UI = A.getEmbeddingLevels(M, AA)
            ;((kA = new Uint16Array(hI)),
              (NA = new Uint8Array(hI)),
              (qA = new Float32Array(hI * 2)),
              (ZA = {}),
              (YA = [1 / 0, 1 / 0, -1 / 0, -1 / 0]),
              (eI = []),
              nA && (cI = new Float32Array(M.length * 4)),
              sA && (sI = new Uint8Array(hI * 3)))
            let GI = 0,
              LI = -1,
              Bg = -1,
              MA,
              OA
            if (
              (tA.forEach((aI, RI) => {
                let { count: VA, width: ag } = aI
                if (VA > 0) {
                  let XI = 0
                  for (let zI = VA; zI-- && aI.glyphAt(zI).glyphObj.isWhitespace; ) XI++
                  let $I = 0,
                    SA = 0
                  if (X === "center") $I = (uA - ag) / 2
                  else if (X === "right") $I = uA - ag
                  else if (X === "justify" && aI.isSoftWrapped) {
                    let zI = 0
                    for (let qI = VA - XI; qI--; ) aI.glyphAt(qI).glyphObj.isWhitespace && zI++
                    SA = (uA - ag) / zI
                  }
                  if (SA || $I) {
                    let zI = 0
                    for (let qI = 0; qI < VA; qI++) {
                      let dg = aI.glyphAt(qI)
                      const $g = dg.glyphObj
                      ;((dg.x += $I + zI),
                        SA !== 0 &&
                          $g.isWhitespace &&
                          qI < VA - XI &&
                          ((zI += SA), (dg.width += SA)))
                    }
                  }
                  const NI = A.getReorderSegments(
                    M,
                    UI,
                    aI.glyphAt(0).charIndex,
                    aI.glyphAt(aI.count - 1).charIndex,
                  )
                  for (let zI = 0; zI < NI.length; zI++) {
                    const [qI, dg] = NI[zI]
                    let $g = 1 / 0,
                      Qg = -1 / 0
                    for (let Fg = 0; Fg < VA; Fg++)
                      if (aI.glyphAt(Fg).charIndex >= qI) {
                        let jC = Fg,
                          mC = Fg
                        for (; mC < VA; mC++) {
                          let zC = aI.glyphAt(mC)
                          if (zC.charIndex > dg) break
                          mC < VA - XI &&
                            (($g = Math.min($g, zC.x)), (Qg = Math.max(Qg, zC.x + zC.width)))
                        }
                        for (let zC = jC; zC < mC; zC++) {
                          const Ee = aI.glyphAt(zC)
                          Ee.x = Qg - (Ee.x + Ee.width - $g)
                        }
                        break
                      }
                  }
                  let HA
                  const iI = (zI) => (HA = zI)
                  for (let zI = 0; zI < VA; zI++) {
                    const qI = aI.glyphAt(zI)
                    HA = qI.glyphObj
                    const dg = HA.index,
                      $g = UI.levels[qI.charIndex] & 1
                    if ($g) {
                      const Qg = A.getMirroredCharacter(M[qI.charIndex])
                      Qg && qI.fontData.fontObj.forEachGlyph(Qg, 0, 0, iI)
                    }
                    if (nA) {
                      const { charIndex: Qg, fontData: Fg } = qI,
                        jC = qI.x + WA,
                        mC = qI.x + qI.width + WA
                      ;((cI[Qg * 4] = $g ? mC : jC),
                        (cI[Qg * 4 + 1] = $g ? jC : mC),
                        (cI[Qg * 4 + 2] = aI.baseline + Fg.caretBottom + jA),
                        (cI[Qg * 4 + 3] = aI.baseline + Fg.caretTop + jA))
                      const zC = Qg - LI
                      ;(zC > 1 && h(cI, LI, zC), (LI = Qg))
                    }
                    if (sA) {
                      const { charIndex: Qg } = qI
                      for (; Qg > Bg; ) (Bg++, sA.hasOwnProperty(Bg) && (OA = sA[Bg]))
                    }
                    if (!HA.isWhitespace && !HA.isEmpty) {
                      const Qg = GI++,
                        { fontSizeMult: Fg, src: jC, index: mC } = qI.fontData,
                        zC = ZA[jC] || (ZA[jC] = {})
                      zC[dg] ||
                        (zC[dg] = {
                          path: HA.path,
                          pathBounds: [HA.xMin, HA.yMin, HA.xMax, HA.yMax],
                        })
                      const Ee = qI.x + WA,
                        ei = qI.y + aI.baseline + jA
                      ;((qA[Qg * 2] = Ee), (qA[Qg * 2 + 1] = ei))
                      const fe = Ee + HA.xMin * Fg,
                        Ei = ei + HA.yMin * Fg,
                        vi = Ee + HA.xMax * Fg,
                        Li = ei + HA.yMax * Fg
                      ;(fe < YA[0] && (YA[0] = fe),
                        Ei < YA[1] && (YA[1] = Ei),
                        vi > YA[2] && (YA[2] = vi),
                        Li > YA[3] && (YA[3] = Li),
                        Qg % fA === 0 &&
                          ((MA = { start: Qg, end: Qg, rect: [1 / 0, 1 / 0, -1 / 0, -1 / 0] }),
                          eI.push(MA)),
                        MA.end++)
                      const mA = MA.rect
                      if (
                        (fe < mA[0] && (mA[0] = fe),
                        Ei < mA[1] && (mA[1] = Ei),
                        vi > mA[2] && (mA[2] = vi),
                        Li > mA[3] && (mA[3] = Li),
                        (kA[Qg] = dg),
                        (NA[Qg] = mC),
                        sA)
                      ) {
                        const TI = Qg * 3
                        ;((sI[TI] = (OA >> 16) & 255),
                          (sI[TI + 1] = (OA >> 8) & 255),
                          (sI[TI + 2] = OA & 255))
                      }
                    }
                  }
                }
              }),
              cI)
            ) {
              const aI = M.length - LI
              aI > 1 && h(cI, LI, aI)
            }
          }
          const nI = []
          ;(pI.forEach(
            ({
              index: UI,
              src: GI,
              unitsPerEm: LI,
              ascender: Bg,
              descender: MA,
              lineHeight: OA,
              capHeight: aI,
              xHeight: RI,
            }) => {
              nI[UI] = {
                src: GI,
                unitsPerEm: LI,
                ascender: Bg,
                descender: MA,
                lineHeight: OA,
                capHeight: aI,
                xHeight: RI,
              }
            },
          ),
            (GA.typesetting = S() - AI),
            $({
              glyphIds: kA,
              //id for each glyph, specific to that glyph's font
              glyphFontIndices: NA,
              //index into fontData for each glyph
              glyphPositions: qA,
              //x,y of each glyph's origin in layout
              glyphData: ZA,
              //dict holding data about each glyph appearing in the text
              fontData: nI,
              //data about each font used in the text
              caretPositions: cI,
              //startX,endX,bottomY caret positions for each char
              // caretHeight, //height of cursor from bottom to top - todo per glyph?
              glyphColors: sI,
              //color for each glyph, if color ranges supplied
              chunkedBounds: eI,
              //total rects per (n=chunkedBoundsSize) consecutive glyphs
              fontSize: L,
              //calculated em height
              topBaseline: jA + tA[0].baseline,
              //y coordinate of the top line's baseline
              blockBounds: [
                //bounds for the whole block of text, including vertical padding for lineHeight
                WA,
                jA - FA,
                WA + uA,
                jA,
              ],
              visibleBounds: YA,
              //total bounds of visible text paths, may be larger or smaller than blockBounds
              timings: GA,
            }))
        },
      ))
  }
  function r(M, K) {
    o({ ...M, metricsOnly: !0 }, (R) => {
      const [F, L, Y, H] = R.blockBounds
      K({
        width: Y - F,
        height: H - L,
      })
    })
  }
  function s(M) {
    let K = M.match(/^([\d.]+)%$/),
      R = K ? parseFloat(K[1]) : NaN
    return isNaN(R) ? 0 : R / 100
  }
  function h(M, K, R) {
    const F = M[K * 4],
      L = M[K * 4 + 1],
      Y = M[K * 4 + 2],
      H = M[K * 4 + 3],
      V = (L - F) / R
    for (let j = 0; j < R; j++) {
      const P = (K + j) * 4
      ;((M[P] = F + V * j), (M[P + 1] = F + V * (j + 1)), (M[P + 2] = Y), (M[P + 3] = H))
    }
  }
  function S() {
    return (self.performance || Date).now()
  }
  function d() {
    this.data = []
  }
  const w = ["glyphObj", "x", "y", "width", "charIndex", "fontData"]
  return (
    (d.prototype = {
      width: 0,
      lineHeight: 0,
      baseline: 0,
      cap: 0,
      ex: 0,
      isSoftWrapped: !1,
      get count() {
        return Math.ceil(this.data.length / w.length)
      },
      glyphAt(M) {
        let K = d.flyweight
        return ((K.data = this.data), (K.index = M), K)
      },
      splitAt(M) {
        let K = new d()
        return ((K.data = this.data.splice(M * w.length)), K)
      },
    }),
    (d.flyweight = w.reduce(
      (M, K, R, F) => (
        Object.defineProperty(M, K, {
          get() {
            return this.data[this.index * w.length + R]
          },
          set(L) {
            this.data[this.index * w.length + R] = L
          },
        }),
        M
      ),
      { data: null, index: 0 },
    )),
    {
      typeset: o,
      measure: r,
    }
  )
}
const vf = () => (self.performance || Date).now(),
  wF = /* @__PURE__ */ EO()
let jT
function G9(e, A, I, g, C, i, B, o, r, s, h = !0) {
  return h
    ? M9(e, A, I, g, C, i, B, o, r, s).then(
        null,
        (S) => (
          jT || (console.warn("WebGL SDF generation failed, falling back to JS", S), (jT = !0)),
          XT(e, A, I, g, C, i, B, o, r, s)
        ),
      )
    : XT(e, A, I, g, C, i, B, o, r, s)
}
const qU = [],
  k9 = 5
let Km = 0
function rO() {
  const e = vf()
  for (; qU.length && vf() - e < k9; ) qU.shift()()
  Km = qU.length ? setTimeout(rO, 0) : 0
}
const M9 = (...e) =>
    new Promise((A, I) => {
      ;(qU.push(() => {
        const g = vf()
        try {
          ;(wF.webgl.generateIntoCanvas(...e), A({ timing: vf() - g }))
        } catch (C) {
          I(C)
        }
      }),
        Km || (Km = setTimeout(rO, 0)))
    }),
  U9 = 4,
  N9 = 2e3,
  zT = {}
let F9 = 0
function XT(e, A, I, g, C, i, B, o, r, s) {
  const h = "TroikaTextSDFGenerator_JS_" + (F9++ % U9)
  let S = zT[h]
  return (
    S ||
      (S = zT[h] =
        {
          workerModule: Up({
            name: h,
            workerId: h,
            dependencies: [EO, vf],
            init(d, w) {
              const M = d().javascript.generate
              return function (...K) {
                const R = w()
                return {
                  textureData: M(...K),
                  timing: w() - R,
                }
              }
            },
            getTransferables(d) {
              return [d.textureData.buffer]
            },
          }),
          requests: 0,
          idleTimer: null,
        }),
    S.requests++,
    clearTimeout(S.idleTimer),
    S.workerModule(e, A, I, g, C, i).then(({ textureData: d, timing: w }) => {
      const M = vf(),
        K = new Uint8Array(d.length * 4)
      for (let R = 0; R < d.length; R++) K[R * 4 + s] = d[R]
      return (
        wF.webglUtils.renderImageData(B, K, o, r, e, A, 1 << (3 - s)),
        (w += vf() - M),
        --S.requests === 0 &&
          (S.idleTimer = setTimeout(() => {
            Q9(h)
          }, N9)),
        { timing: w }
      )
    })
  )
}
function R9(e) {
  e._warm || (wF.webgl.isSupported(e), (e._warm = !0))
}
const J9 = wF.webglUtils.resizeWebGLCanvasWithoutClearing,
  $y = {
    defaultFontURL: null,
    unicodeFontsURL: null,
    sdfGlyphSize: 64,
    sdfMargin: 1 / 16,
    sdfExponent: 9,
    textureWidth: 2048,
    useWorker: !0,
  },
  K9 = /* @__PURE__ */ new Mg()
function Vy() {
  return (self.performance || Date).now()
}
const $T = /* @__PURE__ */ Object.create(null)
function sO(e, A) {
  e = L9({}, e)
  const I = Vy(),
    { defaultFontURL: g } = $y,
    C = []
  if (
    (g && C.push({ label: "default", src: Ax(g) }),
    e.font && C.push({ label: "user", src: Ax(e.font) }),
    (e.font = C),
    (e.text = "" + e.text),
    (e.sdfGlyphSize = e.sdfGlyphSize || $y.sdfGlyphSize),
    (e.unicodeFontsURL = e.unicodeFontsURL || $y.unicodeFontsURL),
    e.colorRanges != null)
  ) {
    let w = {}
    for (let M in e.colorRanges)
      if (e.colorRanges.hasOwnProperty(M)) {
        let K = e.colorRanges[M]
        ;(typeof K != "number" && (K = K9.set(K).getHex()), (w[M] = K))
      }
    e.colorRanges = w
  }
  Object.freeze(e)
  const { textureWidth: i, sdfExponent: B } = $y,
    { sdfGlyphSize: o } = e,
    r = (i / o) * 4
  let s = $T[o]
  if (!s) {
    const w = document.createElement("canvas")
    ;((w.width = i),
      (w.height = (o * 256) / r),
      (s = $T[o] =
        {
          glyphCount: 0,
          sdfGlyphSize: o,
          sdfCanvas: w,
          sdfTexture: new pt(w, void 0, void 0, void 0, nt, nt),
          contextLost: !1,
          glyphsByFont: /* @__PURE__ */ new Map(),
        }),
      (s.sdfTexture.generateMipmaps = !1),
      m9(s))
  }
  const { sdfTexture: h, sdfCanvas: S } = s
  ;(hO(e).then((w) => {
    const {
        glyphIds: M,
        glyphFontIndices: K,
        fontData: R,
        glyphPositions: F,
        fontSize: L,
        timings: Y,
      } = w,
      H = [],
      V = new Float32Array(M.length * 4)
    let j = 0,
      P = 0
    const AA = Vy(),
      X = R.map((lA) => {
        let JA = s.glyphsByFont.get(lA.src)
        return (JA || s.glyphsByFont.set(lA.src, (JA = /* @__PURE__ */ new Map())), JA)
      })
    ;(M.forEach((lA, JA) => {
      const yA = K[JA],
        { src: LA, unitsPerEm: nA } = R[yA]
      let fA = X[yA].get(lA)
      if (!fA) {
        const { path: DA, pathBounds: dA } = w.glyphData[LA][lA],
          kA = (Math.max(dA[2] - dA[0], dA[3] - dA[1]) / o) * ($y.sdfMargin * o + 0.5),
          NA = s.glyphCount++,
          qA = [dA[0] - kA, dA[1] - kA, dA[2] + kA, dA[3] + kA]
        ;(X[yA].set(lA, (fA = { path: DA, atlasIndex: NA, sdfViewBox: qA })), H.push(fA))
      }
      const { sdfViewBox: sA } = fA,
        $ = F[P++],
        EA = F[P++],
        GA = L / nA
      ;((V[j++] = $ + sA[0] * GA),
        (V[j++] = EA + sA[1] * GA),
        (V[j++] = $ + sA[2] * GA),
        (V[j++] = EA + sA[3] * GA),
        (M[JA] = fA.atlasIndex))
    }),
      (Y.quads = (Y.quads || 0) + (Vy() - AA)))
    const _ = Vy()
    Y.sdf = {}
    const eA = S.height,
      CA = Math.ceil(s.glyphCount / r),
      aA = Math.pow(2, Math.ceil(Math.log2(CA * o)))
    ;(aA > eA &&
      (console.info(`Increasing SDF texture size ${eA}->${aA}`), J9(S, i, aA), h.dispose()),
      Promise.all(
        H.map((lA) =>
          lO(lA, s, e.gpuAccelerateSDF).then(({ timing: JA }) => {
            Y.sdf[lA.atlasIndex] = JA
          }),
        ),
      ).then(() => {
        ;(H.length && !s.contextLost && (cO(s), (h.needsUpdate = !0)),
          (Y.sdfTotal = Vy() - _),
          (Y.total = Vy() - I),
          A(
            Object.freeze({
              parameters: e,
              sdfTexture: h,
              sdfGlyphSize: o,
              sdfExponent: B,
              glyphBounds: V,
              glyphAtlasIndices: M,
              glyphColors: w.glyphColors,
              caretPositions: w.caretPositions,
              chunkedBounds: w.chunkedBounds,
              ascender: w.ascender,
              descender: w.descender,
              lineHeight: w.lineHeight,
              capHeight: w.capHeight,
              xHeight: w.xHeight,
              topBaseline: w.topBaseline,
              blockBounds: w.blockBounds,
              visibleBounds: w.visibleBounds,
              timings: w.timings,
            }),
          ))
      }))
  }),
    Promise.resolve().then(() => {
      s.contextLost || R9(S)
    }))
}
function lO(
  { path: e, atlasIndex: A, sdfViewBox: I },
  { sdfGlyphSize: g, sdfCanvas: C, contextLost: i },
  B,
) {
  if (i) return Promise.resolve({ timing: -1 })
  const { textureWidth: o, sdfExponent: r } = $y,
    s = Math.max(I[2] - I[0], I[3] - I[1]),
    h = Math.floor(A / 4),
    S = (h % (o / g)) * g,
    d = Math.floor(h / (o / g)) * g,
    w = A % 4
  return G9(g, g, e, I, s, r, C, S, d, w, B)
}
function m9(e) {
  const A = e.sdfCanvas
  ;(A.addEventListener("webglcontextlost", (I) => {
    ;(console.log("Context Lost", I), I.preventDefault(), (e.contextLost = !0))
  }),
    A.addEventListener("webglcontextrestored", (I) => {
      ;(console.log("Context Restored", I), (e.contextLost = !1))
      const g = []
      ;(e.glyphsByFont.forEach((C) => {
        C.forEach((i) => {
          g.push(lO(i, e, !0))
        })
      }),
        Promise.all(g).then(() => {
          ;(cO(e), (e.sdfTexture.needsUpdate = !0))
        }))
    }))
}
function v9({ font: e, characters: A, sdfGlyphSize: I }, g) {
  let C = Array.isArray(A)
    ? A.join(`
`)
    : "" + A
  sO({ font: e, sdfGlyphSize: I, text: C }, g)
}
function L9(e, A) {
  for (let I in A) A.hasOwnProperty(I) && (e[I] = A[I])
  return e
}
let NU
function Ax(e) {
  return (
    NU || (NU = typeof document > "u" ? {} : document.createElement("a")),
    (NU.href = e),
    NU.href
  )
}
function cO(e) {
  if (typeof createImageBitmap != "function") {
    console.info("Safari<15: applying SDF canvas workaround")
    const { sdfCanvas: A, sdfTexture: I } = e,
      { width: g, height: C } = A,
      i = e.sdfCanvas.getContext("webgl")
    let B = I.image.data
    ;((!B || B.length !== g * C * 4) &&
      ((B = new Uint8Array(g * C * 4)),
      (I.image = { width: g, height: C, data: B }),
      (I.flipY = !1),
      (I.isDataTexture = !0)),
      i.readPixels(0, 0, g, C, i.RGBA, i.UNSIGNED_BYTE, B))
  }
}
const Y9 = /* @__PURE__ */ Up({
    name: "Typesetter",
    dependencies: [w9, p9, n9],
    init(e, A, I) {
      return e(A, I())
    },
  }),
  hO = /* @__PURE__ */ Up({
    name: "Typesetter",
    dependencies: [Y9],
    init(e) {
      return function (A) {
        return new Promise((I) => {
          e.typeset(A, I)
        })
      }
    },
    getTransferables(e) {
      const A = []
      for (let I in e) e[I] && e[I].buffer && A.push(e[I].buffer)
      return A
    },
  })
hO.onMainThread
const Ix = {}
function q9(e) {
  let A = Ix[e]
  return (A || (A = Ix[e] = new su(1, 1, e, e).translate(0.5, 0.5, 0)), A)
}
const H9 = "aTroikaGlyphBounds",
  gx = "aTroikaGlyphIndex",
  T9 = "aTroikaGlyphColor"
class x9 extends wv {
  constructor() {
    ;(super(),
      (this.detail = 1),
      (this.curveRadius = 0),
      (this.groups = [
        { start: 0, count: 1 / 0, materialIndex: 0 },
        { start: 0, count: 1 / 0, materialIndex: 1 },
      ]),
      (this.boundingSphere = new jo()),
      (this.boundingBox = new Vo()))
  }
  computeBoundingSphere() {}
  computeBoundingBox() {}
  set detail(A) {
    if (A !== this._detail) {
      ;((this._detail = A), (typeof A != "number" || A < 1) && (A = 1))
      let I = q9(A)
      ;(["position", "normal", "uv"].forEach((g) => {
        this.attributes[g] = I.attributes[g].clone()
      }),
        this.setIndex(I.getIndex().clone()))
    }
  }
  get detail() {
    return this._detail
  }
  set curveRadius(A) {
    A !== this._curveRadius && ((this._curveRadius = A), this._updateBounds())
  }
  get curveRadius() {
    return this._curveRadius
  }
  /**
   * Update the geometry for a new set of glyphs.
   * @param {Float32Array} glyphBounds - An array holding the planar bounds for all glyphs
   *        to be rendered, 4 entries for each glyph: x1,x2,y1,y1
   * @param {Float32Array} glyphAtlasIndices - An array holding the index of each glyph within
   *        the SDF atlas texture.
   * @param {Array} blockBounds - An array holding the [minX, minY, maxX, maxY] across all glyphs
   * @param {Array} [chunkedBounds] - An array of objects describing bounds for each chunk of N
   *        consecutive glyphs: `{start:N, end:N, rect:[minX, minY, maxX, maxY]}`. This can be
   *        used with `applyClipRect` to choose an optimized `instanceCount`.
   * @param {Uint8Array} [glyphColors] - An array holding r,g,b values for each glyph.
   */
  updateGlyphs(A, I, g, C, i) {
    ;(this.updateAttributeData(H9, A, 4),
      this.updateAttributeData(gx, I, 1),
      this.updateAttributeData(T9, i, 3),
      (this._blockBounds = g),
      (this._chunkedBounds = C),
      (this.instanceCount = I.length),
      this._updateBounds())
  }
  _updateBounds() {
    const A = this._blockBounds
    if (A) {
      const { curveRadius: I, boundingBox: g } = this
      if (I) {
        const { PI: C, floor: i, min: B, max: o, sin: r, cos: s } = Math,
          h = C / 2,
          S = C * 2,
          d = Math.abs(I),
          w = A[0] / d,
          M = A[2] / d,
          K = i((w + h) / S) !== i((M + h) / S) ? -d : B(r(w) * d, r(M) * d),
          R = i((w - h) / S) !== i((M - h) / S) ? d : o(r(w) * d, r(M) * d),
          F = i((w + C) / S) !== i((M + C) / S) ? d * 2 : o(d - s(w) * d, d - s(M) * d)
        ;(g.min.set(K, A[1], I < 0 ? -F : 0), g.max.set(R, A[3], I < 0 ? 0 : F))
      } else (g.min.set(A[0], A[1], 0), g.max.set(A[2], A[3], 0))
      g.getBoundingSphere(this.boundingSphere)
    }
  }
  /**
   * Given a clipping rect, and the chunkedBounds from the last updateGlyphs call, choose the lowest
   * `instanceCount` that will show all glyphs within the clipped view. This is an optimization
   * for long blocks of text that are clipped, to skip vertex shader evaluation for glyphs that would
   * be clipped anyway.
   *
   * Note that since `drawElementsInstanced[ANGLE]` only accepts an instance count and not a starting
   * offset, this optimization becomes less effective as the clipRect moves closer to the end of the
   * text block. We could fix that by switching from instancing to a full geometry with a drawRange,
   * but at the expense of much larger attribute buffers (see classdoc above.)
   *
   * @param {Vector4} clipRect
   */
  applyClipRect(A) {
    let I = this.getAttribute(gx).count,
      g = this._chunkedBounds
    if (g)
      for (let C = g.length; C--; ) {
        I = g[C].end
        let i = g[C].rect
        if (i[1] < A.w && i[3] > A.y && i[0] < A.z && i[2] > A.x) break
      }
    this.instanceCount = I
  }
  /**
   * Utility for updating instance attributes with automatic resizing
   */
  updateAttributeData(A, I, g) {
    const C = this.getAttribute(A)
    I
      ? C && C.array.length === I.length
        ? (C.array.set(I), (C.needsUpdate = !0))
        : (this.setAttribute(A, new RD(I, g)), delete this._maxInstanceCount, this.dispose())
      : C && this.deleteAttribute(A)
  }
}
const b9 = `
uniform vec2 uTroikaSDFTextureSize;
uniform float uTroikaSDFGlyphSize;
uniform vec4 uTroikaTotalBounds;
uniform vec4 uTroikaClipRect;
uniform mat3 uTroikaOrient;
uniform bool uTroikaUseGlyphColors;
uniform float uTroikaEdgeOffset;
uniform float uTroikaBlurRadius;
uniform vec2 uTroikaPositionOffset;
uniform float uTroikaCurveRadius;
attribute vec4 aTroikaGlyphBounds;
attribute float aTroikaGlyphIndex;
attribute vec3 aTroikaGlyphColor;
varying vec2 vTroikaGlyphUV;
varying vec4 vTroikaTextureUVBounds;
varying float vTroikaTextureChannel;
varying vec3 vTroikaGlyphColor;
varying vec2 vTroikaGlyphDimensions;
`,
  O9 = `
vec4 bounds = aTroikaGlyphBounds;
bounds.xz += uTroikaPositionOffset.x;
bounds.yw -= uTroikaPositionOffset.y;

vec4 outlineBounds = vec4(
  bounds.xy - uTroikaEdgeOffset - uTroikaBlurRadius,
  bounds.zw + uTroikaEdgeOffset + uTroikaBlurRadius
);
vec4 clippedBounds = vec4(
  clamp(outlineBounds.xy, uTroikaClipRect.xy, uTroikaClipRect.zw),
  clamp(outlineBounds.zw, uTroikaClipRect.xy, uTroikaClipRect.zw)
);

vec2 clippedXY = (mix(clippedBounds.xy, clippedBounds.zw, position.xy) - bounds.xy) / (bounds.zw - bounds.xy);

position.xy = mix(bounds.xy, bounds.zw, clippedXY);

uv = (position.xy - uTroikaTotalBounds.xy) / (uTroikaTotalBounds.zw - uTroikaTotalBounds.xy);

float rad = uTroikaCurveRadius;
if (rad != 0.0) {
  float angle = position.x / rad;
  position.xz = vec2(sin(angle) * rad, rad - cos(angle) * rad);
  normal.xz = vec2(sin(angle), cos(angle));
}
  
position = uTroikaOrient * position;
normal = uTroikaOrient * normal;

vTroikaGlyphUV = clippedXY.xy;
vTroikaGlyphDimensions = vec2(bounds[2] - bounds[0], bounds[3] - bounds[1]);


float txCols = uTroikaSDFTextureSize.x / uTroikaSDFGlyphSize;
vec2 txUvPerSquare = uTroikaSDFGlyphSize / uTroikaSDFTextureSize;
vec2 txStartUV = txUvPerSquare * vec2(
  mod(floor(aTroikaGlyphIndex / 4.0), txCols),
  floor(floor(aTroikaGlyphIndex / 4.0) / txCols)
);
vTroikaTextureUVBounds = vec4(txStartUV, vec2(txStartUV) + txUvPerSquare);
vTroikaTextureChannel = mod(aTroikaGlyphIndex, 4.0);
`,
  _9 = `
uniform sampler2D uTroikaSDFTexture;
uniform vec2 uTroikaSDFTextureSize;
uniform float uTroikaSDFGlyphSize;
uniform float uTroikaSDFExponent;
uniform float uTroikaEdgeOffset;
uniform float uTroikaFillOpacity;
uniform float uTroikaBlurRadius;
uniform vec3 uTroikaStrokeColor;
uniform float uTroikaStrokeWidth;
uniform float uTroikaStrokeOpacity;
uniform bool uTroikaSDFDebug;
varying vec2 vTroikaGlyphUV;
varying vec4 vTroikaTextureUVBounds;
varying float vTroikaTextureChannel;
varying vec2 vTroikaGlyphDimensions;

float troikaSdfValueToSignedDistance(float alpha) {
  // Inverse of exponential encoding in webgl-sdf-generator
  
  float maxDimension = max(vTroikaGlyphDimensions.x, vTroikaGlyphDimensions.y);
  float absDist = (1.0 - pow(2.0 * (alpha > 0.5 ? 1.0 - alpha : alpha), 1.0 / uTroikaSDFExponent)) * maxDimension;
  float signedDist = absDist * (alpha > 0.5 ? -1.0 : 1.0);
  return signedDist;
}

float troikaGlyphUvToSdfValue(vec2 glyphUV) {
  vec2 textureUV = mix(vTroikaTextureUVBounds.xy, vTroikaTextureUVBounds.zw, glyphUV);
  vec4 rgba = texture2D(uTroikaSDFTexture, textureUV);
  float ch = floor(vTroikaTextureChannel + 0.5); //NOTE: can't use round() in WebGL1
  return ch == 0.0 ? rgba.r : ch == 1.0 ? rgba.g : ch == 2.0 ? rgba.b : rgba.a;
}

float troikaGlyphUvToDistance(vec2 uv) {
  return troikaSdfValueToSignedDistance(troikaGlyphUvToSdfValue(uv));
}

float troikaGetAADist() {
  
  #if defined(GL_OES_standard_derivatives) || __VERSION__ >= 300
  return length(fwidth(vTroikaGlyphUV * vTroikaGlyphDimensions)) * 0.5;
  #else
  return vTroikaGlyphDimensions.x / 64.0;
  #endif
}

float troikaGetFragDistValue() {
  vec2 clampedGlyphUV = clamp(vTroikaGlyphUV, 0.5 / uTroikaSDFGlyphSize, 1.0 - 0.5 / uTroikaSDFGlyphSize);
  float distance = troikaGlyphUvToDistance(clampedGlyphUV);
 
  // Extrapolate distance when outside bounds:
  distance += clampedGlyphUV == vTroikaGlyphUV ? 0.0 : 
    length((vTroikaGlyphUV - clampedGlyphUV) * vTroikaGlyphDimensions);

  

  return distance;
}

float troikaGetEdgeAlpha(float distance, float distanceOffset, float aaDist) {
  #if defined(IS_DEPTH_MATERIAL) || defined(IS_DISTANCE_MATERIAL)
  float alpha = step(-distanceOffset, -distance);
  #else

  float alpha = smoothstep(
    distanceOffset + aaDist,
    distanceOffset - aaDist,
    distance
  );
  #endif

  return alpha;
}
`,
  Z9 = `
float aaDist = troikaGetAADist();
float fragDistance = troikaGetFragDistValue();
float edgeAlpha = uTroikaSDFDebug ?
  troikaGlyphUvToSdfValue(vTroikaGlyphUV) :
  troikaGetEdgeAlpha(fragDistance, uTroikaEdgeOffset, max(aaDist, uTroikaBlurRadius));

#if !defined(IS_DEPTH_MATERIAL) && !defined(IS_DISTANCE_MATERIAL)
vec4 fillRGBA = gl_FragColor;
fillRGBA.a *= uTroikaFillOpacity;
vec4 strokeRGBA = uTroikaStrokeWidth == 0.0 ? fillRGBA : vec4(uTroikaStrokeColor, uTroikaStrokeOpacity);
if (fillRGBA.a == 0.0) fillRGBA.rgb = strokeRGBA.rgb;
gl_FragColor = mix(fillRGBA, strokeRGBA, smoothstep(
  -uTroikaStrokeWidth - aaDist,
  -uTroikaStrokeWidth + aaDist,
  fragDistance
));
gl_FragColor.a *= edgeAlpha;
#endif

if (edgeAlpha == 0.0) {
  discard;
}
`
function P9(e) {
  const A = Jm(e, {
    chained: !0,
    extensions: {
      derivatives: !0,
    },
    uniforms: {
      uTroikaSDFTexture: { value: null },
      uTroikaSDFTextureSize: { value: new ZI() },
      uTroikaSDFGlyphSize: { value: 0 },
      uTroikaSDFExponent: { value: 0 },
      uTroikaTotalBounds: { value: new Xe(0, 0, 0, 0) },
      uTroikaClipRect: { value: new Xe(0, 0, 0, 0) },
      uTroikaEdgeOffset: { value: 0 },
      uTroikaFillOpacity: { value: 1 },
      uTroikaPositionOffset: { value: new ZI() },
      uTroikaCurveRadius: { value: 0 },
      uTroikaBlurRadius: { value: 0 },
      uTroikaStrokeWidth: { value: 0 },
      uTroikaStrokeColor: { value: new Mg() },
      uTroikaStrokeOpacity: { value: 1 },
      uTroikaOrient: { value: new ce() },
      uTroikaUseGlyphColors: { value: !0 },
      uTroikaSDFDebug: { value: !1 },
    },
    vertexDefs: b9,
    vertexTransform: O9,
    fragmentDefs: _9,
    fragmentColorTransform: Z9,
    customRewriter({ vertexShader: I, fragmentShader: g }) {
      let C = /\buniform\s+vec3\s+diffuse\b/
      return (
        C.test(g) &&
          ((g = g
            .replace(C, "varying vec3 vTroikaGlyphColor")
            .replace(/\bdiffuse\b/g, "vTroikaGlyphColor")),
          C.test(I) ||
            (I = I.replace(
              aO,
              `uniform vec3 diffuse;
$&
vTroikaGlyphColor = uTroikaUseGlyphColors ? aTroikaGlyphColor / 255.0 : diffuse;
`,
            ))),
        { vertexShader: I, fragmentShader: g }
      )
    },
  })
  return (
    (A.transparent = !0),
    (A.forceSinglePass = !0),
    Object.defineProperties(A, {
      isTroikaTextMaterial: { value: !0 },
      // WebGLShadowMap reverses the side of the shadow material by default, which fails
      // for planes, so here we force the `shadowSide` to always match the main side.
      shadowSide: {
        get() {
          return this.side
        },
        set() {},
      },
    }),
    A
  )
}
const vv = /* @__PURE__ */ new La({
    color: 16777215,
    side: rE,
    transparent: !0,
  }),
  Cx = 8421504,
  ex = /* @__PURE__ */ new RC(),
  FU = /* @__PURE__ */ new wA(),
  Im = /* @__PURE__ */ new wA(),
  x0 = [],
  W9 = /* @__PURE__ */ new wA(),
  gm = "+x+y"
function ix(e) {
  return Array.isArray(e) ? e[0] : e
}
let uO = () => {
    const e = new EB(new su(1, 1), vv)
    return ((uO = () => e), e)
  },
  DO = () => {
    const e = new EB(new su(1, 1, 32, 1), vv)
    return ((DO = () => e), e)
  }
const V9 = { type: "syncstart" },
  j9 = { type: "synccomplete" },
  SO = [
    "font",
    "fontSize",
    "fontStyle",
    "fontWeight",
    "lang",
    "letterSpacing",
    "lineHeight",
    "maxWidth",
    "overflowWrap",
    "text",
    "direction",
    "textAlign",
    "textIndent",
    "whiteSpace",
    "anchorX",
    "anchorY",
    "colorRanges",
    "sdfGlyphSize",
  ],
  z9 = SO.concat(
    "material",
    "color",
    "depthOffset",
    "clipRect",
    "curveRadius",
    "orientation",
    "glyphGeometryDetail",
  )
let fO = class extends EB {
  constructor() {
    const A = new x9()
    ;(super(A, null),
      (this.text = ""),
      (this.anchorX = 0),
      (this.anchorY = 0),
      (this.curveRadius = 0),
      (this.direction = "auto"),
      (this.font = null),
      (this.unicodeFontsURL = null),
      (this.fontSize = 0.1),
      (this.fontWeight = "normal"),
      (this.fontStyle = "normal"),
      (this.lang = null),
      (this.letterSpacing = 0),
      (this.lineHeight = "normal"),
      (this.maxWidth = 1 / 0),
      (this.overflowWrap = "normal"),
      (this.textAlign = "left"),
      (this.textIndent = 0),
      (this.whiteSpace = "normal"),
      (this.material = null),
      (this.color = null),
      (this.colorRanges = null),
      (this.outlineWidth = 0),
      (this.outlineColor = 0),
      (this.outlineOpacity = 1),
      (this.outlineBlur = 0),
      (this.outlineOffsetX = 0),
      (this.outlineOffsetY = 0),
      (this.strokeWidth = 0),
      (this.strokeColor = Cx),
      (this.strokeOpacity = 1),
      (this.fillOpacity = 1),
      (this.depthOffset = 0),
      (this.clipRect = null),
      (this.orientation = gm),
      (this.glyphGeometryDetail = 1),
      (this.sdfGlyphSize = null),
      (this.gpuAccelerateSDF = !0),
      (this.debugSDF = !1))
  }
  /**
   * Updates the text rendering according to the current text-related configuration properties.
   * This is an async process, so you can pass in a callback function to be executed when it
   * finishes.
   * @param {function} [callback]
   */
  sync(A) {
    this._needsSync &&
      ((this._needsSync = !1),
      this._isSyncing
        ? (this._queuedSyncs || (this._queuedSyncs = [])).push(A)
        : ((this._isSyncing = !0),
          this.dispatchEvent(V9),
          sO(
            {
              text: this.text,
              font: this.font,
              lang: this.lang,
              fontSize: this.fontSize || 0.1,
              fontWeight: this.fontWeight || "normal",
              fontStyle: this.fontStyle || "normal",
              letterSpacing: this.letterSpacing || 0,
              lineHeight: this.lineHeight || "normal",
              maxWidth: this.maxWidth,
              direction: this.direction || "auto",
              textAlign: this.textAlign,
              textIndent: this.textIndent,
              whiteSpace: this.whiteSpace,
              overflowWrap: this.overflowWrap,
              anchorX: this.anchorX,
              anchorY: this.anchorY,
              colorRanges: this.colorRanges,
              includeCaretPositions: !0,
              //TODO parameterize
              sdfGlyphSize: this.sdfGlyphSize,
              gpuAccelerateSDF: this.gpuAccelerateSDF,
              unicodeFontsURL: this.unicodeFontsURL,
            },
            (I) => {
              ;((this._isSyncing = !1),
                (this._textRenderInfo = I),
                this.geometry.updateGlyphs(
                  I.glyphBounds,
                  I.glyphAtlasIndices,
                  I.blockBounds,
                  I.chunkedBounds,
                  I.glyphColors,
                ))
              const g = this._queuedSyncs
              ;(g &&
                ((this._queuedSyncs = null),
                (this._needsSync = !0),
                this.sync(() => {
                  g.forEach((C) => C && C())
                })),
                this.dispatchEvent(j9),
                A && A())
            },
          )))
  }
  /**
   * Initiate a sync if needed - note it won't complete until next frame at the
   * earliest so if possible it's a good idea to call sync() manually as soon as
   * all the properties have been set.
   * @override
   */
  onBeforeRender(A, I, g, C, i, B) {
    ;(this.sync(), i.isTroikaTextMaterial && this._prepareForRender(i))
  }
  /**
   * Shortcut to dispose the geometry specific to this instance.
   * Note: we don't also dispose the derived material here because if anything else is
   * sharing the same base material it will result in a pause next frame as the program
   * is recompiled. Instead users can dispose the base material manually, like normal,
   * and we'll also dispose the derived material at that time.
   */
  dispose() {
    this.geometry.dispose()
  }
  /**
   * @property {TroikaTextRenderInfo|null} textRenderInfo
   * @readonly
   * The current processed rendering data for this TextMesh, returned by the TextBuilder after
   * a `sync()` call. This will be `null` initially, and may be stale for a short period until
   * the asynchrous `sync()` process completes.
   */
  get textRenderInfo() {
    return this._textRenderInfo || null
  }
  /**
   * Create the text derived material from the base material. Can be overridden to use a custom
   * derived material.
   */
  createDerivedMaterial(A) {
    return P9(A)
  }
  // Handler for automatically wrapping the base material with our upgrades. We do the wrapping
  // lazily on _read_ rather than write to avoid unnecessary wrapping on transient values.
  get material() {
    let A = this._derivedMaterial
    const I = this._baseMaterial || this._defaultMaterial || (this._defaultMaterial = vv.clone())
    if (
      ((!A || !A.isDerivedFrom(I)) &&
        ((A = this._derivedMaterial = this.createDerivedMaterial(I)),
        I.addEventListener("dispose", function g() {
          ;(I.removeEventListener("dispose", g), A.dispose())
        })),
      this.hasOutline())
    ) {
      let g = A._outlineMtl
      return (
        g ||
          ((g = A._outlineMtl =
            Object.create(A, {
              id: { value: A.id + 0.1 },
            })),
          (g.isTextOutlineMaterial = !0),
          (g.depthWrite = !1),
          (g.map = null),
          A.addEventListener("dispose", function C() {
            ;(A.removeEventListener("dispose", C), g.dispose())
          })),
        [g, A]
      )
    } else return A
  }
  set material(A) {
    A && A.isTroikaTextMaterial
      ? ((this._derivedMaterial = A), (this._baseMaterial = A.baseMaterial))
      : (this._baseMaterial = A)
  }
  hasOutline() {
    return !!(this.outlineWidth || this.outlineBlur || this.outlineOffsetX || this.outlineOffsetY)
  }
  get glyphGeometryDetail() {
    return this.geometry.detail
  }
  set glyphGeometryDetail(A) {
    this.geometry.detail = A
  }
  get curveRadius() {
    return this.geometry.curveRadius
  }
  set curveRadius(A) {
    this.geometry.curveRadius = A
  }
  // Create and update material for shadows upon request:
  get customDepthMaterial() {
    return ix(this.material).getDepthMaterial()
  }
  get customDistanceMaterial() {
    return ix(this.material).getDistanceMaterial()
  }
  _prepareForRender(A) {
    const I = A.isTextOutlineMaterial,
      g = A.uniforms,
      C = this.textRenderInfo
    if (C) {
      const { sdfTexture: o, blockBounds: r } = C
      ;((g.uTroikaSDFTexture.value = o),
        g.uTroikaSDFTextureSize.value.set(o.image.width, o.image.height),
        (g.uTroikaSDFGlyphSize.value = C.sdfGlyphSize),
        (g.uTroikaSDFExponent.value = C.sdfExponent),
        g.uTroikaTotalBounds.value.fromArray(r),
        (g.uTroikaUseGlyphColors.value = !I && !!C.glyphColors))
      let s = 0,
        h = 0,
        S = 0,
        d,
        w,
        M,
        K = 0,
        R = 0
      if (I) {
        let {
          outlineWidth: L,
          outlineOffsetX: Y,
          outlineOffsetY: H,
          outlineBlur: V,
          outlineOpacity: j,
        } = this
        ;((s = this._parsePercent(L) || 0),
          (h = Math.max(0, this._parsePercent(V) || 0)),
          (d = j),
          (K = this._parsePercent(Y) || 0),
          (R = this._parsePercent(H) || 0))
      } else
        ((S = Math.max(0, this._parsePercent(this.strokeWidth) || 0)),
          S &&
            ((M = this.strokeColor),
            g.uTroikaStrokeColor.value.set(M ?? Cx),
            (w = this.strokeOpacity),
            w == null && (w = 1)),
          (d = this.fillOpacity))
      ;((g.uTroikaEdgeOffset.value = s),
        g.uTroikaPositionOffset.value.set(K, R),
        (g.uTroikaBlurRadius.value = h),
        (g.uTroikaStrokeWidth.value = S),
        (g.uTroikaStrokeOpacity.value = w),
        (g.uTroikaFillOpacity.value = d ?? 1),
        (g.uTroikaCurveRadius.value = this.curveRadius || 0))
      let F = this.clipRect
      if (F && Array.isArray(F) && F.length === 4) g.uTroikaClipRect.value.fromArray(F)
      else {
        const L = (this.fontSize || 0.1) * 100
        g.uTroikaClipRect.value.set(r[0] - L, r[1] - L, r[2] + L, r[3] + L)
      }
      this.geometry.applyClipRect(g.uTroikaClipRect.value)
    }
    ;((g.uTroikaSDFDebug.value = !!this.debugSDF),
      (A.polygonOffset = !!this.depthOffset),
      (A.polygonOffsetFactor = A.polygonOffsetUnits = this.depthOffset || 0))
    const i = I ? this.outlineColor || 0 : this.color
    if (i == null) delete A.color
    else {
      const o = A.hasOwnProperty("color") ? A.color : (A.color = new Mg())
      ;(i !== o._input || typeof i == "object") && o.set((o._input = i))
    }
    let B = this.orientation || gm
    if (B !== A._orientation) {
      let o = g.uTroikaOrient.value
      B = B.replace(/[^-+xyz]/g, "")
      let r = B !== gm && B.match(/^([-+])([xyz])([-+])([xyz])$/)
      if (r) {
        let [, s, h, S, d] = r
        ;((FU.set(0, 0, 0)[h] = s === "-" ? 1 : -1),
          (Im.set(0, 0, 0)[d] = S === "-" ? -1 : 1),
          ex.lookAt(W9, FU.cross(Im), Im),
          o.setFromMatrix4(ex))
      } else o.identity()
      A._orientation = B
    }
  }
  _parsePercent(A) {
    if (typeof A == "string") {
      let I = A.match(/^(-?[\d.]+)%$/),
        g = I ? parseFloat(I[1]) : NaN
      A = (isNaN(g) ? 0 : g / 100) * this.fontSize
    }
    return A
  }
  /**
   * Translate a point in local space to an x/y in the text plane.
   */
  localPositionToTextCoords(A, I = new ZI()) {
    I.copy(A)
    const g = this.curveRadius
    return (g && (I.x = Math.atan2(A.x, Math.abs(g) - Math.abs(A.z)) * Math.abs(g)), I)
  }
  /**
   * Translate a point in world space to an x/y in the text plane.
   */
  worldPositionToTextCoords(A, I = new ZI()) {
    return (FU.copy(A), this.localPositionToTextCoords(this.worldToLocal(FU), I))
  }
  /**
   * @override Custom raycasting to test against the whole text block's max rectangular bounds
   * TODO is there any reason to make this more granular, like within individual line or glyph rects?
   */
  raycast(A, I) {
    const { textRenderInfo: g, curveRadius: C } = this
    if (g) {
      const i = g.blockBounds,
        B = C ? DO() : uO(),
        o = B.geometry,
        { position: r, uv: s } = o.attributes
      for (let h = 0; h < s.count; h++) {
        let S = i[0] + s.getX(h) * (i[2] - i[0])
        const d = i[1] + s.getY(h) * (i[3] - i[1])
        let w = 0
        ;(C && ((w = C - Math.cos(S / C) * C), (S = Math.sin(S / C) * C)), r.setXYZ(h, S, d, w))
      }
      ;((o.boundingSphere = this.geometry.boundingSphere),
        (o.boundingBox = this.geometry.boundingBox),
        (B.matrixWorld = this.matrixWorld),
        (B.material.side = this.material.side),
        (x0.length = 0),
        B.raycast(A, x0))
      for (let h = 0; h < x0.length; h++) ((x0[h].object = this), I.push(x0[h]))
    }
  }
  copy(A) {
    const I = this.geometry
    return (
      super.copy(A),
      (this.geometry = I),
      z9.forEach((g) => {
        this[g] = A[g]
      }),
      this
    )
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
SO.forEach((e) => {
  const A = "_private_" + e
  Object.defineProperty(fO.prototype, e, {
    get() {
      return this[A]
    },
    set(I) {
      I !== this[A] && ((this[A] = I), (this._needsSync = !0))
    },
  })
})
new Vo()
new Mg()
const X9 = /* @__PURE__ */ xI.forwardRef(
  (
    {
      sdfGlyphSize: e = 64,
      anchorX: A = "center",
      anchorY: I = "middle",
      font: g,
      fontSize: C = 1,
      children: i,
      characters: B,
      onSync: o,
      ...r
    },
    s,
  ) => {
    const h = Ya(({ invalidate: M }) => M),
      [S] = xI.useState(() => new fO()),
      [d, w] = xI.useMemo(() => {
        const M = []
        let K = ""
        return (
          xI.Children.forEach(i, (R) => {
            typeof R == "string" || typeof R == "number" ? (K += R) : M.push(R)
          }),
          [M, K]
        )
      }, [i])
    return (
      pF(
        () =>
          new Promise((M) =>
            v9(
              {
                font: g,
                characters: B,
              },
              M,
            ),
          ),
        ["troika-text", g, B],
      ),
      xI.useLayoutEffect(
        () =>
          void S.sync(() => {
            ;(h(), o && o(S))
          }),
      ),
      xI.useEffect(() => () => S.dispose(), [S]),
      /* @__PURE__ */ xI.createElement(
        "primitive",
        GN(
          {
            object: S,
            ref: s,
            font: g,
            text: w,
            anchorX: A,
            anchorY: I,
            fontSize: C,
            sdfGlyphSize: e,
          },
          r,
        ),
        d,
      )
    )
  },
)
function $9(e, A, I, g) {
  const C = class extends VQ {
    constructor(B = {}) {
      const o = Object.entries(e)
      ;(super({
        uniforms: o.reduce((r, [s, h]) => {
          const S = AF.clone({
            [s]: {
              value: h,
            },
          })
          return {
            ...r,
            ...S,
          }
        }, {}),
        vertexShader: A,
        fragmentShader: I,
      }),
        (this.key = ""),
        o.forEach(([r]) =>
          Object.defineProperty(this, r, {
            get: () => this.uniforms[r].value,
            set: (s) => (this.uniforms[r].value = s),
          }),
        ),
        Object.assign(this, B))
    }
  }
  return ((C.key = XN.generateUUID()), C)
}
let RU = null,
  dO = "https://www.gstatic.com/draco/versioned/decoders/1.5.5/"
function yO(e = !0, A = !0, I) {
  return (g) => {
    ;(I && I(g),
      e &&
        (RU || (RU = new g9()),
        RU.setDecoderPath(typeof e == "string" ? e : dO),
        g.setDRACOLoader(RU)),
      A && g.setMeshoptDecoder(typeof $K == "function" ? $K() : $K))
  }
}
const TG = (e, A, I, g) => HG(mv, e, yO(A, I, g))
TG.preload = (e, A, I, g) => HG.preload(mv, e, yO(A, I, g))
TG.clear = (e) => HG.clear(mv, e)
TG.setDecoderPath = (e) => {
  dO = e
}
function tx(e, A, I) {
  const g = Ya((d) => d.size),
    C = Ya((d) => d.viewport),
    i = typeof e == "number" ? e : g.width * C.dpr,
    B = g.height * C.dpr,
    o = (typeof e == "number" ? I : e) || {},
    { samples: r = 0, depth: s, ...h } = o,
    S = xI.useMemo(() => {
      const d = new BQ(i, B, {
        minFilter: nt,
        magFilter: nt,
        type: KD,
        ...h,
      })
      return (s && (d.depthTexture = new JG(i, B, sE)), (d.samples = r), d)
    }, [])
  return (
    xI.useLayoutEffect(() => {
      ;(S.setSize(i, B), r && (S.samples = r))
    }, [r, S, i, B]),
    xI.useEffect(() => () => S.dispose(), []),
    S
  )
}
function Cm(e, A, I, g) {
  return new (I || (I = Promise))(function (C, i) {
    function B(s) {
      try {
        r(g.next(s))
      } catch (h) {
        i(h)
      }
    }
    function o(s) {
      try {
        r(g.throw(s))
      } catch (h) {
        i(h)
      }
    }
    function r(s) {
      var h
      s.done
        ? C(s.value)
        : ((h = s.value),
          h instanceof I
            ? h
            : new I(function (S) {
                S(h)
              })).then(B, o)
    }
    r((g = g.apply(e, [])).next())
  })
}
const A6 = [
  "geforce 320m",
  "geforce 8600",
  "geforce 8600m gt",
  "geforce 8800 gs",
  "geforce 8800 gt",
  "geforce 9400",
  "geforce 9400m g",
  "geforce 9400m",
  "geforce 9600m gt",
  "geforce 9600m",
  "geforce fx go5200",
  "geforce gt 120",
  "geforce gt 130",
  "geforce gt 330m",
  "geforce gtx 285",
  "google swiftshader",
  "intel g41",
  "intel g45",
  "intel gma 4500mhd",
  "intel gma x3100",
  "intel hd 3000",
  "intel q45",
  "legacy",
  "mali-2",
  "mali-3",
  "mali-4",
  "quadro fx 1500",
  "quadro fx 4",
  "quadro fx 5",
  "radeon hd 2400",
  "radeon hd 2600",
  "radeon hd 4670",
  "radeon hd 4850",
  "radeon hd 4870",
  "radeon hd 5670",
  "radeon hd 5750",
  "radeon hd 6290",
  "radeon hd 6300",
  "radeon hd 6310",
  "radeon hd 6320",
  "radeon hd 6490m",
  "radeon hd 6630m",
  "radeon hd 6750m",
  "radeon hd 6770m",
  "radeon hd 6970m",
  "sgx 543",
  "sgx543",
]
function Bx(e) {
  return (e = e
    .toLowerCase()
    .replace(/.*angle ?\((.+)\)(?: on vulkan [0-9.]+)?$/i, "$1")
    .replace(/\s(\d{1,2}gb|direct3d.+$)|\(r\)| \([^)]+\)$/g, "")
    .replace(/(?:vulkan|opengl) \d+\.\d+(?:\.\d+)?(?: \((.*)\))?/, "$1"))
}
const pO = typeof window > "u",
  Hc = (() => {
    if (pO) return
    const { userAgent: e, platform: A, maxTouchPoints: I } = window.navigator,
      g = /(iphone|ipod|ipad)/i.test(e),
      C = A === "iPad" || (A === "MacIntel" && I > 0 && !window.MSStream)
    return {
      isIpad: C,
      isMobile: /android/i.test(e) || g || C,
      isSafari12: /Version\/12.+Safari/.test(e),
      isFirefox: /Firefox/.test(e),
    }
  })()
function I6(e, A, I) {
  if (!I) return [A]
  const g = (function (s) {
      const h = `
    precision highp float;
    attribute vec3 aPosition;
    varying float vvv;
    void main() {
      vvv = 0.31622776601683794;
      gl_Position = vec4(aPosition, 1.0);
    }
  `,
        S = `
    precision highp float;
    varying float vvv;
    void main() {
      vec4 enc = vec4(1.0, 255.0, 65025.0, 16581375.0) * vvv;
      enc = fract(enc);
      enc -= enc.yzww * vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 0.0);
      gl_FragColor = enc;
    }
  `,
        d = s.createShader(35633),
        w = s.createShader(35632),
        M = s.createProgram()
      if (!(w && d && M)) return
      ;(s.shaderSource(d, h),
        s.shaderSource(w, S),
        s.compileShader(d),
        s.compileShader(w),
        s.attachShader(M, d),
        s.attachShader(M, w),
        s.linkProgram(M),
        s.detachShader(M, d),
        s.detachShader(M, w),
        s.deleteShader(d),
        s.deleteShader(w),
        s.useProgram(M))
      const K = s.createBuffer()
      ;(s.bindBuffer(34962, K),
        s.bufferData(34962, new Float32Array([-1, -1, 0, 3, -1, 0, -1, 3, 0]), 35044))
      const R = s.getAttribLocation(M, "aPosition")
      ;(s.vertexAttribPointer(R, 3, 5126, !1, 0, 0),
        s.enableVertexAttribArray(R),
        s.clearColor(1, 1, 1, 1),
        s.clear(16384),
        s.viewport(0, 0, 1, 1),
        s.drawArrays(4, 0, 3))
      const F = new Uint8Array(4)
      return (
        s.readPixels(0, 0, 1, 1, 6408, 5121, F),
        s.deleteProgram(M),
        s.deleteBuffer(K),
        F.join("")
      )
    })(e),
    C = "801621810",
    i = "8016218135",
    B = "80162181161",
    o = Hc?.isIpad
      ? [
          ["a7", B, 12],
          ["a8", i, 15],
          ["a8x", i, 15],
          ["a9", i, 15],
          ["a9x", i, 15],
          ["a10", i, 15],
          ["a10x", i, 15],
          ["a12", C, 15],
          ["a12x", C, 15],
          ["a12z", C, 15],
          ["a14", C, 15],
          ["a15", C, 15],
          ["m1", C, 15],
          ["m2", C, 15],
        ]
      : [
          ["a7", B, 12],
          ["a8", i, 12],
          ["a9", i, 15],
          ["a10", i, 15],
          ["a11", C, 15],
          ["a12", C, 15],
          ["a13", C, 15],
          ["a14", C, 15],
          ["a15", C, 15],
          ["a16", C, 15],
          ["a17", C, 15],
        ]
  let r
  return (
    g === "80162181255"
      ? (r = o.filter(([, , s]) => s >= 14))
      : ((r = o.filter(([, s]) => s === g)), r.length || (r = o)),
    r.map(([s]) => `apple ${s} gpu`)
  )
}
let Qx = class extends Error {
  constructor(A) {
    ;(super(A), Object.setPrototypeOf(this, new.target.prototype))
  }
}
const em = [],
  ox = []
function g6(e, A) {
  if (e === A) return 0
  const I = e
  e.length > A.length && ((e = A), (A = I))
  let g = e.length,
    C = A.length
  for (; g > 0 && e.charCodeAt(~-g) === A.charCodeAt(~-C); ) (g--, C--)
  let i,
    B = 0
  for (; B < g && e.charCodeAt(B) === A.charCodeAt(B); ) B++
  if (((g -= B), (C -= B), g === 0)) return C
  let o,
    r,
    s = 0,
    h = 0,
    S = 0
  for (; h < g; ) ((ox[h] = e.charCodeAt(B + h)), (em[h] = ++h))
  for (; S < C; )
    for (i = A.charCodeAt(B + S), o = S++, s = S, h = 0; h < g; h++)
      ((r = i === ox[h] ? o : o + 1),
        (o = em[h]),
        (s = em[h] = o > s ? (r > s ? s + 1 : r) : r > o ? o + 1 : r))
  return s
}
function C6(e) {
  return e != null
}
const e6 = ({
    mobileTiers: e = [0, 15, 30, 60],
    desktopTiers: A = [0, 15, 30, 60],
    override: I = {},
    glContext: g,
    failIfMajorPerformanceCaveat: C = !1,
    benchmarksURL: i = "https://unpkg.com/detect-gpu@5.0.58/dist/benchmarks",
  } = {}) =>
    Cm(void 0, void 0, void 0, function* () {
      const B = {}
      if (pO) return { tier: 0, type: "SSR" }
      const {
        isIpad: o = !!Hc?.isIpad,
        isMobile: r = !!Hc?.isMobile,
        screenSize: s = window.screen,
        loadBenchmarks: h = (V) =>
          Cm(void 0, void 0, void 0, function* () {
            const j = yield fetch(`${i}/${V}`).then((P) => P.json())
            if (parseInt(j.shift().split(".")[0], 10) < 4)
              throw new Qx("Detect GPU benchmark data is out of date. Please update to version 4x")
            return j
          }),
      } = I
      let { renderer: S } = I
      const d = (V, j, P, AA, X) => ({ device: X, fps: AA, gpu: P, isMobile: r, tier: V, type: j })
      let w,
        M = ""
      if (S) ((S = Bx(S)), (w = [S]))
      else {
        const V =
          g ||
          (function (P, AA = !1) {
            const X = {
              alpha: !1,
              antialias: !1,
              depth: !1,
              failIfMajorPerformanceCaveat: AA,
              powerPreference: "high-performance",
              stencil: !1,
            }
            P && delete X.powerPreference
            const _ = window.document.createElement("canvas"),
              eA = _.getContext("webgl", X) || _.getContext("experimental-webgl", X)
            return eA ?? void 0
          })(Hc?.isSafari12, C)
        if (!V) return d(0, "WEBGL_UNSUPPORTED")
        const j = Hc?.isFirefox ? null : V.getExtension("WEBGL_debug_renderer_info")
        if (((S = j ? V.getParameter(j.UNMASKED_RENDERER_WEBGL) : V.getParameter(V.RENDERER)), !S))
          return d(1, "FALLBACK")
        ;((M = S),
          (S = Bx(S)),
          (w = (function (P, AA, X) {
            return AA === "apple gpu" ? I6(P, AA, X) : [AA]
          })(V, S, r)))
      }
      const K = (yield Promise.all(
        w.map(function (V) {
          var j
          return Cm(this, void 0, void 0, function* () {
            const P = ((GA) => {
              const DA = r
                ? ["adreno", "apple", "mali-t", "mali", "nvidia", "powervr", "samsung"]
                : ["intel", "apple", "amd", "radeon", "nvidia", "geforce", "adreno"]
              for (const dA of DA) if (GA.includes(dA)) return dA
            })(V)
            if (!P) return
            const AA = `${r ? "m" : "d"}-${P}${o ? "-ipad" : ""}.json`,
              X = (B[AA] = (j = B[AA]) !== null && j !== void 0 ? j : h(AA))
            let _
            try {
              _ = yield X
            } catch (GA) {
              if (GA instanceof Qx) throw GA
              return
            }
            const eA = (function (GA) {
              var DA
              const dA =
                (GA = GA.replace(/\([^)]+\)/, "")).match(/\d+/) ||
                GA.match(/(\W|^)([A-Za-z]{1,3})(\W|$)/g)
              return (DA = dA?.join("").replace(/\W|amd/g, "")) !== null && DA !== void 0 ? DA : ""
            })(V)
            let CA = _.filter(([, GA]) => GA === eA)
            CA.length || (CA = _.filter(([GA]) => GA.includes(V)))
            const aA = CA.length
            if (aA === 0) return
            const lA = V.split(/[.,()\[\]/\s]/g)
              .sort()
              .filter((GA, DA, dA) => DA === 0 || GA !== dA[DA - 1])
              .join(" ")
            let JA,
              [yA, , , , LA] =
                aA > 1
                  ? CA.map((GA) => [GA, g6(lA, GA[2])]).sort(([, GA], [, DA]) => GA - DA)[0][0]
                  : CA[0],
              nA = Number.MAX_VALUE
            const { devicePixelRatio: fA } = window,
              sA = s.width * fA * s.height * fA
            for (const GA of LA) {
              const [DA, dA] = GA,
                kA = DA * dA,
                NA = Math.abs(sA - kA)
              NA < nA && ((nA = NA), (JA = GA))
            }
            if (!JA) return
            const [, , $, EA] = JA
            return [nA, $, yA, EA]
          })
        }),
      ))
        .filter(C6)
        .sort(([V = Number.MAX_VALUE, j], [P = Number.MAX_VALUE, AA]) => (V === P ? j - AA : V - P))
      if (!K.length) {
        const V = A6.find((j) => S.includes(j))
        return V ? d(0, "BLOCKLISTED", V) : d(1, "FALLBACK", `${S} (${M})`)
      }
      const [, R, F, L] = K[0]
      if (R === -1) return d(0, "BLOCKLISTED", F, R, L)
      const Y = r ? e : A
      let H = 0
      for (let V = 0; V < Y.length; V++) R >= Y[V] && (H = V)
      return d(H, "BENCHMARK", F, R, L)
    }),
  i6 = (e) => pF(() => e6(e), ["useDetectGPU"]),
  t6 = /* @__PURE__ */ $9(
    {},
    "void main() { }",
    "void main() { gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0); discard;  }",
  )
class B6 extends Hr {
  constructor(A = 6, I = !1) {
    ;(super(),
      (this.uniforms = {
        chromaticAberration: {
          value: 0.05,
        },
        // Transmission must always be 0, unless transmissionSampler is being used
        transmission: {
          value: 0,
        },
        // Instead a workaround is used, see below for reasons why
        _transmission: {
          value: 1,
        },
        transmissionMap: {
          value: null,
        },
        // Roughness is 1 in THREE.MeshPhysicalMaterial but it makes little sense in a transmission material
        roughness: {
          value: 0,
        },
        thickness: {
          value: 0,
        },
        thicknessMap: {
          value: null,
        },
        attenuationDistance: {
          value: 1 / 0,
        },
        attenuationColor: {
          value: new Mg("white"),
        },
        anisotropicBlur: {
          value: 0.1,
        },
        time: {
          value: 0,
        },
        distortion: {
          value: 0,
        },
        distortionScale: {
          value: 0.5,
        },
        temporalDistortion: {
          value: 0,
        },
        buffer: {
          value: null,
        },
      }),
      (this.onBeforeCompile = (g) => {
        ;((g.uniforms = {
          ...g.uniforms,
          ...this.uniforms,
        }),
          this.anisotropy > 0 && (g.defines.USE_ANISOTROPY = ""),
          I ? (g.defines.USE_SAMPLER = "") : (g.defines.USE_TRANSMISSION = ""),
          (g.fragmentShader =
            /*glsl*/
            `
      uniform float chromaticAberration;         
      uniform float anisotropicBlur;      
      uniform float time;
      uniform float distortion;
      uniform float distortionScale;
      uniform float temporalDistortion;
      uniform sampler2D buffer;

      vec3 random3(vec3 c) {
        float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));
        vec3 r;
        r.z = fract(512.0*j);
        j *= .125;
        r.x = fract(512.0*j);
        j *= .125;
        r.y = fract(512.0*j);
        return r-0.5;
      }

      uint hash( uint x ) {
        x += ( x << 10u );
        x ^= ( x >>  6u );
        x += ( x <<  3u );
        x ^= ( x >> 11u );
        x += ( x << 15u );
        return x;
      }

      // Compound versions of the hashing algorithm I whipped together.
      uint hash( uvec2 v ) { return hash( v.x ^ hash(v.y)                         ); }
      uint hash( uvec3 v ) { return hash( v.x ^ hash(v.y) ^ hash(v.z)             ); }
      uint hash( uvec4 v ) { return hash( v.x ^ hash(v.y) ^ hash(v.z) ^ hash(v.w) ); }

      // Construct a float with half-open range [0:1] using low 23 bits.
      // All zeroes yields 0.0, all ones yields the next smallest representable value below 1.0.
      float floatConstruct( uint m ) {
        const uint ieeeMantissa = 0x007FFFFFu; // binary32 mantissa bitmask
        const uint ieeeOne      = 0x3F800000u; // 1.0 in IEEE binary32
        m &= ieeeMantissa;                     // Keep only mantissa bits (fractional part)
        m |= ieeeOne;                          // Add fractional part to 1.0
        float  f = uintBitsToFloat( m );       // Range [1:2]
        return f - 1.0;                        // Range [0:1]
      }

      // Pseudo-random value in half-open range [0:1].
      float randomBase( float x ) { return floatConstruct(hash(floatBitsToUint(x))); }
      float randomBase( vec2  v ) { return floatConstruct(hash(floatBitsToUint(v))); }
      float randomBase( vec3  v ) { return floatConstruct(hash(floatBitsToUint(v))); }
      float randomBase( vec4  v ) { return floatConstruct(hash(floatBitsToUint(v))); }
      float rand(float seed) {
        float result = randomBase(vec3(gl_FragCoord.xy, seed));
        return result;
      }

      const float F3 =  0.3333333;
      const float G3 =  0.1666667;

      float snoise(vec3 p) {
        vec3 s = floor(p + dot(p, vec3(F3)));
        vec3 x = p - s + dot(s, vec3(G3));
        vec3 e = step(vec3(0.0), x - x.yzx);
        vec3 i1 = e*(1.0 - e.zxy);
        vec3 i2 = 1.0 - e.zxy*(1.0 - e);
        vec3 x1 = x - i1 + G3;
        vec3 x2 = x - i2 + 2.0*G3;
        vec3 x3 = x - 1.0 + 3.0*G3;
        vec4 w, d;
        w.x = dot(x, x);
        w.y = dot(x1, x1);
        w.z = dot(x2, x2);
        w.w = dot(x3, x3);
        w = max(0.6 - w, 0.0);
        d.x = dot(random3(s), x);
        d.y = dot(random3(s + i1), x1);
        d.z = dot(random3(s + i2), x2);
        d.w = dot(random3(s + 1.0), x3);
        w *= w;
        w *= w;
        d *= w;
        return dot(d, vec4(52.0));
      }

      float snoiseFractal(vec3 m) {
        return 0.5333333* snoise(m)
              +0.2666667* snoise(2.0*m)
              +0.1333333* snoise(4.0*m)
              +0.0666667* snoise(8.0*m);
      }
` + g.fragmentShader),
          (g.fragmentShader = g.fragmentShader.replace(
            "#include <transmission_pars_fragment>",
            /*glsl*/
            `
        #ifdef USE_TRANSMISSION
          // Transmission code is based on glTF-Sampler-Viewer
          // https://github.com/KhronosGroup/glTF-Sample-Viewer
          uniform float _transmission;
          uniform float thickness;
          uniform float attenuationDistance;
          uniform vec3 attenuationColor;
          #ifdef USE_TRANSMISSIONMAP
            uniform sampler2D transmissionMap;
          #endif
          #ifdef USE_THICKNESSMAP
            uniform sampler2D thicknessMap;
          #endif
          uniform vec2 transmissionSamplerSize;
          uniform sampler2D transmissionSamplerMap;
          uniform mat4 modelMatrix;
          uniform mat4 projectionMatrix;
          varying vec3 vWorldPosition;
          vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
            // Direction of refracted light.
            vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
            // Compute rotation-independant scaling of the model matrix.
            vec3 modelScale;
            modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
            modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
            modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
            // The thickness is specified in local space.
            return normalize( refractionVector ) * thickness * modelScale;
          }
          float applyIorToRoughness( const in float roughness, const in float ior ) {
            // Scale roughness with IOR so that an IOR of 1.0 results in no microfacet refraction and
            // an IOR of 1.5 results in the default amount of microfacet refraction.
            return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
          }
          vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
            float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );            
            #ifdef USE_SAMPLER
              #ifdef texture2DLodEXT
                return texture2DLodEXT(transmissionSamplerMap, fragCoord.xy, framebufferLod);
              #else
                return texture2D(transmissionSamplerMap, fragCoord.xy, framebufferLod);
              #endif
            #else
              return texture2D(buffer, fragCoord.xy);
            #endif
          }
          vec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
            if ( isinf( attenuationDistance ) ) {
              // Attenuation distance is +∞, i.e. the transmitted color is not attenuated at all.
              return radiance;
            } else {
              // Compute light attenuation using Beer's law.
              vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
              vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance ); // Beer's law
              return transmittance * radiance;
            }
          }
          vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
            const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
            const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,
            const in vec3 attenuationColor, const in float attenuationDistance ) {
            vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
            vec3 refractedRayExit = position + transmissionRay;
            // Project refracted vector on the framebuffer, while mapping to normalized device coordinates.
            vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
            vec2 refractionCoords = ndcPos.xy / ndcPos.w;
            refractionCoords += 1.0;
            refractionCoords /= 2.0;
            // Sample framebuffer to get pixel the refracted ray hits.
            vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
            vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );
            // Get the specular component.
            vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
            return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );
          }
        #endif
`,
          )),
          (g.fragmentShader = g.fragmentShader.replace(
            "#include <transmission_fragment>",
            /*glsl*/
            `  
        // Improve the refraction to use the world pos
        material.transmission = _transmission;
        material.transmissionAlpha = 1.0;
        material.thickness = thickness;
        material.attenuationDistance = attenuationDistance;
        material.attenuationColor = attenuationColor;
        #ifdef USE_TRANSMISSIONMAP
          material.transmission *= texture2D( transmissionMap, vUv ).r;
        #endif
        #ifdef USE_THICKNESSMAP
          material.thickness *= texture2D( thicknessMap, vUv ).g;
        #endif
        
        vec3 pos = vWorldPosition;
        float runningSeed = 0.0;
        vec3 v = normalize( cameraPosition - pos );
        vec3 n = inverseTransformDirection( normal, viewMatrix );
        vec3 transmission = vec3(0.0);
        float transmissionR, transmissionB, transmissionG;
        float randomCoords = rand(runningSeed++);
        float thickness_smear = thickness * max(pow(roughnessFactor, 0.33), anisotropicBlur);
        vec3 distortionNormal = vec3(0.0);
        vec3 temporalOffset = vec3(time, -time, -time) * temporalDistortion;
        if (distortion > 0.0) {
          distortionNormal = distortion * vec3(snoiseFractal(vec3((pos * distortionScale + temporalOffset))), snoiseFractal(vec3(pos.zxy * distortionScale - temporalOffset)), snoiseFractal(vec3(pos.yxz * distortionScale + temporalOffset)));
        }
        for (float i = 0.0; i < ${A}.0; i ++) {
          vec3 sampleNorm = normalize(n + roughnessFactor * roughnessFactor * 2.0 * normalize(vec3(rand(runningSeed++) - 0.5, rand(runningSeed++) - 0.5, rand(runningSeed++) - 0.5)) * pow(rand(runningSeed++), 0.33) + distortionNormal);
          transmissionR = getIBLVolumeRefraction(
            sampleNorm, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
            pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness  + thickness_smear * (i + randomCoords) / float(${A}),
            material.attenuationColor, material.attenuationDistance
          ).r;
          transmissionG = getIBLVolumeRefraction(
            sampleNorm, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
            pos, modelMatrix, viewMatrix, projectionMatrix, material.ior  * (1.0 + chromaticAberration * (i + randomCoords) / float(${A})) , material.thickness + thickness_smear * (i + randomCoords) / float(${A}),
            material.attenuationColor, material.attenuationDistance
          ).g;
          transmissionB = getIBLVolumeRefraction(
            sampleNorm, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
            pos, modelMatrix, viewMatrix, projectionMatrix, material.ior * (1.0 + 2.0 * chromaticAberration * (i + randomCoords) / float(${A})), material.thickness + thickness_smear * (i + randomCoords) / float(${A}),
            material.attenuationColor, material.attenuationDistance
          ).b;
          transmission.r += transmissionR;
          transmission.g += transmissionG;
          transmission.b += transmissionB;
        }
        transmission /= ${A}.0;
        totalDiffuse = mix( totalDiffuse, transmission.rgb, material.transmission );
`,
          )))
      }),
      Object.keys(this.uniforms).forEach((g) =>
        Object.defineProperty(this, g, {
          get: () => this.uniforms[g].value,
          set: (C) => (this.uniforms[g].value = C),
        }),
      ))
  }
}
const Q6 = /* @__PURE__ */ xI.forwardRef(
    (
      {
        buffer: e,
        transmissionSampler: A = !1,
        backside: I = !1,
        side: g = Us,
        transmission: C = 1,
        thickness: i = 0,
        backsideThickness: B = 0,
        backsideEnvMapIntensity: o = 1,
        samples: r = 10,
        resolution: s,
        backsideResolution: h,
        background: S,
        anisotropy: d,
        anisotropicBlur: w,
        ...M
      },
      K,
    ) => {
      Jv({
        MeshTransmissionMaterial: B6,
      })
      const R = xI.useRef(null),
        [F] = xI.useState(() => new t6()),
        L = tx(h || s),
        Y = tx(s)
      let H, V, j, P
      return (
        Mp((AA) => {
          ;((R.current.time = AA.clock.getElapsedTime()),
            R.current.buffer === Y.texture &&
              !A &&
              ((P = R.current.__r3f.parent),
              P &&
                ((j = AA.gl.toneMapping),
                (H = AA.scene.background),
                (V = R.current.envMapIntensity),
                (AA.gl.toneMapping = Ms),
                S && (AA.scene.background = S),
                (P.material = F),
                I &&
                  (AA.gl.setRenderTarget(L),
                  AA.gl.render(AA.scene, AA.camera),
                  (P.material = R.current),
                  (P.material.buffer = L.texture),
                  (P.material.thickness = B),
                  (P.material.side = WQ),
                  (P.material.envMapIntensity = o)),
                AA.gl.setRenderTarget(Y),
                AA.gl.render(AA.scene, AA.camera),
                (P.material = R.current),
                (P.material.thickness = i),
                (P.material.side = g),
                (P.material.buffer = Y.texture),
                (P.material.envMapIntensity = V),
                (AA.scene.background = H),
                AA.gl.setRenderTarget(null),
                (AA.gl.toneMapping = j))))
        }),
        xI.useImperativeHandle(K, () => R.current, []),
        /* @__PURE__ */ xI.createElement(
          "meshTransmissionMaterial",
          GN(
            {
              // Samples must re-compile the shader so we memoize it
              args: [r, A],
              ref: R,
            },
            M,
            {
              buffer: e || Y.texture,
              _transmission: C,
              anisotropicBlur: w ?? d,
              transmission: A ? C : 0,
              thickness: i,
              side: g,
            },
          ),
        )
      )
    },
  ),
  o6 = ({ focus: e = 0, size: A = 25, samples: I = 10 } = {}) => `
#define PENUMBRA_FILTER_SIZE float(${A})
#define RGB_NOISE_FUNCTION(uv) (randRGB(uv))
vec3 randRGB(vec2 uv) {
  return vec3(
    fract(sin(dot(uv, vec2(12.75613, 38.12123))) * 13234.76575),
    fract(sin(dot(uv, vec2(19.45531, 58.46547))) * 43678.23431),
    fract(sin(dot(uv, vec2(23.67817, 78.23121))) * 93567.23423)
  );
}

vec3 lowPassRandRGB(vec2 uv) {
  // 3x3 convolution (average)
  // can be implemented as separable with an extra buffer for a total of 6 samples instead of 9
  vec3 result = vec3(0);
  result += RGB_NOISE_FUNCTION(uv + vec2(-1.0, -1.0));
  result += RGB_NOISE_FUNCTION(uv + vec2(-1.0,  0.0));
  result += RGB_NOISE_FUNCTION(uv + vec2(-1.0, +1.0));
  result += RGB_NOISE_FUNCTION(uv + vec2( 0.0, -1.0));
  result += RGB_NOISE_FUNCTION(uv + vec2( 0.0,  0.0));
  result += RGB_NOISE_FUNCTION(uv + vec2( 0.0, +1.0));
  result += RGB_NOISE_FUNCTION(uv + vec2(+1.0, -1.0));
  result += RGB_NOISE_FUNCTION(uv + vec2(+1.0,  0.0));
  result += RGB_NOISE_FUNCTION(uv + vec2(+1.0, +1.0));
  result *= 0.111111111; // 1.0 / 9.0
  return result;
}
vec3 highPassRandRGB(vec2 uv) {
  // by subtracting the low-pass signal from the original signal, we're being left with the high-pass signal
  // hp(x) = x - lp(x)
  return RGB_NOISE_FUNCTION(uv) - lowPassRandRGB(uv) + 0.5;
}


vec2 vogelDiskSample(int sampleIndex, int sampleCount, float angle) {
  const float goldenAngle = 2.399963f; // radians
  float r = sqrt(float(sampleIndex) + 0.5f) / sqrt(float(sampleCount));
  float theta = float(sampleIndex) * goldenAngle + angle;
  float sine = sin(theta);
  float cosine = cos(theta);
  return vec2(cosine, sine) * r;
}
float penumbraSize( const in float zReceiver, const in float zBlocker ) { // Parallel plane estimation
  return (zReceiver - zBlocker) / zBlocker;
}
float findBlocker(sampler2D shadowMap, vec2 uv, float compare, float angle) {
  float texelSize = 1.0 / float(textureSize(shadowMap, 0).x);
  float blockerDepthSum = float(${e});
  float blockers = 0.0;

  int j = 0;
  vec2 offset = vec2(0.);
  float depth = 0.;

  #pragma unroll_loop_start
  for(int i = 0; i < ${I}; i ++) {
    offset = (vogelDiskSample(j, ${I}, angle) * texelSize) * 2.0 * PENUMBRA_FILTER_SIZE;
    depth = unpackRGBAToDepth( texture2D( shadowMap, uv + offset));
    if (depth < compare) {
      blockerDepthSum += depth;
      blockers++;
    }
    j++;
  }
  #pragma unroll_loop_end

  if (blockers > 0.0) {
    return blockerDepthSum / blockers;
  }
  return -1.0;
}

        
float vogelFilter(sampler2D shadowMap, vec2 uv, float zReceiver, float filterRadius, float angle) {
  float texelSize = 1.0 / float(textureSize(shadowMap, 0).x);
  float shadow = 0.0f;
  int j = 0;
  vec2 vogelSample = vec2(0.0);
  vec2 offset = vec2(0.0);
  #pragma unroll_loop_start
  for (int i = 0; i < ${I}; i++) {
    vogelSample = vogelDiskSample(j, ${I}, angle) * texelSize;
    offset = vogelSample * (1.0 + filterRadius * float(${A}));
    shadow += step( zReceiver, unpackRGBAToDepth( texture2D( shadowMap, uv + offset ) ) );
    j++;
  }
  #pragma unroll_loop_end
  return shadow * 1.0 / ${I}.0;
}

float PCSS (sampler2D shadowMap, vec4 coords) {
  vec2 uv = coords.xy;
  float zReceiver = coords.z; // Assumed to be eye-space z in this code
  float angle = highPassRandRGB(gl_FragCoord.xy).r * PI2;
  float avgBlockerDepth = findBlocker(shadowMap, uv, zReceiver, angle);
  if (avgBlockerDepth == -1.0) {
    return 1.0;
  }
  float penumbraRatio = penumbraSize(zReceiver, avgBlockerDepth);
  return vogelFilter(shadowMap, uv, zReceiver, 1.25 * penumbraRatio, angle);
}`
function nx(e, A, I) {
  ;(A.traverse((g) => {
    g.material &&
      (e.properties.remove(g.material), g.material.dispose == null || g.material.dispose())
  }),
    (e.info.programs.length = 0),
    e.compile(A, I))
}
function n6({ focus: e = 0, samples: A = 10, size: I = 25 }) {
  const g = Ya((B) => B.gl),
    C = Ya((B) => B.scene),
    i = Ya((B) => B.camera)
  return (
    xI.useEffect(() => {
      const B = ne.shadowmap_pars_fragment
      return (
        (ne.shadowmap_pars_fragment = ne.shadowmap_pars_fragment
          .replace(
            "#ifdef USE_SHADOWMAP",
            `#ifdef USE_SHADOWMAP
` +
              o6({
                size: I,
                samples: A,
                focus: e,
              }),
          )
          .replace(
            "#if defined( SHADOWMAP_TYPE_PCF )",
            `
return PCSS(shadowMap, shadowCoord);
#if defined( SHADOWMAP_TYPE_PCF )`,
          )),
        nx(g, C, i),
        () => {
          ;((ne.shadowmap_pars_fragment = B), nx(g, C, i))
        }
      )
    }, [e, I, A]),
    null
  )
}
let b
const Si = new Array(128).fill(void 0)
Si.push(void 0, null, !0, !1)
let oG = Si.length
function ZQ(e) {
  oG === Si.length && Si.push(Si.length + 1)
  const A = oG
  return ((oG = Si[A]), (Si[A] = e), A)
}
function Vi(e) {
  return Si[e]
}
function fG(e) {
  const A = Vi(e)
  return (
    (function (I) {
      I < 132 || ((Si[I] = oG), (oG = I))
    })(e),
    A
  )
}
function QC(e) {
  return e == null
}
let P0 = null
function dG() {
  return ((P0 !== null && P0.byteLength !== 0) || (P0 = new Float64Array(b.memory.buffer)), P0)
}
let W0 = null
function VC() {
  return ((W0 !== null && W0.byteLength !== 0) || (W0 = new Int32Array(b.memory.buffer)), W0)
}
const wO =
  typeof TextDecoder < "u"
    ? new TextDecoder("utf-8", { ignoreBOM: !0, fatal: !0 })
    : {
        decode: () => {
          throw Error("TextDecoder not available")
        },
      }
typeof TextDecoder < "u" && wO.decode()
let V0 = null
function GO(e, A) {
  return (
    (e >>>= 0),
    wO.decode(
      ((V0 !== null && V0.byteLength !== 0) || (V0 = new Uint8Array(b.memory.buffer)), V0).subarray(
        e,
        e + A,
      ),
    )
  )
}
function xA(e, A) {
  if (!(e instanceof A)) throw new Error(`expected instance of ${A.name}`)
  return e.ptr
}
let j0 = null
function nB() {
  return ((j0 !== null && j0.byteLength !== 0) || (j0 = new Float32Array(b.memory.buffer)), j0)
}
let mt = 128
function fB(e) {
  if (mt == 1) throw new Error("out of js stack")
  return ((Si[--mt] = e), mt)
}
function Ex(e, A) {
  return ((e >>>= 0), nB().subarray(e / 4, e / 4 + A))
}
let z0 = null
function kO() {
  return ((z0 !== null && z0.byteLength !== 0) || (z0 = new Uint32Array(b.memory.buffer)), z0)
}
let Kr = 0
function Sf(e, A) {
  const I = A(4 * e.length, 4) >>> 0
  return (nB().set(e, I / 4), (Kr = e.length), I)
}
function JU(e, A) {
  const I = A(4 * e.length, 4) >>> 0
  return (kO().set(e, I / 4), (Kr = e.length), I)
}
function im(e, A) {
  try {
    return e.apply(this, A)
  } catch (I) {
    b.__wbindgen_exn_store(ZQ(I))
  }
}
const GF = Object.freeze({
    LinX: 0,
    0: "LinX",
    LinY: 1,
    1: "LinY",
    LinZ: 2,
    2: "LinZ",
    AngX: 3,
    3: "AngX",
    AngY: 4,
    4: "AngY",
    AngZ: 5,
    5: "AngZ",
  }),
  wl = Object.freeze({
    Revolute: 0,
    0: "Revolute",
    Fixed: 1,
    1: "Fixed",
    Prismatic: 2,
    2: "Prismatic",
    Rope: 3,
    3: "Rope",
    Spring: 4,
    4: "Spring",
    Spherical: 5,
    5: "Spherical",
    Generic: 6,
    6: "Generic",
  }),
  Jn = Object.freeze({
    Ball: 0,
    0: "Ball",
    Cuboid: 1,
    1: "Cuboid",
    Capsule: 2,
    2: "Capsule",
    Segment: 3,
    3: "Segment",
    Polyline: 4,
    4: "Polyline",
    Triangle: 5,
    5: "Triangle",
    TriMesh: 6,
    6: "TriMesh",
    HeightField: 7,
    7: "HeightField",
    Compound: 8,
    8: "Compound",
    ConvexPolyhedron: 9,
    9: "ConvexPolyhedron",
    Cylinder: 10,
    10: "Cylinder",
    Cone: 11,
    11: "Cone",
    RoundCuboid: 12,
    12: "RoundCuboid",
    RoundTriangle: 13,
    13: "RoundTriangle",
    RoundCylinder: 14,
    14: "RoundCylinder",
    RoundCone: 15,
    15: "RoundCone",
    RoundConvexPolyhedron: 16,
    16: "RoundConvexPolyhedron",
    HalfSpace: 17,
    17: "HalfSpace",
  }),
  ax =
    typeof FinalizationRegistry > "u"
      ? { register: () => {}, unregister: () => {} }
      : new FinalizationRegistry((e) => b.__wbg_rawbroadphase_free(e >>> 0))
class xf {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(xf.prototype)
    return ((I.__wbg_ptr = A), ax.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), ax.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawbroadphase_free(A)
  }
  constructor() {
    const A = b.rawbroadphase_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
}
const E6 =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawccdsolver_free(e >>> 0))
class mm {
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), E6.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawccdsolver_free(A)
  }
  constructor() {
    const A = b.rawccdsolver_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
}
const a6 =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawcharactercollision_free(e >>> 0))
class MO {
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), a6.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawcharactercollision_free(A)
  }
  constructor() {
    const A = b.rawcharactercollision_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
  handle() {
    return b.rawcharactercollision_handle(this.__wbg_ptr)
  }
  translationDeltaApplied() {
    const A = b.rawcharactercollision_translationDeltaApplied(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  translationDeltaRemaining() {
    const A = b.rawcharactercollision_translationDeltaRemaining(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  toi() {
    return b.rawcharactercollision_toi(this.__wbg_ptr)
  }
  worldWitness1() {
    const A = b.rawcharactercollision_worldWitness1(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  worldWitness2() {
    const A = b.rawcharactercollision_worldWitness2(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  worldNormal1() {
    const A = b.rawcharactercollision_worldNormal1(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  worldNormal2() {
    const A = b.rawcharactercollision_worldNormal2(this.__wbg_ptr)
    return BI.__wrap(A)
  }
}
const rx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawcolliderset_free(e >>> 0))
class YB {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(YB.prototype)
    return ((I.__wbg_ptr = A), rx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), rx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawcolliderset_free(A)
  }
  coTranslation(A) {
    const I = b.rawcolliderset_coTranslation(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  coRotation(A) {
    const I = b.rawcolliderset_coRotation(this.__wbg_ptr, A)
    return je.__wrap(I)
  }
  coSetTranslation(A, I, g, C) {
    b.rawcolliderset_coSetTranslation(this.__wbg_ptr, A, I, g, C)
  }
  coSetTranslationWrtParent(A, I, g, C) {
    b.rawcolliderset_coSetTranslationWrtParent(this.__wbg_ptr, A, I, g, C)
  }
  coSetRotation(A, I, g, C, i) {
    b.rawcolliderset_coSetRotation(this.__wbg_ptr, A, I, g, C, i)
  }
  coSetRotationWrtParent(A, I, g, C, i) {
    b.rawcolliderset_coSetRotationWrtParent(this.__wbg_ptr, A, I, g, C, i)
  }
  coIsSensor(A) {
    return b.rawcolliderset_coIsSensor(this.__wbg_ptr, A) !== 0
  }
  coShapeType(A) {
    return b.rawcolliderset_coShapeType(this.__wbg_ptr, A)
  }
  coHalfspaceNormal(A) {
    const I = b.rawcolliderset_coHalfspaceNormal(this.__wbg_ptr, A)
    return I === 0 ? void 0 : BI.__wrap(I)
  }
  coHalfExtents(A) {
    const I = b.rawcolliderset_coHalfExtents(this.__wbg_ptr, A)
    return I === 0 ? void 0 : BI.__wrap(I)
  }
  coSetHalfExtents(A, I) {
    ;(xA(I, BI), b.rawcolliderset_coSetHalfExtents(this.__wbg_ptr, A, I.__wbg_ptr))
  }
  coRadius(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawcolliderset_coRadius(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  coSetRadius(A, I) {
    b.rawcolliderset_coSetRadius(this.__wbg_ptr, A, I)
  }
  coHalfHeight(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawcolliderset_coHalfHeight(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  coSetHalfHeight(A, I) {
    b.rawcolliderset_coSetHalfHeight(this.__wbg_ptr, A, I)
  }
  coRoundRadius(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawcolliderset_coRoundRadius(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  coSetRoundRadius(A, I) {
    b.rawcolliderset_coSetRoundRadius(this.__wbg_ptr, A, I)
  }
  coVertices(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawcolliderset_coVertices(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = VC()[C / 4 + 1]
      let i
      return (I !== 0 && ((i = Ex(I, g).slice()), b.__wbindgen_free(I, 4 * g, 4)), i)
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  coIndices(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawcolliderset_coIndices(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = VC()[C / 4 + 1]
      let i
      return (
        I !== 0 &&
          ((i = (function (B, o) {
            return ((B >>>= 0), kO().subarray(B / 4, B / 4 + o))
          })(I, g).slice()),
          b.__wbindgen_free(I, 4 * g, 4)),
        i
      )
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  coTriMeshFlags(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawcolliderset_coTriMeshFlags(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = VC()[C / 4 + 1]
      return I === 0 ? void 0 : g >>> 0
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  coHeightFieldFlags(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawcolliderset_coHeightFieldFlags(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = VC()[C / 4 + 1]
      return I === 0 ? void 0 : g >>> 0
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  coHeightfieldHeights(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawcolliderset_coHeightfieldHeights(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = VC()[C / 4 + 1]
      let i
      return (I !== 0 && ((i = Ex(I, g).slice()), b.__wbindgen_free(I, 4 * g, 4)), i)
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  coHeightfieldScale(A) {
    const I = b.rawcolliderset_coHeightfieldScale(this.__wbg_ptr, A)
    return I === 0 ? void 0 : BI.__wrap(I)
  }
  coHeightfieldNRows(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawcolliderset_coHeightfieldNRows(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = VC()[C / 4 + 1]
      return I === 0 ? void 0 : g >>> 0
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  coHeightfieldNCols(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawcolliderset_coHeightfieldNCols(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = VC()[C / 4 + 1]
      return I === 0 ? void 0 : g >>> 0
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  coParent(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawcolliderset_coParent(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = dG()[C / 8 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  coSetEnabled(A, I) {
    b.rawcolliderset_coSetEnabled(this.__wbg_ptr, A, I)
  }
  coIsEnabled(A) {
    return b.rawcolliderset_coIsEnabled(this.__wbg_ptr, A) !== 0
  }
  coSetContactSkin(A, I) {
    b.rawcolliderset_coSetContactSkin(this.__wbg_ptr, A, I)
  }
  coContactSkin(A) {
    return b.rawcolliderset_coContactSkin(this.__wbg_ptr, A)
  }
  coFriction(A) {
    return b.rawcolliderset_coFriction(this.__wbg_ptr, A)
  }
  coRestitution(A) {
    return b.rawcolliderset_coRestitution(this.__wbg_ptr, A)
  }
  coDensity(A) {
    return b.rawcolliderset_coDensity(this.__wbg_ptr, A)
  }
  coMass(A) {
    return b.rawcolliderset_coMass(this.__wbg_ptr, A)
  }
  coVolume(A) {
    return b.rawcolliderset_coVolume(this.__wbg_ptr, A)
  }
  coCollisionGroups(A) {
    return b.rawcolliderset_coCollisionGroups(this.__wbg_ptr, A) >>> 0
  }
  coSolverGroups(A) {
    return b.rawcolliderset_coSolverGroups(this.__wbg_ptr, A) >>> 0
  }
  coActiveHooks(A) {
    return b.rawcolliderset_coActiveHooks(this.__wbg_ptr, A) >>> 0
  }
  coActiveCollisionTypes(A) {
    return b.rawcolliderset_coActiveCollisionTypes(this.__wbg_ptr, A)
  }
  coActiveEvents(A) {
    return b.rawcolliderset_coActiveEvents(this.__wbg_ptr, A) >>> 0
  }
  coContactForceEventThreshold(A) {
    return b.rawcolliderset_coContactForceEventThreshold(this.__wbg_ptr, A)
  }
  coContainsPoint(A, I) {
    return (xA(I, BI), b.rawcolliderset_coContainsPoint(this.__wbg_ptr, A, I.__wbg_ptr) !== 0)
  }
  coCastShape(A, I, g, C, i, B, o, r, s) {
    ;(xA(I, BI), xA(g, bC), xA(C, BI), xA(i, je), xA(B, BI))
    const h = b.rawcolliderset_coCastShape(
      this.__wbg_ptr,
      A,
      I.__wbg_ptr,
      g.__wbg_ptr,
      C.__wbg_ptr,
      i.__wbg_ptr,
      B.__wbg_ptr,
      o,
      r,
      s,
    )
    return h === 0 ? void 0 : FF.__wrap(h)
  }
  coCastCollider(A, I, g, C, i, B, o) {
    ;(xA(I, BI), xA(C, BI))
    const r = b.rawcolliderset_coCastCollider(
      this.__wbg_ptr,
      A,
      I.__wbg_ptr,
      g,
      C.__wbg_ptr,
      i,
      B,
      o,
    )
    return r === 0 ? void 0 : kF.__wrap(r)
  }
  coIntersectsShape(A, I, g, C) {
    return (
      xA(I, bC),
      xA(g, BI),
      xA(C, je),
      b.rawcolliderset_coIntersectsShape(
        this.__wbg_ptr,
        A,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C.__wbg_ptr,
      ) !== 0
    )
  }
  coContactShape(A, I, g, C, i) {
    ;(xA(I, bC), xA(g, BI), xA(C, je))
    const B = b.rawcolliderset_coContactShape(
      this.__wbg_ptr,
      A,
      I.__wbg_ptr,
      g.__wbg_ptr,
      C.__wbg_ptr,
      i,
    )
    return B === 0 ? void 0 : yG.__wrap(B)
  }
  coContactCollider(A, I, g) {
    const C = b.rawcolliderset_coContactCollider(this.__wbg_ptr, A, I, g)
    return C === 0 ? void 0 : yG.__wrap(C)
  }
  coProjectPoint(A, I, g) {
    xA(I, BI)
    const C = b.rawcolliderset_coProjectPoint(this.__wbg_ptr, A, I.__wbg_ptr, g)
    return MF.__wrap(C)
  }
  coIntersectsRay(A, I, g, C) {
    return (
      xA(I, BI),
      xA(g, BI),
      b.rawcolliderset_coIntersectsRay(this.__wbg_ptr, A, I.__wbg_ptr, g.__wbg_ptr, C) !== 0
    )
  }
  coCastRay(A, I, g, C, i) {
    return (
      xA(I, BI),
      xA(g, BI),
      b.rawcolliderset_coCastRay(this.__wbg_ptr, A, I.__wbg_ptr, g.__wbg_ptr, C, i)
    )
  }
  coCastRayAndGetNormal(A, I, g, C, i) {
    ;(xA(I, BI), xA(g, BI))
    const B = b.rawcolliderset_coCastRayAndGetNormal(
      this.__wbg_ptr,
      A,
      I.__wbg_ptr,
      g.__wbg_ptr,
      C,
      i,
    )
    return B === 0 ? void 0 : NF.__wrap(B)
  }
  coSetSensor(A, I) {
    b.rawcolliderset_coSetSensor(this.__wbg_ptr, A, I)
  }
  coSetRestitution(A, I) {
    b.rawcolliderset_coSetRestitution(this.__wbg_ptr, A, I)
  }
  coSetFriction(A, I) {
    b.rawcolliderset_coSetFriction(this.__wbg_ptr, A, I)
  }
  coFrictionCombineRule(A) {
    return b.rawcolliderset_coFrictionCombineRule(this.__wbg_ptr, A) >>> 0
  }
  coSetFrictionCombineRule(A, I) {
    b.rawcolliderset_coSetFrictionCombineRule(this.__wbg_ptr, A, I)
  }
  coRestitutionCombineRule(A) {
    return b.rawcolliderset_coRestitutionCombineRule(this.__wbg_ptr, A) >>> 0
  }
  coSetRestitutionCombineRule(A, I) {
    b.rawcolliderset_coSetRestitutionCombineRule(this.__wbg_ptr, A, I)
  }
  coSetCollisionGroups(A, I) {
    b.rawcolliderset_coSetCollisionGroups(this.__wbg_ptr, A, I)
  }
  coSetSolverGroups(A, I) {
    b.rawcolliderset_coSetSolverGroups(this.__wbg_ptr, A, I)
  }
  coSetActiveHooks(A, I) {
    b.rawcolliderset_coSetActiveHooks(this.__wbg_ptr, A, I)
  }
  coSetActiveEvents(A, I) {
    b.rawcolliderset_coSetActiveEvents(this.__wbg_ptr, A, I)
  }
  coSetActiveCollisionTypes(A, I) {
    b.rawcolliderset_coSetActiveCollisionTypes(this.__wbg_ptr, A, I)
  }
  coSetShape(A, I) {
    ;(xA(I, bC), b.rawcolliderset_coSetShape(this.__wbg_ptr, A, I.__wbg_ptr))
  }
  coSetContactForceEventThreshold(A, I) {
    b.rawcolliderset_coSetContactForceEventThreshold(this.__wbg_ptr, A, I)
  }
  coSetDensity(A, I) {
    b.rawcolliderset_coSetDensity(this.__wbg_ptr, A, I)
  }
  coSetMass(A, I) {
    b.rawcolliderset_coSetMass(this.__wbg_ptr, A, I)
  }
  coSetMassProperties(A, I, g, C, i) {
    ;(xA(g, BI),
      xA(C, BI),
      xA(i, je),
      b.rawcolliderset_coSetMassProperties(
        this.__wbg_ptr,
        A,
        I,
        g.__wbg_ptr,
        C.__wbg_ptr,
        i.__wbg_ptr,
      ))
  }
  constructor() {
    const A = b.rawcolliderset_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
  len() {
    return b.rawcolliderset_len(this.__wbg_ptr) >>> 0
  }
  contains(A) {
    return b.rawcolliderset_contains(this.__wbg_ptr, A) !== 0
  }
  createCollider(A, I, g, C, i, B, o, r, s, h, S, d, w, M, K, R, F, L, Y, H, V, j, P, AA, X) {
    try {
      const CA = b.__wbindgen_add_to_stack_pointer(-16)
      ;(xA(I, bC),
        xA(g, BI),
        xA(C, je),
        xA(o, BI),
        xA(r, BI),
        xA(s, je),
        xA(X, NQ),
        b.rawcolliderset_createCollider(
          CA,
          this.__wbg_ptr,
          A,
          I.__wbg_ptr,
          g.__wbg_ptr,
          C.__wbg_ptr,
          i,
          B,
          o.__wbg_ptr,
          r.__wbg_ptr,
          s.__wbg_ptr,
          h,
          S,
          d,
          w,
          M,
          K,
          R,
          F,
          L,
          Y,
          H,
          V,
          j,
          P,
          AA,
          X.__wbg_ptr,
        ))
      var _ = VC()[CA / 4 + 0],
        eA = dG()[CA / 8 + 1]
      return _ === 0 ? void 0 : eA
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  remove(A, I, g, C) {
    ;(xA(I, nu), xA(g, NQ), b.rawcolliderset_remove(this.__wbg_ptr, A, I.__wbg_ptr, g.__wbg_ptr, C))
  }
  isHandleValid(A) {
    return b.rawcolliderset_contains(this.__wbg_ptr, A) !== 0
  }
  forEachColliderHandle(A) {
    try {
      b.rawcolliderset_forEachColliderHandle(this.__wbg_ptr, fB(A))
    } finally {
      Si[mt++] = void 0
    }
  }
}
const sx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawcollidershapecasthit_free(e >>> 0))
class kF {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(kF.prototype)
    return ((I.__wbg_ptr = A), sx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), sx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawcollidershapecasthit_free(A)
  }
  colliderHandle() {
    return b.rawcharactercollision_handle(this.__wbg_ptr)
  }
  time_of_impact() {
    return b.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr)
  }
  witness1() {
    const A = b.rawcollidershapecasthit_witness1(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  witness2() {
    const A = b.rawcollidershapecasthit_witness2(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  normal1() {
    const A = b.rawcharactercollision_translationDeltaApplied(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  normal2() {
    const A = b.rawcharactercollision_translationDeltaRemaining(this.__wbg_ptr)
    return BI.__wrap(A)
  }
}
const lx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawcontactforceevent_free(e >>> 0))
class Lv {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(Lv.prototype)
    return ((I.__wbg_ptr = A), lx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), lx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawcontactforceevent_free(A)
  }
  collider1() {
    return b.rawcharactercollision_handle(this.__wbg_ptr)
  }
  collider2() {
    return b.rawcontactforceevent_collider2(this.__wbg_ptr)
  }
  total_force() {
    const A = b.rawcontactforceevent_total_force(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  total_force_magnitude() {
    return b.rawcontactforceevent_total_force_magnitude(this.__wbg_ptr)
  }
  max_force_direction() {
    const A = b.rawcontactforceevent_max_force_direction(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  max_force_magnitude() {
    return b.rawcontactforceevent_max_force_magnitude(this.__wbg_ptr)
  }
}
const cx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawcontactmanifold_free(e >>> 0))
class Yv {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(Yv.prototype)
    return ((I.__wbg_ptr = A), cx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), cx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawcontactmanifold_free(A)
  }
  normal() {
    const A = b.rawcontactmanifold_normal(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  local_n1() {
    const A = b.rawcontactmanifold_local_n1(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  local_n2() {
    const A = b.rawcontactmanifold_local_n2(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  subshape1() {
    return b.rawcontactmanifold_subshape1(this.__wbg_ptr) >>> 0
  }
  subshape2() {
    return b.rawcontactmanifold_subshape2(this.__wbg_ptr) >>> 0
  }
  num_contacts() {
    return b.rawcontactmanifold_num_contacts(this.__wbg_ptr) >>> 0
  }
  contact_local_p1(A) {
    const I = b.rawcontactmanifold_contact_local_p1(this.__wbg_ptr, A)
    return I === 0 ? void 0 : BI.__wrap(I)
  }
  contact_local_p2(A) {
    const I = b.rawcontactmanifold_contact_local_p2(this.__wbg_ptr, A)
    return I === 0 ? void 0 : BI.__wrap(I)
  }
  contact_dist(A) {
    return b.rawcontactmanifold_contact_dist(this.__wbg_ptr, A)
  }
  contact_fid1(A) {
    return b.rawcontactmanifold_contact_fid1(this.__wbg_ptr, A) >>> 0
  }
  contact_fid2(A) {
    return b.rawcontactmanifold_contact_fid2(this.__wbg_ptr, A) >>> 0
  }
  contact_impulse(A) {
    return b.rawcontactmanifold_contact_impulse(this.__wbg_ptr, A)
  }
  contact_tangent_impulse_x(A) {
    return b.rawcontactmanifold_contact_tangent_impulse_x(this.__wbg_ptr, A)
  }
  contact_tangent_impulse_y(A) {
    return b.rawcontactmanifold_contact_tangent_impulse_y(this.__wbg_ptr, A)
  }
  num_solver_contacts() {
    return b.rawcontactmanifold_num_solver_contacts(this.__wbg_ptr) >>> 0
  }
  solver_contact_point(A) {
    const I = b.rawcontactmanifold_solver_contact_point(this.__wbg_ptr, A)
    return I === 0 ? void 0 : BI.__wrap(I)
  }
  solver_contact_dist(A) {
    return b.rawcontactmanifold_solver_contact_dist(this.__wbg_ptr, A)
  }
  solver_contact_friction(A) {
    return b.rawcontactmanifold_solver_contact_friction(this.__wbg_ptr, A)
  }
  solver_contact_restitution(A) {
    return b.rawcontactmanifold_solver_contact_restitution(this.__wbg_ptr, A)
  }
  solver_contact_tangent_velocity(A) {
    const I = b.rawcontactmanifold_solver_contact_tangent_velocity(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
}
const hx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawcontactpair_free(e >>> 0))
class qv {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(qv.prototype)
    return ((I.__wbg_ptr = A), hx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), hx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawcontactpair_free(A)
  }
  collider1() {
    return b.rawcontactpair_collider1(this.__wbg_ptr)
  }
  collider2() {
    return b.rawcontactpair_collider2(this.__wbg_ptr)
  }
  numContactManifolds() {
    return b.rawcontactpair_numContactManifolds(this.__wbg_ptr) >>> 0
  }
  contactManifold(A) {
    const I = b.rawcontactpair_contactManifold(this.__wbg_ptr, A)
    return I === 0 ? void 0 : Yv.__wrap(I)
  }
}
const r6 =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawdebugrenderpipeline_free(e >>> 0))
class s6 {
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), r6.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawdebugrenderpipeline_free(A)
  }
  constructor() {
    const A = b.rawdebugrenderpipeline_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
  vertices() {
    return fG(b.rawdebugrenderpipeline_vertices(this.__wbg_ptr))
  }
  colors() {
    return fG(b.rawdebugrenderpipeline_colors(this.__wbg_ptr))
  }
  render(A, I, g, C, i) {
    ;(xA(A, NQ),
      xA(I, YB),
      xA(g, ou),
      xA(C, Eu),
      xA(i, JD),
      b.rawdebugrenderpipeline_render(
        this.__wbg_ptr,
        A.__wbg_ptr,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C.__wbg_ptr,
        i.__wbg_ptr,
      ))
  }
}
const ux =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawdeserializedworld_free(e >>> 0))
class Hv {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(Hv.prototype)
    return ((I.__wbg_ptr = A), ux.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), ux.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawdeserializedworld_free(A)
  }
  takeGravity() {
    const A = b.rawdeserializedworld_takeGravity(this.__wbg_ptr)
    return A === 0 ? void 0 : BI.__wrap(A)
  }
  takeIntegrationParameters() {
    const A = b.rawdeserializedworld_takeIntegrationParameters(this.__wbg_ptr)
    return A === 0 ? void 0 : bf.__wrap(A)
  }
  takeIslandManager() {
    const A = b.rawdeserializedworld_takeIslandManager(this.__wbg_ptr)
    return A === 0 ? void 0 : nu.__wrap(A)
  }
  takeBroadPhase() {
    const A = b.rawdeserializedworld_takeBroadPhase(this.__wbg_ptr)
    return A === 0 ? void 0 : xf.__wrap(A)
  }
  takeNarrowPhase() {
    const A = b.rawdeserializedworld_takeNarrowPhase(this.__wbg_ptr)
    return A === 0 ? void 0 : JD.__wrap(A)
  }
  takeBodies() {
    const A = b.rawdeserializedworld_takeBodies(this.__wbg_ptr)
    return A === 0 ? void 0 : NQ.__wrap(A)
  }
  takeColliders() {
    const A = b.rawdeserializedworld_takeColliders(this.__wbg_ptr)
    return A === 0 ? void 0 : YB.__wrap(A)
  }
  takeImpulseJoints() {
    const A = b.rawdeserializedworld_takeImpulseJoints(this.__wbg_ptr)
    return A === 0 ? void 0 : ou.__wrap(A)
  }
  takeMultibodyJoints() {
    const A = b.rawdeserializedworld_takeMultibodyJoints(this.__wbg_ptr)
    return A === 0 ? void 0 : Eu.__wrap(A)
  }
}
const l6 =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawdynamicraycastvehiclecontroller_free(e >>> 0))
class c6 {
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), l6.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawdynamicraycastvehiclecontroller_free(A)
  }
  constructor(A) {
    const I = b.rawdynamicraycastvehiclecontroller_new(A)
    return ((this.__wbg_ptr = I >>> 0), this)
  }
  current_vehicle_speed() {
    return b.rawdynamicraycastvehiclecontroller_current_vehicle_speed(this.__wbg_ptr)
  }
  chassis() {
    return b.rawdynamicraycastvehiclecontroller_chassis(this.__wbg_ptr)
  }
  index_up_axis() {
    return b.rawdynamicraycastvehiclecontroller_index_up_axis(this.__wbg_ptr) >>> 0
  }
  set_index_up_axis(A) {
    b.rawdynamicraycastvehiclecontroller_set_index_up_axis(this.__wbg_ptr, A)
  }
  index_forward_axis() {
    return b.rawdynamicraycastvehiclecontroller_index_forward_axis(this.__wbg_ptr) >>> 0
  }
  set_index_forward_axis(A) {
    b.rawdynamicraycastvehiclecontroller_set_index_forward_axis(this.__wbg_ptr, A)
  }
  add_wheel(A, I, g, C, i) {
    ;(xA(A, BI),
      xA(I, BI),
      xA(g, BI),
      b.rawdynamicraycastvehiclecontroller_add_wheel(
        this.__wbg_ptr,
        A.__wbg_ptr,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C,
        i,
      ))
  }
  num_wheels() {
    return b.rawdynamicraycastvehiclecontroller_num_wheels(this.__wbg_ptr) >>> 0
  }
  update_vehicle(A, I, g, C, i, B, o) {
    try {
      ;(xA(I, NQ),
        xA(g, YB),
        xA(C, Tv),
        b.rawdynamicraycastvehiclecontroller_update_vehicle(
          this.__wbg_ptr,
          A,
          I.__wbg_ptr,
          g.__wbg_ptr,
          C.__wbg_ptr,
          i,
          !QC(B),
          QC(B) ? 0 : B,
          fB(o),
        ))
    } finally {
      Si[mt++] = void 0
    }
  }
  wheel_chassis_connection_point_cs(A) {
    const I = b.rawdynamicraycastvehiclecontroller_wheel_chassis_connection_point_cs(
      this.__wbg_ptr,
      A,
    )
    return I === 0 ? void 0 : BI.__wrap(I)
  }
  set_wheel_chassis_connection_point_cs(A, I) {
    ;(xA(I, BI),
      b.rawdynamicraycastvehiclecontroller_set_wheel_chassis_connection_point_cs(
        this.__wbg_ptr,
        A,
        I.__wbg_ptr,
      ))
  }
  wheel_suspension_rest_length(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_suspension_rest_length(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  set_wheel_suspension_rest_length(A, I) {
    b.rawdynamicraycastvehiclecontroller_set_wheel_suspension_rest_length(this.__wbg_ptr, A, I)
  }
  wheel_max_suspension_travel(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_max_suspension_travel(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  set_wheel_max_suspension_travel(A, I) {
    b.rawdynamicraycastvehiclecontroller_set_wheel_max_suspension_travel(this.__wbg_ptr, A, I)
  }
  wheel_radius(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_radius(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  set_wheel_radius(A, I) {
    b.rawdynamicraycastvehiclecontroller_set_wheel_radius(this.__wbg_ptr, A, I)
  }
  wheel_suspension_stiffness(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_suspension_stiffness(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  set_wheel_suspension_stiffness(A, I) {
    b.rawdynamicraycastvehiclecontroller_set_wheel_suspension_stiffness(this.__wbg_ptr, A, I)
  }
  wheel_suspension_compression(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_suspension_compression(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  set_wheel_suspension_compression(A, I) {
    b.rawdynamicraycastvehiclecontroller_set_wheel_suspension_compression(this.__wbg_ptr, A, I)
  }
  wheel_suspension_relaxation(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_suspension_relaxation(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  set_wheel_suspension_relaxation(A, I) {
    b.rawdynamicraycastvehiclecontroller_set_wheel_suspension_relaxation(this.__wbg_ptr, A, I)
  }
  wheel_max_suspension_force(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_max_suspension_force(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  set_wheel_max_suspension_force(A, I) {
    b.rawdynamicraycastvehiclecontroller_set_wheel_max_suspension_force(this.__wbg_ptr, A, I)
  }
  wheel_brake(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_brake(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  set_wheel_brake(A, I) {
    b.rawdynamicraycastvehiclecontroller_set_wheel_brake(this.__wbg_ptr, A, I)
  }
  wheel_steering(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_steering(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  set_wheel_steering(A, I) {
    b.rawdynamicraycastvehiclecontroller_set_wheel_steering(this.__wbg_ptr, A, I)
  }
  wheel_engine_force(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_engine_force(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  set_wheel_engine_force(A, I) {
    b.rawdynamicraycastvehiclecontroller_set_wheel_engine_force(this.__wbg_ptr, A, I)
  }
  wheel_direction_cs(A) {
    const I = b.rawdynamicraycastvehiclecontroller_wheel_direction_cs(this.__wbg_ptr, A)
    return I === 0 ? void 0 : BI.__wrap(I)
  }
  set_wheel_direction_cs(A, I) {
    ;(xA(I, BI),
      b.rawdynamicraycastvehiclecontroller_set_wheel_direction_cs(this.__wbg_ptr, A, I.__wbg_ptr))
  }
  wheel_axle_cs(A) {
    const I = b.rawdynamicraycastvehiclecontroller_wheel_axle_cs(this.__wbg_ptr, A)
    return I === 0 ? void 0 : BI.__wrap(I)
  }
  set_wheel_axle_cs(A, I) {
    ;(xA(I, BI),
      b.rawdynamicraycastvehiclecontroller_set_wheel_axle_cs(this.__wbg_ptr, A, I.__wbg_ptr))
  }
  wheel_friction_slip(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_friction_slip(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  set_wheel_friction_slip(A, I) {
    b.rawdynamicraycastvehiclecontroller_set_wheel_friction_slip(this.__wbg_ptr, A, I)
  }
  wheel_side_friction_stiffness(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_side_friction_stiffness(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  set_wheel_side_friction_stiffness(A, I) {
    b.rawdynamicraycastvehiclecontroller_set_wheel_side_friction_stiffness(this.__wbg_ptr, A, I)
  }
  wheel_rotation(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_rotation(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  wheel_forward_impulse(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_forward_impulse(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  wheel_side_impulse(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_side_impulse(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  wheel_suspension_force(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_suspension_force(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  wheel_contact_normal_ws(A) {
    const I = b.rawdynamicraycastvehiclecontroller_wheel_contact_normal_ws(this.__wbg_ptr, A)
    return I === 0 ? void 0 : BI.__wrap(I)
  }
  wheel_contact_point_ws(A) {
    const I = b.rawdynamicraycastvehiclecontroller_wheel_contact_point_ws(this.__wbg_ptr, A)
    return I === 0 ? void 0 : BI.__wrap(I)
  }
  wheel_suspension_length(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_suspension_length(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = nB()[C / 4 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  wheel_hard_point_ws(A) {
    const I = b.rawdynamicraycastvehiclecontroller_wheel_hard_point_ws(this.__wbg_ptr, A)
    return I === 0 ? void 0 : BI.__wrap(I)
  }
  wheel_is_in_contact(A) {
    return b.rawdynamicraycastvehiclecontroller_wheel_is_in_contact(this.__wbg_ptr, A) !== 0
  }
  wheel_ground_object(A) {
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawdynamicraycastvehiclecontroller_wheel_ground_object(C, this.__wbg_ptr, A)
      var I = VC()[C / 4 + 0],
        g = dG()[C / 8 + 1]
      return I === 0 ? void 0 : g
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
}
const h6 =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_raweventqueue_free(e >>> 0))
class UO {
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), h6.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_raweventqueue_free(A)
  }
  constructor(A) {
    const I = b.raweventqueue_new(A)
    return ((this.__wbg_ptr = I >>> 0), this)
  }
  drainCollisionEvents(A) {
    try {
      b.raweventqueue_drainCollisionEvents(this.__wbg_ptr, fB(A))
    } finally {
      Si[mt++] = void 0
    }
  }
  drainContactForceEvents(A) {
    try {
      b.raweventqueue_drainContactForceEvents(this.__wbg_ptr, fB(A))
    } finally {
      Si[mt++] = void 0
    }
  }
  clear() {
    b.raweventqueue_clear(this.__wbg_ptr)
  }
}
const Dx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawgenericjoint_free(e >>> 0))
class Wo {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(Wo.prototype)
    return ((I.__wbg_ptr = A), Dx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), Dx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawgenericjoint_free(A)
  }
  static generic(A, I, g, C) {
    ;(xA(A, BI), xA(I, BI), xA(g, BI))
    const i = b.rawgenericjoint_generic(A.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C)
    return i === 0 ? void 0 : Wo.__wrap(i)
  }
  static spring(A, I, g, C, i) {
    ;(xA(C, BI), xA(i, BI))
    const B = b.rawgenericjoint_spring(A, I, g, C.__wbg_ptr, i.__wbg_ptr)
    return Wo.__wrap(B)
  }
  static rope(A, I, g) {
    ;(xA(I, BI), xA(g, BI))
    const C = b.rawgenericjoint_rope(A, I.__wbg_ptr, g.__wbg_ptr)
    return Wo.__wrap(C)
  }
  static spherical(A, I) {
    ;(xA(A, BI), xA(I, BI))
    const g = b.rawgenericjoint_spherical(A.__wbg_ptr, I.__wbg_ptr)
    return Wo.__wrap(g)
  }
  static prismatic(A, I, g, C, i, B) {
    ;(xA(A, BI), xA(I, BI), xA(g, BI))
    const o = b.rawgenericjoint_prismatic(A.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C, i, B)
    return o === 0 ? void 0 : Wo.__wrap(o)
  }
  static fixed(A, I, g, C) {
    ;(xA(A, BI), xA(I, je), xA(g, BI), xA(C, je))
    const i = b.rawgenericjoint_fixed(A.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr)
    return Wo.__wrap(i)
  }
  static revolute(A, I, g) {
    ;(xA(A, BI), xA(I, BI), xA(g, BI))
    const C = b.rawgenericjoint_revolute(A.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr)
    return C === 0 ? void 0 : Wo.__wrap(C)
  }
}
const Sx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawimpulsejointset_free(e >>> 0))
class ou {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(ou.prototype)
    return ((I.__wbg_ptr = A), Sx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), Sx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawimpulsejointset_free(A)
  }
  jointType(A) {
    return b.rawimpulsejointset_jointType(this.__wbg_ptr, A)
  }
  jointBodyHandle1(A) {
    return b.rawimpulsejointset_jointBodyHandle1(this.__wbg_ptr, A)
  }
  jointBodyHandle2(A) {
    return b.rawimpulsejointset_jointBodyHandle2(this.__wbg_ptr, A)
  }
  jointFrameX1(A) {
    const I = b.rawimpulsejointset_jointFrameX1(this.__wbg_ptr, A)
    return je.__wrap(I)
  }
  jointFrameX2(A) {
    const I = b.rawimpulsejointset_jointFrameX2(this.__wbg_ptr, A)
    return je.__wrap(I)
  }
  jointAnchor1(A) {
    const I = b.rawimpulsejointset_jointAnchor1(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  jointAnchor2(A) {
    const I = b.rawimpulsejointset_jointAnchor2(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  jointSetAnchor1(A, I) {
    ;(xA(I, BI), b.rawimpulsejointset_jointSetAnchor1(this.__wbg_ptr, A, I.__wbg_ptr))
  }
  jointSetAnchor2(A, I) {
    ;(xA(I, BI), b.rawimpulsejointset_jointSetAnchor2(this.__wbg_ptr, A, I.__wbg_ptr))
  }
  jointContactsEnabled(A) {
    return b.rawimpulsejointset_jointContactsEnabled(this.__wbg_ptr, A) !== 0
  }
  jointSetContactsEnabled(A, I) {
    b.rawimpulsejointset_jointSetContactsEnabled(this.__wbg_ptr, A, I)
  }
  jointLimitsEnabled(A, I) {
    return b.rawimpulsejointset_jointLimitsEnabled(this.__wbg_ptr, A, I) !== 0
  }
  jointLimitsMin(A, I) {
    return b.rawimpulsejointset_jointLimitsMin(this.__wbg_ptr, A, I)
  }
  jointLimitsMax(A, I) {
    return b.rawimpulsejointset_jointLimitsMax(this.__wbg_ptr, A, I)
  }
  jointSetLimits(A, I, g, C) {
    b.rawimpulsejointset_jointSetLimits(this.__wbg_ptr, A, I, g, C)
  }
  jointConfigureMotorModel(A, I, g) {
    b.rawimpulsejointset_jointConfigureMotorModel(this.__wbg_ptr, A, I, g)
  }
  jointConfigureMotorVelocity(A, I, g, C) {
    b.rawimpulsejointset_jointConfigureMotorVelocity(this.__wbg_ptr, A, I, g, C)
  }
  jointConfigureMotorPosition(A, I, g, C, i) {
    b.rawimpulsejointset_jointConfigureMotorPosition(this.__wbg_ptr, A, I, g, C, i)
  }
  jointConfigureMotor(A, I, g, C, i, B) {
    b.rawimpulsejointset_jointConfigureMotor(this.__wbg_ptr, A, I, g, C, i, B)
  }
  constructor() {
    const A = b.rawimpulsejointset_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
  createJoint(A, I, g, C) {
    return (xA(A, Wo), b.rawimpulsejointset_createJoint(this.__wbg_ptr, A.__wbg_ptr, I, g, C))
  }
  remove(A, I) {
    b.rawimpulsejointset_remove(this.__wbg_ptr, A, I)
  }
  len() {
    return b.rawimpulsejointset_len(this.__wbg_ptr) >>> 0
  }
  contains(A) {
    return b.rawimpulsejointset_contains(this.__wbg_ptr, A) !== 0
  }
  forEachJointHandle(A) {
    try {
      b.rawimpulsejointset_forEachJointHandle(this.__wbg_ptr, fB(A))
    } finally {
      Si[mt++] = void 0
    }
  }
  forEachJointAttachedToRigidBody(A, I) {
    try {
      b.rawimpulsejointset_forEachJointAttachedToRigidBody(this.__wbg_ptr, A, fB(I))
    } finally {
      Si[mt++] = void 0
    }
  }
}
const fx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawintegrationparameters_free(e >>> 0))
class bf {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(bf.prototype)
    return ((I.__wbg_ptr = A), fx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), fx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawintegrationparameters_free(A)
  }
  constructor() {
    const A = b.rawintegrationparameters_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
  get dt() {
    return b.rawintegrationparameters_dt(this.__wbg_ptr)
  }
  get contact_erp() {
    return b.rawintegrationparameters_contact_erp(this.__wbg_ptr)
  }
  get normalizedAllowedLinearError() {
    return b.rawdynamicraycastvehiclecontroller_current_vehicle_speed(this.__wbg_ptr)
  }
  get normalizedPredictionDistance() {
    return b.rawcontactforceevent_max_force_magnitude(this.__wbg_ptr)
  }
  get numSolverIterations() {
    return b.rawintegrationparameters_numSolverIterations(this.__wbg_ptr) >>> 0
  }
  get numAdditionalFrictionIterations() {
    return b.rawdynamicraycastvehiclecontroller_index_up_axis(this.__wbg_ptr) >>> 0
  }
  get numInternalPgsIterations() {
    return b.rawdynamicraycastvehiclecontroller_index_forward_axis(this.__wbg_ptr) >>> 0
  }
  get minIslandSize() {
    return b.rawimpulsejointset_len(this.__wbg_ptr) >>> 0
  }
  get maxCcdSubsteps() {
    return b.rawintegrationparameters_maxCcdSubsteps(this.__wbg_ptr) >>> 0
  }
  get lengthUnit() {
    return b.rawintegrationparameters_lengthUnit(this.__wbg_ptr)
  }
  set dt(A) {
    b.rawintegrationparameters_set_dt(this.__wbg_ptr, A)
  }
  set contact_natural_frequency(A) {
    b.rawintegrationparameters_set_contact_natural_frequency(this.__wbg_ptr, A)
  }
  set normalizedAllowedLinearError(A) {
    b.rawintegrationparameters_set_normalizedAllowedLinearError(this.__wbg_ptr, A)
  }
  set normalizedPredictionDistance(A) {
    b.rawintegrationparameters_set_normalizedPredictionDistance(this.__wbg_ptr, A)
  }
  set numSolverIterations(A) {
    b.rawintegrationparameters_set_numSolverIterations(this.__wbg_ptr, A)
  }
  set numAdditionalFrictionIterations(A) {
    b.rawdynamicraycastvehiclecontroller_set_index_up_axis(this.__wbg_ptr, A)
  }
  set numInternalPgsIterations(A) {
    b.rawdynamicraycastvehiclecontroller_set_index_forward_axis(this.__wbg_ptr, A)
  }
  set minIslandSize(A) {
    b.rawintegrationparameters_set_minIslandSize(this.__wbg_ptr, A)
  }
  set maxCcdSubsteps(A) {
    b.rawintegrationparameters_set_maxCcdSubsteps(this.__wbg_ptr, A)
  }
  set lengthUnit(A) {
    b.rawintegrationparameters_set_lengthUnit(this.__wbg_ptr, A)
  }
  switchToStandardPgsSolver() {
    b.rawintegrationparameters_switchToStandardPgsSolver(this.__wbg_ptr)
  }
  switchToSmallStepsPgsSolver() {
    b.rawintegrationparameters_switchToSmallStepsPgsSolver(this.__wbg_ptr)
  }
  switchToSmallStepsPgsSolverWithoutWarmstart() {
    b.rawintegrationparameters_switchToSmallStepsPgsSolverWithoutWarmstart(this.__wbg_ptr)
  }
}
const dx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawislandmanager_free(e >>> 0))
class nu {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(nu.prototype)
    return ((I.__wbg_ptr = A), dx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), dx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawislandmanager_free(A)
  }
  constructor() {
    const A = b.rawislandmanager_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
  forEachActiveRigidBodyHandle(A) {
    try {
      b.rawislandmanager_forEachActiveRigidBodyHandle(this.__wbg_ptr, fB(A))
    } finally {
      Si[mt++] = void 0
    }
  }
}
const u6 =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawkinematiccharactercontroller_free(e >>> 0))
class D6 {
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), u6.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawkinematiccharactercontroller_free(A)
  }
  constructor(A) {
    const I = b.rawkinematiccharactercontroller_new(A)
    return ((this.__wbg_ptr = I >>> 0), this)
  }
  up() {
    const A = b.rawcharactercollision_translationDeltaApplied(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  setUp(A) {
    ;(xA(A, BI), b.rawkinematiccharactercontroller_setUp(this.__wbg_ptr, A.__wbg_ptr))
  }
  normalNudgeFactor() {
    return b.rawkinematiccharactercontroller_normalNudgeFactor(this.__wbg_ptr)
  }
  setNormalNudgeFactor(A) {
    b.rawkinematiccharactercontroller_setNormalNudgeFactor(this.__wbg_ptr, A)
  }
  offset() {
    return b.rawintegrationparameters_dt(this.__wbg_ptr)
  }
  setOffset(A) {
    b.rawkinematiccharactercontroller_setOffset(this.__wbg_ptr, A)
  }
  slideEnabled() {
    return b.rawkinematiccharactercontroller_slideEnabled(this.__wbg_ptr) !== 0
  }
  setSlideEnabled(A) {
    b.rawkinematiccharactercontroller_setSlideEnabled(this.__wbg_ptr, A)
  }
  autostepMaxHeight() {
    try {
      const g = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawkinematiccharactercontroller_autostepMaxHeight(g, this.__wbg_ptr)
      var A = VC()[g / 4 + 0],
        I = nB()[g / 4 + 1]
      return A === 0 ? void 0 : I
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  autostepMinWidth() {
    try {
      const g = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawkinematiccharactercontroller_autostepMinWidth(g, this.__wbg_ptr)
      var A = VC()[g / 4 + 0],
        I = nB()[g / 4 + 1]
      return A === 0 ? void 0 : I
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  autostepIncludesDynamicBodies() {
    const A = b.rawkinematiccharactercontroller_autostepIncludesDynamicBodies(this.__wbg_ptr)
    return A === 16777215 ? void 0 : A !== 0
  }
  autostepEnabled() {
    return b.rawkinematiccharactercontroller_autostepEnabled(this.__wbg_ptr) !== 0
  }
  enableAutostep(A, I, g) {
    b.rawkinematiccharactercontroller_enableAutostep(this.__wbg_ptr, A, I, g)
  }
  disableAutostep() {
    b.rawkinematiccharactercontroller_disableAutostep(this.__wbg_ptr)
  }
  maxSlopeClimbAngle() {
    return b.rawkinematiccharactercontroller_maxSlopeClimbAngle(this.__wbg_ptr)
  }
  setMaxSlopeClimbAngle(A) {
    b.rawkinematiccharactercontroller_setMaxSlopeClimbAngle(this.__wbg_ptr, A)
  }
  minSlopeSlideAngle() {
    return b.rawkinematiccharactercontroller_minSlopeSlideAngle(this.__wbg_ptr)
  }
  setMinSlopeSlideAngle(A) {
    b.rawkinematiccharactercontroller_setMinSlopeSlideAngle(this.__wbg_ptr, A)
  }
  snapToGroundDistance() {
    try {
      const g = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawkinematiccharactercontroller_snapToGroundDistance(g, this.__wbg_ptr)
      var A = VC()[g / 4 + 0],
        I = nB()[g / 4 + 1]
      return A === 0 ? void 0 : I
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
  enableSnapToGround(A) {
    b.rawkinematiccharactercontroller_enableSnapToGround(this.__wbg_ptr, A)
  }
  disableSnapToGround() {
    b.rawkinematiccharactercontroller_disableSnapToGround(this.__wbg_ptr)
  }
  snapToGroundEnabled() {
    return b.rawkinematiccharactercontroller_snapToGroundEnabled(this.__wbg_ptr) !== 0
  }
  computeColliderMovement(A, I, g, C, i, B, o, r, s, h, S) {
    try {
      ;(xA(I, NQ),
        xA(g, YB),
        xA(C, Tv),
        xA(B, BI),
        b.rawkinematiccharactercontroller_computeColliderMovement(
          this.__wbg_ptr,
          A,
          I.__wbg_ptr,
          g.__wbg_ptr,
          C.__wbg_ptr,
          i,
          B.__wbg_ptr,
          o,
          !QC(r),
          QC(r) ? 0 : r,
          s,
          !QC(h),
          QC(h) ? 0 : h,
          fB(S),
        ))
    } finally {
      Si[mt++] = void 0
    }
  }
  computedMovement() {
    const A = b.rawkinematiccharactercontroller_computedMovement(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  computedGrounded() {
    return b.rawkinematiccharactercontroller_computedGrounded(this.__wbg_ptr) !== 0
  }
  numComputedCollisions() {
    return b.rawkinematiccharactercontroller_numComputedCollisions(this.__wbg_ptr) >>> 0
  }
  computedCollision(A, I) {
    return (
      xA(I, MO),
      b.rawkinematiccharactercontroller_computedCollision(this.__wbg_ptr, A, I.__wbg_ptr) !== 0
    )
  }
}
const yx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawmultibodyjointset_free(e >>> 0))
class Eu {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(Eu.prototype)
    return ((I.__wbg_ptr = A), yx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), yx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawmultibodyjointset_free(A)
  }
  jointType(A) {
    return b.rawmultibodyjointset_jointType(this.__wbg_ptr, A)
  }
  jointFrameX1(A) {
    const I = b.rawmultibodyjointset_jointFrameX1(this.__wbg_ptr, A)
    return je.__wrap(I)
  }
  jointFrameX2(A) {
    const I = b.rawmultibodyjointset_jointFrameX2(this.__wbg_ptr, A)
    return je.__wrap(I)
  }
  jointAnchor1(A) {
    const I = b.rawmultibodyjointset_jointAnchor1(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  jointAnchor2(A) {
    const I = b.rawmultibodyjointset_jointAnchor2(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  jointContactsEnabled(A) {
    return b.rawmultibodyjointset_jointContactsEnabled(this.__wbg_ptr, A) !== 0
  }
  jointSetContactsEnabled(A, I) {
    b.rawmultibodyjointset_jointSetContactsEnabled(this.__wbg_ptr, A, I)
  }
  jointLimitsEnabled(A, I) {
    return b.rawmultibodyjointset_jointLimitsEnabled(this.__wbg_ptr, A, I) !== 0
  }
  jointLimitsMin(A, I) {
    return b.rawmultibodyjointset_jointLimitsMin(this.__wbg_ptr, A, I)
  }
  jointLimitsMax(A, I) {
    return b.rawmultibodyjointset_jointLimitsMax(this.__wbg_ptr, A, I)
  }
  constructor() {
    const A = b.rawmultibodyjointset_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
  createJoint(A, I, g, C) {
    return (xA(A, Wo), b.rawmultibodyjointset_createJoint(this.__wbg_ptr, A.__wbg_ptr, I, g, C))
  }
  remove(A, I) {
    b.rawmultibodyjointset_remove(this.__wbg_ptr, A, I)
  }
  contains(A) {
    return b.rawmultibodyjointset_contains(this.__wbg_ptr, A) !== 0
  }
  forEachJointHandle(A) {
    try {
      b.rawmultibodyjointset_forEachJointHandle(this.__wbg_ptr, fB(A))
    } finally {
      Si[mt++] = void 0
    }
  }
  forEachJointAttachedToRigidBody(A, I) {
    try {
      b.rawmultibodyjointset_forEachJointAttachedToRigidBody(this.__wbg_ptr, A, fB(I))
    } finally {
      Si[mt++] = void 0
    }
  }
}
const px =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawnarrowphase_free(e >>> 0))
class JD {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(JD.prototype)
    return ((I.__wbg_ptr = A), px.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), px.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawnarrowphase_free(A)
  }
  constructor() {
    const A = b.rawnarrowphase_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
  contact_pairs_with(A, I) {
    b.rawnarrowphase_contact_pairs_with(this.__wbg_ptr, A, ZQ(I))
  }
  contact_pair(A, I) {
    const g = b.rawnarrowphase_contact_pair(this.__wbg_ptr, A, I)
    return g === 0 ? void 0 : qv.__wrap(g)
  }
  intersection_pairs_with(A, I) {
    b.rawnarrowphase_intersection_pairs_with(this.__wbg_ptr, A, ZQ(I))
  }
  intersection_pair(A, I) {
    return b.rawnarrowphase_intersection_pair(this.__wbg_ptr, A, I) !== 0
  }
}
const S6 =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawphysicspipeline_free(e >>> 0))
class f6 {
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), S6.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawphysicspipeline_free(A)
  }
  constructor() {
    const A = b.rawphysicspipeline_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
  step(A, I, g, C, i, B, o, r, s, h) {
    ;(xA(A, BI),
      xA(I, bf),
      xA(g, nu),
      xA(C, xf),
      xA(i, JD),
      xA(B, NQ),
      xA(o, YB),
      xA(r, ou),
      xA(s, Eu),
      xA(h, mm),
      b.rawphysicspipeline_step(
        this.__wbg_ptr,
        A.__wbg_ptr,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C.__wbg_ptr,
        i.__wbg_ptr,
        B.__wbg_ptr,
        o.__wbg_ptr,
        r.__wbg_ptr,
        s.__wbg_ptr,
        h.__wbg_ptr,
      ))
  }
  stepWithEvents(A, I, g, C, i, B, o, r, s, h, S, d, w, M) {
    ;(xA(A, BI),
      xA(I, bf),
      xA(g, nu),
      xA(C, xf),
      xA(i, JD),
      xA(B, NQ),
      xA(o, YB),
      xA(r, ou),
      xA(s, Eu),
      xA(h, mm),
      xA(S, UO),
      b.rawphysicspipeline_stepWithEvents(
        this.__wbg_ptr,
        A.__wbg_ptr,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C.__wbg_ptr,
        i.__wbg_ptr,
        B.__wbg_ptr,
        o.__wbg_ptr,
        r.__wbg_ptr,
        s.__wbg_ptr,
        h.__wbg_ptr,
        S.__wbg_ptr,
        ZQ(d),
        ZQ(w),
        ZQ(M),
      ))
  }
}
const wx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawpointcolliderprojection_free(e >>> 0))
class MN {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(MN.prototype)
    return ((I.__wbg_ptr = A), wx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), wx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawpointcolliderprojection_free(A)
  }
  colliderHandle() {
    return b.rawpointcolliderprojection_colliderHandle(this.__wbg_ptr)
  }
  point() {
    const A = b.rawpointcolliderprojection_point(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  isInside() {
    return b.rawpointcolliderprojection_isInside(this.__wbg_ptr) !== 0
  }
  featureType() {
    return b.rawpointcolliderprojection_featureType(this.__wbg_ptr)
  }
  featureId() {
    try {
      const g = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawpointcolliderprojection_featureId(g, this.__wbg_ptr)
      var A = VC()[g / 4 + 0],
        I = VC()[g / 4 + 1]
      return A === 0 ? void 0 : I >>> 0
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
}
const Gx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawpointprojection_free(e >>> 0))
class MF {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(MF.prototype)
    return ((I.__wbg_ptr = A), Gx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), Gx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawpointprojection_free(A)
  }
  point() {
    const A = b.rawpointprojection_point(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  isInside() {
    return b.rawpointprojection_isInside(this.__wbg_ptr) !== 0
  }
}
const d6 =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawquerypipeline_free(e >>> 0))
class Tv {
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), d6.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawquerypipeline_free(A)
  }
  constructor() {
    const A = b.rawquerypipeline_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
  update(A) {
    ;(xA(A, YB), b.rawquerypipeline_update(this.__wbg_ptr, A.__wbg_ptr))
  }
  castRay(A, I, g, C, i, B, o, r, s, h, S) {
    try {
      ;(xA(A, NQ), xA(I, YB), xA(g, BI), xA(C, BI))
      const d = b.rawquerypipeline_castRay(
        this.__wbg_ptr,
        A.__wbg_ptr,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C.__wbg_ptr,
        i,
        B,
        o,
        !QC(r),
        QC(r) ? 0 : r,
        !QC(s),
        QC(s) ? 0 : s,
        !QC(h),
        QC(h) ? 0 : h,
        fB(S),
      )
      return d === 0 ? void 0 : xv.__wrap(d)
    } finally {
      Si[mt++] = void 0
    }
  }
  castRayAndGetNormal(A, I, g, C, i, B, o, r, s, h, S) {
    try {
      ;(xA(A, NQ), xA(I, YB), xA(g, BI), xA(C, BI))
      const d = b.rawquerypipeline_castRayAndGetNormal(
        this.__wbg_ptr,
        A.__wbg_ptr,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C.__wbg_ptr,
        i,
        B,
        o,
        !QC(r),
        QC(r) ? 0 : r,
        !QC(s),
        QC(s) ? 0 : s,
        !QC(h),
        QC(h) ? 0 : h,
        fB(S),
      )
      return d === 0 ? void 0 : UF.__wrap(d)
    } finally {
      Si[mt++] = void 0
    }
  }
  intersectionsWithRay(A, I, g, C, i, B, o, r, s, h, S, d) {
    try {
      ;(xA(A, NQ),
        xA(I, YB),
        xA(g, BI),
        xA(C, BI),
        b.rawquerypipeline_intersectionsWithRay(
          this.__wbg_ptr,
          A.__wbg_ptr,
          I.__wbg_ptr,
          g.__wbg_ptr,
          C.__wbg_ptr,
          i,
          B,
          fB(o),
          r,
          !QC(s),
          QC(s) ? 0 : s,
          !QC(h),
          QC(h) ? 0 : h,
          !QC(S),
          QC(S) ? 0 : S,
          fB(d),
        ))
    } finally {
      ;((Si[mt++] = void 0), (Si[mt++] = void 0))
    }
  }
  intersectionWithShape(A, I, g, C, i, B, o, r, s, h) {
    try {
      const w = b.__wbindgen_add_to_stack_pointer(-16)
      ;(xA(A, NQ),
        xA(I, YB),
        xA(g, BI),
        xA(C, je),
        xA(i, bC),
        b.rawquerypipeline_intersectionWithShape(
          w,
          this.__wbg_ptr,
          A.__wbg_ptr,
          I.__wbg_ptr,
          g.__wbg_ptr,
          C.__wbg_ptr,
          i.__wbg_ptr,
          B,
          !QC(o),
          QC(o) ? 0 : o,
          !QC(r),
          QC(r) ? 0 : r,
          !QC(s),
          QC(s) ? 0 : s,
          fB(h),
        ))
      var S = VC()[w / 4 + 0],
        d = dG()[w / 8 + 1]
      return S === 0 ? void 0 : d
    } finally {
      ;(b.__wbindgen_add_to_stack_pointer(16), (Si[mt++] = void 0))
    }
  }
  projectPoint(A, I, g, C, i, B, o, r, s) {
    try {
      ;(xA(A, NQ), xA(I, YB), xA(g, BI))
      const h = b.rawquerypipeline_projectPoint(
        this.__wbg_ptr,
        A.__wbg_ptr,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C,
        i,
        !QC(B),
        QC(B) ? 0 : B,
        !QC(o),
        QC(o) ? 0 : o,
        !QC(r),
        QC(r) ? 0 : r,
        fB(s),
      )
      return h === 0 ? void 0 : MN.__wrap(h)
    } finally {
      Si[mt++] = void 0
    }
  }
  projectPointAndGetFeature(A, I, g, C, i, B, o, r) {
    try {
      ;(xA(A, NQ), xA(I, YB), xA(g, BI))
      const s = b.rawquerypipeline_projectPointAndGetFeature(
        this.__wbg_ptr,
        A.__wbg_ptr,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C,
        !QC(i),
        QC(i) ? 0 : i,
        !QC(B),
        QC(B) ? 0 : B,
        !QC(o),
        QC(o) ? 0 : o,
        fB(r),
      )
      return s === 0 ? void 0 : MN.__wrap(s)
    } finally {
      Si[mt++] = void 0
    }
  }
  intersectionsWithPoint(A, I, g, C, i, B, o, r, s) {
    try {
      ;(xA(A, NQ),
        xA(I, YB),
        xA(g, BI),
        b.rawquerypipeline_intersectionsWithPoint(
          this.__wbg_ptr,
          A.__wbg_ptr,
          I.__wbg_ptr,
          g.__wbg_ptr,
          fB(C),
          i,
          !QC(B),
          QC(B) ? 0 : B,
          !QC(o),
          QC(o) ? 0 : o,
          !QC(r),
          QC(r) ? 0 : r,
          fB(s),
        ))
    } finally {
      ;((Si[mt++] = void 0), (Si[mt++] = void 0))
    }
  }
  castShape(A, I, g, C, i, B, o, r, s, h, S, d, w, M) {
    try {
      ;(xA(A, NQ), xA(I, YB), xA(g, BI), xA(C, je), xA(i, BI), xA(B, bC))
      const K = b.rawquerypipeline_castShape(
        this.__wbg_ptr,
        A.__wbg_ptr,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C.__wbg_ptr,
        i.__wbg_ptr,
        B.__wbg_ptr,
        o,
        r,
        s,
        h,
        !QC(S),
        QC(S) ? 0 : S,
        !QC(d),
        QC(d) ? 0 : d,
        !QC(w),
        QC(w) ? 0 : w,
        fB(M),
      )
      return K === 0 ? void 0 : kF.__wrap(K)
    } finally {
      Si[mt++] = void 0
    }
  }
  intersectionsWithShape(A, I, g, C, i, B, o, r, s, h, S) {
    try {
      ;(xA(A, NQ),
        xA(I, YB),
        xA(g, BI),
        xA(C, je),
        xA(i, bC),
        b.rawquerypipeline_intersectionsWithShape(
          this.__wbg_ptr,
          A.__wbg_ptr,
          I.__wbg_ptr,
          g.__wbg_ptr,
          C.__wbg_ptr,
          i.__wbg_ptr,
          fB(B),
          o,
          !QC(r),
          QC(r) ? 0 : r,
          !QC(s),
          QC(s) ? 0 : s,
          !QC(h),
          QC(h) ? 0 : h,
          fB(S),
        ))
    } finally {
      ;((Si[mt++] = void 0), (Si[mt++] = void 0))
    }
  }
  collidersWithAabbIntersectingAabb(A, I, g) {
    try {
      ;(xA(A, BI),
        xA(I, BI),
        b.rawquerypipeline_collidersWithAabbIntersectingAabb(
          this.__wbg_ptr,
          A.__wbg_ptr,
          I.__wbg_ptr,
          fB(g),
        ))
    } finally {
      Si[mt++] = void 0
    }
  }
}
const kx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawraycolliderhit_free(e >>> 0))
class xv {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(xv.prototype)
    return ((I.__wbg_ptr = A), kx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), kx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawraycolliderhit_free(A)
  }
  colliderHandle() {
    return b.rawcharactercollision_handle(this.__wbg_ptr)
  }
  timeOfImpact() {
    return b.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr)
  }
}
const Mx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawraycolliderintersection_free(e >>> 0))
class UF {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(UF.prototype)
    return ((I.__wbg_ptr = A), Mx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), Mx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawraycolliderintersection_free(A)
  }
  colliderHandle() {
    return b.rawpointcolliderprojection_colliderHandle(this.__wbg_ptr)
  }
  normal() {
    const A = b.rawcollidershapecasthit_witness1(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  time_of_impact() {
    return b.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr)
  }
  featureType() {
    return b.rawpointcolliderprojection_featureType(this.__wbg_ptr)
  }
  featureId() {
    try {
      const g = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawpointcolliderprojection_featureId(g, this.__wbg_ptr)
      var A = VC()[g / 4 + 0],
        I = VC()[g / 4 + 1]
      return A === 0 ? void 0 : I >>> 0
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
}
const Ux =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawrayintersection_free(e >>> 0))
class NF {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(NF.prototype)
    return ((I.__wbg_ptr = A), Ux.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), Ux.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawrayintersection_free(A)
  }
  normal() {
    const A = b.rawcollidershapecasthit_witness1(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  time_of_impact() {
    return b.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr)
  }
  featureType() {
    return b.rawpointcolliderprojection_featureType(this.__wbg_ptr)
  }
  featureId() {
    try {
      const g = b.__wbindgen_add_to_stack_pointer(-16)
      b.rawpointcolliderprojection_featureId(g, this.__wbg_ptr)
      var A = VC()[g / 4 + 0],
        I = VC()[g / 4 + 1]
      return A === 0 ? void 0 : I >>> 0
    } finally {
      b.__wbindgen_add_to_stack_pointer(16)
    }
  }
}
const Nx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawrigidbodyset_free(e >>> 0))
class NQ {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(NQ.prototype)
    return ((I.__wbg_ptr = A), Nx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), Nx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawrigidbodyset_free(A)
  }
  rbTranslation(A) {
    const I = b.rawrigidbodyset_rbTranslation(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  rbRotation(A) {
    const I = b.rawrigidbodyset_rbRotation(this.__wbg_ptr, A)
    return je.__wrap(I)
  }
  rbSleep(A) {
    b.rawrigidbodyset_rbSleep(this.__wbg_ptr, A)
  }
  rbIsSleeping(A) {
    return b.rawrigidbodyset_rbIsSleeping(this.__wbg_ptr, A) !== 0
  }
  rbIsMoving(A) {
    return b.rawrigidbodyset_rbIsMoving(this.__wbg_ptr, A) !== 0
  }
  rbNextTranslation(A) {
    const I = b.rawrigidbodyset_rbNextTranslation(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  rbNextRotation(A) {
    const I = b.rawrigidbodyset_rbNextRotation(this.__wbg_ptr, A)
    return je.__wrap(I)
  }
  rbSetTranslation(A, I, g, C, i) {
    b.rawrigidbodyset_rbSetTranslation(this.__wbg_ptr, A, I, g, C, i)
  }
  rbSetRotation(A, I, g, C, i, B) {
    b.rawrigidbodyset_rbSetRotation(this.__wbg_ptr, A, I, g, C, i, B)
  }
  rbSetLinvel(A, I, g) {
    ;(xA(I, BI), b.rawrigidbodyset_rbSetLinvel(this.__wbg_ptr, A, I.__wbg_ptr, g))
  }
  rbSetAngvel(A, I, g) {
    ;(xA(I, BI), b.rawrigidbodyset_rbSetAngvel(this.__wbg_ptr, A, I.__wbg_ptr, g))
  }
  rbSetNextKinematicTranslation(A, I, g, C) {
    b.rawrigidbodyset_rbSetNextKinematicTranslation(this.__wbg_ptr, A, I, g, C)
  }
  rbSetNextKinematicRotation(A, I, g, C, i) {
    b.rawrigidbodyset_rbSetNextKinematicRotation(this.__wbg_ptr, A, I, g, C, i)
  }
  rbRecomputeMassPropertiesFromColliders(A, I) {
    ;(xA(I, YB),
      b.rawrigidbodyset_rbRecomputeMassPropertiesFromColliders(this.__wbg_ptr, A, I.__wbg_ptr))
  }
  rbSetAdditionalMass(A, I, g) {
    b.rawrigidbodyset_rbSetAdditionalMass(this.__wbg_ptr, A, I, g)
  }
  rbSetAdditionalMassProperties(A, I, g, C, i, B) {
    ;(xA(g, BI),
      xA(C, BI),
      xA(i, je),
      b.rawrigidbodyset_rbSetAdditionalMassProperties(
        this.__wbg_ptr,
        A,
        I,
        g.__wbg_ptr,
        C.__wbg_ptr,
        i.__wbg_ptr,
        B,
      ))
  }
  rbLinvel(A) {
    const I = b.rawrigidbodyset_rbLinvel(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  rbAngvel(A) {
    const I = b.rawrigidbodyset_rbAngvel(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  rbLockTranslations(A, I, g) {
    b.rawrigidbodyset_rbLockTranslations(this.__wbg_ptr, A, I, g)
  }
  rbSetEnabledTranslations(A, I, g, C, i) {
    b.rawrigidbodyset_rbSetEnabledTranslations(this.__wbg_ptr, A, I, g, C, i)
  }
  rbLockRotations(A, I, g) {
    b.rawrigidbodyset_rbLockRotations(this.__wbg_ptr, A, I, g)
  }
  rbSetEnabledRotations(A, I, g, C, i) {
    b.rawrigidbodyset_rbSetEnabledRotations(this.__wbg_ptr, A, I, g, C, i)
  }
  rbDominanceGroup(A) {
    return b.rawrigidbodyset_rbDominanceGroup(this.__wbg_ptr, A)
  }
  rbSetDominanceGroup(A, I) {
    b.rawrigidbodyset_rbSetDominanceGroup(this.__wbg_ptr, A, I)
  }
  rbEnableCcd(A, I) {
    b.rawrigidbodyset_rbEnableCcd(this.__wbg_ptr, A, I)
  }
  rbSetSoftCcdPrediction(A, I) {
    b.rawrigidbodyset_rbSetSoftCcdPrediction(this.__wbg_ptr, A, I)
  }
  rbMass(A) {
    return b.rawrigidbodyset_rbMass(this.__wbg_ptr, A)
  }
  rbInvMass(A) {
    return b.rawrigidbodyset_rbInvMass(this.__wbg_ptr, A)
  }
  rbEffectiveInvMass(A) {
    const I = b.rawrigidbodyset_rbEffectiveInvMass(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  rbLocalCom(A) {
    const I = b.rawrigidbodyset_rbLocalCom(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  rbWorldCom(A) {
    const I = b.rawrigidbodyset_rbWorldCom(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  rbInvPrincipalInertiaSqrt(A) {
    const I = b.rawrigidbodyset_rbInvPrincipalInertiaSqrt(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  rbPrincipalInertiaLocalFrame(A) {
    const I = b.rawrigidbodyset_rbPrincipalInertiaLocalFrame(this.__wbg_ptr, A)
    return je.__wrap(I)
  }
  rbPrincipalInertia(A) {
    const I = b.rawrigidbodyset_rbPrincipalInertia(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  rbEffectiveWorldInvInertiaSqrt(A) {
    const I = b.rawrigidbodyset_rbEffectiveWorldInvInertiaSqrt(this.__wbg_ptr, A)
    return UN.__wrap(I)
  }
  rbEffectiveAngularInertia(A) {
    const I = b.rawrigidbodyset_rbEffectiveAngularInertia(this.__wbg_ptr, A)
    return UN.__wrap(I)
  }
  rbWakeUp(A) {
    b.rawrigidbodyset_rbWakeUp(this.__wbg_ptr, A)
  }
  rbIsCcdEnabled(A) {
    return b.rawrigidbodyset_rbIsCcdEnabled(this.__wbg_ptr, A) !== 0
  }
  rbSoftCcdPrediction(A) {
    return b.rawrigidbodyset_rbSoftCcdPrediction(this.__wbg_ptr, A)
  }
  rbNumColliders(A) {
    return b.rawrigidbodyset_rbNumColliders(this.__wbg_ptr, A) >>> 0
  }
  rbCollider(A, I) {
    return b.rawrigidbodyset_rbCollider(this.__wbg_ptr, A, I)
  }
  rbBodyType(A) {
    return b.rawrigidbodyset_rbBodyType(this.__wbg_ptr, A)
  }
  rbSetBodyType(A, I, g) {
    b.rawrigidbodyset_rbSetBodyType(this.__wbg_ptr, A, I, g)
  }
  rbIsFixed(A) {
    return b.rawrigidbodyset_rbIsFixed(this.__wbg_ptr, A) !== 0
  }
  rbIsKinematic(A) {
    return b.rawrigidbodyset_rbIsKinematic(this.__wbg_ptr, A) !== 0
  }
  rbIsDynamic(A) {
    return b.rawrigidbodyset_rbIsDynamic(this.__wbg_ptr, A) !== 0
  }
  rbLinearDamping(A) {
    return b.rawrigidbodyset_rbLinearDamping(this.__wbg_ptr, A)
  }
  rbAngularDamping(A) {
    return b.rawrigidbodyset_rbAngularDamping(this.__wbg_ptr, A)
  }
  rbSetLinearDamping(A, I) {
    b.rawrigidbodyset_rbSetLinearDamping(this.__wbg_ptr, A, I)
  }
  rbSetAngularDamping(A, I) {
    b.rawrigidbodyset_rbSetAngularDamping(this.__wbg_ptr, A, I)
  }
  rbSetEnabled(A, I) {
    b.rawrigidbodyset_rbSetEnabled(this.__wbg_ptr, A, I)
  }
  rbIsEnabled(A) {
    return b.rawrigidbodyset_rbIsEnabled(this.__wbg_ptr, A) !== 0
  }
  rbGravityScale(A) {
    return b.rawrigidbodyset_rbGravityScale(this.__wbg_ptr, A)
  }
  rbSetGravityScale(A, I, g) {
    b.rawrigidbodyset_rbSetGravityScale(this.__wbg_ptr, A, I, g)
  }
  rbResetForces(A, I) {
    b.rawrigidbodyset_rbResetForces(this.__wbg_ptr, A, I)
  }
  rbResetTorques(A, I) {
    b.rawrigidbodyset_rbResetTorques(this.__wbg_ptr, A, I)
  }
  rbAddForce(A, I, g) {
    ;(xA(I, BI), b.rawrigidbodyset_rbAddForce(this.__wbg_ptr, A, I.__wbg_ptr, g))
  }
  rbApplyImpulse(A, I, g) {
    ;(xA(I, BI), b.rawrigidbodyset_rbApplyImpulse(this.__wbg_ptr, A, I.__wbg_ptr, g))
  }
  rbAddTorque(A, I, g) {
    ;(xA(I, BI), b.rawrigidbodyset_rbAddTorque(this.__wbg_ptr, A, I.__wbg_ptr, g))
  }
  rbApplyTorqueImpulse(A, I, g) {
    ;(xA(I, BI), b.rawrigidbodyset_rbApplyTorqueImpulse(this.__wbg_ptr, A, I.__wbg_ptr, g))
  }
  rbAddForceAtPoint(A, I, g, C) {
    ;(xA(I, BI),
      xA(g, BI),
      b.rawrigidbodyset_rbAddForceAtPoint(this.__wbg_ptr, A, I.__wbg_ptr, g.__wbg_ptr, C))
  }
  rbApplyImpulseAtPoint(A, I, g, C) {
    ;(xA(I, BI),
      xA(g, BI),
      b.rawrigidbodyset_rbApplyImpulseAtPoint(this.__wbg_ptr, A, I.__wbg_ptr, g.__wbg_ptr, C))
  }
  rbAdditionalSolverIterations(A) {
    return b.rawrigidbodyset_rbAdditionalSolverIterations(this.__wbg_ptr, A) >>> 0
  }
  rbSetAdditionalSolverIterations(A, I) {
    b.rawrigidbodyset_rbSetAdditionalSolverIterations(this.__wbg_ptr, A, I)
  }
  rbUserData(A) {
    return b.rawrigidbodyset_rbUserData(this.__wbg_ptr, A) >>> 0
  }
  rbSetUserData(A, I) {
    b.rawrigidbodyset_rbSetUserData(this.__wbg_ptr, A, I)
  }
  rbUserForce(A) {
    const I = b.rawrigidbodyset_rbUserForce(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  rbUserTorque(A) {
    const I = b.rawrigidbodyset_rbUserTorque(this.__wbg_ptr, A)
    return BI.__wrap(I)
  }
  constructor() {
    const A = b.rawrigidbodyset_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
  createRigidBody(A, I, g, C, i, B, o, r, s, h, S, d, w, M, K, R, F, L, Y, H, V, j, P, AA, X, _) {
    return (
      xA(I, BI),
      xA(g, je),
      xA(o, BI),
      xA(r, BI),
      xA(s, BI),
      xA(h, BI),
      xA(S, je),
      b.rawrigidbodyset_createRigidBody(
        this.__wbg_ptr,
        A,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C,
        i,
        B,
        o.__wbg_ptr,
        r.__wbg_ptr,
        s.__wbg_ptr,
        h.__wbg_ptr,
        S.__wbg_ptr,
        d,
        w,
        M,
        K,
        R,
        F,
        L,
        Y,
        H,
        V,
        j,
        P,
        AA,
        X,
        _,
      )
    )
  }
  remove(A, I, g, C, i) {
    ;(xA(I, nu),
      xA(g, YB),
      xA(C, ou),
      xA(i, Eu),
      b.rawrigidbodyset_remove(
        this.__wbg_ptr,
        A,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C.__wbg_ptr,
        i.__wbg_ptr,
      ))
  }
  len() {
    return b.rawcolliderset_len(this.__wbg_ptr) >>> 0
  }
  contains(A) {
    return b.rawrigidbodyset_contains(this.__wbg_ptr, A) !== 0
  }
  forEachRigidBodyHandle(A) {
    try {
      b.rawrigidbodyset_forEachRigidBodyHandle(this.__wbg_ptr, fB(A))
    } finally {
      Si[mt++] = void 0
    }
  }
  propagateModifiedBodyPositionsToColliders(A) {
    ;(xA(A, YB),
      b.rawrigidbodyset_propagateModifiedBodyPositionsToColliders(this.__wbg_ptr, A.__wbg_ptr))
  }
}
const Fx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawrotation_free(e >>> 0))
class je {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(je.prototype)
    return ((I.__wbg_ptr = A), Fx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), Fx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawrotation_free(A)
  }
  constructor(A, I, g, C) {
    const i = b.rawrotation_new(A, I, g, C)
    return ((this.__wbg_ptr = i >>> 0), this)
  }
  static identity() {
    const A = b.rawrotation_identity()
    return je.__wrap(A)
  }
  get x() {
    return b.rawrotation_x(this.__wbg_ptr)
  }
  get y() {
    return b.rawintegrationparameters_dt(this.__wbg_ptr)
  }
  get z() {
    return b.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr)
  }
  get w() {
    return b.rawrotation_w(this.__wbg_ptr)
  }
}
const Rx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawsdpmatrix3_free(e >>> 0))
class UN {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(UN.prototype)
    return ((I.__wbg_ptr = A), Rx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), Rx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawsdpmatrix3_free(A)
  }
  elements() {
    return fG(b.rawsdpmatrix3_elements(this.__wbg_ptr))
  }
}
const y6 =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawserializationpipeline_free(e >>> 0))
class p6 {
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), y6.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawserializationpipeline_free(A)
  }
  constructor() {
    const A = b.rawserializationpipeline_new()
    return ((this.__wbg_ptr = A >>> 0), this)
  }
  serializeAll(A, I, g, C, i, B, o, r, s) {
    return (
      xA(A, BI),
      xA(I, bf),
      xA(g, nu),
      xA(C, xf),
      xA(i, JD),
      xA(B, NQ),
      xA(o, YB),
      xA(r, ou),
      xA(s, Eu),
      fG(
        b.rawserializationpipeline_serializeAll(
          this.__wbg_ptr,
          A.__wbg_ptr,
          I.__wbg_ptr,
          g.__wbg_ptr,
          C.__wbg_ptr,
          i.__wbg_ptr,
          B.__wbg_ptr,
          o.__wbg_ptr,
          r.__wbg_ptr,
          s.__wbg_ptr,
        ),
      )
    )
  }
  deserializeAll(A) {
    const I = b.rawserializationpipeline_deserializeAll(this.__wbg_ptr, ZQ(A))
    return I === 0 ? void 0 : Hv.__wrap(I)
  }
}
const Jx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawshape_free(e >>> 0))
class bC {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(bC.prototype)
    return ((I.__wbg_ptr = A), Jx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), Jx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawshape_free(A)
  }
  static cuboid(A, I, g) {
    const C = b.rawshape_cuboid(A, I, g)
    return bC.__wrap(C)
  }
  static roundCuboid(A, I, g, C) {
    const i = b.rawshape_roundCuboid(A, I, g, C)
    return bC.__wrap(i)
  }
  static ball(A) {
    const I = b.rawshape_ball(A)
    return bC.__wrap(I)
  }
  static halfspace(A) {
    xA(A, BI)
    const I = b.rawshape_halfspace(A.__wbg_ptr)
    return bC.__wrap(I)
  }
  static capsule(A, I) {
    const g = b.rawshape_capsule(A, I)
    return bC.__wrap(g)
  }
  static cylinder(A, I) {
    const g = b.rawshape_cylinder(A, I)
    return bC.__wrap(g)
  }
  static roundCylinder(A, I, g) {
    const C = b.rawshape_roundCylinder(A, I, g)
    return bC.__wrap(C)
  }
  static cone(A, I) {
    const g = b.rawshape_cone(A, I)
    return bC.__wrap(g)
  }
  static roundCone(A, I, g) {
    const C = b.rawshape_roundCone(A, I, g)
    return bC.__wrap(C)
  }
  static polyline(A, I) {
    const g = Sf(A, b.__wbindgen_malloc),
      C = Kr,
      i = JU(I, b.__wbindgen_malloc),
      B = Kr,
      o = b.rawshape_polyline(g, C, i, B)
    return bC.__wrap(o)
  }
  static trimesh(A, I, g) {
    const C = Sf(A, b.__wbindgen_malloc),
      i = Kr,
      B = JU(I, b.__wbindgen_malloc),
      o = Kr,
      r = b.rawshape_trimesh(C, i, B, o, g)
    return bC.__wrap(r)
  }
  static heightfield(A, I, g, C, i) {
    const B = Sf(g, b.__wbindgen_malloc),
      o = Kr
    xA(C, BI)
    const r = b.rawshape_heightfield(A, I, B, o, C.__wbg_ptr, i)
    return bC.__wrap(r)
  }
  static segment(A, I) {
    ;(xA(A, BI), xA(I, BI))
    const g = b.rawshape_segment(A.__wbg_ptr, I.__wbg_ptr)
    return bC.__wrap(g)
  }
  static triangle(A, I, g) {
    ;(xA(A, BI), xA(I, BI), xA(g, BI))
    const C = b.rawshape_triangle(A.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr)
    return bC.__wrap(C)
  }
  static roundTriangle(A, I, g, C) {
    ;(xA(A, BI), xA(I, BI), xA(g, BI))
    const i = b.rawshape_roundTriangle(A.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C)
    return bC.__wrap(i)
  }
  static convexHull(A) {
    const I = Sf(A, b.__wbindgen_malloc),
      g = Kr,
      C = b.rawshape_convexHull(I, g)
    return C === 0 ? void 0 : bC.__wrap(C)
  }
  static roundConvexHull(A, I) {
    const g = Sf(A, b.__wbindgen_malloc),
      C = Kr,
      i = b.rawshape_roundConvexHull(g, C, I)
    return i === 0 ? void 0 : bC.__wrap(i)
  }
  static convexMesh(A, I) {
    const g = Sf(A, b.__wbindgen_malloc),
      C = Kr,
      i = JU(I, b.__wbindgen_malloc),
      B = Kr,
      o = b.rawshape_convexMesh(g, C, i, B)
    return o === 0 ? void 0 : bC.__wrap(o)
  }
  static roundConvexMesh(A, I, g) {
    const C = Sf(A, b.__wbindgen_malloc),
      i = Kr,
      B = JU(I, b.__wbindgen_malloc),
      o = Kr,
      r = b.rawshape_roundConvexMesh(C, i, B, o, g)
    return r === 0 ? void 0 : bC.__wrap(r)
  }
  castShape(A, I, g, C, i, B, o, r, s, h) {
    ;(xA(A, BI), xA(I, je), xA(g, BI), xA(C, bC), xA(i, BI), xA(B, je), xA(o, BI))
    const S = b.rawshape_castShape(
      this.__wbg_ptr,
      A.__wbg_ptr,
      I.__wbg_ptr,
      g.__wbg_ptr,
      C.__wbg_ptr,
      i.__wbg_ptr,
      B.__wbg_ptr,
      o.__wbg_ptr,
      r,
      s,
      h,
    )
    return S === 0 ? void 0 : FF.__wrap(S)
  }
  intersectsShape(A, I, g, C, i) {
    return (
      xA(A, BI),
      xA(I, je),
      xA(g, bC),
      xA(C, BI),
      xA(i, je),
      b.rawshape_intersectsShape(
        this.__wbg_ptr,
        A.__wbg_ptr,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C.__wbg_ptr,
        i.__wbg_ptr,
      ) !== 0
    )
  }
  contactShape(A, I, g, C, i, B) {
    ;(xA(A, BI), xA(I, je), xA(g, bC), xA(C, BI), xA(i, je))
    const o = b.rawshape_contactShape(
      this.__wbg_ptr,
      A.__wbg_ptr,
      I.__wbg_ptr,
      g.__wbg_ptr,
      C.__wbg_ptr,
      i.__wbg_ptr,
      B,
    )
    return o === 0 ? void 0 : yG.__wrap(o)
  }
  containsPoint(A, I, g) {
    return (
      xA(A, BI),
      xA(I, je),
      xA(g, BI),
      b.rawshape_containsPoint(this.__wbg_ptr, A.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr) !== 0
    )
  }
  projectPoint(A, I, g, C) {
    ;(xA(A, BI), xA(I, je), xA(g, BI))
    const i = b.rawshape_projectPoint(this.__wbg_ptr, A.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C)
    return MF.__wrap(i)
  }
  intersectsRay(A, I, g, C, i) {
    return (
      xA(A, BI),
      xA(I, je),
      xA(g, BI),
      xA(C, BI),
      b.rawshape_intersectsRay(
        this.__wbg_ptr,
        A.__wbg_ptr,
        I.__wbg_ptr,
        g.__wbg_ptr,
        C.__wbg_ptr,
        i,
      ) !== 0
    )
  }
  castRay(A, I, g, C, i, B) {
    return (
      xA(A, BI),
      xA(I, je),
      xA(g, BI),
      xA(C, BI),
      b.rawshape_castRay(this.__wbg_ptr, A.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, i, B)
    )
  }
  castRayAndGetNormal(A, I, g, C, i, B) {
    ;(xA(A, BI), xA(I, je), xA(g, BI), xA(C, BI))
    const o = b.rawshape_castRayAndGetNormal(
      this.__wbg_ptr,
      A.__wbg_ptr,
      I.__wbg_ptr,
      g.__wbg_ptr,
      C.__wbg_ptr,
      i,
      B,
    )
    return o === 0 ? void 0 : NF.__wrap(o)
  }
}
const Kx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawshapecasthit_free(e >>> 0))
class FF {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(FF.prototype)
    return ((I.__wbg_ptr = A), Kx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), Kx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawshapecasthit_free(A)
  }
  time_of_impact() {
    return b.rawrotation_x(this.__wbg_ptr)
  }
  witness1() {
    const A = b.rawshapecasthit_witness1(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  witness2() {
    const A = b.rawcontactforceevent_total_force(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  normal1() {
    const A = b.rawshapecasthit_normal1(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  normal2() {
    const A = b.rawshapecasthit_normal2(this.__wbg_ptr)
    return BI.__wrap(A)
  }
}
const mx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawshapecontact_free(e >>> 0))
class yG {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(yG.prototype)
    return ((I.__wbg_ptr = A), mx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), mx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawshapecontact_free(A)
  }
  distance() {
    return b.rawkinematiccharactercontroller_maxSlopeClimbAngle(this.__wbg_ptr)
  }
  point1() {
    const A = b.rawpointprojection_point(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  point2() {
    const A = b.rawcollidershapecasthit_witness1(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  normal1() {
    const A = b.rawcollidershapecasthit_witness2(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  normal2() {
    const A = b.rawcharactercollision_translationDeltaApplied(this.__wbg_ptr)
    return BI.__wrap(A)
  }
}
const vx =
  typeof FinalizationRegistry > "u"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((e) => b.__wbg_rawvector_free(e >>> 0))
class BI {
  static __wrap(A) {
    A >>>= 0
    const I = Object.create(BI.prototype)
    return ((I.__wbg_ptr = A), vx.register(I, I.__wbg_ptr, I), I)
  }
  __destroy_into_raw() {
    const A = this.__wbg_ptr
    return ((this.__wbg_ptr = 0), vx.unregister(this), A)
  }
  free() {
    const A = this.__destroy_into_raw()
    b.__wbg_rawvector_free(A)
  }
  static zero() {
    const A = b.rawvector_zero()
    return BI.__wrap(A)
  }
  constructor(A, I, g) {
    const C = b.rawvector_new(A, I, g)
    return ((this.__wbg_ptr = C >>> 0), this)
  }
  get x() {
    return b.rawrotation_x(this.__wbg_ptr)
  }
  set x(A) {
    b.rawvector_set_x(this.__wbg_ptr, A)
  }
  get y() {
    return b.rawintegrationparameters_dt(this.__wbg_ptr)
  }
  set y(A) {
    b.rawintegrationparameters_set_dt(this.__wbg_ptr, A)
  }
  get z() {
    return b.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr)
  }
  set z(A) {
    b.rawvector_set_z(this.__wbg_ptr, A)
  }
  xyz() {
    const A = b.rawvector_xyz(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  yxz() {
    const A = b.rawvector_yxz(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  zxy() {
    const A = b.rawvector_zxy(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  xzy() {
    const A = b.rawvector_xzy(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  yzx() {
    const A = b.rawvector_yzx(this.__wbg_ptr)
    return BI.__wrap(A)
  }
  zyx() {
    const A = b.rawvector_zyx(this.__wbg_ptr)
    return BI.__wrap(A)
  }
}
async function NO(e) {
  if (b !== void 0) return b
  e === void 0 && (e = new URL("rapier_wasm3d_bg.wasm", "<deleted>"))
  const A = (function () {
    const C = { wbg: {} }
    return (
      (C.wbg.__wbindgen_number_new = function (i) {
        return ZQ(i)
      }),
      (C.wbg.__wbindgen_boolean_get = function (i) {
        const B = Vi(i)
        return typeof B == "boolean" ? (B ? 1 : 0) : 2
      }),
      (C.wbg.__wbindgen_object_drop_ref = function (i) {
        fG(i)
      }),
      (C.wbg.__wbindgen_number_get = function (i, B) {
        const o = Vi(B),
          r = typeof o == "number" ? o : void 0
        ;((dG()[i / 8 + 1] = QC(r) ? 0 : r), (VC()[i / 4 + 0] = !QC(r)))
      }),
      (C.wbg.__wbindgen_is_function = function (i) {
        return typeof Vi(i) == "function"
      }),
      (C.wbg.__wbg_rawraycolliderintersection_new = function (i) {
        return ZQ(UF.__wrap(i))
      }),
      (C.wbg.__wbg_rawcontactforceevent_new = function (i) {
        return ZQ(Lv.__wrap(i))
      }),
      (C.wbg.__wbg_call_b3ca7c6051f9bec1 = function () {
        return im(function (i, B, o) {
          return ZQ(Vi(i).call(Vi(B), Vi(o)))
        }, arguments)
      }),
      (C.wbg.__wbg_call_8e7cb608789c2528 = function () {
        return im(function (i, B, o, r) {
          return ZQ(Vi(i).call(Vi(B), Vi(o), Vi(r)))
        }, arguments)
      }),
      (C.wbg.__wbg_call_938992c832f74314 = function () {
        return im(function (i, B, o, r, s) {
          return ZQ(Vi(i).call(Vi(B), Vi(o), Vi(r), Vi(s)))
        }, arguments)
      }),
      (C.wbg.__wbg_bind_4d857b598695205e = function (i, B, o, r) {
        return ZQ(Vi(i).bind(Vi(B), Vi(o), Vi(r)))
      }),
      (C.wbg.__wbg_buffer_12d079cc21e14bdb = function (i) {
        return ZQ(Vi(i).buffer)
      }),
      (C.wbg.__wbg_newwithbyteoffsetandlength_aa4a17c33a06e5cb = function (i, B, o) {
        return ZQ(new Uint8Array(Vi(i), B >>> 0, o >>> 0))
      }),
      (C.wbg.__wbg_new_63b92bc8671ed464 = function (i) {
        return ZQ(new Uint8Array(Vi(i)))
      }),
      (C.wbg.__wbg_set_a47bac70306a19a7 = function (i, B, o) {
        Vi(i).set(Vi(B), o >>> 0)
      }),
      (C.wbg.__wbg_length_c20a40f15020d68a = function (i) {
        return Vi(i).length
      }),
      (C.wbg.__wbg_newwithbyteoffsetandlength_4a659d079a1650e0 = function (i, B, o) {
        return ZQ(new Float32Array(Vi(i), B >>> 0, o >>> 0))
      }),
      (C.wbg.__wbg_set_bd975934d1b1fddb = function (i, B, o) {
        Vi(i).set(Vi(B), o >>> 0)
      }),
      (C.wbg.__wbg_length_d25bbcbc3367f684 = function (i) {
        return Vi(i).length
      }),
      (C.wbg.__wbg_newwithlength_1e8b839a06de01c5 = function (i) {
        return ZQ(new Float32Array(i >>> 0))
      }),
      (C.wbg.__wbindgen_throw = function (i, B) {
        throw new Error(GO(i, B))
      }),
      (C.wbg.__wbindgen_memory = function () {
        return ZQ(b.memory)
      }),
      C
    )
  })()
  ;(typeof e == "string" ||
    (typeof Request == "function" && e instanceof Request) ||
    (typeof URL == "function" && e instanceof URL)) &&
    (e = fetch(e))
  const { instance: I, module: g } = await (async function (C, i) {
    if (typeof Response == "function" && C instanceof Response) {
      if (typeof WebAssembly.instantiateStreaming == "function")
        try {
          return await WebAssembly.instantiateStreaming(C, i)
        } catch (o) {
          if (C.headers.get("Content-Type") == "application/wasm") throw o
          console.warn(
            "`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n",
            o,
          )
        }
      const B = await C.arrayBuffer()
      return await WebAssembly.instantiate(B, i)
    }
    {
      const B = await WebAssembly.instantiate(C, i)
      return B instanceof WebAssembly.Instance ? { instance: B, module: C } : B
    }
  })(await e, A)
  return (function (C, i) {
    return (
      (b = C.exports),
      (NO.__wbindgen_wasm_module = i),
      (j0 = null),
      (P0 = null),
      (W0 = null),
      (z0 = null),
      (V0 = null),
      b
    )
  })(I, g)
}
class Bp {
  constructor(A, I, g) {
    ;((this.x = A), (this.y = I), (this.z = g))
  }
}
class tI {
  static new(A, I, g) {
    return new Bp(A, I, g)
  }
  static intoRaw(A) {
    return new BI(A.x, A.y, A.z)
  }
  static zeros() {
    return tI.new(0, 0, 0)
  }
  static fromRaw(A) {
    if (!A) return null
    let I = tI.new(A.x, A.y, A.z)
    return (A.free(), I)
  }
  static copy(A, I) {
    ;((A.x = I.x), (A.y = I.y), (A.z = I.z))
  }
}
class NN {
  constructor(A, I, g, C) {
    ;((this.x = A), (this.y = I), (this.z = g), (this.w = C))
  }
}
class ke {
  static identity() {
    return new NN(0, 0, 0, 1)
  }
  static fromRaw(A) {
    if (!A) return null
    let I = new NN(A.x, A.y, A.z, A.w)
    return (A.free(), I)
  }
  static intoRaw(A) {
    return new je(A.x, A.y, A.z, A.w)
  }
  static copy(A, I) {
    ;((A.x = I.x), (A.y = I.y), (A.z = I.z), (A.w = I.w))
  }
}
class bv {
  constructor(A) {
    this.elements = A
  }
  get m11() {
    return this.elements[0]
  }
  get m12() {
    return this.elements[1]
  }
  get m21() {
    return this.m12
  }
  get m13() {
    return this.elements[2]
  }
  get m31() {
    return this.m13
  }
  get m22() {
    return this.elements[3]
  }
  get m23() {
    return this.elements[4]
  }
  get m32() {
    return this.m23
  }
  get m33() {
    return this.elements[5]
  }
}
class FN {
  static fromRaw(A) {
    const I = new bv(A.elements())
    return (A.free(), I)
  }
}
var ws, Po, RN, JN, hp, Of, FQ, KN, mN, vN, Cu, pG, LN, wG, pD
;(function (e) {
  ;((e[(e.Dynamic = 0)] = "Dynamic"),
    (e[(e.Fixed = 1)] = "Fixed"),
    (e[(e.KinematicPositionBased = 2)] = "KinematicPositionBased"),
    (e[(e.KinematicVelocityBased = 3)] = "KinematicVelocityBased"))
})(ws || (ws = {}))
class YN {
  constructor(A, I, g) {
    ;((this.rawSet = A), (this.colliderSet = I), (this.handle = g))
  }
  finalizeDeserialization(A) {
    this.colliderSet = A
  }
  isValid() {
    return this.rawSet.contains(this.handle)
  }
  lockTranslations(A, I) {
    return this.rawSet.rbLockTranslations(this.handle, A, I)
  }
  lockRotations(A, I) {
    return this.rawSet.rbLockRotations(this.handle, A, I)
  }
  setEnabledTranslations(A, I, g, C) {
    return this.rawSet.rbSetEnabledTranslations(this.handle, A, I, g, C)
  }
  restrictTranslations(A, I, g, C) {
    this.setEnabledTranslations(A, I, g, C)
  }
  setEnabledRotations(A, I, g, C) {
    return this.rawSet.rbSetEnabledRotations(this.handle, A, I, g, C)
  }
  restrictRotations(A, I, g, C) {
    this.setEnabledRotations(A, I, g, C)
  }
  dominanceGroup() {
    return this.rawSet.rbDominanceGroup(this.handle)
  }
  setDominanceGroup(A) {
    this.rawSet.rbSetDominanceGroup(this.handle, A)
  }
  additionalSolverIterations() {
    return this.rawSet.rbAdditionalSolverIterations(this.handle)
  }
  setAdditionalSolverIterations(A) {
    this.rawSet.rbSetAdditionalSolverIterations(this.handle, A)
  }
  enableCcd(A) {
    this.rawSet.rbEnableCcd(this.handle, A)
  }
  setSoftCcdPrediction(A) {
    this.rawSet.rbSetSoftCcdPrediction(this.handle, A)
  }
  softCcdPrediction() {
    return this.rawSet.rbSoftCcdPrediction(this.handle)
  }
  translation() {
    let A = this.rawSet.rbTranslation(this.handle)
    return tI.fromRaw(A)
  }
  rotation() {
    let A = this.rawSet.rbRotation(this.handle)
    return ke.fromRaw(A)
  }
  nextTranslation() {
    let A = this.rawSet.rbNextTranslation(this.handle)
    return tI.fromRaw(A)
  }
  nextRotation() {
    let A = this.rawSet.rbNextRotation(this.handle)
    return ke.fromRaw(A)
  }
  setTranslation(A, I) {
    this.rawSet.rbSetTranslation(this.handle, A.x, A.y, A.z, I)
  }
  setLinvel(A, I) {
    let g = tI.intoRaw(A)
    ;(this.rawSet.rbSetLinvel(this.handle, g, I), g.free())
  }
  gravityScale() {
    return this.rawSet.rbGravityScale(this.handle)
  }
  setGravityScale(A, I) {
    this.rawSet.rbSetGravityScale(this.handle, A, I)
  }
  setRotation(A, I) {
    this.rawSet.rbSetRotation(this.handle, A.x, A.y, A.z, A.w, I)
  }
  setAngvel(A, I) {
    let g = tI.intoRaw(A)
    ;(this.rawSet.rbSetAngvel(this.handle, g, I), g.free())
  }
  setNextKinematicTranslation(A) {
    this.rawSet.rbSetNextKinematicTranslation(this.handle, A.x, A.y, A.z)
  }
  setNextKinematicRotation(A) {
    this.rawSet.rbSetNextKinematicRotation(this.handle, A.x, A.y, A.z, A.w)
  }
  linvel() {
    return tI.fromRaw(this.rawSet.rbLinvel(this.handle))
  }
  angvel() {
    return tI.fromRaw(this.rawSet.rbAngvel(this.handle))
  }
  mass() {
    return this.rawSet.rbMass(this.handle)
  }
  effectiveInvMass() {
    return tI.fromRaw(this.rawSet.rbEffectiveInvMass(this.handle))
  }
  invMass() {
    return this.rawSet.rbInvMass(this.handle)
  }
  localCom() {
    return tI.fromRaw(this.rawSet.rbLocalCom(this.handle))
  }
  worldCom() {
    return tI.fromRaw(this.rawSet.rbWorldCom(this.handle))
  }
  invPrincipalInertiaSqrt() {
    return tI.fromRaw(this.rawSet.rbInvPrincipalInertiaSqrt(this.handle))
  }
  principalInertia() {
    return tI.fromRaw(this.rawSet.rbPrincipalInertia(this.handle))
  }
  principalInertiaLocalFrame() {
    return ke.fromRaw(this.rawSet.rbPrincipalInertiaLocalFrame(this.handle))
  }
  effectiveWorldInvInertiaSqrt() {
    return FN.fromRaw(this.rawSet.rbEffectiveWorldInvInertiaSqrt(this.handle))
  }
  effectiveAngularInertia() {
    return FN.fromRaw(this.rawSet.rbEffectiveAngularInertia(this.handle))
  }
  sleep() {
    this.rawSet.rbSleep(this.handle)
  }
  wakeUp() {
    this.rawSet.rbWakeUp(this.handle)
  }
  isCcdEnabled() {
    return this.rawSet.rbIsCcdEnabled(this.handle)
  }
  numColliders() {
    return this.rawSet.rbNumColliders(this.handle)
  }
  collider(A) {
    return this.colliderSet.get(this.rawSet.rbCollider(this.handle, A))
  }
  setEnabled(A) {
    this.rawSet.rbSetEnabled(this.handle, A)
  }
  isEnabled() {
    return this.rawSet.rbIsEnabled(this.handle)
  }
  bodyType() {
    return this.rawSet.rbBodyType(this.handle)
  }
  setBodyType(A, I) {
    return this.rawSet.rbSetBodyType(this.handle, A, I)
  }
  isSleeping() {
    return this.rawSet.rbIsSleeping(this.handle)
  }
  isMoving() {
    return this.rawSet.rbIsMoving(this.handle)
  }
  isFixed() {
    return this.rawSet.rbIsFixed(this.handle)
  }
  isKinematic() {
    return this.rawSet.rbIsKinematic(this.handle)
  }
  isDynamic() {
    return this.rawSet.rbIsDynamic(this.handle)
  }
  linearDamping() {
    return this.rawSet.rbLinearDamping(this.handle)
  }
  angularDamping() {
    return this.rawSet.rbAngularDamping(this.handle)
  }
  setLinearDamping(A) {
    this.rawSet.rbSetLinearDamping(this.handle, A)
  }
  recomputeMassPropertiesFromColliders() {
    this.rawSet.rbRecomputeMassPropertiesFromColliders(this.handle, this.colliderSet.raw)
  }
  setAdditionalMass(A, I) {
    this.rawSet.rbSetAdditionalMass(this.handle, A, I)
  }
  setAdditionalMassProperties(A, I, g, C, i) {
    let B = tI.intoRaw(I),
      o = tI.intoRaw(g),
      r = ke.intoRaw(C)
    ;(this.rawSet.rbSetAdditionalMassProperties(this.handle, A, B, o, r, i),
      B.free(),
      o.free(),
      r.free())
  }
  setAngularDamping(A) {
    this.rawSet.rbSetAngularDamping(this.handle, A)
  }
  resetForces(A) {
    this.rawSet.rbResetForces(this.handle, A)
  }
  resetTorques(A) {
    this.rawSet.rbResetTorques(this.handle, A)
  }
  addForce(A, I) {
    const g = tI.intoRaw(A)
    ;(this.rawSet.rbAddForce(this.handle, g, I), g.free())
  }
  applyImpulse(A, I) {
    const g = tI.intoRaw(A)
    ;(this.rawSet.rbApplyImpulse(this.handle, g, I), g.free())
  }
  addTorque(A, I) {
    const g = tI.intoRaw(A)
    ;(this.rawSet.rbAddTorque(this.handle, g, I), g.free())
  }
  applyTorqueImpulse(A, I) {
    const g = tI.intoRaw(A)
    ;(this.rawSet.rbApplyTorqueImpulse(this.handle, g, I), g.free())
  }
  addForceAtPoint(A, I, g) {
    const C = tI.intoRaw(A),
      i = tI.intoRaw(I)
    ;(this.rawSet.rbAddForceAtPoint(this.handle, C, i, g), C.free(), i.free())
  }
  applyImpulseAtPoint(A, I, g) {
    const C = tI.intoRaw(A),
      i = tI.intoRaw(I)
    ;(this.rawSet.rbApplyImpulseAtPoint(this.handle, C, i, g), C.free(), i.free())
  }
  userForce() {
    return tI.fromRaw(this.rawSet.rbUserForce(this.handle))
  }
  userTorque() {
    return tI.fromRaw(this.rawSet.rbUserTorque(this.handle))
  }
}
class Gs {
  constructor(A) {
    ;((this.enabled = !0),
      (this.status = A),
      (this.translation = tI.zeros()),
      (this.rotation = ke.identity()),
      (this.gravityScale = 1),
      (this.linvel = tI.zeros()),
      (this.mass = 0),
      (this.massOnly = !1),
      (this.centerOfMass = tI.zeros()),
      (this.translationsEnabledX = !0),
      (this.translationsEnabledY = !0),
      (this.angvel = tI.zeros()),
      (this.principalAngularInertia = tI.zeros()),
      (this.angularInertiaLocalFrame = ke.identity()),
      (this.translationsEnabledZ = !0),
      (this.rotationsEnabledX = !0),
      (this.rotationsEnabledY = !0),
      (this.rotationsEnabledZ = !0),
      (this.linearDamping = 0),
      (this.angularDamping = 0),
      (this.canSleep = !0),
      (this.sleeping = !1),
      (this.ccdEnabled = !1),
      (this.softCcdPrediction = 0),
      (this.dominanceGroup = 0),
      (this.additionalSolverIterations = 0))
  }
  static dynamic() {
    return new Gs(ws.Dynamic)
  }
  static kinematicPositionBased() {
    return new Gs(ws.KinematicPositionBased)
  }
  static kinematicVelocityBased() {
    return new Gs(ws.KinematicVelocityBased)
  }
  static fixed() {
    return new Gs(ws.Fixed)
  }
  static newDynamic() {
    return new Gs(ws.Dynamic)
  }
  static newKinematicPositionBased() {
    return new Gs(ws.KinematicPositionBased)
  }
  static newKinematicVelocityBased() {
    return new Gs(ws.KinematicVelocityBased)
  }
  static newStatic() {
    return new Gs(ws.Fixed)
  }
  setDominanceGroup(A) {
    return ((this.dominanceGroup = A), this)
  }
  setAdditionalSolverIterations(A) {
    return ((this.additionalSolverIterations = A), this)
  }
  setEnabled(A) {
    return ((this.enabled = A), this)
  }
  setTranslation(A, I, g) {
    if (typeof A != "number" || typeof I != "number" || typeof g != "number")
      throw TypeError("The translation components must be numbers.")
    return ((this.translation = { x: A, y: I, z: g }), this)
  }
  setRotation(A) {
    return (ke.copy(this.rotation, A), this)
  }
  setGravityScale(A) {
    return ((this.gravityScale = A), this)
  }
  setAdditionalMass(A) {
    return ((this.mass = A), (this.massOnly = !0), this)
  }
  setLinvel(A, I, g) {
    if (typeof A != "number" || typeof I != "number" || typeof g != "number")
      throw TypeError("The linvel components must be numbers.")
    return ((this.linvel = { x: A, y: I, z: g }), this)
  }
  setAngvel(A) {
    return (tI.copy(this.angvel, A), this)
  }
  setAdditionalMassProperties(A, I, g, C) {
    return (
      (this.mass = A),
      tI.copy(this.centerOfMass, I),
      tI.copy(this.principalAngularInertia, g),
      ke.copy(this.angularInertiaLocalFrame, C),
      (this.massOnly = !1),
      this
    )
  }
  enabledTranslations(A, I, g) {
    return (
      (this.translationsEnabledX = A),
      (this.translationsEnabledY = I),
      (this.translationsEnabledZ = g),
      this
    )
  }
  restrictTranslations(A, I, g) {
    return this.enabledTranslations(A, I, g)
  }
  lockTranslations() {
    return this.enabledTranslations(!1, !1, !1)
  }
  enabledRotations(A, I, g) {
    return (
      (this.rotationsEnabledX = A),
      (this.rotationsEnabledY = I),
      (this.rotationsEnabledZ = g),
      this
    )
  }
  restrictRotations(A, I, g) {
    return this.enabledRotations(A, I, g)
  }
  lockRotations() {
    return this.restrictRotations(!1, !1, !1)
  }
  setLinearDamping(A) {
    return ((this.linearDamping = A), this)
  }
  setAngularDamping(A) {
    return ((this.angularDamping = A), this)
  }
  setCanSleep(A) {
    return ((this.canSleep = A), this)
  }
  setSleeping(A) {
    return ((this.sleeping = A), this)
  }
  setCcdEnabled(A) {
    return ((this.ccdEnabled = A), this)
  }
  setSoftCcdPrediction(A) {
    return ((this.softCcdPrediction = A), this)
  }
  setUserData(A) {
    return ((this.userData = A), this)
  }
}
class RF {
  constructor() {
    ;((this.fconv = new Float64Array(1)),
      (this.uconv = new Uint32Array(this.fconv.buffer)),
      (this.data = new Array()),
      (this.size = 0))
  }
  set(A, I) {
    let g = this.index(A)
    for (; this.data.length <= g; ) this.data.push(null)
    ;(this.data[g] == null && (this.size += 1), (this.data[g] = I))
  }
  len() {
    return this.size
  }
  delete(A) {
    let I = this.index(A)
    I < this.data.length && (this.data[I] != null && (this.size -= 1), (this.data[I] = null))
  }
  clear() {
    this.data = new Array()
  }
  get(A) {
    let I = this.index(A)
    return I < this.data.length ? this.data[I] : null
  }
  forEach(A) {
    for (const I of this.data) I != null && A(I)
  }
  getAll() {
    return this.data.filter((A) => A != null)
  }
  index(A) {
    return ((this.fconv[0] = A), this.uconv[0])
  }
}
class Ov {
  constructor(A) {
    ;((this.raw = A || new NQ()),
      (this.map = new RF()),
      A &&
        A.forEachRigidBodyHandle((I) => {
          this.map.set(I, new YN(A, null, I))
        }))
  }
  free() {
    ;(this.raw && this.raw.free(),
      (this.raw = void 0),
      this.map && this.map.clear(),
      (this.map = void 0))
  }
  finalizeDeserialization(A) {
    this.map.forEach((I) => I.finalizeDeserialization(A))
  }
  createRigidBody(A, I) {
    let g = tI.intoRaw(I.translation),
      C = ke.intoRaw(I.rotation),
      i = tI.intoRaw(I.linvel),
      B = tI.intoRaw(I.centerOfMass),
      o = tI.intoRaw(I.angvel),
      r = tI.intoRaw(I.principalAngularInertia),
      s = ke.intoRaw(I.angularInertiaLocalFrame),
      h = this.raw.createRigidBody(
        I.enabled,
        g,
        C,
        I.gravityScale,
        I.mass,
        I.massOnly,
        B,
        i,
        o,
        r,
        s,
        I.translationsEnabledX,
        I.translationsEnabledY,
        I.translationsEnabledZ,
        I.rotationsEnabledX,
        I.rotationsEnabledY,
        I.rotationsEnabledZ,
        I.linearDamping,
        I.angularDamping,
        I.status,
        I.canSleep,
        I.sleeping,
        I.softCcdPrediction,
        I.ccdEnabled,
        I.dominanceGroup,
        I.additionalSolverIterations,
      )
    ;(g.free(), C.free(), i.free(), B.free(), o.free(), r.free(), s.free())
    const S = new YN(this.raw, A, h)
    return ((S.userData = I.userData), this.map.set(h, S), S)
  }
  remove(A, I, g, C, i) {
    for (let B = 0; B < this.raw.rbNumColliders(A); B += 1) g.unmap(this.raw.rbCollider(A, B))
    ;(C.forEachJointHandleAttachedToRigidBody(A, (B) => C.unmap(B)),
      i.forEachJointHandleAttachedToRigidBody(A, (B) => i.unmap(B)),
      this.raw.remove(A, I.raw, g.raw, C.raw, i.raw),
      this.map.delete(A))
  }
  len() {
    return this.map.len()
  }
  contains(A) {
    return this.get(A) != null
  }
  get(A) {
    return this.map.get(A)
  }
  forEach(A) {
    this.map.forEach(A)
  }
  forEachActiveRigidBody(A, I) {
    A.forEachActiveRigidBodyHandle((g) => {
      I(this.get(g))
    })
  }
  getAll() {
    return this.map.getAll()
  }
}
class _v {
  constructor(A) {
    this.raw = A || new bf()
  }
  free() {
    ;(this.raw && this.raw.free(), (this.raw = void 0))
  }
  get dt() {
    return this.raw.dt
  }
  get contact_erp() {
    return this.raw.contact_erp
  }
  get lengthUnit() {
    return this.raw.lengthUnit
  }
  get normalizedAllowedLinearError() {
    return this.raw.normalizedAllowedLinearError
  }
  get normalizedPredictionDistance() {
    return this.raw.normalizedPredictionDistance
  }
  get numSolverIterations() {
    return this.raw.numSolverIterations
  }
  get numAdditionalFrictionIterations() {
    return this.raw.numAdditionalFrictionIterations
  }
  get numInternalPgsIterations() {
    return this.raw.numInternalPgsIterations
  }
  get minIslandSize() {
    return this.raw.minIslandSize
  }
  get maxCcdSubsteps() {
    return this.raw.maxCcdSubsteps
  }
  set dt(A) {
    this.raw.dt = A
  }
  set contact_natural_frequency(A) {
    this.raw.contact_natural_frequency = A
  }
  set lengthUnit(A) {
    this.raw.lengthUnit = A
  }
  set normalizedAllowedLinearError(A) {
    this.raw.normalizedAllowedLinearError = A
  }
  set normalizedPredictionDistance(A) {
    this.raw.normalizedPredictionDistance = A
  }
  set numSolverIterations(A) {
    this.raw.numSolverIterations = A
  }
  set numAdditionalFrictionIterations(A) {
    this.raw.numAdditionalFrictionIterations = A
  }
  set numInternalPgsIterations(A) {
    this.raw.numInternalPgsIterations = A
  }
  set minIslandSize(A) {
    this.raw.minIslandSize = A
  }
  set maxCcdSubsteps(A) {
    this.raw.maxCcdSubsteps = A
  }
  switchToStandardPgsSolver() {
    this.raw.switchToStandardPgsSolver()
  }
  switchToSmallStepsPgsSolver() {
    this.raw.switchToSmallStepsPgsSolver()
  }
  switchToSmallStepsPgsSolverWithoutWarmstart() {
    this.raw.switchToSmallStepsPgsSolverWithoutWarmstart()
  }
}
;((function (e) {
  ;((e[(e.Revolute = 0)] = "Revolute"),
    (e[(e.Fixed = 1)] = "Fixed"),
    (e[(e.Prismatic = 2)] = "Prismatic"),
    (e[(e.Rope = 3)] = "Rope"),
    (e[(e.Spring = 4)] = "Spring"),
    (e[(e.Spherical = 5)] = "Spherical"),
    (e[(e.Generic = 6)] = "Generic"))
})(Po || (Po = {})),
  (function (e) {
    ;((e[(e.AccelerationBased = 0)] = "AccelerationBased"), (e[(e.ForceBased = 1)] = "ForceBased"))
  })(RN || (RN = {})),
  (function (e) {
    ;((e[(e.LinX = 1)] = "LinX"),
      (e[(e.LinY = 2)] = "LinY"),
      (e[(e.LinZ = 4)] = "LinZ"),
      (e[(e.AngX = 8)] = "AngX"),
      (e[(e.AngY = 16)] = "AngY"),
      (e[(e.AngZ = 32)] = "AngZ"))
  })(JN || (JN = {})))
class Ns {
  constructor(A, I, g) {
    ;((this.rawSet = A), (this.bodySet = I), (this.handle = g))
  }
  static newTyped(A, I, g) {
    switch (A.jointType(g)) {
      case wl.Revolute:
        return new jv(A, I, g)
      case wl.Prismatic:
        return new Vv(A, I, g)
      case wl.Fixed:
        return new Zv(A, I, g)
      case wl.Spring:
        return new Wv(A, I, g)
      case wl.Rope:
        return new Pv(A, I, g)
      case wl.Spherical:
        return new Xv(A, I, g)
      case wl.Generic:
        return new zv(A, I, g)
      default:
        return new Ns(A, I, g)
    }
  }
  finalizeDeserialization(A) {
    this.bodySet = A
  }
  isValid() {
    return this.rawSet.contains(this.handle)
  }
  body1() {
    return this.bodySet.get(this.rawSet.jointBodyHandle1(this.handle))
  }
  body2() {
    return this.bodySet.get(this.rawSet.jointBodyHandle2(this.handle))
  }
  type() {
    return this.rawSet.jointType(this.handle)
  }
  frameX1() {
    return ke.fromRaw(this.rawSet.jointFrameX1(this.handle))
  }
  frameX2() {
    return ke.fromRaw(this.rawSet.jointFrameX2(this.handle))
  }
  anchor1() {
    return tI.fromRaw(this.rawSet.jointAnchor1(this.handle))
  }
  anchor2() {
    return tI.fromRaw(this.rawSet.jointAnchor2(this.handle))
  }
  setAnchor1(A) {
    const I = tI.intoRaw(A)
    ;(this.rawSet.jointSetAnchor1(this.handle, I), I.free())
  }
  setAnchor2(A) {
    const I = tI.intoRaw(A)
    ;(this.rawSet.jointSetAnchor2(this.handle, I), I.free())
  }
  setContactsEnabled(A) {
    this.rawSet.jointSetContactsEnabled(this.handle, A)
  }
  contactsEnabled() {
    return this.rawSet.jointContactsEnabled(this.handle)
  }
}
class JF extends Ns {
  limitsEnabled() {
    return this.rawSet.jointLimitsEnabled(this.handle, this.rawAxis())
  }
  limitsMin() {
    return this.rawSet.jointLimitsMin(this.handle, this.rawAxis())
  }
  limitsMax() {
    return this.rawSet.jointLimitsMax(this.handle, this.rawAxis())
  }
  setLimits(A, I) {
    this.rawSet.jointSetLimits(this.handle, this.rawAxis(), A, I)
  }
  configureMotorModel(A) {
    this.rawSet.jointConfigureMotorModel(this.handle, this.rawAxis(), A)
  }
  configureMotorVelocity(A, I) {
    this.rawSet.jointConfigureMotorVelocity(this.handle, this.rawAxis(), A, I)
  }
  configureMotorPosition(A, I, g) {
    this.rawSet.jointConfigureMotorPosition(this.handle, this.rawAxis(), A, I, g)
  }
  configureMotor(A, I, g, C) {
    this.rawSet.jointConfigureMotor(this.handle, this.rawAxis(), A, I, g, C)
  }
}
class Zv extends Ns {}
class Pv extends Ns {}
class Wv extends Ns {}
class Vv extends JF {
  rawAxis() {
    return GF.LinX
  }
}
class jv extends JF {
  rawAxis() {
    return GF.AngX
  }
}
class zv extends Ns {}
class Xv extends Ns {}
class Tc {
  constructor() {}
  static fixed(A, I, g, C) {
    let i = new Tc()
    return (
      (i.anchor1 = A),
      (i.anchor2 = g),
      (i.frame1 = I),
      (i.frame2 = C),
      (i.jointType = Po.Fixed),
      i
    )
  }
  static spring(A, I, g, C, i) {
    let B = new Tc()
    return (
      (B.anchor1 = C),
      (B.anchor2 = i),
      (B.length = A),
      (B.stiffness = I),
      (B.damping = g),
      (B.jointType = Po.Spring),
      B
    )
  }
  static rope(A, I, g) {
    let C = new Tc()
    return ((C.anchor1 = I), (C.anchor2 = g), (C.length = A), (C.jointType = Po.Rope), C)
  }
  static generic(A, I, g, C) {
    let i = new Tc()
    return (
      (i.anchor1 = A),
      (i.anchor2 = I),
      (i.axis = g),
      (i.axesMask = C),
      (i.jointType = Po.Generic),
      i
    )
  }
  static spherical(A, I) {
    let g = new Tc()
    return ((g.anchor1 = A), (g.anchor2 = I), (g.jointType = Po.Spherical), g)
  }
  static prismatic(A, I, g) {
    let C = new Tc()
    return ((C.anchor1 = A), (C.anchor2 = I), (C.axis = g), (C.jointType = Po.Prismatic), C)
  }
  static revolute(A, I, g) {
    let C = new Tc()
    return ((C.anchor1 = A), (C.anchor2 = I), (C.axis = g), (C.jointType = Po.Revolute), C)
  }
  intoRaw() {
    let A,
      I,
      g = tI.intoRaw(this.anchor1),
      C = tI.intoRaw(this.anchor2),
      i = !1,
      B = 0,
      o = 0
    switch (this.jointType) {
      case Po.Fixed:
        let r = ke.intoRaw(this.frame1),
          s = ke.intoRaw(this.frame2)
        ;((I = Wo.fixed(g, r, C, s)), r.free(), s.free())
        break
      case Po.Spring:
        I = Wo.spring(this.length, this.stiffness, this.damping, g, C)
        break
      case Po.Rope:
        I = Wo.rope(this.length, g, C)
        break
      case Po.Prismatic:
        ;((A = tI.intoRaw(this.axis)),
          this.limitsEnabled && ((i = !0), (B = this.limits[0]), (o = this.limits[1])),
          (I = Wo.prismatic(g, C, A, i, B, o)),
          A.free())
        break
      case Po.Generic:
        A = tI.intoRaw(this.axis)
        let h = this.axesMask
        I = Wo.generic(g, C, A, h)
        break
      case Po.Spherical:
        I = Wo.spherical(g, C)
        break
      case Po.Revolute:
        ;((A = tI.intoRaw(this.axis)), (I = Wo.revolute(g, C, A)), A.free())
    }
    return (g.free(), C.free(), I)
  }
}
class $v {
  constructor(A) {
    ;((this.raw = A || new ou()),
      (this.map = new RF()),
      A &&
        A.forEachJointHandle((I) => {
          this.map.set(I, Ns.newTyped(A, null, I))
        }))
  }
  free() {
    ;(this.raw && this.raw.free(),
      (this.raw = void 0),
      this.map && this.map.clear(),
      (this.map = void 0))
  }
  finalizeDeserialization(A) {
    this.map.forEach((I) => I.finalizeDeserialization(A))
  }
  createJoint(A, I, g, C, i) {
    const B = I.intoRaw(),
      o = this.raw.createJoint(B, g, C, i)
    B.free()
    let r = Ns.newTyped(this.raw, A, o)
    return (this.map.set(o, r), r)
  }
  remove(A, I) {
    ;(this.raw.remove(A, I), this.unmap(A))
  }
  forEachJointHandleAttachedToRigidBody(A, I) {
    this.raw.forEachJointAttachedToRigidBody(A, I)
  }
  unmap(A) {
    this.map.delete(A)
  }
  len() {
    return this.map.len()
  }
  contains(A) {
    return this.get(A) != null
  }
  get(A) {
    return this.map.get(A)
  }
  forEach(A) {
    this.map.forEach(A)
  }
  getAll() {
    return this.map.getAll()
  }
}
class au {
  constructor(A, I) {
    ;((this.rawSet = A), (this.handle = I))
  }
  static newTyped(A, I) {
    switch (A.jointType(I)) {
      case wl.Revolute:
        return new gL(A, I)
      case wl.Prismatic:
        return new IL(A, I)
      case wl.Fixed:
        return new AL(A, I)
      case wl.Spherical:
        return new CL(A, I)
      default:
        return new au(A, I)
    }
  }
  isValid() {
    return this.rawSet.contains(this.handle)
  }
  setContactsEnabled(A) {
    this.rawSet.jointSetContactsEnabled(this.handle, A)
  }
  contactsEnabled() {
    return this.rawSet.jointContactsEnabled(this.handle)
  }
}
class KF extends au {}
class AL extends au {}
class IL extends KF {
  rawAxis() {
    return GF.LinX
  }
}
class gL extends KF {
  rawAxis() {
    return GF.AngX
  }
}
class CL extends au {}
class eL {
  constructor(A) {
    ;((this.raw = A || new Eu()),
      (this.map = new RF()),
      A &&
        A.forEachJointHandle((I) => {
          this.map.set(I, au.newTyped(this.raw, I))
        }))
  }
  free() {
    ;(this.raw && this.raw.free(),
      (this.raw = void 0),
      this.map && this.map.clear(),
      (this.map = void 0))
  }
  createJoint(A, I, g, C) {
    const i = A.intoRaw(),
      B = this.raw.createJoint(i, I, g, C)
    i.free()
    let o = au.newTyped(this.raw, B)
    return (this.map.set(B, o), o)
  }
  remove(A, I) {
    ;(this.raw.remove(A, I), this.map.delete(A))
  }
  unmap(A) {
    this.map.delete(A)
  }
  len() {
    return this.map.len()
  }
  contains(A) {
    return this.get(A) != null
  }
  get(A) {
    return this.map.get(A)
  }
  forEach(A) {
    this.map.forEach(A)
  }
  forEachJointHandleAttachedToRigidBody(A, I) {
    this.raw.forEachJointAttachedToRigidBody(A, I)
  }
  getAll() {
    return this.map.getAll()
  }
}
;(function (e) {
  ;((e[(e.Average = 0)] = "Average"),
    (e[(e.Min = 1)] = "Min"),
    (e[(e.Multiply = 2)] = "Multiply"),
    (e[(e.Max = 3)] = "Max"))
})(hp || (hp = {}))
class iL {
  constructor(A) {
    this.raw = A || new mm()
  }
  free() {
    ;(this.raw && this.raw.free(), (this.raw = void 0))
  }
}
class tL {
  constructor(A) {
    this.raw = A || new nu()
  }
  free() {
    ;(this.raw && this.raw.free(), (this.raw = void 0))
  }
  forEachActiveRigidBodyHandle(A) {
    this.raw.forEachActiveRigidBodyHandle(A)
  }
}
class BL {
  constructor(A) {
    this.raw = A || new xf()
  }
  free() {
    ;(this.raw && this.raw.free(), (this.raw = void 0))
  }
}
class QL {
  constructor(A) {
    ;((this.raw = A || new JD()), (this.tempManifold = new oL(null)))
  }
  free() {
    ;(this.raw && this.raw.free(), (this.raw = void 0))
  }
  contactPairsWith(A, I) {
    this.raw.contact_pairs_with(A, I)
  }
  intersectionPairsWith(A, I) {
    this.raw.intersection_pairs_with(A, I)
  }
  contactPair(A, I, g) {
    const C = this.raw.contact_pair(A, I)
    if (C) {
      const i = C.collider1() != A
      let B
      for (B = 0; B < C.numContactManifolds(); ++B)
        ((this.tempManifold.raw = C.contactManifold(B)),
          this.tempManifold.raw && g(this.tempManifold, i),
          this.tempManifold.free())
      C.free()
    }
  }
  intersectionPair(A, I) {
    return this.raw.intersection_pair(A, I)
  }
}
class oL {
  constructor(A) {
    this.raw = A
  }
  free() {
    ;(this.raw && this.raw.free(), (this.raw = void 0))
  }
  normal() {
    return tI.fromRaw(this.raw.normal())
  }
  localNormal1() {
    return tI.fromRaw(this.raw.local_n1())
  }
  localNormal2() {
    return tI.fromRaw(this.raw.local_n2())
  }
  subshape1() {
    return this.raw.subshape1()
  }
  subshape2() {
    return this.raw.subshape2()
  }
  numContacts() {
    return this.raw.num_contacts()
  }
  localContactPoint1(A) {
    return tI.fromRaw(this.raw.contact_local_p1(A))
  }
  localContactPoint2(A) {
    return tI.fromRaw(this.raw.contact_local_p2(A))
  }
  contactDist(A) {
    return this.raw.contact_dist(A)
  }
  contactFid1(A) {
    return this.raw.contact_fid1(A)
  }
  contactFid2(A) {
    return this.raw.contact_fid2(A)
  }
  contactImpulse(A) {
    return this.raw.contact_impulse(A)
  }
  contactTangentImpulseX(A) {
    return this.raw.contact_tangent_impulse_x(A)
  }
  contactTangentImpulseY(A) {
    return this.raw.contact_tangent_impulse_y(A)
  }
  numSolverContacts() {
    return this.raw.num_solver_contacts()
  }
  solverContactPoint(A) {
    return tI.fromRaw(this.raw.solver_contact_point(A))
  }
  solverContactDist(A) {
    return this.raw.solver_contact_dist(A)
  }
  solverContactFriction(A) {
    return this.raw.solver_contact_friction(A)
  }
  solverContactRestitution(A) {
    return this.raw.solver_contact_restitution(A)
  }
  solverContactTangentVelocity(A) {
    return tI.fromRaw(this.raw.solver_contact_tangent_velocity(A))
  }
}
class _f {
  constructor(A, I, g, C, i) {
    ;((this.distance = A),
      (this.point1 = I),
      (this.point2 = g),
      (this.normal1 = C),
      (this.normal2 = i))
  }
  static fromRaw(A) {
    if (!A) return null
    const I = new _f(
      A.distance(),
      tI.fromRaw(A.point1()),
      tI.fromRaw(A.point2()),
      tI.fromRaw(A.normal1()),
      tI.fromRaw(A.normal2()),
    )
    return (A.free(), I)
  }
}
;(function (e) {
  ;((e[(e.Vertex = 0)] = "Vertex"),
    (e[(e.Edge = 1)] = "Edge"),
    (e[(e.Face = 2)] = "Face"),
    (e[(e.Unknown = 3)] = "Unknown"))
})(Of || (Of = {}))
class Np {
  constructor(A, I) {
    ;((this.point = A), (this.isInside = I))
  }
  static fromRaw(A) {
    if (!A) return null
    const I = new Np(tI.fromRaw(A.point()), A.isInside())
    return (A.free(), I)
  }
}
class up {
  constructor(A, I, g, C, i) {
    ;((this.featureType = Of.Unknown),
      (this.featureId = void 0),
      (this.collider = A),
      (this.point = I),
      (this.isInside = g),
      i !== void 0 && (this.featureId = i),
      C !== void 0 && (this.featureType = C))
  }
  static fromRaw(A, I) {
    if (!I) return null
    const g = new up(
      A.get(I.colliderHandle()),
      tI.fromRaw(I.point()),
      I.isInside(),
      I.featureType(),
      I.featureId(),
    )
    return (I.free(), g)
  }
}
class FO {
  constructor(A, I) {
    ;((this.origin = A), (this.dir = I))
  }
  pointAt(A) {
    return {
      x: this.origin.x + this.dir.x * A,
      y: this.origin.y + this.dir.y * A,
      z: this.origin.z + this.dir.z * A,
    }
  }
}
class Fp {
  constructor(A, I, g, C) {
    ;((this.featureType = Of.Unknown),
      (this.featureId = void 0),
      (this.timeOfImpact = A),
      (this.normal = I),
      C !== void 0 && (this.featureId = C),
      g !== void 0 && (this.featureType = g))
  }
  static fromRaw(A) {
    if (!A) return null
    const I = new Fp(A.time_of_impact(), tI.fromRaw(A.normal()), A.featureType(), A.featureId())
    return (A.free(), I)
  }
}
class Dp {
  constructor(A, I, g, C, i) {
    ;((this.featureType = Of.Unknown),
      (this.featureId = void 0),
      (this.collider = A),
      (this.timeOfImpact = I),
      (this.normal = g),
      i !== void 0 && (this.featureId = i),
      C !== void 0 && (this.featureType = C))
  }
  static fromRaw(A, I) {
    if (!I) return null
    const g = new Dp(
      A.get(I.colliderHandle()),
      I.time_of_impact(),
      tI.fromRaw(I.normal()),
      I.featureType(),
      I.featureId(),
    )
    return (I.free(), g)
  }
}
class xG {
  constructor(A, I) {
    ;((this.collider = A), (this.timeOfImpact = I))
  }
  static fromRaw(A, I) {
    if (!I) return null
    const g = new xG(A.get(I.colliderHandle()), I.timeOfImpact())
    return (I.free(), g)
  }
}
class Xf {
  constructor(A, I, g, C, i) {
    ;((this.time_of_impact = A),
      (this.witness1 = I),
      (this.witness2 = g),
      (this.normal1 = C),
      (this.normal2 = i))
  }
  static fromRaw(A, I) {
    if (!I) return null
    const g = new Xf(
      I.time_of_impact(),
      tI.fromRaw(I.witness1()),
      tI.fromRaw(I.witness2()),
      tI.fromRaw(I.normal1()),
      tI.fromRaw(I.normal2()),
    )
    return (I.free(), g)
  }
}
class Rp extends Xf {
  constructor(A, I, g, C, i, B) {
    ;(super(I, g, C, i, B), (this.collider = A))
  }
  static fromRaw(A, I) {
    if (!I) return null
    const g = new Rp(
      A.get(I.colliderHandle()),
      I.time_of_impact(),
      tI.fromRaw(I.witness1()),
      tI.fromRaw(I.witness2()),
      tI.fromRaw(I.normal1()),
      tI.fromRaw(I.normal2()),
    )
    return (I.free(), g)
  }
}
class jQ {
  static fromRaw(A, I) {
    const g = A.coShapeType(I)
    let C, i, B, o, r, s, h
    switch (g) {
      case Jn.Ball:
        return new mF(A.coRadius(I))
      case Jn.Cuboid:
        return ((C = A.coHalfExtents(I)), new vF(C.x, C.y, C.z))
      case Jn.RoundCuboid:
        return ((C = A.coHalfExtents(I)), (i = A.coRoundRadius(I)), new LF(C.x, C.y, C.z, i))
      case Jn.Capsule:
        return ((r = A.coHalfHeight(I)), (s = A.coRadius(I)), new YF(r, s))
      case Jn.Segment:
        return ((B = A.coVertices(I)), new qF(tI.new(B[0], B[1], B[2]), tI.new(B[3], B[4], B[5])))
      case Jn.Polyline:
        return ((B = A.coVertices(I)), (o = A.coIndices(I)), new xF(B, o))
      case Jn.Triangle:
        return (
          (B = A.coVertices(I)),
          new HF(tI.new(B[0], B[1], B[2]), tI.new(B[3], B[4], B[5]), tI.new(B[6], B[7], B[8]))
        )
      case Jn.RoundTriangle:
        return (
          (B = A.coVertices(I)),
          (i = A.coRoundRadius(I)),
          new TF(tI.new(B[0], B[1], B[2]), tI.new(B[3], B[4], B[5]), tI.new(B[6], B[7], B[8]), i)
        )
      case Jn.HalfSpace:
        return ((h = tI.fromRaw(A.coHalfspaceNormal(I))), new nL(h))
      case Jn.TriMesh:
        ;((B = A.coVertices(I)), (o = A.coIndices(I)))
        const S = A.coTriMeshFlags(I)
        return new bF(B, o, S)
      case Jn.HeightField:
        const d = A.coHeightfieldScale(I),
          w = A.coHeightfieldHeights(I),
          M = A.coHeightfieldNRows(I),
          K = A.coHeightfieldNCols(I),
          R = A.coHeightFieldFlags(I)
        return new OF(M, K, w, d, R)
      case Jn.ConvexPolyhedron:
        return ((B = A.coVertices(I)), (o = A.coIndices(I)), new GG(B, o))
      case Jn.RoundConvexPolyhedron:
        return (
          (B = A.coVertices(I)),
          (o = A.coIndices(I)),
          (i = A.coRoundRadius(I)),
          new kG(B, o, i)
        )
      case Jn.Cylinder:
        return ((r = A.coHalfHeight(I)), (s = A.coRadius(I)), new _F(r, s))
      case Jn.RoundCylinder:
        return (
          (r = A.coHalfHeight(I)),
          (s = A.coRadius(I)),
          (i = A.coRoundRadius(I)),
          new ZF(r, s, i)
        )
      case Jn.Cone:
        return ((r = A.coHalfHeight(I)), (s = A.coRadius(I)), new PF(r, s))
      case Jn.RoundCone:
        return (
          (r = A.coHalfHeight(I)),
          (s = A.coRadius(I)),
          (i = A.coRoundRadius(I)),
          new WF(r, s, i)
        )
      default:
        throw new Error("unknown shape type: " + g)
    }
  }
  castShape(A, I, g, C, i, B, o, r, s, h) {
    let S = tI.intoRaw(A),
      d = ke.intoRaw(I),
      w = tI.intoRaw(g),
      M = tI.intoRaw(i),
      K = ke.intoRaw(B),
      R = tI.intoRaw(o),
      F = this.intoRaw(),
      L = C.intoRaw(),
      Y = Xf.fromRaw(null, F.castShape(S, d, w, L, M, K, R, r, s, h))
    return (S.free(), d.free(), w.free(), M.free(), K.free(), R.free(), F.free(), L.free(), Y)
  }
  intersectsShape(A, I, g, C, i) {
    let B = tI.intoRaw(A),
      o = ke.intoRaw(I),
      r = tI.intoRaw(C),
      s = ke.intoRaw(i),
      h = this.intoRaw(),
      S = g.intoRaw(),
      d = h.intersectsShape(B, o, S, r, s)
    return (B.free(), o.free(), r.free(), s.free(), h.free(), S.free(), d)
  }
  contactShape(A, I, g, C, i, B) {
    let o = tI.intoRaw(A),
      r = ke.intoRaw(I),
      s = tI.intoRaw(C),
      h = ke.intoRaw(i),
      S = this.intoRaw(),
      d = g.intoRaw(),
      w = _f.fromRaw(S.contactShape(o, r, d, s, h, B))
    return (o.free(), r.free(), s.free(), h.free(), S.free(), d.free(), w)
  }
  containsPoint(A, I, g) {
    let C = tI.intoRaw(A),
      i = ke.intoRaw(I),
      B = tI.intoRaw(g),
      o = this.intoRaw(),
      r = o.containsPoint(C, i, B)
    return (C.free(), i.free(), B.free(), o.free(), r)
  }
  projectPoint(A, I, g, C) {
    let i = tI.intoRaw(A),
      B = ke.intoRaw(I),
      o = tI.intoRaw(g),
      r = this.intoRaw(),
      s = Np.fromRaw(r.projectPoint(i, B, o, C))
    return (i.free(), B.free(), o.free(), r.free(), s)
  }
  intersectsRay(A, I, g, C) {
    let i = tI.intoRaw(I),
      B = ke.intoRaw(g),
      o = tI.intoRaw(A.origin),
      r = tI.intoRaw(A.dir),
      s = this.intoRaw(),
      h = s.intersectsRay(i, B, o, r, C)
    return (i.free(), B.free(), o.free(), r.free(), s.free(), h)
  }
  castRay(A, I, g, C, i) {
    let B = tI.intoRaw(I),
      o = ke.intoRaw(g),
      r = tI.intoRaw(A.origin),
      s = tI.intoRaw(A.dir),
      h = this.intoRaw(),
      S = h.castRay(B, o, r, s, C, i)
    return (B.free(), o.free(), r.free(), s.free(), h.free(), S)
  }
  castRayAndGetNormal(A, I, g, C, i) {
    let B = tI.intoRaw(I),
      o = ke.intoRaw(g),
      r = tI.intoRaw(A.origin),
      s = tI.intoRaw(A.dir),
      h = this.intoRaw(),
      S = Fp.fromRaw(h.castRayAndGetNormal(B, o, r, s, C, i))
    return (B.free(), o.free(), r.free(), s.free(), h.free(), S)
  }
}
;((function (e) {
  ;((e[(e.Ball = 0)] = "Ball"),
    (e[(e.Cuboid = 1)] = "Cuboid"),
    (e[(e.Capsule = 2)] = "Capsule"),
    (e[(e.Segment = 3)] = "Segment"),
    (e[(e.Polyline = 4)] = "Polyline"),
    (e[(e.Triangle = 5)] = "Triangle"),
    (e[(e.TriMesh = 6)] = "TriMesh"),
    (e[(e.HeightField = 7)] = "HeightField"),
    (e[(e.ConvexPolyhedron = 9)] = "ConvexPolyhedron"),
    (e[(e.Cylinder = 10)] = "Cylinder"),
    (e[(e.Cone = 11)] = "Cone"),
    (e[(e.RoundCuboid = 12)] = "RoundCuboid"),
    (e[(e.RoundTriangle = 13)] = "RoundTriangle"),
    (e[(e.RoundCylinder = 14)] = "RoundCylinder"),
    (e[(e.RoundCone = 15)] = "RoundCone"),
    (e[(e.RoundConvexPolyhedron = 16)] = "RoundConvexPolyhedron"),
    (e[(e.HalfSpace = 17)] = "HalfSpace"))
})(FQ || (FQ = {})),
  (function (e) {
    e[(e.FIX_INTERNAL_EDGES = 1)] = "FIX_INTERNAL_EDGES"
  })(KN || (KN = {})),
  (function (e) {
    ;((e[(e.DELETE_BAD_TOPOLOGY_TRIANGLES = 4)] = "DELETE_BAD_TOPOLOGY_TRIANGLES"),
      (e[(e.ORIENTED = 8)] = "ORIENTED"),
      (e[(e.MERGE_DUPLICATE_VERTICES = 16)] = "MERGE_DUPLICATE_VERTICES"),
      (e[(e.DELETE_DEGENERATE_TRIANGLES = 32)] = "DELETE_DEGENERATE_TRIANGLES"),
      (e[(e.DELETE_DUPLICATE_TRIANGLES = 64)] = "DELETE_DUPLICATE_TRIANGLES"),
      (e[(e.FIX_INTERNAL_EDGES = 152)] = "FIX_INTERNAL_EDGES"))
  })(mN || (mN = {})))
class mF extends jQ {
  constructor(A) {
    ;(super(), (this.type = FQ.Ball), (this.radius = A))
  }
  intoRaw() {
    return bC.ball(this.radius)
  }
}
class nL extends jQ {
  constructor(A) {
    ;(super(), (this.type = FQ.HalfSpace), (this.normal = A))
  }
  intoRaw() {
    let A = tI.intoRaw(this.normal),
      I = bC.halfspace(A)
    return (A.free(), I)
  }
}
class vF extends jQ {
  constructor(A, I, g) {
    ;(super(), (this.type = FQ.Cuboid), (this.halfExtents = tI.new(A, I, g)))
  }
  intoRaw() {
    return bC.cuboid(this.halfExtents.x, this.halfExtents.y, this.halfExtents.z)
  }
}
class LF extends jQ {
  constructor(A, I, g, C) {
    ;(super(),
      (this.type = FQ.RoundCuboid),
      (this.halfExtents = tI.new(A, I, g)),
      (this.borderRadius = C))
  }
  intoRaw() {
    return bC.roundCuboid(
      this.halfExtents.x,
      this.halfExtents.y,
      this.halfExtents.z,
      this.borderRadius,
    )
  }
}
class YF extends jQ {
  constructor(A, I) {
    ;(super(), (this.type = FQ.Capsule), (this.halfHeight = A), (this.radius = I))
  }
  intoRaw() {
    return bC.capsule(this.halfHeight, this.radius)
  }
}
class qF extends jQ {
  constructor(A, I) {
    ;(super(), (this.type = FQ.Segment), (this.a = A), (this.b = I))
  }
  intoRaw() {
    let A = tI.intoRaw(this.a),
      I = tI.intoRaw(this.b),
      g = bC.segment(A, I)
    return (A.free(), I.free(), g)
  }
}
class HF extends jQ {
  constructor(A, I, g) {
    ;(super(), (this.type = FQ.Triangle), (this.a = A), (this.b = I), (this.c = g))
  }
  intoRaw() {
    let A = tI.intoRaw(this.a),
      I = tI.intoRaw(this.b),
      g = tI.intoRaw(this.c),
      C = bC.triangle(A, I, g)
    return (A.free(), I.free(), g.free(), C)
  }
}
class TF extends jQ {
  constructor(A, I, g, C) {
    ;(super(),
      (this.type = FQ.RoundTriangle),
      (this.a = A),
      (this.b = I),
      (this.c = g),
      (this.borderRadius = C))
  }
  intoRaw() {
    let A = tI.intoRaw(this.a),
      I = tI.intoRaw(this.b),
      g = tI.intoRaw(this.c),
      C = bC.roundTriangle(A, I, g, this.borderRadius)
    return (A.free(), I.free(), g.free(), C)
  }
}
class xF extends jQ {
  constructor(A, I) {
    ;(super(),
      (this.type = FQ.Polyline),
      (this.vertices = A),
      (this.indices = I ?? new Uint32Array(0)))
  }
  intoRaw() {
    return bC.polyline(this.vertices, this.indices)
  }
}
class bF extends jQ {
  constructor(A, I, g) {
    ;(super(), (this.type = FQ.TriMesh), (this.vertices = A), (this.indices = I), (this.flags = g))
  }
  intoRaw() {
    return bC.trimesh(this.vertices, this.indices, this.flags)
  }
}
class GG extends jQ {
  constructor(A, I) {
    ;(super(), (this.type = FQ.ConvexPolyhedron), (this.vertices = A), (this.indices = I))
  }
  intoRaw() {
    return this.indices ? bC.convexMesh(this.vertices, this.indices) : bC.convexHull(this.vertices)
  }
}
class kG extends jQ {
  constructor(A, I, g) {
    ;(super(),
      (this.type = FQ.RoundConvexPolyhedron),
      (this.vertices = A),
      (this.indices = I),
      (this.borderRadius = g))
  }
  intoRaw() {
    return this.indices
      ? bC.roundConvexMesh(this.vertices, this.indices, this.borderRadius)
      : bC.roundConvexHull(this.vertices, this.borderRadius)
  }
}
class OF extends jQ {
  constructor(A, I, g, C, i) {
    ;(super(),
      (this.type = FQ.HeightField),
      (this.nrows = A),
      (this.ncols = I),
      (this.heights = g),
      (this.scale = C),
      (this.flags = i))
  }
  intoRaw() {
    let A = tI.intoRaw(this.scale),
      I = bC.heightfield(this.nrows, this.ncols, this.heights, A, this.flags)
    return (A.free(), I)
  }
}
class _F extends jQ {
  constructor(A, I) {
    ;(super(), (this.type = FQ.Cylinder), (this.halfHeight = A), (this.radius = I))
  }
  intoRaw() {
    return bC.cylinder(this.halfHeight, this.radius)
  }
}
class ZF extends jQ {
  constructor(A, I, g) {
    ;(super(),
      (this.type = FQ.RoundCylinder),
      (this.borderRadius = g),
      (this.halfHeight = A),
      (this.radius = I))
  }
  intoRaw() {
    return bC.roundCylinder(this.halfHeight, this.radius, this.borderRadius)
  }
}
class PF extends jQ {
  constructor(A, I) {
    ;(super(), (this.type = FQ.Cone), (this.halfHeight = A), (this.radius = I))
  }
  intoRaw() {
    return bC.cone(this.halfHeight, this.radius)
  }
}
class WF extends jQ {
  constructor(A, I, g) {
    ;(super(),
      (this.type = FQ.RoundCone),
      (this.halfHeight = A),
      (this.radius = I),
      (this.borderRadius = g))
  }
  intoRaw() {
    return bC.roundCone(this.halfHeight, this.radius, this.borderRadius)
  }
}
class EL {
  constructor(A) {
    this.raw = A || new f6()
  }
  free() {
    ;(this.raw && this.raw.free(), (this.raw = void 0))
  }
  step(A, I, g, C, i, B, o, r, s, h, S, d) {
    let w = tI.intoRaw(A)
    ;(S
      ? this.raw.stepWithEvents(
          w,
          I.raw,
          g.raw,
          C.raw,
          i.raw,
          B.raw,
          o.raw,
          r.raw,
          s.raw,
          h.raw,
          S.raw,
          d,
          d ? d.filterContactPair : null,
          d ? d.filterIntersectionPair : null,
        )
      : this.raw.step(w, I.raw, g.raw, C.raw, i.raw, B.raw, o.raw, r.raw, s.raw, h.raw),
      w.free())
  }
}
;(function (e) {
  ;((e[(e.EXCLUDE_FIXED = 1)] = "EXCLUDE_FIXED"),
    (e[(e.EXCLUDE_KINEMATIC = 2)] = "EXCLUDE_KINEMATIC"),
    (e[(e.EXCLUDE_DYNAMIC = 4)] = "EXCLUDE_DYNAMIC"),
    (e[(e.EXCLUDE_SENSORS = 8)] = "EXCLUDE_SENSORS"),
    (e[(e.EXCLUDE_SOLIDS = 16)] = "EXCLUDE_SOLIDS"),
    (e[(e.ONLY_DYNAMIC = 3)] = "ONLY_DYNAMIC"),
    (e[(e.ONLY_KINEMATIC = 5)] = "ONLY_KINEMATIC"),
    (e[(e.ONLY_FIXED = 6)] = "ONLY_FIXED"))
})(vN || (vN = {}))
class aL {
  constructor(A) {
    this.raw = A || new Tv()
  }
  free() {
    ;(this.raw && this.raw.free(), (this.raw = void 0))
  }
  update(A) {
    this.raw.update(A.raw)
  }
  castRay(A, I, g, C, i, B, o, r, s, h) {
    let S = tI.intoRaw(g.origin),
      d = tI.intoRaw(g.dir),
      w = xG.fromRaw(I, this.raw.castRay(A.raw, I.raw, S, d, C, i, B, o, r, s, h))
    return (S.free(), d.free(), w)
  }
  castRayAndGetNormal(A, I, g, C, i, B, o, r, s, h) {
    let S = tI.intoRaw(g.origin),
      d = tI.intoRaw(g.dir),
      w = Dp.fromRaw(I, this.raw.castRayAndGetNormal(A.raw, I.raw, S, d, C, i, B, o, r, s, h))
    return (S.free(), d.free(), w)
  }
  intersectionsWithRay(A, I, g, C, i, B, o, r, s, h, S) {
    let d = tI.intoRaw(g.origin),
      w = tI.intoRaw(g.dir)
    ;(this.raw.intersectionsWithRay(
      A.raw,
      I.raw,
      d,
      w,
      C,
      i,
      (M) => B(Dp.fromRaw(I, M)),
      o,
      r,
      s,
      h,
      S,
    ),
      d.free(),
      w.free())
  }
  intersectionWithShape(A, I, g, C, i, B, o, r, s, h) {
    let S = tI.intoRaw(g),
      d = ke.intoRaw(C),
      w = i.intoRaw(),
      M = this.raw.intersectionWithShape(A.raw, I.raw, S, d, w, B, o, r, s, h)
    return (S.free(), d.free(), w.free(), M)
  }
  projectPoint(A, I, g, C, i, B, o, r, s) {
    let h = tI.intoRaw(g),
      S = up.fromRaw(I, this.raw.projectPoint(A.raw, I.raw, h, C, i, B, o, r, s))
    return (h.free(), S)
  }
  projectPointAndGetFeature(A, I, g, C, i, B, o, r) {
    let s = tI.intoRaw(g),
      h = up.fromRaw(I, this.raw.projectPointAndGetFeature(A.raw, I.raw, s, C, i, B, o, r))
    return (s.free(), h)
  }
  intersectionsWithPoint(A, I, g, C, i, B, o, r, s) {
    let h = tI.intoRaw(g)
    ;(this.raw.intersectionsWithPoint(A.raw, I.raw, h, C, i, B, o, r, s), h.free())
  }
  castShape(A, I, g, C, i, B, o, r, s, h, S, d, w, M) {
    let K = tI.intoRaw(g),
      R = ke.intoRaw(C),
      F = tI.intoRaw(i),
      L = B.intoRaw(),
      Y = Rp.fromRaw(I, this.raw.castShape(A.raw, I.raw, K, R, F, L, o, r, s, h, S, d, w, M))
    return (K.free(), R.free(), F.free(), L.free(), Y)
  }
  intersectionsWithShape(A, I, g, C, i, B, o, r, s, h, S) {
    let d = tI.intoRaw(g),
      w = ke.intoRaw(C),
      M = i.intoRaw()
    ;(this.raw.intersectionsWithShape(A.raw, I.raw, d, w, M, B, o, r, s, h, S),
      d.free(),
      w.free(),
      M.free())
  }
  collidersWithAabbIntersectingAabb(A, I, g) {
    let C = tI.intoRaw(A),
      i = tI.intoRaw(I)
    ;(this.raw.collidersWithAabbIntersectingAabb(C, i, g), C.free(), i.free())
  }
}
class qN {
  constructor(A) {
    this.raw = A || new p6()
  }
  free() {
    ;(this.raw && this.raw.free(), (this.raw = void 0))
  }
  serializeAll(A, I, g, C, i, B, o, r, s) {
    let h = tI.intoRaw(A)
    const S = this.raw.serializeAll(h, I.raw, g.raw, C.raw, i.raw, B.raw, o.raw, r.raw, s.raw)
    return (h.free(), S)
  }
  deserializeAll(A) {
    return bG.fromRaw(this.raw.deserializeAll(A))
  }
}
class rL {
  constructor(A, I) {
    ;((this.vertices = A), (this.colors = I))
  }
}
class sL {
  constructor(A) {
    this.raw = A || new s6()
  }
  free() {
    ;(this.raw && this.raw.free(),
      (this.raw = void 0),
      (this.vertices = void 0),
      (this.colors = void 0))
  }
  render(A, I, g, C, i) {
    ;(this.raw.render(A.raw, I.raw, g.raw, C.raw, i.raw),
      (this.vertices = this.raw.vertices()),
      (this.colors = this.raw.colors()))
  }
}
class lL {}
class cL {
  constructor(A, I, g, C, i) {
    ;((this.params = I),
      (this.bodies = g),
      (this.colliders = C),
      (this.queries = i),
      (this.raw = new D6(A)),
      (this.rawCharacterCollision = new MO()),
      (this._applyImpulsesToDynamicBodies = !1),
      (this._characterMass = null))
  }
  free() {
    ;(this.raw && (this.raw.free(), this.rawCharacterCollision.free()),
      (this.raw = void 0),
      (this.rawCharacterCollision = void 0))
  }
  up() {
    return this.raw.up()
  }
  setUp(A) {
    let I = tI.intoRaw(A)
    return this.raw.setUp(I)
  }
  applyImpulsesToDynamicBodies() {
    return this._applyImpulsesToDynamicBodies
  }
  setApplyImpulsesToDynamicBodies(A) {
    this._applyImpulsesToDynamicBodies = A
  }
  characterMass() {
    return this._characterMass
  }
  setCharacterMass(A) {
    this._characterMass = A
  }
  offset() {
    return this.raw.offset()
  }
  setOffset(A) {
    this.raw.setOffset(A)
  }
  normalNudgeFactor() {
    return this.raw.normalNudgeFactor()
  }
  setNormalNudgeFactor(A) {
    this.raw.setNormalNudgeFactor(A)
  }
  slideEnabled() {
    return this.raw.slideEnabled()
  }
  setSlideEnabled(A) {
    this.raw.setSlideEnabled(A)
  }
  autostepMaxHeight() {
    return this.raw.autostepMaxHeight()
  }
  autostepMinWidth() {
    return this.raw.autostepMinWidth()
  }
  autostepIncludesDynamicBodies() {
    return this.raw.autostepIncludesDynamicBodies()
  }
  autostepEnabled() {
    return this.raw.autostepEnabled()
  }
  enableAutostep(A, I, g) {
    this.raw.enableAutostep(A, I, g)
  }
  disableAutostep() {
    return this.raw.disableAutostep()
  }
  maxSlopeClimbAngle() {
    return this.raw.maxSlopeClimbAngle()
  }
  setMaxSlopeClimbAngle(A) {
    this.raw.setMaxSlopeClimbAngle(A)
  }
  minSlopeSlideAngle() {
    return this.raw.minSlopeSlideAngle()
  }
  setMinSlopeSlideAngle(A) {
    this.raw.setMinSlopeSlideAngle(A)
  }
  snapToGroundDistance() {
    return this.raw.snapToGroundDistance()
  }
  enableSnapToGround(A) {
    this.raw.enableSnapToGround(A)
  }
  disableSnapToGround() {
    this.raw.disableSnapToGround()
  }
  snapToGroundEnabled() {
    return this.raw.snapToGroundEnabled()
  }
  computeColliderMovement(A, I, g, C, i) {
    let B = tI.intoRaw(I)
    ;(this.raw.computeColliderMovement(
      this.params.dt,
      this.bodies.raw,
      this.colliders.raw,
      this.queries.raw,
      A.handle,
      B,
      this._applyImpulsesToDynamicBodies,
      this._characterMass,
      g,
      C,
      this.colliders.castClosure(i),
    ),
      B.free())
  }
  computedMovement() {
    return tI.fromRaw(this.raw.computedMovement())
  }
  computedGrounded() {
    return this.raw.computedGrounded()
  }
  numComputedCollisions() {
    return this.raw.numComputedCollisions()
  }
  computedCollision(A, I) {
    if (this.raw.computedCollision(A, this.rawCharacterCollision)) {
      let g = this.rawCharacterCollision
      return (
        ((I = I ?? new lL()).translationDeltaApplied = tI.fromRaw(g.translationDeltaApplied())),
        (I.translationDeltaRemaining = tI.fromRaw(g.translationDeltaRemaining())),
        (I.toi = g.toi()),
        (I.witness1 = tI.fromRaw(g.worldWitness1())),
        (I.witness2 = tI.fromRaw(g.worldWitness2())),
        (I.normal1 = tI.fromRaw(g.worldNormal1())),
        (I.normal2 = tI.fromRaw(g.worldNormal2())),
        (I.collider = this.colliders.get(g.handle())),
        I
      )
    }
    return null
  }
}
class hL {
  constructor(A, I, g, C) {
    ;((this.raw = new c6(A.handle)),
      (this.bodies = I),
      (this.colliders = g),
      (this.queries = C),
      (this._chassis = A))
  }
  free() {
    ;(this.raw && this.raw.free(), (this.raw = void 0))
  }
  updateVehicle(A, I, g, C) {
    this.raw.update_vehicle(
      A,
      this.bodies.raw,
      this.colliders.raw,
      this.queries.raw,
      I,
      g,
      this.colliders.castClosure(C),
    )
  }
  currentVehicleSpeed() {
    return this.raw.current_vehicle_speed()
  }
  chassis() {
    return this._chassis
  }
  get indexUpAxis() {
    return this.raw.index_up_axis()
  }
  set indexUpAxis(A) {
    this.raw.set_index_up_axis(A)
  }
  get indexForwardAxis() {
    return this.raw.index_forward_axis()
  }
  set setIndexForwardAxis(A) {
    this.raw.set_index_forward_axis(A)
  }
  addWheel(A, I, g, C, i) {
    let B = tI.intoRaw(A),
      o = tI.intoRaw(I),
      r = tI.intoRaw(g)
    ;(this.raw.add_wheel(B, o, r, C, i), B.free(), o.free(), r.free())
  }
  numWheels() {
    return this.raw.num_wheels()
  }
  wheelChassisConnectionPointCs(A) {
    return tI.fromRaw(this.raw.wheel_chassis_connection_point_cs(A))
  }
  setWheelChassisConnectionPointCs(A, I) {
    let g = tI.intoRaw(I)
    ;(this.raw.set_wheel_chassis_connection_point_cs(A, g), g.free())
  }
  wheelSuspensionRestLength(A) {
    return this.raw.wheel_suspension_rest_length(A)
  }
  setWheelSuspensionRestLength(A, I) {
    this.raw.set_wheel_suspension_rest_length(A, I)
  }
  wheelMaxSuspensionTravel(A) {
    return this.raw.wheel_max_suspension_travel(A)
  }
  setWheelMaxSuspensionTravel(A, I) {
    this.raw.set_wheel_max_suspension_travel(A, I)
  }
  wheelRadius(A) {
    return this.raw.wheel_radius(A)
  }
  setWheelRadius(A, I) {
    this.raw.set_wheel_radius(A, I)
  }
  wheelSuspensionStiffness(A) {
    return this.raw.wheel_suspension_stiffness(A)
  }
  setWheelSuspensionStiffness(A, I) {
    this.raw.set_wheel_suspension_stiffness(A, I)
  }
  wheelSuspensionCompression(A) {
    return this.raw.wheel_suspension_compression(A)
  }
  setWheelSuspensionCompression(A, I) {
    this.raw.set_wheel_suspension_compression(A, I)
  }
  wheelSuspensionRelaxation(A) {
    return this.raw.wheel_suspension_relaxation(A)
  }
  setWheelSuspensionRelaxation(A, I) {
    this.raw.set_wheel_suspension_relaxation(A, I)
  }
  wheelMaxSuspensionForce(A) {
    return this.raw.wheel_max_suspension_force(A)
  }
  setWheelMaxSuspensionForce(A, I) {
    this.raw.set_wheel_max_suspension_force(A, I)
  }
  wheelBrake(A) {
    return this.raw.wheel_brake(A)
  }
  setWheelBrake(A, I) {
    this.raw.set_wheel_brake(A, I)
  }
  wheelSteering(A) {
    return this.raw.wheel_steering(A)
  }
  setWheelSteering(A, I) {
    this.raw.set_wheel_steering(A, I)
  }
  wheelEngineForce(A) {
    return this.raw.wheel_engine_force(A)
  }
  setWheelEngineForce(A, I) {
    this.raw.set_wheel_engine_force(A, I)
  }
  wheelDirectionCs(A) {
    return tI.fromRaw(this.raw.wheel_direction_cs(A))
  }
  setWheelDirectionCs(A, I) {
    let g = tI.intoRaw(I)
    ;(this.raw.set_wheel_direction_cs(A, g), g.free())
  }
  wheelAxleCs(A) {
    return tI.fromRaw(this.raw.wheel_axle_cs(A))
  }
  setWheelAxleCs(A, I) {
    let g = tI.intoRaw(I)
    ;(this.raw.set_wheel_axle_cs(A, g), g.free())
  }
  wheelFrictionSlip(A) {
    return this.raw.wheel_friction_slip(A)
  }
  setWheelFrictionSlip(A, I) {
    this.raw.set_wheel_friction_slip(A, I)
  }
  wheelSideFrictionStiffness(A) {
    return this.raw.wheel_side_friction_stiffness(A)
  }
  setWheelSideFrictionStiffness(A, I) {
    this.raw.set_wheel_side_friction_stiffness(A, I)
  }
  wheelRotation(A) {
    return this.raw.wheel_rotation(A)
  }
  wheelForwardImpulse(A) {
    return this.raw.wheel_forward_impulse(A)
  }
  wheelSideImpulse(A) {
    return this.raw.wheel_side_impulse(A)
  }
  wheelSuspensionForce(A) {
    return this.raw.wheel_suspension_force(A)
  }
  wheelContactNormal(A) {
    return tI.fromRaw(this.raw.wheel_contact_normal_ws(A))
  }
  wheelContactPoint(A) {
    return tI.fromRaw(this.raw.wheel_contact_point_ws(A))
  }
  wheelSuspensionLength(A) {
    return this.raw.wheel_suspension_length(A)
  }
  wheelHardPoint(A) {
    return tI.fromRaw(this.raw.wheel_hard_point_ws(A))
  }
  wheelIsInContact(A) {
    return this.raw.wheel_is_in_contact(A)
  }
  wheelGroundObject(A) {
    return this.colliders.get(this.raw.wheel_ground_object(A))
  }
}
class bG {
  constructor(A, I, g, C, i, B, o, r, s, h, S, d, w, M) {
    ;((this.gravity = A),
      (this.integrationParameters = new _v(I)),
      (this.islands = new tL(g)),
      (this.broadPhase = new BL(C)),
      (this.narrowPhase = new QL(i)),
      (this.bodies = new Ov(B)),
      (this.colliders = new SL(o)),
      (this.impulseJoints = new $v(r)),
      (this.multibodyJoints = new eL(s)),
      (this.ccdSolver = new iL(h)),
      (this.queryPipeline = new aL(S)),
      (this.physicsPipeline = new EL(d)),
      (this.serializationPipeline = new qN(w)),
      (this.debugRenderPipeline = new sL(M)),
      (this.characterControllers = /* @__PURE__ */ new Set()),
      (this.vehicleControllers = /* @__PURE__ */ new Set()),
      this.impulseJoints.finalizeDeserialization(this.bodies),
      this.bodies.finalizeDeserialization(this.colliders),
      this.colliders.finalizeDeserialization(this.bodies))
  }
  free() {
    ;(this.integrationParameters.free(),
      this.islands.free(),
      this.broadPhase.free(),
      this.narrowPhase.free(),
      this.bodies.free(),
      this.colliders.free(),
      this.impulseJoints.free(),
      this.multibodyJoints.free(),
      this.ccdSolver.free(),
      this.queryPipeline.free(),
      this.physicsPipeline.free(),
      this.serializationPipeline.free(),
      this.debugRenderPipeline.free(),
      this.characterControllers.forEach((A) => A.free()),
      this.vehicleControllers.forEach((A) => A.free()),
      (this.integrationParameters = void 0),
      (this.islands = void 0),
      (this.broadPhase = void 0),
      (this.narrowPhase = void 0),
      (this.bodies = void 0),
      (this.colliders = void 0),
      (this.ccdSolver = void 0),
      (this.impulseJoints = void 0),
      (this.multibodyJoints = void 0),
      (this.queryPipeline = void 0),
      (this.physicsPipeline = void 0),
      (this.serializationPipeline = void 0),
      (this.debugRenderPipeline = void 0),
      (this.characterControllers = void 0),
      (this.vehicleControllers = void 0))
  }
  static fromRaw(A) {
    return A
      ? new bG(
          tI.fromRaw(A.takeGravity()),
          A.takeIntegrationParameters(),
          A.takeIslandManager(),
          A.takeBroadPhase(),
          A.takeNarrowPhase(),
          A.takeBodies(),
          A.takeColliders(),
          A.takeImpulseJoints(),
          A.takeMultibodyJoints(),
        )
      : null
  }
  takeSnapshot() {
    return this.serializationPipeline.serializeAll(
      this.gravity,
      this.integrationParameters,
      this.islands,
      this.broadPhase,
      this.narrowPhase,
      this.bodies,
      this.colliders,
      this.impulseJoints,
      this.multibodyJoints,
    )
  }
  static restoreSnapshot(A) {
    return new qN().deserializeAll(A)
  }
  debugRender() {
    return (
      this.debugRenderPipeline.render(
        this.bodies,
        this.colliders,
        this.impulseJoints,
        this.multibodyJoints,
        this.narrowPhase,
      ),
      new rL(this.debugRenderPipeline.vertices, this.debugRenderPipeline.colors)
    )
  }
  step(A, I) {
    ;(this.physicsPipeline.step(
      this.gravity,
      this.integrationParameters,
      this.islands,
      this.broadPhase,
      this.narrowPhase,
      this.bodies,
      this.colliders,
      this.impulseJoints,
      this.multibodyJoints,
      this.ccdSolver,
      A,
      I,
    ),
      this.queryPipeline.update(this.colliders))
  }
  propagateModifiedBodyPositionsToColliders() {
    this.bodies.raw.propagateModifiedBodyPositionsToColliders(this.colliders.raw)
  }
  updateSceneQueries() {
    ;(this.propagateModifiedBodyPositionsToColliders(), this.queryPipeline.update(this.colliders))
  }
  get timestep() {
    return this.integrationParameters.dt
  }
  set timestep(A) {
    this.integrationParameters.dt = A
  }
  get lengthUnit() {
    return this.integrationParameters.lengthUnit
  }
  set lengthUnit(A) {
    this.integrationParameters.lengthUnit = A
  }
  get numSolverIterations() {
    return this.integrationParameters.numSolverIterations
  }
  set numSolverIterations(A) {
    this.integrationParameters.numSolverIterations = A
  }
  get numAdditionalFrictionIterations() {
    return this.integrationParameters.numAdditionalFrictionIterations
  }
  set numAdditionalFrictionIterations(A) {
    this.integrationParameters.numAdditionalFrictionIterations = A
  }
  get numInternalPgsIterations() {
    return this.integrationParameters.numInternalPgsIterations
  }
  set numInternalPgsIterations(A) {
    this.integrationParameters.numInternalPgsIterations = A
  }
  switchToStandardPgsSolver() {
    this.integrationParameters.switchToStandardPgsSolver()
  }
  switchToSmallStepsPgsSolver() {
    this.integrationParameters.switchToSmallStepsPgsSolver()
  }
  switchToSmallStepsPgsSolverWithoutWarmstart() {
    this.integrationParameters.switchToSmallStepsPgsSolverWithoutWarmstart()
  }
  createRigidBody(A) {
    return this.bodies.createRigidBody(this.colliders, A)
  }
  createCharacterController(A) {
    let I = new cL(A, this.integrationParameters, this.bodies, this.colliders, this.queryPipeline)
    return (this.characterControllers.add(I), I)
  }
  removeCharacterController(A) {
    ;(this.characterControllers.delete(A), A.free())
  }
  createVehicleController(A) {
    let I = new hL(A, this.bodies, this.colliders, this.queryPipeline)
    return (this.vehicleControllers.add(I), I)
  }
  removeVehicleController(A) {
    ;(this.vehicleControllers.delete(A), A.free())
  }
  createCollider(A, I) {
    let g = I ? I.handle : void 0
    return this.colliders.createCollider(this.bodies, A, g)
  }
  createImpulseJoint(A, I, g, C) {
    return this.impulseJoints.createJoint(this.bodies, A, I.handle, g.handle, C)
  }
  createMultibodyJoint(A, I, g, C) {
    return this.multibodyJoints.createJoint(A, I.handle, g.handle, C)
  }
  getRigidBody(A) {
    return this.bodies.get(A)
  }
  getCollider(A) {
    return this.colliders.get(A)
  }
  getImpulseJoint(A) {
    return this.impulseJoints.get(A)
  }
  getMultibodyJoint(A) {
    return this.multibodyJoints.get(A)
  }
  removeRigidBody(A) {
    this.bodies &&
      this.bodies.remove(
        A.handle,
        this.islands,
        this.colliders,
        this.impulseJoints,
        this.multibodyJoints,
      )
  }
  removeCollider(A, I) {
    this.colliders && this.colliders.remove(A.handle, this.islands, this.bodies, I)
  }
  removeImpulseJoint(A, I) {
    this.impulseJoints && this.impulseJoints.remove(A.handle, I)
  }
  removeMultibodyJoint(A, I) {
    this.impulseJoints && this.multibodyJoints.remove(A.handle, I)
  }
  forEachCollider(A) {
    this.colliders.forEach(A)
  }
  forEachRigidBody(A) {
    this.bodies.forEach(A)
  }
  forEachActiveRigidBody(A) {
    this.bodies.forEachActiveRigidBody(this.islands, A)
  }
  castRay(A, I, g, C, i, B, o, r) {
    return this.queryPipeline.castRay(
      this.bodies,
      this.colliders,
      A,
      I,
      g,
      C,
      i,
      B ? B.handle : null,
      o ? o.handle : null,
      this.colliders.castClosure(r),
    )
  }
  castRayAndGetNormal(A, I, g, C, i, B, o, r) {
    return this.queryPipeline.castRayAndGetNormal(
      this.bodies,
      this.colliders,
      A,
      I,
      g,
      C,
      i,
      B ? B.handle : null,
      o ? o.handle : null,
      this.colliders.castClosure(r),
    )
  }
  intersectionsWithRay(A, I, g, C, i, B, o, r, s) {
    this.queryPipeline.intersectionsWithRay(
      this.bodies,
      this.colliders,
      A,
      I,
      g,
      C,
      i,
      B,
      o ? o.handle : null,
      r ? r.handle : null,
      this.colliders.castClosure(s),
    )
  }
  intersectionWithShape(A, I, g, C, i, B, o, r) {
    let s = this.queryPipeline.intersectionWithShape(
      this.bodies,
      this.colliders,
      A,
      I,
      g,
      C,
      i,
      B ? B.handle : null,
      o ? o.handle : null,
      this.colliders.castClosure(r),
    )
    return s != null ? this.colliders.get(s) : null
  }
  projectPoint(A, I, g, C, i, B, o) {
    return this.queryPipeline.projectPoint(
      this.bodies,
      this.colliders,
      A,
      I,
      g,
      C,
      i ? i.handle : null,
      B ? B.handle : null,
      this.colliders.castClosure(o),
    )
  }
  projectPointAndGetFeature(A, I, g, C, i, B) {
    return this.queryPipeline.projectPointAndGetFeature(
      this.bodies,
      this.colliders,
      A,
      I,
      g,
      C ? C.handle : null,
      i ? i.handle : null,
      this.colliders.castClosure(B),
    )
  }
  intersectionsWithPoint(A, I, g, C, i, B, o) {
    this.queryPipeline.intersectionsWithPoint(
      this.bodies,
      this.colliders,
      A,
      this.colliders.castClosure(I),
      g,
      C,
      i ? i.handle : null,
      B ? B.handle : null,
      this.colliders.castClosure(o),
    )
  }
  castShape(A, I, g, C, i, B, o, r, s, h, S, d) {
    return this.queryPipeline.castShape(
      this.bodies,
      this.colliders,
      A,
      I,
      g,
      C,
      i,
      B,
      o,
      r,
      s,
      h ? h.handle : null,
      S ? S.handle : null,
      this.colliders.castClosure(d),
    )
  }
  intersectionsWithShape(A, I, g, C, i, B, o, r, s) {
    this.queryPipeline.intersectionsWithShape(
      this.bodies,
      this.colliders,
      A,
      I,
      g,
      this.colliders.castClosure(C),
      i,
      B,
      o ? o.handle : null,
      r ? r.handle : null,
      this.colliders.castClosure(s),
    )
  }
  collidersWithAabbIntersectingAabb(A, I, g) {
    this.queryPipeline.collidersWithAabbIntersectingAabb(A, I, this.colliders.castClosure(g))
  }
  contactPairsWith(A, I) {
    this.narrowPhase.contactPairsWith(A.handle, this.colliders.castClosure(I))
  }
  intersectionPairsWith(A, I) {
    this.narrowPhase.intersectionPairsWith(A.handle, this.colliders.castClosure(I))
  }
  contactPair(A, I, g) {
    this.narrowPhase.contactPair(A.handle, I.handle, g)
  }
  intersectionPair(A, I) {
    return this.narrowPhase.intersectionPair(A.handle, I.handle)
  }
}
;(function (e) {
  ;((e[(e.NONE = 0)] = "NONE"),
    (e[(e.COLLISION_EVENTS = 1)] = "COLLISION_EVENTS"),
    (e[(e.CONTACT_FORCE_EVENTS = 2)] = "CONTACT_FORCE_EVENTS"))
})(Cu || (Cu = {}))
class uL {
  free() {
    ;(this.raw && this.raw.free(), (this.raw = void 0))
  }
  collider1() {
    return this.raw.collider1()
  }
  collider2() {
    return this.raw.collider2()
  }
  totalForce() {
    return tI.fromRaw(this.raw.total_force())
  }
  totalForceMagnitude() {
    return this.raw.total_force_magnitude()
  }
  maxForceDirection() {
    return tI.fromRaw(this.raw.max_force_direction())
  }
  maxForceMagnitude() {
    return this.raw.max_force_magnitude()
  }
}
class DL {
  constructor(A, I) {
    this.raw = I || new UO(A)
  }
  free() {
    ;(this.raw && this.raw.free(), (this.raw = void 0))
  }
  drainCollisionEvents(A) {
    this.raw.drainCollisionEvents(A)
  }
  drainContactForceEvents(A) {
    let I = new uL()
    this.raw.drainContactForceEvents((g) => {
      ;((I.raw = g), A(I), I.free())
    })
  }
  clear() {
    this.raw.clear()
  }
}
;((function (e) {
  ;((e[(e.NONE = 0)] = "NONE"),
    (e[(e.FILTER_CONTACT_PAIRS = 1)] = "FILTER_CONTACT_PAIRS"),
    (e[(e.FILTER_INTERSECTION_PAIRS = 2)] = "FILTER_INTERSECTION_PAIRS"))
})(pG || (pG = {})),
  (function (e) {
    ;((e[(e.EMPTY = 0)] = "EMPTY"), (e[(e.COMPUTE_IMPULSE = 1)] = "COMPUTE_IMPULSE"))
  })(LN || (LN = {})),
  (function (e) {
    ;((e[(e.DYNAMIC_DYNAMIC = 1)] = "DYNAMIC_DYNAMIC"),
      (e[(e.DYNAMIC_KINEMATIC = 12)] = "DYNAMIC_KINEMATIC"),
      (e[(e.DYNAMIC_FIXED = 2)] = "DYNAMIC_FIXED"),
      (e[(e.KINEMATIC_KINEMATIC = 52224)] = "KINEMATIC_KINEMATIC"),
      (e[(e.KINEMATIC_FIXED = 8704)] = "KINEMATIC_FIXED"),
      (e[(e.FIXED_FIXED = 32)] = "FIXED_FIXED"),
      (e[(e.DEFAULT = 15)] = "DEFAULT"),
      (e[(e.ALL = 60943)] = "ALL"))
  })(wG || (wG = {})))
class HN {
  constructor(A, I, g, C) {
    ;((this.colliderSet = A), (this.handle = I), (this._parent = g), (this._shape = C))
  }
  finalizeDeserialization(A) {
    this.handle != null && (this._parent = A.get(this.colliderSet.raw.coParent(this.handle)))
  }
  ensureShapeIsCached() {
    this._shape || (this._shape = jQ.fromRaw(this.colliderSet.raw, this.handle))
  }
  get shape() {
    return (this.ensureShapeIsCached(), this._shape)
  }
  isValid() {
    return this.colliderSet.raw.contains(this.handle)
  }
  translation() {
    return tI.fromRaw(this.colliderSet.raw.coTranslation(this.handle))
  }
  rotation() {
    return ke.fromRaw(this.colliderSet.raw.coRotation(this.handle))
  }
  isSensor() {
    return this.colliderSet.raw.coIsSensor(this.handle)
  }
  setSensor(A) {
    this.colliderSet.raw.coSetSensor(this.handle, A)
  }
  setShape(A) {
    let I = A.intoRaw()
    ;(this.colliderSet.raw.coSetShape(this.handle, I), I.free(), (this._shape = A))
  }
  setEnabled(A) {
    this.colliderSet.raw.coSetEnabled(this.handle, A)
  }
  isEnabled() {
    return this.colliderSet.raw.coIsEnabled(this.handle)
  }
  setRestitution(A) {
    this.colliderSet.raw.coSetRestitution(this.handle, A)
  }
  setFriction(A) {
    this.colliderSet.raw.coSetFriction(this.handle, A)
  }
  frictionCombineRule() {
    return this.colliderSet.raw.coFrictionCombineRule(this.handle)
  }
  setFrictionCombineRule(A) {
    this.colliderSet.raw.coSetFrictionCombineRule(this.handle, A)
  }
  restitutionCombineRule() {
    return this.colliderSet.raw.coRestitutionCombineRule(this.handle)
  }
  setRestitutionCombineRule(A) {
    this.colliderSet.raw.coSetRestitutionCombineRule(this.handle, A)
  }
  setCollisionGroups(A) {
    this.colliderSet.raw.coSetCollisionGroups(this.handle, A)
  }
  setSolverGroups(A) {
    this.colliderSet.raw.coSetSolverGroups(this.handle, A)
  }
  contactSkin() {
    return this.colliderSet.raw.coContactSkin(this.handle)
  }
  setContactSkin(A) {
    return this.colliderSet.raw.coSetContactSkin(this.handle, A)
  }
  activeHooks() {
    return this.colliderSet.raw.coActiveHooks(this.handle)
  }
  setActiveHooks(A) {
    this.colliderSet.raw.coSetActiveHooks(this.handle, A)
  }
  activeEvents() {
    return this.colliderSet.raw.coActiveEvents(this.handle)
  }
  setActiveEvents(A) {
    this.colliderSet.raw.coSetActiveEvents(this.handle, A)
  }
  activeCollisionTypes() {
    return this.colliderSet.raw.coActiveCollisionTypes(this.handle)
  }
  setContactForceEventThreshold(A) {
    return this.colliderSet.raw.coSetContactForceEventThreshold(this.handle, A)
  }
  contactForceEventThreshold() {
    return this.colliderSet.raw.coContactForceEventThreshold(this.handle)
  }
  setActiveCollisionTypes(A) {
    this.colliderSet.raw.coSetActiveCollisionTypes(this.handle, A)
  }
  setDensity(A) {
    this.colliderSet.raw.coSetDensity(this.handle, A)
  }
  setMass(A) {
    this.colliderSet.raw.coSetMass(this.handle, A)
  }
  setMassProperties(A, I, g, C) {
    let i = tI.intoRaw(I),
      B = tI.intoRaw(g),
      o = ke.intoRaw(C)
    ;(this.colliderSet.raw.coSetMassProperties(this.handle, A, i, B, o),
      i.free(),
      B.free(),
      o.free())
  }
  setTranslation(A) {
    this.colliderSet.raw.coSetTranslation(this.handle, A.x, A.y, A.z)
  }
  setTranslationWrtParent(A) {
    this.colliderSet.raw.coSetTranslationWrtParent(this.handle, A.x, A.y, A.z)
  }
  setRotation(A) {
    this.colliderSet.raw.coSetRotation(this.handle, A.x, A.y, A.z, A.w)
  }
  setRotationWrtParent(A) {
    this.colliderSet.raw.coSetRotationWrtParent(this.handle, A.x, A.y, A.z, A.w)
  }
  shapeType() {
    return this.colliderSet.raw.coShapeType(this.handle)
  }
  halfExtents() {
    return tI.fromRaw(this.colliderSet.raw.coHalfExtents(this.handle))
  }
  setHalfExtents(A) {
    const I = tI.intoRaw(A)
    this.colliderSet.raw.coSetHalfExtents(this.handle, I)
  }
  radius() {
    return this.colliderSet.raw.coRadius(this.handle)
  }
  setRadius(A) {
    this.colliderSet.raw.coSetRadius(this.handle, A)
  }
  roundRadius() {
    return this.colliderSet.raw.coRoundRadius(this.handle)
  }
  setRoundRadius(A) {
    this.colliderSet.raw.coSetRoundRadius(this.handle, A)
  }
  halfHeight() {
    return this.colliderSet.raw.coHalfHeight(this.handle)
  }
  setHalfHeight(A) {
    this.colliderSet.raw.coSetHalfHeight(this.handle, A)
  }
  vertices() {
    return this.colliderSet.raw.coVertices(this.handle)
  }
  indices() {
    return this.colliderSet.raw.coIndices(this.handle)
  }
  heightfieldHeights() {
    return this.colliderSet.raw.coHeightfieldHeights(this.handle)
  }
  heightfieldScale() {
    let A = this.colliderSet.raw.coHeightfieldScale(this.handle)
    return tI.fromRaw(A)
  }
  heightfieldNRows() {
    return this.colliderSet.raw.coHeightfieldNRows(this.handle)
  }
  heightfieldNCols() {
    return this.colliderSet.raw.coHeightfieldNCols(this.handle)
  }
  parent() {
    return this._parent
  }
  friction() {
    return this.colliderSet.raw.coFriction(this.handle)
  }
  restitution() {
    return this.colliderSet.raw.coRestitution(this.handle)
  }
  density() {
    return this.colliderSet.raw.coDensity(this.handle)
  }
  mass() {
    return this.colliderSet.raw.coMass(this.handle)
  }
  volume() {
    return this.colliderSet.raw.coVolume(this.handle)
  }
  collisionGroups() {
    return this.colliderSet.raw.coCollisionGroups(this.handle)
  }
  solverGroups() {
    return this.colliderSet.raw.coSolverGroups(this.handle)
  }
  containsPoint(A) {
    let I = tI.intoRaw(A),
      g = this.colliderSet.raw.coContainsPoint(this.handle, I)
    return (I.free(), g)
  }
  projectPoint(A, I) {
    let g = tI.intoRaw(A),
      C = Np.fromRaw(this.colliderSet.raw.coProjectPoint(this.handle, g, I))
    return (g.free(), C)
  }
  intersectsRay(A, I) {
    let g = tI.intoRaw(A.origin),
      C = tI.intoRaw(A.dir),
      i = this.colliderSet.raw.coIntersectsRay(this.handle, g, C, I)
    return (g.free(), C.free(), i)
  }
  castShape(A, I, g, C, i, B, o, r) {
    let s = tI.intoRaw(A),
      h = tI.intoRaw(g),
      S = ke.intoRaw(C),
      d = tI.intoRaw(i),
      w = I.intoRaw(),
      M = Xf.fromRaw(
        this.colliderSet,
        this.colliderSet.raw.coCastShape(this.handle, s, w, h, S, d, B, o, r),
      )
    return (s.free(), h.free(), S.free(), d.free(), w.free(), M)
  }
  castCollider(A, I, g, C, i, B) {
    let o = tI.intoRaw(A),
      r = tI.intoRaw(g),
      s = Rp.fromRaw(
        this.colliderSet,
        this.colliderSet.raw.coCastCollider(this.handle, o, I.handle, r, C, i, B),
      )
    return (o.free(), r.free(), s)
  }
  intersectsShape(A, I, g) {
    let C = tI.intoRaw(I),
      i = ke.intoRaw(g),
      B = A.intoRaw(),
      o = this.colliderSet.raw.coIntersectsShape(this.handle, B, C, i)
    return (C.free(), i.free(), B.free(), o)
  }
  contactShape(A, I, g, C) {
    let i = tI.intoRaw(I),
      B = ke.intoRaw(g),
      o = A.intoRaw(),
      r = _f.fromRaw(this.colliderSet.raw.coContactShape(this.handle, o, i, B, C))
    return (i.free(), B.free(), o.free(), r)
  }
  contactCollider(A, I) {
    return _f.fromRaw(this.colliderSet.raw.coContactCollider(this.handle, A.handle, I))
  }
  castRay(A, I, g) {
    let C = tI.intoRaw(A.origin),
      i = tI.intoRaw(A.dir),
      B = this.colliderSet.raw.coCastRay(this.handle, C, i, I, g)
    return (C.free(), i.free(), B)
  }
  castRayAndGetNormal(A, I, g) {
    let C = tI.intoRaw(A.origin),
      i = tI.intoRaw(A.dir),
      B = Fp.fromRaw(this.colliderSet.raw.coCastRayAndGetNormal(this.handle, C, i, I, g))
    return (C.free(), i.free(), B)
  }
}
;(function (e) {
  ;((e[(e.Density = 0)] = "Density"),
    (e[(e.Mass = 1)] = "Mass"),
    (e[(e.MassProps = 2)] = "MassProps"))
})(pD || (pD = {}))
class CQ {
  constructor(A) {
    ;((this.enabled = !0),
      (this.shape = A),
      (this.massPropsMode = pD.Density),
      (this.density = 1),
      (this.friction = 0.5),
      (this.restitution = 0),
      (this.rotation = ke.identity()),
      (this.translation = tI.zeros()),
      (this.isSensor = !1),
      (this.collisionGroups = 4294967295),
      (this.solverGroups = 4294967295),
      (this.frictionCombineRule = hp.Average),
      (this.restitutionCombineRule = hp.Average),
      (this.activeCollisionTypes = wG.DEFAULT),
      (this.activeEvents = Cu.NONE),
      (this.activeHooks = pG.NONE),
      (this.mass = 0),
      (this.centerOfMass = tI.zeros()),
      (this.contactForceEventThreshold = 0),
      (this.contactSkin = 0),
      (this.principalAngularInertia = tI.zeros()),
      (this.angularInertiaLocalFrame = ke.identity()))
  }
  static ball(A) {
    const I = new mF(A)
    return new CQ(I)
  }
  static capsule(A, I) {
    const g = new YF(A, I)
    return new CQ(g)
  }
  static segment(A, I) {
    const g = new qF(A, I)
    return new CQ(g)
  }
  static triangle(A, I, g) {
    const C = new HF(A, I, g)
    return new CQ(C)
  }
  static roundTriangle(A, I, g, C) {
    const i = new TF(A, I, g, C)
    return new CQ(i)
  }
  static polyline(A, I) {
    const g = new xF(A, I)
    return new CQ(g)
  }
  static trimesh(A, I, g) {
    const C = new bF(A, I, g)
    return new CQ(C)
  }
  static cuboid(A, I, g) {
    const C = new vF(A, I, g)
    return new CQ(C)
  }
  static roundCuboid(A, I, g, C) {
    const i = new LF(A, I, g, C)
    return new CQ(i)
  }
  static heightfield(A, I, g, C, i) {
    const B = new OF(A, I, g, C, i)
    return new CQ(B)
  }
  static cylinder(A, I) {
    const g = new _F(A, I)
    return new CQ(g)
  }
  static roundCylinder(A, I, g) {
    const C = new ZF(A, I, g)
    return new CQ(C)
  }
  static cone(A, I) {
    const g = new PF(A, I)
    return new CQ(g)
  }
  static roundCone(A, I, g) {
    const C = new WF(A, I, g)
    return new CQ(C)
  }
  static convexHull(A) {
    const I = new GG(A, null)
    return new CQ(I)
  }
  static convexMesh(A, I) {
    const g = new GG(A, I)
    return new CQ(g)
  }
  static roundConvexHull(A, I) {
    const g = new kG(A, null, I)
    return new CQ(g)
  }
  static roundConvexMesh(A, I, g) {
    const C = new kG(A, I, g)
    return new CQ(C)
  }
  setTranslation(A, I, g) {
    if (typeof A != "number" || typeof I != "number" || typeof g != "number")
      throw TypeError("The translation components must be numbers.")
    return ((this.translation = { x: A, y: I, z: g }), this)
  }
  setRotation(A) {
    return (ke.copy(this.rotation, A), this)
  }
  setSensor(A) {
    return ((this.isSensor = A), this)
  }
  setEnabled(A) {
    return ((this.enabled = A), this)
  }
  setContactSkin(A) {
    return ((this.contactSkin = A), this)
  }
  setDensity(A) {
    return ((this.massPropsMode = pD.Density), (this.density = A), this)
  }
  setMass(A) {
    return ((this.massPropsMode = pD.Mass), (this.mass = A), this)
  }
  setMassProperties(A, I, g, C) {
    return (
      (this.massPropsMode = pD.MassProps),
      (this.mass = A),
      tI.copy(this.centerOfMass, I),
      tI.copy(this.principalAngularInertia, g),
      ke.copy(this.angularInertiaLocalFrame, C),
      this
    )
  }
  setRestitution(A) {
    return ((this.restitution = A), this)
  }
  setFriction(A) {
    return ((this.friction = A), this)
  }
  setFrictionCombineRule(A) {
    return ((this.frictionCombineRule = A), this)
  }
  setRestitutionCombineRule(A) {
    return ((this.restitutionCombineRule = A), this)
  }
  setCollisionGroups(A) {
    return ((this.collisionGroups = A), this)
  }
  setSolverGroups(A) {
    return ((this.solverGroups = A), this)
  }
  setActiveHooks(A) {
    return ((this.activeHooks = A), this)
  }
  setActiveEvents(A) {
    return ((this.activeEvents = A), this)
  }
  setActiveCollisionTypes(A) {
    return ((this.activeCollisionTypes = A), this)
  }
  setContactForceEventThreshold(A) {
    return ((this.contactForceEventThreshold = A), this)
  }
}
class SL {
  constructor(A) {
    ;((this.raw = A || new YB()),
      (this.map = new RF()),
      A &&
        A.forEachColliderHandle((I) => {
          this.map.set(I, new HN(this, I, null))
        }))
  }
  free() {
    ;(this.raw && this.raw.free(),
      (this.raw = void 0),
      this.map && this.map.clear(),
      (this.map = void 0))
  }
  castClosure(A) {
    return (I) => (A ? A(this.get(I)) : void 0)
  }
  finalizeDeserialization(A) {
    this.map.forEach((I) => I.finalizeDeserialization(A))
  }
  createCollider(A, I, g) {
    let C = g != null && g != null
    if (C && isNaN(g))
      throw Error("Cannot create a collider with a parent rigid-body handle that is not a number.")
    let i = I.shape.intoRaw(),
      B = tI.intoRaw(I.translation),
      o = ke.intoRaw(I.rotation),
      r = tI.intoRaw(I.centerOfMass),
      s = tI.intoRaw(I.principalAngularInertia),
      h = ke.intoRaw(I.angularInertiaLocalFrame),
      S = this.raw.createCollider(
        I.enabled,
        i,
        B,
        o,
        I.massPropsMode,
        I.mass,
        r,
        s,
        h,
        I.density,
        I.friction,
        I.restitution,
        I.frictionCombineRule,
        I.restitutionCombineRule,
        I.isSensor,
        I.collisionGroups,
        I.solverGroups,
        I.activeCollisionTypes,
        I.activeHooks,
        I.activeEvents,
        I.contactForceEventThreshold,
        I.contactSkin,
        C,
        C ? g : 0,
        A.raw,
      )
    ;(i.free(), B.free(), o.free(), r.free(), s.free(), h.free())
    let d = C ? A.get(g) : null,
      w = new HN(this, S, d, I.shape)
    return (this.map.set(S, w), w)
  }
  remove(A, I, g, C) {
    ;(this.raw.remove(A, I.raw, g.raw, C), this.unmap(A))
  }
  unmap(A) {
    this.map.delete(A)
  }
  get(A) {
    return this.map.get(A)
  }
  len() {
    return this.map.len()
  }
  contains(A) {
    return this.get(A) != null
  }
  forEach(A) {
    this.map.forEach(A)
  }
  getAll() {
    return this.map.getAll()
  }
}
function w6(e, A, I, g) {
  return new (I || (I = Promise))(function (C, i) {
    function B(s) {
      try {
        r(g.next(s))
      } catch (h) {
        i(h)
      }
    }
    function o(s) {
      try {
        r(g.throw(s))
      } catch (h) {
        i(h)
      }
    }
    function r(s) {
      var h
      s.done
        ? C(s.value)
        : ((h = s.value),
          h instanceof I
            ? h
            : new I(function (S) {
                S(h)
              })).then(B, o)
    }
    r((g = g.apply(e, [])).next())
  })
}
for (
  var G6 = {
      byteLength: function (e) {
        var A = Lx(e),
          I = A[0],
          g = A[1]
        return (3 * (I + g)) / 4 - g
      },
      toByteArray: function (e) {
        var A,
          I,
          g = Lx(e),
          C = g[0],
          i = g[1],
          B = new k6(
            (function (s, h, S) {
              return (3 * (h + S)) / 4 - S
            })(0, C, i),
          ),
          o = 0,
          r = i > 0 ? C - 4 : C
        for (I = 0; I < r; I += 4)
          ((A =
            (ys[e.charCodeAt(I)] << 18) |
            (ys[e.charCodeAt(I + 1)] << 12) |
            (ys[e.charCodeAt(I + 2)] << 6) |
            ys[e.charCodeAt(I + 3)]),
            (B[o++] = (A >> 16) & 255),
            (B[o++] = (A >> 8) & 255),
            (B[o++] = 255 & A))
        return (
          i === 2 &&
            ((A = (ys[e.charCodeAt(I)] << 2) | (ys[e.charCodeAt(I + 1)] >> 4)), (B[o++] = 255 & A)),
          i === 1 &&
            ((A =
              (ys[e.charCodeAt(I)] << 10) |
              (ys[e.charCodeAt(I + 1)] << 4) |
              (ys[e.charCodeAt(I + 2)] >> 2)),
            (B[o++] = (A >> 8) & 255),
            (B[o++] = 255 & A)),
          B
        )
      },
      fromByteArray: function (e) {
        for (var A, I = e.length, g = I % 3, C = [], i = 16383, B = 0, o = I - g; B < o; B += i)
          C.push(U6(e, B, B + i > o ? o : B + i))
        return (
          g === 1
            ? ((A = e[I - 1]), C.push(xc[A >> 2] + xc[(A << 4) & 63] + "=="))
            : g === 2 &&
              ((A = (e[I - 2] << 8) + e[I - 1]),
              C.push(xc[A >> 10] + xc[(A >> 4) & 63] + xc[(A << 2) & 63] + "=")),
          C.join("")
        )
      },
    },
    xc = [],
    ys = [],
    k6 = typeof Uint8Array < "u" ? Uint8Array : Array,
    tm = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    jy = 0,
    M6 = tm.length;
  jy < M6;
  ++jy
)
  ((xc[jy] = tm[jy]), (ys[tm.charCodeAt(jy)] = jy))
function Lx(e) {
  var A = e.length
  if (A % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4")
  var I = e.indexOf("=")
  return (I === -1 && (I = A), [I, I === A ? 0 : 4 - (I % 4)])
}
function U6(e, A, I) {
  for (var g, C, i = [], B = A; B < I; B += 3)
    ((g = ((e[B] << 16) & 16711680) + ((e[B + 1] << 8) & 65280) + (255 & e[B + 2])),
      i.push(xc[((C = g) >> 18) & 63] + xc[(C >> 12) & 63] + xc[(C >> 6) & 63] + xc[63 & C]))
  return i.join("")
}
function RO() {
  return w6(this, void 0, void 0, function* () {
    yield NO(
      G6.toByteArray(
        "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",
      ).buffer,
    )
  })
}
function JO() {
  return (function () {
    let e, A
    try {
      const C = b.__wbindgen_add_to_stack_pointer(-16)
      b.version(C)
      var I = VC()[C / 4 + 0],
        g = VC()[C / 4 + 1]
      return ((e = I), (A = g), GO(I, g))
    } finally {
      ;(b.__wbindgen_add_to_stack_pointer(16), b.__wbindgen_free(e, A, 1))
    }
  })()
}
;((ys[45] = 62), (ys[95] = 63))
var N6 = Object.freeze({
  __proto__: null,
  version: JO,
  Vector3: Bp,
  VectorOps: tI,
  Quaternion: NN,
  RotationOps: ke,
  SdpMatrix3: bv,
  SdpMatrix3Ops: FN,
  get RigidBodyType() {
    return ws
  },
  RigidBody: YN,
  RigidBodyDesc: Gs,
  RigidBodySet: Ov,
  IntegrationParameters: _v,
  get JointType() {
    return Po
  },
  get MotorModel() {
    return RN
  },
  get JointAxesMask() {
    return JN
  },
  ImpulseJoint: Ns,
  UnitImpulseJoint: JF,
  FixedImpulseJoint: Zv,
  RopeImpulseJoint: Pv,
  SpringImpulseJoint: Wv,
  PrismaticImpulseJoint: Vv,
  RevoluteImpulseJoint: jv,
  GenericImpulseJoint: zv,
  SphericalImpulseJoint: Xv,
  JointData: Tc,
  ImpulseJointSet: $v,
  MultibodyJoint: au,
  UnitMultibodyJoint: KF,
  FixedMultibodyJoint: AL,
  PrismaticMultibodyJoint: IL,
  RevoluteMultibodyJoint: gL,
  SphericalMultibodyJoint: CL,
  MultibodyJointSet: eL,
  get CoefficientCombineRule() {
    return hp
  },
  CCDSolver: iL,
  IslandManager: tL,
  BroadPhase: BL,
  NarrowPhase: QL,
  TempContactManifold: oL,
  Shape: jQ,
  get ShapeType() {
    return FQ
  },
  get HeightFieldFlags() {
    return KN
  },
  get TriMeshFlags() {
    return mN
  },
  Ball: mF,
  HalfSpace: nL,
  Cuboid: vF,
  RoundCuboid: LF,
  Capsule: YF,
  Segment: qF,
  Triangle: HF,
  RoundTriangle: TF,
  Polyline: xF,
  TriMesh: bF,
  ConvexPolyhedron: GG,
  RoundConvexPolyhedron: kG,
  Heightfield: OF,
  Cylinder: _F,
  RoundCylinder: ZF,
  Cone: PF,
  RoundCone: WF,
  get ActiveCollisionTypes() {
    return wG
  },
  Collider: HN,
  get MassPropsMode() {
    return pD
  },
  ColliderDesc: CQ,
  ColliderSet: SL,
  get FeatureType() {
    return Of
  },
  Ray: FO,
  RayIntersection: Fp,
  RayColliderIntersection: Dp,
  RayColliderHit: xG,
  PointProjection: Np,
  PointColliderProjection: up,
  ShapeCastHit: Xf,
  ColliderShapeCastHit: Rp,
  ShapeContact: _f,
  World: bG,
  PhysicsPipeline: EL,
  SerializationPipeline: qN,
  get ActiveEvents() {
    return Cu
  },
  TempContactForceEvent: uL,
  EventQueue: DL,
  get ActiveHooks() {
    return pG
  },
  get SolverFlags() {
    return LN
  },
  DebugRenderBuffers: rL,
  DebugRenderPipeline: sL,
  get QueryFilterFlags() {
    return vN
  },
  QueryPipeline: aL,
  init: RO,
  CharacterCollision: lL,
  KinematicCharacterController: cL,
  DynamicRayCastVehicleController: hL,
})
const F6 = /* @__PURE__ */ Object.freeze(
  /* @__PURE__ */ Object.defineProperty(
    {
      __proto__: null,
      get ActiveCollisionTypes() {
        return wG
      },
      get ActiveEvents() {
        return Cu
      },
      get ActiveHooks() {
        return pG
      },
      Ball: mF,
      BroadPhase: BL,
      CCDSolver: iL,
      Capsule: YF,
      CharacterCollision: lL,
      get CoefficientCombineRule() {
        return hp
      },
      Collider: HN,
      ColliderDesc: CQ,
      ColliderSet: SL,
      ColliderShapeCastHit: Rp,
      Cone: PF,
      ConvexPolyhedron: GG,
      Cuboid: vF,
      Cylinder: _F,
      DebugRenderBuffers: rL,
      DebugRenderPipeline: sL,
      DynamicRayCastVehicleController: hL,
      EventQueue: DL,
      get FeatureType() {
        return Of
      },
      FixedImpulseJoint: Zv,
      FixedMultibodyJoint: AL,
      GenericImpulseJoint: zv,
      HalfSpace: nL,
      get HeightFieldFlags() {
        return KN
      },
      Heightfield: OF,
      ImpulseJoint: Ns,
      ImpulseJointSet: $v,
      IntegrationParameters: _v,
      IslandManager: tL,
      get JointAxesMask() {
        return JN
      },
      JointData: Tc,
      get JointType() {
        return Po
      },
      KinematicCharacterController: cL,
      get MassPropsMode() {
        return pD
      },
      get MotorModel() {
        return RN
      },
      MultibodyJoint: au,
      MultibodyJointSet: eL,
      NarrowPhase: QL,
      PhysicsPipeline: EL,
      PointColliderProjection: up,
      PointProjection: Np,
      Polyline: xF,
      PrismaticImpulseJoint: Vv,
      PrismaticMultibodyJoint: IL,
      Quaternion: NN,
      get QueryFilterFlags() {
        return vN
      },
      QueryPipeline: aL,
      Ray: FO,
      RayColliderHit: xG,
      RayColliderIntersection: Dp,
      RayIntersection: Fp,
      RevoluteImpulseJoint: jv,
      RevoluteMultibodyJoint: gL,
      RigidBody: YN,
      RigidBodyDesc: Gs,
      RigidBodySet: Ov,
      get RigidBodyType() {
        return ws
      },
      RopeImpulseJoint: Pv,
      RotationOps: ke,
      RoundCone: WF,
      RoundConvexPolyhedron: kG,
      RoundCuboid: LF,
      RoundCylinder: ZF,
      RoundTriangle: TF,
      SdpMatrix3: bv,
      SdpMatrix3Ops: FN,
      Segment: qF,
      SerializationPipeline: qN,
      Shape: jQ,
      ShapeCastHit: Xf,
      ShapeContact: _f,
      get ShapeType() {
        return FQ
      },
      get SolverFlags() {
        return LN
      },
      SphericalImpulseJoint: Xv,
      SphericalMultibodyJoint: CL,
      SpringImpulseJoint: Wv,
      TempContactForceEvent: uL,
      TempContactManifold: oL,
      TriMesh: bF,
      get TriMeshFlags() {
        return mN
      },
      Triangle: HF,
      UnitImpulseJoint: JF,
      UnitMultibodyJoint: KF,
      Vector3: Bp,
      VectorOps: tI,
      World: bG,
      default: N6,
      init: RO,
      version: JO,
    },
    Symbol.toStringTag,
    { value: "Module" },
  ),
)
function R6(e, A) {
  if (typeof e != "object" || !e) return e
  var I = e[Symbol.toPrimitive]
  if (I !== void 0) {
    var g = I.call(e, A || "default")
    if (typeof g != "object") return g
    throw new TypeError("@@toPrimitive must return a primitive value.")
  }
  return (A === "string" ? String : Number)(e)
}
function J6(e) {
  var A = R6(e, "string")
  return typeof A == "symbol" ? A : A + ""
}
function K6(e, A, I) {
  return (
    (A = J6(A)) in e
      ? Object.defineProperty(e, A, {
          value: I,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (e[A] = I),
    e
  )
}
function Yx(e, A) {
  var I = Object.keys(e)
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(e)
    ;(A &&
      (g = g.filter(function (C) {
        return Object.getOwnPropertyDescriptor(e, C).enumerable
      })),
      I.push.apply(I, g))
  }
  return I
}
function ji(e) {
  for (var A = 1; A < arguments.length; A++) {
    var I = arguments[A] != null ? arguments[A] : {}
    A % 2
      ? Yx(Object(I), !0).forEach(function (g) {
          K6(e, g, I[g])
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(I))
        : Yx(Object(I)).forEach(function (g) {
            Object.defineProperty(e, g, Object.getOwnPropertyDescriptor(I, g))
          })
  }
  return e
}
const m6 = new ho()
new uE()
const v6 = new wA()
new Ci()
const GD = new RC(),
  mn = new wA(),
  Ml = new ho(),
  Zf = new wA(),
  L6 = (e) => {
    const [A, I, g] = e
    return new wA(A, I, g)
  },
  qx = ({ x: e, y: A, z: I, w: g }) => m6.set(e, A, I, g),
  Y6 = (e) => {
    if (Array.isArray(e)) return new Bp(e[0], e[1], e[2])
    if (typeof e == "number") return new Bp(e, e, e)
    {
      const A = e
      return new Bp(A.x, A.y, A.z)
    }
  },
  q6 = {
    fixed: 1,
    dynamic: 0,
    kinematicPosition: 2,
    kinematicVelocity: 3,
  },
  KO = (e) => q6[e],
  H6 = (e, A) => {
    const I = Array.from(e)
    for (let g = 0; g < e.length / 3; g++)
      ((I[g * 3] *= A.x), (I[g * 3 + 1] *= A.y), (I[g * 3 + 2] *= A.z))
    return I
  },
  mO = (e) =>
    e
      ? e instanceof ho
        ? [e.x, e.y, e.z, e.w]
        : e instanceof wA || e instanceof uE
          ? [e.x, e.y, e.z]
          : Array.isArray(e)
            ? e
            : [e]
      : [0]
function DD(e) {
  const A = xI.useRef()
  return (
    A.current === void 0 &&
      (A.current = {
        value: typeof e == "function" ? e() : e,
      }),
    A.current.value
  )
}
const T6 = (e) => {
    const A = xI.useRef(e),
      I = xI.useRef(0),
      g = xI.useRef(0)
    ;(xI.useEffect(() => {
      A.current = e
    }, [e]),
      xI.useEffect(() => {
        const C = () => {
          const i = performance.now(),
            B = i - g.current
          ;((I.current = requestAnimationFrame(C)), A.current(B / 1e3), (g.current = i))
        }
        return ((I.current = requestAnimationFrame(C)), () => cancelAnimationFrame(I.current))
      }, []))
  },
  x6 = ({ onStep: e, updatePriority: A }) => (
    Mp((I, g) => {
      e(g)
    }, A),
    null
  ),
  b6 = ({ onStep: e }) => (
    T6((A) => {
      e(A)
    }),
    null
  ),
  O6 = ({ onStep: e, type: A, updatePriority: I }) =>
    A === "independent"
      ? /* @__PURE__ */ HC.createElement(b6, {
          onStep: e,
        })
      : /* @__PURE__ */ HC.createElement(x6, {
          onStep: e,
          updatePriority: I,
        })
var _6 = /* @__PURE__ */ xI.memo(O6)
function Z6(e, A) {
  if (e == null) return {}
  var I = {}
  for (var g in e)
    if ({}.hasOwnProperty.call(e, g)) {
      if (A.includes(g)) continue
      I[g] = e[g]
    }
  return I
}
function fL(e, A) {
  if (e == null) return {}
  var I,
    g,
    C = Z6(e, A)
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e)
    for (g = 0; g < i.length; g++)
      ((I = i[g]), A.includes(I) || ({}.propertyIsEnumerable.call(e, I) && (C[I] = e[I])))
  }
  return C
}
const P6 = [
    "mass",
    "linearDamping",
    "angularDamping",
    "type",
    "onCollisionEnter",
    "onCollisionExit",
    "onIntersectionEnter",
    "onIntersectionExit",
    "onContactForce",
    "children",
    "canSleep",
    "ccd",
    "gravityScale",
    "softCcdPrediction",
  ],
  W6 = (e, A, I) => {
    const g = A.slice()
    if (e === "heightfield") {
      const i = g[3]
      return ((i.x *= I.x), (i.x *= I.y), (i.x *= I.z), g)
    }
    if (e === "trimesh" || e === "convexHull") return ((g[0] = H6(g[0], I)), g)
    const C = [I.x, I.y, I.z, I.x, I.x]
    return g.map((i, B) => C[B] * i)
  },
  V6 = (e, A, I, g) => {
    const C = W6(e.shape, e.args, I),
      i = CQ[e.shape](...C)
    return A.createCollider(i, g?.())
  },
  j6 = ["shape", "args"],
  Hx = "Please pick ONLY ONE of the `density`, `mass` and `massProperties` options.",
  z6 = (e, A) => {
    if (A.density !== void 0) {
      if (A.mass !== void 0 || A.massProperties !== void 0) throw new Error(Hx)
      e.setDensity(A.density)
      return
    }
    if (A.mass !== void 0) {
      if (A.massProperties !== void 0) throw new Error(Hx)
      e.setMass(A.mass)
      return
    }
    A.massProperties !== void 0 &&
      e.setMassProperties(
        A.massProperties.mass,
        A.massProperties.centerOfMass,
        A.massProperties.principalAngularInertia,
        A.massProperties.angularInertiaLocalFrame,
      )
  },
  vO = {
    sensor: (e, A) => {
      e.setSensor(A)
    },
    collisionGroups: (e, A) => {
      e.setCollisionGroups(A)
    },
    solverGroups: (e, A) => {
      e.setSolverGroups(A)
    },
    friction: (e, A) => {
      e.setFriction(A)
    },
    frictionCombineRule: (e, A) => {
      e.setFrictionCombineRule(A)
    },
    restitution: (e, A) => {
      e.setRestitution(A)
    },
    restitutionCombineRule: (e, A) => {
      e.setRestitutionCombineRule(A)
    },
    activeCollisionTypes: (e, A) => {
      e.setActiveCollisionTypes(A)
    },
    contactSkin: (e, A) => {
      e.setContactSkin(A)
    },
    // To make sure the options all mutable options are listed
    quaternion: () => {},
    position: () => {},
    rotation: () => {},
    scale: () => {},
  },
  LO = Object.keys(vO),
  X6 = (e, A, I) => {
    const g = I.get(e.handle)
    if (g) {
      var C
      const i = g.object.parent.getWorldScale(v6),
        B = (C = g.worldParent) === null || C === void 0 ? void 0 : C.matrixWorld.clone().invert()
      ;(g.object.updateWorldMatrix(!0, !1),
        GD.copy(g.object.matrixWorld),
        B && GD.premultiply(B),
        GD.decompose(mn, Ml, Zf),
        e.parent()
          ? (e.setTranslationWrtParent({
              x: mn.x * i.x,
              y: mn.y * i.y,
              z: mn.z * i.z,
            }),
            e.setRotationWrtParent(Ml))
          : (e.setTranslation({
              x: mn.x * i.x,
              y: mn.y * i.y,
              z: mn.z * i.z,
            }),
            e.setRotation(Ml)),
        LO.forEach((o) => {
          if (o in A) {
            const r = A[o]
            vO[o](
              e,
              // @ts-ignore Option does not want to fit into the function, but it will
              r,
              A,
            )
          }
        }),
        z6(e, A))
    }
  },
  $6 = (e, A, I) => {
    const g = xI.useMemo(() => LO.flatMap((C) => mO(A[C])), [A])
    xI.useEffect(() => {
      const C = e()
      X6(C, A, I)
    }, [...g, e])
  },
  A7 = (e) => {
    let A = !1
    return (
      e.traverseAncestors((I) => {
        I.userData.r3RapierType === "MeshCollider" && (A = !0)
      }),
      A
    )
  },
  I7 = (e, A, I) => ({
    collider: e,
    worldParent: I || void 0,
    object: A,
  }),
  g7 = {
    cuboid: "cuboid",
    ball: "ball",
    hull: "convexHull",
    trimesh: "trimesh",
  },
  C7 = ({ object: e, ignoreMeshColliders: A = !0, options: I }) => {
    const g = []
    e.updateWorldMatrix(!0, !1)
    const C = e.matrixWorld.clone().invert(),
      i = (B) => {
        if ("isMesh" in B) {
          if (A && A7(B)) return
          const o = B.getWorldScale(Zf),
            r = g7[I.colliders || "cuboid"]
          ;(B.updateWorldMatrix(!0, !1),
            GD.copy(B.matrixWorld).premultiply(C).decompose(mn, Ml, Zf))
          const s = new uE().setFromQuaternion(Ml, "XYZ"),
            { geometry: h } = B,
            { args: S, offset: d } = e7(h, I.colliders || "cuboid"),
            w = ji(
              ji({}, qO(I)),
              {},
              {
                args: S,
                shape: r,
                rotation: [s.x, s.y, s.z],
                position: [mn.x + d.x * o.x, mn.y + d.y * o.y, mn.z + d.z * o.z],
                scale: [o.x, o.y, o.z],
              },
            )
          g.push(w)
        }
      }
    return (I.includeInvisible ? e.traverse(i) : e.traverseVisible(i), g)
  },
  e7 = (e, A) => {
    switch (A) {
      case "cuboid": {
        e.computeBoundingBox()
        const { boundingBox: g } = e,
          C = g.getSize(new wA())
        return {
          args: [C.x / 2, C.y / 2, C.z / 2],
          offset: g.getCenter(new wA()),
        }
      }
      case "ball": {
        e.computeBoundingSphere()
        const { boundingSphere: g } = e
        return {
          args: [g.radius],
          offset: g.center,
        }
      }
      case "trimesh": {
        var I
        const g = e.index ? e.clone() : SX(e)
        return {
          args: [
            g.attributes.position.array,
            (I = g.index) === null || I === void 0 ? void 0 : I.array,
          ],
          offset: new wA(),
        }
      }
      case "hull":
        return {
          args: [e.clone().attributes.position.array],
          offset: new wA(),
        }
    }
    return {
      args: [],
      offset: new wA(),
    }
  },
  YO = (e) => ({
    collision: !!(
      (e != null && e.onCollisionEnter) ||
      (e != null && e.onCollisionExit) ||
      (e != null && e.onIntersectionEnter) ||
      (e != null && e.onIntersectionExit)
    ),
    contactForce: !!(e != null && e.onContactForce),
  }),
  i7 = (e, A, I, g = {}) => {
    const {
      onCollisionEnter: C,
      onCollisionExit: i,
      onIntersectionEnter: B,
      onIntersectionExit: o,
      onContactForce: r,
    } = A
    xI.useEffect(() => {
      const s = e()
      if (s) {
        const { collision: h, contactForce: S } = YO(A),
          d = h || g.collision,
          w = S || g.contactForce
        ;(d && w
          ? s.setActiveEvents(Cu.COLLISION_EVENTS | Cu.CONTACT_FORCE_EVENTS)
          : d
            ? s.setActiveEvents(Cu.COLLISION_EVENTS)
            : w && s.setActiveEvents(Cu.CONTACT_FORCE_EVENTS),
          I.set(s.handle, {
            onCollisionEnter: C,
            onCollisionExit: i,
            onIntersectionEnter: B,
            onIntersectionExit: o,
            onContactForce: r,
          }))
      }
      return () => {
        s && I.delete(s.handle)
      }
    }, [C, i, B, o, r, g])
  },
  qO = (e = {}) => fL(e, P6),
  VF = () => {
    const e = xI.useContext(HO)
    if (!e) throw new Error("react-three-rapier: useRapier must be used within <Physics />!")
    return e
  },
  dL = (e, A, I = !0) => {
    const [g, C] = xI.useState([])
    return (
      xI.useEffect(() => {
        e.current &&
          A.colliders !== !1 &&
          C(
            C7({
              object: e.current,
              options: A,
              ignoreMeshColliders: I,
            }),
          )
      }, [A.colliders]),
      g
    )
  },
  t7 = /* @__PURE__ */ xI.memo(() => {
    const { world: e } = VF(),
      A = xI.useRef(null)
    return (
      Mp(() => {
        const I = A.current
        if (!I) return
        const g = e.debugRender()
        ;(I.geometry.setAttribute("position", new Ye(g.vertices, 3)),
          I.geometry.setAttribute("color", new Ye(g.colors, 4)))
      }),
      /* @__PURE__ */ HC.createElement(
        "group",
        null,
        /* @__PURE__ */ HC.createElement(
          "lineSegments",
          {
            ref: A,
            frustumCulled: !1,
          },
          /* @__PURE__ */ HC.createElement("lineBasicMaterial", {
            color: 16777215,
            vertexColors: !0,
          }),
          /* @__PURE__ */ HC.createElement("bufferGeometry", null),
        ),
      )
    )
  }),
  B7 = (e) => {
    let A
    const I = {
      get(B, o) {
        return (A || (A = e()), Reflect.get(A, o))
      },
      set(B, o, r) {
        return (A || (A = e()), Reflect.set(A, o, r))
      },
    }
    return {
      proxy: new Proxy({}, I),
      reset: () => {
        A = void 0
      },
      set: (B) => {
        A = B
      },
    }
  },
  HO = /* @__PURE__ */ xI.createContext(void 0),
  KU = (e, A) => {
    var I, g, C, i, B, o
    return {
      target: {
        rigidBody: e.rigidBody.object,
        collider: e.collider.object,
        colliderObject: (I = e.collider.state) === null || I === void 0 ? void 0 : I.object,
        rigidBodyObject: (g = e.rigidBody.state) === null || g === void 0 ? void 0 : g.object,
      },
      other: {
        rigidBody: A.rigidBody.object,
        collider: A.collider.object,
        colliderObject: (C = A.collider.state) === null || C === void 0 ? void 0 : C.object,
        rigidBodyObject: (i = A.rigidBody.state) === null || i === void 0 ? void 0 : i.object,
      },
      rigidBody: A.rigidBody.object,
      collider: A.collider.object,
      colliderObject: (B = A.collider.state) === null || B === void 0 ? void 0 : B.object,
      rigidBodyObject: (o = A.rigidBody.state) === null || o === void 0 ? void 0 : o.object,
    }
  },
  Tx = async () => {
    let e = await Promise.resolve().then(() => F6)
    return (await e.init(), e)
  },
  Q7 = (e) => {
    const {
        colliders: A = "cuboid",
        children: I,
        timeStep: g = 1 / 60,
        paused: C = !1,
        interpolate: i = !0,
        updatePriority: B,
        updateLoop: o = "follow",
        debug: r = !1,
        gravity: s = [0, -9.81, 0],
        allowedLinearError: h = 1e-3,
        predictionDistance: S = 2e-3,
        numSolverIterations: d = 4,
        numAdditionalFrictionIterations: w = 4,
        numInternalPgsIterations: M = 1,
        minIslandSize: K = 128,
        maxCcdSubsteps: R = 1,
        contactNaturalFrequency: F = 30,
        lengthUnit: L = 1,
      } = e,
      Y = pF(Tx, ["@react-thee/rapier", Tx]),
      { invalidate: H } = Ya(),
      V = DD(() => /* @__PURE__ */ new Map()),
      j = DD(() => /* @__PURE__ */ new Map()),
      P = DD(() => /* @__PURE__ */ new Map()),
      AA = DD(() => /* @__PURE__ */ new Map()),
      X = DD(() => new DL(!1)),
      _ = DD(() => /* @__PURE__ */ new Set()),
      eA = DD(() => /* @__PURE__ */ new Set()),
      { proxy: CA, reset: aA, set: lA } = DD(() => B7(() => new Y.World(L6(s))))
    ;(xI.useEffect(
      () => () => {
        ;(CA.free(), aA())
      },
      [],
    ),
      xI.useEffect(() => {
        ;((CA.gravity = Y6(s)),
          (CA.integrationParameters.numSolverIterations = d),
          (CA.integrationParameters.numAdditionalFrictionIterations = w),
          (CA.integrationParameters.numInternalPgsIterations = M),
          (CA.integrationParameters.normalizedAllowedLinearError = h),
          (CA.integrationParameters.minIslandSize = K),
          (CA.integrationParameters.maxCcdSubsteps = R),
          (CA.integrationParameters.normalizedPredictionDistance = S),
          (CA.lengthUnit = L),
          (CA.integrationParameters.contact_natural_frequency = F))
      }, [CA, ...s, d, w, M, h, K, R, S, L, F]))
    const JA = xI.useCallback((sA) => {
        var $
        const EA = CA.getCollider(sA),
          GA = AA.get(sA),
          DA = j.get(sA),
          dA = EA == null || ($ = EA.parent()) === null || $ === void 0 ? void 0 : $.handle,
          kA = dA !== void 0 ? CA.getRigidBody(dA) : void 0,
          NA = kA && dA !== void 0 ? P.get(dA) : void 0,
          qA = dA !== void 0 ? V.get(dA) : void 0
        return {
          collider: {
            object: EA,
            events: GA,
            state: DA,
          },
          rigidBody: {
            object: kA,
            events: NA,
            state: qA,
          },
        }
      }, []),
      [yA] = xI.useState({
        previousState: {},
        accumulator: 0,
      }),
      LA = xI.useCallback(
        (sA) => {
          const $ = CA,
            EA = g === "vary",
            GA = XN.clamp(sA, 0, 0.5),
            DA = (kA) => {
              ;(_.forEach((NA) => {
                NA.current($)
              }),
                ($.timestep = kA),
                $.step(X),
                eA.forEach((NA) => {
                  NA.current($)
                }))
            }
          if (EA) DA(GA)
          else
            for (yA.accumulator += GA; yA.accumulator >= g; )
              (i &&
                ((yA.previousState = {}),
                $.forEachRigidBody((kA) => {
                  yA.previousState[kA.handle] = {
                    position: kA.translation(),
                    rotation: kA.rotation(),
                  }
                })),
                DA(g),
                (yA.accumulator -= g))
          const dA = EA || !i || C ? 1 : yA.accumulator / g
          ;(V.forEach((kA, NA) => {
            const qA = $.getRigidBody(NA),
              ZA = P.get(NA)
            if ((ZA != null && ZA.onSleep) || (ZA != null && ZA.onWake)) {
              if (qA.isSleeping() && !kA.isSleeping) {
                var sI
                ZA == null || (sI = ZA.onSleep) === null || sI === void 0 || sI.call(ZA)
              }
              if (!qA.isSleeping() && kA.isSleeping) {
                var cI
                ZA == null || (cI = ZA.onWake) === null || cI === void 0 || cI.call(ZA)
              }
              kA.isSleeping = qA.isSleeping()
            }
            if (!qA || (qA.isSleeping() && !("isInstancedMesh" in kA.object)) || !kA.setMatrix)
              return
            let YA = qA.translation(),
              eI = qA.rotation(),
              uA = yA.previousState[NA]
            ;(uA &&
              (GD.compose(uA.position, qx(uA.rotation), kA.scale)
                .premultiply(kA.invertedWorldMatrix)
                .decompose(mn, Ml, Zf),
              kA.meshType == "mesh" &&
                (kA.object.position.copy(mn), kA.object.quaternion.copy(Ml))),
              GD.compose(YA, qx(eI), kA.scale)
                .premultiply(kA.invertedWorldMatrix)
                .decompose(mn, Ml, Zf),
              kA.meshType == "instancedMesh"
                ? kA.setMatrix(GD)
                : (kA.object.position.lerp(mn, dA), kA.object.quaternion.slerp(Ml, dA)))
          }),
            X.drainCollisionEvents((kA, NA, qA) => {
              const ZA = JA(kA),
                sI = JA(NA)
              if (!(ZA != null && ZA.collider.object) || !(sI != null && sI.collider.object)) return
              const cI = KU(ZA, sI),
                YA = KU(sI, ZA)
              if (qA)
                $.contactPair(ZA.collider.object, sI.collider.object, (XI, $I) => {
                  var SA, NI, HA, iI, zI, qI, dg, $g
                  ;((SA = ZA.rigidBody.events) === null ||
                    SA === void 0 ||
                    (NI = SA.onCollisionEnter) === null ||
                    NI === void 0 ||
                    NI.call(
                      SA,
                      ji(
                        ji({}, cI),
                        {},
                        {
                          manifold: XI,
                          flipped: $I,
                        },
                      ),
                    ),
                    (HA = sI.rigidBody.events) === null ||
                      HA === void 0 ||
                      (iI = HA.onCollisionEnter) === null ||
                      iI === void 0 ||
                      iI.call(
                        HA,
                        ji(
                          ji({}, YA),
                          {},
                          {
                            manifold: XI,
                            flipped: $I,
                          },
                        ),
                      ),
                    (zI = ZA.collider.events) === null ||
                      zI === void 0 ||
                      (qI = zI.onCollisionEnter) === null ||
                      qI === void 0 ||
                      qI.call(
                        zI,
                        ji(
                          ji({}, cI),
                          {},
                          {
                            manifold: XI,
                            flipped: $I,
                          },
                        ),
                      ),
                    (dg = sI.collider.events) === null ||
                      dg === void 0 ||
                      ($g = dg.onCollisionEnter) === null ||
                      $g === void 0 ||
                      $g.call(
                        dg,
                        ji(
                          ji({}, YA),
                          {},
                          {
                            manifold: XI,
                            flipped: $I,
                          },
                        ),
                      ))
                })
              else {
                var eI, uA, hI, II, pI, AI, YI, SI
                ;((eI = ZA.rigidBody.events) === null ||
                  eI === void 0 ||
                  (uA = eI.onCollisionExit) === null ||
                  uA === void 0 ||
                  uA.call(eI, cI),
                  (hI = sI.rigidBody.events) === null ||
                    hI === void 0 ||
                    (II = hI.onCollisionExit) === null ||
                    II === void 0 ||
                    II.call(hI, YA),
                  (pI = ZA.collider.events) === null ||
                    pI === void 0 ||
                    (AI = pI.onCollisionExit) === null ||
                    AI === void 0 ||
                    AI.call(pI, cI),
                  (YI = sI.collider.events) === null ||
                    YI === void 0 ||
                    (SI = YI.onCollisionExit) === null ||
                    SI === void 0 ||
                    SI.call(YI, YA))
              }
              if (qA) {
                if ($.intersectionPair(ZA.collider.object, sI.collider.object)) {
                  var QA, tA, FA, WA, jA, nI, UI, GI
                  ;((QA = ZA.rigidBody.events) === null ||
                    QA === void 0 ||
                    (tA = QA.onIntersectionEnter) === null ||
                    tA === void 0 ||
                    tA.call(QA, cI),
                    (FA = sI.rigidBody.events) === null ||
                      FA === void 0 ||
                      (WA = FA.onIntersectionEnter) === null ||
                      WA === void 0 ||
                      WA.call(FA, YA),
                    (jA = ZA.collider.events) === null ||
                      jA === void 0 ||
                      (nI = jA.onIntersectionEnter) === null ||
                      nI === void 0 ||
                      nI.call(jA, cI),
                    (UI = sI.collider.events) === null ||
                      UI === void 0 ||
                      (GI = UI.onIntersectionEnter) === null ||
                      GI === void 0 ||
                      GI.call(UI, YA))
                }
              } else {
                var LI, Bg, MA, OA, aI, RI, VA, ag
                ;((LI = ZA.rigidBody.events) === null ||
                  LI === void 0 ||
                  (Bg = LI.onIntersectionExit) === null ||
                  Bg === void 0 ||
                  Bg.call(LI, cI),
                  (MA = sI.rigidBody.events) === null ||
                    MA === void 0 ||
                    (OA = MA.onIntersectionExit) === null ||
                    OA === void 0 ||
                    OA.call(MA, YA),
                  (aI = ZA.collider.events) === null ||
                    aI === void 0 ||
                    (RI = aI.onIntersectionExit) === null ||
                    RI === void 0 ||
                    RI.call(aI, cI),
                  (VA = sI.collider.events) === null ||
                    VA === void 0 ||
                    (ag = VA.onIntersectionExit) === null ||
                    ag === void 0 ||
                    ag.call(VA, YA))
              }
            }),
            X.drainContactForceEvents((kA) => {
              var NA, qA, ZA, sI, cI, YA, eI, uA
              const hI = JA(kA.collider1()),
                II = JA(kA.collider2())
              if (!(hI != null && hI.collider.object) || !(II != null && II.collider.object)) return
              const pI = KU(hI, II),
                AI = KU(II, hI)
              ;((NA = hI.rigidBody.events) === null ||
                NA === void 0 ||
                (qA = NA.onContactForce) === null ||
                qA === void 0 ||
                qA.call(
                  NA,
                  ji(
                    ji({}, pI),
                    {},
                    {
                      totalForce: kA.totalForce(),
                      totalForceMagnitude: kA.totalForceMagnitude(),
                      maxForceDirection: kA.maxForceDirection(),
                      maxForceMagnitude: kA.maxForceMagnitude(),
                    },
                  ),
                ),
                (ZA = II.rigidBody.events) === null ||
                  ZA === void 0 ||
                  (sI = ZA.onContactForce) === null ||
                  sI === void 0 ||
                  sI.call(
                    ZA,
                    ji(
                      ji({}, AI),
                      {},
                      {
                        totalForce: kA.totalForce(),
                        totalForceMagnitude: kA.totalForceMagnitude(),
                        maxForceDirection: kA.maxForceDirection(),
                        maxForceMagnitude: kA.maxForceMagnitude(),
                      },
                    ),
                  ),
                (cI = hI.collider.events) === null ||
                  cI === void 0 ||
                  (YA = cI.onContactForce) === null ||
                  YA === void 0 ||
                  YA.call(
                    cI,
                    ji(
                      ji({}, pI),
                      {},
                      {
                        totalForce: kA.totalForce(),
                        totalForceMagnitude: kA.totalForceMagnitude(),
                        maxForceDirection: kA.maxForceDirection(),
                        maxForceMagnitude: kA.maxForceMagnitude(),
                      },
                    ),
                  ),
                (eI = II.collider.events) === null ||
                  eI === void 0 ||
                  (uA = eI.onContactForce) === null ||
                  uA === void 0 ||
                  uA.call(
                    eI,
                    ji(
                      ji({}, AI),
                      {},
                      {
                        totalForce: kA.totalForce(),
                        totalForceMagnitude: kA.totalForceMagnitude(),
                        maxForceDirection: kA.maxForceDirection(),
                        maxForceMagnitude: kA.maxForceMagnitude(),
                      },
                    ),
                  ))
            }),
            $.forEachActiveRigidBody(() => {
              H()
            }))
        },
        [C, g, i, CA],
      ),
      nA = xI.useMemo(
        () => ({
          rapier: Y,
          world: CA,
          setWorld: (sA) => {
            lA(sA)
          },
          physicsOptions: {
            colliders: A,
            gravity: s,
          },
          rigidBodyStates: V,
          colliderStates: j,
          rigidBodyEvents: P,
          colliderEvents: AA,
          beforeStepCallbacks: _,
          afterStepCallbacks: eA,
          isPaused: C,
          isDebug: r,
          step: LA,
        }),
        [C, LA, r, A, s],
      ),
      fA = xI.useCallback(
        (sA) => {
          C || LA(sA)
        },
        [C, LA],
      )
    return /* @__PURE__ */ HC.createElement(
      HO.Provider,
      {
        value: nA,
      },
      /* @__PURE__ */ HC.createElement(_6, {
        onStep: fA,
        type: o,
        updatePriority: B,
      }),
      r && /* @__PURE__ */ HC.createElement(t7, null),
      I,
    )
  }
function zo() {
  return (
    (zo = Object.assign
      ? Object.assign.bind()
      : function (e) {
          for (var A = 1; A < arguments.length; A++) {
            var I = arguments[A]
            for (var g in I) ({}).hasOwnProperty.call(I, g) && (e[g] = I[g])
          }
          return e
        }),
    zo.apply(null, arguments)
  )
}
const TO = (e, A, I) => {
    const g = xI.useRef(),
      C = xI.useCallback(() => (g.current || (g.current = e()), g.current), I)
    return (
      xI.useEffect(() => {
        const i = C(),
          B = () => A(i)
        return () => {
          ;(B(), (g.current = void 0))
        }
      }, [C]),
      C
    )
  },
  o7 = (
    { x: e, y: A, z: I } = {
      x: 0,
      y: 0,
      z: 0,
    },
  ) => new wA(e, A, I),
  yL = (e, A = null) => {
    const I = xI.useRef(A)
    return e && typeof e != "function" ? (e.current || (e.current = I.current), e) : I
  },
  Tr = /* @__PURE__ */ xI.memo(
    /* @__PURE__ */ xI.forwardRef((e, A) => {
      const { children: I, position: g, rotation: C, quaternion: i, scale: B, name: o } = e,
        { world: r, colliderEvents: s, colliderStates: h } = VF(),
        S = ZO(),
        d = yL(A),
        w = xI.useRef(null),
        M = j6.flatMap((F) => (Array.isArray(e[F]) ? [...e[F]] : e[F])),
        K = TO(
          () => {
            const F = w.current.getWorldScale(o7()),
              L = V6(e, r, F, S?.getRigidBody)
            return (typeof A == "function" && A(L), (d.current = L), L)
          },
          (F) => {
            r.getCollider(F.handle) && r.removeCollider(F, !0)
          },
          [...M, S],
        )
      xI.useEffect(() => {
        const F = K()
        return (
          h.set(F.handle, I7(F, w.current, S?.ref.current)),
          () => {
            h.delete(F.handle)
          }
        )
      }, [K])
      const R = xI.useMemo(() => ji(ji({}, qO(S?.options)), e), [e, S?.options])
      return (
        $6(K, R, h),
        i7(K, R, s, YO(S?.options)),
        /* @__PURE__ */ HC.createElement(
          "object3D",
          {
            position: g,
            rotation: C,
            quaternion: i,
            scale: B,
            ref: w,
            name: o,
          },
          I,
        )
      )
    }),
  ),
  dD = /* @__PURE__ */ HC.forwardRef((e, A) =>
    /* @__PURE__ */ HC.createElement(
      Tr,
      zo({}, e, {
        shape: "cuboid",
        ref: A,
      }),
    ),
  )
dD.displayName = "CuboidCollider"
const n7 = /* @__PURE__ */ HC.forwardRef((e, A) =>
  /* @__PURE__ */ HC.createElement(
    Tr,
    zo({}, e, {
      shape: "roundCuboid",
      ref: A,
    }),
  ),
)
n7.displayName = "RoundCuboidCollider"
const E7 = /* @__PURE__ */ HC.forwardRef((e, A) =>
  /* @__PURE__ */ HC.createElement(
    Tr,
    zo({}, e, {
      shape: "ball",
      ref: A,
    }),
  ),
)
E7.displayName = "BallCollider"
const a7 = /* @__PURE__ */ HC.forwardRef((e, A) =>
  /* @__PURE__ */ HC.createElement(
    Tr,
    zo({}, e, {
      shape: "capsule",
      ref: A,
    }),
  ),
)
a7.displayName = "CapsuleCollider"
const r7 = /* @__PURE__ */ HC.forwardRef((e, A) =>
  /* @__PURE__ */ HC.createElement(
    Tr,
    zo({}, e, {
      shape: "heightfield",
      ref: A,
    }),
  ),
)
r7.displayName = "HeightfieldCollider"
const s7 = /* @__PURE__ */ HC.forwardRef((e, A) =>
  /* @__PURE__ */ HC.createElement(
    Tr,
    zo({}, e, {
      shape: "trimesh",
      ref: A,
    }),
  ),
)
s7.displayName = "TrimeshCollider"
const l7 = /* @__PURE__ */ HC.forwardRef((e, A) =>
  /* @__PURE__ */ HC.createElement(
    Tr,
    zo({}, e, {
      shape: "cone",
      ref: A,
    }),
  ),
)
l7.displayName = "ConeCollider"
const c7 = /* @__PURE__ */ HC.forwardRef((e, A) =>
  /* @__PURE__ */ HC.createElement(
    Tr,
    zo({}, e, {
      shape: "roundCone",
      ref: A,
    }),
  ),
)
c7.displayName = "RoundConeCollider"
const xO = /* @__PURE__ */ HC.forwardRef((e, A) =>
  /* @__PURE__ */ HC.createElement(
    Tr,
    zo({}, e, {
      shape: "cylinder",
      ref: A,
    }),
  ),
)
xO.displayName = "CylinderCollider"
xO.displayName = "RoundCylinderCollider"
const h7 = /* @__PURE__ */ HC.forwardRef((e, A) =>
  /* @__PURE__ */ HC.createElement(
    Tr,
    zo({}, e, {
      shape: "convexHull",
      ref: A,
    }),
  ),
)
h7.displayName = "ConvexHullCollider"
const u7 = (e) => {
    var A
    const I = KO(e?.type || "dynamic"),
      g = new Gs(I)
    return ((g.canSleep = (A = e?.canSleep) !== null && A !== void 0 ? A : !0), g)
  },
  D7 = ({
    rigidBody: e,
    object: A,
    setMatrix: I,
    getMatrix: g,
    worldScale: C,
    meshType: i = "mesh",
  }) => {
    A.updateWorldMatrix(!0, !1)
    const B = A.parent.matrixWorld.clone().invert()
    return {
      object: A,
      rigidBody: e,
      invertedWorldMatrix: B,
      setMatrix:
        I ||
        ((o) => {
          A.matrix.copy(o)
        }),
      getMatrix: g || ((o) => o.copy(A.matrix)),
      scale: C || A.getWorldScale(Zf).clone(),
      isSleeping: !1,
      meshType: i,
    }
  },
  S7 = ["args", "colliders", "canSleep"],
  bO = {
    gravityScale: (e, A) => {
      e.setGravityScale(A, !0)
    },
    additionalSolverIterations(e, A) {
      e.setAdditionalSolverIterations(A)
    },
    linearDamping: (e, A) => {
      e.setLinearDamping(A)
    },
    angularDamping: (e, A) => {
      e.setAngularDamping(A)
    },
    dominanceGroup: (e, A) => {
      e.setDominanceGroup(A)
    },
    enabledRotations: (e, [A, I, g]) => {
      e.setEnabledRotations(A, I, g, !0)
    },
    enabledTranslations: (e, [A, I, g]) => {
      e.setEnabledTranslations(A, I, g, !0)
    },
    lockRotations: (e, A) => {
      e.lockRotations(A, !0)
    },
    lockTranslations: (e, A) => {
      e.lockTranslations(A, !0)
    },
    angularVelocity: (e, [A, I, g]) => {
      e.setAngvel(
        {
          x: A,
          y: I,
          z: g,
        },
        !0,
      )
    },
    linearVelocity: (e, [A, I, g]) => {
      e.setLinvel(
        {
          x: A,
          y: I,
          z: g,
        },
        !0,
      )
    },
    ccd: (e, A) => {
      e.enableCcd(A)
    },
    softCcdPrediction: (e, A) => {
      e.setSoftCcdPrediction(A)
    },
    userData: (e, A) => {
      e.userData = A
    },
    type(e, A) {
      e.setBodyType(KO(A), !0)
    },
    position: () => {},
    rotation: () => {},
    quaternion: () => {},
    scale: () => {},
  },
  OO = Object.keys(bO),
  f7 = (e, A, I, g = !0) => {
    if (!e) return
    const C = I.get(e.handle)
    C &&
      (g &&
        (C.object.updateWorldMatrix(!0, !1),
        GD.copy(C.object.matrixWorld).decompose(mn, Ml, Zf),
        e.setTranslation(mn, !1),
        e.setRotation(Ml, !1)),
      OO.forEach((i) => {
        i in A && bO[i](e, A[i])
      }))
  },
  d7 = (e, A, I, g = !0) => {
    const C = xI.useMemo(() => OO.flatMap((i) => mO(A[i])), [A])
    xI.useEffect(() => {
      const i = e()
      f7(i, A, I, g)
    }, C)
  },
  y7 = (e, A, I) => {
    const {
        onWake: g,
        onSleep: C,
        onCollisionEnter: i,
        onCollisionExit: B,
        onIntersectionEnter: o,
        onIntersectionExit: r,
        onContactForce: s,
      } = A,
      h = {
        onWake: g,
        onSleep: C,
        onCollisionEnter: i,
        onCollisionExit: B,
        onIntersectionEnter: o,
        onIntersectionExit: r,
        onContactForce: s,
      }
    xI.useEffect(() => {
      const S = e()
      return (
        I.set(S.handle, h),
        () => {
          I.delete(S.handle)
        }
      )
    }, [g, C, i, B, o, r, s])
  },
  p7 = ["children", "type", "position", "rotation", "scale", "quaternion", "transformState"],
  _O = /* @__PURE__ */ xI.createContext(void 0),
  ZO = () => xI.useContext(_O),
  OG = /* @__PURE__ */ xI.memo(
    /* @__PURE__ */ xI.forwardRef((e, A) => {
      const {
          children: I,
          type: g,
          position: C,
          rotation: i,
          scale: B,
          quaternion: o,
          transformState: r,
        } = e,
        s = fL(e, p7),
        h = xI.useRef(null),
        S = yL(A),
        { world: d, rigidBodyStates: w, physicsOptions: M, rigidBodyEvents: K } = VF(),
        R = xI.useMemo(
          () =>
            ji(
              ji(ji({}, M), e),
              {},
              {
                children: void 0,
              },
            ),
          [M, e],
        ),
        F = S7.flatMap((V) => (Array.isArray(R[V]) ? [...R[V]] : R[V])),
        L = dL(h, R),
        Y = TO(
          () => {
            const V = u7(R),
              j = d.createRigidBody(V)
            return (typeof A == "function" && A(j), (S.current = j), j)
          },
          (V) => {
            d.getRigidBody(V.handle) && d.removeRigidBody(V)
          },
          F,
        )
      ;(xI.useEffect(() => {
        const V = Y(),
          j = D7({
            rigidBody: V,
            object: h.current,
          })
        return (
          w.set(V.handle, e.transformState ? e.transformState(j) : j),
          () => {
            w.delete(V.handle)
          }
        )
      }, [Y]),
        d7(Y, R, w),
        y7(Y, R, K))
      const H = xI.useMemo(
        () => ({
          ref: h,
          getRigidBody: Y,
          options: R,
        }),
        [Y],
      )
      return /* @__PURE__ */ HC.createElement(
        _O.Provider,
        {
          value: H,
        },
        /* @__PURE__ */ HC.createElement(
          "object3D",
          zo(
            {
              ref: h,
            },
            s,
            {
              position: C,
              rotation: i,
              quaternion: o,
              scale: B,
            },
          ),
          I,
          L.map((V, j) =>
            /* @__PURE__ */ HC.createElement(
              Tr,
              zo(
                {
                  key: j,
                },
                V,
              ),
            ),
          ),
        ),
      )
    }),
  )
OG.displayName = "RigidBody"
const w7 = /* @__PURE__ */ xI.memo((e) => {
  const { children: A, type: I } = e,
    { physicsOptions: g } = VF(),
    C = xI.useRef(null),
    { options: i } = ZO(),
    B = xI.useMemo(
      () =>
        ji(
          ji(ji({}, g), i),
          {},
          {
            children: void 0,
            colliders: I,
          },
        ),
      [g, i],
    ),
    o = dL(C, B, !1)
  return /* @__PURE__ */ HC.createElement(
    "object3D",
    {
      ref: C,
      userData: {
        r3RapierType: "MeshCollider",
      },
    },
    A,
    o.map((r, s) =>
      /* @__PURE__ */ HC.createElement(
        Tr,
        zo(
          {
            key: s,
          },
          r,
        ),
      ),
    ),
  )
})
w7.displayName = "MeshCollider"
const G7 = [
    "children",
    "instances",
    "colliderNodes",
    "position",
    "rotation",
    "quaternion",
    "scale",
  ],
  k7 = /* @__PURE__ */ xI.memo(
    /* @__PURE__ */ xI.forwardRef((e, A) => {
      const I = yL(A, []),
        g = xI.useRef(null),
        C = xI.useRef(null),
        {
          // instanced props
          children: i,
          instances: B,
          colliderNodes: o = [],
          // wrapper object props
          position: r,
          rotation: s,
          quaternion: h,
          scale: S,
          // rigid body specific props, and r3f-object props
        } = e,
        d = fL(e, G7),
        w = dL(
          g,
          ji(
            ji({}, e),
            {},
            {
              children: void 0,
            },
          ),
        ),
        M = () => {
          const R = C.current.children[0]
          if (R && "isInstancedMesh" in R) return R
        }
      xI.useEffect(() => {
        const R = M()
        R
          ? R.instanceMatrix.setUsage(H2)
          : console.warn(
              "InstancedRigidBodies expects exactly one child, which must be an InstancedMesh",
            )
      }, [])
      const K = (R, F) => {
        const L = M()
        return L
          ? ji(
              ji({}, R),
              {},
              {
                getMatrix: (Y) => (L.getMatrixAt(F, Y), Y),
                setMatrix: (Y) => {
                  ;(L.setMatrixAt(F, Y), (L.instanceMatrix.needsUpdate = !0))
                },
                meshType: "instancedMesh",
              },
            )
          : R
      }
      return /* @__PURE__ */ HC.createElement(
        "object3D",
        zo(
          {
            ref: g,
          },
          d,
          {
            position: r,
            rotation: s,
            quaternion: h,
            scale: S,
          },
        ),
        /* @__PURE__ */ HC.createElement(
          "object3D",
          {
            ref: C,
          },
          i,
        ),
        B?.map((R, F) =>
          /* @__PURE__ */ HC.createElement(
            OG,
            zo({}, d, R, {
              ref: (L) => (I.current[F] = L),
              transformState: (L) => K(L, F),
            }),
            /* @__PURE__ */ HC.createElement(
              HC.Fragment,
              null,
              o.map((L, Y) =>
                /* @__PURE__ */ HC.createElement(
                  xI.Fragment,
                  {
                    key: Y,
                  },
                  L,
                ),
              ),
              w.map((L, Y) =>
                /* @__PURE__ */ HC.createElement(
                  Tr,
                  zo(
                    {
                      key: Y,
                    },
                    L,
                  ),
                ),
              ),
            ),
          ),
        ),
      )
    }),
  )
k7.displayName = "InstancedRigidBodies"
/**
 * postprocessing v6.36.4 build Tue Nov 05 2024
 * https://github.com/pmndrs/postprocessing
 * Copyright 2015-2024 Raoul van Rüschen
 * @license Zlib
 */
var Bm = 1 / 1e3,
  M7 = 1e3,
  U7 = class {
    /**
     * Constructs a new timer.
     */
    constructor() {
      ;((this.startTime = performance.now()),
        (this.previousTime = 0),
        (this.currentTime = 0),
        (this._delta = 0),
        (this._elapsed = 0),
        (this._fixedDelta = 1e3 / 60),
        (this.timescale = 1),
        (this.useFixedDelta = !1),
        (this._autoReset = !1))
    }
    /**
     * Enables or disables auto reset based on page visibility.
     *
     * If enabled, the timer will be reset when the page becomes visible. This effectively pauses the timer when the page
     * is hidden. Has no effect if the API is not supported.
     *
     * @type {Boolean}
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
     */
    get autoReset() {
      return this._autoReset
    }
    set autoReset(e) {
      typeof document < "u" &&
        document.hidden !== void 0 &&
        (e
          ? document.addEventListener("visibilitychange", this)
          : document.removeEventListener("visibilitychange", this),
        (this._autoReset = e))
    }
    get delta() {
      return this._delta * Bm
    }
    get fixedDelta() {
      return this._fixedDelta * Bm
    }
    set fixedDelta(e) {
      this._fixedDelta = e * M7
    }
    get elapsed() {
      return this._elapsed * Bm
    }
    /**
     * Updates this timer.
     *
     * @param {Boolean} [timestamp] - The current time in milliseconds.
     */
    update(e) {
      ;(this.useFixedDelta
        ? (this._delta = this.fixedDelta)
        : ((this.previousTime = this.currentTime),
          (this.currentTime = (e !== void 0 ? e : performance.now()) - this.startTime),
          (this._delta = this.currentTime - this.previousTime)),
        (this._delta *= this.timescale),
        (this._elapsed += this._delta))
    }
    /**
     * Resets this timer.
     */
    reset() {
      ;((this._delta = 0),
        (this._elapsed = 0),
        (this.currentTime = performance.now() - this.startTime))
    }
    getDelta() {
      return this.delta
    }
    getElapsed() {
      return this.elapsed
    }
    handleEvent(e) {
      document.hidden || (this.currentTime = performance.now() - this.startTime)
    }
    dispose() {
      this.autoReset = !1
    }
  },
  N7 = /* @__PURE__ */ (() => {
    const e = new Float32Array([-1, -1, 0, 3, -1, 0, -1, 3, 0]),
      A = new Float32Array([0, 0, 2, 0, 0, 2]),
      I = new se()
    return (I.setAttribute("position", new Ye(e, 3)), I.setAttribute("uv", new Ye(A, 2)), I)
  })(),
  qa = class vm {
    /**
     * A shared fullscreen triangle.
     *
     * The screen size is 2x2 units (NDC). A triangle needs to be 4x4 units to fill the screen.
     * @see https://michaldrobot.com/2014/04/01/gcn-execution-patterns-in-full-screen-passes/
     * @type {BufferGeometry}
     * @internal
     */
    static get fullscreenGeometry() {
      return N7
    }
    /**
     * Constructs a new pass.
     *
     * @param {String} [name] - The name of this pass. Does not have to be unique.
     * @param {Scene} [scene] - The scene to render. The default scene contains a single mesh that fills the screen.
     * @param {Camera} [camera] - A camera. Fullscreen effect passes don't require a camera.
     */
    constructor(A = "Pass", I = new sp(), g = new dp()) {
      ;((this.name = A),
        (this.renderer = null),
        (this.scene = I),
        (this.camera = g),
        (this.screen = null),
        (this.rtt = !0),
        (this.needsSwap = !0),
        (this.needsDepthTexture = !1),
        (this.enabled = !0))
    }
    /**
     * Sets the render to screen flag.
     *
     * If this flag is changed, the fullscreen material will be updated as well.
     *
     * @type {Boolean}
     */
    get renderToScreen() {
      return !this.rtt
    }
    set renderToScreen(A) {
      if (this.rtt === A) {
        const I = this.fullscreenMaterial
        ;(I !== null && (I.needsUpdate = !0), (this.rtt = !A))
      }
    }
    /**
     * Sets the main scene.
     *
     * @type {Scene}
     */
    set mainScene(A) {}
    /**
     * Sets the main camera.
     *
     * @type {Camera}
     */
    set mainCamera(A) {}
    /**
     * Sets the renderer
     *
     * @deprecated
     * @param {WebGLRenderer} renderer - The renderer.
     */
    setRenderer(A) {
      this.renderer = A
    }
    /**
     * Indicates whether this pass is enabled.
     *
     * @deprecated Use enabled instead.
     * @return {Boolean} Whether this pass is enabled.
     */
    isEnabled() {
      return this.enabled
    }
    /**
     * Enables or disables this pass.
     *
     * @deprecated Use enabled instead.
     * @param {Boolean} value - Whether the pass should be enabled.
     */
    setEnabled(A) {
      this.enabled = A
    }
    /**
     * The fullscreen material.
     *
     * @type {Material}
     */
    get fullscreenMaterial() {
      return this.screen !== null ? this.screen.material : null
    }
    set fullscreenMaterial(A) {
      let I = this.screen
      I !== null
        ? (I.material = A)
        : ((I = new EB(vm.fullscreenGeometry, A)),
          (I.frustumCulled = !1),
          this.scene === null && (this.scene = new sp()),
          this.scene.add(I),
          (this.screen = I))
    }
    /**
     * Returns the current fullscreen material.
     *
     * @deprecated Use fullscreenMaterial instead.
     * @return {Material} The current fullscreen material, or null if there is none.
     */
    getFullscreenMaterial() {
      return this.fullscreenMaterial
    }
    /**
     * Sets the fullscreen material.
     *
     * @deprecated Use fullscreenMaterial instead.
     * @protected
     * @param {Material} value - A fullscreen material.
     */
    setFullscreenMaterial(A) {
      this.fullscreenMaterial = A
    }
    /**
     * Returns the current depth texture.
     *
     * @return {Texture} The current depth texture, or null if there is none.
     */
    getDepthTexture() {
      return null
    }
    /**
     * Sets the depth texture.
     *
     * This method will be called automatically by the {@link EffectComposer}.
     * You may override this method if your pass relies on the depth information of a preceding {@link RenderPass}.
     *
     * @param {Texture} depthTexture - A depth texture.
     * @param {DepthPackingStrategy} [depthPacking=BasicDepthPacking] - The depth packing.
     */
    setDepthTexture(A, I = mD) {}
    /**
     * Renders this pass.
     *
     * This is an abstract method that must be overridden.
     *
     * @abstract
     * @throws {Error} An error is thrown if the method is not overridden.
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */
    render(A, I, g, C, i) {
      throw new Error("Render method not implemented!")
    }
    /**
     * Sets the size.
     *
     * You may override this method if you want to be informed about the size of the backbuffer/canvas.
     * This method is called before {@link initialize} and every time the size of the {@link EffectComposer} changes.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(A, I) {}
    /**
     * Performs initialization tasks.
     *
     * This method is called when this pass is added to an {@link EffectComposer}.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */
    initialize(A, I, g) {}
    /**
     * Performs a shallow search for disposable properties and deletes them.
     *
     * The {@link EffectComposer} calls this method when it is being destroyed. You can use it independently to free
     * memory when you're certain that you don't need this pass anymore.
     */
    dispose() {
      for (const A of Object.keys(this)) {
        const I = this[A]
        ;(I instanceof BQ || I instanceof tQ || I instanceof pt || I instanceof vm) &&
          this[A].dispose()
      }
      this.fullscreenMaterial !== null && this.fullscreenMaterial.dispose()
    }
  },
  F7 = class extends qa {
    /**
     * Constructs a new clear mask pass.
     */
    constructor() {
      ;(super("ClearMaskPass", null, null), (this.needsSwap = !1))
    }
    /**
     * Disables the global stencil test.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */
    render(e, A, I, g, C) {
      const i = e.state.buffers.stencil
      ;(i.setLocked(!1), i.setTest(!1))
    }
  },
  R7 = `#include <common>
#include <dithering_pars_fragment>
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform float opacity;varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);gl_FragColor=opacity*texel;
#include <colorspace_fragment>
#include <dithering_fragment>
}`,
  PO =
    "varying vec2 vUv;void main(){vUv=position.xy*0.5+0.5;gl_Position=vec4(position.xy,1.0,1.0);}",
  WO = class extends VQ {
    /**
     * Constructs a new copy material.
     */
    constructor() {
      super({
        name: "CopyMaterial",
        uniforms: {
          inputBuffer: new ki(null),
          opacity: new ki(1),
        },
        blending: hE,
        toneMapped: !1,
        depthWrite: !1,
        depthTest: !1,
        fragmentShader: R7,
        vertexShader: PO,
      })
    }
    /**
     * The input buffer.
     *
     * @type {Texture}
     */
    set inputBuffer(e) {
      this.uniforms.inputBuffer.value = e
    }
    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Number} value - The buffer.
     */
    setInputBuffer(e) {
      this.uniforms.inputBuffer.value = e
    }
    /**
     * Returns the opacity.
     *
     * @deprecated Use opacity instead.
     * @return {Number} The opacity.
     */
    getOpacity(e) {
      return this.uniforms.opacity.value
    }
    /**
     * Sets the opacity.
     *
     * @deprecated Use opacity instead.
     * @param {Number} value - The opacity.
     */
    setOpacity(e) {
      this.uniforms.opacity.value = e
    }
  },
  J7 = class extends qa {
    /**
     * Constructs a new save pass.
     *
     * @param {WebGLRenderTarget} [renderTarget] - A render target.
     * @param {Boolean} [autoResize=true] - Whether the render target size should be updated automatically.
     */
    constructor(e, A = !0) {
      ;(super("CopyPass"),
        (this.fullscreenMaterial = new WO()),
        (this.needsSwap = !1),
        (this.renderTarget = e),
        e === void 0 &&
          ((this.renderTarget = new BQ(1, 1, {
            minFilter: nt,
            magFilter: nt,
            stencilBuffer: !1,
            depthBuffer: !1,
          })),
          (this.renderTarget.texture.name = "CopyPass.Target")),
        (this.autoResize = A))
    }
    /**
     * Enables or disables auto resizing of the render target.
     *
     * @deprecated Use autoResize instead.
     * @type {Boolean}
     */
    get resize() {
      return this.autoResize
    }
    set resize(e) {
      this.autoResize = e
    }
    /**
     * The output texture.
     *
     * @type {Texture}
     */
    get texture() {
      return this.renderTarget.texture
    }
    /**
     * Returns the output texture.
     *
     * @deprecated Use texture instead.
     * @return {Texture} The texture.
     */
    getTexture() {
      return this.renderTarget.texture
    }
    /**
     * Enables or disables auto resizing of the render target.
     *
     * @deprecated Use autoResize instead.
     * @param {Boolean} value - Whether the render target size should be updated automatically.
     */
    setAutoResizeEnabled(e) {
      this.autoResize = e
    }
    /**
     * Saves the input buffer.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */
    render(e, A, I, g, C) {
      ;((this.fullscreenMaterial.inputBuffer = A.texture),
        e.setRenderTarget(this.renderToScreen ? null : this.renderTarget),
        e.render(this.scene, this.camera))
    }
    /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {
      this.autoResize && this.renderTarget.setSize(e, A)
    }
    /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - A renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */
    initialize(e, A, I) {
      I !== void 0 &&
        ((this.renderTarget.texture.type = I),
        I !== Xo
          ? (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1")
          : e !== null && e.outputColorSpace === zi && (this.renderTarget.texture.colorSpace = zi))
    }
  },
  xx = /* @__PURE__ */ new Mg(),
  VO = class extends qa {
    /**
     * Constructs a new clear pass.
     *
     * @param {Boolean} [color=true] - Determines whether the color buffer should be cleared.
     * @param {Boolean} [depth=true] - Determines whether the depth buffer should be cleared.
     * @param {Boolean} [stencil=false] - Determines whether the stencil buffer should be cleared.
     */
    constructor(e = !0, A = !0, I = !1) {
      ;(super("ClearPass", null, null),
        (this.needsSwap = !1),
        (this.color = e),
        (this.depth = A),
        (this.stencil = I),
        (this.overrideClearColor = null),
        (this.overrideClearAlpha = -1))
    }
    /**
     * Sets the clear flags.
     *
     * @param {Boolean} color - Whether the color buffer should be cleared.
     * @param {Boolean} depth - Whether the depth buffer should be cleared.
     * @param {Boolean} stencil - Whether the stencil buffer should be cleared.
     */
    setClearFlags(e, A, I) {
      ;((this.color = e), (this.depth = A), (this.stencil = I))
    }
    /**
     * Returns the override clear color. Default is null.
     *
     * @deprecated Use overrideClearColor instead.
     * @return {Color} The clear color.
     */
    getOverrideClearColor() {
      return this.overrideClearColor
    }
    /**
     * Sets the override clear color.
     *
     * @deprecated Use overrideClearColor instead.
     * @param {Color} value - The clear color.
     */
    setOverrideClearColor(e) {
      this.overrideClearColor = e
    }
    /**
     * Returns the override clear alpha. Default is -1.
     *
     * @deprecated Use overrideClearAlpha instead.
     * @return {Number} The clear alpha.
     */
    getOverrideClearAlpha() {
      return this.overrideClearAlpha
    }
    /**
     * Sets the override clear alpha.
     *
     * @deprecated Use overrideClearAlpha instead.
     * @param {Number} value - The clear alpha.
     */
    setOverrideClearAlpha(e) {
      this.overrideClearAlpha = e
    }
    /**
     * Clears the input buffer or the screen.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */
    render(e, A, I, g, C) {
      const i = this.overrideClearColor,
        B = this.overrideClearAlpha,
        o = e.getClearAlpha(),
        r = i !== null,
        s = B >= 0
      ;(r ? (e.getClearColor(xx), e.setClearColor(i, s ? B : o)) : s && e.setClearAlpha(B),
        e.setRenderTarget(this.renderToScreen ? null : A),
        e.clear(this.color, this.depth, this.stencil),
        r ? e.setClearColor(xx, o) : s && e.setClearAlpha(o))
    }
  },
  K7 = class extends qa {
    /**
     * Constructs a new mask pass.
     *
     * @param {Scene} scene - The scene to render.
     * @param {Camera} camera - The camera to use.
     */
    constructor(e, A) {
      ;(super("MaskPass", e, A),
        (this.needsSwap = !1),
        (this.clearPass = new VO(!1, !1, !0)),
        (this.inverse = !1))
    }
    set mainScene(e) {
      this.scene = e
    }
    set mainCamera(e) {
      this.camera = e
    }
    /**
     * Indicates whether the mask should be inverted.
     *
     * @type {Boolean}
     */
    get inverted() {
      return this.inverse
    }
    set inverted(e) {
      this.inverse = e
    }
    /**
     * Indicates whether this pass should clear the stencil buffer.
     *
     * @type {Boolean}
     * @deprecated Use clearPass.enabled instead.
     */
    get clear() {
      return this.clearPass.enabled
    }
    set clear(e) {
      this.clearPass.enabled = e
    }
    /**
     * Returns the internal clear pass.
     *
     * @deprecated Use clearPass.enabled instead.
     * @return {ClearPass} The clear pass.
     */
    getClearPass() {
      return this.clearPass
    }
    /**
     * Indicates whether the mask is inverted.
     *
     * @deprecated Use inverted instead.
     * @return {Boolean} Whether the mask is inverted.
     */
    isInverted() {
      return this.inverted
    }
    /**
     * Enables or disable mask inversion.
     *
     * @deprecated Use inverted instead.
     * @param {Boolean} value - Whether the mask should be inverted.
     */
    setInverted(e) {
      this.inverted = e
    }
    /**
     * Renders the effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */
    render(e, A, I, g, C) {
      const i = e.getContext(),
        B = e.state.buffers,
        o = this.scene,
        r = this.camera,
        s = this.clearPass,
        h = this.inverted ? 0 : 1,
        S = 1 - h
      ;(B.color.setMask(!1),
        B.depth.setMask(!1),
        B.color.setLocked(!0),
        B.depth.setLocked(!0),
        B.stencil.setTest(!0),
        B.stencil.setOp(i.REPLACE, i.REPLACE, i.REPLACE),
        B.stencil.setFunc(i.ALWAYS, h, 4294967295),
        B.stencil.setClear(S),
        B.stencil.setLocked(!0),
        this.clearPass.enabled &&
          (this.renderToScreen ? s.render(e, null) : (s.render(e, A), s.render(e, I))),
        this.renderToScreen
          ? (e.setRenderTarget(null), e.render(o, r))
          : (e.setRenderTarget(A), e.render(o, r), e.setRenderTarget(I), e.render(o, r)),
        B.color.setLocked(!1),
        B.depth.setLocked(!1),
        B.stencil.setLocked(!1),
        B.stencil.setFunc(i.EQUAL, 1, 4294967295),
        B.stencil.setOp(i.KEEP, i.KEEP, i.KEEP),
        B.stencil.setLocked(!0))
    }
  },
  m7 = class {
    /**
     * Constructs a new effect composer.
     *
     * @param {WebGLRenderer} renderer - The renderer that should be used.
     * @param {Object} [options] - The options.
     * @param {Boolean} [options.depthBuffer=true] - Whether the main render targets should have a depth buffer.
     * @param {Boolean} [options.stencilBuffer=false] - Whether the main render targets should have a stencil buffer.
     * @param {Boolean} [options.alpha] - Deprecated. Buffers are always RGBA since three r137.
     * @param {Number} [options.multisampling=0] - The number of samples used for multisample antialiasing. Requires WebGL 2.
     * @param {Number} [options.frameBufferType] - The type of the internal frame buffers. It's recommended to use HalfFloatType if possible.
     */
    constructor(
      A = null,
      { depthBuffer: I = !0, stencilBuffer: g = !1, multisampling: C = 0, frameBufferType: i } = {},
    ) {
      ;((this.renderer = null),
        (this.inputBuffer = this.createBuffer(I, g, i, C)),
        (this.outputBuffer = this.inputBuffer.clone()),
        (this.copyPass = new J7()),
        (this.depthTexture = null),
        (this.passes = []),
        (this.timer = new U7()),
        (this.autoRenderToScreen = !0),
        this.setRenderer(A))
    }
    /**
     * The current amount of samples used for multisample anti-aliasing.
     *
     * @type {Number}
     */
    get multisampling() {
      return this.inputBuffer.samples || 0
    }
    /**
     * Sets the amount of MSAA samples.
     *
     * Requires WebGL 2. Set to zero to disable multisampling.
     *
     * @type {Number}
     */
    set multisampling(A) {
      const I = this.inputBuffer,
        g = this.multisampling
      g > 0 && A > 0
        ? ((this.inputBuffer.samples = A),
          (this.outputBuffer.samples = A),
          this.inputBuffer.dispose(),
          this.outputBuffer.dispose())
        : g !== A &&
          (this.inputBuffer.dispose(),
          this.outputBuffer.dispose(),
          (this.inputBuffer = this.createBuffer(I.depthBuffer, I.stencilBuffer, I.texture.type, A)),
          (this.inputBuffer.depthTexture = this.depthTexture),
          (this.outputBuffer = this.inputBuffer.clone()))
    }
    /**
     * Returns the internal timer.
     *
     * @return {Timer} The timer.
     */
    getTimer() {
      return this.timer
    }
    /**
     * Returns the renderer.
     *
     * @return {WebGLRenderer} The renderer.
     */
    getRenderer() {
      return this.renderer
    }
    /**
     * Sets the renderer.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     */
    setRenderer(A) {
      if (((this.renderer = A), A !== null)) {
        const I = A.getSize(new ZI()),
          g = A.getContext().getContextAttributes().alpha,
          C = this.inputBuffer.texture.type
        ;(C === Xo &&
          A.outputColorSpace === zi &&
          ((this.inputBuffer.texture.colorSpace = zi),
          (this.outputBuffer.texture.colorSpace = zi),
          this.inputBuffer.dispose(),
          this.outputBuffer.dispose()),
          (A.autoClear = !1),
          this.setSize(I.width, I.height))
        for (const i of this.passes) i.initialize(A, g, C)
      }
    }
    /**
     * Replaces the current renderer with the given one.
     *
     * The auto clear mechanism of the provided renderer will be disabled. If the new render size differs from the
     * previous one, all passes will be updated.
     *
     * By default, the DOM element of the current renderer will automatically be removed from its parent node and the DOM
     * element of the new renderer will take its place.
     *
     * @deprecated Use setRenderer instead.
     * @param {WebGLRenderer} renderer - The new renderer.
     * @param {Boolean} updateDOM - Indicates whether the old canvas should be replaced by the new one in the DOM.
     * @return {WebGLRenderer} The old renderer.
     */
    replaceRenderer(A, I = !0) {
      const g = this.renderer,
        C = g.domElement.parentNode
      return (
        this.setRenderer(A),
        I && C !== null && (C.removeChild(g.domElement), C.appendChild(A.domElement)),
        g
      )
    }
    /**
     * Creates a depth texture attachment that will be provided to all passes.
     *
     * Note: When a shader reads from a depth texture and writes to a render target that uses the same depth texture
     * attachment, the depth information will be lost. This happens even if `depthWrite` is disabled.
     *
     * @private
     * @return {DepthTexture} The depth texture.
     */
    createDepthTexture() {
      const A = (this.depthTexture = new JG())
      return (
        (this.inputBuffer.depthTexture = A),
        this.inputBuffer.dispose(),
        this.inputBuffer.stencilBuffer ? ((A.format = ND), (A.type = UD)) : (A.type = Zc),
        A
      )
    }
    /**
     * Deletes the current depth texture.
     *
     * @private
     */
    deleteDepthTexture() {
      if (this.depthTexture !== null) {
        ;(this.depthTexture.dispose(),
          (this.depthTexture = null),
          (this.inputBuffer.depthTexture = null),
          this.inputBuffer.dispose())
        for (const A of this.passes) A.setDepthTexture(null)
      }
    }
    /**
     * Creates a new render target.
     *
     * @deprecated Create buffers manually via WebGLRenderTarget instead.
     * @param {Boolean} depthBuffer - Whether the render target should have a depth buffer.
     * @param {Boolean} stencilBuffer - Whether the render target should have a stencil buffer.
     * @param {Number} type - The frame buffer type.
     * @param {Number} multisampling - The number of samples to use for antialiasing.
     * @return {WebGLRenderTarget} A new render target that equals the renderer's canvas.
     */
    createBuffer(A, I, g, C) {
      const i = this.renderer,
        B = i === null ? new ZI() : i.getDrawingBufferSize(new ZI()),
        o = {
          minFilter: nt,
          magFilter: nt,
          stencilBuffer: I,
          depthBuffer: A,
          type: g,
        },
        r = new BQ(B.width, B.height, o)
      return (
        C > 0 && ((r.ignoreDepthForMultisampleCopy = !1), (r.samples = C)),
        g === Xo && i !== null && i.outputColorSpace === zi && (r.texture.colorSpace = zi),
        (r.texture.name = "EffectComposer.Buffer"),
        (r.texture.generateMipmaps = !1),
        r
      )
    }
    /**
     * Can be used to change the main scene for all registered passes and effects.
     *
     * @param {Scene} scene - The scene.
     */
    setMainScene(A) {
      for (const I of this.passes) I.mainScene = A
    }
    /**
     * Can be used to change the main camera for all registered passes and effects.
     *
     * @param {Camera} camera - The camera.
     */
    setMainCamera(A) {
      for (const I of this.passes) I.mainCamera = A
    }
    /**
     * Adds a pass, optionally at a specific index.
     *
     * @param {Pass} pass - A new pass.
     * @param {Number} [index] - An index at which the pass should be inserted.
     */
    addPass(A, I) {
      const g = this.passes,
        C = this.renderer,
        i = C.getDrawingBufferSize(new ZI()),
        B = C.getContext().getContextAttributes().alpha,
        o = this.inputBuffer.texture.type
      if (
        (A.setRenderer(C),
        A.setSize(i.width, i.height),
        A.initialize(C, B, o),
        this.autoRenderToScreen &&
          (g.length > 0 && (g[g.length - 1].renderToScreen = !1),
          A.renderToScreen && (this.autoRenderToScreen = !1)),
        I !== void 0 ? g.splice(I, 0, A) : g.push(A),
        this.autoRenderToScreen && (g[g.length - 1].renderToScreen = !0),
        A.needsDepthTexture || this.depthTexture !== null)
      )
        if (this.depthTexture === null) {
          const r = this.createDepthTexture()
          for (A of g) A.setDepthTexture(r)
        } else A.setDepthTexture(this.depthTexture)
    }
    /**
     * Removes a pass.
     *
     * @param {Pass} pass - The pass.
     */
    removePass(A) {
      const I = this.passes,
        g = I.indexOf(A)
      if (g !== -1 && I.splice(g, 1).length > 0) {
        if (this.depthTexture !== null) {
          const B = (r, s) => r || s.needsDepthTexture
          I.reduce(B, !1) ||
            (A.getDepthTexture() === this.depthTexture && A.setDepthTexture(null),
            this.deleteDepthTexture())
        }
        this.autoRenderToScreen &&
          g === I.length &&
          ((A.renderToScreen = !1), I.length > 0 && (I[I.length - 1].renderToScreen = !0))
      }
    }
    /**
     * Removes all passes.
     */
    removeAllPasses() {
      const A = this.passes
      ;(this.deleteDepthTexture(),
        A.length > 0 &&
          (this.autoRenderToScreen && (A[A.length - 1].renderToScreen = !1), (this.passes = [])))
    }
    /**
     * Renders all enabled passes in the order in which they were added.
     *
     * @param {Number} [deltaTime] - The time since the last frame in seconds.
     */
    render(A) {
      const I = this.renderer,
        g = this.copyPass
      let C = this.inputBuffer,
        i = this.outputBuffer,
        B = !1,
        o,
        r,
        s
      A === void 0 && (this.timer.update(), (A = this.timer.getDelta()))
      for (const h of this.passes)
        h.enabled &&
          (h.render(I, C, i, A, B),
          h.needsSwap &&
            (B &&
              ((g.renderToScreen = h.renderToScreen),
              (o = I.getContext()),
              (r = I.state.buffers.stencil),
              r.setFunc(o.NOTEQUAL, 1, 4294967295),
              g.render(I, C, i, A, B),
              r.setFunc(o.EQUAL, 1, 4294967295)),
            (s = C),
            (C = i),
            (i = s)),
          h instanceof K7 ? (B = !0) : h instanceof F7 && (B = !1))
    }
    /**
     * Sets the size of the buffers, passes and the renderer.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     * @param {Boolean} [updateStyle] - Determines whether the style of the canvas should be updated.
     */
    setSize(A, I, g) {
      const C = this.renderer,
        i = C.getSize(new ZI())
      ;((A === void 0 || I === void 0) && ((A = i.width), (I = i.height)),
        (i.width !== A || i.height !== I) && C.setSize(A, I, g))
      const B = C.getDrawingBufferSize(new ZI())
      ;(this.inputBuffer.setSize(B.width, B.height), this.outputBuffer.setSize(B.width, B.height))
      for (const o of this.passes) o.setSize(B.width, B.height)
    }
    /**
     * Resets this composer by deleting all passes and creating new buffers.
     */
    reset() {
      ;(this.dispose(), (this.autoRenderToScreen = !0))
    }
    /**
     * Disposes this composer and all passes.
     */
    dispose() {
      for (const A of this.passes) A.dispose()
      ;((this.passes = []),
        this.inputBuffer !== null && this.inputBuffer.dispose(),
        this.outputBuffer !== null && this.outputBuffer.dispose(),
        this.deleteDepthTexture(),
        this.copyPass.dispose(),
        this.timer.dispose(),
        qa.fullscreenGeometry.dispose())
    }
  },
  tu = {
    NONE: 0,
    DEPTH: 1,
    CONVOLUTION: 2,
  },
  mi = {
    FRAGMENT_HEAD: "FRAGMENT_HEAD",
    FRAGMENT_MAIN_UV: "FRAGMENT_MAIN_UV",
    FRAGMENT_MAIN_IMAGE: "FRAGMENT_MAIN_IMAGE",
    VERTEX_HEAD: "VERTEX_HEAD",
    VERTEX_MAIN_SUPPORT: "VERTEX_MAIN_SUPPORT",
  },
  v7 = class {
    /**
     * Constructs new shader data.
     */
    constructor() {
      ;((this.shaderParts = /* @__PURE__ */ new Map([
        [mi.FRAGMENT_HEAD, null],
        [mi.FRAGMENT_MAIN_UV, null],
        [mi.FRAGMENT_MAIN_IMAGE, null],
        [mi.VERTEX_HEAD, null],
        [mi.VERTEX_MAIN_SUPPORT, null],
      ])),
        (this.defines = /* @__PURE__ */ new Map()),
        (this.uniforms = /* @__PURE__ */ new Map()),
        (this.blendModes = /* @__PURE__ */ new Map()),
        (this.extensions = /* @__PURE__ */ new Set()),
        (this.attributes = tu.NONE),
        (this.varyings = /* @__PURE__ */ new Set()),
        (this.uvTransformation = !1),
        (this.readDepth = !1),
        (this.colorSpace = ru))
    }
  },
  Qm = !1,
  bx = class {
    /**
     * Constructs a new override material manager.
     *
     * @param {Material} [material=null] - An override material.
     */
    constructor(e = null) {
      ;((this.originalMaterials = /* @__PURE__ */ new Map()),
        (this.material = null),
        (this.materials = null),
        (this.materialsBackSide = null),
        (this.materialsDoubleSide = null),
        (this.materialsFlatShaded = null),
        (this.materialsFlatShadedBackSide = null),
        (this.materialsFlatShadedDoubleSide = null),
        this.setMaterial(e),
        (this.meshCount = 0),
        (this.replaceMaterial = (A) => {
          if (A.isMesh) {
            let I
            if (A.material.flatShading)
              switch (A.material.side) {
                case rE:
                  I = this.materialsFlatShadedDoubleSide
                  break
                case WQ:
                  I = this.materialsFlatShadedBackSide
                  break
                default:
                  I = this.materialsFlatShaded
                  break
              }
            else
              switch (A.material.side) {
                case rE:
                  I = this.materialsDoubleSide
                  break
                case WQ:
                  I = this.materialsBackSide
                  break
                default:
                  I = this.materials
                  break
              }
            ;(this.originalMaterials.set(A, A.material),
              A.isSkinnedMesh
                ? (A.material = I[2])
                : A.isInstancedMesh
                  ? (A.material = I[1])
                  : (A.material = I[0]),
              ++this.meshCount)
          }
        }))
    }
    /**
     * Clones the given material.
     *
     * @private
     * @param {Material} material - The material.
     * @return {Material} The cloned material.
     */
    cloneMaterial(e) {
      if (!(e instanceof VQ)) return e.clone()
      const A = e.uniforms,
        I = /* @__PURE__ */ new Map()
      for (const C in A) {
        const i = A[C].value
        i.isRenderTargetTexture && ((A[C].value = null), I.set(C, i))
      }
      const g = e.clone()
      for (const C of I) ((A[C[0]].value = C[1]), (g.uniforms[C[0]].value = C[1]))
      return g
    }
    /**
     * Sets the override material.
     *
     * @param {Material} material - The material.
     */
    setMaterial(e) {
      if ((this.disposeMaterials(), (this.material = e), e !== null)) {
        const A = (this.materials = [
          this.cloneMaterial(e),
          this.cloneMaterial(e),
          this.cloneMaterial(e),
        ])
        for (const I of A) ((I.uniforms = Object.assign({}, e.uniforms)), (I.side = Us))
        ;((A[2].skinning = !0),
          (this.materialsBackSide = A.map((I) => {
            const g = this.cloneMaterial(I)
            return ((g.uniforms = Object.assign({}, e.uniforms)), (g.side = WQ), g)
          })),
          (this.materialsDoubleSide = A.map((I) => {
            const g = this.cloneMaterial(I)
            return ((g.uniforms = Object.assign({}, e.uniforms)), (g.side = rE), g)
          })),
          (this.materialsFlatShaded = A.map((I) => {
            const g = this.cloneMaterial(I)
            return ((g.uniforms = Object.assign({}, e.uniforms)), (g.flatShading = !0), g)
          })),
          (this.materialsFlatShadedBackSide = A.map((I) => {
            const g = this.cloneMaterial(I)
            return (
              (g.uniforms = Object.assign({}, e.uniforms)),
              (g.flatShading = !0),
              (g.side = WQ),
              g
            )
          })),
          (this.materialsFlatShadedDoubleSide = A.map((I) => {
            const g = this.cloneMaterial(I)
            return (
              (g.uniforms = Object.assign({}, e.uniforms)),
              (g.flatShading = !0),
              (g.side = rE),
              g
            )
          })))
      }
    }
    /**
     * Renders the scene with the override material.
     *
     * @private
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Scene} scene - A scene.
     * @param {Camera} camera - A camera.
     */
    render(e, A, I) {
      const g = e.shadowMap.enabled
      if (((e.shadowMap.enabled = !1), Qm)) {
        const C = this.originalMaterials
        ;((this.meshCount = 0), A.traverse(this.replaceMaterial), e.render(A, I))
        for (const i of C) i[0].material = i[1]
        this.meshCount !== C.size && C.clear()
      } else {
        const C = A.overrideMaterial
        ;((A.overrideMaterial = this.material), e.render(A, I), (A.overrideMaterial = C))
      }
      e.shadowMap.enabled = g
    }
    /**
     * Deletes cloned override materials.
     *
     * @private
     */
    disposeMaterials() {
      if (this.material !== null) {
        const e = this.materials
          .concat(this.materialsBackSide)
          .concat(this.materialsDoubleSide)
          .concat(this.materialsFlatShaded)
          .concat(this.materialsFlatShadedBackSide)
          .concat(this.materialsFlatShadedDoubleSide)
        for (const A of e) A.dispose()
      }
    }
    /**
     * Performs cleanup tasks.
     */
    dispose() {
      ;(this.originalMaterials.clear(), this.disposeMaterials())
    }
    /**
     * Indicates whether the override material workaround is enabled.
     *
     * @type {Boolean}
     */
    static get workaroundEnabled() {
      return Qm
    }
    /**
     * Enables or disables the override material workaround globally.
     *
     * This only affects post processing passes and effects.
     *
     * @type {Boolean}
     */
    static set workaroundEnabled(e) {
      Qm = e
    }
  },
  SD = -1,
  cE = class extends qr {
    /**
     * Constructs a new resolution.
     *
     * TODO Remove resizable param.
     * @param {Resizable} resizable - A resizable object.
     * @param {Number} [width=Resolution.AUTO_SIZE] - The preferred width.
     * @param {Number} [height=Resolution.AUTO_SIZE] - The preferred height.
     * @param {Number} [scale=1.0] - A resolution scale.
     */
    constructor(e, A = SD, I = SD, g = 1) {
      ;(super(),
        (this.resizable = e),
        (this.baseSize = new ZI(1, 1)),
        (this.preferredSize = new ZI(A, I)),
        (this.target = this.preferredSize),
        (this.s = g),
        (this.effectiveSize = new ZI()),
        this.addEventListener("change", () => this.updateEffectiveSize()),
        this.updateEffectiveSize())
    }
    /**
     * Calculates the effective size.
     *
     * @private
     */
    updateEffectiveSize() {
      const e = this.baseSize,
        A = this.preferredSize,
        I = this.effectiveSize,
        g = this.scale
      ;(A.width !== SD
        ? (I.width = A.width)
        : A.height !== SD
          ? (I.width = Math.round(A.height * (e.width / Math.max(e.height, 1))))
          : (I.width = Math.round(e.width * g)),
        A.height !== SD
          ? (I.height = A.height)
          : A.width !== SD
            ? (I.height = Math.round(A.width / Math.max(e.width / Math.max(e.height, 1), 1)))
            : (I.height = Math.round(e.height * g)))
    }
    /**
     * The effective width.
     *
     * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base width will be returned.
     *
     * @type {Number}
     */
    get width() {
      return this.effectiveSize.width
    }
    set width(e) {
      this.preferredWidth = e
    }
    /**
     * The effective height.
     *
     * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base height will be returned.
     *
     * @type {Number}
     */
    get height() {
      return this.effectiveSize.height
    }
    set height(e) {
      this.preferredHeight = e
    }
    /**
     * Returns the effective width.
     *
     * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base width will be returned.
     *
     * @deprecated Use width instead.
     * @return {Number} The effective width.
     */
    getWidth() {
      return this.width
    }
    /**
     * Returns the effective height.
     *
     * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base height will be returned.
     *
     * @deprecated Use height instead.
     * @return {Number} The effective height.
     */
    getHeight() {
      return this.height
    }
    /**
     * The resolution scale.
     *
     * @type {Number}
     */
    get scale() {
      return this.s
    }
    set scale(e) {
      this.s !== e &&
        ((this.s = e),
        this.preferredSize.setScalar(SD),
        this.dispatchEvent({ type: "change" }),
        this.resizable.setSize(this.baseSize.width, this.baseSize.height))
    }
    /**
     * Returns the current resolution scale.
     *
     * @deprecated Use scale instead.
     * @return {Number} The scale.
     */
    getScale() {
      return this.scale
    }
    /**
     * Sets the resolution scale.
     *
     * Also sets the preferred resolution to {@link Resizer.AUTO_SIZE}.
     *
     * @deprecated Use scale instead.
     * @param {Number} value - The scale.
     */
    setScale(e) {
      this.scale = e
    }
    /**
     * The base width.
     *
     * @type {Number}
     */
    get baseWidth() {
      return this.baseSize.width
    }
    set baseWidth(e) {
      this.baseSize.width !== e &&
        ((this.baseSize.width = e),
        this.dispatchEvent({ type: "change" }),
        this.resizable.setSize(this.baseSize.width, this.baseSize.height))
    }
    /**
     * Returns the base width.
     *
     * @deprecated Use baseWidth instead.
     * @return {Number} The base width.
     */
    getBaseWidth() {
      return this.baseWidth
    }
    /**
     * Sets the base width.
     *
     * @deprecated Use baseWidth instead.
     * @param {Number} value - The width.
     */
    setBaseWidth(e) {
      this.baseWidth = e
    }
    /**
     * The base height.
     *
     * @type {Number}
     */
    get baseHeight() {
      return this.baseSize.height
    }
    set baseHeight(e) {
      this.baseSize.height !== e &&
        ((this.baseSize.height = e),
        this.dispatchEvent({ type: "change" }),
        this.resizable.setSize(this.baseSize.width, this.baseSize.height))
    }
    /**
     * Returns the base height.
     *
     * @deprecated Use baseHeight instead.
     * @return {Number} The base height.
     */
    getBaseHeight() {
      return this.baseHeight
    }
    /**
     * Sets the base height.
     *
     * @deprecated Use baseHeight instead.
     * @param {Number} value - The height.
     */
    setBaseHeight(e) {
      this.baseHeight = e
    }
    /**
     * Sets the base size.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setBaseSize(e, A) {
      ;(this.baseSize.width !== e || this.baseSize.height !== A) &&
        (this.baseSize.set(e, A),
        this.dispatchEvent({ type: "change" }),
        this.resizable.setSize(this.baseSize.width, this.baseSize.height))
    }
    /**
     * The preferred width.
     *
     * @type {Number}
     */
    get preferredWidth() {
      return this.preferredSize.width
    }
    set preferredWidth(e) {
      this.preferredSize.width !== e &&
        ((this.preferredSize.width = e),
        this.dispatchEvent({ type: "change" }),
        this.resizable.setSize(this.baseSize.width, this.baseSize.height))
    }
    /**
     * Returns the preferred width.
     *
     * @deprecated Use preferredWidth instead.
     * @return {Number} The preferred width.
     */
    getPreferredWidth() {
      return this.preferredWidth
    }
    /**
     * Sets the preferred width.
     *
     * Use {@link Resizer.AUTO_SIZE} to automatically calculate the width based on the height and aspect ratio.
     *
     * @deprecated Use preferredWidth instead.
     * @param {Number} value - The width.
     */
    setPreferredWidth(e) {
      this.preferredWidth = e
    }
    /**
     * The preferred height.
     *
     * @type {Number}
     */
    get preferredHeight() {
      return this.preferredSize.height
    }
    set preferredHeight(e) {
      this.preferredSize.height !== e &&
        ((this.preferredSize.height = e),
        this.dispatchEvent({ type: "change" }),
        this.resizable.setSize(this.baseSize.width, this.baseSize.height))
    }
    /**
     * Returns the preferred height.
     *
     * @deprecated Use preferredHeight instead.
     * @return {Number} The preferred height.
     */
    getPreferredHeight() {
      return this.preferredHeight
    }
    /**
     * Sets the preferred height.
     *
     * Use {@link Resizer.AUTO_SIZE} to automatically calculate the height based on the width and aspect ratio.
     *
     * @deprecated Use preferredHeight instead.
     * @param {Number} value - The height.
     */
    setPreferredHeight(e) {
      this.preferredHeight = e
    }
    /**
     * Sets the preferred size.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setPreferredSize(e, A) {
      ;(this.preferredSize.width !== e || this.preferredSize.height !== A) &&
        (this.preferredSize.set(e, A),
        this.dispatchEvent({ type: "change" }),
        this.resizable.setSize(this.baseSize.width, this.baseSize.height))
    }
    /**
     * Copies the given resolution.
     *
     * @param {Resolution} resolution - The resolution.
     */
    copy(e) {
      ;((this.s = e.scale),
        this.baseSize.set(e.baseWidth, e.baseHeight),
        this.preferredSize.set(e.preferredWidth, e.preferredHeight),
        this.dispatchEvent({ type: "change" }),
        this.resizable.setSize(this.baseSize.width, this.baseSize.height))
    }
    /**
     * An auto sizing constant.
     *
     * Can be used to automatically calculate the width or height based on the original aspect ratio.
     *
     * @type {Number}
     */
    static get AUTO_SIZE() {
      return SD
    }
  },
  Ve = {
    SKIP: 9,
    SET: 30,
    ADD: 0,
    ALPHA: 1,
    AVERAGE: 2,
    COLOR: 3,
    COLOR_BURN: 4,
    COLOR_DODGE: 5,
    DARKEN: 6,
    DIFFERENCE: 7,
    DIVIDE: 8,
    DST: 9,
    EXCLUSION: 10,
    HARD_LIGHT: 11,
    HARD_MIX: 12,
    HUE: 13,
    INVERT: 14,
    INVERT_RGB: 15,
    LIGHTEN: 16,
    LINEAR_BURN: 17,
    LINEAR_DODGE: 18,
    LINEAR_LIGHT: 19,
    LUMINOSITY: 20,
    MULTIPLY: 21,
    NEGATION: 22,
    NORMAL: 23,
    OVERLAY: 24,
    PIN_LIGHT: 25,
    REFLECT: 26,
    SATURATION: 27,
    SCREEN: 28,
    SOFT_LIGHT: 29,
    SRC: 30,
    SUBTRACT: 31,
    VIVID_LIGHT: 32,
  },
  L7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x+y,opacity);}",
  Y7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,y,min(y.a,opacity));}",
  q7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,(x+y)*0.5,opacity);}",
  H7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(yHSL.rg,xHSL.b));return vec4(mix(x.rgb,z,opacity),y.a);}",
  T7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(step(0.0,y)*(1.0-min(vec4(1.0),(1.0-x)/y)),vec4(1.0),step(1.0,x));return mix(x,z,opacity);}",
  x7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=step(0.0,x)*mix(min(vec4(1.0),x/max(1.0-y,1e-9)),vec4(1.0),step(1.0,y));return mix(x,z,opacity);}",
  b7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,min(x,y),opacity);}",
  O7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,abs(x-y),opacity);}",
  _7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x/max(y,1e-12),opacity);}",
  Z7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,(x+y-2.0*x*y),opacity);}",
  P7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 a=min(x,1.0),b=min(y,1.0);vec4 z=mix(2.0*a*b,1.0-2.0*(1.0-a)*(1.0-b),step(0.5,y));return mix(x,z,opacity);}",
  W7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,step(1.0,x+y),opacity);}",
  V7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(yHSL.r,xHSL.gb));return vec4(mix(x.rgb,z,opacity),y.a);}",
  j7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,1.0-y,opacity);}",
  z7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,y*(1.0-x),opacity);}",
  X7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,max(x,y),opacity);}",
  $7 =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,clamp(y+x-1.0,0.0,1.0),opacity);}",
  A$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,min(x+y,1.0),opacity);}",
  I$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,clamp(2.0*y+x-1.0,0.0,1.0),opacity);}",
  g$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(xHSL.rg,yHSL.b));return vec4(mix(x.rgb,z,opacity),y.a);}",
  C$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x*y,opacity);}",
  e$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,1.0-abs(1.0-x-y),opacity);}",
  i$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,y,opacity);}",
  t$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(2.0*y*x,1.0-2.0*(1.0-y)*(1.0-x),step(0.5,x));return mix(x,z,opacity);}",
  B$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 y2=2.0*y;vec4 z=mix(mix(y2,x,step(0.5*x,y)),max(vec4(0.0),y2-1.0),step(x,(y2-1.0)));return mix(x,z,opacity);}",
  Q$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(min(x*x/max(1.0-y,1e-12),1.0),y,step(1.0,y));return mix(x,z,opacity);}",
  o$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(xHSL.r,yHSL.g,xHSL.b));return vec4(mix(x.rgb,z,opacity),y.a);}",
  n$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x+y-min(x*y,1.0),opacity);}",
  E$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 y2=2.0*y;vec4 w=step(0.5,y);vec4 z=mix(x-(1.0-y2)*x*(1.0-x),mix(x+(y2-1.0)*(sqrt(x)-x),x+(y2-1.0)*x*((16.0*x-12.0)*x+3.0),w*(1.0-step(0.25,x))),w);return mix(x,z,opacity);}",
  a$ = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return y;}",
  r$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,max(x+y-1.0,0.0),opacity);}",
  s$ =
    "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(max(1.0-min((1.0-x)/(2.0*y),1.0),0.0),min(x/(2.0*(1.0-y)),1.0),step(0.5,y));return mix(x,z,opacity);}",
  l$ = /* @__PURE__ */ new Map([
    [Ve.ADD, L7],
    [Ve.ALPHA, Y7],
    [Ve.AVERAGE, q7],
    [Ve.COLOR, H7],
    [Ve.COLOR_BURN, T7],
    [Ve.COLOR_DODGE, x7],
    [Ve.DARKEN, b7],
    [Ve.DIFFERENCE, O7],
    [Ve.DIVIDE, _7],
    [Ve.DST, null],
    [Ve.EXCLUSION, Z7],
    [Ve.HARD_LIGHT, P7],
    [Ve.HARD_MIX, W7],
    [Ve.HUE, V7],
    [Ve.INVERT, j7],
    [Ve.INVERT_RGB, z7],
    [Ve.LIGHTEN, X7],
    [Ve.LINEAR_BURN, $7],
    [Ve.LINEAR_DODGE, A$],
    [Ve.LINEAR_LIGHT, I$],
    [Ve.LUMINOSITY, g$],
    [Ve.MULTIPLY, C$],
    [Ve.NEGATION, e$],
    [Ve.NORMAL, i$],
    [Ve.OVERLAY, t$],
    [Ve.PIN_LIGHT, B$],
    [Ve.REFLECT, Q$],
    [Ve.SATURATION, o$],
    [Ve.SCREEN, n$],
    [Ve.SOFT_LIGHT, E$],
    [Ve.SRC, a$],
    [Ve.SUBTRACT, r$],
    [Ve.VIVID_LIGHT, s$],
  ]),
  c$ = class extends qr {
    /**
     * Constructs a new blend mode.
     *
     * @param {BlendFunction} blendFunction - The blend function.
     * @param {Number} opacity - The opacity of the color that will be blended with the base color.
     */
    constructor(e, A = 1) {
      ;(super(), (this._blendFunction = e), (this.opacity = new ki(A)))
    }
    /**
     * Returns the opacity.
     *
     * @return {Number} The opacity.
     */
    getOpacity() {
      return this.opacity.value
    }
    /**
     * Sets the opacity.
     *
     * @param {Number} value - The opacity.
     */
    setOpacity(e) {
      this.opacity.value = e
    }
    /**
     * The blend function.
     *
     * @type {BlendFunction}
     */
    get blendFunction() {
      return this._blendFunction
    }
    set blendFunction(e) {
      ;((this._blendFunction = e), this.dispatchEvent({ type: "change" }))
    }
    /**
     * Returns the blend function.
     *
     * @deprecated Use blendFunction instead.
     * @return {BlendFunction} The blend function.
     */
    getBlendFunction() {
      return this.blendFunction
    }
    /**
     * Sets the blend function.
     *
     * @deprecated Use blendFunction instead.
     * @param {BlendFunction} value - The blend function.
     */
    setBlendFunction(e) {
      this.blendFunction = e
    }
    /**
     * Returns the blend function shader code.
     *
     * @return {String} The blend function shader code.
     */
    getShaderCode() {
      return l$.get(this.blendFunction)
    }
  },
  pL = {
    VERY_SMALL: 0,
    SMALL: 1,
    MEDIUM: 2,
    LARGE: 3,
    VERY_LARGE: 4,
    HUGE: 5,
  },
  h$ = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec4 sum=texture2D(inputBuffer,vUv0);sum+=texture2D(inputBuffer,vUv1);sum+=texture2D(inputBuffer,vUv2);sum+=texture2D(inputBuffer,vUv3);gl_FragColor=sum*0.25;
#include <colorspace_fragment>
}`,
  u$ =
    "uniform vec4 texelSize;uniform float kernel;uniform float scale;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vec2 dUv=(texelSize.xy*vec2(kernel)+texelSize.zw)*scale;vUv0=vec2(uv.x-dUv.x,uv.y+dUv.y);vUv1=vec2(uv.x+dUv.x,uv.y+dUv.y);vUv2=vec2(uv.x+dUv.x,uv.y-dUv.y);vUv3=vec2(uv.x-dUv.x,uv.y-dUv.y);gl_Position=vec4(position.xy,1.0,1.0);}",
  D$ = [
    new Float32Array([0, 0]),
    new Float32Array([0, 1, 1]),
    new Float32Array([0, 1, 1, 2]),
    new Float32Array([0, 1, 2, 2, 3]),
    new Float32Array([0, 1, 2, 3, 4, 4, 5]),
    new Float32Array([0, 1, 2, 3, 4, 5, 7, 8, 9, 10]),
  ],
  S$ = class extends VQ {
    /**
     * Constructs a new convolution material.
     *
     * TODO Remove texelSize param.
     * @param {Vector4} [texelSize] - Deprecated.
     */
    constructor(e = new Xe()) {
      ;(super({
        name: "KawaseBlurMaterial",
        uniforms: {
          inputBuffer: new ki(null),
          texelSize: new ki(new Xe()),
          scale: new ki(1),
          kernel: new ki(0),
        },
        blending: hE,
        toneMapped: !1,
        depthWrite: !1,
        depthTest: !1,
        fragmentShader: h$,
        vertexShader: u$,
      }),
        this.setTexelSize(e.x, e.y),
        (this.kernelSize = pL.MEDIUM))
    }
    /**
     * The input buffer.
     *
     * @type {Texture}
     */
    set inputBuffer(e) {
      this.uniforms.inputBuffer.value = e
    }
    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Texture} value - The input buffer.
     */
    setInputBuffer(e) {
      this.inputBuffer = e
    }
    /**
     * The kernel sequence for the current kernel size.
     *
     * @type {Float32Array}
     */
    get kernelSequence() {
      return D$[this.kernelSize]
    }
    /**
     * The blur scale.
     *
     * @type {Number}
     */
    get scale() {
      return this.uniforms.scale.value
    }
    set scale(e) {
      this.uniforms.scale.value = e
    }
    /**
     * Returns the blur scale.
     *
     * @deprecated Use scale instead.
     * @return {Number} The scale.
     */
    getScale() {
      return this.uniforms.scale.value
    }
    /**
     * Sets the blur scale.
     *
     * @deprecated Use scale instead.
     * @return {Number} value - The scale.
     */
    setScale(e) {
      this.uniforms.scale.value = e
    }
    /**
     * Returns the kernel.
     *
     * @return {Float32Array} The kernel.
     * @deprecated Implementation detail, removed with no replacement.
     */
    getKernel() {
      return null
    }
    /**
     * The current kernel.
     *
     * @type {Number}
     */
    get kernel() {
      return this.uniforms.kernel.value
    }
    set kernel(e) {
      this.uniforms.kernel.value = e
    }
    /**
     * Sets the current kernel.
     *
     * @deprecated Use kernel instead.
     * @param {Number} value - The kernel.
     */
    setKernel(e) {
      this.kernel = e
    }
    /**
     * Sets the texel size.
     *
     * @deprecated Use setSize() instead.
     * @param {Number} x - The texel width.
     * @param {Number} y - The texel height.
     */
    setTexelSize(e, A) {
      this.uniforms.texelSize.value.set(e, A, e * 0.5, A * 0.5)
    }
    /**
     * Sets the size of this object.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {
      const I = 1 / e,
        g = 1 / A
      this.uniforms.texelSize.value.set(I, g, I * 0.5, g * 0.5)
    }
  },
  f$ = class extends qa {
    /**
     * Constructs a new Kawase blur pass.
     *
     * @param {Object} [options] - The options.
     * @param {KernelSize} [options.kernelSize=KernelSize.MEDIUM] - The blur kernel size.
     * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
     * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
     * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
     * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
     * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
     */
    constructor({
      kernelSize: e = pL.MEDIUM,
      resolutionScale: A = 0.5,
      width: I = cE.AUTO_SIZE,
      height: g = cE.AUTO_SIZE,
      resolutionX: C = I,
      resolutionY: i = g,
    } = {}) {
      ;(super("KawaseBlurPass"),
        (this.renderTargetA = new BQ(1, 1, { depthBuffer: !1 })),
        (this.renderTargetA.texture.name = "Blur.Target.A"),
        (this.renderTargetB = this.renderTargetA.clone()),
        (this.renderTargetB.texture.name = "Blur.Target.B"))
      const B = (this.resolution = new cE(this, C, i, A))
      ;(B.addEventListener("change", (o) => this.setSize(B.baseWidth, B.baseHeight)),
        (this._blurMaterial = new S$()),
        (this._blurMaterial.kernelSize = e),
        (this.copyMaterial = new WO()))
    }
    /**
     * Returns the resolution settings.
     *
     * @deprecated Use resolution instead.
     * @return {Resolution} The resolution.
     */
    getResolution() {
      return this.resolution
    }
    /**
     * The blur material.
     *
     * @type {KawaseBlurMaterial}
     */
    get blurMaterial() {
      return this._blurMaterial
    }
    /**
     * The blur material.
     *
     * @type {KawaseBlurMaterial}
     * @protected
     */
    set blurMaterial(e) {
      this._blurMaterial = e
    }
    /**
     * Indicates whether dithering is enabled.
     *
     * @type {Boolean}
     * @deprecated Use copyMaterial.dithering instead.
     */
    get dithering() {
      return this.copyMaterial.dithering
    }
    set dithering(e) {
      this.copyMaterial.dithering = e
    }
    /**
     * The kernel size.
     *
     * @type {KernelSize}
     * @deprecated Use blurMaterial.kernelSize instead.
     */
    get kernelSize() {
      return this.blurMaterial.kernelSize
    }
    set kernelSize(e) {
      this.blurMaterial.kernelSize = e
    }
    /**
     * The current width of the internal render targets.
     *
     * @type {Number}
     * @deprecated Use resolution.width instead.
     */
    get width() {
      return this.resolution.width
    }
    /**
     * Sets the render width.
     *
     * @type {Number}
     * @deprecated Use resolution.preferredWidth instead.
     */
    set width(e) {
      this.resolution.preferredWidth = e
    }
    /**
     * The current height of the internal render targets.
     *
     * @type {Number}
     * @deprecated Use resolution.height instead.
     */
    get height() {
      return this.resolution.height
    }
    /**
     * Sets the render height.
     *
     * @type {Number}
     * @deprecated Use resolution.preferredHeight instead.
     */
    set height(e) {
      this.resolution.preferredHeight = e
    }
    /**
     * The current blur scale.
     *
     * @type {Number}
     * @deprecated Use blurMaterial.scale instead.
     */
    get scale() {
      return this.blurMaterial.scale
    }
    set scale(e) {
      this.blurMaterial.scale = e
    }
    /**
     * Returns the current blur scale.
     *
     * @deprecated Use blurMaterial.scale instead.
     * @return {Number} The scale.
     */
    getScale() {
      return this.blurMaterial.scale
    }
    /**
     * Sets the blur scale.
     *
     * @deprecated Use blurMaterial.scale instead.
     * @param {Number} value - The scale.
     */
    setScale(e) {
      this.blurMaterial.scale = e
    }
    /**
     * Returns the kernel size.
     *
     * @deprecated Use blurMaterial.kernelSize instead.
     * @return {KernelSize} The kernel size.
     */
    getKernelSize() {
      return this.kernelSize
    }
    /**
     * Sets the kernel size.
     *
     * Larger kernels require more processing power but scale well with larger render resolutions.
     *
     * @deprecated Use blurMaterial.kernelSize instead.
     * @param {KernelSize} value - The kernel size.
     */
    setKernelSize(e) {
      this.kernelSize = e
    }
    /**
     * Returns the current resolution scale.
     *
     * @return {Number} The resolution scale.
     * @deprecated Use resolution instead.
     */
    getResolutionScale() {
      return this.resolution.scale
    }
    /**
     * Sets the resolution scale.
     *
     * @param {Number} scale - The new resolution scale.
     * @deprecated Use resolution instead.
     */
    setResolutionScale(e) {
      this.resolution.scale = e
    }
    /**
     * Renders the blur.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */
    render(e, A, I, g, C) {
      const i = this.scene,
        B = this.camera,
        o = this.renderTargetA,
        r = this.renderTargetB,
        s = this.blurMaterial,
        h = s.kernelSequence
      let S = A
      this.fullscreenMaterial = s
      for (let d = 0, w = h.length; d < w; ++d) {
        const M = d & 1 ? r : o
        ;((s.kernel = h[d]),
          (s.inputBuffer = S.texture),
          e.setRenderTarget(M),
          e.render(i, B),
          (S = M))
      }
      ;((this.fullscreenMaterial = this.copyMaterial),
        (this.copyMaterial.inputBuffer = S.texture),
        e.setRenderTarget(this.renderToScreen ? null : I),
        e.render(i, B))
    }
    /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {
      const I = this.resolution
      I.setBaseSize(e, A)
      const g = I.width,
        C = I.height
      ;(this.renderTargetA.setSize(g, C),
        this.renderTargetB.setSize(g, C),
        this.blurMaterial.setSize(e, A))
    }
    /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */
    initialize(e, A, I) {
      I !== void 0 &&
        ((this.renderTargetA.texture.type = I),
        (this.renderTargetB.texture.type = I),
        I !== Xo
          ? ((this.blurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1"),
            (this.copyMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1"))
          : e !== null &&
            e.outputColorSpace === zi &&
            ((this.renderTargetA.texture.colorSpace = zi),
            (this.renderTargetB.texture.colorSpace = zi)))
    }
    /**
     * An auto sizing flag.
     *
     * @type {Number}
     * @deprecated Use {@link Resolution.AUTO_SIZE} instead.
     */
    static get AUTO_SIZE() {
      return cE.AUTO_SIZE
    }
  },
  d$ = `#include <common>
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef RANGE
uniform vec2 range;
#elif defined(THRESHOLD)
uniform float threshold;uniform float smoothing;
#endif
varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);float l=luminance(texel.rgb);
#ifdef RANGE
float low=step(range.x,l);float high=step(l,range.y);l*=low*high;
#elif defined(THRESHOLD)
l=smoothstep(threshold,threshold+smoothing,l)*l;
#endif
#ifdef COLOR
gl_FragColor=vec4(texel.rgb*clamp(l,0.0,1.0),l);
#else
gl_FragColor=vec4(l);
#endif
}`,
  y$ = class extends VQ {
    /**
     * Constructs a new luminance material.
     *
     * @param {Boolean} [colorOutput=false] - Defines whether the shader should output colors scaled with their luminance value.
     * @param {Vector2} [luminanceRange] - If provided, the shader will mask out texels that aren't in the specified luminance range.
     */
    constructor(e = !1, A = null) {
      ;(super({
        name: "LuminanceMaterial",
        defines: {
          THREE_REVISION: Wf.replace(/\D+/g, ""),
        },
        uniforms: {
          inputBuffer: new ki(null),
          threshold: new ki(0),
          smoothing: new ki(1),
          range: new ki(null),
        },
        blending: hE,
        toneMapped: !1,
        depthWrite: !1,
        depthTest: !1,
        fragmentShader: d$,
        vertexShader: PO,
      }),
        (this.colorOutput = e),
        (this.luminanceRange = A))
    }
    /**
     * The input buffer.
     *
     * @type {Texture}
     */
    set inputBuffer(e) {
      this.uniforms.inputBuffer.value = e
    }
    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Texture} value - The input buffer.
     */
    setInputBuffer(e) {
      this.uniforms.inputBuffer.value = e
    }
    /**
     * The luminance threshold.
     *
     * @type {Number}
     */
    get threshold() {
      return this.uniforms.threshold.value
    }
    set threshold(e) {
      ;(this.smoothing > 0 || e > 0
        ? (this.defines.THRESHOLD = "1")
        : delete this.defines.THRESHOLD,
        (this.uniforms.threshold.value = e))
    }
    /**
     * Returns the luminance threshold.
     *
     * @deprecated Use threshold instead.
     * @return {Number} The threshold.
     */
    getThreshold() {
      return this.threshold
    }
    /**
     * Sets the luminance threshold.
     *
     * @deprecated Use threshold instead.
     * @param {Number} value - The threshold.
     */
    setThreshold(e) {
      this.threshold = e
    }
    /**
     * The luminance threshold smoothing.
     *
     * @type {Number}
     */
    get smoothing() {
      return this.uniforms.smoothing.value
    }
    set smoothing(e) {
      ;(this.threshold > 0 || e > 0
        ? (this.defines.THRESHOLD = "1")
        : delete this.defines.THRESHOLD,
        (this.uniforms.smoothing.value = e))
    }
    /**
     * Returns the luminance threshold smoothing factor.
     *
     * @deprecated Use smoothing instead.
     * @return {Number} The smoothing factor.
     */
    getSmoothingFactor() {
      return this.smoothing
    }
    /**
     * Sets the luminance threshold smoothing factor.
     *
     * @deprecated Use smoothing instead.
     * @param {Number} value - The smoothing factor.
     */
    setSmoothingFactor(e) {
      this.smoothing = e
    }
    /**
     * Indicates whether the luminance threshold is enabled.
     *
     * @type {Boolean}
     * @deprecated Adjust the threshold or smoothing factor instead.
     */
    get useThreshold() {
      return this.threshold > 0 || this.smoothing > 0
    }
    set useThreshold(e) {}
    /**
     * Indicates whether color output is enabled.
     *
     * @type {Boolean}
     */
    get colorOutput() {
      return this.defines.COLOR !== void 0
    }
    set colorOutput(e) {
      ;(e ? (this.defines.COLOR = "1") : delete this.defines.COLOR, (this.needsUpdate = !0))
    }
    /**
     * Indicates whether color output is enabled.
     *
     * @deprecated Use colorOutput instead.
     * @return {Boolean} Whether color output is enabled.
     */
    isColorOutputEnabled(e) {
      return this.colorOutput
    }
    /**
     * Enables or disables color output.
     *
     * @deprecated Use colorOutput instead.
     * @param {Boolean} value - Whether color output should be enabled.
     */
    setColorOutputEnabled(e) {
      this.colorOutput = e
    }
    /**
     * Indicates whether luminance masking is enabled.
     *
     * @type {Boolean}
     * @deprecated
     */
    get useRange() {
      return this.luminanceRange !== null
    }
    set useRange(e) {
      this.luminanceRange = null
    }
    /**
     * The luminance range. Set to null to disable.
     *
     * @type {Boolean}
     */
    get luminanceRange() {
      return this.uniforms.range.value
    }
    set luminanceRange(e) {
      ;(e !== null ? (this.defines.RANGE = "1") : delete this.defines.RANGE,
        (this.uniforms.range.value = e),
        (this.needsUpdate = !0))
    }
    /**
     * Returns the current luminance range.
     *
     * @deprecated Use luminanceRange instead.
     * @return {Vector2} The luminance range.
     */
    getLuminanceRange() {
      return this.luminanceRange
    }
    /**
     * Sets a luminance range. Set to null to disable.
     *
     * @deprecated Use luminanceRange instead.
     * @param {Vector2} value - The luminance range.
     */
    setLuminanceRange(e) {
      this.luminanceRange = e
    }
  },
  p$ = class extends qa {
    /**
     * Constructs a new luminance pass.
     *
     * @param {Object} [options] - The options. See {@link LuminanceMaterial} for additional options.
     * @param {WebGLRenderTarget} [options.renderTarget] - A custom render target.
     * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
     * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
     * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
     * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
     * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
     */
    constructor({
      renderTarget: e,
      luminanceRange: A,
      colorOutput: I,
      resolutionScale: g = 1,
      width: C = cE.AUTO_SIZE,
      height: i = cE.AUTO_SIZE,
      resolutionX: B = C,
      resolutionY: o = i,
    } = {}) {
      ;(super("LuminancePass"),
        (this.fullscreenMaterial = new y$(I, A)),
        (this.needsSwap = !1),
        (this.renderTarget = e),
        this.renderTarget === void 0 &&
          ((this.renderTarget = new BQ(1, 1, { depthBuffer: !1 })),
          (this.renderTarget.texture.name = "LuminancePass.Target")))
      const r = (this.resolution = new cE(this, B, o, g))
      r.addEventListener("change", (s) => this.setSize(r.baseWidth, r.baseHeight))
    }
    /**
     * The luminance texture.
     *
     * @type {Texture}
     */
    get texture() {
      return this.renderTarget.texture
    }
    /**
     * Returns the luminance texture.
     *
     * @deprecated Use texture instead.
     * @return {Texture} The texture.
     */
    getTexture() {
      return this.renderTarget.texture
    }
    /**
     * Returns the resolution settings.
     *
     * @deprecated Use resolution instead.
     * @return {Resolution} The resolution.
     */
    getResolution() {
      return this.resolution
    }
    /**
     * Renders the luminance.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */
    render(e, A, I, g, C) {
      const i = this.fullscreenMaterial
      ;((i.inputBuffer = A.texture),
        e.setRenderTarget(this.renderToScreen ? null : this.renderTarget),
        e.render(this.scene, this.camera))
    }
    /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {
      const I = this.resolution
      ;(I.setBaseSize(e, A), this.renderTarget.setSize(I.width, I.height))
    }
    /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - A renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */
    initialize(e, A, I) {
      I !== void 0 &&
        I !== Xo &&
        ((this.renderTarget.texture.type = I),
        (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1"))
    }
  },
  w$ = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#define WEIGHT_INNER 0.125
#define WEIGHT_OUTER 0.0555555
varying vec2 vUv;varying vec2 vUv00;varying vec2 vUv01;varying vec2 vUv02;varying vec2 vUv03;varying vec2 vUv04;varying vec2 vUv05;varying vec2 vUv06;varying vec2 vUv07;varying vec2 vUv08;varying vec2 vUv09;varying vec2 vUv10;varying vec2 vUv11;float clampToBorder(const in vec2 uv){return float(uv.s>=0.0&&uv.s<=1.0&&uv.t>=0.0&&uv.t<=1.0);}void main(){vec4 c=vec4(0.0);vec4 w=WEIGHT_INNER*vec4(clampToBorder(vUv00),clampToBorder(vUv01),clampToBorder(vUv02),clampToBorder(vUv03));c+=w.x*texture2D(inputBuffer,vUv00);c+=w.y*texture2D(inputBuffer,vUv01);c+=w.z*texture2D(inputBuffer,vUv02);c+=w.w*texture2D(inputBuffer,vUv03);w=WEIGHT_OUTER*vec4(clampToBorder(vUv04),clampToBorder(vUv05),clampToBorder(vUv06),clampToBorder(vUv07));c+=w.x*texture2D(inputBuffer,vUv04);c+=w.y*texture2D(inputBuffer,vUv05);c+=w.z*texture2D(inputBuffer,vUv06);c+=w.w*texture2D(inputBuffer,vUv07);w=WEIGHT_OUTER*vec4(clampToBorder(vUv08),clampToBorder(vUv09),clampToBorder(vUv10),clampToBorder(vUv11));c+=w.x*texture2D(inputBuffer,vUv08);c+=w.y*texture2D(inputBuffer,vUv09);c+=w.z*texture2D(inputBuffer,vUv10);c+=w.w*texture2D(inputBuffer,vUv11);c+=WEIGHT_OUTER*texture2D(inputBuffer,vUv);gl_FragColor=c;
#include <colorspace_fragment>
}`,
  G$ =
    "uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv00;varying vec2 vUv01;varying vec2 vUv02;varying vec2 vUv03;varying vec2 vUv04;varying vec2 vUv05;varying vec2 vUv06;varying vec2 vUv07;varying vec2 vUv08;varying vec2 vUv09;varying vec2 vUv10;varying vec2 vUv11;void main(){vUv=position.xy*0.5+0.5;vUv00=vUv+texelSize*vec2(-1.0,1.0);vUv01=vUv+texelSize*vec2(1.0,1.0);vUv02=vUv+texelSize*vec2(-1.0,-1.0);vUv03=vUv+texelSize*vec2(1.0,-1.0);vUv04=vUv+texelSize*vec2(-2.0,2.0);vUv05=vUv+texelSize*vec2(0.0,2.0);vUv06=vUv+texelSize*vec2(2.0,2.0);vUv07=vUv+texelSize*vec2(-2.0,0.0);vUv08=vUv+texelSize*vec2(2.0,0.0);vUv09=vUv+texelSize*vec2(-2.0,-2.0);vUv10=vUv+texelSize*vec2(0.0,-2.0);vUv11=vUv+texelSize*vec2(2.0,-2.0);gl_Position=vec4(position.xy,1.0,1.0);}",
  k$ = class extends VQ {
    /**
     * Constructs a new downsampling material.
     */
    constructor() {
      super({
        name: "DownsamplingMaterial",
        uniforms: {
          inputBuffer: new ki(null),
          texelSize: new ki(new ZI()),
        },
        blending: hE,
        toneMapped: !1,
        depthWrite: !1,
        depthTest: !1,
        fragmentShader: w$,
        vertexShader: G$,
      })
    }
    /**
     * The input buffer.
     *
     * @type {Texture}
     */
    set inputBuffer(e) {
      this.uniforms.inputBuffer.value = e
    }
    /**
     * Sets the size of this object.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {
      this.uniforms.texelSize.value.set(1 / e, 1 / A)
    }
  },
  M$ = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;uniform mediump sampler2D supportBuffer;
#else
uniform lowp sampler2D inputBuffer;uniform lowp sampler2D supportBuffer;
#endif
uniform float radius;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;varying vec2 vUv6;varying vec2 vUv7;void main(){vec4 c=vec4(0.0);c+=texture2D(inputBuffer,vUv0)*0.0625;c+=texture2D(inputBuffer,vUv1)*0.125;c+=texture2D(inputBuffer,vUv2)*0.0625;c+=texture2D(inputBuffer,vUv3)*0.125;c+=texture2D(inputBuffer,vUv)*0.25;c+=texture2D(inputBuffer,vUv4)*0.125;c+=texture2D(inputBuffer,vUv5)*0.0625;c+=texture2D(inputBuffer,vUv6)*0.125;c+=texture2D(inputBuffer,vUv7)*0.0625;vec4 baseColor=texture2D(supportBuffer,vUv);gl_FragColor=mix(baseColor,c,radius);
#include <colorspace_fragment>
}`,
  U$ =
    "uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;varying vec2 vUv6;varying vec2 vUv7;void main(){vUv=position.xy*0.5+0.5;vUv0=vUv+texelSize*vec2(-1.0,1.0);vUv1=vUv+texelSize*vec2(0.0,1.0);vUv2=vUv+texelSize*vec2(1.0,1.0);vUv3=vUv+texelSize*vec2(-1.0,0.0);vUv4=vUv+texelSize*vec2(1.0,0.0);vUv5=vUv+texelSize*vec2(-1.0,-1.0);vUv6=vUv+texelSize*vec2(0.0,-1.0);vUv7=vUv+texelSize*vec2(1.0,-1.0);gl_Position=vec4(position.xy,1.0,1.0);}",
  N$ = class extends VQ {
    /**
     * Constructs a new upsampling material.
     */
    constructor() {
      super({
        name: "UpsamplingMaterial",
        uniforms: {
          inputBuffer: new ki(null),
          supportBuffer: new ki(null),
          texelSize: new ki(new ZI()),
          radius: new ki(0.85),
        },
        blending: hE,
        toneMapped: !1,
        depthWrite: !1,
        depthTest: !1,
        fragmentShader: M$,
        vertexShader: U$,
      })
    }
    /**
     * The input buffer.
     *
     * @type {Texture}
     */
    set inputBuffer(e) {
      this.uniforms.inputBuffer.value = e
    }
    /**
     * A support buffer.
     *
     * @type {Texture}
     */
    set supportBuffer(e) {
      this.uniforms.supportBuffer.value = e
    }
    /**
     * The blur radius.
     *
     * @type {Number}
     */
    get radius() {
      return this.uniforms.radius.value
    }
    set radius(e) {
      this.uniforms.radius.value = e
    }
    /**
     * Sets the size of this object.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {
      this.uniforms.texelSize.value.set(1 / e, 1 / A)
    }
  },
  F$ = class extends qa {
    /**
     * Constructs a new mipmap blur pass.
     *
     * @param {Object} [options] - The options.
     */
    constructor() {
      ;(super("MipmapBlurPass"),
        (this.needsSwap = !1),
        (this.renderTarget = new BQ(1, 1, { depthBuffer: !1 })),
        (this.renderTarget.texture.name = "Upsampling.Mipmap0"),
        (this.downsamplingMipmaps = []),
        (this.upsamplingMipmaps = []),
        (this.downsamplingMaterial = new k$()),
        (this.upsamplingMaterial = new N$()),
        (this.resolution = new ZI()))
    }
    /**
     * A texture that contains the blurred result.
     *
     * @type {Texture}
     */
    get texture() {
      return this.renderTarget.texture
    }
    /**
     * The MIP levels. Default is 8.
     *
     * @type {Number}
     */
    get levels() {
      return this.downsamplingMipmaps.length
    }
    set levels(e) {
      if (this.levels !== e) {
        const A = this.renderTarget
        ;(this.dispose(), (this.downsamplingMipmaps = []), (this.upsamplingMipmaps = []))
        for (let I = 0; I < e; ++I) {
          const g = A.clone()
          ;((g.texture.name = "Downsampling.Mipmap" + I), this.downsamplingMipmaps.push(g))
        }
        this.upsamplingMipmaps.push(A)
        for (let I = 1, g = e - 1; I < g; ++I) {
          const C = A.clone()
          ;((C.texture.name = "Upsampling.Mipmap" + I), this.upsamplingMipmaps.push(C))
        }
        this.setSize(this.resolution.x, this.resolution.y)
      }
    }
    /**
     * The blur radius.
     *
     * @type {Number}
     */
    get radius() {
      return this.upsamplingMaterial.radius
    }
    set radius(e) {
      this.upsamplingMaterial.radius = e
    }
    /**
     * Renders the blur.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */
    render(e, A, I, g, C) {
      const { scene: i, camera: B } = this,
        { downsamplingMaterial: o, upsamplingMaterial: r } = this,
        { downsamplingMipmaps: s, upsamplingMipmaps: h } = this
      let S = A
      this.fullscreenMaterial = o
      for (let d = 0, w = s.length; d < w; ++d) {
        const M = s[d]
        ;(o.setSize(S.width, S.height),
          (o.inputBuffer = S.texture),
          e.setRenderTarget(M),
          e.render(i, B),
          (S = M))
      }
      this.fullscreenMaterial = r
      for (let d = h.length - 1; d >= 0; --d) {
        const w = h[d]
        ;(r.setSize(S.width, S.height),
          (r.inputBuffer = S.texture),
          (r.supportBuffer = s[d].texture),
          e.setRenderTarget(w),
          e.render(i, B),
          (S = w))
      }
    }
    /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {
      const I = this.resolution
      I.set(e, A)
      let g = I.width,
        C = I.height
      for (let i = 0, B = this.downsamplingMipmaps.length; i < B; ++i)
        ((g = Math.round(g * 0.5)),
          (C = Math.round(C * 0.5)),
          this.downsamplingMipmaps[i].setSize(g, C),
          i < this.upsamplingMipmaps.length && this.upsamplingMipmaps[i].setSize(g, C))
    }
    /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */
    initialize(e, A, I) {
      if (I !== void 0) {
        const g = this.downsamplingMipmaps.concat(this.upsamplingMipmaps)
        for (const C of g) C.texture.type = I
        if (I !== Xo)
          ((this.downsamplingMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1"),
            (this.upsamplingMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1"))
        else if (e !== null && e.outputColorSpace === zi)
          for (const C of g) C.texture.colorSpace = zi
      }
    }
    /**
     * Deletes internal render targets and textures.
     */
    dispose() {
      super.dispose()
      for (const e of this.downsamplingMipmaps.concat(this.upsamplingMipmaps)) e.dispose()
    }
  },
  Lm = class extends qr {
    /**
     * Constructs a new effect.
     *
     * @param {String} name - The name of this effect. Doesn't have to be unique.
     * @param {String} fragmentShader - The fragment shader. This shader is required.
     * @param {Object} [options] - Additional options.
     * @param {EffectAttribute} [options.attributes=EffectAttribute.NONE] - The effect attributes that determine the execution priority and resource requirements.
     * @param {BlendFunction} [options.blendFunction=BlendFunction.NORMAL] - The blend function of this effect.
     * @param {Map<String, String>} [options.defines] - Custom preprocessor macro definitions. Keys are names and values are code.
     * @param {Map<String, Uniform>} [options.uniforms] - Custom shader uniforms. Keys are names and values are uniforms.
     * @param {Set<WebGLExtension>} [options.extensions] - WebGL extensions.
     * @param {String} [options.vertexShader=null] - The vertex shader. Most effects don't need one.
     */
    constructor(
      e,
      A,
      {
        attributes: I = tu.NONE,
        blendFunction: g = Ve.NORMAL,
        defines: C = /* @__PURE__ */ new Map(),
        uniforms: i = /* @__PURE__ */ new Map(),
        extensions: B = null,
        vertexShader: o = null,
      } = {},
    ) {
      ;(super(),
        (this.name = e),
        (this.renderer = null),
        (this.attributes = I),
        (this.fragmentShader = A),
        (this.vertexShader = o),
        (this.defines = C),
        (this.uniforms = i),
        (this.extensions = B),
        (this.blendMode = new c$(g)),
        this.blendMode.addEventListener("change", (r) => this.setChanged()),
        (this._inputColorSpace = ru),
        (this._outputColorSpace = kl))
    }
    /**
     * The input color space.
     *
     * @type {ColorSpace}
     * @experimental
     */
    get inputColorSpace() {
      return this._inputColorSpace
    }
    /**
     * @type {ColorSpace}
     * @protected
     * @experimental
     */
    set inputColorSpace(e) {
      ;((this._inputColorSpace = e), this.setChanged())
    }
    /**
     * The output color space.
     *
     * Should only be changed if this effect converts the input colors to a different color space.
     *
     * @type {ColorSpace}
     * @experimental
     */
    get outputColorSpace() {
      return this._outputColorSpace
    }
    /**
     * @type {ColorSpace}
     * @protected
     * @experimental
     */
    set outputColorSpace(e) {
      ;((this._outputColorSpace = e), this.setChanged())
    }
    /**
     * Sets the main scene.
     *
     * @type {Scene}
     */
    set mainScene(e) {}
    /**
     * Sets the main camera.
     *
     * @type {Camera}
     */
    set mainCamera(e) {}
    /**
     * Returns the name of this effect.
     *
     * @deprecated Use name instead.
     * @return {String} The name.
     */
    getName() {
      return this.name
    }
    /**
     * Sets the renderer.
     *
     * @deprecated
     * @param {WebGLRenderer} renderer - The renderer.
     */
    setRenderer(e) {
      this.renderer = e
    }
    /**
     * Returns the preprocessor macro definitions.
     *
     * @deprecated Use defines instead.
     * @return {Map<String, String>} The extensions.
     */
    getDefines() {
      return this.defines
    }
    /**
     * Returns the uniforms of this effect.
     *
     * @deprecated Use uniforms instead.
     * @return {Map<String, Uniform>} The extensions.
     */
    getUniforms() {
      return this.uniforms
    }
    /**
     * Returns the WebGL extensions that are required by this effect.
     *
     * @deprecated Use extensions instead.
     * @return {Set<WebGLExtension>} The extensions.
     */
    getExtensions() {
      return this.extensions
    }
    /**
     * Returns the blend mode.
     *
     * The result of this effect will be blended with the result of the previous effect using this blend mode.
     *
     * @deprecated Use blendMode instead.
     * @return {BlendMode} The blend mode.
     */
    getBlendMode() {
      return this.blendMode
    }
    /**
     * Returns the effect attributes.
     *
     * @return {EffectAttribute} The attributes.
     */
    getAttributes() {
      return this.attributes
    }
    /**
     * Sets the effect attributes.
     *
     * Effects that have the same attributes will be executed in the order in which they were registered. Some attributes
     * imply a higher priority.
     *
     * @protected
     * @param {EffectAttribute} attributes - The attributes.
     */
    setAttributes(e) {
      ;((this.attributes = e), this.setChanged())
    }
    /**
     * Returns the fragment shader.
     *
     * @return {String} The fragment shader.
     */
    getFragmentShader() {
      return this.fragmentShader
    }
    /**
     * Sets the fragment shader.
     *
     * @protected
     * @param {String} fragmentShader - The fragment shader.
     */
    setFragmentShader(e) {
      ;((this.fragmentShader = e), this.setChanged())
    }
    /**
     * Returns the vertex shader.
     *
     * @return {String} The vertex shader.
     */
    getVertexShader() {
      return this.vertexShader
    }
    /**
     * Sets the vertex shader.
     *
     * @protected
     * @param {String} vertexShader - The vertex shader.
     */
    setVertexShader(e) {
      ;((this.vertexShader = e), this.setChanged())
    }
    /**
     * Informs the associated {@link EffectPass} that this effect requires a shader recompilation.
     *
     * Should be called after changing macros or extensions and after adding/removing uniforms.
     *
     * @protected
     */
    setChanged() {
      this.dispatchEvent({ type: "change" })
    }
    /**
     * Sets the depth texture.
     *
     * You may override this method if your effect requires direct access to the depth texture that is bound to the
     * associated {@link EffectPass}.
     *
     * @param {Texture} depthTexture - A depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
     */
    setDepthTexture(e, A = mD) {}
    /**
     * Updates this effect by performing supporting operations.
     *
     * This method is called by the {@link EffectPass} right before the main fullscreen render operation, even if the
     * blend function is set to `SKIP`.
     *
     * You may override this method if you need to update custom uniforms or render additional off-screen textures.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     */
    update(e, A, I) {}
    /**
     * Updates the size of this effect.
     *
     * You may override this method if you want to be informed about the size of the backbuffer/canvas.
     * This method is called before {@link initialize} and every time the size of the {@link EffectComposer} changes.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {}
    /**
     * Performs initialization tasks.
     *
     * This method is called when the associated {@link EffectPass} is added to an {@link EffectComposer}.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     * @example if(!alpha && frameBufferType === UnsignedByteType) { this.myRenderTarget.texture.format = RGBFormat; }
     */
    initialize(e, A, I) {}
    /**
     * Performs a shallow search for properties that define a dispose method and deletes them.
     *
     * The {@link EffectComposer} calls this method when it is being destroyed.
     */
    dispose() {
      for (const e of Object.keys(this)) {
        const A = this[e]
        ;(A instanceof BQ || A instanceof tQ || A instanceof pt || A instanceof qa) &&
          this[e].dispose()
      }
    }
  },
  R$ = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D map;
#else
uniform lowp sampler2D map;
#endif
uniform float intensity;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec4 texel=texture2D(map,uv);outputColor=vec4(texel.rgb*intensity,texel.a);}`,
  J$ = class extends Lm {
    /**
     * Constructs a new bloom effect.
     *
     * @param {Object} [options] - The options.
     * @param {BlendFunction} [options.blendFunction=BlendFunction.SCREEN] - The blend function of this effect.
     * @param {Number} [options.luminanceThreshold=0.9] - The luminance threshold. Raise this value to mask out darker elements in the scene.
     * @param {Number} [options.luminanceSmoothing=0.025] - Controls the smoothness of the luminance threshold.
     * @param {Boolean} [options.mipmapBlur=false] - Enables or disables mipmap blur.
     * @param {Number} [options.intensity=1.0] - The bloom intensity.
     * @param {Number} [options.radius=0.85] - The blur radius. Only applies to mipmap blur.
     * @param {Number} [options.levels=8] - The amount of MIP levels. Only applies to mipmap blur.
     * @param {KernelSize} [options.kernelSize=KernelSize.LARGE] - Deprecated. Use mipmapBlur instead.
     * @param {Number} [options.resolutionScale=0.5] - Deprecated. Use mipmapBlur instead.
     * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
     * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
     * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
     * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
     */
    constructor({
      blendFunction: e = Ve.SCREEN,
      luminanceThreshold: A = 0.9,
      luminanceSmoothing: I = 0.025,
      mipmapBlur: g = !1,
      intensity: C = 1,
      radius: i = 0.85,
      levels: B = 8,
      kernelSize: o = pL.LARGE,
      resolutionScale: r = 0.5,
      width: s = cE.AUTO_SIZE,
      height: h = cE.AUTO_SIZE,
      resolutionX: S = s,
      resolutionY: d = h,
    } = {}) {
      ;(super("BloomEffect", R$, {
        blendFunction: e,
        uniforms: /* @__PURE__ */ new Map([
          ["map", new ki(null)],
          ["intensity", new ki(C)],
        ]),
      }),
        (this.renderTarget = new BQ(1, 1, { depthBuffer: !1 })),
        (this.renderTarget.texture.name = "Bloom.Target"),
        (this.blurPass = new f$({ kernelSize: o })),
        (this.luminancePass = new p$({ colorOutput: !0 })),
        (this.luminanceMaterial.threshold = A),
        (this.luminanceMaterial.smoothing = I),
        (this.mipmapBlurPass = new F$()),
        (this.mipmapBlurPass.enabled = g),
        (this.mipmapBlurPass.radius = i),
        (this.mipmapBlurPass.levels = B),
        (this.uniforms.get("map").value = g
          ? this.mipmapBlurPass.texture
          : this.renderTarget.texture))
      const w = (this.resolution = new cE(this, S, d, r))
      w.addEventListener("change", (M) => this.setSize(w.baseWidth, w.baseHeight))
    }
    /**
     * A texture that contains the intermediate result of this effect.
     *
     * @type {Texture}
     */
    get texture() {
      return this.mipmapBlurPass.enabled ? this.mipmapBlurPass.texture : this.renderTarget.texture
    }
    /**
     * Returns the generated bloom texture.
     *
     * @deprecated Use texture instead.
     * @return {Texture} The texture.
     */
    getTexture() {
      return this.texture
    }
    /**
     * Returns the resolution settings.
     *
     * @deprecated Use resolution instead.
     * @return {Resolution} The resolution.
     */
    getResolution() {
      return this.resolution
    }
    /**
     * Returns the blur pass.
     *
     * @deprecated
     * @return {KawaseBlurPass} The blur pass.
     */
    getBlurPass() {
      return this.blurPass
    }
    /**
     * Returns the luminance pass.
     *
     * @deprecated Use luminancePass instead.
     * @return {LuminancePass} The luminance pass.
     */
    getLuminancePass() {
      return this.luminancePass
    }
    /**
     * The luminance material.
     *
     * @type {LuminanceMaterial}
     */
    get luminanceMaterial() {
      return this.luminancePass.fullscreenMaterial
    }
    /**
     * Returns the luminance material.
     *
     * @deprecated Use luminanceMaterial instead.
     * @return {LuminanceMaterial} The material.
     */
    getLuminanceMaterial() {
      return this.luminancePass.fullscreenMaterial
    }
    /**
     * The current width of the internal render targets.
     *
     * @type {Number}
     * @deprecated
     */
    get width() {
      return this.resolution.width
    }
    set width(e) {
      this.resolution.preferredWidth = e
    }
    /**
     * The current height of the internal render targets.
     *
     * @type {Number}
     * @deprecated
     */
    get height() {
      return this.resolution.height
    }
    set height(e) {
      this.resolution.preferredHeight = e
    }
    /**
     * Indicates whether dithering is enabled.
     *
     * @type {Boolean}
     * @deprecated Use EffectPass.dithering instead.
     */
    get dithering() {
      return this.blurPass.dithering
    }
    set dithering(e) {
      this.blurPass.dithering = e
    }
    /**
     * The blur kernel size.
     *
     * @type {KernelSize}
     * @deprecated
     */
    get kernelSize() {
      return this.blurPass.kernelSize
    }
    set kernelSize(e) {
      this.blurPass.kernelSize = e
    }
    /**
     * @type {Number}
     * @deprecated
     */
    get distinction() {
      return (console.warn(this.name, "distinction was removed"), 1)
    }
    set distinction(e) {
      console.warn(this.name, "distinction was removed")
    }
    /**
     * The bloom intensity.
     *
     * @type {Number}
     */
    get intensity() {
      return this.uniforms.get("intensity").value
    }
    set intensity(e) {
      this.uniforms.get("intensity").value = e
    }
    /**
     * The bloom intensity.
     *
     * @deprecated Use intensity instead.
     * @return {Number} The intensity.
     */
    getIntensity() {
      return this.intensity
    }
    /**
     * Sets the bloom intensity.
     *
     * @deprecated Use intensity instead.
     * @param {Number} value - The intensity.
     */
    setIntensity(e) {
      this.intensity = e
    }
    /**
     * Returns the current resolution scale.
     *
     * @return {Number} The resolution scale.
     * @deprecated
     */
    getResolutionScale() {
      return this.resolution.scale
    }
    /**
     * Sets the resolution scale.
     *
     * @param {Number} scale - The new resolution scale.
     * @deprecated
     */
    setResolutionScale(e) {
      this.resolution.scale = e
    }
    /**
     * Updates this effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     */
    update(e, A, I) {
      const g = this.renderTarget,
        C = this.luminancePass
      C.enabled
        ? (C.render(e, A),
          this.mipmapBlurPass.enabled
            ? this.mipmapBlurPass.render(e, C.renderTarget)
            : this.blurPass.render(e, C.renderTarget, g))
        : this.mipmapBlurPass.enabled
          ? this.mipmapBlurPass.render(e, A)
          : this.blurPass.render(e, A, g)
    }
    /**
     * Updates the size of internal render targets.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {
      const I = this.resolution
      ;(I.setBaseSize(e, A),
        this.renderTarget.setSize(I.width, I.height),
        this.blurPass.resolution.copy(I),
        this.luminancePass.setSize(e, A),
        this.mipmapBlurPass.setSize(e, A))
    }
    /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */
    initialize(e, A, I) {
      ;(this.blurPass.initialize(e, A, I),
        this.luminancePass.initialize(e, A, I),
        this.mipmapBlurPass.initialize(e, A, I),
        I !== void 0 &&
          ((this.renderTarget.texture.type = I),
          e !== null && e.outputColorSpace === zi && (this.renderTarget.texture.colorSpace = zi)))
    }
  },
  jO = class extends qa {
    /**
     * Constructs a new render pass.
     *
     * @param {Scene} scene - The scene to render.
     * @param {Camera} camera - The camera to use to render the scene.
     * @param {Material} [overrideMaterial=null] - An override material.
     */
    constructor(e, A, I = null) {
      ;(super("RenderPass", e, A),
        (this.needsSwap = !1),
        (this.clearPass = new VO()),
        (this.overrideMaterialManager = I === null ? null : new bx(I)),
        (this.ignoreBackground = !1),
        (this.skipShadowMapUpdate = !1),
        (this.selection = null))
    }
    set mainScene(e) {
      this.scene = e
    }
    set mainCamera(e) {
      this.camera = e
    }
    get renderToScreen() {
      return super.renderToScreen
    }
    set renderToScreen(e) {
      ;((super.renderToScreen = e), (this.clearPass.renderToScreen = e))
    }
    /**
     * The current override material.
     *
     * @type {Material}
     */
    get overrideMaterial() {
      const e = this.overrideMaterialManager
      return e !== null ? e.material : null
    }
    set overrideMaterial(e) {
      const A = this.overrideMaterialManager
      e !== null
        ? A !== null
          ? A.setMaterial(e)
          : (this.overrideMaterialManager = new bx(e))
        : A !== null && (A.dispose(), (this.overrideMaterialManager = null))
    }
    /**
     * Returns the current override material.
     *
     * @deprecated Use overrideMaterial instead.
     * @return {Material} The material.
     */
    getOverrideMaterial() {
      return this.overrideMaterial
    }
    /**
     * Sets the override material.
     *
     * @deprecated Use overrideMaterial instead.
     * @return {Material} value - The material.
     */
    setOverrideMaterial(e) {
      this.overrideMaterial = e
    }
    /**
     * Indicates whether the target buffer should be cleared before rendering.
     *
     * @type {Boolean}
     * @deprecated Use clearPass.enabled instead.
     */
    get clear() {
      return this.clearPass.enabled
    }
    set clear(e) {
      this.clearPass.enabled = e
    }
    /**
     * Returns the selection. Default is `null` (no restriction).
     *
     * @deprecated Use selection instead.
     * @return {Selection} The selection.
     */
    getSelection() {
      return this.selection
    }
    /**
     * Sets the selection. Set to `null` to disable.
     *
     * @deprecated Use selection instead.
     * @param {Selection} value - The selection.
     */
    setSelection(e) {
      this.selection = e
    }
    /**
     * Indicates whether the scene background is disabled.
     *
     * @deprecated Use ignoreBackground instead.
     * @return {Boolean} Whether the scene background is disabled.
     */
    isBackgroundDisabled() {
      return this.ignoreBackground
    }
    /**
     * Enables or disables the scene background.
     *
     * @deprecated Use ignoreBackground instead.
     * @param {Boolean} value - Whether the scene background should be disabled.
     */
    setBackgroundDisabled(e) {
      this.ignoreBackground = e
    }
    /**
     * Indicates whether the shadow map auto update is disabled.
     *
     * @deprecated Use skipShadowMapUpdate instead.
     * @return {Boolean} Whether the shadow map update is disabled.
     */
    isShadowMapDisabled() {
      return this.skipShadowMapUpdate
    }
    /**
     * Enables or disables the shadow map auto update.
     *
     * @deprecated Use skipShadowMapUpdate instead.
     * @param {Boolean} value - Whether the shadow map auto update should be disabled.
     */
    setShadowMapDisabled(e) {
      this.skipShadowMapUpdate = e
    }
    /**
     * Returns the clear pass.
     *
     * @deprecated Use clearPass.enabled instead.
     * @return {ClearPass} The clear pass.
     */
    getClearPass() {
      return this.clearPass
    }
    /**
     * Renders the scene.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */
    render(e, A, I, g, C) {
      const i = this.scene,
        B = this.camera,
        o = this.selection,
        r = B.layers.mask,
        s = i.background,
        h = e.shadowMap.autoUpdate,
        S = this.renderToScreen ? null : A
      ;(o !== null && B.layers.set(o.getLayer()),
        this.skipShadowMapUpdate && (e.shadowMap.autoUpdate = !1),
        (this.ignoreBackground || this.clearPass.overrideClearColor !== null) &&
          (i.background = null),
        this.clearPass.enabled && this.clearPass.render(e, A),
        e.setRenderTarget(S),
        this.overrideMaterialManager !== null
          ? this.overrideMaterialManager.render(e, i, B)
          : e.render(i, B),
        (B.layers.mask = r),
        (i.background = s),
        (e.shadowMap.autoUpdate = h))
    }
  },
  K$ = `#include <packing>
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
#ifdef DOWNSAMPLE_NORMALS
uniform lowp sampler2D normalBuffer;
#endif
varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}int findBestDepth(const in float samples[4]){float c=(samples[0]+samples[1]+samples[2]+samples[3])*0.25;float distances[4];distances[0]=abs(c-samples[0]);distances[1]=abs(c-samples[1]);distances[2]=abs(c-samples[2]);distances[3]=abs(c-samples[3]);float maxDistance=max(max(distances[0],distances[1]),max(distances[2],distances[3]));int remaining[3];int rejected[3];int i,j,k;for(i=0,j=0,k=0;i<4;++i){if(distances[i]<maxDistance){remaining[j++]=i;}else{rejected[k++]=i;}}for(;j<3;++j){remaining[j]=rejected[--k];}vec3 s=vec3(samples[remaining[0]],samples[remaining[1]],samples[remaining[2]]);c=(s.x+s.y+s.z)/3.0;distances[0]=abs(c-s.x);distances[1]=abs(c-s.y);distances[2]=abs(c-s.z);float minDistance=min(distances[0],min(distances[1],distances[2]));for(i=0;i<3;++i){if(distances[i]==minDistance){break;}}return remaining[i];}void main(){float d[4];d[0]=readDepth(vUv0);d[1]=readDepth(vUv1);d[2]=readDepth(vUv2);d[3]=readDepth(vUv3);int index=findBestDepth(d);
#ifdef DOWNSAMPLE_NORMALS
vec3 n[4];n[0]=texture2D(normalBuffer,vUv0).rgb;n[1]=texture2D(normalBuffer,vUv1).rgb;n[2]=texture2D(normalBuffer,vUv2).rgb;n[3]=texture2D(normalBuffer,vUv3).rgb;
#else
vec3 n[4];n[0]=vec3(0.0);n[1]=vec3(0.0);n[2]=vec3(0.0);n[3]=vec3(0.0);
#endif
gl_FragColor=vec4(n[index],d[index]);}`,
  m$ =
    "uniform vec2 texelSize;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vUv0=uv;vUv1=vec2(uv.x,uv.y+texelSize.y);vUv2=vec2(uv.x+texelSize.x,uv.y);vUv3=uv+texelSize;gl_Position=vec4(position.xy,1.0,1.0);}",
  v$ = class extends VQ {
    /**
     * Constructs a new depth downsampling material.
     */
    constructor() {
      super({
        name: "DepthDownsamplingMaterial",
        defines: {
          DEPTH_PACKING: "0",
        },
        uniforms: {
          depthBuffer: new ki(null),
          normalBuffer: new ki(null),
          texelSize: new ki(new ZI()),
        },
        blending: hE,
        toneMapped: !1,
        depthWrite: !1,
        depthTest: !1,
        fragmentShader: K$,
        vertexShader: m$,
      })
    }
    /**
     * The depth buffer.
     *
     * @type {Texture}
     */
    set depthBuffer(e) {
      this.uniforms.depthBuffer.value = e
    }
    /**
     * The depth packing strategy.
     *
     * @type {DepthPackingStrategies}
     */
    set depthPacking(e) {
      ;((this.defines.DEPTH_PACKING = e.toFixed(0)), (this.needsUpdate = !0))
    }
    /**
     * Sets the depth buffer.
     *
     * @deprecated Use depthBuffer and depthPacking instead.
     * @param {Texture} buffer - The depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
     */
    setDepthBuffer(e, A = mD) {
      ;((this.depthBuffer = e), (this.depthPacking = A))
    }
    /**
     * The normal buffer.
     *
     * @type {Texture}
     */
    set normalBuffer(e) {
      ;((this.uniforms.normalBuffer.value = e),
        e !== null
          ? (this.defines.DOWNSAMPLE_NORMALS = "1")
          : delete this.defines.DOWNSAMPLE_NORMALS,
        (this.needsUpdate = !0))
    }
    /**
     * Sets the normal buffer.
     *
     * @deprecated Use normalBuffer instead.
     * @param {Texture} value - The normal buffer.
     */
    setNormalBuffer(e) {
      this.normalBuffer = e
    }
    /**
     * Sets the texel size.
     *
     * @deprecated Use setSize() instead.
     * @param {Number} x - The texel width.
     * @param {Number} y - The texel height.
     */
    setTexelSize(e, A) {
      this.uniforms.texelSize.value.set(e, A)
    }
    /**
     * Sets the size of this object.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {
      this.uniforms.texelSize.value.set(1 / e, 1 / A)
    }
  },
  L$ = class extends qa {
    /**
     * Constructs a new depth downsampling pass.
     *
     * @param {Object} [options] - The options.
     * @param {Texture} [options.normalBuffer=null] - A texture that contains view space normals. See {@link NormalPass}.
     * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
     * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
     * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
     * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
     * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
     */
    constructor({
      normalBuffer: e = null,
      resolutionScale: A = 0.5,
      width: I = cE.AUTO_SIZE,
      height: g = cE.AUTO_SIZE,
      resolutionX: C = I,
      resolutionY: i = g,
    } = {}) {
      super("DepthDownsamplingPass")
      const B = new v$()
      ;((B.normalBuffer = e),
        (this.fullscreenMaterial = B),
        (this.needsDepthTexture = !0),
        (this.needsSwap = !1),
        (this.renderTarget = new BQ(1, 1, {
          minFilter: iQ,
          magFilter: iQ,
          depthBuffer: !1,
          type: sE,
        })),
        (this.renderTarget.texture.name = "DepthDownsamplingPass.Target"),
        (this.renderTarget.texture.generateMipmaps = !1))
      const o = (this.resolution = new cE(this, C, i, A))
      o.addEventListener("change", (r) => this.setSize(o.baseWidth, o.baseHeight))
    }
    /**
     * The normal(RGB) + depth(A) texture.
     *
     * @type {Texture}
     */
    get texture() {
      return this.renderTarget.texture
    }
    /**
     * Returns the normal(RGB) + depth(A) texture.
     *
     * @deprecated Use texture instead.
     * @return {Texture} The texture.
     */
    getTexture() {
      return this.renderTarget.texture
    }
    /**
     * Returns the resolution settings.
     *
     * @deprecated Use resolution instead.
     * @return {Resolution} The resolution.
     */
    getResolution() {
      return this.resolution
    }
    /**
     * Sets the depth texture.
     *
     * @param {Texture} depthTexture - A depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
     */
    setDepthTexture(e, A = mD) {
      ;((this.fullscreenMaterial.depthBuffer = e), (this.fullscreenMaterial.depthPacking = A))
    }
    /**
     * Downsamples depth and scene normals.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */
    render(e, A, I, g, C) {
      ;(e.setRenderTarget(this.renderToScreen ? null : this.renderTarget),
        e.render(this.scene, this.camera))
    }
    /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {
      const I = this.resolution
      ;(I.setBaseSize(e, A),
        this.renderTarget.setSize(I.width, I.height),
        this.fullscreenMaterial.setSize(e, A))
    }
    /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */
    initialize(e, A, I) {
      const g = e.getContext()
      if (
        !(g.getExtension("EXT_color_buffer_float") || g.getExtension("EXT_color_buffer_half_float"))
      )
        throw new Error("Rendering to float texture is not supported.")
    }
  },
  Y$ = `#include <common>
#include <packing>
#include <dithering_pars_fragment>
#define packFloatToRGBA(v) packDepthToRGBA(v)
#define unpackRGBAToFloat(v) unpackRGBAToDepth(v)
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#if DEPTH_PACKING == 3201
uniform lowp sampler2D depthBuffer;
#elif defined(GL_FRAGMENT_PRECISION_HIGH)
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;vec4 sRGBToLinear(const in vec4 value){return vec4(mix(pow(value.rgb*0.9478672986+vec3(0.0521327014),vec3(2.4)),value.rgb*0.0773993808,vec3(lessThanEqual(value.rgb,vec3(0.04045)))),value.a);}float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}float getViewZ(const in float depth){
#ifdef PERSPECTIVE_CAMERA
return perspectiveDepthToViewZ(depth,cameraNear,cameraFar);
#else
return orthographicDepthToViewZ(depth,cameraNear,cameraFar);
#endif
}vec3 RGBToHCV(const in vec3 RGB){vec4 P=mix(vec4(RGB.bg,-1.0,2.0/3.0),vec4(RGB.gb,0.0,-1.0/3.0),step(RGB.b,RGB.g));vec4 Q=mix(vec4(P.xyw,RGB.r),vec4(RGB.r,P.yzx),step(P.x,RGB.r));float C=Q.x-min(Q.w,Q.y);float H=abs((Q.w-Q.y)/(6.0*C+EPSILON)+Q.z);return vec3(H,C,Q.x);}vec3 RGBToHSL(const in vec3 RGB){vec3 HCV=RGBToHCV(RGB);float L=HCV.z-HCV.y*0.5;float S=HCV.y/(1.0-abs(L*2.0-1.0)+EPSILON);return vec3(HCV.x,S,L);}vec3 HueToRGB(const in float H){float R=abs(H*6.0-3.0)-1.0;float G=2.0-abs(H*6.0-2.0);float B=2.0-abs(H*6.0-4.0);return clamp(vec3(R,G,B),0.0,1.0);}vec3 HSLToRGB(const in vec3 HSL){vec3 RGB=HueToRGB(HSL.x);float C=(1.0-abs(2.0*HSL.z-1.0))*HSL.y;return(RGB-0.5)*C+HSL.z;}FRAGMENT_HEAD void main(){FRAGMENT_MAIN_UV vec4 color0=texture2D(inputBuffer,UV);vec4 color1=vec4(0.0);FRAGMENT_MAIN_IMAGE color0.a=clamp(color0.a,0.0,1.0);gl_FragColor=color0;
#ifdef ENCODE_OUTPUT
#include <colorspace_fragment>
#endif
#include <dithering_fragment>
}`,
  q$ =
    "uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;VERTEX_HEAD void main(){vUv=position.xy*0.5+0.5;VERTEX_MAIN_SUPPORT gl_Position=vec4(position.xy,1.0,1.0);}",
  H$ = class extends VQ {
    /**
     * Constructs a new effect material.
     *
     * @param {Map<String, String>} [shaderParts] - Deprecated. Use setShaderData instead.
     * @param {Map<String, String>} [defines] - Deprecated. Use setShaderData instead.
     * @param {Map<String, Uniform>} [uniforms] - Deprecated. Use setShaderData instead.
     * @param {Camera} [camera] - A camera.
     * @param {Boolean} [dithering=false] - Deprecated.
     */
    constructor(e, A, I, g, C = !1) {
      ;(super({
        name: "EffectMaterial",
        defines: {
          THREE_REVISION: Wf.replace(/\D+/g, ""),
          DEPTH_PACKING: "0",
          ENCODE_OUTPUT: "1",
        },
        uniforms: {
          inputBuffer: new ki(null),
          depthBuffer: new ki(null),
          resolution: new ki(new ZI()),
          texelSize: new ki(new ZI()),
          cameraNear: new ki(0.3),
          cameraFar: new ki(1e3),
          aspect: new ki(1),
          time: new ki(0),
        },
        blending: hE,
        toneMapped: !1,
        depthWrite: !1,
        depthTest: !1,
        dithering: C,
      }),
        e && this.setShaderParts(e),
        A && this.setDefines(A),
        I && this.setUniforms(I),
        this.copyCameraSettings(g))
    }
    /**
     * The input buffer.
     *
     * @type {Texture}
     */
    set inputBuffer(e) {
      this.uniforms.inputBuffer.value = e
    }
    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Texture} value - The input buffer.
     */
    setInputBuffer(e) {
      this.uniforms.inputBuffer.value = e
    }
    /**
     * The depth buffer.
     *
     * @type {Texture}
     */
    get depthBuffer() {
      return this.uniforms.depthBuffer.value
    }
    set depthBuffer(e) {
      this.uniforms.depthBuffer.value = e
    }
    /**
     * The depth packing strategy.
     *
     * @type {DepthPackingStrategies}
     */
    get depthPacking() {
      return Number(this.defines.DEPTH_PACKING)
    }
    set depthPacking(e) {
      ;((this.defines.DEPTH_PACKING = e.toFixed(0)), (this.needsUpdate = !0))
    }
    /**
     * Sets the depth buffer.
     *
     * @deprecated Use depthBuffer and depthPacking instead.
     * @param {Texture} buffer - The depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
     */
    setDepthBuffer(e, A = mD) {
      ;((this.depthBuffer = e), (this.depthPacking = A))
    }
    /**
     * Sets the shader data.
     *
     * @param {EffectShaderData} data - The shader data.
     * @return {EffectMaterial} This material.
     */
    setShaderData(e) {
      ;(this.setShaderParts(e.shaderParts),
        this.setDefines(e.defines),
        this.setUniforms(e.uniforms),
        this.setExtensions(e.extensions))
    }
    /**
     * Sets the shader parts.
     *
     * @deprecated Use setShaderData instead.
     * @param {Map<String, String>} shaderParts - A collection of shader snippets. See {@link EffectShaderSection}.
     * @return {EffectMaterial} This material.
     */
    setShaderParts(e) {
      return (
        (this.fragmentShader = Y$.replace(mi.FRAGMENT_HEAD, e.get(mi.FRAGMENT_HEAD) || "")
          .replace(mi.FRAGMENT_MAIN_UV, e.get(mi.FRAGMENT_MAIN_UV) || "")
          .replace(mi.FRAGMENT_MAIN_IMAGE, e.get(mi.FRAGMENT_MAIN_IMAGE) || "")),
        (this.vertexShader = q$
          .replace(mi.VERTEX_HEAD, e.get(mi.VERTEX_HEAD) || "")
          .replace(mi.VERTEX_MAIN_SUPPORT, e.get(mi.VERTEX_MAIN_SUPPORT) || "")),
        (this.needsUpdate = !0),
        this
      )
    }
    /**
     * Sets the shader macros.
     *
     * @deprecated Use setShaderData instead.
     * @param {Map<String, String>} defines - A collection of preprocessor macro definitions.
     * @return {EffectMaterial} This material.
     */
    setDefines(e) {
      for (const A of e.entries()) this.defines[A[0]] = A[1]
      return ((this.needsUpdate = !0), this)
    }
    /**
     * Sets the shader uniforms.
     *
     * @deprecated Use setShaderData instead.
     * @param {Map<String, Uniform>} uniforms - A collection of uniforms.
     * @return {EffectMaterial} This material.
     */
    setUniforms(e) {
      for (const A of e.entries()) this.uniforms[A[0]] = A[1]
      return this
    }
    /**
     * Sets the required shader extensions.
     *
     * @deprecated Use setShaderData instead.
     * @param {Set<WebGLExtension>} extensions - A collection of extensions.
     * @return {EffectMaterial} This material.
     */
    setExtensions(e) {
      this.extensions = {}
      for (const A of e) this.extensions[A] = !0
      return this
    }
    /**
     * Indicates whether output encoding is enabled.
     *
     * @type {Boolean}
     */
    get encodeOutput() {
      return this.defines.ENCODE_OUTPUT !== void 0
    }
    set encodeOutput(e) {
      this.encodeOutput !== e &&
        (e ? (this.defines.ENCODE_OUTPUT = "1") : delete this.defines.ENCODE_OUTPUT,
        (this.needsUpdate = !0))
    }
    /**
     * Indicates whether output encoding is enabled.
     *
     * @deprecated Use encodeOutput instead.
     * @return {Boolean} Whether output encoding is enabled.
     */
    isOutputEncodingEnabled(e) {
      return this.encodeOutput
    }
    /**
     * Enables or disables output encoding.
     *
     * @deprecated Use encodeOutput instead.
     * @param {Boolean} value - Whether output encoding should be enabled.
     */
    setOutputEncodingEnabled(e) {
      this.encodeOutput = e
    }
    /**
     * The time in seconds.
     *
     * @type {Number}
     */
    get time() {
      return this.uniforms.time.value
    }
    set time(e) {
      this.uniforms.time.value = e
    }
    /**
     * Sets the delta time.
     *
     * @deprecated Use time instead.
     * @param {Number} value - The delta time in seconds.
     */
    setDeltaTime(e) {
      this.uniforms.time.value += e
    }
    /**
     * Copies the settings of the given camera.
     *
     * @deprecated Use copyCameraSettings instead.
     * @param {Camera} camera - A camera.
     */
    adoptCameraSettings(e) {
      this.copyCameraSettings(e)
    }
    /**
     * Copies the settings of the given camera.
     *
     * @param {Camera} camera - A camera.
     */
    copyCameraSettings(e) {
      e &&
        ((this.uniforms.cameraNear.value = e.near),
        (this.uniforms.cameraFar.value = e.far),
        e instanceof PQ
          ? (this.defines.PERSPECTIVE_CAMERA = "1")
          : delete this.defines.PERSPECTIVE_CAMERA,
        (this.needsUpdate = !0))
    }
    /**
     * Sets the resolution.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {
      const I = this.uniforms
      ;(I.resolution.value.set(e, A), I.texelSize.value.set(1 / e, 1 / A), (I.aspect.value = e / A))
    }
    /**
     * An enumeration of shader code placeholders.
     *
     * @deprecated Use EffectShaderSection instead.
     * @type {Object}
     */
    static get Section() {
      return mi
    }
  }
function Ox(e, A, I) {
  for (const g of A) {
    const C = "$1" + e + g.charAt(0).toUpperCase() + g.slice(1),
      i = new RegExp("([^\\.])(\\b" + g + "\\b)", "g")
    for (const B of I.entries()) B[1] !== null && I.set(B[0], B[1].replace(i, C))
  }
}
function T$(e, A, I) {
  let g = A.getFragmentShader(),
    C = A.getVertexShader()
  const i = g !== void 0 && /mainImage/.test(g),
    B = g !== void 0 && /mainUv/.test(g)
  if (((I.attributes |= A.getAttributes()), g === void 0))
    throw new Error(`Missing fragment shader (${A.name})`)
  if (B && I.attributes & tu.CONVOLUTION)
    throw new Error(
      `Effects that transform UVs are incompatible with convolution effects (${A.name})`,
    )
  if (!i && !B) throw new Error(`Could not find mainImage or mainUv function (${A.name})`)
  {
    const o = /\w+\s+(\w+)\([\w\s,]*\)\s*{/g,
      r = I.shaderParts
    let s = r.get(mi.FRAGMENT_HEAD) || "",
      h = r.get(mi.FRAGMENT_MAIN_UV) || "",
      S = r.get(mi.FRAGMENT_MAIN_IMAGE) || "",
      d = r.get(mi.VERTEX_HEAD) || "",
      w = r.get(mi.VERTEX_MAIN_SUPPORT) || ""
    const M = /* @__PURE__ */ new Set(),
      K = /* @__PURE__ */ new Set()
    if (
      (B &&
        ((h += `	${e}MainUv(UV);
`),
        (I.uvTransformation = !0)),
      C !== null && /mainSupport/.test(C))
    ) {
      const L = /mainSupport *\([\w\s]*?uv\s*?\)/.test(C)
      ;((w += `	${e}MainSupport(`),
        (w += L
          ? `vUv);
`
          : `);
`))
      for (const Y of C.matchAll(/(?:varying\s+\w+\s+([\S\s]*?);)/g))
        for (const H of Y[1].split(/\s*,\s*/)) (I.varyings.add(H), M.add(H), K.add(H))
      for (const Y of C.matchAll(o)) K.add(Y[1])
    }
    for (const L of g.matchAll(o)) K.add(L[1])
    for (const L of A.defines.keys()) K.add(L.replace(/\([\w\s,]*\)/g, ""))
    for (const L of A.uniforms.keys()) K.add(L)
    ;(K.delete("while"),
      K.delete("for"),
      K.delete("if"),
      A.uniforms.forEach((L, Y) => I.uniforms.set(e + Y.charAt(0).toUpperCase() + Y.slice(1), L)),
      A.defines.forEach((L, Y) => I.defines.set(e + Y.charAt(0).toUpperCase() + Y.slice(1), L)))
    const R = /* @__PURE__ */ new Map([
      ["fragment", g],
      ["vertex", C],
    ])
    ;(Ox(e, K, I.defines), Ox(e, K, R), (g = R.get("fragment")), (C = R.get("vertex")))
    const F = A.blendMode
    if ((I.blendModes.set(F.blendFunction, F), i)) {
      ;(A.inputColorSpace !== null &&
        A.inputColorSpace !== I.colorSpace &&
        (S +=
          A.inputColorSpace === zi
            ? `color0 = sRGBTransferOETF(color0);
	`
            : `color0 = sRGBToLinear(color0);
	`),
        A.outputColorSpace !== kl
          ? (I.colorSpace = A.outputColorSpace)
          : A.inputColorSpace !== null && (I.colorSpace = A.inputColorSpace))
      const L = /MainImage *\([\w\s,]*?depth[\w\s,]*?\)/
      ;((S += `${e}MainImage(color0, UV, `),
        I.attributes & tu.DEPTH && L.test(g) && ((S += "depth, "), (I.readDepth = !0)),
        (S += `color1);
	`))
      const Y = e + "BlendOpacity"
      ;(I.uniforms.set(Y, F.opacity),
        (S += `color0 = blend${F.blendFunction}(color0, color1, ${Y});

	`),
        (s += `uniform float ${Y};

`))
    }
    if (
      ((s +=
        g +
        `
`),
      C !== null &&
        (d +=
          C +
          `
`),
      r.set(mi.FRAGMENT_HEAD, s),
      r.set(mi.FRAGMENT_MAIN_UV, h),
      r.set(mi.FRAGMENT_MAIN_IMAGE, S),
      r.set(mi.VERTEX_HEAD, d),
      r.set(mi.VERTEX_MAIN_SUPPORT, w),
      A.extensions !== null)
    )
      for (const L of A.extensions) I.extensions.add(L)
  }
}
var x$ = class extends qa {
    /**
     * Constructs a new effect pass.
     *
     * @param {Camera} camera - The main camera.
     * @param {...Effect} effects - The effects that will be rendered by this pass.
     */
    constructor(e, ...A) {
      ;(super("EffectPass"),
        (this.fullscreenMaterial = new H$(null, null, null, e)),
        (this.listener = (I) => this.handleEvent(I)),
        (this.effects = []),
        this.setEffects(A),
        (this.skipRendering = !1),
        (this.minTime = 1),
        (this.maxTime = Number.POSITIVE_INFINITY),
        (this.timeScale = 1))
    }
    set mainScene(e) {
      for (const A of this.effects) A.mainScene = e
    }
    set mainCamera(e) {
      this.fullscreenMaterial.copyCameraSettings(e)
      for (const A of this.effects) A.mainCamera = e
    }
    /**
     * Indicates whether this pass encodes its output when rendering to screen.
     *
     * @type {Boolean}
     * @deprecated Use fullscreenMaterial.encodeOutput instead.
     */
    get encodeOutput() {
      return this.fullscreenMaterial.encodeOutput
    }
    set encodeOutput(e) {
      this.fullscreenMaterial.encodeOutput = e
    }
    /**
     * Indicates whether dithering is enabled.
     *
     * @type {Boolean}
     */
    get dithering() {
      return this.fullscreenMaterial.dithering
    }
    set dithering(e) {
      const A = this.fullscreenMaterial
      ;((A.dithering = e), (A.needsUpdate = !0))
    }
    /**
     * Sets the effects.
     *
     * @param {Effect[]} effects - The effects.
     * @protected
     */
    setEffects(e) {
      for (const A of this.effects) A.removeEventListener("change", this.listener)
      this.effects = e.sort((A, I) => I.attributes - A.attributes)
      for (const A of this.effects) A.addEventListener("change", this.listener)
    }
    /**
     * Updates the compound shader material.
     *
     * @protected
     */
    updateMaterial() {
      const e = new v7()
      let A = 0
      for (const B of this.effects)
        if (B.blendMode.blendFunction === Ve.DST) e.attributes |= B.getAttributes() & tu.DEPTH
        else {
          if (e.attributes & B.getAttributes() & tu.CONVOLUTION)
            throw new Error(`Convolution effects cannot be merged (${B.name})`)
          T$("e" + A++, B, e)
        }
      let I = e.shaderParts.get(mi.FRAGMENT_HEAD),
        g = e.shaderParts.get(mi.FRAGMENT_MAIN_IMAGE),
        C = e.shaderParts.get(mi.FRAGMENT_MAIN_UV)
      const i = /\bblend\b/g
      for (const B of e.blendModes.values())
        I +=
          B.getShaderCode().replace(i, `blend${B.blendFunction}`) +
          `
`
      ;(e.attributes & tu.DEPTH
        ? (e.readDepth &&
            (g =
              `float depth = readDepth(UV);

	` + g),
          (this.needsDepthTexture = this.getDepthTexture() === null))
        : (this.needsDepthTexture = !1),
        e.colorSpace === zi &&
          (g += `color0 = sRGBToLinear(color0);
	`),
        e.uvTransformation
          ? ((C =
              `vec2 transformedUv = vUv;
` + C),
            e.defines.set("UV", "transformedUv"))
          : e.defines.set("UV", "vUv"),
        e.shaderParts.set(mi.FRAGMENT_HEAD, I),
        e.shaderParts.set(mi.FRAGMENT_MAIN_IMAGE, g),
        e.shaderParts.set(mi.FRAGMENT_MAIN_UV, C))
      for (const [B, o] of e.shaderParts)
        o !== null &&
          e.shaderParts.set(
            B,
            o.trim().replace(
              /^#/,
              `
#`,
            ),
          )
      ;((this.skipRendering = A === 0),
        (this.needsSwap = !this.skipRendering),
        this.fullscreenMaterial.setShaderData(e))
    }
    /**
     * Rebuilds the shader material.
     */
    recompile() {
      this.updateMaterial()
    }
    /**
     * Returns the current depth texture.
     *
     * @return {Texture} The current depth texture, or null if there is none.
     */
    getDepthTexture() {
      return this.fullscreenMaterial.depthBuffer
    }
    /**
     * Sets the depth texture.
     *
     * @param {Texture} depthTexture - A depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
     */
    setDepthTexture(e, A = mD) {
      ;((this.fullscreenMaterial.depthBuffer = e), (this.fullscreenMaterial.depthPacking = A))
      for (const I of this.effects) I.setDepthTexture(e, A)
    }
    /**
     * Renders the effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */
    render(e, A, I, g, C) {
      for (const i of this.effects) i.update(e, A, g)
      if (!this.skipRendering || this.renderToScreen) {
        const i = this.fullscreenMaterial
        ;((i.inputBuffer = A.texture),
          (i.time += g * this.timeScale),
          e.setRenderTarget(this.renderToScreen ? null : I),
          e.render(this.scene, this.camera))
      }
    }
    /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {
      this.fullscreenMaterial.setSize(e, A)
      for (const I of this.effects) I.setSize(e, A)
    }
    /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */
    initialize(e, A, I) {
      this.renderer = e
      for (const g of this.effects) g.initialize(e, A, I)
      ;(this.updateMaterial(),
        I !== void 0 &&
          I !== Xo &&
          (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1"))
    }
    /**
     * Deletes disposable objects.
     */
    dispose() {
      super.dispose()
      for (const e of this.effects) (e.removeEventListener("change", this.listener), e.dispose())
    }
    /**
     * Handles events.
     *
     * @param {Event} event - An event.
     */
    handleEvent(e) {
      switch (e.type) {
        case "change":
          this.recompile()
          break
      }
    }
  },
  b$ = class extends qa {
    /**
     * Constructs a new normal pass.
     *
     * @param {Scene} scene - The scene to render.
     * @param {Camera} camera - The camera to use to render the scene.
     * @param {Object} [options] - The options.
     * @param {WebGLRenderTarget} [options.renderTarget] - A custom render target.
     * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
     * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
     * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
     * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
     * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
     */
    constructor(
      e,
      A,
      {
        renderTarget: I,
        resolutionScale: g = 1,
        width: C = cE.AUTO_SIZE,
        height: i = cE.AUTO_SIZE,
        resolutionX: B = C,
        resolutionY: o = i,
      } = {},
    ) {
      ;(super("NormalPass"), (this.needsSwap = !1), (this.renderPass = new jO(e, A, new cv())))
      const r = this.renderPass
      ;((r.ignoreBackground = !0), (r.skipShadowMapUpdate = !0))
      const s = r.getClearPass()
      ;((s.overrideClearColor = new Mg(7829503)),
        (s.overrideClearAlpha = 1),
        (this.renderTarget = I),
        this.renderTarget === void 0 &&
          ((this.renderTarget = new BQ(1, 1, {
            minFilter: iQ,
            magFilter: iQ,
          })),
          (this.renderTarget.texture.name = "NormalPass.Target")))
      const h = (this.resolution = new cE(this, B, o, g))
      h.addEventListener("change", (S) => this.setSize(h.baseWidth, h.baseHeight))
    }
    set mainScene(e) {
      this.renderPass.mainScene = e
    }
    set mainCamera(e) {
      this.renderPass.mainCamera = e
    }
    /**
     * The normal texture.
     *
     * @type {Texture}
     */
    get texture() {
      return this.renderTarget.texture
    }
    /**
     * The normal texture.
     *
     * @deprecated Use texture instead.
     * @return {Texture} The texture.
     */
    getTexture() {
      return this.renderTarget.texture
    }
    /**
     * Returns the resolution settings.
     *
     * @deprecated Use resolution instead.
     * @return {Resolution} The resolution.
     */
    getResolution() {
      return this.resolution
    }
    /**
     * Returns the current resolution scale.
     *
     * @return {Number} The resolution scale.
     * @deprecated Use resolution.preferredWidth or resolution.preferredHeight instead.
     */
    getResolutionScale() {
      return this.resolution.scale
    }
    /**
     * Sets the resolution scale.
     *
     * @param {Number} scale - The new resolution scale.
     * @deprecated Use resolution.preferredWidth or resolution.preferredHeight instead.
     */
    setResolutionScale(e) {
      this.resolution.scale = e
    }
    /**
     * Renders the scene normals.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */
    render(e, A, I, g, C) {
      const i = this.renderToScreen ? null : this.renderTarget
      this.renderPass.render(e, i, i)
    }
    /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */
    setSize(e, A) {
      const I = this.resolution
      ;(I.setBaseSize(e, A), this.renderTarget.setSize(I.width, I.height))
    }
  }
const O$ = xI.createContext(null),
  _x = (e) => (e.getAttributes() & tu.CONVOLUTION) === tu.CONVOLUTION,
  _$ = HC.memo(
    xI.forwardRef(
      (
        {
          children: e,
          camera: A,
          scene: I,
          resolutionScale: g,
          enabled: C = !0,
          renderPriority: i = 1,
          autoClear: B = !0,
          depthBuffer: o,
          enableNormalPass: r,
          stencilBuffer: s,
          multisampling: h = 8,
          frameBufferType: S = KD,
        },
        d,
      ) => {
        const { gl: w, scene: M, camera: K, size: R } = Ya(),
          F = I || M,
          L = A || K,
          [Y, H, V] = xI.useMemo(() => {
            const X = uX(),
              _ = new m7(w, {
                depthBuffer: o,
                stencilBuffer: s,
                multisampling: h > 0 && X ? h : 0,
                frameBufferType: S,
              })
            _.addPass(new jO(F, L))
            let eA = null,
              CA = null
            return (
              r &&
                ((CA = new b$(F, L)),
                (CA.enabled = !1),
                _.addPass(CA),
                g !== void 0 &&
                  X &&
                  ((eA = new L$({ normalBuffer: CA.texture, resolutionScale: g })),
                  (eA.enabled = !1),
                  _.addPass(eA))),
              [_, CA, eA]
            )
          }, [L, w, o, s, h, S, F, r, g])
        ;(xI.useEffect(() => Y?.setSize(R.width, R.height), [Y, R]),
          Mp(
            (X, _) => {
              if (C) {
                const eA = w.autoClear
                ;((w.autoClear = B), s && !B && w.clearStencil(), Y.render(_), (w.autoClear = eA))
              }
            },
            C ? i : 0,
          ))
        const j = xI.useRef(null),
          P = Wz(j)
        ;(xI.useLayoutEffect(() => {
          const X = []
          if (j.current && P.current && Y) {
            const _ = P.current.objects
            for (let eA = 0; eA < _.length; eA++) {
              const CA = _[eA]
              if (CA instanceof Lm) {
                const aA = [CA]
                if (!_x(CA)) {
                  let JA = null
                  for (; (JA = _[eA + 1]) instanceof Lm && !_x(JA); ) (aA.push(JA), eA++)
                }
                const lA = new x$(L, ...aA)
                X.push(lA)
              } else CA instanceof qa && X.push(CA)
            }
            for (const eA of X) Y?.addPass(eA)
            ;(H && (H.enabled = !0), V && (V.enabled = !0))
          }
          return () => {
            for (const _ of X) Y?.removePass(_)
            ;(H && (H.enabled = !1), V && (V.enabled = !1))
          }
        }, [Y, e, L, H, V, P]),
          xI.useEffect(() => {
            const X = w.toneMapping
            return (
              (w.toneMapping = Ms),
              () => {
                w.toneMapping = X
              }
            )
          }, []))
        const AA = xI.useMemo(
          () => ({
            composer: Y,
            normalPass: H,
            downSamplingPass: V,
            resolutionScale: g,
            camera: L,
            scene: F,
          }),
          [Y, H, V, g, L, F],
        )
        return (
          xI.useImperativeHandle(d, () => Y, [Y]),
          /* @__PURE__ */ qC.jsx(O$.Provider, {
            value: AA,
            children: /* @__PURE__ */ qC.jsx("group", { ref: j, children: e }),
          })
        )
      },
    ),
  )
let Z$ = 0
const Zx = /* @__PURE__ */ new WeakMap(),
  P$ = (e, A) =>
    /* @__PURE__ */ HC.forwardRef(function (
      { blendFunction: g = A?.blendFunction, opacity: C = A?.opacity, ...i },
      B,
    ) {
      let o = Zx.get(e)
      if (!o) {
        const h = `@react-three/postprocessing/${e.name}-${Z$++}`
        ;(Jv({ [h]: e }), Zx.set(e, (o = h)))
      }
      const r = Ya((h) => h.camera),
        s = HC.useMemo(
          () => {
            var h, S
            return [
              ...((h = A?.args) != null ? h : []),
              ...((S = i.args) != null ? S : [{ ...A, ...i }]),
            ]
          },
          // eslint-disable-next-line react-hooks/exhaustive-deps
          [JSON.stringify(i)],
        )
      return /* @__PURE__ */ qC.jsx(o, {
        camera: r,
        "blendMode-blendFunction": g,
        "blendMode-opacity-value": C,
        ...i,
        ref: B,
        args: s,
      })
    }),
  W$ = P$(J$, {
    blendFunction: Ve.ADD,
  }),
  Px = ({ color: e = "black", children: A, ...I }) =>
    /* @__PURE__ */ qC.jsx(X9, {
      font: "/fonts/trade-gothic-bold-condensed.woff",
      anchorX: "left",
      anchorY: "top",
      fontSize: 1.25,
      color: e,
      lineHeight: 0.9,
      ...I,
      children: A,
    }),
  V$ = ({ headline: e, ...A }) => {
    const I = HC.useRef(null),
      g = Ya(),
      C = g.size.width <= 768 ? 24 : 48,
      i = (C / g.size.width) * g.viewport.width,
      o = -g.viewport.width / 2 + i,
      r = (C / g.size.height) * g.viewport.height,
      h = g.viewport.height / 2 - r,
      S = Math.min(g.viewport.width / 9.5, 0.625),
      d = g.size.width <= 768 ? 4 : 8
    return /* @__PURE__ */ qC.jsxs("group", {
      ref: I,
      scale: S,
      "position-y": h,
      "position-x": o,
      ...A,
      children: [
        /* @__PURE__ */ qC.jsx(Px, { maxWidth: 8, children: e.primary.toUpperCase() }),
        /* @__PURE__ */ qC.jsx(Px, {
          maxWidth: d,
          lineHeight: 1,
          color: "#b9b9b9",
          position: [0, -1.25, 0],
          children: e.secondary.toUpperCase(),
        }),
      ],
    })
  },
  SB = {
    depth: 3,
    thickness: 1.5,
  },
  j$ = "data-content",
  z$ = "data-override",
  X$ = () =>
    /* @__PURE__ */ qC.jsx("directionalLight", {
      castShadow: !0,
      intensity: 1,
      color: "#fff",
      "shadow-mapSize": [1280, 1280],
      position: [1.25, -0.25, 6],
    })
var mr
;((e) => {
  function A(i) {
    if (i.length === 0) throw new Error("Cannot get random index from empty array")
    const B = Math.floor(Math.random() * i.length)
    return i.at(B)
  }
  e.pickRandom = A
  function I(i) {
    if (i)
      try {
        return JSON.parse(i)
      } catch {
        return
      }
  }
  e.safeJsonParse = I
  function g(i, B, o) {
    return Math.max(B, Math.min(o, i))
  }
  e.clamp = g
  function C(i, B) {
    return Math.random() * (B - i) + i
  }
  e.rand = C
})(mr || (mr = {}))
const Wx = 0.65,
  $$ = ({ vec: e = new wA() }) => {
    const A = HC.useRef(null),
      I = Ya()
    return (
      Mp(({ pointer: g, viewport: C }) => {
        if (!A.current) return
        const i = (g.x * C.width) / 2,
          B = (g.y * C.height) / 2,
          o = SB.depth / 2,
          r = (I.viewport.width / 2) * Wx,
          s = (I.viewport.height / 2) * Wx,
          h = mr.clamp(i, -r, r),
          S = mr.clamp(B, -s, s)
        A.current.setNextKinematicTranslation(e.set(h, S, o))
      }),
      /* @__PURE__ */ qC.jsx(OG, {
        position: [0, 0, 1],
        type: "kinematicPosition",
        colliders: !1,
        ref: A,
        density: 0.1,
        children:
          I.size.width > 768 && /* @__PURE__ */ qC.jsx(dD, { args: [0.1, 0.1, SB.depth / 2] }),
      })
    )
  },
  AAA = () => {
    const e = Ya(),
      A = e.viewport.width / 2,
      I = e.viewport.height / 2
    return /* @__PURE__ */ qC.jsxs(OG, {
      type: "fixed",
      children: [
        /* @__PURE__ */ qC.jsx(dD, {
          name: "front-wall",
          args: [A, I, SB.thickness],
          position: [0, 0, SB.thickness + SB.depth],
        }),
        /* @__PURE__ */ qC.jsx(dD, {
          name: "back-wall",
          args: [A, I, SB.thickness],
          position: [0, 0, -SB.thickness],
        }),
        /* @__PURE__ */ qC.jsx(dD, {
          name: "right-wall",
          args: [SB.thickness, I, SB.depth / 2],
          position: [A + SB.thickness, 0, SB.depth / 2],
        }),
        /* @__PURE__ */ qC.jsx(dD, {
          name: "left-wall",
          args: [SB.thickness, I, SB.depth / 2],
          position: [-(A + SB.thickness), 0, SB.depth / 2],
        }),
        /* @__PURE__ */ qC.jsx(dD, {
          name: "top-wall",
          args: [A, SB.thickness, SB.depth / 2],
          position: [0, I + SB.thickness, SB.depth / 2],
        }),
        /* @__PURE__ */ qC.jsx(dD, {
          name: "bottom-wall",
          args: [A, SB.thickness, SB.depth / 2],
          position: [0, -(I + SB.thickness), SB.depth / 2],
        }),
      ],
    })
  },
  zO = "/w.glb",
  ds = { DELTA: 1.5, ROTATE: 0.4 },
  om = 1,
  nm = 625e-5,
  Vx = ({ name: e, ...A }) => {
    const I = HC.useRef(!0),
      g = HC.useRef(null),
      C = HC.useRef(Math.random() * 1e4),
      i = HC.useRef(null),
      B = HC.useRef(!1),
      { nodes: o } = TG(zO),
      r = Ya()
    function s() {
      i.current &&
        (r.size.width > 768 ||
          (g.current && clearTimeout(g.current),
          i.current.applyImpulse(
            {
              x: mr.rand(-ds.DELTA, ds.DELTA),
              y: mr.rand(-ds.DELTA, ds.DELTA),
              z: mr.rand(-ds.DELTA, ds.DELTA),
            },
            !0,
          ),
          i.current.applyTorqueImpulse(
            {
              x: mr.rand(-ds.ROTATE, ds.ROTATE),
              y: mr.rand(-ds.ROTATE, ds.ROTATE),
              z: mr.rand(-ds.ROTATE, ds.ROTATE),
            },
            !0,
          ),
          (I.current = !1),
          (g.current = setTimeout(() => (I.current = !0), 1e3))))
    }
    Mp((d) => {
      if (!i.current) return
      const w = r.size.width <= 768 ? 25e-4 : 625e-5,
        M = new wA().copy(i.current.translation()).negate().multiplyScalar(w)
      i.current.applyImpulse(M, !0)
      const K = i.current.rotation(),
        R = C.current + d.clock.getElapsedTime(),
        F = (Math.cos((R / 4) * om) / 8) * nm,
        L = (Math.sin((R / 4) * om) / 8) * nm,
        Y = (Math.sin((R / 4) * om) / 20) * nm
      ;((K.x += F), (K.y += L), (K.z += Y), i.current.setRotation(K, !0))
    })
    function h(d) {
      d.other.colliderObject?.name || (B.current = !0)
    }
    const S = Math.min(r.viewport.width / 0.165, 20)
    return /* @__PURE__ */ qC.jsx(OG, {
      ref: i,
      linearDamping: 4,
      angularDamping: 4,
      restitution: 0.5,
      ccd: !0,
      density: 2,
      colliders: "hull",
      onCollisionEnter: h,
      onCollisionExit: () => (B.current = !1),
      ...A,
      children: /* @__PURE__ */ qC.jsx("mesh", {
        geometry: o.Extrude.geometry,
        onClick: s,
        scale: S,
        name: e,
        castShadow: !0,
        children: /* @__PURE__ */ qC.jsx(Q6, {
          transmission: 1,
          thickness: 0.05,
          roughness: 0,
          ior: 2,
          chromaticAberration: 0.1,
          anisotropy: 0.25,
          clearcoat: 1,
          color: "#fff",
        }),
      }),
    })
  }
TG.preload(zO)
const IAA = () => {
    const e = Ya(),
      A = e.viewport.width / 2,
      I = e.viewport.height / 2,
      g = A / 3,
      C = I / 3
    return /* @__PURE__ */ qC.jsxs(qC.Fragment, {
      children: [
        /* @__PURE__ */ qC.jsx(Vx, { position: [-g, C, 1], name: "left-letter" }),
        /* @__PURE__ */ qC.jsx(Vx, { position: [g, -C, 1], name: "right-letter" }),
      ],
    })
  },
  gAA = ({ headlines: e, override: A, height: I }) => {
    const g = i6(),
      C = A ?? mr.pickRandom(e)
    return /* @__PURE__ */ qC.jsx(hX, {
      style: {
        height: I ?? "100dvh",
        width: "100dvw",
      },
      shadows: !0,
      dpr: g.tier < 3 ? 1 : [1, 1.5],
      gl: { antialias: !1 },
      camera: { position: [0, 0, 15], fov: 17.5, near: 1, far: 200 },
      children: /* @__PURE__ */ qC.jsxs(xI.Suspense, {
        children: [
          /* @__PURE__ */ qC.jsx("color", { attach: "background", args: ["#fff"] }),
          /* @__PURE__ */ qC.jsx("ambientLight", { intensity: 0.4 }),
          /* @__PURE__ */ qC.jsx(X$, {}),
          /* @__PURE__ */ qC.jsx(n6, { size: 25, samples: 5, focus: 0 }),
          /* @__PURE__ */ qC.jsxs("mesh", {
            receiveShadow: !0,
            position: [0, 0, -(SB.thickness + 0.25)],
            scale: 10,
            children: [
              /* @__PURE__ */ qC.jsx("planeGeometry", {}),
              /* @__PURE__ */ qC.jsx("shadowMaterial", { color: "#f1f1f1" }),
            ],
          }),
          /* @__PURE__ */ qC.jsxs(Q7, {
            gravity: [0, 0, 1],
            children: [
              /* @__PURE__ */ qC.jsx($$, {}),
              /* @__PURE__ */ qC.jsx(IAA, {}),
              /* @__PURE__ */ qC.jsx(AAA, {}),
            ],
          }),
          /* @__PURE__ */ qC.jsx(V$, { headline: C }),
          /* @__PURE__ */ qC.jsx(_$, {
            children: /* @__PURE__ */ qC.jsx(W$, { luminanceThreshold: 1, intensity: 0.15 }),
          }),
        ],
      }),
    })
  }
var Em
function XO(e) {
  return {
    lang: e?.lang ?? Em?.lang,
    message: e?.message,
    abortEarly: e?.abortEarly ?? Em?.abortEarly,
    abortPipeEarly: e?.abortPipeEarly ?? Em?.abortPipeEarly,
  }
}
var CAA
function eAA(e) {
  return CAA?.get(e)
}
var iAA
function tAA(e) {
  return iAA?.get(e)
}
var BAA
function QAA(e, A) {
  return BAA?.get(e)?.get(A)
}
function oAA(e) {
  const A = typeof e
  return A === "string"
    ? `"${e}"`
    : A === "number" || A === "bigint" || A === "boolean"
      ? `${e}`
      : A === "object" || A === "function"
        ? ((e && Object.getPrototypeOf(e)?.constructor?.name) ?? "null")
        : A
}
function wL(e, A, I, g, C) {
  const i = I.value,
    B = e.expects ?? null,
    o = oAA(i),
    r = {
      kind: e.kind,
      type: e.type,
      input: i,
      expected: B,
      received: o,
      message: `Invalid ${A}: ${B ? `Expected ${B} but r` : "R"}eceived ${o}`,
      requirement: e.requirement,
      path: C?.path,
      issues: C?.issues,
      lang: g.lang,
      abortEarly: g.abortEarly,
      abortPipeEarly: g.abortPipeEarly,
    },
    s = e.kind === "schema",
    h =
      e.message ?? QAA(e.reference, r.lang) ?? (s ? tAA(r.lang) : null) ?? g.message ?? eAA(r.lang)
  ;(h &&
    (r.message =
      typeof h == "function"
        ? // @ts-expect-error
          h(r)
        : h),
    s && (I.typed = !1),
    I.issues ? I.issues.push(r) : (I.issues = [r]))
}
function jF(e) {
  return {
    version: 1,
    vendor: "valibot",
    validate(A) {
      return e["~run"]({ value: A }, XO())
    },
  }
}
var nAA = class extends Error {
  /**
   * The error issues.
   */
  issues
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(e) {
    ;(super(e[0].message), (this.name = "ValiError"), (this.issues = e))
  }
}
function EAA(e, A, I) {
  return typeof e.default == "function"
    ? // @ts-expect-error
      e.default(A, I)
    : // @ts-expect-error
      e.default
}
function $O(e, A) {
  return {
    kind: "schema",
    type: "array",
    reference: $O,
    expects: "Array",
    async: !1,
    item: e,
    message: A,
    get "~standard"() {
      return jF(this)
    },
    "~run"(I, g) {
      const C = I.value
      if (Array.isArray(C)) {
        ;((I.typed = !0), (I.value = []))
        for (let i = 0; i < C.length; i++) {
          const B = C[i],
            o = this.item["~run"]({ value: B }, g)
          if (o.issues) {
            const r = {
              type: "array",
              origin: "value",
              input: C,
              key: i,
              value: B,
            }
            for (const s of o.issues)
              (s.path ? s.path.unshift(r) : (s.path = [r]), I.issues?.push(s))
            if ((I.issues || (I.issues = o.issues), g.abortEarly)) {
              I.typed = !1
              break
            }
          }
          ;(o.typed || (I.typed = !1), I.value.push(o.value))
        }
      } else wL(this, "type", I, g)
      return I
    },
  }
}
function A_(e, A) {
  return {
    kind: "schema",
    type: "object",
    reference: A_,
    expects: "Object",
    async: !1,
    entries: e,
    message: A,
    get "~standard"() {
      return jF(this)
    },
    "~run"(I, g) {
      const C = I.value
      if (C && typeof C == "object") {
        ;((I.typed = !0), (I.value = {}))
        for (const i in this.entries) {
          const B = C[i],
            o = this.entries[i]["~run"]({ value: B }, g)
          if (o.issues) {
            const r = {
              type: "object",
              origin: "value",
              input: C,
              key: i,
              value: B,
            }
            for (const s of o.issues)
              (s.path ? s.path.unshift(r) : (s.path = [r]), I.issues?.push(s))
            if ((I.issues || (I.issues = o.issues), g.abortEarly)) {
              I.typed = !1
              break
            }
          }
          ;(o.typed || (I.typed = !1), (o.value !== void 0 || i in C) && (I.value[i] = o.value))
        }
      } else wL(this, "type", I, g)
      return I
    },
  }
}
function I_(e, A) {
  return {
    kind: "schema",
    type: "optional",
    reference: I_,
    expects: `(${e.expects} | undefined)`,
    async: !1,
    wrapped: e,
    default: A,
    get "~standard"() {
      return jF(this)
    },
    "~run"(I, g) {
      return I.value === void 0 &&
        (this.default !== void 0 && (I.value = EAA(this, I, g)), I.value === void 0)
        ? ((I.typed = !0), I)
        : this.wrapped["~run"](I, g)
    },
  }
}
function Ym(e) {
  return {
    kind: "schema",
    type: "string",
    reference: Ym,
    expects: "string",
    async: !1,
    message: e,
    get "~standard"() {
      return jF(this)
    },
    "~run"(A, I) {
      return (typeof A.value == "string" ? (A.typed = !0) : wL(this, "type", A, I), A)
    },
  }
}
function jx(e, A, I) {
  const g = e["~run"]({ value: A }, XO(I))
  if (g.issues) throw new nAA(g.issues)
  return g.value
}
var TN
;((e) => {
  ;((e.Headline = A_({
    primary: Ym(),
    secondary: Ym(),
  })),
    (e.Headlines = $O(e.Headline)))
})(TN || (TN = {}))
function uAA(e) {
  try {
    const A = jx(TN.Headlines, mr.safeJsonParse(e.getAttribute(j$))),
      I = jx(I_(TN.Headline), mr.safeJsonParse(e.getAttribute(z$))),
      g = e.getAttribute("height") ?? void 0
    a1.createRoot(e).render(/* @__PURE__ */ qC.jsx(gAA, { headlines: A, override: I, height: g }))
  } catch {}
}
export { uAA as renderScene }
